
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8287"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8287"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iwYKF", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $d7da5726a9ca36a2$export$ffb0004e005737fa, (v) => $d7da5726a9ca36a2$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $d7da5726a9ca36a2$export$34b9dba7ce09269b, (v) => $d7da5726a9ca36a2$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $d7da5726a9ca36a2$export$25062201e9e25d76, (v) => $d7da5726a9ca36a2$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d7da5726a9ca36a2$export$ffb0004e005737fa;
var $d7da5726a9ca36a2$export$34b9dba7ce09269b;
var $d7da5726a9ca36a2$export$25062201e9e25d76;
'use strict';

var $lx97N = parcelRequire("lx97N");
var $d7da5726a9ca36a2$var$k = Symbol.for("react.element"), $d7da5726a9ca36a2$var$l = Symbol.for("react.fragment"), $d7da5726a9ca36a2$var$m = Object.prototype.hasOwnProperty, $d7da5726a9ca36a2$var$n = $lx97N.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $d7da5726a9ca36a2$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $d7da5726a9ca36a2$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$d7da5726a9ca36a2$var$m.call(a, b) && !$d7da5726a9ca36a2$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $d7da5726a9ca36a2$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $d7da5726a9ca36a2$var$n.current
    };
}
$d7da5726a9ca36a2$export$ffb0004e005737fa = $d7da5726a9ca36a2$var$l;
$d7da5726a9ca36a2$export$34b9dba7ce09269b = $d7da5726a9ca36a2$var$q;
$d7da5726a9ca36a2$export$25062201e9e25d76 = $d7da5726a9ca36a2$var$q;

});
parcelRegister("lx97N", function(module, exports) {
'use strict';

module.exports = (parcelRequire("8E8IG"));

});
parcelRegister("8E8IG", function(module, exports) {

$parcel$export(module.exports, "Children", () => $64b8d2b03b5764eb$export$dca3b0875bd9a954, (v) => $64b8d2b03b5764eb$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $64b8d2b03b5764eb$export$16fa2f45be04daa8, (v) => $64b8d2b03b5764eb$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $64b8d2b03b5764eb$export$ffb0004e005737fa, (v) => $64b8d2b03b5764eb$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $64b8d2b03b5764eb$export$e2c29f18771995cb, (v) => $64b8d2b03b5764eb$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $64b8d2b03b5764eb$export$221d75b3f55bb0bd, (v) => $64b8d2b03b5764eb$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $64b8d2b03b5764eb$export$5f8d39834fd61797, (v) => $64b8d2b03b5764eb$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $64b8d2b03b5764eb$export$74bf444e3cd11ea5, (v) => $64b8d2b03b5764eb$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $64b8d2b03b5764eb$export$ae55be85d98224ed, (v) => $64b8d2b03b5764eb$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $64b8d2b03b5764eb$export$e530037191fcd5d7, (v) => $64b8d2b03b5764eb$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $64b8d2b03b5764eb$export$fd42f52fd3ae1109, (v) => $64b8d2b03b5764eb$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $64b8d2b03b5764eb$export$c8a8987d4410bf2d, (v) => $64b8d2b03b5764eb$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $64b8d2b03b5764eb$export$d38cd72104c1f0e9, (v) => $64b8d2b03b5764eb$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $64b8d2b03b5764eb$export$7d1e3a5e95ceca43, (v) => $64b8d2b03b5764eb$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $64b8d2b03b5764eb$export$257a8862b851cb5b, (v) => $64b8d2b03b5764eb$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $64b8d2b03b5764eb$export$a8257692ac88316c, (v) => $64b8d2b03b5764eb$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $64b8d2b03b5764eb$export$488013bae63b21da, (v) => $64b8d2b03b5764eb$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $64b8d2b03b5764eb$export$7c73462e0d25e514, (v) => $64b8d2b03b5764eb$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $64b8d2b03b5764eb$export$7568632d0d33d16d, (v) => $64b8d2b03b5764eb$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $64b8d2b03b5764eb$export$88948ce120ea2619, (v) => $64b8d2b03b5764eb$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $64b8d2b03b5764eb$export$35808ee640e87ca7, (v) => $64b8d2b03b5764eb$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $64b8d2b03b5764eb$export$fae74005e78b1a27, (v) => $64b8d2b03b5764eb$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $64b8d2b03b5764eb$export$dc8fbce3eb94dc1e, (v) => $64b8d2b03b5764eb$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $64b8d2b03b5764eb$export$6a7bc4e911dc01cf, (v) => $64b8d2b03b5764eb$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $64b8d2b03b5764eb$export$6d9c69b0de29b591, (v) => $64b8d2b03b5764eb$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $64b8d2b03b5764eb$export$f680877a34711e37, (v) => $64b8d2b03b5764eb$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $64b8d2b03b5764eb$export$d5a552a76deda3c2, (v) => $64b8d2b03b5764eb$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $64b8d2b03b5764eb$export$aaabe4eda9ed9969, (v) => $64b8d2b03b5764eb$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $64b8d2b03b5764eb$export$e5c5a5f917a5871c, (v) => $64b8d2b03b5764eb$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $64b8d2b03b5764eb$export$1538c33de8887b59, (v) => $64b8d2b03b5764eb$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $64b8d2b03b5764eb$export$13e3392192263954, (v) => $64b8d2b03b5764eb$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $64b8d2b03b5764eb$export$b8f5890fc79d6aca, (v) => $64b8d2b03b5764eb$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $64b8d2b03b5764eb$export$60241385465d0a34, (v) => $64b8d2b03b5764eb$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $64b8d2b03b5764eb$export$306c0aa65ff9ec16, (v) => $64b8d2b03b5764eb$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $64b8d2b03b5764eb$export$7b286972b8d8ccbf, (v) => $64b8d2b03b5764eb$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $64b8d2b03b5764eb$export$83d89fbfd8236492, (v) => $64b8d2b03b5764eb$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $64b8d2b03b5764eb$export$dca3b0875bd9a954;
var $64b8d2b03b5764eb$export$16fa2f45be04daa8;
var $64b8d2b03b5764eb$export$ffb0004e005737fa;
var $64b8d2b03b5764eb$export$e2c29f18771995cb;
var $64b8d2b03b5764eb$export$221d75b3f55bb0bd;
var $64b8d2b03b5764eb$export$5f8d39834fd61797;
var $64b8d2b03b5764eb$export$74bf444e3cd11ea5;
var $64b8d2b03b5764eb$export$ae55be85d98224ed;
var $64b8d2b03b5764eb$export$e530037191fcd5d7;
var $64b8d2b03b5764eb$export$fd42f52fd3ae1109;
var $64b8d2b03b5764eb$export$c8a8987d4410bf2d;
var $64b8d2b03b5764eb$export$d38cd72104c1f0e9;
var $64b8d2b03b5764eb$export$7d1e3a5e95ceca43;
var $64b8d2b03b5764eb$export$257a8862b851cb5b;
var $64b8d2b03b5764eb$export$a8257692ac88316c;
var $64b8d2b03b5764eb$export$488013bae63b21da;
var $64b8d2b03b5764eb$export$7c73462e0d25e514;
var $64b8d2b03b5764eb$export$7568632d0d33d16d;
var $64b8d2b03b5764eb$export$88948ce120ea2619;
var $64b8d2b03b5764eb$export$35808ee640e87ca7;
var $64b8d2b03b5764eb$export$fae74005e78b1a27;
var $64b8d2b03b5764eb$export$dc8fbce3eb94dc1e;
var $64b8d2b03b5764eb$export$6a7bc4e911dc01cf;
var $64b8d2b03b5764eb$export$6d9c69b0de29b591;
var $64b8d2b03b5764eb$export$f680877a34711e37;
var $64b8d2b03b5764eb$export$d5a552a76deda3c2;
var $64b8d2b03b5764eb$export$aaabe4eda9ed9969;
var $64b8d2b03b5764eb$export$e5c5a5f917a5871c;
var $64b8d2b03b5764eb$export$1538c33de8887b59;
var $64b8d2b03b5764eb$export$13e3392192263954;
var $64b8d2b03b5764eb$export$b8f5890fc79d6aca;
var $64b8d2b03b5764eb$export$60241385465d0a34;
var $64b8d2b03b5764eb$export$306c0aa65ff9ec16;
var $64b8d2b03b5764eb$export$7b286972b8d8ccbf;
var $64b8d2b03b5764eb$export$83d89fbfd8236492;
'use strict';
var $64b8d2b03b5764eb$var$l = Symbol.for("react.element"), $64b8d2b03b5764eb$var$n = Symbol.for("react.portal"), $64b8d2b03b5764eb$var$p = Symbol.for("react.fragment"), $64b8d2b03b5764eb$var$q = Symbol.for("react.strict_mode"), $64b8d2b03b5764eb$var$r = Symbol.for("react.profiler"), $64b8d2b03b5764eb$var$t = Symbol.for("react.provider"), $64b8d2b03b5764eb$var$u = Symbol.for("react.context"), $64b8d2b03b5764eb$var$v = Symbol.for("react.forward_ref"), $64b8d2b03b5764eb$var$w = Symbol.for("react.suspense"), $64b8d2b03b5764eb$var$x = Symbol.for("react.memo"), $64b8d2b03b5764eb$var$y = Symbol.for("react.lazy"), $64b8d2b03b5764eb$var$z = Symbol.iterator;
function $64b8d2b03b5764eb$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $64b8d2b03b5764eb$var$z && a[$64b8d2b03b5764eb$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $64b8d2b03b5764eb$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $64b8d2b03b5764eb$var$C = Object.assign, $64b8d2b03b5764eb$var$D = {};
function $64b8d2b03b5764eb$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $64b8d2b03b5764eb$var$D;
    this.updater = e || $64b8d2b03b5764eb$var$B;
}
$64b8d2b03b5764eb$var$E.prototype.isReactComponent = {};
$64b8d2b03b5764eb$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$64b8d2b03b5764eb$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $64b8d2b03b5764eb$var$F() {}
$64b8d2b03b5764eb$var$F.prototype = $64b8d2b03b5764eb$var$E.prototype;
function $64b8d2b03b5764eb$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $64b8d2b03b5764eb$var$D;
    this.updater = e || $64b8d2b03b5764eb$var$B;
}
var $64b8d2b03b5764eb$var$H = $64b8d2b03b5764eb$var$G.prototype = new $64b8d2b03b5764eb$var$F;
$64b8d2b03b5764eb$var$H.constructor = $64b8d2b03b5764eb$var$G;
$64b8d2b03b5764eb$var$C($64b8d2b03b5764eb$var$H, $64b8d2b03b5764eb$var$E.prototype);
$64b8d2b03b5764eb$var$H.isPureReactComponent = !0;
var $64b8d2b03b5764eb$var$I = Array.isArray, $64b8d2b03b5764eb$var$J = Object.prototype.hasOwnProperty, $64b8d2b03b5764eb$var$K = {
    current: null
}, $64b8d2b03b5764eb$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $64b8d2b03b5764eb$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$64b8d2b03b5764eb$var$J.call(b, d) && !$64b8d2b03b5764eb$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $64b8d2b03b5764eb$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $64b8d2b03b5764eb$var$K.current
    };
}
function $64b8d2b03b5764eb$var$N(a, b) {
    return {
        $$typeof: $64b8d2b03b5764eb$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $64b8d2b03b5764eb$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $64b8d2b03b5764eb$var$l;
}
function $64b8d2b03b5764eb$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $64b8d2b03b5764eb$var$P = /\/+/g;
function $64b8d2b03b5764eb$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $64b8d2b03b5764eb$var$escape("" + a.key) : b.toString(36);
}
function $64b8d2b03b5764eb$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $64b8d2b03b5764eb$var$l:
                case $64b8d2b03b5764eb$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $64b8d2b03b5764eb$var$Q(h, 0) : d, $64b8d2b03b5764eb$var$I(c) ? (e = "", null != a && (e = a.replace($64b8d2b03b5764eb$var$P, "$&/") + "/"), $64b8d2b03b5764eb$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($64b8d2b03b5764eb$var$O(c) && (c = $64b8d2b03b5764eb$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($64b8d2b03b5764eb$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($64b8d2b03b5764eb$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $64b8d2b03b5764eb$var$Q(k, g);
        h += $64b8d2b03b5764eb$var$R(k, b, e, f, c);
    }
    else if (f = $64b8d2b03b5764eb$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $64b8d2b03b5764eb$var$Q(k, g++), h += $64b8d2b03b5764eb$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $64b8d2b03b5764eb$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $64b8d2b03b5764eb$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $64b8d2b03b5764eb$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $64b8d2b03b5764eb$var$U = {
    current: null
}, $64b8d2b03b5764eb$var$V = {
    transition: null
}, $64b8d2b03b5764eb$var$W = {
    ReactCurrentDispatcher: $64b8d2b03b5764eb$var$U,
    ReactCurrentBatchConfig: $64b8d2b03b5764eb$var$V,
    ReactCurrentOwner: $64b8d2b03b5764eb$var$K
};
$64b8d2b03b5764eb$export$dca3b0875bd9a954 = {
    map: $64b8d2b03b5764eb$var$S,
    forEach: function(a, b, e) {
        $64b8d2b03b5764eb$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $64b8d2b03b5764eb$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $64b8d2b03b5764eb$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$64b8d2b03b5764eb$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$64b8d2b03b5764eb$export$16fa2f45be04daa8 = $64b8d2b03b5764eb$var$E;
$64b8d2b03b5764eb$export$ffb0004e005737fa = $64b8d2b03b5764eb$var$p;
$64b8d2b03b5764eb$export$e2c29f18771995cb = $64b8d2b03b5764eb$var$r;
$64b8d2b03b5764eb$export$221d75b3f55bb0bd = $64b8d2b03b5764eb$var$G;
$64b8d2b03b5764eb$export$5f8d39834fd61797 = $64b8d2b03b5764eb$var$q;
$64b8d2b03b5764eb$export$74bf444e3cd11ea5 = $64b8d2b03b5764eb$var$w;
$64b8d2b03b5764eb$export$ae55be85d98224ed = $64b8d2b03b5764eb$var$W;
$64b8d2b03b5764eb$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $64b8d2b03b5764eb$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $64b8d2b03b5764eb$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$64b8d2b03b5764eb$var$J.call(b, f) && !$64b8d2b03b5764eb$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $64b8d2b03b5764eb$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$64b8d2b03b5764eb$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $64b8d2b03b5764eb$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $64b8d2b03b5764eb$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$64b8d2b03b5764eb$export$c8a8987d4410bf2d = $64b8d2b03b5764eb$var$M;
$64b8d2b03b5764eb$export$d38cd72104c1f0e9 = function(a) {
    var b = $64b8d2b03b5764eb$var$M.bind(null, a);
    b.type = a;
    return b;
};
$64b8d2b03b5764eb$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$64b8d2b03b5764eb$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $64b8d2b03b5764eb$var$v,
        render: a
    };
};
$64b8d2b03b5764eb$export$a8257692ac88316c = $64b8d2b03b5764eb$var$O;
$64b8d2b03b5764eb$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $64b8d2b03b5764eb$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $64b8d2b03b5764eb$var$T
    };
};
$64b8d2b03b5764eb$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $64b8d2b03b5764eb$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$64b8d2b03b5764eb$export$7568632d0d33d16d = function(a) {
    var b = $64b8d2b03b5764eb$var$V.transition;
    $64b8d2b03b5764eb$var$V.transition = {};
    try {
        a();
    } finally{
        $64b8d2b03b5764eb$var$V.transition = b;
    }
};
$64b8d2b03b5764eb$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$64b8d2b03b5764eb$export$35808ee640e87ca7 = function(a, b) {
    return $64b8d2b03b5764eb$var$U.current.useCallback(a, b);
};
$64b8d2b03b5764eb$export$fae74005e78b1a27 = function(a) {
    return $64b8d2b03b5764eb$var$U.current.useContext(a);
};
$64b8d2b03b5764eb$export$dc8fbce3eb94dc1e = function() {};
$64b8d2b03b5764eb$export$6a7bc4e911dc01cf = function(a) {
    return $64b8d2b03b5764eb$var$U.current.useDeferredValue(a);
};
$64b8d2b03b5764eb$export$6d9c69b0de29b591 = function(a, b) {
    return $64b8d2b03b5764eb$var$U.current.useEffect(a, b);
};
$64b8d2b03b5764eb$export$f680877a34711e37 = function() {
    return $64b8d2b03b5764eb$var$U.current.useId();
};
$64b8d2b03b5764eb$export$d5a552a76deda3c2 = function(a, b, e) {
    return $64b8d2b03b5764eb$var$U.current.useImperativeHandle(a, b, e);
};
$64b8d2b03b5764eb$export$aaabe4eda9ed9969 = function(a, b) {
    return $64b8d2b03b5764eb$var$U.current.useInsertionEffect(a, b);
};
$64b8d2b03b5764eb$export$e5c5a5f917a5871c = function(a, b) {
    return $64b8d2b03b5764eb$var$U.current.useLayoutEffect(a, b);
};
$64b8d2b03b5764eb$export$1538c33de8887b59 = function(a, b) {
    return $64b8d2b03b5764eb$var$U.current.useMemo(a, b);
};
$64b8d2b03b5764eb$export$13e3392192263954 = function(a, b, e) {
    return $64b8d2b03b5764eb$var$U.current.useReducer(a, b, e);
};
$64b8d2b03b5764eb$export$b8f5890fc79d6aca = function(a) {
    return $64b8d2b03b5764eb$var$U.current.useRef(a);
};
$64b8d2b03b5764eb$export$60241385465d0a34 = function(a) {
    return $64b8d2b03b5764eb$var$U.current.useState(a);
};
$64b8d2b03b5764eb$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $64b8d2b03b5764eb$var$U.current.useSyncExternalStore(a, b, e);
};
$64b8d2b03b5764eb$export$7b286972b8d8ccbf = function() {
    return $64b8d2b03b5764eb$var$U.current.useTransition();
};
$64b8d2b03b5764eb$export$83d89fbfd8236492 = "18.2.0";

});



parcelRegister("1amKe", function(module, exports) {
'use strict';
function $0d985e384f32d040$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($0d985e384f32d040$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$0d985e384f32d040$var$checkDCE();

module.exports = (parcelRequire("f2Jil"));

});
parcelRegister("f2Jil", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $af3a2d87ccb15d29$export$ae55be85d98224ed, (v) => $af3a2d87ccb15d29$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $af3a2d87ccb15d29$export$d39a5bbd09211389, (v) => $af3a2d87ccb15d29$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $af3a2d87ccb15d29$export$882461b6382ed46c, (v) => $af3a2d87ccb15d29$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $af3a2d87ccb15d29$export$466bfc07425424d5, (v) => $af3a2d87ccb15d29$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $af3a2d87ccb15d29$export$cd75ccfd720a3cd4, (v) => $af3a2d87ccb15d29$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $af3a2d87ccb15d29$export$fa8d919ba61d84db, (v) => $af3a2d87ccb15d29$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $af3a2d87ccb15d29$export$757ceba2d55c277e, (v) => $af3a2d87ccb15d29$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $af3a2d87ccb15d29$export$b3890eb0ae9dca99, (v) => $af3a2d87ccb15d29$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $af3a2d87ccb15d29$export$502457920280e6be, (v) => $af3a2d87ccb15d29$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $af3a2d87ccb15d29$export$c78a37762a8d58e1, (v) => $af3a2d87ccb15d29$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $af3a2d87ccb15d29$export$dc54d992c10e8a18, (v) => $af3a2d87ccb15d29$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $af3a2d87ccb15d29$export$83d89fbfd8236492, (v) => $af3a2d87ccb15d29$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $af3a2d87ccb15d29$export$ae55be85d98224ed;
var $af3a2d87ccb15d29$export$d39a5bbd09211389;
var $af3a2d87ccb15d29$export$882461b6382ed46c;
var $af3a2d87ccb15d29$export$466bfc07425424d5;
var $af3a2d87ccb15d29$export$cd75ccfd720a3cd4;
var $af3a2d87ccb15d29$export$fa8d919ba61d84db;
var $af3a2d87ccb15d29$export$757ceba2d55c277e;
var $af3a2d87ccb15d29$export$b3890eb0ae9dca99;
var $af3a2d87ccb15d29$export$502457920280e6be;
var $af3a2d87ccb15d29$export$c78a37762a8d58e1;
var $af3a2d87ccb15d29$export$dc54d992c10e8a18;
var $af3a2d87ccb15d29$export$83d89fbfd8236492;
'use strict';

var $lx97N = parcelRequire("lx97N");

var $7zDBh = parcelRequire("7zDBh");
function $af3a2d87ccb15d29$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $af3a2d87ccb15d29$var$da = new Set, $af3a2d87ccb15d29$var$ea = {};
function $af3a2d87ccb15d29$var$fa(a, b) {
    $af3a2d87ccb15d29$var$ha(a, b);
    $af3a2d87ccb15d29$var$ha(a + "Capture", b);
}
function $af3a2d87ccb15d29$var$ha(a, b) {
    $af3a2d87ccb15d29$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$af3a2d87ccb15d29$var$da.add(b[a]);
}
var $af3a2d87ccb15d29$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $af3a2d87ccb15d29$var$ja = Object.prototype.hasOwnProperty, $af3a2d87ccb15d29$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $af3a2d87ccb15d29$var$la = {}, $af3a2d87ccb15d29$var$ma = {};
function $af3a2d87ccb15d29$var$oa(a) {
    if ($af3a2d87ccb15d29$var$ja.call($af3a2d87ccb15d29$var$ma, a)) return !0;
    if ($af3a2d87ccb15d29$var$ja.call($af3a2d87ccb15d29$var$la, a)) return !1;
    if ($af3a2d87ccb15d29$var$ka.test(a)) return $af3a2d87ccb15d29$var$ma[a] = !0;
    $af3a2d87ccb15d29$var$la[a] = !0;
    return !1;
}
function $af3a2d87ccb15d29$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $af3a2d87ccb15d29$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $af3a2d87ccb15d29$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $af3a2d87ccb15d29$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $af3a2d87ccb15d29$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $af3a2d87ccb15d29$var$z[a] = new $af3a2d87ccb15d29$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $af3a2d87ccb15d29$var$z[b] = new $af3a2d87ccb15d29$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $af3a2d87ccb15d29$var$z[a] = new $af3a2d87ccb15d29$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $af3a2d87ccb15d29$var$z[a] = new $af3a2d87ccb15d29$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $af3a2d87ccb15d29$var$z[a] = new $af3a2d87ccb15d29$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $af3a2d87ccb15d29$var$z[a] = new $af3a2d87ccb15d29$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $af3a2d87ccb15d29$var$z[a] = new $af3a2d87ccb15d29$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $af3a2d87ccb15d29$var$z[a] = new $af3a2d87ccb15d29$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $af3a2d87ccb15d29$var$z[a] = new $af3a2d87ccb15d29$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $af3a2d87ccb15d29$var$ra = /[\-:]([a-z])/g;
function $af3a2d87ccb15d29$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($af3a2d87ccb15d29$var$ra, $af3a2d87ccb15d29$var$sa);
    $af3a2d87ccb15d29$var$z[b] = new $af3a2d87ccb15d29$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($af3a2d87ccb15d29$var$ra, $af3a2d87ccb15d29$var$sa);
    $af3a2d87ccb15d29$var$z[b] = new $af3a2d87ccb15d29$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($af3a2d87ccb15d29$var$ra, $af3a2d87ccb15d29$var$sa);
    $af3a2d87ccb15d29$var$z[b] = new $af3a2d87ccb15d29$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $af3a2d87ccb15d29$var$z[a] = new $af3a2d87ccb15d29$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$af3a2d87ccb15d29$var$z.xlinkHref = new $af3a2d87ccb15d29$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $af3a2d87ccb15d29$var$z[a] = new $af3a2d87ccb15d29$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $af3a2d87ccb15d29$var$ta(a, b, c, d) {
    var e = $af3a2d87ccb15d29$var$z.hasOwnProperty(b) ? $af3a2d87ccb15d29$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $af3a2d87ccb15d29$var$qa(b, c, e, d) && (c = null), d || null === e ? $af3a2d87ccb15d29$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $af3a2d87ccb15d29$var$ua = $lx97N.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $af3a2d87ccb15d29$var$va = Symbol.for("react.element"), $af3a2d87ccb15d29$var$wa = Symbol.for("react.portal"), $af3a2d87ccb15d29$var$ya = Symbol.for("react.fragment"), $af3a2d87ccb15d29$var$za = Symbol.for("react.strict_mode"), $af3a2d87ccb15d29$var$Aa = Symbol.for("react.profiler"), $af3a2d87ccb15d29$var$Ba = Symbol.for("react.provider"), $af3a2d87ccb15d29$var$Ca = Symbol.for("react.context"), $af3a2d87ccb15d29$var$Da = Symbol.for("react.forward_ref"), $af3a2d87ccb15d29$var$Ea = Symbol.for("react.suspense"), $af3a2d87ccb15d29$var$Fa = Symbol.for("react.suspense_list"), $af3a2d87ccb15d29$var$Ga = Symbol.for("react.memo"), $af3a2d87ccb15d29$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $af3a2d87ccb15d29$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $af3a2d87ccb15d29$var$Ja = Symbol.iterator;
function $af3a2d87ccb15d29$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $af3a2d87ccb15d29$var$Ja && a[$af3a2d87ccb15d29$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $af3a2d87ccb15d29$var$A = Object.assign, $af3a2d87ccb15d29$var$La;
function $af3a2d87ccb15d29$var$Ma(a) {
    if (void 0 === $af3a2d87ccb15d29$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $af3a2d87ccb15d29$var$La = b && b[1] || "";
    }
    return "\n" + $af3a2d87ccb15d29$var$La + a;
}
var $af3a2d87ccb15d29$var$Na = !1;
function $af3a2d87ccb15d29$var$Oa(a, b) {
    if (!a || $af3a2d87ccb15d29$var$Na) return "";
    $af3a2d87ccb15d29$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $af3a2d87ccb15d29$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $af3a2d87ccb15d29$var$Ma(a) : "";
}
function $af3a2d87ccb15d29$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $af3a2d87ccb15d29$var$Ma(a.type);
        case 16:
            return $af3a2d87ccb15d29$var$Ma("Lazy");
        case 13:
            return $af3a2d87ccb15d29$var$Ma("Suspense");
        case 19:
            return $af3a2d87ccb15d29$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $af3a2d87ccb15d29$var$Oa(a.type, !1), a;
        case 11:
            return a = $af3a2d87ccb15d29$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $af3a2d87ccb15d29$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $af3a2d87ccb15d29$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $af3a2d87ccb15d29$var$ya:
            return "Fragment";
        case $af3a2d87ccb15d29$var$wa:
            return "Portal";
        case $af3a2d87ccb15d29$var$Aa:
            return "Profiler";
        case $af3a2d87ccb15d29$var$za:
            return "StrictMode";
        case $af3a2d87ccb15d29$var$Ea:
            return "Suspense";
        case $af3a2d87ccb15d29$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $af3a2d87ccb15d29$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $af3a2d87ccb15d29$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $af3a2d87ccb15d29$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $af3a2d87ccb15d29$var$Ga:
            return b = a.displayName || null, null !== b ? b : $af3a2d87ccb15d29$var$Qa(a.type) || "Memo";
        case $af3a2d87ccb15d29$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $af3a2d87ccb15d29$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $af3a2d87ccb15d29$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $af3a2d87ccb15d29$var$Qa(b);
        case 8:
            return b === $af3a2d87ccb15d29$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $af3a2d87ccb15d29$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $af3a2d87ccb15d29$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $af3a2d87ccb15d29$var$Ua(a) {
    var b = $af3a2d87ccb15d29$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $af3a2d87ccb15d29$var$Va(a) {
    a._valueTracker || (a._valueTracker = $af3a2d87ccb15d29$var$Ua(a));
}
function $af3a2d87ccb15d29$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $af3a2d87ccb15d29$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $af3a2d87ccb15d29$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $af3a2d87ccb15d29$var$Ya(a, b) {
    var c = b.checked;
    return $af3a2d87ccb15d29$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $af3a2d87ccb15d29$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $af3a2d87ccb15d29$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $af3a2d87ccb15d29$var$ab(a, b) {
    b = b.checked;
    null != b && $af3a2d87ccb15d29$var$ta(a, "checked", b, !1);
}
function $af3a2d87ccb15d29$var$bb(a, b) {
    $af3a2d87ccb15d29$var$ab(a, b);
    var c = $af3a2d87ccb15d29$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $af3a2d87ccb15d29$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $af3a2d87ccb15d29$var$cb(a, b.type, $af3a2d87ccb15d29$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $af3a2d87ccb15d29$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $af3a2d87ccb15d29$var$cb(a, b, c) {
    if ("number" !== b || $af3a2d87ccb15d29$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $af3a2d87ccb15d29$var$eb = Array.isArray;
function $af3a2d87ccb15d29$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $af3a2d87ccb15d29$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $af3a2d87ccb15d29$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($af3a2d87ccb15d29$var$p(91));
    return $af3a2d87ccb15d29$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $af3a2d87ccb15d29$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($af3a2d87ccb15d29$var$p(92));
            if ($af3a2d87ccb15d29$var$eb(c)) {
                if (1 < c.length) throw Error($af3a2d87ccb15d29$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $af3a2d87ccb15d29$var$Sa(c)
    };
}
function $af3a2d87ccb15d29$var$ib(a, b) {
    var c = $af3a2d87ccb15d29$var$Sa(b.value), d = $af3a2d87ccb15d29$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $af3a2d87ccb15d29$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $af3a2d87ccb15d29$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $af3a2d87ccb15d29$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $af3a2d87ccb15d29$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $af3a2d87ccb15d29$var$mb, $af3a2d87ccb15d29$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $af3a2d87ccb15d29$var$mb = $af3a2d87ccb15d29$var$mb || document.createElement("div");
        $af3a2d87ccb15d29$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $af3a2d87ccb15d29$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $af3a2d87ccb15d29$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $af3a2d87ccb15d29$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $af3a2d87ccb15d29$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($af3a2d87ccb15d29$var$pb).forEach(function(a) {
    $af3a2d87ccb15d29$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $af3a2d87ccb15d29$var$pb[b] = $af3a2d87ccb15d29$var$pb[a];
    });
});
function $af3a2d87ccb15d29$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $af3a2d87ccb15d29$var$pb.hasOwnProperty(a) && $af3a2d87ccb15d29$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $af3a2d87ccb15d29$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $af3a2d87ccb15d29$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $af3a2d87ccb15d29$var$tb = $af3a2d87ccb15d29$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $af3a2d87ccb15d29$var$ub(a, b) {
    if (b) {
        if ($af3a2d87ccb15d29$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($af3a2d87ccb15d29$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($af3a2d87ccb15d29$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($af3a2d87ccb15d29$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($af3a2d87ccb15d29$var$p(62));
    }
}
function $af3a2d87ccb15d29$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $af3a2d87ccb15d29$var$wb = null;
function $af3a2d87ccb15d29$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $af3a2d87ccb15d29$var$yb = null, $af3a2d87ccb15d29$var$zb = null, $af3a2d87ccb15d29$var$Ab = null;
function $af3a2d87ccb15d29$var$Bb(a) {
    if (a = $af3a2d87ccb15d29$var$Cb(a)) {
        if ("function" !== typeof $af3a2d87ccb15d29$var$yb) throw Error($af3a2d87ccb15d29$var$p(280));
        var b = a.stateNode;
        b && (b = $af3a2d87ccb15d29$var$Db(b), $af3a2d87ccb15d29$var$yb(a.stateNode, a.type, b));
    }
}
function $af3a2d87ccb15d29$var$Eb(a) {
    $af3a2d87ccb15d29$var$zb ? $af3a2d87ccb15d29$var$Ab ? $af3a2d87ccb15d29$var$Ab.push(a) : $af3a2d87ccb15d29$var$Ab = [
        a
    ] : $af3a2d87ccb15d29$var$zb = a;
}
function $af3a2d87ccb15d29$var$Fb() {
    if ($af3a2d87ccb15d29$var$zb) {
        var a = $af3a2d87ccb15d29$var$zb, b = $af3a2d87ccb15d29$var$Ab;
        $af3a2d87ccb15d29$var$Ab = $af3a2d87ccb15d29$var$zb = null;
        $af3a2d87ccb15d29$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$af3a2d87ccb15d29$var$Bb(b[a]);
    }
}
function $af3a2d87ccb15d29$var$Gb(a, b) {
    return a(b);
}
function $af3a2d87ccb15d29$var$Hb() {}
var $af3a2d87ccb15d29$var$Ib = !1;
function $af3a2d87ccb15d29$var$Jb(a, b, c) {
    if ($af3a2d87ccb15d29$var$Ib) return a(b, c);
    $af3a2d87ccb15d29$var$Ib = !0;
    try {
        return $af3a2d87ccb15d29$var$Gb(a, b, c);
    } finally{
        if ($af3a2d87ccb15d29$var$Ib = !1, null !== $af3a2d87ccb15d29$var$zb || null !== $af3a2d87ccb15d29$var$Ab) $af3a2d87ccb15d29$var$Hb(), $af3a2d87ccb15d29$var$Fb();
    }
}
function $af3a2d87ccb15d29$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $af3a2d87ccb15d29$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($af3a2d87ccb15d29$var$p(231, b, typeof c));
    return c;
}
var $af3a2d87ccb15d29$var$Lb = !1;
if ($af3a2d87ccb15d29$var$ia) try {
    var $af3a2d87ccb15d29$var$Mb = {};
    Object.defineProperty($af3a2d87ccb15d29$var$Mb, "passive", {
        get: function() {
            $af3a2d87ccb15d29$var$Lb = !0;
        }
    });
    window.addEventListener("test", $af3a2d87ccb15d29$var$Mb, $af3a2d87ccb15d29$var$Mb);
    window.removeEventListener("test", $af3a2d87ccb15d29$var$Mb, $af3a2d87ccb15d29$var$Mb);
} catch (a) {
    $af3a2d87ccb15d29$var$Lb = !1;
}
function $af3a2d87ccb15d29$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $af3a2d87ccb15d29$var$Ob = !1, $af3a2d87ccb15d29$var$Pb = null, $af3a2d87ccb15d29$var$Qb = !1, $af3a2d87ccb15d29$var$Rb = null, $af3a2d87ccb15d29$var$Sb = {
    onError: function(a) {
        $af3a2d87ccb15d29$var$Ob = !0;
        $af3a2d87ccb15d29$var$Pb = a;
    }
};
function $af3a2d87ccb15d29$var$Tb(a, b, c, d, e, f, g, h, k) {
    $af3a2d87ccb15d29$var$Ob = !1;
    $af3a2d87ccb15d29$var$Pb = null;
    $af3a2d87ccb15d29$var$Nb.apply($af3a2d87ccb15d29$var$Sb, arguments);
}
function $af3a2d87ccb15d29$var$Ub(a, b, c, d, e, f, g, h, k) {
    $af3a2d87ccb15d29$var$Tb.apply(this, arguments);
    if ($af3a2d87ccb15d29$var$Ob) {
        if ($af3a2d87ccb15d29$var$Ob) {
            var l = $af3a2d87ccb15d29$var$Pb;
            $af3a2d87ccb15d29$var$Ob = !1;
            $af3a2d87ccb15d29$var$Pb = null;
        } else throw Error($af3a2d87ccb15d29$var$p(198));
        $af3a2d87ccb15d29$var$Qb || ($af3a2d87ccb15d29$var$Qb = !0, $af3a2d87ccb15d29$var$Rb = l);
    }
}
function $af3a2d87ccb15d29$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $af3a2d87ccb15d29$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $af3a2d87ccb15d29$var$Xb(a) {
    if ($af3a2d87ccb15d29$var$Vb(a) !== a) throw Error($af3a2d87ccb15d29$var$p(188));
}
function $af3a2d87ccb15d29$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $af3a2d87ccb15d29$var$Vb(a);
        if (null === b) throw Error($af3a2d87ccb15d29$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $af3a2d87ccb15d29$var$Xb(e), a;
                if (f === d) return $af3a2d87ccb15d29$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($af3a2d87ccb15d29$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($af3a2d87ccb15d29$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($af3a2d87ccb15d29$var$p(190));
    }
    if (3 !== c.tag) throw Error($af3a2d87ccb15d29$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $af3a2d87ccb15d29$var$Zb(a) {
    a = $af3a2d87ccb15d29$var$Yb(a);
    return null !== a ? $af3a2d87ccb15d29$var$$b(a) : null;
}
function $af3a2d87ccb15d29$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $af3a2d87ccb15d29$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $af3a2d87ccb15d29$var$ac = $7zDBh.unstable_scheduleCallback, $af3a2d87ccb15d29$var$bc = $7zDBh.unstable_cancelCallback, $af3a2d87ccb15d29$var$cc = $7zDBh.unstable_shouldYield, $af3a2d87ccb15d29$var$dc = $7zDBh.unstable_requestPaint, $af3a2d87ccb15d29$var$B = $7zDBh.unstable_now, $af3a2d87ccb15d29$var$ec = $7zDBh.unstable_getCurrentPriorityLevel, $af3a2d87ccb15d29$var$fc = $7zDBh.unstable_ImmediatePriority, $af3a2d87ccb15d29$var$gc = $7zDBh.unstable_UserBlockingPriority, $af3a2d87ccb15d29$var$hc = $7zDBh.unstable_NormalPriority, $af3a2d87ccb15d29$var$ic = $7zDBh.unstable_LowPriority, $af3a2d87ccb15d29$var$jc = $7zDBh.unstable_IdlePriority, $af3a2d87ccb15d29$var$kc = null, $af3a2d87ccb15d29$var$lc = null;
function $af3a2d87ccb15d29$var$mc(a) {
    if ($af3a2d87ccb15d29$var$lc && "function" === typeof $af3a2d87ccb15d29$var$lc.onCommitFiberRoot) try {
        $af3a2d87ccb15d29$var$lc.onCommitFiberRoot($af3a2d87ccb15d29$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $af3a2d87ccb15d29$var$oc = Math.clz32 ? Math.clz32 : $af3a2d87ccb15d29$var$nc, $af3a2d87ccb15d29$var$pc = Math.log, $af3a2d87ccb15d29$var$qc = Math.LN2;
function $af3a2d87ccb15d29$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($af3a2d87ccb15d29$var$pc(a) / $af3a2d87ccb15d29$var$qc | 0) | 0;
}
var $af3a2d87ccb15d29$var$rc = 64, $af3a2d87ccb15d29$var$sc = 4194304;
function $af3a2d87ccb15d29$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $af3a2d87ccb15d29$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $af3a2d87ccb15d29$var$tc(h) : (f &= g, 0 !== f && (d = $af3a2d87ccb15d29$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $af3a2d87ccb15d29$var$tc(g) : 0 !== f && (d = $af3a2d87ccb15d29$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $af3a2d87ccb15d29$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $af3a2d87ccb15d29$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $af3a2d87ccb15d29$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $af3a2d87ccb15d29$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $af3a2d87ccb15d29$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $af3a2d87ccb15d29$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $af3a2d87ccb15d29$var$yc() {
    var a = $af3a2d87ccb15d29$var$rc;
    $af3a2d87ccb15d29$var$rc <<= 1;
    0 === ($af3a2d87ccb15d29$var$rc & 4194240) && ($af3a2d87ccb15d29$var$rc = 64);
    return a;
}
function $af3a2d87ccb15d29$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $af3a2d87ccb15d29$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $af3a2d87ccb15d29$var$oc(b);
    a[b] = c;
}
function $af3a2d87ccb15d29$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $af3a2d87ccb15d29$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $af3a2d87ccb15d29$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $af3a2d87ccb15d29$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $af3a2d87ccb15d29$var$C = 0;
function $af3a2d87ccb15d29$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $af3a2d87ccb15d29$var$Ec, $af3a2d87ccb15d29$var$Fc, $af3a2d87ccb15d29$var$Gc, $af3a2d87ccb15d29$var$Hc, $af3a2d87ccb15d29$var$Ic, $af3a2d87ccb15d29$var$Jc = !1, $af3a2d87ccb15d29$var$Kc = [], $af3a2d87ccb15d29$var$Lc = null, $af3a2d87ccb15d29$var$Mc = null, $af3a2d87ccb15d29$var$Nc = null, $af3a2d87ccb15d29$var$Oc = new Map, $af3a2d87ccb15d29$var$Pc = new Map, $af3a2d87ccb15d29$var$Qc = [], $af3a2d87ccb15d29$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $af3a2d87ccb15d29$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $af3a2d87ccb15d29$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $af3a2d87ccb15d29$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $af3a2d87ccb15d29$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $af3a2d87ccb15d29$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $af3a2d87ccb15d29$var$Pc.delete(b.pointerId);
    }
}
function $af3a2d87ccb15d29$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $af3a2d87ccb15d29$var$Cb(b), null !== b && $af3a2d87ccb15d29$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $af3a2d87ccb15d29$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $af3a2d87ccb15d29$var$Lc = $af3a2d87ccb15d29$var$Tc($af3a2d87ccb15d29$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $af3a2d87ccb15d29$var$Mc = $af3a2d87ccb15d29$var$Tc($af3a2d87ccb15d29$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $af3a2d87ccb15d29$var$Nc = $af3a2d87ccb15d29$var$Tc($af3a2d87ccb15d29$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $af3a2d87ccb15d29$var$Oc.set(f, $af3a2d87ccb15d29$var$Tc($af3a2d87ccb15d29$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $af3a2d87ccb15d29$var$Pc.set(f, $af3a2d87ccb15d29$var$Tc($af3a2d87ccb15d29$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $af3a2d87ccb15d29$var$Vc(a) {
    var b = $af3a2d87ccb15d29$var$Wc(a.target);
    if (null !== b) {
        var c = $af3a2d87ccb15d29$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $af3a2d87ccb15d29$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $af3a2d87ccb15d29$var$Ic(a.priority, function() {
                        $af3a2d87ccb15d29$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $af3a2d87ccb15d29$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $af3a2d87ccb15d29$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $af3a2d87ccb15d29$var$wb = d;
            c.target.dispatchEvent(d);
            $af3a2d87ccb15d29$var$wb = null;
        } else return b = $af3a2d87ccb15d29$var$Cb(c), null !== b && $af3a2d87ccb15d29$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $af3a2d87ccb15d29$var$Zc(a, b, c) {
    $af3a2d87ccb15d29$var$Xc(a) && c.delete(b);
}
function $af3a2d87ccb15d29$var$$c() {
    $af3a2d87ccb15d29$var$Jc = !1;
    null !== $af3a2d87ccb15d29$var$Lc && $af3a2d87ccb15d29$var$Xc($af3a2d87ccb15d29$var$Lc) && ($af3a2d87ccb15d29$var$Lc = null);
    null !== $af3a2d87ccb15d29$var$Mc && $af3a2d87ccb15d29$var$Xc($af3a2d87ccb15d29$var$Mc) && ($af3a2d87ccb15d29$var$Mc = null);
    null !== $af3a2d87ccb15d29$var$Nc && $af3a2d87ccb15d29$var$Xc($af3a2d87ccb15d29$var$Nc) && ($af3a2d87ccb15d29$var$Nc = null);
    $af3a2d87ccb15d29$var$Oc.forEach($af3a2d87ccb15d29$var$Zc);
    $af3a2d87ccb15d29$var$Pc.forEach($af3a2d87ccb15d29$var$Zc);
}
function $af3a2d87ccb15d29$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $af3a2d87ccb15d29$var$Jc || ($af3a2d87ccb15d29$var$Jc = !0, $7zDBh.unstable_scheduleCallback($7zDBh.unstable_NormalPriority, $af3a2d87ccb15d29$var$$c)));
}
function $af3a2d87ccb15d29$var$bd(a) {
    function b(b) {
        return $af3a2d87ccb15d29$var$ad(b, a);
    }
    if (0 < $af3a2d87ccb15d29$var$Kc.length) {
        $af3a2d87ccb15d29$var$ad($af3a2d87ccb15d29$var$Kc[0], a);
        for(var c = 1; c < $af3a2d87ccb15d29$var$Kc.length; c++){
            var d = $af3a2d87ccb15d29$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $af3a2d87ccb15d29$var$Lc && $af3a2d87ccb15d29$var$ad($af3a2d87ccb15d29$var$Lc, a);
    null !== $af3a2d87ccb15d29$var$Mc && $af3a2d87ccb15d29$var$ad($af3a2d87ccb15d29$var$Mc, a);
    null !== $af3a2d87ccb15d29$var$Nc && $af3a2d87ccb15d29$var$ad($af3a2d87ccb15d29$var$Nc, a);
    $af3a2d87ccb15d29$var$Oc.forEach(b);
    $af3a2d87ccb15d29$var$Pc.forEach(b);
    for(c = 0; c < $af3a2d87ccb15d29$var$Qc.length; c++)d = $af3a2d87ccb15d29$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $af3a2d87ccb15d29$var$Qc.length && (c = $af3a2d87ccb15d29$var$Qc[0], null === c.blockedOn);)$af3a2d87ccb15d29$var$Vc(c), null === c.blockedOn && $af3a2d87ccb15d29$var$Qc.shift();
}
var $af3a2d87ccb15d29$var$cd = $af3a2d87ccb15d29$var$ua.ReactCurrentBatchConfig, $af3a2d87ccb15d29$var$dd = !0;
function $af3a2d87ccb15d29$var$ed(a, b, c, d) {
    var e = $af3a2d87ccb15d29$var$C, f = $af3a2d87ccb15d29$var$cd.transition;
    $af3a2d87ccb15d29$var$cd.transition = null;
    try {
        $af3a2d87ccb15d29$var$C = 1, $af3a2d87ccb15d29$var$fd(a, b, c, d);
    } finally{
        $af3a2d87ccb15d29$var$C = e, $af3a2d87ccb15d29$var$cd.transition = f;
    }
}
function $af3a2d87ccb15d29$var$gd(a, b, c, d) {
    var e = $af3a2d87ccb15d29$var$C, f = $af3a2d87ccb15d29$var$cd.transition;
    $af3a2d87ccb15d29$var$cd.transition = null;
    try {
        $af3a2d87ccb15d29$var$C = 4, $af3a2d87ccb15d29$var$fd(a, b, c, d);
    } finally{
        $af3a2d87ccb15d29$var$C = e, $af3a2d87ccb15d29$var$cd.transition = f;
    }
}
function $af3a2d87ccb15d29$var$fd(a, b, c, d) {
    if ($af3a2d87ccb15d29$var$dd) {
        var e = $af3a2d87ccb15d29$var$Yc(a, b, c, d);
        if (null === e) $af3a2d87ccb15d29$var$hd(a, b, d, $af3a2d87ccb15d29$var$id, c), $af3a2d87ccb15d29$var$Sc(a, d);
        else if ($af3a2d87ccb15d29$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($af3a2d87ccb15d29$var$Sc(a, d), b & 4 && -1 < $af3a2d87ccb15d29$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $af3a2d87ccb15d29$var$Cb(e);
                null !== f && $af3a2d87ccb15d29$var$Ec(f);
                f = $af3a2d87ccb15d29$var$Yc(a, b, c, d);
                null === f && $af3a2d87ccb15d29$var$hd(a, b, d, $af3a2d87ccb15d29$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $af3a2d87ccb15d29$var$hd(a, b, d, null, c);
    }
}
var $af3a2d87ccb15d29$var$id = null;
function $af3a2d87ccb15d29$var$Yc(a, b, c, d) {
    $af3a2d87ccb15d29$var$id = null;
    a = $af3a2d87ccb15d29$var$xb(d);
    a = $af3a2d87ccb15d29$var$Wc(a);
    if (null !== a) {
        if (b = $af3a2d87ccb15d29$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $af3a2d87ccb15d29$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $af3a2d87ccb15d29$var$id = a;
    return null;
}
function $af3a2d87ccb15d29$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($af3a2d87ccb15d29$var$ec()){
                case $af3a2d87ccb15d29$var$fc:
                    return 1;
                case $af3a2d87ccb15d29$var$gc:
                    return 4;
                case $af3a2d87ccb15d29$var$hc:
                case $af3a2d87ccb15d29$var$ic:
                    return 16;
                case $af3a2d87ccb15d29$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $af3a2d87ccb15d29$var$kd = null, $af3a2d87ccb15d29$var$ld = null, $af3a2d87ccb15d29$var$md = null;
function $af3a2d87ccb15d29$var$nd() {
    if ($af3a2d87ccb15d29$var$md) return $af3a2d87ccb15d29$var$md;
    var a, b = $af3a2d87ccb15d29$var$ld, c = b.length, d, e = "value" in $af3a2d87ccb15d29$var$kd ? $af3a2d87ccb15d29$var$kd.value : $af3a2d87ccb15d29$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $af3a2d87ccb15d29$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $af3a2d87ccb15d29$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $af3a2d87ccb15d29$var$pd() {
    return !0;
}
function $af3a2d87ccb15d29$var$qd() {
    return !1;
}
function $af3a2d87ccb15d29$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $af3a2d87ccb15d29$var$pd : $af3a2d87ccb15d29$var$qd;
        this.isPropagationStopped = $af3a2d87ccb15d29$var$qd;
        return this;
    }
    $af3a2d87ccb15d29$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $af3a2d87ccb15d29$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $af3a2d87ccb15d29$var$pd);
        },
        persist: function() {},
        isPersistent: $af3a2d87ccb15d29$var$pd
    });
    return b;
}
var $af3a2d87ccb15d29$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $af3a2d87ccb15d29$var$td = $af3a2d87ccb15d29$var$rd($af3a2d87ccb15d29$var$sd), $af3a2d87ccb15d29$var$ud = $af3a2d87ccb15d29$var$A({}, $af3a2d87ccb15d29$var$sd, {
    view: 0,
    detail: 0
}), $af3a2d87ccb15d29$var$vd = $af3a2d87ccb15d29$var$rd($af3a2d87ccb15d29$var$ud), $af3a2d87ccb15d29$var$wd, $af3a2d87ccb15d29$var$xd, $af3a2d87ccb15d29$var$yd, $af3a2d87ccb15d29$var$Ad = $af3a2d87ccb15d29$var$A({}, $af3a2d87ccb15d29$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $af3a2d87ccb15d29$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $af3a2d87ccb15d29$var$yd && ($af3a2d87ccb15d29$var$yd && "mousemove" === a.type ? ($af3a2d87ccb15d29$var$wd = a.screenX - $af3a2d87ccb15d29$var$yd.screenX, $af3a2d87ccb15d29$var$xd = a.screenY - $af3a2d87ccb15d29$var$yd.screenY) : $af3a2d87ccb15d29$var$xd = $af3a2d87ccb15d29$var$wd = 0, $af3a2d87ccb15d29$var$yd = a);
        return $af3a2d87ccb15d29$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $af3a2d87ccb15d29$var$xd;
    }
}), $af3a2d87ccb15d29$var$Bd = $af3a2d87ccb15d29$var$rd($af3a2d87ccb15d29$var$Ad), $af3a2d87ccb15d29$var$Cd = $af3a2d87ccb15d29$var$A({}, $af3a2d87ccb15d29$var$Ad, {
    dataTransfer: 0
}), $af3a2d87ccb15d29$var$Dd = $af3a2d87ccb15d29$var$rd($af3a2d87ccb15d29$var$Cd), $af3a2d87ccb15d29$var$Ed = $af3a2d87ccb15d29$var$A({}, $af3a2d87ccb15d29$var$ud, {
    relatedTarget: 0
}), $af3a2d87ccb15d29$var$Fd = $af3a2d87ccb15d29$var$rd($af3a2d87ccb15d29$var$Ed), $af3a2d87ccb15d29$var$Gd = $af3a2d87ccb15d29$var$A({}, $af3a2d87ccb15d29$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $af3a2d87ccb15d29$var$Hd = $af3a2d87ccb15d29$var$rd($af3a2d87ccb15d29$var$Gd), $af3a2d87ccb15d29$var$Id = $af3a2d87ccb15d29$var$A({}, $af3a2d87ccb15d29$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $af3a2d87ccb15d29$var$Jd = $af3a2d87ccb15d29$var$rd($af3a2d87ccb15d29$var$Id), $af3a2d87ccb15d29$var$Kd = $af3a2d87ccb15d29$var$A({}, $af3a2d87ccb15d29$var$sd, {
    data: 0
}), $af3a2d87ccb15d29$var$Ld = $af3a2d87ccb15d29$var$rd($af3a2d87ccb15d29$var$Kd), $af3a2d87ccb15d29$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $af3a2d87ccb15d29$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $af3a2d87ccb15d29$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $af3a2d87ccb15d29$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $af3a2d87ccb15d29$var$Od[a]) ? !!b[a] : !1;
}
function $af3a2d87ccb15d29$var$zd() {
    return $af3a2d87ccb15d29$var$Pd;
}
var $af3a2d87ccb15d29$var$Qd = $af3a2d87ccb15d29$var$A({}, $af3a2d87ccb15d29$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $af3a2d87ccb15d29$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $af3a2d87ccb15d29$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $af3a2d87ccb15d29$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $af3a2d87ccb15d29$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $af3a2d87ccb15d29$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $af3a2d87ccb15d29$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $af3a2d87ccb15d29$var$Rd = $af3a2d87ccb15d29$var$rd($af3a2d87ccb15d29$var$Qd), $af3a2d87ccb15d29$var$Sd = $af3a2d87ccb15d29$var$A({}, $af3a2d87ccb15d29$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $af3a2d87ccb15d29$var$Td = $af3a2d87ccb15d29$var$rd($af3a2d87ccb15d29$var$Sd), $af3a2d87ccb15d29$var$Ud = $af3a2d87ccb15d29$var$A({}, $af3a2d87ccb15d29$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $af3a2d87ccb15d29$var$zd
}), $af3a2d87ccb15d29$var$Vd = $af3a2d87ccb15d29$var$rd($af3a2d87ccb15d29$var$Ud), $af3a2d87ccb15d29$var$Wd = $af3a2d87ccb15d29$var$A({}, $af3a2d87ccb15d29$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $af3a2d87ccb15d29$var$Xd = $af3a2d87ccb15d29$var$rd($af3a2d87ccb15d29$var$Wd), $af3a2d87ccb15d29$var$Yd = $af3a2d87ccb15d29$var$A({}, $af3a2d87ccb15d29$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $af3a2d87ccb15d29$var$Zd = $af3a2d87ccb15d29$var$rd($af3a2d87ccb15d29$var$Yd), $af3a2d87ccb15d29$var$$d = [
    9,
    13,
    27,
    32
], $af3a2d87ccb15d29$var$ae = $af3a2d87ccb15d29$var$ia && "CompositionEvent" in window, $af3a2d87ccb15d29$var$be = null;
$af3a2d87ccb15d29$var$ia && "documentMode" in document && ($af3a2d87ccb15d29$var$be = document.documentMode);
var $af3a2d87ccb15d29$var$ce = $af3a2d87ccb15d29$var$ia && "TextEvent" in window && !$af3a2d87ccb15d29$var$be, $af3a2d87ccb15d29$var$de = $af3a2d87ccb15d29$var$ia && (!$af3a2d87ccb15d29$var$ae || $af3a2d87ccb15d29$var$be && 8 < $af3a2d87ccb15d29$var$be && 11 >= $af3a2d87ccb15d29$var$be), $af3a2d87ccb15d29$var$ee = String.fromCharCode(32), $af3a2d87ccb15d29$var$fe = !1;
function $af3a2d87ccb15d29$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $af3a2d87ccb15d29$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $af3a2d87ccb15d29$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $af3a2d87ccb15d29$var$ie = !1;
function $af3a2d87ccb15d29$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $af3a2d87ccb15d29$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $af3a2d87ccb15d29$var$fe = !0;
            return $af3a2d87ccb15d29$var$ee;
        case "textInput":
            return a = b.data, a === $af3a2d87ccb15d29$var$ee && $af3a2d87ccb15d29$var$fe ? null : a;
        default:
            return null;
    }
}
function $af3a2d87ccb15d29$var$ke(a, b) {
    if ($af3a2d87ccb15d29$var$ie) return "compositionend" === a || !$af3a2d87ccb15d29$var$ae && $af3a2d87ccb15d29$var$ge(a, b) ? (a = $af3a2d87ccb15d29$var$nd(), $af3a2d87ccb15d29$var$md = $af3a2d87ccb15d29$var$ld = $af3a2d87ccb15d29$var$kd = null, $af3a2d87ccb15d29$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $af3a2d87ccb15d29$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $af3a2d87ccb15d29$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $af3a2d87ccb15d29$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$af3a2d87ccb15d29$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $af3a2d87ccb15d29$var$ne(a, b, c, d) {
    $af3a2d87ccb15d29$var$Eb(d);
    b = $af3a2d87ccb15d29$var$oe(b, "onChange");
    0 < b.length && (c = new $af3a2d87ccb15d29$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $af3a2d87ccb15d29$var$pe = null, $af3a2d87ccb15d29$var$qe = null;
function $af3a2d87ccb15d29$var$re(a) {
    $af3a2d87ccb15d29$var$se(a, 0);
}
function $af3a2d87ccb15d29$var$te(a) {
    var b = $af3a2d87ccb15d29$var$ue(a);
    if ($af3a2d87ccb15d29$var$Wa(b)) return a;
}
function $af3a2d87ccb15d29$var$ve(a, b) {
    if ("change" === a) return b;
}
var $af3a2d87ccb15d29$var$we = !1;
if ($af3a2d87ccb15d29$var$ia) {
    var $af3a2d87ccb15d29$var$xe;
    if ($af3a2d87ccb15d29$var$ia) {
        var $af3a2d87ccb15d29$var$ye = "oninput" in document;
        if (!$af3a2d87ccb15d29$var$ye) {
            var $af3a2d87ccb15d29$var$ze = document.createElement("div");
            $af3a2d87ccb15d29$var$ze.setAttribute("oninput", "return;");
            $af3a2d87ccb15d29$var$ye = "function" === typeof $af3a2d87ccb15d29$var$ze.oninput;
        }
        $af3a2d87ccb15d29$var$xe = $af3a2d87ccb15d29$var$ye;
    } else $af3a2d87ccb15d29$var$xe = !1;
    $af3a2d87ccb15d29$var$we = $af3a2d87ccb15d29$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $af3a2d87ccb15d29$var$Ae() {
    $af3a2d87ccb15d29$var$pe && ($af3a2d87ccb15d29$var$pe.detachEvent("onpropertychange", $af3a2d87ccb15d29$var$Be), $af3a2d87ccb15d29$var$qe = $af3a2d87ccb15d29$var$pe = null);
}
function $af3a2d87ccb15d29$var$Be(a) {
    if ("value" === a.propertyName && $af3a2d87ccb15d29$var$te($af3a2d87ccb15d29$var$qe)) {
        var b = [];
        $af3a2d87ccb15d29$var$ne(b, $af3a2d87ccb15d29$var$qe, a, $af3a2d87ccb15d29$var$xb(a));
        $af3a2d87ccb15d29$var$Jb($af3a2d87ccb15d29$var$re, b);
    }
}
function $af3a2d87ccb15d29$var$Ce(a, b, c) {
    "focusin" === a ? ($af3a2d87ccb15d29$var$Ae(), $af3a2d87ccb15d29$var$pe = b, $af3a2d87ccb15d29$var$qe = c, $af3a2d87ccb15d29$var$pe.attachEvent("onpropertychange", $af3a2d87ccb15d29$var$Be)) : "focusout" === a && $af3a2d87ccb15d29$var$Ae();
}
function $af3a2d87ccb15d29$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $af3a2d87ccb15d29$var$te($af3a2d87ccb15d29$var$qe);
}
function $af3a2d87ccb15d29$var$Ee(a, b) {
    if ("click" === a) return $af3a2d87ccb15d29$var$te(b);
}
function $af3a2d87ccb15d29$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $af3a2d87ccb15d29$var$te(b);
}
function $af3a2d87ccb15d29$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $af3a2d87ccb15d29$var$He = "function" === typeof Object.is ? Object.is : $af3a2d87ccb15d29$var$Ge;
function $af3a2d87ccb15d29$var$Ie(a, b) {
    if ($af3a2d87ccb15d29$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$af3a2d87ccb15d29$var$ja.call(b, e) || !$af3a2d87ccb15d29$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $af3a2d87ccb15d29$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $af3a2d87ccb15d29$var$Ke(a, b) {
    var c = $af3a2d87ccb15d29$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $af3a2d87ccb15d29$var$Je(c);
    }
}
function $af3a2d87ccb15d29$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $af3a2d87ccb15d29$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $af3a2d87ccb15d29$var$Me() {
    for(var a = window, b = $af3a2d87ccb15d29$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $af3a2d87ccb15d29$var$Xa(a.document);
    }
    return b;
}
function $af3a2d87ccb15d29$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $af3a2d87ccb15d29$var$Oe(a) {
    var b = $af3a2d87ccb15d29$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $af3a2d87ccb15d29$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $af3a2d87ccb15d29$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $af3a2d87ccb15d29$var$Ke(c, f);
                var g = $af3a2d87ccb15d29$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $af3a2d87ccb15d29$var$Pe = $af3a2d87ccb15d29$var$ia && "documentMode" in document && 11 >= document.documentMode, $af3a2d87ccb15d29$var$Qe = null, $af3a2d87ccb15d29$var$Re = null, $af3a2d87ccb15d29$var$Se = null, $af3a2d87ccb15d29$var$Te = !1;
function $af3a2d87ccb15d29$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $af3a2d87ccb15d29$var$Te || null == $af3a2d87ccb15d29$var$Qe || $af3a2d87ccb15d29$var$Qe !== $af3a2d87ccb15d29$var$Xa(d) || (d = $af3a2d87ccb15d29$var$Qe, "selectionStart" in d && $af3a2d87ccb15d29$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $af3a2d87ccb15d29$var$Se && $af3a2d87ccb15d29$var$Ie($af3a2d87ccb15d29$var$Se, d) || ($af3a2d87ccb15d29$var$Se = d, d = $af3a2d87ccb15d29$var$oe($af3a2d87ccb15d29$var$Re, "onSelect"), 0 < d.length && (b = new $af3a2d87ccb15d29$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $af3a2d87ccb15d29$var$Qe)));
}
function $af3a2d87ccb15d29$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $af3a2d87ccb15d29$var$We = {
    animationend: $af3a2d87ccb15d29$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $af3a2d87ccb15d29$var$Ve("Animation", "AnimationIteration"),
    animationstart: $af3a2d87ccb15d29$var$Ve("Animation", "AnimationStart"),
    transitionend: $af3a2d87ccb15d29$var$Ve("Transition", "TransitionEnd")
}, $af3a2d87ccb15d29$var$Xe = {}, $af3a2d87ccb15d29$var$Ye = {};
$af3a2d87ccb15d29$var$ia && ($af3a2d87ccb15d29$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $af3a2d87ccb15d29$var$We.animationend.animation, delete $af3a2d87ccb15d29$var$We.animationiteration.animation, delete $af3a2d87ccb15d29$var$We.animationstart.animation), "TransitionEvent" in window || delete $af3a2d87ccb15d29$var$We.transitionend.transition);
function $af3a2d87ccb15d29$var$Ze(a) {
    if ($af3a2d87ccb15d29$var$Xe[a]) return $af3a2d87ccb15d29$var$Xe[a];
    if (!$af3a2d87ccb15d29$var$We[a]) return a;
    var b = $af3a2d87ccb15d29$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $af3a2d87ccb15d29$var$Ye) return $af3a2d87ccb15d29$var$Xe[a] = b[c];
    return a;
}
var $af3a2d87ccb15d29$var$$e = $af3a2d87ccb15d29$var$Ze("animationend"), $af3a2d87ccb15d29$var$af = $af3a2d87ccb15d29$var$Ze("animationiteration"), $af3a2d87ccb15d29$var$bf = $af3a2d87ccb15d29$var$Ze("animationstart"), $af3a2d87ccb15d29$var$cf = $af3a2d87ccb15d29$var$Ze("transitionend"), $af3a2d87ccb15d29$var$df = new Map, $af3a2d87ccb15d29$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $af3a2d87ccb15d29$var$ff(a, b) {
    $af3a2d87ccb15d29$var$df.set(a, b);
    $af3a2d87ccb15d29$var$fa(b, [
        a
    ]);
}
for(var $af3a2d87ccb15d29$var$gf = 0; $af3a2d87ccb15d29$var$gf < $af3a2d87ccb15d29$var$ef.length; $af3a2d87ccb15d29$var$gf++){
    var $af3a2d87ccb15d29$var$hf = $af3a2d87ccb15d29$var$ef[$af3a2d87ccb15d29$var$gf], $af3a2d87ccb15d29$var$jf = $af3a2d87ccb15d29$var$hf.toLowerCase(), $af3a2d87ccb15d29$var$kf = $af3a2d87ccb15d29$var$hf[0].toUpperCase() + $af3a2d87ccb15d29$var$hf.slice(1);
    $af3a2d87ccb15d29$var$ff($af3a2d87ccb15d29$var$jf, "on" + $af3a2d87ccb15d29$var$kf);
}
$af3a2d87ccb15d29$var$ff($af3a2d87ccb15d29$var$$e, "onAnimationEnd");
$af3a2d87ccb15d29$var$ff($af3a2d87ccb15d29$var$af, "onAnimationIteration");
$af3a2d87ccb15d29$var$ff($af3a2d87ccb15d29$var$bf, "onAnimationStart");
$af3a2d87ccb15d29$var$ff("dblclick", "onDoubleClick");
$af3a2d87ccb15d29$var$ff("focusin", "onFocus");
$af3a2d87ccb15d29$var$ff("focusout", "onBlur");
$af3a2d87ccb15d29$var$ff($af3a2d87ccb15d29$var$cf, "onTransitionEnd");
$af3a2d87ccb15d29$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$af3a2d87ccb15d29$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$af3a2d87ccb15d29$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$af3a2d87ccb15d29$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$af3a2d87ccb15d29$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$af3a2d87ccb15d29$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$af3a2d87ccb15d29$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$af3a2d87ccb15d29$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$af3a2d87ccb15d29$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$af3a2d87ccb15d29$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $af3a2d87ccb15d29$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $af3a2d87ccb15d29$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($af3a2d87ccb15d29$var$lf));
function $af3a2d87ccb15d29$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $af3a2d87ccb15d29$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $af3a2d87ccb15d29$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $af3a2d87ccb15d29$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $af3a2d87ccb15d29$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($af3a2d87ccb15d29$var$Qb) throw a = $af3a2d87ccb15d29$var$Rb, $af3a2d87ccb15d29$var$Qb = !1, $af3a2d87ccb15d29$var$Rb = null, a;
}
function $af3a2d87ccb15d29$var$D(a, b) {
    var c = b[$af3a2d87ccb15d29$var$of];
    void 0 === c && (c = b[$af3a2d87ccb15d29$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($af3a2d87ccb15d29$var$pf(b, a, 2, !1), c.add(d));
}
function $af3a2d87ccb15d29$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $af3a2d87ccb15d29$var$pf(c, a, d, b);
}
var $af3a2d87ccb15d29$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $af3a2d87ccb15d29$var$sf(a) {
    if (!a[$af3a2d87ccb15d29$var$rf]) {
        a[$af3a2d87ccb15d29$var$rf] = !0;
        $af3a2d87ccb15d29$var$da.forEach(function(b) {
            "selectionchange" !== b && ($af3a2d87ccb15d29$var$mf.has(b) || $af3a2d87ccb15d29$var$qf(b, !1, a), $af3a2d87ccb15d29$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$af3a2d87ccb15d29$var$rf] || (b[$af3a2d87ccb15d29$var$rf] = !0, $af3a2d87ccb15d29$var$qf("selectionchange", !1, b));
    }
}
function $af3a2d87ccb15d29$var$pf(a, b, c, d) {
    switch($af3a2d87ccb15d29$var$jd(b)){
        case 1:
            var e = $af3a2d87ccb15d29$var$ed;
            break;
        case 4:
            e = $af3a2d87ccb15d29$var$gd;
            break;
        default:
            e = $af3a2d87ccb15d29$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$af3a2d87ccb15d29$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $af3a2d87ccb15d29$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $af3a2d87ccb15d29$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $af3a2d87ccb15d29$var$Jb(function() {
        var d = f, e = $af3a2d87ccb15d29$var$xb(c), g = [];
        a: {
            var h = $af3a2d87ccb15d29$var$df.get(a);
            if (void 0 !== h) {
                var k = $af3a2d87ccb15d29$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $af3a2d87ccb15d29$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $af3a2d87ccb15d29$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $af3a2d87ccb15d29$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $af3a2d87ccb15d29$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $af3a2d87ccb15d29$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $af3a2d87ccb15d29$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $af3a2d87ccb15d29$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $af3a2d87ccb15d29$var$Vd;
                        break;
                    case $af3a2d87ccb15d29$var$$e:
                    case $af3a2d87ccb15d29$var$af:
                    case $af3a2d87ccb15d29$var$bf:
                        k = $af3a2d87ccb15d29$var$Hd;
                        break;
                    case $af3a2d87ccb15d29$var$cf:
                        k = $af3a2d87ccb15d29$var$Xd;
                        break;
                    case "scroll":
                        k = $af3a2d87ccb15d29$var$vd;
                        break;
                    case "wheel":
                        k = $af3a2d87ccb15d29$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $af3a2d87ccb15d29$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $af3a2d87ccb15d29$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $af3a2d87ccb15d29$var$Kb(w, x), null != F && t.push($af3a2d87ccb15d29$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $af3a2d87ccb15d29$var$wb && (n = c.relatedTarget || c.fromElement) && ($af3a2d87ccb15d29$var$Wc(n) || n[$af3a2d87ccb15d29$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $af3a2d87ccb15d29$var$Wc(n) : null, null !== n && (J = $af3a2d87ccb15d29$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $af3a2d87ccb15d29$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $af3a2d87ccb15d29$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $af3a2d87ccb15d29$var$ue(k);
                        u = null == n ? h : $af3a2d87ccb15d29$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $af3a2d87ccb15d29$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $af3a2d87ccb15d29$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $af3a2d87ccb15d29$var$vf(F))u++;
                            for(; 0 < w - u;)t = $af3a2d87ccb15d29$var$vf(t), w--;
                            for(; 0 < u - w;)x = $af3a2d87ccb15d29$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $af3a2d87ccb15d29$var$vf(t);
                                x = $af3a2d87ccb15d29$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $af3a2d87ccb15d29$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $af3a2d87ccb15d29$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $af3a2d87ccb15d29$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $af3a2d87ccb15d29$var$ve;
                else if ($af3a2d87ccb15d29$var$me(h)) {
                    if ($af3a2d87ccb15d29$var$we) na = $af3a2d87ccb15d29$var$Fe;
                    else {
                        na = $af3a2d87ccb15d29$var$De;
                        var xa = $af3a2d87ccb15d29$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $af3a2d87ccb15d29$var$Ee);
                if (na && (na = na(a, d))) {
                    $af3a2d87ccb15d29$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $af3a2d87ccb15d29$var$cb(h, "number", h.value);
            }
            xa = d ? $af3a2d87ccb15d29$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($af3a2d87ccb15d29$var$me(xa) || "true" === xa.contentEditable) $af3a2d87ccb15d29$var$Qe = xa, $af3a2d87ccb15d29$var$Re = d, $af3a2d87ccb15d29$var$Se = null;
                    break;
                case "focusout":
                    $af3a2d87ccb15d29$var$Se = $af3a2d87ccb15d29$var$Re = $af3a2d87ccb15d29$var$Qe = null;
                    break;
                case "mousedown":
                    $af3a2d87ccb15d29$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $af3a2d87ccb15d29$var$Te = !1;
                    $af3a2d87ccb15d29$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($af3a2d87ccb15d29$var$Pe) break;
                case "keydown":
                case "keyup":
                    $af3a2d87ccb15d29$var$Ue(g, c, e);
            }
            var $a;
            if ($af3a2d87ccb15d29$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $af3a2d87ccb15d29$var$ie ? $af3a2d87ccb15d29$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($af3a2d87ccb15d29$var$de && "ko" !== c.locale && ($af3a2d87ccb15d29$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $af3a2d87ccb15d29$var$ie && ($a = $af3a2d87ccb15d29$var$nd()) : ($af3a2d87ccb15d29$var$kd = e, $af3a2d87ccb15d29$var$ld = "value" in $af3a2d87ccb15d29$var$kd ? $af3a2d87ccb15d29$var$kd.value : $af3a2d87ccb15d29$var$kd.textContent, $af3a2d87ccb15d29$var$ie = !0)), xa = $af3a2d87ccb15d29$var$oe(d, ba), 0 < xa.length && (ba = new $af3a2d87ccb15d29$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $af3a2d87ccb15d29$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $af3a2d87ccb15d29$var$ce ? $af3a2d87ccb15d29$var$je(a, c) : $af3a2d87ccb15d29$var$ke(a, c)) d = $af3a2d87ccb15d29$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $af3a2d87ccb15d29$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $af3a2d87ccb15d29$var$se(g, b);
    });
}
function $af3a2d87ccb15d29$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $af3a2d87ccb15d29$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $af3a2d87ccb15d29$var$Kb(a, c), null != f && d.unshift($af3a2d87ccb15d29$var$tf(a, f, e)), f = $af3a2d87ccb15d29$var$Kb(a, b), null != f && d.push($af3a2d87ccb15d29$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $af3a2d87ccb15d29$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $af3a2d87ccb15d29$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $af3a2d87ccb15d29$var$Kb(c, f), null != k && g.unshift($af3a2d87ccb15d29$var$tf(c, k, h))) : e || (k = $af3a2d87ccb15d29$var$Kb(c, f), null != k && g.push($af3a2d87ccb15d29$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $af3a2d87ccb15d29$var$xf = /\r\n?/g, $af3a2d87ccb15d29$var$yf = /\u0000|\uFFFD/g;
function $af3a2d87ccb15d29$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($af3a2d87ccb15d29$var$xf, "\n").replace($af3a2d87ccb15d29$var$yf, "");
}
function $af3a2d87ccb15d29$var$Af(a, b, c) {
    b = $af3a2d87ccb15d29$var$zf(b);
    if ($af3a2d87ccb15d29$var$zf(a) !== b && c) throw Error($af3a2d87ccb15d29$var$p(425));
}
function $af3a2d87ccb15d29$var$Bf() {}
var $af3a2d87ccb15d29$var$Cf = null, $af3a2d87ccb15d29$var$Df = null;
function $af3a2d87ccb15d29$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $af3a2d87ccb15d29$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $af3a2d87ccb15d29$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $af3a2d87ccb15d29$var$Hf = "function" === typeof Promise ? Promise : void 0, $af3a2d87ccb15d29$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $af3a2d87ccb15d29$var$Hf ? function(a) {
    return $af3a2d87ccb15d29$var$Hf.resolve(null).then(a).catch($af3a2d87ccb15d29$var$If);
} : $af3a2d87ccb15d29$var$Ff;
function $af3a2d87ccb15d29$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $af3a2d87ccb15d29$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $af3a2d87ccb15d29$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $af3a2d87ccb15d29$var$bd(b);
}
function $af3a2d87ccb15d29$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $af3a2d87ccb15d29$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $af3a2d87ccb15d29$var$Nf = Math.random().toString(36).slice(2), $af3a2d87ccb15d29$var$Of = "__reactFiber$" + $af3a2d87ccb15d29$var$Nf, $af3a2d87ccb15d29$var$Pf = "__reactProps$" + $af3a2d87ccb15d29$var$Nf, $af3a2d87ccb15d29$var$uf = "__reactContainer$" + $af3a2d87ccb15d29$var$Nf, $af3a2d87ccb15d29$var$of = "__reactEvents$" + $af3a2d87ccb15d29$var$Nf, $af3a2d87ccb15d29$var$Qf = "__reactListeners$" + $af3a2d87ccb15d29$var$Nf, $af3a2d87ccb15d29$var$Rf = "__reactHandles$" + $af3a2d87ccb15d29$var$Nf;
function $af3a2d87ccb15d29$var$Wc(a) {
    var b = a[$af3a2d87ccb15d29$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$af3a2d87ccb15d29$var$uf] || c[$af3a2d87ccb15d29$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $af3a2d87ccb15d29$var$Mf(a); null !== a;){
                if (c = a[$af3a2d87ccb15d29$var$Of]) return c;
                a = $af3a2d87ccb15d29$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $af3a2d87ccb15d29$var$Cb(a) {
    a = a[$af3a2d87ccb15d29$var$Of] || a[$af3a2d87ccb15d29$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $af3a2d87ccb15d29$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($af3a2d87ccb15d29$var$p(33));
}
function $af3a2d87ccb15d29$var$Db(a) {
    return a[$af3a2d87ccb15d29$var$Pf] || null;
}
var $af3a2d87ccb15d29$var$Sf = [], $af3a2d87ccb15d29$var$Tf = -1;
function $af3a2d87ccb15d29$var$Uf(a) {
    return {
        current: a
    };
}
function $af3a2d87ccb15d29$var$E(a) {
    0 > $af3a2d87ccb15d29$var$Tf || (a.current = $af3a2d87ccb15d29$var$Sf[$af3a2d87ccb15d29$var$Tf], $af3a2d87ccb15d29$var$Sf[$af3a2d87ccb15d29$var$Tf] = null, $af3a2d87ccb15d29$var$Tf--);
}
function $af3a2d87ccb15d29$var$G(a, b) {
    $af3a2d87ccb15d29$var$Tf++;
    $af3a2d87ccb15d29$var$Sf[$af3a2d87ccb15d29$var$Tf] = a.current;
    a.current = b;
}
var $af3a2d87ccb15d29$var$Vf = {}, $af3a2d87ccb15d29$var$H = $af3a2d87ccb15d29$var$Uf($af3a2d87ccb15d29$var$Vf), $af3a2d87ccb15d29$var$Wf = $af3a2d87ccb15d29$var$Uf(!1), $af3a2d87ccb15d29$var$Xf = $af3a2d87ccb15d29$var$Vf;
function $af3a2d87ccb15d29$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $af3a2d87ccb15d29$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $af3a2d87ccb15d29$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $af3a2d87ccb15d29$var$$f() {
    $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$Wf);
    $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$H);
}
function $af3a2d87ccb15d29$var$ag(a, b, c) {
    if ($af3a2d87ccb15d29$var$H.current !== $af3a2d87ccb15d29$var$Vf) throw Error($af3a2d87ccb15d29$var$p(168));
    $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$H, b);
    $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$Wf, c);
}
function $af3a2d87ccb15d29$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($af3a2d87ccb15d29$var$p(108, $af3a2d87ccb15d29$var$Ra(a) || "Unknown", e));
    return $af3a2d87ccb15d29$var$A({}, c, d);
}
function $af3a2d87ccb15d29$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $af3a2d87ccb15d29$var$Vf;
    $af3a2d87ccb15d29$var$Xf = $af3a2d87ccb15d29$var$H.current;
    $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$H, a);
    $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$Wf, $af3a2d87ccb15d29$var$Wf.current);
    return !0;
}
function $af3a2d87ccb15d29$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($af3a2d87ccb15d29$var$p(169));
    c ? (a = $af3a2d87ccb15d29$var$bg(a, b, $af3a2d87ccb15d29$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$Wf), $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$H), $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$H, a)) : $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$Wf);
    $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$Wf, c);
}
var $af3a2d87ccb15d29$var$eg = null, $af3a2d87ccb15d29$var$fg = !1, $af3a2d87ccb15d29$var$gg = !1;
function $af3a2d87ccb15d29$var$hg(a) {
    null === $af3a2d87ccb15d29$var$eg ? $af3a2d87ccb15d29$var$eg = [
        a
    ] : $af3a2d87ccb15d29$var$eg.push(a);
}
function $af3a2d87ccb15d29$var$ig(a) {
    $af3a2d87ccb15d29$var$fg = !0;
    $af3a2d87ccb15d29$var$hg(a);
}
function $af3a2d87ccb15d29$var$jg() {
    if (!$af3a2d87ccb15d29$var$gg && null !== $af3a2d87ccb15d29$var$eg) {
        $af3a2d87ccb15d29$var$gg = !0;
        var a = 0, b = $af3a2d87ccb15d29$var$C;
        try {
            var c = $af3a2d87ccb15d29$var$eg;
            for($af3a2d87ccb15d29$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $af3a2d87ccb15d29$var$eg = null;
            $af3a2d87ccb15d29$var$fg = !1;
        } catch (e) {
            throw null !== $af3a2d87ccb15d29$var$eg && ($af3a2d87ccb15d29$var$eg = $af3a2d87ccb15d29$var$eg.slice(a + 1)), $af3a2d87ccb15d29$var$ac($af3a2d87ccb15d29$var$fc, $af3a2d87ccb15d29$var$jg), e;
        } finally{
            $af3a2d87ccb15d29$var$C = b, $af3a2d87ccb15d29$var$gg = !1;
        }
    }
    return null;
}
var $af3a2d87ccb15d29$var$kg = [], $af3a2d87ccb15d29$var$lg = 0, $af3a2d87ccb15d29$var$mg = null, $af3a2d87ccb15d29$var$ng = 0, $af3a2d87ccb15d29$var$og = [], $af3a2d87ccb15d29$var$pg = 0, $af3a2d87ccb15d29$var$qg = null, $af3a2d87ccb15d29$var$rg = 1, $af3a2d87ccb15d29$var$sg = "";
function $af3a2d87ccb15d29$var$tg(a, b) {
    $af3a2d87ccb15d29$var$kg[$af3a2d87ccb15d29$var$lg++] = $af3a2d87ccb15d29$var$ng;
    $af3a2d87ccb15d29$var$kg[$af3a2d87ccb15d29$var$lg++] = $af3a2d87ccb15d29$var$mg;
    $af3a2d87ccb15d29$var$mg = a;
    $af3a2d87ccb15d29$var$ng = b;
}
function $af3a2d87ccb15d29$var$ug(a, b, c) {
    $af3a2d87ccb15d29$var$og[$af3a2d87ccb15d29$var$pg++] = $af3a2d87ccb15d29$var$rg;
    $af3a2d87ccb15d29$var$og[$af3a2d87ccb15d29$var$pg++] = $af3a2d87ccb15d29$var$sg;
    $af3a2d87ccb15d29$var$og[$af3a2d87ccb15d29$var$pg++] = $af3a2d87ccb15d29$var$qg;
    $af3a2d87ccb15d29$var$qg = a;
    var d = $af3a2d87ccb15d29$var$rg;
    a = $af3a2d87ccb15d29$var$sg;
    var e = 32 - $af3a2d87ccb15d29$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $af3a2d87ccb15d29$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $af3a2d87ccb15d29$var$rg = 1 << 32 - $af3a2d87ccb15d29$var$oc(b) + e | c << e | d;
        $af3a2d87ccb15d29$var$sg = f + a;
    } else $af3a2d87ccb15d29$var$rg = 1 << f | c << e | d, $af3a2d87ccb15d29$var$sg = a;
}
function $af3a2d87ccb15d29$var$vg(a) {
    null !== a.return && ($af3a2d87ccb15d29$var$tg(a, 1), $af3a2d87ccb15d29$var$ug(a, 1, 0));
}
function $af3a2d87ccb15d29$var$wg(a) {
    for(; a === $af3a2d87ccb15d29$var$mg;)$af3a2d87ccb15d29$var$mg = $af3a2d87ccb15d29$var$kg[--$af3a2d87ccb15d29$var$lg], $af3a2d87ccb15d29$var$kg[$af3a2d87ccb15d29$var$lg] = null, $af3a2d87ccb15d29$var$ng = $af3a2d87ccb15d29$var$kg[--$af3a2d87ccb15d29$var$lg], $af3a2d87ccb15d29$var$kg[$af3a2d87ccb15d29$var$lg] = null;
    for(; a === $af3a2d87ccb15d29$var$qg;)$af3a2d87ccb15d29$var$qg = $af3a2d87ccb15d29$var$og[--$af3a2d87ccb15d29$var$pg], $af3a2d87ccb15d29$var$og[$af3a2d87ccb15d29$var$pg] = null, $af3a2d87ccb15d29$var$sg = $af3a2d87ccb15d29$var$og[--$af3a2d87ccb15d29$var$pg], $af3a2d87ccb15d29$var$og[$af3a2d87ccb15d29$var$pg] = null, $af3a2d87ccb15d29$var$rg = $af3a2d87ccb15d29$var$og[--$af3a2d87ccb15d29$var$pg], $af3a2d87ccb15d29$var$og[$af3a2d87ccb15d29$var$pg] = null;
}
var $af3a2d87ccb15d29$var$xg = null, $af3a2d87ccb15d29$var$yg = null, $af3a2d87ccb15d29$var$I = !1, $af3a2d87ccb15d29$var$zg = null;
function $af3a2d87ccb15d29$var$Ag(a, b) {
    var c = $af3a2d87ccb15d29$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $af3a2d87ccb15d29$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $af3a2d87ccb15d29$var$xg = a, $af3a2d87ccb15d29$var$yg = $af3a2d87ccb15d29$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $af3a2d87ccb15d29$var$xg = a, $af3a2d87ccb15d29$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $af3a2d87ccb15d29$var$qg ? {
                id: $af3a2d87ccb15d29$var$rg,
                overflow: $af3a2d87ccb15d29$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $af3a2d87ccb15d29$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $af3a2d87ccb15d29$var$xg = a, $af3a2d87ccb15d29$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $af3a2d87ccb15d29$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $af3a2d87ccb15d29$var$Eg(a) {
    if ($af3a2d87ccb15d29$var$I) {
        var b = $af3a2d87ccb15d29$var$yg;
        if (b) {
            var c = b;
            if (!$af3a2d87ccb15d29$var$Cg(a, b)) {
                if ($af3a2d87ccb15d29$var$Dg(a)) throw Error($af3a2d87ccb15d29$var$p(418));
                b = $af3a2d87ccb15d29$var$Lf(c.nextSibling);
                var d = $af3a2d87ccb15d29$var$xg;
                b && $af3a2d87ccb15d29$var$Cg(a, b) ? $af3a2d87ccb15d29$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $af3a2d87ccb15d29$var$I = !1, $af3a2d87ccb15d29$var$xg = a);
            }
        } else {
            if ($af3a2d87ccb15d29$var$Dg(a)) throw Error($af3a2d87ccb15d29$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $af3a2d87ccb15d29$var$I = !1;
            $af3a2d87ccb15d29$var$xg = a;
        }
    }
}
function $af3a2d87ccb15d29$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $af3a2d87ccb15d29$var$xg = a;
}
function $af3a2d87ccb15d29$var$Gg(a) {
    if (a !== $af3a2d87ccb15d29$var$xg) return !1;
    if (!$af3a2d87ccb15d29$var$I) return $af3a2d87ccb15d29$var$Fg(a), $af3a2d87ccb15d29$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$af3a2d87ccb15d29$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $af3a2d87ccb15d29$var$yg)) {
        if ($af3a2d87ccb15d29$var$Dg(a)) throw $af3a2d87ccb15d29$var$Hg(), Error($af3a2d87ccb15d29$var$p(418));
        for(; b;)$af3a2d87ccb15d29$var$Ag(a, b), b = $af3a2d87ccb15d29$var$Lf(b.nextSibling);
    }
    $af3a2d87ccb15d29$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($af3a2d87ccb15d29$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $af3a2d87ccb15d29$var$yg = $af3a2d87ccb15d29$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $af3a2d87ccb15d29$var$yg = null;
        }
    } else $af3a2d87ccb15d29$var$yg = $af3a2d87ccb15d29$var$xg ? $af3a2d87ccb15d29$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $af3a2d87ccb15d29$var$Hg() {
    for(var a = $af3a2d87ccb15d29$var$yg; a;)a = $af3a2d87ccb15d29$var$Lf(a.nextSibling);
}
function $af3a2d87ccb15d29$var$Ig() {
    $af3a2d87ccb15d29$var$yg = $af3a2d87ccb15d29$var$xg = null;
    $af3a2d87ccb15d29$var$I = !1;
}
function $af3a2d87ccb15d29$var$Jg(a) {
    null === $af3a2d87ccb15d29$var$zg ? $af3a2d87ccb15d29$var$zg = [
        a
    ] : $af3a2d87ccb15d29$var$zg.push(a);
}
var $af3a2d87ccb15d29$var$Kg = $af3a2d87ccb15d29$var$ua.ReactCurrentBatchConfig;
function $af3a2d87ccb15d29$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $af3a2d87ccb15d29$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $af3a2d87ccb15d29$var$Mg = $af3a2d87ccb15d29$var$Uf(null), $af3a2d87ccb15d29$var$Ng = null, $af3a2d87ccb15d29$var$Og = null, $af3a2d87ccb15d29$var$Pg = null;
function $af3a2d87ccb15d29$var$Qg() {
    $af3a2d87ccb15d29$var$Pg = $af3a2d87ccb15d29$var$Og = $af3a2d87ccb15d29$var$Ng = null;
}
function $af3a2d87ccb15d29$var$Rg(a) {
    var b = $af3a2d87ccb15d29$var$Mg.current;
    $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$Mg);
    a._currentValue = b;
}
function $af3a2d87ccb15d29$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $af3a2d87ccb15d29$var$Tg(a, b) {
    $af3a2d87ccb15d29$var$Ng = a;
    $af3a2d87ccb15d29$var$Pg = $af3a2d87ccb15d29$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($af3a2d87ccb15d29$var$Ug = !0), a.firstContext = null);
}
function $af3a2d87ccb15d29$var$Vg(a) {
    var b = a._currentValue;
    if ($af3a2d87ccb15d29$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $af3a2d87ccb15d29$var$Og) {
            if (null === $af3a2d87ccb15d29$var$Ng) throw Error($af3a2d87ccb15d29$var$p(308));
            $af3a2d87ccb15d29$var$Og = a;
            $af3a2d87ccb15d29$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $af3a2d87ccb15d29$var$Og = $af3a2d87ccb15d29$var$Og.next = a;
    }
    return b;
}
var $af3a2d87ccb15d29$var$Wg = null;
function $af3a2d87ccb15d29$var$Xg(a) {
    null === $af3a2d87ccb15d29$var$Wg ? $af3a2d87ccb15d29$var$Wg = [
        a
    ] : $af3a2d87ccb15d29$var$Wg.push(a);
}
function $af3a2d87ccb15d29$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $af3a2d87ccb15d29$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $af3a2d87ccb15d29$var$Zg(a, d);
}
function $af3a2d87ccb15d29$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $af3a2d87ccb15d29$var$$g = !1;
function $af3a2d87ccb15d29$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $af3a2d87ccb15d29$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $af3a2d87ccb15d29$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $af3a2d87ccb15d29$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($af3a2d87ccb15d29$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $af3a2d87ccb15d29$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $af3a2d87ccb15d29$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $af3a2d87ccb15d29$var$Zg(a, c);
}
function $af3a2d87ccb15d29$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $af3a2d87ccb15d29$var$Cc(a, c);
    }
}
function $af3a2d87ccb15d29$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $af3a2d87ccb15d29$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $af3a2d87ccb15d29$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $af3a2d87ccb15d29$var$A({}, q, r);
                            break a;
                        case 2:
                            $af3a2d87ccb15d29$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $af3a2d87ccb15d29$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $af3a2d87ccb15d29$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($af3a2d87ccb15d29$var$p(191, e));
            e.call(d);
        }
    }
}
var $af3a2d87ccb15d29$var$jh = (new $lx97N.Component).refs;
function $af3a2d87ccb15d29$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $af3a2d87ccb15d29$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $af3a2d87ccb15d29$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $af3a2d87ccb15d29$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $af3a2d87ccb15d29$var$L(), e = $af3a2d87ccb15d29$var$lh(a), f = $af3a2d87ccb15d29$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $af3a2d87ccb15d29$var$dh(a, f, e);
        null !== b && ($af3a2d87ccb15d29$var$mh(b, a, e, d), $af3a2d87ccb15d29$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $af3a2d87ccb15d29$var$L(), e = $af3a2d87ccb15d29$var$lh(a), f = $af3a2d87ccb15d29$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $af3a2d87ccb15d29$var$dh(a, f, e);
        null !== b && ($af3a2d87ccb15d29$var$mh(b, a, e, d), $af3a2d87ccb15d29$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $af3a2d87ccb15d29$var$L(), d = $af3a2d87ccb15d29$var$lh(a), e = $af3a2d87ccb15d29$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $af3a2d87ccb15d29$var$dh(a, e, d);
        null !== b && ($af3a2d87ccb15d29$var$mh(b, a, d, c), $af3a2d87ccb15d29$var$eh(b, a, d));
    }
};
function $af3a2d87ccb15d29$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$af3a2d87ccb15d29$var$Ie(c, d) || !$af3a2d87ccb15d29$var$Ie(e, f) : !0;
}
function $af3a2d87ccb15d29$var$ph(a, b, c) {
    var d = !1, e = $af3a2d87ccb15d29$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $af3a2d87ccb15d29$var$Vg(f) : (e = $af3a2d87ccb15d29$var$Zf(b) ? $af3a2d87ccb15d29$var$Xf : $af3a2d87ccb15d29$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $af3a2d87ccb15d29$var$Yf(a, e) : $af3a2d87ccb15d29$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $af3a2d87ccb15d29$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $af3a2d87ccb15d29$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $af3a2d87ccb15d29$var$nh.enqueueReplaceState(b, b.state, null);
}
function $af3a2d87ccb15d29$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $af3a2d87ccb15d29$var$jh;
    $af3a2d87ccb15d29$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $af3a2d87ccb15d29$var$Vg(f) : (f = $af3a2d87ccb15d29$var$Zf(b) ? $af3a2d87ccb15d29$var$Xf : $af3a2d87ccb15d29$var$H.current, e.context = $af3a2d87ccb15d29$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($af3a2d87ccb15d29$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $af3a2d87ccb15d29$var$nh.enqueueReplaceState(e, e.state, null), $af3a2d87ccb15d29$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $af3a2d87ccb15d29$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($af3a2d87ccb15d29$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($af3a2d87ccb15d29$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $af3a2d87ccb15d29$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($af3a2d87ccb15d29$var$p(284));
        if (!c._owner) throw Error($af3a2d87ccb15d29$var$p(290, a));
    }
    return a;
}
function $af3a2d87ccb15d29$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($af3a2d87ccb15d29$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $af3a2d87ccb15d29$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $af3a2d87ccb15d29$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $af3a2d87ccb15d29$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $af3a2d87ccb15d29$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $af3a2d87ccb15d29$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $af3a2d87ccb15d29$var$Ha && $af3a2d87ccb15d29$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $af3a2d87ccb15d29$var$sh(a, b, c), d.return = a, d;
        d = $af3a2d87ccb15d29$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $af3a2d87ccb15d29$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $af3a2d87ccb15d29$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $af3a2d87ccb15d29$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $af3a2d87ccb15d29$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $af3a2d87ccb15d29$var$va:
                    return c = $af3a2d87ccb15d29$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $af3a2d87ccb15d29$var$sh(a, null, b), c.return = a, c;
                case $af3a2d87ccb15d29$var$wa:
                    return b = $af3a2d87ccb15d29$var$zh(b, a.mode, c), b.return = a, b;
                case $af3a2d87ccb15d29$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($af3a2d87ccb15d29$var$eb(b) || $af3a2d87ccb15d29$var$Ka(b)) return b = $af3a2d87ccb15d29$var$Ah(b, a.mode, c, null), b.return = a, b;
            $af3a2d87ccb15d29$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $af3a2d87ccb15d29$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $af3a2d87ccb15d29$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $af3a2d87ccb15d29$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($af3a2d87ccb15d29$var$eb(c) || $af3a2d87ccb15d29$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $af3a2d87ccb15d29$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $af3a2d87ccb15d29$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $af3a2d87ccb15d29$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $af3a2d87ccb15d29$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($af3a2d87ccb15d29$var$eb(d) || $af3a2d87ccb15d29$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $af3a2d87ccb15d29$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $af3a2d87ccb15d29$var$I && $af3a2d87ccb15d29$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $af3a2d87ccb15d29$var$I && $af3a2d87ccb15d29$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $af3a2d87ccb15d29$var$I && $af3a2d87ccb15d29$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $af3a2d87ccb15d29$var$Ka(h);
        if ("function" !== typeof l) throw Error($af3a2d87ccb15d29$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($af3a2d87ccb15d29$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $af3a2d87ccb15d29$var$I && $af3a2d87ccb15d29$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $af3a2d87ccb15d29$var$I && $af3a2d87ccb15d29$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $af3a2d87ccb15d29$var$I && $af3a2d87ccb15d29$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $af3a2d87ccb15d29$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $af3a2d87ccb15d29$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $af3a2d87ccb15d29$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $af3a2d87ccb15d29$var$Ha && $af3a2d87ccb15d29$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $af3a2d87ccb15d29$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $af3a2d87ccb15d29$var$ya ? (d = $af3a2d87ccb15d29$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $af3a2d87ccb15d29$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $af3a2d87ccb15d29$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $af3a2d87ccb15d29$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $af3a2d87ccb15d29$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $af3a2d87ccb15d29$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($af3a2d87ccb15d29$var$eb(f)) return n(a, d, f, h);
            if ($af3a2d87ccb15d29$var$Ka(f)) return t(a, d, f, h);
            $af3a2d87ccb15d29$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $af3a2d87ccb15d29$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $af3a2d87ccb15d29$var$Bh = $af3a2d87ccb15d29$var$vh(!0), $af3a2d87ccb15d29$var$Ch = $af3a2d87ccb15d29$var$vh(!1), $af3a2d87ccb15d29$var$Dh = {}, $af3a2d87ccb15d29$var$Eh = $af3a2d87ccb15d29$var$Uf($af3a2d87ccb15d29$var$Dh), $af3a2d87ccb15d29$var$Fh = $af3a2d87ccb15d29$var$Uf($af3a2d87ccb15d29$var$Dh), $af3a2d87ccb15d29$var$Gh = $af3a2d87ccb15d29$var$Uf($af3a2d87ccb15d29$var$Dh);
function $af3a2d87ccb15d29$var$Hh(a) {
    if (a === $af3a2d87ccb15d29$var$Dh) throw Error($af3a2d87ccb15d29$var$p(174));
    return a;
}
function $af3a2d87ccb15d29$var$Ih(a, b) {
    $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$Gh, b);
    $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$Fh, a);
    $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$Eh, $af3a2d87ccb15d29$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $af3a2d87ccb15d29$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $af3a2d87ccb15d29$var$lb(b, a);
    }
    $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$Eh);
    $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$Eh, b);
}
function $af3a2d87ccb15d29$var$Jh() {
    $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$Eh);
    $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$Fh);
    $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$Gh);
}
function $af3a2d87ccb15d29$var$Kh(a) {
    $af3a2d87ccb15d29$var$Hh($af3a2d87ccb15d29$var$Gh.current);
    var b = $af3a2d87ccb15d29$var$Hh($af3a2d87ccb15d29$var$Eh.current);
    var c = $af3a2d87ccb15d29$var$lb(b, a.type);
    b !== c && ($af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$Fh, a), $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$Eh, c));
}
function $af3a2d87ccb15d29$var$Lh(a) {
    $af3a2d87ccb15d29$var$Fh.current === a && ($af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$Eh), $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$Fh));
}
var $af3a2d87ccb15d29$var$M = $af3a2d87ccb15d29$var$Uf(0);
function $af3a2d87ccb15d29$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $af3a2d87ccb15d29$var$Nh = [];
function $af3a2d87ccb15d29$var$Oh() {
    for(var a = 0; a < $af3a2d87ccb15d29$var$Nh.length; a++)$af3a2d87ccb15d29$var$Nh[a]._workInProgressVersionPrimary = null;
    $af3a2d87ccb15d29$var$Nh.length = 0;
}
var $af3a2d87ccb15d29$var$Ph = $af3a2d87ccb15d29$var$ua.ReactCurrentDispatcher, $af3a2d87ccb15d29$var$Qh = $af3a2d87ccb15d29$var$ua.ReactCurrentBatchConfig, $af3a2d87ccb15d29$var$Rh = 0, $af3a2d87ccb15d29$var$N = null, $af3a2d87ccb15d29$var$O = null, $af3a2d87ccb15d29$var$P = null, $af3a2d87ccb15d29$var$Sh = !1, $af3a2d87ccb15d29$var$Th = !1, $af3a2d87ccb15d29$var$Uh = 0, $af3a2d87ccb15d29$var$Vh = 0;
function $af3a2d87ccb15d29$var$Q() {
    throw Error($af3a2d87ccb15d29$var$p(321));
}
function $af3a2d87ccb15d29$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$af3a2d87ccb15d29$var$He(a[c], b[c])) return !1;
    return !0;
}
function $af3a2d87ccb15d29$var$Xh(a, b, c, d, e, f) {
    $af3a2d87ccb15d29$var$Rh = f;
    $af3a2d87ccb15d29$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $af3a2d87ccb15d29$var$Ph.current = null === a || null === a.memoizedState ? $af3a2d87ccb15d29$var$Yh : $af3a2d87ccb15d29$var$Zh;
    a = c(d, e);
    if ($af3a2d87ccb15d29$var$Th) {
        f = 0;
        do {
            $af3a2d87ccb15d29$var$Th = !1;
            $af3a2d87ccb15d29$var$Uh = 0;
            if (25 <= f) throw Error($af3a2d87ccb15d29$var$p(301));
            f += 1;
            $af3a2d87ccb15d29$var$P = $af3a2d87ccb15d29$var$O = null;
            b.updateQueue = null;
            $af3a2d87ccb15d29$var$Ph.current = $af3a2d87ccb15d29$var$$h;
            a = c(d, e);
        }while ($af3a2d87ccb15d29$var$Th);
    }
    $af3a2d87ccb15d29$var$Ph.current = $af3a2d87ccb15d29$var$ai;
    b = null !== $af3a2d87ccb15d29$var$O && null !== $af3a2d87ccb15d29$var$O.next;
    $af3a2d87ccb15d29$var$Rh = 0;
    $af3a2d87ccb15d29$var$P = $af3a2d87ccb15d29$var$O = $af3a2d87ccb15d29$var$N = null;
    $af3a2d87ccb15d29$var$Sh = !1;
    if (b) throw Error($af3a2d87ccb15d29$var$p(300));
    return a;
}
function $af3a2d87ccb15d29$var$bi() {
    var a = 0 !== $af3a2d87ccb15d29$var$Uh;
    $af3a2d87ccb15d29$var$Uh = 0;
    return a;
}
function $af3a2d87ccb15d29$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $af3a2d87ccb15d29$var$P ? $af3a2d87ccb15d29$var$N.memoizedState = $af3a2d87ccb15d29$var$P = a : $af3a2d87ccb15d29$var$P = $af3a2d87ccb15d29$var$P.next = a;
    return $af3a2d87ccb15d29$var$P;
}
function $af3a2d87ccb15d29$var$di() {
    if (null === $af3a2d87ccb15d29$var$O) {
        var a = $af3a2d87ccb15d29$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $af3a2d87ccb15d29$var$O.next;
    var b = null === $af3a2d87ccb15d29$var$P ? $af3a2d87ccb15d29$var$N.memoizedState : $af3a2d87ccb15d29$var$P.next;
    if (null !== b) $af3a2d87ccb15d29$var$P = b, $af3a2d87ccb15d29$var$O = a;
    else {
        if (null === a) throw Error($af3a2d87ccb15d29$var$p(310));
        $af3a2d87ccb15d29$var$O = a;
        a = {
            memoizedState: $af3a2d87ccb15d29$var$O.memoizedState,
            baseState: $af3a2d87ccb15d29$var$O.baseState,
            baseQueue: $af3a2d87ccb15d29$var$O.baseQueue,
            queue: $af3a2d87ccb15d29$var$O.queue,
            next: null
        };
        null === $af3a2d87ccb15d29$var$P ? $af3a2d87ccb15d29$var$N.memoizedState = $af3a2d87ccb15d29$var$P = a : $af3a2d87ccb15d29$var$P = $af3a2d87ccb15d29$var$P.next = a;
    }
    return $af3a2d87ccb15d29$var$P;
}
function $af3a2d87ccb15d29$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $af3a2d87ccb15d29$var$fi(a) {
    var b = $af3a2d87ccb15d29$var$di(), c = b.queue;
    if (null === c) throw Error($af3a2d87ccb15d29$var$p(311));
    c.lastRenderedReducer = a;
    var d = $af3a2d87ccb15d29$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($af3a2d87ccb15d29$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $af3a2d87ccb15d29$var$N.lanes |= m;
                $af3a2d87ccb15d29$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $af3a2d87ccb15d29$var$He(d, b.memoizedState) || ($af3a2d87ccb15d29$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $af3a2d87ccb15d29$var$N.lanes |= f, $af3a2d87ccb15d29$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $af3a2d87ccb15d29$var$gi(a) {
    var b = $af3a2d87ccb15d29$var$di(), c = b.queue;
    if (null === c) throw Error($af3a2d87ccb15d29$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $af3a2d87ccb15d29$var$He(f, b.memoizedState) || ($af3a2d87ccb15d29$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $af3a2d87ccb15d29$var$hi() {}
function $af3a2d87ccb15d29$var$ii(a, b) {
    var c = $af3a2d87ccb15d29$var$N, d = $af3a2d87ccb15d29$var$di(), e = b(), f = !$af3a2d87ccb15d29$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $af3a2d87ccb15d29$var$Ug = !0);
    d = d.queue;
    $af3a2d87ccb15d29$var$ji($af3a2d87ccb15d29$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $af3a2d87ccb15d29$var$P && $af3a2d87ccb15d29$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $af3a2d87ccb15d29$var$li(9, $af3a2d87ccb15d29$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $af3a2d87ccb15d29$var$R) throw Error($af3a2d87ccb15d29$var$p(349));
        0 !== ($af3a2d87ccb15d29$var$Rh & 30) || $af3a2d87ccb15d29$var$ni(c, b, e);
    }
    return e;
}
function $af3a2d87ccb15d29$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $af3a2d87ccb15d29$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $af3a2d87ccb15d29$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $af3a2d87ccb15d29$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $af3a2d87ccb15d29$var$oi(b) && $af3a2d87ccb15d29$var$pi(a);
}
function $af3a2d87ccb15d29$var$ki(a, b, c) {
    return c(function() {
        $af3a2d87ccb15d29$var$oi(b) && $af3a2d87ccb15d29$var$pi(a);
    });
}
function $af3a2d87ccb15d29$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$af3a2d87ccb15d29$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $af3a2d87ccb15d29$var$pi(a) {
    var b = $af3a2d87ccb15d29$var$Zg(a, 1);
    null !== b && $af3a2d87ccb15d29$var$mh(b, a, 1, -1);
}
function $af3a2d87ccb15d29$var$qi(a) {
    var b = $af3a2d87ccb15d29$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $af3a2d87ccb15d29$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $af3a2d87ccb15d29$var$ri.bind(null, $af3a2d87ccb15d29$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $af3a2d87ccb15d29$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $af3a2d87ccb15d29$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $af3a2d87ccb15d29$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $af3a2d87ccb15d29$var$si() {
    return $af3a2d87ccb15d29$var$di().memoizedState;
}
function $af3a2d87ccb15d29$var$ti(a, b, c, d) {
    var e = $af3a2d87ccb15d29$var$ci();
    $af3a2d87ccb15d29$var$N.flags |= a;
    e.memoizedState = $af3a2d87ccb15d29$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $af3a2d87ccb15d29$var$ui(a, b, c, d) {
    var e = $af3a2d87ccb15d29$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $af3a2d87ccb15d29$var$O) {
        var g = $af3a2d87ccb15d29$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $af3a2d87ccb15d29$var$Wh(d, g.deps)) {
            e.memoizedState = $af3a2d87ccb15d29$var$li(b, c, f, d);
            return;
        }
    }
    $af3a2d87ccb15d29$var$N.flags |= a;
    e.memoizedState = $af3a2d87ccb15d29$var$li(1 | b, c, f, d);
}
function $af3a2d87ccb15d29$var$vi(a, b) {
    return $af3a2d87ccb15d29$var$ti(8390656, 8, a, b);
}
function $af3a2d87ccb15d29$var$ji(a, b) {
    return $af3a2d87ccb15d29$var$ui(2048, 8, a, b);
}
function $af3a2d87ccb15d29$var$wi(a, b) {
    return $af3a2d87ccb15d29$var$ui(4, 2, a, b);
}
function $af3a2d87ccb15d29$var$xi(a, b) {
    return $af3a2d87ccb15d29$var$ui(4, 4, a, b);
}
function $af3a2d87ccb15d29$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $af3a2d87ccb15d29$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $af3a2d87ccb15d29$var$ui(4, 4, $af3a2d87ccb15d29$var$yi.bind(null, b, a), c);
}
function $af3a2d87ccb15d29$var$Ai() {}
function $af3a2d87ccb15d29$var$Bi(a, b) {
    var c = $af3a2d87ccb15d29$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $af3a2d87ccb15d29$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $af3a2d87ccb15d29$var$Ci(a, b) {
    var c = $af3a2d87ccb15d29$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $af3a2d87ccb15d29$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $af3a2d87ccb15d29$var$Di(a, b, c) {
    if (0 === ($af3a2d87ccb15d29$var$Rh & 21)) return a.baseState && (a.baseState = !1, $af3a2d87ccb15d29$var$Ug = !0), a.memoizedState = c;
    $af3a2d87ccb15d29$var$He(c, b) || (c = $af3a2d87ccb15d29$var$yc(), $af3a2d87ccb15d29$var$N.lanes |= c, $af3a2d87ccb15d29$var$hh |= c, a.baseState = !0);
    return b;
}
function $af3a2d87ccb15d29$var$Ei(a, b) {
    var c = $af3a2d87ccb15d29$var$C;
    $af3a2d87ccb15d29$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $af3a2d87ccb15d29$var$Qh.transition;
    $af3a2d87ccb15d29$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $af3a2d87ccb15d29$var$C = c, $af3a2d87ccb15d29$var$Qh.transition = d;
    }
}
function $af3a2d87ccb15d29$var$Fi() {
    return $af3a2d87ccb15d29$var$di().memoizedState;
}
function $af3a2d87ccb15d29$var$Gi(a, b, c) {
    var d = $af3a2d87ccb15d29$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($af3a2d87ccb15d29$var$Hi(a)) $af3a2d87ccb15d29$var$Ii(b, c);
    else if (c = $af3a2d87ccb15d29$var$Yg(a, b, c, d), null !== c) {
        var e = $af3a2d87ccb15d29$var$L();
        $af3a2d87ccb15d29$var$mh(c, a, d, e);
        $af3a2d87ccb15d29$var$Ji(c, b, d);
    }
}
function $af3a2d87ccb15d29$var$ri(a, b, c) {
    var d = $af3a2d87ccb15d29$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($af3a2d87ccb15d29$var$Hi(a)) $af3a2d87ccb15d29$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($af3a2d87ccb15d29$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $af3a2d87ccb15d29$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $af3a2d87ccb15d29$var$Yg(a, b, e, d);
        null !== c && (e = $af3a2d87ccb15d29$var$L(), $af3a2d87ccb15d29$var$mh(c, a, d, e), $af3a2d87ccb15d29$var$Ji(c, b, d));
    }
}
function $af3a2d87ccb15d29$var$Hi(a) {
    var b = a.alternate;
    return a === $af3a2d87ccb15d29$var$N || null !== b && b === $af3a2d87ccb15d29$var$N;
}
function $af3a2d87ccb15d29$var$Ii(a, b) {
    $af3a2d87ccb15d29$var$Th = $af3a2d87ccb15d29$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $af3a2d87ccb15d29$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $af3a2d87ccb15d29$var$Cc(a, c);
    }
}
var $af3a2d87ccb15d29$var$ai = {
    readContext: $af3a2d87ccb15d29$var$Vg,
    useCallback: $af3a2d87ccb15d29$var$Q,
    useContext: $af3a2d87ccb15d29$var$Q,
    useEffect: $af3a2d87ccb15d29$var$Q,
    useImperativeHandle: $af3a2d87ccb15d29$var$Q,
    useInsertionEffect: $af3a2d87ccb15d29$var$Q,
    useLayoutEffect: $af3a2d87ccb15d29$var$Q,
    useMemo: $af3a2d87ccb15d29$var$Q,
    useReducer: $af3a2d87ccb15d29$var$Q,
    useRef: $af3a2d87ccb15d29$var$Q,
    useState: $af3a2d87ccb15d29$var$Q,
    useDebugValue: $af3a2d87ccb15d29$var$Q,
    useDeferredValue: $af3a2d87ccb15d29$var$Q,
    useTransition: $af3a2d87ccb15d29$var$Q,
    useMutableSource: $af3a2d87ccb15d29$var$Q,
    useSyncExternalStore: $af3a2d87ccb15d29$var$Q,
    useId: $af3a2d87ccb15d29$var$Q,
    unstable_isNewReconciler: !1
}, $af3a2d87ccb15d29$var$Yh = {
    readContext: $af3a2d87ccb15d29$var$Vg,
    useCallback: function(a, b) {
        $af3a2d87ccb15d29$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $af3a2d87ccb15d29$var$Vg,
    useEffect: $af3a2d87ccb15d29$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $af3a2d87ccb15d29$var$ti(4194308, 4, $af3a2d87ccb15d29$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $af3a2d87ccb15d29$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $af3a2d87ccb15d29$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $af3a2d87ccb15d29$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $af3a2d87ccb15d29$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $af3a2d87ccb15d29$var$Gi.bind(null, $af3a2d87ccb15d29$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $af3a2d87ccb15d29$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $af3a2d87ccb15d29$var$qi,
    useDebugValue: $af3a2d87ccb15d29$var$Ai,
    useDeferredValue: function(a) {
        return $af3a2d87ccb15d29$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $af3a2d87ccb15d29$var$qi(!1), b = a[0];
        a = $af3a2d87ccb15d29$var$Ei.bind(null, a[1]);
        $af3a2d87ccb15d29$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $af3a2d87ccb15d29$var$N, e = $af3a2d87ccb15d29$var$ci();
        if ($af3a2d87ccb15d29$var$I) {
            if (void 0 === c) throw Error($af3a2d87ccb15d29$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $af3a2d87ccb15d29$var$R) throw Error($af3a2d87ccb15d29$var$p(349));
            0 !== ($af3a2d87ccb15d29$var$Rh & 30) || $af3a2d87ccb15d29$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $af3a2d87ccb15d29$var$vi($af3a2d87ccb15d29$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $af3a2d87ccb15d29$var$li(9, $af3a2d87ccb15d29$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $af3a2d87ccb15d29$var$ci(), b = $af3a2d87ccb15d29$var$R.identifierPrefix;
        if ($af3a2d87ccb15d29$var$I) {
            var c = $af3a2d87ccb15d29$var$sg;
            var d = $af3a2d87ccb15d29$var$rg;
            c = (d & ~(1 << 32 - $af3a2d87ccb15d29$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $af3a2d87ccb15d29$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $af3a2d87ccb15d29$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $af3a2d87ccb15d29$var$Zh = {
    readContext: $af3a2d87ccb15d29$var$Vg,
    useCallback: $af3a2d87ccb15d29$var$Bi,
    useContext: $af3a2d87ccb15d29$var$Vg,
    useEffect: $af3a2d87ccb15d29$var$ji,
    useImperativeHandle: $af3a2d87ccb15d29$var$zi,
    useInsertionEffect: $af3a2d87ccb15d29$var$wi,
    useLayoutEffect: $af3a2d87ccb15d29$var$xi,
    useMemo: $af3a2d87ccb15d29$var$Ci,
    useReducer: $af3a2d87ccb15d29$var$fi,
    useRef: $af3a2d87ccb15d29$var$si,
    useState: function() {
        return $af3a2d87ccb15d29$var$fi($af3a2d87ccb15d29$var$ei);
    },
    useDebugValue: $af3a2d87ccb15d29$var$Ai,
    useDeferredValue: function(a) {
        var b = $af3a2d87ccb15d29$var$di();
        return $af3a2d87ccb15d29$var$Di(b, $af3a2d87ccb15d29$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $af3a2d87ccb15d29$var$fi($af3a2d87ccb15d29$var$ei)[0], b = $af3a2d87ccb15d29$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $af3a2d87ccb15d29$var$hi,
    useSyncExternalStore: $af3a2d87ccb15d29$var$ii,
    useId: $af3a2d87ccb15d29$var$Fi,
    unstable_isNewReconciler: !1
}, $af3a2d87ccb15d29$var$$h = {
    readContext: $af3a2d87ccb15d29$var$Vg,
    useCallback: $af3a2d87ccb15d29$var$Bi,
    useContext: $af3a2d87ccb15d29$var$Vg,
    useEffect: $af3a2d87ccb15d29$var$ji,
    useImperativeHandle: $af3a2d87ccb15d29$var$zi,
    useInsertionEffect: $af3a2d87ccb15d29$var$wi,
    useLayoutEffect: $af3a2d87ccb15d29$var$xi,
    useMemo: $af3a2d87ccb15d29$var$Ci,
    useReducer: $af3a2d87ccb15d29$var$gi,
    useRef: $af3a2d87ccb15d29$var$si,
    useState: function() {
        return $af3a2d87ccb15d29$var$gi($af3a2d87ccb15d29$var$ei);
    },
    useDebugValue: $af3a2d87ccb15d29$var$Ai,
    useDeferredValue: function(a) {
        var b = $af3a2d87ccb15d29$var$di();
        return null === $af3a2d87ccb15d29$var$O ? b.memoizedState = a : $af3a2d87ccb15d29$var$Di(b, $af3a2d87ccb15d29$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $af3a2d87ccb15d29$var$gi($af3a2d87ccb15d29$var$ei)[0], b = $af3a2d87ccb15d29$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $af3a2d87ccb15d29$var$hi,
    useSyncExternalStore: $af3a2d87ccb15d29$var$ii,
    useId: $af3a2d87ccb15d29$var$Fi,
    unstable_isNewReconciler: !1
};
function $af3a2d87ccb15d29$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $af3a2d87ccb15d29$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $af3a2d87ccb15d29$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $af3a2d87ccb15d29$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $af3a2d87ccb15d29$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $af3a2d87ccb15d29$var$Oi(a, b, c) {
    c = $af3a2d87ccb15d29$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $af3a2d87ccb15d29$var$Pi || ($af3a2d87ccb15d29$var$Pi = !0, $af3a2d87ccb15d29$var$Qi = d);
        $af3a2d87ccb15d29$var$Mi(a, b);
    };
    return c;
}
function $af3a2d87ccb15d29$var$Ri(a, b, c) {
    c = $af3a2d87ccb15d29$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $af3a2d87ccb15d29$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $af3a2d87ccb15d29$var$Mi(a, b);
        "function" !== typeof d && (null === $af3a2d87ccb15d29$var$Si ? $af3a2d87ccb15d29$var$Si = new Set([
            this
        ]) : $af3a2d87ccb15d29$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $af3a2d87ccb15d29$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $af3a2d87ccb15d29$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $af3a2d87ccb15d29$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $af3a2d87ccb15d29$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $af3a2d87ccb15d29$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $af3a2d87ccb15d29$var$ch(-1, 1), b.tag = 2, $af3a2d87ccb15d29$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $af3a2d87ccb15d29$var$Xi = $af3a2d87ccb15d29$var$ua.ReactCurrentOwner, $af3a2d87ccb15d29$var$Ug = !1;
function $af3a2d87ccb15d29$var$Yi(a, b, c, d) {
    b.child = null === a ? $af3a2d87ccb15d29$var$Ch(b, null, c, d) : $af3a2d87ccb15d29$var$Bh(b, a.child, c, d);
}
function $af3a2d87ccb15d29$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $af3a2d87ccb15d29$var$Tg(b, e);
    d = $af3a2d87ccb15d29$var$Xh(a, b, c, d, f, e);
    c = $af3a2d87ccb15d29$var$bi();
    if (null !== a && !$af3a2d87ccb15d29$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $af3a2d87ccb15d29$var$$i(a, b, e);
    $af3a2d87ccb15d29$var$I && c && $af3a2d87ccb15d29$var$vg(b);
    b.flags |= 1;
    $af3a2d87ccb15d29$var$Yi(a, b, d, e);
    return b.child;
}
function $af3a2d87ccb15d29$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$af3a2d87ccb15d29$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $af3a2d87ccb15d29$var$cj(a, b, f, d, e);
        a = $af3a2d87ccb15d29$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $af3a2d87ccb15d29$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $af3a2d87ccb15d29$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $af3a2d87ccb15d29$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $af3a2d87ccb15d29$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($af3a2d87ccb15d29$var$Ie(f, d) && a.ref === b.ref) {
            if ($af3a2d87ccb15d29$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($af3a2d87ccb15d29$var$Ug = !0);
            else return b.lanes = a.lanes, $af3a2d87ccb15d29$var$$i(a, b, e);
        }
    }
    return $af3a2d87ccb15d29$var$dj(a, b, c, d, e);
}
function $af3a2d87ccb15d29$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$fj, $af3a2d87ccb15d29$var$gj), $af3a2d87ccb15d29$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$fj, $af3a2d87ccb15d29$var$gj), $af3a2d87ccb15d29$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$fj, $af3a2d87ccb15d29$var$gj);
            $af3a2d87ccb15d29$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$fj, $af3a2d87ccb15d29$var$gj), $af3a2d87ccb15d29$var$gj |= d;
    $af3a2d87ccb15d29$var$Yi(a, b, e, c);
    return b.child;
}
function $af3a2d87ccb15d29$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $af3a2d87ccb15d29$var$dj(a, b, c, d, e) {
    var f = $af3a2d87ccb15d29$var$Zf(c) ? $af3a2d87ccb15d29$var$Xf : $af3a2d87ccb15d29$var$H.current;
    f = $af3a2d87ccb15d29$var$Yf(b, f);
    $af3a2d87ccb15d29$var$Tg(b, e);
    c = $af3a2d87ccb15d29$var$Xh(a, b, c, d, f, e);
    d = $af3a2d87ccb15d29$var$bi();
    if (null !== a && !$af3a2d87ccb15d29$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $af3a2d87ccb15d29$var$$i(a, b, e);
    $af3a2d87ccb15d29$var$I && d && $af3a2d87ccb15d29$var$vg(b);
    b.flags |= 1;
    $af3a2d87ccb15d29$var$Yi(a, b, c, e);
    return b.child;
}
function $af3a2d87ccb15d29$var$ij(a, b, c, d, e) {
    if ($af3a2d87ccb15d29$var$Zf(c)) {
        var f = !0;
        $af3a2d87ccb15d29$var$cg(b);
    } else f = !1;
    $af3a2d87ccb15d29$var$Tg(b, e);
    if (null === b.stateNode) $af3a2d87ccb15d29$var$jj(a, b), $af3a2d87ccb15d29$var$ph(b, c, d), $af3a2d87ccb15d29$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $af3a2d87ccb15d29$var$Vg(l) : (l = $af3a2d87ccb15d29$var$Zf(c) ? $af3a2d87ccb15d29$var$Xf : $af3a2d87ccb15d29$var$H.current, l = $af3a2d87ccb15d29$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $af3a2d87ccb15d29$var$qh(b, g, d, l);
        $af3a2d87ccb15d29$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $af3a2d87ccb15d29$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $af3a2d87ccb15d29$var$Wf.current || $af3a2d87ccb15d29$var$$g ? ("function" === typeof m && ($af3a2d87ccb15d29$var$kh(b, c, m, d), k = b.memoizedState), (h = $af3a2d87ccb15d29$var$$g || $af3a2d87ccb15d29$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $af3a2d87ccb15d29$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $af3a2d87ccb15d29$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $af3a2d87ccb15d29$var$Vg(k) : (k = $af3a2d87ccb15d29$var$Zf(c) ? $af3a2d87ccb15d29$var$Xf : $af3a2d87ccb15d29$var$H.current, k = $af3a2d87ccb15d29$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $af3a2d87ccb15d29$var$qh(b, g, d, k);
        $af3a2d87ccb15d29$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $af3a2d87ccb15d29$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $af3a2d87ccb15d29$var$Wf.current || $af3a2d87ccb15d29$var$$g ? ("function" === typeof y && ($af3a2d87ccb15d29$var$kh(b, c, y, d), n = b.memoizedState), (l = $af3a2d87ccb15d29$var$$g || $af3a2d87ccb15d29$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $af3a2d87ccb15d29$var$kj(a, b, c, d, f, e);
}
function $af3a2d87ccb15d29$var$kj(a, b, c, d, e, f) {
    $af3a2d87ccb15d29$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $af3a2d87ccb15d29$var$dg(b, c, !1), $af3a2d87ccb15d29$var$$i(a, b, f);
    d = b.stateNode;
    $af3a2d87ccb15d29$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $af3a2d87ccb15d29$var$Bh(b, a.child, null, f), b.child = $af3a2d87ccb15d29$var$Bh(b, null, h, f)) : $af3a2d87ccb15d29$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $af3a2d87ccb15d29$var$dg(b, c, !0);
    return b.child;
}
function $af3a2d87ccb15d29$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $af3a2d87ccb15d29$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $af3a2d87ccb15d29$var$ag(a, b.context, !1);
    $af3a2d87ccb15d29$var$Ih(a, b.containerInfo);
}
function $af3a2d87ccb15d29$var$mj(a, b, c, d, e) {
    $af3a2d87ccb15d29$var$Ig();
    $af3a2d87ccb15d29$var$Jg(e);
    b.flags |= 256;
    $af3a2d87ccb15d29$var$Yi(a, b, c, d);
    return b.child;
}
var $af3a2d87ccb15d29$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $af3a2d87ccb15d29$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $af3a2d87ccb15d29$var$pj(a, b, c) {
    var d = b.pendingProps, e = $af3a2d87ccb15d29$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$M, e & 1);
    if (null === a) {
        $af3a2d87ccb15d29$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $af3a2d87ccb15d29$var$qj(g, d, 0, null), a = $af3a2d87ccb15d29$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $af3a2d87ccb15d29$var$oj(c), b.memoizedState = $af3a2d87ccb15d29$var$nj, a) : $af3a2d87ccb15d29$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $af3a2d87ccb15d29$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $af3a2d87ccb15d29$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $af3a2d87ccb15d29$var$wh(h, f) : (f = $af3a2d87ccb15d29$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $af3a2d87ccb15d29$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $af3a2d87ccb15d29$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $af3a2d87ccb15d29$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $af3a2d87ccb15d29$var$rj(a, b) {
    b = $af3a2d87ccb15d29$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $af3a2d87ccb15d29$var$tj(a, b, c, d) {
    null !== d && $af3a2d87ccb15d29$var$Jg(d);
    $af3a2d87ccb15d29$var$Bh(b, a.child, null, c);
    a = $af3a2d87ccb15d29$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $af3a2d87ccb15d29$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $af3a2d87ccb15d29$var$Li(Error($af3a2d87ccb15d29$var$p(422))), $af3a2d87ccb15d29$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $af3a2d87ccb15d29$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $af3a2d87ccb15d29$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $af3a2d87ccb15d29$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $af3a2d87ccb15d29$var$oj(g);
        b.memoizedState = $af3a2d87ccb15d29$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $af3a2d87ccb15d29$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($af3a2d87ccb15d29$var$p(419));
        d = $af3a2d87ccb15d29$var$Li(f, d, void 0);
        return $af3a2d87ccb15d29$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($af3a2d87ccb15d29$var$Ug || h) {
        d = $af3a2d87ccb15d29$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $af3a2d87ccb15d29$var$Zg(a, e), $af3a2d87ccb15d29$var$mh(d, a, e, -1));
        }
        $af3a2d87ccb15d29$var$uj();
        d = $af3a2d87ccb15d29$var$Li(Error($af3a2d87ccb15d29$var$p(421)));
        return $af3a2d87ccb15d29$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $af3a2d87ccb15d29$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $af3a2d87ccb15d29$var$yg = $af3a2d87ccb15d29$var$Lf(e.nextSibling);
    $af3a2d87ccb15d29$var$xg = b;
    $af3a2d87ccb15d29$var$I = !0;
    $af3a2d87ccb15d29$var$zg = null;
    null !== a && ($af3a2d87ccb15d29$var$og[$af3a2d87ccb15d29$var$pg++] = $af3a2d87ccb15d29$var$rg, $af3a2d87ccb15d29$var$og[$af3a2d87ccb15d29$var$pg++] = $af3a2d87ccb15d29$var$sg, $af3a2d87ccb15d29$var$og[$af3a2d87ccb15d29$var$pg++] = $af3a2d87ccb15d29$var$qg, $af3a2d87ccb15d29$var$rg = a.id, $af3a2d87ccb15d29$var$sg = a.overflow, $af3a2d87ccb15d29$var$qg = b);
    b = $af3a2d87ccb15d29$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $af3a2d87ccb15d29$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $af3a2d87ccb15d29$var$Sg(a.return, b, c);
}
function $af3a2d87ccb15d29$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $af3a2d87ccb15d29$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $af3a2d87ccb15d29$var$Yi(a, b, d.children, c);
    d = $af3a2d87ccb15d29$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $af3a2d87ccb15d29$var$wj(a, c, b);
            else if (19 === a.tag) $af3a2d87ccb15d29$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $af3a2d87ccb15d29$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $af3a2d87ccb15d29$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $af3a2d87ccb15d29$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $af3a2d87ccb15d29$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $af3a2d87ccb15d29$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $af3a2d87ccb15d29$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $af3a2d87ccb15d29$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $af3a2d87ccb15d29$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($af3a2d87ccb15d29$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $af3a2d87ccb15d29$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $af3a2d87ccb15d29$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $af3a2d87ccb15d29$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $af3a2d87ccb15d29$var$lj(b);
            $af3a2d87ccb15d29$var$Ig();
            break;
        case 5:
            $af3a2d87ccb15d29$var$Kh(b);
            break;
        case 1:
            $af3a2d87ccb15d29$var$Zf(b.type) && $af3a2d87ccb15d29$var$cg(b);
            break;
        case 4:
            $af3a2d87ccb15d29$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$M, $af3a2d87ccb15d29$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $af3a2d87ccb15d29$var$pj(a, b, c);
                $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$M, $af3a2d87ccb15d29$var$M.current & 1);
                a = $af3a2d87ccb15d29$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$M, $af3a2d87ccb15d29$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $af3a2d87ccb15d29$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$M, $af3a2d87ccb15d29$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $af3a2d87ccb15d29$var$ej(a, b, c);
    }
    return $af3a2d87ccb15d29$var$$i(a, b, c);
}
var $af3a2d87ccb15d29$var$Aj, $af3a2d87ccb15d29$var$Bj, $af3a2d87ccb15d29$var$Cj, $af3a2d87ccb15d29$var$Dj;
$af3a2d87ccb15d29$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$af3a2d87ccb15d29$var$Bj = function() {};
$af3a2d87ccb15d29$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $af3a2d87ccb15d29$var$Hh($af3a2d87ccb15d29$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $af3a2d87ccb15d29$var$Ya(a, e);
                d = $af3a2d87ccb15d29$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $af3a2d87ccb15d29$var$A({}, e, {
                    value: void 0
                });
                d = $af3a2d87ccb15d29$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $af3a2d87ccb15d29$var$gb(a, e);
                d = $af3a2d87ccb15d29$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $af3a2d87ccb15d29$var$Bf);
        }
        $af3a2d87ccb15d29$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($af3a2d87ccb15d29$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($af3a2d87ccb15d29$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $af3a2d87ccb15d29$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$af3a2d87ccb15d29$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $af3a2d87ccb15d29$var$Ej(a, b) {
    if (!$af3a2d87ccb15d29$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $af3a2d87ccb15d29$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $af3a2d87ccb15d29$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $af3a2d87ccb15d29$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $af3a2d87ccb15d29$var$S(b), null;
        case 1:
            return $af3a2d87ccb15d29$var$Zf(b.type) && $af3a2d87ccb15d29$var$$f(), $af3a2d87ccb15d29$var$S(b), null;
        case 3:
            d = b.stateNode;
            $af3a2d87ccb15d29$var$Jh();
            $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$Wf);
            $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$H);
            $af3a2d87ccb15d29$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $af3a2d87ccb15d29$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $af3a2d87ccb15d29$var$zg && ($af3a2d87ccb15d29$var$Gj($af3a2d87ccb15d29$var$zg), $af3a2d87ccb15d29$var$zg = null));
            $af3a2d87ccb15d29$var$Bj(a, b);
            $af3a2d87ccb15d29$var$S(b);
            return null;
        case 5:
            $af3a2d87ccb15d29$var$Lh(b);
            var e = $af3a2d87ccb15d29$var$Hh($af3a2d87ccb15d29$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $af3a2d87ccb15d29$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($af3a2d87ccb15d29$var$p(166));
                    $af3a2d87ccb15d29$var$S(b);
                    return null;
                }
                a = $af3a2d87ccb15d29$var$Hh($af3a2d87ccb15d29$var$Eh.current);
                if ($af3a2d87ccb15d29$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$af3a2d87ccb15d29$var$Of] = b;
                    d[$af3a2d87ccb15d29$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $af3a2d87ccb15d29$var$D("cancel", d);
                            $af3a2d87ccb15d29$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $af3a2d87ccb15d29$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $af3a2d87ccb15d29$var$lf.length; e++)$af3a2d87ccb15d29$var$D($af3a2d87ccb15d29$var$lf[e], d);
                            break;
                        case "source":
                            $af3a2d87ccb15d29$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $af3a2d87ccb15d29$var$D("error", d);
                            $af3a2d87ccb15d29$var$D("load", d);
                            break;
                        case "details":
                            $af3a2d87ccb15d29$var$D("toggle", d);
                            break;
                        case "input":
                            $af3a2d87ccb15d29$var$Za(d, f);
                            $af3a2d87ccb15d29$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $af3a2d87ccb15d29$var$D("invalid", d);
                            break;
                        case "textarea":
                            $af3a2d87ccb15d29$var$hb(d, f), $af3a2d87ccb15d29$var$D("invalid", d);
                    }
                    $af3a2d87ccb15d29$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $af3a2d87ccb15d29$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $af3a2d87ccb15d29$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $af3a2d87ccb15d29$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $af3a2d87ccb15d29$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $af3a2d87ccb15d29$var$Va(d);
                            $af3a2d87ccb15d29$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $af3a2d87ccb15d29$var$Va(d);
                            $af3a2d87ccb15d29$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $af3a2d87ccb15d29$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $af3a2d87ccb15d29$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$af3a2d87ccb15d29$var$Of] = b;
                    a[$af3a2d87ccb15d29$var$Pf] = d;
                    $af3a2d87ccb15d29$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $af3a2d87ccb15d29$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $af3a2d87ccb15d29$var$D("cancel", a);
                                $af3a2d87ccb15d29$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $af3a2d87ccb15d29$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $af3a2d87ccb15d29$var$lf.length; e++)$af3a2d87ccb15d29$var$D($af3a2d87ccb15d29$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $af3a2d87ccb15d29$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $af3a2d87ccb15d29$var$D("error", a);
                                $af3a2d87ccb15d29$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $af3a2d87ccb15d29$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $af3a2d87ccb15d29$var$Za(a, d);
                                e = $af3a2d87ccb15d29$var$Ya(a, d);
                                $af3a2d87ccb15d29$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $af3a2d87ccb15d29$var$A({}, d, {
                                    value: void 0
                                });
                                $af3a2d87ccb15d29$var$D("invalid", a);
                                break;
                            case "textarea":
                                $af3a2d87ccb15d29$var$hb(a, d);
                                e = $af3a2d87ccb15d29$var$gb(a, d);
                                $af3a2d87ccb15d29$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $af3a2d87ccb15d29$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $af3a2d87ccb15d29$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $af3a2d87ccb15d29$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $af3a2d87ccb15d29$var$ob(a, k) : "number" === typeof k && $af3a2d87ccb15d29$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($af3a2d87ccb15d29$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $af3a2d87ccb15d29$var$D("scroll", a) : null != k && $af3a2d87ccb15d29$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $af3a2d87ccb15d29$var$Va(a);
                                $af3a2d87ccb15d29$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $af3a2d87ccb15d29$var$Va(a);
                                $af3a2d87ccb15d29$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $af3a2d87ccb15d29$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $af3a2d87ccb15d29$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $af3a2d87ccb15d29$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $af3a2d87ccb15d29$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $af3a2d87ccb15d29$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $af3a2d87ccb15d29$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($af3a2d87ccb15d29$var$p(166));
                c = $af3a2d87ccb15d29$var$Hh($af3a2d87ccb15d29$var$Gh.current);
                $af3a2d87ccb15d29$var$Hh($af3a2d87ccb15d29$var$Eh.current);
                if ($af3a2d87ccb15d29$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$af3a2d87ccb15d29$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $af3a2d87ccb15d29$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $af3a2d87ccb15d29$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $af3a2d87ccb15d29$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$af3a2d87ccb15d29$var$Of] = b, b.stateNode = d;
            }
            $af3a2d87ccb15d29$var$S(b);
            return null;
        case 13:
            $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($af3a2d87ccb15d29$var$I && null !== $af3a2d87ccb15d29$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $af3a2d87ccb15d29$var$Hg(), $af3a2d87ccb15d29$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $af3a2d87ccb15d29$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($af3a2d87ccb15d29$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($af3a2d87ccb15d29$var$p(317));
                        f[$af3a2d87ccb15d29$var$Of] = b;
                    } else $af3a2d87ccb15d29$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $af3a2d87ccb15d29$var$S(b);
                    f = !1;
                } else null !== $af3a2d87ccb15d29$var$zg && ($af3a2d87ccb15d29$var$Gj($af3a2d87ccb15d29$var$zg), $af3a2d87ccb15d29$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($af3a2d87ccb15d29$var$M.current & 1) ? 0 === $af3a2d87ccb15d29$var$T && ($af3a2d87ccb15d29$var$T = 3) : $af3a2d87ccb15d29$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $af3a2d87ccb15d29$var$S(b);
            return null;
        case 4:
            return $af3a2d87ccb15d29$var$Jh(), $af3a2d87ccb15d29$var$Bj(a, b), null === a && $af3a2d87ccb15d29$var$sf(b.stateNode.containerInfo), $af3a2d87ccb15d29$var$S(b), null;
        case 10:
            return $af3a2d87ccb15d29$var$Rg(b.type._context), $af3a2d87ccb15d29$var$S(b), null;
        case 17:
            return $af3a2d87ccb15d29$var$Zf(b.type) && $af3a2d87ccb15d29$var$$f(), $af3a2d87ccb15d29$var$S(b), null;
        case 19:
            $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$M);
            f = b.memoizedState;
            if (null === f) return $af3a2d87ccb15d29$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $af3a2d87ccb15d29$var$Ej(f, !1);
                else {
                    if (0 !== $af3a2d87ccb15d29$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $af3a2d87ccb15d29$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $af3a2d87ccb15d29$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$M, $af3a2d87ccb15d29$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $af3a2d87ccb15d29$var$B() > $af3a2d87ccb15d29$var$Hj && (b.flags |= 128, d = !0, $af3a2d87ccb15d29$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $af3a2d87ccb15d29$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $af3a2d87ccb15d29$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$af3a2d87ccb15d29$var$I) return $af3a2d87ccb15d29$var$S(b), null;
                    } else 2 * $af3a2d87ccb15d29$var$B() - f.renderingStartTime > $af3a2d87ccb15d29$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $af3a2d87ccb15d29$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $af3a2d87ccb15d29$var$B(), b.sibling = null, c = $af3a2d87ccb15d29$var$M.current, $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$M, d ? c & 1 | 2 : c & 1), b;
            $af3a2d87ccb15d29$var$S(b);
            return null;
        case 22:
        case 23:
            return $af3a2d87ccb15d29$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($af3a2d87ccb15d29$var$gj & 1073741824) && ($af3a2d87ccb15d29$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $af3a2d87ccb15d29$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($af3a2d87ccb15d29$var$p(156, b.tag));
}
function $af3a2d87ccb15d29$var$Jj(a, b) {
    $af3a2d87ccb15d29$var$wg(b);
    switch(b.tag){
        case 1:
            return $af3a2d87ccb15d29$var$Zf(b.type) && $af3a2d87ccb15d29$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $af3a2d87ccb15d29$var$Jh(), $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$Wf), $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$H), $af3a2d87ccb15d29$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $af3a2d87ccb15d29$var$Lh(b), null;
        case 13:
            $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($af3a2d87ccb15d29$var$p(340));
                $af3a2d87ccb15d29$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$M), null;
        case 4:
            return $af3a2d87ccb15d29$var$Jh(), null;
        case 10:
            return $af3a2d87ccb15d29$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $af3a2d87ccb15d29$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $af3a2d87ccb15d29$var$Kj = !1, $af3a2d87ccb15d29$var$U = !1, $af3a2d87ccb15d29$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $af3a2d87ccb15d29$var$V = null;
function $af3a2d87ccb15d29$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $af3a2d87ccb15d29$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $af3a2d87ccb15d29$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $af3a2d87ccb15d29$var$W(a, b, d);
    }
}
var $af3a2d87ccb15d29$var$Oj = !1;
function $af3a2d87ccb15d29$var$Pj(a, b) {
    $af3a2d87ccb15d29$var$Cf = $af3a2d87ccb15d29$var$dd;
    a = $af3a2d87ccb15d29$var$Me();
    if ($af3a2d87ccb15d29$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $af3a2d87ccb15d29$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $af3a2d87ccb15d29$var$dd = !1;
    for($af3a2d87ccb15d29$var$V = b; null !== $af3a2d87ccb15d29$var$V;)if (b = $af3a2d87ccb15d29$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $af3a2d87ccb15d29$var$V = a;
    else for(; null !== $af3a2d87ccb15d29$var$V;){
        b = $af3a2d87ccb15d29$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $af3a2d87ccb15d29$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($af3a2d87ccb15d29$var$p(163));
            }
        } catch (F) {
            $af3a2d87ccb15d29$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $af3a2d87ccb15d29$var$V = a;
            break;
        }
        $af3a2d87ccb15d29$var$V = b.return;
    }
    n = $af3a2d87ccb15d29$var$Oj;
    $af3a2d87ccb15d29$var$Oj = !1;
    return n;
}
function $af3a2d87ccb15d29$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $af3a2d87ccb15d29$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $af3a2d87ccb15d29$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $af3a2d87ccb15d29$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $af3a2d87ccb15d29$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $af3a2d87ccb15d29$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$af3a2d87ccb15d29$var$Of], delete b[$af3a2d87ccb15d29$var$Pf], delete b[$af3a2d87ccb15d29$var$of], delete b[$af3a2d87ccb15d29$var$Qf], delete b[$af3a2d87ccb15d29$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $af3a2d87ccb15d29$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $af3a2d87ccb15d29$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $af3a2d87ccb15d29$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $af3a2d87ccb15d29$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $af3a2d87ccb15d29$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($af3a2d87ccb15d29$var$Wj(a, b, c), a = a.sibling; null !== a;)$af3a2d87ccb15d29$var$Wj(a, b, c), a = a.sibling;
}
function $af3a2d87ccb15d29$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($af3a2d87ccb15d29$var$Xj(a, b, c), a = a.sibling; null !== a;)$af3a2d87ccb15d29$var$Xj(a, b, c), a = a.sibling;
}
var $af3a2d87ccb15d29$var$X = null, $af3a2d87ccb15d29$var$Yj = !1;
function $af3a2d87ccb15d29$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$af3a2d87ccb15d29$var$ak(a, b, c), c = c.sibling;
}
function $af3a2d87ccb15d29$var$ak(a, b, c) {
    if ($af3a2d87ccb15d29$var$lc && "function" === typeof $af3a2d87ccb15d29$var$lc.onCommitFiberUnmount) try {
        $af3a2d87ccb15d29$var$lc.onCommitFiberUnmount($af3a2d87ccb15d29$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $af3a2d87ccb15d29$var$U || $af3a2d87ccb15d29$var$Mj(c, b);
        case 6:
            var d = $af3a2d87ccb15d29$var$X, e = $af3a2d87ccb15d29$var$Yj;
            $af3a2d87ccb15d29$var$X = null;
            $af3a2d87ccb15d29$var$Zj(a, b, c);
            $af3a2d87ccb15d29$var$X = d;
            $af3a2d87ccb15d29$var$Yj = e;
            null !== $af3a2d87ccb15d29$var$X && ($af3a2d87ccb15d29$var$Yj ? (a = $af3a2d87ccb15d29$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $af3a2d87ccb15d29$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $af3a2d87ccb15d29$var$X && ($af3a2d87ccb15d29$var$Yj ? (a = $af3a2d87ccb15d29$var$X, c = c.stateNode, 8 === a.nodeType ? $af3a2d87ccb15d29$var$Kf(a.parentNode, c) : 1 === a.nodeType && $af3a2d87ccb15d29$var$Kf(a, c), $af3a2d87ccb15d29$var$bd(a)) : $af3a2d87ccb15d29$var$Kf($af3a2d87ccb15d29$var$X, c.stateNode));
            break;
        case 4:
            d = $af3a2d87ccb15d29$var$X;
            e = $af3a2d87ccb15d29$var$Yj;
            $af3a2d87ccb15d29$var$X = c.stateNode.containerInfo;
            $af3a2d87ccb15d29$var$Yj = !0;
            $af3a2d87ccb15d29$var$Zj(a, b, c);
            $af3a2d87ccb15d29$var$X = d;
            $af3a2d87ccb15d29$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$af3a2d87ccb15d29$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $af3a2d87ccb15d29$var$Nj(c, b, g) : 0 !== (f & 4) && $af3a2d87ccb15d29$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $af3a2d87ccb15d29$var$Zj(a, b, c);
            break;
        case 1:
            if (!$af3a2d87ccb15d29$var$U && ($af3a2d87ccb15d29$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $af3a2d87ccb15d29$var$W(c, b, h);
            }
            $af3a2d87ccb15d29$var$Zj(a, b, c);
            break;
        case 21:
            $af3a2d87ccb15d29$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($af3a2d87ccb15d29$var$U = (d = $af3a2d87ccb15d29$var$U) || null !== c.memoizedState, $af3a2d87ccb15d29$var$Zj(a, b, c), $af3a2d87ccb15d29$var$U = d) : $af3a2d87ccb15d29$var$Zj(a, b, c);
            break;
        default:
            $af3a2d87ccb15d29$var$Zj(a, b, c);
    }
}
function $af3a2d87ccb15d29$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $af3a2d87ccb15d29$var$Lj);
        b.forEach(function(b) {
            var d = $af3a2d87ccb15d29$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $af3a2d87ccb15d29$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $af3a2d87ccb15d29$var$X = h.stateNode;
                        $af3a2d87ccb15d29$var$Yj = !1;
                        break a;
                    case 3:
                        $af3a2d87ccb15d29$var$X = h.stateNode.containerInfo;
                        $af3a2d87ccb15d29$var$Yj = !0;
                        break a;
                    case 4:
                        $af3a2d87ccb15d29$var$X = h.stateNode.containerInfo;
                        $af3a2d87ccb15d29$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $af3a2d87ccb15d29$var$X) throw Error($af3a2d87ccb15d29$var$p(160));
            $af3a2d87ccb15d29$var$ak(f, g, e);
            $af3a2d87ccb15d29$var$X = null;
            $af3a2d87ccb15d29$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $af3a2d87ccb15d29$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$af3a2d87ccb15d29$var$ek(b, a), b = b.sibling;
}
function $af3a2d87ccb15d29$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $af3a2d87ccb15d29$var$dk(b, a);
            $af3a2d87ccb15d29$var$fk(a);
            if (d & 4) {
                try {
                    $af3a2d87ccb15d29$var$Qj(3, a, a.return), $af3a2d87ccb15d29$var$Rj(3, a);
                } catch (t) {
                    $af3a2d87ccb15d29$var$W(a, a.return, t);
                }
                try {
                    $af3a2d87ccb15d29$var$Qj(5, a, a.return);
                } catch (t) {
                    $af3a2d87ccb15d29$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $af3a2d87ccb15d29$var$dk(b, a);
            $af3a2d87ccb15d29$var$fk(a);
            d & 512 && null !== c && $af3a2d87ccb15d29$var$Mj(c, c.return);
            break;
        case 5:
            $af3a2d87ccb15d29$var$dk(b, a);
            $af3a2d87ccb15d29$var$fk(a);
            d & 512 && null !== c && $af3a2d87ccb15d29$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $af3a2d87ccb15d29$var$ob(e, "");
                } catch (t) {
                    $af3a2d87ccb15d29$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $af3a2d87ccb15d29$var$ab(e, f);
                    $af3a2d87ccb15d29$var$vb(h, g);
                    var l = $af3a2d87ccb15d29$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $af3a2d87ccb15d29$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $af3a2d87ccb15d29$var$nb(e, q) : "children" === m ? $af3a2d87ccb15d29$var$ob(e, q) : $af3a2d87ccb15d29$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $af3a2d87ccb15d29$var$bb(e, f);
                            break;
                        case "textarea":
                            $af3a2d87ccb15d29$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $af3a2d87ccb15d29$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $af3a2d87ccb15d29$var$fb(e, !!f.multiple, f.defaultValue, !0) : $af3a2d87ccb15d29$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$af3a2d87ccb15d29$var$Pf] = f;
                } catch (t) {
                    $af3a2d87ccb15d29$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $af3a2d87ccb15d29$var$dk(b, a);
            $af3a2d87ccb15d29$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($af3a2d87ccb15d29$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $af3a2d87ccb15d29$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $af3a2d87ccb15d29$var$dk(b, a);
            $af3a2d87ccb15d29$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $af3a2d87ccb15d29$var$bd(b.containerInfo);
            } catch (t) {
                $af3a2d87ccb15d29$var$W(a, a.return, t);
            }
            break;
        case 4:
            $af3a2d87ccb15d29$var$dk(b, a);
            $af3a2d87ccb15d29$var$fk(a);
            break;
        case 13:
            $af3a2d87ccb15d29$var$dk(b, a);
            $af3a2d87ccb15d29$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($af3a2d87ccb15d29$var$gk = $af3a2d87ccb15d29$var$B()));
            d & 4 && $af3a2d87ccb15d29$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($af3a2d87ccb15d29$var$U = (l = $af3a2d87ccb15d29$var$U) || m, $af3a2d87ccb15d29$var$dk(b, a), $af3a2d87ccb15d29$var$U = l) : $af3a2d87ccb15d29$var$dk(b, a);
            $af3a2d87ccb15d29$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($af3a2d87ccb15d29$var$V = a, m = a.child; null !== m;){
                    for(q = $af3a2d87ccb15d29$var$V = m; null !== $af3a2d87ccb15d29$var$V;){
                        r = $af3a2d87ccb15d29$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $af3a2d87ccb15d29$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $af3a2d87ccb15d29$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $af3a2d87ccb15d29$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $af3a2d87ccb15d29$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $af3a2d87ccb15d29$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $af3a2d87ccb15d29$var$V = y) : $af3a2d87ccb15d29$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $af3a2d87ccb15d29$var$rb("display", g));
                            } catch (t) {
                                $af3a2d87ccb15d29$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $af3a2d87ccb15d29$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $af3a2d87ccb15d29$var$dk(b, a);
            $af3a2d87ccb15d29$var$fk(a);
            d & 4 && $af3a2d87ccb15d29$var$bk(a);
            break;
        case 21:
            break;
        default:
            $af3a2d87ccb15d29$var$dk(b, a), $af3a2d87ccb15d29$var$fk(a);
    }
}
function $af3a2d87ccb15d29$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($af3a2d87ccb15d29$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($af3a2d87ccb15d29$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($af3a2d87ccb15d29$var$ob(e, ""), d.flags &= -33);
                    var f = $af3a2d87ccb15d29$var$Vj(a);
                    $af3a2d87ccb15d29$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $af3a2d87ccb15d29$var$Vj(a);
                    $af3a2d87ccb15d29$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($af3a2d87ccb15d29$var$p(161));
            }
        } catch (k) {
            $af3a2d87ccb15d29$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $af3a2d87ccb15d29$var$ik(a, b, c) {
    $af3a2d87ccb15d29$var$V = a;
    $af3a2d87ccb15d29$var$jk(a, b, c);
}
function $af3a2d87ccb15d29$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $af3a2d87ccb15d29$var$V;){
        var e = $af3a2d87ccb15d29$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $af3a2d87ccb15d29$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $af3a2d87ccb15d29$var$U;
                h = $af3a2d87ccb15d29$var$Kj;
                var l = $af3a2d87ccb15d29$var$U;
                $af3a2d87ccb15d29$var$Kj = g;
                if (($af3a2d87ccb15d29$var$U = k) && !l) for($af3a2d87ccb15d29$var$V = e; null !== $af3a2d87ccb15d29$var$V;)g = $af3a2d87ccb15d29$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $af3a2d87ccb15d29$var$kk(e) : null !== k ? (k.return = g, $af3a2d87ccb15d29$var$V = k) : $af3a2d87ccb15d29$var$kk(e);
                for(; null !== f;)$af3a2d87ccb15d29$var$V = f, $af3a2d87ccb15d29$var$jk(f, b, c), f = f.sibling;
                $af3a2d87ccb15d29$var$V = e;
                $af3a2d87ccb15d29$var$Kj = h;
                $af3a2d87ccb15d29$var$U = l;
            }
            $af3a2d87ccb15d29$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $af3a2d87ccb15d29$var$V = f) : $af3a2d87ccb15d29$var$lk(a, b, c);
    }
}
function $af3a2d87ccb15d29$var$lk(a) {
    for(; null !== $af3a2d87ccb15d29$var$V;){
        var b = $af3a2d87ccb15d29$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $af3a2d87ccb15d29$var$U || $af3a2d87ccb15d29$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$af3a2d87ccb15d29$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $af3a2d87ccb15d29$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $af3a2d87ccb15d29$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $af3a2d87ccb15d29$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $af3a2d87ccb15d29$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($af3a2d87ccb15d29$var$p(163));
                }
                $af3a2d87ccb15d29$var$U || b.flags & 512 && $af3a2d87ccb15d29$var$Sj(b);
            } catch (r) {
                $af3a2d87ccb15d29$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $af3a2d87ccb15d29$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $af3a2d87ccb15d29$var$V = c;
            break;
        }
        $af3a2d87ccb15d29$var$V = b.return;
    }
}
function $af3a2d87ccb15d29$var$hk(a) {
    for(; null !== $af3a2d87ccb15d29$var$V;){
        var b = $af3a2d87ccb15d29$var$V;
        if (b === a) {
            $af3a2d87ccb15d29$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $af3a2d87ccb15d29$var$V = c;
            break;
        }
        $af3a2d87ccb15d29$var$V = b.return;
    }
}
function $af3a2d87ccb15d29$var$kk(a) {
    for(; null !== $af3a2d87ccb15d29$var$V;){
        var b = $af3a2d87ccb15d29$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $af3a2d87ccb15d29$var$Rj(4, b);
                    } catch (k) {
                        $af3a2d87ccb15d29$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $af3a2d87ccb15d29$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $af3a2d87ccb15d29$var$Sj(b);
                    } catch (k) {
                        $af3a2d87ccb15d29$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $af3a2d87ccb15d29$var$Sj(b);
                    } catch (k) {
                        $af3a2d87ccb15d29$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $af3a2d87ccb15d29$var$W(b, b.return, k);
        }
        if (b === a) {
            $af3a2d87ccb15d29$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $af3a2d87ccb15d29$var$V = h;
            break;
        }
        $af3a2d87ccb15d29$var$V = b.return;
    }
}
var $af3a2d87ccb15d29$var$mk = Math.ceil, $af3a2d87ccb15d29$var$nk = $af3a2d87ccb15d29$var$ua.ReactCurrentDispatcher, $af3a2d87ccb15d29$var$ok = $af3a2d87ccb15d29$var$ua.ReactCurrentOwner, $af3a2d87ccb15d29$var$pk = $af3a2d87ccb15d29$var$ua.ReactCurrentBatchConfig, $af3a2d87ccb15d29$var$K = 0, $af3a2d87ccb15d29$var$R = null, $af3a2d87ccb15d29$var$Y = null, $af3a2d87ccb15d29$var$Z = 0, $af3a2d87ccb15d29$var$gj = 0, $af3a2d87ccb15d29$var$fj = $af3a2d87ccb15d29$var$Uf(0), $af3a2d87ccb15d29$var$T = 0, $af3a2d87ccb15d29$var$qk = null, $af3a2d87ccb15d29$var$hh = 0, $af3a2d87ccb15d29$var$rk = 0, $af3a2d87ccb15d29$var$sk = 0, $af3a2d87ccb15d29$var$tk = null, $af3a2d87ccb15d29$var$uk = null, $af3a2d87ccb15d29$var$gk = 0, $af3a2d87ccb15d29$var$Hj = Infinity, $af3a2d87ccb15d29$var$vk = null, $af3a2d87ccb15d29$var$Pi = !1, $af3a2d87ccb15d29$var$Qi = null, $af3a2d87ccb15d29$var$Si = null, $af3a2d87ccb15d29$var$wk = !1, $af3a2d87ccb15d29$var$xk = null, $af3a2d87ccb15d29$var$yk = 0, $af3a2d87ccb15d29$var$zk = 0, $af3a2d87ccb15d29$var$Ak = null, $af3a2d87ccb15d29$var$Bk = -1, $af3a2d87ccb15d29$var$Ck = 0;
function $af3a2d87ccb15d29$var$L() {
    return 0 !== ($af3a2d87ccb15d29$var$K & 6) ? $af3a2d87ccb15d29$var$B() : -1 !== $af3a2d87ccb15d29$var$Bk ? $af3a2d87ccb15d29$var$Bk : $af3a2d87ccb15d29$var$Bk = $af3a2d87ccb15d29$var$B();
}
function $af3a2d87ccb15d29$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($af3a2d87ccb15d29$var$K & 2) && 0 !== $af3a2d87ccb15d29$var$Z) return $af3a2d87ccb15d29$var$Z & -$af3a2d87ccb15d29$var$Z;
    if (null !== $af3a2d87ccb15d29$var$Kg.transition) return 0 === $af3a2d87ccb15d29$var$Ck && ($af3a2d87ccb15d29$var$Ck = $af3a2d87ccb15d29$var$yc()), $af3a2d87ccb15d29$var$Ck;
    a = $af3a2d87ccb15d29$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $af3a2d87ccb15d29$var$jd(a.type);
    return a;
}
function $af3a2d87ccb15d29$var$mh(a, b, c, d) {
    if (50 < $af3a2d87ccb15d29$var$zk) throw $af3a2d87ccb15d29$var$zk = 0, $af3a2d87ccb15d29$var$Ak = null, Error($af3a2d87ccb15d29$var$p(185));
    $af3a2d87ccb15d29$var$Ac(a, c, d);
    if (0 === ($af3a2d87ccb15d29$var$K & 2) || a !== $af3a2d87ccb15d29$var$R) a === $af3a2d87ccb15d29$var$R && (0 === ($af3a2d87ccb15d29$var$K & 2) && ($af3a2d87ccb15d29$var$rk |= c), 4 === $af3a2d87ccb15d29$var$T && $af3a2d87ccb15d29$var$Dk(a, $af3a2d87ccb15d29$var$Z)), $af3a2d87ccb15d29$var$Ek(a, d), 1 === c && 0 === $af3a2d87ccb15d29$var$K && 0 === (b.mode & 1) && ($af3a2d87ccb15d29$var$Hj = $af3a2d87ccb15d29$var$B() + 500, $af3a2d87ccb15d29$var$fg && $af3a2d87ccb15d29$var$jg());
}
function $af3a2d87ccb15d29$var$Ek(a, b) {
    var c = a.callbackNode;
    $af3a2d87ccb15d29$var$wc(a, b);
    var d = $af3a2d87ccb15d29$var$uc(a, a === $af3a2d87ccb15d29$var$R ? $af3a2d87ccb15d29$var$Z : 0);
    if (0 === d) null !== c && $af3a2d87ccb15d29$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $af3a2d87ccb15d29$var$bc(c);
        if (1 === b) 0 === a.tag ? $af3a2d87ccb15d29$var$ig($af3a2d87ccb15d29$var$Fk.bind(null, a)) : $af3a2d87ccb15d29$var$hg($af3a2d87ccb15d29$var$Fk.bind(null, a)), $af3a2d87ccb15d29$var$Jf(function() {
            0 === ($af3a2d87ccb15d29$var$K & 6) && $af3a2d87ccb15d29$var$jg();
        }), c = null;
        else {
            switch($af3a2d87ccb15d29$var$Dc(d)){
                case 1:
                    c = $af3a2d87ccb15d29$var$fc;
                    break;
                case 4:
                    c = $af3a2d87ccb15d29$var$gc;
                    break;
                case 16:
                    c = $af3a2d87ccb15d29$var$hc;
                    break;
                case 536870912:
                    c = $af3a2d87ccb15d29$var$jc;
                    break;
                default:
                    c = $af3a2d87ccb15d29$var$hc;
            }
            c = $af3a2d87ccb15d29$var$Gk(c, $af3a2d87ccb15d29$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $af3a2d87ccb15d29$var$Hk(a, b) {
    $af3a2d87ccb15d29$var$Bk = -1;
    $af3a2d87ccb15d29$var$Ck = 0;
    if (0 !== ($af3a2d87ccb15d29$var$K & 6)) throw Error($af3a2d87ccb15d29$var$p(327));
    var c = a.callbackNode;
    if ($af3a2d87ccb15d29$var$Ik() && a.callbackNode !== c) return null;
    var d = $af3a2d87ccb15d29$var$uc(a, a === $af3a2d87ccb15d29$var$R ? $af3a2d87ccb15d29$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $af3a2d87ccb15d29$var$Jk(a, d);
    else {
        b = d;
        var e = $af3a2d87ccb15d29$var$K;
        $af3a2d87ccb15d29$var$K |= 2;
        var f = $af3a2d87ccb15d29$var$Kk();
        if ($af3a2d87ccb15d29$var$R !== a || $af3a2d87ccb15d29$var$Z !== b) $af3a2d87ccb15d29$var$vk = null, $af3a2d87ccb15d29$var$Hj = $af3a2d87ccb15d29$var$B() + 500, $af3a2d87ccb15d29$var$Lk(a, b);
        for(;;)try {
            $af3a2d87ccb15d29$var$Mk();
            break;
        } catch (h) {
            $af3a2d87ccb15d29$var$Nk(a, h);
        }
        $af3a2d87ccb15d29$var$Qg();
        $af3a2d87ccb15d29$var$nk.current = f;
        $af3a2d87ccb15d29$var$K = e;
        null !== $af3a2d87ccb15d29$var$Y ? b = 0 : ($af3a2d87ccb15d29$var$R = null, $af3a2d87ccb15d29$var$Z = 0, b = $af3a2d87ccb15d29$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $af3a2d87ccb15d29$var$xc(a), 0 !== e && (d = e, b = $af3a2d87ccb15d29$var$Ok(a, e)));
        if (1 === b) throw c = $af3a2d87ccb15d29$var$qk, $af3a2d87ccb15d29$var$Lk(a, 0), $af3a2d87ccb15d29$var$Dk(a, d), $af3a2d87ccb15d29$var$Ek(a, $af3a2d87ccb15d29$var$B()), c;
        if (6 === b) $af3a2d87ccb15d29$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$af3a2d87ccb15d29$var$Pk(e) && (b = $af3a2d87ccb15d29$var$Jk(a, d), 2 === b && (f = $af3a2d87ccb15d29$var$xc(a), 0 !== f && (d = f, b = $af3a2d87ccb15d29$var$Ok(a, f))), 1 === b)) throw c = $af3a2d87ccb15d29$var$qk, $af3a2d87ccb15d29$var$Lk(a, 0), $af3a2d87ccb15d29$var$Dk(a, d), $af3a2d87ccb15d29$var$Ek(a, $af3a2d87ccb15d29$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($af3a2d87ccb15d29$var$p(345));
                case 2:
                    $af3a2d87ccb15d29$var$Qk(a, $af3a2d87ccb15d29$var$uk, $af3a2d87ccb15d29$var$vk);
                    break;
                case 3:
                    $af3a2d87ccb15d29$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $af3a2d87ccb15d29$var$gk + 500 - $af3a2d87ccb15d29$var$B(), 10 < b)) {
                        if (0 !== $af3a2d87ccb15d29$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $af3a2d87ccb15d29$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $af3a2d87ccb15d29$var$Ff($af3a2d87ccb15d29$var$Qk.bind(null, a, $af3a2d87ccb15d29$var$uk, $af3a2d87ccb15d29$var$vk), b);
                        break;
                    }
                    $af3a2d87ccb15d29$var$Qk(a, $af3a2d87ccb15d29$var$uk, $af3a2d87ccb15d29$var$vk);
                    break;
                case 4:
                    $af3a2d87ccb15d29$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $af3a2d87ccb15d29$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $af3a2d87ccb15d29$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $af3a2d87ccb15d29$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $af3a2d87ccb15d29$var$Ff($af3a2d87ccb15d29$var$Qk.bind(null, a, $af3a2d87ccb15d29$var$uk, $af3a2d87ccb15d29$var$vk), d);
                        break;
                    }
                    $af3a2d87ccb15d29$var$Qk(a, $af3a2d87ccb15d29$var$uk, $af3a2d87ccb15d29$var$vk);
                    break;
                case 5:
                    $af3a2d87ccb15d29$var$Qk(a, $af3a2d87ccb15d29$var$uk, $af3a2d87ccb15d29$var$vk);
                    break;
                default:
                    throw Error($af3a2d87ccb15d29$var$p(329));
            }
        }
    }
    $af3a2d87ccb15d29$var$Ek(a, $af3a2d87ccb15d29$var$B());
    return a.callbackNode === c ? $af3a2d87ccb15d29$var$Hk.bind(null, a) : null;
}
function $af3a2d87ccb15d29$var$Ok(a, b) {
    var c = $af3a2d87ccb15d29$var$tk;
    a.current.memoizedState.isDehydrated && ($af3a2d87ccb15d29$var$Lk(a, b).flags |= 256);
    a = $af3a2d87ccb15d29$var$Jk(a, b);
    2 !== a && (b = $af3a2d87ccb15d29$var$uk, $af3a2d87ccb15d29$var$uk = c, null !== b && $af3a2d87ccb15d29$var$Gj(b));
    return a;
}
function $af3a2d87ccb15d29$var$Gj(a) {
    null === $af3a2d87ccb15d29$var$uk ? $af3a2d87ccb15d29$var$uk = a : $af3a2d87ccb15d29$var$uk.push.apply($af3a2d87ccb15d29$var$uk, a);
}
function $af3a2d87ccb15d29$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$af3a2d87ccb15d29$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $af3a2d87ccb15d29$var$Dk(a, b) {
    b &= ~$af3a2d87ccb15d29$var$sk;
    b &= ~$af3a2d87ccb15d29$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $af3a2d87ccb15d29$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $af3a2d87ccb15d29$var$Fk(a) {
    if (0 !== ($af3a2d87ccb15d29$var$K & 6)) throw Error($af3a2d87ccb15d29$var$p(327));
    $af3a2d87ccb15d29$var$Ik();
    var b = $af3a2d87ccb15d29$var$uc(a, 0);
    if (0 === (b & 1)) return $af3a2d87ccb15d29$var$Ek(a, $af3a2d87ccb15d29$var$B()), null;
    var c = $af3a2d87ccb15d29$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $af3a2d87ccb15d29$var$xc(a);
        0 !== d && (b = d, c = $af3a2d87ccb15d29$var$Ok(a, d));
    }
    if (1 === c) throw c = $af3a2d87ccb15d29$var$qk, $af3a2d87ccb15d29$var$Lk(a, 0), $af3a2d87ccb15d29$var$Dk(a, b), $af3a2d87ccb15d29$var$Ek(a, $af3a2d87ccb15d29$var$B()), c;
    if (6 === c) throw Error($af3a2d87ccb15d29$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $af3a2d87ccb15d29$var$Qk(a, $af3a2d87ccb15d29$var$uk, $af3a2d87ccb15d29$var$vk);
    $af3a2d87ccb15d29$var$Ek(a, $af3a2d87ccb15d29$var$B());
    return null;
}
function $af3a2d87ccb15d29$var$Rk(a, b) {
    var c = $af3a2d87ccb15d29$var$K;
    $af3a2d87ccb15d29$var$K |= 1;
    try {
        return a(b);
    } finally{
        $af3a2d87ccb15d29$var$K = c, 0 === $af3a2d87ccb15d29$var$K && ($af3a2d87ccb15d29$var$Hj = $af3a2d87ccb15d29$var$B() + 500, $af3a2d87ccb15d29$var$fg && $af3a2d87ccb15d29$var$jg());
    }
}
function $af3a2d87ccb15d29$var$Sk(a) {
    null !== $af3a2d87ccb15d29$var$xk && 0 === $af3a2d87ccb15d29$var$xk.tag && 0 === ($af3a2d87ccb15d29$var$K & 6) && $af3a2d87ccb15d29$var$Ik();
    var b = $af3a2d87ccb15d29$var$K;
    $af3a2d87ccb15d29$var$K |= 1;
    var c = $af3a2d87ccb15d29$var$pk.transition, d = $af3a2d87ccb15d29$var$C;
    try {
        if ($af3a2d87ccb15d29$var$pk.transition = null, $af3a2d87ccb15d29$var$C = 1, a) return a();
    } finally{
        $af3a2d87ccb15d29$var$C = d, $af3a2d87ccb15d29$var$pk.transition = c, $af3a2d87ccb15d29$var$K = b, 0 === ($af3a2d87ccb15d29$var$K & 6) && $af3a2d87ccb15d29$var$jg();
    }
}
function $af3a2d87ccb15d29$var$Ij() {
    $af3a2d87ccb15d29$var$gj = $af3a2d87ccb15d29$var$fj.current;
    $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$fj);
}
function $af3a2d87ccb15d29$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $af3a2d87ccb15d29$var$Gf(c));
    if (null !== $af3a2d87ccb15d29$var$Y) for(c = $af3a2d87ccb15d29$var$Y.return; null !== c;){
        var d = c;
        $af3a2d87ccb15d29$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $af3a2d87ccb15d29$var$$f();
                break;
            case 3:
                $af3a2d87ccb15d29$var$Jh();
                $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$Wf);
                $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$H);
                $af3a2d87ccb15d29$var$Oh();
                break;
            case 5:
                $af3a2d87ccb15d29$var$Lh(d);
                break;
            case 4:
                $af3a2d87ccb15d29$var$Jh();
                break;
            case 13:
                $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$M);
                break;
            case 19:
                $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$M);
                break;
            case 10:
                $af3a2d87ccb15d29$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $af3a2d87ccb15d29$var$Ij();
        }
        c = c.return;
    }
    $af3a2d87ccb15d29$var$R = a;
    $af3a2d87ccb15d29$var$Y = a = $af3a2d87ccb15d29$var$wh(a.current, null);
    $af3a2d87ccb15d29$var$Z = $af3a2d87ccb15d29$var$gj = b;
    $af3a2d87ccb15d29$var$T = 0;
    $af3a2d87ccb15d29$var$qk = null;
    $af3a2d87ccb15d29$var$sk = $af3a2d87ccb15d29$var$rk = $af3a2d87ccb15d29$var$hh = 0;
    $af3a2d87ccb15d29$var$uk = $af3a2d87ccb15d29$var$tk = null;
    if (null !== $af3a2d87ccb15d29$var$Wg) {
        for(b = 0; b < $af3a2d87ccb15d29$var$Wg.length; b++)if (c = $af3a2d87ccb15d29$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $af3a2d87ccb15d29$var$Wg = null;
    }
    return a;
}
function $af3a2d87ccb15d29$var$Nk(a, b) {
    do {
        var c = $af3a2d87ccb15d29$var$Y;
        try {
            $af3a2d87ccb15d29$var$Qg();
            $af3a2d87ccb15d29$var$Ph.current = $af3a2d87ccb15d29$var$ai;
            if ($af3a2d87ccb15d29$var$Sh) {
                for(var d = $af3a2d87ccb15d29$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $af3a2d87ccb15d29$var$Sh = !1;
            }
            $af3a2d87ccb15d29$var$Rh = 0;
            $af3a2d87ccb15d29$var$P = $af3a2d87ccb15d29$var$O = $af3a2d87ccb15d29$var$N = null;
            $af3a2d87ccb15d29$var$Th = !1;
            $af3a2d87ccb15d29$var$Uh = 0;
            $af3a2d87ccb15d29$var$ok.current = null;
            if (null === c || null === c.return) {
                $af3a2d87ccb15d29$var$T = 1;
                $af3a2d87ccb15d29$var$qk = b;
                $af3a2d87ccb15d29$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $af3a2d87ccb15d29$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $af3a2d87ccb15d29$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $af3a2d87ccb15d29$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $af3a2d87ccb15d29$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $af3a2d87ccb15d29$var$Ti(f, l, b);
                            $af3a2d87ccb15d29$var$uj();
                            break a;
                        }
                        k = Error($af3a2d87ccb15d29$var$p(426));
                    }
                } else if ($af3a2d87ccb15d29$var$I && h.mode & 1) {
                    var J = $af3a2d87ccb15d29$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $af3a2d87ccb15d29$var$Wi(J, g, h, f, b);
                        $af3a2d87ccb15d29$var$Jg($af3a2d87ccb15d29$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $af3a2d87ccb15d29$var$Ki(k, h);
                4 !== $af3a2d87ccb15d29$var$T && ($af3a2d87ccb15d29$var$T = 2);
                null === $af3a2d87ccb15d29$var$tk ? $af3a2d87ccb15d29$var$tk = [
                    f
                ] : $af3a2d87ccb15d29$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $af3a2d87ccb15d29$var$Oi(f, k, b);
                            $af3a2d87ccb15d29$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $af3a2d87ccb15d29$var$Si || !$af3a2d87ccb15d29$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $af3a2d87ccb15d29$var$Ri(f, h, b);
                                $af3a2d87ccb15d29$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $af3a2d87ccb15d29$var$Tk(c);
        } catch (na) {
            b = na;
            $af3a2d87ccb15d29$var$Y === c && null !== c && ($af3a2d87ccb15d29$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $af3a2d87ccb15d29$var$Kk() {
    var a = $af3a2d87ccb15d29$var$nk.current;
    $af3a2d87ccb15d29$var$nk.current = $af3a2d87ccb15d29$var$ai;
    return null === a ? $af3a2d87ccb15d29$var$ai : a;
}
function $af3a2d87ccb15d29$var$uj() {
    if (0 === $af3a2d87ccb15d29$var$T || 3 === $af3a2d87ccb15d29$var$T || 2 === $af3a2d87ccb15d29$var$T) $af3a2d87ccb15d29$var$T = 4;
    null === $af3a2d87ccb15d29$var$R || 0 === ($af3a2d87ccb15d29$var$hh & 268435455) && 0 === ($af3a2d87ccb15d29$var$rk & 268435455) || $af3a2d87ccb15d29$var$Dk($af3a2d87ccb15d29$var$R, $af3a2d87ccb15d29$var$Z);
}
function $af3a2d87ccb15d29$var$Jk(a, b) {
    var c = $af3a2d87ccb15d29$var$K;
    $af3a2d87ccb15d29$var$K |= 2;
    var d = $af3a2d87ccb15d29$var$Kk();
    if ($af3a2d87ccb15d29$var$R !== a || $af3a2d87ccb15d29$var$Z !== b) $af3a2d87ccb15d29$var$vk = null, $af3a2d87ccb15d29$var$Lk(a, b);
    for(;;)try {
        $af3a2d87ccb15d29$var$Uk();
        break;
    } catch (e) {
        $af3a2d87ccb15d29$var$Nk(a, e);
    }
    $af3a2d87ccb15d29$var$Qg();
    $af3a2d87ccb15d29$var$K = c;
    $af3a2d87ccb15d29$var$nk.current = d;
    if (null !== $af3a2d87ccb15d29$var$Y) throw Error($af3a2d87ccb15d29$var$p(261));
    $af3a2d87ccb15d29$var$R = null;
    $af3a2d87ccb15d29$var$Z = 0;
    return $af3a2d87ccb15d29$var$T;
}
function $af3a2d87ccb15d29$var$Uk() {
    for(; null !== $af3a2d87ccb15d29$var$Y;)$af3a2d87ccb15d29$var$Vk($af3a2d87ccb15d29$var$Y);
}
function $af3a2d87ccb15d29$var$Mk() {
    for(; null !== $af3a2d87ccb15d29$var$Y && !$af3a2d87ccb15d29$var$cc();)$af3a2d87ccb15d29$var$Vk($af3a2d87ccb15d29$var$Y);
}
function $af3a2d87ccb15d29$var$Vk(a) {
    var b = $af3a2d87ccb15d29$var$Wk(a.alternate, a, $af3a2d87ccb15d29$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $af3a2d87ccb15d29$var$Tk(a) : $af3a2d87ccb15d29$var$Y = b;
    $af3a2d87ccb15d29$var$ok.current = null;
}
function $af3a2d87ccb15d29$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $af3a2d87ccb15d29$var$Fj(c, b, $af3a2d87ccb15d29$var$gj), null !== c) {
                $af3a2d87ccb15d29$var$Y = c;
                return;
            }
        } else {
            c = $af3a2d87ccb15d29$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $af3a2d87ccb15d29$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $af3a2d87ccb15d29$var$T = 6;
                $af3a2d87ccb15d29$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $af3a2d87ccb15d29$var$Y = b;
            return;
        }
        $af3a2d87ccb15d29$var$Y = b = a;
    }while (null !== b);
    0 === $af3a2d87ccb15d29$var$T && ($af3a2d87ccb15d29$var$T = 5);
}
function $af3a2d87ccb15d29$var$Qk(a, b, c) {
    var d = $af3a2d87ccb15d29$var$C, e = $af3a2d87ccb15d29$var$pk.transition;
    try {
        $af3a2d87ccb15d29$var$pk.transition = null, $af3a2d87ccb15d29$var$C = 1, $af3a2d87ccb15d29$var$Xk(a, b, c, d);
    } finally{
        $af3a2d87ccb15d29$var$pk.transition = e, $af3a2d87ccb15d29$var$C = d;
    }
    return null;
}
function $af3a2d87ccb15d29$var$Xk(a, b, c, d) {
    do $af3a2d87ccb15d29$var$Ik();
    while (null !== $af3a2d87ccb15d29$var$xk);
    if (0 !== ($af3a2d87ccb15d29$var$K & 6)) throw Error($af3a2d87ccb15d29$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($af3a2d87ccb15d29$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $af3a2d87ccb15d29$var$Bc(a, f);
    a === $af3a2d87ccb15d29$var$R && ($af3a2d87ccb15d29$var$Y = $af3a2d87ccb15d29$var$R = null, $af3a2d87ccb15d29$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $af3a2d87ccb15d29$var$wk || ($af3a2d87ccb15d29$var$wk = !0, $af3a2d87ccb15d29$var$Gk($af3a2d87ccb15d29$var$hc, function() {
        $af3a2d87ccb15d29$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $af3a2d87ccb15d29$var$pk.transition;
        $af3a2d87ccb15d29$var$pk.transition = null;
        var g = $af3a2d87ccb15d29$var$C;
        $af3a2d87ccb15d29$var$C = 1;
        var h = $af3a2d87ccb15d29$var$K;
        $af3a2d87ccb15d29$var$K |= 4;
        $af3a2d87ccb15d29$var$ok.current = null;
        $af3a2d87ccb15d29$var$Pj(a, c);
        $af3a2d87ccb15d29$var$ek(c, a);
        $af3a2d87ccb15d29$var$Oe($af3a2d87ccb15d29$var$Df);
        $af3a2d87ccb15d29$var$dd = !!$af3a2d87ccb15d29$var$Cf;
        $af3a2d87ccb15d29$var$Df = $af3a2d87ccb15d29$var$Cf = null;
        a.current = c;
        $af3a2d87ccb15d29$var$ik(c, a, e);
        $af3a2d87ccb15d29$var$dc();
        $af3a2d87ccb15d29$var$K = h;
        $af3a2d87ccb15d29$var$C = g;
        $af3a2d87ccb15d29$var$pk.transition = f;
    } else a.current = c;
    $af3a2d87ccb15d29$var$wk && ($af3a2d87ccb15d29$var$wk = !1, $af3a2d87ccb15d29$var$xk = a, $af3a2d87ccb15d29$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($af3a2d87ccb15d29$var$Si = null);
    $af3a2d87ccb15d29$var$mc(c.stateNode, d);
    $af3a2d87ccb15d29$var$Ek(a, $af3a2d87ccb15d29$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($af3a2d87ccb15d29$var$Pi) throw $af3a2d87ccb15d29$var$Pi = !1, a = $af3a2d87ccb15d29$var$Qi, $af3a2d87ccb15d29$var$Qi = null, a;
    0 !== ($af3a2d87ccb15d29$var$yk & 1) && 0 !== a.tag && $af3a2d87ccb15d29$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $af3a2d87ccb15d29$var$Ak ? $af3a2d87ccb15d29$var$zk++ : ($af3a2d87ccb15d29$var$zk = 0, $af3a2d87ccb15d29$var$Ak = a) : $af3a2d87ccb15d29$var$zk = 0;
    $af3a2d87ccb15d29$var$jg();
    return null;
}
function $af3a2d87ccb15d29$var$Ik() {
    if (null !== $af3a2d87ccb15d29$var$xk) {
        var a = $af3a2d87ccb15d29$var$Dc($af3a2d87ccb15d29$var$yk), b = $af3a2d87ccb15d29$var$pk.transition, c = $af3a2d87ccb15d29$var$C;
        try {
            $af3a2d87ccb15d29$var$pk.transition = null;
            $af3a2d87ccb15d29$var$C = 16 > a ? 16 : a;
            if (null === $af3a2d87ccb15d29$var$xk) var d = !1;
            else {
                a = $af3a2d87ccb15d29$var$xk;
                $af3a2d87ccb15d29$var$xk = null;
                $af3a2d87ccb15d29$var$yk = 0;
                if (0 !== ($af3a2d87ccb15d29$var$K & 6)) throw Error($af3a2d87ccb15d29$var$p(331));
                var e = $af3a2d87ccb15d29$var$K;
                $af3a2d87ccb15d29$var$K |= 4;
                for($af3a2d87ccb15d29$var$V = a.current; null !== $af3a2d87ccb15d29$var$V;){
                    var f = $af3a2d87ccb15d29$var$V, g = f.child;
                    if (0 !== ($af3a2d87ccb15d29$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($af3a2d87ccb15d29$var$V = l; null !== $af3a2d87ccb15d29$var$V;){
                                    var m = $af3a2d87ccb15d29$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $af3a2d87ccb15d29$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $af3a2d87ccb15d29$var$V = q;
                                    else for(; null !== $af3a2d87ccb15d29$var$V;){
                                        m = $af3a2d87ccb15d29$var$V;
                                        var r = m.sibling, y = m.return;
                                        $af3a2d87ccb15d29$var$Tj(m);
                                        if (m === l) {
                                            $af3a2d87ccb15d29$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $af3a2d87ccb15d29$var$V = r;
                                            break;
                                        }
                                        $af3a2d87ccb15d29$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $af3a2d87ccb15d29$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $af3a2d87ccb15d29$var$V = g;
                    else b: for(; null !== $af3a2d87ccb15d29$var$V;){
                        f = $af3a2d87ccb15d29$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $af3a2d87ccb15d29$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $af3a2d87ccb15d29$var$V = x;
                            break b;
                        }
                        $af3a2d87ccb15d29$var$V = f.return;
                    }
                }
                var w = a.current;
                for($af3a2d87ccb15d29$var$V = w; null !== $af3a2d87ccb15d29$var$V;){
                    g = $af3a2d87ccb15d29$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $af3a2d87ccb15d29$var$V = u;
                    else b: for(g = w; null !== $af3a2d87ccb15d29$var$V;){
                        h = $af3a2d87ccb15d29$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $af3a2d87ccb15d29$var$Rj(9, h);
                            }
                        } catch (na) {
                            $af3a2d87ccb15d29$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $af3a2d87ccb15d29$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $af3a2d87ccb15d29$var$V = F;
                            break b;
                        }
                        $af3a2d87ccb15d29$var$V = h.return;
                    }
                }
                $af3a2d87ccb15d29$var$K = e;
                $af3a2d87ccb15d29$var$jg();
                if ($af3a2d87ccb15d29$var$lc && "function" === typeof $af3a2d87ccb15d29$var$lc.onPostCommitFiberRoot) try {
                    $af3a2d87ccb15d29$var$lc.onPostCommitFiberRoot($af3a2d87ccb15d29$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $af3a2d87ccb15d29$var$C = c, $af3a2d87ccb15d29$var$pk.transition = b;
        }
    }
    return !1;
}
function $af3a2d87ccb15d29$var$Yk(a, b, c) {
    b = $af3a2d87ccb15d29$var$Ki(c, b);
    b = $af3a2d87ccb15d29$var$Oi(a, b, 1);
    a = $af3a2d87ccb15d29$var$dh(a, b, 1);
    b = $af3a2d87ccb15d29$var$L();
    null !== a && ($af3a2d87ccb15d29$var$Ac(a, 1, b), $af3a2d87ccb15d29$var$Ek(a, b));
}
function $af3a2d87ccb15d29$var$W(a, b, c) {
    if (3 === a.tag) $af3a2d87ccb15d29$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $af3a2d87ccb15d29$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $af3a2d87ccb15d29$var$Si || !$af3a2d87ccb15d29$var$Si.has(d))) {
                a = $af3a2d87ccb15d29$var$Ki(c, a);
                a = $af3a2d87ccb15d29$var$Ri(b, a, 1);
                b = $af3a2d87ccb15d29$var$dh(b, a, 1);
                a = $af3a2d87ccb15d29$var$L();
                null !== b && ($af3a2d87ccb15d29$var$Ac(b, 1, a), $af3a2d87ccb15d29$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $af3a2d87ccb15d29$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $af3a2d87ccb15d29$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $af3a2d87ccb15d29$var$R === a && ($af3a2d87ccb15d29$var$Z & c) === c && (4 === $af3a2d87ccb15d29$var$T || 3 === $af3a2d87ccb15d29$var$T && ($af3a2d87ccb15d29$var$Z & 130023424) === $af3a2d87ccb15d29$var$Z && 500 > $af3a2d87ccb15d29$var$B() - $af3a2d87ccb15d29$var$gk ? $af3a2d87ccb15d29$var$Lk(a, 0) : $af3a2d87ccb15d29$var$sk |= c);
    $af3a2d87ccb15d29$var$Ek(a, b);
}
function $af3a2d87ccb15d29$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $af3a2d87ccb15d29$var$sc, $af3a2d87ccb15d29$var$sc <<= 1, 0 === ($af3a2d87ccb15d29$var$sc & 130023424) && ($af3a2d87ccb15d29$var$sc = 4194304)));
    var c = $af3a2d87ccb15d29$var$L();
    a = $af3a2d87ccb15d29$var$Zg(a, b);
    null !== a && ($af3a2d87ccb15d29$var$Ac(a, b, c), $af3a2d87ccb15d29$var$Ek(a, c));
}
function $af3a2d87ccb15d29$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $af3a2d87ccb15d29$var$Zk(a, c);
}
function $af3a2d87ccb15d29$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($af3a2d87ccb15d29$var$p(314));
    }
    null !== d && d.delete(b);
    $af3a2d87ccb15d29$var$Zk(a, c);
}
var $af3a2d87ccb15d29$var$Wk;
$af3a2d87ccb15d29$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $af3a2d87ccb15d29$var$Wf.current) $af3a2d87ccb15d29$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $af3a2d87ccb15d29$var$Ug = !1, $af3a2d87ccb15d29$var$zj(a, b, c);
            $af3a2d87ccb15d29$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $af3a2d87ccb15d29$var$Ug = !1, $af3a2d87ccb15d29$var$I && 0 !== (b.flags & 1048576) && $af3a2d87ccb15d29$var$ug(b, $af3a2d87ccb15d29$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $af3a2d87ccb15d29$var$jj(a, b);
            a = b.pendingProps;
            var e = $af3a2d87ccb15d29$var$Yf(b, $af3a2d87ccb15d29$var$H.current);
            $af3a2d87ccb15d29$var$Tg(b, c);
            e = $af3a2d87ccb15d29$var$Xh(null, b, d, a, e, c);
            var f = $af3a2d87ccb15d29$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $af3a2d87ccb15d29$var$Zf(d) ? (f = !0, $af3a2d87ccb15d29$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $af3a2d87ccb15d29$var$ah(b), e.updater = $af3a2d87ccb15d29$var$nh, b.stateNode = e, e._reactInternals = b, $af3a2d87ccb15d29$var$rh(b, d, a, c), b = $af3a2d87ccb15d29$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $af3a2d87ccb15d29$var$I && f && $af3a2d87ccb15d29$var$vg(b), $af3a2d87ccb15d29$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $af3a2d87ccb15d29$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $af3a2d87ccb15d29$var$$k(d);
                a = $af3a2d87ccb15d29$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $af3a2d87ccb15d29$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $af3a2d87ccb15d29$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $af3a2d87ccb15d29$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $af3a2d87ccb15d29$var$aj(null, b, d, $af3a2d87ccb15d29$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($af3a2d87ccb15d29$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $af3a2d87ccb15d29$var$Lg(d, e), $af3a2d87ccb15d29$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $af3a2d87ccb15d29$var$Lg(d, e), $af3a2d87ccb15d29$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $af3a2d87ccb15d29$var$lj(b);
                if (null === a) throw Error($af3a2d87ccb15d29$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $af3a2d87ccb15d29$var$bh(a, b);
                $af3a2d87ccb15d29$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $af3a2d87ccb15d29$var$Ki(Error($af3a2d87ccb15d29$var$p(423)), b);
                        b = $af3a2d87ccb15d29$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $af3a2d87ccb15d29$var$Ki(Error($af3a2d87ccb15d29$var$p(424)), b);
                        b = $af3a2d87ccb15d29$var$mj(a, b, d, c, e);
                        break a;
                    } else for($af3a2d87ccb15d29$var$yg = $af3a2d87ccb15d29$var$Lf(b.stateNode.containerInfo.firstChild), $af3a2d87ccb15d29$var$xg = b, $af3a2d87ccb15d29$var$I = !0, $af3a2d87ccb15d29$var$zg = null, c = $af3a2d87ccb15d29$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $af3a2d87ccb15d29$var$Ig();
                    if (d === e) {
                        b = $af3a2d87ccb15d29$var$$i(a, b, c);
                        break a;
                    }
                    $af3a2d87ccb15d29$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $af3a2d87ccb15d29$var$Kh(b), null === a && $af3a2d87ccb15d29$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $af3a2d87ccb15d29$var$Ef(d, e) ? g = null : null !== f && $af3a2d87ccb15d29$var$Ef(d, f) && (b.flags |= 32), $af3a2d87ccb15d29$var$hj(a, b), $af3a2d87ccb15d29$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $af3a2d87ccb15d29$var$Eg(b), null;
        case 13:
            return $af3a2d87ccb15d29$var$pj(a, b, c);
        case 4:
            return $af3a2d87ccb15d29$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $af3a2d87ccb15d29$var$Bh(b, null, d, c) : $af3a2d87ccb15d29$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $af3a2d87ccb15d29$var$Lg(d, e), $af3a2d87ccb15d29$var$Zi(a, b, d, e, c);
        case 7:
            return $af3a2d87ccb15d29$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $af3a2d87ccb15d29$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $af3a2d87ccb15d29$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($af3a2d87ccb15d29$var$He(f.value, g)) {
                        if (f.children === e.children && !$af3a2d87ccb15d29$var$Wf.current) {
                            b = $af3a2d87ccb15d29$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $af3a2d87ccb15d29$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $af3a2d87ccb15d29$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($af3a2d87ccb15d29$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $af3a2d87ccb15d29$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $af3a2d87ccb15d29$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $af3a2d87ccb15d29$var$Tg(b, c), e = $af3a2d87ccb15d29$var$Vg(e), d = d(e), b.flags |= 1, $af3a2d87ccb15d29$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $af3a2d87ccb15d29$var$Lg(d, b.pendingProps), e = $af3a2d87ccb15d29$var$Lg(d.type, e), $af3a2d87ccb15d29$var$aj(a, b, d, e, c);
        case 15:
            return $af3a2d87ccb15d29$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $af3a2d87ccb15d29$var$Lg(d, e), $af3a2d87ccb15d29$var$jj(a, b), b.tag = 1, $af3a2d87ccb15d29$var$Zf(d) ? (a = !0, $af3a2d87ccb15d29$var$cg(b)) : a = !1, $af3a2d87ccb15d29$var$Tg(b, c), $af3a2d87ccb15d29$var$ph(b, d, e), $af3a2d87ccb15d29$var$rh(b, d, e, c), $af3a2d87ccb15d29$var$kj(null, b, d, !0, a, c);
        case 19:
            return $af3a2d87ccb15d29$var$yj(a, b, c);
        case 22:
            return $af3a2d87ccb15d29$var$ej(a, b, c);
    }
    throw Error($af3a2d87ccb15d29$var$p(156, b.tag));
};
function $af3a2d87ccb15d29$var$Gk(a, b) {
    return $af3a2d87ccb15d29$var$ac(a, b);
}
function $af3a2d87ccb15d29$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $af3a2d87ccb15d29$var$Bg(a, b, c, d) {
    return new $af3a2d87ccb15d29$var$al(a, b, c, d);
}
function $af3a2d87ccb15d29$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $af3a2d87ccb15d29$var$$k(a) {
    if ("function" === typeof a) return $af3a2d87ccb15d29$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $af3a2d87ccb15d29$var$Da) return 11;
        if (a === $af3a2d87ccb15d29$var$Ga) return 14;
    }
    return 2;
}
function $af3a2d87ccb15d29$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $af3a2d87ccb15d29$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $af3a2d87ccb15d29$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $af3a2d87ccb15d29$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $af3a2d87ccb15d29$var$ya:
            return $af3a2d87ccb15d29$var$Ah(c.children, e, f, b);
        case $af3a2d87ccb15d29$var$za:
            g = 8;
            e |= 8;
            break;
        case $af3a2d87ccb15d29$var$Aa:
            return a = $af3a2d87ccb15d29$var$Bg(12, c, b, e | 2), a.elementType = $af3a2d87ccb15d29$var$Aa, a.lanes = f, a;
        case $af3a2d87ccb15d29$var$Ea:
            return a = $af3a2d87ccb15d29$var$Bg(13, c, b, e), a.elementType = $af3a2d87ccb15d29$var$Ea, a.lanes = f, a;
        case $af3a2d87ccb15d29$var$Fa:
            return a = $af3a2d87ccb15d29$var$Bg(19, c, b, e), a.elementType = $af3a2d87ccb15d29$var$Fa, a.lanes = f, a;
        case $af3a2d87ccb15d29$var$Ia:
            return $af3a2d87ccb15d29$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $af3a2d87ccb15d29$var$Ba:
                    g = 10;
                    break a;
                case $af3a2d87ccb15d29$var$Ca:
                    g = 9;
                    break a;
                case $af3a2d87ccb15d29$var$Da:
                    g = 11;
                    break a;
                case $af3a2d87ccb15d29$var$Ga:
                    g = 14;
                    break a;
                case $af3a2d87ccb15d29$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($af3a2d87ccb15d29$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $af3a2d87ccb15d29$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $af3a2d87ccb15d29$var$Ah(a, b, c, d) {
    a = $af3a2d87ccb15d29$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $af3a2d87ccb15d29$var$qj(a, b, c, d) {
    a = $af3a2d87ccb15d29$var$Bg(22, a, d, b);
    a.elementType = $af3a2d87ccb15d29$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $af3a2d87ccb15d29$var$xh(a, b, c) {
    a = $af3a2d87ccb15d29$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $af3a2d87ccb15d29$var$zh(a, b, c) {
    b = $af3a2d87ccb15d29$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $af3a2d87ccb15d29$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $af3a2d87ccb15d29$var$zc(0);
    this.expirationTimes = $af3a2d87ccb15d29$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $af3a2d87ccb15d29$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $af3a2d87ccb15d29$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $af3a2d87ccb15d29$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $af3a2d87ccb15d29$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $af3a2d87ccb15d29$var$ah(f);
    return a;
}
function $af3a2d87ccb15d29$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $af3a2d87ccb15d29$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $af3a2d87ccb15d29$var$el(a) {
    if (!a) return $af3a2d87ccb15d29$var$Vf;
    a = a._reactInternals;
    a: {
        if ($af3a2d87ccb15d29$var$Vb(a) !== a || 1 !== a.tag) throw Error($af3a2d87ccb15d29$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($af3a2d87ccb15d29$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($af3a2d87ccb15d29$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($af3a2d87ccb15d29$var$Zf(c)) return $af3a2d87ccb15d29$var$bg(a, c, b);
    }
    return b;
}
function $af3a2d87ccb15d29$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $af3a2d87ccb15d29$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $af3a2d87ccb15d29$var$el(null);
    c = a.current;
    d = $af3a2d87ccb15d29$var$L();
    e = $af3a2d87ccb15d29$var$lh(c);
    f = $af3a2d87ccb15d29$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $af3a2d87ccb15d29$var$dh(c, f, e);
    a.current.lanes = e;
    $af3a2d87ccb15d29$var$Ac(a, e, d);
    $af3a2d87ccb15d29$var$Ek(a, d);
    return a;
}
function $af3a2d87ccb15d29$var$gl(a, b, c, d) {
    var e = b.current, f = $af3a2d87ccb15d29$var$L(), g = $af3a2d87ccb15d29$var$lh(e);
    c = $af3a2d87ccb15d29$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $af3a2d87ccb15d29$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $af3a2d87ccb15d29$var$dh(e, b, g);
    null !== a && ($af3a2d87ccb15d29$var$mh(a, e, g, f), $af3a2d87ccb15d29$var$eh(a, e, g));
    return g;
}
function $af3a2d87ccb15d29$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $af3a2d87ccb15d29$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $af3a2d87ccb15d29$var$jl(a, b) {
    $af3a2d87ccb15d29$var$il(a, b);
    (a = a.alternate) && $af3a2d87ccb15d29$var$il(a, b);
}
function $af3a2d87ccb15d29$var$kl() {
    return null;
}
var $af3a2d87ccb15d29$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $af3a2d87ccb15d29$var$ml(a) {
    this._internalRoot = a;
}
$af3a2d87ccb15d29$var$nl.prototype.render = $af3a2d87ccb15d29$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($af3a2d87ccb15d29$var$p(409));
    $af3a2d87ccb15d29$var$gl(a, b, null, null);
};
$af3a2d87ccb15d29$var$nl.prototype.unmount = $af3a2d87ccb15d29$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $af3a2d87ccb15d29$var$Sk(function() {
            $af3a2d87ccb15d29$var$gl(null, a, null, null);
        });
        b[$af3a2d87ccb15d29$var$uf] = null;
    }
};
function $af3a2d87ccb15d29$var$nl(a) {
    this._internalRoot = a;
}
$af3a2d87ccb15d29$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $af3a2d87ccb15d29$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $af3a2d87ccb15d29$var$Qc.length && 0 !== b && b < $af3a2d87ccb15d29$var$Qc[c].priority; c++);
        $af3a2d87ccb15d29$var$Qc.splice(c, 0, a);
        0 === c && $af3a2d87ccb15d29$var$Vc(a);
    }
};
function $af3a2d87ccb15d29$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $af3a2d87ccb15d29$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $af3a2d87ccb15d29$var$ql() {}
function $af3a2d87ccb15d29$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $af3a2d87ccb15d29$var$hl(g);
                f.call(a);
            };
        }
        var g = $af3a2d87ccb15d29$var$fl(b, d, a, 0, null, !1, !1, "", $af3a2d87ccb15d29$var$ql);
        a._reactRootContainer = g;
        a[$af3a2d87ccb15d29$var$uf] = g.current;
        $af3a2d87ccb15d29$var$sf(8 === a.nodeType ? a.parentNode : a);
        $af3a2d87ccb15d29$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $af3a2d87ccb15d29$var$hl(k);
            h.call(a);
        };
    }
    var k = $af3a2d87ccb15d29$var$cl(a, 0, !1, null, null, !1, !1, "", $af3a2d87ccb15d29$var$ql);
    a._reactRootContainer = k;
    a[$af3a2d87ccb15d29$var$uf] = k.current;
    $af3a2d87ccb15d29$var$sf(8 === a.nodeType ? a.parentNode : a);
    $af3a2d87ccb15d29$var$Sk(function() {
        $af3a2d87ccb15d29$var$gl(b, k, c, d);
    });
    return k;
}
function $af3a2d87ccb15d29$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $af3a2d87ccb15d29$var$hl(g);
                h.call(a);
            };
        }
        $af3a2d87ccb15d29$var$gl(b, g, a, e);
    } else g = $af3a2d87ccb15d29$var$rl(c, b, a, e, d);
    return $af3a2d87ccb15d29$var$hl(g);
}
$af3a2d87ccb15d29$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $af3a2d87ccb15d29$var$tc(b.pendingLanes);
                0 !== c && ($af3a2d87ccb15d29$var$Cc(b, c | 1), $af3a2d87ccb15d29$var$Ek(b, $af3a2d87ccb15d29$var$B()), 0 === ($af3a2d87ccb15d29$var$K & 6) && ($af3a2d87ccb15d29$var$Hj = $af3a2d87ccb15d29$var$B() + 500, $af3a2d87ccb15d29$var$jg()));
            }
            break;
        case 13:
            $af3a2d87ccb15d29$var$Sk(function() {
                var b = $af3a2d87ccb15d29$var$Zg(a, 1);
                if (null !== b) {
                    var c = $af3a2d87ccb15d29$var$L();
                    $af3a2d87ccb15d29$var$mh(b, a, 1, c);
                }
            }), $af3a2d87ccb15d29$var$jl(a, 1);
    }
};
$af3a2d87ccb15d29$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $af3a2d87ccb15d29$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $af3a2d87ccb15d29$var$L();
            $af3a2d87ccb15d29$var$mh(b, a, 134217728, c);
        }
        $af3a2d87ccb15d29$var$jl(a, 134217728);
    }
};
$af3a2d87ccb15d29$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $af3a2d87ccb15d29$var$lh(a), c = $af3a2d87ccb15d29$var$Zg(a, b);
        if (null !== c) {
            var d = $af3a2d87ccb15d29$var$L();
            $af3a2d87ccb15d29$var$mh(c, a, b, d);
        }
        $af3a2d87ccb15d29$var$jl(a, b);
    }
};
$af3a2d87ccb15d29$var$Hc = function() {
    return $af3a2d87ccb15d29$var$C;
};
$af3a2d87ccb15d29$var$Ic = function(a, b) {
    var c = $af3a2d87ccb15d29$var$C;
    try {
        return $af3a2d87ccb15d29$var$C = a, b();
    } finally{
        $af3a2d87ccb15d29$var$C = c;
    }
};
$af3a2d87ccb15d29$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $af3a2d87ccb15d29$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $af3a2d87ccb15d29$var$Db(d);
                        if (!e) throw Error($af3a2d87ccb15d29$var$p(90));
                        $af3a2d87ccb15d29$var$Wa(d);
                        $af3a2d87ccb15d29$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $af3a2d87ccb15d29$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $af3a2d87ccb15d29$var$fb(a, !!c.multiple, b, !1);
    }
};
$af3a2d87ccb15d29$var$Gb = $af3a2d87ccb15d29$var$Rk;
$af3a2d87ccb15d29$var$Hb = $af3a2d87ccb15d29$var$Sk;
var $af3a2d87ccb15d29$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $af3a2d87ccb15d29$var$Cb,
        $af3a2d87ccb15d29$var$ue,
        $af3a2d87ccb15d29$var$Db,
        $af3a2d87ccb15d29$var$Eb,
        $af3a2d87ccb15d29$var$Fb,
        $af3a2d87ccb15d29$var$Rk
    ]
}, $af3a2d87ccb15d29$var$ul = {
    findFiberByHostInstance: $af3a2d87ccb15d29$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $af3a2d87ccb15d29$var$vl = {
    bundleType: $af3a2d87ccb15d29$var$ul.bundleType,
    version: $af3a2d87ccb15d29$var$ul.version,
    rendererPackageName: $af3a2d87ccb15d29$var$ul.rendererPackageName,
    rendererConfig: $af3a2d87ccb15d29$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $af3a2d87ccb15d29$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $af3a2d87ccb15d29$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $af3a2d87ccb15d29$var$ul.findFiberByHostInstance || $af3a2d87ccb15d29$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $af3a2d87ccb15d29$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$af3a2d87ccb15d29$var$wl.isDisabled && $af3a2d87ccb15d29$var$wl.supportsFiber) try {
        $af3a2d87ccb15d29$var$kc = $af3a2d87ccb15d29$var$wl.inject($af3a2d87ccb15d29$var$vl), $af3a2d87ccb15d29$var$lc = $af3a2d87ccb15d29$var$wl;
    } catch (a) {}
}
$af3a2d87ccb15d29$export$ae55be85d98224ed = $af3a2d87ccb15d29$var$tl;
$af3a2d87ccb15d29$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$af3a2d87ccb15d29$var$ol(b)) throw Error($af3a2d87ccb15d29$var$p(200));
    return $af3a2d87ccb15d29$var$dl(a, b, null, c);
};
$af3a2d87ccb15d29$export$882461b6382ed46c = function(a, b) {
    if (!$af3a2d87ccb15d29$var$ol(a)) throw Error($af3a2d87ccb15d29$var$p(299));
    var c = !1, d = "", e = $af3a2d87ccb15d29$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $af3a2d87ccb15d29$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$af3a2d87ccb15d29$var$uf] = b.current;
    $af3a2d87ccb15d29$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $af3a2d87ccb15d29$var$ml(b);
};
$af3a2d87ccb15d29$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($af3a2d87ccb15d29$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($af3a2d87ccb15d29$var$p(268, a));
    }
    a = $af3a2d87ccb15d29$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$af3a2d87ccb15d29$export$cd75ccfd720a3cd4 = function(a) {
    return $af3a2d87ccb15d29$var$Sk(a);
};
$af3a2d87ccb15d29$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$af3a2d87ccb15d29$var$pl(b)) throw Error($af3a2d87ccb15d29$var$p(200));
    return $af3a2d87ccb15d29$var$sl(null, a, b, !0, c);
};
$af3a2d87ccb15d29$export$757ceba2d55c277e = function(a, b, c) {
    if (!$af3a2d87ccb15d29$var$ol(a)) throw Error($af3a2d87ccb15d29$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $af3a2d87ccb15d29$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $af3a2d87ccb15d29$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$af3a2d87ccb15d29$var$uf] = b.current;
    $af3a2d87ccb15d29$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $af3a2d87ccb15d29$var$nl(b);
};
$af3a2d87ccb15d29$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$af3a2d87ccb15d29$var$pl(b)) throw Error($af3a2d87ccb15d29$var$p(200));
    return $af3a2d87ccb15d29$var$sl(null, a, b, !1, c);
};
$af3a2d87ccb15d29$export$502457920280e6be = function(a) {
    if (!$af3a2d87ccb15d29$var$pl(a)) throw Error($af3a2d87ccb15d29$var$p(40));
    return a._reactRootContainer ? ($af3a2d87ccb15d29$var$Sk(function() {
        $af3a2d87ccb15d29$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$af3a2d87ccb15d29$var$uf] = null;
        });
    }), !0) : !1;
};
$af3a2d87ccb15d29$export$c78a37762a8d58e1 = $af3a2d87ccb15d29$var$Rk;
$af3a2d87ccb15d29$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$af3a2d87ccb15d29$var$pl(c)) throw Error($af3a2d87ccb15d29$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($af3a2d87ccb15d29$var$p(38));
    return $af3a2d87ccb15d29$var$sl(a, b, c, !1, d);
};
$af3a2d87ccb15d29$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("7zDBh", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1uxJf"));

});
parcelRegister("1uxJf", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $1162c1a406d3f6f8$export$c4744153514ff05d, (v) => $1162c1a406d3f6f8$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $1162c1a406d3f6f8$export$3e506c1ccc9cc1a7, (v) => $1162c1a406d3f6f8$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $1162c1a406d3f6f8$export$e26fe2ed2fa76875, (v) => $1162c1a406d3f6f8$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $1162c1a406d3f6f8$export$502329bbf4b505b1, (v) => $1162c1a406d3f6f8$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $1162c1a406d3f6f8$export$6e3807111c4874c4, (v) => $1162c1a406d3f6f8$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $1162c1a406d3f6f8$export$c27134553091fb3a, (v) => $1162c1a406d3f6f8$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $1162c1a406d3f6f8$export$33ee1acdc04fd2a2, (v) => $1162c1a406d3f6f8$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $1162c1a406d3f6f8$export$b00a404bbd5edef2, (v) => $1162c1a406d3f6f8$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $1162c1a406d3f6f8$export$8352ce38b91d0c62, (v) => $1162c1a406d3f6f8$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $1162c1a406d3f6f8$export$d66a1c1c77bd778b, (v) => $1162c1a406d3f6f8$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $1162c1a406d3f6f8$export$d3dfb8e4810cb555, (v) => $1162c1a406d3f6f8$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $1162c1a406d3f6f8$export$839f9183b0465a69, (v) => $1162c1a406d3f6f8$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $1162c1a406d3f6f8$export$72fdf0e06517287b, (v) => $1162c1a406d3f6f8$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $1162c1a406d3f6f8$export$4b844e58a3e414b4, (v) => $1162c1a406d3f6f8$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $1162c1a406d3f6f8$export$816d2913ae6b83b1, (v) => $1162c1a406d3f6f8$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $1162c1a406d3f6f8$export$61bcfe829111a1d0, (v) => $1162c1a406d3f6f8$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $1162c1a406d3f6f8$export$7ee8c9beb337bc3f, (v) => $1162c1a406d3f6f8$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $1162c1a406d3f6f8$export$b5836b71941fa3ed, (v) => $1162c1a406d3f6f8$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $1162c1a406d3f6f8$export$cf845f2c119da08a, (v) => $1162c1a406d3f6f8$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1162c1a406d3f6f8$export$c4744153514ff05d;
var $1162c1a406d3f6f8$export$3e506c1ccc9cc1a7;
var $1162c1a406d3f6f8$export$e26fe2ed2fa76875;
var $1162c1a406d3f6f8$export$502329bbf4b505b1;
var $1162c1a406d3f6f8$export$6e3807111c4874c4;
var $1162c1a406d3f6f8$export$c27134553091fb3a;
var $1162c1a406d3f6f8$export$33ee1acdc04fd2a2;
var $1162c1a406d3f6f8$export$b00a404bbd5edef2;
var $1162c1a406d3f6f8$export$8352ce38b91d0c62;
var $1162c1a406d3f6f8$export$d66a1c1c77bd778b;
var $1162c1a406d3f6f8$export$d3dfb8e4810cb555;
var $1162c1a406d3f6f8$export$839f9183b0465a69;
var $1162c1a406d3f6f8$export$72fdf0e06517287b;
var $1162c1a406d3f6f8$export$4b844e58a3e414b4;
var $1162c1a406d3f6f8$export$816d2913ae6b83b1;
var $1162c1a406d3f6f8$export$61bcfe829111a1d0;
var $1162c1a406d3f6f8$export$7ee8c9beb337bc3f;
var $1162c1a406d3f6f8$export$b5836b71941fa3ed;
var $1162c1a406d3f6f8$export$cf845f2c119da08a;
'use strict';
function $1162c1a406d3f6f8$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $1162c1a406d3f6f8$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $1162c1a406d3f6f8$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $1162c1a406d3f6f8$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $1162c1a406d3f6f8$var$g(C, c)) n < e && 0 > $1162c1a406d3f6f8$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $1162c1a406d3f6f8$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $1162c1a406d3f6f8$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $1162c1a406d3f6f8$var$l = performance;
    $1162c1a406d3f6f8$export$c4744153514ff05d = function() {
        return $1162c1a406d3f6f8$var$l.now();
    };
} else {
    var $1162c1a406d3f6f8$var$p = Date, $1162c1a406d3f6f8$var$q = $1162c1a406d3f6f8$var$p.now();
    $1162c1a406d3f6f8$export$c4744153514ff05d = function() {
        return $1162c1a406d3f6f8$var$p.now() - $1162c1a406d3f6f8$var$q;
    };
}
var $1162c1a406d3f6f8$var$r = [], $1162c1a406d3f6f8$var$t = [], $1162c1a406d3f6f8$var$u = 1, $1162c1a406d3f6f8$var$v = null, $1162c1a406d3f6f8$var$y = 3, $1162c1a406d3f6f8$var$z = !1, $1162c1a406d3f6f8$var$A = !1, $1162c1a406d3f6f8$var$B = !1, $1162c1a406d3f6f8$var$D = "function" === typeof setTimeout ? setTimeout : null, $1162c1a406d3f6f8$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $1162c1a406d3f6f8$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $1162c1a406d3f6f8$var$G(a) {
    for(var b = $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$t); null !== b;){
        if (null === b.callback) $1162c1a406d3f6f8$var$k($1162c1a406d3f6f8$var$t);
        else if (b.startTime <= a) $1162c1a406d3f6f8$var$k($1162c1a406d3f6f8$var$t), b.sortIndex = b.expirationTime, $1162c1a406d3f6f8$var$f($1162c1a406d3f6f8$var$r, b);
        else break;
        b = $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$t);
    }
}
function $1162c1a406d3f6f8$var$H(a) {
    $1162c1a406d3f6f8$var$B = !1;
    $1162c1a406d3f6f8$var$G(a);
    if (!$1162c1a406d3f6f8$var$A) {
        if (null !== $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$r)) $1162c1a406d3f6f8$var$A = !0, $1162c1a406d3f6f8$var$I($1162c1a406d3f6f8$var$J);
        else {
            var b = $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$t);
            null !== b && $1162c1a406d3f6f8$var$K($1162c1a406d3f6f8$var$H, b.startTime - a);
        }
    }
}
function $1162c1a406d3f6f8$var$J(a, b) {
    $1162c1a406d3f6f8$var$A = !1;
    $1162c1a406d3f6f8$var$B && ($1162c1a406d3f6f8$var$B = !1, $1162c1a406d3f6f8$var$E($1162c1a406d3f6f8$var$L), $1162c1a406d3f6f8$var$L = -1);
    $1162c1a406d3f6f8$var$z = !0;
    var c = $1162c1a406d3f6f8$var$y;
    try {
        $1162c1a406d3f6f8$var$G(b);
        for($1162c1a406d3f6f8$var$v = $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$r); null !== $1162c1a406d3f6f8$var$v && (!($1162c1a406d3f6f8$var$v.expirationTime > b) || a && !$1162c1a406d3f6f8$var$M());){
            var d = $1162c1a406d3f6f8$var$v.callback;
            if ("function" === typeof d) {
                $1162c1a406d3f6f8$var$v.callback = null;
                $1162c1a406d3f6f8$var$y = $1162c1a406d3f6f8$var$v.priorityLevel;
                var e = d($1162c1a406d3f6f8$var$v.expirationTime <= b);
                b = $1162c1a406d3f6f8$export$c4744153514ff05d();
                "function" === typeof e ? $1162c1a406d3f6f8$var$v.callback = e : $1162c1a406d3f6f8$var$v === $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$r) && $1162c1a406d3f6f8$var$k($1162c1a406d3f6f8$var$r);
                $1162c1a406d3f6f8$var$G(b);
            } else $1162c1a406d3f6f8$var$k($1162c1a406d3f6f8$var$r);
            $1162c1a406d3f6f8$var$v = $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$r);
        }
        if (null !== $1162c1a406d3f6f8$var$v) var w = !0;
        else {
            var m = $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$t);
            null !== m && $1162c1a406d3f6f8$var$K($1162c1a406d3f6f8$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $1162c1a406d3f6f8$var$v = null, $1162c1a406d3f6f8$var$y = c, $1162c1a406d3f6f8$var$z = !1;
    }
}
var $1162c1a406d3f6f8$var$N = !1, $1162c1a406d3f6f8$var$O = null, $1162c1a406d3f6f8$var$L = -1, $1162c1a406d3f6f8$var$P = 5, $1162c1a406d3f6f8$var$Q = -1;
function $1162c1a406d3f6f8$var$M() {
    return $1162c1a406d3f6f8$export$c4744153514ff05d() - $1162c1a406d3f6f8$var$Q < $1162c1a406d3f6f8$var$P ? !1 : !0;
}
function $1162c1a406d3f6f8$var$R() {
    if (null !== $1162c1a406d3f6f8$var$O) {
        var a = $1162c1a406d3f6f8$export$c4744153514ff05d();
        $1162c1a406d3f6f8$var$Q = a;
        var b = !0;
        try {
            b = $1162c1a406d3f6f8$var$O(!0, a);
        } finally{
            b ? $1162c1a406d3f6f8$var$S() : ($1162c1a406d3f6f8$var$N = !1, $1162c1a406d3f6f8$var$O = null);
        }
    } else $1162c1a406d3f6f8$var$N = !1;
}
var $1162c1a406d3f6f8$var$S;
if ("function" === typeof $1162c1a406d3f6f8$var$F) $1162c1a406d3f6f8$var$S = function() {
    $1162c1a406d3f6f8$var$F($1162c1a406d3f6f8$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $1162c1a406d3f6f8$var$T = new MessageChannel, $1162c1a406d3f6f8$var$U = $1162c1a406d3f6f8$var$T.port2;
    $1162c1a406d3f6f8$var$T.port1.onmessage = $1162c1a406d3f6f8$var$R;
    $1162c1a406d3f6f8$var$S = function() {
        $1162c1a406d3f6f8$var$U.postMessage(null);
    };
} else $1162c1a406d3f6f8$var$S = function() {
    $1162c1a406d3f6f8$var$D($1162c1a406d3f6f8$var$R, 0);
};
function $1162c1a406d3f6f8$var$I(a) {
    $1162c1a406d3f6f8$var$O = a;
    $1162c1a406d3f6f8$var$N || ($1162c1a406d3f6f8$var$N = !0, $1162c1a406d3f6f8$var$S());
}
function $1162c1a406d3f6f8$var$K(a, b) {
    $1162c1a406d3f6f8$var$L = $1162c1a406d3f6f8$var$D(function() {
        a($1162c1a406d3f6f8$export$c4744153514ff05d());
    }, b);
}
$1162c1a406d3f6f8$export$3e506c1ccc9cc1a7 = 5;
$1162c1a406d3f6f8$export$e26fe2ed2fa76875 = 1;
$1162c1a406d3f6f8$export$502329bbf4b505b1 = 4;
$1162c1a406d3f6f8$export$6e3807111c4874c4 = 3;
$1162c1a406d3f6f8$export$c27134553091fb3a = null;
$1162c1a406d3f6f8$export$33ee1acdc04fd2a2 = 2;
$1162c1a406d3f6f8$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$1162c1a406d3f6f8$export$8352ce38b91d0c62 = function() {
    $1162c1a406d3f6f8$var$A || $1162c1a406d3f6f8$var$z || ($1162c1a406d3f6f8$var$A = !0, $1162c1a406d3f6f8$var$I($1162c1a406d3f6f8$var$J));
};
$1162c1a406d3f6f8$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $1162c1a406d3f6f8$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$1162c1a406d3f6f8$export$d3dfb8e4810cb555 = function() {
    return $1162c1a406d3f6f8$var$y;
};
$1162c1a406d3f6f8$export$839f9183b0465a69 = function() {
    return $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$r);
};
$1162c1a406d3f6f8$export$72fdf0e06517287b = function(a) {
    switch($1162c1a406d3f6f8$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $1162c1a406d3f6f8$var$y;
    }
    var c = $1162c1a406d3f6f8$var$y;
    $1162c1a406d3f6f8$var$y = b;
    try {
        return a();
    } finally{
        $1162c1a406d3f6f8$var$y = c;
    }
};
$1162c1a406d3f6f8$export$4b844e58a3e414b4 = function() {};
$1162c1a406d3f6f8$export$816d2913ae6b83b1 = function() {};
$1162c1a406d3f6f8$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $1162c1a406d3f6f8$var$y;
    $1162c1a406d3f6f8$var$y = a;
    try {
        return b();
    } finally{
        $1162c1a406d3f6f8$var$y = c;
    }
};
$1162c1a406d3f6f8$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $1162c1a406d3f6f8$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $1162c1a406d3f6f8$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $1162c1a406d3f6f8$var$f($1162c1a406d3f6f8$var$t, a), null === $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$r) && a === $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$t) && ($1162c1a406d3f6f8$var$B ? ($1162c1a406d3f6f8$var$E($1162c1a406d3f6f8$var$L), $1162c1a406d3f6f8$var$L = -1) : $1162c1a406d3f6f8$var$B = !0, $1162c1a406d3f6f8$var$K($1162c1a406d3f6f8$var$H, c - d))) : (a.sortIndex = e, $1162c1a406d3f6f8$var$f($1162c1a406d3f6f8$var$r, a), $1162c1a406d3f6f8$var$A || $1162c1a406d3f6f8$var$z || ($1162c1a406d3f6f8$var$A = !0, $1162c1a406d3f6f8$var$I($1162c1a406d3f6f8$var$J)));
    return a;
};
$1162c1a406d3f6f8$export$b5836b71941fa3ed = $1162c1a406d3f6f8$var$M;
$1162c1a406d3f6f8$export$cf845f2c119da08a = function(a) {
    var b = $1162c1a406d3f6f8$var$y;
    return function() {
        var c = $1162c1a406d3f6f8$var$y;
        $1162c1a406d3f6f8$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $1162c1a406d3f6f8$var$y = c;
        }
    };
};

});




parcelRegister("4RND8", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $38b29c2dc0019b47$var$ReactIs, $38b29c2dc0019b47$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("dflA0"))();

});
parcelRegister("dflA0", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $lNqgI = parcelRequire("lNqgI");
function $9a4d6a57aaaab11e$var$emptyFunction() {}
function $9a4d6a57aaaab11e$var$emptyFunctionWithReset() {}
$9a4d6a57aaaab11e$var$emptyFunctionWithReset.resetWarningCache = $9a4d6a57aaaab11e$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $lNqgI) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $9a4d6a57aaaab11e$var$emptyFunctionWithReset,
        resetWarningCache: $9a4d6a57aaaab11e$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("lNqgI", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $fde28cfe61c36500$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $fde28cfe61c36500$var$ReactPropTypesSecret;

});



parcelRegister("dhnve", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $9aaf1809a83fe6d0$export$2b8d127b894957b9, (v) => $9aaf1809a83fe6d0$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $9aaf1809a83fe6d0$export$cea3a54a6425200c, (v) => $9aaf1809a83fe6d0$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $9aaf1809a83fe6d0$export$a7c73072b1a182ae, (v) => $9aaf1809a83fe6d0$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $9aaf1809a83fe6d0$export$9f27bc3417b4524d, (v) => $9aaf1809a83fe6d0$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $9aaf1809a83fe6d0$export$db77ccec0bb4ccac, (v) => $9aaf1809a83fe6d0$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $9aaf1809a83fe6d0$export$8392c0c9d3dcbd35, (v) => $9aaf1809a83fe6d0$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $9aaf1809a83fe6d0$export$ffb0004e005737fa, (v) => $9aaf1809a83fe6d0$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $9aaf1809a83fe6d0$export$b624eff549462981, (v) => $9aaf1809a83fe6d0$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $9aaf1809a83fe6d0$export$7897aa7841a5380c, (v) => $9aaf1809a83fe6d0$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $9aaf1809a83fe6d0$export$602eac185826482c, (v) => $9aaf1809a83fe6d0$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $9aaf1809a83fe6d0$export$e2c29f18771995cb, (v) => $9aaf1809a83fe6d0$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $9aaf1809a83fe6d0$export$5f8d39834fd61797, (v) => $9aaf1809a83fe6d0$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $9aaf1809a83fe6d0$export$74bf444e3cd11ea5, (v) => $9aaf1809a83fe6d0$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $9aaf1809a83fe6d0$export$92387174baf9b227, (v) => $9aaf1809a83fe6d0$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $9aaf1809a83fe6d0$export$ec112efeb987d9c6, (v) => $9aaf1809a83fe6d0$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $9aaf1809a83fe6d0$export$b706b080d889d2c9, (v) => $9aaf1809a83fe6d0$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $9aaf1809a83fe6d0$export$5be5a87408f70ddc, (v) => $9aaf1809a83fe6d0$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $9aaf1809a83fe6d0$export$45a5e7f76e0caa8d, (v) => $9aaf1809a83fe6d0$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $9aaf1809a83fe6d0$export$455c2e768291efa6, (v) => $9aaf1809a83fe6d0$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $9aaf1809a83fe6d0$export$9522e17588c12572, (v) => $9aaf1809a83fe6d0$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $9aaf1809a83fe6d0$export$2110ac352bb060b9, (v) => $9aaf1809a83fe6d0$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $9aaf1809a83fe6d0$export$56885ab8b9c456ab, (v) => $9aaf1809a83fe6d0$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $9aaf1809a83fe6d0$export$d927fcb6adf8f9de, (v) => $9aaf1809a83fe6d0$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $9aaf1809a83fe6d0$export$b82d16f27459e05a, (v) => $9aaf1809a83fe6d0$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $9aaf1809a83fe6d0$export$522c17b4f5e123e8, (v) => $9aaf1809a83fe6d0$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $9aaf1809a83fe6d0$export$1aabd8a0274ecfd6, (v) => $9aaf1809a83fe6d0$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $9aaf1809a83fe6d0$export$9b621391a187a31a, (v) => $9aaf1809a83fe6d0$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $9aaf1809a83fe6d0$export$f5bbd400c2f4426f, (v) => $9aaf1809a83fe6d0$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9aaf1809a83fe6d0$export$2b8d127b894957b9;
var $9aaf1809a83fe6d0$export$cea3a54a6425200c;
var $9aaf1809a83fe6d0$export$a7c73072b1a182ae;
var $9aaf1809a83fe6d0$export$9f27bc3417b4524d;
var $9aaf1809a83fe6d0$export$db77ccec0bb4ccac;
var $9aaf1809a83fe6d0$export$8392c0c9d3dcbd35;
var $9aaf1809a83fe6d0$export$ffb0004e005737fa;
var $9aaf1809a83fe6d0$export$b624eff549462981;
var $9aaf1809a83fe6d0$export$7897aa7841a5380c;
var $9aaf1809a83fe6d0$export$602eac185826482c;
var $9aaf1809a83fe6d0$export$e2c29f18771995cb;
var $9aaf1809a83fe6d0$export$5f8d39834fd61797;
var $9aaf1809a83fe6d0$export$74bf444e3cd11ea5;
var $9aaf1809a83fe6d0$export$92387174baf9b227;
var $9aaf1809a83fe6d0$export$ec112efeb987d9c6;
var $9aaf1809a83fe6d0$export$b706b080d889d2c9;
var $9aaf1809a83fe6d0$export$5be5a87408f70ddc;
var $9aaf1809a83fe6d0$export$45a5e7f76e0caa8d;
var $9aaf1809a83fe6d0$export$455c2e768291efa6;
var $9aaf1809a83fe6d0$export$9522e17588c12572;
var $9aaf1809a83fe6d0$export$2110ac352bb060b9;
var $9aaf1809a83fe6d0$export$56885ab8b9c456ab;
var $9aaf1809a83fe6d0$export$d927fcb6adf8f9de;
var $9aaf1809a83fe6d0$export$b82d16f27459e05a;
var $9aaf1809a83fe6d0$export$522c17b4f5e123e8;
var $9aaf1809a83fe6d0$export$1aabd8a0274ecfd6;
var $9aaf1809a83fe6d0$export$9b621391a187a31a;
var $9aaf1809a83fe6d0$export$f5bbd400c2f4426f;
'use strict';
var $9aaf1809a83fe6d0$var$b = "function" === typeof Symbol && Symbol.for, $9aaf1809a83fe6d0$var$c = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.element") : 60103, $9aaf1809a83fe6d0$var$d = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.portal") : 60106, $9aaf1809a83fe6d0$var$e = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.fragment") : 60107, $9aaf1809a83fe6d0$var$f = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.strict_mode") : 60108, $9aaf1809a83fe6d0$var$g = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.profiler") : 60114, $9aaf1809a83fe6d0$var$h = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.provider") : 60109, $9aaf1809a83fe6d0$var$k = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.context") : 60110, $9aaf1809a83fe6d0$var$l = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.async_mode") : 60111, $9aaf1809a83fe6d0$var$m = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.concurrent_mode") : 60111, $9aaf1809a83fe6d0$var$n = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.forward_ref") : 60112, $9aaf1809a83fe6d0$var$p = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.suspense") : 60113, $9aaf1809a83fe6d0$var$q = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.suspense_list") : 60120, $9aaf1809a83fe6d0$var$r = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.memo") : 60115, $9aaf1809a83fe6d0$var$t = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.lazy") : 60116, $9aaf1809a83fe6d0$var$v = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.block") : 60121, $9aaf1809a83fe6d0$var$w = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.fundamental") : 60117, $9aaf1809a83fe6d0$var$x = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.responder") : 60118, $9aaf1809a83fe6d0$var$y = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.scope") : 60119;
function $9aaf1809a83fe6d0$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $9aaf1809a83fe6d0$var$c:
                switch(a = a.type, a){
                    case $9aaf1809a83fe6d0$var$l:
                    case $9aaf1809a83fe6d0$var$m:
                    case $9aaf1809a83fe6d0$var$e:
                    case $9aaf1809a83fe6d0$var$g:
                    case $9aaf1809a83fe6d0$var$f:
                    case $9aaf1809a83fe6d0$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $9aaf1809a83fe6d0$var$k:
                            case $9aaf1809a83fe6d0$var$n:
                            case $9aaf1809a83fe6d0$var$t:
                            case $9aaf1809a83fe6d0$var$r:
                            case $9aaf1809a83fe6d0$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $9aaf1809a83fe6d0$var$d:
                return u;
        }
    }
}
function $9aaf1809a83fe6d0$var$A(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$m;
}
$9aaf1809a83fe6d0$export$2b8d127b894957b9 = $9aaf1809a83fe6d0$var$l;
$9aaf1809a83fe6d0$export$cea3a54a6425200c = $9aaf1809a83fe6d0$var$m;
$9aaf1809a83fe6d0$export$a7c73072b1a182ae = $9aaf1809a83fe6d0$var$k;
$9aaf1809a83fe6d0$export$9f27bc3417b4524d = $9aaf1809a83fe6d0$var$h;
$9aaf1809a83fe6d0$export$db77ccec0bb4ccac = $9aaf1809a83fe6d0$var$c;
$9aaf1809a83fe6d0$export$8392c0c9d3dcbd35 = $9aaf1809a83fe6d0$var$n;
$9aaf1809a83fe6d0$export$ffb0004e005737fa = $9aaf1809a83fe6d0$var$e;
$9aaf1809a83fe6d0$export$b624eff549462981 = $9aaf1809a83fe6d0$var$t;
$9aaf1809a83fe6d0$export$7897aa7841a5380c = $9aaf1809a83fe6d0$var$r;
$9aaf1809a83fe6d0$export$602eac185826482c = $9aaf1809a83fe6d0$var$d;
$9aaf1809a83fe6d0$export$e2c29f18771995cb = $9aaf1809a83fe6d0$var$g;
$9aaf1809a83fe6d0$export$5f8d39834fd61797 = $9aaf1809a83fe6d0$var$f;
$9aaf1809a83fe6d0$export$74bf444e3cd11ea5 = $9aaf1809a83fe6d0$var$p;
$9aaf1809a83fe6d0$export$92387174baf9b227 = function(a) {
    return $9aaf1809a83fe6d0$var$A(a) || $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$l;
};
$9aaf1809a83fe6d0$export$ec112efeb987d9c6 = $9aaf1809a83fe6d0$var$A;
$9aaf1809a83fe6d0$export$b706b080d889d2c9 = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$k;
};
$9aaf1809a83fe6d0$export$5be5a87408f70ddc = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$h;
};
$9aaf1809a83fe6d0$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $9aaf1809a83fe6d0$var$c;
};
$9aaf1809a83fe6d0$export$455c2e768291efa6 = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$n;
};
$9aaf1809a83fe6d0$export$9522e17588c12572 = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$e;
};
$9aaf1809a83fe6d0$export$2110ac352bb060b9 = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$t;
};
$9aaf1809a83fe6d0$export$56885ab8b9c456ab = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$r;
};
$9aaf1809a83fe6d0$export$d927fcb6adf8f9de = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$d;
};
$9aaf1809a83fe6d0$export$b82d16f27459e05a = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$g;
};
$9aaf1809a83fe6d0$export$522c17b4f5e123e8 = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$f;
};
$9aaf1809a83fe6d0$export$1aabd8a0274ecfd6 = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$p;
};
$9aaf1809a83fe6d0$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $9aaf1809a83fe6d0$var$e || a === $9aaf1809a83fe6d0$var$m || a === $9aaf1809a83fe6d0$var$g || a === $9aaf1809a83fe6d0$var$f || a === $9aaf1809a83fe6d0$var$p || a === $9aaf1809a83fe6d0$var$q || "object" === typeof a && null !== a && (a.$$typeof === $9aaf1809a83fe6d0$var$t || a.$$typeof === $9aaf1809a83fe6d0$var$r || a.$$typeof === $9aaf1809a83fe6d0$var$h || a.$$typeof === $9aaf1809a83fe6d0$var$k || a.$$typeof === $9aaf1809a83fe6d0$var$n || a.$$typeof === $9aaf1809a83fe6d0$var$w || a.$$typeof === $9aaf1809a83fe6d0$var$x || a.$$typeof === $9aaf1809a83fe6d0$var$y || a.$$typeof === $9aaf1809a83fe6d0$var$v);
};
$9aaf1809a83fe6d0$export$f5bbd400c2f4426f = $9aaf1809a83fe6d0$var$z;

});

parcelRegister("1dCkN", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $0e34bdc1602f642d$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
module.exports = $0e34bdc1602f642d$var$invariant;

});

parcelRegister("hCibb", function(module, exports) {
exports = module.exports = stringify;
exports.getSerialize = serializer;
function stringify(obj, replacer, spaces, cycleReplacer) {
    return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces);
}
function serializer(replacer, cycleReplacer) {
    var stack = [], keys = [];
    if (cycleReplacer == null) cycleReplacer = function(key, value) {
        if (stack[0] === value) return "[Circular ~]";
        return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
    };
    return function(key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value)) value = cycleReplacer.call(this, key, value);
        } else stack.push(value);
        return replacer == null ? value : replacer.call(this, key, value);
    };
}

});

parcelRegister("iq75z", function(module, exports) {

$parcel$export(module.exports, "nothing", () => NOTHING);
$parcel$export(module.exports, "immerable", () => DRAFTABLE);
$parcel$export(module.exports, "isDraft", () => isDraft);
$parcel$export(module.exports, "isDraftable", () => isDraftable);
$parcel$export(module.exports, "original", () => original);
$parcel$export(module.exports, "Immer", () => Immer);
$parcel$export(module.exports, "produce", () => produce);
$parcel$export(module.exports, "setAutoFreeze", () => setAutoFreeze);
$parcel$export(module.exports, "setUseProxies", () => setUseProxies);
$parcel$export(module.exports, "applyPatches", () => applyPatches$1);
$parcel$export(module.exports, "default", () => $d690276c18b5c681$export$2e2bcd8739ae039);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var defineProperty = function(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
};
var NOTHING = typeof Symbol !== "undefined" ? Symbol("immer-nothing") : defineProperty({}, "immer-nothing", true);
var DRAFTABLE = typeof Symbol !== "undefined" ? Symbol("immer-draftable") : "__$immer_draftable";
var DRAFT_STATE = typeof Symbol !== "undefined" ? Symbol("immer-state") : "__$immer_state";
function isDraft(value) {
    return !!value && !!value[DRAFT_STATE];
}
function isDraftable(value) {
    if (!value || (typeof value === "undefined" ? "undefined" : _typeof(value)) !== "object") return false;
    if (Array.isArray(value)) return true;
    var proto = Object.getPrototypeOf(value);
    if (!proto || proto === Object.prototype) return true;
    return !!value[DRAFTABLE] || !!value.constructor[DRAFTABLE];
}
function original(value) {
    if (value && value[DRAFT_STATE]) return value[DRAFT_STATE].base;
// otherwise return undefined
}
var assign = Object.assign || function assign(target, value) {
    for(var key in value)if (has(value, key)) target[key] = value[key];
    return target;
};
var ownKeys = typeof Reflect !== "undefined" && Reflect.ownKeys ? Reflect.ownKeys : typeof Object.getOwnPropertySymbols !== "undefined" ? function(obj) {
    return Object.getOwnPropertyNames(obj).concat(Object.getOwnPropertySymbols(obj));
} : Object.getOwnPropertyNames;
function shallowCopy(base) {
    var invokeGetters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (Array.isArray(base)) return base.slice();
    var clone = Object.create(Object.getPrototypeOf(base));
    ownKeys(base).forEach(function(key) {
        if (key === DRAFT_STATE) return; // Never copy over draft state.
        var desc = Object.getOwnPropertyDescriptor(base, key);
        if (desc.get) {
            if (!invokeGetters) throw new Error("Immer drafts cannot have computed properties");
            desc.value = desc.get.call(base);
        }
        if (desc.enumerable) clone[key] = desc.value;
        else Object.defineProperty(clone, key, {
            value: desc.value,
            writable: true,
            configurable: true
        });
    });
    return clone;
}
function each(value, cb) {
    if (Array.isArray(value)) for(var i = 0; i < value.length; i++)cb(i, value[i], value);
    else ownKeys(value).forEach(function(key) {
        return cb(key, value[key], value);
    });
}
function isEnumerable(base, prop) {
    return Object.getOwnPropertyDescriptor(base, prop).enumerable;
}
function has(thing, prop) {
    return Object.prototype.hasOwnProperty.call(thing, prop);
}
function is(x, y) {
    // From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
// @ts-check
var descriptors = {};
// For nested produce calls:
var scopes = [];
var currentScope = function currentScope() {
    return scopes[scopes.length - 1];
};
function willFinalize(result, baseDraft, needPatches) {
    var scope = currentScope();
    scope.forEach(function(state) {
        return state.finalizing = true;
    });
    if (result === undefined || result === baseDraft) {
        if (needPatches) markChangesRecursively(baseDraft);
        // This is faster when we don't care about which attributes changed.
        markChangesSweep(scope);
    }
}
function createDraft(base, parent) {
    var isArray = Array.isArray(base);
    var draft = clonePotentialDraft(base);
    each(draft, function(prop) {
        proxyProperty(draft, prop, isArray || isEnumerable(base, prop));
    });
    // See "proxy.js" for property documentation.
    var state = {
        scope: parent ? parent.scope : currentScope(),
        modified: false,
        finalizing: false,
        finalized: false,
        assigned: {},
        parent: parent,
        base: base,
        draft: draft,
        copy: null,
        revoke: revoke,
        revoked: false // es5 only
    };
    createHiddenProperty(draft, DRAFT_STATE, state);
    state.scope.push(state);
    return draft;
}
function revoke() {
    this.revoked = true;
}
function source(state) {
    return state.copy || state.base;
}
function _get(state, prop) {
    assertUnrevoked(state);
    var value = source(state)[prop];
    // Drafts are only created for proxyable values that exist in the base state.
    if (!state.finalizing && value === state.base[prop] && isDraftable(value)) {
        prepareCopy(state);
        return state.copy[prop] = createDraft(value, state);
    }
    return value;
}
function _set(state, prop, value) {
    assertUnrevoked(state);
    state.assigned[prop] = true;
    if (!state.modified) {
        if (is(source(state)[prop], value)) return;
        markChanged(state);
        prepareCopy(state);
    }
    state.copy[prop] = value;
}
function markChanged(state) {
    if (!state.modified) {
        state.modified = true;
        if (state.parent) markChanged(state.parent);
    }
}
function prepareCopy(state) {
    if (!state.copy) state.copy = clonePotentialDraft(state.base);
}
function clonePotentialDraft(base) {
    var state = base && base[DRAFT_STATE];
    if (state) {
        state.finalizing = true;
        var draft = shallowCopy(state.draft, true);
        state.finalizing = false;
        return draft;
    }
    return shallowCopy(base);
}
function proxyProperty(draft, prop, enumerable) {
    var desc = descriptors[prop];
    if (desc) desc.enumerable = enumerable;
    else descriptors[prop] = desc = {
        configurable: true,
        enumerable: enumerable,
        get: function get$$1() {
            return _get(this[DRAFT_STATE], prop);
        },
        set: function set$$1(value) {
            _set(this[DRAFT_STATE], prop, value);
        }
    };
    Object.defineProperty(draft, prop, desc);
}
function assertUnrevoked(state) {
    if (state.revoked === true) throw new Error("Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + JSON.stringify(source(state)));
}
// This looks expensive, but only proxies are visited, and only objects without known changes are scanned.
function markChangesSweep(scope) {
    // The natural order of drafts in the `scope` array is based on when they
    // were accessed. By processing drafts in reverse natural order, we have a
    // better chance of processing leaf nodes first. When a leaf node is known to
    // have changed, we can avoid any traversal of its ancestor nodes.
    for(var i = scope.length - 1; i >= 0; i--){
        var state = scope[i];
        if (state.modified === false) {
            if (Array.isArray(state.base)) {
                if (hasArrayChanges(state)) markChanged(state);
            } else if (hasObjectChanges(state)) markChanged(state);
        }
    }
}
function markChangesRecursively(object) {
    if (!object || (typeof object === "undefined" ? "undefined" : _typeof(object)) !== "object") return;
    var state = object[DRAFT_STATE];
    if (!state) return;
    var base = state.base, draft = state.draft, assigned = state.assigned;
    if (!Array.isArray(object)) {
        // Look for added keys.
        Object.keys(draft).forEach(function(key) {
            // The `undefined` check is a fast path for pre-existing keys.
            if (base[key] === undefined && !has(base, key)) {
                assigned[key] = true;
                markChanged(state);
            } else if (!assigned[key]) // Only untouched properties trigger recursion.
            markChangesRecursively(draft[key]);
        });
        // Look for removed keys.
        Object.keys(base).forEach(function(key) {
            // The `undefined` check is a fast path for pre-existing keys.
            if (draft[key] === undefined && !has(draft, key)) {
                assigned[key] = false;
                markChanged(state);
            }
        });
    } else if (hasArrayChanges(state)) {
        markChanged(state);
        assigned.length = true;
        if (draft.length < base.length) for(var i = draft.length; i < base.length; i++)assigned[i] = false;
        else for(var _i = base.length; _i < draft.length; _i++)assigned[_i] = true;
        for(var _i2 = 0; _i2 < draft.length; _i2++)// Only untouched indices trigger recursion.
        if (assigned[_i2] === undefined) markChangesRecursively(draft[_i2]);
    }
}
function hasObjectChanges(state) {
    var base = state.base, draft = state.draft;
    // Search for added keys. Start at the back, because non-numeric keys
    // are ordered by time of definition on the object.
    var keys = Object.keys(draft);
    for(var i = keys.length - 1; i >= 0; i--){
        // The `undefined` check is a fast path for pre-existing keys.
        if (base[keys[i]] === undefined && !has(base, keys[i])) return true;
    }
    // Since no keys have been added, we can compare lengths to know if an
    // object has been deleted.
    return keys.length !== Object.keys(base).length;
}
function hasArrayChanges(state) {
    var draft = state.draft;
    if (draft.length !== state.base.length) return true;
    // See #116
    // If we first shorten the length, our array interceptors will be removed.
    // If after that new items are added, result in the same original length,
    // those last items will have no intercepting property.
    // So if there is no own descriptor on the last position, we know that items were removed and added
    // N.B.: splice, unshift, etc only shift values around, but not prop descriptors, so we only have to check
    // the last one
    var descriptor = Object.getOwnPropertyDescriptor(draft, draft.length - 1);
    // descriptor can be null, but only for newly created sparse arrays, eg. new Array(10)
    if (descriptor && !descriptor.get) return true;
    // For all other cases, we don't have to compare, as they would have been picked up by the index setters
    return false;
}
function createHiddenProperty(target, prop, value) {
    Object.defineProperty(target, prop, {
        value: value,
        enumerable: false,
        writable: true
    });
}
var legacyProxy = Object.freeze({
    scopes: scopes,
    currentScope: currentScope,
    willFinalize: willFinalize,
    createDraft: createDraft
});
// @ts-check
// For nested produce calls:
var scopes$1 = [];
var currentScope$1 = function currentScope() {
    return scopes$1[scopes$1.length - 1];
};
// Do nothing before being finalized.
function willFinalize$1() {}
function createDraft$1(base, parent) {
    var state = {
        // Track which produce call this is associated with.
        scope: parent ? parent.scope : currentScope$1(),
        // True for both shallow and deep changes.
        modified: false,
        // Used during finalization.
        finalized: false,
        // Track which properties have been assigned (true) or deleted (false).
        assigned: {},
        // The parent draft state.
        parent: parent,
        // The base state.
        base: base,
        // The base proxy.
        draft: null,
        // Any property proxies.
        drafts: {},
        // The base copy with any updated values.
        copy: null,
        // Called by the `produce` function.
        revoke: null
    };
    var _ref = Array.isArray(base) ? Proxy.revocable([
        state
    ], arrayTraps) : Proxy.revocable(state, objectTraps), revoke = _ref.revoke, proxy = _ref.proxy;
    state.draft = proxy;
    state.revoke = revoke;
    state.scope.push(state);
    return proxy;
}
var objectTraps = {
    get: get$1,
    has: function has$$1(target, prop) {
        return prop in source$1(target);
    },
    ownKeys: function ownKeys$$1(target) {
        return Reflect.ownKeys(source$1(target));
    },
    set: set$1,
    deleteProperty: deleteProperty,
    getOwnPropertyDescriptor: getOwnPropertyDescriptor,
    defineProperty: function defineProperty() {
        throw new Error("Object.defineProperty() cannot be used on an Immer draft"); // prettier-ignore
    },
    getPrototypeOf: function getPrototypeOf(target) {
        return Object.getPrototypeOf(target.base);
    },
    setPrototypeOf: function setPrototypeOf() {
        throw new Error("Object.setPrototypeOf() cannot be used on an Immer draft"); // prettier-ignore
    }
};
var arrayTraps = {};
each(objectTraps, function(key, fn) {
    arrayTraps[key] = function() {
        arguments[0] = arguments[0][0];
        return fn.apply(this, arguments);
    };
});
arrayTraps.deleteProperty = function(state, prop) {
    if (isNaN(parseInt(prop))) throw new Error("Immer only supports deleting array indices"); // prettier-ignore
    return objectTraps.deleteProperty.call(this, state[0], prop);
};
arrayTraps.set = function(state, prop, value) {
    if (prop !== "length" && isNaN(parseInt(prop))) throw new Error("Immer only supports setting array indices and the 'length' property"); // prettier-ignore
    return objectTraps.set.call(this, state[0], prop, value);
};
function source$1(state) {
    return state.copy || state.base;
}
function get$1(state, prop) {
    if (prop === DRAFT_STATE) return state;
    var drafts = state.drafts;
    // Check for existing draft in unmodified state.
    if (!state.modified && has(drafts, prop)) return drafts[prop];
    var value = source$1(state)[prop];
    if (state.finalized || !isDraftable(value)) return value;
    // Check for existing draft in modified state.
    if (state.modified) {
        // Assigned values are never drafted. This catches any drafts we created, too.
        if (value !== state.base[prop]) return value;
        // Store drafts on the copy (when one exists).
        drafts = state.copy;
    }
    return drafts[prop] = createDraft$1(value, state);
}
function set$1(state, prop, value) {
    if (!state.modified) {
        // Optimize based on value's truthiness. Truthy values are guaranteed to
        // never be undefined, so we can avoid the `in` operator. Lastly, truthy
        // values may be drafts, but falsy values are never drafts.
        var isUnchanged = value ? is(state.base[prop], value) || value === state.drafts[prop] : is(state.base[prop], value) && prop in state.base;
        if (isUnchanged) return true;
        markChanged$1(state);
    }
    state.assigned[prop] = true;
    state.copy[prop] = value;
    return true;
}
function deleteProperty(state, prop) {
    // The `undefined` check is a fast path for pre-existing keys.
    if (state.base[prop] !== undefined || prop in state.base) {
        state.assigned[prop] = false;
        markChanged$1(state);
    }
    if (state.copy) delete state.copy[prop];
    return true;
}
function getOwnPropertyDescriptor(state, prop) {
    var owner = source$1(state);
    var desc = Reflect.getOwnPropertyDescriptor(owner, prop);
    if (desc) {
        desc.writable = true;
        desc.configurable = !Array.isArray(owner) || prop !== "length";
    }
    return desc;
}
function markChanged$1(state) {
    if (!state.modified) {
        state.modified = true;
        state.copy = assign(shallowCopy(state.base), state.drafts);
        state.drafts = null;
        if (state.parent) markChanged$1(state.parent);
    }
}
var modernProxy = Object.freeze({
    scopes: scopes$1,
    currentScope: currentScope$1,
    willFinalize: willFinalize$1,
    createDraft: createDraft$1
});
function generatePatches(state, basePath, patches, inversePatches) {
    Array.isArray(state.base) ? generateArrayPatches(state, basePath, patches, inversePatches) : generateObjectPatches(state, basePath, patches, inversePatches);
}
function generateArrayPatches(state, basePath, patches, inversePatches) {
    var base = state.base, copy = state.copy, assigned = state.assigned;
    var minLength = Math.min(base.length, copy.length);
    // Look for replaced indices.
    for(var i = 0; i < minLength; i++)if (assigned[i] && base[i] !== copy[i]) {
        var path = basePath.concat(i);
        patches.push({
            op: "replace",
            path: path,
            value: copy[i]
        });
        inversePatches.push({
            op: "replace",
            path: path,
            value: base[i]
        });
    }
    // Did the array expand?
    if (minLength < copy.length) {
        for(var _i = minLength; _i < copy.length; _i++)patches.push({
            op: "add",
            path: basePath.concat(_i),
            value: copy[_i]
        });
        inversePatches.push({
            op: "replace",
            path: basePath.concat("length"),
            value: base.length
        });
    } else if (minLength < base.length) {
        patches.push({
            op: "replace",
            path: basePath.concat("length"),
            value: copy.length
        });
        for(var _i2 = minLength; _i2 < base.length; _i2++)inversePatches.push({
            op: "add",
            path: basePath.concat(_i2),
            value: base[_i2]
        });
    }
}
function generateObjectPatches(state, basePath, patches, inversePatches) {
    var base = state.base, copy = state.copy;
    each(state.assigned, function(key, assignedValue) {
        var origValue = base[key];
        var value = copy[key];
        var op = !assignedValue ? "remove" : key in base ? "replace" : "add";
        if (origValue === value && op === "replace") return;
        var path = basePath.concat(key);
        patches.push(op === "remove" ? {
            op: op,
            path: path
        } : {
            op: op,
            path: path,
            value: value
        });
        inversePatches.push(op === "add" ? {
            op: "remove",
            path: path
        } : op === "remove" ? {
            op: "add",
            path: path,
            value: origValue
        } : {
            op: "replace",
            path: path,
            value: origValue
        });
    });
}
function applyPatches(draft, patches) {
    for(var i = 0; i < patches.length; i++){
        var patch = patches[i];
        var path = patch.path;
        if (path.length === 0 && patch.op === "replace") draft = patch.value;
        else {
            var base = draft;
            for(var _i3 = 0; _i3 < path.length - 1; _i3++){
                base = base[path[_i3]];
                if (!base || (typeof base === "undefined" ? "undefined" : _typeof(base)) !== "object") throw new Error("Cannot apply patch, path doesn't resolve: " + path.join("/")); // prettier-ignore
            }
            var key = path[path.length - 1];
            switch(patch.op){
                case "replace":
                case "add":
                    // TODO: add support is not extensive, it does not support insertion or `-` atm!
                    base[key] = patch.value;
                    break;
                case "remove":
                    if (Array.isArray(base)) {
                        if (key !== base.length - 1) throw new Error("Only the last index of an array can be removed, index: " + key + ", length: " + base.length); // prettier-ignore
                        base.length -= 1;
                    } else delete base[key];
                    break;
                default:
                    throw new Error("Unsupported patch operation: " + patch.op);
            }
        }
    }
    return draft;
}
function verifyMinified() {}
var configDefaults = {
    useProxies: typeof Proxy !== "undefined" && typeof Reflect !== "undefined",
    autoFreeze: verifyMinified.name === "verifyMinified",
    onAssign: null,
    onDelete: null,
    onCopy: null
};
var Immer = function() {
    function Immer(config) {
        classCallCheck(this, Immer);
        assign(this, configDefaults, config);
        this.setUseProxies(this.useProxies);
        this.produce = this.produce.bind(this);
    }
    createClass(Immer, [
        {
            key: "produce",
            value: function produce(base, recipe, patchListener) {
                var _this = this;
                // curried invocation
                if (typeof base === "function" && typeof recipe !== "function") {
                    var defaultBase = recipe;
                    recipe = base;
                    // prettier-ignore
                    return function() {
                        for(var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                        var base = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultBase;
                        return _this.produce(base, function(draft) {
                            var _recipe;
                            return (_recipe = recipe).call.apply(_recipe, [
                                draft,
                                draft
                            ].concat(args));
                        });
                    };
                }
                if (typeof recipe !== "function") throw new Error("if first argument is not a function, the second argument to produce should be a function");
                if (patchListener !== undefined && typeof patchListener !== "function") throw new Error("the third argument of a producer should not be set or a function");
                var result = void 0;
                // Only create proxies for plain objects/arrays.
                if (!isDraftable(base)) {
                    result = recipe(base);
                    if (result === undefined) return base;
                } else {
                    this.scopes.push([]);
                    var baseDraft = this.createDraft(base);
                    try {
                        result = recipe.call(baseDraft, baseDraft);
                        this.willFinalize(result, baseDraft, !!patchListener);
                        // Never generate patches when no listener exists.
                        var patches = patchListener && [], inversePatches = patchListener && [];
                        // Finalize the modified draft...
                        if (result === undefined || result === baseDraft) result = this.finalize(baseDraft, [], patches, inversePatches);
                        else {
                            // Users must never modify the draft _and_ return something else.
                            if (baseDraft[DRAFT_STATE].modified) throw new Error("An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft."); // prettier-ignore
                            // Finalize the replacement in case it contains (or is) a subset of the draft.
                            if (isDraftable(result)) result = this.finalize(result);
                            if (patchListener) {
                                patches.push({
                                    op: "replace",
                                    path: [],
                                    value: result
                                });
                                inversePatches.push({
                                    op: "replace",
                                    path: [],
                                    value: base
                                });
                            }
                        }
                    } finally{
                        this.currentScope().forEach(function(state) {
                            return state.revoke();
                        });
                        this.scopes.pop();
                    }
                    patchListener && patchListener(patches, inversePatches);
                }
                // Normalize the result.
                return result === NOTHING ? undefined : result;
            }
        },
        {
            key: "setAutoFreeze",
            value: function setAutoFreeze(value) {
                this.autoFreeze = value;
            }
        },
        {
            key: "setUseProxies",
            value: function setUseProxies(value) {
                this.useProxies = value;
                assign(this, value ? modernProxy : legacyProxy);
            }
        },
        {
            key: "applyPatches",
            value: function applyPatches$$1(base, patches) {
                // Mutate the base state when a draft is passed.
                if (isDraft(base)) return applyPatches(base, patches);
                // Otherwise, produce a copy of the base state.
                return this.produce(base, function(draft) {
                    return applyPatches(draft, patches);
                });
            }
        },
        {
            key: "finalize",
            value: function finalize(draft, path, patches, inversePatches) {
                var _this2 = this;
                var state = draft[DRAFT_STATE];
                if (!state) {
                    if (Object.isFrozen(draft)) return draft;
                    return this.finalizeTree(draft);
                }
                // Never finalize drafts owned by an outer scope.
                if (state.scope !== this.currentScope()) return draft;
                if (!state.modified) return state.base;
                if (!state.finalized) {
                    state.finalized = true;
                    this.finalizeTree(state.draft, path, patches, inversePatches);
                    if (this.onDelete) {
                        // The `assigned` object is unreliable with ES5 drafts.
                        if (this.useProxies) {
                            var assigned = state.assigned;
                            for(var prop in assigned)if (!assigned[prop]) this.onDelete(state, prop);
                        } else {
                            var base = state.base, copy = state.copy;
                            each(base, function(prop) {
                                if (!has(copy, prop)) _this2.onDelete(state, prop);
                            });
                        }
                    }
                    if (this.onCopy) this.onCopy(state);
                    // Nested producers must never auto-freeze their result,
                    // because it may contain drafts from parent producers.
                    if (this.autoFreeze && this.scopes.length === 1) Object.freeze(state.copy);
                    if (patches) generatePatches(state, path, patches, inversePatches);
                }
                return state.copy;
            }
        },
        {
            key: "finalizeTree",
            value: function finalizeTree(root, path, patches, inversePatches) {
                var _this3 = this;
                var state = root[DRAFT_STATE];
                if (state) {
                    if (!this.useProxies) {
                        state.finalizing = true;
                        state.copy = shallowCopy(state.draft, true);
                        state.finalizing = false;
                    }
                    root = state.copy;
                }
                var onAssign = this.onAssign;
                var finalizeProperty = function finalizeProperty(prop, value, parent) {
                    if (value === parent) throw Error("Immer forbids circular references");
                    // The only possible draft (in the scope of a `finalizeTree` call) is the `root` object.
                    var inDraft = !!state && parent === root;
                    if (isDraft(value)) {
                        value = // Patches are never generated for assigned properties.
                        patches && inDraft && !state.assigned[prop] ? _this3.finalize(value, path.concat(prop), patches, inversePatches) // prettier-ignore
                         : _this3.finalize(value);
                        // Preserve non-enumerable properties.
                        if (Array.isArray(parent) || isEnumerable(parent, prop)) parent[prop] = value;
                        else Object.defineProperty(parent, prop, {
                            value: value
                        });
                        // Unchanged drafts are never passed to the `onAssign` hook.
                        if (inDraft && value === state.base[prop]) return;
                    } else if (inDraft && is(value, state.base[prop])) return;
                    else if (isDraftable(value) && !Object.isFrozen(value)) each(value, finalizeProperty);
                    if (inDraft && onAssign) onAssign(state, prop, value);
                };
                each(root, finalizeProperty);
                return root;
            }
        }
    ]);
    return Immer;
}();
var immer = new Immer();
/**
 * The `produce` function takes a value and a "recipe function" (whose
 * return value often depends on the base state). The recipe function is
 * free to mutate its first argument however it wants. All mutations are
 * only ever applied to a __copy__ of the base state.
 *
 * Pass only a function to create a "curried producer" which relieves you
 * from passing the recipe function every time.
 *
 * Only plain objects and arrays are made mutable. All other objects are
 * considered uncopyable.
 *
 * Note: This function is __bound__ to its `Immer` instance.
 *
 * @param {any} base - the initial state
 * @param {Function} producer - function that receives a proxy of the base state as first argument and which can be freely modified
 * @param {Function} patchListener - optional function that will be called with all the patches produced here
 * @returns {any} a new state, or the initial state if nothing was modified
 */ var produce = immer.produce;
/**
 * Pass true to automatically freeze all copies created by Immer.
 *
 * By default, auto-freezing is disabled in production.
 */ var setAutoFreeze = immer.setAutoFreeze.bind(immer);
/**
 * Pass true to use the ES2015 `Proxy` class when creating drafts, which is
 * always faster than using ES5 proxies.
 *
 * By default, feature detection is used, so calling this is rarely necessary.
 */ var setUseProxies = immer.setUseProxies.bind(immer);
/**
 * Apply an array of Immer patches to the first argument.
 *
 * This function is a producer, which means copy-on-write is in effect.
 */ var applyPatches$1 = immer.applyPatches.bind(immer);
var $d690276c18b5c681$export$2e2bcd8739ae039 = produce;

});

parcelRegister("4OsZl", function(module, exports) {
(function() {
    var forEach = Array.prototype.forEach;
    /**
   * Converts a roman number to its arabic equivalent.
   *
   * Will throw TypeError on non-string inputs.
   *
   * @param {String} roman
   * @return {Number}
   */ function toArabic(roman) {
        if ('string' !== typeof roman && !(roman instanceof String)) throw new TypeError('toArabic expects a string');
        // Zero is/was a special case. I'll go with Dionysius Exiguus on this one as
        // seen on http://en.wikipedia.org/wiki/Roman_numerals#Zero
        if (/^nulla$/i.test(roman) || !roman.length) return 0;
        // Ultra magical regexp to validate roman numbers!
        roman = roman.toUpperCase().match(/^(M{0,3})(CM|DC{0,3}|CD|C{0,3})(XC|LX{0,3}|XL|X{0,3})(IX|VI{0,3}|IV|I{0,3})$/);
        if (!roman) throw new Error('toArabic expects a valid roman number');
        var arabic = 0;
        // Crunching the thousands...
        arabic += roman[1].length * 1000;
        // Crunching the hundreds...
        if (roman[2] === 'CM') arabic += 900;
        else if (roman[2] === 'CD') arabic += 400;
        else arabic += roman[2].length * 100 + (roman[2][0] === 'D' ? 400 : 0);
        // Crunching the tenths
        if (roman[3] === 'XC') arabic += 90;
        else if (roman[3] === 'XL') arabic += 40;
        else arabic += roman[3].length * 10 + (roman[3][0] === 'L' ? 40 : 0);
        // Crunching the...you see where I'm going, right?
        if (roman[4] === 'IX') arabic += 9;
        else if (roman[4] === 'IV') arabic += 4;
        else arabic += roman[4].length * 1 + (roman[4][0] === 'V' ? 4 : 0);
        return arabic;
    }
    module.exports = toArabic;
})();

});

parcelRegister("84eBh", function(module, exports) {
(function() {
    /**
   * Generate the roman number for the current power of tenth
   *
   * @param {Number} num
   * @param {String} one
   * @param {String} five
   * @param {String} ten
   * @return {String}
   */ function upToTen(num, one, five, ten) {
        var value = '';
        switch(num){
            case 0:
                return value;
            case 9:
                return one + ten;
            case 4:
                return one + five;
        }
        if (num >= 5) value = five, num -= 5;
        while(num-- > 0)value += one;
        return value;
    }
    /**
   * Converts an arabic number from 0 to 3999 to its roman equivalent.
   *
   * Will throw TypeError on non-number inputs (stringed numbers are accepted)
   * or NaN and Error on number under 0 or over 3999.
   *
   * @param {Number/String} arabic
   * @return {String}
   */ function toRoman(arabic) {
        // Checking input first with type comparisons, convert Number() instances to
        // a literal, etc...
        if (arabic instanceof Number) arabic = parseInt(arabic, 10);
        if ('string' === typeof arabic || arabic instanceof String) {
            arabic = parseInt(arabic, 10);
            if (isNaN(arabic)) throw new TypeError('toArabic expects a number');
        }
        if ('number' !== typeof arabic) throw new TypeError('toArabic expects a number');
        // Rounding up "bad" numbers: NaN, negative numbers, numbers over 3999,...
        if (isNaN(arabic)) throw new TypeError('toArabic expects a real number');
        if (arabic < 0) throw new Error('toArabic cannot express negative numbers');
        if (arabic > 3999) throw new Error('toArabic cannot express numbers over 3999');
        // Zero is/was a special case. I'll go with Dionysius Exiguus on this one as
        // seen on http://en.wikipedia.org/wiki/Roman_numerals#Zero
        if (arabic === 0) return 'nulla';
        var roman = '';
        // Chomping away by the power of tenths
        roman += upToTen(Math.floor(arabic / 1000), 'M', '', ''), arabic %= 1000;
        roman += upToTen(Math.floor(arabic / 100), 'C', 'D', 'M'), arabic %= 100;
        roman += upToTen(Math.floor(arabic / 10), 'X', 'L', 'C'), arabic %= 10;
        roman += upToTen(arabic, 'I', 'V', 'X');
        return roman;
    }
    module.exports = toRoman;
})();

});

parcelRegister("5Uvwt", function(module, exports) {
"use strict";
// ref: https://github.com/tc39/proposal-global
var getGlobal = function() {
    // the only reliable means to get the global object is
    // `Function('return this')()`
    // However, this causes CSP violations in Chrome apps.
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    throw new Error('unable to locate global object');
};
var globalObject = getGlobal();
module.exports = exports = globalObject.fetch;
// Needed for TypeScript and Webpack.
if (globalObject.fetch) exports.default = globalObject.fetch.bind(globalObject);
exports.Headers = globalObject.Headers;
exports.Request = globalObject.Request;
exports.Response = globalObject.Response;

});

parcelRegister("2iHVY", function(module, exports) {
module.exports = $1acf5795eaaf5cd2$var$authenticationPlugin;

var $9OSsP = parcelRequire("9OSsP");
var $1acf5795eaaf5cd2$require$createTokenAuth = $9OSsP.createTokenAuth;

var $lG4DW = parcelRequire("lG4DW");
var $1acf5795eaaf5cd2$require$Deprecation = $lG4DW.Deprecation;

var $i1Owb = parcelRequire("i1Owb");

var $9Wl0q = parcelRequire("9Wl0q");

var $dkN7D = parcelRequire("dkN7D");

var $i2X2K = parcelRequire("i2X2K");

var $fT3UG = parcelRequire("fT3UG");
const $1acf5795eaaf5cd2$var$deprecateAuthBasic = $i1Owb((log, deprecation)=>log.warn(deprecation));
const $1acf5795eaaf5cd2$var$deprecateAuthObject = $i1Owb((log, deprecation)=>log.warn(deprecation));
function $1acf5795eaaf5cd2$var$authenticationPlugin(octokit, options) {
    // If `options.authStrategy` is set then use it and pass in `options.auth`
    if (options.authStrategy) {
        const auth = options.authStrategy(options.auth);
        octokit.hook.wrap("request", auth.hook);
        octokit.auth = auth;
        return;
    }
    // If neither `options.authStrategy` nor `options.auth` are set, the `octokit` instance
    // is unauthenticated. The `octokit.auth()` method is a no-op and no request hook is registred.
    if (!options.auth) {
        octokit.auth = ()=>Promise.resolve({
                type: "unauthenticated"
            });
        return;
    }
    const isBasicAuthString = typeof options.auth === "string" && /^basic/.test($fT3UG(options.auth));
    // If only `options.auth` is set to a string, use the default token authentication strategy.
    if (typeof options.auth === "string" && !isBasicAuthString) {
        const auth = $1acf5795eaaf5cd2$require$createTokenAuth(options.auth);
        octokit.hook.wrap("request", auth.hook);
        octokit.auth = auth;
        return;
    }
    // Otherwise log a deprecation message
    const [deprecationMethod, deprecationMessapge] = isBasicAuthString ? [
        $1acf5795eaaf5cd2$var$deprecateAuthBasic,
        'Setting the "new Octokit({ auth })" option to a Basic Auth string is deprecated. Use https://github.com/octokit/auth-basic.js instead. See (https://octokit.github.io/rest.js/#authentication)'
    ] : [
        $1acf5795eaaf5cd2$var$deprecateAuthObject,
        'Setting the "new Octokit({ auth })" option to an object without also setting the "authStrategy" option is deprecated and will be removed in v17. See (https://octokit.github.io/rest.js/#authentication)'
    ];
    deprecationMethod(octokit.log, new $1acf5795eaaf5cd2$require$Deprecation("[@octokit/rest] " + deprecationMessapge));
    octokit.auth = ()=>Promise.resolve({
            type: "deprecated",
            message: deprecationMessapge
        });
    $i2X2K(options.auth);
    const state = {
        octokit: octokit,
        auth: options.auth
    };
    octokit.hook.before("request", $9Wl0q.bind(null, state));
    octokit.hook.error("request", $dkN7D.bind(null, state));
}

});
parcelRegister("9OSsP", function(module, exports) {

$parcel$export(module.exports, "createTokenAuth", () => $726307f80fd1f0c2$export$acf0006d85231cb6);
const $726307f80fd1f0c2$var$REGEX_IS_INSTALLATION_LEGACY = /^v1\./;
const $726307f80fd1f0c2$var$REGEX_IS_INSTALLATION = /^ghs_/;
const $726307f80fd1f0c2$var$REGEX_IS_USER_TO_SERVER = /^ghu_/;
async function $726307f80fd1f0c2$var$auth(token) {
    const isApp = token.split(/\./).length === 3;
    const isInstallation = $726307f80fd1f0c2$var$REGEX_IS_INSTALLATION_LEGACY.test(token) || $726307f80fd1f0c2$var$REGEX_IS_INSTALLATION.test(token);
    const isUserToServer = $726307f80fd1f0c2$var$REGEX_IS_USER_TO_SERVER.test(token);
    const tokenType = isApp ? "app" : isInstallation ? "installation" : isUserToServer ? "user-to-server" : "oauth";
    return {
        type: "token",
        token: token,
        tokenType: tokenType
    };
}
/**
 * Prefix token for usage in the Authorization header
 *
 * @param token OAuth token or JSON Web Token
 */ function $726307f80fd1f0c2$var$withAuthorizationPrefix(token) {
    if (token.split(/\./).length === 3) return `bearer ${token}`;
    return `token ${token}`;
}
async function $726307f80fd1f0c2$var$hook(token, request, route, parameters) {
    const endpoint = request.endpoint.merge(route, parameters);
    endpoint.headers.authorization = $726307f80fd1f0c2$var$withAuthorizationPrefix(token);
    return request(endpoint);
}
const $726307f80fd1f0c2$export$acf0006d85231cb6 = function createTokenAuth(token) {
    if (!token) throw new Error("[@octokit/auth-token] No token passed to createTokenAuth");
    if (typeof token !== "string") throw new Error("[@octokit/auth-token] Token passed to createTokenAuth is not a string");
    token = token.replace(/^(token|bearer) +/i, "");
    return Object.assign($726307f80fd1f0c2$var$auth.bind(null, token), {
        hook: $726307f80fd1f0c2$var$hook.bind(null, token)
    });
};

});

parcelRegister("lG4DW", function(module, exports) {

$parcel$export(module.exports, "Deprecation", () => $fc811f45fe9ff3ed$export$d5e40bdbb672dd52);
class $fc811f45fe9ff3ed$export$d5e40bdbb672dd52 extends Error {
    constructor(message){
        super(message); // Maintains proper stack trace (only available on V8)
        /* istanbul ignore next */ if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
        this.name = 'Deprecation';
    }
}

});

parcelRegister("i1Owb", function(module, exports) {

var $eUIqW = parcelRequire("eUIqW");
module.exports = $eUIqW($036316bd3d945875$var$once);
module.exports.strict = $eUIqW($036316bd3d945875$var$onceStrict);
$036316bd3d945875$var$once.proto = $036316bd3d945875$var$once(function() {
    Object.defineProperty(Function.prototype, 'once', {
        value: function() {
            return $036316bd3d945875$var$once(this);
        },
        configurable: true
    });
    Object.defineProperty(Function.prototype, 'onceStrict', {
        value: function() {
            return $036316bd3d945875$var$onceStrict(this);
        },
        configurable: true
    });
});
function $036316bd3d945875$var$once(fn) {
    var f = function() {
        if (f.called) return f.value;
        f.called = true;
        return f.value = fn.apply(this, arguments);
    };
    f.called = false;
    return f;
}
function $036316bd3d945875$var$onceStrict(fn) {
    var f = function() {
        if (f.called) throw new Error(f.onceError);
        f.called = true;
        return f.value = fn.apply(this, arguments);
    };
    var name = fn.name || 'Function wrapped with `once`';
    f.onceError = name + " shouldn't be called more than once";
    f.called = false;
    return f;
}

});
parcelRegister("eUIqW", function(module, exports) {
// Returns a wrapper function that returns a wrapped callback
// The wrapper function should do some stuff, and return a
// presumably different callback function.
// This makes sure that own properties are retained, so that
// decorations and such are not lost along the way.
module.exports = $adb8c33b91db52cf$var$wrappy;
function $adb8c33b91db52cf$var$wrappy(fn, cb) {
    if (fn && cb) return $adb8c33b91db52cf$var$wrappy(fn)(cb);
    if (typeof fn !== 'function') throw new TypeError('need wrapper function');
    Object.keys(fn).forEach(function(k) {
        wrapper[k] = fn[k];
    });
    return wrapper;
    function wrapper() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        var ret = fn.apply(this, args);
        var cb = args[args.length - 1];
        if (typeof ret === 'function' && ret !== cb) Object.keys(cb).forEach(function(k) {
            ret[k] = cb[k];
        });
        return ret;
    }
}

});


parcelRegister("9Wl0q", function(module, exports) {
module.exports = $73c9d32965f2124d$var$authenticationBeforeRequest;

var $fsahJ = parcelRequire("fsahJ");

var $fT3UG = parcelRequire("fT3UG");
function $73c9d32965f2124d$var$authenticationBeforeRequest(state, options) {
    if (typeof state.auth === "string") {
        options.headers.authorization = $fT3UG(state.auth);
        return;
    }
    if (state.auth.username) {
        const hash = $fsahJ(`${state.auth.username}:${state.auth.password}`);
        options.headers.authorization = `Basic ${hash}`;
        if (state.otp) options.headers["x-github-otp"] = state.otp;
        return;
    }
    if (state.auth.clientId) {
        // There is a special case for OAuth applications, when `clientId` and `clientSecret` is passed as
        // Basic Authorization instead of query parameters. The only routes where that applies share the same
        // URL though: `/applications/:client_id/tokens/:access_token`.
        //
        //  1. [Check an authorization](https://developer.github.com/v3/oauth_authorizations/#check-an-authorization)
        //  2. [Reset an authorization](https://developer.github.com/v3/oauth_authorizations/#reset-an-authorization)
        //  3. [Revoke an authorization for an application](https://developer.github.com/v3/oauth_authorizations/#revoke-an-authorization-for-an-application)
        //
        // We identify by checking the URL. It must merge both "/applications/:client_id/tokens/:access_token"
        // as well as "/applications/123/tokens/token456"
        if (/\/applications\/:?[\w_]+\/tokens\/:?[\w_]+($|\?)/.test(options.url)) {
            const hash = $fsahJ(`${state.auth.clientId}:${state.auth.clientSecret}`);
            options.headers.authorization = `Basic ${hash}`;
            return;
        }
        options.url += options.url.indexOf("?") === -1 ? "?" : "&";
        options.url += `client_id=${state.auth.clientId}&client_secret=${state.auth.clientSecret}`;
        return;
    }
    return Promise.resolve().then(()=>{
        return state.auth();
    }).then((authorization)=>{
        options.headers.authorization = $fT3UG(authorization);
    });
}

});
parcelRegister("fsahJ", function(module, exports) {
module.exports = function _btoa(str) {
    return btoa(str);
};

});

parcelRegister("fT3UG", function(module, exports) {
module.exports = $b90f0726d7d97f4b$var$withAuthorizationPrefix;

var $g5zp5 = parcelRequire("g5zp5");
const $b90f0726d7d97f4b$var$REGEX_IS_BASIC_AUTH = /^[\w-]+:/;
function $b90f0726d7d97f4b$var$withAuthorizationPrefix(authorization) {
    if (/^(basic|bearer|token) /i.test(authorization)) return authorization;
    try {
        if ($b90f0726d7d97f4b$var$REGEX_IS_BASIC_AUTH.test($g5zp5(authorization))) return `basic ${authorization}`;
    } catch (error) {}
    if (authorization.split(/\./).length === 3) return `bearer ${authorization}`;
    return `token ${authorization}`;
}

});
parcelRegister("g5zp5", function(module, exports) {
module.exports = function _atob(str) {
    return atob(str);
};

});



parcelRegister("dkN7D", function(module, exports) {
module.exports = $9b533f4771698198$var$authenticationRequestError;

var $aZ0zi = parcelRequire("aZ0zi");
var $9b533f4771698198$require$RequestError = $aZ0zi.RequestError;
function $9b533f4771698198$var$authenticationRequestError(state, error, options) {
    if (!error.headers) throw error;
    const otpRequired = /required/.test(error.headers["x-github-otp"] || "");
    // handle "2FA required" error only
    if (error.status !== 401 || !otpRequired) throw error;
    if (error.status === 401 && otpRequired && error.request && error.request.headers["x-github-otp"]) {
        if (state.otp) delete state.otp; // no longer valid, request again
        else throw new $9b533f4771698198$require$RequestError("Invalid one-time password for two-factor authentication", 401, {
            headers: error.headers,
            request: options
        });
    }
    if (typeof state.auth.on2fa !== "function") throw new $9b533f4771698198$require$RequestError("2FA required, but options.on2fa is not a function. See https://github.com/octokit/rest.js#authentication", 401, {
        headers: error.headers,
        request: options
    });
    return Promise.resolve().then(()=>{
        return state.auth.on2fa();
    }).then((oneTimePassword)=>{
        const newOptions = Object.assign(options, {
            headers: Object.assign(options.headers, {
                "x-github-otp": oneTimePassword
            })
        });
        return state.octokit.request(newOptions).then((response)=>{
            // If OTP still valid, then persist it for following requests
            state.otp = oneTimePassword;
            return response;
        });
    });
}

});
parcelRegister("aZ0zi", function(module, exports) {

$parcel$export(module.exports, "RequestError", () => $7ff00ac377cb3e3e$export$43ee7d0e4f429743);

var $lG4DW = parcelRequire("lG4DW");

var $i1Owb = parcelRequire("i1Owb");
const $7ff00ac377cb3e3e$var$logOnce = (0, (/*@__PURE__*/$parcel$interopDefault($i1Owb)))((deprecation)=>console.warn(deprecation));
/**
 * Error with extra properties to help with debugging
 */ class $7ff00ac377cb3e3e$export$43ee7d0e4f429743 extends Error {
    constructor(message, statusCode, options){
        super(message);
        // Maintains proper stack trace (only available on V8)
        /* istanbul ignore next */ if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
        this.name = "HttpError";
        this.status = statusCode;
        Object.defineProperty(this, "code", {
            get () {
                $7ff00ac377cb3e3e$var$logOnce(new (0, $lG4DW.Deprecation)("[@octokit/request-error] `error.code` is deprecated, use `error.status`."));
                return statusCode;
            }
        });
        this.headers = options.headers || {};
        // redact request credentials without mutating original request options
        const requestCopy = Object.assign({}, options.request);
        if (options.request.headers.authorization) requestCopy.headers = Object.assign({}, options.request.headers, {
            authorization: options.request.headers.authorization.replace(/ .*$/, " [REDACTED]")
        });
        requestCopy.url = requestCopy.url// client_id & client_secret can be passed as URL query parameters to increase rate limit
        // see https://developer.github.com/v3/#increasing-the-unauthenticated-rate-limit-for-oauth-applications
        .replace(/\bclient_secret=\w+/g, "client_secret=[REDACTED]")// OAuth tokens can be passed as URL query parameters, although it is not recommended
        // see https://developer.github.com/v3/#oauth2-token-sent-in-a-header
        .replace(/\baccess_token=\w+/g, "access_token=[REDACTED]");
        this.request = requestCopy;
    }
}

});


parcelRegister("i2X2K", function(module, exports) {
module.exports = $d23636aed3e63df2$var$validateAuth;
function $d23636aed3e63df2$var$validateAuth(auth) {
    if (typeof auth === "string") return;
    if (typeof auth === "function") return;
    if (auth.username && auth.password) return;
    if (auth.clientId && auth.clientSecret) return;
    throw new Error(`Invalid "auth" option: ${JSON.stringify(auth)}`);
}

});


parcelRegister("9h37l", function(module, exports) {
module.exports = $01be1102b648ae16$var$authenticationPlugin;

var $lG4DW = parcelRequire("lG4DW");
var $01be1102b648ae16$require$Deprecation = $lG4DW.Deprecation;

var $i1Owb = parcelRequire("i1Owb");
const $01be1102b648ae16$var$deprecateAuthenticate = $i1Owb((log, deprecation)=>log.warn(deprecation));

var $4BH28 = parcelRequire("4BH28");

var $4SwNX = parcelRequire("4SwNX");

var $bnYmE = parcelRequire("bnYmE");
function $01be1102b648ae16$var$authenticationPlugin(octokit, options) {
    if (options.auth) {
        octokit.authenticate = ()=>{
            $01be1102b648ae16$var$deprecateAuthenticate(octokit.log, new $01be1102b648ae16$require$Deprecation('[@octokit/rest] octokit.authenticate() is deprecated and has no effect when "auth" option is set on Octokit constructor'));
        };
        return;
    }
    const state = {
        octokit: octokit,
        auth: false
    };
    octokit.authenticate = $4BH28.bind(null, state);
    octokit.hook.before("request", $4SwNX.bind(null, state));
    octokit.hook.error("request", $bnYmE.bind(null, state));
}

});
parcelRegister("4BH28", function(module, exports) {
module.exports = $35abffb0551d3562$var$authenticate;

var $lG4DW = parcelRequire("lG4DW");
var $35abffb0551d3562$require$Deprecation = $lG4DW.Deprecation;

var $i1Owb = parcelRequire("i1Owb");
const $35abffb0551d3562$var$deprecateAuthenticate = $i1Owb((log, deprecation)=>log.warn(deprecation));
function $35abffb0551d3562$var$authenticate(state, options) {
    $35abffb0551d3562$var$deprecateAuthenticate(state.octokit.log, new $35abffb0551d3562$require$Deprecation('[@octokit/rest] octokit.authenticate() is deprecated. Use "auth" constructor option instead.'));
    if (!options) {
        state.auth = false;
        return;
    }
    switch(options.type){
        case "basic":
            if (!options.username || !options.password) throw new Error("Basic authentication requires both a username and password to be set");
            break;
        case "oauth":
            if (!options.token && !(options.key && options.secret)) throw new Error("OAuth2 authentication requires a token or key & secret to be set");
            break;
        case "token":
        case "app":
            if (!options.token) throw new Error("Token authentication requires a token to be set");
            break;
        default:
            throw new Error("Invalid authentication type, must be 'basic', 'oauth', 'token' or 'app'");
    }
    state.auth = options;
}

});

parcelRegister("4SwNX", function(module, exports) {
module.exports = $38d5a6ebb5be550b$var$authenticationBeforeRequest;

var $fsahJ = parcelRequire("fsahJ");

var $jD1Mn = parcelRequire("jD1Mn");
function $38d5a6ebb5be550b$var$authenticationBeforeRequest(state, options) {
    if (!state.auth.type) return;
    if (state.auth.type === "basic") {
        const hash = $fsahJ(`${state.auth.username}:${state.auth.password}`);
        options.headers.authorization = `Basic ${hash}`;
        return;
    }
    if (state.auth.type === "token") {
        options.headers.authorization = `token ${state.auth.token}`;
        return;
    }
    if (state.auth.type === "app") {
        options.headers.authorization = `Bearer ${state.auth.token}`;
        const acceptHeaders = options.headers.accept.split(",").concat("application/vnd.github.machine-man-preview+json");
        options.headers.accept = $jD1Mn(acceptHeaders).filter(Boolean).join(",");
        return;
    }
    options.url += options.url.indexOf("?") === -1 ? "?" : "&";
    if (state.auth.token) {
        options.url += `access_token=${encodeURIComponent(state.auth.token)}`;
        return;
    }
    const key = encodeURIComponent(state.auth.key);
    const secret = encodeURIComponent(state.auth.secret);
    options.url += `client_id=${key}&client_secret=${secret}`;
}

});
parcelRegister("jD1Mn", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var $e4a30a24e70b73cf$var$LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var $e4a30a24e70b73cf$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used as references for various `Number` constants. */ var $e4a30a24e70b73cf$var$INFINITY = 1 / 0;
/** `Object#toString` result references. */ var $e4a30a24e70b73cf$var$funcTag = '[object Function]', $e4a30a24e70b73cf$var$genTag = '[object GeneratorFunction]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $e4a30a24e70b73cf$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $e4a30a24e70b73cf$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Detect free variable `global` from Node.js. */ var $e4a30a24e70b73cf$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $e4a30a24e70b73cf$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $e4a30a24e70b73cf$var$root = $e4a30a24e70b73cf$var$freeGlobal || $e4a30a24e70b73cf$var$freeSelf || Function('return this')();
/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $e4a30a24e70b73cf$var$arrayIncludes(array, value) {
    var length = array ? array.length : 0;
    return !!length && $e4a30a24e70b73cf$var$baseIndexOf(array, value, 0) > -1;
}
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $e4a30a24e70b73cf$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $e4a30a24e70b73cf$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $e4a30a24e70b73cf$var$baseIndexOf(array, value, fromIndex) {
    if (value !== value) return $e4a30a24e70b73cf$var$baseFindIndex(array, $e4a30a24e70b73cf$var$baseIsNaN, fromIndex);
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $e4a30a24e70b73cf$var$baseIsNaN(value) {
    return value !== value;
}
/**
 * Checks if a cache value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e4a30a24e70b73cf$var$cacheHas(cache, key) {
    return cache.has(key);
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $e4a30a24e70b73cf$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function $e4a30a24e70b73cf$var$isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != 'function') try {
        result = !!(value + '');
    } catch (e) {}
    return result;
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $e4a30a24e70b73cf$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var $e4a30a24e70b73cf$var$arrayProto = Array.prototype, $e4a30a24e70b73cf$var$funcProto = Function.prototype, $e4a30a24e70b73cf$var$objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var $e4a30a24e70b73cf$var$coreJsData = $e4a30a24e70b73cf$var$root['__core-js_shared__'];
/** Used to detect methods masquerading as native. */ var $e4a30a24e70b73cf$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($e4a30a24e70b73cf$var$coreJsData && $e4a30a24e70b73cf$var$coreJsData.keys && $e4a30a24e70b73cf$var$coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/** Used to resolve the decompiled source of functions. */ var $e4a30a24e70b73cf$var$funcToString = $e4a30a24e70b73cf$var$funcProto.toString;
/** Used to check objects for own properties. */ var $e4a30a24e70b73cf$var$hasOwnProperty = $e4a30a24e70b73cf$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $e4a30a24e70b73cf$var$objectToString = $e4a30a24e70b73cf$var$objectProto.toString;
/** Used to detect if a method is native. */ var $e4a30a24e70b73cf$var$reIsNative = RegExp('^' + $e4a30a24e70b73cf$var$funcToString.call($e4a30a24e70b73cf$var$hasOwnProperty).replace($e4a30a24e70b73cf$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var $e4a30a24e70b73cf$var$splice = $e4a30a24e70b73cf$var$arrayProto.splice;
/* Built-in method references that are verified to be native. */ var $e4a30a24e70b73cf$var$Map = $e4a30a24e70b73cf$var$getNative($e4a30a24e70b73cf$var$root, 'Map'), $e4a30a24e70b73cf$var$Set = $e4a30a24e70b73cf$var$getNative($e4a30a24e70b73cf$var$root, 'Set'), $e4a30a24e70b73cf$var$nativeCreate = $e4a30a24e70b73cf$var$getNative(Object, 'create');
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $e4a30a24e70b73cf$var$Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $e4a30a24e70b73cf$var$hashClear() {
    this.__data__ = $e4a30a24e70b73cf$var$nativeCreate ? $e4a30a24e70b73cf$var$nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $e4a30a24e70b73cf$var$hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $e4a30a24e70b73cf$var$hashGet(key) {
    var data = this.__data__;
    if ($e4a30a24e70b73cf$var$nativeCreate) {
        var result = data[key];
        return result === $e4a30a24e70b73cf$var$HASH_UNDEFINED ? undefined : result;
    }
    return $e4a30a24e70b73cf$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e4a30a24e70b73cf$var$hashHas(key) {
    var data = this.__data__;
    return $e4a30a24e70b73cf$var$nativeCreate ? data[key] !== undefined : $e4a30a24e70b73cf$var$hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $e4a30a24e70b73cf$var$hashSet(key, value) {
    var data = this.__data__;
    data[key] = $e4a30a24e70b73cf$var$nativeCreate && value === undefined ? $e4a30a24e70b73cf$var$HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
$e4a30a24e70b73cf$var$Hash.prototype.clear = $e4a30a24e70b73cf$var$hashClear;
$e4a30a24e70b73cf$var$Hash.prototype['delete'] = $e4a30a24e70b73cf$var$hashDelete;
$e4a30a24e70b73cf$var$Hash.prototype.get = $e4a30a24e70b73cf$var$hashGet;
$e4a30a24e70b73cf$var$Hash.prototype.has = $e4a30a24e70b73cf$var$hashHas;
$e4a30a24e70b73cf$var$Hash.prototype.set = $e4a30a24e70b73cf$var$hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $e4a30a24e70b73cf$var$ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $e4a30a24e70b73cf$var$listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $e4a30a24e70b73cf$var$listCacheDelete(key) {
    var data = this.__data__, index = $e4a30a24e70b73cf$var$assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $e4a30a24e70b73cf$var$splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $e4a30a24e70b73cf$var$listCacheGet(key) {
    var data = this.__data__, index = $e4a30a24e70b73cf$var$assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e4a30a24e70b73cf$var$listCacheHas(key) {
    return $e4a30a24e70b73cf$var$assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $e4a30a24e70b73cf$var$listCacheSet(key, value) {
    var data = this.__data__, index = $e4a30a24e70b73cf$var$assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
$e4a30a24e70b73cf$var$ListCache.prototype.clear = $e4a30a24e70b73cf$var$listCacheClear;
$e4a30a24e70b73cf$var$ListCache.prototype['delete'] = $e4a30a24e70b73cf$var$listCacheDelete;
$e4a30a24e70b73cf$var$ListCache.prototype.get = $e4a30a24e70b73cf$var$listCacheGet;
$e4a30a24e70b73cf$var$ListCache.prototype.has = $e4a30a24e70b73cf$var$listCacheHas;
$e4a30a24e70b73cf$var$ListCache.prototype.set = $e4a30a24e70b73cf$var$listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $e4a30a24e70b73cf$var$MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $e4a30a24e70b73cf$var$mapCacheClear() {
    this.__data__ = {
        'hash': new $e4a30a24e70b73cf$var$Hash,
        'map': new ($e4a30a24e70b73cf$var$Map || $e4a30a24e70b73cf$var$ListCache),
        'string': new $e4a30a24e70b73cf$var$Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $e4a30a24e70b73cf$var$mapCacheDelete(key) {
    return $e4a30a24e70b73cf$var$getMapData(this, key)['delete'](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $e4a30a24e70b73cf$var$mapCacheGet(key) {
    return $e4a30a24e70b73cf$var$getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e4a30a24e70b73cf$var$mapCacheHas(key) {
    return $e4a30a24e70b73cf$var$getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $e4a30a24e70b73cf$var$mapCacheSet(key, value) {
    $e4a30a24e70b73cf$var$getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
$e4a30a24e70b73cf$var$MapCache.prototype.clear = $e4a30a24e70b73cf$var$mapCacheClear;
$e4a30a24e70b73cf$var$MapCache.prototype['delete'] = $e4a30a24e70b73cf$var$mapCacheDelete;
$e4a30a24e70b73cf$var$MapCache.prototype.get = $e4a30a24e70b73cf$var$mapCacheGet;
$e4a30a24e70b73cf$var$MapCache.prototype.has = $e4a30a24e70b73cf$var$mapCacheHas;
$e4a30a24e70b73cf$var$MapCache.prototype.set = $e4a30a24e70b73cf$var$mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $e4a30a24e70b73cf$var$SetCache(values) {
    var index = -1, length = values ? values.length : 0;
    this.__data__ = new $e4a30a24e70b73cf$var$MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $e4a30a24e70b73cf$var$setCacheAdd(value) {
    this.__data__.set(value, $e4a30a24e70b73cf$var$HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $e4a30a24e70b73cf$var$setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
$e4a30a24e70b73cf$var$SetCache.prototype.add = $e4a30a24e70b73cf$var$SetCache.prototype.push = $e4a30a24e70b73cf$var$setCacheAdd;
$e4a30a24e70b73cf$var$SetCache.prototype.has = $e4a30a24e70b73cf$var$setCacheHas;
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $e4a30a24e70b73cf$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($e4a30a24e70b73cf$var$eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $e4a30a24e70b73cf$var$baseIsNative(value) {
    if (!$e4a30a24e70b73cf$var$isObject(value) || $e4a30a24e70b73cf$var$isMasked(value)) return false;
    var pattern = $e4a30a24e70b73cf$var$isFunction(value) || $e4a30a24e70b73cf$var$isHostObject(value) ? $e4a30a24e70b73cf$var$reIsNative : $e4a30a24e70b73cf$var$reIsHostCtor;
    return pattern.test($e4a30a24e70b73cf$var$toSource(value));
}
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $e4a30a24e70b73cf$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $e4a30a24e70b73cf$var$arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $e4a30a24e70b73cf$var$arrayIncludesWith;
    } else if (length >= $e4a30a24e70b73cf$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $e4a30a24e70b73cf$var$createSet(array);
        if (set) return $e4a30a24e70b73cf$var$setToArray(set);
        isCommon = false;
        includes = $e4a30a24e70b73cf$var$cacheHas;
        seen = new $e4a30a24e70b73cf$var$SetCache;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $e4a30a24e70b73cf$var$createSet = !($e4a30a24e70b73cf$var$Set && 1 / $e4a30a24e70b73cf$var$setToArray(new $e4a30a24e70b73cf$var$Set([
    ,
    -0
]))[1] == $e4a30a24e70b73cf$var$INFINITY) ? $e4a30a24e70b73cf$var$noop : function(values) {
    return new $e4a30a24e70b73cf$var$Set(values);
};
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $e4a30a24e70b73cf$var$getMapData(map, key) {
    var data = map.__data__;
    return $e4a30a24e70b73cf$var$isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $e4a30a24e70b73cf$var$getNative(object, key) {
    var value = $e4a30a24e70b73cf$var$getValue(object, key);
    return $e4a30a24e70b73cf$var$baseIsNative(value) ? value : undefined;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $e4a30a24e70b73cf$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $e4a30a24e70b73cf$var$isMasked(func) {
    return !!$e4a30a24e70b73cf$var$maskSrcKey && $e4a30a24e70b73cf$var$maskSrcKey in func;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function $e4a30a24e70b73cf$var$toSource(func) {
    if (func != null) {
        try {
            return $e4a30a24e70b73cf$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each
 * element is kept.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */ function $e4a30a24e70b73cf$var$uniq(array) {
    return array && array.length ? $e4a30a24e70b73cf$var$baseUniq(array) : [];
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $e4a30a24e70b73cf$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $e4a30a24e70b73cf$var$isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = $e4a30a24e70b73cf$var$isObject(value) ? $e4a30a24e70b73cf$var$objectToString.call(value) : '';
    return tag == $e4a30a24e70b73cf$var$funcTag || tag == $e4a30a24e70b73cf$var$genTag;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $e4a30a24e70b73cf$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $e4a30a24e70b73cf$var$noop() {
// No operation performed.
}
module.exports = $e4a30a24e70b73cf$var$uniq;

});


parcelRegister("bnYmE", function(module, exports) {
module.exports = $84a0aaceaa0e761c$var$authenticationRequestError;

var $aZ0zi = parcelRequire("aZ0zi");
var $84a0aaceaa0e761c$require$RequestError = $aZ0zi.RequestError;
function $84a0aaceaa0e761c$var$authenticationRequestError(state, error, options) {
    /* istanbul ignore next */ if (!error.headers) throw error;
    const otpRequired = /required/.test(error.headers["x-github-otp"] || "");
    // handle "2FA required" error only
    if (error.status !== 401 || !otpRequired) throw error;
    if (error.status === 401 && otpRequired && error.request && error.request.headers["x-github-otp"]) throw new $84a0aaceaa0e761c$require$RequestError("Invalid one-time password for two-factor authentication", 401, {
        headers: error.headers,
        request: options
    });
    if (typeof state.auth.on2fa !== "function") throw new $84a0aaceaa0e761c$require$RequestError("2FA required, but options.on2fa is not a function. See https://github.com/octokit/rest.js#authentication", 401, {
        headers: error.headers,
        request: options
    });
    return Promise.resolve().then(()=>{
        return state.auth.on2fa();
    }).then((oneTimePassword)=>{
        const newOptions = Object.assign(options, {
            headers: Object.assign({
                "x-github-otp": oneTimePassword
            }, options.headers)
        });
        return state.octokit.request(newOptions);
    });
}

});


parcelRegister("5RX7O", function(module, exports) {
module.exports = $445fc3fc68ee9a77$var$paginatePlugin;

var $iBJBn = parcelRequire("iBJBn");
var $445fc3fc68ee9a77$require$paginateRest = $iBJBn.paginateRest;
function $445fc3fc68ee9a77$var$paginatePlugin(octokit) {
    Object.assign(octokit, $445fc3fc68ee9a77$require$paginateRest(octokit));
}

});
parcelRegister("iBJBn", function(module, exports) {

$parcel$export(module.exports, "paginateRest", () => $d8bf0e4bce919cc8$export$d8def7ab7602fc50);
const $d8bf0e4bce919cc8$var$VERSION = "1.1.2";
/**
 * Some “list” response that can be paginated have a different response structure
 *
 * They have a `total_count` key in the response (search also has `incomplete_results`,
 * /installation/repositories also has `repository_selection`), as well as a key with
 * the list of the items which name varies from endpoint to endpoint:
 *
 * - https://developer.github.com/v3/search/#example (key `items`)
 * - https://developer.github.com/v3/checks/runs/#response-3 (key: `check_runs`)
 * - https://developer.github.com/v3/checks/suites/#response-1 (key: `check_suites`)
 * - https://developer.github.com/v3/apps/installations/#list-repositories (key: `repositories`)
 * - https://developer.github.com/v3/apps/installations/#list-installations-for-a-user (key `installations`)
 *
 * Octokit normalizes these responses so that paginated results are always returned following
 * the same structure. One challenge is that if the list response has only one page, no Link
 * header is provided, so this header alone is not sufficient to check wether a response is
 * paginated or not. For the exceptions with the namespace, a fallback check for the route
 * paths has to be added in order to normalize the response. We cannot check for the total_count
 * property because it also exists in the response of Get the combined status for a specific ref.
 */ const $d8bf0e4bce919cc8$var$REGEX = [
    /^\/search\//,
    /^\/repos\/[^/]+\/[^/]+\/commits\/[^/]+\/(check-runs|check-suites)([^/]|$)/,
    /^\/installation\/repositories([^/]|$)/,
    /^\/user\/installations([^/]|$)/,
    /^\/repos\/[^/]+\/[^/]+\/actions\/secrets([^/]|$)/,
    /^\/repos\/[^/]+\/[^/]+\/actions\/workflows(\/[^/]+\/runs)?([^/]|$)/,
    /^\/repos\/[^/]+\/[^/]+\/actions\/runs(\/[^/]+\/(artifacts|jobs))?([^/]|$)/
];
function $d8bf0e4bce919cc8$var$normalizePaginatedListResponse(octokit, url, response) {
    const path = url.replace(octokit.request.endpoint.DEFAULTS.baseUrl, "");
    const responseNeedsNormalization = $d8bf0e4bce919cc8$var$REGEX.find((regex)=>regex.test(path));
    if (!responseNeedsNormalization) return;
    // keep the additional properties intact as there is currently no other way
    // to retrieve the same information.
    const incompleteResults = response.data.incomplete_results;
    const repositorySelection = response.data.repository_selection;
    const totalCount = response.data.total_count;
    delete response.data.incomplete_results;
    delete response.data.repository_selection;
    delete response.data.total_count;
    const namespaceKey = Object.keys(response.data)[0];
    const data = response.data[namespaceKey];
    response.data = data;
    if (typeof incompleteResults !== "undefined") response.data.incomplete_results = incompleteResults;
    if (typeof repositorySelection !== "undefined") response.data.repository_selection = repositorySelection;
    response.data.total_count = totalCount;
    Object.defineProperty(response.data, namespaceKey, {
        get () {
            octokit.log.warn(`[@octokit/paginate-rest] "response.data.${namespaceKey}" is deprecated for "GET ${path}". Get the results directly from "response.data"`);
            return Array.from(data);
        }
    });
}
function $d8bf0e4bce919cc8$var$iterator(octokit, route, parameters) {
    const options = octokit.request.endpoint(route, parameters);
    const method = options.method;
    const headers = options.headers;
    let url = options.url;
    return {
        [Symbol.asyncIterator]: ()=>({
                next () {
                    if (!url) return Promise.resolve({
                        done: true
                    });
                    return octokit.request({
                        method: method,
                        url: url,
                        headers: headers
                    }).then((response)=>{
                        $d8bf0e4bce919cc8$var$normalizePaginatedListResponse(octokit, url, response);
                        // `response.headers.link` format:
                        // '<https://api.github.com/users/aseemk/followers?page=2>; rel="next", <https://api.github.com/users/aseemk/followers?page=2>; rel="last"'
                        // sets `url` to undefined if "next" URL is not present or `link` header is not set
                        url = ((response.headers.link || "").match(/<([^>]+)>;\s*rel="next"/) || [])[1];
                        return {
                            value: response
                        };
                    });
                }
            })
    };
}
function $d8bf0e4bce919cc8$var$paginate(octokit, route, parameters, mapFn) {
    if (typeof parameters === "function") {
        mapFn = parameters;
        parameters = undefined;
    }
    return $d8bf0e4bce919cc8$var$gather(octokit, [], $d8bf0e4bce919cc8$var$iterator(octokit, route, parameters)[Symbol.asyncIterator](), mapFn);
}
function $d8bf0e4bce919cc8$var$gather(octokit, results, iterator, mapFn) {
    return iterator.next().then((result)=>{
        if (result.done) return results;
        let earlyExit = false;
        function done() {
            earlyExit = true;
        }
        results = results.concat(mapFn ? mapFn(result.value, done) : result.value.data);
        if (earlyExit) return results;
        return $d8bf0e4bce919cc8$var$gather(octokit, results, iterator, mapFn);
    });
}
/**
 * @param octokit Octokit instance
 * @param options Options passed to Octokit constructor
 */ function $d8bf0e4bce919cc8$export$d8def7ab7602fc50(octokit) {
    return {
        paginate: Object.assign($d8bf0e4bce919cc8$var$paginate.bind(null, octokit), {
            iterator: $d8bf0e4bce919cc8$var$iterator.bind(null, octokit)
        })
    };
}
$d8bf0e4bce919cc8$export$d8def7ab7602fc50.VERSION = $d8bf0e4bce919cc8$var$VERSION;

});


parcelRegister("3asPy", function(module, exports) {
module.exports = $24e8ab6d44dcd9f3$var$octokitValidate;

var $92CLy = parcelRequire("92CLy");
function $24e8ab6d44dcd9f3$var$octokitValidate(octokit) {
    octokit.hook.before("request", $92CLy.bind(null, octokit));
}

});
parcelRegister("92CLy", function(module, exports) {
"use strict";
module.exports = $69525f19a091d919$var$validate;

var $aZ0zi = parcelRequire("aZ0zi");
var $69525f19a091d919$require$RequestError = $aZ0zi.RequestError;

var $j0yhs = parcelRequire("j0yhs");

var $9CSLD = parcelRequire("9CSLD");
function $69525f19a091d919$var$validate(octokit, options) {
    if (!options.request.validate) return;
    const { validate: params } = options.request;
    Object.keys(params).forEach((parameterName)=>{
        const parameter = $j0yhs(params, parameterName);
        const expectedType = parameter.type;
        let parentParameterName;
        let parentValue;
        let parentParamIsPresent = true;
        let parentParameterIsArray = false;
        if (/\./.test(parameterName)) {
            parentParameterName = parameterName.replace(/\.[^.]+$/, "");
            parentParameterIsArray = parentParameterName.slice(-2) === "[]";
            if (parentParameterIsArray) parentParameterName = parentParameterName.slice(0, -2);
            parentValue = $j0yhs(options, parentParameterName);
            parentParamIsPresent = parentParameterName === "headers" || typeof parentValue === "object" && parentValue !== null;
        }
        const values = parentParameterIsArray ? ($j0yhs(options, parentParameterName) || []).map((value)=>value[parameterName.split(/\./).pop()]) : [
            $j0yhs(options, parameterName)
        ];
        values.forEach((value, i)=>{
            const valueIsPresent = typeof value !== "undefined";
            const valueIsNull = value === null;
            const currentParameterName = parentParameterIsArray ? parameterName.replace(/\[\]/, `[${i}]`) : parameterName;
            if (!parameter.required && !valueIsPresent) return;
            // if the parent parameter is of type object but allows null
            // then the child parameters can be ignored
            if (!parentParamIsPresent) return;
            if (parameter.allowNull && valueIsNull) return;
            if (!parameter.allowNull && valueIsNull) throw new $69525f19a091d919$require$RequestError(`'${currentParameterName}' cannot be null`, 400, {
                request: options
            });
            if (parameter.required && !valueIsPresent) throw new $69525f19a091d919$require$RequestError(`Empty value for parameter '${currentParameterName}': ${JSON.stringify(value)}`, 400, {
                request: options
            });
            // parse to integer before checking for enum
            // so that string "1" will match enum with number 1
            if (expectedType === "integer") {
                const unparsedValue = value;
                value = parseInt(value, 10);
                if (isNaN(value)) throw new $69525f19a091d919$require$RequestError(`Invalid value for parameter '${currentParameterName}': ${JSON.stringify(unparsedValue)} is NaN`, 400, {
                    request: options
                });
            }
            if (parameter.enum && parameter.enum.indexOf(String(value)) === -1) throw new $69525f19a091d919$require$RequestError(`Invalid value for parameter '${currentParameterName}': ${JSON.stringify(value)}`, 400, {
                request: options
            });
            if (parameter.validation) {
                const regex = new RegExp(parameter.validation);
                if (!regex.test(value)) throw new $69525f19a091d919$require$RequestError(`Invalid value for parameter '${currentParameterName}': ${JSON.stringify(value)}`, 400, {
                    request: options
                });
            }
            if (expectedType === "object" && typeof value === "string") try {
                value = JSON.parse(value);
            } catch (exception) {
                throw new $69525f19a091d919$require$RequestError(`JSON parse error of value for parameter '${currentParameterName}': ${JSON.stringify(value)}`, 400, {
                    request: options
                });
            }
            $9CSLD(options, parameter.mapTo || currentParameterName, value);
        });
    });
    return options;
}

});
parcelRegister("j0yhs", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $dd689bd5b5db437f$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used to stand-in for `undefined` hash values. */ var $dd689bd5b5db437f$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used as references for various `Number` constants. */ var $dd689bd5b5db437f$var$INFINITY = 1 / 0;
/** `Object#toString` result references. */ var $dd689bd5b5db437f$var$funcTag = '[object Function]', $dd689bd5b5db437f$var$genTag = '[object GeneratorFunction]', $dd689bd5b5db437f$var$symbolTag = '[object Symbol]';
/** Used to match property names within property paths. */ var $dd689bd5b5db437f$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $dd689bd5b5db437f$var$reIsPlainProp = /^\w*$/, $dd689bd5b5db437f$var$reLeadingDot = /^\./, $dd689bd5b5db437f$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $dd689bd5b5db437f$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to match backslashes in property paths. */ var $dd689bd5b5db437f$var$reEscapeChar = /\\(\\)?/g;
/** Used to detect host constructors (Safari). */ var $dd689bd5b5db437f$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Detect free variable `global` from Node.js. */ var $dd689bd5b5db437f$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $dd689bd5b5db437f$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $dd689bd5b5db437f$var$root = $dd689bd5b5db437f$var$freeGlobal || $dd689bd5b5db437f$var$freeSelf || Function('return this')();
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $dd689bd5b5db437f$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function $dd689bd5b5db437f$var$isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != 'function') try {
        result = !!(value + '');
    } catch (e) {}
    return result;
}
/** Used for built-in method references. */ var $dd689bd5b5db437f$var$arrayProto = Array.prototype, $dd689bd5b5db437f$var$funcProto = Function.prototype, $dd689bd5b5db437f$var$objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var $dd689bd5b5db437f$var$coreJsData = $dd689bd5b5db437f$var$root['__core-js_shared__'];
/** Used to detect methods masquerading as native. */ var $dd689bd5b5db437f$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($dd689bd5b5db437f$var$coreJsData && $dd689bd5b5db437f$var$coreJsData.keys && $dd689bd5b5db437f$var$coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/** Used to resolve the decompiled source of functions. */ var $dd689bd5b5db437f$var$funcToString = $dd689bd5b5db437f$var$funcProto.toString;
/** Used to check objects for own properties. */ var $dd689bd5b5db437f$var$hasOwnProperty = $dd689bd5b5db437f$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $dd689bd5b5db437f$var$objectToString = $dd689bd5b5db437f$var$objectProto.toString;
/** Used to detect if a method is native. */ var $dd689bd5b5db437f$var$reIsNative = RegExp('^' + $dd689bd5b5db437f$var$funcToString.call($dd689bd5b5db437f$var$hasOwnProperty).replace($dd689bd5b5db437f$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var $dd689bd5b5db437f$var$Symbol = $dd689bd5b5db437f$var$root.Symbol, $dd689bd5b5db437f$var$splice = $dd689bd5b5db437f$var$arrayProto.splice;
/* Built-in method references that are verified to be native. */ var $dd689bd5b5db437f$var$Map = $dd689bd5b5db437f$var$getNative($dd689bd5b5db437f$var$root, 'Map'), $dd689bd5b5db437f$var$nativeCreate = $dd689bd5b5db437f$var$getNative(Object, 'create');
/** Used to convert symbols to primitives and strings. */ var $dd689bd5b5db437f$var$symbolProto = $dd689bd5b5db437f$var$Symbol ? $dd689bd5b5db437f$var$Symbol.prototype : undefined, $dd689bd5b5db437f$var$symbolToString = $dd689bd5b5db437f$var$symbolProto ? $dd689bd5b5db437f$var$symbolProto.toString : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $dd689bd5b5db437f$var$Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $dd689bd5b5db437f$var$hashClear() {
    this.__data__ = $dd689bd5b5db437f$var$nativeCreate ? $dd689bd5b5db437f$var$nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $dd689bd5b5db437f$var$hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $dd689bd5b5db437f$var$hashGet(key) {
    var data = this.__data__;
    if ($dd689bd5b5db437f$var$nativeCreate) {
        var result = data[key];
        return result === $dd689bd5b5db437f$var$HASH_UNDEFINED ? undefined : result;
    }
    return $dd689bd5b5db437f$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $dd689bd5b5db437f$var$hashHas(key) {
    var data = this.__data__;
    return $dd689bd5b5db437f$var$nativeCreate ? data[key] !== undefined : $dd689bd5b5db437f$var$hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $dd689bd5b5db437f$var$hashSet(key, value) {
    var data = this.__data__;
    data[key] = $dd689bd5b5db437f$var$nativeCreate && value === undefined ? $dd689bd5b5db437f$var$HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
$dd689bd5b5db437f$var$Hash.prototype.clear = $dd689bd5b5db437f$var$hashClear;
$dd689bd5b5db437f$var$Hash.prototype['delete'] = $dd689bd5b5db437f$var$hashDelete;
$dd689bd5b5db437f$var$Hash.prototype.get = $dd689bd5b5db437f$var$hashGet;
$dd689bd5b5db437f$var$Hash.prototype.has = $dd689bd5b5db437f$var$hashHas;
$dd689bd5b5db437f$var$Hash.prototype.set = $dd689bd5b5db437f$var$hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $dd689bd5b5db437f$var$ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $dd689bd5b5db437f$var$listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $dd689bd5b5db437f$var$listCacheDelete(key) {
    var data = this.__data__, index = $dd689bd5b5db437f$var$assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $dd689bd5b5db437f$var$splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $dd689bd5b5db437f$var$listCacheGet(key) {
    var data = this.__data__, index = $dd689bd5b5db437f$var$assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $dd689bd5b5db437f$var$listCacheHas(key) {
    return $dd689bd5b5db437f$var$assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $dd689bd5b5db437f$var$listCacheSet(key, value) {
    var data = this.__data__, index = $dd689bd5b5db437f$var$assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
$dd689bd5b5db437f$var$ListCache.prototype.clear = $dd689bd5b5db437f$var$listCacheClear;
$dd689bd5b5db437f$var$ListCache.prototype['delete'] = $dd689bd5b5db437f$var$listCacheDelete;
$dd689bd5b5db437f$var$ListCache.prototype.get = $dd689bd5b5db437f$var$listCacheGet;
$dd689bd5b5db437f$var$ListCache.prototype.has = $dd689bd5b5db437f$var$listCacheHas;
$dd689bd5b5db437f$var$ListCache.prototype.set = $dd689bd5b5db437f$var$listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $dd689bd5b5db437f$var$MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $dd689bd5b5db437f$var$mapCacheClear() {
    this.__data__ = {
        'hash': new $dd689bd5b5db437f$var$Hash,
        'map': new ($dd689bd5b5db437f$var$Map || $dd689bd5b5db437f$var$ListCache),
        'string': new $dd689bd5b5db437f$var$Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $dd689bd5b5db437f$var$mapCacheDelete(key) {
    return $dd689bd5b5db437f$var$getMapData(this, key)['delete'](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $dd689bd5b5db437f$var$mapCacheGet(key) {
    return $dd689bd5b5db437f$var$getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $dd689bd5b5db437f$var$mapCacheHas(key) {
    return $dd689bd5b5db437f$var$getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $dd689bd5b5db437f$var$mapCacheSet(key, value) {
    $dd689bd5b5db437f$var$getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
$dd689bd5b5db437f$var$MapCache.prototype.clear = $dd689bd5b5db437f$var$mapCacheClear;
$dd689bd5b5db437f$var$MapCache.prototype['delete'] = $dd689bd5b5db437f$var$mapCacheDelete;
$dd689bd5b5db437f$var$MapCache.prototype.get = $dd689bd5b5db437f$var$mapCacheGet;
$dd689bd5b5db437f$var$MapCache.prototype.has = $dd689bd5b5db437f$var$mapCacheHas;
$dd689bd5b5db437f$var$MapCache.prototype.set = $dd689bd5b5db437f$var$mapCacheSet;
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $dd689bd5b5db437f$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($dd689bd5b5db437f$var$eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $dd689bd5b5db437f$var$baseGet(object, path) {
    path = $dd689bd5b5db437f$var$isKey(path, object) ? [
        path
    ] : $dd689bd5b5db437f$var$castPath(path);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$dd689bd5b5db437f$var$toKey(path[index++])];
    return index && index == length ? object : undefined;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $dd689bd5b5db437f$var$baseIsNative(value) {
    if (!$dd689bd5b5db437f$var$isObject(value) || $dd689bd5b5db437f$var$isMasked(value)) return false;
    var pattern = $dd689bd5b5db437f$var$isFunction(value) || $dd689bd5b5db437f$var$isHostObject(value) ? $dd689bd5b5db437f$var$reIsNative : $dd689bd5b5db437f$var$reIsHostCtor;
    return pattern.test($dd689bd5b5db437f$var$toSource(value));
}
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $dd689bd5b5db437f$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($dd689bd5b5db437f$var$isSymbol(value)) return $dd689bd5b5db437f$var$symbolToString ? $dd689bd5b5db437f$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$dd689bd5b5db437f$var$INFINITY ? '-0' : result;
}
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */ function $dd689bd5b5db437f$var$castPath(value) {
    return $dd689bd5b5db437f$var$isArray(value) ? value : $dd689bd5b5db437f$var$stringToPath(value);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $dd689bd5b5db437f$var$getMapData(map, key) {
    var data = map.__data__;
    return $dd689bd5b5db437f$var$isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $dd689bd5b5db437f$var$getNative(object, key) {
    var value = $dd689bd5b5db437f$var$getValue(object, key);
    return $dd689bd5b5db437f$var$baseIsNative(value) ? value : undefined;
}
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $dd689bd5b5db437f$var$isKey(value, object) {
    if ($dd689bd5b5db437f$var$isArray(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $dd689bd5b5db437f$var$isSymbol(value)) return true;
    return $dd689bd5b5db437f$var$reIsPlainProp.test(value) || !$dd689bd5b5db437f$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $dd689bd5b5db437f$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $dd689bd5b5db437f$var$isMasked(func) {
    return !!$dd689bd5b5db437f$var$maskSrcKey && $dd689bd5b5db437f$var$maskSrcKey in func;
}
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $dd689bd5b5db437f$var$stringToPath = $dd689bd5b5db437f$var$memoize(function(string) {
    string = $dd689bd5b5db437f$var$toString(string);
    var result = [];
    if ($dd689bd5b5db437f$var$reLeadingDot.test(string)) result.push('');
    string.replace($dd689bd5b5db437f$var$rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace($dd689bd5b5db437f$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $dd689bd5b5db437f$var$toKey(value) {
    if (typeof value == 'string' || $dd689bd5b5db437f$var$isSymbol(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$dd689bd5b5db437f$var$INFINITY ? '-0' : result;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function $dd689bd5b5db437f$var$toSource(func) {
    if (func != null) {
        try {
            return $dd689bd5b5db437f$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $dd689bd5b5db437f$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver && typeof resolver != 'function') throw new TypeError($dd689bd5b5db437f$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result);
        return result;
    };
    memoized.cache = new ($dd689bd5b5db437f$var$memoize.Cache || $dd689bd5b5db437f$var$MapCache);
    return memoized;
}
// Assign cache to `_.memoize`.
$dd689bd5b5db437f$var$memoize.Cache = $dd689bd5b5db437f$var$MapCache;
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $dd689bd5b5db437f$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $dd689bd5b5db437f$var$isArray = Array.isArray;
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $dd689bd5b5db437f$var$isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = $dd689bd5b5db437f$var$isObject(value) ? $dd689bd5b5db437f$var$objectToString.call(value) : '';
    return tag == $dd689bd5b5db437f$var$funcTag || tag == $dd689bd5b5db437f$var$genTag;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $dd689bd5b5db437f$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $dd689bd5b5db437f$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $dd689bd5b5db437f$var$isSymbol(value) {
    return typeof value == 'symbol' || $dd689bd5b5db437f$var$isObjectLike(value) && $dd689bd5b5db437f$var$objectToString.call(value) == $dd689bd5b5db437f$var$symbolTag;
}
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $dd689bd5b5db437f$var$toString(value) {
    return value == null ? '' : $dd689bd5b5db437f$var$baseToString(value);
}
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $dd689bd5b5db437f$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $dd689bd5b5db437f$var$baseGet(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = $dd689bd5b5db437f$var$get;

});

parcelRegister("9CSLD", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $7022254a06f6870e$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used to stand-in for `undefined` hash values. */ var $7022254a06f6870e$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used as references for various `Number` constants. */ var $7022254a06f6870e$var$INFINITY = 1 / 0, $7022254a06f6870e$var$MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var $7022254a06f6870e$var$funcTag = '[object Function]', $7022254a06f6870e$var$genTag = '[object GeneratorFunction]', $7022254a06f6870e$var$symbolTag = '[object Symbol]';
/** Used to match property names within property paths. */ var $7022254a06f6870e$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $7022254a06f6870e$var$reIsPlainProp = /^\w*$/, $7022254a06f6870e$var$reLeadingDot = /^\./, $7022254a06f6870e$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $7022254a06f6870e$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to match backslashes in property paths. */ var $7022254a06f6870e$var$reEscapeChar = /\\(\\)?/g;
/** Used to detect host constructors (Safari). */ var $7022254a06f6870e$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var $7022254a06f6870e$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/** Detect free variable `global` from Node.js. */ var $7022254a06f6870e$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $7022254a06f6870e$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $7022254a06f6870e$var$root = $7022254a06f6870e$var$freeGlobal || $7022254a06f6870e$var$freeSelf || Function('return this')();
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $7022254a06f6870e$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function $7022254a06f6870e$var$isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != 'function') try {
        result = !!(value + '');
    } catch (e) {}
    return result;
}
/** Used for built-in method references. */ var $7022254a06f6870e$var$arrayProto = Array.prototype, $7022254a06f6870e$var$funcProto = Function.prototype, $7022254a06f6870e$var$objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var $7022254a06f6870e$var$coreJsData = $7022254a06f6870e$var$root['__core-js_shared__'];
/** Used to detect methods masquerading as native. */ var $7022254a06f6870e$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($7022254a06f6870e$var$coreJsData && $7022254a06f6870e$var$coreJsData.keys && $7022254a06f6870e$var$coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/** Used to resolve the decompiled source of functions. */ var $7022254a06f6870e$var$funcToString = $7022254a06f6870e$var$funcProto.toString;
/** Used to check objects for own properties. */ var $7022254a06f6870e$var$hasOwnProperty = $7022254a06f6870e$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $7022254a06f6870e$var$objectToString = $7022254a06f6870e$var$objectProto.toString;
/** Used to detect if a method is native. */ var $7022254a06f6870e$var$reIsNative = RegExp('^' + $7022254a06f6870e$var$funcToString.call($7022254a06f6870e$var$hasOwnProperty).replace($7022254a06f6870e$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var $7022254a06f6870e$var$Symbol = $7022254a06f6870e$var$root.Symbol, $7022254a06f6870e$var$splice = $7022254a06f6870e$var$arrayProto.splice;
/* Built-in method references that are verified to be native. */ var $7022254a06f6870e$var$Map = $7022254a06f6870e$var$getNative($7022254a06f6870e$var$root, 'Map'), $7022254a06f6870e$var$nativeCreate = $7022254a06f6870e$var$getNative(Object, 'create');
/** Used to convert symbols to primitives and strings. */ var $7022254a06f6870e$var$symbolProto = $7022254a06f6870e$var$Symbol ? $7022254a06f6870e$var$Symbol.prototype : undefined, $7022254a06f6870e$var$symbolToString = $7022254a06f6870e$var$symbolProto ? $7022254a06f6870e$var$symbolProto.toString : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $7022254a06f6870e$var$Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $7022254a06f6870e$var$hashClear() {
    this.__data__ = $7022254a06f6870e$var$nativeCreate ? $7022254a06f6870e$var$nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $7022254a06f6870e$var$hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $7022254a06f6870e$var$hashGet(key) {
    var data = this.__data__;
    if ($7022254a06f6870e$var$nativeCreate) {
        var result = data[key];
        return result === $7022254a06f6870e$var$HASH_UNDEFINED ? undefined : result;
    }
    return $7022254a06f6870e$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $7022254a06f6870e$var$hashHas(key) {
    var data = this.__data__;
    return $7022254a06f6870e$var$nativeCreate ? data[key] !== undefined : $7022254a06f6870e$var$hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $7022254a06f6870e$var$hashSet(key, value) {
    var data = this.__data__;
    data[key] = $7022254a06f6870e$var$nativeCreate && value === undefined ? $7022254a06f6870e$var$HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
$7022254a06f6870e$var$Hash.prototype.clear = $7022254a06f6870e$var$hashClear;
$7022254a06f6870e$var$Hash.prototype['delete'] = $7022254a06f6870e$var$hashDelete;
$7022254a06f6870e$var$Hash.prototype.get = $7022254a06f6870e$var$hashGet;
$7022254a06f6870e$var$Hash.prototype.has = $7022254a06f6870e$var$hashHas;
$7022254a06f6870e$var$Hash.prototype.set = $7022254a06f6870e$var$hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $7022254a06f6870e$var$ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $7022254a06f6870e$var$listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $7022254a06f6870e$var$listCacheDelete(key) {
    var data = this.__data__, index = $7022254a06f6870e$var$assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $7022254a06f6870e$var$splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $7022254a06f6870e$var$listCacheGet(key) {
    var data = this.__data__, index = $7022254a06f6870e$var$assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $7022254a06f6870e$var$listCacheHas(key) {
    return $7022254a06f6870e$var$assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $7022254a06f6870e$var$listCacheSet(key, value) {
    var data = this.__data__, index = $7022254a06f6870e$var$assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
$7022254a06f6870e$var$ListCache.prototype.clear = $7022254a06f6870e$var$listCacheClear;
$7022254a06f6870e$var$ListCache.prototype['delete'] = $7022254a06f6870e$var$listCacheDelete;
$7022254a06f6870e$var$ListCache.prototype.get = $7022254a06f6870e$var$listCacheGet;
$7022254a06f6870e$var$ListCache.prototype.has = $7022254a06f6870e$var$listCacheHas;
$7022254a06f6870e$var$ListCache.prototype.set = $7022254a06f6870e$var$listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $7022254a06f6870e$var$MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $7022254a06f6870e$var$mapCacheClear() {
    this.__data__ = {
        'hash': new $7022254a06f6870e$var$Hash,
        'map': new ($7022254a06f6870e$var$Map || $7022254a06f6870e$var$ListCache),
        'string': new $7022254a06f6870e$var$Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $7022254a06f6870e$var$mapCacheDelete(key) {
    return $7022254a06f6870e$var$getMapData(this, key)['delete'](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $7022254a06f6870e$var$mapCacheGet(key) {
    return $7022254a06f6870e$var$getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $7022254a06f6870e$var$mapCacheHas(key) {
    return $7022254a06f6870e$var$getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $7022254a06f6870e$var$mapCacheSet(key, value) {
    $7022254a06f6870e$var$getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
$7022254a06f6870e$var$MapCache.prototype.clear = $7022254a06f6870e$var$mapCacheClear;
$7022254a06f6870e$var$MapCache.prototype['delete'] = $7022254a06f6870e$var$mapCacheDelete;
$7022254a06f6870e$var$MapCache.prototype.get = $7022254a06f6870e$var$mapCacheGet;
$7022254a06f6870e$var$MapCache.prototype.has = $7022254a06f6870e$var$mapCacheHas;
$7022254a06f6870e$var$MapCache.prototype.set = $7022254a06f6870e$var$mapCacheSet;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $7022254a06f6870e$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($7022254a06f6870e$var$hasOwnProperty.call(object, key) && $7022254a06f6870e$var$eq(objValue, value)) || value === undefined && !(key in object)) object[key] = value;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $7022254a06f6870e$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($7022254a06f6870e$var$eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $7022254a06f6870e$var$baseIsNative(value) {
    if (!$7022254a06f6870e$var$isObject(value) || $7022254a06f6870e$var$isMasked(value)) return false;
    var pattern = $7022254a06f6870e$var$isFunction(value) || $7022254a06f6870e$var$isHostObject(value) ? $7022254a06f6870e$var$reIsNative : $7022254a06f6870e$var$reIsHostCtor;
    return pattern.test($7022254a06f6870e$var$toSource(value));
}
/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $7022254a06f6870e$var$baseSet(object, path, value, customizer) {
    if (!$7022254a06f6870e$var$isObject(object)) return object;
    path = $7022254a06f6870e$var$isKey(path, object) ? [
        path
    ] : $7022254a06f6870e$var$castPath(path);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = $7022254a06f6870e$var$toKey(path[index]), newValue = value;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = $7022254a06f6870e$var$isObject(objValue) ? objValue : $7022254a06f6870e$var$isIndex(path[index + 1]) ? [] : {};
        }
        $7022254a06f6870e$var$assignValue(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $7022254a06f6870e$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($7022254a06f6870e$var$isSymbol(value)) return $7022254a06f6870e$var$symbolToString ? $7022254a06f6870e$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$7022254a06f6870e$var$INFINITY ? '-0' : result;
}
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */ function $7022254a06f6870e$var$castPath(value) {
    return $7022254a06f6870e$var$isArray(value) ? value : $7022254a06f6870e$var$stringToPath(value);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $7022254a06f6870e$var$getMapData(map, key) {
    var data = map.__data__;
    return $7022254a06f6870e$var$isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $7022254a06f6870e$var$getNative(object, key) {
    var value = $7022254a06f6870e$var$getValue(object, key);
    return $7022254a06f6870e$var$baseIsNative(value) ? value : undefined;
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $7022254a06f6870e$var$isIndex(value, length) {
    length = length == null ? $7022254a06f6870e$var$MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || $7022254a06f6870e$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $7022254a06f6870e$var$isKey(value, object) {
    if ($7022254a06f6870e$var$isArray(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $7022254a06f6870e$var$isSymbol(value)) return true;
    return $7022254a06f6870e$var$reIsPlainProp.test(value) || !$7022254a06f6870e$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $7022254a06f6870e$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $7022254a06f6870e$var$isMasked(func) {
    return !!$7022254a06f6870e$var$maskSrcKey && $7022254a06f6870e$var$maskSrcKey in func;
}
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $7022254a06f6870e$var$stringToPath = $7022254a06f6870e$var$memoize(function(string) {
    string = $7022254a06f6870e$var$toString(string);
    var result = [];
    if ($7022254a06f6870e$var$reLeadingDot.test(string)) result.push('');
    string.replace($7022254a06f6870e$var$rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace($7022254a06f6870e$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $7022254a06f6870e$var$toKey(value) {
    if (typeof value == 'string' || $7022254a06f6870e$var$isSymbol(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$7022254a06f6870e$var$INFINITY ? '-0' : result;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function $7022254a06f6870e$var$toSource(func) {
    if (func != null) {
        try {
            return $7022254a06f6870e$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $7022254a06f6870e$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver && typeof resolver != 'function') throw new TypeError($7022254a06f6870e$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result);
        return result;
    };
    memoized.cache = new ($7022254a06f6870e$var$memoize.Cache || $7022254a06f6870e$var$MapCache);
    return memoized;
}
// Assign cache to `_.memoize`.
$7022254a06f6870e$var$memoize.Cache = $7022254a06f6870e$var$MapCache;
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $7022254a06f6870e$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $7022254a06f6870e$var$isArray = Array.isArray;
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $7022254a06f6870e$var$isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = $7022254a06f6870e$var$isObject(value) ? $7022254a06f6870e$var$objectToString.call(value) : '';
    return tag == $7022254a06f6870e$var$funcTag || tag == $7022254a06f6870e$var$genTag;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $7022254a06f6870e$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $7022254a06f6870e$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $7022254a06f6870e$var$isSymbol(value) {
    return typeof value == 'symbol' || $7022254a06f6870e$var$isObjectLike(value) && $7022254a06f6870e$var$objectToString.call(value) == $7022254a06f6870e$var$symbolTag;
}
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $7022254a06f6870e$var$toString(value) {
    return value == null ? '' : $7022254a06f6870e$var$baseToString(value);
}
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $7022254a06f6870e$var$set(object, path, value) {
    return object == null ? object : $7022254a06f6870e$var$baseSet(object, path, value);
}
module.exports = $7022254a06f6870e$var$set;

});



parcelRegister("5C24u", function(module, exports) {
module.exports = $41621bb08c96e0c1$var$paginationMethodsPlugin;








function $41621bb08c96e0c1$var$paginationMethodsPlugin(octokit) {
    octokit.getFirstPage = (parcelRequire("e3L0u")).bind(null, octokit);
    octokit.getLastPage = (parcelRequire("gSIeD")).bind(null, octokit);
    octokit.getNextPage = (parcelRequire("mnKfB")).bind(null, octokit);
    octokit.getPreviousPage = (parcelRequire("iwtYh")).bind(null, octokit);
    octokit.hasFirstPage = (parcelRequire("elZJm"));
    octokit.hasLastPage = (parcelRequire("kH6ND"));
    octokit.hasNextPage = (parcelRequire("aC6qI"));
    octokit.hasPreviousPage = (parcelRequire("9UkoR"));
}

});
parcelRegister("e3L0u", function(module, exports) {
module.exports = $a3c5cf16df1d5257$var$getFirstPage;

var $clGcn = parcelRequire("clGcn");
function $a3c5cf16df1d5257$var$getFirstPage(octokit, link, headers) {
    return $clGcn(octokit, link, 'first', headers);
}

});
parcelRegister("clGcn", function(module, exports) {
module.exports = $8fd82df30babec30$var$getPage;

var $ccfmF = parcelRequire("ccfmF");

var $aCqg0 = parcelRequire("aCqg0");

var $cl4cV = parcelRequire("cl4cV");
function $8fd82df30babec30$var$getPage(octokit, link, which, headers) {
    $ccfmF(`octokit.get${which.charAt(0).toUpperCase() + which.slice(1)}Page() \u{2013} You can use octokit.paginate or async iterators instead: https://github.com/octokit/rest.js#pagination.`);
    const url = $aCqg0(link)[which];
    if (!url) {
        const urlError = new $cl4cV(`No ${which} page found`, 404);
        return Promise.reject(urlError);
    }
    const requestOptions = {
        url: url,
        headers: $8fd82df30babec30$var$applyAcceptHeader(link, headers)
    };
    const promise = octokit.request(requestOptions);
    return promise;
}
function $8fd82df30babec30$var$applyAcceptHeader(res, headers) {
    const previous = res.headers && res.headers['x-github-media-type'];
    if (!previous || headers && headers.accept) return headers;
    headers = headers || {};
    headers.accept = 'application/vnd.' + previous.replace('; param=', '.').replace('; format=', '+');
    return headers;
}

});
parcelRegister("ccfmF", function(module, exports) {
module.exports = $024a9f10e705315e$var$deprecate;
const $024a9f10e705315e$var$loggedMessages = {};
function $024a9f10e705315e$var$deprecate(message) {
    if ($024a9f10e705315e$var$loggedMessages[message]) return;
    console.warn(`DEPRECATED (@octokit/rest): ${message}`);
    $024a9f10e705315e$var$loggedMessages[message] = 1;
}

});

parcelRegister("aCqg0", function(module, exports) {
module.exports = $7bb1d21e45d4d081$var$getPageLinks;
function $7bb1d21e45d4d081$var$getPageLinks(link) {
    link = link.link || link.headers.link || '';
    const links = {};
    // link format:
    // '<https://api.github.com/users/aseemk/followers?page=2>; rel="next", <https://api.github.com/users/aseemk/followers?page=2>; rel="last"'
    link.replace(/<([^>]*)>;\s*rel="([\w]*)"/g, (m, uri, type)=>{
        links[type] = uri;
    });
    return links;
}

});

parcelRegister("cl4cV", function(module, exports) {
module.exports = class HttpError extends Error {
    constructor(message, code, headers){
        super(message);
        // Maintains proper stack trace (only available on V8)
        /* istanbul ignore next */ if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
        this.name = 'HttpError';
        this.code = code;
        this.headers = headers;
    }
};

});



parcelRegister("gSIeD", function(module, exports) {
module.exports = $c4a400a1dd39bca2$var$getLastPage;

var $clGcn = parcelRequire("clGcn");
function $c4a400a1dd39bca2$var$getLastPage(octokit, link, headers) {
    return $clGcn(octokit, link, 'last', headers);
}

});

parcelRegister("mnKfB", function(module, exports) {
module.exports = $0434797266715c80$var$getNextPage;

var $clGcn = parcelRequire("clGcn");
function $0434797266715c80$var$getNextPage(octokit, link, headers) {
    return $clGcn(octokit, link, 'next', headers);
}

});

parcelRegister("iwtYh", function(module, exports) {
module.exports = $d7c276d019deb5eb$var$getPreviousPage;

var $clGcn = parcelRequire("clGcn");
function $d7c276d019deb5eb$var$getPreviousPage(octokit, link, headers) {
    return $clGcn(octokit, link, 'prev', headers);
}

});

parcelRegister("elZJm", function(module, exports) {
module.exports = $a732e94528da10d7$var$hasFirstPage;

var $ccfmF = parcelRequire("ccfmF");

var $aCqg0 = parcelRequire("aCqg0");
function $a732e94528da10d7$var$hasFirstPage(link) {
    $ccfmF(`octokit.hasFirstPage() \u{2013} You can use octokit.paginate or async iterators instead: https://github.com/octokit/rest.js#pagination.`);
    return $aCqg0(link).first;
}

});

parcelRegister("kH6ND", function(module, exports) {
module.exports = $f10d19119d871a37$var$hasLastPage;

var $ccfmF = parcelRequire("ccfmF");

var $aCqg0 = parcelRequire("aCqg0");
function $f10d19119d871a37$var$hasLastPage(link) {
    $ccfmF(`octokit.hasLastPage() \u{2013} You can use octokit.paginate or async iterators instead: https://github.com/octokit/rest.js#pagination.`);
    return $aCqg0(link).last;
}

});

parcelRegister("aC6qI", function(module, exports) {
module.exports = $7ba270d81aaaf7fa$var$hasNextPage;

var $ccfmF = parcelRequire("ccfmF");

var $aCqg0 = parcelRequire("aCqg0");
function $7ba270d81aaaf7fa$var$hasNextPage(link) {
    $ccfmF(`octokit.hasNextPage() \u{2013} You can use octokit.paginate or async iterators instead: https://github.com/octokit/rest.js#pagination.`);
    return $aCqg0(link).next;
}

});

parcelRegister("9UkoR", function(module, exports) {
module.exports = $73692b094dc288cd$var$hasPreviousPage;

var $ccfmF = parcelRequire("ccfmF");

var $aCqg0 = parcelRequire("aCqg0");
function $73692b094dc288cd$var$hasPreviousPage(link) {
    $ccfmF(`octokit.hasPreviousPage() \u{2013} You can use octokit.paginate or async iterators instead: https://github.com/octokit/rest.js#pagination.`);
    return $aCqg0(link).prev;
}

});


parcelRegister("h5Z1H", function(module, exports) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, 'toString')) a.toString = b.toString;
        if (hasOwnProp(b, 'valueOf')) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) console.warn('Deprecation warning: ' + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ': ' + arguments[0][key] + ', ';
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this['_' + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, '');
        return input.replace(/\\/g, '');
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = '', i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') return tok.slice(1);
            return tok;
        }).join('');
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = 'Invalid date';
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = '%d', defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }
    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year'
    };
    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === 'string') token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken('Y', 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, [
        'YY',
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        'YYYY',
        4
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYY',
        5
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYYY',
        6,
        true
    ], 0, 'year');
    // PARSING
    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken([
        'YYYYY',
        'YYYYYY'
    ], YEAR);
    addParseToken('YYYY', function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet('FullYear', true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken('M', [
        'MM',
        2
    ], 'Mo', function() {
        return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        'M',
        'MM'
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        'MMM',
        'MMMM'
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months['standalone'];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, 'Month');
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken('w', [
        'ww',
        2
    ], 'wo', 'week');
    addFormatToken('W', [
        'WW',
        2
    ], 'Wo', 'isoWeek');
    // PARSING
    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken([
        'w',
        'ww',
        'W',
        'WW'
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    // FORMATTING
    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');
    // PARSING
    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        'dd',
        'ddd',
        'dddd'
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        'd',
        'e',
        'E'
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== 'string') return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === 'number') return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'), defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'), defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken('H', [
        'HH',
        2
    ], 0, 'hour');
    addFormatToken('h', [
        'hh',
        2
    ], 0, hFormat);
    addFormatToken('k', [
        'kk',
        2
    ], 0, kFormat);
    addFormatToken('hmm', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem('a', true);
    meridiem('A', false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken([
        'H',
        'HH'
    ], HOUR);
    addParseToken([
        'k',
        'kk'
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        'a',
        'A'
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        'h',
        'hh'
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? 'pm' : 'PM';
        else return isLower ? 'am' : 'AM';
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire('./locale/' + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== 'undefined' && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride', "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            'YYYYYY-MM-DD',
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            'YYYY-MM-DD',
            /\d{4}-\d\d-\d\d/
        ],
        [
            'GGGG-[W]WW-E',
            /\d{4}-W\d\d-\d/
        ],
        [
            'GGGG-[W]WW',
            /\d{4}-W\d\d/,
            false
        ],
        [
            'YYYY-DDD',
            /\d{4}-\d{3}/
        ],
        [
            'YYYY-MM',
            /\d{4}-\d\d/,
            false
        ],
        [
            'YYYYYYMMDD',
            /[+-]\d{10}/
        ],
        [
            'YYYYMMDD',
            /\d{8}/
        ],
        [
            'GGGG[W]WWE',
            /\d{4}W\d{3}/
        ],
        [
            'GGGG[W]WW',
            /\d{4}W\d{2}/,
            false
        ],
        [
            'YYYYDDD',
            /\d{7}/
        ],
        [
            'YYYYMM',
            /\d{6}/,
            false
        ],
        [
            'YYYY',
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            'HH:mm:ss.SSSS',
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            'HH:mm:ss,SSSS',
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            'HH:mm:ss',
            /\d\d:\d\d:\d\d/
        ],
        [
            'HH:mm',
            /\d\d:\d\d/
        ],
        [
            'HHmmss.SSSS',
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            'HHmmss,SSSS',
            /\d\d\d\d\d\d,\d+/
        ],
        [
            'HHmmss',
            /\d\d\d\d\d\d/
        ],
        [
            'HHmm',
            /\d\d\d\d/
        ],
        [
            'HH',
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = 'Z';
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === '') return createInvalid({
            nullInput: true
        });
        if (typeof input === 'string') config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === 'string') configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isBefore', args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isAfter', args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond'
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset('Z', ':');
    offset('ZZ', '');
    // PARSING
    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken([
        'Z',
        'ZZ'
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || [
            '-',
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, 'm');
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), 'm');
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, '_locale')) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, '_isValid')) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, 'M');
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, 'Month') + months * isAdding);
        if (days) set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, 'add'), subtract = createAdder(-1, 'subtract');
    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'years',
            'year',
            'y',
            'months',
            'month',
            'M',
            'days',
            'day',
            'd',
            'dates',
            'date',
            'D',
            'hours',
            'hour',
            'h',
            'minutes',
            'minute',
            'm',
            'seconds',
            'second',
            's',
            'milliseconds',
            'millisecond',
            'ms'
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'sameDay',
            'nextDay',
            'lastDay',
            'nextWeek',
            'lastWeek',
            'sameElse'
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf('day'), format = hooks.calendarFormat(this, sod) || 'sameElse', output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return 'moment.invalid(/* ' + this._i + ' */)';
        var func = 'moment', zone = '', prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', [
        'y',
        1
    ], 'yo', 'eraYear');
    addFormatToken('y', [
        'yy',
        2
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyy',
        3
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyyy',
        4
    ], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken([
        'N',
        'NN',
        'NNN',
        'NNNN',
        'NNNNN'
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken([
        'y',
        'yy',
        'yyy',
        'yyyy'
    ], YEAR);
    addParseToken([
        'yo'
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale('en')._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case 'undefined':
                    eras[i].until = Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case 'N':
                case 'NN':
                case 'NNN':
                    if (abbr === eraName) return eras[i];
                    break;
                case 'NNNN':
                    if (name === eraName) return eras[i];
                    break;
                case 'NNNNN':
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return '';
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return '';
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return '';
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken(0, [
        'gg',
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        'GG',
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
    // ALIASES
    // PARSING
    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken([
        'gggg',
        'ggggg',
        'GGGG',
        'GGGGG'
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        'gg',
        'GG'
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken('Q', 0, 'Qo', 'quarter');
    // PARSING
    addRegexToken('Q', match1);
    addParseToken('Q', function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken('D', [
        'DD',
        2
    ], 'Do', 'date');
    // PARSING
    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        'D',
        'DD'
    ], DATE);
    addParseToken('Do', function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet('Date', true);
    // FORMATTING
    addFormatToken('DDD', [
        'DDDD',
        3
    ], 'DDDo', 'dayOfYear');
    // PARSING
    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken([
        'DDD',
        'DDDD'
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }
    // FORMATTING
    addFormatToken('m', [
        'mm',
        2
    ], 0, 'minute');
    // PARSING
    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken([
        'm',
        'mm'
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet('Minutes', false);
    // FORMATTING
    addFormatToken('s', [
        'ss',
        2
    ], 0, 'second');
    // PARSING
    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken([
        's',
        'ss'
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet('Seconds', false);
    // FORMATTING
    addFormatToken('S', 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        'SS',
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        'SSS',
        3
    ], 0, 'millisecond');
    addFormatToken(0, [
        'SSSS',
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        'SSSSS',
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        'SSSSSS',
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        'SSSSSSS',
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        'SSSSSSSS',
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        'SSSSSSSSS',
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;
    for(token = 'SSSS'; token.length <= 9; token += 'S')addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }
    for(token = 'S'; token.length <= 9; token += 'S')addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet('Milliseconds', false);
    // FORMATTING
    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }
    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) proto[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return 'Moment<' + this.format() + '>';
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || '';
        if (index != null) return get$1(format, index, field, 'month');
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, 'month');
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, 'day');
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, 'day');
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }
    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD'
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC'
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs('ms'), asSeconds = makeAs('s'), asMinutes = makeAs('m'), asHours = makeAs('h'), asDays = makeAs('d'), asWeeks = makeAs('w'), asMonths = makeAs('M'), asQuarters = makeAs('Q'), asYears = makeAs('y'), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter('milliseconds'), seconds = makeGetter('seconds'), minutes = makeGetter('minutes'), hours = makeGetter('hours'), days = makeGetter('days'), months = makeGetter('months'), years = makeGetter('years');
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as('s')), minutes = round(duration.as('m')), hours = round(duration.as('h')), days = round(duration.as('d')), months = round(duration.as('M')), weeks = round(duration.as('w')), years = round(duration.as('y')), a = seconds <= thresholds.ss && [
            's',
            seconds
        ] || seconds < thresholds.s && [
            'ss',
            seconds
        ] || minutes <= 1 && [
            'm'
        ] || minutes < thresholds.m && [
            'mm',
            minutes
        ] || hours <= 1 && [
            'h'
        ] || hours < thresholds.h && [
            'hh',
            hours
        ] || days <= 1 && [
            'd'
        ] || days < thresholds.d && [
            'dd',
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            'w'
        ] || weeks < thresholds.w && [
            'ww',
            weeks
        ];
        a = a || months <= 1 && [
            'M'
        ] || months < thresholds.M && [
            'MM',
            months
        ] || years <= 1 && [
            'y'
        ] || [
            'yy',
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === 's') thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') withSuffix = argWithSuffix;
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
        return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');
    // PARSING
    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = '2.30.1';
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
        DATE: 'YYYY-MM-DD',
        TIME: 'HH:mm',
        TIME_SECONDS: 'HH:mm:ss',
        TIME_MS: 'HH:mm:ss.SSS',
        WEEK: 'GGGG-[W]WW',
        MONTH: 'YYYY-MM'
    };
    return hooks;
});

});

parcelRegister("jan5f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $df40db6a42a47b61$var$_react = $df40db6a42a47b61$var$_interopRequireWildcard((parcelRequire("lx97N")));

var $df40db6a42a47b61$var$_propTypes = $df40db6a42a47b61$var$_interopRequireDefault((parcelRequire("4RND8")));

var $df40db6a42a47b61$var$_lodash = $df40db6a42a47b61$var$_interopRequireDefault((parcelRequire("iljZL")));

var $Hu4Ju = parcelRequire("Hu4Ju");
function $df40db6a42a47b61$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $df40db6a42a47b61$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj["default"] = obj;
        return newObj;
    }
}
function $df40db6a42a47b61$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $df40db6a42a47b61$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $df40db6a42a47b61$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $df40db6a42a47b61$var$_typeof(obj);
}
function $df40db6a42a47b61$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $df40db6a42a47b61$var$_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function $df40db6a42a47b61$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $df40db6a42a47b61$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $df40db6a42a47b61$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $df40db6a42a47b61$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $df40db6a42a47b61$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $df40db6a42a47b61$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $df40db6a42a47b61$var$_possibleConstructorReturn(self, call) {
    if (call && ($df40db6a42a47b61$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $df40db6a42a47b61$var$_assertThisInitialized(self);
}
function $df40db6a42a47b61$var$_getPrototypeOf(o) {
    $df40db6a42a47b61$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $df40db6a42a47b61$var$_getPrototypeOf(o);
}
function $df40db6a42a47b61$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $df40db6a42a47b61$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $df40db6a42a47b61$var$_setPrototypeOf(subClass, superClass);
}
function $df40db6a42a47b61$var$_setPrototypeOf(o, p) {
    $df40db6a42a47b61$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $df40db6a42a47b61$var$_setPrototypeOf(o, p);
}
var $df40db6a42a47b61$var$ace = (0, $Hu4Ju.getAceInstance)();
var $df40db6a42a47b61$var$_ace$acequire = $df40db6a42a47b61$var$ace.acequire("ace/range"), $df40db6a42a47b61$var$Range = $df40db6a42a47b61$var$_ace$acequire.Range;
var $df40db6a42a47b61$var$ReactAce = /*#__PURE__*/ function(_Component) {
    $df40db6a42a47b61$var$_inherits(ReactAce, _Component);
    function ReactAce(props) {
        var _this;
        $df40db6a42a47b61$var$_classCallCheck(this, ReactAce);
        _this = $df40db6a42a47b61$var$_possibleConstructorReturn(this, $df40db6a42a47b61$var$_getPrototypeOf(ReactAce).call(this, props));
        $Hu4Ju.editorEvents.forEach(function(method) {
            _this[method] = _this[method].bind($df40db6a42a47b61$var$_assertThisInitialized(_this));
        });
        _this.debounce = $Hu4Ju.debounce;
        return _this;
    }
    $df40db6a42a47b61$var$_createClass(ReactAce, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this2 = this;
                var _this$props = this.props, className = _this$props.className, onBeforeLoad = _this$props.onBeforeLoad, onValidate = _this$props.onValidate, mode = _this$props.mode, focus = _this$props.focus, theme = _this$props.theme, fontSize = _this$props.fontSize, value = _this$props.value, defaultValue = _this$props.defaultValue, cursorStart = _this$props.cursorStart, showGutter = _this$props.showGutter, wrapEnabled = _this$props.wrapEnabled, showPrintMargin = _this$props.showPrintMargin, _this$props$scrollMar = _this$props.scrollMargin, scrollMargin = _this$props$scrollMar === void 0 ? [
                    0,
                    0,
                    0,
                    0
                ] : _this$props$scrollMar, keyboardHandler = _this$props.keyboardHandler, onLoad = _this$props.onLoad, commands = _this$props.commands, annotations = _this$props.annotations, markers = _this$props.markers, placeholder = _this$props.placeholder;
                this.editor = $df40db6a42a47b61$var$ace.edit(this.refEditor);
                if (onBeforeLoad) onBeforeLoad($df40db6a42a47b61$var$ace);
                var editorProps = Object.keys(this.props.editorProps);
                for(var i = 0; i < editorProps.length; i++)this.editor[editorProps[i]] = this.props.editorProps[editorProps[i]];
                if (this.props.debounceChangePeriod) this.onChange = this.debounce(this.onChange, this.props.debounceChangePeriod);
                this.editor.renderer.setScrollMargin(scrollMargin[0], scrollMargin[1], scrollMargin[2], scrollMargin[3]);
                this.editor.getSession().setMode("ace/mode/".concat(mode));
                this.editor.setTheme("ace/theme/".concat(theme));
                this.editor.setFontSize(fontSize);
                this.editor.getSession().setValue(!defaultValue ? value : defaultValue, cursorStart);
                if (this.props.navigateToFileEnd) this.editor.navigateFileEnd();
                this.editor.renderer.setShowGutter(showGutter);
                this.editor.getSession().setUseWrapMode(wrapEnabled);
                this.editor.setShowPrintMargin(showPrintMargin);
                this.editor.on("focus", this.onFocus);
                this.editor.on("blur", this.onBlur);
                this.editor.on("copy", this.onCopy);
                this.editor.on("paste", this.onPaste);
                this.editor.on("change", this.onChange);
                this.editor.on("input", this.onInput);
                if (placeholder) this.updatePlaceholder(this.editor, placeholder);
                this.editor.getSession().selection.on("changeSelection", this.onSelectionChange);
                this.editor.getSession().selection.on("changeCursor", this.onCursorChange);
                if (onValidate) this.editor.getSession().on("changeAnnotation", function() {
                    var annotations = _this2.editor.getSession().getAnnotations();
                    _this2.props.onValidate(annotations);
                });
                this.editor.session.on("changeScrollTop", this.onScroll);
                this.editor.getSession().setAnnotations(annotations || []);
                if (markers && markers.length > 0) this.handleMarkers(markers);
                 // get a list of possible options to avoid 'misspelled option errors'
                var availableOptions = this.editor.$options;
                for(var _i = 0; _i < $Hu4Ju.editorOptions.length; _i++){
                    var option = $Hu4Ju.editorOptions[_i];
                    if (availableOptions.hasOwnProperty(option)) this.editor.setOption(option, this.props[option]);
                    else if (this.props[option]) console.warn("ReactAce: editor option ".concat(option, " was activated but not found. Did you need to import a related tool or did you possibly mispell the option?"));
                }
                this.handleOptions(this.props);
                if (Array.isArray(commands)) commands.forEach(function(command) {
                    if (typeof command.exec == "string") _this2.editor.commands.bindKey(command.bindKey, command.exec);
                    else _this2.editor.commands.addCommand(command);
                });
                if (keyboardHandler) this.editor.setKeyboardHandler("ace/keyboard/" + keyboardHandler);
                if (className) this.refEditor.className += " " + className;
                if (onLoad) onLoad(this.editor);
                this.editor.resize();
                if (focus) this.editor.focus();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var oldProps = prevProps;
                var nextProps = this.props;
                for(var i = 0; i < $Hu4Ju.editorOptions.length; i++){
                    var option = $Hu4Ju.editorOptions[i];
                    if (nextProps[option] !== oldProps[option]) this.editor.setOption(option, nextProps[option]);
                }
                if (nextProps.className !== oldProps.className) {
                    var appliedClasses = this.refEditor.className;
                    var appliedClassesArray = appliedClasses.trim().split(" ");
                    var oldClassesArray = oldProps.className.trim().split(" ");
                    oldClassesArray.forEach(function(oldClass) {
                        var index = appliedClassesArray.indexOf(oldClass);
                        appliedClassesArray.splice(index, 1);
                    });
                    this.refEditor.className = " " + nextProps.className + " " + appliedClassesArray.join(" ");
                } // First process editor value, as it may create a new session (see issue #300)
                if (this.editor && this.editor.getValue() !== nextProps.value) {
                    // editor.setValue is a synchronous function call, change event is emitted before setValue return.
                    this.silent = true;
                    var pos = this.editor.session.selection.toJSON();
                    this.editor.setValue(nextProps.value, nextProps.cursorStart);
                    this.editor.session.selection.fromJSON(pos);
                    this.silent = false;
                }
                if (nextProps.placeholder !== oldProps.placeholder) this.updatePlaceholder();
                if (nextProps.mode !== oldProps.mode) this.editor.getSession().setMode("ace/mode/" + nextProps.mode);
                if (nextProps.theme !== oldProps.theme) this.editor.setTheme("ace/theme/" + nextProps.theme);
                if (nextProps.keyboardHandler !== oldProps.keyboardHandler) {
                    if (nextProps.keyboardHandler) this.editor.setKeyboardHandler("ace/keyboard/" + nextProps.keyboardHandler);
                    else this.editor.setKeyboardHandler(null);
                }
                if (nextProps.fontSize !== oldProps.fontSize) this.editor.setFontSize(nextProps.fontSize);
                if (nextProps.wrapEnabled !== oldProps.wrapEnabled) this.editor.getSession().setUseWrapMode(nextProps.wrapEnabled);
                if (nextProps.showPrintMargin !== oldProps.showPrintMargin) this.editor.setShowPrintMargin(nextProps.showPrintMargin);
                if (nextProps.showGutter !== oldProps.showGutter) this.editor.renderer.setShowGutter(nextProps.showGutter);
                if (!(0, $df40db6a42a47b61$var$_lodash["default"])(nextProps.setOptions, oldProps.setOptions)) this.handleOptions(nextProps);
                if (!(0, $df40db6a42a47b61$var$_lodash["default"])(nextProps.annotations, oldProps.annotations)) this.editor.getSession().setAnnotations(nextProps.annotations || []);
                if (!(0, $df40db6a42a47b61$var$_lodash["default"])(nextProps.markers, oldProps.markers) && Array.isArray(nextProps.markers)) this.handleMarkers(nextProps.markers);
                 // this doesn't look like it works at all....
                if (!(0, $df40db6a42a47b61$var$_lodash["default"])(nextProps.scrollMargin, oldProps.scrollMargin)) this.handleScrollMargins(nextProps.scrollMargin);
                if (prevProps.height !== this.props.height || prevProps.width !== this.props.width) this.editor.resize();
                if (this.props.focus && !prevProps.focus) this.editor.focus();
            }
        },
        {
            key: "handleScrollMargins",
            value: function handleScrollMargins() {
                var margins = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [
                    0,
                    0,
                    0,
                    0
                ];
                this.editor.renderer.setScrollMargins(margins[0], margins[1], margins[2], margins[3]);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.editor.destroy();
                this.editor = null;
            }
        },
        {
            key: "onChange",
            value: function onChange(event) {
                if (this.props.onChange && !this.silent) {
                    var value = this.editor.getValue();
                    this.props.onChange(value, event);
                }
            }
        },
        {
            key: "onSelectionChange",
            value: function onSelectionChange(event) {
                if (this.props.onSelectionChange) {
                    var value = this.editor.getSelection();
                    this.props.onSelectionChange(value, event);
                }
            }
        },
        {
            key: "onCursorChange",
            value: function onCursorChange(event) {
                if (this.props.onCursorChange) {
                    var value = this.editor.getSelection();
                    this.props.onCursorChange(value, event);
                }
            }
        },
        {
            key: "onInput",
            value: function onInput(event) {
                if (this.props.onInput) this.props.onInput(event);
                if (this.props.placeholder) this.updatePlaceholder();
            }
        },
        {
            key: "onFocus",
            value: function onFocus(event) {
                if (this.props.onFocus) this.props.onFocus(event, this.editor);
            }
        },
        {
            key: "onBlur",
            value: function onBlur(event) {
                if (this.props.onBlur) this.props.onBlur(event, this.editor);
            }
        },
        {
            key: "onCopy",
            value: function onCopy(text) {
                if (this.props.onCopy) this.props.onCopy(text);
            }
        },
        {
            key: "onPaste",
            value: function onPaste(text) {
                if (this.props.onPaste) this.props.onPaste(text);
            }
        },
        {
            key: "onScroll",
            value: function onScroll() {
                if (this.props.onScroll) this.props.onScroll(this.editor);
            }
        },
        {
            key: "handleOptions",
            value: function handleOptions(props) {
                var setOptions = Object.keys(props.setOptions);
                for(var y = 0; y < setOptions.length; y++)this.editor.setOption(setOptions[y], props.setOptions[setOptions[y]]);
            }
        },
        {
            key: "handleMarkers",
            value: function handleMarkers(markers) {
                var _this3 = this;
                // remove foreground markers
                var currentMarkers = this.editor.getSession().getMarkers(true);
                for(var i in currentMarkers)if (currentMarkers.hasOwnProperty(i)) this.editor.getSession().removeMarker(currentMarkers[i].id);
                 // remove background markers except active line marker and selected word marker
                currentMarkers = this.editor.getSession().getMarkers(false);
                for(var _i2 in currentMarkers)if (currentMarkers.hasOwnProperty(_i2) && currentMarkers[_i2].clazz !== "ace_active-line" && currentMarkers[_i2].clazz !== "ace_selected-word") this.editor.getSession().removeMarker(currentMarkers[_i2].id);
                 // add new markers
                markers.forEach(function(_ref) {
                    var startRow = _ref.startRow, startCol = _ref.startCol, endRow = _ref.endRow, endCol = _ref.endCol, className = _ref.className, type = _ref.type, _ref$inFront = _ref.inFront, inFront = _ref$inFront === void 0 ? false : _ref$inFront;
                    var range = new $df40db6a42a47b61$var$Range(startRow, startCol, endRow, endCol);
                    _this3.editor.getSession().addMarker(range, className, type, inFront);
                });
            }
        },
        {
            key: "updatePlaceholder",
            value: function updatePlaceholder() {
                // Adapted from https://stackoverflow.com/questions/26695708/how-can-i-add-placeholder-text-when-the-editor-is-empty
                var editor = this.editor;
                var placeholder = this.props.placeholder;
                var showPlaceholder = !editor.session.getValue().length;
                var node = editor.renderer.placeholderNode;
                if (!showPlaceholder && node) {
                    editor.renderer.scroller.removeChild(editor.renderer.placeholderNode);
                    editor.renderer.placeholderNode = null;
                } else if (showPlaceholder && !node) {
                    node = editor.renderer.placeholderNode = document.createElement("div");
                    node.textContent = placeholder || "";
                    node.className = "ace_comment ace_placeholder";
                    node.style.padding = "0 9px";
                    node.style.position = "absolute";
                    node.style.zIndex = "3";
                    editor.renderer.scroller.appendChild(node);
                } else if (showPlaceholder && node) node.textContent = placeholder;
            }
        },
        {
            key: "updateRef",
            value: function updateRef(item) {
                this.refEditor = item;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, name = _this$props2.name, width = _this$props2.width, height = _this$props2.height, style = _this$props2.style;
                var divStyle = $df40db6a42a47b61$var$_objectSpread({
                    width: width,
                    height: height
                }, style);
                return $df40db6a42a47b61$var$_react["default"].createElement("div", {
                    ref: this.updateRef,
                    id: name,
                    style: divStyle
                });
            }
        }
    ]);
    return ReactAce;
}($df40db6a42a47b61$var$_react.Component);
module.exports["default"] = $df40db6a42a47b61$var$ReactAce;
$df40db6a42a47b61$var$ReactAce.propTypes = {
    mode: $df40db6a42a47b61$var$_propTypes["default"].string,
    focus: $df40db6a42a47b61$var$_propTypes["default"].bool,
    theme: $df40db6a42a47b61$var$_propTypes["default"].string,
    name: $df40db6a42a47b61$var$_propTypes["default"].string,
    className: $df40db6a42a47b61$var$_propTypes["default"].string,
    height: $df40db6a42a47b61$var$_propTypes["default"].string,
    width: $df40db6a42a47b61$var$_propTypes["default"].string,
    fontSize: $df40db6a42a47b61$var$_propTypes["default"].oneOfType([
        $df40db6a42a47b61$var$_propTypes["default"].number,
        $df40db6a42a47b61$var$_propTypes["default"].string
    ]),
    showGutter: $df40db6a42a47b61$var$_propTypes["default"].bool,
    onChange: $df40db6a42a47b61$var$_propTypes["default"].func,
    onCopy: $df40db6a42a47b61$var$_propTypes["default"].func,
    onPaste: $df40db6a42a47b61$var$_propTypes["default"].func,
    onFocus: $df40db6a42a47b61$var$_propTypes["default"].func,
    onInput: $df40db6a42a47b61$var$_propTypes["default"].func,
    onBlur: $df40db6a42a47b61$var$_propTypes["default"].func,
    onScroll: $df40db6a42a47b61$var$_propTypes["default"].func,
    value: $df40db6a42a47b61$var$_propTypes["default"].string,
    defaultValue: $df40db6a42a47b61$var$_propTypes["default"].string,
    onLoad: $df40db6a42a47b61$var$_propTypes["default"].func,
    onSelectionChange: $df40db6a42a47b61$var$_propTypes["default"].func,
    onCursorChange: $df40db6a42a47b61$var$_propTypes["default"].func,
    onBeforeLoad: $df40db6a42a47b61$var$_propTypes["default"].func,
    onValidate: $df40db6a42a47b61$var$_propTypes["default"].func,
    minLines: $df40db6a42a47b61$var$_propTypes["default"].number,
    maxLines: $df40db6a42a47b61$var$_propTypes["default"].number,
    readOnly: $df40db6a42a47b61$var$_propTypes["default"].bool,
    highlightActiveLine: $df40db6a42a47b61$var$_propTypes["default"].bool,
    tabSize: $df40db6a42a47b61$var$_propTypes["default"].number,
    showPrintMargin: $df40db6a42a47b61$var$_propTypes["default"].bool,
    cursorStart: $df40db6a42a47b61$var$_propTypes["default"].number,
    debounceChangePeriod: $df40db6a42a47b61$var$_propTypes["default"].number,
    editorProps: $df40db6a42a47b61$var$_propTypes["default"].object,
    setOptions: $df40db6a42a47b61$var$_propTypes["default"].object,
    style: $df40db6a42a47b61$var$_propTypes["default"].object,
    scrollMargin: $df40db6a42a47b61$var$_propTypes["default"].array,
    annotations: $df40db6a42a47b61$var$_propTypes["default"].array,
    markers: $df40db6a42a47b61$var$_propTypes["default"].array,
    keyboardHandler: $df40db6a42a47b61$var$_propTypes["default"].string,
    wrapEnabled: $df40db6a42a47b61$var$_propTypes["default"].bool,
    enableBasicAutocompletion: $df40db6a42a47b61$var$_propTypes["default"].oneOfType([
        $df40db6a42a47b61$var$_propTypes["default"].bool,
        $df40db6a42a47b61$var$_propTypes["default"].array
    ]),
    enableLiveAutocompletion: $df40db6a42a47b61$var$_propTypes["default"].oneOfType([
        $df40db6a42a47b61$var$_propTypes["default"].bool,
        $df40db6a42a47b61$var$_propTypes["default"].array
    ]),
    navigateToFileEnd: $df40db6a42a47b61$var$_propTypes["default"].bool,
    commands: $df40db6a42a47b61$var$_propTypes["default"].array,
    placeholder: $df40db6a42a47b61$var$_propTypes["default"].string
};
$df40db6a42a47b61$var$ReactAce.defaultProps = {
    name: "brace-editor",
    focus: false,
    mode: "",
    theme: "",
    height: "500px",
    width: "500px",
    value: "",
    fontSize: 12,
    showGutter: true,
    onChange: null,
    onPaste: null,
    onLoad: null,
    onScroll: null,
    minLines: null,
    maxLines: null,
    readOnly: false,
    highlightActiveLine: true,
    showPrintMargin: true,
    tabSize: 4,
    cursorStart: 1,
    editorProps: {},
    style: {},
    scrollMargin: [
        0,
        0,
        0,
        0
    ],
    setOptions: {},
    wrapEnabled: false,
    enableBasicAutocompletion: false,
    enableLiveAutocompletion: false,
    placeholder: null,
    navigateToFileEnd: true
};

});
parcelRegister("iljZL", function(module, exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, 'DataView'), Map = getNative(root, 'Map'), Promise = getNative(root, 'Promise'), Set = getNative(root, 'Set'), WeakMap = getNative(root, 'WeakMap'), nativeCreate = getNative(Object, 'create');
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function isEqual(value, other) {
    return baseIsEqual(value, other);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = isEqual;

});

parcelRegister("Hu4Ju", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getAceInstance = module.exports.debounce = module.exports.editorEvents = module.exports.editorOptions = void 0;
var $082b589a08b85736$var$editorOptions = [
    'minLines',
    'maxLines',
    'readOnly',
    'highlightActiveLine',
    'tabSize',
    'enableBasicAutocompletion',
    'enableLiveAutocompletion',
    'enableSnippets'
];
module.exports.editorOptions = $082b589a08b85736$var$editorOptions;
var $082b589a08b85736$var$editorEvents = [
    'onChange',
    'onFocus',
    'onInput',
    'onBlur',
    'onCopy',
    'onPaste',
    'onSelectionChange',
    'onCursorChange',
    'onScroll',
    'handleOptions',
    'updateRef'
];
module.exports.editorEvents = $082b589a08b85736$var$editorEvents;

var $082b589a08b85736$var$getAceInstance = function getAceInstance() {
    var ace; // Fallback for ace.require when vanilla ACE is hosted over a CDN
    if (window.ace) {
        ace = window.ace;
        ace.acequire = window.ace.require || window.ace.acequire;
    } else ace = (parcelRequire("j9Ter"));
    return ace;
};
module.exports.getAceInstance = $082b589a08b85736$var$getAceInstance;
var $082b589a08b85736$var$debounce = function debounce(fn, delay) {
    var timer = null;
    return function() {
        var context = this, args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function() {
            fn.apply(context, args);
        }, delay);
    };
};
module.exports.debounce = $082b589a08b85736$var$debounce;

});
parcelRegister("j9Ter", function(module, exports) {
/* ***** BEGIN LICENSE BLOCK *****
 * Distributed under the BSD license:
 *
 * Copyright (c) 2010, Ajax.org B.V.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *     * Redistributions of source code must retain the above copyright
 *       notice, this list of conditions and the following disclaimer.
 *     * Redistributions in binary form must reproduce the above copyright
 *       notice, this list of conditions and the following disclaimer in the
 *       documentation and/or other materials provided with the distribution.
 *     * Neither the name of Ajax.org B.V. nor the
 *       names of its contributors may be used to endorse or promote products
 *       derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL AJAX.ORG B.V. BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * ***** END LICENSE BLOCK ***** */ /**
 * Define a module along with a payload
 * @param module a name for the payload
 * @param payload a function to call with (acequire, exports, module) params
 */ (function() {
    var ACE_NAMESPACE = "ace";
    var global = function() {
        return this;
    }();
    if (!global && typeof window != "undefined") global = window; // strict mode
    if (!ACE_NAMESPACE && typeof acequirejs !== "undefined") return;
    var define1 = function(module1, deps, payload) {
        if (typeof module1 !== "string") {
            if (define1.original) define1.original.apply(this, arguments);
            else {
                console.error("dropping module because define wasn\'t a string.");
                console.trace();
            }
            return;
        }
        if (arguments.length == 2) payload = deps;
        if (!define1.modules[module1]) {
            define1.payloads[module1] = payload;
            define1.modules[module1] = null;
        }
    };
    define1.modules = {};
    define1.payloads = {};
    /**
 * Get at functionality define()ed using the function above
 */ var _acequire = function(parentId, module1, callback) {
        if (typeof module1 === "string") {
            var payload = lookup(parentId, module1);
            if (payload != undefined) {
                callback && callback();
                return payload;
            }
        } else if (Object.prototype.toString.call(module1) === "[object Array]") {
            var params = [];
            for(var i = 0, l = module1.length; i < l; ++i){
                var dep = lookup(parentId, module1[i]);
                if (dep == undefined && acequire.original) return;
                params.push(dep);
            }
            return callback && callback.apply(null, params) || true;
        }
    };
    var acequire = function(module1, callback) {
        var packagedModule = _acequire("", module1, callback);
        if (packagedModule == undefined && acequire.original) return acequire.original.apply(this, arguments);
        return packagedModule;
    };
    var normalizeModule = function(parentId, moduleName) {
        // normalize plugin acequires
        if (moduleName.indexOf("!") !== -1) {
            var chunks = moduleName.split("!");
            return normalizeModule(parentId, chunks[0]) + "!" + normalizeModule(parentId, chunks[1]);
        }
        // normalize relative acequires
        if (moduleName.charAt(0) == ".") {
            var base = parentId.split("/").slice(0, -1).join("/");
            moduleName = base + "/" + moduleName;
            while(moduleName.indexOf(".") !== -1 && previous != moduleName){
                var previous = moduleName;
                moduleName = moduleName.replace(/\/\.\//, "/").replace(/[^\/]+\/\.\.\//, "");
            }
        }
        return moduleName;
    };
    /**
 * Internal function to lookup moduleNames and resolve them by calling the
 * definition function if needed.
 */ var lookup = function(parentId, moduleName) {
        moduleName = normalizeModule(parentId, moduleName);
        var module1 = define1.modules[moduleName];
        if (!module1) {
            module1 = define1.payloads[moduleName];
            if (typeof module1 === 'function') {
                var exports = {};
                var mod = {
                    id: moduleName,
                    uri: '',
                    exports: exports,
                    packaged: true
                };
                var req = function(module1, callback) {
                    return _acequire(moduleName, module1, callback);
                };
                var returnValue = module1(req, exports, mod);
                exports = returnValue || mod.exports;
                define1.modules[moduleName] = exports;
                delete define1.payloads[moduleName];
            }
            module1 = define1.modules[moduleName] = exports || module1;
        }
        return module1;
    };
    function exportAce(ns) {
        var root = global;
        if (ns) {
            if (!global[ns]) global[ns] = {};
            root = global[ns];
        }
        if (!root.define || !root.define.packaged) {
            define1.original = root.define;
            root.define = define1;
            root.define.packaged = true;
        }
        if (!root.acequire || !root.acequire.packaged) {
            acequire.original = root.acequire;
            root.acequire = acequire;
            root.acequire.packaged = true;
        }
    }
    exportAce(ACE_NAMESPACE);
})();
ace.define("ace/lib/regexp", [
    "require",
    "exports",
    "module"
], function(acequire, exports, module1) {
    "use strict";
    var real = {
        exec: RegExp.prototype.exec,
        test: RegExp.prototype.test,
        match: String.prototype.match,
        replace: String.prototype.replace,
        split: String.prototype.split
    }, compliantExecNpcg = real.exec.call(/()??/, "")[1] === undefined, compliantLastIndexIncrement = function() {
        var x = /^/g;
        real.test.call(x, "");
        return !x.lastIndex;
    }();
    if (compliantLastIndexIncrement && compliantExecNpcg) return;
    RegExp.prototype.exec = function(str) {
        var match = real.exec.apply(this, arguments), name, r2;
        if (typeof str == 'string' && match) {
            if (!compliantExecNpcg && match.length > 1 && indexOf(match, "") > -1) {
                r2 = RegExp(this.source, real.replace.call(getNativeFlags(this), "g", ""));
                real.replace.call(str.slice(match.index), r2, function() {
                    for(var i = 1; i < arguments.length - 2; i++)if (arguments[i] === undefined) match[i] = undefined;
                });
            }
            if (this._xregexp && this._xregexp.captureNames) for(var i = 1; i < match.length; i++){
                name = this._xregexp.captureNames[i - 1];
                if (name) match[name] = match[i];
            }
            if (!compliantLastIndexIncrement && this.global && !match[0].length && this.lastIndex > match.index) this.lastIndex--;
        }
        return match;
    };
    if (!compliantLastIndexIncrement) RegExp.prototype.test = function(str) {
        var match = real.exec.call(this, str);
        if (match && this.global && !match[0].length && this.lastIndex > match.index) this.lastIndex--;
        return !!match;
    };
    function getNativeFlags(regex) {
        return (regex.global ? "g" : "") + (regex.ignoreCase ? "i" : "") + (regex.multiline ? "m" : "") + (regex.extended ? "x" : "") + // Proposed for ES4; included in AS3
        (regex.sticky ? "y" : "");
    }
    function indexOf(array, item, from) {
        if (Array.prototype.indexOf) return array.indexOf(item, from);
        for(var i = from || 0; i < array.length; i++){
            if (array[i] === item) return i;
        }
        return -1;
    }
});
ace.define("ace/lib/es5-shim", [
    "require",
    "exports",
    "module"
], function(acequire, exports, module1) {
    function Empty() {}
    if (!Function.prototype.bind) Function.prototype.bind = function bind(that) {
        var target = this;
        if (typeof target != "function") throw new TypeError("Function.prototype.bind called on incompatible " + target);
        var args = slice.call(arguments, 1); // for normal call
        var bound = function() {
            if (this instanceof bound) {
                var result = target.apply(this, args.concat(slice.call(arguments)));
                if (Object(result) === result) return result;
                return this;
            } else return target.apply(that, args.concat(slice.call(arguments)));
        };
        if (target.prototype) {
            Empty.prototype = target.prototype;
            bound.prototype = new Empty();
            Empty.prototype = null;
        }
        return bound;
    };
    var call = Function.prototype.call;
    var prototypeOfArray = Array.prototype;
    var prototypeOfObject = Object.prototype;
    var slice = prototypeOfArray.slice;
    var _toString = call.bind(prototypeOfObject.toString);
    var owns = call.bind(prototypeOfObject.hasOwnProperty);
    var defineGetter;
    var defineSetter;
    var lookupGetter;
    var lookupSetter;
    var supportsAccessors;
    if (supportsAccessors = owns(prototypeOfObject, "__defineGetter__")) {
        defineGetter = call.bind(prototypeOfObject.__defineGetter__);
        defineSetter = call.bind(prototypeOfObject.__defineSetter__);
        lookupGetter = call.bind(prototypeOfObject.__lookupGetter__);
        lookupSetter = call.bind(prototypeOfObject.__lookupSetter__);
    }
    if ([
        1,
        2
    ].splice(0).length != 2) {
        if (function() {
            function makeArray(l) {
                var a = new Array(l + 2);
                a[0] = a[1] = 0;
                return a;
            }
            var array = [], lengthBefore;
            array.splice.apply(array, makeArray(20));
            array.splice.apply(array, makeArray(26));
            lengthBefore = array.length; //46
            array.splice(5, 0, "XXX"); // add one element
            array.length;
            if (lengthBefore + 1 == array.length) return true; // has right splice implementation without bugs
        }()) {
            var array_splice = Array.prototype.splice;
            Array.prototype.splice = function(start, deleteCount) {
                if (!arguments.length) return [];
                else return array_splice.apply(this, [
                    start === void 0 ? 0 : start,
                    deleteCount === void 0 ? this.length - start : deleteCount
                ].concat(slice.call(arguments, 2)));
            };
        } else Array.prototype.splice = function(pos, removeCount) {
            var length = this.length;
            if (pos > 0) {
                if (pos > length) pos = length;
            } else if (pos == void 0) pos = 0;
            else if (pos < 0) pos = Math.max(length + pos, 0);
            if (!(pos + removeCount < length)) removeCount = length - pos;
            var removed = this.slice(pos, pos + removeCount);
            var insert = slice.call(arguments, 2);
            var add = insert.length;
            if (pos === length) {
                if (add) this.push.apply(this, insert);
            } else {
                var remove = Math.min(removeCount, length - pos);
                var tailOldPos = pos + remove;
                var tailNewPos = tailOldPos + add - remove;
                var tailCount = length - tailOldPos;
                var lengthAfterRemove = length - remove;
                if (tailNewPos < tailOldPos) for(var i = 0; i < tailCount; ++i)this[tailNewPos + i] = this[tailOldPos + i];
                else if (tailNewPos > tailOldPos) for(i = tailCount; i--;)this[tailNewPos + i] = this[tailOldPos + i];
                 // else, add == remove (nothing to do)
                if (add && pos === lengthAfterRemove) {
                    this.length = lengthAfterRemove; // truncate array
                    this.push.apply(this, insert);
                } else {
                    this.length = lengthAfterRemove + add; // reserves space
                    for(i = 0; i < add; ++i)this[pos + i] = insert[i];
                }
            }
            return removed;
        };
    }
    if (!Array.isArray) Array.isArray = function isArray(obj) {
        return _toString(obj) == "[object Array]";
    };
    var boxedString = Object("a"), splitString = boxedString[0] != "a" || !(0 in boxedString);
    if (!Array.prototype.forEach) Array.prototype.forEach = function forEach(fun /*, thisp*/ ) {
        var object = toObject(this), self = splitString && _toString(this) == "[object String]" ? this.split("") : object, thisp = arguments[1], i = -1, length = self.length >>> 0;
        if (_toString(fun) != "[object Function]") throw new TypeError(); // TODO message
        while(++i < length)if (i in self) fun.call(thisp, self[i], i, object);
    };
    if (!Array.prototype.map) Array.prototype.map = function map(fun /*, thisp*/ ) {
        var object = toObject(this), self = splitString && _toString(this) == "[object String]" ? this.split("") : object, length = self.length >>> 0, result = Array(length), thisp = arguments[1];
        if (_toString(fun) != "[object Function]") throw new TypeError(fun + " is not a function");
        for(var i = 0; i < length; i++)if (i in self) result[i] = fun.call(thisp, self[i], i, object);
        return result;
    };
    if (!Array.prototype.filter) Array.prototype.filter = function filter(fun /*, thisp */ ) {
        var object = toObject(this), self = splitString && _toString(this) == "[object String]" ? this.split("") : object, length = self.length >>> 0, result = [], value, thisp = arguments[1];
        if (_toString(fun) != "[object Function]") throw new TypeError(fun + " is not a function");
        for(var i = 0; i < length; i++)if (i in self) {
            value = self[i];
            if (fun.call(thisp, value, i, object)) result.push(value);
        }
        return result;
    };
    if (!Array.prototype.every) Array.prototype.every = function every(fun /*, thisp */ ) {
        var object = toObject(this), self = splitString && _toString(this) == "[object String]" ? this.split("") : object, length = self.length >>> 0, thisp = arguments[1];
        if (_toString(fun) != "[object Function]") throw new TypeError(fun + " is not a function");
        for(var i = 0; i < length; i++){
            if (i in self && !fun.call(thisp, self[i], i, object)) return false;
        }
        return true;
    };
    if (!Array.prototype.some) Array.prototype.some = function some(fun /*, thisp */ ) {
        var object = toObject(this), self = splitString && _toString(this) == "[object String]" ? this.split("") : object, length = self.length >>> 0, thisp = arguments[1];
        if (_toString(fun) != "[object Function]") throw new TypeError(fun + " is not a function");
        for(var i = 0; i < length; i++){
            if (i in self && fun.call(thisp, self[i], i, object)) return true;
        }
        return false;
    };
    if (!Array.prototype.reduce) Array.prototype.reduce = function reduce(fun /*, initial*/ ) {
        var object = toObject(this), self = splitString && _toString(this) == "[object String]" ? this.split("") : object, length = self.length >>> 0;
        if (_toString(fun) != "[object Function]") throw new TypeError(fun + " is not a function");
        if (!length && arguments.length == 1) throw new TypeError("reduce of empty array with no initial value");
        var i = 0;
        var result;
        if (arguments.length >= 2) result = arguments[1];
        else do {
            if (i in self) {
                result = self[i++];
                break;
            }
            if (++i >= length) throw new TypeError("reduce of empty array with no initial value");
        }while (true);
        for(; i < length; i++)if (i in self) result = fun.call(void 0, result, self[i], i, object);
        return result;
    };
    if (!Array.prototype.reduceRight) Array.prototype.reduceRight = function reduceRight(fun /*, initial*/ ) {
        var object = toObject(this), self = splitString && _toString(this) == "[object String]" ? this.split("") : object, length = self.length >>> 0;
        if (_toString(fun) != "[object Function]") throw new TypeError(fun + " is not a function");
        if (!length && arguments.length == 1) throw new TypeError("reduceRight of empty array with no initial value");
        var result, i = length - 1;
        if (arguments.length >= 2) result = arguments[1];
        else do {
            if (i in self) {
                result = self[i--];
                break;
            }
            if (--i < 0) throw new TypeError("reduceRight of empty array with no initial value");
        }while (true);
        do if (i in this) result = fun.call(void 0, result, self[i], i, object);
        while (i--);
        return result;
    };
    if (!Array.prototype.indexOf || [
        0,
        1
    ].indexOf(1, 2) != -1) Array.prototype.indexOf = function indexOf(sought /*, fromIndex */ ) {
        var self = splitString && _toString(this) == "[object String]" ? this.split("") : toObject(this), length = self.length >>> 0;
        if (!length) return -1;
        var i = 0;
        if (arguments.length > 1) i = toInteger(arguments[1]);
        i = i >= 0 ? i : Math.max(0, length + i);
        for(; i < length; i++){
            if (i in self && self[i] === sought) return i;
        }
        return -1;
    };
    if (!Array.prototype.lastIndexOf || [
        0,
        1
    ].lastIndexOf(0, -3) != -1) Array.prototype.lastIndexOf = function lastIndexOf(sought /*, fromIndex */ ) {
        var self = splitString && _toString(this) == "[object String]" ? this.split("") : toObject(this), length = self.length >>> 0;
        if (!length) return -1;
        var i = length - 1;
        if (arguments.length > 1) i = Math.min(i, toInteger(arguments[1]));
        i = i >= 0 ? i : length - Math.abs(i);
        for(; i >= 0; i--){
            if (i in self && sought === self[i]) return i;
        }
        return -1;
    };
    if (!Object.getPrototypeOf) Object.getPrototypeOf = function getPrototypeOf(object) {
        return object.__proto__ || (object.constructor ? object.constructor.prototype : prototypeOfObject);
    };
    if (!Object.getOwnPropertyDescriptor) {
        var ERR_NON_OBJECT = "Object.getOwnPropertyDescriptor called on a non-object: ";
        Object.getOwnPropertyDescriptor = function getOwnPropertyDescriptor(object, property) {
            if (typeof object != "object" && typeof object != "function" || object === null) throw new TypeError(ERR_NON_OBJECT + object);
            if (!owns(object, property)) return;
            var descriptor, getter, setter;
            descriptor = {
                enumerable: true,
                configurable: true
            };
            if (supportsAccessors) {
                var prototype = object.__proto__;
                object.__proto__ = prototypeOfObject;
                var getter = lookupGetter(object, property);
                var setter = lookupSetter(object, property);
                object.__proto__ = prototype;
                if (getter || setter) {
                    if (getter) descriptor.get = getter;
                    if (setter) descriptor.set = setter;
                    return descriptor;
                }
            }
            descriptor.value = object[property];
            return descriptor;
        };
    }
    if (!Object.getOwnPropertyNames) Object.getOwnPropertyNames = function getOwnPropertyNames(object) {
        return Object.keys(object);
    };
    if (!Object.create) {
        var createEmpty;
        if (Object.prototype.__proto__ === null) createEmpty = function() {
            return {
                "__proto__": null
            };
        };
        else createEmpty = function() {
            var empty = {};
            for(var i in empty)empty[i] = null;
            empty.constructor = empty.hasOwnProperty = empty.propertyIsEnumerable = empty.isPrototypeOf = empty.toLocaleString = empty.toString = empty.valueOf = empty.__proto__ = null;
            return empty;
        };
        Object.create = function create(prototype, properties) {
            var object;
            if (prototype === null) object = createEmpty();
            else {
                if (typeof prototype != "object") throw new TypeError("typeof prototype[" + typeof prototype + "] != 'object'");
                var Type = function() {};
                Type.prototype = prototype;
                object = new Type();
                object.__proto__ = prototype;
            }
            if (properties !== void 0) Object.defineProperties(object, properties);
            return object;
        };
    }
    function doesDefinePropertyWork(object) {
        try {
            Object.defineProperty(object, "sentinel", {});
            return "sentinel" in object;
        } catch (exception) {}
    }
    if (Object.defineProperty) {
        var definePropertyWorksOnObject = doesDefinePropertyWork({});
        var definePropertyWorksOnDom = typeof document == "undefined" || doesDefinePropertyWork(document.createElement("div"));
        if (!definePropertyWorksOnObject || !definePropertyWorksOnDom) var definePropertyFallback = Object.defineProperty;
    }
    if (!Object.defineProperty || definePropertyFallback) {
        var ERR_NON_OBJECT_DESCRIPTOR = "Property description must be an object: ";
        var ERR_NON_OBJECT_TARGET = "Object.defineProperty called on non-object: ";
        var ERR_ACCESSORS_NOT_SUPPORTED = "getters & setters can not be defined on this javascript engine";
        Object.defineProperty = function defineProperty(object, property, descriptor) {
            if (typeof object != "object" && typeof object != "function" || object === null) throw new TypeError(ERR_NON_OBJECT_TARGET + object);
            if (typeof descriptor != "object" && typeof descriptor != "function" || descriptor === null) throw new TypeError(ERR_NON_OBJECT_DESCRIPTOR + descriptor);
            if (definePropertyFallback) try {
                return definePropertyFallback.call(Object, object, property, descriptor);
            } catch (exception) {}
            if (owns(descriptor, "value")) {
                if (supportsAccessors && (lookupGetter(object, property) || lookupSetter(object, property))) {
                    var prototype = object.__proto__;
                    object.__proto__ = prototypeOfObject;
                    delete object[property];
                    object[property] = descriptor.value;
                    object.__proto__ = prototype;
                } else object[property] = descriptor.value;
            } else {
                if (!supportsAccessors) throw new TypeError(ERR_ACCESSORS_NOT_SUPPORTED);
                if (owns(descriptor, "get")) defineGetter(object, property, descriptor.get);
                if (owns(descriptor, "set")) defineSetter(object, property, descriptor.set);
            }
            return object;
        };
    }
    if (!Object.defineProperties) Object.defineProperties = function defineProperties(object, properties) {
        for(var property in properties)if (owns(properties, property)) Object.defineProperty(object, property, properties[property]);
        return object;
    };
    if (!Object.seal) Object.seal = function seal(object) {
        return object;
    };
    if (!Object.freeze) Object.freeze = function freeze(object) {
        return object;
    };
    try {
        Object.freeze(function() {});
    } catch (exception) {
        Object.freeze = function freeze(freezeObject) {
            return function freeze(object) {
                if (typeof object == "function") return object;
                else return freezeObject(object);
            };
        }(Object.freeze);
    }
    if (!Object.preventExtensions) Object.preventExtensions = function preventExtensions(object) {
        return object;
    };
    if (!Object.isSealed) Object.isSealed = function isSealed(object) {
        return false;
    };
    if (!Object.isFrozen) Object.isFrozen = function isFrozen(object) {
        return false;
    };
    if (!Object.isExtensible) Object.isExtensible = function isExtensible(object) {
        if (Object(object) === object) throw new TypeError(); // TODO message
        var name = '';
        while(owns(object, name))name += '?';
        object[name] = true;
        var returnValue = owns(object, name);
        delete object[name];
        return returnValue;
    };
    if (!Object.keys) {
        var hasDontEnumBug = true, dontEnums = [
            "toString",
            "toLocaleString",
            "valueOf",
            "hasOwnProperty",
            "isPrototypeOf",
            "propertyIsEnumerable",
            "constructor"
        ], dontEnumsLength = dontEnums.length;
        for(var key in {
            "toString": null
        })hasDontEnumBug = false;
        Object.keys = function keys(object) {
            if (typeof object != "object" && typeof object != "function" || object === null) throw new TypeError("Object.keys called on a non-object");
            var keys = [];
            for(var name in object)if (owns(object, name)) keys.push(name);
            if (hasDontEnumBug) for(var i = 0, ii = dontEnumsLength; i < ii; i++){
                var dontEnum = dontEnums[i];
                if (owns(object, dontEnum)) keys.push(dontEnum);
            }
            return keys;
        };
    }
    if (!Date.now) Date.now = function now() {
        return new Date().getTime();
    };
    var ws = "	\n\v\f\r \xa0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";
    if (!String.prototype.trim || ws.trim()) {
        ws = "[" + ws + "]";
        var trimBeginRegexp = new RegExp("^" + ws + ws + "*"), trimEndRegexp = new RegExp(ws + ws + "*$");
        String.prototype.trim = function trim() {
            return String(this).replace(trimBeginRegexp, "").replace(trimEndRegexp, "");
        };
    }
    function toInteger(n) {
        n = +n;
        if (n !== n) n = 0;
        else if (n !== 0 && n !== 1 / 0 && n !== -1 / 0) n = (n > 0 || -1) * Math.floor(Math.abs(n));
        return n;
    }
    function isPrimitive(input) {
        var type = typeof input;
        return input === null || type === "undefined" || type === "boolean" || type === "number" || type === "string";
    }
    function toPrimitive(input) {
        var val, valueOf, toString;
        if (isPrimitive(input)) return input;
        valueOf = input.valueOf;
        if (typeof valueOf === "function") {
            val = valueOf.call(input);
            if (isPrimitive(val)) return val;
        }
        toString = input.toString;
        if (typeof toString === "function") {
            val = toString.call(input);
            if (isPrimitive(val)) return val;
        }
        throw new TypeError();
    }
    var toObject = function(o) {
        if (o == null) throw new TypeError("can't convert " + o + " to object");
        return Object(o);
    };
});
ace.define("ace/lib/fixoldbrowsers", [
    "require",
    "exports",
    "module",
    "ace/lib/regexp",
    "ace/lib/es5-shim"
], function(acequire, exports, module1) {
    "use strict";
    acequire("./regexp");
    acequire("./es5-shim");
});
ace.define("ace/lib/dom", [
    "require",
    "exports",
    "module"
], function(acequire, exports, module1) {
    "use strict";
    var XHTML_NS = "http://www.w3.org/1999/xhtml";
    exports.getDocumentHead = function(doc) {
        if (!doc) doc = document;
        return doc.head || doc.getElementsByTagName("head")[0] || doc.documentElement;
    };
    exports.createElement = function(tag, ns) {
        return document.createElementNS ? document.createElementNS(ns || XHTML_NS, tag) : document.createElement(tag);
    };
    exports.hasCssClass = function(el, name) {
        var classes = (el.className + "").split(/\s+/g);
        return classes.indexOf(name) !== -1;
    };
    exports.addCssClass = function(el, name) {
        if (!exports.hasCssClass(el, name)) el.className += " " + name;
    };
    exports.removeCssClass = function(el, name) {
        var classes = el.className.split(/\s+/g);
        while(true){
            var index = classes.indexOf(name);
            if (index == -1) break;
            classes.splice(index, 1);
        }
        el.className = classes.join(" ");
    };
    exports.toggleCssClass = function(el, name) {
        var classes = el.className.split(/\s+/g), add = true;
        while(true){
            var index = classes.indexOf(name);
            if (index == -1) break;
            add = false;
            classes.splice(index, 1);
        }
        if (add) classes.push(name);
        el.className = classes.join(" ");
        return add;
    };
    exports.setCssClass = function(node, className, include) {
        if (include) exports.addCssClass(node, className);
        else exports.removeCssClass(node, className);
    };
    exports.hasCssString = function(id, doc) {
        var index = 0, sheets;
        doc = doc || document;
        if (doc.createStyleSheet && (sheets = doc.styleSheets)) {
            while(index < sheets.length)if (sheets[index++].owningElement.id === id) return true;
        } else if (sheets = doc.getElementsByTagName("style")) {
            while(index < sheets.length)if (sheets[index++].id === id) return true;
        }
        return false;
    };
    exports.importCssString = function importCssString(cssText, id, doc) {
        doc = doc || document;
        if (id && exports.hasCssString(id, doc)) return null;
        var style;
        if (id) cssText += "\n/*# sourceURL=ace/css/" + id + " */";
        if (doc.createStyleSheet) {
            style = doc.createStyleSheet();
            style.cssText = cssText;
            if (id) style.owningElement.id = id;
        } else {
            style = exports.createElement("style");
            style.appendChild(doc.createTextNode(cssText));
            if (id) style.id = id;
            exports.getDocumentHead(doc).appendChild(style);
        }
    };
    exports.importCssStylsheet = function(uri, doc) {
        if (doc.createStyleSheet) doc.createStyleSheet(uri);
        else {
            var link = exports.createElement('link');
            link.rel = 'stylesheet';
            link.href = uri;
            exports.getDocumentHead(doc).appendChild(link);
        }
    };
    exports.getInnerWidth = function(element) {
        return parseInt(exports.computedStyle(element, "paddingLeft"), 10) + parseInt(exports.computedStyle(element, "paddingRight"), 10) + element.clientWidth;
    };
    exports.getInnerHeight = function(element) {
        return parseInt(exports.computedStyle(element, "paddingTop"), 10) + parseInt(exports.computedStyle(element, "paddingBottom"), 10) + element.clientHeight;
    };
    exports.scrollbarWidth = function(document1) {
        var inner = exports.createElement("ace_inner");
        inner.style.width = "100%";
        inner.style.minWidth = "0px";
        inner.style.height = "200px";
        inner.style.display = "block";
        var outer = exports.createElement("ace_outer");
        var style = outer.style;
        style.position = "absolute";
        style.left = "-10000px";
        style.overflow = "hidden";
        style.width = "200px";
        style.minWidth = "0px";
        style.height = "150px";
        style.display = "block";
        outer.appendChild(inner);
        var body = document1.documentElement;
        body.appendChild(outer);
        var noScrollbar = inner.offsetWidth;
        style.overflow = "scroll";
        var withScrollbar = inner.offsetWidth;
        if (noScrollbar == withScrollbar) withScrollbar = outer.clientWidth;
        body.removeChild(outer);
        return noScrollbar - withScrollbar;
    };
    if (typeof document == "undefined") {
        exports.importCssString = function() {};
        return;
    }
    if (window.pageYOffset !== undefined) {
        exports.getPageScrollTop = function() {
            return window.pageYOffset;
        };
        exports.getPageScrollLeft = function() {
            return window.pageXOffset;
        };
    } else {
        exports.getPageScrollTop = function() {
            return document.body.scrollTop;
        };
        exports.getPageScrollLeft = function() {
            return document.body.scrollLeft;
        };
    }
    if (window.getComputedStyle) exports.computedStyle = function(element, style) {
        if (style) return (window.getComputedStyle(element, "") || {})[style] || "";
        return window.getComputedStyle(element, "") || {};
    };
    else exports.computedStyle = function(element, style) {
        if (style) return element.currentStyle[style];
        return element.currentStyle;
    };
    exports.setInnerHtml = function(el, innerHtml) {
        var element = el.cloneNode(false); //document.createElement("div");
        element.innerHTML = innerHtml;
        el.parentNode.replaceChild(element, el);
        return element;
    };
    if ("textContent" in document.documentElement) {
        exports.setInnerText = function(el, innerText) {
            el.textContent = innerText;
        };
        exports.getInnerText = function(el) {
            return el.textContent;
        };
    } else {
        exports.setInnerText = function(el, innerText) {
            el.innerText = innerText;
        };
        exports.getInnerText = function(el) {
            return el.innerText;
        };
    }
    exports.getParentWindow = function(document1) {
        return document1.defaultView || document1.parentWindow;
    };
});
ace.define("ace/lib/oop", [
    "require",
    "exports",
    "module"
], function(acequire, exports, module1) {
    "use strict";
    exports.inherits = function(ctor, superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    };
    exports.mixin = function(obj, mixin) {
        for(var key in mixin)obj[key] = mixin[key];
        return obj;
    };
    exports.implement = function(proto, mixin) {
        exports.mixin(proto, mixin);
    };
});
ace.define("ace/lib/keys", [
    "require",
    "exports",
    "module",
    "ace/lib/fixoldbrowsers",
    "ace/lib/oop"
], function(acequire, exports, module1) {
    "use strict";
    acequire("./fixoldbrowsers");
    var oop = acequire("./oop");
    var Keys = function() {
        var ret = {
            MODIFIER_KEYS: {
                16: 'Shift',
                17: 'Ctrl',
                18: 'Alt',
                224: 'Meta'
            },
            KEY_MODS: {
                "ctrl": 1,
                "alt": 2,
                "option": 2,
                "shift": 4,
                "super": 8,
                "meta": 8,
                "command": 8,
                "cmd": 8
            },
            FUNCTION_KEYS: {
                8: "Backspace",
                9: "Tab",
                13: "Return",
                19: "Pause",
                27: "Esc",
                32: "Space",
                33: "PageUp",
                34: "PageDown",
                35: "End",
                36: "Home",
                37: "Left",
                38: "Up",
                39: "Right",
                40: "Down",
                44: "Print",
                45: "Insert",
                46: "Delete",
                96: "Numpad0",
                97: "Numpad1",
                98: "Numpad2",
                99: "Numpad3",
                100: "Numpad4",
                101: "Numpad5",
                102: "Numpad6",
                103: "Numpad7",
                104: "Numpad8",
                105: "Numpad9",
                '-13': "NumpadEnter",
                112: "F1",
                113: "F2",
                114: "F3",
                115: "F4",
                116: "F5",
                117: "F6",
                118: "F7",
                119: "F8",
                120: "F9",
                121: "F10",
                122: "F11",
                123: "F12",
                144: "Numlock",
                145: "Scrolllock"
            },
            PRINTABLE_KEYS: {
                32: ' ',
                48: '0',
                49: '1',
                50: '2',
                51: '3',
                52: '4',
                53: '5',
                54: '6',
                55: '7',
                56: '8',
                57: '9',
                59: ';',
                61: '=',
                65: 'a',
                66: 'b',
                67: 'c',
                68: 'd',
                69: 'e',
                70: 'f',
                71: 'g',
                72: 'h',
                73: 'i',
                74: 'j',
                75: 'k',
                76: 'l',
                77: 'm',
                78: 'n',
                79: 'o',
                80: 'p',
                81: 'q',
                82: 'r',
                83: 's',
                84: 't',
                85: 'u',
                86: 'v',
                87: 'w',
                88: 'x',
                89: 'y',
                90: 'z',
                107: '+',
                109: '-',
                110: '.',
                186: ';',
                187: '=',
                188: ',',
                189: '-',
                190: '.',
                191: '/',
                192: '`',
                219: '[',
                220: '\\',
                221: ']',
                222: "'",
                111: '/',
                106: '*'
            }
        };
        var name, i;
        for(i in ret.FUNCTION_KEYS){
            name = ret.FUNCTION_KEYS[i].toLowerCase();
            ret[name] = parseInt(i, 10);
        }
        for(i in ret.PRINTABLE_KEYS){
            name = ret.PRINTABLE_KEYS[i].toLowerCase();
            ret[name] = parseInt(i, 10);
        }
        oop.mixin(ret, ret.MODIFIER_KEYS);
        oop.mixin(ret, ret.PRINTABLE_KEYS);
        oop.mixin(ret, ret.FUNCTION_KEYS);
        ret.enter = ret["return"];
        ret.escape = ret.esc;
        ret.del = ret["delete"];
        ret[173] = '-';
        (function() {
            var mods = [
                "cmd",
                "ctrl",
                "alt",
                "shift"
            ];
            for(var i = Math.pow(2, mods.length); i--;)ret.KEY_MODS[i] = mods.filter(function(x) {
                return i & ret.KEY_MODS[x];
            }).join("-") + "-";
        })();
        ret.KEY_MODS[0] = "";
        ret.KEY_MODS[-1] = "input-";
        return ret;
    }();
    oop.mixin(exports, Keys);
    exports.keyCodeToString = function(keyCode) {
        var keyString = Keys[keyCode];
        if (typeof keyString != "string") keyString = String.fromCharCode(keyCode);
        return keyString.toLowerCase();
    };
});
ace.define("ace/lib/useragent", [
    "require",
    "exports",
    "module"
], function(acequire, exports, module1) {
    "use strict";
    exports.OS = {
        LINUX: "LINUX",
        MAC: "MAC",
        WINDOWS: "WINDOWS"
    };
    exports.getOS = function() {
        if (exports.isMac) return exports.OS.MAC;
        else if (exports.isLinux) return exports.OS.LINUX;
        else return exports.OS.WINDOWS;
    };
    if (typeof navigator != "object") return;
    var os = (navigator.platform.match(/mac|win|linux/i) || [
        "other"
    ])[0].toLowerCase();
    var ua = navigator.userAgent;
    exports.isWin = os == "win";
    exports.isMac = os == "mac";
    exports.isLinux = os == "linux";
    exports.isIE = navigator.appName == "Microsoft Internet Explorer" || navigator.appName.indexOf("MSAppHost") >= 0 ? parseFloat((ua.match(/(?:MSIE |Trident\/[0-9]+[\.0-9]+;.*rv:)([0-9]+[\.0-9]+)/) || [])[1]) : parseFloat((ua.match(/(?:Trident\/[0-9]+[\.0-9]+;.*rv:)([0-9]+[\.0-9]+)/) || [])[1]); // for ie
    exports.isOldIE = exports.isIE && exports.isIE < 9;
    exports.isGecko = exports.isMozilla = (window.Controllers || window.controllers) && window.navigator.product === "Gecko";
    exports.isOldGecko = exports.isGecko && parseInt((ua.match(/rv:(\d+)/) || [])[1], 10) < 4;
    exports.isOpera = window.opera && Object.prototype.toString.call(window.opera) == "[object Opera]";
    exports.isWebKit = parseFloat(ua.split("WebKit/")[1]) || undefined;
    exports.isChrome = parseFloat(ua.split(" Chrome/")[1]) || undefined;
    exports.isAIR = ua.indexOf("AdobeAIR") >= 0;
    exports.isIPad = ua.indexOf("iPad") >= 0;
    exports.isChromeOS = ua.indexOf(" CrOS ") >= 0;
    exports.isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
    if (exports.isIOS) exports.isMac = true;
});
ace.define("ace/lib/event", [
    "require",
    "exports",
    "module",
    "ace/lib/keys",
    "ace/lib/useragent"
], function(acequire, exports, module1) {
    "use strict";
    var keys = acequire("./keys");
    var useragent = acequire("./useragent");
    var pressedKeys = null;
    var ts = 0;
    exports.addListener = function(elem, type, callback) {
        if (elem.addEventListener) return elem.addEventListener(type, callback, false);
        if (elem.attachEvent) {
            var wrapper = function() {
                callback.call(elem, window.event);
            };
            callback._wrapper = wrapper;
            elem.attachEvent("on" + type, wrapper);
        }
    };
    exports.removeListener = function(elem, type, callback) {
        if (elem.removeEventListener) return elem.removeEventListener(type, callback, false);
        if (elem.detachEvent) elem.detachEvent("on" + type, callback._wrapper || callback);
    };
    exports.stopEvent = function(e) {
        exports.stopPropagation(e);
        exports.preventDefault(e);
        return false;
    };
    exports.stopPropagation = function(e) {
        if (e.stopPropagation) e.stopPropagation();
        else e.cancelBubble = true;
    };
    exports.preventDefault = function(e) {
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
    };
    exports.getButton = function(e) {
        if (e.type == "dblclick") return 0;
        if (e.type == "contextmenu" || useragent.isMac && e.ctrlKey && !e.altKey && !e.shiftKey) return 2;
        if (e.preventDefault) return e.button;
        else return ({
            1: 0,
            2: 2,
            4: 1
        })[e.button];
    };
    exports.capture = function(el, eventHandler, releaseCaptureHandler) {
        function onMouseUp(e) {
            eventHandler && eventHandler(e);
            releaseCaptureHandler && releaseCaptureHandler(e);
            exports.removeListener(document, "mousemove", eventHandler, true);
            exports.removeListener(document, "mouseup", onMouseUp, true);
            exports.removeListener(document, "dragstart", onMouseUp, true);
        }
        exports.addListener(document, "mousemove", eventHandler, true);
        exports.addListener(document, "mouseup", onMouseUp, true);
        exports.addListener(document, "dragstart", onMouseUp, true);
        return onMouseUp;
    };
    exports.addTouchMoveListener = function(el, callback) {
        var startx, starty;
        exports.addListener(el, "touchstart", function(e) {
            var touches = e.touches;
            var touchObj = touches[0];
            startx = touchObj.clientX;
            starty = touchObj.clientY;
        });
        exports.addListener(el, "touchmove", function(e) {
            var touches = e.touches;
            if (touches.length > 1) return;
            var touchObj = touches[0];
            e.wheelX = startx - touchObj.clientX;
            e.wheelY = starty - touchObj.clientY;
            startx = touchObj.clientX;
            starty = touchObj.clientY;
            callback(e);
        });
    };
    exports.addMouseWheelListener = function(el, callback) {
        if ("onmousewheel" in el) exports.addListener(el, "mousewheel", function(e) {
            var factor = 8;
            if (e.wheelDeltaX !== undefined) {
                e.wheelX = -e.wheelDeltaX / factor;
                e.wheelY = -e.wheelDeltaY / factor;
            } else {
                e.wheelX = 0;
                e.wheelY = -e.wheelDelta / factor;
            }
            callback(e);
        });
        else if ("onwheel" in el) exports.addListener(el, "wheel", function(e) {
            var factor = 0.35;
            switch(e.deltaMode){
                case e.DOM_DELTA_PIXEL:
                    e.wheelX = e.deltaX * factor || 0;
                    e.wheelY = e.deltaY * factor || 0;
                    break;
                case e.DOM_DELTA_LINE:
                case e.DOM_DELTA_PAGE:
                    e.wheelX = (e.deltaX || 0) * 5;
                    e.wheelY = (e.deltaY || 0) * 5;
                    break;
            }
            callback(e);
        });
        else exports.addListener(el, "DOMMouseScroll", function(e) {
            if (e.axis && e.axis == e.HORIZONTAL_AXIS) {
                e.wheelX = (e.detail || 0) * 5;
                e.wheelY = 0;
            } else {
                e.wheelX = 0;
                e.wheelY = (e.detail || 0) * 5;
            }
            callback(e);
        });
    };
    exports.addMultiMouseDownListener = function(elements, timeouts, eventHandler, callbackName) {
        var clicks = 0;
        var startX, startY, timer;
        var eventNames = {
            2: "dblclick",
            3: "tripleclick",
            4: "quadclick"
        };
        function onMousedown(e) {
            if (exports.getButton(e) !== 0) clicks = 0;
            else if (e.detail > 1) {
                clicks++;
                if (clicks > 4) clicks = 1;
            } else clicks = 1;
            if (useragent.isIE) {
                var isNewClick = Math.abs(e.clientX - startX) > 5 || Math.abs(e.clientY - startY) > 5;
                if (!timer || isNewClick) clicks = 1;
                if (timer) clearTimeout(timer);
                timer = setTimeout(function() {
                    timer = null;
                }, timeouts[clicks - 1] || 600);
                if (clicks == 1) {
                    startX = e.clientX;
                    startY = e.clientY;
                }
            }
            e._clicks = clicks;
            eventHandler[callbackName]("mousedown", e);
            if (clicks > 4) clicks = 0;
            else if (clicks > 1) return eventHandler[callbackName](eventNames[clicks], e);
        }
        function onDblclick(e) {
            clicks = 2;
            if (timer) clearTimeout(timer);
            timer = setTimeout(function() {
                timer = null;
            }, timeouts[clicks - 1] || 600);
            eventHandler[callbackName]("mousedown", e);
            eventHandler[callbackName](eventNames[clicks], e);
        }
        if (!Array.isArray(elements)) elements = [
            elements
        ];
        elements.forEach(function(el) {
            exports.addListener(el, "mousedown", onMousedown);
            if (useragent.isOldIE) exports.addListener(el, "dblclick", onDblclick);
        });
    };
    var getModifierHash = useragent.isMac && useragent.isOpera && !("KeyboardEvent" in window) ? function(e) {
        return 0 | (e.metaKey ? 1 : 0) | (e.altKey ? 2 : 0) | (e.shiftKey ? 4 : 0) | (e.ctrlKey ? 8 : 0);
    } : function(e) {
        return 0 | (e.ctrlKey ? 1 : 0) | (e.altKey ? 2 : 0) | (e.shiftKey ? 4 : 0) | (e.metaKey ? 8 : 0);
    };
    exports.getModifierString = function(e) {
        return keys.KEY_MODS[getModifierHash(e)];
    };
    function normalizeCommandKeys(callback, e, keyCode) {
        var hashId = getModifierHash(e);
        if (!useragent.isMac && pressedKeys) {
            if (e.getModifierState && (e.getModifierState("OS") || e.getModifierState("Win"))) hashId |= 8;
            if (pressedKeys.altGr) {
                if ((3 & hashId) != 3) pressedKeys.altGr = 0;
                else return;
            }
            if (keyCode === 18 || keyCode === 17) {
                var location = "location" in e ? e.location : e.keyLocation;
                if (keyCode === 17 && location === 1) {
                    if (pressedKeys[keyCode] == 1) ts = e.timeStamp;
                } else if (keyCode === 18 && hashId === 3 && location === 2) {
                    var dt = e.timeStamp - ts;
                    if (dt < 50) pressedKeys.altGr = true;
                }
            }
        }
        if (keyCode in keys.MODIFIER_KEYS) keyCode = -1;
        if (hashId & 8 && keyCode >= 91 && keyCode <= 93) keyCode = -1;
        if (!hashId && keyCode === 13) {
            var location = "location" in e ? e.location : e.keyLocation;
            if (location === 3) {
                callback(e, hashId, -keyCode);
                if (e.defaultPrevented) return;
            }
        }
        if (useragent.isChromeOS && hashId & 8) {
            callback(e, hashId, keyCode);
            if (e.defaultPrevented) return;
            else hashId &= -9;
        }
        if (!hashId && !(keyCode in keys.FUNCTION_KEYS) && !(keyCode in keys.PRINTABLE_KEYS)) return false;
        return callback(e, hashId, keyCode);
    }
    exports.addCommandKeyListener = function(el, callback) {
        var addListener = exports.addListener;
        if (useragent.isOldGecko || useragent.isOpera && !("KeyboardEvent" in window)) {
            var lastKeyDownKeyCode = null;
            addListener(el, "keydown", function(e) {
                lastKeyDownKeyCode = e.keyCode;
            });
            addListener(el, "keypress", function(e) {
                return normalizeCommandKeys(callback, e, lastKeyDownKeyCode);
            });
        } else {
            var lastDefaultPrevented = null;
            addListener(el, "keydown", function(e) {
                pressedKeys[e.keyCode] = (pressedKeys[e.keyCode] || 0) + 1;
                var result = normalizeCommandKeys(callback, e, e.keyCode);
                lastDefaultPrevented = e.defaultPrevented;
                return result;
            });
            addListener(el, "keypress", function(e) {
                if (lastDefaultPrevented && (e.ctrlKey || e.altKey || e.shiftKey || e.metaKey)) {
                    exports.stopEvent(e);
                    lastDefaultPrevented = null;
                }
            });
            addListener(el, "keyup", function(e) {
                pressedKeys[e.keyCode] = null;
            });
            if (!pressedKeys) {
                resetPressedKeys();
                addListener(window, "focus", resetPressedKeys);
            }
        }
    };
    function resetPressedKeys() {
        pressedKeys = Object.create(null);
    }
    if (typeof window == "object" && window.postMessage && !useragent.isOldIE) {
        var postMessageId = 1;
        exports.nextTick = function(callback, win) {
            win = win || window;
            var messageName = "zero-timeout-message-" + postMessageId;
            exports.addListener(win, "message", function listener(e) {
                if (e.data == messageName) {
                    exports.stopPropagation(e);
                    exports.removeListener(win, "message", listener);
                    callback();
                }
            });
            win.postMessage(messageName, "*");
        };
    }
    exports.nextFrame = typeof window == "object" && (window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame || window.oRequestAnimationFrame);
    if (exports.nextFrame) exports.nextFrame = exports.nextFrame.bind(window);
    else exports.nextFrame = function(callback) {
        setTimeout(callback, 17);
    };
});
ace.define("ace/lib/lang", [
    "require",
    "exports",
    "module"
], function(acequire, exports, module1) {
    "use strict";
    exports.last = function(a) {
        return a[a.length - 1];
    };
    exports.stringReverse = function(string) {
        return string.split("").reverse().join("");
    };
    exports.stringRepeat = function(string, count) {
        var result = '';
        while(count > 0){
            if (count & 1) result += string;
            if (count >>= 1) string += string;
        }
        return result;
    };
    var trimBeginRegexp = /^\s\s*/;
    var trimEndRegexp = /\s\s*$/;
    exports.stringTrimLeft = function(string) {
        return string.replace(trimBeginRegexp, '');
    };
    exports.stringTrimRight = function(string) {
        return string.replace(trimEndRegexp, '');
    };
    exports.copyObject = function(obj) {
        var copy = {};
        for(var key in obj)copy[key] = obj[key];
        return copy;
    };
    exports.copyArray = function(array) {
        var copy = [];
        for(var i = 0, l = array.length; i < l; i++)if (array[i] && typeof array[i] == "object") copy[i] = this.copyObject(array[i]);
        else copy[i] = array[i];
        return copy;
    };
    exports.deepCopy = function deepCopy(obj) {
        if (typeof obj !== "object" || !obj) return obj;
        var copy;
        if (Array.isArray(obj)) {
            copy = [];
            for(var key = 0; key < obj.length; key++)copy[key] = deepCopy(obj[key]);
            return copy;
        }
        if (Object.prototype.toString.call(obj) !== "[object Object]") return obj;
        copy = {};
        for(var key in obj)copy[key] = deepCopy(obj[key]);
        return copy;
    };
    exports.arrayToMap = function(arr) {
        var map = {};
        for(var i = 0; i < arr.length; i++)map[arr[i]] = 1;
        return map;
    };
    exports.createMap = function(props) {
        var map = Object.create(null);
        for(var i in props)map[i] = props[i];
        return map;
    };
    exports.arrayRemove = function(array, value) {
        for(var i = 0; i <= array.length; i++)if (value === array[i]) array.splice(i, 1);
    };
    exports.escapeRegExp = function(str) {
        return str.replace(/([.*+?^${}()|[\]\/\\])/g, '\\$1');
    };
    exports.escapeHTML = function(str) {
        return str.replace(/&/g, "&#38;").replace(/"/g, "&#34;").replace(/'/g, "&#39;").replace(/</g, "&#60;");
    };
    exports.getMatchOffsets = function(string, regExp) {
        var matches = [];
        string.replace(regExp, function(str) {
            matches.push({
                offset: arguments[arguments.length - 2],
                length: str.length
            });
        });
        return matches;
    };
    exports.deferredCall = function(fcn) {
        var timer = null;
        var callback = function() {
            timer = null;
            fcn();
        };
        var deferred = function(timeout) {
            deferred.cancel();
            timer = setTimeout(callback, timeout || 0);
            return deferred;
        };
        deferred.schedule = deferred;
        deferred.call = function() {
            this.cancel();
            fcn();
            return deferred;
        };
        deferred.cancel = function() {
            clearTimeout(timer);
            timer = null;
            return deferred;
        };
        deferred.isPending = function() {
            return timer;
        };
        return deferred;
    };
    exports.delayedCall = function(fcn, defaultTimeout) {
        var timer = null;
        var callback = function() {
            timer = null;
            fcn();
        };
        var _self = function(timeout) {
            if (timer == null) timer = setTimeout(callback, timeout || defaultTimeout);
        };
        _self.delay = function(timeout) {
            timer && clearTimeout(timer);
            timer = setTimeout(callback, timeout || defaultTimeout);
        };
        _self.schedule = _self;
        _self.call = function() {
            this.cancel();
            fcn();
        };
        _self.cancel = function() {
            timer && clearTimeout(timer);
            timer = null;
        };
        _self.isPending = function() {
            return timer;
        };
        return _self;
    };
});
ace.define("ace/keyboard/textinput_ios", [
    "require",
    "exports",
    "module",
    "ace/lib/event",
    "ace/lib/useragent",
    "ace/lib/dom",
    "ace/lib/lang",
    "ace/lib/keys"
], function(acequire, exports, module1) {
    "use strict";
    var event = acequire("../lib/event");
    var useragent = acequire("../lib/useragent");
    var dom = acequire("../lib/dom");
    var lang = acequire("../lib/lang");
    var KEYS = acequire("../lib/keys");
    var MODS = KEYS.KEY_MODS;
    var BROKEN_SETDATA = useragent.isChrome < 18;
    var USE_IE_MIME_TYPE = useragent.isIE;
    var TextInput = function(parentNode, host) {
        var self = this;
        var text = dom.createElement("textarea");
        text.className = useragent.isIOS ? "ace_text-input ace_text-input-ios" : "ace_text-input";
        if (useragent.isTouchPad) text.setAttribute("x-palm-disable-auto-cap", true);
        text.setAttribute("wrap", "off");
        text.setAttribute("autocorrect", "off");
        text.setAttribute("autocapitalize", "off");
        text.setAttribute("spellcheck", false);
        text.style.opacity = "0";
        parentNode.insertBefore(text, parentNode.firstChild);
        var PLACEHOLDER = "\n aaaa a\n";
        var copied = false;
        var cut = false;
        var pasted = false;
        var inComposition = false;
        var tempStyle = '';
        var isSelectionEmpty = true;
        try {
            var isFocused = document.activeElement === text;
        } catch (e) {}
        event.addListener(text, "blur", function(e) {
            host.onBlur(e);
            isFocused = false;
        });
        event.addListener(text, "focus", function(e) {
            isFocused = true;
            host.onFocus(e);
            resetSelection();
        });
        this.focus = function() {
            if (tempStyle) return text.focus();
            text.style.position = "fixed";
            text.focus();
        };
        this.blur = function() {
            text.blur();
        };
        this.isFocused = function() {
            return isFocused;
        };
        var syncSelection = lang.delayedCall(function() {
            isFocused && resetSelection(isSelectionEmpty);
        });
        var syncValue = lang.delayedCall(function() {
            if (!inComposition) {
                text.value = PLACEHOLDER;
                isFocused && resetSelection();
            }
        });
        function resetSelection(isEmpty) {
            if (inComposition) return;
            inComposition = true;
            if (inputHandler) {
                selectionStart = 0;
                selectionEnd = isEmpty ? 0 : text.value.length - 1;
            } else {
                var selectionStart = 4;
                var selectionEnd = 5;
            }
            try {
                text.setSelectionRange(selectionStart, selectionEnd);
            } catch (e) {}
            inComposition = false;
        }
        function resetValue() {
            if (inComposition) return;
            text.value = PLACEHOLDER;
            if (useragent.isWebKit) syncValue.schedule();
        }
        useragent.isWebKit || host.addEventListener('changeSelection', function() {
            if (host.selection.isEmpty() != isSelectionEmpty) {
                isSelectionEmpty = !isSelectionEmpty;
                syncSelection.schedule();
            }
        });
        resetValue();
        if (isFocused) host.onFocus();
        var isAllSelected = function(text) {
            return text.selectionStart === 0 && text.selectionEnd === text.value.length;
        };
        var onSelect = function(e) {
            if (isAllSelected(text)) {
                host.selectAll();
                resetSelection();
            } else if (inputHandler) resetSelection(host.selection.isEmpty());
        };
        var inputHandler = null;
        this.setInputHandler = function(cb) {
            inputHandler = cb;
        };
        this.getInputHandler = function() {
            return inputHandler;
        };
        var afterContextMenu = false;
        var sendText = function(data) {
            if (text.selectionStart === 4 && text.selectionEnd === 5) return;
            if (inputHandler) {
                data = inputHandler(data);
                inputHandler = null;
            }
            if (pasted) {
                resetSelection();
                if (data) host.onPaste(data);
                pasted = false;
            } else if (data == PLACEHOLDER.substr(0) && text.selectionStart === 4) {
                if (afterContextMenu) host.execCommand("del", {
                    source: "ace"
                });
                else host.execCommand("backspace", {
                    source: "ace"
                });
            } else if (!copied) {
                if (data.substring(0, 9) == PLACEHOLDER && data.length > PLACEHOLDER.length) data = data.substr(9);
                else if (data.substr(0, 4) == PLACEHOLDER.substr(0, 4)) data = data.substr(4, data.length - PLACEHOLDER.length + 1);
                else if (data.charAt(data.length - 1) == PLACEHOLDER.charAt(0)) data = data.slice(0, -1);
                if (data == PLACEHOLDER.charAt(0)) ;
                else if (data.charAt(data.length - 1) == PLACEHOLDER.charAt(0)) data = data.slice(0, -1);
                if (data) host.onTextInput(data);
            }
            if (copied) copied = false;
            if (afterContextMenu) afterContextMenu = false;
        };
        var onInput = function(e) {
            if (inComposition) return;
            var data = text.value;
            sendText(data);
            resetValue();
        };
        var handleClipboardData = function(e, data, forceIEMime) {
            var clipboardData = e.clipboardData || window.clipboardData;
            if (!clipboardData || BROKEN_SETDATA) return;
            var mime = USE_IE_MIME_TYPE || forceIEMime ? "Text" : "text/plain";
            try {
                if (data) return clipboardData.setData(mime, data) !== false;
                else return clipboardData.getData(mime);
            } catch (e) {
                if (!forceIEMime) return handleClipboardData(e, data, true);
            }
        };
        var doCopy = function(e, isCut) {
            var data = host.getCopyText();
            if (!data) return event.preventDefault(e);
            if (handleClipboardData(e, data)) {
                if (useragent.isIOS) {
                    cut = isCut;
                    text.value = "\n aa" + data + "a a\n";
                    text.setSelectionRange(4, 4 + data.length);
                    copied = {
                        value: data
                    };
                }
                isCut ? host.onCut() : host.onCopy();
                if (!useragent.isIOS) event.preventDefault(e);
            } else {
                copied = true;
                text.value = data;
                text.select();
                setTimeout(function() {
                    copied = false;
                    resetValue();
                    resetSelection();
                    isCut ? host.onCut() : host.onCopy();
                });
            }
        };
        var onCut = function(e) {
            doCopy(e, true);
        };
        var onCopy = function(e) {
            doCopy(e, false);
        };
        var onPaste = function(e) {
            var data = handleClipboardData(e);
            if (typeof data == "string") {
                if (data) host.onPaste(data, e);
                if (useragent.isIE) setTimeout(resetSelection);
                event.preventDefault(e);
            } else {
                text.value = "";
                pasted = true;
            }
        };
        event.addCommandKeyListener(text, host.onCommandKey.bind(host));
        event.addListener(text, "select", onSelect);
        event.addListener(text, "input", onInput);
        event.addListener(text, "cut", onCut);
        event.addListener(text, "copy", onCopy);
        event.addListener(text, "paste", onPaste);
        var onCompositionStart = function(e) {
            if (inComposition || !host.onCompositionStart || host.$readOnly) return;
            inComposition = {};
            inComposition.canUndo = host.session.$undoManager;
            host.onCompositionStart();
            setTimeout(onCompositionUpdate, 0);
            host.on("mousedown", onCompositionEnd);
            if (inComposition.canUndo && !host.selection.isEmpty()) {
                host.insert("");
                host.session.markUndoGroup();
                host.selection.clearSelection();
            }
            host.session.markUndoGroup();
        };
        var onCompositionUpdate = function() {
            if (!inComposition || !host.onCompositionUpdate || host.$readOnly) return;
            var val = text.value.replace(/\x01/g, "");
            if (inComposition.lastValue === val) return;
            host.onCompositionUpdate(val);
            if (inComposition.lastValue) host.undo();
            if (inComposition.canUndo) inComposition.lastValue = val;
            if (inComposition.lastValue) {
                var r = host.selection.getRange();
                host.insert(inComposition.lastValue);
                host.session.markUndoGroup();
                inComposition.range = host.selection.getRange();
                host.selection.setRange(r);
                host.selection.clearSelection();
            }
        };
        var onCompositionEnd = function(e) {
            if (!host.onCompositionEnd || host.$readOnly) return;
            var c = inComposition;
            inComposition = false;
            var timer = setTimeout(function() {
                timer = null;
                var str = text.value.replace(/\x01/g, "");
                if (inComposition) return;
                else if (str == c.lastValue) resetValue();
                else if (!c.lastValue && str) {
                    resetValue();
                    sendText(str);
                }
            });
            inputHandler = function compositionInputHandler(str) {
                if (timer) clearTimeout(timer);
                str = str.replace(/\x01/g, "");
                if (str == c.lastValue) return "";
                if (c.lastValue && timer) host.undo();
                return str;
            };
            host.onCompositionEnd();
            host.removeListener("mousedown", onCompositionEnd);
            if (e.type == "compositionend" && c.range) host.selection.setRange(c.range);
            var needsOnInput = !!useragent.isChrome && useragent.isChrome >= 53 || !!useragent.isWebKit && useragent.isWebKit >= 603;
            if (needsOnInput) onInput();
        };
        var syncComposition = lang.delayedCall(onCompositionUpdate, 50);
        event.addListener(text, "compositionstart", onCompositionStart);
        if (useragent.isGecko) event.addListener(text, "text", function() {
            syncComposition.schedule();
        });
        else {
            event.addListener(text, "keyup", function() {
                syncComposition.schedule();
            });
            event.addListener(text, "keydown", function() {
                syncComposition.schedule();
            });
        }
        event.addListener(text, "compositionend", onCompositionEnd);
        this.getElement = function() {
            return text;
        };
        this.setReadOnly = function(readOnly) {
            text.readOnly = readOnly;
        };
        this.onContextMenu = function(e) {
            afterContextMenu = true;
            resetSelection(host.selection.isEmpty());
            host._emit("nativecontextmenu", {
                target: host,
                domEvent: e
            });
            this.moveToMouse(e, true);
        };
        this.moveToMouse = function(e, bringToFront) {
            if (!tempStyle) tempStyle = text.style.cssText;
            text.style.cssText = (bringToFront ? "z-index:100000;" : "") + "height:" + text.style.height + ";" + (useragent.isIE ? "opacity:0.1;" : "");
            var rect = host.container.getBoundingClientRect();
            var style = dom.computedStyle(host.container);
            var top = rect.top + (parseInt(style.borderTopWidth) || 0);
            var left = rect.left + (parseInt(rect.borderLeftWidth) || 0);
            var maxTop = rect.bottom - top - text.clientHeight - 2;
            var move = function(e) {
                text.style.left = e.clientX - left - 2 + "px";
                text.style.top = Math.min(e.clientY - top - 2, maxTop) + "px";
            };
            move(e);
            if (e.type != "mousedown") return;
            if (host.renderer.$keepTextAreaAtCursor) host.renderer.$keepTextAreaAtCursor = null;
            clearTimeout(closeTimeout);
            if (useragent.isWin) event.capture(host.container, move, onContextMenuClose);
        };
        this.onContextMenuClose = onContextMenuClose;
        var closeTimeout;
        function onContextMenuClose() {
            clearTimeout(closeTimeout);
            closeTimeout = setTimeout(function() {
                if (tempStyle) {
                    text.style.cssText = tempStyle;
                    tempStyle = '';
                }
                if (host.renderer.$keepTextAreaAtCursor == null) {
                    host.renderer.$keepTextAreaAtCursor = true;
                    host.renderer.$moveTextAreaToCursor();
                }
            }, 0);
        }
        var onContextMenu = function(e) {
            host.textInput.onContextMenu(e);
            onContextMenuClose();
        };
        event.addListener(text, "mouseup", onContextMenu);
        event.addListener(text, "mousedown", function(e) {
            e.preventDefault();
            onContextMenuClose();
        });
        event.addListener(host.renderer.scroller, "contextmenu", onContextMenu);
        event.addListener(text, "contextmenu", onContextMenu);
        if (useragent.isIOS) {
            var typingResetTimeout = null;
            var typing = false;
            parentNode.addEventListener("keydown", function(e) {
                if (typingResetTimeout) clearTimeout(typingResetTimeout);
                typing = true;
            });
            parentNode.addEventListener("keyup", function(e) {
                typingResetTimeout = setTimeout(function() {
                    typing = false;
                }, 100);
            });
            var detectArrowKeys = function(e) {
                if (document.activeElement !== text) return;
                if (typing) return;
                if (cut) return setTimeout(function() {
                    cut = false;
                }, 100);
                var selectionStart = text.selectionStart;
                var selectionEnd = text.selectionEnd;
                text.setSelectionRange(4, 5);
                if (selectionStart == selectionEnd) switch(selectionStart){
                    case 0:
                        host.onCommandKey(null, 0, KEYS.up);
                        break;
                    case 1:
                        host.onCommandKey(null, 0, KEYS.home);
                        break;
                    case 2:
                        host.onCommandKey(null, MODS.option, KEYS.left);
                        break;
                    case 4:
                        host.onCommandKey(null, 0, KEYS.left);
                        break;
                    case 5:
                        host.onCommandKey(null, 0, KEYS.right);
                        break;
                    case 7:
                        host.onCommandKey(null, MODS.option, KEYS.right);
                        break;
                    case 8:
                        host.onCommandKey(null, 0, KEYS.end);
                        break;
                    case 9:
                        host.onCommandKey(null, 0, KEYS.down);
                        break;
                }
                else {
                    switch(selectionEnd){
                        case 6:
                            host.onCommandKey(null, MODS.shift, KEYS.right);
                            break;
                        case 7:
                            host.onCommandKey(null, MODS.shift | MODS.option, KEYS.right);
                            break;
                        case 8:
                            host.onCommandKey(null, MODS.shift, KEYS.end);
                            break;
                        case 9:
                            host.onCommandKey(null, MODS.shift, KEYS.down);
                            break;
                    }
                    switch(selectionStart){
                        case 0:
                            host.onCommandKey(null, MODS.shift, KEYS.up);
                            break;
                        case 1:
                            host.onCommandKey(null, MODS.shift, KEYS.home);
                            break;
                        case 2:
                            host.onCommandKey(null, MODS.shift | MODS.option, KEYS.left);
                            break;
                        case 3:
                            host.onCommandKey(null, MODS.shift, KEYS.left);
                            break;
                    }
                }
            };
            document.addEventListener("selectionchange", detectArrowKeys);
            host.on("destroy", function() {
                document.removeEventListener("selectionchange", detectArrowKeys);
            });
        }
    };
    exports.TextInput = TextInput;
});
ace.define("ace/keyboard/textinput", [
    "require",
    "exports",
    "module",
    "ace/lib/event",
    "ace/lib/useragent",
    "ace/lib/dom",
    "ace/lib/lang",
    "ace/keyboard/textinput_ios"
], function(acequire, exports, module1) {
    "use strict";
    var event = acequire("../lib/event");
    var useragent = acequire("../lib/useragent");
    var dom = acequire("../lib/dom");
    var lang = acequire("../lib/lang");
    var BROKEN_SETDATA = useragent.isChrome < 18;
    var USE_IE_MIME_TYPE = useragent.isIE;
    var TextInputIOS = acequire("./textinput_ios").TextInput;
    var TextInput = function(parentNode, host) {
        if (useragent.isIOS) return TextInputIOS.call(this, parentNode, host);
        var text = dom.createElement("textarea");
        text.className = "ace_text-input";
        text.setAttribute("wrap", "off");
        text.setAttribute("autocorrect", "off");
        text.setAttribute("autocapitalize", "off");
        text.setAttribute("spellcheck", false);
        text.style.opacity = "0";
        parentNode.insertBefore(text, parentNode.firstChild);
        var PLACEHOLDER = "\u2028\u2028";
        var copied = false;
        var pasted = false;
        var inComposition = false;
        var tempStyle = '';
        var isSelectionEmpty = true;
        try {
            var isFocused = document.activeElement === text;
        } catch (e) {}
        event.addListener(text, "blur", function(e) {
            host.onBlur(e);
            isFocused = false;
        });
        event.addListener(text, "focus", function(e) {
            isFocused = true;
            host.onFocus(e);
            resetSelection();
        });
        this.focus = function() {
            if (tempStyle) return text.focus();
            var top = text.style.top;
            text.style.position = "fixed";
            text.style.top = "0px";
            text.focus();
            setTimeout(function() {
                text.style.position = "";
                if (text.style.top == "0px") text.style.top = top;
            }, 0);
        };
        this.blur = function() {
            text.blur();
        };
        this.isFocused = function() {
            return isFocused;
        };
        var syncSelection = lang.delayedCall(function() {
            isFocused && resetSelection(isSelectionEmpty);
        });
        var syncValue = lang.delayedCall(function() {
            if (!inComposition) {
                text.value = PLACEHOLDER;
                isFocused && resetSelection();
            }
        });
        function resetSelection(isEmpty) {
            if (inComposition) return;
            inComposition = true;
            if (inputHandler) {
                var selectionStart = 0;
                var selectionEnd = isEmpty ? 0 : text.value.length - 1;
            } else {
                var selectionStart = isEmpty ? 2 : 1;
                var selectionEnd = 2;
            }
            try {
                text.setSelectionRange(selectionStart, selectionEnd);
            } catch (e) {}
            inComposition = false;
        }
        function resetValue() {
            if (inComposition) return;
            text.value = PLACEHOLDER;
            if (useragent.isWebKit) syncValue.schedule();
        }
        useragent.isWebKit || host.addEventListener('changeSelection', function() {
            if (host.selection.isEmpty() != isSelectionEmpty) {
                isSelectionEmpty = !isSelectionEmpty;
                syncSelection.schedule();
            }
        });
        resetValue();
        if (isFocused) host.onFocus();
        var isAllSelected = function(text) {
            return text.selectionStart === 0 && text.selectionEnd === text.value.length;
        };
        var onSelect = function(e) {
            if (copied) copied = false;
            else if (isAllSelected(text)) {
                host.selectAll();
                resetSelection();
            } else if (inputHandler) resetSelection(host.selection.isEmpty());
        };
        var inputHandler = null;
        this.setInputHandler = function(cb) {
            inputHandler = cb;
        };
        this.getInputHandler = function() {
            return inputHandler;
        };
        var afterContextMenu = false;
        var sendText = function(data) {
            if (inputHandler) {
                data = inputHandler(data);
                inputHandler = null;
            }
            if (pasted) {
                resetSelection();
                if (data) host.onPaste(data);
                pasted = false;
            } else if (data == PLACEHOLDER.charAt(0)) {
                if (afterContextMenu) host.execCommand("del", {
                    source: "ace"
                });
                else host.execCommand("backspace", {
                    source: "ace"
                });
            } else {
                if (data.substring(0, 2) == PLACEHOLDER) data = data.substr(2);
                else if (data.charAt(0) == PLACEHOLDER.charAt(0)) data = data.substr(1);
                else if (data.charAt(data.length - 1) == PLACEHOLDER.charAt(0)) data = data.slice(0, -1);
                if (data.charAt(data.length - 1) == PLACEHOLDER.charAt(0)) data = data.slice(0, -1);
                if (data) host.onTextInput(data);
            }
            if (afterContextMenu) afterContextMenu = false;
        };
        var onInput = function(e) {
            if (inComposition) return;
            var data = text.value;
            sendText(data);
            resetValue();
        };
        var handleClipboardData = function(e, data, forceIEMime) {
            var clipboardData = e.clipboardData || window.clipboardData;
            if (!clipboardData || BROKEN_SETDATA) return;
            var mime = USE_IE_MIME_TYPE || forceIEMime ? "Text" : "text/plain";
            try {
                if (data) return clipboardData.setData(mime, data) !== false;
                else return clipboardData.getData(mime);
            } catch (e) {
                if (!forceIEMime) return handleClipboardData(e, data, true);
            }
        };
        var doCopy = function(e, isCut) {
            var data = host.getCopyText();
            if (!data) return event.preventDefault(e);
            if (handleClipboardData(e, data)) {
                isCut ? host.onCut() : host.onCopy();
                event.preventDefault(e);
            } else {
                copied = true;
                text.value = data;
                text.select();
                setTimeout(function() {
                    copied = false;
                    resetValue();
                    resetSelection();
                    isCut ? host.onCut() : host.onCopy();
                });
            }
        };
        var onCut = function(e) {
            doCopy(e, true);
        };
        var onCopy = function(e) {
            doCopy(e, false);
        };
        var onPaste = function(e) {
            var data = handleClipboardData(e);
            if (typeof data == "string") {
                if (data) host.onPaste(data, e);
                if (useragent.isIE) setTimeout(resetSelection);
                event.preventDefault(e);
            } else {
                text.value = "";
                pasted = true;
            }
        };
        event.addCommandKeyListener(text, host.onCommandKey.bind(host));
        event.addListener(text, "select", onSelect);
        event.addListener(text, "input", onInput);
        event.addListener(text, "cut", onCut);
        event.addListener(text, "copy", onCopy);
        event.addListener(text, "paste", onPaste);
        if (!('oncut' in text) || !('oncopy' in text) || !('onpaste' in text)) event.addListener(parentNode, "keydown", function(e) {
            if (useragent.isMac && !e.metaKey || !e.ctrlKey) return;
            switch(e.keyCode){
                case 67:
                    onCopy(e);
                    break;
                case 86:
                    onPaste(e);
                    break;
                case 88:
                    onCut(e);
                    break;
            }
        });
        var onCompositionStart = function(e) {
            if (inComposition || !host.onCompositionStart || host.$readOnly) return;
            inComposition = {};
            inComposition.canUndo = host.session.$undoManager;
            host.onCompositionStart();
            setTimeout(onCompositionUpdate, 0);
            host.on("mousedown", onCompositionEnd);
            if (inComposition.canUndo && !host.selection.isEmpty()) {
                host.insert("");
                host.session.markUndoGroup();
                host.selection.clearSelection();
            }
            host.session.markUndoGroup();
        };
        var onCompositionUpdate = function() {
            if (!inComposition || !host.onCompositionUpdate || host.$readOnly) return;
            var val = text.value.replace(/\u2028/g, "");
            if (inComposition.lastValue === val) return;
            host.onCompositionUpdate(val);
            if (inComposition.lastValue) host.undo();
            if (inComposition.canUndo) inComposition.lastValue = val;
            if (inComposition.lastValue) {
                var r = host.selection.getRange();
                host.insert(inComposition.lastValue);
                host.session.markUndoGroup();
                inComposition.range = host.selection.getRange();
                host.selection.setRange(r);
                host.selection.clearSelection();
            }
        };
        var onCompositionEnd = function(e) {
            if (!host.onCompositionEnd || host.$readOnly) return;
            var c = inComposition;
            inComposition = false;
            var timer = setTimeout(function() {
                timer = null;
                var str = text.value.replace(/\u2028/g, "");
                if (inComposition) return;
                else if (str == c.lastValue) resetValue();
                else if (!c.lastValue && str) {
                    resetValue();
                    sendText(str);
                }
            });
            inputHandler = function compositionInputHandler(str) {
                if (timer) clearTimeout(timer);
                str = str.replace(/\u2028/g, "");
                if (str == c.lastValue) return "";
                if (c.lastValue && timer) host.undo();
                return str;
            };
            host.onCompositionEnd();
            host.removeListener("mousedown", onCompositionEnd);
            if (e.type == "compositionend" && c.range) host.selection.setRange(c.range);
            var needsOnInput = !!useragent.isChrome && useragent.isChrome >= 53 || !!useragent.isWebKit && useragent.isWebKit >= 603;
            if (needsOnInput) onInput();
        };
        var syncComposition = lang.delayedCall(onCompositionUpdate, 50);
        event.addListener(text, "compositionstart", onCompositionStart);
        if (useragent.isGecko) event.addListener(text, "text", function() {
            syncComposition.schedule();
        });
        else {
            event.addListener(text, "keyup", function() {
                syncComposition.schedule();
            });
            event.addListener(text, "keydown", function() {
                syncComposition.schedule();
            });
        }
        event.addListener(text, "compositionend", onCompositionEnd);
        this.getElement = function() {
            return text;
        };
        this.setReadOnly = function(readOnly) {
            text.readOnly = readOnly;
        };
        this.onContextMenu = function(e) {
            afterContextMenu = true;
            resetSelection(host.selection.isEmpty());
            host._emit("nativecontextmenu", {
                target: host,
                domEvent: e
            });
            this.moveToMouse(e, true);
        };
        this.moveToMouse = function(e, bringToFront) {
            if (!tempStyle) tempStyle = text.style.cssText;
            text.style.cssText = (bringToFront ? "z-index:100000;" : "") + "height:" + text.style.height + ";" + (useragent.isIE ? "opacity:0.1;" : "");
            var rect = host.container.getBoundingClientRect();
            var style = dom.computedStyle(host.container);
            var top = rect.top + (parseInt(style.borderTopWidth) || 0);
            var left = rect.left + (parseInt(rect.borderLeftWidth) || 0);
            var maxTop = rect.bottom - top - text.clientHeight - 2;
            var move = function(e) {
                text.style.left = e.clientX - left - 2 + "px";
                text.style.top = Math.min(e.clientY - top - 2, maxTop) + "px";
            };
            move(e);
            if (e.type != "mousedown") return;
            if (host.renderer.$keepTextAreaAtCursor) host.renderer.$keepTextAreaAtCursor = null;
            clearTimeout(closeTimeout);
            if (useragent.isWin) event.capture(host.container, move, onContextMenuClose);
        };
        this.onContextMenuClose = onContextMenuClose;
        var closeTimeout;
        function onContextMenuClose() {
            clearTimeout(closeTimeout);
            closeTimeout = setTimeout(function() {
                if (tempStyle) {
                    text.style.cssText = tempStyle;
                    tempStyle = '';
                }
                if (host.renderer.$keepTextAreaAtCursor == null) {
                    host.renderer.$keepTextAreaAtCursor = true;
                    host.renderer.$moveTextAreaToCursor();
                }
            }, 0);
        }
        var onContextMenu = function(e) {
            host.textInput.onContextMenu(e);
            onContextMenuClose();
        };
        event.addListener(text, "mouseup", onContextMenu);
        event.addListener(text, "mousedown", function(e) {
            e.preventDefault();
            onContextMenuClose();
        });
        event.addListener(host.renderer.scroller, "contextmenu", onContextMenu);
        event.addListener(text, "contextmenu", onContextMenu);
    };
    exports.TextInput = TextInput;
});
ace.define("ace/mouse/default_handlers", [
    "require",
    "exports",
    "module",
    "ace/lib/dom",
    "ace/lib/event",
    "ace/lib/useragent"
], function(acequire, exports, module1) {
    "use strict";
    var dom = acequire("../lib/dom");
    var event = acequire("../lib/event");
    var useragent = acequire("../lib/useragent");
    var DRAG_OFFSET = 0; // pixels
    var SCROLL_COOLDOWN_T = 250; // milliseconds
    function DefaultHandlers(mouseHandler) {
        mouseHandler.$clickSelection = null;
        var editor = mouseHandler.editor;
        editor.setDefaultHandler("mousedown", this.onMouseDown.bind(mouseHandler));
        editor.setDefaultHandler("dblclick", this.onDoubleClick.bind(mouseHandler));
        editor.setDefaultHandler("tripleclick", this.onTripleClick.bind(mouseHandler));
        editor.setDefaultHandler("quadclick", this.onQuadClick.bind(mouseHandler));
        editor.setDefaultHandler("mousewheel", this.onMouseWheel.bind(mouseHandler));
        editor.setDefaultHandler("touchmove", this.onTouchMove.bind(mouseHandler));
        var exports = [
            "select",
            "startSelect",
            "selectEnd",
            "selectAllEnd",
            "selectByWordsEnd",
            "selectByLinesEnd",
            "dragWait",
            "dragWaitEnd",
            "focusWait"
        ];
        exports.forEach(function(x) {
            mouseHandler[x] = this[x];
        }, this);
        mouseHandler.selectByLines = this.extendSelectionBy.bind(mouseHandler, "getLineRange");
        mouseHandler.selectByWords = this.extendSelectionBy.bind(mouseHandler, "getWordRange");
    }
    (function() {
        this.onMouseDown = function(ev) {
            var inSelection = ev.inSelection();
            var pos = ev.getDocumentPosition();
            this.mousedownEvent = ev;
            var editor = this.editor;
            var button = ev.getButton();
            if (button !== 0) {
                var selectionRange = editor.getSelectionRange();
                var selectionEmpty = selectionRange.isEmpty();
                editor.$blockScrolling++;
                if (selectionEmpty || button == 1) editor.selection.moveToPosition(pos);
                editor.$blockScrolling--;
                if (button == 2) {
                    editor.textInput.onContextMenu(ev.domEvent);
                    if (!useragent.isMozilla) ev.preventDefault();
                }
                return;
            }
            this.mousedownEvent.time = Date.now();
            if (inSelection && !editor.isFocused()) {
                editor.focus();
                if (this.$focusTimout && !this.$clickSelection && !editor.inMultiSelectMode) {
                    this.setState("focusWait");
                    this.captureMouse(ev);
                    return;
                }
            }
            this.captureMouse(ev);
            this.startSelect(pos, ev.domEvent._clicks > 1);
            return ev.preventDefault();
        };
        this.startSelect = function(pos, waitForClickSelection) {
            pos = pos || this.editor.renderer.screenToTextCoordinates(this.x, this.y);
            var editor = this.editor;
            editor.$blockScrolling++;
            if (this.mousedownEvent.getShiftKey()) editor.selection.selectToPosition(pos);
            else if (!waitForClickSelection) editor.selection.moveToPosition(pos);
            if (!waitForClickSelection) this.select();
            if (editor.renderer.scroller.setCapture) editor.renderer.scroller.setCapture();
            editor.setStyle("ace_selecting");
            this.setState("select");
            editor.$blockScrolling--;
        };
        this.select = function() {
            var anchor, editor = this.editor;
            var cursor = editor.renderer.screenToTextCoordinates(this.x, this.y);
            editor.$blockScrolling++;
            if (this.$clickSelection) {
                var cmp = this.$clickSelection.comparePoint(cursor);
                if (cmp == -1) anchor = this.$clickSelection.end;
                else if (cmp == 1) anchor = this.$clickSelection.start;
                else {
                    var orientedRange = calcRangeOrientation(this.$clickSelection, cursor);
                    cursor = orientedRange.cursor;
                    anchor = orientedRange.anchor;
                }
                editor.selection.setSelectionAnchor(anchor.row, anchor.column);
            }
            editor.selection.selectToPosition(cursor);
            editor.$blockScrolling--;
            editor.renderer.scrollCursorIntoView();
        };
        this.extendSelectionBy = function(unitName) {
            var anchor, editor = this.editor;
            var cursor = editor.renderer.screenToTextCoordinates(this.x, this.y);
            var range = editor.selection[unitName](cursor.row, cursor.column);
            editor.$blockScrolling++;
            if (this.$clickSelection) {
                var cmpStart = this.$clickSelection.comparePoint(range.start);
                var cmpEnd = this.$clickSelection.comparePoint(range.end);
                if (cmpStart == -1 && cmpEnd <= 0) {
                    anchor = this.$clickSelection.end;
                    if (range.end.row != cursor.row || range.end.column != cursor.column) cursor = range.start;
                } else if (cmpEnd == 1 && cmpStart >= 0) {
                    anchor = this.$clickSelection.start;
                    if (range.start.row != cursor.row || range.start.column != cursor.column) cursor = range.end;
                } else if (cmpStart == -1 && cmpEnd == 1) {
                    cursor = range.end;
                    anchor = range.start;
                } else {
                    var orientedRange = calcRangeOrientation(this.$clickSelection, cursor);
                    cursor = orientedRange.cursor;
                    anchor = orientedRange.anchor;
                }
                editor.selection.setSelectionAnchor(anchor.row, anchor.column);
            }
            editor.selection.selectToPosition(cursor);
            editor.$blockScrolling--;
            editor.renderer.scrollCursorIntoView();
        };
        this.selectEnd = this.selectAllEnd = this.selectByWordsEnd = this.selectByLinesEnd = function() {
            this.$clickSelection = null;
            this.editor.unsetStyle("ace_selecting");
            if (this.editor.renderer.scroller.releaseCapture) this.editor.renderer.scroller.releaseCapture();
        };
        this.focusWait = function() {
            var distance = calcDistance(this.mousedownEvent.x, this.mousedownEvent.y, this.x, this.y);
            var time = Date.now();
            if (distance > DRAG_OFFSET || time - this.mousedownEvent.time > this.$focusTimout) this.startSelect(this.mousedownEvent.getDocumentPosition());
        };
        this.onDoubleClick = function(ev) {
            var pos = ev.getDocumentPosition();
            var editor = this.editor;
            var session = editor.session;
            var range = session.getBracketRange(pos);
            if (range) {
                if (range.isEmpty()) {
                    range.start.column--;
                    range.end.column++;
                }
                this.setState("select");
            } else {
                range = editor.selection.getWordRange(pos.row, pos.column);
                this.setState("selectByWords");
            }
            this.$clickSelection = range;
            this.select();
        };
        this.onTripleClick = function(ev) {
            var pos = ev.getDocumentPosition();
            var editor = this.editor;
            this.setState("selectByLines");
            var range = editor.getSelectionRange();
            if (range.isMultiLine() && range.contains(pos.row, pos.column)) {
                this.$clickSelection = editor.selection.getLineRange(range.start.row);
                this.$clickSelection.end = editor.selection.getLineRange(range.end.row).end;
            } else this.$clickSelection = editor.selection.getLineRange(pos.row);
            this.select();
        };
        this.onQuadClick = function(ev) {
            var editor = this.editor;
            editor.selectAll();
            this.$clickSelection = editor.getSelectionRange();
            this.setState("selectAll");
        };
        this.onMouseWheel = function(ev) {
            if (ev.getAccelKey()) return;
            if (ev.getShiftKey() && ev.wheelY && !ev.wheelX) {
                ev.wheelX = ev.wheelY;
                ev.wheelY = 0;
            }
            var editor = this.editor;
            if (!this.$lastScroll) this.$lastScroll = {
                t: 0,
                vx: 0,
                vy: 0,
                allowed: 0
            };
            var prevScroll = this.$lastScroll;
            var t = ev.domEvent.timeStamp;
            var dt = t - prevScroll.t;
            var vx = ev.wheelX / dt;
            var vy = ev.wheelY / dt;
            if (dt < SCROLL_COOLDOWN_T) {
                vx = (vx + prevScroll.vx) / 2;
                vy = (vy + prevScroll.vy) / 2;
            }
            var direction = Math.abs(vx / vy);
            var canScroll = false;
            if (direction >= 1 && editor.renderer.isScrollableBy(ev.wheelX * ev.speed, 0)) canScroll = true;
            if (direction <= 1 && editor.renderer.isScrollableBy(0, ev.wheelY * ev.speed)) canScroll = true;
            if (canScroll) prevScroll.allowed = t;
            else if (t - prevScroll.allowed < SCROLL_COOLDOWN_T) {
                var isSlower = Math.abs(vx) <= 1.1 * Math.abs(prevScroll.vx) && Math.abs(vy) <= 1.1 * Math.abs(prevScroll.vy);
                if (isSlower) {
                    canScroll = true;
                    prevScroll.allowed = t;
                } else prevScroll.allowed = 0;
            }
            prevScroll.t = t;
            prevScroll.vx = vx;
            prevScroll.vy = vy;
            if (canScroll) {
                editor.renderer.scrollBy(ev.wheelX * ev.speed, ev.wheelY * ev.speed);
                return ev.stop();
            }
        };
        this.onTouchMove = function(ev) {
            this.editor._emit("mousewheel", ev);
        };
    }).call(DefaultHandlers.prototype);
    exports.DefaultHandlers = DefaultHandlers;
    function calcDistance(ax, ay, bx, by) {
        return Math.sqrt(Math.pow(bx - ax, 2) + Math.pow(by - ay, 2));
    }
    function calcRangeOrientation(range, cursor) {
        if (range.start.row == range.end.row) var cmp = 2 * cursor.column - range.start.column - range.end.column;
        else if (range.start.row == range.end.row - 1 && !range.start.column && !range.end.column) var cmp = cursor.column - 4;
        else var cmp = 2 * cursor.row - range.start.row - range.end.row;
        if (cmp < 0) return {
            cursor: range.start,
            anchor: range.end
        };
        else return {
            cursor: range.end,
            anchor: range.start
        };
    }
});
ace.define("ace/tooltip", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/lib/dom"
], function(acequire, exports, module1) {
    "use strict";
    var oop = acequire("./lib/oop");
    var dom = acequire("./lib/dom");
    function Tooltip(parentNode) {
        this.isOpen = false;
        this.$element = null;
        this.$parentNode = parentNode;
    }
    (function() {
        this.$init = function() {
            this.$element = dom.createElement("div");
            this.$element.className = "ace_tooltip";
            this.$element.style.display = "none";
            this.$parentNode.appendChild(this.$element);
            return this.$element;
        };
        this.getElement = function() {
            return this.$element || this.$init();
        };
        this.setText = function(text) {
            dom.setInnerText(this.getElement(), text);
        };
        this.setHtml = function(html) {
            this.getElement().innerHTML = html;
        };
        this.setPosition = function(x, y) {
            this.getElement().style.left = x + "px";
            this.getElement().style.top = y + "px";
        };
        this.setClassName = function(className) {
            dom.addCssClass(this.getElement(), className);
        };
        this.show = function(text, x, y) {
            if (text != null) this.setText(text);
            if (x != null && y != null) this.setPosition(x, y);
            if (!this.isOpen) {
                this.getElement().style.display = "block";
                this.isOpen = true;
            }
        };
        this.hide = function() {
            if (this.isOpen) {
                this.getElement().style.display = "none";
                this.isOpen = false;
            }
        };
        this.getHeight = function() {
            return this.getElement().offsetHeight;
        };
        this.getWidth = function() {
            return this.getElement().offsetWidth;
        };
        this.destroy = function() {
            this.isOpen = false;
            if (this.$element && this.$element.parentNode) this.$element.parentNode.removeChild(this.$element);
        };
    }).call(Tooltip.prototype);
    exports.Tooltip = Tooltip;
});
ace.define("ace/mouse/default_gutter_handler", [
    "require",
    "exports",
    "module",
    "ace/lib/dom",
    "ace/lib/oop",
    "ace/lib/event",
    "ace/tooltip"
], function(acequire, exports, module1) {
    "use strict";
    var dom = acequire("../lib/dom");
    var oop = acequire("../lib/oop");
    var event = acequire("../lib/event");
    var Tooltip = acequire("../tooltip").Tooltip;
    function GutterHandler(mouseHandler) {
        var editor = mouseHandler.editor;
        var gutter = editor.renderer.$gutterLayer;
        var tooltip = new GutterTooltip(editor.container);
        mouseHandler.editor.setDefaultHandler("guttermousedown", function(e) {
            if (!editor.isFocused() || e.getButton() != 0) return;
            var gutterRegion = gutter.getRegion(e);
            if (gutterRegion == "foldWidgets") return;
            var row = e.getDocumentPosition().row;
            var selection = editor.session.selection;
            if (e.getShiftKey()) selection.selectTo(row, 0);
            else {
                if (e.domEvent.detail == 2) {
                    editor.selectAll();
                    return e.preventDefault();
                }
                mouseHandler.$clickSelection = editor.selection.getLineRange(row);
            }
            mouseHandler.setState("selectByLines");
            mouseHandler.captureMouse(e);
            return e.preventDefault();
        });
        var tooltipTimeout, mouseEvent, tooltipAnnotation;
        function showTooltip() {
            var row = mouseEvent.getDocumentPosition().row;
            var annotation = gutter.$annotations[row];
            if (!annotation) return hideTooltip();
            var maxRow = editor.session.getLength();
            if (row == maxRow) {
                var screenRow = editor.renderer.pixelToScreenCoordinates(0, mouseEvent.y).row;
                var pos = mouseEvent.$pos;
                if (screenRow > editor.session.documentToScreenRow(pos.row, pos.column)) return hideTooltip();
            }
            if (tooltipAnnotation == annotation) return;
            tooltipAnnotation = annotation.text.join("<br/>");
            tooltip.setHtml(tooltipAnnotation);
            tooltip.show();
            editor._signal("showGutterTooltip", tooltip);
            editor.on("mousewheel", hideTooltip);
            if (mouseHandler.$tooltipFollowsMouse) moveTooltip(mouseEvent);
            else {
                var gutterElement = mouseEvent.domEvent.target;
                var rect = gutterElement.getBoundingClientRect();
                var style = tooltip.getElement().style;
                style.left = rect.right + "px";
                style.top = rect.bottom + "px";
            }
        }
        function hideTooltip() {
            if (tooltipTimeout) tooltipTimeout = clearTimeout(tooltipTimeout);
            if (tooltipAnnotation) {
                tooltip.hide();
                tooltipAnnotation = null;
                editor._signal("hideGutterTooltip", tooltip);
                editor.removeEventListener("mousewheel", hideTooltip);
            }
        }
        function moveTooltip(e) {
            tooltip.setPosition(e.x, e.y);
        }
        mouseHandler.editor.setDefaultHandler("guttermousemove", function(e) {
            var target = e.domEvent.target || e.domEvent.srcElement;
            if (dom.hasCssClass(target, "ace_fold-widget")) return hideTooltip();
            if (tooltipAnnotation && mouseHandler.$tooltipFollowsMouse) moveTooltip(e);
            mouseEvent = e;
            if (tooltipTimeout) return;
            tooltipTimeout = setTimeout(function() {
                tooltipTimeout = null;
                if (mouseEvent && !mouseHandler.isMousePressed) showTooltip();
                else hideTooltip();
            }, 50);
        });
        event.addListener(editor.renderer.$gutter, "mouseout", function(e) {
            mouseEvent = null;
            if (!tooltipAnnotation || tooltipTimeout) return;
            tooltipTimeout = setTimeout(function() {
                tooltipTimeout = null;
                hideTooltip();
            }, 50);
        });
        editor.on("changeSession", hideTooltip);
    }
    function GutterTooltip(parentNode) {
        Tooltip.call(this, parentNode);
    }
    oop.inherits(GutterTooltip, Tooltip);
    (function() {
        this.setPosition = function(x, y) {
            var windowWidth = window.innerWidth || document.documentElement.clientWidth;
            var windowHeight = window.innerHeight || document.documentElement.clientHeight;
            var width = this.getWidth();
            var height = this.getHeight();
            x += 15;
            y += 15;
            if (x + width > windowWidth) x -= x + width - windowWidth;
            if (y + height > windowHeight) y -= 20 + height;
            Tooltip.prototype.setPosition.call(this, x, y);
        };
    }).call(GutterTooltip.prototype);
    exports.GutterHandler = GutterHandler;
});
ace.define("ace/mouse/mouse_event", [
    "require",
    "exports",
    "module",
    "ace/lib/event",
    "ace/lib/useragent"
], function(acequire, exports, module1) {
    "use strict";
    var event = acequire("../lib/event");
    var useragent = acequire("../lib/useragent");
    var MouseEvent = exports.MouseEvent = function(domEvent, editor) {
        this.domEvent = domEvent;
        this.editor = editor;
        this.x = this.clientX = domEvent.clientX;
        this.y = this.clientY = domEvent.clientY;
        this.$pos = null;
        this.$inSelection = null;
        this.propagationStopped = false;
        this.defaultPrevented = false;
    };
    (function() {
        this.stopPropagation = function() {
            event.stopPropagation(this.domEvent);
            this.propagationStopped = true;
        };
        this.preventDefault = function() {
            event.preventDefault(this.domEvent);
            this.defaultPrevented = true;
        };
        this.stop = function() {
            this.stopPropagation();
            this.preventDefault();
        };
        this.getDocumentPosition = function() {
            if (this.$pos) return this.$pos;
            this.$pos = this.editor.renderer.screenToTextCoordinates(this.clientX, this.clientY);
            return this.$pos;
        };
        this.inSelection = function() {
            if (this.$inSelection !== null) return this.$inSelection;
            var editor = this.editor;
            var selectionRange = editor.getSelectionRange();
            if (selectionRange.isEmpty()) this.$inSelection = false;
            else {
                var pos = this.getDocumentPosition();
                this.$inSelection = selectionRange.contains(pos.row, pos.column);
            }
            return this.$inSelection;
        };
        this.getButton = function() {
            return event.getButton(this.domEvent);
        };
        this.getShiftKey = function() {
            return this.domEvent.shiftKey;
        };
        this.getAccelKey = useragent.isMac ? function() {
            return this.domEvent.metaKey;
        } : function() {
            return this.domEvent.ctrlKey;
        };
    }).call(MouseEvent.prototype);
});
ace.define("ace/mouse/dragdrop_handler", [
    "require",
    "exports",
    "module",
    "ace/lib/dom",
    "ace/lib/event",
    "ace/lib/useragent"
], function(acequire, exports, module1) {
    "use strict";
    var dom = acequire("../lib/dom");
    var event = acequire("../lib/event");
    var useragent = acequire("../lib/useragent");
    var AUTOSCROLL_DELAY = 200;
    var SCROLL_CURSOR_DELAY = 200;
    var SCROLL_CURSOR_HYSTERESIS = 5;
    function DragdropHandler(mouseHandler) {
        var editor = mouseHandler.editor;
        var blankImage = dom.createElement("img");
        blankImage.src = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
        if (useragent.isOpera) blankImage.style.cssText = "width:1px;height:1px;position:fixed;top:0;left:0;z-index:2147483647;opacity:0;";
        var exports = [
            "dragWait",
            "dragWaitEnd",
            "startDrag",
            "dragReadyEnd",
            "onMouseDrag"
        ];
        exports.forEach(function(x) {
            mouseHandler[x] = this[x];
        }, this);
        editor.addEventListener("mousedown", this.onMouseDown.bind(mouseHandler));
        var mouseTarget = editor.container;
        var dragSelectionMarker, x, y;
        var timerId, range;
        var dragCursor, counter = 0;
        var dragOperation;
        var isInternal;
        var autoScrollStartTime;
        var cursorMovedTime;
        var cursorPointOnCaretMoved;
        this.onDragStart = function(e) {
            if (this.cancelDrag || !mouseTarget.draggable) {
                var self = this;
                setTimeout(function() {
                    self.startSelect();
                    self.captureMouse(e);
                }, 0);
                return e.preventDefault();
            }
            range = editor.getSelectionRange();
            var dataTransfer = e.dataTransfer;
            dataTransfer.effectAllowed = editor.getReadOnly() ? "copy" : "copyMove";
            if (useragent.isOpera) {
                editor.container.appendChild(blankImage);
                blankImage.scrollTop = 0;
            }
            dataTransfer.setDragImage && dataTransfer.setDragImage(blankImage, 0, 0);
            if (useragent.isOpera) editor.container.removeChild(blankImage);
            dataTransfer.clearData();
            dataTransfer.setData("Text", editor.session.getTextRange());
            isInternal = true;
            this.setState("drag");
        };
        this.onDragEnd = function(e) {
            mouseTarget.draggable = false;
            isInternal = false;
            this.setState(null);
            if (!editor.getReadOnly()) {
                var dropEffect = e.dataTransfer.dropEffect;
                if (!dragOperation && dropEffect == "move") editor.session.remove(editor.getSelectionRange());
                editor.renderer.$cursorLayer.setBlinking(true);
            }
            this.editor.unsetStyle("ace_dragging");
            this.editor.renderer.setCursorStyle("");
        };
        this.onDragEnter = function(e) {
            if (editor.getReadOnly() || !canAccept(e.dataTransfer)) return;
            x = e.clientX;
            y = e.clientY;
            if (!dragSelectionMarker) addDragMarker();
            counter++;
            e.dataTransfer.dropEffect = dragOperation = getDropEffect(e);
            return event.preventDefault(e);
        };
        this.onDragOver = function(e) {
            if (editor.getReadOnly() || !canAccept(e.dataTransfer)) return;
            x = e.clientX;
            y = e.clientY;
            if (!dragSelectionMarker) {
                addDragMarker();
                counter++;
            }
            if (onMouseMoveTimer !== null) onMouseMoveTimer = null;
            e.dataTransfer.dropEffect = dragOperation = getDropEffect(e);
            return event.preventDefault(e);
        };
        this.onDragLeave = function(e) {
            counter--;
            if (counter <= 0 && dragSelectionMarker) {
                clearDragMarker();
                dragOperation = null;
                return event.preventDefault(e);
            }
        };
        this.onDrop = function(e) {
            if (!dragCursor) return;
            var dataTransfer = e.dataTransfer;
            if (isInternal) switch(dragOperation){
                case "move":
                    if (range.contains(dragCursor.row, dragCursor.column)) range = {
                        start: dragCursor,
                        end: dragCursor
                    };
                    else range = editor.moveText(range, dragCursor);
                    break;
                case "copy":
                    range = editor.moveText(range, dragCursor, true);
                    break;
            }
            else {
                var dropData = dataTransfer.getData('Text');
                range = {
                    start: dragCursor,
                    end: editor.session.insert(dragCursor, dropData)
                };
                editor.focus();
                dragOperation = null;
            }
            clearDragMarker();
            return event.preventDefault(e);
        };
        event.addListener(mouseTarget, "dragstart", this.onDragStart.bind(mouseHandler));
        event.addListener(mouseTarget, "dragend", this.onDragEnd.bind(mouseHandler));
        event.addListener(mouseTarget, "dragenter", this.onDragEnter.bind(mouseHandler));
        event.addListener(mouseTarget, "dragover", this.onDragOver.bind(mouseHandler));
        event.addListener(mouseTarget, "dragleave", this.onDragLeave.bind(mouseHandler));
        event.addListener(mouseTarget, "drop", this.onDrop.bind(mouseHandler));
        function scrollCursorIntoView(cursor, prevCursor) {
            var now = Date.now();
            var vMovement = !prevCursor || cursor.row != prevCursor.row;
            var hMovement = !prevCursor || cursor.column != prevCursor.column;
            if (!cursorMovedTime || vMovement || hMovement) {
                editor.$blockScrolling += 1;
                editor.moveCursorToPosition(cursor);
                editor.$blockScrolling -= 1;
                cursorMovedTime = now;
                cursorPointOnCaretMoved = {
                    x: x,
                    y: y
                };
            } else {
                var distance = calcDistance(cursorPointOnCaretMoved.x, cursorPointOnCaretMoved.y, x, y);
                if (distance > SCROLL_CURSOR_HYSTERESIS) cursorMovedTime = null;
                else if (now - cursorMovedTime >= SCROLL_CURSOR_DELAY) {
                    editor.renderer.scrollCursorIntoView();
                    cursorMovedTime = null;
                }
            }
        }
        function autoScroll(cursor, prevCursor) {
            var now = Date.now();
            var lineHeight = editor.renderer.layerConfig.lineHeight;
            var characterWidth = editor.renderer.layerConfig.characterWidth;
            var editorRect = editor.renderer.scroller.getBoundingClientRect();
            var offsets = {
                x: {
                    left: x - editorRect.left,
                    right: editorRect.right - x
                },
                y: {
                    top: y - editorRect.top,
                    bottom: editorRect.bottom - y
                }
            };
            var nearestXOffset = Math.min(offsets.x.left, offsets.x.right);
            var nearestYOffset = Math.min(offsets.y.top, offsets.y.bottom);
            var scrollCursor = {
                row: cursor.row,
                column: cursor.column
            };
            if (nearestXOffset / characterWidth <= 2) scrollCursor.column += offsets.x.left < offsets.x.right ? -3 : 2;
            if (nearestYOffset / lineHeight <= 1) scrollCursor.row += offsets.y.top < offsets.y.bottom ? -1 : 1;
            var vScroll = cursor.row != scrollCursor.row;
            var hScroll = cursor.column != scrollCursor.column;
            var vMovement = !prevCursor || cursor.row != prevCursor.row;
            if (vScroll || hScroll && !vMovement) {
                if (!autoScrollStartTime) autoScrollStartTime = now;
                else if (now - autoScrollStartTime >= AUTOSCROLL_DELAY) editor.renderer.scrollCursorIntoView(scrollCursor);
            } else autoScrollStartTime = null;
        }
        function onDragInterval() {
            var prevCursor = dragCursor;
            dragCursor = editor.renderer.screenToTextCoordinates(x, y);
            scrollCursorIntoView(dragCursor, prevCursor);
            autoScroll(dragCursor, prevCursor);
        }
        function addDragMarker() {
            range = editor.selection.toOrientedRange();
            dragSelectionMarker = editor.session.addMarker(range, "ace_selection", editor.getSelectionStyle());
            editor.clearSelection();
            if (editor.isFocused()) editor.renderer.$cursorLayer.setBlinking(false);
            clearInterval(timerId);
            onDragInterval();
            timerId = setInterval(onDragInterval, 20);
            counter = 0;
            event.addListener(document, "mousemove", onMouseMove);
        }
        function clearDragMarker() {
            clearInterval(timerId);
            editor.session.removeMarker(dragSelectionMarker);
            dragSelectionMarker = null;
            editor.$blockScrolling += 1;
            editor.selection.fromOrientedRange(range);
            editor.$blockScrolling -= 1;
            if (editor.isFocused() && !isInternal) editor.renderer.$cursorLayer.setBlinking(!editor.getReadOnly());
            range = null;
            dragCursor = null;
            counter = 0;
            autoScrollStartTime = null;
            cursorMovedTime = null;
            event.removeListener(document, "mousemove", onMouseMove);
        }
        var onMouseMoveTimer = null;
        function onMouseMove() {
            if (onMouseMoveTimer == null) onMouseMoveTimer = setTimeout(function() {
                if (onMouseMoveTimer != null && dragSelectionMarker) clearDragMarker();
            }, 20);
        }
        function canAccept(dataTransfer) {
            var types = dataTransfer.types;
            return !types || Array.prototype.some.call(types, function(type) {
                return type == 'text/plain' || type == 'Text';
            });
        }
        function getDropEffect(e) {
            var copyAllowed = [
                'copy',
                'copymove',
                'all',
                'uninitialized'
            ];
            var moveAllowed = [
                'move',
                'copymove',
                'linkmove',
                'all',
                'uninitialized'
            ];
            var copyModifierState = useragent.isMac ? e.altKey : e.ctrlKey;
            var effectAllowed = "uninitialized";
            try {
                effectAllowed = e.dataTransfer.effectAllowed.toLowerCase();
            } catch (e) {}
            var dropEffect = "none";
            if (copyModifierState && copyAllowed.indexOf(effectAllowed) >= 0) dropEffect = "copy";
            else if (moveAllowed.indexOf(effectAllowed) >= 0) dropEffect = "move";
            else if (copyAllowed.indexOf(effectAllowed) >= 0) dropEffect = "copy";
            return dropEffect;
        }
    }
    (function() {
        this.dragWait = function() {
            var interval = Date.now() - this.mousedownEvent.time;
            if (interval > this.editor.getDragDelay()) this.startDrag();
        };
        this.dragWaitEnd = function() {
            var target = this.editor.container;
            target.draggable = false;
            this.startSelect(this.mousedownEvent.getDocumentPosition());
            this.selectEnd();
        };
        this.dragReadyEnd = function(e) {
            this.editor.renderer.$cursorLayer.setBlinking(!this.editor.getReadOnly());
            this.editor.unsetStyle("ace_dragging");
            this.editor.renderer.setCursorStyle("");
            this.dragWaitEnd();
        };
        this.startDrag = function() {
            this.cancelDrag = false;
            var editor = this.editor;
            var target = editor.container;
            target.draggable = true;
            editor.renderer.$cursorLayer.setBlinking(false);
            editor.setStyle("ace_dragging");
            var cursorStyle = useragent.isWin ? "default" : "move";
            editor.renderer.setCursorStyle(cursorStyle);
            this.setState("dragReady");
        };
        this.onMouseDrag = function(e) {
            var target = this.editor.container;
            if (useragent.isIE && this.state == "dragReady") {
                var distance = calcDistance(this.mousedownEvent.x, this.mousedownEvent.y, this.x, this.y);
                if (distance > 3) target.dragDrop();
            }
            if (this.state === "dragWait") {
                var distance = calcDistance(this.mousedownEvent.x, this.mousedownEvent.y, this.x, this.y);
                if (distance > 0) {
                    target.draggable = false;
                    this.startSelect(this.mousedownEvent.getDocumentPosition());
                }
            }
        };
        this.onMouseDown = function(e) {
            if (!this.$dragEnabled) return;
            this.mousedownEvent = e;
            var editor = this.editor;
            var inSelection = e.inSelection();
            var button = e.getButton();
            var clickCount = e.domEvent.detail || 1;
            if (clickCount === 1 && button === 0 && inSelection) {
                if (e.editor.inMultiSelectMode && (e.getAccelKey() || e.getShiftKey())) return;
                this.mousedownEvent.time = Date.now();
                var eventTarget = e.domEvent.target || e.domEvent.srcElement;
                if ("unselectable" in eventTarget) eventTarget.unselectable = "on";
                if (editor.getDragDelay()) {
                    if (useragent.isWebKit) {
                        this.cancelDrag = true;
                        var mouseTarget = editor.container;
                        mouseTarget.draggable = true;
                    }
                    this.setState("dragWait");
                } else this.startDrag();
                this.captureMouse(e, this.onMouseDrag.bind(this));
                e.defaultPrevented = true;
            }
        };
    }).call(DragdropHandler.prototype);
    function calcDistance(ax, ay, bx, by) {
        return Math.sqrt(Math.pow(bx - ax, 2) + Math.pow(by - ay, 2));
    }
    exports.DragdropHandler = DragdropHandler;
});
ace.define("ace/lib/net", [
    "require",
    "exports",
    "module",
    "ace/lib/dom"
], function(acequire, exports, module1) {
    "use strict";
    var dom = acequire("./dom");
    exports.get = function(url, callback) {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.onreadystatechange = function() {
            if (xhr.readyState === 4) callback(xhr.responseText);
        };
        xhr.send(null);
    };
    exports.loadScript = function(path, callback) {
        var head = dom.getDocumentHead();
        var s = document.createElement('script');
        s.src = path;
        head.appendChild(s);
        s.onload = s.onreadystatechange = function(_, isAbort) {
            if (isAbort || !s.readyState || s.readyState == "loaded" || s.readyState == "complete") {
                s = s.onload = s.onreadystatechange = null;
                if (!isAbort) callback();
            }
        };
    };
    exports.qualifyURL = function(url) {
        var a = document.createElement('a');
        a.href = url;
        return a.href;
    };
});
ace.define("ace/lib/event_emitter", [
    "require",
    "exports",
    "module"
], function(acequire, exports, module1) {
    "use strict";
    var EventEmitter = {};
    var stopPropagation = function() {
        this.propagationStopped = true;
    };
    var preventDefault = function() {
        this.defaultPrevented = true;
    };
    EventEmitter._emit = EventEmitter._dispatchEvent = function(eventName, e) {
        this._eventRegistry || (this._eventRegistry = {});
        this._defaultHandlers || (this._defaultHandlers = {});
        var listeners = this._eventRegistry[eventName] || [];
        var defaultHandler = this._defaultHandlers[eventName];
        if (!listeners.length && !defaultHandler) return;
        if (typeof e != "object" || !e) e = {};
        if (!e.type) e.type = eventName;
        if (!e.stopPropagation) e.stopPropagation = stopPropagation;
        if (!e.preventDefault) e.preventDefault = preventDefault;
        listeners = listeners.slice();
        for(var i = 0; i < listeners.length; i++){
            listeners[i](e, this);
            if (e.propagationStopped) break;
        }
        if (defaultHandler && !e.defaultPrevented) return defaultHandler(e, this);
    };
    EventEmitter._signal = function(eventName, e) {
        var listeners = (this._eventRegistry || {})[eventName];
        if (!listeners) return;
        listeners = listeners.slice();
        for(var i = 0; i < listeners.length; i++)listeners[i](e, this);
    };
    EventEmitter.once = function(eventName, callback) {
        var _self = this;
        callback && this.addEventListener(eventName, function newCallback() {
            _self.removeEventListener(eventName, newCallback);
            callback.apply(null, arguments);
        });
    };
    EventEmitter.setDefaultHandler = function(eventName, callback) {
        var handlers = this._defaultHandlers;
        if (!handlers) handlers = this._defaultHandlers = {
            _disabled_: {}
        };
        if (handlers[eventName]) {
            var old = handlers[eventName];
            var disabled = handlers._disabled_[eventName];
            if (!disabled) handlers._disabled_[eventName] = disabled = [];
            disabled.push(old);
            var i = disabled.indexOf(callback);
            if (i != -1) disabled.splice(i, 1);
        }
        handlers[eventName] = callback;
    };
    EventEmitter.removeDefaultHandler = function(eventName, callback) {
        var handlers = this._defaultHandlers;
        if (!handlers) return;
        var disabled = handlers._disabled_[eventName];
        if (handlers[eventName] == callback) {
            var old = handlers[eventName];
            if (disabled) this.setDefaultHandler(eventName, disabled.pop());
        } else if (disabled) {
            var i = disabled.indexOf(callback);
            if (i != -1) disabled.splice(i, 1);
        }
    };
    EventEmitter.on = EventEmitter.addEventListener = function(eventName, callback, capturing) {
        this._eventRegistry = this._eventRegistry || {};
        var listeners = this._eventRegistry[eventName];
        if (!listeners) listeners = this._eventRegistry[eventName] = [];
        if (listeners.indexOf(callback) == -1) listeners[capturing ? "unshift" : "push"](callback);
        return callback;
    };
    EventEmitter.off = EventEmitter.removeListener = EventEmitter.removeEventListener = function(eventName, callback) {
        this._eventRegistry = this._eventRegistry || {};
        var listeners = this._eventRegistry[eventName];
        if (!listeners) return;
        var index = listeners.indexOf(callback);
        if (index !== -1) listeners.splice(index, 1);
    };
    EventEmitter.removeAllListeners = function(eventName) {
        if (this._eventRegistry) this._eventRegistry[eventName] = [];
    };
    exports.EventEmitter = EventEmitter;
});
ace.define("ace/lib/app_config", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/lib/event_emitter"
], function(acequire, exports, module1) {
    "no use strict";
    var oop = acequire("./oop");
    var EventEmitter = acequire("./event_emitter").EventEmitter;
    var optionsProvider = {
        setOptions: function(optList) {
            Object.keys(optList).forEach(function(key) {
                this.setOption(key, optList[key]);
            }, this);
        },
        getOptions: function(optionNames) {
            var result = {};
            if (!optionNames) optionNames = Object.keys(this.$options);
            else if (!Array.isArray(optionNames)) {
                result = optionNames;
                optionNames = Object.keys(result);
            }
            optionNames.forEach(function(key) {
                result[key] = this.getOption(key);
            }, this);
            return result;
        },
        setOption: function(name, value) {
            if (this["$" + name] === value) return;
            var opt = this.$options[name];
            if (!opt) return warn('misspelled option "' + name + '"');
            if (opt.forwardTo) return this[opt.forwardTo] && this[opt.forwardTo].setOption(name, value);
            if (!opt.handlesSet) this["$" + name] = value;
            if (opt && opt.set) opt.set.call(this, value);
        },
        getOption: function(name) {
            var opt = this.$options[name];
            if (!opt) return warn('misspelled option "' + name + '"');
            if (opt.forwardTo) return this[opt.forwardTo] && this[opt.forwardTo].getOption(name);
            return opt && opt.get ? opt.get.call(this) : this["$" + name];
        }
    };
    function warn(message) {
        if (typeof console != "undefined" && console.warn) console.warn.apply(console, arguments);
    }
    function reportError(msg, data) {
        var e = new Error(msg);
        e.data = data;
        if (typeof console == "object" && console.error) console.error(e);
        setTimeout(function() {
            throw e;
        });
    }
    var AppConfig = function() {
        this.$defaultOptions = {};
    };
    (function() {
        oop.implement(this, EventEmitter);
        this.defineOptions = function(obj, path, options) {
            if (!obj.$options) this.$defaultOptions[path] = obj.$options = {};
            Object.keys(options).forEach(function(key) {
                var opt = options[key];
                if (typeof opt == "string") opt = {
                    forwardTo: opt
                };
                opt.name || (opt.name = key);
                obj.$options[opt.name] = opt;
                if ("initialValue" in opt) obj["$" + opt.name] = opt.initialValue;
            });
            oop.implement(obj, optionsProvider);
            return this;
        };
        this.resetOptions = function(obj) {
            Object.keys(obj.$options).forEach(function(key) {
                var opt = obj.$options[key];
                if ("value" in opt) obj.setOption(key, opt.value);
            });
        };
        this.setDefaultValue = function(path, name, value) {
            var opts = this.$defaultOptions[path] || (this.$defaultOptions[path] = {});
            if (opts[name]) {
                if (opts.forwardTo) this.setDefaultValue(opts.forwardTo, name, value);
                else opts[name].value = value;
            }
        };
        this.setDefaultValues = function(path, optionHash) {
            Object.keys(optionHash).forEach(function(key) {
                this.setDefaultValue(path, key, optionHash[key]);
            }, this);
        };
        this.warn = warn;
        this.reportError = reportError;
    }).call(AppConfig.prototype);
    exports.AppConfig = AppConfig;
});
ace.define("ace/config", [
    "require",
    "exports",
    "module",
    "ace/lib/lang",
    "ace/lib/oop",
    "ace/lib/net",
    "ace/lib/app_config"
], function(acequire, exports, module1) {
    "no use strict";
    var lang = acequire("./lib/lang");
    var oop = acequire("./lib/oop");
    var net = acequire("./lib/net");
    var AppConfig = acequire("./lib/app_config").AppConfig;
    module1.exports = exports = new AppConfig();
    var global = function() {
        return this || typeof window != "undefined" && window;
    }();
    var options = {
        packaged: false,
        workerPath: null,
        modePath: null,
        themePath: null,
        basePath: "",
        suffix: ".js",
        $moduleUrls: {}
    };
    exports.get = function(key) {
        if (!options.hasOwnProperty(key)) throw new Error("Unknown config key: " + key);
        return options[key];
    };
    exports.set = function(key, value) {
        if (!options.hasOwnProperty(key)) throw new Error("Unknown config key: " + key);
        options[key] = value;
    };
    exports.all = function() {
        return lang.copyObject(options);
    };
    exports.moduleUrl = function(name, component) {
        if (options.$moduleUrls[name]) return options.$moduleUrls[name];
        var parts = name.split("/");
        component = component || parts[parts.length - 2] || "";
        var sep = component == "snippets" ? "/" : "-";
        var base = parts[parts.length - 1];
        if (component == "worker" && sep == "-") {
            var re = new RegExp("^" + component + "[\\-_]|[\\-_]" + component + "$", "g");
            base = base.replace(re, "");
        }
        if ((!base || base == component) && parts.length > 1) base = parts[parts.length - 2];
        var path = options[component + "Path"];
        if (path == null) path = options.basePath;
        else if (sep == "/") component = sep = "";
        if (path && path.slice(-1) != "/") path += "/";
        return path + component + sep + base + this.get("suffix");
    };
    exports.setModuleUrl = function(name, subst) {
        return options.$moduleUrls[name] = subst;
    };
    exports.$loading = {};
    exports.loadModule = function(moduleName, onLoad) {
        var module1, moduleType;
        if (Array.isArray(moduleName)) {
            moduleType = moduleName[0];
            moduleName = moduleName[1];
        }
        try {
            module1 = acequire(moduleName);
        } catch (e) {}
        if (module1 && !exports.$loading[moduleName]) return onLoad && onLoad(module1);
        if (!exports.$loading[moduleName]) exports.$loading[moduleName] = [];
        exports.$loading[moduleName].push(onLoad);
        if (exports.$loading[moduleName].length > 1) return;
        var afterLoad = function() {
            acequire([
                moduleName
            ], function(module1) {
                exports._emit("load.module", {
                    name: moduleName,
                    module: module1
                });
                var listeners = exports.$loading[moduleName];
                exports.$loading[moduleName] = null;
                listeners.forEach(function(onLoad) {
                    onLoad && onLoad(module1);
                });
            });
        };
        if (!exports.get("packaged")) return afterLoad();
        net.loadScript(exports.moduleUrl(moduleName, moduleType), afterLoad);
    };
    init(true);
    function init(packaged) {
        if (!global || !global.document) return;
        options.packaged = packaged || acequire.packaged || module1.packaged || global.define && define.packaged;
        var scriptOptions = {};
        var scriptUrl = "";
        var currentScript = document.currentScript || document._currentScript; // native or polyfill
        var currentDocument = currentScript && currentScript.ownerDocument || document;
        var scripts = currentDocument.getElementsByTagName("script");
        for(var i = 0; i < scripts.length; i++){
            var script = scripts[i];
            var src = script.src || script.getAttribute("src");
            if (!src) continue;
            var attributes = script.attributes;
            for(var j = 0, l = attributes.length; j < l; j++){
                var attr = attributes[j];
                if (attr.name.indexOf("data-ace-") === 0) scriptOptions[deHyphenate(attr.name.replace(/^data-ace-/, ""))] = attr.value;
            }
            var m = src.match(/^(.*)\/ace(\-\w+)?\.js(\?|$)/);
            if (m) scriptUrl = m[1];
        }
        if (scriptUrl) {
            scriptOptions.base = scriptOptions.base || scriptUrl;
            scriptOptions.packaged = true;
        }
        scriptOptions.basePath = scriptOptions.base;
        scriptOptions.workerPath = scriptOptions.workerPath || scriptOptions.base;
        scriptOptions.modePath = scriptOptions.modePath || scriptOptions.base;
        scriptOptions.themePath = scriptOptions.themePath || scriptOptions.base;
        delete scriptOptions.base;
        for(var key in scriptOptions)if (typeof scriptOptions[key] !== "undefined") exports.set(key, scriptOptions[key]);
    }
    exports.init = init;
    function deHyphenate(str) {
        return str.replace(/-(.)/g, function(m, m1) {
            return m1.toUpperCase();
        });
    }
});
ace.define("ace/mouse/mouse_handler", [
    "require",
    "exports",
    "module",
    "ace/lib/event",
    "ace/lib/useragent",
    "ace/mouse/default_handlers",
    "ace/mouse/default_gutter_handler",
    "ace/mouse/mouse_event",
    "ace/mouse/dragdrop_handler",
    "ace/config"
], function(acequire, exports, module1) {
    "use strict";
    var event = acequire("../lib/event");
    var useragent = acequire("../lib/useragent");
    var DefaultHandlers = acequire("./default_handlers").DefaultHandlers;
    var DefaultGutterHandler = acequire("./default_gutter_handler").GutterHandler;
    var MouseEvent = acequire("./mouse_event").MouseEvent;
    var DragdropHandler = acequire("./dragdrop_handler").DragdropHandler;
    var config = acequire("../config");
    var MouseHandler = function(editor) {
        var _self = this;
        this.editor = editor;
        new DefaultHandlers(this);
        new DefaultGutterHandler(this);
        new DragdropHandler(this);
        var focusEditor = function(e) {
            var windowBlurred = !document.hasFocus || !document.hasFocus() || !editor.isFocused() && document.activeElement == (editor.textInput && editor.textInput.getElement());
            if (windowBlurred) window.focus();
            editor.focus();
        };
        var mouseTarget = editor.renderer.getMouseEventTarget();
        event.addListener(mouseTarget, "click", this.onMouseEvent.bind(this, "click"));
        event.addListener(mouseTarget, "mousemove", this.onMouseMove.bind(this, "mousemove"));
        event.addMultiMouseDownListener([
            mouseTarget,
            editor.renderer.scrollBarV && editor.renderer.scrollBarV.inner,
            editor.renderer.scrollBarH && editor.renderer.scrollBarH.inner,
            editor.textInput && editor.textInput.getElement()
        ].filter(Boolean), [
            400,
            300,
            250
        ], this, "onMouseEvent");
        event.addMouseWheelListener(editor.container, this.onMouseWheel.bind(this, "mousewheel"));
        event.addTouchMoveListener(editor.container, this.onTouchMove.bind(this, "touchmove"));
        var gutterEl = editor.renderer.$gutter;
        event.addListener(gutterEl, "mousedown", this.onMouseEvent.bind(this, "guttermousedown"));
        event.addListener(gutterEl, "click", this.onMouseEvent.bind(this, "gutterclick"));
        event.addListener(gutterEl, "dblclick", this.onMouseEvent.bind(this, "gutterdblclick"));
        event.addListener(gutterEl, "mousemove", this.onMouseEvent.bind(this, "guttermousemove"));
        event.addListener(mouseTarget, "mousedown", focusEditor);
        event.addListener(gutterEl, "mousedown", focusEditor);
        if (useragent.isIE && editor.renderer.scrollBarV) {
            event.addListener(editor.renderer.scrollBarV.element, "mousedown", focusEditor);
            event.addListener(editor.renderer.scrollBarH.element, "mousedown", focusEditor);
        }
        editor.on("mousemove", function(e) {
            if (_self.state || _self.$dragDelay || !_self.$dragEnabled) return;
            var character = editor.renderer.screenToTextCoordinates(e.x, e.y);
            var range = editor.session.selection.getRange();
            var renderer = editor.renderer;
            if (!range.isEmpty() && range.insideStart(character.row, character.column)) renderer.setCursorStyle("default");
            else renderer.setCursorStyle("");
        });
    };
    (function() {
        this.onMouseEvent = function(name, e) {
            this.editor._emit(name, new MouseEvent(e, this.editor));
        };
        this.onMouseMove = function(name, e) {
            var listeners = this.editor._eventRegistry && this.editor._eventRegistry.mousemove;
            if (!listeners || !listeners.length) return;
            this.editor._emit(name, new MouseEvent(e, this.editor));
        };
        this.onMouseWheel = function(name, e) {
            var mouseEvent = new MouseEvent(e, this.editor);
            mouseEvent.speed = this.$scrollSpeed * 2;
            mouseEvent.wheelX = e.wheelX;
            mouseEvent.wheelY = e.wheelY;
            this.editor._emit(name, mouseEvent);
        };
        this.onTouchMove = function(name, e) {
            var mouseEvent = new MouseEvent(e, this.editor);
            mouseEvent.speed = 1; //this.$scrollSpeed * 2;
            mouseEvent.wheelX = e.wheelX;
            mouseEvent.wheelY = e.wheelY;
            this.editor._emit(name, mouseEvent);
        };
        this.setState = function(state) {
            this.state = state;
        };
        this.captureMouse = function(ev, mouseMoveHandler) {
            this.x = ev.x;
            this.y = ev.y;
            this.isMousePressed = true;
            var renderer = this.editor.renderer;
            if (renderer.$keepTextAreaAtCursor) renderer.$keepTextAreaAtCursor = null;
            var self = this;
            var onMouseMove = function(e) {
                if (!e) return;
                if (useragent.isWebKit && !e.which && self.releaseMouse) return self.releaseMouse();
                self.x = e.clientX;
                self.y = e.clientY;
                mouseMoveHandler && mouseMoveHandler(e);
                self.mouseEvent = new MouseEvent(e, self.editor);
                self.$mouseMoved = true;
            };
            var onCaptureEnd = function(e) {
                clearInterval(timerId);
                onCaptureInterval();
                self[self.state + "End"] && self[self.state + "End"](e);
                self.state = "";
                if (renderer.$keepTextAreaAtCursor == null) {
                    renderer.$keepTextAreaAtCursor = true;
                    renderer.$moveTextAreaToCursor();
                }
                self.isMousePressed = false;
                self.$onCaptureMouseMove = self.releaseMouse = null;
                e && self.onMouseEvent("mouseup", e);
            };
            var onCaptureInterval = function() {
                self[self.state] && self[self.state]();
                self.$mouseMoved = false;
            };
            if (useragent.isOldIE && ev.domEvent.type == "dblclick") return setTimeout(function() {
                onCaptureEnd(ev);
            });
            self.$onCaptureMouseMove = onMouseMove;
            self.releaseMouse = event.capture(this.editor.container, onMouseMove, onCaptureEnd);
            var timerId = setInterval(onCaptureInterval, 20);
        };
        this.releaseMouse = null;
        this.cancelContextMenu = function() {
            var stop = (function(e) {
                if (e && e.domEvent && e.domEvent.type != "contextmenu") return;
                this.editor.off("nativecontextmenu", stop);
                if (e && e.domEvent) event.stopEvent(e.domEvent);
            }).bind(this);
            setTimeout(stop, 10);
            this.editor.on("nativecontextmenu", stop);
        };
    }).call(MouseHandler.prototype);
    config.defineOptions(MouseHandler.prototype, "mouseHandler", {
        scrollSpeed: {
            initialValue: 2
        },
        dragDelay: {
            initialValue: useragent.isMac ? 150 : 0
        },
        dragEnabled: {
            initialValue: true
        },
        focusTimout: {
            initialValue: 0
        },
        tooltipFollowsMouse: {
            initialValue: true
        }
    });
    exports.MouseHandler = MouseHandler;
});
ace.define("ace/mouse/fold_handler", [
    "require",
    "exports",
    "module"
], function(acequire, exports, module1) {
    "use strict";
    function FoldHandler(editor) {
        editor.on("click", function(e) {
            var position = e.getDocumentPosition();
            var session = editor.session;
            var fold = session.getFoldAt(position.row, position.column, 1);
            if (fold) {
                if (e.getAccelKey()) session.removeFold(fold);
                else session.expandFold(fold);
                e.stop();
            }
        });
        editor.on("gutterclick", function(e) {
            var gutterRegion = editor.renderer.$gutterLayer.getRegion(e);
            if (gutterRegion == "foldWidgets") {
                var row = e.getDocumentPosition().row;
                var session = editor.session;
                if (session.foldWidgets && session.foldWidgets[row]) editor.session.onFoldWidgetClick(row, e);
                if (!editor.isFocused()) editor.focus();
                e.stop();
            }
        });
        editor.on("gutterdblclick", function(e) {
            var gutterRegion = editor.renderer.$gutterLayer.getRegion(e);
            if (gutterRegion == "foldWidgets") {
                var row = e.getDocumentPosition().row;
                var session = editor.session;
                var data = session.getParentFoldRangeData(row, true);
                var range = data.range || data.firstRange;
                if (range) {
                    row = range.start.row;
                    var fold = session.getFoldAt(row, session.getLine(row).length, 1);
                    if (fold) session.removeFold(fold);
                    else {
                        session.addFold("...", range);
                        editor.renderer.scrollCursorIntoView({
                            row: range.start.row,
                            column: 0
                        });
                    }
                }
                e.stop();
            }
        });
    }
    exports.FoldHandler = FoldHandler;
});
ace.define("ace/keyboard/keybinding", [
    "require",
    "exports",
    "module",
    "ace/lib/keys",
    "ace/lib/event"
], function(acequire, exports, module1) {
    "use strict";
    var keyUtil = acequire("../lib/keys");
    var event = acequire("../lib/event");
    var KeyBinding = function(editor) {
        this.$editor = editor;
        this.$data = {
            editor: editor
        };
        this.$handlers = [];
        this.setDefaultHandler(editor.commands);
    };
    (function() {
        this.setDefaultHandler = function(kb) {
            this.removeKeyboardHandler(this.$defaultHandler);
            this.$defaultHandler = kb;
            this.addKeyboardHandler(kb, 0);
        };
        this.setKeyboardHandler = function(kb) {
            var h = this.$handlers;
            if (h[h.length - 1] == kb) return;
            while(h[h.length - 1] && h[h.length - 1] != this.$defaultHandler)this.removeKeyboardHandler(h[h.length - 1]);
            this.addKeyboardHandler(kb, 1);
        };
        this.addKeyboardHandler = function(kb, pos) {
            if (!kb) return;
            if (typeof kb == "function" && !kb.handleKeyboard) kb.handleKeyboard = kb;
            var i = this.$handlers.indexOf(kb);
            if (i != -1) this.$handlers.splice(i, 1);
            if (pos == undefined) this.$handlers.push(kb);
            else this.$handlers.splice(pos, 0, kb);
            if (i == -1 && kb.attach) kb.attach(this.$editor);
        };
        this.removeKeyboardHandler = function(kb) {
            var i = this.$handlers.indexOf(kb);
            if (i == -1) return false;
            this.$handlers.splice(i, 1);
            kb.detach && kb.detach(this.$editor);
            return true;
        };
        this.getKeyboardHandler = function() {
            return this.$handlers[this.$handlers.length - 1];
        };
        this.getStatusText = function() {
            var data = this.$data;
            var editor = data.editor;
            return this.$handlers.map(function(h) {
                return h.getStatusText && h.getStatusText(editor, data) || "";
            }).filter(Boolean).join(" ");
        };
        this.$callKeyboardHandlers = function(hashId, keyString, keyCode, e) {
            var toExecute;
            var success = false;
            var commands = this.$editor.commands;
            for(var i = this.$handlers.length; i--;){
                toExecute = this.$handlers[i].handleKeyboard(this.$data, hashId, keyString, keyCode, e);
                if (!toExecute || !toExecute.command) continue;
                if (toExecute.command == "null") success = true;
                else success = commands.exec(toExecute.command, this.$editor, toExecute.args, e);
                if (success && e && hashId != -1 && toExecute.passEvent != true && toExecute.command.passEvent != true) event.stopEvent(e);
                if (success) break;
            }
            if (!success && hashId == -1) {
                toExecute = {
                    command: "insertstring"
                };
                success = commands.exec("insertstring", this.$editor, keyString);
            }
            if (success && this.$editor._signal) this.$editor._signal("keyboardActivity", toExecute);
            return success;
        };
        this.onCommandKey = function(e, hashId, keyCode) {
            var keyString = keyUtil.keyCodeToString(keyCode);
            this.$callKeyboardHandlers(hashId, keyString, keyCode, e);
        };
        this.onTextInput = function(text) {
            this.$callKeyboardHandlers(-1, text);
        };
    }).call(KeyBinding.prototype);
    exports.KeyBinding = KeyBinding;
});
ace.define("ace/lib/bidiutil", [
    "require",
    "exports",
    "module"
], function(acequire, exports, module1) {
    "use strict";
    var ArabicAlefBetIntervalsBegine = [
        '\u0621',
        '\u0641'
    ];
    var ArabicAlefBetIntervalsEnd = [
        '\u063A',
        '\u064a'
    ];
    var dir = 0, hiLevel = 0;
    var lastArabic = false, hasUBAT_AL = false, hasUBAT_B = false, hasUBAT_S = false, hasBlockSep = false, hasSegSep = false;
    var impTab_LTR = [
        [
            0,
            3,
            0,
            1,
            0,
            0,
            0
        ],
        [
            0,
            3,
            0,
            1,
            2,
            2,
            0
        ],
        [
            0,
            3,
            0,
            0x11,
            2,
            0,
            1
        ],
        [
            0,
            3,
            5,
            5,
            4,
            1,
            0
        ],
        [
            0,
            3,
            0x15,
            0x15,
            4,
            0,
            1
        ],
        [
            0,
            3,
            5,
            5,
            4,
            2,
            0
        ]
    ];
    var impTab_RTL = [
        [
            2,
            0,
            1,
            1,
            0,
            1,
            0
        ],
        [
            2,
            0,
            1,
            1,
            0,
            2,
            0
        ],
        [
            2,
            0,
            2,
            1,
            3,
            2,
            0
        ],
        [
            2,
            0,
            2,
            0x21,
            3,
            1,
            1
        ]
    ];
    var LTR = 0, RTL = 1;
    var L = 0;
    var R = 1;
    var EN = 2;
    var AN = 3;
    var ON = 4;
    var B = 5;
    var S = 6;
    var AL = 7;
    var WS = 8;
    var CS = 9;
    var ES = 10;
    var ET = 11;
    var NSM = 12;
    var LRE = 13;
    var RLE = 14;
    var PDF = 15;
    var LRO = 16;
    var RLO = 17;
    var BN = 18;
    var UnicodeTBL00 = [
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        S,
        B,
        S,
        WS,
        B,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        B,
        B,
        B,
        S,
        WS,
        ON,
        ON,
        ET,
        ET,
        ET,
        ON,
        ON,
        ON,
        ON,
        ON,
        ES,
        CS,
        ES,
        CS,
        CS,
        EN,
        EN,
        EN,
        EN,
        EN,
        EN,
        EN,
        EN,
        EN,
        EN,
        CS,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        ON,
        ON,
        ON,
        ON,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        B,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        CS,
        ON,
        ET,
        ET,
        ET,
        ET,
        ON,
        ON,
        ON,
        ON,
        L,
        ON,
        ON,
        BN,
        ON,
        ON,
        ET,
        ET,
        EN,
        EN,
        ON,
        L,
        ON,
        ON,
        ON,
        EN,
        L,
        ON,
        ON,
        ON,
        ON,
        ON
    ];
    var UnicodeTBL20 = [
        WS,
        WS,
        WS,
        WS,
        WS,
        WS,
        WS,
        WS,
        WS,
        WS,
        WS,
        BN,
        BN,
        BN,
        L,
        R,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        WS,
        B,
        LRE,
        RLE,
        PDF,
        LRO,
        RLO,
        CS,
        ET,
        ET,
        ET,
        ET,
        ET,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        CS,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        WS
    ];
    function _computeLevels(chars, levels, len, charTypes) {
        var impTab = dir ? impTab_RTL : impTab_LTR, prevState = null, newClass = null, newLevel = null, newState = 0, action = null, cond = null, condPos = -1, i = null, ix = null, classes = [];
        if (!charTypes) for(i = 0, charTypes = []; i < len; i++)charTypes[i] = _getCharacterType(chars[i]);
        hiLevel = dir;
        lastArabic = false;
        hasUBAT_AL = false;
        hasUBAT_B = false;
        hasUBAT_S = false;
        for(ix = 0; ix < len; ix++){
            prevState = newState;
            classes[ix] = newClass = _getCharClass(chars, charTypes, classes, ix);
            newState = impTab[prevState][newClass];
            action = newState & 0xF0;
            newState &= 0x0F;
            levels[ix] = newLevel = impTab[newState][5];
            if (action > 0) {
                if (action == 0x10) {
                    for(i = condPos; i < ix; i++)levels[i] = 1;
                    condPos = -1;
                } else condPos = -1;
            }
            cond = impTab[newState][6];
            if (cond) {
                if (condPos == -1) condPos = ix;
            } else if (condPos > -1) {
                for(i = condPos; i < ix; i++)levels[i] = newLevel;
                condPos = -1;
            }
            if (charTypes[ix] == B) levels[ix] = 0;
            hiLevel |= newLevel;
        }
        if (hasUBAT_S) {
            for(i = 0; i < len; i++)if (charTypes[i] == S) {
                levels[i] = dir;
                for(var j = i - 1; j >= 0; j--){
                    if (charTypes[j] == WS) levels[j] = dir;
                    else break;
                }
            }
        }
    }
    function _invertLevel(lev, levels, _array) {
        if (hiLevel < lev) return;
        if (lev == 1 && dir == RTL && !hasUBAT_B) {
            _array.reverse();
            return;
        }
        var len = _array.length, start = 0, end, lo, hi, tmp;
        while(start < len){
            if (levels[start] >= lev) {
                end = start + 1;
                while(end < len && levels[end] >= lev)end++;
                for(lo = start, hi = end - 1; lo < hi; lo++, hi--){
                    tmp = _array[lo];
                    _array[lo] = _array[hi];
                    _array[hi] = tmp;
                }
                start = end;
            }
            start++;
        }
    }
    function _getCharClass(chars, types, classes, ix) {
        var cType = types[ix], wType, nType, len, i;
        switch(cType){
            case L:
            case R:
                lastArabic = false;
            case ON:
            case AN:
                return cType;
            case EN:
                return lastArabic ? AN : EN;
            case AL:
                lastArabic = true;
                hasUBAT_AL = true;
                return R;
            case WS:
                return ON;
            case CS:
                if (ix < 1 || ix + 1 >= types.length || (wType = classes[ix - 1]) != EN && wType != AN || (nType = types[ix + 1]) != EN && nType != AN) return ON;
                if (lastArabic) nType = AN;
                return nType == wType ? nType : ON;
            case ES:
                wType = ix > 0 ? classes[ix - 1] : B;
                if (wType == EN && ix + 1 < types.length && types[ix + 1] == EN) return EN;
                return ON;
            case ET:
                if (ix > 0 && classes[ix - 1] == EN) return EN;
                if (lastArabic) return ON;
                i = ix + 1;
                len = types.length;
                while(i < len && types[i] == ET)i++;
                if (i < len && types[i] == EN) return EN;
                return ON;
            case NSM:
                len = types.length;
                i = ix + 1;
                while(i < len && types[i] == NSM)i++;
                if (i < len) {
                    var c = chars[ix], rtlCandidate = c >= 0x0591 && c <= 0x08FF || c == 0xFB1E;
                    wType = types[i];
                    if (rtlCandidate && (wType == R || wType == AL)) return R;
                }
                if (ix < 1 || (wType = types[ix - 1]) == B) return ON;
                return classes[ix - 1];
            case B:
                lastArabic = false;
                hasUBAT_B = true;
                return dir;
            case S:
                hasUBAT_S = true;
                return ON;
            case LRE:
            case RLE:
            case LRO:
            case RLO:
            case PDF:
                lastArabic = false;
            case BN:
                return ON;
        }
    }
    function _getCharacterType(ch) {
        var uc = ch.charCodeAt(0), hi = uc >> 8;
        if (hi == 0) return uc > 0x00BF ? L : UnicodeTBL00[uc];
        else if (hi == 5) return /[\u0591-\u05f4]/.test(ch) ? R : L;
        else if (hi == 6) {
            if (/[\u0610-\u061a\u064b-\u065f\u06d6-\u06e4\u06e7-\u06ed]/.test(ch)) return NSM;
            else if (/[\u0660-\u0669\u066b-\u066c]/.test(ch)) return AN;
            else if (uc == 0x066A) return ET;
            else if (/[\u06f0-\u06f9]/.test(ch)) return EN;
            else return AL;
        } else if (hi == 0x20 && uc <= 0x205F) return UnicodeTBL20[uc & 0xFF];
        else if (hi == 0xFE) return uc >= 0xFE70 ? AL : ON;
        return ON;
    }
    function _isArabicDiacritics(ch) {
        return ch >= '\u064b' && ch <= '\u0655';
    }
    exports.L = L;
    exports.R = R;
    exports.EN = EN;
    exports.ON_R = 3;
    exports.AN = 4;
    exports.R_H = 5;
    exports.B = 6;
    exports.DOT = "\xB7";
    exports.doBidiReorder = function(text, textCharTypes, isRtl) {
        if (text.length < 2) return {};
        var chars = text.split(""), logicalFromVisual = new Array(chars.length), bidiLevels = new Array(chars.length), levels = [];
        dir = isRtl ? RTL : LTR;
        _computeLevels(chars, levels, chars.length, textCharTypes);
        for(var i = 0; i < logicalFromVisual.length; logicalFromVisual[i] = i, i++);
        _invertLevel(2, levels, logicalFromVisual);
        _invertLevel(1, levels, logicalFromVisual);
        for(var i = 0; i < logicalFromVisual.length - 1; i++){
            if (textCharTypes[i] === AN) levels[i] = exports.AN;
            else if (levels[i] === R && (textCharTypes[i] > AL && textCharTypes[i] < LRE || textCharTypes[i] === ON || textCharTypes[i] === BN)) levels[i] = exports.ON_R;
            else if (i > 0 && chars[i - 1] === '\u0644' && /\u0622|\u0623|\u0625|\u0627/.test(chars[i])) {
                levels[i - 1] = levels[i] = exports.R_H;
                i++;
            }
        }
        if (chars[chars.length - 1] === exports.DOT) levels[chars.length - 1] = exports.B;
        for(var i = 0; i < logicalFromVisual.length; i++)bidiLevels[i] = levels[logicalFromVisual[i]];
        return {
            'logicalFromVisual': logicalFromVisual,
            'bidiLevels': bidiLevels
        };
    };
    exports.hasBidiCharacters = function(text, textCharTypes) {
        var ret = false;
        for(var i = 0; i < text.length; i++){
            textCharTypes[i] = _getCharacterType(text.charAt(i));
            if (!ret && (textCharTypes[i] == R || textCharTypes[i] == AL)) ret = true;
        }
        return ret;
    };
    exports.getVisualFromLogicalIdx = function(logIdx, rowMap) {
        for(var i = 0; i < rowMap.logicalFromVisual.length; i++){
            if (rowMap.logicalFromVisual[i] == logIdx) return i;
        }
        return 0;
    };
});
ace.define("ace/bidihandler", [
    "require",
    "exports",
    "module",
    "ace/lib/bidiutil",
    "ace/lib/lang",
    "ace/lib/useragent"
], function(acequire, exports, module1) {
    "use strict";
    var bidiUtil = acequire("./lib/bidiutil");
    var lang = acequire("./lib/lang");
    var useragent = acequire("./lib/useragent");
    var bidiRE = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
    var BidiHandler = function(session) {
        this.session = session;
        this.bidiMap = {};
        this.currentRow = null;
        this.bidiUtil = bidiUtil;
        this.charWidths = [];
        this.EOL = "\xAC";
        this.showInvisibles = true;
        this.isRtlDir = false;
        this.line = "";
        this.wrapIndent = 0;
        this.isLastRow = false;
        this.EOF = "\xB6";
        this.seenBidi = false;
    };
    (function() {
        this.isBidiRow = function(screenRow, docRow, splitIndex) {
            if (!this.seenBidi) return false;
            if (screenRow !== this.currentRow) {
                this.currentRow = screenRow;
                this.updateRowLine(docRow, splitIndex);
                this.updateBidiMap();
            }
            return this.bidiMap.bidiLevels;
        };
        this.onChange = function(delta) {
            if (!this.seenBidi) {
                if (delta.action == "insert" && bidiRE.test(delta.lines.join("\n"))) {
                    this.seenBidi = true;
                    this.currentRow = null;
                }
            } else this.currentRow = null;
        };
        this.getDocumentRow = function() {
            var docRow = 0;
            var rowCache = this.session.$screenRowCache;
            if (rowCache.length) {
                var index = this.session.$getRowCacheIndex(rowCache, this.currentRow);
                if (index >= 0) docRow = this.session.$docRowCache[index];
            }
            return docRow;
        };
        this.getSplitIndex = function() {
            var splitIndex = 0;
            var rowCache = this.session.$screenRowCache;
            if (rowCache.length) {
                var currentIndex, prevIndex = this.session.$getRowCacheIndex(rowCache, this.currentRow);
                while(this.currentRow - splitIndex > 0){
                    currentIndex = this.session.$getRowCacheIndex(rowCache, this.currentRow - splitIndex - 1);
                    if (currentIndex !== prevIndex) break;
                    prevIndex = currentIndex;
                    splitIndex++;
                }
            }
            return splitIndex;
        };
        this.updateRowLine = function(docRow, splitIndex) {
            if (docRow === undefined) docRow = this.getDocumentRow();
            this.wrapIndent = 0;
            this.isLastRow = docRow === this.session.getLength() - 1;
            this.line = this.session.getLine(docRow);
            if (this.session.$useWrapMode) {
                var splits = this.session.$wrapData[docRow];
                if (splits) {
                    if (splitIndex === undefined) splitIndex = this.getSplitIndex();
                    if (splitIndex > 0 && splits.length) {
                        this.wrapIndent = splits.indent;
                        this.line = splitIndex < splits.length ? this.line.substring(splits[splitIndex - 1], splits[splits.length - 1]) : this.line.substring(splits[splits.length - 1]);
                    } else this.line = this.line.substring(0, splits[splitIndex]);
                }
            }
            var session = this.session, shift = 0, size;
            this.line = this.line.replace(/\t|[\u1100-\u2029, \u202F-\uFFE6]/g, function(ch, i) {
                if (ch === '\t' || session.isFullWidth(ch.charCodeAt(0))) {
                    size = ch === '\t' ? session.getScreenTabSize(i + shift) : 2;
                    shift += size - 1;
                    return lang.stringRepeat(bidiUtil.DOT, size);
                }
                return ch;
            });
        };
        this.updateBidiMap = function() {
            var textCharTypes = [], endOfLine = this.isLastRow ? this.EOF : this.EOL;
            var line = this.line + (this.showInvisibles ? endOfLine : bidiUtil.DOT);
            if (bidiUtil.hasBidiCharacters(line, textCharTypes)) this.bidiMap = bidiUtil.doBidiReorder(line, textCharTypes, this.isRtlDir);
            else this.bidiMap = {};
        };
        this.markAsDirty = function() {
            this.currentRow = null;
        };
        this.updateCharacterWidths = function(fontMetrics) {
            if (!this.seenBidi) return;
            if (this.characterWidth === fontMetrics.$characterSize.width) return;
            var characterWidth = this.characterWidth = fontMetrics.$characterSize.width;
            var bidiCharWidth = fontMetrics.$measureCharWidth("\u05d4");
            this.charWidths[bidiUtil.L] = this.charWidths[bidiUtil.EN] = this.charWidths[bidiUtil.ON_R] = characterWidth;
            this.charWidths[bidiUtil.R] = this.charWidths[bidiUtil.AN] = bidiCharWidth;
            this.charWidths[bidiUtil.R_H] = useragent.isChrome ? bidiCharWidth : bidiCharWidth * 0.45;
            this.charWidths[bidiUtil.B] = 0;
            this.currentRow = null;
        };
        this.getShowInvisibles = function() {
            return this.showInvisibles;
        };
        this.setShowInvisibles = function(showInvisibles) {
            this.showInvisibles = showInvisibles;
            this.currentRow = null;
        };
        this.setEolChar = function(eolChar) {
            this.EOL = eolChar;
        };
        this.setTextDir = function(isRtlDir) {
            this.isRtlDir = isRtlDir;
        };
        this.getPosLeft = function(col) {
            col -= this.wrapIndent;
            var visualIdx = bidiUtil.getVisualFromLogicalIdx(col > 0 ? col - 1 : 0, this.bidiMap), levels = this.bidiMap.bidiLevels, left = 0;
            if (col === 0 && levels[visualIdx] % 2 !== 0) visualIdx++;
            for(var i = 0; i < visualIdx; i++)left += this.charWidths[levels[i]];
            if (col !== 0 && levels[visualIdx] % 2 === 0) left += this.charWidths[levels[visualIdx]];
            if (this.wrapIndent) left += this.wrapIndent * this.charWidths[bidiUtil.L];
            return left;
        };
        this.getSelections = function(startCol, endCol) {
            var map = this.bidiMap, levels = map.bidiLevels, level, offset = this.wrapIndent * this.charWidths[bidiUtil.L], selections = [], selColMin = Math.min(startCol, endCol) - this.wrapIndent, selColMax = Math.max(startCol, endCol) - this.wrapIndent, isSelected = false, isSelectedPrev = false, selectionStart = 0;
            for(var logIdx, visIdx = 0; visIdx < levels.length; visIdx++){
                logIdx = map.logicalFromVisual[visIdx];
                level = levels[visIdx];
                isSelected = logIdx >= selColMin && logIdx < selColMax;
                if (isSelected && !isSelectedPrev) selectionStart = offset;
                else if (!isSelected && isSelectedPrev) selections.push({
                    left: selectionStart,
                    width: offset - selectionStart
                });
                offset += this.charWidths[level];
                isSelectedPrev = isSelected;
            }
            if (isSelected && visIdx === levels.length) selections.push({
                left: selectionStart,
                width: offset - selectionStart
            });
            return selections;
        };
        this.offsetToCol = function(posX) {
            var logicalIdx = 0, posX = Math.max(posX, 0), offset = 0, visualIdx = 0, levels = this.bidiMap.bidiLevels, charWidth = this.charWidths[levels[visualIdx]];
            if (this.wrapIndent) posX -= this.wrapIndent * this.charWidths[bidiUtil.L];
            while(posX > offset + charWidth / 2){
                offset += charWidth;
                if (visualIdx === levels.length - 1) {
                    charWidth = 0;
                    break;
                }
                charWidth = this.charWidths[levels[++visualIdx]];
            }
            if (visualIdx > 0 && levels[visualIdx - 1] % 2 !== 0 && levels[visualIdx] % 2 === 0) {
                if (posX < offset) visualIdx--;
                logicalIdx = this.bidiMap.logicalFromVisual[visualIdx];
            } else if (visualIdx > 0 && levels[visualIdx - 1] % 2 === 0 && levels[visualIdx] % 2 !== 0) logicalIdx = 1 + (posX > offset ? this.bidiMap.logicalFromVisual[visualIdx] : this.bidiMap.logicalFromVisual[visualIdx - 1]);
            else if (this.isRtlDir && visualIdx === levels.length - 1 && charWidth === 0 && levels[visualIdx - 1] % 2 === 0 || !this.isRtlDir && visualIdx === 0 && levels[visualIdx] % 2 !== 0) logicalIdx = 1 + this.bidiMap.logicalFromVisual[visualIdx];
            else {
                if (visualIdx > 0 && levels[visualIdx - 1] % 2 !== 0 && charWidth !== 0) visualIdx--;
                logicalIdx = this.bidiMap.logicalFromVisual[visualIdx];
            }
            return logicalIdx + this.wrapIndent;
        };
    }).call(BidiHandler.prototype);
    exports.BidiHandler = BidiHandler;
});
ace.define("ace/range", [
    "require",
    "exports",
    "module"
], function(acequire, exports, module1) {
    "use strict";
    var comparePoints = function(p1, p2) {
        return p1.row - p2.row || p1.column - p2.column;
    };
    var Range = function(startRow, startColumn, endRow, endColumn) {
        this.start = {
            row: startRow,
            column: startColumn
        };
        this.end = {
            row: endRow,
            column: endColumn
        };
    };
    (function() {
        this.isEqual = function(range) {
            return this.start.row === range.start.row && this.end.row === range.end.row && this.start.column === range.start.column && this.end.column === range.end.column;
        };
        this.toString = function() {
            return "Range: [" + this.start.row + "/" + this.start.column + "] -> [" + this.end.row + "/" + this.end.column + "]";
        };
        this.contains = function(row, column) {
            return this.compare(row, column) == 0;
        };
        this.compareRange = function(range) {
            var cmp, end = range.end, start = range.start;
            cmp = this.compare(end.row, end.column);
            if (cmp == 1) {
                cmp = this.compare(start.row, start.column);
                if (cmp == 1) return 2;
                else if (cmp == 0) return 1;
                else return 0;
            } else if (cmp == -1) return -2;
            else {
                cmp = this.compare(start.row, start.column);
                if (cmp == -1) return -1;
                else if (cmp == 1) return 42;
                else return 0;
            }
        };
        this.comparePoint = function(p) {
            return this.compare(p.row, p.column);
        };
        this.containsRange = function(range) {
            return this.comparePoint(range.start) == 0 && this.comparePoint(range.end) == 0;
        };
        this.intersects = function(range) {
            var cmp = this.compareRange(range);
            return cmp == -1 || cmp == 0 || cmp == 1;
        };
        this.isEnd = function(row, column) {
            return this.end.row == row && this.end.column == column;
        };
        this.isStart = function(row, column) {
            return this.start.row == row && this.start.column == column;
        };
        this.setStart = function(row, column) {
            if (typeof row == "object") {
                this.start.column = row.column;
                this.start.row = row.row;
            } else {
                this.start.row = row;
                this.start.column = column;
            }
        };
        this.setEnd = function(row, column) {
            if (typeof row == "object") {
                this.end.column = row.column;
                this.end.row = row.row;
            } else {
                this.end.row = row;
                this.end.column = column;
            }
        };
        this.inside = function(row, column) {
            if (this.compare(row, column) == 0) {
                if (this.isEnd(row, column) || this.isStart(row, column)) return false;
                else return true;
            }
            return false;
        };
        this.insideStart = function(row, column) {
            if (this.compare(row, column) == 0) {
                if (this.isEnd(row, column)) return false;
                else return true;
            }
            return false;
        };
        this.insideEnd = function(row, column) {
            if (this.compare(row, column) == 0) {
                if (this.isStart(row, column)) return false;
                else return true;
            }
            return false;
        };
        this.compare = function(row, column) {
            if (!this.isMultiLine()) {
                if (row === this.start.row) return column < this.start.column ? -1 : column > this.end.column ? 1 : 0;
            }
            if (row < this.start.row) return -1;
            if (row > this.end.row) return 1;
            if (this.start.row === row) return column >= this.start.column ? 0 : -1;
            if (this.end.row === row) return column <= this.end.column ? 0 : 1;
            return 0;
        };
        this.compareStart = function(row, column) {
            if (this.start.row == row && this.start.column == column) return -1;
            else return this.compare(row, column);
        };
        this.compareEnd = function(row, column) {
            if (this.end.row == row && this.end.column == column) return 1;
            else return this.compare(row, column);
        };
        this.compareInside = function(row, column) {
            if (this.end.row == row && this.end.column == column) return 1;
            else if (this.start.row == row && this.start.column == column) return -1;
            else return this.compare(row, column);
        };
        this.clipRows = function(firstRow, lastRow) {
            if (this.end.row > lastRow) var end = {
                row: lastRow + 1,
                column: 0
            };
            else if (this.end.row < firstRow) var end = {
                row: firstRow,
                column: 0
            };
            if (this.start.row > lastRow) var start = {
                row: lastRow + 1,
                column: 0
            };
            else if (this.start.row < firstRow) var start = {
                row: firstRow,
                column: 0
            };
            return Range.fromPoints(start || this.start, end || this.end);
        };
        this.extend = function(row, column) {
            var cmp = this.compare(row, column);
            if (cmp == 0) return this;
            else if (cmp == -1) var start = {
                row: row,
                column: column
            };
            else var end = {
                row: row,
                column: column
            };
            return Range.fromPoints(start || this.start, end || this.end);
        };
        this.isEmpty = function() {
            return this.start.row === this.end.row && this.start.column === this.end.column;
        };
        this.isMultiLine = function() {
            return this.start.row !== this.end.row;
        };
        this.clone = function() {
            return Range.fromPoints(this.start, this.end);
        };
        this.collapseRows = function() {
            if (this.end.column == 0) return new Range(this.start.row, 0, Math.max(this.start.row, this.end.row - 1), 0);
            else return new Range(this.start.row, 0, this.end.row, 0);
        };
        this.toScreenRange = function(session) {
            var screenPosStart = session.documentToScreenPosition(this.start);
            var screenPosEnd = session.documentToScreenPosition(this.end);
            return new Range(screenPosStart.row, screenPosStart.column, screenPosEnd.row, screenPosEnd.column);
        };
        this.moveBy = function(row, column) {
            this.start.row += row;
            this.start.column += column;
            this.end.row += row;
            this.end.column += column;
        };
    }).call(Range.prototype);
    Range.fromPoints = function(start, end) {
        return new Range(start.row, start.column, end.row, end.column);
    };
    Range.comparePoints = comparePoints;
    Range.comparePoints = function(p1, p2) {
        return p1.row - p2.row || p1.column - p2.column;
    };
    exports.Range = Range;
});
ace.define("ace/selection", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/lib/lang",
    "ace/lib/event_emitter",
    "ace/range"
], function(acequire, exports, module1) {
    "use strict";
    var oop = acequire("./lib/oop");
    var lang = acequire("./lib/lang");
    var EventEmitter = acequire("./lib/event_emitter").EventEmitter;
    var Range = acequire("./range").Range;
    var Selection = function(session) {
        this.session = session;
        this.doc = session.getDocument();
        this.clearSelection();
        this.lead = this.selectionLead = this.doc.createAnchor(0, 0);
        this.anchor = this.selectionAnchor = this.doc.createAnchor(0, 0);
        var self = this;
        this.lead.on("change", function(e) {
            self._emit("changeCursor");
            if (!self.$isEmpty) self._emit("changeSelection");
            if (!self.$keepDesiredColumnOnChange && e.old.column != e.value.column) self.$desiredColumn = null;
        });
        this.selectionAnchor.on("change", function() {
            if (!self.$isEmpty) self._emit("changeSelection");
        });
    };
    (function() {
        oop.implement(this, EventEmitter);
        this.isEmpty = function() {
            return this.$isEmpty || this.anchor.row == this.lead.row && this.anchor.column == this.lead.column;
        };
        this.isMultiLine = function() {
            if (this.isEmpty()) return false;
            return this.getRange().isMultiLine();
        };
        this.getCursor = function() {
            return this.lead.getPosition();
        };
        this.setSelectionAnchor = function(row, column) {
            this.anchor.setPosition(row, column);
            if (this.$isEmpty) {
                this.$isEmpty = false;
                this._emit("changeSelection");
            }
        };
        this.getSelectionAnchor = function() {
            if (this.$isEmpty) return this.getSelectionLead();
            else return this.anchor.getPosition();
        };
        this.getSelectionLead = function() {
            return this.lead.getPosition();
        };
        this.shiftSelection = function(columns) {
            if (this.$isEmpty) {
                this.moveCursorTo(this.lead.row, this.lead.column + columns);
                return;
            }
            var anchor = this.getSelectionAnchor();
            var lead = this.getSelectionLead();
            var isBackwards = this.isBackwards();
            if (!isBackwards || anchor.column !== 0) this.setSelectionAnchor(anchor.row, anchor.column + columns);
            if (isBackwards || lead.column !== 0) this.$moveSelection(function() {
                this.moveCursorTo(lead.row, lead.column + columns);
            });
        };
        this.isBackwards = function() {
            var anchor = this.anchor;
            var lead = this.lead;
            return anchor.row > lead.row || anchor.row == lead.row && anchor.column > lead.column;
        };
        this.getRange = function() {
            var anchor = this.anchor;
            var lead = this.lead;
            if (this.isEmpty()) return Range.fromPoints(lead, lead);
            if (this.isBackwards()) return Range.fromPoints(lead, anchor);
            else return Range.fromPoints(anchor, lead);
        };
        this.clearSelection = function() {
            if (!this.$isEmpty) {
                this.$isEmpty = true;
                this._emit("changeSelection");
            }
        };
        this.selectAll = function() {
            var lastRow = this.doc.getLength() - 1;
            this.setSelectionAnchor(0, 0);
            this.moveCursorTo(lastRow, this.doc.getLine(lastRow).length);
        };
        this.setRange = this.setSelectionRange = function(range, reverse) {
            if (reverse) {
                this.setSelectionAnchor(range.end.row, range.end.column);
                this.selectTo(range.start.row, range.start.column);
            } else {
                this.setSelectionAnchor(range.start.row, range.start.column);
                this.selectTo(range.end.row, range.end.column);
            }
            if (this.getRange().isEmpty()) this.$isEmpty = true;
            this.$desiredColumn = null;
        };
        this.$moveSelection = function(mover) {
            var lead = this.lead;
            if (this.$isEmpty) this.setSelectionAnchor(lead.row, lead.column);
            mover.call(this);
        };
        this.selectTo = function(row, column) {
            this.$moveSelection(function() {
                this.moveCursorTo(row, column);
            });
        };
        this.selectToPosition = function(pos) {
            this.$moveSelection(function() {
                this.moveCursorToPosition(pos);
            });
        };
        this.moveTo = function(row, column) {
            this.clearSelection();
            this.moveCursorTo(row, column);
        };
        this.moveToPosition = function(pos) {
            this.clearSelection();
            this.moveCursorToPosition(pos);
        };
        this.selectUp = function() {
            this.$moveSelection(this.moveCursorUp);
        };
        this.selectDown = function() {
            this.$moveSelection(this.moveCursorDown);
        };
        this.selectRight = function() {
            this.$moveSelection(this.moveCursorRight);
        };
        this.selectLeft = function() {
            this.$moveSelection(this.moveCursorLeft);
        };
        this.selectLineStart = function() {
            this.$moveSelection(this.moveCursorLineStart);
        };
        this.selectLineEnd = function() {
            this.$moveSelection(this.moveCursorLineEnd);
        };
        this.selectFileEnd = function() {
            this.$moveSelection(this.moveCursorFileEnd);
        };
        this.selectFileStart = function() {
            this.$moveSelection(this.moveCursorFileStart);
        };
        this.selectWordRight = function() {
            this.$moveSelection(this.moveCursorWordRight);
        };
        this.selectWordLeft = function() {
            this.$moveSelection(this.moveCursorWordLeft);
        };
        this.getWordRange = function(row, column) {
            if (typeof column == "undefined") {
                var cursor = row || this.lead;
                row = cursor.row;
                column = cursor.column;
            }
            return this.session.getWordRange(row, column);
        };
        this.selectWord = function() {
            this.setSelectionRange(this.getWordRange());
        };
        this.selectAWord = function() {
            var cursor = this.getCursor();
            var range = this.session.getAWordRange(cursor.row, cursor.column);
            this.setSelectionRange(range);
        };
        this.getLineRange = function(row, excludeLastChar) {
            var rowStart = typeof row == "number" ? row : this.lead.row;
            var rowEnd;
            var foldLine = this.session.getFoldLine(rowStart);
            if (foldLine) {
                rowStart = foldLine.start.row;
                rowEnd = foldLine.end.row;
            } else rowEnd = rowStart;
            if (excludeLastChar === true) return new Range(rowStart, 0, rowEnd, this.session.getLine(rowEnd).length);
            else return new Range(rowStart, 0, rowEnd + 1, 0);
        };
        this.selectLine = function() {
            this.setSelectionRange(this.getLineRange());
        };
        this.moveCursorUp = function() {
            this.moveCursorBy(-1, 0);
        };
        this.moveCursorDown = function() {
            this.moveCursorBy(1, 0);
        };
        this.wouldMoveIntoSoftTab = function(cursor, tabSize, direction) {
            var start = cursor.column;
            var end = cursor.column + tabSize;
            if (direction < 0) {
                start = cursor.column - tabSize;
                end = cursor.column;
            }
            return this.session.isTabStop(cursor) && this.doc.getLine(cursor.row).slice(start, end).split(" ").length - 1 == tabSize;
        };
        this.moveCursorLeft = function() {
            var cursor = this.lead.getPosition(), fold;
            if (fold = this.session.getFoldAt(cursor.row, cursor.column, -1)) this.moveCursorTo(fold.start.row, fold.start.column);
            else if (cursor.column === 0) {
                if (cursor.row > 0) this.moveCursorTo(cursor.row - 1, this.doc.getLine(cursor.row - 1).length);
            } else {
                var tabSize = this.session.getTabSize();
                if (this.wouldMoveIntoSoftTab(cursor, tabSize, -1) && !this.session.getNavigateWithinSoftTabs()) this.moveCursorBy(0, -tabSize);
                else this.moveCursorBy(0, -1);
            }
        };
        this.moveCursorRight = function() {
            var cursor = this.lead.getPosition(), fold;
            if (fold = this.session.getFoldAt(cursor.row, cursor.column, 1)) this.moveCursorTo(fold.end.row, fold.end.column);
            else if (this.lead.column == this.doc.getLine(this.lead.row).length) {
                if (this.lead.row < this.doc.getLength() - 1) this.moveCursorTo(this.lead.row + 1, 0);
            } else {
                var tabSize = this.session.getTabSize();
                var cursor = this.lead;
                if (this.wouldMoveIntoSoftTab(cursor, tabSize, 1) && !this.session.getNavigateWithinSoftTabs()) this.moveCursorBy(0, tabSize);
                else this.moveCursorBy(0, 1);
            }
        };
        this.moveCursorLineStart = function() {
            var row = this.lead.row;
            var column = this.lead.column;
            var screenRow = this.session.documentToScreenRow(row, column);
            var firstColumnPosition = this.session.screenToDocumentPosition(screenRow, 0);
            var beforeCursor = this.session.getDisplayLine(row, null, firstColumnPosition.row, firstColumnPosition.column);
            var leadingSpace = beforeCursor.match(/^\s*/);
            if (leadingSpace[0].length != column && !this.session.$useEmacsStyleLineStart) firstColumnPosition.column += leadingSpace[0].length;
            this.moveCursorToPosition(firstColumnPosition);
        };
        this.moveCursorLineEnd = function() {
            var lead = this.lead;
            var lineEnd = this.session.getDocumentLastRowColumnPosition(lead.row, lead.column);
            if (this.lead.column == lineEnd.column) {
                var line = this.session.getLine(lineEnd.row);
                if (lineEnd.column == line.length) {
                    var textEnd = line.search(/\s+$/);
                    if (textEnd > 0) lineEnd.column = textEnd;
                }
            }
            this.moveCursorTo(lineEnd.row, lineEnd.column);
        };
        this.moveCursorFileEnd = function() {
            var row = this.doc.getLength() - 1;
            var column = this.doc.getLine(row).length;
            this.moveCursorTo(row, column);
        };
        this.moveCursorFileStart = function() {
            this.moveCursorTo(0, 0);
        };
        this.moveCursorLongWordRight = function() {
            var row = this.lead.row;
            var column = this.lead.column;
            var line = this.doc.getLine(row);
            var rightOfCursor = line.substring(column);
            var match;
            this.session.nonTokenRe.lastIndex = 0;
            this.session.tokenRe.lastIndex = 0;
            var fold = this.session.getFoldAt(row, column, 1);
            if (fold) {
                this.moveCursorTo(fold.end.row, fold.end.column);
                return;
            }
            if (match = this.session.nonTokenRe.exec(rightOfCursor)) {
                column += this.session.nonTokenRe.lastIndex;
                this.session.nonTokenRe.lastIndex = 0;
                rightOfCursor = line.substring(column);
            }
            if (column >= line.length) {
                this.moveCursorTo(row, line.length);
                this.moveCursorRight();
                if (row < this.doc.getLength() - 1) this.moveCursorWordRight();
                return;
            }
            if (match = this.session.tokenRe.exec(rightOfCursor)) {
                column += this.session.tokenRe.lastIndex;
                this.session.tokenRe.lastIndex = 0;
            }
            this.moveCursorTo(row, column);
        };
        this.moveCursorLongWordLeft = function() {
            var row = this.lead.row;
            var column = this.lead.column;
            var fold;
            if (fold = this.session.getFoldAt(row, column, -1)) {
                this.moveCursorTo(fold.start.row, fold.start.column);
                return;
            }
            var str = this.session.getFoldStringAt(row, column, -1);
            if (str == null) str = this.doc.getLine(row).substring(0, column);
            var leftOfCursor = lang.stringReverse(str);
            var match;
            this.session.nonTokenRe.lastIndex = 0;
            this.session.tokenRe.lastIndex = 0;
            if (match = this.session.nonTokenRe.exec(leftOfCursor)) {
                column -= this.session.nonTokenRe.lastIndex;
                leftOfCursor = leftOfCursor.slice(this.session.nonTokenRe.lastIndex);
                this.session.nonTokenRe.lastIndex = 0;
            }
            if (column <= 0) {
                this.moveCursorTo(row, 0);
                this.moveCursorLeft();
                if (row > 0) this.moveCursorWordLeft();
                return;
            }
            if (match = this.session.tokenRe.exec(leftOfCursor)) {
                column -= this.session.tokenRe.lastIndex;
                this.session.tokenRe.lastIndex = 0;
            }
            this.moveCursorTo(row, column);
        };
        this.$shortWordEndIndex = function(rightOfCursor) {
            var match, index = 0, ch;
            var whitespaceRe = /\s/;
            var tokenRe = this.session.tokenRe;
            tokenRe.lastIndex = 0;
            if (match = this.session.tokenRe.exec(rightOfCursor)) index = this.session.tokenRe.lastIndex;
            else {
                while((ch = rightOfCursor[index]) && whitespaceRe.test(ch))index++;
                if (index < 1) {
                    tokenRe.lastIndex = 0;
                    while((ch = rightOfCursor[index]) && !tokenRe.test(ch)){
                        tokenRe.lastIndex = 0;
                        index++;
                        if (whitespaceRe.test(ch)) {
                            if (index > 2) {
                                index--;
                                break;
                            } else {
                                while((ch = rightOfCursor[index]) && whitespaceRe.test(ch))index++;
                                if (index > 2) break;
                            }
                        }
                    }
                }
            }
            tokenRe.lastIndex = 0;
            return index;
        };
        this.moveCursorShortWordRight = function() {
            var row = this.lead.row;
            var column = this.lead.column;
            var line = this.doc.getLine(row);
            var rightOfCursor = line.substring(column);
            var fold = this.session.getFoldAt(row, column, 1);
            if (fold) return this.moveCursorTo(fold.end.row, fold.end.column);
            if (column == line.length) {
                var l = this.doc.getLength();
                do {
                    row++;
                    rightOfCursor = this.doc.getLine(row);
                }while (row < l && /^\s*$/.test(rightOfCursor));
                if (!/^\s+/.test(rightOfCursor)) rightOfCursor = "";
                column = 0;
            }
            var index = this.$shortWordEndIndex(rightOfCursor);
            this.moveCursorTo(row, column + index);
        };
        this.moveCursorShortWordLeft = function() {
            var row = this.lead.row;
            var column = this.lead.column;
            var fold;
            if (fold = this.session.getFoldAt(row, column, -1)) return this.moveCursorTo(fold.start.row, fold.start.column);
            var line = this.session.getLine(row).substring(0, column);
            if (column === 0) {
                do {
                    row--;
                    line = this.doc.getLine(row);
                }while (row > 0 && /^\s*$/.test(line));
                column = line.length;
                if (!/\s+$/.test(line)) line = "";
            }
            var leftOfCursor = lang.stringReverse(line);
            var index = this.$shortWordEndIndex(leftOfCursor);
            return this.moveCursorTo(row, column - index);
        };
        this.moveCursorWordRight = function() {
            if (this.session.$selectLongWords) this.moveCursorLongWordRight();
            else this.moveCursorShortWordRight();
        };
        this.moveCursorWordLeft = function() {
            if (this.session.$selectLongWords) this.moveCursorLongWordLeft();
            else this.moveCursorShortWordLeft();
        };
        this.moveCursorBy = function(rows, chars) {
            var screenPos = this.session.documentToScreenPosition(this.lead.row, this.lead.column);
            var offsetX;
            if (chars === 0) {
                if (rows !== 0) {
                    if (this.session.$bidiHandler.isBidiRow(screenPos.row, this.lead.row)) {
                        offsetX = this.session.$bidiHandler.getPosLeft(screenPos.column);
                        screenPos.column = Math.round(offsetX / this.session.$bidiHandler.charWidths[0]);
                    } else offsetX = screenPos.column * this.session.$bidiHandler.charWidths[0];
                }
                if (this.$desiredColumn) screenPos.column = this.$desiredColumn;
                else this.$desiredColumn = screenPos.column;
            }
            var docPos = this.session.screenToDocumentPosition(screenPos.row + rows, screenPos.column, offsetX);
            if (rows !== 0 && chars === 0 && docPos.row === this.lead.row && docPos.column === this.lead.column) {
                if (this.session.lineWidgets && this.session.lineWidgets[docPos.row]) {
                    if (docPos.row > 0 || rows > 0) docPos.row++;
                }
            }
            this.moveCursorTo(docPos.row, docPos.column + chars, chars === 0);
        };
        this.moveCursorToPosition = function(position) {
            this.moveCursorTo(position.row, position.column);
        };
        this.moveCursorTo = function(row, column, keepDesiredColumn) {
            var fold = this.session.getFoldAt(row, column, 1);
            if (fold) {
                row = fold.start.row;
                column = fold.start.column;
            }
            this.$keepDesiredColumnOnChange = true;
            var line = this.session.getLine(row);
            if (/[\uDC00-\uDFFF]/.test(line.charAt(column)) && line.charAt(column - 1)) {
                if (this.lead.row == row && this.lead.column == column + 1) column = column - 1;
                else column = column + 1;
            }
            this.lead.setPosition(row, column);
            this.$keepDesiredColumnOnChange = false;
            if (!keepDesiredColumn) this.$desiredColumn = null;
        };
        this.moveCursorToScreen = function(row, column, keepDesiredColumn) {
            var pos = this.session.screenToDocumentPosition(row, column);
            this.moveCursorTo(pos.row, pos.column, keepDesiredColumn);
        };
        this.detach = function() {
            this.lead.detach();
            this.anchor.detach();
            this.session = this.doc = null;
        };
        this.fromOrientedRange = function(range) {
            this.setSelectionRange(range, range.cursor == range.start);
            this.$desiredColumn = range.desiredColumn || this.$desiredColumn;
        };
        this.toOrientedRange = function(range) {
            var r = this.getRange();
            if (range) {
                range.start.column = r.start.column;
                range.start.row = r.start.row;
                range.end.column = r.end.column;
                range.end.row = r.end.row;
            } else range = r;
            range.cursor = this.isBackwards() ? range.start : range.end;
            range.desiredColumn = this.$desiredColumn;
            return range;
        };
        this.getRangeOfMovements = function(func) {
            var start = this.getCursor();
            try {
                func(this);
                var end = this.getCursor();
                return Range.fromPoints(start, end);
            } catch (e) {
                return Range.fromPoints(start, start);
            } finally{
                this.moveCursorToPosition(start);
            }
        };
        this.toJSON = function() {
            if (this.rangeCount) var data = this.ranges.map(function(r) {
                var r1 = r.clone();
                r1.isBackwards = r.cursor == r.start;
                return r1;
            });
            else {
                var data = this.getRange();
                data.isBackwards = this.isBackwards();
            }
            return data;
        };
        this.fromJSON = function(data) {
            if (data.start == undefined) {
                if (this.rangeList) {
                    this.toSingleRange(data[0]);
                    for(var i = data.length; i--;){
                        var r = Range.fromPoints(data[i].start, data[i].end);
                        if (data[i].isBackwards) r.cursor = r.start;
                        this.addRange(r, true);
                    }
                    return;
                } else data = data[0];
            }
            if (this.rangeList) this.toSingleRange(data);
            this.setSelectionRange(data, data.isBackwards);
        };
        this.isEqual = function(data) {
            if ((data.length || this.rangeCount) && data.length != this.rangeCount) return false;
            if (!data.length || !this.ranges) return this.getRange().isEqual(data);
            for(var i = this.ranges.length; i--;){
                if (!this.ranges[i].isEqual(data[i])) return false;
            }
            return true;
        };
    }).call(Selection.prototype);
    exports.Selection = Selection;
});
ace.define("ace/tokenizer", [
    "require",
    "exports",
    "module",
    "ace/config"
], function(acequire, exports, module1) {
    "use strict";
    var config = acequire("./config");
    var MAX_TOKEN_COUNT = 2000;
    var Tokenizer = function(rules) {
        this.states = rules;
        this.regExps = {};
        this.matchMappings = {};
        for(var key in this.states){
            var state = this.states[key];
            var ruleRegExps = [];
            var matchTotal = 0;
            var mapping = this.matchMappings[key] = {
                defaultToken: "text"
            };
            var flag = "g";
            var splitterRurles = [];
            for(var i = 0; i < state.length; i++){
                var rule = state[i];
                if (rule.defaultToken) mapping.defaultToken = rule.defaultToken;
                if (rule.caseInsensitive) flag = "gi";
                if (rule.regex == null) continue;
                if (rule.regex instanceof RegExp) rule.regex = rule.regex.toString().slice(1, -1);
                var adjustedregex = rule.regex;
                var matchcount = new RegExp("(?:(" + adjustedregex + ")|(.))").exec("a").length - 2;
                if (Array.isArray(rule.token)) {
                    if (rule.token.length == 1 || matchcount == 1) rule.token = rule.token[0];
                    else if (matchcount - 1 != rule.token.length) {
                        this.reportError("number of classes and regexp groups doesn't match", {
                            rule: rule,
                            groupCount: matchcount - 1
                        });
                        rule.token = rule.token[0];
                    } else {
                        rule.tokenArray = rule.token;
                        rule.token = null;
                        rule.onMatch = this.$arrayTokens;
                    }
                } else if (typeof rule.token == "function" && !rule.onMatch) {
                    if (matchcount > 1) rule.onMatch = this.$applyToken;
                    else rule.onMatch = rule.token;
                }
                if (matchcount > 1) {
                    if (/\\\d/.test(rule.regex)) adjustedregex = rule.regex.replace(/\\([0-9]+)/g, function(match, digit) {
                        return "\\" + (parseInt(digit, 10) + matchTotal + 1);
                    });
                    else {
                        matchcount = 1;
                        adjustedregex = this.removeCapturingGroups(rule.regex);
                    }
                    if (!rule.splitRegex && typeof rule.token != "string") splitterRurles.push(rule); // flag will be known only at the very end
                }
                mapping[matchTotal] = i;
                matchTotal += matchcount;
                ruleRegExps.push(adjustedregex);
                if (!rule.onMatch) rule.onMatch = null;
            }
            if (!ruleRegExps.length) {
                mapping[0] = 0;
                ruleRegExps.push("$");
            }
            splitterRurles.forEach(function(rule) {
                rule.splitRegex = this.createSplitterRegexp(rule.regex, flag);
            }, this);
            this.regExps[key] = new RegExp("(" + ruleRegExps.join(")|(") + ")|($)", flag);
        }
    };
    (function() {
        this.$setMaxTokenCount = function(m) {
            MAX_TOKEN_COUNT = m | 0;
        };
        this.$applyToken = function(str) {
            var values = this.splitRegex.exec(str).slice(1);
            var types = this.token.apply(this, values);
            if (typeof types === "string") return [
                {
                    type: types,
                    value: str
                }
            ];
            var tokens = [];
            for(var i = 0, l = types.length; i < l; i++)if (values[i]) tokens[tokens.length] = {
                type: types[i],
                value: values[i]
            };
            return tokens;
        };
        this.$arrayTokens = function(str) {
            if (!str) return [];
            var values = this.splitRegex.exec(str);
            if (!values) return "text";
            var tokens = [];
            var types = this.tokenArray;
            for(var i = 0, l = types.length; i < l; i++)if (values[i + 1]) tokens[tokens.length] = {
                type: types[i],
                value: values[i + 1]
            };
            return tokens;
        };
        this.removeCapturingGroups = function(src) {
            var r = src.replace(/\[(?:\\.|[^\]])*?\]|\\.|\(\?[:=!]|(\()/g, function(x, y) {
                return y ? "(?:" : x;
            });
            return r;
        };
        this.createSplitterRegexp = function(src, flag) {
            if (src.indexOf("(?=") != -1) {
                var stack = 0;
                var inChClass = false;
                var lastCapture = {};
                src.replace(/(\\.)|(\((?:\?[=!])?)|(\))|([\[\]])/g, function(m, esc, parenOpen, parenClose, square, index) {
                    if (inChClass) inChClass = square != "]";
                    else if (square) inChClass = true;
                    else if (parenClose) {
                        if (stack == lastCapture.stack) {
                            lastCapture.end = index + 1;
                            lastCapture.stack = -1;
                        }
                        stack--;
                    } else if (parenOpen) {
                        stack++;
                        if (parenOpen.length != 1) {
                            lastCapture.stack = stack;
                            lastCapture.start = index;
                        }
                    }
                    return m;
                });
                if (lastCapture.end != null && /^\)*$/.test(src.substr(lastCapture.end))) src = src.substring(0, lastCapture.start) + src.substr(lastCapture.end);
            }
            if (src.charAt(0) != "^") src = "^" + src;
            if (src.charAt(src.length - 1) != "$") src += "$";
            return new RegExp(src, (flag || "").replace("g", ""));
        };
        this.getLineTokens = function(line, startState) {
            if (startState && typeof startState != "string") {
                var stack = startState.slice(0);
                startState = stack[0];
                if (startState === "#tmp") {
                    stack.shift();
                    startState = stack.shift();
                }
            } else var stack = [];
            var currentState = startState || "start";
            var state = this.states[currentState];
            if (!state) {
                currentState = "start";
                state = this.states[currentState];
            }
            var mapping = this.matchMappings[currentState];
            var re = this.regExps[currentState];
            re.lastIndex = 0;
            var match, tokens = [];
            var lastIndex = 0;
            var matchAttempts = 0;
            var token = {
                type: null,
                value: ""
            };
            while(match = re.exec(line)){
                var type = mapping.defaultToken;
                var rule = null;
                var value = match[0];
                var index = re.lastIndex;
                if (index - value.length > lastIndex) {
                    var skipped = line.substring(lastIndex, index - value.length);
                    if (token.type == type) token.value += skipped;
                    else {
                        if (token.type) tokens.push(token);
                        token = {
                            type: type,
                            value: skipped
                        };
                    }
                }
                for(var i = 0; i < match.length - 2; i++){
                    if (match[i + 1] === undefined) continue;
                    rule = state[mapping[i]];
                    if (rule.onMatch) type = rule.onMatch(value, currentState, stack, line);
                    else type = rule.token;
                    if (rule.next) {
                        if (typeof rule.next == "string") currentState = rule.next;
                        else currentState = rule.next(currentState, stack);
                        state = this.states[currentState];
                        if (!state) {
                            this.reportError("state doesn't exist", currentState);
                            currentState = "start";
                            state = this.states[currentState];
                        }
                        mapping = this.matchMappings[currentState];
                        lastIndex = index;
                        re = this.regExps[currentState];
                        re.lastIndex = index;
                    }
                    if (rule.consumeLineEnd) lastIndex = index;
                    break;
                }
                if (value) {
                    if (typeof type === "string") {
                        if ((!rule || rule.merge !== false) && token.type === type) token.value += value;
                        else {
                            if (token.type) tokens.push(token);
                            token = {
                                type: type,
                                value: value
                            };
                        }
                    } else if (type) {
                        if (token.type) tokens.push(token);
                        token = {
                            type: null,
                            value: ""
                        };
                        for(var i = 0; i < type.length; i++)tokens.push(type[i]);
                    }
                }
                if (lastIndex == line.length) break;
                lastIndex = index;
                if (matchAttempts++ > MAX_TOKEN_COUNT) {
                    if (matchAttempts > 2 * line.length) this.reportError("infinite loop with in ace tokenizer", {
                        startState: startState,
                        line: line
                    });
                    while(lastIndex < line.length){
                        if (token.type) tokens.push(token);
                        token = {
                            value: line.substring(lastIndex, lastIndex += 2000),
                            type: "overflow"
                        };
                    }
                    currentState = "start";
                    stack = [];
                    break;
                }
            }
            if (token.type) tokens.push(token);
            if (stack.length > 1) {
                if (stack[0] !== currentState) stack.unshift("#tmp", currentState);
            }
            return {
                tokens: tokens,
                state: stack.length ? stack : currentState
            };
        };
        this.reportError = config.reportError;
    }).call(Tokenizer.prototype);
    exports.Tokenizer = Tokenizer;
});
ace.define("ace/mode/text_highlight_rules", [
    "require",
    "exports",
    "module",
    "ace/lib/lang"
], function(acequire, exports, module1) {
    "use strict";
    var lang = acequire("../lib/lang");
    var TextHighlightRules = function() {
        this.$rules = {
            "start": [
                {
                    token: "empty_line",
                    regex: '^$'
                },
                {
                    defaultToken: "text"
                }
            ]
        };
    };
    (function() {
        this.addRules = function(rules, prefix) {
            if (!prefix) {
                for(var key in rules)this.$rules[key] = rules[key];
                return;
            }
            for(var key in rules){
                var state = rules[key];
                for(var i = 0; i < state.length; i++){
                    var rule = state[i];
                    if (rule.next || rule.onMatch) {
                        if (typeof rule.next == "string") {
                            if (rule.next.indexOf(prefix) !== 0) rule.next = prefix + rule.next;
                        }
                        if (rule.nextState && rule.nextState.indexOf(prefix) !== 0) rule.nextState = prefix + rule.nextState;
                    }
                }
                this.$rules[prefix + key] = state;
            }
        };
        this.getRules = function() {
            return this.$rules;
        };
        this.embedRules = function(HighlightRules, prefix, escapeRules, states, append) {
            var embedRules = typeof HighlightRules == "function" ? new HighlightRules().getRules() : HighlightRules;
            if (states) for(var i = 0; i < states.length; i++)states[i] = prefix + states[i];
            else {
                states = [];
                for(var key in embedRules)states.push(prefix + key);
            }
            this.addRules(embedRules, prefix);
            if (escapeRules) {
                var addRules = Array.prototype[append ? "push" : "unshift"];
                for(var i = 0; i < states.length; i++)addRules.apply(this.$rules[states[i]], lang.deepCopy(escapeRules));
            }
            if (!this.$embeds) this.$embeds = [];
            this.$embeds.push(prefix);
        };
        this.getEmbeds = function() {
            return this.$embeds;
        };
        var pushState = function(currentState, stack) {
            if (currentState != "start" || stack.length) stack.unshift(this.nextState, currentState);
            return this.nextState;
        };
        var popState = function(currentState, stack) {
            stack.shift();
            return stack.shift() || "start";
        };
        this.normalizeRules = function() {
            var id = 0;
            var rules = this.$rules;
            function processState(key) {
                var state = rules[key];
                state.processed = true;
                for(var i = 0; i < state.length; i++){
                    var rule = state[i];
                    var toInsert = null;
                    if (Array.isArray(rule)) {
                        toInsert = rule;
                        rule = {};
                    }
                    if (!rule.regex && rule.start) {
                        rule.regex = rule.start;
                        if (!rule.next) rule.next = [];
                        rule.next.push({
                            defaultToken: rule.token
                        }, {
                            token: rule.token + ".end",
                            regex: rule.end || rule.start,
                            next: "pop"
                        });
                        rule.token = rule.token + ".start";
                        rule.push = true;
                    }
                    var next = rule.next || rule.push;
                    if (next && Array.isArray(next)) {
                        var stateName = rule.stateName;
                        if (!stateName) {
                            stateName = rule.token;
                            if (typeof stateName != "string") stateName = stateName[0] || "";
                            if (rules[stateName]) stateName += id++;
                        }
                        rules[stateName] = next;
                        rule.next = stateName;
                        processState(stateName);
                    } else if (next == "pop") rule.next = popState;
                    if (rule.push) {
                        rule.nextState = rule.next || rule.push;
                        rule.next = pushState;
                        delete rule.push;
                    }
                    if (rule.rules) for(var r in rule.rules){
                        if (rules[r]) {
                            if (rules[r].push) rules[r].push.apply(rules[r], rule.rules[r]);
                        } else rules[r] = rule.rules[r];
                    }
                    var includeName = typeof rule == "string" ? rule : rule.include;
                    if (includeName) {
                        if (Array.isArray(includeName)) toInsert = includeName.map(function(x) {
                            return rules[x];
                        });
                        else toInsert = rules[includeName];
                    }
                    if (toInsert) {
                        var args = [
                            i,
                            1
                        ].concat(toInsert);
                        if (rule.noEscape) args = args.filter(function(x) {
                            return !x.next;
                        });
                        state.splice.apply(state, args);
                        i--;
                    }
                    if (rule.keywordMap) {
                        rule.token = this.createKeywordMapper(rule.keywordMap, rule.defaultToken || "text", rule.caseInsensitive);
                        delete rule.defaultToken;
                    }
                }
            }
            Object.keys(rules).forEach(processState, this);
        };
        this.createKeywordMapper = function(map, defaultToken, ignoreCase, splitChar) {
            var keywords = Object.create(null);
            Object.keys(map).forEach(function(className) {
                var a = map[className];
                if (ignoreCase) a = a.toLowerCase();
                var list = a.split(splitChar || "|");
                for(var i = list.length; i--;)keywords[list[i]] = className;
            });
            if (Object.getPrototypeOf(keywords)) keywords.__proto__ = null;
            this.$keywordList = Object.keys(keywords);
            map = null;
            return ignoreCase ? function(value) {
                return keywords[value.toLowerCase()] || defaultToken;
            } : function(value) {
                return keywords[value] || defaultToken;
            };
        };
        this.getKeywords = function() {
            return this.$keywords;
        };
    }).call(TextHighlightRules.prototype);
    exports.TextHighlightRules = TextHighlightRules;
});
ace.define("ace/mode/behaviour", [
    "require",
    "exports",
    "module"
], function(acequire, exports, module1) {
    "use strict";
    var Behaviour = function() {
        this.$behaviours = {};
    };
    (function() {
        this.add = function(name, action, callback) {
            switch(undefined){
                case this.$behaviours:
                    this.$behaviours = {};
                case this.$behaviours[name]:
                    this.$behaviours[name] = {};
            }
            this.$behaviours[name][action] = callback;
        };
        this.addBehaviours = function(behaviours) {
            for(var key in behaviours)for(var action in behaviours[key])this.add(key, action, behaviours[key][action]);
        };
        this.remove = function(name) {
            if (this.$behaviours && this.$behaviours[name]) delete this.$behaviours[name];
        };
        this.inherit = function(mode, filter) {
            if (typeof mode === "function") var behaviours = new mode().getBehaviours(filter);
            else var behaviours = mode.getBehaviours(filter);
            this.addBehaviours(behaviours);
        };
        this.getBehaviours = function(filter) {
            if (!filter) return this.$behaviours;
            else {
                var ret = {};
                for(var i = 0; i < filter.length; i++)if (this.$behaviours[filter[i]]) ret[filter[i]] = this.$behaviours[filter[i]];
                return ret;
            }
        };
    }).call(Behaviour.prototype);
    exports.Behaviour = Behaviour;
});
ace.define("ace/token_iterator", [
    "require",
    "exports",
    "module",
    "ace/range"
], function(acequire, exports, module1) {
    "use strict";
    var Range = acequire("./range").Range;
    var TokenIterator = function(session, initialRow, initialColumn) {
        this.$session = session;
        this.$row = initialRow;
        this.$rowTokens = session.getTokens(initialRow);
        var token = session.getTokenAt(initialRow, initialColumn);
        this.$tokenIndex = token ? token.index : -1;
    };
    (function() {
        this.stepBackward = function() {
            this.$tokenIndex -= 1;
            while(this.$tokenIndex < 0){
                this.$row -= 1;
                if (this.$row < 0) {
                    this.$row = 0;
                    return null;
                }
                this.$rowTokens = this.$session.getTokens(this.$row);
                this.$tokenIndex = this.$rowTokens.length - 1;
            }
            return this.$rowTokens[this.$tokenIndex];
        };
        this.stepForward = function() {
            this.$tokenIndex += 1;
            var rowCount;
            while(this.$tokenIndex >= this.$rowTokens.length){
                this.$row += 1;
                if (!rowCount) rowCount = this.$session.getLength();
                if (this.$row >= rowCount) {
                    this.$row = rowCount - 1;
                    return null;
                }
                this.$rowTokens = this.$session.getTokens(this.$row);
                this.$tokenIndex = 0;
            }
            return this.$rowTokens[this.$tokenIndex];
        };
        this.getCurrentToken = function() {
            return this.$rowTokens[this.$tokenIndex];
        };
        this.getCurrentTokenRow = function() {
            return this.$row;
        };
        this.getCurrentTokenColumn = function() {
            var rowTokens = this.$rowTokens;
            var tokenIndex = this.$tokenIndex;
            var column = rowTokens[tokenIndex].start;
            if (column !== undefined) return column;
            column = 0;
            while(tokenIndex > 0){
                tokenIndex -= 1;
                column += rowTokens[tokenIndex].value.length;
            }
            return column;
        };
        this.getCurrentTokenPosition = function() {
            return {
                row: this.$row,
                column: this.getCurrentTokenColumn()
            };
        };
        this.getCurrentTokenRange = function() {
            var token = this.$rowTokens[this.$tokenIndex];
            var column = this.getCurrentTokenColumn();
            return new Range(this.$row, column, this.$row, column + token.value.length);
        };
    }).call(TokenIterator.prototype);
    exports.TokenIterator = TokenIterator;
});
ace.define("ace/mode/behaviour/cstyle", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/behaviour",
    "ace/token_iterator",
    "ace/lib/lang"
], function(acequire, exports, module1) {
    "use strict";
    var oop = acequire("../../lib/oop");
    var Behaviour = acequire("../behaviour").Behaviour;
    var TokenIterator = acequire("../../token_iterator").TokenIterator;
    var lang = acequire("../../lib/lang");
    var SAFE_INSERT_IN_TOKENS = [
        "text",
        "paren.rparen",
        "punctuation.operator"
    ];
    var SAFE_INSERT_BEFORE_TOKENS = [
        "text",
        "paren.rparen",
        "punctuation.operator",
        "comment"
    ];
    var context;
    var contextCache = {};
    var defaultQuotes = {
        '"': '"',
        "'": "'"
    };
    var initContext = function(editor) {
        var id = -1;
        if (editor.multiSelect) {
            id = editor.selection.index;
            if (contextCache.rangeCount != editor.multiSelect.rangeCount) contextCache = {
                rangeCount: editor.multiSelect.rangeCount
            };
        }
        if (contextCache[id]) return context = contextCache[id];
        context = contextCache[id] = {
            autoInsertedBrackets: 0,
            autoInsertedRow: -1,
            autoInsertedLineEnd: "",
            maybeInsertedBrackets: 0,
            maybeInsertedRow: -1,
            maybeInsertedLineStart: "",
            maybeInsertedLineEnd: ""
        };
    };
    var getWrapped = function(selection, selected, opening, closing) {
        var rowDiff = selection.end.row - selection.start.row;
        return {
            text: opening + selected + closing,
            selection: [
                0,
                selection.start.column + 1,
                rowDiff,
                selection.end.column + (rowDiff ? 0 : 1)
            ]
        };
    };
    var CstyleBehaviour = function(options) {
        this.add("braces", "insertion", function(state, action, editor, session, text) {
            var cursor = editor.getCursorPosition();
            var line = session.doc.getLine(cursor.row);
            if (text == '{') {
                initContext(editor);
                var selection = editor.getSelectionRange();
                var selected = session.doc.getTextRange(selection);
                if (selected !== "" && selected !== "{" && editor.getWrapBehavioursEnabled()) return getWrapped(selection, selected, '{', '}');
                else if (CstyleBehaviour.isSaneInsertion(editor, session)) {
                    if (/[\]\}\)]/.test(line[cursor.column]) || editor.inMultiSelectMode || options && options.braces) {
                        CstyleBehaviour.recordAutoInsert(editor, session, "}");
                        return {
                            text: '{}',
                            selection: [
                                1,
                                1
                            ]
                        };
                    } else {
                        CstyleBehaviour.recordMaybeInsert(editor, session, "{");
                        return {
                            text: '{',
                            selection: [
                                1,
                                1
                            ]
                        };
                    }
                }
            } else if (text == '}') {
                initContext(editor);
                var rightChar = line.substring(cursor.column, cursor.column + 1);
                if (rightChar == '}') {
                    var matching = session.$findOpeningBracket('}', {
                        column: cursor.column + 1,
                        row: cursor.row
                    });
                    if (matching !== null && CstyleBehaviour.isAutoInsertedClosing(cursor, line, text)) {
                        CstyleBehaviour.popAutoInsertedClosing();
                        return {
                            text: '',
                            selection: [
                                1,
                                1
                            ]
                        };
                    }
                }
            } else if (text == "\n" || text == "\r\n") {
                initContext(editor);
                var closing = "";
                if (CstyleBehaviour.isMaybeInsertedClosing(cursor, line)) {
                    closing = lang.stringRepeat("}", context.maybeInsertedBrackets);
                    CstyleBehaviour.clearMaybeInsertedClosing();
                }
                var rightChar = line.substring(cursor.column, cursor.column + 1);
                if (rightChar === '}') {
                    var openBracePos = session.findMatchingBracket({
                        row: cursor.row,
                        column: cursor.column + 1
                    }, '}');
                    if (!openBracePos) return null;
                    var next_indent = this.$getIndent(session.getLine(openBracePos.row));
                } else if (closing) var next_indent = this.$getIndent(line);
                else {
                    CstyleBehaviour.clearMaybeInsertedClosing();
                    return;
                }
                var indent = next_indent + session.getTabString();
                return {
                    text: '\n' + indent + '\n' + next_indent + closing,
                    selection: [
                        1,
                        indent.length,
                        1,
                        indent.length
                    ]
                };
            } else CstyleBehaviour.clearMaybeInsertedClosing();
        });
        this.add("braces", "deletion", function(state, action, editor, session, range) {
            var selected = session.doc.getTextRange(range);
            if (!range.isMultiLine() && selected == '{') {
                initContext(editor);
                var line = session.doc.getLine(range.start.row);
                var rightChar = line.substring(range.end.column, range.end.column + 1);
                if (rightChar == '}') {
                    range.end.column++;
                    return range;
                } else context.maybeInsertedBrackets--;
            }
        });
        this.add("parens", "insertion", function(state, action, editor, session, text) {
            if (text == '(') {
                initContext(editor);
                var selection = editor.getSelectionRange();
                var selected = session.doc.getTextRange(selection);
                if (selected !== "" && editor.getWrapBehavioursEnabled()) return getWrapped(selection, selected, '(', ')');
                else if (CstyleBehaviour.isSaneInsertion(editor, session)) {
                    CstyleBehaviour.recordAutoInsert(editor, session, ")");
                    return {
                        text: '()',
                        selection: [
                            1,
                            1
                        ]
                    };
                }
            } else if (text == ')') {
                initContext(editor);
                var cursor = editor.getCursorPosition();
                var line = session.doc.getLine(cursor.row);
                var rightChar = line.substring(cursor.column, cursor.column + 1);
                if (rightChar == ')') {
                    var matching = session.$findOpeningBracket(')', {
                        column: cursor.column + 1,
                        row: cursor.row
                    });
                    if (matching !== null && CstyleBehaviour.isAutoInsertedClosing(cursor, line, text)) {
                        CstyleBehaviour.popAutoInsertedClosing();
                        return {
                            text: '',
                            selection: [
                                1,
                                1
                            ]
                        };
                    }
                }
            }
        });
        this.add("parens", "deletion", function(state, action, editor, session, range) {
            var selected = session.doc.getTextRange(range);
            if (!range.isMultiLine() && selected == '(') {
                initContext(editor);
                var line = session.doc.getLine(range.start.row);
                var rightChar = line.substring(range.start.column + 1, range.start.column + 2);
                if (rightChar == ')') {
                    range.end.column++;
                    return range;
                }
            }
        });
        this.add("brackets", "insertion", function(state, action, editor, session, text) {
            if (text == '[') {
                initContext(editor);
                var selection = editor.getSelectionRange();
                var selected = session.doc.getTextRange(selection);
                if (selected !== "" && editor.getWrapBehavioursEnabled()) return getWrapped(selection, selected, '[', ']');
                else if (CstyleBehaviour.isSaneInsertion(editor, session)) {
                    CstyleBehaviour.recordAutoInsert(editor, session, "]");
                    return {
                        text: '[]',
                        selection: [
                            1,
                            1
                        ]
                    };
                }
            } else if (text == ']') {
                initContext(editor);
                var cursor = editor.getCursorPosition();
                var line = session.doc.getLine(cursor.row);
                var rightChar = line.substring(cursor.column, cursor.column + 1);
                if (rightChar == ']') {
                    var matching = session.$findOpeningBracket(']', {
                        column: cursor.column + 1,
                        row: cursor.row
                    });
                    if (matching !== null && CstyleBehaviour.isAutoInsertedClosing(cursor, line, text)) {
                        CstyleBehaviour.popAutoInsertedClosing();
                        return {
                            text: '',
                            selection: [
                                1,
                                1
                            ]
                        };
                    }
                }
            }
        });
        this.add("brackets", "deletion", function(state, action, editor, session, range) {
            var selected = session.doc.getTextRange(range);
            if (!range.isMultiLine() && selected == '[') {
                initContext(editor);
                var line = session.doc.getLine(range.start.row);
                var rightChar = line.substring(range.start.column + 1, range.start.column + 2);
                if (rightChar == ']') {
                    range.end.column++;
                    return range;
                }
            }
        });
        this.add("string_dquotes", "insertion", function(state, action, editor, session, text) {
            var quotes = session.$mode.$quotes || defaultQuotes;
            if (text.length == 1 && quotes[text]) {
                if (this.lineCommentStart && this.lineCommentStart.indexOf(text) != -1) return;
                initContext(editor);
                var quote = text;
                var selection = editor.getSelectionRange();
                var selected = session.doc.getTextRange(selection);
                if (selected !== "" && (selected.length != 1 || !quotes[selected]) && editor.getWrapBehavioursEnabled()) return getWrapped(selection, selected, quote, quote);
                else if (!selected) {
                    var cursor = editor.getCursorPosition();
                    var line = session.doc.getLine(cursor.row);
                    var leftChar = line.substring(cursor.column - 1, cursor.column);
                    var rightChar = line.substring(cursor.column, cursor.column + 1);
                    var token = session.getTokenAt(cursor.row, cursor.column);
                    var rightToken = session.getTokenAt(cursor.row, cursor.column + 1);
                    if (leftChar == "\\" && token && /escape/.test(token.type)) return null;
                    var stringBefore = token && /string|escape/.test(token.type);
                    var stringAfter = !rightToken || /string|escape/.test(rightToken.type);
                    var pair;
                    if (rightChar == quote) {
                        pair = stringBefore !== stringAfter;
                        if (pair && /string\.end/.test(rightToken.type)) pair = false;
                    } else {
                        if (stringBefore && !stringAfter) return null; // wrap string with different quote
                        if (stringBefore && stringAfter) return null; // do not pair quotes inside strings
                        var wordRe = session.$mode.tokenRe;
                        wordRe.lastIndex = 0;
                        var isWordBefore = wordRe.test(leftChar);
                        wordRe.lastIndex = 0;
                        var isWordAfter = wordRe.test(leftChar);
                        if (isWordBefore || isWordAfter) return null; // before or after alphanumeric
                        if (rightChar && !/[\s;,.})\]\\]/.test(rightChar)) return null; // there is rightChar and it isn't closing
                        pair = true;
                    }
                    return {
                        text: pair ? quote + quote : "",
                        selection: [
                            1,
                            1
                        ]
                    };
                }
            }
        });
        this.add("string_dquotes", "deletion", function(state, action, editor, session, range) {
            var selected = session.doc.getTextRange(range);
            if (!range.isMultiLine() && (selected == '"' || selected == "'")) {
                initContext(editor);
                var line = session.doc.getLine(range.start.row);
                var rightChar = line.substring(range.start.column + 1, range.start.column + 2);
                if (rightChar == selected) {
                    range.end.column++;
                    return range;
                }
            }
        });
    };
    CstyleBehaviour.isSaneInsertion = function(editor, session) {
        var cursor = editor.getCursorPosition();
        var iterator = new TokenIterator(session, cursor.row, cursor.column);
        if (!this.$matchTokenType(iterator.getCurrentToken() || "text", SAFE_INSERT_IN_TOKENS)) {
            var iterator2 = new TokenIterator(session, cursor.row, cursor.column + 1);
            if (!this.$matchTokenType(iterator2.getCurrentToken() || "text", SAFE_INSERT_IN_TOKENS)) return false;
        }
        iterator.stepForward();
        return iterator.getCurrentTokenRow() !== cursor.row || this.$matchTokenType(iterator.getCurrentToken() || "text", SAFE_INSERT_BEFORE_TOKENS);
    };
    CstyleBehaviour.$matchTokenType = function(token, types) {
        return types.indexOf(token.type || token) > -1;
    };
    CstyleBehaviour.recordAutoInsert = function(editor, session, bracket) {
        var cursor = editor.getCursorPosition();
        var line = session.doc.getLine(cursor.row);
        if (!this.isAutoInsertedClosing(cursor, line, context.autoInsertedLineEnd[0])) context.autoInsertedBrackets = 0;
        context.autoInsertedRow = cursor.row;
        context.autoInsertedLineEnd = bracket + line.substr(cursor.column);
        context.autoInsertedBrackets++;
    };
    CstyleBehaviour.recordMaybeInsert = function(editor, session, bracket) {
        var cursor = editor.getCursorPosition();
        var line = session.doc.getLine(cursor.row);
        if (!this.isMaybeInsertedClosing(cursor, line)) context.maybeInsertedBrackets = 0;
        context.maybeInsertedRow = cursor.row;
        context.maybeInsertedLineStart = line.substr(0, cursor.column) + bracket;
        context.maybeInsertedLineEnd = line.substr(cursor.column);
        context.maybeInsertedBrackets++;
    };
    CstyleBehaviour.isAutoInsertedClosing = function(cursor, line, bracket) {
        return context.autoInsertedBrackets > 0 && cursor.row === context.autoInsertedRow && bracket === context.autoInsertedLineEnd[0] && line.substr(cursor.column) === context.autoInsertedLineEnd;
    };
    CstyleBehaviour.isMaybeInsertedClosing = function(cursor, line) {
        return context.maybeInsertedBrackets > 0 && cursor.row === context.maybeInsertedRow && line.substr(cursor.column) === context.maybeInsertedLineEnd && line.substr(0, cursor.column) == context.maybeInsertedLineStart;
    };
    CstyleBehaviour.popAutoInsertedClosing = function() {
        context.autoInsertedLineEnd = context.autoInsertedLineEnd.substr(1);
        context.autoInsertedBrackets--;
    };
    CstyleBehaviour.clearMaybeInsertedClosing = function() {
        if (context) {
            context.maybeInsertedBrackets = 0;
            context.maybeInsertedRow = -1;
        }
    };
    oop.inherits(CstyleBehaviour, Behaviour);
    exports.CstyleBehaviour = CstyleBehaviour;
});
ace.define("ace/unicode", [
    "require",
    "exports",
    "module"
], function(acequire, exports, module1) {
    "use strict";
    exports.packages = {};
    addUnicodePackage({
        L: "0041-005A0061-007A00AA00B500BA00C0-00D600D8-00F600F8-02C102C6-02D102E0-02E402EC02EE0370-037403760377037A-037D03860388-038A038C038E-03A103A3-03F503F7-0481048A-05250531-055605590561-058705D0-05EA05F0-05F20621-064A066E066F0671-06D306D506E506E606EE06EF06FA-06FC06FF07100712-072F074D-07A507B107CA-07EA07F407F507FA0800-0815081A082408280904-0939093D09500958-0961097109720979-097F0985-098C098F09900993-09A809AA-09B009B209B6-09B909BD09CE09DC09DD09DF-09E109F009F10A05-0A0A0A0F0A100A13-0A280A2A-0A300A320A330A350A360A380A390A59-0A5C0A5E0A72-0A740A85-0A8D0A8F-0A910A93-0AA80AAA-0AB00AB20AB30AB5-0AB90ABD0AD00AE00AE10B05-0B0C0B0F0B100B13-0B280B2A-0B300B320B330B35-0B390B3D0B5C0B5D0B5F-0B610B710B830B85-0B8A0B8E-0B900B92-0B950B990B9A0B9C0B9E0B9F0BA30BA40BA8-0BAA0BAE-0BB90BD00C05-0C0C0C0E-0C100C12-0C280C2A-0C330C35-0C390C3D0C580C590C600C610C85-0C8C0C8E-0C900C92-0CA80CAA-0CB30CB5-0CB90CBD0CDE0CE00CE10D05-0D0C0D0E-0D100D12-0D280D2A-0D390D3D0D600D610D7A-0D7F0D85-0D960D9A-0DB10DB3-0DBB0DBD0DC0-0DC60E01-0E300E320E330E40-0E460E810E820E840E870E880E8A0E8D0E94-0E970E99-0E9F0EA1-0EA30EA50EA70EAA0EAB0EAD-0EB00EB20EB30EBD0EC0-0EC40EC60EDC0EDD0F000F40-0F470F49-0F6C0F88-0F8B1000-102A103F1050-1055105A-105D106110651066106E-10701075-1081108E10A0-10C510D0-10FA10FC1100-1248124A-124D1250-12561258125A-125D1260-1288128A-128D1290-12B012B2-12B512B8-12BE12C012C2-12C512C8-12D612D8-13101312-13151318-135A1380-138F13A0-13F41401-166C166F-167F1681-169A16A0-16EA1700-170C170E-17111720-17311740-17511760-176C176E-17701780-17B317D717DC1820-18771880-18A818AA18B0-18F51900-191C1950-196D1970-19741980-19AB19C1-19C71A00-1A161A20-1A541AA71B05-1B331B45-1B4B1B83-1BA01BAE1BAF1C00-1C231C4D-1C4F1C5A-1C7D1CE9-1CEC1CEE-1CF11D00-1DBF1E00-1F151F18-1F1D1F20-1F451F48-1F4D1F50-1F571F591F5B1F5D1F5F-1F7D1F80-1FB41FB6-1FBC1FBE1FC2-1FC41FC6-1FCC1FD0-1FD31FD6-1FDB1FE0-1FEC1FF2-1FF41FF6-1FFC2071207F2090-209421022107210A-211321152119-211D212421262128212A-212D212F-2139213C-213F2145-2149214E218321842C00-2C2E2C30-2C5E2C60-2CE42CEB-2CEE2D00-2D252D30-2D652D6F2D80-2D962DA0-2DA62DA8-2DAE2DB0-2DB62DB8-2DBE2DC0-2DC62DC8-2DCE2DD0-2DD62DD8-2DDE2E2F300530063031-3035303B303C3041-3096309D-309F30A1-30FA30FC-30FF3105-312D3131-318E31A0-31B731F0-31FF3400-4DB54E00-9FCBA000-A48CA4D0-A4FDA500-A60CA610-A61FA62AA62BA640-A65FA662-A66EA67F-A697A6A0-A6E5A717-A71FA722-A788A78BA78CA7FB-A801A803-A805A807-A80AA80C-A822A840-A873A882-A8B3A8F2-A8F7A8FBA90A-A925A930-A946A960-A97CA984-A9B2A9CFAA00-AA28AA40-AA42AA44-AA4BAA60-AA76AA7AAA80-AAAFAAB1AAB5AAB6AAB9-AABDAAC0AAC2AADB-AADDABC0-ABE2AC00-D7A3D7B0-D7C6D7CB-D7FBF900-FA2DFA30-FA6DFA70-FAD9FB00-FB06FB13-FB17FB1DFB1F-FB28FB2A-FB36FB38-FB3CFB3EFB40FB41FB43FB44FB46-FBB1FBD3-FD3DFD50-FD8FFD92-FDC7FDF0-FDFBFE70-FE74FE76-FEFCFF21-FF3AFF41-FF5AFF66-FFBEFFC2-FFC7FFCA-FFCFFFD2-FFD7FFDA-FFDC",
        Ll: "0061-007A00AA00B500BA00DF-00F600F8-00FF01010103010501070109010B010D010F01110113011501170119011B011D011F01210123012501270129012B012D012F01310133013501370138013A013C013E014001420144014601480149014B014D014F01510153015501570159015B015D015F01610163016501670169016B016D016F0171017301750177017A017C017E-0180018301850188018C018D019201950199-019B019E01A101A301A501A801AA01AB01AD01B001B401B601B901BA01BD-01BF01C601C901CC01CE01D001D201D401D601D801DA01DC01DD01DF01E101E301E501E701E901EB01ED01EF01F001F301F501F901FB01FD01FF02010203020502070209020B020D020F02110213021502170219021B021D021F02210223022502270229022B022D022F02310233-0239023C023F0240024202470249024B024D024F-02930295-02AF037103730377037B-037D039003AC-03CE03D003D103D5-03D703D903DB03DD03DF03E103E303E503E703E903EB03ED03EF-03F303F503F803FB03FC0430-045F04610463046504670469046B046D046F04710473047504770479047B047D047F0481048B048D048F04910493049504970499049B049D049F04A104A304A504A704A904AB04AD04AF04B104B304B504B704B904BB04BD04BF04C204C404C604C804CA04CC04CE04CF04D104D304D504D704D904DB04DD04DF04E104E304E504E704E904EB04ED04EF04F104F304F504F704F904FB04FD04FF05010503050505070509050B050D050F05110513051505170519051B051D051F0521052305250561-05871D00-1D2B1D62-1D771D79-1D9A1E011E031E051E071E091E0B1E0D1E0F1E111E131E151E171E191E1B1E1D1E1F1E211E231E251E271E291E2B1E2D1E2F1E311E331E351E371E391E3B1E3D1E3F1E411E431E451E471E491E4B1E4D1E4F1E511E531E551E571E591E5B1E5D1E5F1E611E631E651E671E691E6B1E6D1E6F1E711E731E751E771E791E7B1E7D1E7F1E811E831E851E871E891E8B1E8D1E8F1E911E931E95-1E9D1E9F1EA11EA31EA51EA71EA91EAB1EAD1EAF1EB11EB31EB51EB71EB91EBB1EBD1EBF1EC11EC31EC51EC71EC91ECB1ECD1ECF1ED11ED31ED51ED71ED91EDB1EDD1EDF1EE11EE31EE51EE71EE91EEB1EED1EEF1EF11EF31EF51EF71EF91EFB1EFD1EFF-1F071F10-1F151F20-1F271F30-1F371F40-1F451F50-1F571F60-1F671F70-1F7D1F80-1F871F90-1F971FA0-1FA71FB0-1FB41FB61FB71FBE1FC2-1FC41FC61FC71FD0-1FD31FD61FD71FE0-1FE71FF2-1FF41FF61FF7210A210E210F2113212F21342139213C213D2146-2149214E21842C30-2C5E2C612C652C662C682C6A2C6C2C712C732C742C76-2C7C2C812C832C852C872C892C8B2C8D2C8F2C912C932C952C972C992C9B2C9D2C9F2CA12CA32CA52CA72CA92CAB2CAD2CAF2CB12CB32CB52CB72CB92CBB2CBD2CBF2CC12CC32CC52CC72CC92CCB2CCD2CCF2CD12CD32CD52CD72CD92CDB2CDD2CDF2CE12CE32CE42CEC2CEE2D00-2D25A641A643A645A647A649A64BA64DA64FA651A653A655A657A659A65BA65DA65FA663A665A667A669A66BA66DA681A683A685A687A689A68BA68DA68FA691A693A695A697A723A725A727A729A72BA72DA72F-A731A733A735A737A739A73BA73DA73FA741A743A745A747A749A74BA74DA74FA751A753A755A757A759A75BA75DA75FA761A763A765A767A769A76BA76DA76FA771-A778A77AA77CA77FA781A783A785A787A78CFB00-FB06FB13-FB17FF41-FF5A",
        Lu: "0041-005A00C0-00D600D8-00DE01000102010401060108010A010C010E01100112011401160118011A011C011E01200122012401260128012A012C012E01300132013401360139013B013D013F0141014301450147014A014C014E01500152015401560158015A015C015E01600162016401660168016A016C016E017001720174017601780179017B017D018101820184018601870189-018B018E-0191019301940196-0198019C019D019F01A001A201A401A601A701A901AC01AE01AF01B1-01B301B501B701B801BC01C401C701CA01CD01CF01D101D301D501D701D901DB01DE01E001E201E401E601E801EA01EC01EE01F101F401F6-01F801FA01FC01FE02000202020402060208020A020C020E02100212021402160218021A021C021E02200222022402260228022A022C022E02300232023A023B023D023E02410243-02460248024A024C024E03700372037603860388-038A038C038E038F0391-03A103A3-03AB03CF03D2-03D403D803DA03DC03DE03E003E203E403E603E803EA03EC03EE03F403F703F903FA03FD-042F04600462046404660468046A046C046E04700472047404760478047A047C047E0480048A048C048E04900492049404960498049A049C049E04A004A204A404A604A804AA04AC04AE04B004B204B404B604B804BA04BC04BE04C004C104C304C504C704C904CB04CD04D004D204D404D604D804DA04DC04DE04E004E204E404E604E804EA04EC04EE04F004F204F404F604F804FA04FC04FE05000502050405060508050A050C050E05100512051405160518051A051C051E0520052205240531-055610A0-10C51E001E021E041E061E081E0A1E0C1E0E1E101E121E141E161E181E1A1E1C1E1E1E201E221E241E261E281E2A1E2C1E2E1E301E321E341E361E381E3A1E3C1E3E1E401E421E441E461E481E4A1E4C1E4E1E501E521E541E561E581E5A1E5C1E5E1E601E621E641E661E681E6A1E6C1E6E1E701E721E741E761E781E7A1E7C1E7E1E801E821E841E861E881E8A1E8C1E8E1E901E921E941E9E1EA01EA21EA41EA61EA81EAA1EAC1EAE1EB01EB21EB41EB61EB81EBA1EBC1EBE1EC01EC21EC41EC61EC81ECA1ECC1ECE1ED01ED21ED41ED61ED81EDA1EDC1EDE1EE01EE21EE41EE61EE81EEA1EEC1EEE1EF01EF21EF41EF61EF81EFA1EFC1EFE1F08-1F0F1F18-1F1D1F28-1F2F1F38-1F3F1F48-1F4D1F591F5B1F5D1F5F1F68-1F6F1FB8-1FBB1FC8-1FCB1FD8-1FDB1FE8-1FEC1FF8-1FFB21022107210B-210D2110-211221152119-211D212421262128212A-212D2130-2133213E213F214521832C00-2C2E2C602C62-2C642C672C692C6B2C6D-2C702C722C752C7E-2C802C822C842C862C882C8A2C8C2C8E2C902C922C942C962C982C9A2C9C2C9E2CA02CA22CA42CA62CA82CAA2CAC2CAE2CB02CB22CB42CB62CB82CBA2CBC2CBE2CC02CC22CC42CC62CC82CCA2CCC2CCE2CD02CD22CD42CD62CD82CDA2CDC2CDE2CE02CE22CEB2CEDA640A642A644A646A648A64AA64CA64EA650A652A654A656A658A65AA65CA65EA662A664A666A668A66AA66CA680A682A684A686A688A68AA68CA68EA690A692A694A696A722A724A726A728A72AA72CA72EA732A734A736A738A73AA73CA73EA740A742A744A746A748A74AA74CA74EA750A752A754A756A758A75AA75CA75EA760A762A764A766A768A76AA76CA76EA779A77BA77DA77EA780A782A784A786A78BFF21-FF3A",
        Lt: "01C501C801CB01F21F88-1F8F1F98-1F9F1FA8-1FAF1FBC1FCC1FFC",
        Lm: "02B0-02C102C6-02D102E0-02E402EC02EE0374037A0559064006E506E607F407F507FA081A0824082809710E460EC610FC17D718431AA71C78-1C7D1D2C-1D611D781D9B-1DBF2071207F2090-20942C7D2D6F2E2F30053031-3035303B309D309E30FC-30FEA015A4F8-A4FDA60CA67FA717-A71FA770A788A9CFAA70AADDFF70FF9EFF9F",
        Lo: "01BB01C0-01C3029405D0-05EA05F0-05F20621-063F0641-064A066E066F0671-06D306D506EE06EF06FA-06FC06FF07100712-072F074D-07A507B107CA-07EA0800-08150904-0939093D09500958-096109720979-097F0985-098C098F09900993-09A809AA-09B009B209B6-09B909BD09CE09DC09DD09DF-09E109F009F10A05-0A0A0A0F0A100A13-0A280A2A-0A300A320A330A350A360A380A390A59-0A5C0A5E0A72-0A740A85-0A8D0A8F-0A910A93-0AA80AAA-0AB00AB20AB30AB5-0AB90ABD0AD00AE00AE10B05-0B0C0B0F0B100B13-0B280B2A-0B300B320B330B35-0B390B3D0B5C0B5D0B5F-0B610B710B830B85-0B8A0B8E-0B900B92-0B950B990B9A0B9C0B9E0B9F0BA30BA40BA8-0BAA0BAE-0BB90BD00C05-0C0C0C0E-0C100C12-0C280C2A-0C330C35-0C390C3D0C580C590C600C610C85-0C8C0C8E-0C900C92-0CA80CAA-0CB30CB5-0CB90CBD0CDE0CE00CE10D05-0D0C0D0E-0D100D12-0D280D2A-0D390D3D0D600D610D7A-0D7F0D85-0D960D9A-0DB10DB3-0DBB0DBD0DC0-0DC60E01-0E300E320E330E40-0E450E810E820E840E870E880E8A0E8D0E94-0E970E99-0E9F0EA1-0EA30EA50EA70EAA0EAB0EAD-0EB00EB20EB30EBD0EC0-0EC40EDC0EDD0F000F40-0F470F49-0F6C0F88-0F8B1000-102A103F1050-1055105A-105D106110651066106E-10701075-1081108E10D0-10FA1100-1248124A-124D1250-12561258125A-125D1260-1288128A-128D1290-12B012B2-12B512B8-12BE12C012C2-12C512C8-12D612D8-13101312-13151318-135A1380-138F13A0-13F41401-166C166F-167F1681-169A16A0-16EA1700-170C170E-17111720-17311740-17511760-176C176E-17701780-17B317DC1820-18421844-18771880-18A818AA18B0-18F51900-191C1950-196D1970-19741980-19AB19C1-19C71A00-1A161A20-1A541B05-1B331B45-1B4B1B83-1BA01BAE1BAF1C00-1C231C4D-1C4F1C5A-1C771CE9-1CEC1CEE-1CF12135-21382D30-2D652D80-2D962DA0-2DA62DA8-2DAE2DB0-2DB62DB8-2DBE2DC0-2DC62DC8-2DCE2DD0-2DD62DD8-2DDE3006303C3041-3096309F30A1-30FA30FF3105-312D3131-318E31A0-31B731F0-31FF3400-4DB54E00-9FCBA000-A014A016-A48CA4D0-A4F7A500-A60BA610-A61FA62AA62BA66EA6A0-A6E5A7FB-A801A803-A805A807-A80AA80C-A822A840-A873A882-A8B3A8F2-A8F7A8FBA90A-A925A930-A946A960-A97CA984-A9B2AA00-AA28AA40-AA42AA44-AA4BAA60-AA6FAA71-AA76AA7AAA80-AAAFAAB1AAB5AAB6AAB9-AABDAAC0AAC2AADBAADCABC0-ABE2AC00-D7A3D7B0-D7C6D7CB-D7FBF900-FA2DFA30-FA6DFA70-FAD9FB1DFB1F-FB28FB2A-FB36FB38-FB3CFB3EFB40FB41FB43FB44FB46-FBB1FBD3-FD3DFD50-FD8FFD92-FDC7FDF0-FDFBFE70-FE74FE76-FEFCFF66-FF6FFF71-FF9DFFA0-FFBEFFC2-FFC7FFCA-FFCFFFD2-FFD7FFDA-FFDC",
        M: "0300-036F0483-04890591-05BD05BF05C105C205C405C505C70610-061A064B-065E067006D6-06DC06DE-06E406E706E806EA-06ED07110730-074A07A6-07B007EB-07F30816-0819081B-08230825-08270829-082D0900-0903093C093E-094E0951-0955096209630981-098309BC09BE-09C409C709C809CB-09CD09D709E209E30A01-0A030A3C0A3E-0A420A470A480A4B-0A4D0A510A700A710A750A81-0A830ABC0ABE-0AC50AC7-0AC90ACB-0ACD0AE20AE30B01-0B030B3C0B3E-0B440B470B480B4B-0B4D0B560B570B620B630B820BBE-0BC20BC6-0BC80BCA-0BCD0BD70C01-0C030C3E-0C440C46-0C480C4A-0C4D0C550C560C620C630C820C830CBC0CBE-0CC40CC6-0CC80CCA-0CCD0CD50CD60CE20CE30D020D030D3E-0D440D46-0D480D4A-0D4D0D570D620D630D820D830DCA0DCF-0DD40DD60DD8-0DDF0DF20DF30E310E34-0E3A0E47-0E4E0EB10EB4-0EB90EBB0EBC0EC8-0ECD0F180F190F350F370F390F3E0F3F0F71-0F840F860F870F90-0F970F99-0FBC0FC6102B-103E1056-1059105E-10601062-10641067-106D1071-10741082-108D108F109A-109D135F1712-17141732-1734175217531772177317B6-17D317DD180B-180D18A91920-192B1930-193B19B0-19C019C819C91A17-1A1B1A55-1A5E1A60-1A7C1A7F1B00-1B041B34-1B441B6B-1B731B80-1B821BA1-1BAA1C24-1C371CD0-1CD21CD4-1CE81CED1CF21DC0-1DE61DFD-1DFF20D0-20F02CEF-2CF12DE0-2DFF302A-302F3099309AA66F-A672A67CA67DA6F0A6F1A802A806A80BA823-A827A880A881A8B4-A8C4A8E0-A8F1A926-A92DA947-A953A980-A983A9B3-A9C0AA29-AA36AA43AA4CAA4DAA7BAAB0AAB2-AAB4AAB7AAB8AABEAABFAAC1ABE3-ABEAABECABEDFB1EFE00-FE0FFE20-FE26",
        Mn: "0300-036F0483-04870591-05BD05BF05C105C205C405C505C70610-061A064B-065E067006D6-06DC06DF-06E406E706E806EA-06ED07110730-074A07A6-07B007EB-07F30816-0819081B-08230825-08270829-082D0900-0902093C0941-0948094D0951-095509620963098109BC09C1-09C409CD09E209E30A010A020A3C0A410A420A470A480A4B-0A4D0A510A700A710A750A810A820ABC0AC1-0AC50AC70AC80ACD0AE20AE30B010B3C0B3F0B41-0B440B4D0B560B620B630B820BC00BCD0C3E-0C400C46-0C480C4A-0C4D0C550C560C620C630CBC0CBF0CC60CCC0CCD0CE20CE30D41-0D440D4D0D620D630DCA0DD2-0DD40DD60E310E34-0E3A0E47-0E4E0EB10EB4-0EB90EBB0EBC0EC8-0ECD0F180F190F350F370F390F71-0F7E0F80-0F840F860F870F90-0F970F99-0FBC0FC6102D-10301032-10371039103A103D103E10581059105E-10601071-1074108210851086108D109D135F1712-17141732-1734175217531772177317B7-17BD17C617C9-17D317DD180B-180D18A91920-19221927192819321939-193B1A171A181A561A58-1A5E1A601A621A65-1A6C1A73-1A7C1A7F1B00-1B031B341B36-1B3A1B3C1B421B6B-1B731B801B811BA2-1BA51BA81BA91C2C-1C331C361C371CD0-1CD21CD4-1CE01CE2-1CE81CED1DC0-1DE61DFD-1DFF20D0-20DC20E120E5-20F02CEF-2CF12DE0-2DFF302A-302F3099309AA66FA67CA67DA6F0A6F1A802A806A80BA825A826A8C4A8E0-A8F1A926-A92DA947-A951A980-A982A9B3A9B6-A9B9A9BCAA29-AA2EAA31AA32AA35AA36AA43AA4CAAB0AAB2-AAB4AAB7AAB8AABEAABFAAC1ABE5ABE8ABEDFB1EFE00-FE0FFE20-FE26",
        Mc: "0903093E-09400949-094C094E0982098309BE-09C009C709C809CB09CC09D70A030A3E-0A400A830ABE-0AC00AC90ACB0ACC0B020B030B3E0B400B470B480B4B0B4C0B570BBE0BBF0BC10BC20BC6-0BC80BCA-0BCC0BD70C01-0C030C41-0C440C820C830CBE0CC0-0CC40CC70CC80CCA0CCB0CD50CD60D020D030D3E-0D400D46-0D480D4A-0D4C0D570D820D830DCF-0DD10DD8-0DDF0DF20DF30F3E0F3F0F7F102B102C10311038103B103C105610571062-10641067-106D108310841087-108C108F109A-109C17B617BE-17C517C717C81923-19261929-192B193019311933-193819B0-19C019C819C91A19-1A1B1A551A571A611A631A641A6D-1A721B041B351B3B1B3D-1B411B431B441B821BA11BA61BA71BAA1C24-1C2B1C341C351CE11CF2A823A824A827A880A881A8B4-A8C3A952A953A983A9B4A9B5A9BAA9BBA9BD-A9C0AA2FAA30AA33AA34AA4DAA7BABE3ABE4ABE6ABE7ABE9ABEAABEC",
        Me: "0488048906DE20DD-20E020E2-20E4A670-A672",
        N: "0030-003900B200B300B900BC-00BE0660-066906F0-06F907C0-07C90966-096F09E6-09EF09F4-09F90A66-0A6F0AE6-0AEF0B66-0B6F0BE6-0BF20C66-0C6F0C78-0C7E0CE6-0CEF0D66-0D750E50-0E590ED0-0ED90F20-0F331040-10491090-10991369-137C16EE-16F017E0-17E917F0-17F91810-18191946-194F19D0-19DA1A80-1A891A90-1A991B50-1B591BB0-1BB91C40-1C491C50-1C5920702074-20792080-20892150-21822185-21892460-249B24EA-24FF2776-27932CFD30073021-30293038-303A3192-31953220-32293251-325F3280-328932B1-32BFA620-A629A6E6-A6EFA830-A835A8D0-A8D9A900-A909A9D0-A9D9AA50-AA59ABF0-ABF9FF10-FF19",
        Nd: "0030-00390660-066906F0-06F907C0-07C90966-096F09E6-09EF0A66-0A6F0AE6-0AEF0B66-0B6F0BE6-0BEF0C66-0C6F0CE6-0CEF0D66-0D6F0E50-0E590ED0-0ED90F20-0F291040-10491090-109917E0-17E91810-18191946-194F19D0-19DA1A80-1A891A90-1A991B50-1B591BB0-1BB91C40-1C491C50-1C59A620-A629A8D0-A8D9A900-A909A9D0-A9D9AA50-AA59ABF0-ABF9FF10-FF19",
        Nl: "16EE-16F02160-21822185-218830073021-30293038-303AA6E6-A6EF",
        No: "00B200B300B900BC-00BE09F4-09F90BF0-0BF20C78-0C7E0D70-0D750F2A-0F331369-137C17F0-17F920702074-20792080-20892150-215F21892460-249B24EA-24FF2776-27932CFD3192-31953220-32293251-325F3280-328932B1-32BFA830-A835",
        P: "0021-00230025-002A002C-002F003A003B003F0040005B-005D005F007B007D00A100AB00B700BB00BF037E0387055A-055F0589058A05BE05C005C305C605F305F40609060A060C060D061B061E061F066A-066D06D40700-070D07F7-07F90830-083E0964096509700DF40E4F0E5A0E5B0F04-0F120F3A-0F3D0F850FD0-0FD4104A-104F10FB1361-13681400166D166E169B169C16EB-16ED1735173617D4-17D617D8-17DA1800-180A1944194519DE19DF1A1E1A1F1AA0-1AA61AA8-1AAD1B5A-1B601C3B-1C3F1C7E1C7F1CD32010-20272030-20432045-20512053-205E207D207E208D208E2329232A2768-277527C527C627E6-27EF2983-299829D8-29DB29FC29FD2CF9-2CFC2CFE2CFF2E00-2E2E2E302E313001-30033008-30113014-301F3030303D30A030FBA4FEA4FFA60D-A60FA673A67EA6F2-A6F7A874-A877A8CEA8CFA8F8-A8FAA92EA92FA95FA9C1-A9CDA9DEA9DFAA5C-AA5FAADEAADFABEBFD3EFD3FFE10-FE19FE30-FE52FE54-FE61FE63FE68FE6AFE6BFF01-FF03FF05-FF0AFF0C-FF0FFF1AFF1BFF1FFF20FF3B-FF3DFF3FFF5BFF5DFF5F-FF65",
        Pd: "002D058A05BE140018062010-20152E172E1A301C303030A0FE31FE32FE58FE63FF0D",
        Ps: "0028005B007B0F3A0F3C169B201A201E2045207D208D23292768276A276C276E27702772277427C527E627E827EA27EC27EE2983298529872989298B298D298F299129932995299729D829DA29FC2E222E242E262E283008300A300C300E3010301430163018301A301DFD3EFE17FE35FE37FE39FE3BFE3DFE3FFE41FE43FE47FE59FE5BFE5DFF08FF3BFF5BFF5FFF62",
        Pe: "0029005D007D0F3B0F3D169C2046207E208E232A2769276B276D276F27712773277527C627E727E927EB27ED27EF298429862988298A298C298E2990299229942996299829D929DB29FD2E232E252E272E293009300B300D300F3011301530173019301B301E301FFD3FFE18FE36FE38FE3AFE3CFE3EFE40FE42FE44FE48FE5AFE5CFE5EFF09FF3DFF5DFF60FF63",
        Pi: "00AB2018201B201C201F20392E022E042E092E0C2E1C2E20",
        Pf: "00BB2019201D203A2E032E052E0A2E0D2E1D2E21",
        Pc: "005F203F20402054FE33FE34FE4D-FE4FFF3F",
        Po: "0021-00230025-0027002A002C002E002F003A003B003F0040005C00A100B700BF037E0387055A-055F058905C005C305C605F305F40609060A060C060D061B061E061F066A-066D06D40700-070D07F7-07F90830-083E0964096509700DF40E4F0E5A0E5B0F04-0F120F850FD0-0FD4104A-104F10FB1361-1368166D166E16EB-16ED1735173617D4-17D617D8-17DA1800-18051807-180A1944194519DE19DF1A1E1A1F1AA0-1AA61AA8-1AAD1B5A-1B601C3B-1C3F1C7E1C7F1CD3201620172020-20272030-2038203B-203E2041-20432047-205120532055-205E2CF9-2CFC2CFE2CFF2E002E012E06-2E082E0B2E0E-2E162E182E192E1B2E1E2E1F2E2A-2E2E2E302E313001-3003303D30FBA4FEA4FFA60D-A60FA673A67EA6F2-A6F7A874-A877A8CEA8CFA8F8-A8FAA92EA92FA95FA9C1-A9CDA9DEA9DFAA5C-AA5FAADEAADFABEBFE10-FE16FE19FE30FE45FE46FE49-FE4CFE50-FE52FE54-FE57FE5F-FE61FE68FE6AFE6BFF01-FF03FF05-FF07FF0AFF0CFF0EFF0FFF1AFF1BFF1FFF20FF3CFF61FF64FF65",
        S: "0024002B003C-003E005E0060007C007E00A2-00A900AC00AE-00B100B400B600B800D700F702C2-02C502D2-02DF02E5-02EB02ED02EF-02FF03750384038503F604820606-0608060B060E060F06E906FD06FE07F609F209F309FA09FB0AF10B700BF3-0BFA0C7F0CF10CF20D790E3F0F01-0F030F13-0F170F1A-0F1F0F340F360F380FBE-0FC50FC7-0FCC0FCE0FCF0FD5-0FD8109E109F13601390-139917DB194019E0-19FF1B61-1B6A1B74-1B7C1FBD1FBF-1FC11FCD-1FCF1FDD-1FDF1FED-1FEF1FFD1FFE20442052207A-207C208A-208C20A0-20B8210021012103-21062108210921142116-2118211E-2123212521272129212E213A213B2140-2144214A-214D214F2190-2328232B-23E82400-24262440-244A249C-24E92500-26CD26CF-26E126E326E8-26FF2701-27042706-2709270C-27272729-274B274D274F-27522756-275E2761-276727942798-27AF27B1-27BE27C0-27C427C7-27CA27CC27D0-27E527F0-29822999-29D729DC-29FB29FE-2B4C2B50-2B592CE5-2CEA2E80-2E992E9B-2EF32F00-2FD52FF0-2FFB300430123013302030363037303E303F309B309C319031913196-319F31C0-31E33200-321E322A-32503260-327F328A-32B032C0-32FE3300-33FF4DC0-4DFFA490-A4C6A700-A716A720A721A789A78AA828-A82BA836-A839AA77-AA79FB29FDFCFDFDFE62FE64-FE66FE69FF04FF0BFF1C-FF1EFF3EFF40FF5CFF5EFFE0-FFE6FFE8-FFEEFFFCFFFD",
        Sm: "002B003C-003E007C007E00AC00B100D700F703F60606-060820442052207A-207C208A-208C2140-2144214B2190-2194219A219B21A021A321A621AE21CE21CF21D221D421F4-22FF2308-230B23202321237C239B-23B323DC-23E125B725C125F8-25FF266F27C0-27C427C7-27CA27CC27D0-27E527F0-27FF2900-29822999-29D729DC-29FB29FE-2AFF2B30-2B442B47-2B4CFB29FE62FE64-FE66FF0BFF1C-FF1EFF5CFF5EFFE2FFE9-FFEC",
        Sc: "002400A2-00A5060B09F209F309FB0AF10BF90E3F17DB20A0-20B8A838FDFCFE69FF04FFE0FFE1FFE5FFE6",
        Sk: "005E006000A800AF00B400B802C2-02C502D2-02DF02E5-02EB02ED02EF-02FF0375038403851FBD1FBF-1FC11FCD-1FCF1FDD-1FDF1FED-1FEF1FFD1FFE309B309CA700-A716A720A721A789A78AFF3EFF40FFE3",
        So: "00A600A700A900AE00B000B60482060E060F06E906FD06FE07F609FA0B700BF3-0BF80BFA0C7F0CF10CF20D790F01-0F030F13-0F170F1A-0F1F0F340F360F380FBE-0FC50FC7-0FCC0FCE0FCF0FD5-0FD8109E109F13601390-1399194019E0-19FF1B61-1B6A1B74-1B7C210021012103-21062108210921142116-2118211E-2123212521272129212E213A213B214A214C214D214F2195-2199219C-219F21A121A221A421A521A7-21AD21AF-21CD21D021D121D321D5-21F32300-2307230C-231F2322-2328232B-237B237D-239A23B4-23DB23E2-23E82400-24262440-244A249C-24E92500-25B625B8-25C025C2-25F72600-266E2670-26CD26CF-26E126E326E8-26FF2701-27042706-2709270C-27272729-274B274D274F-27522756-275E2761-276727942798-27AF27B1-27BE2800-28FF2B00-2B2F2B452B462B50-2B592CE5-2CEA2E80-2E992E9B-2EF32F00-2FD52FF0-2FFB300430123013302030363037303E303F319031913196-319F31C0-31E33200-321E322A-32503260-327F328A-32B032C0-32FE3300-33FF4DC0-4DFFA490-A4C6A828-A82BA836A837A839AA77-AA79FDFDFFE4FFE8FFEDFFEEFFFCFFFD",
        Z: "002000A01680180E2000-200A20282029202F205F3000",
        Zs: "002000A01680180E2000-200A202F205F3000",
        Zl: "2028",
        Zp: "2029",
        C: "0000-001F007F-009F00AD03780379037F-0383038B038D03A20526-05300557055805600588058B-059005C8-05CF05EB-05EF05F5-0605061C061D0620065F06DD070E070F074B074C07B2-07BF07FB-07FF082E082F083F-08FF093A093B094F095609570973-097809800984098D098E0991099209A909B109B3-09B509BA09BB09C509C609C909CA09CF-09D609D8-09DB09DE09E409E509FC-0A000A040A0B-0A0E0A110A120A290A310A340A370A3A0A3B0A3D0A43-0A460A490A4A0A4E-0A500A52-0A580A5D0A5F-0A650A76-0A800A840A8E0A920AA90AB10AB40ABA0ABB0AC60ACA0ACE0ACF0AD1-0ADF0AE40AE50AF00AF2-0B000B040B0D0B0E0B110B120B290B310B340B3A0B3B0B450B460B490B4A0B4E-0B550B58-0B5B0B5E0B640B650B72-0B810B840B8B-0B8D0B910B96-0B980B9B0B9D0BA0-0BA20BA5-0BA70BAB-0BAD0BBA-0BBD0BC3-0BC50BC90BCE0BCF0BD1-0BD60BD8-0BE50BFB-0C000C040C0D0C110C290C340C3A-0C3C0C450C490C4E-0C540C570C5A-0C5F0C640C650C70-0C770C800C810C840C8D0C910CA90CB40CBA0CBB0CC50CC90CCE-0CD40CD7-0CDD0CDF0CE40CE50CF00CF3-0D010D040D0D0D110D290D3A-0D3C0D450D490D4E-0D560D58-0D5F0D640D650D76-0D780D800D810D840D97-0D990DB20DBC0DBE0DBF0DC7-0DC90DCB-0DCE0DD50DD70DE0-0DF10DF5-0E000E3B-0E3E0E5C-0E800E830E850E860E890E8B0E8C0E8E-0E930E980EA00EA40EA60EA80EA90EAC0EBA0EBE0EBF0EC50EC70ECE0ECF0EDA0EDB0EDE-0EFF0F480F6D-0F700F8C-0F8F0F980FBD0FCD0FD9-0FFF10C6-10CF10FD-10FF1249124E124F12571259125E125F1289128E128F12B112B612B712BF12C112C612C712D7131113161317135B-135E137D-137F139A-139F13F5-13FF169D-169F16F1-16FF170D1715-171F1737-173F1754-175F176D17711774-177F17B417B517DE17DF17EA-17EF17FA-17FF180F181A-181F1878-187F18AB-18AF18F6-18FF191D-191F192C-192F193C-193F1941-1943196E196F1975-197F19AC-19AF19CA-19CF19DB-19DD1A1C1A1D1A5F1A7D1A7E1A8A-1A8F1A9A-1A9F1AAE-1AFF1B4C-1B4F1B7D-1B7F1BAB-1BAD1BBA-1BFF1C38-1C3A1C4A-1C4C1C80-1CCF1CF3-1CFF1DE7-1DFC1F161F171F1E1F1F1F461F471F4E1F4F1F581F5A1F5C1F5E1F7E1F7F1FB51FC51FD41FD51FDC1FF01FF11FF51FFF200B-200F202A-202E2060-206F20722073208F2095-209F20B9-20CF20F1-20FF218A-218F23E9-23FF2427-243F244B-245F26CE26E226E4-26E727002705270A270B2728274C274E2753-2755275F27602795-279727B027BF27CB27CD-27CF2B4D-2B4F2B5A-2BFF2C2F2C5F2CF2-2CF82D26-2D2F2D66-2D6E2D70-2D7F2D97-2D9F2DA72DAF2DB72DBF2DC72DCF2DD72DDF2E32-2E7F2E9A2EF4-2EFF2FD6-2FEF2FFC-2FFF3040309730983100-3104312E-3130318F31B8-31BF31E4-31EF321F32FF4DB6-4DBF9FCC-9FFFA48D-A48FA4C7-A4CFA62C-A63FA660A661A674-A67BA698-A69FA6F8-A6FFA78D-A7FAA82C-A82FA83A-A83FA878-A87FA8C5-A8CDA8DA-A8DFA8FC-A8FFA954-A95EA97D-A97FA9CEA9DA-A9DDA9E0-A9FFAA37-AA3FAA4EAA4FAA5AAA5BAA7C-AA7FAAC3-AADAAAE0-ABBFABEEABEFABFA-ABFFD7A4-D7AFD7C7-D7CAD7FC-F8FFFA2EFA2FFA6EFA6FFADA-FAFFFB07-FB12FB18-FB1CFB37FB3DFB3FFB42FB45FBB2-FBD2FD40-FD4FFD90FD91FDC8-FDEFFDFEFDFFFE1A-FE1FFE27-FE2FFE53FE67FE6C-FE6FFE75FEFD-FF00FFBF-FFC1FFC8FFC9FFD0FFD1FFD8FFD9FFDD-FFDFFFE7FFEF-FFFBFFFEFFFF",
        Cc: "0000-001F007F-009F",
        Cf: "00AD0600-060306DD070F17B417B5200B-200F202A-202E2060-2064206A-206FFEFFFFF9-FFFB",
        Co: "E000-F8FF",
        Cs: "D800-DFFF",
        Cn: "03780379037F-0383038B038D03A20526-05300557055805600588058B-059005C8-05CF05EB-05EF05F5-05FF06040605061C061D0620065F070E074B074C07B2-07BF07FB-07FF082E082F083F-08FF093A093B094F095609570973-097809800984098D098E0991099209A909B109B3-09B509BA09BB09C509C609C909CA09CF-09D609D8-09DB09DE09E409E509FC-0A000A040A0B-0A0E0A110A120A290A310A340A370A3A0A3B0A3D0A43-0A460A490A4A0A4E-0A500A52-0A580A5D0A5F-0A650A76-0A800A840A8E0A920AA90AB10AB40ABA0ABB0AC60ACA0ACE0ACF0AD1-0ADF0AE40AE50AF00AF2-0B000B040B0D0B0E0B110B120B290B310B340B3A0B3B0B450B460B490B4A0B4E-0B550B58-0B5B0B5E0B640B650B72-0B810B840B8B-0B8D0B910B96-0B980B9B0B9D0BA0-0BA20BA5-0BA70BAB-0BAD0BBA-0BBD0BC3-0BC50BC90BCE0BCF0BD1-0BD60BD8-0BE50BFB-0C000C040C0D0C110C290C340C3A-0C3C0C450C490C4E-0C540C570C5A-0C5F0C640C650C70-0C770C800C810C840C8D0C910CA90CB40CBA0CBB0CC50CC90CCE-0CD40CD7-0CDD0CDF0CE40CE50CF00CF3-0D010D040D0D0D110D290D3A-0D3C0D450D490D4E-0D560D58-0D5F0D640D650D76-0D780D800D810D840D97-0D990DB20DBC0DBE0DBF0DC7-0DC90DCB-0DCE0DD50DD70DE0-0DF10DF5-0E000E3B-0E3E0E5C-0E800E830E850E860E890E8B0E8C0E8E-0E930E980EA00EA40EA60EA80EA90EAC0EBA0EBE0EBF0EC50EC70ECE0ECF0EDA0EDB0EDE-0EFF0F480F6D-0F700F8C-0F8F0F980FBD0FCD0FD9-0FFF10C6-10CF10FD-10FF1249124E124F12571259125E125F1289128E128F12B112B612B712BF12C112C612C712D7131113161317135B-135E137D-137F139A-139F13F5-13FF169D-169F16F1-16FF170D1715-171F1737-173F1754-175F176D17711774-177F17DE17DF17EA-17EF17FA-17FF180F181A-181F1878-187F18AB-18AF18F6-18FF191D-191F192C-192F193C-193F1941-1943196E196F1975-197F19AC-19AF19CA-19CF19DB-19DD1A1C1A1D1A5F1A7D1A7E1A8A-1A8F1A9A-1A9F1AAE-1AFF1B4C-1B4F1B7D-1B7F1BAB-1BAD1BBA-1BFF1C38-1C3A1C4A-1C4C1C80-1CCF1CF3-1CFF1DE7-1DFC1F161F171F1E1F1F1F461F471F4E1F4F1F581F5A1F5C1F5E1F7E1F7F1FB51FC51FD41FD51FDC1FF01FF11FF51FFF2065-206920722073208F2095-209F20B9-20CF20F1-20FF218A-218F23E9-23FF2427-243F244B-245F26CE26E226E4-26E727002705270A270B2728274C274E2753-2755275F27602795-279727B027BF27CB27CD-27CF2B4D-2B4F2B5A-2BFF2C2F2C5F2CF2-2CF82D26-2D2F2D66-2D6E2D70-2D7F2D97-2D9F2DA72DAF2DB72DBF2DC72DCF2DD72DDF2E32-2E7F2E9A2EF4-2EFF2FD6-2FEF2FFC-2FFF3040309730983100-3104312E-3130318F31B8-31BF31E4-31EF321F32FF4DB6-4DBF9FCC-9FFFA48D-A48FA4C7-A4CFA62C-A63FA660A661A674-A67BA698-A69FA6F8-A6FFA78D-A7FAA82C-A82FA83A-A83FA878-A87FA8C5-A8CDA8DA-A8DFA8FC-A8FFA954-A95EA97D-A97FA9CEA9DA-A9DDA9E0-A9FFAA37-AA3FAA4EAA4FAA5AAA5BAA7C-AA7FAAC3-AADAAAE0-ABBFABEEABEFABFA-ABFFD7A4-D7AFD7C7-D7CAD7FC-D7FFFA2EFA2FFA6EFA6FFADA-FAFFFB07-FB12FB18-FB1CFB37FB3DFB3FFB42FB45FBB2-FBD2FD40-FD4FFD90FD91FDC8-FDEFFDFEFDFFFE1A-FE1FFE27-FE2FFE53FE67FE6C-FE6FFE75FEFDFEFEFF00FFBF-FFC1FFC8FFC9FFD0FFD1FFD8FFD9FFDD-FFDFFFE7FFEF-FFF8FFFEFFFF"
    });
    function addUnicodePackage(pack) {
        var codePoint = /\w{4}/g;
        for(var name in pack)exports.packages[name] = pack[name].replace(codePoint, "\\u$&");
    }
});
ace.define("ace/mode/text", [
    "require",
    "exports",
    "module",
    "ace/tokenizer",
    "ace/mode/text_highlight_rules",
    "ace/mode/behaviour/cstyle",
    "ace/unicode",
    "ace/lib/lang",
    "ace/token_iterator",
    "ace/range"
], function(acequire, exports, module1) {
    "use strict";
    var Tokenizer = acequire("../tokenizer").Tokenizer;
    var TextHighlightRules = acequire("./text_highlight_rules").TextHighlightRules;
    var CstyleBehaviour = acequire("./behaviour/cstyle").CstyleBehaviour;
    var unicode = acequire("../unicode");
    var lang = acequire("../lib/lang");
    var TokenIterator = acequire("../token_iterator").TokenIterator;
    var Range = acequire("../range").Range;
    var Mode = function() {
        this.HighlightRules = TextHighlightRules;
    };
    (function() {
        this.$defaultBehaviour = new CstyleBehaviour();
        this.tokenRe = new RegExp("^[" + unicode.packages.L + unicode.packages.Mn + unicode.packages.Mc + unicode.packages.Nd + unicode.packages.Pc + "\\$_]+", "g");
        this.nonTokenRe = new RegExp("^(?:[^" + unicode.packages.L + unicode.packages.Mn + unicode.packages.Mc + unicode.packages.Nd + unicode.packages.Pc + "\\$_]|\\s])+", "g");
        this.getTokenizer = function() {
            if (!this.$tokenizer) {
                this.$highlightRules = this.$highlightRules || new this.HighlightRules(this.$highlightRuleConfig);
                this.$tokenizer = new Tokenizer(this.$highlightRules.getRules());
            }
            return this.$tokenizer;
        };
        this.lineCommentStart = "";
        this.blockComment = "";
        this.toggleCommentLines = function(state, session, startRow, endRow) {
            var doc = session.doc;
            var ignoreBlankLines = true;
            var shouldRemove = true;
            var minIndent = Infinity;
            var tabSize = session.getTabSize();
            var insertAtTabStop = false;
            if (!this.lineCommentStart) {
                if (!this.blockComment) return false;
                var lineCommentStart = this.blockComment.start;
                var lineCommentEnd = this.blockComment.end;
                var regexpStart = new RegExp("^(\\s*)(?:" + lang.escapeRegExp(lineCommentStart) + ")");
                var regexpEnd = new RegExp("(?:" + lang.escapeRegExp(lineCommentEnd) + ")\\s*$");
                var comment = function(line, i) {
                    if (testRemove(line, i)) return;
                    if (!ignoreBlankLines || /\S/.test(line)) {
                        doc.insertInLine({
                            row: i,
                            column: line.length
                        }, lineCommentEnd);
                        doc.insertInLine({
                            row: i,
                            column: minIndent
                        }, lineCommentStart);
                    }
                };
                var uncomment = function(line, i) {
                    var m;
                    if (m = line.match(regexpEnd)) doc.removeInLine(i, line.length - m[0].length, line.length);
                    if (m = line.match(regexpStart)) doc.removeInLine(i, m[1].length, m[0].length);
                };
                var testRemove = function(line, row) {
                    if (regexpStart.test(line)) return true;
                    var tokens = session.getTokens(row);
                    for(var i = 0; i < tokens.length; i++){
                        if (tokens[i].type === "comment") return true;
                    }
                };
            } else {
                if (Array.isArray(this.lineCommentStart)) {
                    var regexpStart = this.lineCommentStart.map(lang.escapeRegExp).join("|");
                    var lineCommentStart = this.lineCommentStart[0];
                } else {
                    var regexpStart = lang.escapeRegExp(this.lineCommentStart);
                    var lineCommentStart = this.lineCommentStart;
                }
                regexpStart = new RegExp("^(\\s*)(?:" + regexpStart + ") ?");
                insertAtTabStop = session.getUseSoftTabs();
                var uncomment = function(line, i) {
                    var m = line.match(regexpStart);
                    if (!m) return;
                    var start = m[1].length, end = m[0].length;
                    if (!shouldInsertSpace(line, start, end) && m[0][end - 1] == " ") end--;
                    doc.removeInLine(i, start, end);
                };
                var commentWithSpace = lineCommentStart + " ";
                var comment = function(line, i) {
                    if (!ignoreBlankLines || /\S/.test(line)) {
                        if (shouldInsertSpace(line, minIndent, minIndent)) doc.insertInLine({
                            row: i,
                            column: minIndent
                        }, commentWithSpace);
                        else doc.insertInLine({
                            row: i,
                            column: minIndent
                        }, lineCommentStart);
                    }
                };
                var testRemove = function(line, i) {
                    return regexpStart.test(line);
                };
                var shouldInsertSpace = function(line, before, after) {
                    var spaces = 0;
                    while(before-- && line.charAt(before) == " ")spaces++;
                    if (spaces % tabSize != 0) return false;
                    var spaces = 0;
                    while(line.charAt(after++) == " ")spaces++;
                    if (tabSize > 2) return spaces % tabSize != tabSize - 1;
                    else return spaces % tabSize == 0;
                    return true;
                };
            }
            function iter(fun) {
                for(var i = startRow; i <= endRow; i++)fun(doc.getLine(i), i);
            }
            var minEmptyLength = Infinity;
            iter(function(line, i) {
                var indent = line.search(/\S/);
                if (indent !== -1) {
                    if (indent < minIndent) minIndent = indent;
                    if (shouldRemove && !testRemove(line, i)) shouldRemove = false;
                } else if (minEmptyLength > line.length) minEmptyLength = line.length;
            });
            if (minIndent == Infinity) {
                minIndent = minEmptyLength;
                ignoreBlankLines = false;
                shouldRemove = false;
            }
            if (insertAtTabStop && minIndent % tabSize != 0) minIndent = Math.floor(minIndent / tabSize) * tabSize;
            iter(shouldRemove ? uncomment : comment);
        };
        this.toggleBlockComment = function(state, session, range, cursor) {
            var comment = this.blockComment;
            if (!comment) return;
            if (!comment.start && comment[0]) comment = comment[0];
            var iterator = new TokenIterator(session, cursor.row, cursor.column);
            var token = iterator.getCurrentToken();
            var sel = session.selection;
            var initialRange = session.selection.toOrientedRange();
            var startRow, colDiff;
            if (token && /comment/.test(token.type)) {
                var startRange, endRange;
                while(token && /comment/.test(token.type)){
                    var i = token.value.indexOf(comment.start);
                    if (i != -1) {
                        var row = iterator.getCurrentTokenRow();
                        var column = iterator.getCurrentTokenColumn() + i;
                        startRange = new Range(row, column, row, column + comment.start.length);
                        break;
                    }
                    token = iterator.stepBackward();
                }
                var iterator = new TokenIterator(session, cursor.row, cursor.column);
                var token = iterator.getCurrentToken();
                while(token && /comment/.test(token.type)){
                    var i = token.value.indexOf(comment.end);
                    if (i != -1) {
                        var row = iterator.getCurrentTokenRow();
                        var column = iterator.getCurrentTokenColumn() + i;
                        endRange = new Range(row, column, row, column + comment.end.length);
                        break;
                    }
                    token = iterator.stepForward();
                }
                if (endRange) session.remove(endRange);
                if (startRange) {
                    session.remove(startRange);
                    startRow = startRange.start.row;
                    colDiff = -comment.start.length;
                }
            } else {
                colDiff = comment.start.length;
                startRow = range.start.row;
                session.insert(range.end, comment.end);
                session.insert(range.start, comment.start);
            }
            if (initialRange.start.row == startRow) initialRange.start.column += colDiff;
            if (initialRange.end.row == startRow) initialRange.end.column += colDiff;
            session.selection.fromOrientedRange(initialRange);
        };
        this.getNextLineIndent = function(state, line, tab) {
            return this.$getIndent(line);
        };
        this.checkOutdent = function(state, line, input) {
            return false;
        };
        this.autoOutdent = function(state, doc, row) {};
        this.$getIndent = function(line) {
            return line.match(/^\s*/)[0];
        };
        this.createWorker = function(session) {
            return null;
        };
        this.createModeDelegates = function(mapping) {
            this.$embeds = [];
            this.$modes = {};
            for(var i in mapping)if (mapping[i]) {
                this.$embeds.push(i);
                this.$modes[i] = new mapping[i]();
            }
            var delegations = [
                "toggleBlockComment",
                "toggleCommentLines",
                "getNextLineIndent",
                "checkOutdent",
                "autoOutdent",
                "transformAction",
                "getCompletions"
            ];
            for(var i = 0; i < delegations.length; i++)(function(scope) {
                var functionName = delegations[i];
                var defaultHandler = scope[functionName];
                scope[delegations[i]] = function() {
                    return this.$delegator(functionName, arguments, defaultHandler);
                };
            })(this);
        };
        this.$delegator = function(method, args, defaultHandler) {
            var state = args[0];
            if (typeof state != "string") state = state[0];
            for(var i = 0; i < this.$embeds.length; i++){
                if (!this.$modes[this.$embeds[i]]) continue;
                var split = state.split(this.$embeds[i]);
                if (!split[0] && split[1]) {
                    args[0] = split[1];
                    var mode = this.$modes[this.$embeds[i]];
                    return mode[method].apply(mode, args);
                }
            }
            var ret = defaultHandler.apply(this, args);
            return defaultHandler ? ret : undefined;
        };
        this.transformAction = function(state, action, editor, session, param) {
            if (this.$behaviour) {
                var behaviours = this.$behaviour.getBehaviours();
                for(var key in behaviours)if (behaviours[key][action]) {
                    var ret = behaviours[key][action].apply(this, arguments);
                    if (ret) return ret;
                }
            }
        };
        this.getKeywords = function(append) {
            if (!this.completionKeywords) {
                var rules = this.$tokenizer.rules;
                var completionKeywords = [];
                for(var rule in rules){
                    var ruleItr = rules[rule];
                    for(var r = 0, l = ruleItr.length; r < l; r++){
                        if (typeof ruleItr[r].token === "string") {
                            if (/keyword|support|storage/.test(ruleItr[r].token)) completionKeywords.push(ruleItr[r].regex);
                        } else if (typeof ruleItr[r].token === "object") {
                            for(var a = 0, aLength = ruleItr[r].token.length; a < aLength; a++)if (/keyword|support|storage/.test(ruleItr[r].token[a])) {
                                var rule = ruleItr[r].regex.match(/\(.+?\)/g)[a];
                                completionKeywords.push(rule.substr(1, rule.length - 2));
                            }
                        }
                    }
                }
                this.completionKeywords = completionKeywords;
            }
            if (!append) return this.$keywordList;
            return completionKeywords.concat(this.$keywordList || []);
        };
        this.$createKeywordList = function() {
            if (!this.$highlightRules) this.getTokenizer();
            return this.$keywordList = this.$highlightRules.$keywordList || [];
        };
        this.getCompletions = function(state, session, pos, prefix) {
            var keywords = this.$keywordList || this.$createKeywordList();
            return keywords.map(function(word) {
                return {
                    name: word,
                    value: word,
                    score: 0,
                    meta: "keyword"
                };
            });
        };
        this.$id = "ace/mode/text";
    }).call(Mode.prototype);
    exports.Mode = Mode;
});
ace.define("ace/apply_delta", [
    "require",
    "exports",
    "module"
], function(acequire, exports, module1) {
    "use strict";
    function throwDeltaError(delta, errorText) {
        console.log("Invalid Delta:", delta);
        throw "Invalid Delta: " + errorText;
    }
    function positionInDocument(docLines, position) {
        return position.row >= 0 && position.row < docLines.length && position.column >= 0 && position.column <= docLines[position.row].length;
    }
    function validateDelta(docLines, delta) {
        if (delta.action != "insert" && delta.action != "remove") throwDeltaError(delta, "delta.action must be 'insert' or 'remove'");
        if (!(delta.lines instanceof Array)) throwDeltaError(delta, "delta.lines must be an Array");
        if (!delta.start || !delta.end) throwDeltaError(delta, "delta.start/end must be an present");
        var start = delta.start;
        if (!positionInDocument(docLines, delta.start)) throwDeltaError(delta, "delta.start must be contained in document");
        var end = delta.end;
        if (delta.action == "remove" && !positionInDocument(docLines, end)) throwDeltaError(delta, "delta.end must contained in document for 'remove' actions");
        var numRangeRows = end.row - start.row;
        var numRangeLastLineChars = end.column - (numRangeRows == 0 ? start.column : 0);
        if (numRangeRows != delta.lines.length - 1 || delta.lines[numRangeRows].length != numRangeLastLineChars) throwDeltaError(delta, "delta.range must match delta lines");
    }
    exports.applyDelta = function(docLines, delta, doNotValidate) {
        var row = delta.start.row;
        var startColumn = delta.start.column;
        var line = docLines[row] || "";
        switch(delta.action){
            case "insert":
                var lines = delta.lines;
                if (lines.length === 1) docLines[row] = line.substring(0, startColumn) + delta.lines[0] + line.substring(startColumn);
                else {
                    var args = [
                        row,
                        1
                    ].concat(delta.lines);
                    docLines.splice.apply(docLines, args);
                    docLines[row] = line.substring(0, startColumn) + docLines[row];
                    docLines[row + delta.lines.length - 1] += line.substring(startColumn);
                }
                break;
            case "remove":
                var endColumn = delta.end.column;
                var endRow = delta.end.row;
                if (row === endRow) docLines[row] = line.substring(0, startColumn) + line.substring(endColumn);
                else docLines.splice(row, endRow - row + 1, line.substring(0, startColumn) + docLines[endRow].substring(endColumn));
                break;
        }
    };
});
ace.define("ace/anchor", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/lib/event_emitter"
], function(acequire, exports, module1) {
    "use strict";
    var oop = acequire("./lib/oop");
    var EventEmitter = acequire("./lib/event_emitter").EventEmitter;
    var Anchor = exports.Anchor = function(doc, row, column) {
        this.$onChange = this.onChange.bind(this);
        this.attach(doc);
        if (typeof column == "undefined") this.setPosition(row.row, row.column);
        else this.setPosition(row, column);
    };
    (function() {
        oop.implement(this, EventEmitter);
        this.getPosition = function() {
            return this.$clipPositionToDocument(this.row, this.column);
        };
        this.getDocument = function() {
            return this.document;
        };
        this.$insertRight = false;
        this.onChange = function(delta) {
            if (delta.start.row == delta.end.row && delta.start.row != this.row) return;
            if (delta.start.row > this.row) return;
            var point = $getTransformedPoint(delta, {
                row: this.row,
                column: this.column
            }, this.$insertRight);
            this.setPosition(point.row, point.column, true);
        };
        function $pointsInOrder(point1, point2, equalPointsInOrder) {
            var bColIsAfter = equalPointsInOrder ? point1.column <= point2.column : point1.column < point2.column;
            return point1.row < point2.row || point1.row == point2.row && bColIsAfter;
        }
        function $getTransformedPoint(delta, point, moveIfEqual) {
            var deltaIsInsert = delta.action == "insert";
            var deltaRowShift = (deltaIsInsert ? 1 : -1) * (delta.end.row - delta.start.row);
            var deltaColShift = (deltaIsInsert ? 1 : -1) * (delta.end.column - delta.start.column);
            var deltaStart = delta.start;
            var deltaEnd = deltaIsInsert ? deltaStart : delta.end; // Collapse insert range.
            if ($pointsInOrder(point, deltaStart, moveIfEqual)) return {
                row: point.row,
                column: point.column
            };
            if ($pointsInOrder(deltaEnd, point, !moveIfEqual)) return {
                row: point.row + deltaRowShift,
                column: point.column + (point.row == deltaEnd.row ? deltaColShift : 0)
            };
            return {
                row: deltaStart.row,
                column: deltaStart.column
            };
        }
        this.setPosition = function(row, column, noClip) {
            var pos;
            if (noClip) pos = {
                row: row,
                column: column
            };
            else pos = this.$clipPositionToDocument(row, column);
            if (this.row == pos.row && this.column == pos.column) return;
            var old = {
                row: this.row,
                column: this.column
            };
            this.row = pos.row;
            this.column = pos.column;
            this._signal("change", {
                old: old,
                value: pos
            });
        };
        this.detach = function() {
            this.document.removeEventListener("change", this.$onChange);
        };
        this.attach = function(doc) {
            this.document = doc || this.document;
            this.document.on("change", this.$onChange);
        };
        this.$clipPositionToDocument = function(row, column) {
            var pos = {};
            if (row >= this.document.getLength()) {
                pos.row = Math.max(0, this.document.getLength() - 1);
                pos.column = this.document.getLine(pos.row).length;
            } else if (row < 0) {
                pos.row = 0;
                pos.column = 0;
            } else {
                pos.row = row;
                pos.column = Math.min(this.document.getLine(pos.row).length, Math.max(0, column));
            }
            if (column < 0) pos.column = 0;
            return pos;
        };
    }).call(Anchor.prototype);
});
ace.define("ace/document", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/apply_delta",
    "ace/lib/event_emitter",
    "ace/range",
    "ace/anchor"
], function(acequire, exports, module1) {
    "use strict";
    var oop = acequire("./lib/oop");
    var applyDelta = acequire("./apply_delta").applyDelta;
    var EventEmitter = acequire("./lib/event_emitter").EventEmitter;
    var Range = acequire("./range").Range;
    var Anchor = acequire("./anchor").Anchor;
    var Document = function(textOrLines) {
        this.$lines = [
            ""
        ];
        if (textOrLines.length === 0) this.$lines = [
            ""
        ];
        else if (Array.isArray(textOrLines)) this.insertMergedLines({
            row: 0,
            column: 0
        }, textOrLines);
        else this.insert({
            row: 0,
            column: 0
        }, textOrLines);
    };
    (function() {
        oop.implement(this, EventEmitter);
        this.setValue = function(text) {
            var len = this.getLength() - 1;
            this.remove(new Range(0, 0, len, this.getLine(len).length));
            this.insert({
                row: 0,
                column: 0
            }, text);
        };
        this.getValue = function() {
            return this.getAllLines().join(this.getNewLineCharacter());
        };
        this.createAnchor = function(row, column) {
            return new Anchor(this, row, column);
        };
        if ("aaa".split(/a/).length === 0) this.$split = function(text) {
            return text.replace(/\r\n|\r/g, "\n").split("\n");
        };
        else this.$split = function(text) {
            return text.split(/\r\n|\r|\n/);
        };
        this.$detectNewLine = function(text) {
            var match = text.match(/^.*?(\r\n|\r|\n)/m);
            this.$autoNewLine = match ? match[1] : "\n";
            this._signal("changeNewLineMode");
        };
        this.getNewLineCharacter = function() {
            switch(this.$newLineMode){
                case "windows":
                    return "\r\n";
                case "unix":
                    return "\n";
                default:
                    return this.$autoNewLine || "\n";
            }
        };
        this.$autoNewLine = "";
        this.$newLineMode = "auto";
        this.setNewLineMode = function(newLineMode) {
            if (this.$newLineMode === newLineMode) return;
            this.$newLineMode = newLineMode;
            this._signal("changeNewLineMode");
        };
        this.getNewLineMode = function() {
            return this.$newLineMode;
        };
        this.isNewLine = function(text) {
            return text == "\r\n" || text == "\r" || text == "\n";
        };
        this.getLine = function(row) {
            return this.$lines[row] || "";
        };
        this.getLines = function(firstRow, lastRow) {
            return this.$lines.slice(firstRow, lastRow + 1);
        };
        this.getAllLines = function() {
            return this.getLines(0, this.getLength());
        };
        this.getLength = function() {
            return this.$lines.length;
        };
        this.getTextRange = function(range) {
            return this.getLinesForRange(range).join(this.getNewLineCharacter());
        };
        this.getLinesForRange = function(range) {
            var lines;
            if (range.start.row === range.end.row) lines = [
                this.getLine(range.start.row).substring(range.start.column, range.end.column)
            ];
            else {
                lines = this.getLines(range.start.row, range.end.row);
                lines[0] = (lines[0] || "").substring(range.start.column);
                var l = lines.length - 1;
                if (range.end.row - range.start.row == l) lines[l] = lines[l].substring(0, range.end.column);
            }
            return lines;
        };
        this.insertLines = function(row, lines) {
            console.warn("Use of document.insertLines is deprecated. Use the insertFullLines method instead.");
            return this.insertFullLines(row, lines);
        };
        this.removeLines = function(firstRow, lastRow) {
            console.warn("Use of document.removeLines is deprecated. Use the removeFullLines method instead.");
            return this.removeFullLines(firstRow, lastRow);
        };
        this.insertNewLine = function(position) {
            console.warn("Use of document.insertNewLine is deprecated. Use insertMergedLines(position, ['', '']) instead.");
            return this.insertMergedLines(position, [
                "",
                ""
            ]);
        };
        this.insert = function(position, text) {
            if (this.getLength() <= 1) this.$detectNewLine(text);
            return this.insertMergedLines(position, this.$split(text));
        };
        this.insertInLine = function(position, text) {
            var start = this.clippedPos(position.row, position.column);
            var end = this.pos(position.row, position.column + text.length);
            this.applyDelta({
                start: start,
                end: end,
                action: "insert",
                lines: [
                    text
                ]
            }, true);
            return this.clonePos(end);
        };
        this.clippedPos = function(row, column) {
            var length = this.getLength();
            if (row === undefined) row = length;
            else if (row < 0) row = 0;
            else if (row >= length) {
                row = length - 1;
                column = undefined;
            }
            var line = this.getLine(row);
            if (column == undefined) column = line.length;
            column = Math.min(Math.max(column, 0), line.length);
            return {
                row: row,
                column: column
            };
        };
        this.clonePos = function(pos) {
            return {
                row: pos.row,
                column: pos.column
            };
        };
        this.pos = function(row, column) {
            return {
                row: row,
                column: column
            };
        };
        this.$clipPosition = function(position) {
            var length = this.getLength();
            if (position.row >= length) {
                position.row = Math.max(0, length - 1);
                position.column = this.getLine(length - 1).length;
            } else {
                position.row = Math.max(0, position.row);
                position.column = Math.min(Math.max(position.column, 0), this.getLine(position.row).length);
            }
            return position;
        };
        this.insertFullLines = function(row, lines) {
            row = Math.min(Math.max(row, 0), this.getLength());
            var column = 0;
            if (row < this.getLength()) {
                lines = lines.concat([
                    ""
                ]);
                column = 0;
            } else {
                lines = [
                    ""
                ].concat(lines);
                row--;
                column = this.$lines[row].length;
            }
            this.insertMergedLines({
                row: row,
                column: column
            }, lines);
        };
        this.insertMergedLines = function(position, lines) {
            var start = this.clippedPos(position.row, position.column);
            var end = {
                row: start.row + lines.length - 1,
                column: (lines.length == 1 ? start.column : 0) + lines[lines.length - 1].length
            };
            this.applyDelta({
                start: start,
                end: end,
                action: "insert",
                lines: lines
            });
            return this.clonePos(end);
        };
        this.remove = function(range) {
            var start = this.clippedPos(range.start.row, range.start.column);
            var end = this.clippedPos(range.end.row, range.end.column);
            this.applyDelta({
                start: start,
                end: end,
                action: "remove",
                lines: this.getLinesForRange({
                    start: start,
                    end: end
                })
            });
            return this.clonePos(start);
        };
        this.removeInLine = function(row, startColumn, endColumn) {
            var start = this.clippedPos(row, startColumn);
            var end = this.clippedPos(row, endColumn);
            this.applyDelta({
                start: start,
                end: end,
                action: "remove",
                lines: this.getLinesForRange({
                    start: start,
                    end: end
                })
            }, true);
            return this.clonePos(start);
        };
        this.removeFullLines = function(firstRow, lastRow) {
            firstRow = Math.min(Math.max(0, firstRow), this.getLength() - 1);
            lastRow = Math.min(Math.max(0, lastRow), this.getLength() - 1);
            var deleteFirstNewLine = lastRow == this.getLength() - 1 && firstRow > 0;
            var deleteLastNewLine = lastRow < this.getLength() - 1;
            var startRow = deleteFirstNewLine ? firstRow - 1 : firstRow;
            var startCol = deleteFirstNewLine ? this.getLine(startRow).length : 0;
            var endRow = deleteLastNewLine ? lastRow + 1 : lastRow;
            var endCol = deleteLastNewLine ? 0 : this.getLine(endRow).length;
            var range = new Range(startRow, startCol, endRow, endCol);
            var deletedLines = this.$lines.slice(firstRow, lastRow + 1);
            this.applyDelta({
                start: range.start,
                end: range.end,
                action: "remove",
                lines: this.getLinesForRange(range)
            });
            return deletedLines;
        };
        this.removeNewLine = function(row) {
            if (row < this.getLength() - 1 && row >= 0) this.applyDelta({
                start: this.pos(row, this.getLine(row).length),
                end: this.pos(row + 1, 0),
                action: "remove",
                lines: [
                    "",
                    ""
                ]
            });
        };
        this.replace = function(range, text) {
            if (!(range instanceof Range)) range = Range.fromPoints(range.start, range.end);
            if (text.length === 0 && range.isEmpty()) return range.start;
            if (text == this.getTextRange(range)) return range.end;
            this.remove(range);
            var end;
            if (text) end = this.insert(range.start, text);
            else end = range.start;
            return end;
        };
        this.applyDeltas = function(deltas) {
            for(var i = 0; i < deltas.length; i++)this.applyDelta(deltas[i]);
        };
        this.revertDeltas = function(deltas) {
            for(var i = deltas.length - 1; i >= 0; i--)this.revertDelta(deltas[i]);
        };
        this.applyDelta = function(delta, doNotValidate) {
            var isInsert = delta.action == "insert";
            if (isInsert ? delta.lines.length <= 1 && !delta.lines[0] : !Range.comparePoints(delta.start, delta.end)) return;
            if (isInsert && delta.lines.length > 20000) this.$splitAndapplyLargeDelta(delta, 20000);
            applyDelta(this.$lines, delta, doNotValidate);
            this._signal("change", delta);
        };
        this.$splitAndapplyLargeDelta = function(delta, MAX) {
            var lines = delta.lines;
            var l = lines.length;
            var row = delta.start.row;
            var column = delta.start.column;
            var from = 0, to = 0;
            do {
                from = to;
                to += MAX - 1;
                var chunk = lines.slice(from, to);
                if (to > l) {
                    delta.lines = chunk;
                    delta.start.row = row + from;
                    delta.start.column = column;
                    break;
                }
                chunk.push("");
                this.applyDelta({
                    start: this.pos(row + from, column),
                    end: this.pos(row + to, column = 0),
                    action: delta.action,
                    lines: chunk
                }, true);
            }while (true);
        };
        this.revertDelta = function(delta) {
            this.applyDelta({
                start: this.clonePos(delta.start),
                end: this.clonePos(delta.end),
                action: delta.action == "insert" ? "remove" : "insert",
                lines: delta.lines.slice()
            });
        };
        this.indexToPosition = function(index, startRow) {
            var lines = this.$lines || this.getAllLines();
            var newlineLength = this.getNewLineCharacter().length;
            for(var i = startRow || 0, l = lines.length; i < l; i++){
                index -= lines[i].length + newlineLength;
                if (index < 0) return {
                    row: i,
                    column: index + lines[i].length + newlineLength
                };
            }
            return {
                row: l - 1,
                column: lines[l - 1].length
            };
        };
        this.positionToIndex = function(pos, startRow) {
            var lines = this.$lines || this.getAllLines();
            var newlineLength = this.getNewLineCharacter().length;
            var index = 0;
            var row = Math.min(pos.row, lines.length);
            for(var i = startRow || 0; i < row; ++i)index += lines[i].length + newlineLength;
            return index + pos.column;
        };
    }).call(Document.prototype);
    exports.Document = Document;
});
ace.define("ace/background_tokenizer", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/lib/event_emitter"
], function(acequire, exports, module1) {
    "use strict";
    var oop = acequire("./lib/oop");
    var EventEmitter = acequire("./lib/event_emitter").EventEmitter;
    var BackgroundTokenizer = function(tokenizer, editor) {
        this.running = false;
        this.lines = [];
        this.states = [];
        this.currentLine = 0;
        this.tokenizer = tokenizer;
        var self = this;
        this.$worker = function() {
            if (!self.running) return;
            var workerStart = new Date();
            var currentLine = self.currentLine;
            var endLine = -1;
            var doc = self.doc;
            var startLine = currentLine;
            while(self.lines[currentLine])currentLine++;
            var len = doc.getLength();
            var processedLines = 0;
            self.running = false;
            while(currentLine < len){
                self.$tokenizeRow(currentLine);
                endLine = currentLine;
                do currentLine++;
                while (self.lines[currentLine]);
                processedLines++;
                if (processedLines % 5 === 0 && new Date() - workerStart > 20) {
                    self.running = setTimeout(self.$worker, 20);
                    break;
                }
            }
            self.currentLine = currentLine;
            if (endLine == -1) endLine = currentLine;
            if (startLine <= endLine) self.fireUpdateEvent(startLine, endLine);
        };
    };
    (function() {
        oop.implement(this, EventEmitter);
        this.setTokenizer = function(tokenizer) {
            this.tokenizer = tokenizer;
            this.lines = [];
            this.states = [];
            this.start(0);
        };
        this.setDocument = function(doc) {
            this.doc = doc;
            this.lines = [];
            this.states = [];
            this.stop();
        };
        this.fireUpdateEvent = function(firstRow, lastRow) {
            var data = {
                first: firstRow,
                last: lastRow
            };
            this._signal("update", {
                data: data
            });
        };
        this.start = function(startRow) {
            this.currentLine = Math.min(startRow || 0, this.currentLine, this.doc.getLength());
            this.lines.splice(this.currentLine, this.lines.length);
            this.states.splice(this.currentLine, this.states.length);
            this.stop();
            this.running = setTimeout(this.$worker, 700);
        };
        this.scheduleStart = function() {
            if (!this.running) this.running = setTimeout(this.$worker, 700);
        };
        this.$updateOnChange = function(delta) {
            var startRow = delta.start.row;
            var len = delta.end.row - startRow;
            if (len === 0) this.lines[startRow] = null;
            else if (delta.action == "remove") {
                this.lines.splice(startRow, len + 1, null);
                this.states.splice(startRow, len + 1, null);
            } else {
                var args = Array(len + 1);
                args.unshift(startRow, 1);
                this.lines.splice.apply(this.lines, args);
                this.states.splice.apply(this.states, args);
            }
            this.currentLine = Math.min(startRow, this.currentLine, this.doc.getLength());
            this.stop();
        };
        this.stop = function() {
            if (this.running) clearTimeout(this.running);
            this.running = false;
        };
        this.getTokens = function(row) {
            return this.lines[row] || this.$tokenizeRow(row);
        };
        this.getState = function(row) {
            if (this.currentLine == row) this.$tokenizeRow(row);
            return this.states[row] || "start";
        };
        this.$tokenizeRow = function(row) {
            var line = this.doc.getLine(row);
            var state = this.states[row - 1];
            var data = this.tokenizer.getLineTokens(line, state, row);
            if (this.states[row] + "" !== data.state + "") {
                this.states[row] = data.state;
                this.lines[row + 1] = null;
                if (this.currentLine > row + 1) this.currentLine = row + 1;
            } else if (this.currentLine == row) this.currentLine = row + 1;
            return this.lines[row] = data.tokens;
        };
    }).call(BackgroundTokenizer.prototype);
    exports.BackgroundTokenizer = BackgroundTokenizer;
});
ace.define("ace/search_highlight", [
    "require",
    "exports",
    "module",
    "ace/lib/lang",
    "ace/lib/oop",
    "ace/range"
], function(acequire, exports, module1) {
    "use strict";
    var lang = acequire("./lib/lang");
    var oop = acequire("./lib/oop");
    var Range = acequire("./range").Range;
    var SearchHighlight = function(regExp, clazz, type) {
        this.setRegexp(regExp);
        this.clazz = clazz;
        this.type = type || "text";
    };
    (function() {
        this.MAX_RANGES = 500;
        this.setRegexp = function(regExp) {
            if (this.regExp + "" == regExp + "") return;
            this.regExp = regExp;
            this.cache = [];
        };
        this.update = function(html, markerLayer, session, config) {
            if (!this.regExp) return;
            var start = config.firstRow, end = config.lastRow;
            for(var i = start; i <= end; i++){
                var ranges = this.cache[i];
                if (ranges == null) {
                    ranges = lang.getMatchOffsets(session.getLine(i), this.regExp);
                    if (ranges.length > this.MAX_RANGES) ranges = ranges.slice(0, this.MAX_RANGES);
                    ranges = ranges.map(function(match) {
                        return new Range(i, match.offset, i, match.offset + match.length);
                    });
                    this.cache[i] = ranges.length ? ranges : "";
                }
                for(var j = ranges.length; j--;)markerLayer.drawSingleLineMarker(html, ranges[j].toScreenRange(session), this.clazz, config);
            }
        };
    }).call(SearchHighlight.prototype);
    exports.SearchHighlight = SearchHighlight;
});
ace.define("ace/edit_session/fold_line", [
    "require",
    "exports",
    "module",
    "ace/range"
], function(acequire, exports, module1) {
    "use strict";
    var Range = acequire("../range").Range;
    function FoldLine(foldData, folds) {
        this.foldData = foldData;
        if (Array.isArray(folds)) this.folds = folds;
        else folds = this.folds = [
            folds
        ];
        var last = folds[folds.length - 1];
        this.range = new Range(folds[0].start.row, folds[0].start.column, last.end.row, last.end.column);
        this.start = this.range.start;
        this.end = this.range.end;
        this.folds.forEach(function(fold) {
            fold.setFoldLine(this);
        }, this);
    }
    (function() {
        this.shiftRow = function(shift) {
            this.start.row += shift;
            this.end.row += shift;
            this.folds.forEach(function(fold) {
                fold.start.row += shift;
                fold.end.row += shift;
            });
        };
        this.addFold = function(fold) {
            if (fold.sameRow) {
                if (fold.start.row < this.startRow || fold.endRow > this.endRow) throw new Error("Can't add a fold to this FoldLine as it has no connection");
                this.folds.push(fold);
                this.folds.sort(function(a, b) {
                    return -a.range.compareEnd(b.start.row, b.start.column);
                });
                if (this.range.compareEnd(fold.start.row, fold.start.column) > 0) {
                    this.end.row = fold.end.row;
                    this.end.column = fold.end.column;
                } else if (this.range.compareStart(fold.end.row, fold.end.column) < 0) {
                    this.start.row = fold.start.row;
                    this.start.column = fold.start.column;
                }
            } else if (fold.start.row == this.end.row) {
                this.folds.push(fold);
                this.end.row = fold.end.row;
                this.end.column = fold.end.column;
            } else if (fold.end.row == this.start.row) {
                this.folds.unshift(fold);
                this.start.row = fold.start.row;
                this.start.column = fold.start.column;
            } else throw new Error("Trying to add fold to FoldRow that doesn't have a matching row");
            fold.foldLine = this;
        };
        this.containsRow = function(row) {
            return row >= this.start.row && row <= this.end.row;
        };
        this.walk = function(callback, endRow, endColumn) {
            var lastEnd = 0, folds = this.folds, fold, cmp, stop, isNewRow = true;
            if (endRow == null) {
                endRow = this.end.row;
                endColumn = this.end.column;
            }
            for(var i = 0; i < folds.length; i++){
                fold = folds[i];
                cmp = fold.range.compareStart(endRow, endColumn);
                if (cmp == -1) {
                    callback(null, endRow, endColumn, lastEnd, isNewRow);
                    return;
                }
                stop = callback(null, fold.start.row, fold.start.column, lastEnd, isNewRow);
                stop = !stop && callback(fold.placeholder, fold.start.row, fold.start.column, lastEnd);
                if (stop || cmp === 0) return;
                isNewRow = !fold.sameRow;
                lastEnd = fold.end.column;
            }
            callback(null, endRow, endColumn, lastEnd, isNewRow);
        };
        this.getNextFoldTo = function(row, column) {
            var fold, cmp;
            for(var i = 0; i < this.folds.length; i++){
                fold = this.folds[i];
                cmp = fold.range.compareEnd(row, column);
                if (cmp == -1) return {
                    fold: fold,
                    kind: "after"
                };
                else if (cmp === 0) return {
                    fold: fold,
                    kind: "inside"
                };
            }
            return null;
        };
        this.addRemoveChars = function(row, column, len) {
            var ret = this.getNextFoldTo(row, column), fold, folds;
            if (ret) {
                fold = ret.fold;
                if (ret.kind == "inside" && fold.start.column != column && fold.start.row != row) window.console && window.console.log(row, column, fold);
                else if (fold.start.row == row) {
                    folds = this.folds;
                    var i = folds.indexOf(fold);
                    if (i === 0) this.start.column += len;
                    for(i; i < folds.length; i++){
                        fold = folds[i];
                        fold.start.column += len;
                        if (!fold.sameRow) return;
                        fold.end.column += len;
                    }
                    this.end.column += len;
                }
            }
        };
        this.split = function(row, column) {
            var pos = this.getNextFoldTo(row, column);
            if (!pos || pos.kind == "inside") return null;
            var fold = pos.fold;
            var folds = this.folds;
            var foldData = this.foldData;
            var i = folds.indexOf(fold);
            var foldBefore = folds[i - 1];
            this.end.row = foldBefore.end.row;
            this.end.column = foldBefore.end.column;
            folds = folds.splice(i, folds.length - i);
            var newFoldLine = new FoldLine(foldData, folds);
            foldData.splice(foldData.indexOf(this) + 1, 0, newFoldLine);
            return newFoldLine;
        };
        this.merge = function(foldLineNext) {
            var folds = foldLineNext.folds;
            for(var i = 0; i < folds.length; i++)this.addFold(folds[i]);
            var foldData = this.foldData;
            foldData.splice(foldData.indexOf(foldLineNext), 1);
        };
        this.toString = function() {
            var ret = [
                this.range.toString() + ": ["
            ];
            this.folds.forEach(function(fold) {
                ret.push("  " + fold.toString());
            });
            ret.push("]");
            return ret.join("\n");
        };
        this.idxToPosition = function(idx) {
            var lastFoldEndColumn = 0;
            for(var i = 0; i < this.folds.length; i++){
                var fold = this.folds[i];
                idx -= fold.start.column - lastFoldEndColumn;
                if (idx < 0) return {
                    row: fold.start.row,
                    column: fold.start.column + idx
                };
                idx -= fold.placeholder.length;
                if (idx < 0) return fold.start;
                lastFoldEndColumn = fold.end.column;
            }
            return {
                row: this.end.row,
                column: this.end.column + idx
            };
        };
    }).call(FoldLine.prototype);
    exports.FoldLine = FoldLine;
});
ace.define("ace/range_list", [
    "require",
    "exports",
    "module",
    "ace/range"
], function(acequire, exports, module1) {
    "use strict";
    var Range = acequire("./range").Range;
    var comparePoints = Range.comparePoints;
    var RangeList = function() {
        this.ranges = [];
    };
    (function() {
        this.comparePoints = comparePoints;
        this.pointIndex = function(pos, excludeEdges, startIndex) {
            var list = this.ranges;
            for(var i = startIndex || 0; i < list.length; i++){
                var range = list[i];
                var cmpEnd = comparePoints(pos, range.end);
                if (cmpEnd > 0) continue;
                var cmpStart = comparePoints(pos, range.start);
                if (cmpEnd === 0) return excludeEdges && cmpStart !== 0 ? -i - 2 : i;
                if (cmpStart > 0 || cmpStart === 0 && !excludeEdges) return i;
                return -i - 1;
            }
            return -i - 1;
        };
        this.add = function(range) {
            var excludeEdges = !range.isEmpty();
            var startIndex = this.pointIndex(range.start, excludeEdges);
            if (startIndex < 0) startIndex = -startIndex - 1;
            var endIndex = this.pointIndex(range.end, excludeEdges, startIndex);
            if (endIndex < 0) endIndex = -endIndex - 1;
            else endIndex++;
            return this.ranges.splice(startIndex, endIndex - startIndex, range);
        };
        this.addList = function(list) {
            var removed = [];
            for(var i = list.length; i--;)removed.push.apply(removed, this.add(list[i]));
            return removed;
        };
        this.substractPoint = function(pos) {
            var i = this.pointIndex(pos);
            if (i >= 0) return this.ranges.splice(i, 1);
        };
        this.merge = function() {
            var removed = [];
            var list = this.ranges;
            list = list.sort(function(a, b) {
                return comparePoints(a.start, b.start);
            });
            var next = list[0], range;
            for(var i = 1; i < list.length; i++){
                range = next;
                next = list[i];
                var cmp = comparePoints(range.end, next.start);
                if (cmp < 0) continue;
                if (cmp == 0 && !range.isEmpty() && !next.isEmpty()) continue;
                if (comparePoints(range.end, next.end) < 0) {
                    range.end.row = next.end.row;
                    range.end.column = next.end.column;
                }
                list.splice(i, 1);
                removed.push(next);
                next = range;
                i--;
            }
            this.ranges = list;
            return removed;
        };
        this.contains = function(row, column) {
            return this.pointIndex({
                row: row,
                column: column
            }) >= 0;
        };
        this.containsPoint = function(pos) {
            return this.pointIndex(pos) >= 0;
        };
        this.rangeAtPoint = function(pos) {
            var i = this.pointIndex(pos);
            if (i >= 0) return this.ranges[i];
        };
        this.clipRows = function(startRow, endRow) {
            var list = this.ranges;
            if (list[0].start.row > endRow || list[list.length - 1].start.row < startRow) return [];
            var startIndex = this.pointIndex({
                row: startRow,
                column: 0
            });
            if (startIndex < 0) startIndex = -startIndex - 1;
            var endIndex = this.pointIndex({
                row: endRow,
                column: 0
            }, startIndex);
            if (endIndex < 0) endIndex = -endIndex - 1;
            var clipped = [];
            for(var i = startIndex; i < endIndex; i++)clipped.push(list[i]);
            return clipped;
        };
        this.removeAll = function() {
            return this.ranges.splice(0, this.ranges.length);
        };
        this.attach = function(session) {
            if (this.session) this.detach();
            this.session = session;
            this.onChange = this.$onChange.bind(this);
            this.session.on('change', this.onChange);
        };
        this.detach = function() {
            if (!this.session) return;
            this.session.removeListener('change', this.onChange);
            this.session = null;
        };
        this.$onChange = function(delta) {
            if (delta.action == "insert") {
                var start = delta.start;
                var end = delta.end;
            } else {
                var end = delta.start;
                var start = delta.end;
            }
            var startRow = start.row;
            var endRow = end.row;
            var lineDif = endRow - startRow;
            var colDiff = -start.column + end.column;
            var ranges = this.ranges;
            for(var i = 0, n = ranges.length; i < n; i++){
                var r = ranges[i];
                if (r.end.row < startRow) continue;
                if (r.start.row > startRow) break;
                if (r.start.row == startRow && r.start.column >= start.column) {
                    if (r.start.column == start.column && this.$insertRight) ;
                    else {
                        r.start.column += colDiff;
                        r.start.row += lineDif;
                    }
                }
                if (r.end.row == startRow && r.end.column >= start.column) {
                    if (r.end.column == start.column && this.$insertRight) continue;
                    if (r.end.column == start.column && colDiff > 0 && i < n - 1) {
                        if (r.end.column > r.start.column && r.end.column == ranges[i + 1].start.column) r.end.column -= colDiff;
                    }
                    r.end.column += colDiff;
                    r.end.row += lineDif;
                }
            }
            if (lineDif != 0 && i < n) for(; i < n; i++){
                var r = ranges[i];
                r.start.row += lineDif;
                r.end.row += lineDif;
            }
        };
    }).call(RangeList.prototype);
    exports.RangeList = RangeList;
});
ace.define("ace/edit_session/fold", [
    "require",
    "exports",
    "module",
    "ace/range",
    "ace/range_list",
    "ace/lib/oop"
], function(acequire, exports, module1) {
    "use strict";
    var Range = acequire("../range").Range;
    var RangeList = acequire("../range_list").RangeList;
    var oop = acequire("../lib/oop");
    var Fold = exports.Fold = function(range, placeholder) {
        this.foldLine = null;
        this.placeholder = placeholder;
        this.range = range;
        this.start = range.start;
        this.end = range.end;
        this.sameRow = range.start.row == range.end.row;
        this.subFolds = this.ranges = [];
    };
    oop.inherits(Fold, RangeList);
    (function() {
        this.toString = function() {
            return '"' + this.placeholder + '" ' + this.range.toString();
        };
        this.setFoldLine = function(foldLine) {
            this.foldLine = foldLine;
            this.subFolds.forEach(function(fold) {
                fold.setFoldLine(foldLine);
            });
        };
        this.clone = function() {
            var range = this.range.clone();
            var fold = new Fold(range, this.placeholder);
            this.subFolds.forEach(function(subFold) {
                fold.subFolds.push(subFold.clone());
            });
            fold.collapseChildren = this.collapseChildren;
            return fold;
        };
        this.addSubFold = function(fold) {
            if (this.range.isEqual(fold)) return;
            if (!this.range.containsRange(fold)) throw new Error("A fold can't intersect already existing fold" + fold.range + this.range);
            consumeRange(fold, this.start);
            var row = fold.start.row, column = fold.start.column;
            for(var i = 0, cmp = -1; i < this.subFolds.length; i++){
                cmp = this.subFolds[i].range.compare(row, column);
                if (cmp != 1) break;
            }
            var afterStart = this.subFolds[i];
            if (cmp == 0) return afterStart.addSubFold(fold);
            var row = fold.range.end.row, column = fold.range.end.column;
            for(var j = i, cmp = -1; j < this.subFolds.length; j++){
                cmp = this.subFolds[j].range.compare(row, column);
                if (cmp != 1) break;
            }
            var afterEnd = this.subFolds[j];
            if (cmp == 0) throw new Error("A fold can't intersect already existing fold" + fold.range + this.range);
            var consumedFolds = this.subFolds.splice(i, j - i, fold);
            fold.setFoldLine(this.foldLine);
            return fold;
        };
        this.restoreRange = function(range) {
            return restoreRange(range, this.start);
        };
    }).call(Fold.prototype);
    function consumePoint(point, anchor) {
        point.row -= anchor.row;
        if (point.row == 0) point.column -= anchor.column;
    }
    function consumeRange(range, anchor) {
        consumePoint(range.start, anchor);
        consumePoint(range.end, anchor);
    }
    function restorePoint(point, anchor) {
        if (point.row == 0) point.column += anchor.column;
        point.row += anchor.row;
    }
    function restoreRange(range, anchor) {
        restorePoint(range.start, anchor);
        restorePoint(range.end, anchor);
    }
});
ace.define("ace/edit_session/folding", [
    "require",
    "exports",
    "module",
    "ace/range",
    "ace/edit_session/fold_line",
    "ace/edit_session/fold",
    "ace/token_iterator"
], function(acequire, exports, module1) {
    "use strict";
    var Range = acequire("../range").Range;
    var FoldLine = acequire("./fold_line").FoldLine;
    var Fold = acequire("./fold").Fold;
    var TokenIterator = acequire("../token_iterator").TokenIterator;
    function Folding() {
        this.getFoldAt = function(row, column, side) {
            var foldLine = this.getFoldLine(row);
            if (!foldLine) return null;
            var folds = foldLine.folds;
            for(var i = 0; i < folds.length; i++){
                var fold = folds[i];
                if (fold.range.contains(row, column)) {
                    if (side == 1 && fold.range.isEnd(row, column)) continue;
                    else if (side == -1 && fold.range.isStart(row, column)) continue;
                    return fold;
                }
            }
        };
        this.getFoldsInRange = function(range) {
            var start = range.start;
            var end = range.end;
            var foldLines = this.$foldData;
            var foundFolds = [];
            start.column += 1;
            end.column -= 1;
            for(var i = 0; i < foldLines.length; i++){
                var cmp = foldLines[i].range.compareRange(range);
                if (cmp == 2) continue;
                else if (cmp == -2) break;
                var folds = foldLines[i].folds;
                for(var j = 0; j < folds.length; j++){
                    var fold = folds[j];
                    cmp = fold.range.compareRange(range);
                    if (cmp == -2) break;
                    else if (cmp == 2) continue;
                    else if (cmp == 42) break;
                    foundFolds.push(fold);
                }
            }
            start.column -= 1;
            end.column += 1;
            return foundFolds;
        };
        this.getFoldsInRangeList = function(ranges) {
            if (Array.isArray(ranges)) {
                var folds = [];
                ranges.forEach(function(range) {
                    folds = folds.concat(this.getFoldsInRange(range));
                }, this);
            } else var folds = this.getFoldsInRange(ranges);
            return folds;
        };
        this.getAllFolds = function() {
            var folds = [];
            var foldLines = this.$foldData;
            for(var i = 0; i < foldLines.length; i++)for(var j = 0; j < foldLines[i].folds.length; j++)folds.push(foldLines[i].folds[j]);
            return folds;
        };
        this.getFoldStringAt = function(row, column, trim, foldLine) {
            foldLine = foldLine || this.getFoldLine(row);
            if (!foldLine) return null;
            var lastFold = {
                end: {
                    column: 0
                }
            };
            var str, fold;
            for(var i = 0; i < foldLine.folds.length; i++){
                fold = foldLine.folds[i];
                var cmp = fold.range.compareEnd(row, column);
                if (cmp == -1) {
                    str = this.getLine(fold.start.row).substring(lastFold.end.column, fold.start.column);
                    break;
                } else if (cmp === 0) return null;
                lastFold = fold;
            }
            if (!str) str = this.getLine(fold.start.row).substring(lastFold.end.column);
            if (trim == -1) return str.substring(0, column - lastFold.end.column);
            else if (trim == 1) return str.substring(column - lastFold.end.column);
            else return str;
        };
        this.getFoldLine = function(docRow, startFoldLine) {
            var foldData = this.$foldData;
            var i = 0;
            if (startFoldLine) i = foldData.indexOf(startFoldLine);
            if (i == -1) i = 0;
            for(i; i < foldData.length; i++){
                var foldLine = foldData[i];
                if (foldLine.start.row <= docRow && foldLine.end.row >= docRow) return foldLine;
                else if (foldLine.end.row > docRow) return null;
            }
            return null;
        };
        this.getNextFoldLine = function(docRow, startFoldLine) {
            var foldData = this.$foldData;
            var i = 0;
            if (startFoldLine) i = foldData.indexOf(startFoldLine);
            if (i == -1) i = 0;
            for(i; i < foldData.length; i++){
                var foldLine = foldData[i];
                if (foldLine.end.row >= docRow) return foldLine;
            }
            return null;
        };
        this.getFoldedRowCount = function(first, last) {
            var foldData = this.$foldData, rowCount = last - first + 1;
            for(var i = 0; i < foldData.length; i++){
                var foldLine = foldData[i], end = foldLine.end.row, start = foldLine.start.row;
                if (end >= last) {
                    if (start < last) {
                        if (start >= first) rowCount -= last - start;
                        else rowCount = 0; // in one fold
                    }
                    break;
                } else if (end >= first) {
                    if (start >= first) rowCount -= end - start;
                    else rowCount -= end - first + 1;
                }
            }
            return rowCount;
        };
        this.$addFoldLine = function(foldLine) {
            this.$foldData.push(foldLine);
            this.$foldData.sort(function(a, b) {
                return a.start.row - b.start.row;
            });
            return foldLine;
        };
        this.addFold = function(placeholder, range) {
            var foldData = this.$foldData;
            var added = false;
            var fold;
            if (placeholder instanceof Fold) fold = placeholder;
            else {
                fold = new Fold(range, placeholder);
                fold.collapseChildren = range.collapseChildren;
            }
            this.$clipRangeToDocument(fold.range);
            var startRow = fold.start.row;
            var startColumn = fold.start.column;
            var endRow = fold.end.row;
            var endColumn = fold.end.column;
            if (!(startRow < endRow || startRow == endRow && startColumn <= endColumn - 2)) throw new Error("The range has to be at least 2 characters width");
            var startFold = this.getFoldAt(startRow, startColumn, 1);
            var endFold = this.getFoldAt(endRow, endColumn, -1);
            if (startFold && endFold == startFold) return startFold.addSubFold(fold);
            if (startFold && !startFold.range.isStart(startRow, startColumn)) this.removeFold(startFold);
            if (endFold && !endFold.range.isEnd(endRow, endColumn)) this.removeFold(endFold);
            var folds = this.getFoldsInRange(fold.range);
            if (folds.length > 0) {
                this.removeFolds(folds);
                folds.forEach(function(subFold) {
                    fold.addSubFold(subFold);
                });
            }
            for(var i = 0; i < foldData.length; i++){
                var foldLine = foldData[i];
                if (endRow == foldLine.start.row) {
                    foldLine.addFold(fold);
                    added = true;
                    break;
                } else if (startRow == foldLine.end.row) {
                    foldLine.addFold(fold);
                    added = true;
                    if (!fold.sameRow) {
                        var foldLineNext = foldData[i + 1];
                        if (foldLineNext && foldLineNext.start.row == endRow) {
                            foldLine.merge(foldLineNext);
                            break;
                        }
                    }
                    break;
                } else if (endRow <= foldLine.start.row) break;
            }
            if (!added) foldLine = this.$addFoldLine(new FoldLine(this.$foldData, fold));
            if (this.$useWrapMode) this.$updateWrapData(foldLine.start.row, foldLine.start.row);
            else this.$updateRowLengthCache(foldLine.start.row, foldLine.start.row);
            this.$modified = true;
            this._signal("changeFold", {
                data: fold,
                action: "add"
            });
            return fold;
        };
        this.addFolds = function(folds) {
            folds.forEach(function(fold) {
                this.addFold(fold);
            }, this);
        };
        this.removeFold = function(fold) {
            var foldLine = fold.foldLine;
            var startRow = foldLine.start.row;
            var endRow = foldLine.end.row;
            var foldLines = this.$foldData;
            var folds = foldLine.folds;
            if (folds.length == 1) foldLines.splice(foldLines.indexOf(foldLine), 1);
            else if (foldLine.range.isEnd(fold.end.row, fold.end.column)) {
                folds.pop();
                foldLine.end.row = folds[folds.length - 1].end.row;
                foldLine.end.column = folds[folds.length - 1].end.column;
            } else if (foldLine.range.isStart(fold.start.row, fold.start.column)) {
                folds.shift();
                foldLine.start.row = folds[0].start.row;
                foldLine.start.column = folds[0].start.column;
            } else if (fold.sameRow) folds.splice(folds.indexOf(fold), 1);
            else {
                var newFoldLine = foldLine.split(fold.start.row, fold.start.column);
                folds = newFoldLine.folds;
                folds.shift();
                newFoldLine.start.row = folds[0].start.row;
                newFoldLine.start.column = folds[0].start.column;
            }
            if (!this.$updating) {
                if (this.$useWrapMode) this.$updateWrapData(startRow, endRow);
                else this.$updateRowLengthCache(startRow, endRow);
            }
            this.$modified = true;
            this._signal("changeFold", {
                data: fold,
                action: "remove"
            });
        };
        this.removeFolds = function(folds) {
            var cloneFolds = [];
            for(var i = 0; i < folds.length; i++)cloneFolds.push(folds[i]);
            cloneFolds.forEach(function(fold) {
                this.removeFold(fold);
            }, this);
            this.$modified = true;
        };
        this.expandFold = function(fold) {
            this.removeFold(fold);
            fold.subFolds.forEach(function(subFold) {
                fold.restoreRange(subFold);
                this.addFold(subFold);
            }, this);
            if (fold.collapseChildren > 0) this.foldAll(fold.start.row + 1, fold.end.row, fold.collapseChildren - 1);
            fold.subFolds = [];
        };
        this.expandFolds = function(folds) {
            folds.forEach(function(fold) {
                this.expandFold(fold);
            }, this);
        };
        this.unfold = function(location, expandInner) {
            var range, folds;
            if (location == null) {
                range = new Range(0, 0, this.getLength(), 0);
                expandInner = true;
            } else if (typeof location == "number") range = new Range(location, 0, location, this.getLine(location).length);
            else if ("row" in location) range = Range.fromPoints(location, location);
            else range = location;
            folds = this.getFoldsInRangeList(range);
            if (expandInner) this.removeFolds(folds);
            else {
                var subFolds = folds;
                while(subFolds.length){
                    this.expandFolds(subFolds);
                    subFolds = this.getFoldsInRangeList(range);
                }
            }
            if (folds.length) return folds;
        };
        this.isRowFolded = function(docRow, startFoldRow) {
            return !!this.getFoldLine(docRow, startFoldRow);
        };
        this.getRowFoldEnd = function(docRow, startFoldRow) {
            var foldLine = this.getFoldLine(docRow, startFoldRow);
            return foldLine ? foldLine.end.row : docRow;
        };
        this.getRowFoldStart = function(docRow, startFoldRow) {
            var foldLine = this.getFoldLine(docRow, startFoldRow);
            return foldLine ? foldLine.start.row : docRow;
        };
        this.getFoldDisplayLine = function(foldLine, endRow, endColumn, startRow, startColumn) {
            if (startRow == null) startRow = foldLine.start.row;
            if (startColumn == null) startColumn = 0;
            if (endRow == null) endRow = foldLine.end.row;
            if (endColumn == null) endColumn = this.getLine(endRow).length;
            var doc = this.doc;
            var textLine = "";
            foldLine.walk(function(placeholder, row, column, lastColumn) {
                if (row < startRow) return;
                if (row == startRow) {
                    if (column < startColumn) return;
                    lastColumn = Math.max(startColumn, lastColumn);
                }
                if (placeholder != null) textLine += placeholder;
                else textLine += doc.getLine(row).substring(lastColumn, column);
            }, endRow, endColumn);
            return textLine;
        };
        this.getDisplayLine = function(row, endColumn, startRow, startColumn) {
            var foldLine = this.getFoldLine(row);
            if (!foldLine) {
                var line;
                line = this.doc.getLine(row);
                return line.substring(startColumn || 0, endColumn || line.length);
            } else return this.getFoldDisplayLine(foldLine, row, endColumn, startRow, startColumn);
        };
        this.$cloneFoldData = function() {
            var fd = [];
            fd = this.$foldData.map(function(foldLine) {
                var folds = foldLine.folds.map(function(fold) {
                    return fold.clone();
                });
                return new FoldLine(fd, folds);
            });
            return fd;
        };
        this.toggleFold = function(tryToUnfold) {
            var selection = this.selection;
            var range = selection.getRange();
            var fold;
            var bracketPos;
            if (range.isEmpty()) {
                var cursor = range.start;
                fold = this.getFoldAt(cursor.row, cursor.column);
                if (fold) {
                    this.expandFold(fold);
                    return;
                } else if (bracketPos = this.findMatchingBracket(cursor)) {
                    if (range.comparePoint(bracketPos) == 1) range.end = bracketPos;
                    else {
                        range.start = bracketPos;
                        range.start.column++;
                        range.end.column--;
                    }
                } else if (bracketPos = this.findMatchingBracket({
                    row: cursor.row,
                    column: cursor.column + 1
                })) {
                    if (range.comparePoint(bracketPos) == 1) range.end = bracketPos;
                    else range.start = bracketPos;
                    range.start.column++;
                } else range = this.getCommentFoldRange(cursor.row, cursor.column) || range;
            } else {
                var folds = this.getFoldsInRange(range);
                if (tryToUnfold && folds.length) {
                    this.expandFolds(folds);
                    return;
                } else if (folds.length == 1) fold = folds[0];
            }
            if (!fold) fold = this.getFoldAt(range.start.row, range.start.column);
            if (fold && fold.range.toString() == range.toString()) {
                this.expandFold(fold);
                return;
            }
            var placeholder = "...";
            if (!range.isMultiLine()) {
                placeholder = this.getTextRange(range);
                if (placeholder.length < 4) return;
                placeholder = placeholder.trim().substring(0, 2) + "..";
            }
            this.addFold(placeholder, range);
        };
        this.getCommentFoldRange = function(row, column, dir) {
            var iterator = new TokenIterator(this, row, column);
            var token = iterator.getCurrentToken();
            var type = token.type;
            if (token && /^comment|string/.test(type)) {
                type = type.match(/comment|string/)[0];
                if (type == "comment") type += "|doc-start";
                var re = new RegExp(type);
                var range = new Range();
                if (dir != 1) {
                    do token = iterator.stepBackward();
                    while (token && re.test(token.type));
                    iterator.stepForward();
                }
                range.start.row = iterator.getCurrentTokenRow();
                range.start.column = iterator.getCurrentTokenColumn() + 2;
                iterator = new TokenIterator(this, row, column);
                if (dir != -1) {
                    var lastRow = -1;
                    do {
                        token = iterator.stepForward();
                        if (lastRow == -1) {
                            var state = this.getState(iterator.$row);
                            if (!re.test(state)) lastRow = iterator.$row;
                        } else if (iterator.$row > lastRow) break;
                    }while (token && re.test(token.type));
                    token = iterator.stepBackward();
                } else token = iterator.getCurrentToken();
                range.end.row = iterator.getCurrentTokenRow();
                range.end.column = iterator.getCurrentTokenColumn() + token.value.length - 2;
                return range;
            }
        };
        this.foldAll = function(startRow, endRow, depth) {
            if (depth == undefined) depth = 100000; // JSON.stringify doesn't hanle Infinity
            var foldWidgets = this.foldWidgets;
            if (!foldWidgets) return; // mode doesn't support folding
            endRow = endRow || this.getLength();
            startRow = startRow || 0;
            for(var row = startRow; row < endRow; row++){
                if (foldWidgets[row] == null) foldWidgets[row] = this.getFoldWidget(row);
                if (foldWidgets[row] != "start") continue;
                var range = this.getFoldWidgetRange(row);
                if (range && range.isMultiLine() && range.end.row <= endRow && range.start.row >= startRow) {
                    row = range.end.row;
                    try {
                        var fold = this.addFold("...", range);
                        if (fold) fold.collapseChildren = depth;
                    } catch (e) {}
                }
            }
        };
        this.$foldStyles = {
            "manual": 1,
            "markbegin": 1,
            "markbeginend": 1
        };
        this.$foldStyle = "markbegin";
        this.setFoldStyle = function(style) {
            if (!this.$foldStyles[style]) throw new Error("invalid fold style: " + style + "[" + Object.keys(this.$foldStyles).join(", ") + "]");
            if (this.$foldStyle == style) return;
            this.$foldStyle = style;
            if (style == "manual") this.unfold();
            var mode = this.$foldMode;
            this.$setFolding(null);
            this.$setFolding(mode);
        };
        this.$setFolding = function(foldMode) {
            if (this.$foldMode == foldMode) return;
            this.$foldMode = foldMode;
            this.off('change', this.$updateFoldWidgets);
            this.off('tokenizerUpdate', this.$tokenizerUpdateFoldWidgets);
            this._signal("changeAnnotation");
            if (!foldMode || this.$foldStyle == "manual") {
                this.foldWidgets = null;
                return;
            }
            this.foldWidgets = [];
            this.getFoldWidget = foldMode.getFoldWidget.bind(foldMode, this, this.$foldStyle);
            this.getFoldWidgetRange = foldMode.getFoldWidgetRange.bind(foldMode, this, this.$foldStyle);
            this.$updateFoldWidgets = this.updateFoldWidgets.bind(this);
            this.$tokenizerUpdateFoldWidgets = this.tokenizerUpdateFoldWidgets.bind(this);
            this.on('change', this.$updateFoldWidgets);
            this.on('tokenizerUpdate', this.$tokenizerUpdateFoldWidgets);
        };
        this.getParentFoldRangeData = function(row, ignoreCurrent) {
            var fw = this.foldWidgets;
            if (!fw || ignoreCurrent && fw[row]) return {};
            var i = row - 1, firstRange;
            while(i >= 0){
                var c = fw[i];
                if (c == null) c = fw[i] = this.getFoldWidget(i);
                if (c == "start") {
                    var range = this.getFoldWidgetRange(i);
                    if (!firstRange) firstRange = range;
                    if (range && range.end.row >= row) break;
                }
                i--;
            }
            return {
                range: i !== -1 && range,
                firstRange: firstRange
            };
        };
        this.onFoldWidgetClick = function(row, e) {
            e = e.domEvent;
            var options = {
                children: e.shiftKey,
                all: e.ctrlKey || e.metaKey,
                siblings: e.altKey
            };
            var range = this.$toggleFoldWidget(row, options);
            if (!range) {
                var el = e.target || e.srcElement;
                if (el && /ace_fold-widget/.test(el.className)) el.className += " ace_invalid";
            }
        };
        this.$toggleFoldWidget = function(row, options) {
            if (!this.getFoldWidget) return;
            var type = this.getFoldWidget(row);
            var line = this.getLine(row);
            var dir = type === "end" ? -1 : 1;
            var fold = this.getFoldAt(row, dir === -1 ? 0 : line.length, dir);
            if (fold) {
                if (options.children || options.all) this.removeFold(fold);
                else this.expandFold(fold);
                return fold;
            }
            var range = this.getFoldWidgetRange(row, true);
            if (range && !range.isMultiLine()) {
                fold = this.getFoldAt(range.start.row, range.start.column, 1);
                if (fold && range.isEqual(fold.range)) {
                    this.removeFold(fold);
                    return fold;
                }
            }
            if (options.siblings) {
                var data = this.getParentFoldRangeData(row);
                if (data.range) {
                    var startRow = data.range.start.row + 1;
                    var endRow = data.range.end.row;
                }
                this.foldAll(startRow, endRow, options.all ? 10000 : 0);
            } else if (options.children) {
                endRow = range ? range.end.row : this.getLength();
                this.foldAll(row + 1, endRow, options.all ? 10000 : 0);
            } else if (range) {
                if (options.all) range.collapseChildren = 10000;
                this.addFold("...", range);
            }
            return range;
        };
        this.toggleFoldWidget = function(toggleParent) {
            var row = this.selection.getCursor().row;
            row = this.getRowFoldStart(row);
            var range = this.$toggleFoldWidget(row, {});
            if (range) return;
            var data = this.getParentFoldRangeData(row, true);
            range = data.range || data.firstRange;
            if (range) {
                row = range.start.row;
                var fold = this.getFoldAt(row, this.getLine(row).length, 1);
                if (fold) this.removeFold(fold);
                else this.addFold("...", range);
            }
        };
        this.updateFoldWidgets = function(delta) {
            var firstRow = delta.start.row;
            var len = delta.end.row - firstRow;
            if (len === 0) this.foldWidgets[firstRow] = null;
            else if (delta.action == 'remove') this.foldWidgets.splice(firstRow, len + 1, null);
            else {
                var args = Array(len + 1);
                args.unshift(firstRow, 1);
                this.foldWidgets.splice.apply(this.foldWidgets, args);
            }
        };
        this.tokenizerUpdateFoldWidgets = function(e) {
            var rows = e.data;
            if (rows.first != rows.last) {
                if (this.foldWidgets.length > rows.first) this.foldWidgets.splice(rows.first, this.foldWidgets.length);
            }
        };
    }
    exports.Folding = Folding;
});
ace.define("ace/edit_session/bracket_match", [
    "require",
    "exports",
    "module",
    "ace/token_iterator",
    "ace/range"
], function(acequire, exports, module1) {
    "use strict";
    var TokenIterator = acequire("../token_iterator").TokenIterator;
    var Range = acequire("../range").Range;
    function BracketMatch() {
        this.findMatchingBracket = function(position, chr) {
            if (position.column == 0) return null;
            var charBeforeCursor = chr || this.getLine(position.row).charAt(position.column - 1);
            if (charBeforeCursor == "") return null;
            var match = charBeforeCursor.match(/([\(\[\{])|([\)\]\}])/);
            if (!match) return null;
            if (match[1]) return this.$findClosingBracket(match[1], position);
            else return this.$findOpeningBracket(match[2], position);
        };
        this.getBracketRange = function(pos) {
            var line = this.getLine(pos.row);
            var before = true, range;
            var chr = line.charAt(pos.column - 1);
            var match = chr && chr.match(/([\(\[\{])|([\)\]\}])/);
            if (!match) {
                chr = line.charAt(pos.column);
                pos = {
                    row: pos.row,
                    column: pos.column + 1
                };
                match = chr && chr.match(/([\(\[\{])|([\)\]\}])/);
                before = false;
            }
            if (!match) return null;
            if (match[1]) {
                var bracketPos = this.$findClosingBracket(match[1], pos);
                if (!bracketPos) return null;
                range = Range.fromPoints(pos, bracketPos);
                if (!before) {
                    range.end.column++;
                    range.start.column--;
                }
                range.cursor = range.end;
            } else {
                var bracketPos = this.$findOpeningBracket(match[2], pos);
                if (!bracketPos) return null;
                range = Range.fromPoints(bracketPos, pos);
                if (!before) {
                    range.start.column++;
                    range.end.column--;
                }
                range.cursor = range.start;
            }
            return range;
        };
        this.$brackets = {
            ")": "(",
            "(": ")",
            "]": "[",
            "[": "]",
            "{": "}",
            "}": "{"
        };
        this.$findOpeningBracket = function(bracket, position, typeRe) {
            var openBracket = this.$brackets[bracket];
            var depth = 1;
            var iterator = new TokenIterator(this, position.row, position.column);
            var token = iterator.getCurrentToken();
            if (!token) token = iterator.stepForward();
            if (!token) return;
            if (!typeRe) typeRe = new RegExp("(\\.?" + token.type.replace(".", "\\.").replace("rparen", ".paren").replace(/\b(?:end)\b/, "(?:start|begin|end)") + ")+");
            var valueIndex = position.column - iterator.getCurrentTokenColumn() - 2;
            var value = token.value;
            while(true){
                while(valueIndex >= 0){
                    var chr = value.charAt(valueIndex);
                    if (chr == openBracket) {
                        depth -= 1;
                        if (depth == 0) return {
                            row: iterator.getCurrentTokenRow(),
                            column: valueIndex + iterator.getCurrentTokenColumn()
                        };
                    } else if (chr == bracket) depth += 1;
                    valueIndex -= 1;
                }
                do token = iterator.stepBackward();
                while (token && !typeRe.test(token.type));
                if (token == null) break;
                value = token.value;
                valueIndex = value.length - 1;
            }
            return null;
        };
        this.$findClosingBracket = function(bracket, position, typeRe) {
            var closingBracket = this.$brackets[bracket];
            var depth = 1;
            var iterator = new TokenIterator(this, position.row, position.column);
            var token = iterator.getCurrentToken();
            if (!token) token = iterator.stepForward();
            if (!token) return;
            if (!typeRe) typeRe = new RegExp("(\\.?" + token.type.replace(".", "\\.").replace("lparen", ".paren").replace(/\b(?:start|begin)\b/, "(?:start|begin|end)") + ")+");
            var valueIndex = position.column - iterator.getCurrentTokenColumn();
            while(true){
                var value = token.value;
                var valueLength = value.length;
                while(valueIndex < valueLength){
                    var chr = value.charAt(valueIndex);
                    if (chr == closingBracket) {
                        depth -= 1;
                        if (depth == 0) return {
                            row: iterator.getCurrentTokenRow(),
                            column: valueIndex + iterator.getCurrentTokenColumn()
                        };
                    } else if (chr == bracket) depth += 1;
                    valueIndex += 1;
                }
                do token = iterator.stepForward();
                while (token && !typeRe.test(token.type));
                if (token == null) break;
                valueIndex = 0;
            }
            return null;
        };
    }
    exports.BracketMatch = BracketMatch;
});
ace.define("ace/edit_session", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/lib/lang",
    "ace/bidihandler",
    "ace/config",
    "ace/lib/event_emitter",
    "ace/selection",
    "ace/mode/text",
    "ace/range",
    "ace/document",
    "ace/background_tokenizer",
    "ace/search_highlight",
    "ace/edit_session/folding",
    "ace/edit_session/bracket_match"
], function(acequire, exports, module1) {
    "use strict";
    var oop = acequire("./lib/oop");
    var lang = acequire("./lib/lang");
    var BidiHandler = acequire("./bidihandler").BidiHandler;
    var config = acequire("./config");
    var EventEmitter = acequire("./lib/event_emitter").EventEmitter;
    var Selection = acequire("./selection").Selection;
    var TextMode = acequire("./mode/text").Mode;
    var Range = acequire("./range").Range;
    var Document = acequire("./document").Document;
    var BackgroundTokenizer = acequire("./background_tokenizer").BackgroundTokenizer;
    var SearchHighlight = acequire("./search_highlight").SearchHighlight;
    var EditSession = function(text, mode) {
        this.$breakpoints = [];
        this.$decorations = [];
        this.$frontMarkers = {};
        this.$backMarkers = {};
        this.$markerId = 1;
        this.$undoSelect = true;
        this.$foldData = [];
        this.id = "session" + ++EditSession.$uid;
        this.$foldData.toString = function() {
            return this.join("\n");
        };
        this.on("changeFold", this.onChangeFold.bind(this));
        this.$onChange = this.onChange.bind(this);
        if (typeof text != "object" || !text.getLine) text = new Document(text);
        this.$bidiHandler = new BidiHandler(this);
        this.setDocument(text);
        this.selection = new Selection(this);
        config.resetOptions(this);
        this.setMode(mode);
        config._signal("session", this);
    };
    EditSession.$uid = 0;
    (function() {
        oop.implement(this, EventEmitter);
        this.setDocument = function(doc) {
            if (this.doc) this.doc.removeListener("change", this.$onChange);
            this.doc = doc;
            doc.on("change", this.$onChange);
            if (this.bgTokenizer) this.bgTokenizer.setDocument(this.getDocument());
            this.resetCaches();
        };
        this.getDocument = function() {
            return this.doc;
        };
        this.$resetRowCache = function(docRow) {
            if (!docRow) {
                this.$docRowCache = [];
                this.$screenRowCache = [];
                return;
            }
            var l = this.$docRowCache.length;
            var i = this.$getRowCacheIndex(this.$docRowCache, docRow) + 1;
            if (l > i) {
                this.$docRowCache.splice(i, l);
                this.$screenRowCache.splice(i, l);
            }
        };
        this.$getRowCacheIndex = function(cacheArray, val) {
            var low = 0;
            var hi = cacheArray.length - 1;
            while(low <= hi){
                var mid = low + hi >> 1;
                var c = cacheArray[mid];
                if (val > c) low = mid + 1;
                else if (val < c) hi = mid - 1;
                else return mid;
            }
            return low - 1;
        };
        this.resetCaches = function() {
            this.$modified = true;
            this.$wrapData = [];
            this.$rowLengthCache = [];
            this.$resetRowCache(0);
            if (this.bgTokenizer) this.bgTokenizer.start(0);
        };
        this.onChangeFold = function(e) {
            var fold = e.data;
            this.$resetRowCache(fold.start.row);
        };
        this.onChange = function(delta) {
            this.$modified = true;
            this.$bidiHandler.onChange(delta);
            this.$resetRowCache(delta.start.row);
            var removedFolds = this.$updateInternalDataOnChange(delta);
            if (!this.$fromUndo && this.$undoManager && !delta.ignore) {
                this.$deltasDoc.push(delta);
                if (removedFolds && removedFolds.length != 0) this.$deltasFold.push({
                    action: "removeFolds",
                    folds: removedFolds
                });
                this.$informUndoManager.schedule();
            }
            this.bgTokenizer && this.bgTokenizer.$updateOnChange(delta);
            this._signal("change", delta);
        };
        this.setValue = function(text) {
            this.doc.setValue(text);
            this.selection.moveTo(0, 0);
            this.$resetRowCache(0);
            this.$deltas = [];
            this.$deltasDoc = [];
            this.$deltasFold = [];
            this.setUndoManager(this.$undoManager);
            this.getUndoManager().reset();
        };
        this.getValue = this.toString = function() {
            return this.doc.getValue();
        };
        this.getSelection = function() {
            return this.selection;
        };
        this.getState = function(row) {
            return this.bgTokenizer.getState(row);
        };
        this.getTokens = function(row) {
            return this.bgTokenizer.getTokens(row);
        };
        this.getTokenAt = function(row, column) {
            var tokens = this.bgTokenizer.getTokens(row);
            var token, c = 0;
            if (column == null) {
                var i = tokens.length - 1;
                c = this.getLine(row).length;
            } else for(var i = 0; i < tokens.length; i++){
                c += tokens[i].value.length;
                if (c >= column) break;
            }
            token = tokens[i];
            if (!token) return null;
            token.index = i;
            token.start = c - token.value.length;
            return token;
        };
        this.setUndoManager = function(undoManager) {
            this.$undoManager = undoManager;
            this.$deltas = [];
            this.$deltasDoc = [];
            this.$deltasFold = [];
            if (this.$informUndoManager) this.$informUndoManager.cancel();
            if (undoManager) {
                var self = this;
                this.$syncInformUndoManager = function() {
                    self.$informUndoManager.cancel();
                    if (self.$deltasFold.length) {
                        self.$deltas.push({
                            group: "fold",
                            deltas: self.$deltasFold
                        });
                        self.$deltasFold = [];
                    }
                    if (self.$deltasDoc.length) {
                        self.$deltas.push({
                            group: "doc",
                            deltas: self.$deltasDoc
                        });
                        self.$deltasDoc = [];
                    }
                    if (self.$deltas.length > 0) undoManager.execute({
                        action: "aceupdate",
                        args: [
                            self.$deltas,
                            self
                        ],
                        merge: self.mergeUndoDeltas
                    });
                    self.mergeUndoDeltas = false;
                    self.$deltas = [];
                };
                this.$informUndoManager = lang.delayedCall(this.$syncInformUndoManager);
            }
        };
        this.markUndoGroup = function() {
            if (this.$syncInformUndoManager) this.$syncInformUndoManager();
        };
        this.$defaultUndoManager = {
            undo: function() {},
            redo: function() {},
            reset: function() {}
        };
        this.getUndoManager = function() {
            return this.$undoManager || this.$defaultUndoManager;
        };
        this.getTabString = function() {
            if (this.getUseSoftTabs()) return lang.stringRepeat(" ", this.getTabSize());
            else return "\t";
        };
        this.setUseSoftTabs = function(val) {
            this.setOption("useSoftTabs", val);
        };
        this.getUseSoftTabs = function() {
            return this.$useSoftTabs && !this.$mode.$indentWithTabs;
        };
        this.setTabSize = function(tabSize) {
            this.setOption("tabSize", tabSize);
        };
        this.getTabSize = function() {
            return this.$tabSize;
        };
        this.isTabStop = function(position) {
            return this.$useSoftTabs && position.column % this.$tabSize === 0;
        };
        this.setNavigateWithinSoftTabs = function(navigateWithinSoftTabs) {
            this.setOption("navigateWithinSoftTabs", navigateWithinSoftTabs);
        };
        this.getNavigateWithinSoftTabs = function() {
            return this.$navigateWithinSoftTabs;
        };
        this.$overwrite = false;
        this.setOverwrite = function(overwrite) {
            this.setOption("overwrite", overwrite);
        };
        this.getOverwrite = function() {
            return this.$overwrite;
        };
        this.toggleOverwrite = function() {
            this.setOverwrite(!this.$overwrite);
        };
        this.addGutterDecoration = function(row, className) {
            if (!this.$decorations[row]) this.$decorations[row] = "";
            this.$decorations[row] += " " + className;
            this._signal("changeBreakpoint", {});
        };
        this.removeGutterDecoration = function(row, className) {
            this.$decorations[row] = (this.$decorations[row] || "").replace(" " + className, "");
            this._signal("changeBreakpoint", {});
        };
        this.getBreakpoints = function() {
            return this.$breakpoints;
        };
        this.setBreakpoints = function(rows) {
            this.$breakpoints = [];
            for(var i = 0; i < rows.length; i++)this.$breakpoints[rows[i]] = "ace_breakpoint";
            this._signal("changeBreakpoint", {});
        };
        this.clearBreakpoints = function() {
            this.$breakpoints = [];
            this._signal("changeBreakpoint", {});
        };
        this.setBreakpoint = function(row, className) {
            if (className === undefined) className = "ace_breakpoint";
            if (className) this.$breakpoints[row] = className;
            else delete this.$breakpoints[row];
            this._signal("changeBreakpoint", {});
        };
        this.clearBreakpoint = function(row) {
            delete this.$breakpoints[row];
            this._signal("changeBreakpoint", {});
        };
        this.addMarker = function(range, clazz, type, inFront) {
            var id = this.$markerId++;
            var marker = {
                range: range,
                type: type || "line",
                renderer: typeof type == "function" ? type : null,
                clazz: clazz,
                inFront: !!inFront,
                id: id
            };
            if (inFront) {
                this.$frontMarkers[id] = marker;
                this._signal("changeFrontMarker");
            } else {
                this.$backMarkers[id] = marker;
                this._signal("changeBackMarker");
            }
            return id;
        };
        this.addDynamicMarker = function(marker, inFront) {
            if (!marker.update) return;
            var id = this.$markerId++;
            marker.id = id;
            marker.inFront = !!inFront;
            if (inFront) {
                this.$frontMarkers[id] = marker;
                this._signal("changeFrontMarker");
            } else {
                this.$backMarkers[id] = marker;
                this._signal("changeBackMarker");
            }
            return marker;
        };
        this.removeMarker = function(markerId) {
            var marker = this.$frontMarkers[markerId] || this.$backMarkers[markerId];
            if (!marker) return;
            var markers = marker.inFront ? this.$frontMarkers : this.$backMarkers;
            if (marker) {
                delete markers[markerId];
                this._signal(marker.inFront ? "changeFrontMarker" : "changeBackMarker");
            }
        };
        this.getMarkers = function(inFront) {
            return inFront ? this.$frontMarkers : this.$backMarkers;
        };
        this.highlight = function(re) {
            if (!this.$searchHighlight) {
                var highlight = new SearchHighlight(null, "ace_selected-word", "text");
                this.$searchHighlight = this.addDynamicMarker(highlight);
            }
            this.$searchHighlight.setRegexp(re);
        };
        this.highlightLines = function(startRow, endRow, clazz, inFront) {
            if (typeof endRow != "number") {
                clazz = endRow;
                endRow = startRow;
            }
            if (!clazz) clazz = "ace_step";
            var range = new Range(startRow, 0, endRow, Infinity);
            range.id = this.addMarker(range, clazz, "fullLine", inFront);
            return range;
        };
        this.setAnnotations = function(annotations) {
            this.$annotations = annotations;
            this._signal("changeAnnotation", {});
        };
        this.getAnnotations = function() {
            return this.$annotations || [];
        };
        this.clearAnnotations = function() {
            this.setAnnotations([]);
        };
        this.$detectNewLine = function(text) {
            var match = text.match(/^.*?(\r?\n)/m);
            if (match) this.$autoNewLine = match[1];
            else this.$autoNewLine = "\n";
        };
        this.getWordRange = function(row, column) {
            var line = this.getLine(row);
            var inToken = false;
            if (column > 0) inToken = !!line.charAt(column - 1).match(this.tokenRe);
            if (!inToken) inToken = !!line.charAt(column).match(this.tokenRe);
            if (inToken) var re = this.tokenRe;
            else if (/^\s+$/.test(line.slice(column - 1, column + 1))) var re = /\s/;
            else var re = this.nonTokenRe;
            var start = column;
            if (start > 0) {
                do start--;
                while (start >= 0 && line.charAt(start).match(re));
                start++;
            }
            var end = column;
            while(end < line.length && line.charAt(end).match(re))end++;
            return new Range(row, start, row, end);
        };
        this.getAWordRange = function(row, column) {
            var wordRange = this.getWordRange(row, column);
            var line = this.getLine(wordRange.end.row);
            while(line.charAt(wordRange.end.column).match(/[ \t]/))wordRange.end.column += 1;
            return wordRange;
        };
        this.setNewLineMode = function(newLineMode) {
            this.doc.setNewLineMode(newLineMode);
        };
        this.getNewLineMode = function() {
            return this.doc.getNewLineMode();
        };
        this.setUseWorker = function(useWorker) {
            this.setOption("useWorker", useWorker);
        };
        this.getUseWorker = function() {
            return this.$useWorker;
        };
        this.onReloadTokenizer = function(e) {
            var rows = e.data;
            this.bgTokenizer.start(rows.first);
            this._signal("tokenizerUpdate", e);
        };
        this.$modes = {};
        this.$mode = null;
        this.$modeId = null;
        this.setMode = function(mode, cb) {
            if (mode && typeof mode === "object") {
                if (mode.getTokenizer) return this.$onChangeMode(mode);
                var options = mode;
                var path = options.path;
            } else path = mode || "ace/mode/text";
            if (!this.$modes["ace/mode/text"]) this.$modes["ace/mode/text"] = new TextMode();
            if (this.$modes[path] && !options) {
                this.$onChangeMode(this.$modes[path]);
                cb && cb();
                return;
            }
            this.$modeId = path;
            config.loadModule([
                "mode",
                path
            ], (function(m) {
                if (this.$modeId !== path) return cb && cb();
                if (this.$modes[path] && !options) this.$onChangeMode(this.$modes[path]);
                else if (m && m.Mode) {
                    m = new m.Mode(options);
                    if (!options) {
                        this.$modes[path] = m;
                        m.$id = path;
                    }
                    this.$onChangeMode(m);
                }
                cb && cb();
            }).bind(this));
            if (!this.$mode) this.$onChangeMode(this.$modes["ace/mode/text"], true);
        };
        this.$onChangeMode = function(mode, $isPlaceholder) {
            if (!$isPlaceholder) this.$modeId = mode.$id;
            if (this.$mode === mode) return;
            this.$mode = mode;
            this.$stopWorker();
            if (this.$useWorker) this.$startWorker();
            var tokenizer = mode.getTokenizer();
            if (tokenizer.addEventListener !== undefined) {
                var onReloadTokenizer = this.onReloadTokenizer.bind(this);
                tokenizer.addEventListener("update", onReloadTokenizer);
            }
            if (!this.bgTokenizer) {
                this.bgTokenizer = new BackgroundTokenizer(tokenizer);
                var _self = this;
                this.bgTokenizer.addEventListener("update", function(e) {
                    _self._signal("tokenizerUpdate", e);
                });
            } else this.bgTokenizer.setTokenizer(tokenizer);
            this.bgTokenizer.setDocument(this.getDocument());
            this.tokenRe = mode.tokenRe;
            this.nonTokenRe = mode.nonTokenRe;
            if (!$isPlaceholder) {
                if (mode.attachToSession) mode.attachToSession(this);
                this.$options.wrapMethod.set.call(this, this.$wrapMethod);
                this.$setFolding(mode.foldingRules);
                this.bgTokenizer.start(0);
                this._emit("changeMode");
            }
        };
        this.$stopWorker = function() {
            if (this.$worker) {
                this.$worker.terminate();
                this.$worker = null;
            }
        };
        this.$startWorker = function() {
            try {
                this.$worker = this.$mode.createWorker(this);
            } catch (e) {
                config.warn("Could not load worker", e);
                this.$worker = null;
            }
        };
        this.getMode = function() {
            return this.$mode;
        };
        this.$scrollTop = 0;
        this.setScrollTop = function(scrollTop) {
            if (this.$scrollTop === scrollTop || isNaN(scrollTop)) return;
            this.$scrollTop = scrollTop;
            this._signal("changeScrollTop", scrollTop);
        };
        this.getScrollTop = function() {
            return this.$scrollTop;
        };
        this.$scrollLeft = 0;
        this.setScrollLeft = function(scrollLeft) {
            if (this.$scrollLeft === scrollLeft || isNaN(scrollLeft)) return;
            this.$scrollLeft = scrollLeft;
            this._signal("changeScrollLeft", scrollLeft);
        };
        this.getScrollLeft = function() {
            return this.$scrollLeft;
        };
        this.getScreenWidth = function() {
            this.$computeWidth();
            if (this.lineWidgets) return Math.max(this.getLineWidgetMaxWidth(), this.screenWidth);
            return this.screenWidth;
        };
        this.getLineWidgetMaxWidth = function() {
            if (this.lineWidgetsWidth != null) return this.lineWidgetsWidth;
            var width = 0;
            this.lineWidgets.forEach(function(w) {
                if (w && w.screenWidth > width) width = w.screenWidth;
            });
            return this.lineWidgetWidth = width;
        };
        this.$computeWidth = function(force) {
            if (this.$modified || force) {
                this.$modified = false;
                if (this.$useWrapMode) return this.screenWidth = this.$wrapLimit;
                var lines = this.doc.getAllLines();
                var cache = this.$rowLengthCache;
                var longestScreenLine = 0;
                var foldIndex = 0;
                var foldLine = this.$foldData[foldIndex];
                var foldStart = foldLine ? foldLine.start.row : Infinity;
                var len = lines.length;
                for(var i = 0; i < len; i++){
                    if (i > foldStart) {
                        i = foldLine.end.row + 1;
                        if (i >= len) break;
                        foldLine = this.$foldData[foldIndex++];
                        foldStart = foldLine ? foldLine.start.row : Infinity;
                    }
                    if (cache[i] == null) cache[i] = this.$getStringScreenWidth(lines[i])[0];
                    if (cache[i] > longestScreenLine) longestScreenLine = cache[i];
                }
                this.screenWidth = longestScreenLine;
            }
        };
        this.getLine = function(row) {
            return this.doc.getLine(row);
        };
        this.getLines = function(firstRow, lastRow) {
            return this.doc.getLines(firstRow, lastRow);
        };
        this.getLength = function() {
            return this.doc.getLength();
        };
        this.getTextRange = function(range) {
            return this.doc.getTextRange(range || this.selection.getRange());
        };
        this.insert = function(position, text) {
            return this.doc.insert(position, text);
        };
        this.remove = function(range) {
            return this.doc.remove(range);
        };
        this.removeFullLines = function(firstRow, lastRow) {
            return this.doc.removeFullLines(firstRow, lastRow);
        };
        this.undoChanges = function(deltas, dontSelect) {
            if (!deltas.length) return;
            this.$fromUndo = true;
            var lastUndoRange = null;
            for(var i = deltas.length - 1; i != -1; i--){
                var delta = deltas[i];
                if (delta.group == "doc") {
                    this.doc.revertDeltas(delta.deltas);
                    lastUndoRange = this.$getUndoSelection(delta.deltas, true, lastUndoRange);
                } else delta.deltas.forEach(function(foldDelta) {
                    this.addFolds(foldDelta.folds);
                }, this);
            }
            this.$fromUndo = false;
            lastUndoRange && this.$undoSelect && !dontSelect && this.selection.setSelectionRange(lastUndoRange);
            return lastUndoRange;
        };
        this.redoChanges = function(deltas, dontSelect) {
            if (!deltas.length) return;
            this.$fromUndo = true;
            var lastUndoRange = null;
            for(var i = 0; i < deltas.length; i++){
                var delta = deltas[i];
                if (delta.group == "doc") {
                    this.doc.applyDeltas(delta.deltas);
                    lastUndoRange = this.$getUndoSelection(delta.deltas, false, lastUndoRange);
                }
            }
            this.$fromUndo = false;
            lastUndoRange && this.$undoSelect && !dontSelect && this.selection.setSelectionRange(lastUndoRange);
            return lastUndoRange;
        };
        this.setUndoSelect = function(enable) {
            this.$undoSelect = enable;
        };
        this.$getUndoSelection = function(deltas, isUndo, lastUndoRange) {
            function isInsert(delta) {
                return isUndo ? delta.action !== "insert" : delta.action === "insert";
            }
            var delta = deltas[0];
            var range, point;
            var lastDeltaIsInsert = false;
            if (isInsert(delta)) {
                range = Range.fromPoints(delta.start, delta.end);
                lastDeltaIsInsert = true;
            } else {
                range = Range.fromPoints(delta.start, delta.start);
                lastDeltaIsInsert = false;
            }
            for(var i = 1; i < deltas.length; i++){
                delta = deltas[i];
                if (isInsert(delta)) {
                    point = delta.start;
                    if (range.compare(point.row, point.column) == -1) range.setStart(point);
                    point = delta.end;
                    if (range.compare(point.row, point.column) == 1) range.setEnd(point);
                    lastDeltaIsInsert = true;
                } else {
                    point = delta.start;
                    if (range.compare(point.row, point.column) == -1) range = Range.fromPoints(delta.start, delta.start);
                    lastDeltaIsInsert = false;
                }
            }
            if (lastUndoRange != null) {
                if (Range.comparePoints(lastUndoRange.start, range.start) === 0) {
                    lastUndoRange.start.column += range.end.column - range.start.column;
                    lastUndoRange.end.column += range.end.column - range.start.column;
                }
                var cmp = lastUndoRange.compareRange(range);
                if (cmp == 1) range.setStart(lastUndoRange.start);
                else if (cmp == -1) range.setEnd(lastUndoRange.end);
            }
            return range;
        };
        this.replace = function(range, text) {
            return this.doc.replace(range, text);
        };
        this.moveText = function(fromRange, toPosition, copy) {
            var text = this.getTextRange(fromRange);
            var folds = this.getFoldsInRange(fromRange);
            var toRange = Range.fromPoints(toPosition, toPosition);
            if (!copy) {
                this.remove(fromRange);
                var rowDiff = fromRange.start.row - fromRange.end.row;
                var collDiff = rowDiff ? -fromRange.end.column : fromRange.start.column - fromRange.end.column;
                if (collDiff) {
                    if (toRange.start.row == fromRange.end.row && toRange.start.column > fromRange.end.column) toRange.start.column += collDiff;
                    if (toRange.end.row == fromRange.end.row && toRange.end.column > fromRange.end.column) toRange.end.column += collDiff;
                }
                if (rowDiff && toRange.start.row >= fromRange.end.row) {
                    toRange.start.row += rowDiff;
                    toRange.end.row += rowDiff;
                }
            }
            toRange.end = this.insert(toRange.start, text);
            if (folds.length) {
                var oldStart = fromRange.start;
                var newStart = toRange.start;
                var rowDiff = newStart.row - oldStart.row;
                var collDiff = newStart.column - oldStart.column;
                this.addFolds(folds.map(function(x) {
                    x = x.clone();
                    if (x.start.row == oldStart.row) x.start.column += collDiff;
                    if (x.end.row == oldStart.row) x.end.column += collDiff;
                    x.start.row += rowDiff;
                    x.end.row += rowDiff;
                    return x;
                }));
            }
            return toRange;
        };
        this.indentRows = function(startRow, endRow, indentString) {
            indentString = indentString.replace(/\t/g, this.getTabString());
            for(var row = startRow; row <= endRow; row++)this.doc.insertInLine({
                row: row,
                column: 0
            }, indentString);
        };
        this.outdentRows = function(range) {
            var rowRange = range.collapseRows();
            var deleteRange = new Range(0, 0, 0, 0);
            var size = this.getTabSize();
            for(var i = rowRange.start.row; i <= rowRange.end.row; ++i){
                var line = this.getLine(i);
                deleteRange.start.row = i;
                deleteRange.end.row = i;
                for(var j = 0; j < size; ++j)if (line.charAt(j) != ' ') break;
                if (j < size && line.charAt(j) == '\t') {
                    deleteRange.start.column = j;
                    deleteRange.end.column = j + 1;
                } else {
                    deleteRange.start.column = 0;
                    deleteRange.end.column = j;
                }
                this.remove(deleteRange);
            }
        };
        this.$moveLines = function(firstRow, lastRow, dir) {
            firstRow = this.getRowFoldStart(firstRow);
            lastRow = this.getRowFoldEnd(lastRow);
            if (dir < 0) {
                var row = this.getRowFoldStart(firstRow + dir);
                if (row < 0) return 0;
                var diff = row - firstRow;
            } else if (dir > 0) {
                var row = this.getRowFoldEnd(lastRow + dir);
                if (row > this.doc.getLength() - 1) return 0;
                var diff = row - lastRow;
            } else {
                firstRow = this.$clipRowToDocument(firstRow);
                lastRow = this.$clipRowToDocument(lastRow);
                var diff = lastRow - firstRow + 1;
            }
            var range = new Range(firstRow, 0, lastRow, Number.MAX_VALUE);
            var folds = this.getFoldsInRange(range).map(function(x) {
                x = x.clone();
                x.start.row += diff;
                x.end.row += diff;
                return x;
            });
            var lines = dir == 0 ? this.doc.getLines(firstRow, lastRow) : this.doc.removeFullLines(firstRow, lastRow);
            this.doc.insertFullLines(firstRow + diff, lines);
            folds.length && this.addFolds(folds);
            return diff;
        };
        this.moveLinesUp = function(firstRow, lastRow) {
            return this.$moveLines(firstRow, lastRow, -1);
        };
        this.moveLinesDown = function(firstRow, lastRow) {
            return this.$moveLines(firstRow, lastRow, 1);
        };
        this.duplicateLines = function(firstRow, lastRow) {
            return this.$moveLines(firstRow, lastRow, 0);
        };
        this.$clipRowToDocument = function(row) {
            return Math.max(0, Math.min(row, this.doc.getLength() - 1));
        };
        this.$clipColumnToRow = function(row, column) {
            if (column < 0) return 0;
            return Math.min(this.doc.getLine(row).length, column);
        };
        this.$clipPositionToDocument = function(row, column) {
            column = Math.max(0, column);
            if (row < 0) {
                row = 0;
                column = 0;
            } else {
                var len = this.doc.getLength();
                if (row >= len) {
                    row = len - 1;
                    column = this.doc.getLine(len - 1).length;
                } else column = Math.min(this.doc.getLine(row).length, column);
            }
            return {
                row: row,
                column: column
            };
        };
        this.$clipRangeToDocument = function(range) {
            if (range.start.row < 0) {
                range.start.row = 0;
                range.start.column = 0;
            } else range.start.column = this.$clipColumnToRow(range.start.row, range.start.column);
            var len = this.doc.getLength() - 1;
            if (range.end.row > len) {
                range.end.row = len;
                range.end.column = this.doc.getLine(len).length;
            } else range.end.column = this.$clipColumnToRow(range.end.row, range.end.column);
            return range;
        };
        this.$wrapLimit = 80;
        this.$useWrapMode = false;
        this.$wrapLimitRange = {
            min: null,
            max: null
        };
        this.setUseWrapMode = function(useWrapMode) {
            if (useWrapMode != this.$useWrapMode) {
                this.$useWrapMode = useWrapMode;
                this.$modified = true;
                this.$resetRowCache(0);
                if (useWrapMode) {
                    var len = this.getLength();
                    this.$wrapData = Array(len);
                    this.$updateWrapData(0, len - 1);
                }
                this._signal("changeWrapMode");
            }
        };
        this.getUseWrapMode = function() {
            return this.$useWrapMode;
        };
        this.setWrapLimitRange = function(min, max) {
            if (this.$wrapLimitRange.min !== min || this.$wrapLimitRange.max !== max) {
                this.$wrapLimitRange = {
                    min: min,
                    max: max
                };
                this.$modified = true;
                this.$bidiHandler.markAsDirty();
                if (this.$useWrapMode) this._signal("changeWrapMode");
            }
        };
        this.adjustWrapLimit = function(desiredLimit, $printMargin) {
            var limits = this.$wrapLimitRange;
            if (limits.max < 0) limits = {
                min: $printMargin,
                max: $printMargin
            };
            var wrapLimit = this.$constrainWrapLimit(desiredLimit, limits.min, limits.max);
            if (wrapLimit != this.$wrapLimit && wrapLimit > 1) {
                this.$wrapLimit = wrapLimit;
                this.$modified = true;
                if (this.$useWrapMode) {
                    this.$updateWrapData(0, this.getLength() - 1);
                    this.$resetRowCache(0);
                    this._signal("changeWrapLimit");
                }
                return true;
            }
            return false;
        };
        this.$constrainWrapLimit = function(wrapLimit, min, max) {
            if (min) wrapLimit = Math.max(min, wrapLimit);
            if (max) wrapLimit = Math.min(max, wrapLimit);
            return wrapLimit;
        };
        this.getWrapLimit = function() {
            return this.$wrapLimit;
        };
        this.setWrapLimit = function(limit) {
            this.setWrapLimitRange(limit, limit);
        };
        this.getWrapLimitRange = function() {
            return {
                min: this.$wrapLimitRange.min,
                max: this.$wrapLimitRange.max
            };
        };
        this.$updateInternalDataOnChange = function(delta) {
            var useWrapMode = this.$useWrapMode;
            var action = delta.action;
            var start = delta.start;
            var end = delta.end;
            var firstRow = start.row;
            var lastRow = end.row;
            var len = lastRow - firstRow;
            var removedFolds = null;
            this.$updating = true;
            if (len != 0) {
                if (action === "remove") {
                    this[useWrapMode ? "$wrapData" : "$rowLengthCache"].splice(firstRow, len);
                    var foldLines = this.$foldData;
                    removedFolds = this.getFoldsInRange(delta);
                    this.removeFolds(removedFolds);
                    var foldLine = this.getFoldLine(end.row);
                    var idx = 0;
                    if (foldLine) {
                        foldLine.addRemoveChars(end.row, end.column, start.column - end.column);
                        foldLine.shiftRow(-len);
                        var foldLineBefore = this.getFoldLine(firstRow);
                        if (foldLineBefore && foldLineBefore !== foldLine) {
                            foldLineBefore.merge(foldLine);
                            foldLine = foldLineBefore;
                        }
                        idx = foldLines.indexOf(foldLine) + 1;
                    }
                    for(idx; idx < foldLines.length; idx++){
                        var foldLine = foldLines[idx];
                        if (foldLine.start.row >= end.row) foldLine.shiftRow(-len);
                    }
                    lastRow = firstRow;
                } else {
                    var args = Array(len);
                    args.unshift(firstRow, 0);
                    var arr = useWrapMode ? this.$wrapData : this.$rowLengthCache;
                    arr.splice.apply(arr, args);
                    var foldLines = this.$foldData;
                    var foldLine = this.getFoldLine(firstRow);
                    var idx = 0;
                    if (foldLine) {
                        var cmp = foldLine.range.compareInside(start.row, start.column);
                        if (cmp == 0) {
                            foldLine = foldLine.split(start.row, start.column);
                            if (foldLine) {
                                foldLine.shiftRow(len);
                                foldLine.addRemoveChars(lastRow, 0, end.column - start.column);
                            }
                        } else if (cmp == -1) {
                            foldLine.addRemoveChars(firstRow, 0, end.column - start.column);
                            foldLine.shiftRow(len);
                        }
                        idx = foldLines.indexOf(foldLine) + 1;
                    }
                    for(idx; idx < foldLines.length; idx++){
                        var foldLine = foldLines[idx];
                        if (foldLine.start.row >= firstRow) foldLine.shiftRow(len);
                    }
                }
            } else {
                len = Math.abs(delta.start.column - delta.end.column);
                if (action === "remove") {
                    removedFolds = this.getFoldsInRange(delta);
                    this.removeFolds(removedFolds);
                    len = -len;
                }
                var foldLine = this.getFoldLine(firstRow);
                if (foldLine) foldLine.addRemoveChars(firstRow, start.column, len);
            }
            if (useWrapMode && this.$wrapData.length != this.doc.getLength()) console.error("doc.getLength() and $wrapData.length have to be the same!");
            this.$updating = false;
            if (useWrapMode) this.$updateWrapData(firstRow, lastRow);
            else this.$updateRowLengthCache(firstRow, lastRow);
            return removedFolds;
        };
        this.$updateRowLengthCache = function(firstRow, lastRow, b) {
            this.$rowLengthCache[firstRow] = null;
            this.$rowLengthCache[lastRow] = null;
        };
        this.$updateWrapData = function(firstRow, lastRow) {
            var lines = this.doc.getAllLines();
            var tabSize = this.getTabSize();
            var wrapData = this.$wrapData;
            var wrapLimit = this.$wrapLimit;
            var tokens;
            var foldLine;
            var row = firstRow;
            lastRow = Math.min(lastRow, lines.length - 1);
            while(row <= lastRow){
                foldLine = this.getFoldLine(row, foldLine);
                if (!foldLine) {
                    tokens = this.$getDisplayTokens(lines[row]);
                    wrapData[row] = this.$computeWrapSplits(tokens, wrapLimit, tabSize);
                    row++;
                } else {
                    tokens = [];
                    foldLine.walk((function(placeholder, row, column, lastColumn) {
                        var walkTokens;
                        if (placeholder != null) {
                            walkTokens = this.$getDisplayTokens(placeholder, tokens.length);
                            walkTokens[0] = PLACEHOLDER_START;
                            for(var i = 1; i < walkTokens.length; i++)walkTokens[i] = PLACEHOLDER_BODY;
                        } else walkTokens = this.$getDisplayTokens(lines[row].substring(lastColumn, column), tokens.length);
                        tokens = tokens.concat(walkTokens);
                    }).bind(this), foldLine.end.row, lines[foldLine.end.row].length + 1);
                    wrapData[foldLine.start.row] = this.$computeWrapSplits(tokens, wrapLimit, tabSize);
                    row = foldLine.end.row + 1;
                }
            }
        };
        var CHAR = 1, CHAR_EXT = 2, PLACEHOLDER_START = 3, PLACEHOLDER_BODY = 4, PUNCTUATION = 9, SPACE = 10, TAB = 11, TAB_SPACE = 12;
        this.$computeWrapSplits = function(tokens, wrapLimit, tabSize) {
            if (tokens.length == 0) return [];
            var splits = [];
            var displayLength = tokens.length;
            var lastSplit = 0, lastDocSplit = 0;
            var isCode = this.$wrapAsCode;
            var indentedSoftWrap = this.$indentedSoftWrap;
            var maxIndent = wrapLimit <= Math.max(2 * tabSize, 8) || indentedSoftWrap === false ? 0 : Math.floor(wrapLimit / 2);
            function getWrapIndent() {
                var indentation = 0;
                if (maxIndent === 0) return indentation;
                if (indentedSoftWrap) for(var i = 0; i < tokens.length; i++){
                    var token = tokens[i];
                    if (token == SPACE) indentation += 1;
                    else if (token == TAB) indentation += tabSize;
                    else if (token == TAB_SPACE) continue;
                    else break;
                }
                if (isCode && indentedSoftWrap !== false) indentation += tabSize;
                return Math.min(indentation, maxIndent);
            }
            function addSplit(screenPos) {
                var displayed = tokens.slice(lastSplit, screenPos);
                var len = displayed.length;
                displayed.join("").replace(/12/g, function() {
                    len -= 1;
                }).replace(/2/g, function() {
                    len -= 1;
                });
                if (!splits.length) {
                    indent = getWrapIndent();
                    splits.indent = indent;
                }
                lastDocSplit += len;
                splits.push(lastDocSplit);
                lastSplit = screenPos;
            }
            var indent = 0;
            while(displayLength - lastSplit > wrapLimit - indent){
                var split = lastSplit + wrapLimit - indent;
                if (tokens[split - 1] >= SPACE && tokens[split] >= SPACE) {
                    addSplit(split);
                    continue;
                }
                if (tokens[split] == PLACEHOLDER_START || tokens[split] == PLACEHOLDER_BODY) {
                    for(split; split != lastSplit - 1; split--){
                        if (tokens[split] == PLACEHOLDER_START) break;
                    }
                    if (split > lastSplit) {
                        addSplit(split);
                        continue;
                    }
                    split = lastSplit + wrapLimit;
                    for(split; split < tokens.length; split++){
                        if (tokens[split] != PLACEHOLDER_BODY) break;
                    }
                    if (split == tokens.length) break; // Breaks the while-loop.
                    addSplit(split);
                    continue;
                }
                var minSplit = Math.max(split - (wrapLimit - (wrapLimit >> 2)), lastSplit - 1);
                while(split > minSplit && tokens[split] < PLACEHOLDER_START)split--;
                if (isCode) {
                    while(split > minSplit && tokens[split] < PLACEHOLDER_START)split--;
                    while(split > minSplit && tokens[split] == PUNCTUATION)split--;
                } else while(split > minSplit && tokens[split] < SPACE)split--;
                if (split > minSplit) {
                    addSplit(++split);
                    continue;
                }
                split = lastSplit + wrapLimit;
                if (tokens[split] == CHAR_EXT) split--;
                addSplit(split - indent);
            }
            return splits;
        };
        this.$getDisplayTokens = function(str, offset) {
            var arr = [];
            var tabSize;
            offset = offset || 0;
            for(var i = 0; i < str.length; i++){
                var c = str.charCodeAt(i);
                if (c == 9) {
                    tabSize = this.getScreenTabSize(arr.length + offset);
                    arr.push(TAB);
                    for(var n = 1; n < tabSize; n++)arr.push(TAB_SPACE);
                } else if (c == 32) arr.push(SPACE);
                else if (c > 39 && c < 48 || c > 57 && c < 64) arr.push(PUNCTUATION);
                else if (c >= 0x1100 && isFullWidth(c)) arr.push(CHAR, CHAR_EXT);
                else arr.push(CHAR);
            }
            return arr;
        };
        this.$getStringScreenWidth = function(str, maxScreenColumn, screenColumn) {
            if (maxScreenColumn == 0) return [
                0,
                0
            ];
            if (maxScreenColumn == null) maxScreenColumn = Infinity;
            screenColumn = screenColumn || 0;
            var c, column;
            for(column = 0; column < str.length; column++){
                c = str.charCodeAt(column);
                if (c == 9) screenColumn += this.getScreenTabSize(screenColumn);
                else if (c >= 0x1100 && isFullWidth(c)) screenColumn += 2;
                else screenColumn += 1;
                if (screenColumn > maxScreenColumn) break;
            }
            return [
                screenColumn,
                column
            ];
        };
        this.lineWidgets = null;
        this.getRowLength = function(row) {
            if (this.lineWidgets) var h = this.lineWidgets[row] && this.lineWidgets[row].rowCount || 0;
            else h = 0;
            if (!this.$useWrapMode || !this.$wrapData[row]) return 1 + h;
            else return this.$wrapData[row].length + 1 + h;
        };
        this.getRowLineCount = function(row) {
            if (!this.$useWrapMode || !this.$wrapData[row]) return 1;
            else return this.$wrapData[row].length + 1;
        };
        this.getRowWrapIndent = function(screenRow) {
            if (this.$useWrapMode) {
                var pos = this.screenToDocumentPosition(screenRow, Number.MAX_VALUE);
                var splits = this.$wrapData[pos.row];
                return splits.length && splits[0] < pos.column ? splits.indent : 0;
            } else return 0;
        };
        this.getScreenLastRowColumn = function(screenRow) {
            var pos = this.screenToDocumentPosition(screenRow, Number.MAX_VALUE);
            return this.documentToScreenColumn(pos.row, pos.column);
        };
        this.getDocumentLastRowColumn = function(docRow, docColumn) {
            var screenRow = this.documentToScreenRow(docRow, docColumn);
            return this.getScreenLastRowColumn(screenRow);
        };
        this.getDocumentLastRowColumnPosition = function(docRow, docColumn) {
            var screenRow = this.documentToScreenRow(docRow, docColumn);
            return this.screenToDocumentPosition(screenRow, Number.MAX_VALUE / 10);
        };
        this.getRowSplitData = function(row) {
            if (!this.$useWrapMode) return undefined;
            else return this.$wrapData[row];
        };
        this.getScreenTabSize = function(screenColumn) {
            return this.$tabSize - screenColumn % this.$tabSize;
        };
        this.screenToDocumentRow = function(screenRow, screenColumn) {
            return this.screenToDocumentPosition(screenRow, screenColumn).row;
        };
        this.screenToDocumentColumn = function(screenRow, screenColumn) {
            return this.screenToDocumentPosition(screenRow, screenColumn).column;
        };
        this.screenToDocumentPosition = function(screenRow, screenColumn, offsetX) {
            if (screenRow < 0) return {
                row: 0,
                column: 0
            };
            var line;
            var docRow = 0;
            var docColumn = 0;
            var column;
            var row = 0;
            var rowLength = 0;
            var rowCache = this.$screenRowCache;
            var i = this.$getRowCacheIndex(rowCache, screenRow);
            var l = rowCache.length;
            if (l && i >= 0) {
                var row = rowCache[i];
                var docRow = this.$docRowCache[i];
                var doCache = screenRow > rowCache[l - 1];
            } else var doCache = !l;
            var maxRow = this.getLength() - 1;
            var foldLine = this.getNextFoldLine(docRow);
            var foldStart = foldLine ? foldLine.start.row : Infinity;
            while(row <= screenRow){
                rowLength = this.getRowLength(docRow);
                if (row + rowLength > screenRow || docRow >= maxRow) break;
                else {
                    row += rowLength;
                    docRow++;
                    if (docRow > foldStart) {
                        docRow = foldLine.end.row + 1;
                        foldLine = this.getNextFoldLine(docRow, foldLine);
                        foldStart = foldLine ? foldLine.start.row : Infinity;
                    }
                }
                if (doCache) {
                    this.$docRowCache.push(docRow);
                    this.$screenRowCache.push(row);
                }
            }
            if (foldLine && foldLine.start.row <= docRow) {
                line = this.getFoldDisplayLine(foldLine);
                docRow = foldLine.start.row;
            } else if (row + rowLength <= screenRow || docRow > maxRow) return {
                row: maxRow,
                column: this.getLine(maxRow).length
            };
            else {
                line = this.getLine(docRow);
                foldLine = null;
            }
            var wrapIndent = 0, splitIndex = Math.floor(screenRow - row);
            if (this.$useWrapMode) {
                var splits = this.$wrapData[docRow];
                if (splits) {
                    column = splits[splitIndex];
                    if (splitIndex > 0 && splits.length) {
                        wrapIndent = splits.indent;
                        docColumn = splits[splitIndex - 1] || splits[splits.length - 1];
                        line = line.substring(docColumn);
                    }
                }
            }
            if (offsetX !== undefined && this.$bidiHandler.isBidiRow(row + splitIndex, docRow, splitIndex)) screenColumn = this.$bidiHandler.offsetToCol(offsetX);
            docColumn += this.$getStringScreenWidth(line, screenColumn - wrapIndent)[1];
            if (this.$useWrapMode && docColumn >= column) docColumn = column - 1;
            if (foldLine) return foldLine.idxToPosition(docColumn);
            return {
                row: docRow,
                column: docColumn
            };
        };
        this.documentToScreenPosition = function(docRow, docColumn) {
            if (typeof docColumn === "undefined") var pos = this.$clipPositionToDocument(docRow.row, docRow.column);
            else pos = this.$clipPositionToDocument(docRow, docColumn);
            docRow = pos.row;
            docColumn = pos.column;
            var screenRow = 0;
            var foldStartRow = null;
            var fold = null;
            fold = this.getFoldAt(docRow, docColumn, 1);
            if (fold) {
                docRow = fold.start.row;
                docColumn = fold.start.column;
            }
            var rowEnd, row = 0;
            var rowCache = this.$docRowCache;
            var i = this.$getRowCacheIndex(rowCache, docRow);
            var l = rowCache.length;
            if (l && i >= 0) {
                var row = rowCache[i];
                var screenRow = this.$screenRowCache[i];
                var doCache = docRow > rowCache[l - 1];
            } else var doCache = !l;
            var foldLine = this.getNextFoldLine(row);
            var foldStart = foldLine ? foldLine.start.row : Infinity;
            while(row < docRow){
                if (row >= foldStart) {
                    rowEnd = foldLine.end.row + 1;
                    if (rowEnd > docRow) break;
                    foldLine = this.getNextFoldLine(rowEnd, foldLine);
                    foldStart = foldLine ? foldLine.start.row : Infinity;
                } else rowEnd = row + 1;
                screenRow += this.getRowLength(row);
                row = rowEnd;
                if (doCache) {
                    this.$docRowCache.push(row);
                    this.$screenRowCache.push(screenRow);
                }
            }
            var textLine = "";
            if (foldLine && row >= foldStart) {
                textLine = this.getFoldDisplayLine(foldLine, docRow, docColumn);
                foldStartRow = foldLine.start.row;
            } else {
                textLine = this.getLine(docRow).substring(0, docColumn);
                foldStartRow = docRow;
            }
            var wrapIndent = 0;
            if (this.$useWrapMode) {
                var wrapRow = this.$wrapData[foldStartRow];
                if (wrapRow) {
                    var screenRowOffset = 0;
                    while(textLine.length >= wrapRow[screenRowOffset]){
                        screenRow++;
                        screenRowOffset++;
                    }
                    textLine = textLine.substring(wrapRow[screenRowOffset - 1] || 0, textLine.length);
                    wrapIndent = screenRowOffset > 0 ? wrapRow.indent : 0;
                }
            }
            return {
                row: screenRow,
                column: wrapIndent + this.$getStringScreenWidth(textLine)[0]
            };
        };
        this.documentToScreenColumn = function(row, docColumn) {
            return this.documentToScreenPosition(row, docColumn).column;
        };
        this.documentToScreenRow = function(docRow, docColumn) {
            return this.documentToScreenPosition(docRow, docColumn).row;
        };
        this.getScreenLength = function() {
            var screenRows = 0;
            var fold = null;
            if (!this.$useWrapMode) {
                screenRows = this.getLength();
                var foldData = this.$foldData;
                for(var i = 0; i < foldData.length; i++){
                    fold = foldData[i];
                    screenRows -= fold.end.row - fold.start.row;
                }
            } else {
                var lastRow = this.$wrapData.length;
                var row = 0, i = 0;
                var fold = this.$foldData[i++];
                var foldStart = fold ? fold.start.row : Infinity;
                while(row < lastRow){
                    var splits = this.$wrapData[row];
                    screenRows += splits ? splits.length + 1 : 1;
                    row++;
                    if (row > foldStart) {
                        row = fold.end.row + 1;
                        fold = this.$foldData[i++];
                        foldStart = fold ? fold.start.row : Infinity;
                    }
                }
            }
            if (this.lineWidgets) screenRows += this.$getWidgetScreenLength();
            return screenRows;
        };
        this.$setFontMetrics = function(fm) {
            if (!this.$enableVarChar) return;
            this.$getStringScreenWidth = function(str, maxScreenColumn, screenColumn) {
                if (maxScreenColumn === 0) return [
                    0,
                    0
                ];
                if (!maxScreenColumn) maxScreenColumn = Infinity;
                screenColumn = screenColumn || 0;
                var c, column;
                for(column = 0; column < str.length; column++){
                    c = str.charAt(column);
                    if (c === "\t") screenColumn += this.getScreenTabSize(screenColumn);
                    else screenColumn += fm.getCharacterWidth(c);
                    if (screenColumn > maxScreenColumn) break;
                }
                return [
                    screenColumn,
                    column
                ];
            };
        };
        this.destroy = function() {
            if (this.bgTokenizer) {
                this.bgTokenizer.setDocument(null);
                this.bgTokenizer = null;
            }
            this.$stopWorker();
        };
        this.isFullWidth = isFullWidth;
        function isFullWidth(c) {
            if (c < 0x1100) return false;
            return c >= 0x1100 && c <= 0x115F || c >= 0x11A3 && c <= 0x11A7 || c >= 0x11FA && c <= 0x11FF || c >= 0x2329 && c <= 0x232A || c >= 0x2E80 && c <= 0x2E99 || c >= 0x2E9B && c <= 0x2EF3 || c >= 0x2F00 && c <= 0x2FD5 || c >= 0x2FF0 && c <= 0x2FFB || c >= 0x3000 && c <= 0x303E || c >= 0x3041 && c <= 0x3096 || c >= 0x3099 && c <= 0x30FF || c >= 0x3105 && c <= 0x312D || c >= 0x3131 && c <= 0x318E || c >= 0x3190 && c <= 0x31BA || c >= 0x31C0 && c <= 0x31E3 || c >= 0x31F0 && c <= 0x321E || c >= 0x3220 && c <= 0x3247 || c >= 0x3250 && c <= 0x32FE || c >= 0x3300 && c <= 0x4DBF || c >= 0x4E00 && c <= 0xA48C || c >= 0xA490 && c <= 0xA4C6 || c >= 0xA960 && c <= 0xA97C || c >= 0xAC00 && c <= 0xD7A3 || c >= 0xD7B0 && c <= 0xD7C6 || c >= 0xD7CB && c <= 0xD7FB || c >= 0xF900 && c <= 0xFAFF || c >= 0xFE10 && c <= 0xFE19 || c >= 0xFE30 && c <= 0xFE52 || c >= 0xFE54 && c <= 0xFE66 || c >= 0xFE68 && c <= 0xFE6B || c >= 0xFF01 && c <= 0xFF60 || c >= 0xFFE0 && c <= 0xFFE6;
        }
    }).call(EditSession.prototype);
    acequire("./edit_session/folding").Folding.call(EditSession.prototype);
    acequire("./edit_session/bracket_match").BracketMatch.call(EditSession.prototype);
    config.defineOptions(EditSession.prototype, "session", {
        wrap: {
            set: function(value) {
                if (!value || value == "off") value = false;
                else if (value == "free") value = true;
                else if (value == "printMargin") value = -1;
                else if (typeof value == "string") value = parseInt(value, 10) || false;
                if (this.$wrap == value) return;
                this.$wrap = value;
                if (!value) this.setUseWrapMode(false);
                else {
                    var col = typeof value == "number" ? value : null;
                    this.setWrapLimitRange(col, col);
                    this.setUseWrapMode(true);
                }
            },
            get: function() {
                if (this.getUseWrapMode()) {
                    if (this.$wrap == -1) return "printMargin";
                    if (!this.getWrapLimitRange().min) return "free";
                    return this.$wrap;
                }
                return "off";
            },
            handlesSet: true
        },
        wrapMethod: {
            set: function(val) {
                val = val == "auto" ? this.$mode.type != "text" : val != "text";
                if (val != this.$wrapAsCode) {
                    this.$wrapAsCode = val;
                    if (this.$useWrapMode) {
                        this.$modified = true;
                        this.$resetRowCache(0);
                        this.$updateWrapData(0, this.getLength() - 1);
                    }
                }
            },
            initialValue: "auto"
        },
        indentedSoftWrap: {
            initialValue: true
        },
        firstLineNumber: {
            set: function() {
                this._signal("changeBreakpoint");
            },
            initialValue: 1
        },
        useWorker: {
            set: function(useWorker) {
                this.$useWorker = useWorker;
                this.$stopWorker();
                if (useWorker) this.$startWorker();
            },
            initialValue: true
        },
        useSoftTabs: {
            initialValue: true
        },
        tabSize: {
            set: function(tabSize) {
                if (isNaN(tabSize) || this.$tabSize === tabSize) return;
                this.$modified = true;
                this.$rowLengthCache = [];
                this.$tabSize = tabSize;
                this._signal("changeTabSize");
            },
            initialValue: 4,
            handlesSet: true
        },
        navigateWithinSoftTabs: {
            initialValue: false
        },
        overwrite: {
            set: function(val) {
                this._signal("changeOverwrite");
            },
            initialValue: false
        },
        newLineMode: {
            set: function(val) {
                this.doc.setNewLineMode(val);
            },
            get: function() {
                return this.doc.getNewLineMode();
            },
            handlesSet: true
        },
        mode: {
            set: function(val) {
                this.setMode(val);
            },
            get: function() {
                return this.$modeId;
            }
        }
    });
    exports.EditSession = EditSession;
});
ace.define("ace/search", [
    "require",
    "exports",
    "module",
    "ace/lib/lang",
    "ace/lib/oop",
    "ace/range"
], function(acequire, exports, module1) {
    "use strict";
    var lang = acequire("./lib/lang");
    var oop = acequire("./lib/oop");
    var Range = acequire("./range").Range;
    var Search = function() {
        this.$options = {};
    };
    (function() {
        this.set = function(options) {
            oop.mixin(this.$options, options);
            return this;
        };
        this.getOptions = function() {
            return lang.copyObject(this.$options);
        };
        this.setOptions = function(options) {
            this.$options = options;
        };
        this.find = function(session) {
            var options = this.$options;
            var iterator = this.$matchIterator(session, options);
            if (!iterator) return false;
            var firstRange = null;
            iterator.forEach(function(sr, sc, er, ec) {
                firstRange = new Range(sr, sc, er, ec);
                if (sc == ec && options.start && options.start.start && options.skipCurrent != false && firstRange.isEqual(options.start)) {
                    firstRange = null;
                    return false;
                }
                return true;
            });
            return firstRange;
        };
        this.findAll = function(session) {
            var options = this.$options;
            if (!options.needle) return [];
            this.$assembleRegExp(options);
            var range = options.range;
            var lines = range ? session.getLines(range.start.row, range.end.row) : session.doc.getAllLines();
            var ranges = [];
            var re = options.re;
            if (options.$isMultiLine) {
                var len = re.length;
                var maxRow = lines.length - len;
                var prevRange;
                outer: for(var row = re.offset || 0; row <= maxRow; row++){
                    for(var j = 0; j < len; j++)if (lines[row + j].search(re[j]) == -1) continue outer;
                    var startLine = lines[row];
                    var line = lines[row + len - 1];
                    var startIndex = startLine.length - startLine.match(re[0])[0].length;
                    var endIndex = line.match(re[len - 1])[0].length;
                    if (prevRange && prevRange.end.row === row && prevRange.end.column > startIndex) continue;
                    ranges.push(prevRange = new Range(row, startIndex, row + len - 1, endIndex));
                    if (len > 2) row = row + len - 2;
                }
            } else for(var i = 0; i < lines.length; i++){
                var matches = lang.getMatchOffsets(lines[i], re);
                for(var j = 0; j < matches.length; j++){
                    var match = matches[j];
                    ranges.push(new Range(i, match.offset, i, match.offset + match.length));
                }
            }
            if (range) {
                var startColumn = range.start.column;
                var endColumn = range.start.column;
                var i = 0, j = ranges.length - 1;
                while(i < j && ranges[i].start.column < startColumn && ranges[i].start.row == range.start.row)i++;
                while(i < j && ranges[j].end.column > endColumn && ranges[j].end.row == range.end.row)j--;
                ranges = ranges.slice(i, j + 1);
                for(i = 0, j = ranges.length; i < j; i++){
                    ranges[i].start.row += range.start.row;
                    ranges[i].end.row += range.start.row;
                }
            }
            return ranges;
        };
        this.replace = function(input, replacement) {
            var options = this.$options;
            var re = this.$assembleRegExp(options);
            if (options.$isMultiLine) return replacement;
            if (!re) return;
            var match = re.exec(input);
            if (!match || match[0].length != input.length) return null;
            replacement = input.replace(re, replacement);
            if (options.preserveCase) {
                replacement = replacement.split("");
                for(var i = Math.min(input.length, input.length); i--;){
                    var ch = input[i];
                    if (ch && ch.toLowerCase() != ch) replacement[i] = replacement[i].toUpperCase();
                    else replacement[i] = replacement[i].toLowerCase();
                }
                replacement = replacement.join("");
            }
            return replacement;
        };
        this.$assembleRegExp = function(options, $disableFakeMultiline) {
            if (options.needle instanceof RegExp) return options.re = options.needle;
            var needle = options.needle;
            if (!options.needle) return options.re = false;
            if (!options.regExp) needle = lang.escapeRegExp(needle);
            if (options.wholeWord) needle = addWordBoundary(needle, options);
            var modifier = options.caseSensitive ? "gm" : "gmi";
            options.$isMultiLine = !$disableFakeMultiline && /[\n\r]/.test(needle);
            if (options.$isMultiLine) return options.re = this.$assembleMultilineRegExp(needle, modifier);
            try {
                var re = new RegExp(needle, modifier);
            } catch (e) {
                re = false;
            }
            return options.re = re;
        };
        this.$assembleMultilineRegExp = function(needle, modifier) {
            var parts = needle.replace(/\r\n|\r|\n/g, "$\n^").split("\n");
            var re = [];
            for(var i = 0; i < parts.length; i++)try {
                re.push(new RegExp(parts[i], modifier));
            } catch (e) {
                return false;
            }
            return re;
        };
        this.$matchIterator = function(session, options) {
            var re = this.$assembleRegExp(options);
            if (!re) return false;
            var backwards = options.backwards == true;
            var skipCurrent = options.skipCurrent != false;
            var range = options.range;
            var start = options.start;
            if (!start) start = range ? range[backwards ? "end" : "start"] : session.selection.getRange();
            if (start.start) start = start[skipCurrent != backwards ? "end" : "start"];
            var firstRow = range ? range.start.row : 0;
            var lastRow = range ? range.end.row : session.getLength() - 1;
            if (backwards) var forEach = function(callback) {
                var row = start.row;
                if (forEachInLine(row, start.column, callback)) return;
                for(row--; row >= firstRow; row--)if (forEachInLine(row, Number.MAX_VALUE, callback)) return;
                if (options.wrap == false) return;
                for(row = lastRow, firstRow = start.row; row >= firstRow; row--)if (forEachInLine(row, Number.MAX_VALUE, callback)) return;
            };
            else var forEach = function(callback) {
                var row = start.row;
                if (forEachInLine(row, start.column, callback)) return;
                for(row = row + 1; row <= lastRow; row++)if (forEachInLine(row, 0, callback)) return;
                if (options.wrap == false) return;
                for(row = firstRow, lastRow = start.row; row <= lastRow; row++)if (forEachInLine(row, 0, callback)) return;
            };
            if (options.$isMultiLine) {
                var len = re.length;
                var forEachInLine = function(row, offset, callback) {
                    var startRow = backwards ? row - len + 1 : row;
                    if (startRow < 0) return;
                    var line = session.getLine(startRow);
                    var startIndex = line.search(re[0]);
                    if (!backwards && startIndex < offset || startIndex === -1) return;
                    for(var i = 1; i < len; i++){
                        line = session.getLine(startRow + i);
                        if (line.search(re[i]) == -1) return;
                    }
                    var endIndex = line.match(re[len - 1])[0].length;
                    if (backwards && endIndex > offset) return;
                    if (callback(startRow, startIndex, startRow + len - 1, endIndex)) return true;
                };
            } else if (backwards) var forEachInLine = function(row, endIndex, callback) {
                var line = session.getLine(row);
                var matches = [];
                var m, last = 0;
                re.lastIndex = 0;
                while(m = re.exec(line)){
                    var length = m[0].length;
                    last = m.index;
                    if (!length) {
                        if (last >= line.length) break;
                        re.lastIndex = last += 1;
                    }
                    if (m.index + length > endIndex) break;
                    matches.push(m.index, length);
                }
                for(var i = matches.length - 1; i >= 0; i -= 2){
                    var column = matches[i - 1];
                    var length = matches[i];
                    if (callback(row, column, row, column + length)) return true;
                }
            };
            else var forEachInLine = function(row, startIndex, callback) {
                var line = session.getLine(row);
                var m;
                var last = startIndex;
                re.lastIndex = startIndex;
                while(m = re.exec(line)){
                    var length = m[0].length;
                    last = m.index;
                    if (callback(row, last, row, last + length)) return true;
                    if (!length) {
                        re.lastIndex = last += 1;
                        if (last >= line.length) return false;
                    }
                }
            };
            return {
                forEach: forEach
            };
        };
    }).call(Search.prototype);
    function addWordBoundary(needle, options) {
        function wordBoundary(c) {
            if (/\w/.test(c) || options.regExp) return "\\b";
            return "";
        }
        return wordBoundary(needle[0]) + needle + wordBoundary(needle[needle.length - 1]);
    }
    exports.Search = Search;
});
ace.define("ace/keyboard/hash_handler", [
    "require",
    "exports",
    "module",
    "ace/lib/keys",
    "ace/lib/useragent"
], function(acequire, exports, module1) {
    "use strict";
    var keyUtil = acequire("../lib/keys");
    var useragent = acequire("../lib/useragent");
    var KEY_MODS = keyUtil.KEY_MODS;
    function HashHandler(config, platform) {
        this.platform = platform || (useragent.isMac ? "mac" : "win");
        this.commands = {};
        this.commandKeyBinding = {};
        this.addCommands(config);
        this.$singleCommand = true;
    }
    function MultiHashHandler(config, platform) {
        HashHandler.call(this, config, platform);
        this.$singleCommand = false;
    }
    MultiHashHandler.prototype = HashHandler.prototype;
    (function() {
        this.addCommand = function(command) {
            if (this.commands[command.name]) this.removeCommand(command);
            this.commands[command.name] = command;
            if (command.bindKey) this._buildKeyHash(command);
        };
        this.removeCommand = function(command, keepCommand) {
            var name = command && (typeof command === 'string' ? command : command.name);
            command = this.commands[name];
            if (!keepCommand) delete this.commands[name];
            var ckb = this.commandKeyBinding;
            for(var keyId in ckb){
                var cmdGroup = ckb[keyId];
                if (cmdGroup == command) delete ckb[keyId];
                else if (Array.isArray(cmdGroup)) {
                    var i = cmdGroup.indexOf(command);
                    if (i != -1) {
                        cmdGroup.splice(i, 1);
                        if (cmdGroup.length == 1) ckb[keyId] = cmdGroup[0];
                    }
                }
            }
        };
        this.bindKey = function(key, command, position) {
            if (typeof key == "object" && key) {
                if (position == undefined) position = key.position;
                key = key[this.platform];
            }
            if (!key) return;
            if (typeof command == "function") return this.addCommand({
                exec: command,
                bindKey: key,
                name: command.name || key
            });
            key.split("|").forEach(function(keyPart) {
                var chain = "";
                if (keyPart.indexOf(" ") != -1) {
                    var parts = keyPart.split(/\s+/);
                    keyPart = parts.pop();
                    parts.forEach(function(keyPart) {
                        var binding = this.parseKeys(keyPart);
                        var id = KEY_MODS[binding.hashId] + binding.key;
                        chain += (chain ? " " : "") + id;
                        this._addCommandToBinding(chain, "chainKeys");
                    }, this);
                    chain += " ";
                }
                var binding = this.parseKeys(keyPart);
                var id = KEY_MODS[binding.hashId] + binding.key;
                this._addCommandToBinding(chain + id, command, position);
            }, this);
        };
        function getPosition(command) {
            return typeof command == "object" && command.bindKey && command.bindKey.position || (command.isDefault ? -100 : 0);
        }
        this._addCommandToBinding = function(keyId, command, position) {
            var ckb = this.commandKeyBinding, i;
            if (!command) delete ckb[keyId];
            else if (!ckb[keyId] || this.$singleCommand) ckb[keyId] = command;
            else {
                if (!Array.isArray(ckb[keyId])) ckb[keyId] = [
                    ckb[keyId]
                ];
                else if ((i = ckb[keyId].indexOf(command)) != -1) ckb[keyId].splice(i, 1);
                if (typeof position != "number") position = getPosition(command);
                var commands = ckb[keyId];
                for(i = 0; i < commands.length; i++){
                    var other = commands[i];
                    var otherPos = getPosition(other);
                    if (otherPos > position) break;
                }
                commands.splice(i, 0, command);
            }
        };
        this.addCommands = function(commands) {
            commands && Object.keys(commands).forEach(function(name) {
                var command = commands[name];
                if (!command) return;
                if (typeof command === "string") return this.bindKey(command, name);
                if (typeof command === "function") command = {
                    exec: command
                };
                if (typeof command !== "object") return;
                if (!command.name) command.name = name;
                this.addCommand(command);
            }, this);
        };
        this.removeCommands = function(commands) {
            Object.keys(commands).forEach(function(name) {
                this.removeCommand(commands[name]);
            }, this);
        };
        this.bindKeys = function(keyList) {
            Object.keys(keyList).forEach(function(key) {
                this.bindKey(key, keyList[key]);
            }, this);
        };
        this._buildKeyHash = function(command) {
            this.bindKey(command.bindKey, command);
        };
        this.parseKeys = function(keys) {
            var parts = keys.toLowerCase().split(/[\-\+]([\-\+])?/).filter(function(x) {
                return x;
            });
            var key = parts.pop();
            var keyCode = keyUtil[key];
            if (keyUtil.FUNCTION_KEYS[keyCode]) key = keyUtil.FUNCTION_KEYS[keyCode].toLowerCase();
            else if (!parts.length) return {
                key: key,
                hashId: -1
            };
            else if (parts.length == 1 && parts[0] == "shift") return {
                key: key.toUpperCase(),
                hashId: -1
            };
            var hashId = 0;
            for(var i = parts.length; i--;){
                var modifier = keyUtil.KEY_MODS[parts[i]];
                if (modifier == null) {
                    if (typeof console != "undefined") console.error("invalid modifier " + parts[i] + " in " + keys);
                    return false;
                }
                hashId |= modifier;
            }
            return {
                key: key,
                hashId: hashId
            };
        };
        this.findKeyCommand = function findKeyCommand(hashId, keyString) {
            var key = KEY_MODS[hashId] + keyString;
            return this.commandKeyBinding[key];
        };
        this.handleKeyboard = function(data, hashId, keyString, keyCode) {
            if (keyCode < 0) return;
            var key = KEY_MODS[hashId] + keyString;
            var command = this.commandKeyBinding[key];
            if (data.$keyChain) {
                data.$keyChain += " " + key;
                command = this.commandKeyBinding[data.$keyChain] || command;
            }
            if (command) {
                if (command == "chainKeys" || command[command.length - 1] == "chainKeys") {
                    data.$keyChain = data.$keyChain || key;
                    return {
                        command: "null"
                    };
                }
            }
            if (data.$keyChain) {
                if ((!hashId || hashId == 4) && keyString.length == 1) data.$keyChain = data.$keyChain.slice(0, -key.length - 1); // wait for input
                else if (hashId == -1 || keyCode > 0) data.$keyChain = ""; // reset keyChain
            }
            return {
                command: command
            };
        };
        this.getStatusText = function(editor, data) {
            return data.$keyChain || "";
        };
    }).call(HashHandler.prototype);
    exports.HashHandler = HashHandler;
    exports.MultiHashHandler = MultiHashHandler;
});
ace.define("ace/commands/command_manager", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/keyboard/hash_handler",
    "ace/lib/event_emitter"
], function(acequire, exports, module1) {
    "use strict";
    var oop = acequire("../lib/oop");
    var MultiHashHandler = acequire("../keyboard/hash_handler").MultiHashHandler;
    var EventEmitter = acequire("../lib/event_emitter").EventEmitter;
    var CommandManager = function(platform, commands) {
        MultiHashHandler.call(this, commands, platform);
        this.byName = this.commands;
        this.setDefaultHandler("exec", function(e) {
            return e.command.exec(e.editor, e.args || {});
        });
    };
    oop.inherits(CommandManager, MultiHashHandler);
    (function() {
        oop.implement(this, EventEmitter);
        this.exec = function(command, editor, args) {
            if (Array.isArray(command)) {
                for(var i = command.length; i--;){
                    if (this.exec(command[i], editor, args)) return true;
                }
                return false;
            }
            if (typeof command === "string") command = this.commands[command];
            if (!command) return false;
            if (editor && editor.$readOnly && !command.readOnly) return false;
            if (command.isAvailable && !command.isAvailable(editor)) return false;
            var e = {
                editor: editor,
                command: command,
                args: args
            };
            e.returnValue = this._emit("exec", e);
            this._signal("afterExec", e);
            return e.returnValue === false ? false : true;
        };
        this.toggleRecording = function(editor) {
            if (this.$inReplay) return;
            editor && editor._emit("changeStatus");
            if (this.recording) {
                this.macro.pop();
                this.removeEventListener("exec", this.$addCommandToMacro);
                if (!this.macro.length) this.macro = this.oldMacro;
                return this.recording = false;
            }
            if (!this.$addCommandToMacro) this.$addCommandToMacro = (function(e) {
                this.macro.push([
                    e.command,
                    e.args
                ]);
            }).bind(this);
            this.oldMacro = this.macro;
            this.macro = [];
            this.on("exec", this.$addCommandToMacro);
            return this.recording = true;
        };
        this.replay = function(editor) {
            if (this.$inReplay || !this.macro) return;
            if (this.recording) return this.toggleRecording(editor);
            try {
                this.$inReplay = true;
                this.macro.forEach(function(x) {
                    if (typeof x == "string") this.exec(x, editor);
                    else this.exec(x[0], editor, x[1]);
                }, this);
            } finally{
                this.$inReplay = false;
            }
        };
        this.trimMacro = function(m) {
            return m.map(function(x) {
                if (typeof x[0] != "string") x[0] = x[0].name;
                if (!x[1]) x = x[0];
                return x;
            });
        };
    }).call(CommandManager.prototype);
    exports.CommandManager = CommandManager;
});
ace.define("ace/commands/default_commands", [
    "require",
    "exports",
    "module",
    "ace/lib/lang",
    "ace/config",
    "ace/range"
], function(acequire, exports, module1) {
    "use strict";
    var lang = acequire("../lib/lang");
    var config = acequire("../config");
    var Range = acequire("../range").Range;
    function bindKey(win, mac) {
        return {
            win: win,
            mac: mac
        };
    }
    exports.commands = [
        {
            name: "showSettingsMenu",
            bindKey: bindKey("Ctrl-,", "Command-,"),
            exec: function(editor) {
                config.loadModule("ace/ext/settings_menu", function(module1) {
                    module1.init(editor);
                    editor.showSettingsMenu();
                });
            },
            readOnly: true
        },
        {
            name: "goToNextError",
            bindKey: bindKey("Alt-E", "F4"),
            exec: function(editor) {
                config.loadModule("ace/ext/error_marker", function(module1) {
                    module1.showErrorMarker(editor, 1);
                });
            },
            scrollIntoView: "animate",
            readOnly: true
        },
        {
            name: "goToPreviousError",
            bindKey: bindKey("Alt-Shift-E", "Shift-F4"),
            exec: function(editor) {
                config.loadModule("ace/ext/error_marker", function(module1) {
                    module1.showErrorMarker(editor, -1);
                });
            },
            scrollIntoView: "animate",
            readOnly: true
        },
        {
            name: "selectall",
            bindKey: bindKey("Ctrl-A", "Command-A"),
            exec: function(editor) {
                editor.selectAll();
            },
            readOnly: true
        },
        {
            name: "centerselection",
            bindKey: bindKey(null, "Ctrl-L"),
            exec: function(editor) {
                editor.centerSelection();
            },
            readOnly: true
        },
        {
            name: "gotoline",
            bindKey: bindKey("Ctrl-L", "Command-L"),
            exec: function(editor) {
                var line = parseInt(prompt("Enter line number:"), 10);
                if (!isNaN(line)) editor.gotoLine(line);
            },
            readOnly: true
        },
        {
            name: "fold",
            bindKey: bindKey("Alt-L|Ctrl-F1", "Command-Alt-L|Command-F1"),
            exec: function(editor) {
                editor.session.toggleFold(false);
            },
            multiSelectAction: "forEach",
            scrollIntoView: "center",
            readOnly: true
        },
        {
            name: "unfold",
            bindKey: bindKey("Alt-Shift-L|Ctrl-Shift-F1", "Command-Alt-Shift-L|Command-Shift-F1"),
            exec: function(editor) {
                editor.session.toggleFold(true);
            },
            multiSelectAction: "forEach",
            scrollIntoView: "center",
            readOnly: true
        },
        {
            name: "toggleFoldWidget",
            bindKey: bindKey("F2", "F2"),
            exec: function(editor) {
                editor.session.toggleFoldWidget();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "center",
            readOnly: true
        },
        {
            name: "toggleParentFoldWidget",
            bindKey: bindKey("Alt-F2", "Alt-F2"),
            exec: function(editor) {
                editor.session.toggleFoldWidget(true);
            },
            multiSelectAction: "forEach",
            scrollIntoView: "center",
            readOnly: true
        },
        {
            name: "foldall",
            bindKey: bindKey(null, "Ctrl-Command-Option-0"),
            exec: function(editor) {
                editor.session.foldAll();
            },
            scrollIntoView: "center",
            readOnly: true
        },
        {
            name: "foldOther",
            bindKey: bindKey("Alt-0", "Command-Option-0"),
            exec: function(editor) {
                editor.session.foldAll();
                editor.session.unfold(editor.selection.getAllRanges());
            },
            scrollIntoView: "center",
            readOnly: true
        },
        {
            name: "unfoldall",
            bindKey: bindKey("Alt-Shift-0", "Command-Option-Shift-0"),
            exec: function(editor) {
                editor.session.unfold();
            },
            scrollIntoView: "center",
            readOnly: true
        },
        {
            name: "findnext",
            bindKey: bindKey("Ctrl-K", "Command-G"),
            exec: function(editor) {
                editor.findNext();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "center",
            readOnly: true
        },
        {
            name: "findprevious",
            bindKey: bindKey("Ctrl-Shift-K", "Command-Shift-G"),
            exec: function(editor) {
                editor.findPrevious();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "center",
            readOnly: true
        },
        {
            name: "selectOrFindNext",
            bindKey: bindKey("Alt-K", "Ctrl-G"),
            exec: function(editor) {
                if (editor.selection.isEmpty()) editor.selection.selectWord();
                else editor.findNext();
            },
            readOnly: true
        },
        {
            name: "selectOrFindPrevious",
            bindKey: bindKey("Alt-Shift-K", "Ctrl-Shift-G"),
            exec: function(editor) {
                if (editor.selection.isEmpty()) editor.selection.selectWord();
                else editor.findPrevious();
            },
            readOnly: true
        },
        {
            name: "find",
            bindKey: bindKey("Ctrl-F", "Command-F"),
            exec: function(editor) {
                config.loadModule("ace/ext/searchbox", function(e) {
                    e.Search(editor);
                });
            },
            readOnly: true
        },
        {
            name: "overwrite",
            bindKey: "Insert",
            exec: function(editor) {
                editor.toggleOverwrite();
            },
            readOnly: true
        },
        {
            name: "selecttostart",
            bindKey: bindKey("Ctrl-Shift-Home", "Command-Shift-Home|Command-Shift-Up"),
            exec: function(editor) {
                editor.getSelection().selectFileStart();
            },
            multiSelectAction: "forEach",
            readOnly: true,
            scrollIntoView: "animate",
            aceCommandGroup: "fileJump"
        },
        {
            name: "gotostart",
            bindKey: bindKey("Ctrl-Home", "Command-Home|Command-Up"),
            exec: function(editor) {
                editor.navigateFileStart();
            },
            multiSelectAction: "forEach",
            readOnly: true,
            scrollIntoView: "animate",
            aceCommandGroup: "fileJump"
        },
        {
            name: "selectup",
            bindKey: bindKey("Shift-Up", "Shift-Up|Ctrl-Shift-P"),
            exec: function(editor) {
                editor.getSelection().selectUp();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "golineup",
            bindKey: bindKey("Up", "Up|Ctrl-P"),
            exec: function(editor, args) {
                editor.navigateUp(args.times);
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "selecttoend",
            bindKey: bindKey("Ctrl-Shift-End", "Command-Shift-End|Command-Shift-Down"),
            exec: function(editor) {
                editor.getSelection().selectFileEnd();
            },
            multiSelectAction: "forEach",
            readOnly: true,
            scrollIntoView: "animate",
            aceCommandGroup: "fileJump"
        },
        {
            name: "gotoend",
            bindKey: bindKey("Ctrl-End", "Command-End|Command-Down"),
            exec: function(editor) {
                editor.navigateFileEnd();
            },
            multiSelectAction: "forEach",
            readOnly: true,
            scrollIntoView: "animate",
            aceCommandGroup: "fileJump"
        },
        {
            name: "selectdown",
            bindKey: bindKey("Shift-Down", "Shift-Down|Ctrl-Shift-N"),
            exec: function(editor) {
                editor.getSelection().selectDown();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "golinedown",
            bindKey: bindKey("Down", "Down|Ctrl-N"),
            exec: function(editor, args) {
                editor.navigateDown(args.times);
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "selectwordleft",
            bindKey: bindKey("Ctrl-Shift-Left", "Option-Shift-Left"),
            exec: function(editor) {
                editor.getSelection().selectWordLeft();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "gotowordleft",
            bindKey: bindKey("Ctrl-Left", "Option-Left"),
            exec: function(editor) {
                editor.navigateWordLeft();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "selecttolinestart",
            bindKey: bindKey("Alt-Shift-Left", "Command-Shift-Left|Ctrl-Shift-A"),
            exec: function(editor) {
                editor.getSelection().selectLineStart();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "gotolinestart",
            bindKey: bindKey("Alt-Left|Home", "Command-Left|Home|Ctrl-A"),
            exec: function(editor) {
                editor.navigateLineStart();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "selectleft",
            bindKey: bindKey("Shift-Left", "Shift-Left|Ctrl-Shift-B"),
            exec: function(editor) {
                editor.getSelection().selectLeft();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "gotoleft",
            bindKey: bindKey("Left", "Left|Ctrl-B"),
            exec: function(editor, args) {
                editor.navigateLeft(args.times);
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "selectwordright",
            bindKey: bindKey("Ctrl-Shift-Right", "Option-Shift-Right"),
            exec: function(editor) {
                editor.getSelection().selectWordRight();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "gotowordright",
            bindKey: bindKey("Ctrl-Right", "Option-Right"),
            exec: function(editor) {
                editor.navigateWordRight();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "selecttolineend",
            bindKey: bindKey("Alt-Shift-Right", "Command-Shift-Right|Shift-End|Ctrl-Shift-E"),
            exec: function(editor) {
                editor.getSelection().selectLineEnd();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "gotolineend",
            bindKey: bindKey("Alt-Right|End", "Command-Right|End|Ctrl-E"),
            exec: function(editor) {
                editor.navigateLineEnd();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "selectright",
            bindKey: bindKey("Shift-Right", "Shift-Right"),
            exec: function(editor) {
                editor.getSelection().selectRight();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "gotoright",
            bindKey: bindKey("Right", "Right|Ctrl-F"),
            exec: function(editor, args) {
                editor.navigateRight(args.times);
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "selectpagedown",
            bindKey: "Shift-PageDown",
            exec: function(editor) {
                editor.selectPageDown();
            },
            readOnly: true
        },
        {
            name: "pagedown",
            bindKey: bindKey(null, "Option-PageDown"),
            exec: function(editor) {
                editor.scrollPageDown();
            },
            readOnly: true
        },
        {
            name: "gotopagedown",
            bindKey: bindKey("PageDown", "PageDown|Ctrl-V"),
            exec: function(editor) {
                editor.gotoPageDown();
            },
            readOnly: true
        },
        {
            name: "selectpageup",
            bindKey: "Shift-PageUp",
            exec: function(editor) {
                editor.selectPageUp();
            },
            readOnly: true
        },
        {
            name: "pageup",
            bindKey: bindKey(null, "Option-PageUp"),
            exec: function(editor) {
                editor.scrollPageUp();
            },
            readOnly: true
        },
        {
            name: "gotopageup",
            bindKey: "PageUp",
            exec: function(editor) {
                editor.gotoPageUp();
            },
            readOnly: true
        },
        {
            name: "scrollup",
            bindKey: bindKey("Ctrl-Up", null),
            exec: function(e) {
                e.renderer.scrollBy(0, -2 * e.renderer.layerConfig.lineHeight);
            },
            readOnly: true
        },
        {
            name: "scrolldown",
            bindKey: bindKey("Ctrl-Down", null),
            exec: function(e) {
                e.renderer.scrollBy(0, 2 * e.renderer.layerConfig.lineHeight);
            },
            readOnly: true
        },
        {
            name: "selectlinestart",
            bindKey: "Shift-Home",
            exec: function(editor) {
                editor.getSelection().selectLineStart();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "selectlineend",
            bindKey: "Shift-End",
            exec: function(editor) {
                editor.getSelection().selectLineEnd();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "togglerecording",
            bindKey: bindKey("Ctrl-Alt-E", "Command-Option-E"),
            exec: function(editor) {
                editor.commands.toggleRecording(editor);
            },
            readOnly: true
        },
        {
            name: "replaymacro",
            bindKey: bindKey("Ctrl-Shift-E", "Command-Shift-E"),
            exec: function(editor) {
                editor.commands.replay(editor);
            },
            readOnly: true
        },
        {
            name: "jumptomatching",
            bindKey: bindKey("Ctrl-P", "Ctrl-P"),
            exec: function(editor) {
                editor.jumpToMatching();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "animate",
            readOnly: true
        },
        {
            name: "selecttomatching",
            bindKey: bindKey("Ctrl-Shift-P", "Ctrl-Shift-P"),
            exec: function(editor) {
                editor.jumpToMatching(true);
            },
            multiSelectAction: "forEach",
            scrollIntoView: "animate",
            readOnly: true
        },
        {
            name: "expandToMatching",
            bindKey: bindKey("Ctrl-Shift-M", "Ctrl-Shift-M"),
            exec: function(editor) {
                editor.jumpToMatching(true, true);
            },
            multiSelectAction: "forEach",
            scrollIntoView: "animate",
            readOnly: true
        },
        {
            name: "passKeysToBrowser",
            bindKey: bindKey(null, null),
            exec: function() {},
            passEvent: true,
            readOnly: true
        },
        {
            name: "copy",
            exec: function(editor) {},
            readOnly: true
        },
        {
            name: "cut",
            exec: function(editor) {
                var range = editor.getSelectionRange();
                editor._emit("cut", range);
                if (!editor.selection.isEmpty()) {
                    editor.session.remove(range);
                    editor.clearSelection();
                }
            },
            scrollIntoView: "cursor",
            multiSelectAction: "forEach"
        },
        {
            name: "paste",
            exec: function(editor, args) {
                editor.$handlePaste(args);
            },
            scrollIntoView: "cursor"
        },
        {
            name: "removeline",
            bindKey: bindKey("Ctrl-D", "Command-D"),
            exec: function(editor) {
                editor.removeLines();
            },
            scrollIntoView: "cursor",
            multiSelectAction: "forEachLine"
        },
        {
            name: "duplicateSelection",
            bindKey: bindKey("Ctrl-Shift-D", "Command-Shift-D"),
            exec: function(editor) {
                editor.duplicateSelection();
            },
            scrollIntoView: "cursor",
            multiSelectAction: "forEach"
        },
        {
            name: "sortlines",
            bindKey: bindKey("Ctrl-Alt-S", "Command-Alt-S"),
            exec: function(editor) {
                editor.sortLines();
            },
            scrollIntoView: "selection",
            multiSelectAction: "forEachLine"
        },
        {
            name: "togglecomment",
            bindKey: bindKey("Ctrl-/", "Command-/"),
            exec: function(editor) {
                editor.toggleCommentLines();
            },
            multiSelectAction: "forEachLine",
            scrollIntoView: "selectionPart"
        },
        {
            name: "toggleBlockComment",
            bindKey: bindKey("Ctrl-Shift-/", "Command-Shift-/"),
            exec: function(editor) {
                editor.toggleBlockComment();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "selectionPart"
        },
        {
            name: "modifyNumberUp",
            bindKey: bindKey("Ctrl-Shift-Up", "Alt-Shift-Up"),
            exec: function(editor) {
                editor.modifyNumber(1);
            },
            scrollIntoView: "cursor",
            multiSelectAction: "forEach"
        },
        {
            name: "modifyNumberDown",
            bindKey: bindKey("Ctrl-Shift-Down", "Alt-Shift-Down"),
            exec: function(editor) {
                editor.modifyNumber(-1);
            },
            scrollIntoView: "cursor",
            multiSelectAction: "forEach"
        },
        {
            name: "replace",
            bindKey: bindKey("Ctrl-H", "Command-Option-F"),
            exec: function(editor) {
                config.loadModule("ace/ext/searchbox", function(e) {
                    e.Search(editor, true);
                });
            }
        },
        {
            name: "undo",
            bindKey: bindKey("Ctrl-Z", "Command-Z"),
            exec: function(editor) {
                editor.undo();
            }
        },
        {
            name: "redo",
            bindKey: bindKey("Ctrl-Shift-Z|Ctrl-Y", "Command-Shift-Z|Command-Y"),
            exec: function(editor) {
                editor.redo();
            }
        },
        {
            name: "copylinesup",
            bindKey: bindKey("Alt-Shift-Up", "Command-Option-Up"),
            exec: function(editor) {
                editor.copyLinesUp();
            },
            scrollIntoView: "cursor"
        },
        {
            name: "movelinesup",
            bindKey: bindKey("Alt-Up", "Option-Up"),
            exec: function(editor) {
                editor.moveLinesUp();
            },
            scrollIntoView: "cursor"
        },
        {
            name: "copylinesdown",
            bindKey: bindKey("Alt-Shift-Down", "Command-Option-Down"),
            exec: function(editor) {
                editor.copyLinesDown();
            },
            scrollIntoView: "cursor"
        },
        {
            name: "movelinesdown",
            bindKey: bindKey("Alt-Down", "Option-Down"),
            exec: function(editor) {
                editor.moveLinesDown();
            },
            scrollIntoView: "cursor"
        },
        {
            name: "del",
            bindKey: bindKey("Delete", "Delete|Ctrl-D|Shift-Delete"),
            exec: function(editor) {
                editor.remove("right");
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor"
        },
        {
            name: "backspace",
            bindKey: bindKey("Shift-Backspace|Backspace", "Ctrl-Backspace|Shift-Backspace|Backspace|Ctrl-H"),
            exec: function(editor) {
                editor.remove("left");
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor"
        },
        {
            name: "cut_or_delete",
            bindKey: bindKey("Shift-Delete", null),
            exec: function(editor) {
                if (editor.selection.isEmpty()) editor.remove("left");
                else return false;
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor"
        },
        {
            name: "removetolinestart",
            bindKey: bindKey("Alt-Backspace", "Command-Backspace"),
            exec: function(editor) {
                editor.removeToLineStart();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor"
        },
        {
            name: "removetolineend",
            bindKey: bindKey("Alt-Delete", "Ctrl-K|Command-Delete"),
            exec: function(editor) {
                editor.removeToLineEnd();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor"
        },
        {
            name: "removetolinestarthard",
            bindKey: bindKey("Ctrl-Shift-Backspace", null),
            exec: function(editor) {
                var range = editor.selection.getRange();
                range.start.column = 0;
                editor.session.remove(range);
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor"
        },
        {
            name: "removetolineendhard",
            bindKey: bindKey("Ctrl-Shift-Delete", null),
            exec: function(editor) {
                var range = editor.selection.getRange();
                range.end.column = Number.MAX_VALUE;
                editor.session.remove(range);
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor"
        },
        {
            name: "removewordleft",
            bindKey: bindKey("Ctrl-Backspace", "Alt-Backspace|Ctrl-Alt-Backspace"),
            exec: function(editor) {
                editor.removeWordLeft();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor"
        },
        {
            name: "removewordright",
            bindKey: bindKey("Ctrl-Delete", "Alt-Delete"),
            exec: function(editor) {
                editor.removeWordRight();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor"
        },
        {
            name: "outdent",
            bindKey: bindKey("Shift-Tab", "Shift-Tab"),
            exec: function(editor) {
                editor.blockOutdent();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "selectionPart"
        },
        {
            name: "indent",
            bindKey: bindKey("Tab", "Tab"),
            exec: function(editor) {
                editor.indent();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "selectionPart"
        },
        {
            name: "blockoutdent",
            bindKey: bindKey("Ctrl-[", "Ctrl-["),
            exec: function(editor) {
                editor.blockOutdent();
            },
            multiSelectAction: "forEachLine",
            scrollIntoView: "selectionPart"
        },
        {
            name: "blockindent",
            bindKey: bindKey("Ctrl-]", "Ctrl-]"),
            exec: function(editor) {
                editor.blockIndent();
            },
            multiSelectAction: "forEachLine",
            scrollIntoView: "selectionPart"
        },
        {
            name: "insertstring",
            exec: function(editor, str) {
                editor.insert(str);
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor"
        },
        {
            name: "inserttext",
            exec: function(editor, args) {
                editor.insert(lang.stringRepeat(args.text || "", args.times || 1));
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor"
        },
        {
            name: "splitline",
            bindKey: bindKey(null, "Ctrl-O"),
            exec: function(editor) {
                editor.splitLine();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor"
        },
        {
            name: "transposeletters",
            bindKey: bindKey("Alt-Shift-X", "Ctrl-T"),
            exec: function(editor) {
                editor.transposeLetters();
            },
            multiSelectAction: function(editor) {
                editor.transposeSelections(1);
            },
            scrollIntoView: "cursor"
        },
        {
            name: "touppercase",
            bindKey: bindKey("Ctrl-U", "Ctrl-U"),
            exec: function(editor) {
                editor.toUpperCase();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor"
        },
        {
            name: "tolowercase",
            bindKey: bindKey("Ctrl-Shift-U", "Ctrl-Shift-U"),
            exec: function(editor) {
                editor.toLowerCase();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor"
        },
        {
            name: "expandtoline",
            bindKey: bindKey("Ctrl-Shift-L", "Command-Shift-L"),
            exec: function(editor) {
                var range = editor.selection.getRange();
                range.start.column = range.end.column = 0;
                range.end.row++;
                editor.selection.setRange(range, false);
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "joinlines",
            bindKey: bindKey(null, null),
            exec: function(editor) {
                var isBackwards = editor.selection.isBackwards();
                var selectionStart = isBackwards ? editor.selection.getSelectionLead() : editor.selection.getSelectionAnchor();
                var selectionEnd = isBackwards ? editor.selection.getSelectionAnchor() : editor.selection.getSelectionLead();
                var firstLineEndCol = editor.session.doc.getLine(selectionStart.row).length;
                var selectedText = editor.session.doc.getTextRange(editor.selection.getRange());
                var selectedCount = selectedText.replace(/\n\s*/, " ").length;
                var insertLine = editor.session.doc.getLine(selectionStart.row);
                for(var i = selectionStart.row + 1; i <= selectionEnd.row + 1; i++){
                    var curLine = lang.stringTrimLeft(lang.stringTrimRight(editor.session.doc.getLine(i)));
                    if (curLine.length !== 0) curLine = " " + curLine;
                    insertLine += curLine;
                }
                if (selectionEnd.row + 1 < editor.session.doc.getLength() - 1) insertLine += editor.session.doc.getNewLineCharacter();
                editor.clearSelection();
                editor.session.doc.replace(new Range(selectionStart.row, 0, selectionEnd.row + 2, 0), insertLine);
                if (selectedCount > 0) {
                    editor.selection.moveCursorTo(selectionStart.row, selectionStart.column);
                    editor.selection.selectTo(selectionStart.row, selectionStart.column + selectedCount);
                } else {
                    firstLineEndCol = editor.session.doc.getLine(selectionStart.row).length > firstLineEndCol ? firstLineEndCol + 1 : firstLineEndCol;
                    editor.selection.moveCursorTo(selectionStart.row, firstLineEndCol);
                }
            },
            multiSelectAction: "forEach",
            readOnly: true
        },
        {
            name: "invertSelection",
            bindKey: bindKey(null, null),
            exec: function(editor) {
                var endRow = editor.session.doc.getLength() - 1;
                var endCol = editor.session.doc.getLine(endRow).length;
                var ranges = editor.selection.rangeList.ranges;
                var newRanges = [];
                if (ranges.length < 1) ranges = [
                    editor.selection.getRange()
                ];
                for(var i = 0; i < ranges.length; i++){
                    if (i == ranges.length - 1) {
                        if (!(ranges[i].end.row === endRow && ranges[i].end.column === endCol)) newRanges.push(new Range(ranges[i].end.row, ranges[i].end.column, endRow, endCol));
                    }
                    if (i === 0) {
                        if (!(ranges[i].start.row === 0 && ranges[i].start.column === 0)) newRanges.push(new Range(0, 0, ranges[i].start.row, ranges[i].start.column));
                    } else newRanges.push(new Range(ranges[i - 1].end.row, ranges[i - 1].end.column, ranges[i].start.row, ranges[i].start.column));
                }
                editor.exitMultiSelectMode();
                editor.clearSelection();
                for(var i = 0; i < newRanges.length; i++)editor.selection.addRange(newRanges[i], false);
            },
            readOnly: true,
            scrollIntoView: "none"
        }
    ];
});
ace.define("ace/editor", [
    "require",
    "exports",
    "module",
    "ace/lib/fixoldbrowsers",
    "ace/lib/oop",
    "ace/lib/dom",
    "ace/lib/lang",
    "ace/lib/useragent",
    "ace/keyboard/textinput",
    "ace/mouse/mouse_handler",
    "ace/mouse/fold_handler",
    "ace/keyboard/keybinding",
    "ace/edit_session",
    "ace/search",
    "ace/range",
    "ace/lib/event_emitter",
    "ace/commands/command_manager",
    "ace/commands/default_commands",
    "ace/config",
    "ace/token_iterator"
], function(acequire, exports, module1) {
    "use strict";
    acequire("./lib/fixoldbrowsers");
    var oop = acequire("./lib/oop");
    var dom = acequire("./lib/dom");
    var lang = acequire("./lib/lang");
    var useragent = acequire("./lib/useragent");
    var TextInput = acequire("./keyboard/textinput").TextInput;
    var MouseHandler = acequire("./mouse/mouse_handler").MouseHandler;
    var FoldHandler = acequire("./mouse/fold_handler").FoldHandler;
    var KeyBinding = acequire("./keyboard/keybinding").KeyBinding;
    var EditSession = acequire("./edit_session").EditSession;
    var Search = acequire("./search").Search;
    var Range = acequire("./range").Range;
    var EventEmitter = acequire("./lib/event_emitter").EventEmitter;
    var CommandManager = acequire("./commands/command_manager").CommandManager;
    var defaultCommands = acequire("./commands/default_commands").commands;
    var config = acequire("./config");
    var TokenIterator = acequire("./token_iterator").TokenIterator;
    var Editor = function(renderer, session) {
        var container = renderer.getContainerElement();
        this.container = container;
        this.renderer = renderer;
        this.id = "editor" + ++Editor.$uid;
        this.commands = new CommandManager(useragent.isMac ? "mac" : "win", defaultCommands);
        if (typeof document == "object") {
            this.textInput = new TextInput(renderer.getTextAreaContainer(), this);
            this.renderer.textarea = this.textInput.getElement();
            this.$mouseHandler = new MouseHandler(this);
            new FoldHandler(this);
        }
        this.keyBinding = new KeyBinding(this);
        this.$blockScrolling = 0;
        this.$search = new Search().set({
            wrap: true
        });
        this.$historyTracker = this.$historyTracker.bind(this);
        this.commands.on("exec", this.$historyTracker);
        this.$initOperationListeners();
        this._$emitInputEvent = lang.delayedCall((function() {
            this._signal("input", {});
            if (this.session && this.session.bgTokenizer) this.session.bgTokenizer.scheduleStart();
        }).bind(this));
        this.on("change", function(_, _self) {
            _self._$emitInputEvent.schedule(31);
        });
        this.setSession(session || new EditSession(""));
        config.resetOptions(this);
        config._signal("editor", this);
    };
    Editor.$uid = 0;
    (function() {
        oop.implement(this, EventEmitter);
        this.$initOperationListeners = function() {
            function last(a) {
                return a[a.length - 1];
            }
            this.selections = [];
            this.commands.on("exec", this.startOperation.bind(this), true);
            this.commands.on("afterExec", this.endOperation.bind(this), true);
            this.$opResetTimer = lang.delayedCall(this.endOperation.bind(this));
            this.on("change", (function() {
                this.curOp || this.startOperation();
                this.curOp.docChanged = true;
            }).bind(this), true);
            this.on("changeSelection", (function() {
                this.curOp || this.startOperation();
                this.curOp.selectionChanged = true;
            }).bind(this), true);
        };
        this.curOp = null;
        this.prevOp = {};
        this.startOperation = function(commadEvent) {
            if (this.curOp) {
                if (!commadEvent || this.curOp.command) return;
                this.prevOp = this.curOp;
            }
            if (!commadEvent) {
                this.previousCommand = null;
                commadEvent = {};
            }
            this.$opResetTimer.schedule();
            this.curOp = {
                command: commadEvent.command || {},
                args: commadEvent.args,
                scrollTop: this.renderer.scrollTop
            };
            if (this.curOp.command.name && this.curOp.command.scrollIntoView !== undefined) this.$blockScrolling++;
        };
        this.endOperation = function(e) {
            if (this.curOp) {
                if (e && e.returnValue === false) return this.curOp = null;
                this._signal("beforeEndOperation");
                var command = this.curOp.command;
                if (command.name && this.$blockScrolling > 0) this.$blockScrolling--;
                var scrollIntoView = command && command.scrollIntoView;
                if (scrollIntoView) {
                    switch(scrollIntoView){
                        case "center-animate":
                            scrollIntoView = "animate";
                        case "center":
                            this.renderer.scrollCursorIntoView(null, 0.5);
                            break;
                        case "animate":
                        case "cursor":
                            this.renderer.scrollCursorIntoView();
                            break;
                        case "selectionPart":
                            var range = this.selection.getRange();
                            var config = this.renderer.layerConfig;
                            if (range.start.row >= config.lastRow || range.end.row <= config.firstRow) this.renderer.scrollSelectionIntoView(this.selection.anchor, this.selection.lead);
                            break;
                        default:
                            break;
                    }
                    if (scrollIntoView == "animate") this.renderer.animateScrolling(this.curOp.scrollTop);
                }
                this.prevOp = this.curOp;
                this.curOp = null;
            }
        };
        this.$mergeableCommands = [
            "backspace",
            "del",
            "insertstring"
        ];
        this.$historyTracker = function(e) {
            if (!this.$mergeUndoDeltas) return;
            var prev = this.prevOp;
            var mergeableCommands = this.$mergeableCommands;
            var shouldMerge = prev.command && e.command.name == prev.command.name;
            if (e.command.name == "insertstring") {
                var text = e.args;
                if (this.mergeNextCommand === undefined) this.mergeNextCommand = true;
                shouldMerge = shouldMerge && this.mergeNextCommand // previous command allows to coalesce with
                 && (!/\s/.test(text) || /\s/.test(prev.args)); // previous insertion was of same type
                this.mergeNextCommand = true;
            } else shouldMerge = shouldMerge && mergeableCommands.indexOf(e.command.name) !== -1; // the command is mergeable
            if (this.$mergeUndoDeltas != "always" && Date.now() - this.sequenceStartTime > 2000) shouldMerge = false; // the sequence is too long
            if (shouldMerge) this.session.mergeUndoDeltas = true;
            else if (mergeableCommands.indexOf(e.command.name) !== -1) this.sequenceStartTime = Date.now();
        };
        this.setKeyboardHandler = function(keyboardHandler, cb) {
            if (keyboardHandler && typeof keyboardHandler === "string") {
                this.$keybindingId = keyboardHandler;
                var _self = this;
                config.loadModule([
                    "keybinding",
                    keyboardHandler
                ], function(module1) {
                    if (_self.$keybindingId == keyboardHandler) _self.keyBinding.setKeyboardHandler(module1 && module1.handler);
                    cb && cb();
                });
            } else {
                this.$keybindingId = null;
                this.keyBinding.setKeyboardHandler(keyboardHandler);
                cb && cb();
            }
        };
        this.getKeyboardHandler = function() {
            return this.keyBinding.getKeyboardHandler();
        };
        this.setSession = function(session) {
            if (this.session == session) return;
            if (this.curOp) this.endOperation();
            this.curOp = {};
            var oldSession = this.session;
            if (oldSession) {
                this.session.off("change", this.$onDocumentChange);
                this.session.off("changeMode", this.$onChangeMode);
                this.session.off("tokenizerUpdate", this.$onTokenizerUpdate);
                this.session.off("changeTabSize", this.$onChangeTabSize);
                this.session.off("changeWrapLimit", this.$onChangeWrapLimit);
                this.session.off("changeWrapMode", this.$onChangeWrapMode);
                this.session.off("changeFold", this.$onChangeFold);
                this.session.off("changeFrontMarker", this.$onChangeFrontMarker);
                this.session.off("changeBackMarker", this.$onChangeBackMarker);
                this.session.off("changeBreakpoint", this.$onChangeBreakpoint);
                this.session.off("changeAnnotation", this.$onChangeAnnotation);
                this.session.off("changeOverwrite", this.$onCursorChange);
                this.session.off("changeScrollTop", this.$onScrollTopChange);
                this.session.off("changeScrollLeft", this.$onScrollLeftChange);
                var selection = this.session.getSelection();
                selection.off("changeCursor", this.$onCursorChange);
                selection.off("changeSelection", this.$onSelectionChange);
            }
            this.session = session;
            if (session) {
                this.$onDocumentChange = this.onDocumentChange.bind(this);
                session.on("change", this.$onDocumentChange);
                this.renderer.setSession(session);
                this.$onChangeMode = this.onChangeMode.bind(this);
                session.on("changeMode", this.$onChangeMode);
                this.$onTokenizerUpdate = this.onTokenizerUpdate.bind(this);
                session.on("tokenizerUpdate", this.$onTokenizerUpdate);
                this.$onChangeTabSize = this.renderer.onChangeTabSize.bind(this.renderer);
                session.on("changeTabSize", this.$onChangeTabSize);
                this.$onChangeWrapLimit = this.onChangeWrapLimit.bind(this);
                session.on("changeWrapLimit", this.$onChangeWrapLimit);
                this.$onChangeWrapMode = this.onChangeWrapMode.bind(this);
                session.on("changeWrapMode", this.$onChangeWrapMode);
                this.$onChangeFold = this.onChangeFold.bind(this);
                session.on("changeFold", this.$onChangeFold);
                this.$onChangeFrontMarker = this.onChangeFrontMarker.bind(this);
                this.session.on("changeFrontMarker", this.$onChangeFrontMarker);
                this.$onChangeBackMarker = this.onChangeBackMarker.bind(this);
                this.session.on("changeBackMarker", this.$onChangeBackMarker);
                this.$onChangeBreakpoint = this.onChangeBreakpoint.bind(this);
                this.session.on("changeBreakpoint", this.$onChangeBreakpoint);
                this.$onChangeAnnotation = this.onChangeAnnotation.bind(this);
                this.session.on("changeAnnotation", this.$onChangeAnnotation);
                this.$onCursorChange = this.onCursorChange.bind(this);
                this.session.on("changeOverwrite", this.$onCursorChange);
                this.$onScrollTopChange = this.onScrollTopChange.bind(this);
                this.session.on("changeScrollTop", this.$onScrollTopChange);
                this.$onScrollLeftChange = this.onScrollLeftChange.bind(this);
                this.session.on("changeScrollLeft", this.$onScrollLeftChange);
                this.selection = session.getSelection();
                this.selection.on("changeCursor", this.$onCursorChange);
                this.$onSelectionChange = this.onSelectionChange.bind(this);
                this.selection.on("changeSelection", this.$onSelectionChange);
                this.onChangeMode();
                this.$blockScrolling += 1;
                this.onCursorChange();
                this.$blockScrolling -= 1;
                this.onScrollTopChange();
                this.onScrollLeftChange();
                this.onSelectionChange();
                this.onChangeFrontMarker();
                this.onChangeBackMarker();
                this.onChangeBreakpoint();
                this.onChangeAnnotation();
                this.session.getUseWrapMode() && this.renderer.adjustWrapLimit();
                this.renderer.updateFull();
            } else {
                this.selection = null;
                this.renderer.setSession(session);
            }
            this._signal("changeSession", {
                session: session,
                oldSession: oldSession
            });
            this.curOp = null;
            oldSession && oldSession._signal("changeEditor", {
                oldEditor: this
            });
            session && session._signal("changeEditor", {
                editor: this
            });
            if (session && session.bgTokenizer) session.bgTokenizer.scheduleStart();
        };
        this.getSession = function() {
            return this.session;
        };
        this.setValue = function(val, cursorPos) {
            this.session.doc.setValue(val);
            if (!cursorPos) this.selectAll();
            else if (cursorPos == 1) this.navigateFileEnd();
            else if (cursorPos == -1) this.navigateFileStart();
            return val;
        };
        this.getValue = function() {
            return this.session.getValue();
        };
        this.getSelection = function() {
            return this.selection;
        };
        this.resize = function(force) {
            this.renderer.onResize(force);
        };
        this.setTheme = function(theme, cb) {
            this.renderer.setTheme(theme, cb);
        };
        this.getTheme = function() {
            return this.renderer.getTheme();
        };
        this.setStyle = function(style) {
            this.renderer.setStyle(style);
        };
        this.unsetStyle = function(style) {
            this.renderer.unsetStyle(style);
        };
        this.getFontSize = function() {
            return this.getOption("fontSize") || dom.computedStyle(this.container, "fontSize");
        };
        this.setFontSize = function(size) {
            this.setOption("fontSize", size);
        };
        this.$highlightBrackets = function() {
            if (this.session.$bracketHighlight) {
                this.session.removeMarker(this.session.$bracketHighlight);
                this.session.$bracketHighlight = null;
            }
            if (this.$highlightPending) return;
            var self = this;
            this.$highlightPending = true;
            setTimeout(function() {
                self.$highlightPending = false;
                var session = self.session;
                if (!session || !session.bgTokenizer) return;
                var pos = session.findMatchingBracket(self.getCursorPosition());
                if (pos) var range = new Range(pos.row, pos.column, pos.row, pos.column + 1);
                else if (session.$mode.getMatching) var range = session.$mode.getMatching(self.session);
                if (range) session.$bracketHighlight = session.addMarker(range, "ace_bracket", "text");
            }, 50);
        };
        this.$highlightTags = function() {
            if (this.$highlightTagPending) return;
            var self = this;
            this.$highlightTagPending = true;
            setTimeout(function() {
                self.$highlightTagPending = false;
                var session = self.session;
                if (!session || !session.bgTokenizer) return;
                var pos = self.getCursorPosition();
                var iterator = new TokenIterator(self.session, pos.row, pos.column);
                var token = iterator.getCurrentToken();
                if (!token || !/\b(?:tag-open|tag-name)/.test(token.type)) {
                    session.removeMarker(session.$tagHighlight);
                    session.$tagHighlight = null;
                    return;
                }
                if (token.type.indexOf("tag-open") != -1) {
                    token = iterator.stepForward();
                    if (!token) return;
                }
                var tag = token.value;
                var depth = 0;
                var prevToken = iterator.stepBackward();
                if (prevToken.value == '<') do {
                    prevToken = token;
                    token = iterator.stepForward();
                    if (token && token.value === tag && token.type.indexOf('tag-name') !== -1) {
                        if (prevToken.value === '<') depth++;
                        else if (prevToken.value === '</') depth--;
                    }
                }while (token && depth >= 0);
                else {
                    do {
                        token = prevToken;
                        prevToken = iterator.stepBackward();
                        if (token && token.value === tag && token.type.indexOf('tag-name') !== -1) {
                            if (prevToken.value === '<') depth++;
                            else if (prevToken.value === '</') depth--;
                        }
                    }while (prevToken && depth <= 0);
                    iterator.stepForward();
                }
                if (!token) {
                    session.removeMarker(session.$tagHighlight);
                    session.$tagHighlight = null;
                    return;
                }
                var row = iterator.getCurrentTokenRow();
                var column = iterator.getCurrentTokenColumn();
                var range = new Range(row, column, row, column + token.value.length);
                var sbm = session.$backMarkers[session.$tagHighlight];
                if (session.$tagHighlight && sbm != undefined && range.compareRange(sbm.range) !== 0) {
                    session.removeMarker(session.$tagHighlight);
                    session.$tagHighlight = null;
                }
                if (range && !session.$tagHighlight) session.$tagHighlight = session.addMarker(range, "ace_bracket", "text");
            }, 50);
        };
        this.focus = function() {
            var _self = this;
            setTimeout(function() {
                _self.textInput.focus();
            });
            this.textInput.focus();
        };
        this.isFocused = function() {
            return this.textInput.isFocused();
        };
        this.blur = function() {
            this.textInput.blur();
        };
        this.onFocus = function(e) {
            if (this.$isFocused) return;
            this.$isFocused = true;
            this.renderer.showCursor();
            this.renderer.visualizeFocus();
            this._emit("focus", e);
        };
        this.onBlur = function(e) {
            if (!this.$isFocused) return;
            this.$isFocused = false;
            this.renderer.hideCursor();
            this.renderer.visualizeBlur();
            this._emit("blur", e);
        };
        this.$cursorChange = function() {
            this.renderer.updateCursor();
        };
        this.onDocumentChange = function(delta) {
            var wrap = this.session.$useWrapMode;
            var lastRow = delta.start.row == delta.end.row ? delta.end.row : Infinity;
            this.renderer.updateLines(delta.start.row, lastRow, wrap);
            this._signal("change", delta);
            this.$cursorChange();
            this.$updateHighlightActiveLine();
        };
        this.onTokenizerUpdate = function(e) {
            var rows = e.data;
            this.renderer.updateLines(rows.first, rows.last);
        };
        this.onScrollTopChange = function() {
            this.renderer.scrollToY(this.session.getScrollTop());
        };
        this.onScrollLeftChange = function() {
            this.renderer.scrollToX(this.session.getScrollLeft());
        };
        this.onCursorChange = function() {
            this.$cursorChange();
            if (!this.$blockScrolling) {
                config.warn("Automatically scrolling cursor into view after selection change", "this will be disabled in the next version", "set editor.$blockScrolling = Infinity to disable this message");
                this.renderer.scrollCursorIntoView();
            }
            this.$highlightBrackets();
            this.$highlightTags();
            this.$updateHighlightActiveLine();
            this._signal("changeSelection");
        };
        this.$updateHighlightActiveLine = function() {
            var session = this.getSession();
            var highlight;
            if (this.$highlightActiveLine) {
                if (this.$selectionStyle != "line" || !this.selection.isMultiLine()) highlight = this.getCursorPosition();
                if (this.renderer.$maxLines && this.session.getLength() === 1 && !(this.renderer.$minLines > 1)) highlight = false;
            }
            if (session.$highlightLineMarker && !highlight) {
                session.removeMarker(session.$highlightLineMarker.id);
                session.$highlightLineMarker = null;
            } else if (!session.$highlightLineMarker && highlight) {
                var range = new Range(highlight.row, highlight.column, highlight.row, Infinity);
                range.id = session.addMarker(range, "ace_active-line", "screenLine");
                session.$highlightLineMarker = range;
            } else if (highlight) {
                session.$highlightLineMarker.start.row = highlight.row;
                session.$highlightLineMarker.end.row = highlight.row;
                session.$highlightLineMarker.start.column = highlight.column;
                session._signal("changeBackMarker");
            }
        };
        this.onSelectionChange = function(e) {
            var session = this.session;
            if (session.$selectionMarker) session.removeMarker(session.$selectionMarker);
            session.$selectionMarker = null;
            if (!this.selection.isEmpty()) {
                var range = this.selection.getRange();
                var style = this.getSelectionStyle();
                session.$selectionMarker = session.addMarker(range, "ace_selection", style);
            } else this.$updateHighlightActiveLine();
            var re = this.$highlightSelectedWord && this.$getSelectionHighLightRegexp();
            this.session.highlight(re);
            this._signal("changeSelection");
        };
        this.$getSelectionHighLightRegexp = function() {
            var session = this.session;
            var selection = this.getSelectionRange();
            if (selection.isEmpty() || selection.isMultiLine()) return;
            var startOuter = selection.start.column - 1;
            var endOuter = selection.end.column + 1;
            var line = session.getLine(selection.start.row);
            var lineCols = line.length;
            var needle = line.substring(Math.max(startOuter, 0), Math.min(endOuter, lineCols));
            if (startOuter >= 0 && /^[\w\d]/.test(needle) || endOuter <= lineCols && /[\w\d]$/.test(needle)) return;
            needle = line.substring(selection.start.column, selection.end.column);
            if (!/^[\w\d]+$/.test(needle)) return;
            var re = this.$search.$assembleRegExp({
                wholeWord: true,
                caseSensitive: true,
                needle: needle
            });
            return re;
        };
        this.onChangeFrontMarker = function() {
            this.renderer.updateFrontMarkers();
        };
        this.onChangeBackMarker = function() {
            this.renderer.updateBackMarkers();
        };
        this.onChangeBreakpoint = function() {
            this.renderer.updateBreakpoints();
        };
        this.onChangeAnnotation = function() {
            this.renderer.setAnnotations(this.session.getAnnotations());
        };
        this.onChangeMode = function(e) {
            this.renderer.updateText();
            this._emit("changeMode", e);
        };
        this.onChangeWrapLimit = function() {
            this.renderer.updateFull();
        };
        this.onChangeWrapMode = function() {
            this.renderer.onResize(true);
        };
        this.onChangeFold = function() {
            this.$updateHighlightActiveLine();
            this.renderer.updateFull();
        };
        this.getSelectedText = function() {
            return this.session.getTextRange(this.getSelectionRange());
        };
        this.getCopyText = function() {
            var text = this.getSelectedText();
            this._signal("copy", text);
            return text;
        };
        this.onCopy = function() {
            this.commands.exec("copy", this);
        };
        this.onCut = function() {
            this.commands.exec("cut", this);
        };
        this.onPaste = function(text, event) {
            var e = {
                text: text,
                event: event
            };
            this.commands.exec("paste", this, e);
        };
        this.$handlePaste = function(e) {
            if (typeof e == "string") e = {
                text: e
            };
            this._signal("paste", e);
            var text = e.text;
            if (!this.inMultiSelectMode || this.inVirtualSelectionMode) this.insert(text);
            else {
                var lines = text.split(/\r\n|\r|\n/);
                var ranges = this.selection.rangeList.ranges;
                if (lines.length > ranges.length || lines.length < 2 || !lines[1]) return this.commands.exec("insertstring", this, text);
                for(var i = ranges.length; i--;){
                    var range = ranges[i];
                    if (!range.isEmpty()) this.session.remove(range);
                    this.session.insert(range.start, lines[i]);
                }
            }
        };
        this.execCommand = function(command, args) {
            return this.commands.exec(command, this, args);
        };
        this.insert = function(text, pasted) {
            var session = this.session;
            var mode = session.getMode();
            var cursor = this.getCursorPosition();
            if (this.getBehavioursEnabled() && !pasted) {
                var transform = mode.transformAction(session.getState(cursor.row), 'insertion', this, session, text);
                if (transform) {
                    if (text !== transform.text) {
                        this.session.mergeUndoDeltas = false;
                        this.$mergeNextCommand = false;
                    }
                    text = transform.text;
                }
            }
            if (text == "\t") text = this.session.getTabString();
            if (!this.selection.isEmpty()) {
                var range = this.getSelectionRange();
                cursor = this.session.remove(range);
                this.clearSelection();
            } else if (this.session.getOverwrite() && text.indexOf("\n") == -1) {
                var range = new Range.fromPoints(cursor, cursor);
                range.end.column += text.length;
                this.session.remove(range);
            }
            if (text == "\n" || text == "\r\n") {
                var line = session.getLine(cursor.row);
                if (cursor.column > line.search(/\S|$/)) {
                    var d = line.substr(cursor.column).search(/\S|$/);
                    session.doc.removeInLine(cursor.row, cursor.column, cursor.column + d);
                }
            }
            this.clearSelection();
            var start = cursor.column;
            var lineState = session.getState(cursor.row);
            var line = session.getLine(cursor.row);
            var shouldOutdent = mode.checkOutdent(lineState, line, text);
            var end = session.insert(cursor, text);
            if (transform && transform.selection) {
                if (transform.selection.length == 2) this.selection.setSelectionRange(new Range(cursor.row, start + transform.selection[0], cursor.row, start + transform.selection[1]));
                else this.selection.setSelectionRange(new Range(cursor.row + transform.selection[0], transform.selection[1], cursor.row + transform.selection[2], transform.selection[3]));
            }
            if (session.getDocument().isNewLine(text)) {
                var lineIndent = mode.getNextLineIndent(lineState, line.slice(0, cursor.column), session.getTabString());
                session.insert({
                    row: cursor.row + 1,
                    column: 0
                }, lineIndent);
            }
            if (shouldOutdent) mode.autoOutdent(lineState, session, cursor.row);
        };
        this.onTextInput = function(text) {
            this.keyBinding.onTextInput(text);
        };
        this.onCommandKey = function(e, hashId, keyCode) {
            this.keyBinding.onCommandKey(e, hashId, keyCode);
        };
        this.setOverwrite = function(overwrite) {
            this.session.setOverwrite(overwrite);
        };
        this.getOverwrite = function() {
            return this.session.getOverwrite();
        };
        this.toggleOverwrite = function() {
            this.session.toggleOverwrite();
        };
        this.setScrollSpeed = function(speed) {
            this.setOption("scrollSpeed", speed);
        };
        this.getScrollSpeed = function() {
            return this.getOption("scrollSpeed");
        };
        this.setDragDelay = function(dragDelay) {
            this.setOption("dragDelay", dragDelay);
        };
        this.getDragDelay = function() {
            return this.getOption("dragDelay");
        };
        this.setSelectionStyle = function(val) {
            this.setOption("selectionStyle", val);
        };
        this.getSelectionStyle = function() {
            return this.getOption("selectionStyle");
        };
        this.setHighlightActiveLine = function(shouldHighlight) {
            this.setOption("highlightActiveLine", shouldHighlight);
        };
        this.getHighlightActiveLine = function() {
            return this.getOption("highlightActiveLine");
        };
        this.setHighlightGutterLine = function(shouldHighlight) {
            this.setOption("highlightGutterLine", shouldHighlight);
        };
        this.getHighlightGutterLine = function() {
            return this.getOption("highlightGutterLine");
        };
        this.setHighlightSelectedWord = function(shouldHighlight) {
            this.setOption("highlightSelectedWord", shouldHighlight);
        };
        this.getHighlightSelectedWord = function() {
            return this.$highlightSelectedWord;
        };
        this.setAnimatedScroll = function(shouldAnimate) {
            this.renderer.setAnimatedScroll(shouldAnimate);
        };
        this.getAnimatedScroll = function() {
            return this.renderer.getAnimatedScroll();
        };
        this.setShowInvisibles = function(showInvisibles) {
            this.renderer.setShowInvisibles(showInvisibles);
        };
        this.getShowInvisibles = function() {
            return this.renderer.getShowInvisibles();
        };
        this.setDisplayIndentGuides = function(display) {
            this.renderer.setDisplayIndentGuides(display);
        };
        this.getDisplayIndentGuides = function() {
            return this.renderer.getDisplayIndentGuides();
        };
        this.setShowPrintMargin = function(showPrintMargin) {
            this.renderer.setShowPrintMargin(showPrintMargin);
        };
        this.getShowPrintMargin = function() {
            return this.renderer.getShowPrintMargin();
        };
        this.setPrintMarginColumn = function(showPrintMargin) {
            this.renderer.setPrintMarginColumn(showPrintMargin);
        };
        this.getPrintMarginColumn = function() {
            return this.renderer.getPrintMarginColumn();
        };
        this.setReadOnly = function(readOnly) {
            this.setOption("readOnly", readOnly);
        };
        this.getReadOnly = function() {
            return this.getOption("readOnly");
        };
        this.setBehavioursEnabled = function(enabled) {
            this.setOption("behavioursEnabled", enabled);
        };
        this.getBehavioursEnabled = function() {
            return this.getOption("behavioursEnabled");
        };
        this.setWrapBehavioursEnabled = function(enabled) {
            this.setOption("wrapBehavioursEnabled", enabled);
        };
        this.getWrapBehavioursEnabled = function() {
            return this.getOption("wrapBehavioursEnabled");
        };
        this.setShowFoldWidgets = function(show) {
            this.setOption("showFoldWidgets", show);
        };
        this.getShowFoldWidgets = function() {
            return this.getOption("showFoldWidgets");
        };
        this.setFadeFoldWidgets = function(fade) {
            this.setOption("fadeFoldWidgets", fade);
        };
        this.getFadeFoldWidgets = function() {
            return this.getOption("fadeFoldWidgets");
        };
        this.remove = function(dir) {
            if (this.selection.isEmpty()) {
                if (dir == "left") this.selection.selectLeft();
                else this.selection.selectRight();
            }
            var range = this.getSelectionRange();
            if (this.getBehavioursEnabled()) {
                var session = this.session;
                var state = session.getState(range.start.row);
                var new_range = session.getMode().transformAction(state, 'deletion', this, session, range);
                if (range.end.column === 0) {
                    var text = session.getTextRange(range);
                    if (text[text.length - 1] == "\n") {
                        var line = session.getLine(range.end.row);
                        if (/^\s+$/.test(line)) range.end.column = line.length;
                    }
                }
                if (new_range) range = new_range;
            }
            this.session.remove(range);
            this.clearSelection();
        };
        this.removeWordRight = function() {
            if (this.selection.isEmpty()) this.selection.selectWordRight();
            this.session.remove(this.getSelectionRange());
            this.clearSelection();
        };
        this.removeWordLeft = function() {
            if (this.selection.isEmpty()) this.selection.selectWordLeft();
            this.session.remove(this.getSelectionRange());
            this.clearSelection();
        };
        this.removeToLineStart = function() {
            if (this.selection.isEmpty()) this.selection.selectLineStart();
            this.session.remove(this.getSelectionRange());
            this.clearSelection();
        };
        this.removeToLineEnd = function() {
            if (this.selection.isEmpty()) this.selection.selectLineEnd();
            var range = this.getSelectionRange();
            if (range.start.column == range.end.column && range.start.row == range.end.row) {
                range.end.column = 0;
                range.end.row++;
            }
            this.session.remove(range);
            this.clearSelection();
        };
        this.splitLine = function() {
            if (!this.selection.isEmpty()) {
                this.session.remove(this.getSelectionRange());
                this.clearSelection();
            }
            var cursor = this.getCursorPosition();
            this.insert("\n");
            this.moveCursorToPosition(cursor);
        };
        this.transposeLetters = function() {
            if (!this.selection.isEmpty()) return;
            var cursor = this.getCursorPosition();
            var column = cursor.column;
            if (column === 0) return;
            var line = this.session.getLine(cursor.row);
            var swap, range;
            if (column < line.length) {
                swap = line.charAt(column) + line.charAt(column - 1);
                range = new Range(cursor.row, column - 1, cursor.row, column + 1);
            } else {
                swap = line.charAt(column - 1) + line.charAt(column - 2);
                range = new Range(cursor.row, column - 2, cursor.row, column);
            }
            this.session.replace(range, swap);
            this.session.selection.moveToPosition(range.end);
        };
        this.toLowerCase = function() {
            var originalRange = this.getSelectionRange();
            if (this.selection.isEmpty()) this.selection.selectWord();
            var range = this.getSelectionRange();
            var text = this.session.getTextRange(range);
            this.session.replace(range, text.toLowerCase());
            this.selection.setSelectionRange(originalRange);
        };
        this.toUpperCase = function() {
            var originalRange = this.getSelectionRange();
            if (this.selection.isEmpty()) this.selection.selectWord();
            var range = this.getSelectionRange();
            var text = this.session.getTextRange(range);
            this.session.replace(range, text.toUpperCase());
            this.selection.setSelectionRange(originalRange);
        };
        this.indent = function() {
            var session = this.session;
            var range = this.getSelectionRange();
            if (range.start.row < range.end.row) {
                var rows = this.$getSelectedRows();
                session.indentRows(rows.first, rows.last, "\t");
                return;
            } else if (range.start.column < range.end.column) {
                var text = session.getTextRange(range);
                if (!/^\s+$/.test(text)) {
                    var rows = this.$getSelectedRows();
                    session.indentRows(rows.first, rows.last, "\t");
                    return;
                }
            }
            var line = session.getLine(range.start.row);
            var position = range.start;
            var size = session.getTabSize();
            var column = session.documentToScreenColumn(position.row, position.column);
            if (this.session.getUseSoftTabs()) {
                var count = size - column % size;
                var indentString = lang.stringRepeat(" ", count);
            } else {
                var count = column % size;
                while(line[range.start.column - 1] == " " && count){
                    range.start.column--;
                    count--;
                }
                this.selection.setSelectionRange(range);
                indentString = "\t";
            }
            return this.insert(indentString);
        };
        this.blockIndent = function() {
            var rows = this.$getSelectedRows();
            this.session.indentRows(rows.first, rows.last, "\t");
        };
        this.blockOutdent = function() {
            var selection = this.session.getSelection();
            this.session.outdentRows(selection.getRange());
        };
        this.sortLines = function() {
            var rows = this.$getSelectedRows();
            var session = this.session;
            var lines = [];
            for(var i = rows.first; i <= rows.last; i++)lines.push(session.getLine(i));
            lines.sort(function(a, b) {
                if (a.toLowerCase() < b.toLowerCase()) return -1;
                if (a.toLowerCase() > b.toLowerCase()) return 1;
                return 0;
            });
            var deleteRange = new Range(0, 0, 0, 0);
            for(var i = rows.first; i <= rows.last; i++){
                var line = session.getLine(i);
                deleteRange.start.row = i;
                deleteRange.end.row = i;
                deleteRange.end.column = line.length;
                session.replace(deleteRange, lines[i - rows.first]);
            }
        };
        this.toggleCommentLines = function() {
            var state = this.session.getState(this.getCursorPosition().row);
            var rows = this.$getSelectedRows();
            this.session.getMode().toggleCommentLines(state, this.session, rows.first, rows.last);
        };
        this.toggleBlockComment = function() {
            var cursor = this.getCursorPosition();
            var state = this.session.getState(cursor.row);
            var range = this.getSelectionRange();
            this.session.getMode().toggleBlockComment(state, this.session, range, cursor);
        };
        this.getNumberAt = function(row, column) {
            var _numberRx = /[\-]?[0-9]+(?:\.[0-9]+)?/g;
            _numberRx.lastIndex = 0;
            var s = this.session.getLine(row);
            while(_numberRx.lastIndex < column){
                var m = _numberRx.exec(s);
                if (m.index <= column && m.index + m[0].length >= column) {
                    var number = {
                        value: m[0],
                        start: m.index,
                        end: m.index + m[0].length
                    };
                    return number;
                }
            }
            return null;
        };
        this.modifyNumber = function(amount) {
            var row = this.selection.getCursor().row;
            var column = this.selection.getCursor().column;
            var charRange = new Range(row, column - 1, row, column);
            var c = this.session.getTextRange(charRange);
            if (!isNaN(parseFloat(c)) && isFinite(c)) {
                var nr = this.getNumberAt(row, column);
                if (nr) {
                    var fp = nr.value.indexOf(".") >= 0 ? nr.start + nr.value.indexOf(".") + 1 : nr.end;
                    var decimals = nr.start + nr.value.length - fp;
                    var t = parseFloat(nr.value);
                    t *= Math.pow(10, decimals);
                    if (fp !== nr.end && column < fp) amount *= Math.pow(10, nr.end - column - 1);
                    else amount *= Math.pow(10, nr.end - column);
                    t += amount;
                    t /= Math.pow(10, decimals);
                    var nnr = t.toFixed(decimals);
                    var replaceRange = new Range(row, nr.start, row, nr.end);
                    this.session.replace(replaceRange, nnr);
                    this.moveCursorTo(row, Math.max(nr.start + 1, column + nnr.length - nr.value.length));
                }
            }
        };
        this.removeLines = function() {
            var rows = this.$getSelectedRows();
            this.session.removeFullLines(rows.first, rows.last);
            this.clearSelection();
        };
        this.duplicateSelection = function() {
            var sel = this.selection;
            var doc = this.session;
            var range = sel.getRange();
            var reverse = sel.isBackwards();
            if (range.isEmpty()) {
                var row = range.start.row;
                doc.duplicateLines(row, row);
            } else {
                var point = reverse ? range.start : range.end;
                var endPoint = doc.insert(point, doc.getTextRange(range), false);
                range.start = point;
                range.end = endPoint;
                sel.setSelectionRange(range, reverse);
            }
        };
        this.moveLinesDown = function() {
            this.$moveLines(1, false);
        };
        this.moveLinesUp = function() {
            this.$moveLines(-1, false);
        };
        this.moveText = function(range, toPosition, copy) {
            return this.session.moveText(range, toPosition, copy);
        };
        this.copyLinesUp = function() {
            this.$moveLines(-1, true);
        };
        this.copyLinesDown = function() {
            this.$moveLines(1, true);
        };
        this.$moveLines = function(dir, copy) {
            var rows, moved;
            var selection = this.selection;
            if (!selection.inMultiSelectMode || this.inVirtualSelectionMode) {
                var range = selection.toOrientedRange();
                rows = this.$getSelectedRows(range);
                moved = this.session.$moveLines(rows.first, rows.last, copy ? 0 : dir);
                if (copy && dir == -1) moved = 0;
                range.moveBy(moved, 0);
                selection.fromOrientedRange(range);
            } else {
                var ranges = selection.rangeList.ranges;
                selection.rangeList.detach(this.session);
                this.inVirtualSelectionMode = true;
                var diff = 0;
                var totalDiff = 0;
                var l = ranges.length;
                for(var i = 0; i < l; i++){
                    var rangeIndex = i;
                    ranges[i].moveBy(diff, 0);
                    rows = this.$getSelectedRows(ranges[i]);
                    var first = rows.first;
                    var last = rows.last;
                    while(++i < l){
                        if (totalDiff) ranges[i].moveBy(totalDiff, 0);
                        var subRows = this.$getSelectedRows(ranges[i]);
                        if (copy && subRows.first != last) break;
                        else if (!copy && subRows.first > last + 1) break;
                        last = subRows.last;
                    }
                    i--;
                    diff = this.session.$moveLines(first, last, copy ? 0 : dir);
                    if (copy && dir == -1) rangeIndex = i + 1;
                    while(rangeIndex <= i){
                        ranges[rangeIndex].moveBy(diff, 0);
                        rangeIndex++;
                    }
                    if (!copy) diff = 0;
                    totalDiff += diff;
                }
                selection.fromOrientedRange(selection.ranges[0]);
                selection.rangeList.attach(this.session);
                this.inVirtualSelectionMode = false;
            }
        };
        this.$getSelectedRows = function(range) {
            range = (range || this.getSelectionRange()).collapseRows();
            return {
                first: this.session.getRowFoldStart(range.start.row),
                last: this.session.getRowFoldEnd(range.end.row)
            };
        };
        this.onCompositionStart = function(text) {
            this.renderer.showComposition(this.getCursorPosition());
        };
        this.onCompositionUpdate = function(text) {
            this.renderer.setCompositionText(text);
        };
        this.onCompositionEnd = function() {
            this.renderer.hideComposition();
        };
        this.getFirstVisibleRow = function() {
            return this.renderer.getFirstVisibleRow();
        };
        this.getLastVisibleRow = function() {
            return this.renderer.getLastVisibleRow();
        };
        this.isRowVisible = function(row) {
            return row >= this.getFirstVisibleRow() && row <= this.getLastVisibleRow();
        };
        this.isRowFullyVisible = function(row) {
            return row >= this.renderer.getFirstFullyVisibleRow() && row <= this.renderer.getLastFullyVisibleRow();
        };
        this.$getVisibleRowCount = function() {
            return this.renderer.getScrollBottomRow() - this.renderer.getScrollTopRow() + 1;
        };
        this.$moveByPage = function(dir, select) {
            var renderer = this.renderer;
            var config = this.renderer.layerConfig;
            var rows = dir * Math.floor(config.height / config.lineHeight);
            this.$blockScrolling++;
            if (select === true) this.selection.$moveSelection(function() {
                this.moveCursorBy(rows, 0);
            });
            else if (select === false) {
                this.selection.moveCursorBy(rows, 0);
                this.selection.clearSelection();
            }
            this.$blockScrolling--;
            var scrollTop = renderer.scrollTop;
            renderer.scrollBy(0, rows * config.lineHeight);
            if (select != null) renderer.scrollCursorIntoView(null, 0.5);
            renderer.animateScrolling(scrollTop);
        };
        this.selectPageDown = function() {
            this.$moveByPage(1, true);
        };
        this.selectPageUp = function() {
            this.$moveByPage(-1, true);
        };
        this.gotoPageDown = function() {
            this.$moveByPage(1, false);
        };
        this.gotoPageUp = function() {
            this.$moveByPage(-1, false);
        };
        this.scrollPageDown = function() {
            this.$moveByPage(1);
        };
        this.scrollPageUp = function() {
            this.$moveByPage(-1);
        };
        this.scrollToRow = function(row) {
            this.renderer.scrollToRow(row);
        };
        this.scrollToLine = function(line, center, animate, callback) {
            this.renderer.scrollToLine(line, center, animate, callback);
        };
        this.centerSelection = function() {
            var range = this.getSelectionRange();
            var pos = {
                row: Math.floor(range.start.row + (range.end.row - range.start.row) / 2),
                column: Math.floor(range.start.column + (range.end.column - range.start.column) / 2)
            };
            this.renderer.alignCursor(pos, 0.5);
        };
        this.getCursorPosition = function() {
            return this.selection.getCursor();
        };
        this.getCursorPositionScreen = function() {
            return this.session.documentToScreenPosition(this.getCursorPosition());
        };
        this.getSelectionRange = function() {
            return this.selection.getRange();
        };
        this.selectAll = function() {
            this.$blockScrolling += 1;
            this.selection.selectAll();
            this.$blockScrolling -= 1;
        };
        this.clearSelection = function() {
            this.selection.clearSelection();
        };
        this.moveCursorTo = function(row, column) {
            this.selection.moveCursorTo(row, column);
        };
        this.moveCursorToPosition = function(pos) {
            this.selection.moveCursorToPosition(pos);
        };
        this.jumpToMatching = function(select, expand) {
            var cursor = this.getCursorPosition();
            var iterator = new TokenIterator(this.session, cursor.row, cursor.column);
            var prevToken = iterator.getCurrentToken();
            var token = prevToken || iterator.stepForward();
            if (!token) return;
            var matchType;
            var found = false;
            var depth = {};
            var i = cursor.column - token.start;
            var bracketType;
            var brackets = {
                ")": "(",
                "(": "(",
                "]": "[",
                "[": "[",
                "{": "{",
                "}": "{"
            };
            do {
                if (token.value.match(/[{}()\[\]]/g)) for(; i < token.value.length && !found; i++){
                    if (!brackets[token.value[i]]) continue;
                    bracketType = brackets[token.value[i]] + '.' + token.type.replace("rparen", "lparen");
                    if (isNaN(depth[bracketType])) depth[bracketType] = 0;
                    switch(token.value[i]){
                        case '(':
                        case '[':
                        case '{':
                            depth[bracketType]++;
                            break;
                        case ')':
                        case ']':
                        case '}':
                            depth[bracketType]--;
                            if (depth[bracketType] === -1) {
                                matchType = 'bracket';
                                found = true;
                            }
                            break;
                    }
                }
                else if (token && token.type.indexOf('tag-name') !== -1) {
                    if (isNaN(depth[token.value])) depth[token.value] = 0;
                    if (prevToken.value === '<') depth[token.value]++;
                    else if (prevToken.value === '</') depth[token.value]--;
                    if (depth[token.value] === -1) {
                        matchType = 'tag';
                        found = true;
                    }
                }
                if (!found) {
                    prevToken = token;
                    token = iterator.stepForward();
                    i = 0;
                }
            }while (token && !found);
            if (!matchType) return;
            var range, pos;
            if (matchType === 'bracket') {
                range = this.session.getBracketRange(cursor);
                if (!range) {
                    range = new Range(iterator.getCurrentTokenRow(), iterator.getCurrentTokenColumn() + i - 1, iterator.getCurrentTokenRow(), iterator.getCurrentTokenColumn() + i - 1);
                    pos = range.start;
                    if (expand || pos.row === cursor.row && Math.abs(pos.column - cursor.column) < 2) range = this.session.getBracketRange(pos);
                }
            } else if (matchType === 'tag') {
                if (token && token.type.indexOf('tag-name') !== -1) var tag = token.value;
                else return;
                range = new Range(iterator.getCurrentTokenRow(), iterator.getCurrentTokenColumn() - 2, iterator.getCurrentTokenRow(), iterator.getCurrentTokenColumn() - 2);
                if (range.compare(cursor.row, cursor.column) === 0) {
                    found = false;
                    do {
                        token = prevToken;
                        prevToken = iterator.stepBackward();
                        if (prevToken) {
                            if (prevToken.type.indexOf('tag-close') !== -1) range.setEnd(iterator.getCurrentTokenRow(), iterator.getCurrentTokenColumn() + 1);
                            if (token.value === tag && token.type.indexOf('tag-name') !== -1) {
                                if (prevToken.value === '<') depth[tag]++;
                                else if (prevToken.value === '</') depth[tag]--;
                                if (depth[tag] === 0) found = true;
                            }
                        }
                    }while (prevToken && !found);
                }
                if (token && token.type.indexOf('tag-name')) {
                    pos = range.start;
                    if (pos.row == cursor.row && Math.abs(pos.column - cursor.column) < 2) pos = range.end;
                }
            }
            pos = range && range.cursor || pos;
            if (pos) {
                if (select) {
                    if (range && expand) this.selection.setRange(range);
                    else if (range && range.isEqual(this.getSelectionRange())) this.clearSelection();
                    else this.selection.selectTo(pos.row, pos.column);
                } else this.selection.moveTo(pos.row, pos.column);
            }
        };
        this.gotoLine = function(lineNumber, column, animate) {
            this.selection.clearSelection();
            this.session.unfold({
                row: lineNumber - 1,
                column: column || 0
            });
            this.$blockScrolling += 1;
            this.exitMultiSelectMode && this.exitMultiSelectMode();
            this.moveCursorTo(lineNumber - 1, column || 0);
            this.$blockScrolling -= 1;
            if (!this.isRowFullyVisible(lineNumber - 1)) this.scrollToLine(lineNumber - 1, true, animate);
        };
        this.navigateTo = function(row, column) {
            this.selection.moveTo(row, column);
        };
        this.navigateUp = function(times) {
            if (this.selection.isMultiLine() && !this.selection.isBackwards()) {
                var selectionStart = this.selection.anchor.getPosition();
                return this.moveCursorToPosition(selectionStart);
            }
            this.selection.clearSelection();
            this.selection.moveCursorBy(-times || -1, 0);
        };
        this.navigateDown = function(times) {
            if (this.selection.isMultiLine() && this.selection.isBackwards()) {
                var selectionEnd = this.selection.anchor.getPosition();
                return this.moveCursorToPosition(selectionEnd);
            }
            this.selection.clearSelection();
            this.selection.moveCursorBy(times || 1, 0);
        };
        this.navigateLeft = function(times) {
            if (!this.selection.isEmpty()) {
                var selectionStart = this.getSelectionRange().start;
                this.moveCursorToPosition(selectionStart);
            } else {
                times = times || 1;
                while(times--)this.selection.moveCursorLeft();
            }
            this.clearSelection();
        };
        this.navigateRight = function(times) {
            if (!this.selection.isEmpty()) {
                var selectionEnd = this.getSelectionRange().end;
                this.moveCursorToPosition(selectionEnd);
            } else {
                times = times || 1;
                while(times--)this.selection.moveCursorRight();
            }
            this.clearSelection();
        };
        this.navigateLineStart = function() {
            this.selection.moveCursorLineStart();
            this.clearSelection();
        };
        this.navigateLineEnd = function() {
            this.selection.moveCursorLineEnd();
            this.clearSelection();
        };
        this.navigateFileEnd = function() {
            this.selection.moveCursorFileEnd();
            this.clearSelection();
        };
        this.navigateFileStart = function() {
            this.selection.moveCursorFileStart();
            this.clearSelection();
        };
        this.navigateWordRight = function() {
            this.selection.moveCursorWordRight();
            this.clearSelection();
        };
        this.navigateWordLeft = function() {
            this.selection.moveCursorWordLeft();
            this.clearSelection();
        };
        this.replace = function(replacement, options) {
            if (options) this.$search.set(options);
            var range = this.$search.find(this.session);
            var replaced = 0;
            if (!range) return replaced;
            if (this.$tryReplace(range, replacement)) replaced = 1;
            if (range !== null) {
                this.selection.setSelectionRange(range);
                this.renderer.scrollSelectionIntoView(range.start, range.end);
            }
            return replaced;
        };
        this.replaceAll = function(replacement, options) {
            if (options) this.$search.set(options);
            var ranges = this.$search.findAll(this.session);
            var replaced = 0;
            if (!ranges.length) return replaced;
            this.$blockScrolling += 1;
            var selection = this.getSelectionRange();
            this.selection.moveTo(0, 0);
            for(var i = ranges.length - 1; i >= 0; --i)if (this.$tryReplace(ranges[i], replacement)) replaced++;
            this.selection.setSelectionRange(selection);
            this.$blockScrolling -= 1;
            return replaced;
        };
        this.$tryReplace = function(range, replacement) {
            var input = this.session.getTextRange(range);
            replacement = this.$search.replace(input, replacement);
            if (replacement !== null) {
                range.end = this.session.replace(range, replacement);
                return range;
            } else return null;
        };
        this.getLastSearchOptions = function() {
            return this.$search.getOptions();
        };
        this.find = function(needle, options, animate) {
            if (!options) options = {};
            if (typeof needle == "string" || needle instanceof RegExp) options.needle = needle;
            else if (typeof needle == "object") oop.mixin(options, needle);
            var range = this.selection.getRange();
            if (options.needle == null) {
                needle = this.session.getTextRange(range) || this.$search.$options.needle;
                if (!needle) {
                    range = this.session.getWordRange(range.start.row, range.start.column);
                    needle = this.session.getTextRange(range);
                }
                this.$search.set({
                    needle: needle
                });
            }
            this.$search.set(options);
            if (!options.start) this.$search.set({
                start: range
            });
            var newRange = this.$search.find(this.session);
            if (options.preventScroll) return newRange;
            if (newRange) {
                this.revealRange(newRange, animate);
                return newRange;
            }
            if (options.backwards) range.start = range.end;
            else range.end = range.start;
            this.selection.setRange(range);
        };
        this.findNext = function(options, animate) {
            this.find({
                skipCurrent: true,
                backwards: false
            }, options, animate);
        };
        this.findPrevious = function(options, animate) {
            this.find(options, {
                skipCurrent: true,
                backwards: true
            }, animate);
        };
        this.revealRange = function(range, animate) {
            this.$blockScrolling += 1;
            this.session.unfold(range);
            this.selection.setSelectionRange(range);
            this.$blockScrolling -= 1;
            var scrollTop = this.renderer.scrollTop;
            this.renderer.scrollSelectionIntoView(range.start, range.end, 0.5);
            if (animate !== false) this.renderer.animateScrolling(scrollTop);
        };
        this.undo = function() {
            this.$blockScrolling++;
            this.session.getUndoManager().undo();
            this.$blockScrolling--;
            this.renderer.scrollCursorIntoView(null, 0.5);
        };
        this.redo = function() {
            this.$blockScrolling++;
            this.session.getUndoManager().redo();
            this.$blockScrolling--;
            this.renderer.scrollCursorIntoView(null, 0.5);
        };
        this.destroy = function() {
            this.renderer.destroy();
            this._signal("destroy", this);
            if (this.session) this.session.destroy();
        };
        this.setAutoScrollEditorIntoView = function(enable) {
            if (!enable) return;
            var rect;
            var self = this;
            var shouldScroll = false;
            if (!this.$scrollAnchor) this.$scrollAnchor = document.createElement("div");
            var scrollAnchor = this.$scrollAnchor;
            scrollAnchor.style.cssText = "position:absolute";
            this.container.insertBefore(scrollAnchor, this.container.firstChild);
            var onChangeSelection = this.on("changeSelection", function() {
                shouldScroll = true;
            });
            var onBeforeRender = this.renderer.on("beforeRender", function() {
                if (shouldScroll) rect = self.renderer.container.getBoundingClientRect();
            });
            var onAfterRender = this.renderer.on("afterRender", function() {
                if (shouldScroll && rect && (self.isFocused() || self.searchBox && self.searchBox.isFocused())) {
                    var renderer = self.renderer;
                    var pos = renderer.$cursorLayer.$pixelPos;
                    var config = renderer.layerConfig;
                    var top = pos.top - config.offset;
                    if (pos.top >= 0 && top + rect.top < 0) shouldScroll = true;
                    else if (pos.top < config.height && pos.top + rect.top + config.lineHeight > window.innerHeight) shouldScroll = false;
                    else shouldScroll = null;
                    if (shouldScroll != null) {
                        scrollAnchor.style.top = top + "px";
                        scrollAnchor.style.left = pos.left + "px";
                        scrollAnchor.style.height = config.lineHeight + "px";
                        scrollAnchor.scrollIntoView(shouldScroll);
                    }
                    shouldScroll = rect = null;
                }
            });
            this.setAutoScrollEditorIntoView = function(enable) {
                if (enable) return;
                delete this.setAutoScrollEditorIntoView;
                this.off("changeSelection", onChangeSelection);
                this.renderer.off("afterRender", onAfterRender);
                this.renderer.off("beforeRender", onBeforeRender);
            };
        };
        this.$resetCursorStyle = function() {
            var style = this.$cursorStyle || "ace";
            var cursorLayer = this.renderer.$cursorLayer;
            if (!cursorLayer) return;
            cursorLayer.setSmoothBlinking(/smooth/.test(style));
            cursorLayer.isBlinking = !this.$readOnly && style != "wide";
            dom.setCssClass(cursorLayer.element, "ace_slim-cursors", /slim/.test(style));
        };
    }).call(Editor.prototype);
    config.defineOptions(Editor.prototype, "editor", {
        selectionStyle: {
            set: function(style) {
                this.onSelectionChange();
                this._signal("changeSelectionStyle", {
                    data: style
                });
            },
            initialValue: "line"
        },
        highlightActiveLine: {
            set: function() {
                this.$updateHighlightActiveLine();
            },
            initialValue: true
        },
        highlightSelectedWord: {
            set: function(shouldHighlight) {
                this.$onSelectionChange();
            },
            initialValue: true
        },
        readOnly: {
            set: function(readOnly) {
                this.$resetCursorStyle();
            },
            initialValue: false
        },
        cursorStyle: {
            set: function(val) {
                this.$resetCursorStyle();
            },
            values: [
                "ace",
                "slim",
                "smooth",
                "wide"
            ],
            initialValue: "ace"
        },
        mergeUndoDeltas: {
            values: [
                false,
                true,
                "always"
            ],
            initialValue: true
        },
        behavioursEnabled: {
            initialValue: true
        },
        wrapBehavioursEnabled: {
            initialValue: true
        },
        autoScrollEditorIntoView: {
            set: function(val) {
                this.setAutoScrollEditorIntoView(val);
            }
        },
        keyboardHandler: {
            set: function(val) {
                this.setKeyboardHandler(val);
            },
            get: function() {
                return this.keybindingId;
            },
            handlesSet: true
        },
        hScrollBarAlwaysVisible: "renderer",
        vScrollBarAlwaysVisible: "renderer",
        highlightGutterLine: "renderer",
        animatedScroll: "renderer",
        showInvisibles: "renderer",
        showPrintMargin: "renderer",
        printMarginColumn: "renderer",
        printMargin: "renderer",
        fadeFoldWidgets: "renderer",
        showFoldWidgets: "renderer",
        showLineNumbers: "renderer",
        showGutter: "renderer",
        displayIndentGuides: "renderer",
        fontSize: "renderer",
        fontFamily: "renderer",
        maxLines: "renderer",
        minLines: "renderer",
        scrollPastEnd: "renderer",
        fixedWidthGutter: "renderer",
        theme: "renderer",
        scrollSpeed: "$mouseHandler",
        dragDelay: "$mouseHandler",
        dragEnabled: "$mouseHandler",
        focusTimout: "$mouseHandler",
        tooltipFollowsMouse: "$mouseHandler",
        firstLineNumber: "session",
        overwrite: "session",
        newLineMode: "session",
        useWorker: "session",
        useSoftTabs: "session",
        tabSize: "session",
        wrap: "session",
        indentedSoftWrap: "session",
        foldStyle: "session",
        mode: "session"
    });
    exports.Editor = Editor;
});
ace.define("ace/undomanager", [
    "require",
    "exports",
    "module"
], function(acequire, exports, module1) {
    "use strict";
    var UndoManager = function() {
        this.reset();
    };
    (function() {
        this.execute = function(options) {
            var deltaSets = options.args[0];
            this.$doc = options.args[1];
            if (options.merge && this.hasUndo()) {
                this.dirtyCounter--;
                deltaSets = this.$undoStack.pop().concat(deltaSets);
            }
            this.$undoStack.push(deltaSets);
            this.$redoStack = [];
            if (this.dirtyCounter < 0) this.dirtyCounter = NaN;
            this.dirtyCounter++;
        };
        this.undo = function(dontSelect) {
            var deltaSets = this.$undoStack.pop();
            var undoSelectionRange = null;
            if (deltaSets) {
                undoSelectionRange = this.$doc.undoChanges(deltaSets, dontSelect);
                this.$redoStack.push(deltaSets);
                this.dirtyCounter--;
            }
            return undoSelectionRange;
        };
        this.redo = function(dontSelect) {
            var deltaSets = this.$redoStack.pop();
            var redoSelectionRange = null;
            if (deltaSets) {
                redoSelectionRange = this.$doc.redoChanges(this.$deserializeDeltas(deltaSets), dontSelect);
                this.$undoStack.push(deltaSets);
                this.dirtyCounter++;
            }
            return redoSelectionRange;
        };
        this.reset = function() {
            this.$undoStack = [];
            this.$redoStack = [];
            this.dirtyCounter = 0;
        };
        this.hasUndo = function() {
            return this.$undoStack.length > 0;
        };
        this.hasRedo = function() {
            return this.$redoStack.length > 0;
        };
        this.markClean = function() {
            this.dirtyCounter = 0;
        };
        this.isClean = function() {
            return this.dirtyCounter === 0;
        };
        this.$serializeDeltas = function(deltaSets) {
            return cloneDeltaSetsObj(deltaSets, $serializeDelta);
        };
        this.$deserializeDeltas = function(deltaSets) {
            return cloneDeltaSetsObj(deltaSets, $deserializeDelta);
        };
        function $serializeDelta(delta) {
            return {
                action: delta.action,
                start: delta.start,
                end: delta.end,
                lines: delta.lines.length == 1 ? null : delta.lines,
                text: delta.lines.length == 1 ? delta.lines[0] : null
            };
        }
        function $deserializeDelta(delta) {
            return {
                action: delta.action,
                start: delta.start,
                end: delta.end,
                lines: delta.lines || [
                    delta.text
                ]
            };
        }
        function cloneDeltaSetsObj(deltaSets_old, fnGetModifiedDelta) {
            var deltaSets_new = new Array(deltaSets_old.length);
            for(var i = 0; i < deltaSets_old.length; i++){
                var deltaSet_old = deltaSets_old[i];
                var deltaSet_new = {
                    group: deltaSet_old.group,
                    deltas: new Array(deltaSet_old.length)
                };
                for(var j = 0; j < deltaSet_old.deltas.length; j++){
                    var delta_old = deltaSet_old.deltas[j];
                    deltaSet_new.deltas[j] = fnGetModifiedDelta(delta_old);
                }
                deltaSets_new[i] = deltaSet_new;
            }
            return deltaSets_new;
        }
    }).call(UndoManager.prototype);
    exports.UndoManager = UndoManager;
});
ace.define("ace/layer/gutter", [
    "require",
    "exports",
    "module",
    "ace/lib/dom",
    "ace/lib/oop",
    "ace/lib/lang",
    "ace/lib/event_emitter"
], function(acequire, exports, module1) {
    "use strict";
    var dom = acequire("../lib/dom");
    var oop = acequire("../lib/oop");
    var lang = acequire("../lib/lang");
    var EventEmitter = acequire("../lib/event_emitter").EventEmitter;
    var Gutter = function(parentEl) {
        this.element = dom.createElement("div");
        this.element.className = "ace_layer ace_gutter-layer";
        parentEl.appendChild(this.element);
        this.setShowFoldWidgets(this.$showFoldWidgets);
        this.gutterWidth = 0;
        this.$annotations = [];
        this.$updateAnnotations = this.$updateAnnotations.bind(this);
        this.$cells = [];
    };
    (function() {
        oop.implement(this, EventEmitter);
        this.setSession = function(session) {
            if (this.session) this.session.removeEventListener("change", this.$updateAnnotations);
            this.session = session;
            if (session) session.on("change", this.$updateAnnotations);
        };
        this.addGutterDecoration = function(row, className) {
            if (window.console) console.warn && console.warn("deprecated use session.addGutterDecoration");
            this.session.addGutterDecoration(row, className);
        };
        this.removeGutterDecoration = function(row, className) {
            if (window.console) console.warn && console.warn("deprecated use session.removeGutterDecoration");
            this.session.removeGutterDecoration(row, className);
        };
        this.setAnnotations = function(annotations) {
            this.$annotations = [];
            for(var i = 0; i < annotations.length; i++){
                var annotation = annotations[i];
                var row = annotation.row;
                var rowInfo = this.$annotations[row];
                if (!rowInfo) rowInfo = this.$annotations[row] = {
                    text: []
                };
                var annoText = annotation.text;
                annoText = annoText ? lang.escapeHTML(annoText) : annotation.html || "";
                if (rowInfo.text.indexOf(annoText) === -1) rowInfo.text.push(annoText);
                var type = annotation.type;
                if (type == "error") rowInfo.className = " ace_error";
                else if (type == "warning" && rowInfo.className != " ace_error") rowInfo.className = " ace_warning";
                else if (type == "info" && !rowInfo.className) rowInfo.className = " ace_info";
            }
        };
        this.$updateAnnotations = function(delta) {
            if (!this.$annotations.length) return;
            var firstRow = delta.start.row;
            var len = delta.end.row - firstRow;
            if (len === 0) ;
            else if (delta.action == 'remove') this.$annotations.splice(firstRow, len + 1, null);
            else {
                var args = new Array(len + 1);
                args.unshift(firstRow, 1);
                this.$annotations.splice.apply(this.$annotations, args);
            }
        };
        this.update = function(config) {
            var session = this.session;
            var firstRow = config.firstRow;
            var lastRow = Math.min(config.lastRow + config.gutterOffset, session.getLength() - 1);
            var fold = session.getNextFoldLine(firstRow);
            var foldStart = fold ? fold.start.row : Infinity;
            var foldWidgets = this.$showFoldWidgets && session.foldWidgets;
            var breakpoints = session.$breakpoints;
            var decorations = session.$decorations;
            var firstLineNumber = session.$firstLineNumber;
            var lastLineNumber = 0;
            var gutterRenderer = session.gutterRenderer || this.$renderer;
            var cell = null;
            var index = -1;
            var row = firstRow;
            while(true){
                if (row > foldStart) {
                    row = fold.end.row + 1;
                    fold = session.getNextFoldLine(row, fold);
                    foldStart = fold ? fold.start.row : Infinity;
                }
                if (row > lastRow) {
                    while(this.$cells.length > index + 1){
                        cell = this.$cells.pop();
                        this.element.removeChild(cell.element);
                    }
                    break;
                }
                cell = this.$cells[++index];
                if (!cell) {
                    cell = {
                        element: null,
                        textNode: null,
                        foldWidget: null
                    };
                    cell.element = dom.createElement("div");
                    cell.textNode = document.createTextNode('');
                    cell.element.appendChild(cell.textNode);
                    this.element.appendChild(cell.element);
                    this.$cells[index] = cell;
                }
                var className = "ace_gutter-cell ";
                if (breakpoints[row]) className += breakpoints[row];
                if (decorations[row]) className += decorations[row];
                if (this.$annotations[row]) className += this.$annotations[row].className;
                if (cell.element.className != className) cell.element.className = className;
                var height = session.getRowLength(row) * config.lineHeight + "px";
                if (height != cell.element.style.height) cell.element.style.height = height;
                if (foldWidgets) {
                    var c = foldWidgets[row];
                    if (c == null) c = foldWidgets[row] = session.getFoldWidget(row);
                }
                if (c) {
                    if (!cell.foldWidget) {
                        cell.foldWidget = dom.createElement("span");
                        cell.element.appendChild(cell.foldWidget);
                    }
                    var className = "ace_fold-widget ace_" + c;
                    if (c == "start" && row == foldStart && row < fold.end.row) className += " ace_closed";
                    else className += " ace_open";
                    if (cell.foldWidget.className != className) cell.foldWidget.className = className;
                    var height = config.lineHeight + "px";
                    if (cell.foldWidget.style.height != height) cell.foldWidget.style.height = height;
                } else if (cell.foldWidget) {
                    cell.element.removeChild(cell.foldWidget);
                    cell.foldWidget = null;
                }
                var text = lastLineNumber = gutterRenderer ? gutterRenderer.getText(session, row) : row + firstLineNumber;
                if (text !== cell.textNode.data) cell.textNode.data = text;
                row++;
            }
            this.element.style.height = config.minHeight + "px";
            if (this.$fixedWidth || session.$useWrapMode) lastLineNumber = session.getLength() + firstLineNumber;
            var gutterWidth = gutterRenderer ? gutterRenderer.getWidth(session, lastLineNumber, config) : lastLineNumber.toString().length * config.characterWidth;
            var padding = this.$padding || this.$computePadding();
            gutterWidth += padding.left + padding.right;
            if (gutterWidth !== this.gutterWidth && !isNaN(gutterWidth)) {
                this.gutterWidth = gutterWidth;
                this.element.style.width = Math.ceil(this.gutterWidth) + "px";
                this._emit("changeGutterWidth", gutterWidth);
            }
        };
        this.$fixedWidth = false;
        this.$showLineNumbers = true;
        this.$renderer = "";
        this.setShowLineNumbers = function(show) {
            this.$renderer = !show && {
                getWidth: function() {
                    return "";
                },
                getText: function() {
                    return "";
                }
            };
        };
        this.getShowLineNumbers = function() {
            return this.$showLineNumbers;
        };
        this.$showFoldWidgets = true;
        this.setShowFoldWidgets = function(show) {
            if (show) dom.addCssClass(this.element, "ace_folding-enabled");
            else dom.removeCssClass(this.element, "ace_folding-enabled");
            this.$showFoldWidgets = show;
            this.$padding = null;
        };
        this.getShowFoldWidgets = function() {
            return this.$showFoldWidgets;
        };
        this.$computePadding = function() {
            if (!this.element.firstChild) return {
                left: 0,
                right: 0
            };
            var style = dom.computedStyle(this.element.firstChild);
            this.$padding = {};
            this.$padding.left = parseInt(style.paddingLeft) + 1 || 0;
            this.$padding.right = parseInt(style.paddingRight) || 0;
            return this.$padding;
        };
        this.getRegion = function(point) {
            var padding = this.$padding || this.$computePadding();
            var rect = this.element.getBoundingClientRect();
            if (point.x < padding.left + rect.left) return "markers";
            if (this.$showFoldWidgets && point.x > rect.right - padding.right) return "foldWidgets";
        };
    }).call(Gutter.prototype);
    exports.Gutter = Gutter;
});
ace.define("ace/layer/marker", [
    "require",
    "exports",
    "module",
    "ace/range",
    "ace/lib/dom"
], function(acequire, exports, module1) {
    "use strict";
    var Range = acequire("../range").Range;
    var dom = acequire("../lib/dom");
    var Marker = function(parentEl) {
        this.element = dom.createElement("div");
        this.element.className = "ace_layer ace_marker-layer";
        parentEl.appendChild(this.element);
    };
    (function() {
        this.$padding = 0;
        this.setPadding = function(padding) {
            this.$padding = padding;
        };
        this.setSession = function(session) {
            this.session = session;
        };
        this.setMarkers = function(markers) {
            this.markers = markers;
        };
        this.update = function(config) {
            if (!config) return;
            this.config = config;
            var html = [];
            for(var key in this.markers){
                var marker = this.markers[key];
                if (!marker.range) {
                    marker.update(html, this, this.session, config);
                    continue;
                }
                var range = marker.range.clipRows(config.firstRow, config.lastRow);
                if (range.isEmpty()) continue;
                range = range.toScreenRange(this.session);
                if (marker.renderer) {
                    var top = this.$getTop(range.start.row, config);
                    var left = this.$padding + (this.session.$bidiHandler.isBidiRow(range.start.row) ? this.session.$bidiHandler.getPosLeft(range.start.column) : range.start.column * config.characterWidth);
                    marker.renderer(html, range, left, top, config);
                } else if (marker.type == "fullLine") this.drawFullLineMarker(html, range, marker.clazz, config);
                else if (marker.type == "screenLine") this.drawScreenLineMarker(html, range, marker.clazz, config);
                else if (range.isMultiLine()) {
                    if (marker.type == "text") this.drawTextMarker(html, range, marker.clazz, config);
                    else this.drawMultiLineMarker(html, range, marker.clazz, config);
                } else if (this.session.$bidiHandler.isBidiRow(range.start.row)) this.drawBidiSingleLineMarker(html, range, marker.clazz + " ace_start" + " ace_br15", config);
                else this.drawSingleLineMarker(html, range, marker.clazz + " ace_start" + " ace_br15", config);
            }
            this.element.innerHTML = html.join("");
        };
        this.$getTop = function(row, layerConfig) {
            return (row - layerConfig.firstRowScreen) * layerConfig.lineHeight;
        };
        function getBorderClass(tl, tr, br, bl) {
            return (tl ? 1 : 0) | (tr ? 2 : 0) | (br ? 4 : 0) | (bl ? 8 : 0);
        }
        this.drawTextMarker = function(stringBuilder, range, clazz, layerConfig, extraStyle) {
            var session = this.session;
            var start = range.start.row;
            var end = range.end.row;
            var row = start;
            var prev = 0;
            var curr = 0;
            var next = session.getScreenLastRowColumn(row);
            var clazzModified = null;
            var lineRange = new Range(row, range.start.column, row, curr);
            for(; row <= end; row++){
                lineRange.start.row = lineRange.end.row = row;
                lineRange.start.column = row == start ? range.start.column : session.getRowWrapIndent(row);
                lineRange.end.column = next;
                prev = curr;
                curr = next;
                next = row + 1 < end ? session.getScreenLastRowColumn(row + 1) : row == end ? 0 : range.end.column;
                clazzModified = clazz + (row == start ? " ace_start" : "") + " ace_br" + getBorderClass(row == start || row == start + 1 && range.start.column, prev < curr, curr > next, row == end);
                if (this.session.$bidiHandler.isBidiRow(row)) this.drawBidiSingleLineMarker(stringBuilder, lineRange, clazzModified, layerConfig, row == end ? 0 : 1, extraStyle);
                else this.drawSingleLineMarker(stringBuilder, lineRange, clazzModified, layerConfig, row == end ? 0 : 1, extraStyle);
            }
        };
        this.drawMultiLineMarker = function(stringBuilder, range, clazz, config, extraStyle) {
            var padding = this.$padding;
            var height, top, left;
            extraStyle = extraStyle || "";
            if (this.session.$bidiHandler.isBidiRow(range.start.row)) {
                var range1 = range.clone();
                range1.end.row = range1.start.row;
                range1.end.column = this.session.getLine(range1.start.row).length;
                this.drawBidiSingleLineMarker(stringBuilder, range1, clazz + " ace_br1 ace_start", config, null, extraStyle);
            } else {
                height = config.lineHeight;
                top = this.$getTop(range.start.row, config);
                left = padding + range.start.column * config.characterWidth;
                stringBuilder.push("<div class='", clazz, " ace_br1 ace_start' style='", "height:", height, "px;", "right:0;", "top:", top, "px;", "left:", left, "px;", extraStyle, "'></div>");
            }
            if (this.session.$bidiHandler.isBidiRow(range.end.row)) {
                var range1 = range.clone();
                range1.start.row = range1.end.row;
                range1.start.column = 0;
                this.drawBidiSingleLineMarker(stringBuilder, range1, clazz + " ace_br12", config, null, extraStyle);
            } else {
                var width = range.end.column * config.characterWidth;
                height = config.lineHeight;
                top = this.$getTop(range.end.row, config);
                stringBuilder.push("<div class='", clazz, " ace_br12' style='", "height:", height, "px;", "width:", width, "px;", "top:", top, "px;", "left:", padding, "px;", extraStyle, "'></div>");
            }
            height = (range.end.row - range.start.row - 1) * config.lineHeight;
            if (height <= 0) return;
            top = this.$getTop(range.start.row + 1, config);
            var radiusClass = (range.start.column ? 1 : 0) | (range.end.column ? 0 : 8);
            stringBuilder.push("<div class='", clazz, radiusClass ? " ace_br" + radiusClass : "", "' style='", "height:", height, "px;", "right:0;", "top:", top, "px;", "left:", padding, "px;", extraStyle, "'></div>");
        };
        this.drawSingleLineMarker = function(stringBuilder, range, clazz, config, extraLength, extraStyle) {
            var height = config.lineHeight;
            var width = (range.end.column + (extraLength || 0) - range.start.column) * config.characterWidth;
            var top = this.$getTop(range.start.row, config);
            var left = this.$padding + range.start.column * config.characterWidth;
            stringBuilder.push("<div class='", clazz, "' style='", "height:", height, "px;", "width:", width, "px;", "top:", top, "px;", "left:", left, "px;", extraStyle || "", "'></div>");
        };
        this.drawBidiSingleLineMarker = function(stringBuilder, range, clazz, config, extraLength, extraStyle) {
            var height = config.lineHeight, top = this.$getTop(range.start.row, config), padding = this.$padding;
            var selections = this.session.$bidiHandler.getSelections(range.start.column, range.end.column);
            selections.forEach(function(selection) {
                stringBuilder.push("<div class='", clazz, "' style='", "height:", height, "px;", "width:", selection.width + (extraLength || 0), "px;", "top:", top, "px;", "left:", padding + selection.left, "px;", extraStyle || "", "'></div>");
            });
        };
        this.drawFullLineMarker = function(stringBuilder, range, clazz, config, extraStyle) {
            var top = this.$getTop(range.start.row, config);
            var height = config.lineHeight;
            if (range.start.row != range.end.row) height += this.$getTop(range.end.row, config) - top;
            stringBuilder.push("<div class='", clazz, "' style='", "height:", height, "px;", "top:", top, "px;", "left:0;right:0;", extraStyle || "", "'></div>");
        };
        this.drawScreenLineMarker = function(stringBuilder, range, clazz, config, extraStyle) {
            var top = this.$getTop(range.start.row, config);
            var height = config.lineHeight;
            stringBuilder.push("<div class='", clazz, "' style='", "height:", height, "px;", "top:", top, "px;", "left:0;right:0;", extraStyle || "", "'></div>");
        };
    }).call(Marker.prototype);
    exports.Marker = Marker;
});
ace.define("ace/layer/text", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/lib/dom",
    "ace/lib/lang",
    "ace/lib/useragent",
    "ace/lib/event_emitter"
], function(acequire, exports, module1) {
    "use strict";
    var oop = acequire("../lib/oop");
    var dom = acequire("../lib/dom");
    var lang = acequire("../lib/lang");
    var useragent = acequire("../lib/useragent");
    var EventEmitter = acequire("../lib/event_emitter").EventEmitter;
    var Text = function(parentEl) {
        this.element = dom.createElement("div");
        this.element.className = "ace_layer ace_text-layer";
        parentEl.appendChild(this.element);
        this.$updateEolChar = this.$updateEolChar.bind(this);
    };
    (function() {
        oop.implement(this, EventEmitter);
        this.EOF_CHAR = "\xB6";
        this.EOL_CHAR_LF = "\xAC";
        this.EOL_CHAR_CRLF = "\xa4";
        this.EOL_CHAR = this.EOL_CHAR_LF;
        this.TAB_CHAR = "\u2014"; //"\u21E5";
        this.SPACE_CHAR = "\xB7";
        this.$padding = 0;
        this.$updateEolChar = function() {
            var EOL_CHAR = this.session.doc.getNewLineCharacter() == "\n" ? this.EOL_CHAR_LF : this.EOL_CHAR_CRLF;
            if (this.EOL_CHAR != EOL_CHAR) {
                this.EOL_CHAR = EOL_CHAR;
                return true;
            }
        };
        this.setPadding = function(padding) {
            this.$padding = padding;
            this.element.style.padding = "0 " + padding + "px";
        };
        this.getLineHeight = function() {
            return this.$fontMetrics.$characterSize.height || 0;
        };
        this.getCharacterWidth = function() {
            return this.$fontMetrics.$characterSize.width || 0;
        };
        this.$setFontMetrics = function(measure) {
            this.$fontMetrics = measure;
            this.$fontMetrics.on("changeCharacterSize", (function(e) {
                this._signal("changeCharacterSize", e);
            }).bind(this));
            this.$pollSizeChanges();
        };
        this.checkForSizeChanges = function() {
            this.$fontMetrics.checkForSizeChanges();
        };
        this.$pollSizeChanges = function() {
            return this.$pollSizeChangesTimer = this.$fontMetrics.$pollSizeChanges();
        };
        this.setSession = function(session) {
            this.session = session;
            if (session) this.$computeTabString();
        };
        this.showInvisibles = false;
        this.setShowInvisibles = function(showInvisibles) {
            if (this.showInvisibles == showInvisibles) return false;
            this.showInvisibles = showInvisibles;
            this.$computeTabString();
            return true;
        };
        this.displayIndentGuides = true;
        this.setDisplayIndentGuides = function(display) {
            if (this.displayIndentGuides == display) return false;
            this.displayIndentGuides = display;
            this.$computeTabString();
            return true;
        };
        this.$tabStrings = [];
        this.onChangeTabSize = this.$computeTabString = function() {
            var tabSize = this.session.getTabSize();
            this.tabSize = tabSize;
            var tabStr = this.$tabStrings = [
                0
            ];
            for(var i = 1; i < tabSize + 1; i++)if (this.showInvisibles) tabStr.push("<span class='ace_invisible ace_invisible_tab'>" + lang.stringRepeat(this.TAB_CHAR, i) + "</span>");
            else tabStr.push(lang.stringRepeat(" ", i));
            if (this.displayIndentGuides) {
                this.$indentGuideRe = /\s\S| \t|\t |\s$/;
                var className = "ace_indent-guide";
                var spaceClass = "";
                var tabClass = "";
                if (this.showInvisibles) {
                    className += " ace_invisible";
                    spaceClass = " ace_invisible_space";
                    tabClass = " ace_invisible_tab";
                    var spaceContent = lang.stringRepeat(this.SPACE_CHAR, this.tabSize);
                    var tabContent = lang.stringRepeat(this.TAB_CHAR, this.tabSize);
                } else {
                    var spaceContent = lang.stringRepeat(" ", this.tabSize);
                    var tabContent = spaceContent;
                }
                this.$tabStrings[" "] = "<span class='" + className + spaceClass + "'>" + spaceContent + "</span>";
                this.$tabStrings["\t"] = "<span class='" + className + tabClass + "'>" + tabContent + "</span>";
            }
        };
        this.updateLines = function(config, firstRow, lastRow) {
            if (this.config.lastRow != config.lastRow || this.config.firstRow != config.firstRow) this.scrollLines(config);
            this.config = config;
            var first = Math.max(firstRow, config.firstRow);
            var last = Math.min(lastRow, config.lastRow);
            var lineElements = this.element.childNodes;
            var lineElementsIdx = 0;
            for(var row = config.firstRow; row < first; row++){
                var foldLine = this.session.getFoldLine(row);
                if (foldLine) {
                    if (foldLine.containsRow(first)) {
                        first = foldLine.start.row;
                        break;
                    } else row = foldLine.end.row;
                }
                lineElementsIdx++;
            }
            var row = first;
            var foldLine = this.session.getNextFoldLine(row);
            var foldStart = foldLine ? foldLine.start.row : Infinity;
            while(true){
                if (row > foldStart) {
                    row = foldLine.end.row + 1;
                    foldLine = this.session.getNextFoldLine(row, foldLine);
                    foldStart = foldLine ? foldLine.start.row : Infinity;
                }
                if (row > last) break;
                var lineElement = lineElements[lineElementsIdx++];
                if (lineElement) {
                    var html = [];
                    this.$renderLine(html, row, !this.$useLineGroups(), row == foldStart ? foldLine : false);
                    lineElement.style.height = config.lineHeight * this.session.getRowLength(row) + "px";
                    lineElement.innerHTML = html.join("");
                }
                row++;
            }
        };
        this.scrollLines = function(config) {
            var oldConfig = this.config;
            this.config = config;
            if (!oldConfig || oldConfig.lastRow < config.firstRow) return this.update(config);
            if (config.lastRow < oldConfig.firstRow) return this.update(config);
            var el = this.element;
            if (oldConfig.firstRow < config.firstRow) for(var row = this.session.getFoldedRowCount(oldConfig.firstRow, config.firstRow - 1); row > 0; row--)el.removeChild(el.firstChild);
            if (oldConfig.lastRow > config.lastRow) for(var row = this.session.getFoldedRowCount(config.lastRow + 1, oldConfig.lastRow); row > 0; row--)el.removeChild(el.lastChild);
            if (config.firstRow < oldConfig.firstRow) {
                var fragment = this.$renderLinesFragment(config, config.firstRow, oldConfig.firstRow - 1);
                if (el.firstChild) el.insertBefore(fragment, el.firstChild);
                else el.appendChild(fragment);
            }
            if (config.lastRow > oldConfig.lastRow) {
                var fragment = this.$renderLinesFragment(config, oldConfig.lastRow + 1, config.lastRow);
                el.appendChild(fragment);
            }
        };
        this.$renderLinesFragment = function(config, firstRow, lastRow) {
            var fragment = this.element.ownerDocument.createDocumentFragment();
            var row = firstRow;
            var foldLine = this.session.getNextFoldLine(row);
            var foldStart = foldLine ? foldLine.start.row : Infinity;
            while(true){
                if (row > foldStart) {
                    row = foldLine.end.row + 1;
                    foldLine = this.session.getNextFoldLine(row, foldLine);
                    foldStart = foldLine ? foldLine.start.row : Infinity;
                }
                if (row > lastRow) break;
                var container = dom.createElement("div");
                var html = [];
                this.$renderLine(html, row, false, row == foldStart ? foldLine : false);
                container.innerHTML = html.join("");
                if (this.$useLineGroups()) {
                    container.className = 'ace_line_group';
                    fragment.appendChild(container);
                    container.style.height = config.lineHeight * this.session.getRowLength(row) + "px";
                } else while(container.firstChild)fragment.appendChild(container.firstChild);
                row++;
            }
            return fragment;
        };
        this.update = function(config) {
            this.config = config;
            var html = [];
            var firstRow = config.firstRow, lastRow = config.lastRow;
            var row = firstRow;
            var foldLine = this.session.getNextFoldLine(row);
            var foldStart = foldLine ? foldLine.start.row : Infinity;
            while(true){
                if (row > foldStart) {
                    row = foldLine.end.row + 1;
                    foldLine = this.session.getNextFoldLine(row, foldLine);
                    foldStart = foldLine ? foldLine.start.row : Infinity;
                }
                if (row > lastRow) break;
                if (this.$useLineGroups()) html.push("<div class='ace_line_group' style='height:", config.lineHeight * this.session.getRowLength(row), "px'>");
                this.$renderLine(html, row, false, row == foldStart ? foldLine : false);
                if (this.$useLineGroups()) html.push("</div>"); // end the line group
                row++;
            }
            this.element.innerHTML = html.join("");
        };
        this.$textToken = {
            "text": true,
            "rparen": true,
            "lparen": true
        };
        this.$renderToken = function(stringBuilder, screenColumn, token, value) {
            var self = this;
            var replaceReg = /\t|&|<|>|( +)|([\x00-\x1f\x80-\xa0\xad\u1680\u180E\u2000-\u200f\u2028\u2029\u202F\u205F\u3000\uFEFF\uFFF9-\uFFFC])|[\u1100-\u115F\u11A3-\u11A7\u11FA-\u11FF\u2329-\u232A\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFB\u3000-\u303E\u3041-\u3096\u3099-\u30FF\u3105-\u312D\u3131-\u318E\u3190-\u31BA\u31C0-\u31E3\u31F0-\u321E\u3220-\u3247\u3250-\u32FE\u3300-\u4DBF\u4E00-\uA48C\uA490-\uA4C6\uA960-\uA97C\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFAFF\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE66\uFE68-\uFE6B\uFF01-\uFF60\uFFE0-\uFFE6]|[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
            var replaceFunc = function(c, a, b, tabIdx, idx4) {
                if (a) return self.showInvisibles ? "<span class='ace_invisible ace_invisible_space'>" + lang.stringRepeat(self.SPACE_CHAR, c.length) + "</span>" : c;
                else if (c == "&") return "&#38;";
                else if (c == "<") return "&#60;";
                else if (c == ">") return "&#62;";
                else if (c == "\t") {
                    var tabSize = self.session.getScreenTabSize(screenColumn + tabIdx);
                    screenColumn += tabSize - 1;
                    return self.$tabStrings[tabSize];
                } else if (c == "\u3000") {
                    var classToUse = self.showInvisibles ? "ace_cjk ace_invisible ace_invisible_space" : "ace_cjk";
                    var space = self.showInvisibles ? self.SPACE_CHAR : "";
                    screenColumn += 1;
                    return "<span class='" + classToUse + "' style='width:" + self.config.characterWidth * 2 + "px'>" + space + "</span>";
                } else if (b) return "<span class='ace_invisible ace_invisible_space ace_invalid'>" + self.SPACE_CHAR + "</span>";
                else {
                    screenColumn += 1;
                    return "<span class='ace_cjk' style='width:" + self.config.characterWidth * 2 + "px'>" + c + "</span>";
                }
            };
            var output = value.replace(replaceReg, replaceFunc);
            if (!this.$textToken[token.type]) {
                var classes = "ace_" + token.type.replace(/\./g, " ace_");
                var style = "";
                if (token.type == "fold") style = " style='width:" + token.value.length * this.config.characterWidth + "px;' ";
                stringBuilder.push("<span class='", classes, "'", style, ">", output, "</span>");
            } else stringBuilder.push(output);
            return screenColumn + value.length;
        };
        this.renderIndentGuide = function(stringBuilder, value, max) {
            var cols = value.search(this.$indentGuideRe);
            if (cols <= 0 || cols >= max) return value;
            if (value[0] == " ") {
                cols -= cols % this.tabSize;
                stringBuilder.push(lang.stringRepeat(this.$tabStrings[" "], cols / this.tabSize));
                return value.substr(cols);
            } else if (value[0] == "\t") {
                stringBuilder.push(lang.stringRepeat(this.$tabStrings["\t"], cols));
                return value.substr(cols);
            }
            return value;
        };
        this.$renderWrappedLine = function(stringBuilder, tokens, splits, onlyContents) {
            var chars = 0;
            var split = 0;
            var splitChars = splits[0];
            var screenColumn = 0;
            for(var i = 0; i < tokens.length; i++){
                var token = tokens[i];
                var value = token.value;
                if (i == 0 && this.displayIndentGuides) {
                    chars = value.length;
                    value = this.renderIndentGuide(stringBuilder, value, splitChars);
                    if (!value) continue;
                    chars -= value.length;
                }
                if (chars + value.length < splitChars) {
                    screenColumn = this.$renderToken(stringBuilder, screenColumn, token, value);
                    chars += value.length;
                } else {
                    while(chars + value.length >= splitChars){
                        screenColumn = this.$renderToken(stringBuilder, screenColumn, token, value.substring(0, splitChars - chars));
                        value = value.substring(splitChars - chars);
                        chars = splitChars;
                        if (!onlyContents) stringBuilder.push("</div>", "<div class='ace_line' style='height:", this.config.lineHeight, "px'>");
                        stringBuilder.push(lang.stringRepeat("\xa0", splits.indent));
                        split++;
                        screenColumn = 0;
                        splitChars = splits[split] || Number.MAX_VALUE;
                    }
                    if (value.length != 0) {
                        chars += value.length;
                        screenColumn = this.$renderToken(stringBuilder, screenColumn, token, value);
                    }
                }
            }
        };
        this.$renderSimpleLine = function(stringBuilder, tokens) {
            var screenColumn = 0;
            var token = tokens[0];
            var value = token.value;
            if (this.displayIndentGuides) value = this.renderIndentGuide(stringBuilder, value);
            if (value) screenColumn = this.$renderToken(stringBuilder, screenColumn, token, value);
            for(var i = 1; i < tokens.length; i++){
                token = tokens[i];
                value = token.value;
                screenColumn = this.$renderToken(stringBuilder, screenColumn, token, value);
            }
        };
        this.$renderLine = function(stringBuilder, row, onlyContents, foldLine) {
            if (!foldLine && foldLine != false) foldLine = this.session.getFoldLine(row);
            if (foldLine) var tokens = this.$getFoldLineTokens(row, foldLine);
            else var tokens = this.session.getTokens(row);
            if (!onlyContents) stringBuilder.push("<div class='ace_line' style='height:", this.config.lineHeight * (this.$useLineGroups() ? 1 : this.session.getRowLength(row)), "px'>");
            if (tokens.length) {
                var splits = this.session.getRowSplitData(row);
                if (splits && splits.length) this.$renderWrappedLine(stringBuilder, tokens, splits, onlyContents);
                else this.$renderSimpleLine(stringBuilder, tokens);
            }
            if (this.showInvisibles) {
                if (foldLine) row = foldLine.end.row;
                stringBuilder.push("<span class='ace_invisible ace_invisible_eol'>", row == this.session.getLength() - 1 ? this.EOF_CHAR : this.EOL_CHAR, "</span>");
            }
            if (!onlyContents) stringBuilder.push("</div>");
        };
        this.$getFoldLineTokens = function(row, foldLine) {
            var session = this.session;
            var renderTokens = [];
            function addTokens(tokens, from, to) {
                var idx = 0, col = 0;
                while(col + tokens[idx].value.length < from){
                    col += tokens[idx].value.length;
                    idx++;
                    if (idx == tokens.length) return;
                }
                if (col != from) {
                    var value = tokens[idx].value.substring(from - col);
                    if (value.length > to - from) value = value.substring(0, to - from);
                    renderTokens.push({
                        type: tokens[idx].type,
                        value: value
                    });
                    col = from + value.length;
                    idx += 1;
                }
                while(col < to && idx < tokens.length){
                    var value = tokens[idx].value;
                    if (value.length + col > to) renderTokens.push({
                        type: tokens[idx].type,
                        value: value.substring(0, to - col)
                    });
                    else renderTokens.push(tokens[idx]);
                    col += value.length;
                    idx += 1;
                }
            }
            var tokens = session.getTokens(row);
            foldLine.walk(function(placeholder, row, column, lastColumn, isNewRow) {
                if (placeholder != null) renderTokens.push({
                    type: "fold",
                    value: placeholder
                });
                else {
                    if (isNewRow) tokens = session.getTokens(row);
                    if (tokens.length) addTokens(tokens, lastColumn, column);
                }
            }, foldLine.end.row, this.session.getLine(foldLine.end.row).length);
            return renderTokens;
        };
        this.$useLineGroups = function() {
            return this.session.getUseWrapMode();
        };
        this.destroy = function() {
            clearInterval(this.$pollSizeChangesTimer);
            if (this.$measureNode) this.$measureNode.parentNode.removeChild(this.$measureNode);
            delete this.$measureNode;
        };
    }).call(Text.prototype);
    exports.Text = Text;
});
ace.define("ace/layer/cursor", [
    "require",
    "exports",
    "module",
    "ace/lib/dom"
], function(acequire, exports, module1) {
    "use strict";
    var dom = acequire("../lib/dom");
    var isIE8;
    var Cursor = function(parentEl) {
        this.element = dom.createElement("div");
        this.element.className = "ace_layer ace_cursor-layer";
        parentEl.appendChild(this.element);
        if (isIE8 === undefined) isIE8 = !("opacity" in this.element.style);
        this.isVisible = false;
        this.isBlinking = true;
        this.blinkInterval = 1000;
        this.smoothBlinking = false;
        this.cursors = [];
        this.cursor = this.addCursor();
        dom.addCssClass(this.element, "ace_hidden-cursors");
        this.$updateCursors = (isIE8 ? this.$updateVisibility : this.$updateOpacity).bind(this);
    };
    (function() {
        this.$updateVisibility = function(val) {
            var cursors = this.cursors;
            for(var i = cursors.length; i--;)cursors[i].style.visibility = val ? "" : "hidden";
        };
        this.$updateOpacity = function(val) {
            var cursors = this.cursors;
            for(var i = cursors.length; i--;)cursors[i].style.opacity = val ? "" : "0";
        };
        this.$padding = 0;
        this.setPadding = function(padding) {
            this.$padding = padding;
        };
        this.setSession = function(session) {
            this.session = session;
        };
        this.setBlinking = function(blinking) {
            if (blinking != this.isBlinking) {
                this.isBlinking = blinking;
                this.restartTimer();
            }
        };
        this.setBlinkInterval = function(blinkInterval) {
            if (blinkInterval != this.blinkInterval) {
                this.blinkInterval = blinkInterval;
                this.restartTimer();
            }
        };
        this.setSmoothBlinking = function(smoothBlinking) {
            if (smoothBlinking != this.smoothBlinking && !isIE8) {
                this.smoothBlinking = smoothBlinking;
                dom.setCssClass(this.element, "ace_smooth-blinking", smoothBlinking);
                this.$updateCursors(true);
                this.$updateCursors = this.$updateOpacity.bind(this);
                this.restartTimer();
            }
        };
        this.addCursor = function() {
            var el = dom.createElement("div");
            el.className = "ace_cursor";
            this.element.appendChild(el);
            this.cursors.push(el);
            return el;
        };
        this.removeCursor = function() {
            if (this.cursors.length > 1) {
                var el = this.cursors.pop();
                el.parentNode.removeChild(el);
                return el;
            }
        };
        this.hideCursor = function() {
            this.isVisible = false;
            dom.addCssClass(this.element, "ace_hidden-cursors");
            this.restartTimer();
        };
        this.showCursor = function() {
            this.isVisible = true;
            dom.removeCssClass(this.element, "ace_hidden-cursors");
            this.restartTimer();
        };
        this.restartTimer = function() {
            var update = this.$updateCursors;
            clearInterval(this.intervalId);
            clearTimeout(this.timeoutId);
            if (this.smoothBlinking) dom.removeCssClass(this.element, "ace_smooth-blinking");
            update(true);
            if (!this.isBlinking || !this.blinkInterval || !this.isVisible) return;
            if (this.smoothBlinking) setTimeout((function() {
                dom.addCssClass(this.element, "ace_smooth-blinking");
            }).bind(this));
            var blink = (function() {
                this.timeoutId = setTimeout(function() {
                    update(false);
                }, 0.6 * this.blinkInterval);
            }).bind(this);
            this.intervalId = setInterval(function() {
                update(true);
                blink();
            }, this.blinkInterval);
            blink();
        };
        this.getPixelPosition = function(position, onScreen) {
            if (!this.config || !this.session) return {
                left: 0,
                top: 0
            };
            if (!position) position = this.session.selection.getCursor();
            var pos = this.session.documentToScreenPosition(position);
            var cursorLeft = this.$padding + (this.session.$bidiHandler.isBidiRow(pos.row, position.row) ? this.session.$bidiHandler.getPosLeft(pos.column) : pos.column * this.config.characterWidth);
            var cursorTop = (pos.row - (onScreen ? this.config.firstRowScreen : 0)) * this.config.lineHeight;
            return {
                left: cursorLeft,
                top: cursorTop
            };
        };
        this.update = function(config) {
            this.config = config;
            var selections = this.session.$selectionMarkers;
            var i = 0, cursorIndex = 0;
            if (selections === undefined || selections.length === 0) selections = [
                {
                    cursor: null
                }
            ];
            for(var i = 0, n = selections.length; i < n; i++){
                var pixelPos = this.getPixelPosition(selections[i].cursor, true);
                if ((pixelPos.top > config.height + config.offset || pixelPos.top < 0) && i > 1) continue;
                var style = (this.cursors[cursorIndex++] || this.addCursor()).style;
                if (!this.drawCursor) {
                    style.left = pixelPos.left + "px";
                    style.top = pixelPos.top + "px";
                    style.width = config.characterWidth + "px";
                    style.height = config.lineHeight + "px";
                } else this.drawCursor(style, pixelPos, config, selections[i], this.session);
            }
            while(this.cursors.length > cursorIndex)this.removeCursor();
            var overwrite = this.session.getOverwrite();
            this.$setOverwrite(overwrite);
            this.$pixelPos = pixelPos;
            this.restartTimer();
        };
        this.drawCursor = null;
        this.$setOverwrite = function(overwrite) {
            if (overwrite != this.overwrite) {
                this.overwrite = overwrite;
                if (overwrite) dom.addCssClass(this.element, "ace_overwrite-cursors");
                else dom.removeCssClass(this.element, "ace_overwrite-cursors");
            }
        };
        this.destroy = function() {
            clearInterval(this.intervalId);
            clearTimeout(this.timeoutId);
        };
    }).call(Cursor.prototype);
    exports.Cursor = Cursor;
});
ace.define("ace/scrollbar", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/lib/dom",
    "ace/lib/event",
    "ace/lib/event_emitter"
], function(acequire, exports, module1) {
    "use strict";
    var oop = acequire("./lib/oop");
    var dom = acequire("./lib/dom");
    var event = acequire("./lib/event");
    var EventEmitter = acequire("./lib/event_emitter").EventEmitter;
    var MAX_SCROLL_H = 0x8000;
    var ScrollBar = function(parent) {
        this.element = dom.createElement("div");
        this.element.className = "ace_scrollbar ace_scrollbar" + this.classSuffix;
        this.inner = dom.createElement("div");
        this.inner.className = "ace_scrollbar-inner";
        this.element.appendChild(this.inner);
        parent.appendChild(this.element);
        this.setVisible(false);
        this.skipEvent = false;
        event.addListener(this.element, "scroll", this.onScroll.bind(this));
        event.addListener(this.element, "mousedown", event.preventDefault);
    };
    (function() {
        oop.implement(this, EventEmitter);
        this.setVisible = function(isVisible) {
            this.element.style.display = isVisible ? "" : "none";
            this.isVisible = isVisible;
            this.coeff = 1;
        };
    }).call(ScrollBar.prototype);
    var VScrollBar = function(parent, renderer) {
        ScrollBar.call(this, parent);
        this.scrollTop = 0;
        this.scrollHeight = 0;
        renderer.$scrollbarWidth = this.width = dom.scrollbarWidth(parent.ownerDocument);
        this.inner.style.width = this.element.style.width = (this.width || 15) + 5 + "px";
        this.$minWidth = 0;
    };
    oop.inherits(VScrollBar, ScrollBar);
    (function() {
        this.classSuffix = '-v';
        this.onScroll = function() {
            if (!this.skipEvent) {
                this.scrollTop = this.element.scrollTop;
                if (this.coeff != 1) {
                    var h = this.element.clientHeight / this.scrollHeight;
                    this.scrollTop = this.scrollTop * (1 - h) / (this.coeff - h);
                }
                this._emit("scroll", {
                    data: this.scrollTop
                });
            }
            this.skipEvent = false;
        };
        this.getWidth = function() {
            return Math.max(this.isVisible ? this.width : 0, this.$minWidth || 0);
        };
        this.setHeight = function(height) {
            this.element.style.height = height + "px";
        };
        this.setInnerHeight = this.setScrollHeight = function(height) {
            this.scrollHeight = height;
            if (height > MAX_SCROLL_H) {
                this.coeff = MAX_SCROLL_H / height;
                height = MAX_SCROLL_H;
            } else if (this.coeff != 1) this.coeff = 1;
            this.inner.style.height = height + "px";
        };
        this.setScrollTop = function(scrollTop) {
            if (this.scrollTop != scrollTop) {
                this.skipEvent = true;
                this.scrollTop = scrollTop;
                this.element.scrollTop = scrollTop * this.coeff;
            }
        };
    }).call(VScrollBar.prototype);
    var HScrollBar = function(parent, renderer) {
        ScrollBar.call(this, parent);
        this.scrollLeft = 0;
        this.height = renderer.$scrollbarWidth;
        this.inner.style.height = this.element.style.height = (this.height || 15) + 5 + "px";
    };
    oop.inherits(HScrollBar, ScrollBar);
    (function() {
        this.classSuffix = '-h';
        this.onScroll = function() {
            if (!this.skipEvent) {
                this.scrollLeft = this.element.scrollLeft;
                this._emit("scroll", {
                    data: this.scrollLeft
                });
            }
            this.skipEvent = false;
        };
        this.getHeight = function() {
            return this.isVisible ? this.height : 0;
        };
        this.setWidth = function(width) {
            this.element.style.width = width + "px";
        };
        this.setInnerWidth = function(width) {
            this.inner.style.width = width + "px";
        };
        this.setScrollWidth = function(width) {
            this.inner.style.width = width + "px";
        };
        this.setScrollLeft = function(scrollLeft) {
            if (this.scrollLeft != scrollLeft) {
                this.skipEvent = true;
                this.scrollLeft = this.element.scrollLeft = scrollLeft;
            }
        };
    }).call(HScrollBar.prototype);
    exports.ScrollBar = VScrollBar; // backward compatibility
    exports.ScrollBarV = VScrollBar; // backward compatibility
    exports.ScrollBarH = HScrollBar; // backward compatibility
    exports.VScrollBar = VScrollBar;
    exports.HScrollBar = HScrollBar;
});
ace.define("ace/renderloop", [
    "require",
    "exports",
    "module",
    "ace/lib/event"
], function(acequire, exports, module1) {
    "use strict";
    var event = acequire("./lib/event");
    var RenderLoop = function(onRender, win) {
        this.onRender = onRender;
        this.pending = false;
        this.changes = 0;
        this.window = win || window;
    };
    (function() {
        this.schedule = function(change) {
            this.changes = this.changes | change;
            if (!this.pending && this.changes) {
                this.pending = true;
                var _self = this;
                event.nextFrame(function() {
                    _self.pending = false;
                    var changes;
                    while(changes = _self.changes){
                        _self.changes = 0;
                        _self.onRender(changes);
                    }
                }, this.window);
            }
        };
    }).call(RenderLoop.prototype);
    exports.RenderLoop = RenderLoop;
});
ace.define("ace/layer/font_metrics", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/lib/dom",
    "ace/lib/lang",
    "ace/lib/useragent",
    "ace/lib/event_emitter"
], function(acequire, exports, module1) {
    var oop = acequire("../lib/oop");
    var dom = acequire("../lib/dom");
    var lang = acequire("../lib/lang");
    var useragent = acequire("../lib/useragent");
    var EventEmitter = acequire("../lib/event_emitter").EventEmitter;
    var CHAR_COUNT = 0;
    var FontMetrics = exports.FontMetrics = function(parentEl) {
        this.el = dom.createElement("div");
        this.$setMeasureNodeStyles(this.el.style, true);
        this.$main = dom.createElement("div");
        this.$setMeasureNodeStyles(this.$main.style);
        this.$measureNode = dom.createElement("div");
        this.$setMeasureNodeStyles(this.$measureNode.style);
        this.el.appendChild(this.$main);
        this.el.appendChild(this.$measureNode);
        parentEl.appendChild(this.el);
        if (!CHAR_COUNT) this.$testFractionalRect();
        this.$measureNode.innerHTML = lang.stringRepeat("X", CHAR_COUNT);
        this.$characterSize = {
            width: 0,
            height: 0
        };
        this.checkForSizeChanges();
    };
    (function() {
        oop.implement(this, EventEmitter);
        this.$characterSize = {
            width: 0,
            height: 0
        };
        this.$testFractionalRect = function() {
            var el = dom.createElement("div");
            this.$setMeasureNodeStyles(el.style);
            el.style.width = "0.2px";
            document.documentElement.appendChild(el);
            var w = el.getBoundingClientRect().width;
            if (w > 0 && w < 1) CHAR_COUNT = 50;
            else CHAR_COUNT = 100;
            el.parentNode.removeChild(el);
        };
        this.$setMeasureNodeStyles = function(style, isRoot) {
            style.width = style.height = "auto";
            style.left = style.top = "0px";
            style.visibility = "hidden";
            style.position = "absolute";
            style.whiteSpace = "pre";
            if (useragent.isIE < 8) style["font-family"] = "inherit";
            else style.font = "inherit";
            style.overflow = isRoot ? "hidden" : "visible";
        };
        this.checkForSizeChanges = function() {
            var size = this.$measureSizes();
            if (size && (this.$characterSize.width !== size.width || this.$characterSize.height !== size.height)) {
                this.$measureNode.style.fontWeight = "bold";
                var boldSize = this.$measureSizes();
                this.$measureNode.style.fontWeight = "";
                this.$characterSize = size;
                this.charSizes = Object.create(null);
                this.allowBoldFonts = boldSize && boldSize.width === size.width && boldSize.height === size.height;
                this._emit("changeCharacterSize", {
                    data: size
                });
            }
        };
        this.$pollSizeChanges = function() {
            if (this.$pollSizeChangesTimer) return this.$pollSizeChangesTimer;
            var self = this;
            return this.$pollSizeChangesTimer = setInterval(function() {
                self.checkForSizeChanges();
            }, 500);
        };
        this.setPolling = function(val) {
            if (val) this.$pollSizeChanges();
            else if (this.$pollSizeChangesTimer) {
                clearInterval(this.$pollSizeChangesTimer);
                this.$pollSizeChangesTimer = 0;
            }
        };
        this.$measureSizes = function() {
            if (CHAR_COUNT === 50) {
                var rect = null;
                try {
                    rect = this.$measureNode.getBoundingClientRect();
                } catch (e) {
                    rect = {
                        width: 0,
                        height: 0
                    };
                }
                var size = {
                    height: rect.height,
                    width: rect.width / CHAR_COUNT
                };
            } else var size = {
                height: this.$measureNode.clientHeight,
                width: this.$measureNode.clientWidth / CHAR_COUNT
            };
            if (size.width === 0 || size.height === 0) return null;
            return size;
        };
        this.$measureCharWidth = function(ch) {
            this.$main.innerHTML = lang.stringRepeat(ch, CHAR_COUNT);
            var rect = this.$main.getBoundingClientRect();
            return rect.width / CHAR_COUNT;
        };
        this.getCharacterWidth = function(ch) {
            var w = this.charSizes[ch];
            if (w === undefined) w = this.charSizes[ch] = this.$measureCharWidth(ch) / this.$characterSize.width;
            return w;
        };
        this.destroy = function() {
            clearInterval(this.$pollSizeChangesTimer);
            if (this.el && this.el.parentNode) this.el.parentNode.removeChild(this.el);
        };
    }).call(FontMetrics.prototype);
});
ace.define("ace/virtual_renderer", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/lib/dom",
    "ace/config",
    "ace/lib/useragent",
    "ace/layer/gutter",
    "ace/layer/marker",
    "ace/layer/text",
    "ace/layer/cursor",
    "ace/scrollbar",
    "ace/scrollbar",
    "ace/renderloop",
    "ace/layer/font_metrics",
    "ace/lib/event_emitter"
], function(acequire, exports, module1) {
    "use strict";
    var oop = acequire("./lib/oop");
    var dom = acequire("./lib/dom");
    var config = acequire("./config");
    var useragent = acequire("./lib/useragent");
    var GutterLayer = acequire("./layer/gutter").Gutter;
    var MarkerLayer = acequire("./layer/marker").Marker;
    var TextLayer = acequire("./layer/text").Text;
    var CursorLayer = acequire("./layer/cursor").Cursor;
    var HScrollBar = acequire("./scrollbar").HScrollBar;
    var VScrollBar = acequire("./scrollbar").VScrollBar;
    var RenderLoop = acequire("./renderloop").RenderLoop;
    var FontMetrics = acequire("./layer/font_metrics").FontMetrics;
    var EventEmitter = acequire("./lib/event_emitter").EventEmitter;
    var editorCss = ".ace_editor {\
position: relative;\
overflow: hidden;\
font: 12px/normal 'Monaco', 'Menlo', 'Ubuntu Mono', 'Consolas', 'source-code-pro', monospace;\
direction: ltr;\
text-align: left;\
-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\
}\
.ace_scroller {\
position: absolute;\
overflow: hidden;\
top: 0;\
bottom: 0;\
background-color: inherit;\
-ms-user-select: none;\
-moz-user-select: none;\
-webkit-user-select: none;\
user-select: none;\
cursor: text;\
}\
.ace_content {\
position: absolute;\
-moz-box-sizing: border-box;\
-webkit-box-sizing: border-box;\
box-sizing: border-box;\
min-width: 100%;\
}\
.ace_dragging .ace_scroller:before{\
position: absolute;\
top: 0;\
left: 0;\
right: 0;\
bottom: 0;\
content: '';\
background: rgba(250, 250, 250, 0.01);\
z-index: 1000;\
}\
.ace_dragging.ace_dark .ace_scroller:before{\
background: rgba(0, 0, 0, 0.01);\
}\
.ace_selecting, .ace_selecting * {\
cursor: text !important;\
}\
.ace_gutter {\
position: absolute;\
overflow : hidden;\
width: auto;\
top: 0;\
bottom: 0;\
left: 0;\
cursor: default;\
z-index: 4;\
-ms-user-select: none;\
-moz-user-select: none;\
-webkit-user-select: none;\
user-select: none;\
}\
.ace_gutter-active-line {\
position: absolute;\
left: 0;\
right: 0;\
}\
.ace_scroller.ace_scroll-left {\
box-shadow: 17px 0 16px -16px rgba(0, 0, 0, 0.4) inset;\
}\
.ace_gutter-cell {\
padding-left: 19px;\
padding-right: 6px;\
background-repeat: no-repeat;\
}\
.ace_gutter-cell.ace_error {\
background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAABOFBMVEX/////////QRswFAb/Ui4wFAYwFAYwFAaWGAfDRymzOSH/PxswFAb/SiUwFAYwFAbUPRvjQiDllog5HhHdRybsTi3/Tyv9Tir+Syj/UC3////XurebMBIwFAb/RSHbPx/gUzfdwL3kzMivKBAwFAbbvbnhPx66NhowFAYwFAaZJg8wFAaxKBDZurf/RB6mMxb/SCMwFAYwFAbxQB3+RB4wFAb/Qhy4Oh+4QifbNRcwFAYwFAYwFAb/QRzdNhgwFAYwFAbav7v/Uy7oaE68MBK5LxLewr/r2NXewLswFAaxJw4wFAbkPRy2PyYwFAaxKhLm1tMwFAazPiQwFAaUGAb/QBrfOx3bvrv/VC/maE4wFAbRPBq6MRO8Qynew8Dp2tjfwb0wFAbx6eju5+by6uns4uH9/f36+vr/GkHjAAAAYnRSTlMAGt+64rnWu/bo8eAA4InH3+DwoN7j4eLi4xP99Nfg4+b+/u9B/eDs1MD1mO7+4PHg2MXa347g7vDizMLN4eG+Pv7i5evs/v79yu7S3/DV7/498Yv24eH+4ufQ3Ozu/v7+y13sRqwAAADLSURBVHjaZc/XDsFgGIBhtDrshlitmk2IrbHFqL2pvXf/+78DPokj7+Fz9qpU/9UXJIlhmPaTaQ6QPaz0mm+5gwkgovcV6GZzd5JtCQwgsxoHOvJO15kleRLAnMgHFIESUEPmawB9ngmelTtipwwfASilxOLyiV5UVUyVAfbG0cCPHig+GBkzAENHS0AstVF6bacZIOzgLmxsHbt2OecNgJC83JERmePUYq8ARGkJx6XtFsdddBQgZE2nPR6CICZhawjA4Fb/chv+399kfR+MMMDGOQAAAABJRU5ErkJggg==\");\
background-repeat: no-repeat;\
background-position: 2px center;\
}\
.ace_gutter-cell.ace_warning {\
background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAmVBMVEX///8AAAD///8AAAAAAABPSzb/5sAAAAB/blH/73z/ulkAAAAAAAD85pkAAAAAAAACAgP/vGz/rkDerGbGrV7/pkQICAf////e0IsAAAD/oED/qTvhrnUAAAD/yHD/njcAAADuv2r/nz//oTj/p064oGf/zHAAAAA9Nir/tFIAAAD/tlTiuWf/tkIAAACynXEAAAAAAAAtIRW7zBpBAAAAM3RSTlMAABR1m7RXO8Ln31Z36zT+neXe5OzooRDfn+TZ4p3h2hTf4t3k3ucyrN1K5+Xaks52Sfs9CXgrAAAAjklEQVR42o3PbQ+CIBQFYEwboPhSYgoYunIqqLn6/z8uYdH8Vmdnu9vz4WwXgN/xTPRD2+sgOcZjsge/whXZgUaYYvT8QnuJaUrjrHUQreGczuEafQCO/SJTufTbroWsPgsllVhq3wJEk2jUSzX3CUEDJC84707djRc5MTAQxoLgupWRwW6UB5fS++NV8AbOZgnsC7BpEAAAAABJRU5ErkJggg==\");\
background-position: 2px center;\
}\
.ace_gutter-cell.ace_info {\
background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAAAAAA6mKC9AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAAJ0Uk5TAAB2k804AAAAPklEQVQY02NgIB68QuO3tiLznjAwpKTgNyDbMegwisCHZUETUZV0ZqOquBpXj2rtnpSJT1AEnnRmL2OgGgAAIKkRQap2htgAAAAASUVORK5CYII=\");\
background-position: 2px center;\
}\
.ace_dark .ace_gutter-cell.ace_info {\
background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQBAMAAADt3eJSAAAAJFBMVEUAAAChoaGAgIAqKiq+vr6tra1ZWVmUlJSbm5s8PDxubm56enrdgzg3AAAAAXRSTlMAQObYZgAAAClJREFUeNpjYMAPdsMYHegyJZFQBlsUlMFVCWUYKkAZMxZAGdxlDMQBAG+TBP4B6RyJAAAAAElFTkSuQmCC\");\
}\
.ace_scrollbar {\
position: absolute;\
right: 0;\
bottom: 0;\
z-index: 6;\
}\
.ace_scrollbar-inner {\
position: absolute;\
cursor: text;\
left: 0;\
top: 0;\
}\
.ace_scrollbar-v{\
overflow-x: hidden;\
overflow-y: scroll;\
top: 0;\
}\
.ace_scrollbar-h {\
overflow-x: scroll;\
overflow-y: hidden;\
left: 0;\
}\
.ace_print-margin {\
position: absolute;\
height: 100%;\
}\
.ace_text-input {\
position: absolute;\
z-index: 0;\
width: 0.5em;\
height: 1em;\
opacity: 0;\
background: transparent;\
-moz-appearance: none;\
appearance: none;\
border: none;\
resize: none;\
outline: none;\
overflow: hidden;\
font: inherit;\
padding: 0 1px;\
margin: 0 -1px;\
text-indent: -1em;\
-ms-user-select: text;\
-moz-user-select: text;\
-webkit-user-select: text;\
user-select: text;\
white-space: pre!important;\
}\
.ace_text-input.ace_composition {\
background: inherit;\
color: inherit;\
z-index: 1000;\
opacity: 1;\
text-indent: 0;\
}\
.ace_layer {\
z-index: 1;\
position: absolute;\
overflow: hidden;\
word-wrap: normal;\
white-space: pre;\
height: 100%;\
width: 100%;\
-moz-box-sizing: border-box;\
-webkit-box-sizing: border-box;\
box-sizing: border-box;\
pointer-events: none;\
}\
.ace_gutter-layer {\
position: relative;\
width: auto;\
text-align: right;\
pointer-events: auto;\
}\
.ace_text-layer {\
font: inherit !important;\
}\
.ace_cjk {\
display: inline-block;\
text-align: center;\
}\
.ace_cursor-layer {\
z-index: 4;\
}\
.ace_cursor {\
z-index: 4;\
position: absolute;\
-moz-box-sizing: border-box;\
-webkit-box-sizing: border-box;\
box-sizing: border-box;\
border-left: 2px solid;\
transform: translatez(0);\
}\
.ace_multiselect .ace_cursor {\
border-left-width: 1px;\
}\
.ace_slim-cursors .ace_cursor {\
border-left-width: 1px;\
}\
.ace_overwrite-cursors .ace_cursor {\
border-left-width: 0;\
border-bottom: 1px solid;\
}\
.ace_hidden-cursors .ace_cursor {\
opacity: 0.2;\
}\
.ace_smooth-blinking .ace_cursor {\
-webkit-transition: opacity 0.18s;\
transition: opacity 0.18s;\
}\
.ace_marker-layer .ace_step, .ace_marker-layer .ace_stack {\
position: absolute;\
z-index: 3;\
}\
.ace_marker-layer .ace_selection {\
position: absolute;\
z-index: 5;\
}\
.ace_marker-layer .ace_bracket {\
position: absolute;\
z-index: 6;\
}\
.ace_marker-layer .ace_active-line {\
position: absolute;\
z-index: 2;\
}\
.ace_marker-layer .ace_selected-word {\
position: absolute;\
z-index: 4;\
-moz-box-sizing: border-box;\
-webkit-box-sizing: border-box;\
box-sizing: border-box;\
}\
.ace_line .ace_fold {\
-moz-box-sizing: border-box;\
-webkit-box-sizing: border-box;\
box-sizing: border-box;\
display: inline-block;\
height: 11px;\
margin-top: -2px;\
vertical-align: middle;\
background-image:\
url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAJCAYAAADU6McMAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAJpJREFUeNpi/P//PwOlgAXGYGRklAVSokD8GmjwY1wasKljQpYACtpCFeADcHVQfQyMQAwzwAZI3wJKvCLkfKBaMSClBlR7BOQikCFGQEErIH0VqkabiGCAqwUadAzZJRxQr/0gwiXIal8zQQPnNVTgJ1TdawL0T5gBIP1MUJNhBv2HKoQHHjqNrA4WO4zY0glyNKLT2KIfIMAAQsdgGiXvgnYAAAAASUVORK5CYII=\"),\
url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAA3CAYAAADNNiA5AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAACJJREFUeNpi+P//fxgTAwPDBxDxD078RSX+YeEyDFMCIMAAI3INmXiwf2YAAAAASUVORK5CYII=\");\
background-repeat: no-repeat, repeat-x;\
background-position: center center, top left;\
color: transparent;\
border: 1px solid black;\
border-radius: 2px;\
cursor: pointer;\
pointer-events: auto;\
}\
.ace_dark .ace_fold {\
}\
.ace_fold:hover{\
background-image:\
url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAJCAYAAADU6McMAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAJpJREFUeNpi/P//PwOlgAXGYGRklAVSokD8GmjwY1wasKljQpYACtpCFeADcHVQfQyMQAwzwAZI3wJKvCLkfKBaMSClBlR7BOQikCFGQEErIH0VqkabiGCAqwUadAzZJRxQr/0gwiXIal8zQQPnNVTgJ1TdawL0T5gBIP1MUJNhBv2HKoQHHjqNrA4WO4zY0glyNKLT2KIfIMAAQsdgGiXvgnYAAAAASUVORK5CYII=\"),\
url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAA3CAYAAADNNiA5AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAACBJREFUeNpi+P//fz4TAwPDZxDxD5X4i5fLMEwJgAADAEPVDbjNw87ZAAAAAElFTkSuQmCC\");\
}\
.ace_tooltip {\
background-color: #FFF;\
background-image: -webkit-linear-gradient(top, transparent, rgba(0, 0, 0, 0.1));\
background-image: linear-gradient(to bottom, transparent, rgba(0, 0, 0, 0.1));\
border: 1px solid gray;\
border-radius: 1px;\
box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);\
color: black;\
max-width: 100%;\
padding: 3px 4px;\
position: fixed;\
z-index: 999999;\
-moz-box-sizing: border-box;\
-webkit-box-sizing: border-box;\
box-sizing: border-box;\
cursor: default;\
white-space: pre;\
word-wrap: break-word;\
line-height: normal;\
font-style: normal;\
font-weight: normal;\
letter-spacing: normal;\
pointer-events: none;\
}\
.ace_folding-enabled > .ace_gutter-cell {\
padding-right: 13px;\
}\
.ace_fold-widget {\
-moz-box-sizing: border-box;\
-webkit-box-sizing: border-box;\
box-sizing: border-box;\
margin: 0 -12px 0 1px;\
display: none;\
width: 11px;\
vertical-align: top;\
background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAANElEQVR42mWKsQ0AMAzC8ixLlrzQjzmBiEjp0A6WwBCSPgKAXoLkqSot7nN3yMwR7pZ32NzpKkVoDBUxKAAAAABJRU5ErkJggg==\");\
background-repeat: no-repeat;\
background-position: center;\
border-radius: 3px;\
border: 1px solid transparent;\
cursor: pointer;\
}\
.ace_folding-enabled .ace_fold-widget {\
display: inline-block;   \
}\
.ace_fold-widget.ace_end {\
background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAANElEQVR42m3HwQkAMAhD0YzsRchFKI7sAikeWkrxwScEB0nh5e7KTPWimZki4tYfVbX+MNl4pyZXejUO1QAAAABJRU5ErkJggg==\");\
}\
.ace_fold-widget.ace_closed {\
background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAGCAYAAAAG5SQMAAAAOUlEQVR42jXKwQkAMAgDwKwqKD4EwQ26sSOkVWjgIIHAzPiCgaqiqnJHZnKICBERHN194O5b9vbLuAVRL+l0YWnZAAAAAElFTkSuQmCCXA==\");\
}\
.ace_fold-widget:hover {\
border: 1px solid rgba(0, 0, 0, 0.3);\
background-color: rgba(255, 255, 255, 0.2);\
box-shadow: 0 1px 1px rgba(255, 255, 255, 0.7);\
}\
.ace_fold-widget:active {\
border: 1px solid rgba(0, 0, 0, 0.4);\
background-color: rgba(0, 0, 0, 0.05);\
box-shadow: 0 1px 1px rgba(255, 255, 255, 0.8);\
}\
.ace_dark .ace_fold-widget {\
background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHklEQVQIW2P4//8/AzoGEQ7oGCaLLAhWiSwB146BAQCSTPYocqT0AAAAAElFTkSuQmCC\");\
}\
.ace_dark .ace_fold-widget.ace_end {\
background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAH0lEQVQIW2P4//8/AxQ7wNjIAjDMgC4AxjCVKBirIAAF0kz2rlhxpAAAAABJRU5ErkJggg==\");\
}\
.ace_dark .ace_fold-widget.ace_closed {\
background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAFCAYAAACAcVaiAAAAHElEQVQIW2P4//+/AxAzgDADlOOAznHAKgPWAwARji8UIDTfQQAAAABJRU5ErkJggg==\");\
}\
.ace_dark .ace_fold-widget:hover {\
box-shadow: 0 1px 1px rgba(255, 255, 255, 0.2);\
background-color: rgba(255, 255, 255, 0.1);\
}\
.ace_dark .ace_fold-widget:active {\
box-shadow: 0 1px 1px rgba(255, 255, 255, 0.2);\
}\
.ace_fold-widget.ace_invalid {\
background-color: #FFB4B4;\
border-color: #DE5555;\
}\
.ace_fade-fold-widgets .ace_fold-widget {\
-webkit-transition: opacity 0.4s ease 0.05s;\
transition: opacity 0.4s ease 0.05s;\
opacity: 0;\
}\
.ace_fade-fold-widgets:hover .ace_fold-widget {\
-webkit-transition: opacity 0.05s ease 0.05s;\
transition: opacity 0.05s ease 0.05s;\
opacity:1;\
}\
.ace_underline {\
text-decoration: underline;\
}\
.ace_bold {\
font-weight: bold;\
}\
.ace_nobold .ace_bold {\
font-weight: normal;\
}\
.ace_italic {\
font-style: italic;\
}\
.ace_error-marker {\
background-color: rgba(255, 0, 0,0.2);\
position: absolute;\
z-index: 9;\
}\
.ace_highlight-marker {\
background-color: rgba(255, 255, 0,0.2);\
position: absolute;\
z-index: 8;\
}\
.ace_br1 {border-top-left-radius    : 3px;}\
.ace_br2 {border-top-right-radius   : 3px;}\
.ace_br3 {border-top-left-radius    : 3px; border-top-right-radius:    3px;}\
.ace_br4 {border-bottom-right-radius: 3px;}\
.ace_br5 {border-top-left-radius    : 3px; border-bottom-right-radius: 3px;}\
.ace_br6 {border-top-right-radius   : 3px; border-bottom-right-radius: 3px;}\
.ace_br7 {border-top-left-radius    : 3px; border-top-right-radius:    3px; border-bottom-right-radius: 3px;}\
.ace_br8 {border-bottom-left-radius : 3px;}\
.ace_br9 {border-top-left-radius    : 3px; border-bottom-left-radius:  3px;}\
.ace_br10{border-top-right-radius   : 3px; border-bottom-left-radius:  3px;}\
.ace_br11{border-top-left-radius    : 3px; border-top-right-radius:    3px; border-bottom-left-radius:  3px;}\
.ace_br12{border-bottom-right-radius: 3px; border-bottom-left-radius:  3px;}\
.ace_br13{border-top-left-radius    : 3px; border-bottom-right-radius: 3px; border-bottom-left-radius:  3px;}\
.ace_br14{border-top-right-radius   : 3px; border-bottom-right-radius: 3px; border-bottom-left-radius:  3px;}\
.ace_br15{border-top-left-radius    : 3px; border-top-right-radius:    3px; border-bottom-right-radius: 3px; border-bottom-left-radius: 3px;}\
.ace_text-input-ios {\
position: absolute !important;\
top: -100000px !important;\
left: -100000px !important;\
}\
";
    dom.importCssString(editorCss, "ace_editor.css");
    var VirtualRenderer = function(container, theme) {
        var _self = this;
        this.container = container || dom.createElement("div");
        this.$keepTextAreaAtCursor = !useragent.isOldIE;
        dom.addCssClass(this.container, "ace_editor");
        this.setTheme(theme);
        this.$gutter = dom.createElement("div");
        this.$gutter.className = "ace_gutter";
        this.container.appendChild(this.$gutter);
        this.$gutter.setAttribute("aria-hidden", true);
        this.scroller = dom.createElement("div");
        this.scroller.className = "ace_scroller";
        this.container.appendChild(this.scroller);
        this.content = dom.createElement("div");
        this.content.className = "ace_content";
        this.scroller.appendChild(this.content);
        this.$gutterLayer = new GutterLayer(this.$gutter);
        this.$gutterLayer.on("changeGutterWidth", this.onGutterResize.bind(this));
        this.$markerBack = new MarkerLayer(this.content);
        var textLayer = this.$textLayer = new TextLayer(this.content);
        this.canvas = textLayer.element;
        this.$markerFront = new MarkerLayer(this.content);
        this.$cursorLayer = new CursorLayer(this.content);
        this.$horizScroll = false;
        this.$vScroll = false;
        this.scrollBar = this.scrollBarV = new VScrollBar(this.container, this);
        this.scrollBarH = new HScrollBar(this.container, this);
        this.scrollBarV.addEventListener("scroll", function(e) {
            if (!_self.$scrollAnimation) _self.session.setScrollTop(e.data - _self.scrollMargin.top);
        });
        this.scrollBarH.addEventListener("scroll", function(e) {
            if (!_self.$scrollAnimation) _self.session.setScrollLeft(e.data - _self.scrollMargin.left);
        });
        this.scrollTop = 0;
        this.scrollLeft = 0;
        this.cursorPos = {
            row: 0,
            column: 0
        };
        this.$fontMetrics = new FontMetrics(this.container);
        this.$textLayer.$setFontMetrics(this.$fontMetrics);
        this.$textLayer.addEventListener("changeCharacterSize", function(e) {
            _self.updateCharacterSize();
            _self.onResize(true, _self.gutterWidth, _self.$size.width, _self.$size.height);
            _self._signal("changeCharacterSize", e);
        });
        this.$size = {
            width: 0,
            height: 0,
            scrollerHeight: 0,
            scrollerWidth: 0,
            $dirty: true
        };
        this.layerConfig = {
            width: 1,
            padding: 0,
            firstRow: 0,
            firstRowScreen: 0,
            lastRow: 0,
            lineHeight: 0,
            characterWidth: 0,
            minHeight: 1,
            maxHeight: 1,
            offset: 0,
            height: 1,
            gutterOffset: 1
        };
        this.scrollMargin = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            v: 0,
            h: 0
        };
        this.$loop = new RenderLoop(this.$renderChanges.bind(this), this.container.ownerDocument.defaultView);
        this.$loop.schedule(this.CHANGE_FULL);
        this.updateCharacterSize();
        this.setPadding(4);
        config.resetOptions(this);
        config._emit("renderer", this);
    };
    (function() {
        this.CHANGE_CURSOR = 1;
        this.CHANGE_MARKER = 2;
        this.CHANGE_GUTTER = 4;
        this.CHANGE_SCROLL = 8;
        this.CHANGE_LINES = 16;
        this.CHANGE_TEXT = 32;
        this.CHANGE_SIZE = 64;
        this.CHANGE_MARKER_BACK = 128;
        this.CHANGE_MARKER_FRONT = 256;
        this.CHANGE_FULL = 512;
        this.CHANGE_H_SCROLL = 1024;
        oop.implement(this, EventEmitter);
        this.updateCharacterSize = function() {
            if (this.$textLayer.allowBoldFonts != this.$allowBoldFonts) {
                this.$allowBoldFonts = this.$textLayer.allowBoldFonts;
                this.setStyle("ace_nobold", !this.$allowBoldFonts);
            }
            this.layerConfig.characterWidth = this.characterWidth = this.$textLayer.getCharacterWidth();
            this.layerConfig.lineHeight = this.lineHeight = this.$textLayer.getLineHeight();
            this.$updatePrintMargin();
        };
        this.setSession = function(session) {
            if (this.session) this.session.doc.off("changeNewLineMode", this.onChangeNewLineMode);
            this.session = session;
            if (session && this.scrollMargin.top && session.getScrollTop() <= 0) session.setScrollTop(-this.scrollMargin.top);
            this.$cursorLayer.setSession(session);
            this.$markerBack.setSession(session);
            this.$markerFront.setSession(session);
            this.$gutterLayer.setSession(session);
            this.$textLayer.setSession(session);
            if (!session) return;
            this.$loop.schedule(this.CHANGE_FULL);
            this.session.$setFontMetrics(this.$fontMetrics);
            this.scrollBarH.scrollLeft = this.scrollBarV.scrollTop = null;
            this.onChangeNewLineMode = this.onChangeNewLineMode.bind(this);
            this.onChangeNewLineMode();
            this.session.doc.on("changeNewLineMode", this.onChangeNewLineMode);
        };
        this.updateLines = function(firstRow, lastRow, force) {
            if (lastRow === undefined) lastRow = Infinity;
            if (!this.$changedLines) this.$changedLines = {
                firstRow: firstRow,
                lastRow: lastRow
            };
            else {
                if (this.$changedLines.firstRow > firstRow) this.$changedLines.firstRow = firstRow;
                if (this.$changedLines.lastRow < lastRow) this.$changedLines.lastRow = lastRow;
            }
            if (this.$changedLines.lastRow < this.layerConfig.firstRow) {
                if (force) this.$changedLines.lastRow = this.layerConfig.lastRow;
                else return;
            }
            if (this.$changedLines.firstRow > this.layerConfig.lastRow) return;
            this.$loop.schedule(this.CHANGE_LINES);
        };
        this.onChangeNewLineMode = function() {
            this.$loop.schedule(this.CHANGE_TEXT);
            this.$textLayer.$updateEolChar();
            this.session.$bidiHandler.setEolChar(this.$textLayer.EOL_CHAR);
        };
        this.onChangeTabSize = function() {
            this.$loop.schedule(this.CHANGE_TEXT | this.CHANGE_MARKER);
            this.$textLayer.onChangeTabSize();
        };
        this.updateText = function() {
            this.$loop.schedule(this.CHANGE_TEXT);
        };
        this.updateFull = function(force) {
            if (force) this.$renderChanges(this.CHANGE_FULL, true);
            else this.$loop.schedule(this.CHANGE_FULL);
        };
        this.updateFontSize = function() {
            this.$textLayer.checkForSizeChanges();
        };
        this.$changes = 0;
        this.$updateSizeAsync = function() {
            if (this.$loop.pending) this.$size.$dirty = true;
            else this.onResize();
        };
        this.onResize = function(force, gutterWidth, width, height) {
            if (this.resizing > 2) return;
            else if (this.resizing > 0) this.resizing++;
            else this.resizing = force ? 1 : 0;
            var el = this.container;
            if (!height) height = el.clientHeight || el.scrollHeight;
            if (!width) width = el.clientWidth || el.scrollWidth;
            var changes = this.$updateCachedSize(force, gutterWidth, width, height);
            if (!this.$size.scrollerHeight || !width && !height) return this.resizing = 0;
            if (force) this.$gutterLayer.$padding = null;
            if (force) this.$renderChanges(changes | this.$changes, true);
            else this.$loop.schedule(changes | this.$changes);
            if (this.resizing) this.resizing = 0;
            this.scrollBarV.scrollLeft = this.scrollBarV.scrollTop = null;
        };
        this.$updateCachedSize = function(force, gutterWidth, width, height) {
            height -= this.$extraHeight || 0;
            var changes = 0;
            var size = this.$size;
            var oldSize = {
                width: size.width,
                height: size.height,
                scrollerHeight: size.scrollerHeight,
                scrollerWidth: size.scrollerWidth
            };
            if (height && (force || size.height != height)) {
                size.height = height;
                changes |= this.CHANGE_SIZE;
                size.scrollerHeight = size.height;
                if (this.$horizScroll) size.scrollerHeight -= this.scrollBarH.getHeight();
                this.scrollBarV.element.style.bottom = this.scrollBarH.getHeight() + "px";
                changes = changes | this.CHANGE_SCROLL;
            }
            if (width && (force || size.width != width)) {
                changes |= this.CHANGE_SIZE;
                size.width = width;
                if (gutterWidth == null) gutterWidth = this.$showGutter ? this.$gutter.offsetWidth : 0;
                this.gutterWidth = gutterWidth;
                this.scrollBarH.element.style.left = this.scroller.style.left = gutterWidth + "px";
                size.scrollerWidth = Math.max(0, width - gutterWidth - this.scrollBarV.getWidth());
                this.scrollBarH.element.style.right = this.scroller.style.right = this.scrollBarV.getWidth() + "px";
                this.scroller.style.bottom = this.scrollBarH.getHeight() + "px";
                if (this.session && this.session.getUseWrapMode() && this.adjustWrapLimit() || force) changes |= this.CHANGE_FULL;
            }
            size.$dirty = !width || !height;
            if (changes) this._signal("resize", oldSize);
            return changes;
        };
        this.onGutterResize = function() {
            var gutterWidth = this.$showGutter ? this.$gutter.offsetWidth : 0;
            if (gutterWidth != this.gutterWidth) this.$changes |= this.$updateCachedSize(true, gutterWidth, this.$size.width, this.$size.height);
            if (this.session.getUseWrapMode() && this.adjustWrapLimit()) this.$loop.schedule(this.CHANGE_FULL);
            else if (this.$size.$dirty) this.$loop.schedule(this.CHANGE_FULL);
            else {
                this.$computeLayerConfig();
                this.$loop.schedule(this.CHANGE_MARKER);
            }
        };
        this.adjustWrapLimit = function() {
            var availableWidth = this.$size.scrollerWidth - this.$padding * 2;
            var limit = Math.floor(availableWidth / this.characterWidth);
            return this.session.adjustWrapLimit(limit, this.$showPrintMargin && this.$printMarginColumn);
        };
        this.setAnimatedScroll = function(shouldAnimate) {
            this.setOption("animatedScroll", shouldAnimate);
        };
        this.getAnimatedScroll = function() {
            return this.$animatedScroll;
        };
        this.setShowInvisibles = function(showInvisibles) {
            this.setOption("showInvisibles", showInvisibles);
            this.session.$bidiHandler.setShowInvisibles(showInvisibles);
        };
        this.getShowInvisibles = function() {
            return this.getOption("showInvisibles");
        };
        this.getDisplayIndentGuides = function() {
            return this.getOption("displayIndentGuides");
        };
        this.setDisplayIndentGuides = function(display) {
            this.setOption("displayIndentGuides", display);
        };
        this.setShowPrintMargin = function(showPrintMargin) {
            this.setOption("showPrintMargin", showPrintMargin);
        };
        this.getShowPrintMargin = function() {
            return this.getOption("showPrintMargin");
        };
        this.setPrintMarginColumn = function(showPrintMargin) {
            this.setOption("printMarginColumn", showPrintMargin);
        };
        this.getPrintMarginColumn = function() {
            return this.getOption("printMarginColumn");
        };
        this.getShowGutter = function() {
            return this.getOption("showGutter");
        };
        this.setShowGutter = function(show) {
            return this.setOption("showGutter", show);
        };
        this.getFadeFoldWidgets = function() {
            return this.getOption("fadeFoldWidgets");
        };
        this.setFadeFoldWidgets = function(show) {
            this.setOption("fadeFoldWidgets", show);
        };
        this.setHighlightGutterLine = function(shouldHighlight) {
            this.setOption("highlightGutterLine", shouldHighlight);
        };
        this.getHighlightGutterLine = function() {
            return this.getOption("highlightGutterLine");
        };
        this.$updateGutterLineHighlight = function() {
            var pos = this.$cursorLayer.$pixelPos;
            var height = this.layerConfig.lineHeight;
            if (this.session.getUseWrapMode()) {
                var cursor = this.session.selection.getCursor();
                cursor.column = 0;
                pos = this.$cursorLayer.getPixelPosition(cursor, true);
                height *= this.session.getRowLength(cursor.row);
            }
            this.$gutterLineHighlight.style.top = pos.top - this.layerConfig.offset + "px";
            this.$gutterLineHighlight.style.height = height + "px";
        };
        this.$updatePrintMargin = function() {
            if (!this.$showPrintMargin && !this.$printMarginEl) return;
            if (!this.$printMarginEl) {
                var containerEl = dom.createElement("div");
                containerEl.className = "ace_layer ace_print-margin-layer";
                this.$printMarginEl = dom.createElement("div");
                this.$printMarginEl.className = "ace_print-margin";
                containerEl.appendChild(this.$printMarginEl);
                this.content.insertBefore(containerEl, this.content.firstChild);
            }
            var style = this.$printMarginEl.style;
            style.left = this.characterWidth * this.$printMarginColumn + this.$padding + "px";
            style.visibility = this.$showPrintMargin ? "visible" : "hidden";
            if (this.session && this.session.$wrap == -1) this.adjustWrapLimit();
        };
        this.getContainerElement = function() {
            return this.container;
        };
        this.getMouseEventTarget = function() {
            return this.scroller;
        };
        this.getTextAreaContainer = function() {
            return this.container;
        };
        this.$moveTextAreaToCursor = function() {
            if (!this.$keepTextAreaAtCursor) return;
            var config = this.layerConfig;
            var posTop = this.$cursorLayer.$pixelPos.top;
            var posLeft = this.$cursorLayer.$pixelPos.left;
            posTop -= config.offset;
            var style = this.textarea.style;
            var h = this.lineHeight;
            if (posTop < 0 || posTop > config.height - h) {
                style.top = style.left = "0";
                return;
            }
            var w = this.characterWidth;
            if (this.$composition) {
                var val = this.textarea.value.replace(/^\x01+/, "");
                w *= this.session.$getStringScreenWidth(val)[0] + 2;
                h += 2;
            }
            posLeft -= this.scrollLeft;
            if (posLeft > this.$size.scrollerWidth - w) posLeft = this.$size.scrollerWidth - w;
            posLeft += this.gutterWidth;
            style.height = h + "px";
            style.width = w + "px";
            style.left = Math.min(posLeft, this.$size.scrollerWidth - w) + "px";
            style.top = Math.min(posTop, this.$size.height - h) + "px";
        };
        this.getFirstVisibleRow = function() {
            return this.layerConfig.firstRow;
        };
        this.getFirstFullyVisibleRow = function() {
            return this.layerConfig.firstRow + (this.layerConfig.offset === 0 ? 0 : 1);
        };
        this.getLastFullyVisibleRow = function() {
            var config = this.layerConfig;
            var lastRow = config.lastRow;
            var top = this.session.documentToScreenRow(lastRow, 0) * config.lineHeight;
            if (top - this.session.getScrollTop() > config.height - config.lineHeight) return lastRow - 1;
            return lastRow;
        };
        this.getLastVisibleRow = function() {
            return this.layerConfig.lastRow;
        };
        this.$padding = null;
        this.setPadding = function(padding) {
            this.$padding = padding;
            this.$textLayer.setPadding(padding);
            this.$cursorLayer.setPadding(padding);
            this.$markerFront.setPadding(padding);
            this.$markerBack.setPadding(padding);
            this.$loop.schedule(this.CHANGE_FULL);
            this.$updatePrintMargin();
        };
        this.setScrollMargin = function(top, bottom, left, right) {
            var sm = this.scrollMargin;
            sm.top = top | 0;
            sm.bottom = bottom | 0;
            sm.right = right | 0;
            sm.left = left | 0;
            sm.v = sm.top + sm.bottom;
            sm.h = sm.left + sm.right;
            if (sm.top && this.scrollTop <= 0 && this.session) this.session.setScrollTop(-sm.top);
            this.updateFull();
        };
        this.getHScrollBarAlwaysVisible = function() {
            return this.$hScrollBarAlwaysVisible;
        };
        this.setHScrollBarAlwaysVisible = function(alwaysVisible) {
            this.setOption("hScrollBarAlwaysVisible", alwaysVisible);
        };
        this.getVScrollBarAlwaysVisible = function() {
            return this.$vScrollBarAlwaysVisible;
        };
        this.setVScrollBarAlwaysVisible = function(alwaysVisible) {
            this.setOption("vScrollBarAlwaysVisible", alwaysVisible);
        };
        this.$updateScrollBarV = function() {
            var scrollHeight = this.layerConfig.maxHeight;
            var scrollerHeight = this.$size.scrollerHeight;
            if (!this.$maxLines && this.$scrollPastEnd) {
                scrollHeight -= (scrollerHeight - this.lineHeight) * this.$scrollPastEnd;
                if (this.scrollTop > scrollHeight - scrollerHeight) {
                    scrollHeight = this.scrollTop + scrollerHeight;
                    this.scrollBarV.scrollTop = null;
                }
            }
            this.scrollBarV.setScrollHeight(scrollHeight + this.scrollMargin.v);
            this.scrollBarV.setScrollTop(this.scrollTop + this.scrollMargin.top);
        };
        this.$updateScrollBarH = function() {
            this.scrollBarH.setScrollWidth(this.layerConfig.width + 2 * this.$padding + this.scrollMargin.h);
            this.scrollBarH.setScrollLeft(this.scrollLeft + this.scrollMargin.left);
        };
        this.$frozen = false;
        this.freeze = function() {
            this.$frozen = true;
        };
        this.unfreeze = function() {
            this.$frozen = false;
        };
        this.$renderChanges = function(changes, force) {
            if (this.$changes) {
                changes |= this.$changes;
                this.$changes = 0;
            }
            if (!this.session || !this.container.offsetWidth || this.$frozen || !changes && !force) {
                this.$changes |= changes;
                return;
            }
            if (this.$size.$dirty) {
                this.$changes |= changes;
                return this.onResize(true);
            }
            if (!this.lineHeight) this.$textLayer.checkForSizeChanges();
            this._signal("beforeRender");
            if (this.session && this.session.$bidiHandler) this.session.$bidiHandler.updateCharacterWidths(this.$fontMetrics);
            var config = this.layerConfig;
            if (changes & this.CHANGE_FULL || changes & this.CHANGE_SIZE || changes & this.CHANGE_TEXT || changes & this.CHANGE_LINES || changes & this.CHANGE_SCROLL || changes & this.CHANGE_H_SCROLL) {
                changes |= this.$computeLayerConfig();
                if (config.firstRow != this.layerConfig.firstRow && config.firstRowScreen == this.layerConfig.firstRowScreen) {
                    var st = this.scrollTop + (config.firstRow - this.layerConfig.firstRow) * this.lineHeight;
                    if (st > 0) {
                        this.scrollTop = st;
                        changes = changes | this.CHANGE_SCROLL;
                        changes |= this.$computeLayerConfig();
                    }
                }
                config = this.layerConfig;
                this.$updateScrollBarV();
                if (changes & this.CHANGE_H_SCROLL) this.$updateScrollBarH();
                this.$gutterLayer.element.style.marginTop = -config.offset + "px";
                this.content.style.marginTop = -config.offset + "px";
                this.content.style.width = config.width + 2 * this.$padding + "px";
                this.content.style.height = config.minHeight + "px";
            }
            if (changes & this.CHANGE_H_SCROLL) {
                this.content.style.marginLeft = -this.scrollLeft + "px";
                this.scroller.className = this.scrollLeft <= 0 ? "ace_scroller" : "ace_scroller ace_scroll-left";
            }
            if (changes & this.CHANGE_FULL) {
                this.$textLayer.update(config);
                if (this.$showGutter) this.$gutterLayer.update(config);
                this.$markerBack.update(config);
                this.$markerFront.update(config);
                this.$cursorLayer.update(config);
                this.$moveTextAreaToCursor();
                this.$highlightGutterLine && this.$updateGutterLineHighlight();
                this._signal("afterRender");
                return;
            }
            if (changes & this.CHANGE_SCROLL) {
                if (changes & this.CHANGE_TEXT || changes & this.CHANGE_LINES) this.$textLayer.update(config);
                else this.$textLayer.scrollLines(config);
                if (this.$showGutter) this.$gutterLayer.update(config);
                this.$markerBack.update(config);
                this.$markerFront.update(config);
                this.$cursorLayer.update(config);
                this.$highlightGutterLine && this.$updateGutterLineHighlight();
                this.$moveTextAreaToCursor();
                this._signal("afterRender");
                return;
            }
            if (changes & this.CHANGE_TEXT) {
                this.$textLayer.update(config);
                if (this.$showGutter) this.$gutterLayer.update(config);
            } else if (changes & this.CHANGE_LINES) {
                if (this.$updateLines() || changes & this.CHANGE_GUTTER && this.$showGutter) this.$gutterLayer.update(config);
            } else if (changes & this.CHANGE_TEXT || changes & this.CHANGE_GUTTER) {
                if (this.$showGutter) this.$gutterLayer.update(config);
            }
            if (changes & this.CHANGE_CURSOR) {
                this.$cursorLayer.update(config);
                this.$moveTextAreaToCursor();
                this.$highlightGutterLine && this.$updateGutterLineHighlight();
            }
            if (changes & (this.CHANGE_MARKER | this.CHANGE_MARKER_FRONT)) this.$markerFront.update(config);
            if (changes & (this.CHANGE_MARKER | this.CHANGE_MARKER_BACK)) this.$markerBack.update(config);
            this._signal("afterRender");
        };
        this.$autosize = function() {
            var height = this.session.getScreenLength() * this.lineHeight;
            var maxHeight = this.$maxLines * this.lineHeight;
            var desiredHeight = Math.min(maxHeight, Math.max((this.$minLines || 1) * this.lineHeight, height)) + this.scrollMargin.v + (this.$extraHeight || 0);
            if (this.$horizScroll) desiredHeight += this.scrollBarH.getHeight();
            if (this.$maxPixelHeight && desiredHeight > this.$maxPixelHeight) desiredHeight = this.$maxPixelHeight;
            var vScroll = height > maxHeight;
            if (desiredHeight != this.desiredHeight || this.$size.height != this.desiredHeight || vScroll != this.$vScroll) {
                if (vScroll != this.$vScroll) {
                    this.$vScroll = vScroll;
                    this.scrollBarV.setVisible(vScroll);
                }
                var w = this.container.clientWidth;
                this.container.style.height = desiredHeight + "px";
                this.$updateCachedSize(true, this.$gutterWidth, w, desiredHeight);
                this.desiredHeight = desiredHeight;
                this._signal("autosize");
            }
        };
        this.$computeLayerConfig = function() {
            var session = this.session;
            var size = this.$size;
            var hideScrollbars = size.height <= 2 * this.lineHeight;
            var screenLines = this.session.getScreenLength();
            var maxHeight = screenLines * this.lineHeight;
            var longestLine = this.$getLongestLine();
            var horizScroll = !hideScrollbars && (this.$hScrollBarAlwaysVisible || size.scrollerWidth - longestLine - 2 * this.$padding < 0);
            var hScrollChanged = this.$horizScroll !== horizScroll;
            if (hScrollChanged) {
                this.$horizScroll = horizScroll;
                this.scrollBarH.setVisible(horizScroll);
            }
            var vScrollBefore = this.$vScroll; // autosize can change vscroll value in which case we need to update longestLine
            if (this.$maxLines && this.lineHeight > 1) this.$autosize();
            var offset = this.scrollTop % this.lineHeight;
            var minHeight = size.scrollerHeight + this.lineHeight;
            var scrollPastEnd = !this.$maxLines && this.$scrollPastEnd ? (size.scrollerHeight - this.lineHeight) * this.$scrollPastEnd : 0;
            maxHeight += scrollPastEnd;
            var sm = this.scrollMargin;
            this.session.setScrollTop(Math.max(-sm.top, Math.min(this.scrollTop, maxHeight - size.scrollerHeight + sm.bottom)));
            this.session.setScrollLeft(Math.max(-sm.left, Math.min(this.scrollLeft, longestLine + 2 * this.$padding - size.scrollerWidth + sm.right)));
            var vScroll = !hideScrollbars && (this.$vScrollBarAlwaysVisible || size.scrollerHeight - maxHeight + scrollPastEnd < 0 || this.scrollTop > sm.top);
            var vScrollChanged = vScrollBefore !== vScroll;
            if (vScrollChanged) {
                this.$vScroll = vScroll;
                this.scrollBarV.setVisible(vScroll);
            }
            var lineCount = Math.ceil(minHeight / this.lineHeight) - 1;
            var firstRow = Math.max(0, Math.round((this.scrollTop - offset) / this.lineHeight));
            var lastRow = firstRow + lineCount;
            var firstRowScreen, firstRowHeight;
            var lineHeight = this.lineHeight;
            firstRow = session.screenToDocumentRow(firstRow, 0);
            var foldLine = session.getFoldLine(firstRow);
            if (foldLine) firstRow = foldLine.start.row;
            firstRowScreen = session.documentToScreenRow(firstRow, 0);
            firstRowHeight = session.getRowLength(firstRow) * lineHeight;
            lastRow = Math.min(session.screenToDocumentRow(lastRow, 0), session.getLength() - 1);
            minHeight = size.scrollerHeight + session.getRowLength(lastRow) * lineHeight + firstRowHeight;
            offset = this.scrollTop - firstRowScreen * lineHeight;
            var changes = 0;
            if (this.layerConfig.width != longestLine) changes = this.CHANGE_H_SCROLL;
            if (hScrollChanged || vScrollChanged) {
                changes = this.$updateCachedSize(true, this.gutterWidth, size.width, size.height);
                this._signal("scrollbarVisibilityChanged");
                if (vScrollChanged) longestLine = this.$getLongestLine();
            }
            this.layerConfig = {
                width: longestLine,
                padding: this.$padding,
                firstRow: firstRow,
                firstRowScreen: firstRowScreen,
                lastRow: lastRow,
                lineHeight: lineHeight,
                characterWidth: this.characterWidth,
                minHeight: minHeight,
                maxHeight: maxHeight,
                offset: offset,
                gutterOffset: lineHeight ? Math.max(0, Math.ceil((offset + size.height - size.scrollerHeight) / lineHeight)) : 0,
                height: this.$size.scrollerHeight
            };
            return changes;
        };
        this.$updateLines = function() {
            if (!this.$changedLines) return;
            var firstRow = this.$changedLines.firstRow;
            var lastRow = this.$changedLines.lastRow;
            this.$changedLines = null;
            var layerConfig = this.layerConfig;
            if (firstRow > layerConfig.lastRow + 1) return;
            if (lastRow < layerConfig.firstRow) return;
            if (lastRow === Infinity) {
                if (this.$showGutter) this.$gutterLayer.update(layerConfig);
                this.$textLayer.update(layerConfig);
                return;
            }
            this.$textLayer.updateLines(layerConfig, firstRow, lastRow);
            return true;
        };
        this.$getLongestLine = function() {
            var charCount = this.session.getScreenWidth();
            if (this.showInvisibles && !this.session.$useWrapMode) charCount += 1;
            return Math.max(this.$size.scrollerWidth - 2 * this.$padding, Math.round(charCount * this.characterWidth));
        };
        this.updateFrontMarkers = function() {
            this.$markerFront.setMarkers(this.session.getMarkers(true));
            this.$loop.schedule(this.CHANGE_MARKER_FRONT);
        };
        this.updateBackMarkers = function() {
            this.$markerBack.setMarkers(this.session.getMarkers());
            this.$loop.schedule(this.CHANGE_MARKER_BACK);
        };
        this.addGutterDecoration = function(row, className) {
            this.$gutterLayer.addGutterDecoration(row, className);
        };
        this.removeGutterDecoration = function(row, className) {
            this.$gutterLayer.removeGutterDecoration(row, className);
        };
        this.updateBreakpoints = function(rows) {
            this.$loop.schedule(this.CHANGE_GUTTER);
        };
        this.setAnnotations = function(annotations) {
            this.$gutterLayer.setAnnotations(annotations);
            this.$loop.schedule(this.CHANGE_GUTTER);
        };
        this.updateCursor = function() {
            this.$loop.schedule(this.CHANGE_CURSOR);
        };
        this.hideCursor = function() {
            this.$cursorLayer.hideCursor();
        };
        this.showCursor = function() {
            this.$cursorLayer.showCursor();
        };
        this.scrollSelectionIntoView = function(anchor, lead, offset) {
            this.scrollCursorIntoView(anchor, offset);
            this.scrollCursorIntoView(lead, offset);
        };
        this.scrollCursorIntoView = function(cursor, offset, $viewMargin) {
            if (this.$size.scrollerHeight === 0) return;
            var pos = this.$cursorLayer.getPixelPosition(cursor);
            var left = pos.left;
            var top = pos.top;
            var topMargin = $viewMargin && $viewMargin.top || 0;
            var bottomMargin = $viewMargin && $viewMargin.bottom || 0;
            var scrollTop = this.$scrollAnimation ? this.session.getScrollTop() : this.scrollTop;
            if (scrollTop + topMargin > top) {
                if (offset && scrollTop + topMargin > top + this.lineHeight) top -= offset * this.$size.scrollerHeight;
                if (top === 0) top = -this.scrollMargin.top;
                this.session.setScrollTop(top);
            } else if (scrollTop + this.$size.scrollerHeight - bottomMargin < top + this.lineHeight) {
                if (offset && scrollTop + this.$size.scrollerHeight - bottomMargin < top - this.lineHeight) top += offset * this.$size.scrollerHeight;
                this.session.setScrollTop(top + this.lineHeight - this.$size.scrollerHeight);
            }
            var scrollLeft = this.scrollLeft;
            if (scrollLeft > left) {
                if (left < this.$padding + 2 * this.layerConfig.characterWidth) left = -this.scrollMargin.left;
                this.session.setScrollLeft(left);
            } else if (scrollLeft + this.$size.scrollerWidth < left + this.characterWidth) this.session.setScrollLeft(Math.round(left + this.characterWidth - this.$size.scrollerWidth));
            else if (scrollLeft <= this.$padding && left - scrollLeft < this.characterWidth) this.session.setScrollLeft(0);
        };
        this.getScrollTop = function() {
            return this.session.getScrollTop();
        };
        this.getScrollLeft = function() {
            return this.session.getScrollLeft();
        };
        this.getScrollTopRow = function() {
            return this.scrollTop / this.lineHeight;
        };
        this.getScrollBottomRow = function() {
            return Math.max(0, Math.floor((this.scrollTop + this.$size.scrollerHeight) / this.lineHeight) - 1);
        };
        this.scrollToRow = function(row) {
            this.session.setScrollTop(row * this.lineHeight);
        };
        this.alignCursor = function(cursor, alignment) {
            if (typeof cursor == "number") cursor = {
                row: cursor,
                column: 0
            };
            var pos = this.$cursorLayer.getPixelPosition(cursor);
            var h = this.$size.scrollerHeight - this.lineHeight;
            var offset = pos.top - h * (alignment || 0);
            this.session.setScrollTop(offset);
            return offset;
        };
        this.STEPS = 8;
        this.$calcSteps = function(fromValue, toValue) {
            var i = 0;
            var l = this.STEPS;
            var steps = [];
            var func = function(t, x_min, dx) {
                return dx * (Math.pow(t - 1, 3) + 1) + x_min;
            };
            for(i = 0; i < l; ++i)steps.push(func(i / this.STEPS, fromValue, toValue - fromValue));
            return steps;
        };
        this.scrollToLine = function(line, center, animate, callback) {
            var pos = this.$cursorLayer.getPixelPosition({
                row: line,
                column: 0
            });
            var offset = pos.top;
            if (center) offset -= this.$size.scrollerHeight / 2;
            var initialScroll = this.scrollTop;
            this.session.setScrollTop(offset);
            if (animate !== false) this.animateScrolling(initialScroll, callback);
        };
        this.animateScrolling = function(fromValue, callback) {
            var toValue = this.scrollTop;
            if (!this.$animatedScroll) return;
            var _self = this;
            if (fromValue == toValue) return;
            if (this.$scrollAnimation) {
                var oldSteps = this.$scrollAnimation.steps;
                if (oldSteps.length) {
                    fromValue = oldSteps[0];
                    if (fromValue == toValue) return;
                }
            }
            var steps = _self.$calcSteps(fromValue, toValue);
            this.$scrollAnimation = {
                from: fromValue,
                to: toValue,
                steps: steps
            };
            clearInterval(this.$timer);
            _self.session.setScrollTop(steps.shift());
            _self.session.$scrollTop = toValue;
            this.$timer = setInterval(function() {
                if (steps.length) {
                    _self.session.setScrollTop(steps.shift());
                    _self.session.$scrollTop = toValue;
                } else if (toValue != null) {
                    _self.session.$scrollTop = -1;
                    _self.session.setScrollTop(toValue);
                    toValue = null;
                } else {
                    _self.$timer = clearInterval(_self.$timer);
                    _self.$scrollAnimation = null;
                    callback && callback();
                }
            }, 10);
        };
        this.scrollToY = function(scrollTop) {
            if (this.scrollTop !== scrollTop) {
                this.$loop.schedule(this.CHANGE_SCROLL);
                this.scrollTop = scrollTop;
            }
        };
        this.scrollToX = function(scrollLeft) {
            if (this.scrollLeft !== scrollLeft) this.scrollLeft = scrollLeft;
            this.$loop.schedule(this.CHANGE_H_SCROLL);
        };
        this.scrollTo = function(x, y) {
            this.session.setScrollTop(y);
            this.session.setScrollLeft(y);
        };
        this.scrollBy = function(deltaX, deltaY) {
            deltaY && this.session.setScrollTop(this.session.getScrollTop() + deltaY);
            deltaX && this.session.setScrollLeft(this.session.getScrollLeft() + deltaX);
        };
        this.isScrollableBy = function(deltaX, deltaY) {
            if (deltaY < 0 && this.session.getScrollTop() >= 1 - this.scrollMargin.top) return true;
            if (deltaY > 0 && this.session.getScrollTop() + this.$size.scrollerHeight - this.layerConfig.maxHeight < -1 + this.scrollMargin.bottom) return true;
            if (deltaX < 0 && this.session.getScrollLeft() >= 1 - this.scrollMargin.left) return true;
            if (deltaX > 0 && this.session.getScrollLeft() + this.$size.scrollerWidth - this.layerConfig.width < -1 + this.scrollMargin.right) return true;
        };
        this.pixelToScreenCoordinates = function(x, y) {
            var canvasPos = this.scroller.getBoundingClientRect();
            var offsetX = x + this.scrollLeft - canvasPos.left - this.$padding;
            var offset = offsetX / this.characterWidth;
            var row = Math.floor((y + this.scrollTop - canvasPos.top) / this.lineHeight);
            var col = Math.round(offset);
            return {
                row: row,
                column: col,
                side: offset - col > 0 ? 1 : -1,
                offsetX: offsetX
            };
        };
        this.screenToTextCoordinates = function(x, y) {
            var canvasPos = this.scroller.getBoundingClientRect();
            var offsetX = x + this.scrollLeft - canvasPos.left - this.$padding;
            var col = Math.round(offsetX / this.characterWidth);
            var row = (y + this.scrollTop - canvasPos.top) / this.lineHeight;
            return this.session.screenToDocumentPosition(row, Math.max(col, 0), offsetX);
        };
        this.textToScreenCoordinates = function(row, column) {
            var canvasPos = this.scroller.getBoundingClientRect();
            var pos = this.session.documentToScreenPosition(row, column);
            var x = this.$padding + (this.session.$bidiHandler.isBidiRow(pos.row, row) ? this.session.$bidiHandler.getPosLeft(pos.column) : Math.round(pos.column * this.characterWidth));
            var y = pos.row * this.lineHeight;
            return {
                pageX: canvasPos.left + x - this.scrollLeft,
                pageY: canvasPos.top + y - this.scrollTop
            };
        };
        this.visualizeFocus = function() {
            dom.addCssClass(this.container, "ace_focus");
        };
        this.visualizeBlur = function() {
            dom.removeCssClass(this.container, "ace_focus");
        };
        this.showComposition = function(position) {
            if (!this.$composition) this.$composition = {
                keepTextAreaAtCursor: this.$keepTextAreaAtCursor,
                cssText: this.textarea.style.cssText
            };
            this.$keepTextAreaAtCursor = true;
            dom.addCssClass(this.textarea, "ace_composition");
            this.textarea.style.cssText = "";
            this.$moveTextAreaToCursor();
        };
        this.setCompositionText = function(text) {
            this.$moveTextAreaToCursor();
        };
        this.hideComposition = function() {
            if (!this.$composition) return;
            dom.removeCssClass(this.textarea, "ace_composition");
            this.$keepTextAreaAtCursor = this.$composition.keepTextAreaAtCursor;
            this.textarea.style.cssText = this.$composition.cssText;
            this.$composition = null;
        };
        this.setTheme = function(theme, cb) {
            var _self = this;
            this.$themeId = theme;
            _self._dispatchEvent('themeChange', {
                theme: theme
            });
            if (!theme || typeof theme == "string") {
                var moduleName = theme || this.$options.theme.initialValue;
                config.loadModule([
                    "theme",
                    moduleName
                ], afterLoad);
            } else afterLoad(theme);
            function afterLoad(module1) {
                if (_self.$themeId != theme) return cb && cb();
                if (!module1 || !module1.cssClass) throw new Error("couldn't load module " + theme + " or it didn't call define");
                dom.importCssString(module1.cssText, module1.cssClass, _self.container.ownerDocument);
                if (_self.theme) dom.removeCssClass(_self.container, _self.theme.cssClass);
                var padding = "padding" in module1 ? module1.padding : "padding" in (_self.theme || {}) ? 4 : _self.$padding;
                if (_self.$padding && padding != _self.$padding) _self.setPadding(padding);
                _self.$theme = module1.cssClass;
                _self.theme = module1;
                dom.addCssClass(_self.container, module1.cssClass);
                dom.setCssClass(_self.container, "ace_dark", module1.isDark);
                if (_self.$size) {
                    _self.$size.width = 0;
                    _self.$updateSizeAsync();
                }
                _self._dispatchEvent('themeLoaded', {
                    theme: module1
                });
                cb && cb();
            }
        };
        this.getTheme = function() {
            return this.$themeId;
        };
        this.setStyle = function(style, include) {
            dom.setCssClass(this.container, style, include !== false);
        };
        this.unsetStyle = function(style) {
            dom.removeCssClass(this.container, style);
        };
        this.setCursorStyle = function(style) {
            if (this.scroller.style.cursor != style) this.scroller.style.cursor = style;
        };
        this.setMouseCursor = function(cursorStyle) {
            this.scroller.style.cursor = cursorStyle;
        };
        this.destroy = function() {
            this.$textLayer.destroy();
            this.$cursorLayer.destroy();
        };
    }).call(VirtualRenderer.prototype);
    config.defineOptions(VirtualRenderer.prototype, "renderer", {
        animatedScroll: {
            initialValue: false
        },
        showInvisibles: {
            set: function(value) {
                if (this.$textLayer.setShowInvisibles(value)) this.$loop.schedule(this.CHANGE_TEXT);
            },
            initialValue: false
        },
        showPrintMargin: {
            set: function() {
                this.$updatePrintMargin();
            },
            initialValue: true
        },
        printMarginColumn: {
            set: function() {
                this.$updatePrintMargin();
            },
            initialValue: 80
        },
        printMargin: {
            set: function(val) {
                if (typeof val == "number") this.$printMarginColumn = val;
                this.$showPrintMargin = !!val;
                this.$updatePrintMargin();
            },
            get: function() {
                return this.$showPrintMargin && this.$printMarginColumn;
            }
        },
        showGutter: {
            set: function(show) {
                this.$gutter.style.display = show ? "block" : "none";
                this.$loop.schedule(this.CHANGE_FULL);
                this.onGutterResize();
            },
            initialValue: true
        },
        fadeFoldWidgets: {
            set: function(show) {
                dom.setCssClass(this.$gutter, "ace_fade-fold-widgets", show);
            },
            initialValue: false
        },
        showFoldWidgets: {
            set: function(show) {
                this.$gutterLayer.setShowFoldWidgets(show);
            },
            initialValue: true
        },
        showLineNumbers: {
            set: function(show) {
                this.$gutterLayer.setShowLineNumbers(show);
                this.$loop.schedule(this.CHANGE_GUTTER);
            },
            initialValue: true
        },
        displayIndentGuides: {
            set: function(show) {
                if (this.$textLayer.setDisplayIndentGuides(show)) this.$loop.schedule(this.CHANGE_TEXT);
            },
            initialValue: true
        },
        highlightGutterLine: {
            set: function(shouldHighlight) {
                if (!this.$gutterLineHighlight) {
                    this.$gutterLineHighlight = dom.createElement("div");
                    this.$gutterLineHighlight.className = "ace_gutter-active-line";
                    this.$gutter.appendChild(this.$gutterLineHighlight);
                    return;
                }
                this.$gutterLineHighlight.style.display = shouldHighlight ? "" : "none";
                if (this.$cursorLayer.$pixelPos) this.$updateGutterLineHighlight();
            },
            initialValue: false,
            value: true
        },
        hScrollBarAlwaysVisible: {
            set: function(val) {
                if (!this.$hScrollBarAlwaysVisible || !this.$horizScroll) this.$loop.schedule(this.CHANGE_SCROLL);
            },
            initialValue: false
        },
        vScrollBarAlwaysVisible: {
            set: function(val) {
                if (!this.$vScrollBarAlwaysVisible || !this.$vScroll) this.$loop.schedule(this.CHANGE_SCROLL);
            },
            initialValue: false
        },
        fontSize: {
            set: function(size) {
                if (typeof size == "number") size = size + "px";
                this.container.style.fontSize = size;
                this.updateFontSize();
            },
            initialValue: 12
        },
        fontFamily: {
            set: function(name) {
                this.container.style.fontFamily = name;
                this.updateFontSize();
            }
        },
        maxLines: {
            set: function(val) {
                this.updateFull();
            }
        },
        minLines: {
            set: function(val) {
                this.updateFull();
            }
        },
        maxPixelHeight: {
            set: function(val) {
                this.updateFull();
            },
            initialValue: 0
        },
        scrollPastEnd: {
            set: function(val) {
                val = +val || 0;
                if (this.$scrollPastEnd == val) return;
                this.$scrollPastEnd = val;
                this.$loop.schedule(this.CHANGE_SCROLL);
            },
            initialValue: 0,
            handlesSet: true
        },
        fixedWidthGutter: {
            set: function(val) {
                this.$gutterLayer.$fixedWidth = !!val;
                this.$loop.schedule(this.CHANGE_GUTTER);
            }
        },
        theme: {
            set: function(val) {
                this.setTheme(val);
            },
            get: function() {
                return this.$themeId || this.theme;
            },
            initialValue: "./theme/textmate",
            handlesSet: true
        }
    });
    exports.VirtualRenderer = VirtualRenderer;
});
ace.define("ace/worker/worker_client", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/lib/net",
    "ace/lib/event_emitter",
    "ace/config"
], function(acequire, exports, module1) {
    "use strict";
    var oop = acequire("../lib/oop");
    var net = acequire("../lib/net");
    var EventEmitter = acequire("../lib/event_emitter").EventEmitter;
    var config = acequire("../config");
    function $workerBlob(workerUrl, mod) {
        var script = mod.src;
        net.qualifyURL(workerUrl);
        try {
            return new Blob([
                script
            ], {
                "type": "application/javascript"
            });
        } catch (e) {
            var BlobBuilder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder;
            var blobBuilder = new BlobBuilder();
            blobBuilder.append(script);
            return blobBuilder.getBlob("application/javascript");
        }
    }
    function createWorker(workerUrl, mod) {
        var blob = $workerBlob(workerUrl, mod);
        var URL = window.URL || window.webkitURL;
        var blobURL = URL.createObjectURL(blob);
        return new Worker(blobURL);
    }
    var WorkerClient = function(topLevelNamespaces, mod, classname, workerUrl, importScripts) {
        this.$sendDeltaQueue = this.$sendDeltaQueue.bind(this);
        this.changeListener = this.changeListener.bind(this);
        this.onMessage = this.onMessage.bind(this);
        if (acequire.nameToUrl && !acequire.toUrl) acequire.toUrl = acequire.nameToUrl;
        if (config.get("packaged") || !acequire.toUrl) workerUrl = workerUrl || config.moduleUrl(mod.id, "worker");
        else {
            var normalizePath = this.$normalizePath;
            workerUrl = workerUrl || normalizePath(acequire.toUrl("ace/worker/worker.js", null, "_"));
            var tlns = {};
            topLevelNamespaces.forEach(function(ns) {
                tlns[ns] = normalizePath(acequire.toUrl(ns, null, "_").replace(/(\.js)?(\?.*)?$/, ""));
            });
        }
        this.$worker = createWorker(workerUrl, mod);
        if (importScripts) this.send("importScripts", importScripts);
        this.$worker.postMessage({
            init: true,
            tlns: tlns,
            module: mod.id,
            classname: classname
        });
        this.callbackId = 1;
        this.callbacks = {};
        this.$worker.onmessage = this.onMessage;
    };
    (function() {
        oop.implement(this, EventEmitter);
        this.onMessage = function(e) {
            var msg = e.data;
            switch(msg.type){
                case "event":
                    this._signal(msg.name, {
                        data: msg.data
                    });
                    break;
                case "call":
                    var callback = this.callbacks[msg.id];
                    if (callback) {
                        callback(msg.data);
                        delete this.callbacks[msg.id];
                    }
                    break;
                case "error":
                    this.reportError(msg.data);
                    break;
                case "log":
                    window.console && console.log && console.log.apply(console, msg.data);
                    break;
            }
        };
        this.reportError = function(err) {
            window.console && console.error && console.error(err);
        };
        this.$normalizePath = function(path) {
            return net.qualifyURL(path);
        };
        this.terminate = function() {
            this._signal("terminate", {});
            this.deltaQueue = null;
            this.$worker.terminate();
            this.$worker = null;
            if (this.$doc) this.$doc.off("change", this.changeListener);
            this.$doc = null;
        };
        this.send = function(cmd, args) {
            this.$worker.postMessage({
                command: cmd,
                args: args
            });
        };
        this.call = function(cmd, args, callback) {
            if (callback) {
                var id = this.callbackId++;
                this.callbacks[id] = callback;
                args.push(id);
            }
            this.send(cmd, args);
        };
        this.emit = function(event, data) {
            try {
                this.$worker.postMessage({
                    event: event,
                    data: {
                        data: data.data
                    }
                });
            } catch (ex) {
                console.error(ex.stack);
            }
        };
        this.attachToDocument = function(doc) {
            if (this.$doc) this.terminate();
            this.$doc = doc;
            this.call("setValue", [
                doc.getValue()
            ]);
            doc.on("change", this.changeListener);
        };
        this.changeListener = function(delta) {
            if (!this.deltaQueue) {
                this.deltaQueue = [];
                setTimeout(this.$sendDeltaQueue, 0);
            }
            if (delta.action == "insert") this.deltaQueue.push(delta.start, delta.lines);
            else this.deltaQueue.push(delta.start, delta.end);
        };
        this.$sendDeltaQueue = function() {
            var q = this.deltaQueue;
            if (!q) return;
            this.deltaQueue = null;
            if (q.length > 50 && q.length > this.$doc.getLength() >> 1) this.call("setValue", [
                this.$doc.getValue()
            ]);
            else this.emit("change", {
                data: q
            });
        };
    }).call(WorkerClient.prototype);
    var UIWorkerClient = function(topLevelNamespaces, mod, classname) {
        this.$sendDeltaQueue = this.$sendDeltaQueue.bind(this);
        this.changeListener = this.changeListener.bind(this);
        this.callbackId = 1;
        this.callbacks = {};
        this.messageBuffer = [];
        var main = null;
        var emitSync = false;
        var sender = Object.create(EventEmitter);
        var _self = this;
        this.$worker = {};
        this.$worker.terminate = function() {};
        this.$worker.postMessage = function(e) {
            _self.messageBuffer.push(e);
            if (main) {
                if (emitSync) setTimeout(processNext);
                else processNext();
            }
        };
        this.setEmitSync = function(val) {
            emitSync = val;
        };
        var processNext = function() {
            var msg = _self.messageBuffer.shift();
            if (msg.command) main[msg.command].apply(main, msg.args);
            else if (msg.event) sender._signal(msg.event, msg.data);
        };
        sender.postMessage = function(msg) {
            _self.onMessage({
                data: msg
            });
        };
        sender.callback = function(data, callbackId) {
            this.postMessage({
                type: "call",
                id: callbackId,
                data: data
            });
        };
        sender.emit = function(name, data) {
            this.postMessage({
                type: "event",
                name: name,
                data: data
            });
        };
        config.loadModule([
            "worker",
            mod
        ], function(Main) {
            main = new Main[classname](sender);
            while(_self.messageBuffer.length)processNext();
        });
    };
    UIWorkerClient.prototype = WorkerClient.prototype;
    exports.UIWorkerClient = UIWorkerClient;
    exports.WorkerClient = WorkerClient;
    exports.createWorker = createWorker;
});
ace.define("ace/placeholder", [
    "require",
    "exports",
    "module",
    "ace/range",
    "ace/lib/event_emitter",
    "ace/lib/oop"
], function(acequire, exports, module1) {
    "use strict";
    var Range = acequire("./range").Range;
    var EventEmitter = acequire("./lib/event_emitter").EventEmitter;
    var oop = acequire("./lib/oop");
    var PlaceHolder = function(session, length, pos, others, mainClass, othersClass) {
        var _self = this;
        this.length = length;
        this.session = session;
        this.doc = session.getDocument();
        this.mainClass = mainClass;
        this.othersClass = othersClass;
        this.$onUpdate = this.onUpdate.bind(this);
        this.doc.on("change", this.$onUpdate);
        this.$others = others;
        this.$onCursorChange = function() {
            setTimeout(function() {
                _self.onCursorChange();
            });
        };
        this.$pos = pos;
        var undoStack = session.getUndoManager().$undoStack || session.getUndoManager().$undostack || {
            length: -1
        };
        this.$undoStackDepth = undoStack.length;
        this.setup();
        session.selection.on("changeCursor", this.$onCursorChange);
    };
    (function() {
        oop.implement(this, EventEmitter);
        this.setup = function() {
            var _self = this;
            var doc = this.doc;
            var session = this.session;
            this.selectionBefore = session.selection.toJSON();
            if (session.selection.inMultiSelectMode) session.selection.toSingleRange();
            this.pos = doc.createAnchor(this.$pos.row, this.$pos.column);
            var pos = this.pos;
            pos.$insertRight = true;
            pos.detach();
            pos.markerId = session.addMarker(new Range(pos.row, pos.column, pos.row, pos.column + this.length), this.mainClass, null, false);
            this.others = [];
            this.$others.forEach(function(other) {
                var anchor = doc.createAnchor(other.row, other.column);
                anchor.$insertRight = true;
                anchor.detach();
                _self.others.push(anchor);
            });
            session.setUndoSelect(false);
        };
        this.showOtherMarkers = function() {
            if (this.othersActive) return;
            var session = this.session;
            var _self = this;
            this.othersActive = true;
            this.others.forEach(function(anchor) {
                anchor.markerId = session.addMarker(new Range(anchor.row, anchor.column, anchor.row, anchor.column + _self.length), _self.othersClass, null, false);
            });
        };
        this.hideOtherMarkers = function() {
            if (!this.othersActive) return;
            this.othersActive = false;
            for(var i = 0; i < this.others.length; i++)this.session.removeMarker(this.others[i].markerId);
        };
        this.onUpdate = function(delta) {
            if (this.$updating) return this.updateAnchors(delta);
            var range = delta;
            if (range.start.row !== range.end.row) return;
            if (range.start.row !== this.pos.row) return;
            this.$updating = true;
            var lengthDiff = delta.action === "insert" ? range.end.column - range.start.column : range.start.column - range.end.column;
            var inMainRange = range.start.column >= this.pos.column && range.start.column <= this.pos.column + this.length + 1;
            var distanceFromStart = range.start.column - this.pos.column;
            this.updateAnchors(delta);
            if (inMainRange) this.length += lengthDiff;
            if (inMainRange && !this.session.$fromUndo) {
                if (delta.action === 'insert') for(var i = this.others.length - 1; i >= 0; i--){
                    var otherPos = this.others[i];
                    var newPos = {
                        row: otherPos.row,
                        column: otherPos.column + distanceFromStart
                    };
                    this.doc.insertMergedLines(newPos, delta.lines);
                }
                else if (delta.action === 'remove') for(var i = this.others.length - 1; i >= 0; i--){
                    var otherPos = this.others[i];
                    var newPos = {
                        row: otherPos.row,
                        column: otherPos.column + distanceFromStart
                    };
                    this.doc.remove(new Range(newPos.row, newPos.column, newPos.row, newPos.column - lengthDiff));
                }
            }
            this.$updating = false;
            this.updateMarkers();
        };
        this.updateAnchors = function(delta) {
            this.pos.onChange(delta);
            for(var i = this.others.length; i--;)this.others[i].onChange(delta);
            this.updateMarkers();
        };
        this.updateMarkers = function() {
            if (this.$updating) return;
            var _self = this;
            var session = this.session;
            var updateMarker = function(pos, className) {
                session.removeMarker(pos.markerId);
                pos.markerId = session.addMarker(new Range(pos.row, pos.column, pos.row, pos.column + _self.length), className, null, false);
            };
            updateMarker(this.pos, this.mainClass);
            for(var i = this.others.length; i--;)updateMarker(this.others[i], this.othersClass);
        };
        this.onCursorChange = function(event) {
            if (this.$updating || !this.session) return;
            var pos = this.session.selection.getCursor();
            if (pos.row === this.pos.row && pos.column >= this.pos.column && pos.column <= this.pos.column + this.length) {
                this.showOtherMarkers();
                this._emit("cursorEnter", event);
            } else {
                this.hideOtherMarkers();
                this._emit("cursorLeave", event);
            }
        };
        this.detach = function() {
            this.session.removeMarker(this.pos && this.pos.markerId);
            this.hideOtherMarkers();
            this.doc.removeEventListener("change", this.$onUpdate);
            this.session.selection.removeEventListener("changeCursor", this.$onCursorChange);
            this.session.setUndoSelect(true);
            this.session = null;
        };
        this.cancel = function() {
            if (this.$undoStackDepth === -1) return;
            var undoManager = this.session.getUndoManager();
            var undosRequired = (undoManager.$undoStack || undoManager.$undostack).length - this.$undoStackDepth;
            for(var i = 0; i < undosRequired; i++)undoManager.undo(true);
            if (this.selectionBefore) this.session.selection.fromJSON(this.selectionBefore);
        };
    }).call(PlaceHolder.prototype);
    exports.PlaceHolder = PlaceHolder;
});
ace.define("ace/mouse/multi_select_handler", [
    "require",
    "exports",
    "module",
    "ace/lib/event",
    "ace/lib/useragent"
], function(acequire, exports, module1) {
    var event = acequire("../lib/event");
    var useragent = acequire("../lib/useragent");
    function isSamePoint(p1, p2) {
        return p1.row == p2.row && p1.column == p2.column;
    }
    function onMouseDown(e) {
        var ev = e.domEvent;
        var alt = ev.altKey;
        var shift = ev.shiftKey;
        var ctrl = ev.ctrlKey;
        var accel = e.getAccelKey();
        var button = e.getButton();
        if (ctrl && useragent.isMac) button = ev.button;
        if (e.editor.inMultiSelectMode && button == 2) {
            e.editor.textInput.onContextMenu(e.domEvent);
            return;
        }
        if (!ctrl && !alt && !accel) {
            if (button === 0 && e.editor.inMultiSelectMode) e.editor.exitMultiSelectMode();
            return;
        }
        if (button !== 0) return;
        var editor = e.editor;
        var selection = editor.selection;
        var isMultiSelect = editor.inMultiSelectMode;
        var pos = e.getDocumentPosition();
        var cursor = selection.getCursor();
        var inSelection = e.inSelection() || selection.isEmpty() && isSamePoint(pos, cursor);
        var mouseX = e.x, mouseY = e.y;
        var onMouseSelection = function(e) {
            mouseX = e.clientX;
            mouseY = e.clientY;
        };
        var session = editor.session;
        var screenAnchor = editor.renderer.pixelToScreenCoordinates(mouseX, mouseY);
        var screenCursor = screenAnchor;
        var selectionMode;
        if (editor.$mouseHandler.$enableJumpToDef) {
            if (ctrl && alt || accel && alt) selectionMode = shift ? "block" : "add";
            else if (alt && editor.$blockSelectEnabled) selectionMode = "block";
        } else {
            if (accel && !alt) {
                selectionMode = "add";
                if (!isMultiSelect && shift) return;
            } else if (alt && editor.$blockSelectEnabled) selectionMode = "block";
        }
        if (selectionMode && useragent.isMac && ev.ctrlKey) editor.$mouseHandler.cancelContextMenu();
        if (selectionMode == "add") {
            if (!isMultiSelect && inSelection) return; // dragging
            if (!isMultiSelect) {
                var range = selection.toOrientedRange();
                editor.addSelectionMarker(range);
            }
            var oldRange = selection.rangeList.rangeAtPoint(pos);
            editor.$blockScrolling++;
            editor.inVirtualSelectionMode = true;
            if (shift) {
                oldRange = null;
                range = selection.ranges[0] || range;
                editor.removeSelectionMarker(range);
            }
            editor.once("mouseup", function() {
                var tmpSel = selection.toOrientedRange();
                if (oldRange && tmpSel.isEmpty() && isSamePoint(oldRange.cursor, tmpSel.cursor)) selection.substractPoint(tmpSel.cursor);
                else {
                    if (shift) selection.substractPoint(range.cursor);
                    else if (range) {
                        editor.removeSelectionMarker(range);
                        selection.addRange(range);
                    }
                    selection.addRange(tmpSel);
                }
                editor.$blockScrolling--;
                editor.inVirtualSelectionMode = false;
            });
        } else if (selectionMode == "block") {
            e.stop();
            editor.inVirtualSelectionMode = true;
            var initialRange;
            var rectSel = [];
            var blockSelect = function() {
                var newCursor = editor.renderer.pixelToScreenCoordinates(mouseX, mouseY);
                var cursor = session.screenToDocumentPosition(newCursor.row, newCursor.column, newCursor.offsetX);
                if (isSamePoint(screenCursor, newCursor) && isSamePoint(cursor, selection.lead)) return;
                screenCursor = newCursor;
                editor.$blockScrolling++;
                editor.selection.moveToPosition(cursor);
                editor.renderer.scrollCursorIntoView();
                editor.removeSelectionMarkers(rectSel);
                rectSel = selection.rectangularRangeBlock(screenCursor, screenAnchor);
                if (editor.$mouseHandler.$clickSelection && rectSel.length == 1 && rectSel[0].isEmpty()) rectSel[0] = editor.$mouseHandler.$clickSelection.clone();
                rectSel.forEach(editor.addSelectionMarker, editor);
                editor.updateSelectionMarkers();
                editor.$blockScrolling--;
            };
            editor.$blockScrolling++;
            if (isMultiSelect && !accel) selection.toSingleRange();
            else if (!isMultiSelect && accel) {
                initialRange = selection.toOrientedRange();
                editor.addSelectionMarker(initialRange);
            }
            if (shift) screenAnchor = session.documentToScreenPosition(selection.lead);
            else selection.moveToPosition(pos);
            editor.$blockScrolling--;
            screenCursor = {
                row: -1,
                column: -1
            };
            var onMouseSelectionEnd = function(e) {
                clearInterval(timerId);
                editor.removeSelectionMarkers(rectSel);
                if (!rectSel.length) rectSel = [
                    selection.toOrientedRange()
                ];
                editor.$blockScrolling++;
                if (initialRange) {
                    editor.removeSelectionMarker(initialRange);
                    selection.toSingleRange(initialRange);
                }
                for(var i = 0; i < rectSel.length; i++)selection.addRange(rectSel[i]);
                editor.inVirtualSelectionMode = false;
                editor.$mouseHandler.$clickSelection = null;
                editor.$blockScrolling--;
            };
            var onSelectionInterval = blockSelect;
            event.capture(editor.container, onMouseSelection, onMouseSelectionEnd);
            var timerId = setInterval(function() {
                onSelectionInterval();
            }, 20);
            return e.preventDefault();
        }
    }
    exports.onMouseDown = onMouseDown;
});
ace.define("ace/commands/multi_select_commands", [
    "require",
    "exports",
    "module",
    "ace/keyboard/hash_handler"
], function(acequire, exports, module1) {
    exports.defaultCommands = [
        {
            name: "addCursorAbove",
            exec: function(editor) {
                editor.selectMoreLines(-1);
            },
            bindKey: {
                win: "Ctrl-Alt-Up",
                mac: "Ctrl-Alt-Up"
            },
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "addCursorBelow",
            exec: function(editor) {
                editor.selectMoreLines(1);
            },
            bindKey: {
                win: "Ctrl-Alt-Down",
                mac: "Ctrl-Alt-Down"
            },
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "addCursorAboveSkipCurrent",
            exec: function(editor) {
                editor.selectMoreLines(-1, true);
            },
            bindKey: {
                win: "Ctrl-Alt-Shift-Up",
                mac: "Ctrl-Alt-Shift-Up"
            },
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "addCursorBelowSkipCurrent",
            exec: function(editor) {
                editor.selectMoreLines(1, true);
            },
            bindKey: {
                win: "Ctrl-Alt-Shift-Down",
                mac: "Ctrl-Alt-Shift-Down"
            },
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "selectMoreBefore",
            exec: function(editor) {
                editor.selectMore(-1);
            },
            bindKey: {
                win: "Ctrl-Alt-Left",
                mac: "Ctrl-Alt-Left"
            },
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "selectMoreAfter",
            exec: function(editor) {
                editor.selectMore(1);
            },
            bindKey: {
                win: "Ctrl-Alt-Right",
                mac: "Ctrl-Alt-Right"
            },
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "selectNextBefore",
            exec: function(editor) {
                editor.selectMore(-1, true);
            },
            bindKey: {
                win: "Ctrl-Alt-Shift-Left",
                mac: "Ctrl-Alt-Shift-Left"
            },
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "selectNextAfter",
            exec: function(editor) {
                editor.selectMore(1, true);
            },
            bindKey: {
                win: "Ctrl-Alt-Shift-Right",
                mac: "Ctrl-Alt-Shift-Right"
            },
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "splitIntoLines",
            exec: function(editor) {
                editor.multiSelect.splitIntoLines();
            },
            bindKey: {
                win: "Ctrl-Alt-L",
                mac: "Ctrl-Alt-L"
            },
            readOnly: true
        },
        {
            name: "alignCursors",
            exec: function(editor) {
                editor.alignCursors();
            },
            bindKey: {
                win: "Ctrl-Alt-A",
                mac: "Ctrl-Alt-A"
            },
            scrollIntoView: "cursor"
        },
        {
            name: "findAll",
            exec: function(editor) {
                editor.findAll();
            },
            bindKey: {
                win: "Ctrl-Alt-K",
                mac: "Ctrl-Alt-G"
            },
            scrollIntoView: "cursor",
            readOnly: true
        }
    ];
    exports.multiSelectCommands = [
        {
            name: "singleSelection",
            bindKey: "esc",
            exec: function(editor) {
                editor.exitMultiSelectMode();
            },
            scrollIntoView: "cursor",
            readOnly: true,
            isAvailable: function(editor) {
                return editor && editor.inMultiSelectMode;
            }
        }
    ];
    var HashHandler = acequire("../keyboard/hash_handler").HashHandler;
    exports.keyboardHandler = new HashHandler(exports.multiSelectCommands);
});
ace.define("ace/multi_select", [
    "require",
    "exports",
    "module",
    "ace/range_list",
    "ace/range",
    "ace/selection",
    "ace/mouse/multi_select_handler",
    "ace/lib/event",
    "ace/lib/lang",
    "ace/commands/multi_select_commands",
    "ace/search",
    "ace/edit_session",
    "ace/editor",
    "ace/config"
], function(acequire, exports, module1) {
    var RangeList = acequire("./range_list").RangeList;
    var Range = acequire("./range").Range;
    var Selection = acequire("./selection").Selection;
    var onMouseDown = acequire("./mouse/multi_select_handler").onMouseDown;
    var event = acequire("./lib/event");
    var lang = acequire("./lib/lang");
    var commands = acequire("./commands/multi_select_commands");
    exports.commands = commands.defaultCommands.concat(commands.multiSelectCommands);
    var Search = acequire("./search").Search;
    var search = new Search();
    function find(session, needle, dir) {
        search.$options.wrap = true;
        search.$options.needle = needle;
        search.$options.backwards = dir == -1;
        return search.find(session);
    }
    var EditSession = acequire("./edit_session").EditSession;
    (function() {
        this.getSelectionMarkers = function() {
            return this.$selectionMarkers;
        };
    }).call(EditSession.prototype);
    (function() {
        this.ranges = null;
        this.rangeList = null;
        this.addRange = function(range, $blockChangeEvents) {
            if (!range) return;
            if (!this.inMultiSelectMode && this.rangeCount === 0) {
                var oldRange = this.toOrientedRange();
                this.rangeList.add(oldRange);
                this.rangeList.add(range);
                if (this.rangeList.ranges.length != 2) {
                    this.rangeList.removeAll();
                    return $blockChangeEvents || this.fromOrientedRange(range);
                }
                this.rangeList.removeAll();
                this.rangeList.add(oldRange);
                this.$onAddRange(oldRange);
            }
            if (!range.cursor) range.cursor = range.end;
            var removed = this.rangeList.add(range);
            this.$onAddRange(range);
            if (removed.length) this.$onRemoveRange(removed);
            if (this.rangeCount > 1 && !this.inMultiSelectMode) {
                this._signal("multiSelect");
                this.inMultiSelectMode = true;
                this.session.$undoSelect = false;
                this.rangeList.attach(this.session);
            }
            return $blockChangeEvents || this.fromOrientedRange(range);
        };
        this.toSingleRange = function(range) {
            range = range || this.ranges[0];
            var removed = this.rangeList.removeAll();
            if (removed.length) this.$onRemoveRange(removed);
            range && this.fromOrientedRange(range);
        };
        this.substractPoint = function(pos) {
            var removed = this.rangeList.substractPoint(pos);
            if (removed) {
                this.$onRemoveRange(removed);
                return removed[0];
            }
        };
        this.mergeOverlappingRanges = function() {
            var removed = this.rangeList.merge();
            if (removed.length) this.$onRemoveRange(removed);
            else if (this.ranges[0]) this.fromOrientedRange(this.ranges[0]);
        };
        this.$onAddRange = function(range) {
            this.rangeCount = this.rangeList.ranges.length;
            this.ranges.unshift(range);
            this._signal("addRange", {
                range: range
            });
        };
        this.$onRemoveRange = function(removed) {
            this.rangeCount = this.rangeList.ranges.length;
            if (this.rangeCount == 1 && this.inMultiSelectMode) {
                var lastRange = this.rangeList.ranges.pop();
                removed.push(lastRange);
                this.rangeCount = 0;
            }
            for(var i = removed.length; i--;){
                var index = this.ranges.indexOf(removed[i]);
                this.ranges.splice(index, 1);
            }
            this._signal("removeRange", {
                ranges: removed
            });
            if (this.rangeCount === 0 && this.inMultiSelectMode) {
                this.inMultiSelectMode = false;
                this._signal("singleSelect");
                this.session.$undoSelect = true;
                this.rangeList.detach(this.session);
            }
            lastRange = lastRange || this.ranges[0];
            if (lastRange && !lastRange.isEqual(this.getRange())) this.fromOrientedRange(lastRange);
        };
        this.$initRangeList = function() {
            if (this.rangeList) return;
            this.rangeList = new RangeList();
            this.ranges = [];
            this.rangeCount = 0;
        };
        this.getAllRanges = function() {
            return this.rangeCount ? this.rangeList.ranges.concat() : [
                this.getRange()
            ];
        };
        this.splitIntoLines = function() {
            if (this.rangeCount > 1) {
                var ranges = this.rangeList.ranges;
                var lastRange = ranges[ranges.length - 1];
                var range = Range.fromPoints(ranges[0].start, lastRange.end);
                this.toSingleRange();
                this.setSelectionRange(range, lastRange.cursor == lastRange.start);
            } else {
                var range = this.getRange();
                var isBackwards = this.isBackwards();
                var startRow = range.start.row;
                var endRow = range.end.row;
                if (startRow == endRow) {
                    if (isBackwards) var start = range.end, end = range.start;
                    else var start = range.start, end = range.end;
                    this.addRange(Range.fromPoints(end, end));
                    this.addRange(Range.fromPoints(start, start));
                    return;
                }
                var rectSel = [];
                var r = this.getLineRange(startRow, true);
                r.start.column = range.start.column;
                rectSel.push(r);
                for(var i = startRow + 1; i < endRow; i++)rectSel.push(this.getLineRange(i, true));
                r = this.getLineRange(endRow, true);
                r.end.column = range.end.column;
                rectSel.push(r);
                rectSel.forEach(this.addRange, this);
            }
        };
        this.toggleBlockSelection = function() {
            if (this.rangeCount > 1) {
                var ranges = this.rangeList.ranges;
                var lastRange = ranges[ranges.length - 1];
                var range = Range.fromPoints(ranges[0].start, lastRange.end);
                this.toSingleRange();
                this.setSelectionRange(range, lastRange.cursor == lastRange.start);
            } else {
                var cursor = this.session.documentToScreenPosition(this.selectionLead);
                var anchor = this.session.documentToScreenPosition(this.selectionAnchor);
                var rectSel = this.rectangularRangeBlock(cursor, anchor);
                rectSel.forEach(this.addRange, this);
            }
        };
        this.rectangularRangeBlock = function(screenCursor, screenAnchor, includeEmptyLines) {
            var rectSel = [];
            var xBackwards = screenCursor.column < screenAnchor.column;
            if (xBackwards) {
                var startColumn = screenCursor.column;
                var endColumn = screenAnchor.column;
                var startOffsetX = screenCursor.offsetX;
                var endOffsetX = screenAnchor.offsetX;
            } else {
                var startColumn = screenAnchor.column;
                var endColumn = screenCursor.column;
                var startOffsetX = screenAnchor.offsetX;
                var endOffsetX = screenCursor.offsetX;
            }
            var yBackwards = screenCursor.row < screenAnchor.row;
            if (yBackwards) {
                var startRow = screenCursor.row;
                var endRow = screenAnchor.row;
            } else {
                var startRow = screenAnchor.row;
                var endRow = screenCursor.row;
            }
            if (startColumn < 0) startColumn = 0;
            if (startRow < 0) startRow = 0;
            if (startRow == endRow) includeEmptyLines = true;
            for(var row = startRow; row <= endRow; row++){
                var range = Range.fromPoints(this.session.screenToDocumentPosition(row, startColumn, startOffsetX), this.session.screenToDocumentPosition(row, endColumn, endOffsetX));
                if (range.isEmpty()) {
                    if (docEnd && isSamePoint(range.end, docEnd)) break;
                    var docEnd = range.end;
                }
                range.cursor = xBackwards ? range.start : range.end;
                rectSel.push(range);
            }
            if (yBackwards) rectSel.reverse();
            if (!includeEmptyLines) {
                var end = rectSel.length - 1;
                while(rectSel[end].isEmpty() && end > 0)end--;
                if (end > 0) {
                    var start = 0;
                    while(rectSel[start].isEmpty())start++;
                }
                for(var i = end; i >= start; i--)if (rectSel[i].isEmpty()) rectSel.splice(i, 1);
            }
            return rectSel;
        };
    }).call(Selection.prototype);
    var Editor = acequire("./editor").Editor;
    (function() {
        this.updateSelectionMarkers = function() {
            this.renderer.updateCursor();
            this.renderer.updateBackMarkers();
        };
        this.addSelectionMarker = function(orientedRange) {
            if (!orientedRange.cursor) orientedRange.cursor = orientedRange.end;
            var style = this.getSelectionStyle();
            orientedRange.marker = this.session.addMarker(orientedRange, "ace_selection", style);
            this.session.$selectionMarkers.push(orientedRange);
            this.session.selectionMarkerCount = this.session.$selectionMarkers.length;
            return orientedRange;
        };
        this.removeSelectionMarker = function(range) {
            if (!range.marker) return;
            this.session.removeMarker(range.marker);
            var index = this.session.$selectionMarkers.indexOf(range);
            if (index != -1) this.session.$selectionMarkers.splice(index, 1);
            this.session.selectionMarkerCount = this.session.$selectionMarkers.length;
        };
        this.removeSelectionMarkers = function(ranges) {
            var markerList = this.session.$selectionMarkers;
            for(var i = ranges.length; i--;){
                var range = ranges[i];
                if (!range.marker) continue;
                this.session.removeMarker(range.marker);
                var index = markerList.indexOf(range);
                if (index != -1) markerList.splice(index, 1);
            }
            this.session.selectionMarkerCount = markerList.length;
        };
        this.$onAddRange = function(e) {
            this.addSelectionMarker(e.range);
            this.renderer.updateCursor();
            this.renderer.updateBackMarkers();
        };
        this.$onRemoveRange = function(e) {
            this.removeSelectionMarkers(e.ranges);
            this.renderer.updateCursor();
            this.renderer.updateBackMarkers();
        };
        this.$onMultiSelect = function(e) {
            if (this.inMultiSelectMode) return;
            this.inMultiSelectMode = true;
            this.setStyle("ace_multiselect");
            this.keyBinding.addKeyboardHandler(commands.keyboardHandler);
            this.commands.setDefaultHandler("exec", this.$onMultiSelectExec);
            this.renderer.updateCursor();
            this.renderer.updateBackMarkers();
        };
        this.$onSingleSelect = function(e) {
            if (this.session.multiSelect.inVirtualMode) return;
            this.inMultiSelectMode = false;
            this.unsetStyle("ace_multiselect");
            this.keyBinding.removeKeyboardHandler(commands.keyboardHandler);
            this.commands.removeDefaultHandler("exec", this.$onMultiSelectExec);
            this.renderer.updateCursor();
            this.renderer.updateBackMarkers();
            this._emit("changeSelection");
        };
        this.$onMultiSelectExec = function(e) {
            var command = e.command;
            var editor = e.editor;
            if (!editor.multiSelect) return;
            if (!command.multiSelectAction) {
                var result = command.exec(editor, e.args || {});
                editor.multiSelect.addRange(editor.multiSelect.toOrientedRange());
                editor.multiSelect.mergeOverlappingRanges();
            } else if (command.multiSelectAction == "forEach") result = editor.forEachSelection(command, e.args);
            else if (command.multiSelectAction == "forEachLine") result = editor.forEachSelection(command, e.args, true);
            else if (command.multiSelectAction == "single") {
                editor.exitMultiSelectMode();
                result = command.exec(editor, e.args || {});
            } else result = command.multiSelectAction(editor, e.args || {});
            return result;
        };
        this.forEachSelection = function(cmd, args, options) {
            if (this.inVirtualSelectionMode) return;
            var keepOrder = options && options.keepOrder;
            var $byLines = options == true || options && options.$byLines;
            var session = this.session;
            var selection = this.selection;
            var rangeList = selection.rangeList;
            var ranges = (keepOrder ? selection : rangeList).ranges;
            var result;
            if (!ranges.length) return cmd.exec ? cmd.exec(this, args || {}) : cmd(this, args || {});
            var reg = selection._eventRegistry;
            selection._eventRegistry = {};
            var tmpSel = new Selection(session);
            this.inVirtualSelectionMode = true;
            for(var i = ranges.length; i--;){
                if ($byLines) while(i > 0 && ranges[i].start.row == ranges[i - 1].end.row)i--;
                tmpSel.fromOrientedRange(ranges[i]);
                tmpSel.index = i;
                this.selection = session.selection = tmpSel;
                var cmdResult = cmd.exec ? cmd.exec(this, args || {}) : cmd(this, args || {});
                if (!result && cmdResult !== undefined) result = cmdResult;
                tmpSel.toOrientedRange(ranges[i]);
            }
            tmpSel.detach();
            this.selection = session.selection = selection;
            this.inVirtualSelectionMode = false;
            selection._eventRegistry = reg;
            selection.mergeOverlappingRanges();
            var anim = this.renderer.$scrollAnimation;
            this.onCursorChange();
            this.onSelectionChange();
            if (anim && anim.from == anim.to) this.renderer.animateScrolling(anim.from);
            return result;
        };
        this.exitMultiSelectMode = function() {
            if (!this.inMultiSelectMode || this.inVirtualSelectionMode) return;
            this.multiSelect.toSingleRange();
        };
        this.getSelectedText = function() {
            var text = "";
            if (this.inMultiSelectMode && !this.inVirtualSelectionMode) {
                var ranges = this.multiSelect.rangeList.ranges;
                var buf = [];
                for(var i = 0; i < ranges.length; i++)buf.push(this.session.getTextRange(ranges[i]));
                var nl = this.session.getDocument().getNewLineCharacter();
                text = buf.join(nl);
                if (text.length == (buf.length - 1) * nl.length) text = "";
            } else if (!this.selection.isEmpty()) text = this.session.getTextRange(this.getSelectionRange());
            return text;
        };
        this.$checkMultiselectChange = function(e, anchor) {
            if (this.inMultiSelectMode && !this.inVirtualSelectionMode) {
                var range = this.multiSelect.ranges[0];
                if (this.multiSelect.isEmpty() && anchor == this.multiSelect.anchor) return;
                var pos = anchor == this.multiSelect.anchor ? range.cursor == range.start ? range.end : range.start : range.cursor;
                if (pos.row != anchor.row || this.session.$clipPositionToDocument(pos.row, pos.column).column != anchor.column) this.multiSelect.toSingleRange(this.multiSelect.toOrientedRange());
            }
        };
        this.findAll = function(needle, options, additive) {
            options = options || {};
            options.needle = needle || options.needle;
            if (options.needle == undefined) {
                var range = this.selection.isEmpty() ? this.selection.getWordRange() : this.selection.getRange();
                options.needle = this.session.getTextRange(range);
            }
            this.$search.set(options);
            var ranges = this.$search.findAll(this.session);
            if (!ranges.length) return 0;
            this.$blockScrolling += 1;
            var selection = this.multiSelect;
            if (!additive) selection.toSingleRange(ranges[0]);
            for(var i = ranges.length; i--;)selection.addRange(ranges[i], true);
            if (range && selection.rangeList.rangeAtPoint(range.start)) selection.addRange(range, true);
            this.$blockScrolling -= 1;
            return ranges.length;
        };
        this.selectMoreLines = function(dir, skip) {
            var range = this.selection.toOrientedRange();
            var isBackwards = range.cursor == range.end;
            var screenLead = this.session.documentToScreenPosition(range.cursor);
            if (this.selection.$desiredColumn) screenLead.column = this.selection.$desiredColumn;
            var lead = this.session.screenToDocumentPosition(screenLead.row + dir, screenLead.column);
            if (!range.isEmpty()) {
                var screenAnchor = this.session.documentToScreenPosition(isBackwards ? range.end : range.start);
                var anchor = this.session.screenToDocumentPosition(screenAnchor.row + dir, screenAnchor.column);
            } else var anchor = lead;
            if (isBackwards) {
                var newRange = Range.fromPoints(lead, anchor);
                newRange.cursor = newRange.start;
            } else {
                var newRange = Range.fromPoints(anchor, lead);
                newRange.cursor = newRange.end;
            }
            newRange.desiredColumn = screenLead.column;
            if (!this.selection.inMultiSelectMode) this.selection.addRange(range);
            else if (skip) var toRemove = range.cursor;
            this.selection.addRange(newRange);
            if (toRemove) this.selection.substractPoint(toRemove);
        };
        this.transposeSelections = function(dir) {
            var session = this.session;
            var sel = session.multiSelect;
            var all = sel.ranges;
            for(var i = all.length; i--;){
                var range = all[i];
                if (range.isEmpty()) {
                    var tmp = session.getWordRange(range.start.row, range.start.column);
                    range.start.row = tmp.start.row;
                    range.start.column = tmp.start.column;
                    range.end.row = tmp.end.row;
                    range.end.column = tmp.end.column;
                }
            }
            sel.mergeOverlappingRanges();
            var words = [];
            for(var i = all.length; i--;){
                var range = all[i];
                words.unshift(session.getTextRange(range));
            }
            if (dir < 0) words.unshift(words.pop());
            else words.push(words.shift());
            for(var i = all.length; i--;){
                var range = all[i];
                var tmp = range.clone();
                session.replace(range, words[i]);
                range.start.row = tmp.start.row;
                range.start.column = tmp.start.column;
            }
        };
        this.selectMore = function(dir, skip, stopAtFirst) {
            var session = this.session;
            var sel = session.multiSelect;
            var range = sel.toOrientedRange();
            if (range.isEmpty()) {
                range = session.getWordRange(range.start.row, range.start.column);
                range.cursor = dir == -1 ? range.start : range.end;
                this.multiSelect.addRange(range);
                if (stopAtFirst) return;
            }
            var needle = session.getTextRange(range);
            var newRange = find(session, needle, dir);
            if (newRange) {
                newRange.cursor = dir == -1 ? newRange.start : newRange.end;
                this.$blockScrolling += 1;
                this.session.unfold(newRange);
                this.multiSelect.addRange(newRange);
                this.$blockScrolling -= 1;
                this.renderer.scrollCursorIntoView(null, 0.5);
            }
            if (skip) this.multiSelect.substractPoint(range.cursor);
        };
        this.alignCursors = function() {
            var session = this.session;
            var sel = session.multiSelect;
            var ranges = sel.ranges;
            var row = -1;
            var sameRowRanges = ranges.filter(function(r) {
                if (r.cursor.row == row) return true;
                row = r.cursor.row;
            });
            if (!ranges.length || sameRowRanges.length == ranges.length - 1) {
                var range = this.selection.getRange();
                var fr = range.start.row, lr = range.end.row;
                var guessRange = fr == lr;
                if (guessRange) {
                    var max = this.session.getLength();
                    var line;
                    do line = this.session.getLine(lr);
                    while (/[=:]/.test(line) && ++lr < max);
                    do line = this.session.getLine(fr);
                    while (/[=:]/.test(line) && --fr > 0);
                    if (fr < 0) fr = 0;
                    if (lr >= max) lr = max - 1;
                }
                var lines = this.session.removeFullLines(fr, lr);
                lines = this.$reAlignText(lines, guessRange);
                this.session.insert({
                    row: fr,
                    column: 0
                }, lines.join("\n") + "\n");
                if (!guessRange) {
                    range.start.column = 0;
                    range.end.column = lines[lines.length - 1].length;
                }
                this.selection.setRange(range);
            } else {
                sameRowRanges.forEach(function(r) {
                    sel.substractPoint(r.cursor);
                });
                var maxCol = 0;
                var minSpace = Infinity;
                var spaceOffsets = ranges.map(function(r) {
                    var p = r.cursor;
                    var line = session.getLine(p.row);
                    var spaceOffset = line.substr(p.column).search(/\S/g);
                    if (spaceOffset == -1) spaceOffset = 0;
                    if (p.column > maxCol) maxCol = p.column;
                    if (spaceOffset < minSpace) minSpace = spaceOffset;
                    return spaceOffset;
                });
                ranges.forEach(function(r, i) {
                    var p = r.cursor;
                    var l = maxCol - p.column;
                    var d = spaceOffsets[i] - minSpace;
                    if (l > d) session.insert(p, lang.stringRepeat(" ", l - d));
                    else session.remove(new Range(p.row, p.column, p.row, p.column - l + d));
                    r.start.column = r.end.column = maxCol;
                    r.start.row = r.end.row = p.row;
                    r.cursor = r.end;
                });
                sel.fromOrientedRange(ranges[0]);
                this.renderer.updateCursor();
                this.renderer.updateBackMarkers();
            }
        };
        this.$reAlignText = function(lines, forceLeft) {
            var isLeftAligned = true, isRightAligned = true;
            var startW, textW, endW;
            return lines.map(function(line) {
                var m = line.match(/(\s*)(.*?)(\s*)([=:].*)/);
                if (!m) return [
                    line
                ];
                if (startW == null) {
                    startW = m[1].length;
                    textW = m[2].length;
                    endW = m[3].length;
                    return m;
                }
                if (startW + textW + endW != m[1].length + m[2].length + m[3].length) isRightAligned = false;
                if (startW != m[1].length) isLeftAligned = false;
                if (startW > m[1].length) startW = m[1].length;
                if (textW < m[2].length) textW = m[2].length;
                if (endW > m[3].length) endW = m[3].length;
                return m;
            }).map(forceLeft ? alignLeft : isLeftAligned ? isRightAligned ? alignRight : alignLeft : unAlign);
            function spaces(n) {
                return lang.stringRepeat(" ", n);
            }
            function alignLeft(m) {
                return !m[2] ? m[0] : spaces(startW) + m[2] + spaces(textW - m[2].length + endW) + m[4].replace(/^([=:])\s+/, "$1 ");
            }
            function alignRight(m) {
                return !m[2] ? m[0] : spaces(startW + textW - m[2].length) + m[2] + spaces(endW, " ") + m[4].replace(/^([=:])\s+/, "$1 ");
            }
            function unAlign(m) {
                return !m[2] ? m[0] : spaces(startW) + m[2] + spaces(endW) + m[4].replace(/^([=:])\s+/, "$1 ");
            }
        };
    }).call(Editor.prototype);
    function isSamePoint(p1, p2) {
        return p1.row == p2.row && p1.column == p2.column;
    }
    exports.onSessionChange = function(e) {
        var session = e.session;
        if (session && !session.multiSelect) {
            session.$selectionMarkers = [];
            session.selection.$initRangeList();
            session.multiSelect = session.selection;
        }
        this.multiSelect = session && session.multiSelect;
        var oldSession = e.oldSession;
        if (oldSession) {
            oldSession.multiSelect.off("addRange", this.$onAddRange);
            oldSession.multiSelect.off("removeRange", this.$onRemoveRange);
            oldSession.multiSelect.off("multiSelect", this.$onMultiSelect);
            oldSession.multiSelect.off("singleSelect", this.$onSingleSelect);
            oldSession.multiSelect.lead.off("change", this.$checkMultiselectChange);
            oldSession.multiSelect.anchor.off("change", this.$checkMultiselectChange);
        }
        if (session) {
            session.multiSelect.on("addRange", this.$onAddRange);
            session.multiSelect.on("removeRange", this.$onRemoveRange);
            session.multiSelect.on("multiSelect", this.$onMultiSelect);
            session.multiSelect.on("singleSelect", this.$onSingleSelect);
            session.multiSelect.lead.on("change", this.$checkMultiselectChange);
            session.multiSelect.anchor.on("change", this.$checkMultiselectChange);
        }
        if (session && this.inMultiSelectMode != session.selection.inMultiSelectMode) {
            if (session.selection.inMultiSelectMode) this.$onMultiSelect();
            else this.$onSingleSelect();
        }
    };
    function MultiSelect(editor) {
        if (editor.$multiselectOnSessionChange) return;
        editor.$onAddRange = editor.$onAddRange.bind(editor);
        editor.$onRemoveRange = editor.$onRemoveRange.bind(editor);
        editor.$onMultiSelect = editor.$onMultiSelect.bind(editor);
        editor.$onSingleSelect = editor.$onSingleSelect.bind(editor);
        editor.$multiselectOnSessionChange = exports.onSessionChange.bind(editor);
        editor.$checkMultiselectChange = editor.$checkMultiselectChange.bind(editor);
        editor.$multiselectOnSessionChange(editor);
        editor.on("changeSession", editor.$multiselectOnSessionChange);
        editor.on("mousedown", onMouseDown);
        editor.commands.addCommands(commands.defaultCommands);
        addAltCursorListeners(editor);
    }
    function addAltCursorListeners(editor) {
        var el = editor.textInput.getElement();
        var altCursor = false;
        event.addListener(el, "keydown", function(e) {
            var altDown = e.keyCode == 18 && !(e.ctrlKey || e.shiftKey || e.metaKey);
            if (editor.$blockSelectEnabled && altDown) {
                if (!altCursor) {
                    editor.renderer.setMouseCursor("crosshair");
                    altCursor = true;
                }
            } else if (altCursor) reset();
        });
        event.addListener(el, "keyup", reset);
        event.addListener(el, "blur", reset);
        function reset(e) {
            if (altCursor) {
                editor.renderer.setMouseCursor("");
                altCursor = false;
            }
        }
    }
    exports.MultiSelect = MultiSelect;
    acequire("./config").defineOptions(Editor.prototype, "editor", {
        enableMultiselect: {
            set: function(val) {
                MultiSelect(this);
                if (val) {
                    this.on("changeSession", this.$multiselectOnSessionChange);
                    this.on("mousedown", onMouseDown);
                } else {
                    this.off("changeSession", this.$multiselectOnSessionChange);
                    this.off("mousedown", onMouseDown);
                }
            },
            value: true
        },
        enableBlockSelect: {
            set: function(val) {
                this.$blockSelectEnabled = val;
            },
            value: true
        }
    });
});
ace.define("ace/mode/folding/fold_mode", [
    "require",
    "exports",
    "module",
    "ace/range"
], function(acequire, exports, module1) {
    "use strict";
    var Range = acequire("../../range").Range;
    var FoldMode = exports.FoldMode = function() {};
    (function() {
        this.foldingStartMarker = null;
        this.foldingStopMarker = null;
        this.getFoldWidget = function(session, foldStyle, row) {
            var line = session.getLine(row);
            if (this.foldingStartMarker.test(line)) return "start";
            if (foldStyle == "markbeginend" && this.foldingStopMarker && this.foldingStopMarker.test(line)) return "end";
            return "";
        };
        this.getFoldWidgetRange = function(session, foldStyle, row) {
            return null;
        };
        this.indentationBlock = function(session, row, column) {
            var re = /\S/;
            var line = session.getLine(row);
            var startLevel = line.search(re);
            if (startLevel == -1) return;
            var startColumn = column || line.length;
            var maxRow = session.getLength();
            var startRow = row;
            var endRow = row;
            while(++row < maxRow){
                var level = session.getLine(row).search(re);
                if (level == -1) continue;
                if (level <= startLevel) break;
                endRow = row;
            }
            if (endRow > startRow) {
                var endColumn = session.getLine(endRow).length;
                return new Range(startRow, startColumn, endRow, endColumn);
            }
        };
        this.openingBracketBlock = function(session, bracket, row, column, typeRe) {
            var start = {
                row: row,
                column: column + 1
            };
            var end = session.$findClosingBracket(bracket, start, typeRe);
            if (!end) return;
            var fw = session.foldWidgets[end.row];
            if (fw == null) fw = session.getFoldWidget(end.row);
            if (fw == "start" && end.row > start.row) {
                end.row--;
                end.column = session.getLine(end.row).length;
            }
            return Range.fromPoints(start, end);
        };
        this.closingBracketBlock = function(session, bracket, row, column, typeRe) {
            var end = {
                row: row,
                column: column
            };
            var start = session.$findOpeningBracket(bracket, end);
            if (!start) return;
            start.column++;
            end.column--;
            return Range.fromPoints(start, end);
        };
    }).call(FoldMode.prototype);
});
ace.define("ace/theme/textmate", [
    "require",
    "exports",
    "module",
    "ace/lib/dom"
], function(acequire, exports, module1) {
    "use strict";
    exports.isDark = false;
    exports.cssClass = "ace-tm";
    exports.cssText = ".ace-tm .ace_gutter {\
background: #f0f0f0;\
color: #333;\
}\
.ace-tm .ace_print-margin {\
width: 1px;\
background: #e8e8e8;\
}\
.ace-tm .ace_fold {\
background-color: #6B72E6;\
}\
.ace-tm {\
background-color: #FFFFFF;\
color: black;\
}\
.ace-tm .ace_cursor {\
color: black;\
}\
.ace-tm .ace_invisible {\
color: rgb(191, 191, 191);\
}\
.ace-tm .ace_storage,\
.ace-tm .ace_keyword {\
color: blue;\
}\
.ace-tm .ace_constant {\
color: rgb(197, 6, 11);\
}\
.ace-tm .ace_constant.ace_buildin {\
color: rgb(88, 72, 246);\
}\
.ace-tm .ace_constant.ace_language {\
color: rgb(88, 92, 246);\
}\
.ace-tm .ace_constant.ace_library {\
color: rgb(6, 150, 14);\
}\
.ace-tm .ace_invalid {\
background-color: rgba(255, 0, 0, 0.1);\
color: red;\
}\
.ace-tm .ace_support.ace_function {\
color: rgb(60, 76, 114);\
}\
.ace-tm .ace_support.ace_constant {\
color: rgb(6, 150, 14);\
}\
.ace-tm .ace_support.ace_type,\
.ace-tm .ace_support.ace_class {\
color: rgb(109, 121, 222);\
}\
.ace-tm .ace_keyword.ace_operator {\
color: rgb(104, 118, 135);\
}\
.ace-tm .ace_string {\
color: rgb(3, 106, 7);\
}\
.ace-tm .ace_comment {\
color: rgb(76, 136, 107);\
}\
.ace-tm .ace_comment.ace_doc {\
color: rgb(0, 102, 255);\
}\
.ace-tm .ace_comment.ace_doc.ace_tag {\
color: rgb(128, 159, 191);\
}\
.ace-tm .ace_constant.ace_numeric {\
color: rgb(0, 0, 205);\
}\
.ace-tm .ace_variable {\
color: rgb(49, 132, 149);\
}\
.ace-tm .ace_xml-pe {\
color: rgb(104, 104, 91);\
}\
.ace-tm .ace_entity.ace_name.ace_function {\
color: #0000A2;\
}\
.ace-tm .ace_heading {\
color: rgb(12, 7, 255);\
}\
.ace-tm .ace_list {\
color:rgb(185, 6, 144);\
}\
.ace-tm .ace_meta.ace_tag {\
color:rgb(0, 22, 142);\
}\
.ace-tm .ace_string.ace_regex {\
color: rgb(255, 0, 0)\
}\
.ace-tm .ace_marker-layer .ace_selection {\
background: rgb(181, 213, 255);\
}\
.ace-tm.ace_multiselect .ace_selection.ace_start {\
box-shadow: 0 0 3px 0px white;\
}\
.ace-tm .ace_marker-layer .ace_step {\
background: rgb(252, 255, 0);\
}\
.ace-tm .ace_marker-layer .ace_stack {\
background: rgb(164, 229, 101);\
}\
.ace-tm .ace_marker-layer .ace_bracket {\
margin: -1px 0 0 -1px;\
border: 1px solid rgb(192, 192, 192);\
}\
.ace-tm .ace_marker-layer .ace_active-line {\
background: rgba(0, 0, 0, 0.07);\
}\
.ace-tm .ace_gutter-active-line {\
background-color : #dcdcdc;\
}\
.ace-tm .ace_marker-layer .ace_selected-word {\
background: rgb(250, 250, 255);\
border: 1px solid rgb(200, 200, 250);\
}\
.ace-tm .ace_indent-guide {\
background: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAAE0lEQVQImWP4////f4bLly//BwAmVgd1/w11/gAAAABJRU5ErkJggg==\") right repeat-y;\
}\
";
    var dom = acequire("../lib/dom");
    dom.importCssString(exports.cssText, exports.cssClass);
});
ace.define("ace/line_widgets", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/lib/dom",
    "ace/range"
], function(acequire, exports, module1) {
    "use strict";
    var oop = acequire("./lib/oop");
    var dom = acequire("./lib/dom");
    var Range = acequire("./range").Range;
    function LineWidgets(session) {
        this.session = session;
        this.session.widgetManager = this;
        this.session.getRowLength = this.getRowLength;
        this.session.$getWidgetScreenLength = this.$getWidgetScreenLength;
        this.updateOnChange = this.updateOnChange.bind(this);
        this.renderWidgets = this.renderWidgets.bind(this);
        this.measureWidgets = this.measureWidgets.bind(this);
        this.session._changedWidgets = [];
        this.$onChangeEditor = this.$onChangeEditor.bind(this);
        this.session.on("change", this.updateOnChange);
        this.session.on("changeFold", this.updateOnFold);
        this.session.on("changeEditor", this.$onChangeEditor);
    }
    (function() {
        this.getRowLength = function(row) {
            var h;
            if (this.lineWidgets) h = this.lineWidgets[row] && this.lineWidgets[row].rowCount || 0;
            else h = 0;
            if (!this.$useWrapMode || !this.$wrapData[row]) return 1 + h;
            else return this.$wrapData[row].length + 1 + h;
        };
        this.$getWidgetScreenLength = function() {
            var screenRows = 0;
            this.lineWidgets.forEach(function(w) {
                if (w && w.rowCount && !w.hidden) screenRows += w.rowCount;
            });
            return screenRows;
        };
        this.$onChangeEditor = function(e) {
            this.attach(e.editor);
        };
        this.attach = function(editor) {
            if (editor && editor.widgetManager && editor.widgetManager != this) editor.widgetManager.detach();
            if (this.editor == editor) return;
            this.detach();
            this.editor = editor;
            if (editor) {
                editor.widgetManager = this;
                editor.renderer.on("beforeRender", this.measureWidgets);
                editor.renderer.on("afterRender", this.renderWidgets);
            }
        };
        this.detach = function(e) {
            var editor = this.editor;
            if (!editor) return;
            this.editor = null;
            editor.widgetManager = null;
            editor.renderer.off("beforeRender", this.measureWidgets);
            editor.renderer.off("afterRender", this.renderWidgets);
            var lineWidgets = this.session.lineWidgets;
            lineWidgets && lineWidgets.forEach(function(w) {
                if (w && w.el && w.el.parentNode) {
                    w._inDocument = false;
                    w.el.parentNode.removeChild(w.el);
                }
            });
        };
        this.updateOnFold = function(e, session) {
            var lineWidgets = session.lineWidgets;
            if (!lineWidgets || !e.action) return;
            var fold = e.data;
            var start = fold.start.row;
            var end = fold.end.row;
            var hide = e.action == "add";
            for(var i = start + 1; i < end; i++)if (lineWidgets[i]) lineWidgets[i].hidden = hide;
            if (lineWidgets[end]) {
                if (hide) {
                    if (!lineWidgets[start]) lineWidgets[start] = lineWidgets[end];
                    else lineWidgets[end].hidden = hide;
                } else {
                    if (lineWidgets[start] == lineWidgets[end]) lineWidgets[start] = undefined;
                    lineWidgets[end].hidden = hide;
                }
            }
        };
        this.updateOnChange = function(delta) {
            var lineWidgets = this.session.lineWidgets;
            if (!lineWidgets) return;
            var startRow = delta.start.row;
            var len = delta.end.row - startRow;
            if (len === 0) ;
            else if (delta.action == 'remove') {
                var removed = lineWidgets.splice(startRow + 1, len);
                removed.forEach(function(w) {
                    w && this.removeLineWidget(w);
                }, this);
                this.$updateRows();
            } else {
                var args = new Array(len);
                args.unshift(startRow, 0);
                lineWidgets.splice.apply(lineWidgets, args);
                this.$updateRows();
            }
        };
        this.$updateRows = function() {
            var lineWidgets = this.session.lineWidgets;
            if (!lineWidgets) return;
            var noWidgets = true;
            lineWidgets.forEach(function(w, i) {
                if (w) {
                    noWidgets = false;
                    w.row = i;
                    while(w.$oldWidget){
                        w.$oldWidget.row = i;
                        w = w.$oldWidget;
                    }
                }
            });
            if (noWidgets) this.session.lineWidgets = null;
        };
        this.addLineWidget = function(w) {
            if (!this.session.lineWidgets) this.session.lineWidgets = new Array(this.session.getLength());
            var old = this.session.lineWidgets[w.row];
            if (old) {
                w.$oldWidget = old;
                if (old.el && old.el.parentNode) {
                    old.el.parentNode.removeChild(old.el);
                    old._inDocument = false;
                }
            }
            this.session.lineWidgets[w.row] = w;
            w.session = this.session;
            var renderer = this.editor.renderer;
            if (w.html && !w.el) {
                w.el = dom.createElement("div");
                w.el.innerHTML = w.html;
            }
            if (w.el) {
                dom.addCssClass(w.el, "ace_lineWidgetContainer");
                w.el.style.position = "absolute";
                w.el.style.zIndex = 5;
                renderer.container.appendChild(w.el);
                w._inDocument = true;
            }
            if (!w.coverGutter) w.el.style.zIndex = 3;
            if (w.pixelHeight == null) w.pixelHeight = w.el.offsetHeight;
            if (w.rowCount == null) w.rowCount = w.pixelHeight / renderer.layerConfig.lineHeight;
            var fold = this.session.getFoldAt(w.row, 0);
            w.$fold = fold;
            if (fold) {
                var lineWidgets = this.session.lineWidgets;
                if (w.row == fold.end.row && !lineWidgets[fold.start.row]) lineWidgets[fold.start.row] = w;
                else w.hidden = true;
            }
            this.session._emit("changeFold", {
                data: {
                    start: {
                        row: w.row
                    }
                }
            });
            this.$updateRows();
            this.renderWidgets(null, renderer);
            this.onWidgetChanged(w);
            return w;
        };
        this.removeLineWidget = function(w) {
            w._inDocument = false;
            w.session = null;
            if (w.el && w.el.parentNode) w.el.parentNode.removeChild(w.el);
            if (w.editor && w.editor.destroy) try {
                w.editor.destroy();
            } catch (e) {}
            if (this.session.lineWidgets) {
                var w1 = this.session.lineWidgets[w.row];
                if (w1 == w) {
                    this.session.lineWidgets[w.row] = w.$oldWidget;
                    if (w.$oldWidget) this.onWidgetChanged(w.$oldWidget);
                } else while(w1){
                    if (w1.$oldWidget == w) {
                        w1.$oldWidget = w.$oldWidget;
                        break;
                    }
                    w1 = w1.$oldWidget;
                }
            }
            this.session._emit("changeFold", {
                data: {
                    start: {
                        row: w.row
                    }
                }
            });
            this.$updateRows();
        };
        this.getWidgetsAtRow = function(row) {
            var lineWidgets = this.session.lineWidgets;
            var w = lineWidgets && lineWidgets[row];
            var list = [];
            while(w){
                list.push(w);
                w = w.$oldWidget;
            }
            return list;
        };
        this.onWidgetChanged = function(w) {
            this.session._changedWidgets.push(w);
            this.editor && this.editor.renderer.updateFull();
        };
        this.measureWidgets = function(e, renderer) {
            var changedWidgets = this.session._changedWidgets;
            var config = renderer.layerConfig;
            if (!changedWidgets || !changedWidgets.length) return;
            var min = Infinity;
            for(var i = 0; i < changedWidgets.length; i++){
                var w = changedWidgets[i];
                if (!w || !w.el) continue;
                if (w.session != this.session) continue;
                if (!w._inDocument) {
                    if (this.session.lineWidgets[w.row] != w) continue;
                    w._inDocument = true;
                    renderer.container.appendChild(w.el);
                }
                w.h = w.el.offsetHeight;
                if (!w.fixedWidth) {
                    w.w = w.el.offsetWidth;
                    w.screenWidth = Math.ceil(w.w / config.characterWidth);
                }
                var rowCount = w.h / config.lineHeight;
                if (w.coverLine) {
                    rowCount -= this.session.getRowLineCount(w.row);
                    if (rowCount < 0) rowCount = 0;
                }
                if (w.rowCount != rowCount) {
                    w.rowCount = rowCount;
                    if (w.row < min) min = w.row;
                }
            }
            if (min != Infinity) {
                this.session._emit("changeFold", {
                    data: {
                        start: {
                            row: min
                        }
                    }
                });
                this.session.lineWidgetWidth = null;
            }
            this.session._changedWidgets = [];
        };
        this.renderWidgets = function(e, renderer) {
            var config = renderer.layerConfig;
            var lineWidgets = this.session.lineWidgets;
            if (!lineWidgets) return;
            var first = Math.min(this.firstRow, config.firstRow);
            var last = Math.max(this.lastRow, config.lastRow, lineWidgets.length);
            while(first > 0 && !lineWidgets[first])first--;
            this.firstRow = config.firstRow;
            this.lastRow = config.lastRow;
            renderer.$cursorLayer.config = config;
            for(var i = first; i <= last; i++){
                var w = lineWidgets[i];
                if (!w || !w.el) continue;
                if (w.hidden) {
                    w.el.style.top = -100 - (w.pixelHeight || 0) + "px";
                    continue;
                }
                if (!w._inDocument) {
                    w._inDocument = true;
                    renderer.container.appendChild(w.el);
                }
                var top = renderer.$cursorLayer.getPixelPosition({
                    row: i,
                    column: 0
                }, true).top;
                if (!w.coverLine) top += config.lineHeight * this.session.getRowLineCount(w.row);
                w.el.style.top = top - config.offset + "px";
                var left = w.coverGutter ? 0 : renderer.gutterWidth;
                if (!w.fixedWidth) left -= renderer.scrollLeft;
                w.el.style.left = left + "px";
                if (w.fullWidth && w.screenWidth) w.el.style.minWidth = config.width + 2 * config.padding + "px";
                if (w.fixedWidth) w.el.style.right = renderer.scrollBar.getWidth() + "px";
                else w.el.style.right = "";
            }
        };
    }).call(LineWidgets.prototype);
    exports.LineWidgets = LineWidgets;
});
ace.define("ace/ext/error_marker", [
    "require",
    "exports",
    "module",
    "ace/line_widgets",
    "ace/lib/dom",
    "ace/range"
], function(acequire, exports, module1) {
    "use strict";
    var LineWidgets = acequire("../line_widgets").LineWidgets;
    var dom = acequire("../lib/dom");
    var Range = acequire("../range").Range;
    function binarySearch(array, needle, comparator) {
        var first = 0;
        var last = array.length - 1;
        while(first <= last){
            var mid = first + last >> 1;
            var c = comparator(needle, array[mid]);
            if (c > 0) first = mid + 1;
            else if (c < 0) last = mid - 1;
            else return mid;
        }
        return -(first + 1);
    }
    function findAnnotations(session, row, dir) {
        var annotations = session.getAnnotations().sort(Range.comparePoints);
        if (!annotations.length) return;
        var i = binarySearch(annotations, {
            row: row,
            column: -1
        }, Range.comparePoints);
        if (i < 0) i = -i - 1;
        if (i >= annotations.length) i = dir > 0 ? 0 : annotations.length - 1;
        else if (i === 0 && dir < 0) i = annotations.length - 1;
        var annotation = annotations[i];
        if (!annotation || !dir) return;
        if (annotation.row === row) {
            do annotation = annotations[i += dir];
            while (annotation && annotation.row === row);
            if (!annotation) return annotations.slice();
        }
        var matched = [];
        row = annotation.row;
        do {
            matched[dir < 0 ? "unshift" : "push"](annotation);
            annotation = annotations[i += dir];
        }while (annotation && annotation.row == row);
        return matched.length && matched;
    }
    exports.showErrorMarker = function(editor, dir) {
        var session = editor.session;
        if (!session.widgetManager) {
            session.widgetManager = new LineWidgets(session);
            session.widgetManager.attach(editor);
        }
        var pos = editor.getCursorPosition();
        var row = pos.row;
        var oldWidget = session.widgetManager.getWidgetsAtRow(row).filter(function(w) {
            return w.type == "errorMarker";
        })[0];
        if (oldWidget) oldWidget.destroy();
        else row -= dir;
        var annotations = findAnnotations(session, row, dir);
        var gutterAnno;
        if (annotations) {
            var annotation = annotations[0];
            pos.column = (annotation.pos && typeof annotation.column != "number" ? annotation.pos.sc : annotation.column) || 0;
            pos.row = annotation.row;
            gutterAnno = editor.renderer.$gutterLayer.$annotations[pos.row];
        } else if (oldWidget) return;
        else gutterAnno = {
            text: [
                "Looks good!"
            ],
            className: "ace_ok"
        };
        editor.session.unfold(pos.row);
        editor.selection.moveToPosition(pos);
        var w = {
            row: pos.row,
            fixedWidth: true,
            coverGutter: true,
            el: dom.createElement("div"),
            type: "errorMarker"
        };
        var el = w.el.appendChild(dom.createElement("div"));
        var arrow = w.el.appendChild(dom.createElement("div"));
        arrow.className = "error_widget_arrow " + gutterAnno.className;
        var left = editor.renderer.$cursorLayer.getPixelPosition(pos).left;
        arrow.style.left = left + editor.renderer.gutterWidth - 5 + "px";
        w.el.className = "error_widget_wrapper";
        el.className = "error_widget " + gutterAnno.className;
        el.innerHTML = gutterAnno.text.join("<br>");
        el.appendChild(dom.createElement("div"));
        var kb = function(_, hashId, keyString) {
            if (hashId === 0 && (keyString === "esc" || keyString === "return")) {
                w.destroy();
                return {
                    command: "null"
                };
            }
        };
        w.destroy = function() {
            if (editor.$mouseHandler.isMousePressed) return;
            editor.keyBinding.removeKeyboardHandler(kb);
            session.widgetManager.removeLineWidget(w);
            editor.off("changeSelection", w.destroy);
            editor.off("changeSession", w.destroy);
            editor.off("mouseup", w.destroy);
            editor.off("change", w.destroy);
        };
        editor.keyBinding.addKeyboardHandler(kb);
        editor.on("changeSelection", w.destroy);
        editor.on("changeSession", w.destroy);
        editor.on("mouseup", w.destroy);
        editor.on("change", w.destroy);
        editor.session.widgetManager.addLineWidget(w);
        w.el.onmousedown = editor.focus.bind(editor);
        editor.renderer.scrollCursorIntoView(null, 0.5, {
            bottom: w.el.offsetHeight
        });
    };
    dom.importCssString("\
    .error_widget_wrapper {\
        background: inherit;\
        color: inherit;\
        border:none\
    }\
    .error_widget {\
        border-top: solid 2px;\
        border-bottom: solid 2px;\
        margin: 5px 0;\
        padding: 10px 40px;\
        white-space: pre-wrap;\
    }\
    .error_widget.ace_error, .error_widget_arrow.ace_error{\
        border-color: #ff5a5a\
    }\
    .error_widget.ace_warning, .error_widget_arrow.ace_warning{\
        border-color: #F1D817\
    }\
    .error_widget.ace_info, .error_widget_arrow.ace_info{\
        border-color: #5a5a5a\
    }\
    .error_widget.ace_ok, .error_widget_arrow.ace_ok{\
        border-color: #5aaa5a\
    }\
    .error_widget_arrow {\
        position: absolute;\
        border: solid 5px;\
        border-top-color: transparent!important;\
        border-right-color: transparent!important;\
        border-left-color: transparent!important;\
        top: -5px;\
    }\
", "");
});
ace.define("ace/ace", [
    "require",
    "exports",
    "module",
    "ace/lib/fixoldbrowsers",
    "ace/lib/dom",
    "ace/lib/event",
    "ace/editor",
    "ace/edit_session",
    "ace/undomanager",
    "ace/virtual_renderer",
    "ace/worker/worker_client",
    "ace/keyboard/hash_handler",
    "ace/placeholder",
    "ace/multi_select",
    "ace/mode/folding/fold_mode",
    "ace/theme/textmate",
    "ace/ext/error_marker",
    "ace/config"
], function(acequire, exports, module1) {
    "use strict";
    acequire("./lib/fixoldbrowsers");
    var dom = acequire("./lib/dom");
    var event = acequire("./lib/event");
    var Editor = acequire("./editor").Editor;
    var EditSession = acequire("./edit_session").EditSession;
    var UndoManager = acequire("./undomanager").UndoManager;
    var Renderer = acequire("./virtual_renderer").VirtualRenderer;
    acequire("./worker/worker_client");
    acequire("./keyboard/hash_handler");
    acequire("./placeholder");
    acequire("./multi_select");
    acequire("./mode/folding/fold_mode");
    acequire("./theme/textmate");
    acequire("./ext/error_marker");
    exports.config = acequire("./config");
    exports.acequire = acequire;
    if (typeof define === "function") exports.define = define;
    exports.edit = function(el) {
        if (typeof el == "string") {
            var _id = el;
            el = document.getElementById(_id);
            if (!el) throw new Error("ace.edit can't find div #" + _id);
        }
        if (el && el.env && el.env.editor instanceof Editor) return el.env.editor;
        var value = "";
        if (el && /input|textarea/i.test(el.tagName)) {
            var oldNode = el;
            value = oldNode.value;
            el = dom.createElement("pre");
            oldNode.parentNode.replaceChild(el, oldNode);
        } else if (el) {
            value = dom.getInnerText(el);
            el.innerHTML = "";
        }
        var doc = exports.createEditSession(value);
        var editor = new Editor(new Renderer(el));
        editor.setSession(doc);
        var env = {
            document: doc,
            editor: editor,
            onResize: editor.resize.bind(editor, null)
        };
        if (oldNode) env.textarea = oldNode;
        event.addListener(window, "resize", env.onResize);
        editor.on("destroy", function() {
            event.removeListener(window, "resize", env.onResize);
            env.editor.container.env = null; // prevent memory leak on old ie
        });
        editor.container.env = editor.env = env;
        return editor;
    };
    exports.createEditSession = function(text, mode) {
        var doc = new EditSession(text, mode);
        doc.setUndoManager(new UndoManager());
        return doc;
    };
    exports.EditSession = EditSession;
    exports.UndoManager = UndoManager;
    exports.version = "1.2.9";
});
(function() {
    ace.acequire([
        "ace/ace"
    ], function(a) {
        if (a) {
            a.config.init(true);
            a.define = ace.define;
        }
        if (!window.ace) window.ace = a;
        for(var key in a)if (a.hasOwnProperty(key)) window.ace[key] = a[key];
    });
})();
module.exports = window.ace.acequire("ace/ace");

});



parcelRegister("les1L", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $Hu4Ju = parcelRequire("Hu4Ju");
parcelRequire("j9Ter");

var $f750a56f8b38f9a9$var$_react = $f750a56f8b38f9a9$var$_interopRequireWildcard((parcelRequire("lx97N")));

var $f750a56f8b38f9a9$var$_propTypes = $f750a56f8b38f9a9$var$_interopRequireDefault((parcelRequire("4RND8")));

var $f750a56f8b38f9a9$var$_lodash = $f750a56f8b38f9a9$var$_interopRequireDefault((parcelRequire("iljZL")));

var $f750a56f8b38f9a9$var$_lodash2 = $f750a56f8b38f9a9$var$_interopRequireDefault((parcelRequire("j0yhs")));
parcelRequire("6dVOx");
function $f750a56f8b38f9a9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $f750a56f8b38f9a9$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj["default"] = obj;
        return newObj;
    }
}
function $f750a56f8b38f9a9$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $f750a56f8b38f9a9$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $f750a56f8b38f9a9$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $f750a56f8b38f9a9$var$_typeof(obj);
}
function $f750a56f8b38f9a9$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $f750a56f8b38f9a9$var$_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function $f750a56f8b38f9a9$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f750a56f8b38f9a9$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f750a56f8b38f9a9$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $f750a56f8b38f9a9$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f750a56f8b38f9a9$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f750a56f8b38f9a9$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $f750a56f8b38f9a9$var$_possibleConstructorReturn(self, call) {
    if (call && ($f750a56f8b38f9a9$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $f750a56f8b38f9a9$var$_assertThisInitialized(self);
}
function $f750a56f8b38f9a9$var$_getPrototypeOf(o) {
    $f750a56f8b38f9a9$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $f750a56f8b38f9a9$var$_getPrototypeOf(o);
}
function $f750a56f8b38f9a9$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $f750a56f8b38f9a9$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $f750a56f8b38f9a9$var$_setPrototypeOf(subClass, superClass);
}
function $f750a56f8b38f9a9$var$_setPrototypeOf(o, p) {
    $f750a56f8b38f9a9$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $f750a56f8b38f9a9$var$_setPrototypeOf(o, p);
}
var $f750a56f8b38f9a9$var$ace = (0, $Hu4Ju.getAceInstance)();
var $f750a56f8b38f9a9$var$_ace$acequire = $f750a56f8b38f9a9$var$ace.acequire('ace/range'), $f750a56f8b38f9a9$var$Range = $f750a56f8b38f9a9$var$_ace$acequire.Range;
var $f750a56f8b38f9a9$var$_ace$acequire2 = $f750a56f8b38f9a9$var$ace.acequire('ace/split'), $f750a56f8b38f9a9$var$Split = $f750a56f8b38f9a9$var$_ace$acequire2.Split;
var $f750a56f8b38f9a9$var$SplitComponent = /*#__PURE__*/ function(_Component) {
    $f750a56f8b38f9a9$var$_inherits(SplitComponent, _Component);
    function SplitComponent(props) {
        var _this;
        $f750a56f8b38f9a9$var$_classCallCheck(this, SplitComponent);
        _this = $f750a56f8b38f9a9$var$_possibleConstructorReturn(this, $f750a56f8b38f9a9$var$_getPrototypeOf(SplitComponent).call(this, props));
        $Hu4Ju.editorEvents.forEach(function(method) {
            _this[method] = _this[method].bind($f750a56f8b38f9a9$var$_assertThisInitialized(_this));
        });
        _this.debounce = $Hu4Ju.debounce;
        return _this;
    }
    $f750a56f8b38f9a9$var$_createClass(SplitComponent, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this2 = this;
                var _this$props = this.props, className = _this$props.className, onBeforeLoad = _this$props.onBeforeLoad, mode = _this$props.mode, focus = _this$props.focus, theme = _this$props.theme, fontSize = _this$props.fontSize, value = _this$props.value, defaultValue = _this$props.defaultValue, cursorStart = _this$props.cursorStart, showGutter = _this$props.showGutter, wrapEnabled = _this$props.wrapEnabled, showPrintMargin = _this$props.showPrintMargin, _this$props$scrollMar = _this$props.scrollMargin, scrollMargin = _this$props$scrollMar === void 0 ? [
                    0,
                    0,
                    0,
                    0
                ] : _this$props$scrollMar, keyboardHandler = _this$props.keyboardHandler, onLoad = _this$props.onLoad, commands = _this$props.commands, annotations = _this$props.annotations, markers = _this$props.markers, splits = _this$props.splits;
                this.editor = $f750a56f8b38f9a9$var$ace.edit(this.refEditor);
                if (onBeforeLoad) onBeforeLoad($f750a56f8b38f9a9$var$ace);
                var editorProps = Object.keys(this.props.editorProps);
                var split = new $f750a56f8b38f9a9$var$Split(this.editor.container, "ace/theme/".concat(theme), splits);
                this.editor.env.split = split;
                this.splitEditor = split.getEditor(0);
                this.split = split; // in a split scenario we don't want a print margin for the entire application
                this.editor.setShowPrintMargin(false);
                this.editor.renderer.setShowGutter(false); // get a list of possible options to avoid 'misspelled option errors'
                var availableOptions = this.splitEditor.$options;
                if (this.props.debounceChangePeriod) this.onChange = this.debounce(this.onChange, this.props.debounceChangePeriod);
                split.forEach(function(editor, index) {
                    for(var i = 0; i < editorProps.length; i++)editor[editorProps[i]] = _this2.props.editorProps[editorProps[i]];
                    var defaultValueForEditor = (0, $f750a56f8b38f9a9$var$_lodash2["default"])(defaultValue, index);
                    var valueForEditor = (0, $f750a56f8b38f9a9$var$_lodash2["default"])(value, index, '');
                    editor.session.setUndoManager(new $f750a56f8b38f9a9$var$ace.UndoManager());
                    editor.setTheme("ace/theme/".concat(theme));
                    editor.renderer.setScrollMargin(scrollMargin[0], scrollMargin[1], scrollMargin[2], scrollMargin[3]);
                    editor.getSession().setMode("ace/mode/".concat(mode));
                    editor.setFontSize(fontSize);
                    editor.renderer.setShowGutter(showGutter);
                    editor.getSession().setUseWrapMode(wrapEnabled);
                    editor.setShowPrintMargin(showPrintMargin);
                    editor.on('focus', _this2.onFocus);
                    editor.on('blur', _this2.onBlur);
                    editor.on('input', _this2.onInput);
                    editor.on('copy', _this2.onCopy);
                    editor.on('paste', _this2.onPaste);
                    editor.on('change', _this2.onChange);
                    editor.getSession().selection.on('changeSelection', _this2.onSelectionChange);
                    editor.getSession().selection.on('changeCursor', _this2.onCursorChange);
                    editor.session.on('changeScrollTop', _this2.onScroll);
                    editor.setValue(defaultValueForEditor === undefined ? valueForEditor : defaultValueForEditor, cursorStart);
                    var newAnnotations = (0, $f750a56f8b38f9a9$var$_lodash2["default"])(annotations, index, []);
                    var newMarkers = (0, $f750a56f8b38f9a9$var$_lodash2["default"])(markers, index, []);
                    editor.getSession().setAnnotations(newAnnotations);
                    if (newMarkers && newMarkers.length > 0) _this2.handleMarkers(newMarkers, editor);
                    for(var _i = 0; _i < $Hu4Ju.editorOptions.length; _i++){
                        var option = $Hu4Ju.editorOptions[_i];
                        if (availableOptions.hasOwnProperty(option)) editor.setOption(option, _this2.props[option]);
                        else if (_this2.props[option]) console.warn("ReaceAce: editor option ".concat(option, " was activated but not found. Did you need to import a related tool or did you possibly mispell the option?"));
                    }
                    _this2.handleOptions(_this2.props, editor);
                    if (Array.isArray(commands)) commands.forEach(function(command) {
                        if (typeof command.exec == 'string') editor.commands.bindKey(command.bindKey, command.exec);
                        else editor.commands.addCommand(command);
                    });
                    if (keyboardHandler) editor.setKeyboardHandler('ace/keyboard/' + keyboardHandler);
                });
                if (className) this.refEditor.className += ' ' + className;
                if (focus) this.splitEditor.focus();
                var sp = this.editor.env.split;
                sp.setOrientation(this.props.orientation === 'below' ? sp.BELOW : sp.BESIDE);
                sp.resize(true);
                if (onLoad) onLoad(sp);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this3 = this;
                var oldProps = prevProps;
                var nextProps = this.props;
                var split = this.editor.env.split;
                if (nextProps.splits !== oldProps.splits) split.setSplits(nextProps.splits);
                if (nextProps.orientation !== oldProps.orientation) split.setOrientation(nextProps.orientation === 'below' ? split.BELOW : split.BESIDE);
                split.forEach(function(editor, index) {
                    if (nextProps.mode !== oldProps.mode) editor.getSession().setMode('ace/mode/' + nextProps.mode);
                    if (nextProps.keyboardHandler !== oldProps.keyboardHandler) {
                        if (nextProps.keyboardHandler) editor.setKeyboardHandler('ace/keyboard/' + nextProps.keyboardHandler);
                        else editor.setKeyboardHandler(null);
                    }
                    if (nextProps.fontSize !== oldProps.fontSize) editor.setFontSize(nextProps.fontSize);
                    if (nextProps.wrapEnabled !== oldProps.wrapEnabled) editor.getSession().setUseWrapMode(nextProps.wrapEnabled);
                    if (nextProps.showPrintMargin !== oldProps.showPrintMargin) editor.setShowPrintMargin(nextProps.showPrintMargin);
                    if (nextProps.showGutter !== oldProps.showGutter) editor.renderer.setShowGutter(nextProps.showGutter);
                    for(var i = 0; i < $Hu4Ju.editorOptions.length; i++){
                        var option = $Hu4Ju.editorOptions[i];
                        if (nextProps[option] !== oldProps[option]) editor.setOption(option, nextProps[option]);
                    }
                    if (!(0, $f750a56f8b38f9a9$var$_lodash["default"])(nextProps.setOptions, oldProps.setOptions)) _this3.handleOptions(nextProps, editor);
                    var nextValue = (0, $f750a56f8b38f9a9$var$_lodash2["default"])(nextProps.value, index, '');
                    if (editor.getValue() !== nextValue) {
                        // editor.setValue is a synchronous function call, change event is emitted before setValue return.
                        _this3.silent = true;
                        var pos = editor.session.selection.toJSON();
                        editor.setValue(nextValue, nextProps.cursorStart);
                        editor.session.selection.fromJSON(pos);
                        _this3.silent = false;
                    }
                    var newAnnotations = (0, $f750a56f8b38f9a9$var$_lodash2["default"])(nextProps.annotations, index, []);
                    var oldAnnotations = (0, $f750a56f8b38f9a9$var$_lodash2["default"])(oldProps.annotations, index, []);
                    if (!(0, $f750a56f8b38f9a9$var$_lodash["default"])(newAnnotations, oldAnnotations)) editor.getSession().setAnnotations(newAnnotations);
                    var newMarkers = (0, $f750a56f8b38f9a9$var$_lodash2["default"])(nextProps.markers, index, []);
                    var oldMarkers = (0, $f750a56f8b38f9a9$var$_lodash2["default"])(oldProps.markers, index, []);
                    if (!(0, $f750a56f8b38f9a9$var$_lodash["default"])(newMarkers, oldMarkers) && Array.isArray(newMarkers)) _this3.handleMarkers(newMarkers, editor);
                });
                if (nextProps.className !== oldProps.className) {
                    var appliedClasses = this.refEditor.className;
                    var appliedClassesArray = appliedClasses.trim().split(' ');
                    var oldClassesArray = oldProps.className.trim().split(' ');
                    oldClassesArray.forEach(function(oldClass) {
                        var index = appliedClassesArray.indexOf(oldClass);
                        appliedClassesArray.splice(index, 1);
                    });
                    this.refEditor.className = ' ' + nextProps.className + ' ' + appliedClassesArray.join(' ');
                }
                if (nextProps.theme !== oldProps.theme) split.setTheme('ace/theme/' + nextProps.theme);
                if (nextProps.focus && !oldProps.focus) this.splitEditor.focus();
                if (nextProps.height !== this.props.height || nextProps.width !== this.props.width) this.editor.resize();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.editor.destroy();
                this.editor = null;
            }
        },
        {
            key: "onChange",
            value: function onChange(event) {
                if (this.props.onChange && !this.silent) {
                    var value = [];
                    this.editor.env.split.forEach(function(editor) {
                        value.push(editor.getValue());
                    });
                    this.props.onChange(value, event);
                }
            }
        },
        {
            key: "onSelectionChange",
            value: function onSelectionChange(event) {
                if (this.props.onSelectionChange) {
                    var value = [];
                    this.editor.env.split.forEach(function(editor) {
                        value.push(editor.getSelection());
                    });
                    this.props.onSelectionChange(value, event);
                }
            }
        },
        {
            key: "onCursorChange",
            value: function onCursorChange(event) {
                if (this.props.onCursorChange) {
                    var value = [];
                    this.editor.env.split.forEach(function(editor) {
                        value.push(editor.getSelection());
                    });
                    this.props.onCursorChange(value, event);
                }
            }
        },
        {
            key: "onFocus",
            value: function onFocus(event) {
                if (this.props.onFocus) this.props.onFocus(event);
            }
        },
        {
            key: "onInput",
            value: function onInput(event) {
                if (this.props.onInput) this.props.onInput(event);
            }
        },
        {
            key: "onBlur",
            value: function onBlur(event) {
                if (this.props.onBlur) this.props.onBlur(event);
            }
        },
        {
            key: "onCopy",
            value: function onCopy(text) {
                if (this.props.onCopy) this.props.onCopy(text);
            }
        },
        {
            key: "onPaste",
            value: function onPaste(text) {
                if (this.props.onPaste) this.props.onPaste(text);
            }
        },
        {
            key: "onScroll",
            value: function onScroll() {
                if (this.props.onScroll) this.props.onScroll(this.editor);
            }
        },
        {
            key: "handleOptions",
            value: function handleOptions(props, editor) {
                var setOptions = Object.keys(props.setOptions);
                for(var y = 0; y < setOptions.length; y++)editor.setOption(setOptions[y], props.setOptions[setOptions[y]]);
            }
        },
        {
            key: "handleMarkers",
            value: function handleMarkers(markers, editor) {
                // remove foreground markers
                var currentMarkers = editor.getSession().getMarkers(true);
                for(var i in currentMarkers)if (currentMarkers.hasOwnProperty(i)) editor.getSession().removeMarker(currentMarkers[i].id);
                 // remove background markers
                currentMarkers = editor.getSession().getMarkers(false);
                for(var _i2 in currentMarkers)if (currentMarkers.hasOwnProperty(_i2)) editor.getSession().removeMarker(currentMarkers[_i2].id);
                 // add new markers
                markers.forEach(function(_ref) {
                    var startRow = _ref.startRow, startCol = _ref.startCol, endRow = _ref.endRow, endCol = _ref.endCol, className = _ref.className, type = _ref.type, _ref$inFront = _ref.inFront, inFront = _ref$inFront === void 0 ? false : _ref$inFront;
                    var range = new $f750a56f8b38f9a9$var$Range(startRow, startCol, endRow, endCol);
                    editor.getSession().addMarker(range, className, type, inFront);
                });
            }
        },
        {
            key: "updateRef",
            value: function updateRef(item) {
                this.refEditor = item;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, name = _this$props2.name, width = _this$props2.width, height = _this$props2.height, style = _this$props2.style;
                var divStyle = $f750a56f8b38f9a9$var$_objectSpread({
                    width: width,
                    height: height
                }, style);
                return $f750a56f8b38f9a9$var$_react["default"].createElement("div", {
                    ref: this.updateRef,
                    id: name,
                    style: divStyle
                });
            }
        }
    ]);
    return SplitComponent;
}($f750a56f8b38f9a9$var$_react.Component);
module.exports["default"] = $f750a56f8b38f9a9$var$SplitComponent;
$f750a56f8b38f9a9$var$SplitComponent.propTypes = {
    mode: $f750a56f8b38f9a9$var$_propTypes["default"].string,
    splits: $f750a56f8b38f9a9$var$_propTypes["default"].number,
    orientation: $f750a56f8b38f9a9$var$_propTypes["default"].string,
    focus: $f750a56f8b38f9a9$var$_propTypes["default"].bool,
    theme: $f750a56f8b38f9a9$var$_propTypes["default"].string,
    name: $f750a56f8b38f9a9$var$_propTypes["default"].string,
    className: $f750a56f8b38f9a9$var$_propTypes["default"].string,
    height: $f750a56f8b38f9a9$var$_propTypes["default"].string,
    width: $f750a56f8b38f9a9$var$_propTypes["default"].string,
    fontSize: $f750a56f8b38f9a9$var$_propTypes["default"].oneOfType([
        $f750a56f8b38f9a9$var$_propTypes["default"].number,
        $f750a56f8b38f9a9$var$_propTypes["default"].string
    ]),
    showGutter: $f750a56f8b38f9a9$var$_propTypes["default"].bool,
    onChange: $f750a56f8b38f9a9$var$_propTypes["default"].func,
    onCopy: $f750a56f8b38f9a9$var$_propTypes["default"].func,
    onPaste: $f750a56f8b38f9a9$var$_propTypes["default"].func,
    onFocus: $f750a56f8b38f9a9$var$_propTypes["default"].func,
    onInput: $f750a56f8b38f9a9$var$_propTypes["default"].func,
    onBlur: $f750a56f8b38f9a9$var$_propTypes["default"].func,
    onScroll: $f750a56f8b38f9a9$var$_propTypes["default"].func,
    value: $f750a56f8b38f9a9$var$_propTypes["default"].arrayOf($f750a56f8b38f9a9$var$_propTypes["default"].string),
    defaultValue: $f750a56f8b38f9a9$var$_propTypes["default"].arrayOf($f750a56f8b38f9a9$var$_propTypes["default"].string),
    debounceChangePeriod: $f750a56f8b38f9a9$var$_propTypes["default"].number,
    onLoad: $f750a56f8b38f9a9$var$_propTypes["default"].func,
    onSelectionChange: $f750a56f8b38f9a9$var$_propTypes["default"].func,
    onCursorChange: $f750a56f8b38f9a9$var$_propTypes["default"].func,
    onBeforeLoad: $f750a56f8b38f9a9$var$_propTypes["default"].func,
    minLines: $f750a56f8b38f9a9$var$_propTypes["default"].number,
    maxLines: $f750a56f8b38f9a9$var$_propTypes["default"].number,
    readOnly: $f750a56f8b38f9a9$var$_propTypes["default"].bool,
    highlightActiveLine: $f750a56f8b38f9a9$var$_propTypes["default"].bool,
    tabSize: $f750a56f8b38f9a9$var$_propTypes["default"].number,
    showPrintMargin: $f750a56f8b38f9a9$var$_propTypes["default"].bool,
    cursorStart: $f750a56f8b38f9a9$var$_propTypes["default"].number,
    editorProps: $f750a56f8b38f9a9$var$_propTypes["default"].object,
    setOptions: $f750a56f8b38f9a9$var$_propTypes["default"].object,
    style: $f750a56f8b38f9a9$var$_propTypes["default"].object,
    scrollMargin: $f750a56f8b38f9a9$var$_propTypes["default"].array,
    annotations: $f750a56f8b38f9a9$var$_propTypes["default"].array,
    markers: $f750a56f8b38f9a9$var$_propTypes["default"].array,
    keyboardHandler: $f750a56f8b38f9a9$var$_propTypes["default"].string,
    wrapEnabled: $f750a56f8b38f9a9$var$_propTypes["default"].bool,
    enableBasicAutocompletion: $f750a56f8b38f9a9$var$_propTypes["default"].oneOfType([
        $f750a56f8b38f9a9$var$_propTypes["default"].bool,
        $f750a56f8b38f9a9$var$_propTypes["default"].array
    ]),
    enableLiveAutocompletion: $f750a56f8b38f9a9$var$_propTypes["default"].oneOfType([
        $f750a56f8b38f9a9$var$_propTypes["default"].bool,
        $f750a56f8b38f9a9$var$_propTypes["default"].array
    ]),
    commands: $f750a56f8b38f9a9$var$_propTypes["default"].array
};
$f750a56f8b38f9a9$var$SplitComponent.defaultProps = {
    name: 'brace-editor',
    focus: false,
    orientation: 'beside',
    splits: 2,
    mode: '',
    theme: '',
    height: '500px',
    width: '500px',
    value: [],
    fontSize: 12,
    showGutter: true,
    onChange: null,
    onPaste: null,
    onLoad: null,
    onScroll: null,
    minLines: null,
    maxLines: null,
    readOnly: false,
    highlightActiveLine: true,
    showPrintMargin: true,
    tabSize: 4,
    cursorStart: 1,
    editorProps: {},
    style: {},
    scrollMargin: [
        0,
        0,
        0,
        0
    ],
    setOptions: {},
    wrapEnabled: false,
    enableBasicAutocompletion: false,
    enableLiveAutocompletion: false
};

});
parcelRegister("6dVOx", function(module, exports) {
ace.define("ace/split", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/lib/lang",
    "ace/lib/event_emitter",
    "ace/editor",
    "ace/virtual_renderer",
    "ace/edit_session"
], function(acequire, exports, module) {
    "use strict";
    var oop = acequire("./lib/oop");
    var lang = acequire("./lib/lang");
    var EventEmitter = acequire("./lib/event_emitter").EventEmitter;
    var Editor = acequire("./editor").Editor;
    var Renderer = acequire("./virtual_renderer").VirtualRenderer;
    var EditSession = acequire("./edit_session").EditSession;
    var Split = function(container, theme, splits) {
        this.BELOW = 1;
        this.BESIDE = 0;
        this.$container = container;
        this.$theme = theme;
        this.$splits = 0;
        this.$editorCSS = "";
        this.$editors = [];
        this.$orientation = this.BESIDE;
        this.setSplits(splits || 1);
        this.$cEditor = this.$editors[0];
        this.on("focus", (function(editor) {
            this.$cEditor = editor;
        }).bind(this));
    };
    (function() {
        oop.implement(this, EventEmitter);
        this.$createEditor = function() {
            var el = document.createElement("div");
            el.className = this.$editorCSS;
            el.style.cssText = "position: absolute; top:0px; bottom:0px";
            this.$container.appendChild(el);
            var editor = new Editor(new Renderer(el, this.$theme));
            editor.on("focus", (function() {
                this._emit("focus", editor);
            }).bind(this));
            this.$editors.push(editor);
            editor.setFontSize(this.$fontSize);
            return editor;
        };
        this.setSplits = function(splits) {
            var editor;
            if (splits < 1) throw "The number of splits have to be > 0!";
            if (splits == this.$splits) return;
            else if (splits > this.$splits) {
                while(this.$splits < this.$editors.length && this.$splits < splits){
                    editor = this.$editors[this.$splits];
                    this.$container.appendChild(editor.container);
                    editor.setFontSize(this.$fontSize);
                    this.$splits++;
                }
                while(this.$splits < splits){
                    this.$createEditor();
                    this.$splits++;
                }
            } else while(this.$splits > splits){
                editor = this.$editors[this.$splits - 1];
                this.$container.removeChild(editor.container);
                this.$splits--;
            }
            this.resize();
        };
        this.getSplits = function() {
            return this.$splits;
        };
        this.getEditor = function(idx) {
            return this.$editors[idx];
        };
        this.getCurrentEditor = function() {
            return this.$cEditor;
        };
        this.focus = function() {
            this.$cEditor.focus();
        };
        this.blur = function() {
            this.$cEditor.blur();
        };
        this.setTheme = function(theme) {
            this.$editors.forEach(function(editor) {
                editor.setTheme(theme);
            });
        };
        this.setKeyboardHandler = function(keybinding) {
            this.$editors.forEach(function(editor) {
                editor.setKeyboardHandler(keybinding);
            });
        };
        this.forEach = function(callback, scope) {
            this.$editors.forEach(callback, scope);
        };
        this.$fontSize = "";
        this.setFontSize = function(size) {
            this.$fontSize = size;
            this.forEach(function(editor) {
                editor.setFontSize(size);
            });
        };
        this.$cloneSession = function(session) {
            var s = new EditSession(session.getDocument(), session.getMode());
            var undoManager = session.getUndoManager();
            if (undoManager) {
                var undoManagerProxy = new UndoManagerProxy(undoManager, s);
                s.setUndoManager(undoManagerProxy);
            }
            s.$informUndoManager = lang.delayedCall(function() {
                s.$deltas = [];
            });
            s.setTabSize(session.getTabSize());
            s.setUseSoftTabs(session.getUseSoftTabs());
            s.setOverwrite(session.getOverwrite());
            s.setBreakpoints(session.getBreakpoints());
            s.setUseWrapMode(session.getUseWrapMode());
            s.setUseWorker(session.getUseWorker());
            s.setWrapLimitRange(session.$wrapLimitRange.min, session.$wrapLimitRange.max);
            s.$foldData = session.$cloneFoldData();
            return s;
        };
        this.setSession = function(session, idx) {
            var editor;
            if (idx == null) editor = this.$cEditor;
            else editor = this.$editors[idx];
            var isUsed = this.$editors.some(function(editor) {
                return editor.session === session;
            });
            if (isUsed) session = this.$cloneSession(session);
            editor.setSession(session);
            return session;
        };
        this.getOrientation = function() {
            return this.$orientation;
        };
        this.setOrientation = function(orientation) {
            if (this.$orientation == orientation) return;
            this.$orientation = orientation;
            this.resize();
        };
        this.resize = function() {
            var width = this.$container.clientWidth;
            var height = this.$container.clientHeight;
            var editor;
            if (this.$orientation == this.BESIDE) {
                var editorWidth = width / this.$splits;
                for(var i = 0; i < this.$splits; i++){
                    editor = this.$editors[i];
                    editor.container.style.width = editorWidth + "px";
                    editor.container.style.top = "0px";
                    editor.container.style.left = i * editorWidth + "px";
                    editor.container.style.height = height + "px";
                    editor.resize();
                }
            } else {
                var editorHeight = height / this.$splits;
                for(var i = 0; i < this.$splits; i++){
                    editor = this.$editors[i];
                    editor.container.style.width = width + "px";
                    editor.container.style.top = i * editorHeight + "px";
                    editor.container.style.left = "0px";
                    editor.container.style.height = editorHeight + "px";
                    editor.resize();
                }
            }
        };
    }).call(Split.prototype);
    function UndoManagerProxy(undoManager, session) {
        this.$u = undoManager;
        this.$doc = session;
    }
    (function() {
        this.execute = function(options) {
            this.$u.execute(options);
        };
        this.undo = function() {
            var selectionRange = this.$u.undo(true);
            if (selectionRange) this.$doc.selection.setSelectionRange(selectionRange);
        };
        this.redo = function() {
            var selectionRange = this.$u.redo(true);
            if (selectionRange) this.$doc.selection.setSelectionRange(selectionRange);
        };
        this.reset = function() {
            this.$u.reset();
        };
        this.hasUndo = function() {
            return this.$u.hasUndo();
        };
        this.hasRedo = function() {
            return this.$u.hasRedo();
        };
    }).call(UndoManagerProxy.prototype);
    exports.Split = Split;
});
ace.define("ace/ext/split", [
    "require",
    "exports",
    "module",
    "ace/split"
], function(acequire, exports, module) {
    "use strict";
    module.exports = acequire("../split");
});
(function() {
    ace.acequire([
        "ace/ext/split"
    ], function() {});
})();

});


parcelRegister("6GVRA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $4df38cc9fa0afcb5$var$_split = $4df38cc9fa0afcb5$var$_interopRequireDefault((parcelRequire("les1L")));

var $4df38cc9fa0afcb5$var$_react = $4df38cc9fa0afcb5$var$_interopRequireWildcard((parcelRequire("lx97N")));

var $4df38cc9fa0afcb5$var$_propTypes = $4df38cc9fa0afcb5$var$_interopRequireDefault((parcelRequire("4RND8")));

var $4df38cc9fa0afcb5$var$_diffMatchPatch = $4df38cc9fa0afcb5$var$_interopRequireDefault((parcelRequire("1l1ud")));
function $4df38cc9fa0afcb5$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj["default"] = obj;
        return newObj;
    }
}
function $4df38cc9fa0afcb5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $4df38cc9fa0afcb5$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $4df38cc9fa0afcb5$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $4df38cc9fa0afcb5$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $4df38cc9fa0afcb5$var$_typeof(obj);
}
function $4df38cc9fa0afcb5$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $4df38cc9fa0afcb5$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4df38cc9fa0afcb5$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $4df38cc9fa0afcb5$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4df38cc9fa0afcb5$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $4df38cc9fa0afcb5$var$_possibleConstructorReturn(self, call) {
    if (call && ($4df38cc9fa0afcb5$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $4df38cc9fa0afcb5$var$_assertThisInitialized(self);
}
function $4df38cc9fa0afcb5$var$_getPrototypeOf(o) {
    $4df38cc9fa0afcb5$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $4df38cc9fa0afcb5$var$_getPrototypeOf(o);
}
function $4df38cc9fa0afcb5$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $4df38cc9fa0afcb5$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $4df38cc9fa0afcb5$var$_setPrototypeOf(subClass, superClass);
}
function $4df38cc9fa0afcb5$var$_setPrototypeOf(o, p) {
    $4df38cc9fa0afcb5$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $4df38cc9fa0afcb5$var$_setPrototypeOf(o, p);
}
var $4df38cc9fa0afcb5$var$DiffComponent = /*#__PURE__*/ function(_Component) {
    $4df38cc9fa0afcb5$var$_inherits(DiffComponent, _Component);
    function DiffComponent(props) {
        var _this;
        $4df38cc9fa0afcb5$var$_classCallCheck(this, DiffComponent);
        _this = $4df38cc9fa0afcb5$var$_possibleConstructorReturn(this, $4df38cc9fa0afcb5$var$_getPrototypeOf(DiffComponent).call(this, props));
        _this.state = {
            value: _this.props.value
        };
        _this.onChange = _this.onChange.bind($4df38cc9fa0afcb5$var$_assertThisInitialized(_this));
        _this.diff = _this.diff.bind($4df38cc9fa0afcb5$var$_assertThisInitialized(_this));
        return _this;
    }
    $4df38cc9fa0afcb5$var$_createClass(DiffComponent, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                var value = this.props.value;
                if (value !== this.state.value) this.setState({
                    value: value
                });
            }
        },
        {
            key: "onChange",
            value: function onChange(value) {
                this.setState({
                    value: value
                });
                if (this.props.onChange) this.props.onChange(value);
            }
        },
        {
            key: "diff",
            value: function diff() {
                var dmp = new $4df38cc9fa0afcb5$var$_diffMatchPatch["default"]();
                var lhString = this.state.value[0];
                var rhString = this.state.value[1];
                if (lhString.length === 0 && rhString.length === 0) return [];
                var diff = dmp.diff_main(lhString, rhString);
                dmp.diff_cleanupSemantic(diff);
                var diffedLines = this.generateDiffedLines(diff);
                var codeEditorSettings = this.setCodeMarkers(diffedLines);
                return codeEditorSettings;
            }
        },
        {
            key: "generateDiffedLines",
            value: function generateDiffedLines(diff) {
                var C = {
                    DIFF_EQUAL: 0,
                    DIFF_DELETE: -1,
                    DIFF_INSERT: 1
                };
                var diffedLines = {
                    left: [],
                    right: []
                };
                var cursor = {
                    left: 1,
                    right: 1
                };
                diff.forEach(function(chunk) {
                    var chunkType = chunk[0];
                    var text = chunk[1];
                    var lines = text.split('\n').length - 1; // diff-match-patch sometimes returns empty strings at random
                    if (text.length === 0) return;
                    var firstChar = text[0];
                    var lastChar = text[text.length - 1];
                    var linesToHighlight = 0;
                    switch(chunkType){
                        case C.DIFF_EQUAL:
                            cursor.left += lines;
                            cursor.right += lines;
                            break;
                        case C.DIFF_DELETE:
                            // If the deletion starts with a newline, push the cursor down to that line
                            if (firstChar === '\n') {
                                cursor.left++;
                                lines--;
                            }
                            linesToHighlight = lines; // If the deletion does not include a newline, highlight the same line on the right
                            if (linesToHighlight === 0) diffedLines.right.push({
                                startLine: cursor.right,
                                endLine: cursor.right
                            });
                             // If the last character is a newline, we don't want to highlight that line
                            if (lastChar === '\n') linesToHighlight -= 1;
                            diffedLines.left.push({
                                startLine: cursor.left,
                                endLine: cursor.left + linesToHighlight
                            });
                            cursor.left += lines;
                            break;
                        case C.DIFF_INSERT:
                            // If the insertion starts with a newline, push the cursor down to that line
                            if (firstChar === '\n') {
                                cursor.right++;
                                lines--;
                            }
                            linesToHighlight = lines; // If the insertion does not include a newline, highlight the same line on the left
                            if (linesToHighlight === 0) diffedLines.left.push({
                                startLine: cursor.left,
                                endLine: cursor.left
                            });
                             // If the last character is a newline, we don't want to highlight that line
                            if (lastChar === '\n') linesToHighlight -= 1;
                            diffedLines.right.push({
                                startLine: cursor.right,
                                endLine: cursor.right + linesToHighlight
                            });
                            cursor.right += lines;
                            break;
                        default:
                            throw new Error('Diff type was not defined.');
                    }
                });
                return diffedLines;
            } // Receives a collection of line numbers and iterates through them to highlight appropriately
        },
        {
            key: "setCodeMarkers",
            value: function setCodeMarkers() {
                var diffedLines = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
                    left: [],
                    right: []
                };
                var codeEditorSettings = [];
                var newMarkerSet = {
                    left: [],
                    right: []
                };
                for(var i = 0; i < diffedLines.left.length; i++){
                    var markerObj = {
                        startRow: diffedLines.left[i].startLine - 1,
                        endRow: diffedLines.left[i].endLine,
                        type: 'text',
                        className: 'codeMarker'
                    };
                    newMarkerSet.left.push(markerObj);
                }
                for(var _i = 0; _i < diffedLines.right.length; _i++){
                    var _markerObj = {
                        startRow: diffedLines.right[_i].startLine - 1,
                        endRow: diffedLines.right[_i].endLine,
                        type: 'text',
                        className: 'codeMarker'
                    };
                    newMarkerSet.right.push(_markerObj);
                }
                codeEditorSettings[0] = newMarkerSet.left;
                codeEditorSettings[1] = newMarkerSet.right;
                return codeEditorSettings;
            }
        },
        {
            key: "render",
            value: function render() {
                var markers = this.diff();
                return $4df38cc9fa0afcb5$var$_react["default"].createElement($4df38cc9fa0afcb5$var$_split["default"], {
                    name: this.props.name,
                    className: this.props.className,
                    focus: this.props.focus,
                    orientation: this.props.orientation,
                    splits: this.props.splits,
                    mode: this.props.mode,
                    theme: this.props.theme,
                    height: this.props.height,
                    width: this.props.width,
                    fontSize: this.props.fontSize,
                    showGutter: this.props.showGutter,
                    onChange: this.onChange,
                    onPaste: this.props.onPaste,
                    onLoad: this.props.onLoad,
                    onScroll: this.props.onScroll,
                    minLines: this.props.minLines,
                    maxLines: this.props.maxLines,
                    readOnly: this.props.readOnly,
                    highlightActiveLine: this.props.highlightActiveLine,
                    showPrintMargin: this.props.showPrintMargin,
                    tabSize: this.props.tabSize,
                    cursorStart: this.props.cursorStart,
                    editorProps: this.props.editorProps,
                    style: this.props.style,
                    scrollMargin: this.props.scrollMargin,
                    setOptions: this.props.setOptions,
                    wrapEnabled: this.props.wrapEnabled,
                    enableBasicAutocompletion: this.props.enableBasicAutocompletion,
                    enableLiveAutocompletion: this.props.enableLiveAutocompletion,
                    value: this.state.value,
                    markers: markers
                });
            }
        }
    ]);
    return DiffComponent;
}($4df38cc9fa0afcb5$var$_react.Component);
module.exports["default"] = $4df38cc9fa0afcb5$var$DiffComponent;
$4df38cc9fa0afcb5$var$DiffComponent.propTypes = {
    cursorStart: $4df38cc9fa0afcb5$var$_propTypes["default"].number,
    editorProps: $4df38cc9fa0afcb5$var$_propTypes["default"].object,
    enableBasicAutocompletion: $4df38cc9fa0afcb5$var$_propTypes["default"].bool,
    enableLiveAutocompletion: $4df38cc9fa0afcb5$var$_propTypes["default"].bool,
    focus: $4df38cc9fa0afcb5$var$_propTypes["default"].bool,
    fontSize: $4df38cc9fa0afcb5$var$_propTypes["default"].number,
    height: $4df38cc9fa0afcb5$var$_propTypes["default"].string,
    highlightActiveLine: $4df38cc9fa0afcb5$var$_propTypes["default"].bool,
    maxLines: $4df38cc9fa0afcb5$var$_propTypes["default"].func,
    minLines: $4df38cc9fa0afcb5$var$_propTypes["default"].func,
    mode: $4df38cc9fa0afcb5$var$_propTypes["default"].string,
    name: $4df38cc9fa0afcb5$var$_propTypes["default"].string,
    className: $4df38cc9fa0afcb5$var$_propTypes["default"].string,
    onLoad: $4df38cc9fa0afcb5$var$_propTypes["default"].func,
    onPaste: $4df38cc9fa0afcb5$var$_propTypes["default"].func,
    onScroll: $4df38cc9fa0afcb5$var$_propTypes["default"].func,
    onChange: $4df38cc9fa0afcb5$var$_propTypes["default"].func,
    orientation: $4df38cc9fa0afcb5$var$_propTypes["default"].string,
    readOnly: $4df38cc9fa0afcb5$var$_propTypes["default"].bool,
    scrollMargin: $4df38cc9fa0afcb5$var$_propTypes["default"].array,
    setOptions: $4df38cc9fa0afcb5$var$_propTypes["default"].object,
    showGutter: $4df38cc9fa0afcb5$var$_propTypes["default"].bool,
    showPrintMargin: $4df38cc9fa0afcb5$var$_propTypes["default"].bool,
    splits: $4df38cc9fa0afcb5$var$_propTypes["default"].number,
    style: $4df38cc9fa0afcb5$var$_propTypes["default"].object,
    tabSize: $4df38cc9fa0afcb5$var$_propTypes["default"].number,
    theme: $4df38cc9fa0afcb5$var$_propTypes["default"].string,
    value: $4df38cc9fa0afcb5$var$_propTypes["default"].array,
    width: $4df38cc9fa0afcb5$var$_propTypes["default"].string,
    wrapEnabled: $4df38cc9fa0afcb5$var$_propTypes["default"].bool
};
$4df38cc9fa0afcb5$var$DiffComponent.defaultProps = {
    cursorStart: 1,
    editorProps: {},
    enableBasicAutocompletion: false,
    enableLiveAutocompletion: false,
    focus: false,
    fontSize: 12,
    height: '500px',
    highlightActiveLine: true,
    maxLines: null,
    minLines: null,
    mode: '',
    name: 'brace-editor',
    onLoad: null,
    onScroll: null,
    onPaste: null,
    onChange: null,
    orientation: 'beside',
    readOnly: false,
    scrollMargin: [
        0,
        0,
        0,
        0
    ],
    setOptions: {},
    showGutter: true,
    showPrintMargin: true,
    splits: 2,
    style: {},
    tabSize: 4,
    theme: 'github',
    value: [
        '',
        ''
    ],
    width: '500px',
    wrapEnabled: true
};

});
parcelRegister("1l1ud", function(module, exports) {
/**
 * Diff Match and Patch
 * Copyright 2018 The diff-match-patch Authors.
 * https://github.com/google/diff-match-patch
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Computes the difference between two texts to create a patch.
 * Applies the patch onto another text, allowing for errors.
 * @author fraser@google.com (Neil Fraser)
 */ /**
 * Class containing the diff, match and patch methods.
 * @constructor
 */ var $0f98e7c131f90f2d$var$diff_match_patch = function() {
    // Defaults.
    // Redefine these in your program to override the defaults.
    // Number of seconds to map a diff before giving up (0 for infinity).
    this.Diff_Timeout = 1.0;
    // Cost of an empty edit operation in terms of edit characters.
    this.Diff_EditCost = 4;
    // At what point is no match declared (0.0 = perfection, 1.0 = very loose).
    this.Match_Threshold = 0.5;
    // How far to search for a match (0 = exact location, 1000+ = broad match).
    // A match this many characters away from the expected location will add
    // 1.0 to the score (0.0 is a perfect match).
    this.Match_Distance = 1000;
    // When deleting a large block of text (over ~64 characters), how close do
    // the contents have to be to match the expected contents. (0.0 = perfection,
    // 1.0 = very loose).  Note that Match_Threshold controls how closely the
    // end points of a delete need to match.
    this.Patch_DeleteThreshold = 0.5;
    // Chunk size for context length.
    this.Patch_Margin = 4;
    // The number of bits in an int.
    this.Match_MaxBits = 32;
};
//  DIFF FUNCTIONS
/**
 * The data structure representing a diff is an array of tuples:
 * [[DIFF_DELETE, 'Hello'], [DIFF_INSERT, 'Goodbye'], [DIFF_EQUAL, ' world.']]
 * which means: delete 'Hello', add 'Goodbye' and keep ' world.'
 */ var $0f98e7c131f90f2d$var$DIFF_DELETE = -1;
var $0f98e7c131f90f2d$var$DIFF_INSERT = 1;
var $0f98e7c131f90f2d$var$DIFF_EQUAL = 0;
/**
 * Class representing one diff tuple.
 * ~Attempts to look like a two-element array (which is what this used to be).~
 * Constructor returns an actual two-element array, to allow destructing @JackuB
 * See https://github.com/JackuB/diff-match-patch/issues/14 for details
 * @param {number} op Operation, one of: DIFF_DELETE, DIFF_INSERT, DIFF_EQUAL.
 * @param {string} text Text to be deleted, inserted, or retained.
 * @constructor
 */ $0f98e7c131f90f2d$var$diff_match_patch.Diff = function(op, text) {
    return [
        op,
        text
    ];
};
/**
 * Find the differences between two texts.  Simplifies the problem by stripping
 * any common prefix or suffix off the texts before diffing.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {boolean=} opt_checklines Optional speedup flag. If present and false,
 *     then don't run a line-level diff first to identify the changed areas.
 *     Defaults to true, which does a faster, slightly less optimal diff.
 * @param {number=} opt_deadline Optional time when the diff should be complete
 *     by.  Used internally for recursive calls.  Users should set DiffTimeout
 *     instead.
 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
 */ $0f98e7c131f90f2d$var$diff_match_patch.prototype.diff_main = function(text1, text2, opt_checklines, opt_deadline) {
    // Set a deadline by which time the diff must be complete.
    if (typeof opt_deadline == 'undefined') {
        if (this.Diff_Timeout <= 0) opt_deadline = Number.MAX_VALUE;
        else opt_deadline = (new Date).getTime() + this.Diff_Timeout * 1000;
    }
    var deadline = opt_deadline;
    // Check for null inputs.
    if (text1 == null || text2 == null) throw new Error('Null input. (diff_main)');
    // Check for equality (speedup).
    if (text1 == text2) {
        if (text1) return [
            new $0f98e7c131f90f2d$var$diff_match_patch.Diff($0f98e7c131f90f2d$var$DIFF_EQUAL, text1)
        ];
        return [];
    }
    if (typeof opt_checklines == 'undefined') opt_checklines = true;
    var checklines = opt_checklines;
    // Trim off common prefix (speedup).
    var commonlength = this.diff_commonPrefix(text1, text2);
    var commonprefix = text1.substring(0, commonlength);
    text1 = text1.substring(commonlength);
    text2 = text2.substring(commonlength);
    // Trim off common suffix (speedup).
    commonlength = this.diff_commonSuffix(text1, text2);
    var commonsuffix = text1.substring(text1.length - commonlength);
    text1 = text1.substring(0, text1.length - commonlength);
    text2 = text2.substring(0, text2.length - commonlength);
    // Compute the diff on the middle block.
    var diffs = this.diff_compute_(text1, text2, checklines, deadline);
    // Restore the prefix and suffix.
    if (commonprefix) diffs.unshift(new $0f98e7c131f90f2d$var$diff_match_patch.Diff($0f98e7c131f90f2d$var$DIFF_EQUAL, commonprefix));
    if (commonsuffix) diffs.push(new $0f98e7c131f90f2d$var$diff_match_patch.Diff($0f98e7c131f90f2d$var$DIFF_EQUAL, commonsuffix));
    this.diff_cleanupMerge(diffs);
    return diffs;
};
/**
 * Find the differences between two texts.  Assumes that the texts do not
 * have any common prefix or suffix.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {boolean} checklines Speedup flag.  If false, then don't run a
 *     line-level diff first to identify the changed areas.
 *     If true, then run a faster, slightly less optimal diff.
 * @param {number} deadline Time when the diff should be complete by.
 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
 * @private
 */ $0f98e7c131f90f2d$var$diff_match_patch.prototype.diff_compute_ = function(text1, text2, checklines, deadline) {
    var diffs;
    if (!text1) // Just add some text (speedup).
    return [
        new $0f98e7c131f90f2d$var$diff_match_patch.Diff($0f98e7c131f90f2d$var$DIFF_INSERT, text2)
    ];
    if (!text2) // Just delete some text (speedup).
    return [
        new $0f98e7c131f90f2d$var$diff_match_patch.Diff($0f98e7c131f90f2d$var$DIFF_DELETE, text1)
    ];
    var longtext = text1.length > text2.length ? text1 : text2;
    var shorttext = text1.length > text2.length ? text2 : text1;
    var i = longtext.indexOf(shorttext);
    if (i != -1) {
        // Shorter text is inside the longer text (speedup).
        diffs = [
            new $0f98e7c131f90f2d$var$diff_match_patch.Diff($0f98e7c131f90f2d$var$DIFF_INSERT, longtext.substring(0, i)),
            new $0f98e7c131f90f2d$var$diff_match_patch.Diff($0f98e7c131f90f2d$var$DIFF_EQUAL, shorttext),
            new $0f98e7c131f90f2d$var$diff_match_patch.Diff($0f98e7c131f90f2d$var$DIFF_INSERT, longtext.substring(i + shorttext.length))
        ];
        // Swap insertions for deletions if diff is reversed.
        if (text1.length > text2.length) diffs[0][0] = diffs[2][0] = $0f98e7c131f90f2d$var$DIFF_DELETE;
        return diffs;
    }
    if (shorttext.length == 1) // Single character string.
    // After the previous speedup, the character can't be an equality.
    return [
        new $0f98e7c131f90f2d$var$diff_match_patch.Diff($0f98e7c131f90f2d$var$DIFF_DELETE, text1),
        new $0f98e7c131f90f2d$var$diff_match_patch.Diff($0f98e7c131f90f2d$var$DIFF_INSERT, text2)
    ];
    // Check to see if the problem can be split in two.
    var hm = this.diff_halfMatch_(text1, text2);
    if (hm) {
        // A half-match was found, sort out the return data.
        var text1_a = hm[0];
        var text1_b = hm[1];
        var text2_a = hm[2];
        var text2_b = hm[3];
        var mid_common = hm[4];
        // Send both pairs off for separate processing.
        var diffs_a = this.diff_main(text1_a, text2_a, checklines, deadline);
        var diffs_b = this.diff_main(text1_b, text2_b, checklines, deadline);
        // Merge the results.
        return diffs_a.concat([
            new $0f98e7c131f90f2d$var$diff_match_patch.Diff($0f98e7c131f90f2d$var$DIFF_EQUAL, mid_common)
        ], diffs_b);
    }
    if (checklines && text1.length > 100 && text2.length > 100) return this.diff_lineMode_(text1, text2, deadline);
    return this.diff_bisect_(text1, text2, deadline);
};
/**
 * Do a quick line-level diff on both strings, then rediff the parts for
 * greater accuracy.
 * This speedup can produce non-minimal diffs.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {number} deadline Time when the diff should be complete by.
 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
 * @private
 */ $0f98e7c131f90f2d$var$diff_match_patch.prototype.diff_lineMode_ = function(text1, text2, deadline) {
    // Scan the text on a line-by-line basis first.
    var a = this.diff_linesToChars_(text1, text2);
    text1 = a.chars1;
    text2 = a.chars2;
    var linearray = a.lineArray;
    var diffs = this.diff_main(text1, text2, false, deadline);
    // Convert the diff back to original text.
    this.diff_charsToLines_(diffs, linearray);
    // Eliminate freak matches (e.g. blank lines)
    this.diff_cleanupSemantic(diffs);
    // Rediff any replacement blocks, this time character-by-character.
    // Add a dummy entry at the end.
    diffs.push(new $0f98e7c131f90f2d$var$diff_match_patch.Diff($0f98e7c131f90f2d$var$DIFF_EQUAL, ''));
    var pointer = 0;
    var count_delete = 0;
    var count_insert = 0;
    var text_delete = '';
    var text_insert = '';
    while(pointer < diffs.length){
        switch(diffs[pointer][0]){
            case $0f98e7c131f90f2d$var$DIFF_INSERT:
                count_insert++;
                text_insert += diffs[pointer][1];
                break;
            case $0f98e7c131f90f2d$var$DIFF_DELETE:
                count_delete++;
                text_delete += diffs[pointer][1];
                break;
            case $0f98e7c131f90f2d$var$DIFF_EQUAL:
                // Upon reaching an equality, check for prior redundancies.
                if (count_delete >= 1 && count_insert >= 1) {
                    // Delete the offending records and add the merged ones.
                    diffs.splice(pointer - count_delete - count_insert, count_delete + count_insert);
                    pointer = pointer - count_delete - count_insert;
                    var subDiff = this.diff_main(text_delete, text_insert, false, deadline);
                    for(var j = subDiff.length - 1; j >= 0; j--)diffs.splice(pointer, 0, subDiff[j]);
                    pointer = pointer + subDiff.length;
                }
                count_insert = 0;
                count_delete = 0;
                text_delete = '';
                text_insert = '';
                break;
        }
        pointer++;
    }
    diffs.pop(); // Remove the dummy entry at the end.
    return diffs;
};
/**
 * Find the 'middle snake' of a diff, split the problem in two
 * and return the recursively constructed diff.
 * See Myers 1986 paper: An O(ND) Difference Algorithm and Its Variations.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {number} deadline Time at which to bail if not yet complete.
 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
 * @private
 */ $0f98e7c131f90f2d$var$diff_match_patch.prototype.diff_bisect_ = function(text1, text2, deadline) {
    // Cache the text lengths to prevent multiple calls.
    var text1_length = text1.length;
    var text2_length = text2.length;
    var max_d = Math.ceil((text1_length + text2_length) / 2);
    var v_offset = max_d;
    var v_length = 2 * max_d;
    var v1 = new Array(v_length);
    var v2 = new Array(v_length);
    // Setting all elements to -1 is faster in Chrome & Firefox than mixing
    // integers and undefined.
    for(var x = 0; x < v_length; x++){
        v1[x] = -1;
        v2[x] = -1;
    }
    v1[v_offset + 1] = 0;
    v2[v_offset + 1] = 0;
    var delta = text1_length - text2_length;
    // If the total number of characters is odd, then the front path will collide
    // with the reverse path.
    var front = delta % 2 != 0;
    // Offsets for start and end of k loop.
    // Prevents mapping of space beyond the grid.
    var k1start = 0;
    var k1end = 0;
    var k2start = 0;
    var k2end = 0;
    for(var d = 0; d < max_d; d++){
        // Bail out if deadline is reached.
        if (new Date().getTime() > deadline) break;
        // Walk the front path one step.
        for(var k1 = -d + k1start; k1 <= d - k1end; k1 += 2){
            var k1_offset = v_offset + k1;
            var x1;
            if (k1 == -d || k1 != d && v1[k1_offset - 1] < v1[k1_offset + 1]) x1 = v1[k1_offset + 1];
            else x1 = v1[k1_offset - 1] + 1;
            var y1 = x1 - k1;
            while(x1 < text1_length && y1 < text2_length && text1.charAt(x1) == text2.charAt(y1)){
                x1++;
                y1++;
            }
            v1[k1_offset] = x1;
            if (x1 > text1_length) // Ran off the right of the graph.
            k1end += 2;
            else if (y1 > text2_length) // Ran off the bottom of the graph.
            k1start += 2;
            else if (front) {
                var k2_offset = v_offset + delta - k1;
                if (k2_offset >= 0 && k2_offset < v_length && v2[k2_offset] != -1) {
                    // Mirror x2 onto top-left coordinate system.
                    var x2 = text1_length - v2[k2_offset];
                    if (x1 >= x2) // Overlap detected.
                    return this.diff_bisectSplit_(text1, text2, x1, y1, deadline);
                }
            }
        }
        // Walk the reverse path one step.
        for(var k2 = -d + k2start; k2 <= d - k2end; k2 += 2){
            var k2_offset = v_offset + k2;
            var x2;
            if (k2 == -d || k2 != d && v2[k2_offset - 1] < v2[k2_offset + 1]) x2 = v2[k2_offset + 1];
            else x2 = v2[k2_offset - 1] + 1;
            var y2 = x2 - k2;
            while(x2 < text1_length && y2 < text2_length && text1.charAt(text1_length - x2 - 1) == text2.charAt(text2_length - y2 - 1)){
                x2++;
                y2++;
            }
            v2[k2_offset] = x2;
            if (x2 > text1_length) // Ran off the left of the graph.
            k2end += 2;
            else if (y2 > text2_length) // Ran off the top of the graph.
            k2start += 2;
            else if (!front) {
                var k1_offset = v_offset + delta - k2;
                if (k1_offset >= 0 && k1_offset < v_length && v1[k1_offset] != -1) {
                    var x1 = v1[k1_offset];
                    var y1 = v_offset + x1 - k1_offset;
                    // Mirror x2 onto top-left coordinate system.
                    x2 = text1_length - x2;
                    if (x1 >= x2) // Overlap detected.
                    return this.diff_bisectSplit_(text1, text2, x1, y1, deadline);
                }
            }
        }
    }
    // Diff took too long and hit the deadline or
    // number of diffs equals number of characters, no commonality at all.
    return [
        new $0f98e7c131f90f2d$var$diff_match_patch.Diff($0f98e7c131f90f2d$var$DIFF_DELETE, text1),
        new $0f98e7c131f90f2d$var$diff_match_patch.Diff($0f98e7c131f90f2d$var$DIFF_INSERT, text2)
    ];
};
/**
 * Given the location of the 'middle snake', split the diff in two parts
 * and recurse.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {number} x Index of split point in text1.
 * @param {number} y Index of split point in text2.
 * @param {number} deadline Time at which to bail if not yet complete.
 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
 * @private
 */ $0f98e7c131f90f2d$var$diff_match_patch.prototype.diff_bisectSplit_ = function(text1, text2, x, y, deadline) {
    var text1a = text1.substring(0, x);
    var text2a = text2.substring(0, y);
    var text1b = text1.substring(x);
    var text2b = text2.substring(y);
    // Compute both diffs serially.
    var diffs = this.diff_main(text1a, text2a, false, deadline);
    var diffsb = this.diff_main(text1b, text2b, false, deadline);
    return diffs.concat(diffsb);
};
/**
 * Split two texts into an array of strings.  Reduce the texts to a string of
 * hashes where each Unicode character represents one line.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {{chars1: string, chars2: string, lineArray: !Array.<string>}}
 *     An object containing the encoded text1, the encoded text2 and
 *     the array of unique strings.
 *     The zeroth element of the array of unique strings is intentionally blank.
 * @private
 */ $0f98e7c131f90f2d$var$diff_match_patch.prototype.diff_linesToChars_ = function(text1, text2) {
    var lineArray = []; // e.g. lineArray[4] == 'Hello\n'
    var lineHash = {}; // e.g. lineHash['Hello\n'] == 4
    // '\x00' is a valid character, but various debuggers don't like it.
    // So we'll insert a junk entry to avoid generating a null character.
    lineArray[0] = '';
    /**
   * Split a text into an array of strings.  Reduce the texts to a string of
   * hashes where each Unicode character represents one line.
   * Modifies linearray and linehash through being a closure.
   * @param {string} text String to encode.
   * @return {string} Encoded string.
   * @private
   */ function diff_linesToCharsMunge_(text) {
        var chars = '';
        // Walk the text, pulling out a substring for each line.
        // text.split('\n') would would temporarily double our memory footprint.
        // Modifying text would create many large strings to garbage collect.
        var lineStart = 0;
        var lineEnd = -1;
        // Keeping our own length variable is faster than looking it up.
        var lineArrayLength = lineArray.length;
        while(lineEnd < text.length - 1){
            lineEnd = text.indexOf('\n', lineStart);
            if (lineEnd == -1) lineEnd = text.length - 1;
            var line = text.substring(lineStart, lineEnd + 1);
            if (lineHash.hasOwnProperty ? lineHash.hasOwnProperty(line) : lineHash[line] !== undefined) chars += String.fromCharCode(lineHash[line]);
            else {
                if (lineArrayLength == maxLines) {
                    // Bail out at 65535 because
                    // String.fromCharCode(65536) == String.fromCharCode(0)
                    line = text.substring(lineStart);
                    lineEnd = text.length;
                }
                chars += String.fromCharCode(lineArrayLength);
                lineHash[line] = lineArrayLength;
                lineArray[lineArrayLength++] = line;
            }
            lineStart = lineEnd + 1;
        }
        return chars;
    }
    // Allocate 2/3rds of the space for text1, the rest for text2.
    var maxLines = 40000;
    var chars1 = diff_linesToCharsMunge_(text1);
    maxLines = 65535;
    var chars2 = diff_linesToCharsMunge_(text2);
    return {
        chars1: chars1,
        chars2: chars2,
        lineArray: lineArray
    };
};
/**
 * Rehydrate the text in a diff from a string of line hashes to real lines of
 * text.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @param {!Array.<string>} lineArray Array of unique strings.
 * @private
 */ $0f98e7c131f90f2d$var$diff_match_patch.prototype.diff_charsToLines_ = function(diffs, lineArray) {
    for(var i = 0; i < diffs.length; i++){
        var chars = diffs[i][1];
        var text = [];
        for(var j = 0; j < chars.length; j++)text[j] = lineArray[chars.charCodeAt(j)];
        diffs[i][1] = text.join('');
    }
};
/**
 * Determine the common prefix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the start of each
 *     string.
 */ $0f98e7c131f90f2d$var$diff_match_patch.prototype.diff_commonPrefix = function(text1, text2) {
    // Quick check for common null cases.
    if (!text1 || !text2 || text1.charAt(0) != text2.charAt(0)) return 0;
    // Binary search.
    // Performance analysis: https://neil.fraser.name/news/2007/10/09/
    var pointermin = 0;
    var pointermax = Math.min(text1.length, text2.length);
    var pointermid = pointermax;
    var pointerstart = 0;
    while(pointermin < pointermid){
        if (text1.substring(pointerstart, pointermid) == text2.substring(pointerstart, pointermid)) {
            pointermin = pointermid;
            pointerstart = pointermin;
        } else pointermax = pointermid;
        pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
    }
    return pointermid;
};
/**
 * Determine the common suffix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the end of each string.
 */ $0f98e7c131f90f2d$var$diff_match_patch.prototype.diff_commonSuffix = function(text1, text2) {
    // Quick check for common null cases.
    if (!text1 || !text2 || text1.charAt(text1.length - 1) != text2.charAt(text2.length - 1)) return 0;
    // Binary search.
    // Performance analysis: https://neil.fraser.name/news/2007/10/09/
    var pointermin = 0;
    var pointermax = Math.min(text1.length, text2.length);
    var pointermid = pointermax;
    var pointerend = 0;
    while(pointermin < pointermid){
        if (text1.substring(text1.length - pointermid, text1.length - pointerend) == text2.substring(text2.length - pointermid, text2.length - pointerend)) {
            pointermin = pointermid;
            pointerend = pointermin;
        } else pointermax = pointermid;
        pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
    }
    return pointermid;
};
/**
 * Determine if the suffix of one string is the prefix of another.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the end of the first
 *     string and the start of the second string.
 * @private
 */ $0f98e7c131f90f2d$var$diff_match_patch.prototype.diff_commonOverlap_ = function(text1, text2) {
    // Cache the text lengths to prevent multiple calls.
    var text1_length = text1.length;
    var text2_length = text2.length;
    // Eliminate the null case.
    if (text1_length == 0 || text2_length == 0) return 0;
    // Truncate the longer string.
    if (text1_length > text2_length) text1 = text1.substring(text1_length - text2_length);
    else if (text1_length < text2_length) text2 = text2.substring(0, text1_length);
    var text_length = Math.min(text1_length, text2_length);
    // Quick check for the worst case.
    if (text1 == text2) return text_length;
    // Start by looking for a single character match
    // and increase length until no match is found.
    // Performance analysis: https://neil.fraser.name/news/2010/11/04/
    var best = 0;
    var length = 1;
    while(true){
        var pattern = text1.substring(text_length - length);
        var found = text2.indexOf(pattern);
        if (found == -1) return best;
        length += found;
        if (found == 0 || text1.substring(text_length - length) == text2.substring(0, length)) {
            best = length;
            length++;
        }
    }
};
/**
 * Do the two texts share a substring which is at least half the length of the
 * longer text?
 * This speedup can produce non-minimal diffs.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {Array.<string>} Five element Array, containing the prefix of
 *     text1, the suffix of text1, the prefix of text2, the suffix of
 *     text2 and the common middle.  Or null if there was no match.
 * @private
 */ $0f98e7c131f90f2d$var$diff_match_patch.prototype.diff_halfMatch_ = function(text1, text2) {
    if (this.Diff_Timeout <= 0) // Don't risk returning a non-optimal diff if we have unlimited time.
    return null;
    var longtext = text1.length > text2.length ? text1 : text2;
    var shorttext = text1.length > text2.length ? text2 : text1;
    if (longtext.length < 4 || shorttext.length * 2 < longtext.length) return null; // Pointless.
    var dmp = this; // 'this' becomes 'window' in a closure.
    /**
   * Does a substring of shorttext exist within longtext such that the substring
   * is at least half the length of longtext?
   * Closure, but does not reference any external variables.
   * @param {string} longtext Longer string.
   * @param {string} shorttext Shorter string.
   * @param {number} i Start index of quarter length substring within longtext.
   * @return {Array.<string>} Five element Array, containing the prefix of
   *     longtext, the suffix of longtext, the prefix of shorttext, the suffix
   *     of shorttext and the common middle.  Or null if there was no match.
   * @private
   */ function diff_halfMatchI_(longtext, shorttext, i) {
        // Start with a 1/4 length substring at position i as a seed.
        var seed = longtext.substring(i, i + Math.floor(longtext.length / 4));
        var j = -1;
        var best_common = '';
        var best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b;
        while((j = shorttext.indexOf(seed, j + 1)) != -1){
            var prefixLength = dmp.diff_commonPrefix(longtext.substring(i), shorttext.substring(j));
            var suffixLength = dmp.diff_commonSuffix(longtext.substring(0, i), shorttext.substring(0, j));
            if (best_common.length < suffixLength + prefixLength) {
                best_common = shorttext.substring(j - suffixLength, j) + shorttext.substring(j, j + prefixLength);
                best_longtext_a = longtext.substring(0, i - suffixLength);
                best_longtext_b = longtext.substring(i + prefixLength);
                best_shorttext_a = shorttext.substring(0, j - suffixLength);
                best_shorttext_b = shorttext.substring(j + prefixLength);
            }
        }
        if (best_common.length * 2 >= longtext.length) return [
            best_longtext_a,
            best_longtext_b,
            best_shorttext_a,
            best_shorttext_b,
            best_common
        ];
        else return null;
    }
    // First check if the second quarter is the seed for a half-match.
    var hm1 = diff_halfMatchI_(longtext, shorttext, Math.ceil(longtext.length / 4));
    // Check again based on the third quarter.
    var hm2 = diff_halfMatchI_(longtext, shorttext, Math.ceil(longtext.length / 2));
    var hm;
    if (!hm1 && !hm2) return null;
    else if (!hm2) hm = hm1;
    else if (!hm1) hm = hm2;
    else // Both matched.  Select the longest.
    hm = hm1[4].length > hm2[4].length ? hm1 : hm2;
    // A half-match was found, sort out the return data.
    var text1_a, text1_b, text2_a, text2_b;
    if (text1.length > text2.length) {
        text1_a = hm[0];
        text1_b = hm[1];
        text2_a = hm[2];
        text2_b = hm[3];
    } else {
        text2_a = hm[0];
        text2_b = hm[1];
        text1_a = hm[2];
        text1_b = hm[3];
    }
    var mid_common = hm[4];
    return [
        text1_a,
        text1_b,
        text2_a,
        text2_b,
        mid_common
    ];
};
/**
 * Reduce the number of edits by eliminating semantically trivial equalities.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 */ $0f98e7c131f90f2d$var$diff_match_patch.prototype.diff_cleanupSemantic = function(diffs) {
    var changes = false;
    var equalities = []; // Stack of indices where equalities are found.
    var equalitiesLength = 0; // Keeping our own length var is faster in JS.
    /** @type {?string} */ var lastEquality = null;
    // Always equal to diffs[equalities[equalitiesLength - 1]][1]
    var pointer = 0; // Index of current position.
    // Number of characters that changed prior to the equality.
    var length_insertions1 = 0;
    var length_deletions1 = 0;
    // Number of characters that changed after the equality.
    var length_insertions2 = 0;
    var length_deletions2 = 0;
    while(pointer < diffs.length){
        if (diffs[pointer][0] == $0f98e7c131f90f2d$var$DIFF_EQUAL) {
            equalities[equalitiesLength++] = pointer;
            length_insertions1 = length_insertions2;
            length_deletions1 = length_deletions2;
            length_insertions2 = 0;
            length_deletions2 = 0;
            lastEquality = diffs[pointer][1];
        } else {
            if (diffs[pointer][0] == $0f98e7c131f90f2d$var$DIFF_INSERT) length_insertions2 += diffs[pointer][1].length;
            else length_deletions2 += diffs[pointer][1].length;
            // Eliminate an equality that is smaller or equal to the edits on both
            // sides of it.
            if (lastEquality && lastEquality.length <= Math.max(length_insertions1, length_deletions1) && lastEquality.length <= Math.max(length_insertions2, length_deletions2)) {
                // Duplicate record.
                diffs.splice(equalities[equalitiesLength - 1], 0, new $0f98e7c131f90f2d$var$diff_match_patch.Diff($0f98e7c131f90f2d$var$DIFF_DELETE, lastEquality));
                // Change second copy to insert.
                diffs[equalities[equalitiesLength - 1] + 1][0] = $0f98e7c131f90f2d$var$DIFF_INSERT;
                // Throw away the equality we just deleted.
                equalitiesLength--;
                // Throw away the previous equality (it needs to be reevaluated).
                equalitiesLength--;
                pointer = equalitiesLength > 0 ? equalities[equalitiesLength - 1] : -1;
                length_insertions1 = 0; // Reset the counters.
                length_deletions1 = 0;
                length_insertions2 = 0;
                length_deletions2 = 0;
                lastEquality = null;
                changes = true;
            }
        }
        pointer++;
    }
    // Normalize the diff.
    if (changes) this.diff_cleanupMerge(diffs);
    this.diff_cleanupSemanticLossless(diffs);
    // Find any overlaps between deletions and insertions.
    // e.g: <del>abcxxx</del><ins>xxxdef</ins>
    //   -> <del>abc</del>xxx<ins>def</ins>
    // e.g: <del>xxxabc</del><ins>defxxx</ins>
    //   -> <ins>def</ins>xxx<del>abc</del>
    // Only extract an overlap if it is as big as the edit ahead or behind it.
    pointer = 1;
    while(pointer < diffs.length){
        if (diffs[pointer - 1][0] == $0f98e7c131f90f2d$var$DIFF_DELETE && diffs[pointer][0] == $0f98e7c131f90f2d$var$DIFF_INSERT) {
            var deletion = diffs[pointer - 1][1];
            var insertion = diffs[pointer][1];
            var overlap_length1 = this.diff_commonOverlap_(deletion, insertion);
            var overlap_length2 = this.diff_commonOverlap_(insertion, deletion);
            if (overlap_length1 >= overlap_length2) {
                if (overlap_length1 >= deletion.length / 2 || overlap_length1 >= insertion.length / 2) {
                    // Overlap found.  Insert an equality and trim the surrounding edits.
                    diffs.splice(pointer, 0, new $0f98e7c131f90f2d$var$diff_match_patch.Diff($0f98e7c131f90f2d$var$DIFF_EQUAL, insertion.substring(0, overlap_length1)));
                    diffs[pointer - 1][1] = deletion.substring(0, deletion.length - overlap_length1);
                    diffs[pointer + 1][1] = insertion.substring(overlap_length1);
                    pointer++;
                }
            } else if (overlap_length2 >= deletion.length / 2 || overlap_length2 >= insertion.length / 2) {
                // Reverse overlap found.
                // Insert an equality and swap and trim the surrounding edits.
                diffs.splice(pointer, 0, new $0f98e7c131f90f2d$var$diff_match_patch.Diff($0f98e7c131f90f2d$var$DIFF_EQUAL, deletion.substring(0, overlap_length2)));
                diffs[pointer - 1][0] = $0f98e7c131f90f2d$var$DIFF_INSERT;
                diffs[pointer - 1][1] = insertion.substring(0, insertion.length - overlap_length2);
                diffs[pointer + 1][0] = $0f98e7c131f90f2d$var$DIFF_DELETE;
                diffs[pointer + 1][1] = deletion.substring(overlap_length2);
                pointer++;
            }
            pointer++;
        }
        pointer++;
    }
};
/**
 * Look for single edits surrounded on both sides by equalities
 * which can be shifted sideways to align the edit to a word boundary.
 * e.g: The c<ins>at c</ins>ame. -> The <ins>cat </ins>came.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 */ $0f98e7c131f90f2d$var$diff_match_patch.prototype.diff_cleanupSemanticLossless = function(diffs) {
    /**
   * Given two strings, compute a score representing whether the internal
   * boundary falls on logical boundaries.
   * Scores range from 6 (best) to 0 (worst).
   * Closure, but does not reference any external variables.
   * @param {string} one First string.
   * @param {string} two Second string.
   * @return {number} The score.
   * @private
   */ function diff_cleanupSemanticScore_(one, two) {
        if (!one || !two) // Edges are the best.
        return 6;
        // Each port of this function behaves slightly differently due to
        // subtle differences in each language's definition of things like
        // 'whitespace'.  Since this function's purpose is largely cosmetic,
        // the choice has been made to use each language's native features
        // rather than force total conformity.
        var char1 = one.charAt(one.length - 1);
        var char2 = two.charAt(0);
        var nonAlphaNumeric1 = char1.match($0f98e7c131f90f2d$var$diff_match_patch.nonAlphaNumericRegex_);
        var nonAlphaNumeric2 = char2.match($0f98e7c131f90f2d$var$diff_match_patch.nonAlphaNumericRegex_);
        var whitespace1 = nonAlphaNumeric1 && char1.match($0f98e7c131f90f2d$var$diff_match_patch.whitespaceRegex_);
        var whitespace2 = nonAlphaNumeric2 && char2.match($0f98e7c131f90f2d$var$diff_match_patch.whitespaceRegex_);
        var lineBreak1 = whitespace1 && char1.match($0f98e7c131f90f2d$var$diff_match_patch.linebreakRegex_);
        var lineBreak2 = whitespace2 && char2.match($0f98e7c131f90f2d$var$diff_match_patch.linebreakRegex_);
        var blankLine1 = lineBreak1 && one.match($0f98e7c131f90f2d$var$diff_match_patch.blanklineEndRegex_);
        var blankLine2 = lineBreak2 && two.match($0f98e7c131f90f2d$var$diff_match_patch.blanklineStartRegex_);
        if (blankLine1 || blankLine2) // Five points for blank lines.
        return 5;
        else if (lineBreak1 || lineBreak2) // Four points for line breaks.
        return 4;
        else if (nonAlphaNumeric1 && !whitespace1 && whitespace2) // Three points for end of sentences.
        return 3;
        else if (whitespace1 || whitespace2) // Two points for whitespace.
        return 2;
        else if (nonAlphaNumeric1 || nonAlphaNumeric2) // One point for non-alphanumeric.
        return 1;
        return 0;
    }
    var pointer = 1;
    // Intentionally ignore the first and last element (don't need checking).
    while(pointer < diffs.length - 1){
        if (diffs[pointer - 1][0] == $0f98e7c131f90f2d$var$DIFF_EQUAL && diffs[pointer + 1][0] == $0f98e7c131f90f2d$var$DIFF_EQUAL) {
            // This is a single edit surrounded by equalities.
            var equality1 = diffs[pointer - 1][1];
            var edit = diffs[pointer][1];
            var equality2 = diffs[pointer + 1][1];
            // First, shift the edit as far left as possible.
            var commonOffset = this.diff_commonSuffix(equality1, edit);
            if (commonOffset) {
                var commonString = edit.substring(edit.length - commonOffset);
                equality1 = equality1.substring(0, equality1.length - commonOffset);
                edit = commonString + edit.substring(0, edit.length - commonOffset);
                equality2 = commonString + equality2;
            }
            // Second, step character by character right, looking for the best fit.
            var bestEquality1 = equality1;
            var bestEdit = edit;
            var bestEquality2 = equality2;
            var bestScore = diff_cleanupSemanticScore_(equality1, edit) + diff_cleanupSemanticScore_(edit, equality2);
            while(edit.charAt(0) === equality2.charAt(0)){
                equality1 += edit.charAt(0);
                edit = edit.substring(1) + equality2.charAt(0);
                equality2 = equality2.substring(1);
                var score = diff_cleanupSemanticScore_(equality1, edit) + diff_cleanupSemanticScore_(edit, equality2);
                // The >= encourages trailing rather than leading whitespace on edits.
                if (score >= bestScore) {
                    bestScore = score;
                    bestEquality1 = equality1;
                    bestEdit = edit;
                    bestEquality2 = equality2;
                }
            }
            if (diffs[pointer - 1][1] != bestEquality1) {
                // We have an improvement, save it back to the diff.
                if (bestEquality1) diffs[pointer - 1][1] = bestEquality1;
                else {
                    diffs.splice(pointer - 1, 1);
                    pointer--;
                }
                diffs[pointer][1] = bestEdit;
                if (bestEquality2) diffs[pointer + 1][1] = bestEquality2;
                else {
                    diffs.splice(pointer + 1, 1);
                    pointer--;
                }
            }
        }
        pointer++;
    }
};
// Define some regex patterns for matching boundaries.
$0f98e7c131f90f2d$var$diff_match_patch.nonAlphaNumericRegex_ = /[^a-zA-Z0-9]/;
$0f98e7c131f90f2d$var$diff_match_patch.whitespaceRegex_ = /\s/;
$0f98e7c131f90f2d$var$diff_match_patch.linebreakRegex_ = /[\r\n]/;
$0f98e7c131f90f2d$var$diff_match_patch.blanklineEndRegex_ = /\n\r?\n$/;
$0f98e7c131f90f2d$var$diff_match_patch.blanklineStartRegex_ = /^\r?\n\r?\n/;
/**
 * Reduce the number of edits by eliminating operationally trivial equalities.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 */ $0f98e7c131f90f2d$var$diff_match_patch.prototype.diff_cleanupEfficiency = function(diffs) {
    var changes = false;
    var equalities = []; // Stack of indices where equalities are found.
    var equalitiesLength = 0; // Keeping our own length var is faster in JS.
    /** @type {?string} */ var lastEquality = null;
    // Always equal to diffs[equalities[equalitiesLength - 1]][1]
    var pointer = 0; // Index of current position.
    // Is there an insertion operation before the last equality.
    var pre_ins = false;
    // Is there a deletion operation before the last equality.
    var pre_del = false;
    // Is there an insertion operation after the last equality.
    var post_ins = false;
    // Is there a deletion operation after the last equality.
    var post_del = false;
    while(pointer < diffs.length){
        if (diffs[pointer][0] == $0f98e7c131f90f2d$var$DIFF_EQUAL) {
            if (diffs[pointer][1].length < this.Diff_EditCost && (post_ins || post_del)) {
                // Candidate found.
                equalities[equalitiesLength++] = pointer;
                pre_ins = post_ins;
                pre_del = post_del;
                lastEquality = diffs[pointer][1];
            } else {
                // Not a candidate, and can never become one.
                equalitiesLength = 0;
                lastEquality = null;
            }
            post_ins = post_del = false;
        } else {
            if (diffs[pointer][0] == $0f98e7c131f90f2d$var$DIFF_DELETE) post_del = true;
            else post_ins = true;
            /*
       * Five types to be split:
       * <ins>A</ins><del>B</del>XY<ins>C</ins><del>D</del>
       * <ins>A</ins>X<ins>C</ins><del>D</del>
       * <ins>A</ins><del>B</del>X<ins>C</ins>
       * <ins>A</del>X<ins>C</ins><del>D</del>
       * <ins>A</ins><del>B</del>X<del>C</del>
       */ if (lastEquality && (pre_ins && pre_del && post_ins && post_del || lastEquality.length < this.Diff_EditCost / 2 && pre_ins + pre_del + post_ins + post_del == 3)) {
                // Duplicate record.
                diffs.splice(equalities[equalitiesLength - 1], 0, new $0f98e7c131f90f2d$var$diff_match_patch.Diff($0f98e7c131f90f2d$var$DIFF_DELETE, lastEquality));
                // Change second copy to insert.
                diffs[equalities[equalitiesLength - 1] + 1][0] = $0f98e7c131f90f2d$var$DIFF_INSERT;
                equalitiesLength--; // Throw away the equality we just deleted;
                lastEquality = null;
                if (pre_ins && pre_del) {
                    // No changes made which could affect previous entry, keep going.
                    post_ins = post_del = true;
                    equalitiesLength = 0;
                } else {
                    equalitiesLength--; // Throw away the previous equality.
                    pointer = equalitiesLength > 0 ? equalities[equalitiesLength - 1] : -1;
                    post_ins = post_del = false;
                }
                changes = true;
            }
        }
        pointer++;
    }
    if (changes) this.diff_cleanupMerge(diffs);
};
/**
 * Reorder and merge like edit sections.  Merge equalities.
 * Any edit section can move as long as it doesn't cross an equality.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 */ $0f98e7c131f90f2d$var$diff_match_patch.prototype.diff_cleanupMerge = function(diffs) {
    // Add a dummy entry at the end.
    diffs.push(new $0f98e7c131f90f2d$var$diff_match_patch.Diff($0f98e7c131f90f2d$var$DIFF_EQUAL, ''));
    var pointer = 0;
    var count_delete = 0;
    var count_insert = 0;
    var text_delete = '';
    var text_insert = '';
    var commonlength;
    while(pointer < diffs.length)switch(diffs[pointer][0]){
        case $0f98e7c131f90f2d$var$DIFF_INSERT:
            count_insert++;
            text_insert += diffs[pointer][1];
            pointer++;
            break;
        case $0f98e7c131f90f2d$var$DIFF_DELETE:
            count_delete++;
            text_delete += diffs[pointer][1];
            pointer++;
            break;
        case $0f98e7c131f90f2d$var$DIFF_EQUAL:
            // Upon reaching an equality, check for prior redundancies.
            if (count_delete + count_insert > 1) {
                if (count_delete !== 0 && count_insert !== 0) {
                    // Factor out any common prefixies.
                    commonlength = this.diff_commonPrefix(text_insert, text_delete);
                    if (commonlength !== 0) {
                        if (pointer - count_delete - count_insert > 0 && diffs[pointer - count_delete - count_insert - 1][0] == $0f98e7c131f90f2d$var$DIFF_EQUAL) diffs[pointer - count_delete - count_insert - 1][1] += text_insert.substring(0, commonlength);
                        else {
                            diffs.splice(0, 0, new $0f98e7c131f90f2d$var$diff_match_patch.Diff($0f98e7c131f90f2d$var$DIFF_EQUAL, text_insert.substring(0, commonlength)));
                            pointer++;
                        }
                        text_insert = text_insert.substring(commonlength);
                        text_delete = text_delete.substring(commonlength);
                    }
                    // Factor out any common suffixies.
                    commonlength = this.diff_commonSuffix(text_insert, text_delete);
                    if (commonlength !== 0) {
                        diffs[pointer][1] = text_insert.substring(text_insert.length - commonlength) + diffs[pointer][1];
                        text_insert = text_insert.substring(0, text_insert.length - commonlength);
                        text_delete = text_delete.substring(0, text_delete.length - commonlength);
                    }
                }
                // Delete the offending records and add the merged ones.
                pointer -= count_delete + count_insert;
                diffs.splice(pointer, count_delete + count_insert);
                if (text_delete.length) {
                    diffs.splice(pointer, 0, new $0f98e7c131f90f2d$var$diff_match_patch.Diff($0f98e7c131f90f2d$var$DIFF_DELETE, text_delete));
                    pointer++;
                }
                if (text_insert.length) {
                    diffs.splice(pointer, 0, new $0f98e7c131f90f2d$var$diff_match_patch.Diff($0f98e7c131f90f2d$var$DIFF_INSERT, text_insert));
                    pointer++;
                }
                pointer++;
            } else if (pointer !== 0 && diffs[pointer - 1][0] == $0f98e7c131f90f2d$var$DIFF_EQUAL) {
                // Merge this equality with the previous one.
                diffs[pointer - 1][1] += diffs[pointer][1];
                diffs.splice(pointer, 1);
            } else pointer++;
            count_insert = 0;
            count_delete = 0;
            text_delete = '';
            text_insert = '';
            break;
    }
    if (diffs[diffs.length - 1][1] === '') diffs.pop(); // Remove the dummy entry at the end.
    // Second pass: look for single edits surrounded on both sides by equalities
    // which can be shifted sideways to eliminate an equality.
    // e.g: A<ins>BA</ins>C -> <ins>AB</ins>AC
    var changes = false;
    pointer = 1;
    // Intentionally ignore the first and last element (don't need checking).
    while(pointer < diffs.length - 1){
        if (diffs[pointer - 1][0] == $0f98e7c131f90f2d$var$DIFF_EQUAL && diffs[pointer + 1][0] == $0f98e7c131f90f2d$var$DIFF_EQUAL) {
            // This is a single edit surrounded by equalities.
            if (diffs[pointer][1].substring(diffs[pointer][1].length - diffs[pointer - 1][1].length) == diffs[pointer - 1][1]) {
                // Shift the edit over the previous equality.
                diffs[pointer][1] = diffs[pointer - 1][1] + diffs[pointer][1].substring(0, diffs[pointer][1].length - diffs[pointer - 1][1].length);
                diffs[pointer + 1][1] = diffs[pointer - 1][1] + diffs[pointer + 1][1];
                diffs.splice(pointer - 1, 1);
                changes = true;
            } else if (diffs[pointer][1].substring(0, diffs[pointer + 1][1].length) == diffs[pointer + 1][1]) {
                // Shift the edit over the next equality.
                diffs[pointer - 1][1] += diffs[pointer + 1][1];
                diffs[pointer][1] = diffs[pointer][1].substring(diffs[pointer + 1][1].length) + diffs[pointer + 1][1];
                diffs.splice(pointer + 1, 1);
                changes = true;
            }
        }
        pointer++;
    }
    // If shifts were made, the diff needs reordering and another shift sweep.
    if (changes) this.diff_cleanupMerge(diffs);
};
/**
 * loc is a location in text1, compute and return the equivalent location in
 * text2.
 * e.g. 'The cat' vs 'The big cat', 1->1, 5->8
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @param {number} loc Location within text1.
 * @return {number} Location within text2.
 */ $0f98e7c131f90f2d$var$diff_match_patch.prototype.diff_xIndex = function(diffs, loc) {
    var chars1 = 0;
    var chars2 = 0;
    var last_chars1 = 0;
    var last_chars2 = 0;
    var x;
    for(x = 0; x < diffs.length; x++){
        if (diffs[x][0] !== $0f98e7c131f90f2d$var$DIFF_INSERT) chars1 += diffs[x][1].length;
        if (diffs[x][0] !== $0f98e7c131f90f2d$var$DIFF_DELETE) chars2 += diffs[x][1].length;
        if (chars1 > loc) break;
        last_chars1 = chars1;
        last_chars2 = chars2;
    }
    // Was the location was deleted?
    if (diffs.length != x && diffs[x][0] === $0f98e7c131f90f2d$var$DIFF_DELETE) return last_chars2;
    // Add the remaining character length.
    return last_chars2 + (loc - last_chars1);
};
/**
 * Convert a diff array into a pretty HTML report.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @return {string} HTML representation.
 */ $0f98e7c131f90f2d$var$diff_match_patch.prototype.diff_prettyHtml = function(diffs) {
    var html = [];
    var pattern_amp = /&/g;
    var pattern_lt = /</g;
    var pattern_gt = />/g;
    var pattern_para = /\n/g;
    for(var x = 0; x < diffs.length; x++){
        var op = diffs[x][0]; // Operation (insert, delete, equal)
        var data = diffs[x][1]; // Text of change.
        var text = data.replace(pattern_amp, '&amp;').replace(pattern_lt, '&lt;').replace(pattern_gt, '&gt;').replace(pattern_para, '&para;<br>');
        switch(op){
            case $0f98e7c131f90f2d$var$DIFF_INSERT:
                html[x] = '<ins style="background:#e6ffe6;">' + text + '</ins>';
                break;
            case $0f98e7c131f90f2d$var$DIFF_DELETE:
                html[x] = '<del style="background:#ffe6e6;">' + text + '</del>';
                break;
            case $0f98e7c131f90f2d$var$DIFF_EQUAL:
                html[x] = '<span>' + text + '</span>';
                break;
        }
    }
    return html.join('');
};
/**
 * Compute and return the source text (all equalities and deletions).
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @return {string} Source text.
 */ $0f98e7c131f90f2d$var$diff_match_patch.prototype.diff_text1 = function(diffs) {
    var text = [];
    for(var x = 0; x < diffs.length; x++)if (diffs[x][0] !== $0f98e7c131f90f2d$var$DIFF_INSERT) text[x] = diffs[x][1];
    return text.join('');
};
/**
 * Compute and return the destination text (all equalities and insertions).
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @return {string} Destination text.
 */ $0f98e7c131f90f2d$var$diff_match_patch.prototype.diff_text2 = function(diffs) {
    var text = [];
    for(var x = 0; x < diffs.length; x++)if (diffs[x][0] !== $0f98e7c131f90f2d$var$DIFF_DELETE) text[x] = diffs[x][1];
    return text.join('');
};
/**
 * Compute the Levenshtein distance; the number of inserted, deleted or
 * substituted characters.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @return {number} Number of changes.
 */ $0f98e7c131f90f2d$var$diff_match_patch.prototype.diff_levenshtein = function(diffs) {
    var levenshtein = 0;
    var insertions = 0;
    var deletions = 0;
    for(var x = 0; x < diffs.length; x++){
        var op = diffs[x][0];
        var data = diffs[x][1];
        switch(op){
            case $0f98e7c131f90f2d$var$DIFF_INSERT:
                insertions += data.length;
                break;
            case $0f98e7c131f90f2d$var$DIFF_DELETE:
                deletions += data.length;
                break;
            case $0f98e7c131f90f2d$var$DIFF_EQUAL:
                // A deletion and an insertion is one substitution.
                levenshtein += Math.max(insertions, deletions);
                insertions = 0;
                deletions = 0;
                break;
        }
    }
    levenshtein += Math.max(insertions, deletions);
    return levenshtein;
};
/**
 * Crush the diff into an encoded string which describes the operations
 * required to transform text1 into text2.
 * E.g. =3\t-2\t+ing  -> Keep 3 chars, delete 2 chars, insert 'ing'.
 * Operations are tab-separated.  Inserted text is escaped using %xx notation.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @return {string} Delta text.
 */ $0f98e7c131f90f2d$var$diff_match_patch.prototype.diff_toDelta = function(diffs) {
    var text = [];
    for(var x = 0; x < diffs.length; x++)switch(diffs[x][0]){
        case $0f98e7c131f90f2d$var$DIFF_INSERT:
            text[x] = '+' + encodeURI(diffs[x][1]);
            break;
        case $0f98e7c131f90f2d$var$DIFF_DELETE:
            text[x] = '-' + diffs[x][1].length;
            break;
        case $0f98e7c131f90f2d$var$DIFF_EQUAL:
            text[x] = '=' + diffs[x][1].length;
            break;
    }
    return text.join('\t').replace(/%20/g, ' ');
};
/**
 * Given the original text1, and an encoded string which describes the
 * operations required to transform text1 into text2, compute the full diff.
 * @param {string} text1 Source string for the diff.
 * @param {string} delta Delta text.
 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
 * @throws {!Error} If invalid input.
 */ $0f98e7c131f90f2d$var$diff_match_patch.prototype.diff_fromDelta = function(text1, delta) {
    var diffs = [];
    var diffsLength = 0; // Keeping our own length var is faster in JS.
    var pointer = 0; // Cursor in text1
    var tokens = delta.split(/\t/g);
    for(var x = 0; x < tokens.length; x++){
        // Each token begins with a one character parameter which specifies the
        // operation of this token (delete, insert, equality).
        var param = tokens[x].substring(1);
        switch(tokens[x].charAt(0)){
            case '+':
                try {
                    diffs[diffsLength++] = new $0f98e7c131f90f2d$var$diff_match_patch.Diff($0f98e7c131f90f2d$var$DIFF_INSERT, decodeURI(param));
                } catch (ex) {
                    // Malformed URI sequence.
                    throw new Error('Illegal escape in diff_fromDelta: ' + param);
                }
                break;
            case '-':
            // Fall through.
            case '=':
                var n = parseInt(param, 10);
                if (isNaN(n) || n < 0) throw new Error('Invalid number in diff_fromDelta: ' + param);
                var text = text1.substring(pointer, pointer += n);
                if (tokens[x].charAt(0) == '=') diffs[diffsLength++] = new $0f98e7c131f90f2d$var$diff_match_patch.Diff($0f98e7c131f90f2d$var$DIFF_EQUAL, text);
                else diffs[diffsLength++] = new $0f98e7c131f90f2d$var$diff_match_patch.Diff($0f98e7c131f90f2d$var$DIFF_DELETE, text);
                break;
            default:
                // Blank tokens are ok (from a trailing \t).
                // Anything else is an error.
                if (tokens[x]) throw new Error('Invalid diff operation in diff_fromDelta: ' + tokens[x]);
        }
    }
    if (pointer != text1.length) throw new Error('Delta length (' + pointer + ') does not equal source text length (' + text1.length + ').');
    return diffs;
};
//  MATCH FUNCTIONS
/**
 * Locate the best instance of 'pattern' in 'text' near 'loc'.
 * @param {string} text The text to search.
 * @param {string} pattern The pattern to search for.
 * @param {number} loc The location to search around.
 * @return {number} Best match index or -1.
 */ $0f98e7c131f90f2d$var$diff_match_patch.prototype.match_main = function(text, pattern, loc) {
    // Check for null inputs.
    if (text == null || pattern == null || loc == null) throw new Error('Null input. (match_main)');
    loc = Math.max(0, Math.min(loc, text.length));
    if (text == pattern) // Shortcut (potentially not guaranteed by the algorithm)
    return 0;
    else if (!text.length) // Nothing to match.
    return -1;
    else if (text.substring(loc, loc + pattern.length) == pattern) // Perfect match at the perfect spot!  (Includes case of null pattern)
    return loc;
    else // Do a fuzzy compare.
    return this.match_bitap_(text, pattern, loc);
};
/**
 * Locate the best instance of 'pattern' in 'text' near 'loc' using the
 * Bitap algorithm.
 * @param {string} text The text to search.
 * @param {string} pattern The pattern to search for.
 * @param {number} loc The location to search around.
 * @return {number} Best match index or -1.
 * @private
 */ $0f98e7c131f90f2d$var$diff_match_patch.prototype.match_bitap_ = function(text, pattern, loc) {
    if (pattern.length > this.Match_MaxBits) throw new Error('Pattern too long for this browser.');
    // Initialise the alphabet.
    var s = this.match_alphabet_(pattern);
    var dmp = this; // 'this' becomes 'window' in a closure.
    /**
   * Compute and return the score for a match with e errors and x location.
   * Accesses loc and pattern through being a closure.
   * @param {number} e Number of errors in match.
   * @param {number} x Location of match.
   * @return {number} Overall score for match (0.0 = good, 1.0 = bad).
   * @private
   */ function match_bitapScore_(e, x) {
        var accuracy = e / pattern.length;
        var proximity = Math.abs(loc - x);
        if (!dmp.Match_Distance) // Dodge divide by zero error.
        return proximity ? 1.0 : accuracy;
        return accuracy + proximity / dmp.Match_Distance;
    }
    // Highest score beyond which we give up.
    var score_threshold = this.Match_Threshold;
    // Is there a nearby exact match? (speedup)
    var best_loc = text.indexOf(pattern, loc);
    if (best_loc != -1) {
        score_threshold = Math.min(match_bitapScore_(0, best_loc), score_threshold);
        // What about in the other direction? (speedup)
        best_loc = text.lastIndexOf(pattern, loc + pattern.length);
        if (best_loc != -1) score_threshold = Math.min(match_bitapScore_(0, best_loc), score_threshold);
    }
    // Initialise the bit arrays.
    var matchmask = 1 << pattern.length - 1;
    best_loc = -1;
    var bin_min, bin_mid;
    var bin_max = pattern.length + text.length;
    var last_rd;
    for(var d = 0; d < pattern.length; d++){
        // Scan for the best match; each iteration allows for one more error.
        // Run a binary search to determine how far from 'loc' we can stray at this
        // error level.
        bin_min = 0;
        bin_mid = bin_max;
        while(bin_min < bin_mid){
            if (match_bitapScore_(d, loc + bin_mid) <= score_threshold) bin_min = bin_mid;
            else bin_max = bin_mid;
            bin_mid = Math.floor((bin_max - bin_min) / 2 + bin_min);
        }
        // Use the result from this iteration as the maximum for the next.
        bin_max = bin_mid;
        var start = Math.max(1, loc - bin_mid + 1);
        var finish = Math.min(loc + bin_mid, text.length) + pattern.length;
        var rd = Array(finish + 2);
        rd[finish + 1] = (1 << d) - 1;
        for(var j = finish; j >= start; j--){
            // The alphabet (s) is a sparse hash, so the following line generates
            // warnings.
            var charMatch = s[text.charAt(j - 1)];
            if (d === 0) rd[j] = (rd[j + 1] << 1 | 1) & charMatch;
            else rd[j] = (rd[j + 1] << 1 | 1) & charMatch | ((last_rd[j + 1] | last_rd[j]) << 1 | 1) | last_rd[j + 1];
            if (rd[j] & matchmask) {
                var score = match_bitapScore_(d, j - 1);
                // This match will almost certainly be better than any existing match.
                // But check anyway.
                if (score <= score_threshold) {
                    // Told you so.
                    score_threshold = score;
                    best_loc = j - 1;
                    if (best_loc > loc) // When passing loc, don't exceed our current distance from loc.
                    start = Math.max(1, 2 * loc - best_loc);
                    else break;
                }
            }
        }
        // No hope for a (better) match at greater error levels.
        if (match_bitapScore_(d + 1, loc) > score_threshold) break;
        last_rd = rd;
    }
    return best_loc;
};
/**
 * Initialise the alphabet for the Bitap algorithm.
 * @param {string} pattern The text to encode.
 * @return {!Object} Hash of character locations.
 * @private
 */ $0f98e7c131f90f2d$var$diff_match_patch.prototype.match_alphabet_ = function(pattern) {
    var s = {};
    for(var i = 0; i < pattern.length; i++)s[pattern.charAt(i)] = 0;
    for(var i = 0; i < pattern.length; i++)s[pattern.charAt(i)] |= 1 << pattern.length - i - 1;
    return s;
};
//  PATCH FUNCTIONS
/**
 * Increase the context until it is unique,
 * but don't let the pattern expand beyond Match_MaxBits.
 * @param {!diff_match_patch.patch_obj} patch The patch to grow.
 * @param {string} text Source text.
 * @private
 */ $0f98e7c131f90f2d$var$diff_match_patch.prototype.patch_addContext_ = function(patch, text) {
    if (text.length == 0) return;
    if (patch.start2 === null) throw Error('patch not initialized');
    var pattern = text.substring(patch.start2, patch.start2 + patch.length1);
    var padding = 0;
    // Look for the first and last matches of pattern in text.  If two different
    // matches are found, increase the pattern length.
    while(text.indexOf(pattern) != text.lastIndexOf(pattern) && pattern.length < this.Match_MaxBits - this.Patch_Margin - this.Patch_Margin){
        padding += this.Patch_Margin;
        pattern = text.substring(patch.start2 - padding, patch.start2 + patch.length1 + padding);
    }
    // Add one chunk for good luck.
    padding += this.Patch_Margin;
    // Add the prefix.
    var prefix = text.substring(patch.start2 - padding, patch.start2);
    if (prefix) patch.diffs.unshift(new $0f98e7c131f90f2d$var$diff_match_patch.Diff($0f98e7c131f90f2d$var$DIFF_EQUAL, prefix));
    // Add the suffix.
    var suffix = text.substring(patch.start2 + patch.length1, patch.start2 + patch.length1 + padding);
    if (suffix) patch.diffs.push(new $0f98e7c131f90f2d$var$diff_match_patch.Diff($0f98e7c131f90f2d$var$DIFF_EQUAL, suffix));
    // Roll back the start points.
    patch.start1 -= prefix.length;
    patch.start2 -= prefix.length;
    // Extend the lengths.
    patch.length1 += prefix.length + suffix.length;
    patch.length2 += prefix.length + suffix.length;
};
/**
 * Compute a list of patches to turn text1 into text2.
 * Use diffs if provided, otherwise compute it ourselves.
 * There are four ways to call this function, depending on what data is
 * available to the caller:
 * Method 1:
 * a = text1, b = text2
 * Method 2:
 * a = diffs
 * Method 3 (optimal):
 * a = text1, b = diffs
 * Method 4 (deprecated, use method 3):
 * a = text1, b = text2, c = diffs
 *
 * @param {string|!Array.<!diff_match_patch.Diff>} a text1 (methods 1,3,4) or
 * Array of diff tuples for text1 to text2 (method 2).
 * @param {string|!Array.<!diff_match_patch.Diff>=} opt_b text2 (methods 1,4) or
 * Array of diff tuples for text1 to text2 (method 3) or undefined (method 2).
 * @param {string|!Array.<!diff_match_patch.Diff>=} opt_c Array of diff tuples
 * for text1 to text2 (method 4) or undefined (methods 1,2,3).
 * @return {!Array.<!diff_match_patch.patch_obj>} Array of Patch objects.
 */ $0f98e7c131f90f2d$var$diff_match_patch.prototype.patch_make = function(a, opt_b, opt_c) {
    var text1, diffs;
    if (typeof a == 'string' && typeof opt_b == 'string' && typeof opt_c == 'undefined') {
        // Method 1: text1, text2
        // Compute diffs from text1 and text2.
        text1 = /** @type {string} */ a;
        diffs = this.diff_main(text1, /** @type {string} */ opt_b, true);
        if (diffs.length > 2) {
            this.diff_cleanupSemantic(diffs);
            this.diff_cleanupEfficiency(diffs);
        }
    } else if (a && typeof a == 'object' && typeof opt_b == 'undefined' && typeof opt_c == 'undefined') {
        // Method 2: diffs
        // Compute text1 from diffs.
        diffs = /** @type {!Array.<!diff_match_patch.Diff>} */ a;
        text1 = this.diff_text1(diffs);
    } else if (typeof a == 'string' && opt_b && typeof opt_b == 'object' && typeof opt_c == 'undefined') {
        // Method 3: text1, diffs
        text1 = /** @type {string} */ a;
        diffs = /** @type {!Array.<!diff_match_patch.Diff>} */ opt_b;
    } else if (typeof a == 'string' && typeof opt_b == 'string' && opt_c && typeof opt_c == 'object') {
        // Method 4: text1, text2, diffs
        // text2 is not used.
        text1 = /** @type {string} */ a;
        diffs = /** @type {!Array.<!diff_match_patch.Diff>} */ opt_c;
    } else throw new Error('Unknown call format to patch_make.');
    if (diffs.length === 0) return []; // Get rid of the null case.
    var patches = [];
    var patch = new $0f98e7c131f90f2d$var$diff_match_patch.patch_obj();
    var patchDiffLength = 0; // Keeping our own length var is faster in JS.
    var char_count1 = 0; // Number of characters into the text1 string.
    var char_count2 = 0; // Number of characters into the text2 string.
    // Start with text1 (prepatch_text) and apply the diffs until we arrive at
    // text2 (postpatch_text).  We recreate the patches one by one to determine
    // context info.
    var prepatch_text = text1;
    var postpatch_text = text1;
    for(var x = 0; x < diffs.length; x++){
        var diff_type = diffs[x][0];
        var diff_text = diffs[x][1];
        if (!patchDiffLength && diff_type !== $0f98e7c131f90f2d$var$DIFF_EQUAL) {
            // A new patch starts here.
            patch.start1 = char_count1;
            patch.start2 = char_count2;
        }
        switch(diff_type){
            case $0f98e7c131f90f2d$var$DIFF_INSERT:
                patch.diffs[patchDiffLength++] = diffs[x];
                patch.length2 += diff_text.length;
                postpatch_text = postpatch_text.substring(0, char_count2) + diff_text + postpatch_text.substring(char_count2);
                break;
            case $0f98e7c131f90f2d$var$DIFF_DELETE:
                patch.length1 += diff_text.length;
                patch.diffs[patchDiffLength++] = diffs[x];
                postpatch_text = postpatch_text.substring(0, char_count2) + postpatch_text.substring(char_count2 + diff_text.length);
                break;
            case $0f98e7c131f90f2d$var$DIFF_EQUAL:
                if (diff_text.length <= 2 * this.Patch_Margin && patchDiffLength && diffs.length != x + 1) {
                    // Small equality inside a patch.
                    patch.diffs[patchDiffLength++] = diffs[x];
                    patch.length1 += diff_text.length;
                    patch.length2 += diff_text.length;
                } else if (diff_text.length >= 2 * this.Patch_Margin) // Time for a new patch.
                {
                    if (patchDiffLength) {
                        this.patch_addContext_(patch, prepatch_text);
                        patches.push(patch);
                        patch = new $0f98e7c131f90f2d$var$diff_match_patch.patch_obj();
                        patchDiffLength = 0;
                        // Unlike Unidiff, our patch lists have a rolling context.
                        // https://github.com/google/diff-match-patch/wiki/Unidiff
                        // Update prepatch text & pos to reflect the application of the
                        // just completed patch.
                        prepatch_text = postpatch_text;
                        char_count1 = char_count2;
                    }
                }
                break;
        }
        // Update the current character count.
        if (diff_type !== $0f98e7c131f90f2d$var$DIFF_INSERT) char_count1 += diff_text.length;
        if (diff_type !== $0f98e7c131f90f2d$var$DIFF_DELETE) char_count2 += diff_text.length;
    }
    // Pick up the leftover patch if not empty.
    if (patchDiffLength) {
        this.patch_addContext_(patch, prepatch_text);
        patches.push(patch);
    }
    return patches;
};
/**
 * Given an array of patches, return another array that is identical.
 * @param {!Array.<!diff_match_patch.patch_obj>} patches Array of Patch objects.
 * @return {!Array.<!diff_match_patch.patch_obj>} Array of Patch objects.
 */ $0f98e7c131f90f2d$var$diff_match_patch.prototype.patch_deepCopy = function(patches) {
    // Making deep copies is hard in JavaScript.
    var patchesCopy = [];
    for(var x = 0; x < patches.length; x++){
        var patch = patches[x];
        var patchCopy = new $0f98e7c131f90f2d$var$diff_match_patch.patch_obj();
        patchCopy.diffs = [];
        for(var y = 0; y < patch.diffs.length; y++)patchCopy.diffs[y] = new $0f98e7c131f90f2d$var$diff_match_patch.Diff(patch.diffs[y][0], patch.diffs[y][1]);
        patchCopy.start1 = patch.start1;
        patchCopy.start2 = patch.start2;
        patchCopy.length1 = patch.length1;
        patchCopy.length2 = patch.length2;
        patchesCopy[x] = patchCopy;
    }
    return patchesCopy;
};
/**
 * Merge a set of patches onto the text.  Return a patched text, as well
 * as a list of true/false values indicating which patches were applied.
 * @param {!Array.<!diff_match_patch.patch_obj>} patches Array of Patch objects.
 * @param {string} text Old text.
 * @return {!Array.<string|!Array.<boolean>>} Two element Array, containing the
 *      new text and an array of boolean values.
 */ $0f98e7c131f90f2d$var$diff_match_patch.prototype.patch_apply = function(patches, text) {
    if (patches.length == 0) return [
        text,
        []
    ];
    // Deep copy the patches so that no changes are made to originals.
    patches = this.patch_deepCopy(patches);
    var nullPadding = this.patch_addPadding(patches);
    text = nullPadding + text + nullPadding;
    this.patch_splitMax(patches);
    // delta keeps track of the offset between the expected and actual location
    // of the previous patch.  If there are patches expected at positions 10 and
    // 20, but the first patch was found at 12, delta is 2 and the second patch
    // has an effective expected position of 22.
    var delta = 0;
    var results = [];
    for(var x = 0; x < patches.length; x++){
        var expected_loc = patches[x].start2 + delta;
        var text1 = this.diff_text1(patches[x].diffs);
        var start_loc;
        var end_loc = -1;
        if (text1.length > this.Match_MaxBits) {
            // patch_splitMax will only provide an oversized pattern in the case of
            // a monster delete.
            start_loc = this.match_main(text, text1.substring(0, this.Match_MaxBits), expected_loc);
            if (start_loc != -1) {
                end_loc = this.match_main(text, text1.substring(text1.length - this.Match_MaxBits), expected_loc + text1.length - this.Match_MaxBits);
                if (end_loc == -1 || start_loc >= end_loc) // Can't find valid trailing context.  Drop this patch.
                start_loc = -1;
            }
        } else start_loc = this.match_main(text, text1, expected_loc);
        if (start_loc == -1) {
            // No match found.  :(
            results[x] = false;
            // Subtract the delta for this failed patch from subsequent patches.
            delta -= patches[x].length2 - patches[x].length1;
        } else {
            // Found a match.  :)
            results[x] = true;
            delta = start_loc - expected_loc;
            var text2;
            if (end_loc == -1) text2 = text.substring(start_loc, start_loc + text1.length);
            else text2 = text.substring(start_loc, end_loc + this.Match_MaxBits);
            if (text1 == text2) // Perfect match, just shove the replacement text in.
            text = text.substring(0, start_loc) + this.diff_text2(patches[x].diffs) + text.substring(start_loc + text1.length);
            else {
                // Imperfect match.  Run a diff to get a framework of equivalent
                // indices.
                var diffs = this.diff_main(text1, text2, false);
                if (text1.length > this.Match_MaxBits && this.diff_levenshtein(diffs) / text1.length > this.Patch_DeleteThreshold) // The end points match, but the content is unacceptably bad.
                results[x] = false;
                else {
                    this.diff_cleanupSemanticLossless(diffs);
                    var index1 = 0;
                    var index2;
                    for(var y = 0; y < patches[x].diffs.length; y++){
                        var mod = patches[x].diffs[y];
                        if (mod[0] !== $0f98e7c131f90f2d$var$DIFF_EQUAL) index2 = this.diff_xIndex(diffs, index1);
                        if (mod[0] === $0f98e7c131f90f2d$var$DIFF_INSERT) text = text.substring(0, start_loc + index2) + mod[1] + text.substring(start_loc + index2);
                        else if (mod[0] === $0f98e7c131f90f2d$var$DIFF_DELETE) text = text.substring(0, start_loc + index2) + text.substring(start_loc + this.diff_xIndex(diffs, index1 + mod[1].length));
                        if (mod[0] !== $0f98e7c131f90f2d$var$DIFF_DELETE) index1 += mod[1].length;
                    }
                }
            }
        }
    }
    // Strip the padding off.
    text = text.substring(nullPadding.length, text.length - nullPadding.length);
    return [
        text,
        results
    ];
};
/**
 * Add some padding on text start and end so that edges can match something.
 * Intended to be called only from within patch_apply.
 * @param {!Array.<!diff_match_patch.patch_obj>} patches Array of Patch objects.
 * @return {string} The padding string added to each side.
 */ $0f98e7c131f90f2d$var$diff_match_patch.prototype.patch_addPadding = function(patches) {
    var paddingLength = this.Patch_Margin;
    var nullPadding = '';
    for(var x = 1; x <= paddingLength; x++)nullPadding += String.fromCharCode(x);
    // Bump all the patches forward.
    for(var x = 0; x < patches.length; x++){
        patches[x].start1 += paddingLength;
        patches[x].start2 += paddingLength;
    }
    // Add some padding on start of first diff.
    var patch = patches[0];
    var diffs = patch.diffs;
    if (diffs.length == 0 || diffs[0][0] != $0f98e7c131f90f2d$var$DIFF_EQUAL) {
        // Add nullPadding equality.
        diffs.unshift(new $0f98e7c131f90f2d$var$diff_match_patch.Diff($0f98e7c131f90f2d$var$DIFF_EQUAL, nullPadding));
        patch.start1 -= paddingLength; // Should be 0.
        patch.start2 -= paddingLength; // Should be 0.
        patch.length1 += paddingLength;
        patch.length2 += paddingLength;
    } else if (paddingLength > diffs[0][1].length) {
        // Grow first equality.
        var extraLength = paddingLength - diffs[0][1].length;
        diffs[0][1] = nullPadding.substring(diffs[0][1].length) + diffs[0][1];
        patch.start1 -= extraLength;
        patch.start2 -= extraLength;
        patch.length1 += extraLength;
        patch.length2 += extraLength;
    }
    // Add some padding on end of last diff.
    patch = patches[patches.length - 1];
    diffs = patch.diffs;
    if (diffs.length == 0 || diffs[diffs.length - 1][0] != $0f98e7c131f90f2d$var$DIFF_EQUAL) {
        // Add nullPadding equality.
        diffs.push(new $0f98e7c131f90f2d$var$diff_match_patch.Diff($0f98e7c131f90f2d$var$DIFF_EQUAL, nullPadding));
        patch.length1 += paddingLength;
        patch.length2 += paddingLength;
    } else if (paddingLength > diffs[diffs.length - 1][1].length) {
        // Grow last equality.
        var extraLength = paddingLength - diffs[diffs.length - 1][1].length;
        diffs[diffs.length - 1][1] += nullPadding.substring(0, extraLength);
        patch.length1 += extraLength;
        patch.length2 += extraLength;
    }
    return nullPadding;
};
/**
 * Look through the patches and break up any which are longer than the maximum
 * limit of the match algorithm.
 * Intended to be called only from within patch_apply.
 * @param {!Array.<!diff_match_patch.patch_obj>} patches Array of Patch objects.
 */ $0f98e7c131f90f2d$var$diff_match_patch.prototype.patch_splitMax = function(patches) {
    var patch_size = this.Match_MaxBits;
    for(var x = 0; x < patches.length; x++){
        if (patches[x].length1 <= patch_size) continue;
        var bigpatch = patches[x];
        // Remove the big old patch.
        patches.splice(x--, 1);
        var start1 = bigpatch.start1;
        var start2 = bigpatch.start2;
        var precontext = '';
        while(bigpatch.diffs.length !== 0){
            // Create one of several smaller patches.
            var patch = new $0f98e7c131f90f2d$var$diff_match_patch.patch_obj();
            var empty = true;
            patch.start1 = start1 - precontext.length;
            patch.start2 = start2 - precontext.length;
            if (precontext !== '') {
                patch.length1 = patch.length2 = precontext.length;
                patch.diffs.push(new $0f98e7c131f90f2d$var$diff_match_patch.Diff($0f98e7c131f90f2d$var$DIFF_EQUAL, precontext));
            }
            while(bigpatch.diffs.length !== 0 && patch.length1 < patch_size - this.Patch_Margin){
                var diff_type = bigpatch.diffs[0][0];
                var diff_text = bigpatch.diffs[0][1];
                if (diff_type === $0f98e7c131f90f2d$var$DIFF_INSERT) {
                    // Insertions are harmless.
                    patch.length2 += diff_text.length;
                    start2 += diff_text.length;
                    patch.diffs.push(bigpatch.diffs.shift());
                    empty = false;
                } else if (diff_type === $0f98e7c131f90f2d$var$DIFF_DELETE && patch.diffs.length == 1 && patch.diffs[0][0] == $0f98e7c131f90f2d$var$DIFF_EQUAL && diff_text.length > 2 * patch_size) {
                    // This is a large deletion.  Let it pass in one chunk.
                    patch.length1 += diff_text.length;
                    start1 += diff_text.length;
                    empty = false;
                    patch.diffs.push(new $0f98e7c131f90f2d$var$diff_match_patch.Diff(diff_type, diff_text));
                    bigpatch.diffs.shift();
                } else {
                    // Deletion or equality.  Only take as much as we can stomach.
                    diff_text = diff_text.substring(0, patch_size - patch.length1 - this.Patch_Margin);
                    patch.length1 += diff_text.length;
                    start1 += diff_text.length;
                    if (diff_type === $0f98e7c131f90f2d$var$DIFF_EQUAL) {
                        patch.length2 += diff_text.length;
                        start2 += diff_text.length;
                    } else empty = false;
                    patch.diffs.push(new $0f98e7c131f90f2d$var$diff_match_patch.Diff(diff_type, diff_text));
                    if (diff_text == bigpatch.diffs[0][1]) bigpatch.diffs.shift();
                    else bigpatch.diffs[0][1] = bigpatch.diffs[0][1].substring(diff_text.length);
                }
            }
            // Compute the head context for the next patch.
            precontext = this.diff_text2(patch.diffs);
            precontext = precontext.substring(precontext.length - this.Patch_Margin);
            // Append the end context for this patch.
            var postcontext = this.diff_text1(bigpatch.diffs).substring(0, this.Patch_Margin);
            if (postcontext !== '') {
                patch.length1 += postcontext.length;
                patch.length2 += postcontext.length;
                if (patch.diffs.length !== 0 && patch.diffs[patch.diffs.length - 1][0] === $0f98e7c131f90f2d$var$DIFF_EQUAL) patch.diffs[patch.diffs.length - 1][1] += postcontext;
                else patch.diffs.push(new $0f98e7c131f90f2d$var$diff_match_patch.Diff($0f98e7c131f90f2d$var$DIFF_EQUAL, postcontext));
            }
            if (!empty) patches.splice(++x, 0, patch);
        }
    }
};
/**
 * Take a list of patches and return a textual representation.
 * @param {!Array.<!diff_match_patch.patch_obj>} patches Array of Patch objects.
 * @return {string} Text representation of patches.
 */ $0f98e7c131f90f2d$var$diff_match_patch.prototype.patch_toText = function(patches) {
    var text = [];
    for(var x = 0; x < patches.length; x++)text[x] = patches[x];
    return text.join('');
};
/**
 * Parse a textual representation of patches and return a list of Patch objects.
 * @param {string} textline Text representation of patches.
 * @return {!Array.<!diff_match_patch.patch_obj>} Array of Patch objects.
 * @throws {!Error} If invalid input.
 */ $0f98e7c131f90f2d$var$diff_match_patch.prototype.patch_fromText = function(textline) {
    var patches = [];
    if (!textline) return patches;
    var text = textline.split('\n');
    var textPointer = 0;
    var patchHeader = /^@@ -(\d+),?(\d*) \+(\d+),?(\d*) @@$/;
    while(textPointer < text.length){
        var m = text[textPointer].match(patchHeader);
        if (!m) throw new Error('Invalid patch string: ' + text[textPointer]);
        var patch = new $0f98e7c131f90f2d$var$diff_match_patch.patch_obj();
        patches.push(patch);
        patch.start1 = parseInt(m[1], 10);
        if (m[2] === '') {
            patch.start1--;
            patch.length1 = 1;
        } else if (m[2] == '0') patch.length1 = 0;
        else {
            patch.start1--;
            patch.length1 = parseInt(m[2], 10);
        }
        patch.start2 = parseInt(m[3], 10);
        if (m[4] === '') {
            patch.start2--;
            patch.length2 = 1;
        } else if (m[4] == '0') patch.length2 = 0;
        else {
            patch.start2--;
            patch.length2 = parseInt(m[4], 10);
        }
        textPointer++;
        while(textPointer < text.length){
            var sign = text[textPointer].charAt(0);
            try {
                var line = decodeURI(text[textPointer].substring(1));
            } catch (ex) {
                // Malformed URI sequence.
                throw new Error('Illegal escape in patch_fromText: ' + line);
            }
            if (sign == '-') // Deletion.
            patch.diffs.push(new $0f98e7c131f90f2d$var$diff_match_patch.Diff($0f98e7c131f90f2d$var$DIFF_DELETE, line));
            else if (sign == '+') // Insertion.
            patch.diffs.push(new $0f98e7c131f90f2d$var$diff_match_patch.Diff($0f98e7c131f90f2d$var$DIFF_INSERT, line));
            else if (sign == ' ') // Minor equality.
            patch.diffs.push(new $0f98e7c131f90f2d$var$diff_match_patch.Diff($0f98e7c131f90f2d$var$DIFF_EQUAL, line));
            else if (sign == '@') break;
            else if (sign === '') ;
            else // WTF?
            throw new Error('Invalid patch mode "' + sign + '" in: ' + line);
            textPointer++;
        }
    }
    return patches;
};
/**
 * Class representing one patch operation.
 * @constructor
 */ $0f98e7c131f90f2d$var$diff_match_patch.patch_obj = function() {
    /** @type {!Array.<!diff_match_patch.Diff>} */ this.diffs = [];
    /** @type {?number} */ this.start1 = null;
    /** @type {?number} */ this.start2 = null;
    /** @type {number} */ this.length1 = 0;
    /** @type {number} */ this.length2 = 0;
};
/**
 * Emulate GNU diff's format.
 * Header: @@ -382,8 +481,9 @@
 * Indices are printed as 1-based, not 0-based.
 * @return {string} The GNU diff string.
 */ $0f98e7c131f90f2d$var$diff_match_patch.patch_obj.prototype.toString = function() {
    var coords1, coords2;
    if (this.length1 === 0) coords1 = this.start1 + ',0';
    else if (this.length1 == 1) coords1 = this.start1 + 1;
    else coords1 = this.start1 + 1 + ',' + this.length1;
    if (this.length2 === 0) coords2 = this.start2 + ',0';
    else if (this.length2 == 1) coords2 = this.start2 + 1;
    else coords2 = this.start2 + 1 + ',' + this.length2;
    var text = [
        '@@ -' + coords1 + ' +' + coords2 + ' @@\n'
    ];
    var op;
    // Escape the body of the patch with %xx notation.
    for(var x = 0; x < this.diffs.length; x++){
        switch(this.diffs[x][0]){
            case $0f98e7c131f90f2d$var$DIFF_INSERT:
                op = '+';
                break;
            case $0f98e7c131f90f2d$var$DIFF_DELETE:
                op = '-';
                break;
            case $0f98e7c131f90f2d$var$DIFF_EQUAL:
                op = ' ';
                break;
        }
        text[x + 1] = op + encodeURI(this.diffs[x][1]) + '\n';
    }
    return text.join('').replace(/%20/g, ' ');
};
// The following export code was added by @ForbesLindesay
module.exports = $0f98e7c131f90f2d$var$diff_match_patch;
module.exports['diff_match_patch'] = $0f98e7c131f90f2d$var$diff_match_patch;
module.exports['DIFF_DELETE'] = $0f98e7c131f90f2d$var$DIFF_DELETE;
module.exports['DIFF_INSERT'] = $0f98e7c131f90f2d$var$DIFF_INSERT;
module.exports['DIFF_EQUAL'] = $0f98e7c131f90f2d$var$DIFF_EQUAL;

});


parcelRegister("9Cv3p", function(module, exports) {
"use strict";

var $22oek = parcelRequire("22oek");
var $700fc0529e1d3e1b$require$forEach = $22oek.forEach;

var $iFLYC = parcelRequire("iFLYC");

var $45hTw = parcelRequire("45hTw");

var $azsC4 = parcelRequire("azsC4");

var $38D6K = parcelRequire("38D6K");

var $bmnQ4 = parcelRequire("bmnQ4");

var $9jxp4 = parcelRequire("9jxp4");

var $dQL4C = parcelRequire("dQL4C");

var $d5mMT = parcelRequire("d5mMT");

var $VSwUd = parcelRequire("VSwUd");

var $5P2oR = parcelRequire("5P2oR");
function $700fc0529e1d3e1b$var$isCollection(obj) {
    return Array.isArray(obj) || obj.length !== undefined;
}
function $700fc0529e1d3e1b$var$toArray(collection) {
    if (!Array.isArray(collection)) {
        var array = [];
        $700fc0529e1d3e1b$require$forEach(collection, function(obj) {
            array.push(obj);
        });
        return array;
    } else return collection;
}
function $700fc0529e1d3e1b$var$isElement(obj) {
    return obj && obj.nodeType === 1;
}
/**
 * @typedef idHandler
 * @type {object}
 * @property {function} get Gets the resize detector id of the element.
 * @property {function} set Generate and sets the resize detector id of the element.
 */ /**
 * @typedef Options
 * @type {object}
 * @property {boolean} callOnAdd    Determines if listeners should be called when they are getting added.
                                    Default is true. If true, the listener is guaranteed to be called when it has been added.
                                    If false, the listener will not be guarenteed to be called when it has been added (does not prevent it from being called).
 * @property {idHandler} idHandler  A custom id handler that is responsible for generating, setting and retrieving id's for elements.
                                    If not provided, a default id handler will be used.
 * @property {reporter} reporter    A custom reporter that handles reporting logs, warnings and errors.
                                    If not provided, a default id handler will be used.
                                    If set to false, then nothing will be reported.
 * @property {boolean} debug        If set to true, the the system will report debug messages as default for the listenTo method.
 */ /**
 * Creates an element resize detector instance.
 * @public
 * @param {Options?} options Optional global options object that will decide how this instance will work.
 */ module.exports = function(options) {
    options = options || {};
    //idHandler is currently not an option to the listenTo function, so it should not be added to globalOptions.
    var idHandler;
    if (options.idHandler) // To maintain compatability with idHandler.get(element, readonly), make sure to wrap the given idHandler
    // so that readonly flag always is true when it's used here. This may be removed next major version bump.
    idHandler = {
        get: function(element) {
            return options.idHandler.get(element, true);
        },
        set: options.idHandler.set
    };
    else {
        var idGenerator = $azsC4();
        var defaultIdHandler = $38D6K({
            idGenerator: idGenerator,
            stateHandler: $d5mMT
        });
        idHandler = defaultIdHandler;
    }
    //reporter is currently not an option to the listenTo function, so it should not be added to globalOptions.
    var reporter = options.reporter;
    if (!reporter) {
        //If options.reporter is false, then the reporter should be quiet.
        var quiet = reporter === false;
        reporter = $bmnQ4(quiet);
    }
    //batchProcessor is currently not an option to the listenTo function, so it should not be added to globalOptions.
    var batchProcessor = $700fc0529e1d3e1b$var$getOption(options, "batchProcessor", $dQL4C({
        reporter: reporter
    }));
    //Options to be used as default for the listenTo function.
    var globalOptions = {};
    globalOptions.callOnAdd = !!$700fc0529e1d3e1b$var$getOption(options, "callOnAdd", true);
    globalOptions.debug = !!$700fc0529e1d3e1b$var$getOption(options, "debug", false);
    var eventListenerHandler = $45hTw(idHandler);
    var elementUtils = $iFLYC({
        stateHandler: $d5mMT
    });
    //The detection strategy to be used.
    var detectionStrategy;
    var desiredStrategy = $700fc0529e1d3e1b$var$getOption(options, "strategy", "object");
    var importantCssRules = $700fc0529e1d3e1b$var$getOption(options, "important", false);
    var strategyOptions = {
        reporter: reporter,
        batchProcessor: batchProcessor,
        stateHandler: $d5mMT,
        idHandler: idHandler,
        important: importantCssRules
    };
    if (desiredStrategy === "scroll") {
        if ($9jxp4.isLegacyOpera()) {
            reporter.warn("Scroll strategy is not supported on legacy Opera. Changing to object strategy.");
            desiredStrategy = "object";
        } else if ($9jxp4.isIE(9)) {
            reporter.warn("Scroll strategy is not supported on IE9. Changing to object strategy.");
            desiredStrategy = "object";
        }
    }
    if (desiredStrategy === "scroll") detectionStrategy = $5P2oR(strategyOptions);
    else if (desiredStrategy === "object") detectionStrategy = $VSwUd(strategyOptions);
    else throw new Error("Invalid strategy name: " + desiredStrategy);
    //Calls can be made to listenTo with elements that are still being installed.
    //Also, same elements can occur in the elements list in the listenTo function.
    //With this map, the ready callbacks can be synchronized between the calls
    //so that the ready callback can always be called when an element is ready - even if
    //it wasn't installed from the function itself.
    var onReadyCallbacks = {};
    /**
     * Makes the given elements resize-detectable and starts listening to resize events on the elements. Calls the event callback for each event for each element.
     * @public
     * @param {Options?} options Optional options object. These options will override the global options. Some options may not be overriden, such as idHandler.
     * @param {element[]|element} elements The given array of elements to detect resize events of. Single element is also valid.
     * @param {function} listener The callback to be executed for each resize event for each element.
     */ function listenTo(options, elements, listener) {
        function onResizeCallback(element) {
            var listeners = eventListenerHandler.get(element);
            $700fc0529e1d3e1b$require$forEach(listeners, function callListenerProxy(listener) {
                listener(element);
            });
        }
        function addListener(callOnAdd, element, listener) {
            eventListenerHandler.add(element, listener);
            if (callOnAdd) listener(element);
        }
        //Options object may be omitted.
        if (!listener) {
            listener = elements;
            elements = options;
            options = {};
        }
        if (!elements) throw new Error("At least one element required.");
        if (!listener) throw new Error("Listener required.");
        if ($700fc0529e1d3e1b$var$isElement(elements)) // A single element has been passed in.
        elements = [
            elements
        ];
        else if ($700fc0529e1d3e1b$var$isCollection(elements)) // Convert collection to array for plugins.
        // TODO: May want to check so that all the elements in the collection are valid elements.
        elements = $700fc0529e1d3e1b$var$toArray(elements);
        else return reporter.error("Invalid arguments. Must be a DOM element or a collection of DOM elements.");
        var elementsReady = 0;
        var callOnAdd = $700fc0529e1d3e1b$var$getOption(options, "callOnAdd", globalOptions.callOnAdd);
        var onReadyCallback = $700fc0529e1d3e1b$var$getOption(options, "onReady", function noop() {});
        var debug = $700fc0529e1d3e1b$var$getOption(options, "debug", globalOptions.debug);
        $700fc0529e1d3e1b$require$forEach(elements, function attachListenerToElement(element) {
            if (!$d5mMT.getState(element)) {
                $d5mMT.initState(element);
                idHandler.set(element);
            }
            var id = idHandler.get(element);
            debug && reporter.log("Attaching listener to element", id, element);
            if (!elementUtils.isDetectable(element)) {
                debug && reporter.log(id, "Not detectable.");
                if (elementUtils.isBusy(element)) {
                    debug && reporter.log(id, "System busy making it detectable");
                    //The element is being prepared to be detectable. Do not make it detectable.
                    //Just add the listener, because the element will soon be detectable.
                    addListener(callOnAdd, element, listener);
                    onReadyCallbacks[id] = onReadyCallbacks[id] || [];
                    onReadyCallbacks[id].push(function onReady() {
                        elementsReady++;
                        if (elementsReady === elements.length) onReadyCallback();
                    });
                    return;
                }
                debug && reporter.log(id, "Making detectable...");
                //The element is not prepared to be detectable, so do prepare it and add a listener to it.
                elementUtils.markBusy(element, true);
                return detectionStrategy.makeDetectable({
                    debug: debug,
                    important: importantCssRules
                }, element, function onElementDetectable(element) {
                    debug && reporter.log(id, "onElementDetectable");
                    if ($d5mMT.getState(element)) {
                        elementUtils.markAsDetectable(element);
                        elementUtils.markBusy(element, false);
                        detectionStrategy.addListener(element, onResizeCallback);
                        addListener(callOnAdd, element, listener);
                        // Since the element size might have changed since the call to "listenTo", we need to check for this change,
                        // so that a resize event may be emitted.
                        // Having the startSize object is optional (since it does not make sense in some cases such as unrendered elements), so check for its existance before.
                        // Also, check the state existance before since the element may have been uninstalled in the installation process.
                        var state = $d5mMT.getState(element);
                        if (state && state.startSize) {
                            var width = element.offsetWidth;
                            var height = element.offsetHeight;
                            if (state.startSize.width !== width || state.startSize.height !== height) onResizeCallback(element);
                        }
                        if (onReadyCallbacks[id]) $700fc0529e1d3e1b$require$forEach(onReadyCallbacks[id], function(callback) {
                            callback();
                        });
                    } else // The element has been unisntalled before being detectable.
                    debug && reporter.log(id, "Element uninstalled before being detectable.");
                    delete onReadyCallbacks[id];
                    elementsReady++;
                    if (elementsReady === elements.length) onReadyCallback();
                });
            }
            debug && reporter.log(id, "Already detecable, adding listener.");
            //The element has been prepared to be detectable and is ready to be listened to.
            addListener(callOnAdd, element, listener);
            elementsReady++;
        });
        if (elementsReady === elements.length) onReadyCallback();
    }
    function uninstall(elements) {
        if (!elements) return reporter.error("At least one element is required.");
        if ($700fc0529e1d3e1b$var$isElement(elements)) // A single element has been passed in.
        elements = [
            elements
        ];
        else if ($700fc0529e1d3e1b$var$isCollection(elements)) // Convert collection to array for plugins.
        // TODO: May want to check so that all the elements in the collection are valid elements.
        elements = $700fc0529e1d3e1b$var$toArray(elements);
        else return reporter.error("Invalid arguments. Must be a DOM element or a collection of DOM elements.");
        $700fc0529e1d3e1b$require$forEach(elements, function(element) {
            eventListenerHandler.removeAllListeners(element);
            detectionStrategy.uninstall(element);
            $d5mMT.cleanState(element);
        });
    }
    function initDocument(targetDocument) {
        detectionStrategy.initDocument && detectionStrategy.initDocument(targetDocument);
    }
    return {
        listenTo: listenTo,
        removeListener: eventListenerHandler.removeListener,
        removeAllListeners: eventListenerHandler.removeAllListeners,
        uninstall: uninstall,
        initDocument: initDocument
    };
};
function $700fc0529e1d3e1b$var$getOption(options, name, defaultValue) {
    var value = options[name];
    if ((value === undefined || value === null) && defaultValue !== undefined) return defaultValue;
    return value;
}

});
parcelRegister("22oek", function(module, exports) {
"use strict";
var $17be9043b658ac70$var$utils = module.exports = {};
/**
 * Loops through the collection and calls the callback for each element. if the callback returns truthy, the loop is broken and returns the same value.
 * @public
 * @param {*} collection The collection to loop through. Needs to have a length property set and have indices set from 0 to length - 1.
 * @param {function} callback The callback to be called for each element. The element will be given as a parameter to the callback. If this callback returns truthy, the loop is broken and the same value is returned.
 * @returns {*} The value that a callback has returned (if truthy). Otherwise nothing.
 */ $17be9043b658ac70$var$utils.forEach = function(collection, callback) {
    for(var i = 0; i < collection.length; i++){
        var result = callback(collection[i]);
        if (result) return result;
    }
};

});

parcelRegister("iFLYC", function(module, exports) {
"use strict";
module.exports = function(options) {
    var getState = options.stateHandler.getState;
    /**
     * Tells if the element has been made detectable and ready to be listened for resize events.
     * @public
     * @param {element} The element to check.
     * @returns {boolean} True or false depending on if the element is detectable or not.
     */ function isDetectable(element) {
        var state = getState(element);
        return state && !!state.isDetectable;
    }
    /**
     * Marks the element that it has been made detectable and ready to be listened for resize events.
     * @public
     * @param {element} The element to mark.
     */ function markAsDetectable(element) {
        getState(element).isDetectable = true;
    }
    /**
     * Tells if the element is busy or not.
     * @public
     * @param {element} The element to check.
     * @returns {boolean} True or false depending on if the element is busy or not.
     */ function isBusy(element) {
        return !!getState(element).busy;
    }
    /**
     * Marks the object is busy and should not be made detectable.
     * @public
     * @param {element} element The element to mark.
     * @param {boolean} busy If the element is busy or not.
     */ function markBusy(element, busy) {
        getState(element).busy = !!busy;
    }
    return {
        isDetectable: isDetectable,
        markAsDetectable: markAsDetectable,
        isBusy: isBusy,
        markBusy: markBusy
    };
};

});

parcelRegister("45hTw", function(module, exports) {
"use strict";
module.exports = function(idHandler) {
    var eventListeners = {};
    /**
     * Gets all listeners for the given element.
     * @public
     * @param {element} element The element to get all listeners for.
     * @returns All listeners for the given element.
     */ function getListeners(element) {
        var id = idHandler.get(element);
        if (id === undefined) return [];
        return eventListeners[id] || [];
    }
    /**
     * Stores the given listener for the given element. Will not actually add the listener to the element.
     * @public
     * @param {element} element The element that should have the listener added.
     * @param {function} listener The callback that the element has added.
     */ function addListener(element, listener) {
        var id = idHandler.get(element);
        if (!eventListeners[id]) eventListeners[id] = [];
        eventListeners[id].push(listener);
    }
    function removeListener(element, listener) {
        var listeners = getListeners(element);
        for(var i = 0, len = listeners.length; i < len; ++i)if (listeners[i] === listener) {
            listeners.splice(i, 1);
            break;
        }
    }
    function removeAllListeners(element) {
        var listeners = getListeners(element);
        if (!listeners) return;
        listeners.length = 0;
    }
    return {
        get: getListeners,
        add: addListener,
        removeListener: removeListener,
        removeAllListeners: removeAllListeners
    };
};

});

parcelRegister("azsC4", function(module, exports) {
"use strict";
module.exports = function() {
    var idCount = 1;
    /**
     * Generates a new unique id in the context.
     * @public
     * @returns {number} A unique id in the context.
     */ function generate() {
        return idCount++;
    }
    return {
        generate: generate
    };
};

});

parcelRegister("38D6K", function(module, exports) {
"use strict";
module.exports = function(options) {
    var idGenerator = options.idGenerator;
    var getState = options.stateHandler.getState;
    /**
     * Gets the resize detector id of the element.
     * @public
     * @param {element} element The target element to get the id of.
     * @returns {string|number|null} The id of the element. Null if it has no id.
     */ function getId(element) {
        var state = getState(element);
        if (state && state.id !== undefined) return state.id;
        return null;
    }
    /**
     * Sets the resize detector id of the element. Requires the element to have a resize detector state initialized.
     * @public
     * @param {element} element The target element to set the id of.
     * @returns {string|number|null} The id of the element.
     */ function setId(element) {
        var state = getState(element);
        if (!state) throw new Error("setId required the element to have a resize detection state.");
        var id = idGenerator.generate();
        state.id = id;
        return id;
    }
    return {
        get: getId,
        set: setId
    };
};

});

parcelRegister("bmnQ4", function(module, exports) {
"use strict";
/* global console: false */ /**
 * Reporter that handles the reporting of logs, warnings and errors.
 * @public
 * @param {boolean} quiet Tells if the reporter should be quiet or not.
 */ module.exports = function(quiet) {
    function noop() {
    //Does nothing.
    }
    var reporter = {
        log: noop,
        warn: noop,
        error: noop
    };
    if (!quiet && window.console) {
        var attachFunction = function(reporter, name) {
            //The proxy is needed to be able to call the method with the console context,
            //since we cannot use bind.
            reporter[name] = function reporterProxy() {
                var f = console[name];
                if (f.apply) f.apply(console, arguments);
                else for(var i = 0; i < arguments.length; i++)f(arguments[i]);
            };
        };
        attachFunction(reporter, "log");
        attachFunction(reporter, "warn");
        attachFunction(reporter, "error");
    }
    return reporter;
};

});

parcelRegister("9jxp4", function(module, exports) {
"use strict";
var $6c7fcc9e3d98c586$var$detector = module.exports = {};
$6c7fcc9e3d98c586$var$detector.isIE = function(version) {
    function isAnyIeVersion() {
        var agent = navigator.userAgent.toLowerCase();
        return agent.indexOf("msie") !== -1 || agent.indexOf("trident") !== -1 || agent.indexOf(" edge/") !== -1;
    }
    if (!isAnyIeVersion()) return false;
    if (!version) return true;
    //Shamelessly stolen from https://gist.github.com/padolsey/527683
    var ieVersion = function() {
        var undef, v = 3, div = document.createElement("div"), all = div.getElementsByTagName("i");
        do div.innerHTML = "<!--[if gt IE " + ++v + "]><i></i><![endif]-->";
        while (all[0]);
        return v > 4 ? v : undef;
    }();
    return version === ieVersion;
};
$6c7fcc9e3d98c586$var$detector.isLegacyOpera = function() {
    return !!window.opera;
};

});

parcelRegister("dQL4C", function(module, exports) {
"use strict";

var $5Ec7w = parcelRequire("5Ec7w");
module.exports = function batchProcessorMaker(options) {
    options = options || {};
    var reporter = options.reporter;
    var asyncProcess = $5Ec7w.getOption(options, "async", true);
    var autoProcess = $5Ec7w.getOption(options, "auto", true);
    if (autoProcess && !asyncProcess) {
        reporter && reporter.warn("Invalid options combination. auto=true and async=false is invalid. Setting async=true.");
        asyncProcess = true;
    }
    var batch = $a154a5828a6b405c$var$Batch();
    var asyncFrameHandler;
    var isProcessing = false;
    function addFunction(level, fn) {
        if (!isProcessing && autoProcess && asyncProcess && batch.size() === 0) // Since this is async, it is guaranteed to be executed after that the fn is added to the batch.
        // This needs to be done before, since we're checking the size of the batch to be 0.
        processBatchAsync();
        batch.add(level, fn);
    }
    function processBatch() {
        // Save the current batch, and create a new batch so that incoming functions are not added into the currently processing batch.
        // Continue processing until the top-level batch is empty (functions may be added to the new batch while processing, and so on).
        isProcessing = true;
        while(batch.size()){
            var processingBatch = batch;
            batch = $a154a5828a6b405c$var$Batch();
            processingBatch.process();
        }
        isProcessing = false;
    }
    function forceProcessBatch(localAsyncProcess) {
        if (isProcessing) return;
        if (localAsyncProcess === undefined) localAsyncProcess = asyncProcess;
        if (asyncFrameHandler) {
            cancelFrame(asyncFrameHandler);
            asyncFrameHandler = null;
        }
        if (localAsyncProcess) processBatchAsync();
        else processBatch();
    }
    function processBatchAsync() {
        asyncFrameHandler = requestFrame(processBatch);
    }
    function clearBatch() {
        batch = {};
        batchSize = 0;
        topLevel = 0;
        bottomLevel = 0;
    }
    function cancelFrame(listener) {
        // var cancel = window.cancelAnimationFrame || window.mozCancelAnimationFrame || window.webkitCancelAnimationFrame || window.clearTimeout;
        var cancel = clearTimeout;
        return cancel(listener);
    }
    function requestFrame(callback) {
        // var raf = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || function(fn) { return window.setTimeout(fn, 20); };
        var raf = function(fn) {
            return setTimeout(fn, 0);
        };
        return raf(callback);
    }
    return {
        add: addFunction,
        force: forceProcessBatch
    };
};
function $a154a5828a6b405c$var$Batch() {
    var batch = {};
    var size = 0;
    var topLevel1 = 0;
    var bottomLevel1 = 0;
    function add(level, fn) {
        if (!fn) {
            fn = level;
            level = 0;
        }
        if (level > topLevel1) topLevel1 = level;
        else if (level < bottomLevel1) bottomLevel1 = level;
        if (!batch[level]) batch[level] = [];
        batch[level].push(fn);
        size++;
    }
    function process() {
        for(var level = bottomLevel1; level <= topLevel1; level++){
            var fns = batch[level];
            for(var i = 0; i < fns.length; i++){
                var fn = fns[i];
                fn();
            }
        }
    }
    function getSize() {
        return size;
    }
    return {
        add: add,
        process: process,
        size: getSize
    };
}

});
parcelRegister("5Ec7w", function(module, exports) {
"use strict";
var $41ca17078b63410c$var$utils = module.exports = {};
$41ca17078b63410c$var$utils.getOption = $41ca17078b63410c$var$getOption;
function $41ca17078b63410c$var$getOption(options, name, defaultValue) {
    var value = options[name];
    if ((value === undefined || value === null) && defaultValue !== undefined) return defaultValue;
    return value;
}

});


parcelRegister("d5mMT", function(module, exports) {
"use strict";
var $986d6b223cfdd0c2$var$prop = "_erd";
function $986d6b223cfdd0c2$var$initState(element) {
    element[$986d6b223cfdd0c2$var$prop] = {};
    return $986d6b223cfdd0c2$var$getState(element);
}
function $986d6b223cfdd0c2$var$getState(element) {
    return element[$986d6b223cfdd0c2$var$prop];
}
function $986d6b223cfdd0c2$var$cleanState(element) {
    delete element[$986d6b223cfdd0c2$var$prop];
}
module.exports = {
    initState: $986d6b223cfdd0c2$var$initState,
    getState: $986d6b223cfdd0c2$var$getState,
    cleanState: $986d6b223cfdd0c2$var$cleanState
};

});

parcelRegister("VSwUd", function(module, exports) {
/**
 * Resize detection strategy that injects objects to elements in order to detect resize events.
 * Heavily inspired by: http://www.backalleycoder.com/2013/03/18/cross-browser-event-based-element-resize-detection/
 */ "use strict";

var $9jxp4 = parcelRequire("9jxp4");
module.exports = function(options) {
    options = options || {};
    var reporter = options.reporter;
    var batchProcessor = options.batchProcessor;
    var getState = options.stateHandler.getState;
    if (!reporter) throw new Error("Missing required dependency: reporter.");
    /**
     * Adds a resize event listener to the element.
     * @public
     * @param {element} element The element that should have the listener added.
     * @param {function} listener The listener callback to be called for each resize event of the element. The element will be given as a parameter to the listener callback.
     */ function addListener(element, listener) {
        function listenerProxy() {
            listener(element);
        }
        if ($9jxp4.isIE(8)) {
            //IE 8 does not support object, but supports the resize event directly on elements.
            getState(element).object = {
                proxy: listenerProxy
            };
            element.attachEvent("onresize", listenerProxy);
        } else {
            var object = getObject(element);
            if (!object) throw new Error("Element is not detectable by this strategy.");
            object.contentDocument.defaultView.addEventListener("resize", listenerProxy);
        }
    }
    function buildCssTextString(rules) {
        var seperator = options.important ? " !important; " : "; ";
        return (rules.join(seperator) + seperator).trim();
    }
    /**
     * Makes an element detectable and ready to be listened for resize events. Will call the callback when the element is ready to be listened for resize changes.
     * @private
     * @param {object} options Optional options object.
     * @param {element} element The element to make detectable
     * @param {function} callback The callback to be called when the element is ready to be listened for resize changes. Will be called with the element as first parameter.
     */ function makeDetectable(options, element, callback) {
        if (!callback) {
            callback = element;
            element = options;
            options = null;
        }
        options = options || {};
        var debug = options.debug;
        function injectObject(element, callback) {
            var OBJECT_STYLE = buildCssTextString([
                "display: block",
                "position: absolute",
                "top: 0",
                "left: 0",
                "width: 100%",
                "height: 100%",
                "border: none",
                "padding: 0",
                "margin: 0",
                "opacity: 0",
                "z-index: -1000",
                "pointer-events: none"
            ]);
            //The target element needs to be positioned (everything except static) so the absolute positioned object will be positioned relative to the target element.
            // Position altering may be performed directly or on object load, depending on if style resolution is possible directly or not.
            var positionCheckPerformed = false;
            // The element may not yet be attached to the DOM, and therefore the style object may be empty in some browsers.
            // Since the style object is a reference, it will be updated as soon as the element is attached to the DOM.
            var style = window.getComputedStyle(element);
            var width = element.offsetWidth;
            var height = element.offsetHeight;
            getState(element).startSize = {
                width: width,
                height: height
            };
            function mutateDom() {
                function alterPositionStyles() {
                    if (style.position === "static") {
                        element.style.setProperty("position", "relative", options.important ? "important" : "");
                        var removeRelativeStyles = function(reporter, element, style, property) {
                            function getNumericalValue(value) {
                                return value.replace(/[^-\d\.]/g, "");
                            }
                            var value = style[property];
                            if (value !== "auto" && getNumericalValue(value) !== "0") {
                                reporter.warn("An element that is positioned static has style." + property + "=" + value + " which is ignored due to the static positioning. The element will need to be positioned relative, so the style." + property + " will be set to 0. Element: ", element);
                                element.style.setProperty(property, "0", options.important ? "important" : "");
                            }
                        };
                        //Check so that there are no accidental styles that will make the element styled differently now that is is relative.
                        //If there are any, set them to 0 (this should be okay with the user since the style properties did nothing before [since the element was positioned static] anyway).
                        removeRelativeStyles(reporter, element, style, "top");
                        removeRelativeStyles(reporter, element, style, "right");
                        removeRelativeStyles(reporter, element, style, "bottom");
                        removeRelativeStyles(reporter, element, style, "left");
                    }
                }
                function onObjectLoad() {
                    // The object has been loaded, which means that the element now is guaranteed to be attached to the DOM.
                    if (!positionCheckPerformed) alterPositionStyles();
                    /*jshint validthis: true */ function getDocument(element, callback) {
                        //Opera 12 seem to call the object.onload before the actual document has been created.
                        //So if it is not present, poll it with an timeout until it is present.
                        //TODO: Could maybe be handled better with object.onreadystatechange or similar.
                        if (!element.contentDocument) {
                            var state = getState(element);
                            if (state.checkForObjectDocumentTimeoutId) window.clearTimeout(state.checkForObjectDocumentTimeoutId);
                            state.checkForObjectDocumentTimeoutId = setTimeout(function checkForObjectDocument() {
                                state.checkForObjectDocumentTimeoutId = 0;
                                getDocument(element, callback);
                            }, 100);
                            return;
                        }
                        callback(element.contentDocument);
                    }
                    //Mutating the object element here seems to fire another load event.
                    //Mutating the inner document of the object element is fine though.
                    var objectElement = this;
                    //Create the style element to be added to the object.
                    getDocument(objectElement, function onObjectDocumentReady(objectDocument) {
                        //Notify that the element is ready to be listened to.
                        callback(element);
                    });
                }
                // The element may be detached from the DOM, and some browsers does not support style resolving of detached elements.
                // The alterPositionStyles needs to be delayed until we know the element has been attached to the DOM (which we are sure of when the onObjectLoad has been fired), if style resolution is not possible.
                if (style.position !== "") {
                    alterPositionStyles(style);
                    positionCheckPerformed = true;
                }
                //Add an object element as a child to the target element that will be listened to for resize events.
                var object = document.createElement("object");
                object.style.cssText = OBJECT_STYLE;
                object.tabIndex = -1;
                object.type = "text/html";
                object.setAttribute("aria-hidden", "true");
                object.onload = onObjectLoad;
                //Safari: This must occur before adding the object to the DOM.
                //IE: Does not like that this happens before, even if it is also added after.
                if (!$9jxp4.isIE()) object.data = "about:blank";
                if (!getState(element)) // The element has been uninstalled before the actual loading happened.
                return;
                element.appendChild(object);
                getState(element).object = object;
                //IE: This must occur after adding the object to the DOM.
                if ($9jxp4.isIE()) object.data = "about:blank";
            }
            if (batchProcessor) batchProcessor.add(mutateDom);
            else mutateDom();
        }
        if ($9jxp4.isIE(8)) //IE 8 does not support objects properly. Luckily they do support the resize event.
        //So do not inject the object and notify that the element is already ready to be listened to.
        //The event handler for the resize event is attached in the utils.addListener instead.
        callback(element);
        else injectObject(element, callback);
    }
    /**
     * Returns the child object of the target element.
     * @private
     * @param {element} element The target element.
     * @returns The object element of the target.
     */ function getObject(element) {
        return getState(element).object;
    }
    function uninstall(element) {
        if (!getState(element)) return;
        var object = getObject(element);
        if (!object) return;
        if ($9jxp4.isIE(8)) element.detachEvent("onresize", object.proxy);
        else element.removeChild(object);
        if (getState(element).checkForObjectDocumentTimeoutId) window.clearTimeout(getState(element).checkForObjectDocumentTimeoutId);
        delete getState(element).object;
    }
    return {
        makeDetectable: makeDetectable,
        addListener: addListener,
        uninstall: uninstall
    };
};

});

parcelRegister("5P2oR", function(module, exports) {
/**
 * Resize detection strategy that injects divs to elements in order to detect resize events on scroll events.
 * Heavily inspired by: https://github.com/marcj/css-element-queries/blob/master/src/ResizeSensor.js
 */ "use strict";

var $22oek = parcelRequire("22oek");
var $43d393c1379be643$require$forEach = $22oek.forEach;
module.exports = function(options) {
    options = options || {};
    var reporter = options.reporter;
    var batchProcessor = options.batchProcessor;
    var getState = options.stateHandler.getState;
    var hasState = options.stateHandler.hasState;
    var idHandler = options.idHandler;
    if (!batchProcessor) throw new Error("Missing required dependency: batchProcessor");
    if (!reporter) throw new Error("Missing required dependency: reporter.");
    //TODO: Could this perhaps be done at installation time?
    var scrollbarSizes = getScrollbarSizes();
    var styleId = "erd_scroll_detection_scrollbar_style";
    var detectionContainerClass = "erd_scroll_detection_container";
    function initDocument(targetDocument) {
        // Inject the scrollbar styling that prevents them from appearing sometimes in Chrome.
        // The injected container needs to have a class, so that it may be styled with CSS (pseudo elements).
        injectScrollStyle(targetDocument, styleId, detectionContainerClass);
    }
    initDocument(window.document);
    function buildCssTextString(rules) {
        var seperator = options.important ? " !important; " : "; ";
        return (rules.join(seperator) + seperator).trim();
    }
    function getScrollbarSizes() {
        var width = 500;
        var height = 500;
        var child = document.createElement("div");
        child.style.cssText = buildCssTextString([
            "position: absolute",
            "width: " + width * 2 + "px",
            "height: " + height * 2 + "px",
            "visibility: hidden",
            "margin: 0",
            "padding: 0"
        ]);
        var container = document.createElement("div");
        container.style.cssText = buildCssTextString([
            "position: absolute",
            "width: " + width + "px",
            "height: " + height + "px",
            "overflow: scroll",
            "visibility: none",
            "top: " + -width * 3 + "px",
            "left: " + -height * 3 + "px",
            "visibility: hidden",
            "margin: 0",
            "padding: 0"
        ]);
        container.appendChild(child);
        document.body.insertBefore(container, document.body.firstChild);
        var widthSize = width - container.clientWidth;
        var heightSize = height - container.clientHeight;
        document.body.removeChild(container);
        return {
            width: widthSize,
            height: heightSize
        };
    }
    function injectScrollStyle(targetDocument, styleId, containerClass) {
        function injectStyle(style, method) {
            method = method || function(element) {
                targetDocument.head.appendChild(element);
            };
            var styleElement = targetDocument.createElement("style");
            styleElement.innerHTML = style;
            styleElement.id = styleId;
            method(styleElement);
            return styleElement;
        }
        if (!targetDocument.getElementById(styleId)) {
            var containerAnimationClass = containerClass + "_animation";
            var containerAnimationActiveClass = containerClass + "_animation_active";
            var style = "/* Created by the element-resize-detector library. */\n";
            style += "." + containerClass + " > div::-webkit-scrollbar { " + buildCssTextString([
                "display: none"
            ]) + " }\n\n";
            style += "." + containerAnimationActiveClass + " { " + buildCssTextString([
                "-webkit-animation-duration: 0.1s",
                "animation-duration: 0.1s",
                "-webkit-animation-name: " + containerAnimationClass,
                "animation-name: " + containerAnimationClass
            ]) + " }\n";
            style += "@-webkit-keyframes " + containerAnimationClass + " { 0% { opacity: 1; } 50% { opacity: 0; } 100% { opacity: 1; } }\n";
            style += "@keyframes " + containerAnimationClass + " { 0% { opacity: 1; } 50% { opacity: 0; } 100% { opacity: 1; } }";
            injectStyle(style);
        }
    }
    function addAnimationClass(element) {
        element.className += " " + detectionContainerClass + "_animation_active";
    }
    function addEvent(el, name, cb) {
        if (el.addEventListener) el.addEventListener(name, cb);
        else if (el.attachEvent) el.attachEvent("on" + name, cb);
        else return reporter.error("[scroll] Don't know how to add event listeners.");
    }
    function removeEvent(el, name, cb) {
        if (el.removeEventListener) el.removeEventListener(name, cb);
        else if (el.detachEvent) el.detachEvent("on" + name, cb);
        else return reporter.error("[scroll] Don't know how to remove event listeners.");
    }
    function getExpandElement(element) {
        return getState(element).container.childNodes[0].childNodes[0].childNodes[0];
    }
    function getShrinkElement(element) {
        return getState(element).container.childNodes[0].childNodes[0].childNodes[1];
    }
    /**
     * Adds a resize event listener to the element.
     * @public
     * @param {element} element The element that should have the listener added.
     * @param {function} listener The listener callback to be called for each resize event of the element. The element will be given as a parameter to the listener callback.
     */ function addListener(element, listener) {
        var listeners = getState(element).listeners;
        if (!listeners.push) throw new Error("Cannot add listener to an element that is not detectable.");
        getState(element).listeners.push(listener);
    }
    /**
     * Makes an element detectable and ready to be listened for resize events. Will call the callback when the element is ready to be listened for resize changes.
     * @private
     * @param {object} options Optional options object.
     * @param {element} element The element to make detectable
     * @param {function} callback The callback to be called when the element is ready to be listened for resize changes. Will be called with the element as first parameter.
     */ function makeDetectable(options, element, callback) {
        if (!callback) {
            callback = element;
            element = options;
            options = null;
        }
        options = options || {};
        function debug() {
            if (options.debug) {
                var args = Array.prototype.slice.call(arguments);
                args.unshift(idHandler.get(element), "Scroll: ");
                if (reporter.log.apply) reporter.log.apply(null, args);
                else for(var i = 0; i < args.length; i++)reporter.log(args[i]);
            }
        }
        function isDetached(element) {
            function isInDocument(element) {
                var isInShadowRoot = element.getRootNode && element.getRootNode().contains(element);
                return element === element.ownerDocument.body || element.ownerDocument.body.contains(element) || isInShadowRoot;
            }
            if (!isInDocument(element)) return true;
            // FireFox returns null style in hidden iframes. See https://github.com/wnr/element-resize-detector/issues/68 and https://bugzilla.mozilla.org/show_bug.cgi?id=795520
            if (window.getComputedStyle(element) === null) return true;
            return false;
        }
        function isUnrendered(element) {
            // Check the absolute positioned container since the top level container is display: inline.
            var container = getState(element).container.childNodes[0];
            var style = window.getComputedStyle(container);
            return !style.width || style.width.indexOf("px") === -1; //Can only compute pixel value when rendered.
        }
        function getStyle() {
            // Some browsers only force layouts when actually reading the style properties of the style object, so make sure that they are all read here,
            // so that the user of the function can be sure that it will perform the layout here, instead of later (important for batching).
            var elementStyle = window.getComputedStyle(element);
            var style = {};
            style.position = elementStyle.position;
            style.width = element.offsetWidth;
            style.height = element.offsetHeight;
            style.top = elementStyle.top;
            style.right = elementStyle.right;
            style.bottom = elementStyle.bottom;
            style.left = elementStyle.left;
            style.widthCSS = elementStyle.width;
            style.heightCSS = elementStyle.height;
            return style;
        }
        function storeStartSize() {
            var style = getStyle();
            getState(element).startSize = {
                width: style.width,
                height: style.height
            };
            debug("Element start size", getState(element).startSize);
        }
        function initListeners() {
            getState(element).listeners = [];
        }
        function storeStyle() {
            debug("storeStyle invoked.");
            if (!getState(element)) {
                debug("Aborting because element has been uninstalled");
                return;
            }
            var style = getStyle();
            getState(element).style = style;
        }
        function storeCurrentSize(element, width, height) {
            getState(element).lastWidth = width;
            getState(element).lastHeight = height;
        }
        function getExpandChildElement(element) {
            return getExpandElement(element).childNodes[0];
        }
        function getWidthOffset() {
            return 2 * scrollbarSizes.width + 1;
        }
        function getHeightOffset() {
            return 2 * scrollbarSizes.height + 1;
        }
        function getExpandWidth(width) {
            return width + 10 + getWidthOffset();
        }
        function getExpandHeight(height) {
            return height + 10 + getHeightOffset();
        }
        function getShrinkWidth(width) {
            return width * 2 + getWidthOffset();
        }
        function getShrinkHeight(height) {
            return height * 2 + getHeightOffset();
        }
        function positionScrollbars(element, width, height) {
            var expand = getExpandElement(element);
            var shrink = getShrinkElement(element);
            var expandWidth = getExpandWidth(width);
            var expandHeight = getExpandHeight(height);
            var shrinkWidth = getShrinkWidth(width);
            var shrinkHeight = getShrinkHeight(height);
            expand.scrollLeft = expandWidth;
            expand.scrollTop = expandHeight;
            shrink.scrollLeft = shrinkWidth;
            shrink.scrollTop = shrinkHeight;
        }
        function injectContainerElement() {
            var container = getState(element).container;
            if (!container) {
                container = document.createElement("div");
                container.className = detectionContainerClass;
                container.style.cssText = buildCssTextString([
                    "visibility: hidden",
                    "display: inline",
                    "width: 0px",
                    "height: 0px",
                    "z-index: -1",
                    "overflow: hidden",
                    "margin: 0",
                    "padding: 0"
                ]);
                getState(element).container = container;
                addAnimationClass(container);
                element.appendChild(container);
                var onAnimationStart = function() {
                    getState(element).onRendered && getState(element).onRendered();
                };
                addEvent(container, "animationstart", onAnimationStart);
                // Store the event handler here so that they may be removed when uninstall is called.
                // See uninstall function for an explanation why it is needed.
                getState(element).onAnimationStart = onAnimationStart;
            }
            return container;
        }
        function injectScrollElements() {
            function alterPositionStyles() {
                var style = getState(element).style;
                if (style.position === "static") {
                    element.style.setProperty("position", "relative", options.important ? "important" : "");
                    var removeRelativeStyles = function(reporter, element, style, property) {
                        function getNumericalValue(value) {
                            return value.replace(/[^-\d\.]/g, "");
                        }
                        var value = style[property];
                        if (value !== "auto" && getNumericalValue(value) !== "0") {
                            reporter.warn("An element that is positioned static has style." + property + "=" + value + " which is ignored due to the static positioning. The element will need to be positioned relative, so the style." + property + " will be set to 0. Element: ", element);
                            element.style[property] = 0;
                        }
                    };
                    //Check so that there are no accidental styles that will make the element styled differently now that is is relative.
                    //If there are any, set them to 0 (this should be okay with the user since the style properties did nothing before [since the element was positioned static] anyway).
                    removeRelativeStyles(reporter, element, style, "top");
                    removeRelativeStyles(reporter, element, style, "right");
                    removeRelativeStyles(reporter, element, style, "bottom");
                    removeRelativeStyles(reporter, element, style, "left");
                }
            }
            function getLeftTopBottomRightCssText(left, top, bottom, right) {
                left = !left ? "0" : left + "px";
                top = !top ? "0" : top + "px";
                bottom = !bottom ? "0" : bottom + "px";
                right = !right ? "0" : right + "px";
                return [
                    "left: " + left,
                    "top: " + top,
                    "right: " + right,
                    "bottom: " + bottom
                ];
            }
            debug("Injecting elements");
            if (!getState(element)) {
                debug("Aborting because element has been uninstalled");
                return;
            }
            alterPositionStyles();
            var rootContainer = getState(element).container;
            if (!rootContainer) rootContainer = injectContainerElement();
            // Due to this WebKit bug https://bugs.webkit.org/show_bug.cgi?id=80808 (currently fixed in Blink, but still present in WebKit browsers such as Safari),
            // we need to inject two containers, one that is width/height 100% and another that is left/top -1px so that the final container always is 1x1 pixels bigger than
            // the targeted element.
            // When the bug is resolved, "containerContainer" may be removed.
            // The outer container can occasionally be less wide than the targeted when inside inline elements element in WebKit (see https://bugs.webkit.org/show_bug.cgi?id=152980).
            // This should be no problem since the inner container either way makes sure the injected scroll elements are at least 1x1 px.
            var scrollbarWidth = scrollbarSizes.width;
            var scrollbarHeight = scrollbarSizes.height;
            var containerContainerStyle = buildCssTextString([
                "position: absolute",
                "flex: none",
                "overflow: hidden",
                "z-index: -1",
                "visibility: hidden",
                "width: 100%",
                "height: 100%",
                "left: 0px",
                "top: 0px"
            ]);
            var containerStyle = buildCssTextString([
                "position: absolute",
                "flex: none",
                "overflow: hidden",
                "z-index: -1",
                "visibility: hidden"
            ].concat(getLeftTopBottomRightCssText(-(1 + scrollbarWidth), -(1 + scrollbarHeight), -scrollbarHeight, -scrollbarWidth)));
            var expandStyle = buildCssTextString([
                "position: absolute",
                "flex: none",
                "overflow: scroll",
                "z-index: -1",
                "visibility: hidden",
                "width: 100%",
                "height: 100%"
            ]);
            var shrinkStyle = buildCssTextString([
                "position: absolute",
                "flex: none",
                "overflow: scroll",
                "z-index: -1",
                "visibility: hidden",
                "width: 100%",
                "height: 100%"
            ]);
            var expandChildStyle = buildCssTextString([
                "position: absolute",
                "left: 0",
                "top: 0"
            ]);
            var shrinkChildStyle = buildCssTextString([
                "position: absolute",
                "width: 200%",
                "height: 200%"
            ]);
            var containerContainer = document.createElement("div");
            var container = document.createElement("div");
            var expand = document.createElement("div");
            var expandChild = document.createElement("div");
            var shrink = document.createElement("div");
            var shrinkChild = document.createElement("div");
            // Some browsers choke on the resize system being rtl, so force it to ltr. https://github.com/wnr/element-resize-detector/issues/56
            // However, dir should not be set on the top level container as it alters the dimensions of the target element in some browsers.
            containerContainer.dir = "ltr";
            containerContainer.style.cssText = containerContainerStyle;
            containerContainer.className = detectionContainerClass;
            container.className = detectionContainerClass;
            container.style.cssText = containerStyle;
            expand.style.cssText = expandStyle;
            expandChild.style.cssText = expandChildStyle;
            shrink.style.cssText = shrinkStyle;
            shrinkChild.style.cssText = shrinkChildStyle;
            expand.appendChild(expandChild);
            shrink.appendChild(shrinkChild);
            container.appendChild(expand);
            container.appendChild(shrink);
            containerContainer.appendChild(container);
            rootContainer.appendChild(containerContainer);
            function onExpandScroll() {
                var state = getState(element);
                if (state && state.onExpand) state.onExpand();
                else debug("Aborting expand scroll handler: element has been uninstalled");
            }
            function onShrinkScroll() {
                var state = getState(element);
                if (state && state.onShrink) state.onShrink();
                else debug("Aborting shrink scroll handler: element has been uninstalled");
            }
            addEvent(expand, "scroll", onExpandScroll);
            addEvent(shrink, "scroll", onShrinkScroll);
            // Store the event handlers here so that they may be removed when uninstall is called.
            // See uninstall function for an explanation why it is needed.
            getState(element).onExpandScroll = onExpandScroll;
            getState(element).onShrinkScroll = onShrinkScroll;
        }
        function registerListenersAndPositionElements() {
            function updateChildSizes(element, width, height) {
                var expandChild = getExpandChildElement(element);
                var expandWidth = getExpandWidth(width);
                var expandHeight = getExpandHeight(height);
                expandChild.style.setProperty("width", expandWidth + "px", options.important ? "important" : "");
                expandChild.style.setProperty("height", expandHeight + "px", options.important ? "important" : "");
            }
            function updateDetectorElements(done) {
                var width = element.offsetWidth;
                var height = element.offsetHeight;
                // Check whether the size has actually changed since last time the algorithm ran. If not, some steps may be skipped.
                var sizeChanged = width !== getState(element).lastWidth || height !== getState(element).lastHeight;
                debug("Storing current size", width, height);
                // Store the size of the element sync here, so that multiple scroll events may be ignored in the event listeners.
                // Otherwise the if-check in handleScroll is useless.
                storeCurrentSize(element, width, height);
                // Since we delay the processing of the batch, there is a risk that uninstall has been called before the batch gets to execute.
                // Since there is no way to cancel the fn executions, we need to add an uninstall guard to all fns of the batch.
                batchProcessor.add(0, function performUpdateChildSizes() {
                    if (!sizeChanged) return;
                    if (!getState(element)) {
                        debug("Aborting because element has been uninstalled");
                        return;
                    }
                    if (!areElementsInjected()) {
                        debug("Aborting because element container has not been initialized");
                        return;
                    }
                    if (options.debug) {
                        var w = element.offsetWidth;
                        var h = element.offsetHeight;
                        if (w !== width || h !== height) reporter.warn(idHandler.get(element), "Scroll: Size changed before updating detector elements.");
                    }
                    updateChildSizes(element, width, height);
                });
                batchProcessor.add(1, function updateScrollbars() {
                    // This function needs to be invoked event though the size is unchanged. The element could have been resized very quickly and then
                    // been restored to the original size, which will have changed the scrollbar positions.
                    if (!getState(element)) {
                        debug("Aborting because element has been uninstalled");
                        return;
                    }
                    if (!areElementsInjected()) {
                        debug("Aborting because element container has not been initialized");
                        return;
                    }
                    positionScrollbars(element, width, height);
                });
                if (sizeChanged && done) batchProcessor.add(2, function() {
                    if (!getState(element)) {
                        debug("Aborting because element has been uninstalled");
                        return;
                    }
                    if (!areElementsInjected()) {
                        debug("Aborting because element container has not been initialized");
                        return;
                    }
                    done();
                });
            }
            function areElementsInjected() {
                return !!getState(element).container;
            }
            function notifyListenersIfNeeded() {
                function isFirstNotify() {
                    return getState(element).lastNotifiedWidth === undefined;
                }
                debug("notifyListenersIfNeeded invoked");
                var state = getState(element);
                // Don't notify if the current size is the start size, and this is the first notification.
                if (isFirstNotify() && state.lastWidth === state.startSize.width && state.lastHeight === state.startSize.height) return debug("Not notifying: Size is the same as the start size, and there has been no notification yet.");
                // Don't notify if the size already has been notified.
                if (state.lastWidth === state.lastNotifiedWidth && state.lastHeight === state.lastNotifiedHeight) return debug("Not notifying: Size already notified");
                debug("Current size not notified, notifying...");
                state.lastNotifiedWidth = state.lastWidth;
                state.lastNotifiedHeight = state.lastHeight;
                $43d393c1379be643$require$forEach(getState(element).listeners, function(listener) {
                    listener(element);
                });
            }
            function handleRender() {
                debug("startanimation triggered.");
                if (isUnrendered(element)) {
                    debug("Ignoring since element is still unrendered...");
                    return;
                }
                debug("Element rendered.");
                var expand = getExpandElement(element);
                var shrink = getShrinkElement(element);
                if (expand.scrollLeft === 0 || expand.scrollTop === 0 || shrink.scrollLeft === 0 || shrink.scrollTop === 0) {
                    debug("Scrollbars out of sync. Updating detector elements...");
                    updateDetectorElements(notifyListenersIfNeeded);
                }
            }
            function handleScroll() {
                debug("Scroll detected.");
                if (isUnrendered(element)) {
                    // Element is still unrendered. Skip this scroll event.
                    debug("Scroll event fired while unrendered. Ignoring...");
                    return;
                }
                updateDetectorElements(notifyListenersIfNeeded);
            }
            debug("registerListenersAndPositionElements invoked.");
            if (!getState(element)) {
                debug("Aborting because element has been uninstalled");
                return;
            }
            getState(element).onRendered = handleRender;
            getState(element).onExpand = handleScroll;
            getState(element).onShrink = handleScroll;
            var style = getState(element).style;
            updateChildSizes(element, style.width, style.height);
        }
        function finalizeDomMutation() {
            debug("finalizeDomMutation invoked.");
            if (!getState(element)) {
                debug("Aborting because element has been uninstalled");
                return;
            }
            var style = getState(element).style;
            storeCurrentSize(element, style.width, style.height);
            positionScrollbars(element, style.width, style.height);
        }
        function ready() {
            callback(element);
        }
        function install() {
            debug("Installing...");
            initListeners();
            storeStartSize();
            batchProcessor.add(0, storeStyle);
            batchProcessor.add(1, injectScrollElements);
            batchProcessor.add(2, registerListenersAndPositionElements);
            batchProcessor.add(3, finalizeDomMutation);
            batchProcessor.add(4, ready);
        }
        debug("Making detectable...");
        if (isDetached(element)) {
            debug("Element is detached");
            injectContainerElement();
            debug("Waiting until element is attached...");
            getState(element).onRendered = function() {
                debug("Element is now attached");
                install();
            };
        } else install();
    }
    function uninstall(element) {
        var state = getState(element);
        if (!state) // Uninstall has been called on a non-erd element.
        return;
        // Uninstall may have been called in the following scenarios:
        // (1) Right between the sync code and async batch (here state.busy = true, but nothing have been registered or injected).
        // (2) In the ready callback of the last level of the batch by another element (here, state.busy = true, but all the stuff has been injected).
        // (3) After the installation process (here, state.busy = false and all the stuff has been injected).
        // So to be on the safe side, let's check for each thing before removing.
        // We need to remove the event listeners, because otherwise the event might fire on an uninstall element which results in an error when trying to get the state of the element.
        state.onExpandScroll && removeEvent(getExpandElement(element), "scroll", state.onExpandScroll);
        state.onShrinkScroll && removeEvent(getShrinkElement(element), "scroll", state.onShrinkScroll);
        state.onAnimationStart && removeEvent(state.container, "animationstart", state.onAnimationStart);
        state.container && element.removeChild(state.container);
    }
    return {
        makeDetectable: makeDetectable,
        addListener: addListener,
        uninstall: uninstall,
        initDocument: initDocument
    };
};

});


parcelRegister("fudzi", function(module, exports) {
//
module.exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};

});

var $b8c53ef43392f031$exports = {};
'use strict';

$b8c53ef43392f031$exports = (parcelRequire("iwYKF"));


parcelRequire("lx97N");
var $e08bedd2d92855da$exports = {};

$parcel$export($e08bedd2d92855da$exports, "createRoot", () => $e08bedd2d92855da$export$882461b6382ed46c, (v) => $e08bedd2d92855da$export$882461b6382ed46c = v);
$parcel$export($e08bedd2d92855da$exports, "hydrateRoot", () => $e08bedd2d92855da$export$757ceba2d55c277e, (v) => $e08bedd2d92855da$export$757ceba2d55c277e = v);
var $e08bedd2d92855da$export$882461b6382ed46c;
var $e08bedd2d92855da$export$757ceba2d55c277e;
'use strict';

var $1amKe = parcelRequire("1amKe");
var $e08bedd2d92855da$var$i;
$e08bedd2d92855da$export$882461b6382ed46c = $1amKe.createRoot;
$e08bedd2d92855da$export$757ceba2d55c277e = $1amKe.hydrateRoot;


function $bd139ac42a0d91f6$export$2e2bcd8739ae039(o, p) {
    $bd139ac42a0d91f6$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $bd139ac42a0d91f6$export$2e2bcd8739ae039(o, p);
}


function $7fd885f4c490992f$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $bd139ac42a0d91f6$export$2e2bcd8739ae039)(subClass, superClass);
}



var $lx97N = parcelRequire("lx97N");

var $4RND8 = parcelRequire("4RND8");

var $lx97N = parcelRequire("lx97N");
var $0aa7f6791cbf89de$export$cc80c08dc91f1c00 = (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createContext(null);
var $0aa7f6791cbf89de$export$2e2bcd8739ae039 = $0aa7f6791cbf89de$export$cc80c08dc91f1c00;


var $302e609c0f21ba7e$var$Provider = /*#__PURE__*/ function(_Component) {
    (0, $7fd885f4c490992f$export$2e2bcd8739ae039)(Provider, _Component);
    function Provider(props) {
        var _this;
        _this = _Component.call(this, props) || this;
        var store = props.store;
        _this.state = {
            storeState: store.getState(),
            store: store
        };
        return _this;
    }
    var _proto = Provider.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this._isMounted = true;
        this.subscribe();
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unsubscribe) this.unsubscribe();
        this._isMounted = false;
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.store !== prevProps.store) {
            if (this.unsubscribe) this.unsubscribe();
            this.subscribe();
        }
    };
    _proto.subscribe = function subscribe() {
        var _this2 = this;
        var store = this.props.store;
        this.unsubscribe = store.subscribe(function() {
            var newStoreState = store.getState();
            if (!_this2._isMounted) return;
            _this2.setState(function(providerState) {
                // If the value is the same, skip the unnecessary state update.
                if (providerState.storeState === newStoreState) return null;
                return {
                    storeState: newStoreState
                };
            });
        }); // Actions might have been dispatched between render and mount - handle those
        var postMountStoreState = store.getState();
        if (postMountStoreState !== this.state.storeState) this.setState({
            storeState: postMountStoreState
        });
    };
    _proto.render = function render() {
        var Context = this.props.context || (0, $0aa7f6791cbf89de$export$cc80c08dc91f1c00);
        return (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement(Context.Provider, {
            value: this.state
        }, this.props.children);
    };
    return Provider;
}((0, $lx97N.Component));
$302e609c0f21ba7e$var$Provider.propTypes = {
    store: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).shape({
        subscribe: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).func.isRequired,
        dispatch: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).func.isRequired,
        getState: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).func.isRequired
    }),
    context: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).object,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).any
};
var $302e609c0f21ba7e$export$2e2bcd8739ae039 = $302e609c0f21ba7e$var$Provider;


function $b228f7024b99ca2f$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}



function $e133885d0b1e9831$export$2e2bcd8739ae039() {
    $e133885d0b1e9831$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e133885d0b1e9831$export$2e2bcd8739ae039.apply(this, arguments);
}


function $1e68ba0013b1ee9c$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var $35f9bc7c0d546ba3$exports = {};
'use strict';
var $6df612c424d59fc3$exports = {};
'use strict';

$6df612c424d59fc3$exports = (parcelRequire("dhnve"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $35f9bc7c0d546ba3$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $35f9bc7c0d546ba3$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $35f9bc7c0d546ba3$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $35f9bc7c0d546ba3$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $35f9bc7c0d546ba3$var$TYPE_STATICS = {};
$35f9bc7c0d546ba3$var$TYPE_STATICS[$6df612c424d59fc3$exports.ForwardRef] = $35f9bc7c0d546ba3$var$FORWARD_REF_STATICS;
$35f9bc7c0d546ba3$var$TYPE_STATICS[$6df612c424d59fc3$exports.Memo] = $35f9bc7c0d546ba3$var$MEMO_STATICS;
function $35f9bc7c0d546ba3$var$getStatics(component) {
    // React v16.11 and below
    if ($6df612c424d59fc3$exports.isMemo(component)) return $35f9bc7c0d546ba3$var$MEMO_STATICS;
     // React v16.12 and above
    return $35f9bc7c0d546ba3$var$TYPE_STATICS[component['$$typeof']] || $35f9bc7c0d546ba3$var$REACT_STATICS;
}
var $35f9bc7c0d546ba3$var$defineProperty = Object.defineProperty;
var $35f9bc7c0d546ba3$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $35f9bc7c0d546ba3$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $35f9bc7c0d546ba3$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $35f9bc7c0d546ba3$var$getPrototypeOf = Object.getPrototypeOf;
var $35f9bc7c0d546ba3$var$objectPrototype = Object.prototype;
function $35f9bc7c0d546ba3$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($35f9bc7c0d546ba3$var$objectPrototype) {
            var inheritedComponent = $35f9bc7c0d546ba3$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $35f9bc7c0d546ba3$var$objectPrototype) $35f9bc7c0d546ba3$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $35f9bc7c0d546ba3$var$getOwnPropertyNames(sourceComponent);
        if ($35f9bc7c0d546ba3$var$getOwnPropertySymbols) keys = keys.concat($35f9bc7c0d546ba3$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $35f9bc7c0d546ba3$var$getStatics(targetComponent);
        var sourceStatics = $35f9bc7c0d546ba3$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$35f9bc7c0d546ba3$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $35f9bc7c0d546ba3$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $35f9bc7c0d546ba3$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$35f9bc7c0d546ba3$exports = $35f9bc7c0d546ba3$var$hoistNonReactStatics;



var $1dCkN = parcelRequire("1dCkN");

var $lx97N = parcelRequire("lx97N");


var $9116515fbf555f14$var$stringifyComponent = function stringifyComponent(Comp) {
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $9116515fbf555f14$export$2e2bcd8739ae039(/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/ selectorFactory, _ref) {
    if (_ref === void 0) _ref = {};
    var _ref2 = _ref, _ref2$getDisplayName = _ref2.getDisplayName, getDisplayName = _ref2$getDisplayName === void 0 ? function(name) {
        return "ConnectAdvanced(" + name + ")";
    } : _ref2$getDisplayName, _ref2$methodName = _ref2.methodName, methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName, _ref2$renderCountProp = _ref2.renderCountProp, renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp, _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges, shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta, _ref2$storeKey = _ref2.storeKey, storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey, _ref2$withRef = _ref2.withRef, withRef = _ref2$withRef === void 0 ? false : _ref2$withRef, _ref2$forwardRef = _ref2.forwardRef, forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef, _ref2$context = _ref2.context, context = _ref2$context === void 0 ? (0, $0aa7f6791cbf89de$export$cc80c08dc91f1c00) : _ref2$context, connectOptions = (0, $1e68ba0013b1ee9c$export$2e2bcd8739ae039)(_ref2, [
        "getDisplayName",
        "methodName",
        "renderCountProp",
        "shouldHandleStateChanges",
        "storeKey",
        "withRef",
        "forwardRef",
        "context"
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($1dCkN)))(renderCountProp === undefined, "renderCountProp is removed. render counting is built into the latest React dev tools profiling extension");
    (0, (/*@__PURE__*/$parcel$interopDefault($1dCkN)))(!withRef, 'withRef is removed. To access the wrapped instance, use a ref on the connected component');
    var customStoreWarningMessage = "To use a custom Redux store for specific components,  create a custom React context with React.createContext(), and pass the context object to React Redux's Provider and specific components like:  <Provider context={MyContext}><ConnectedComponent context={MyContext} /></Provider>. You may also pass a {context : MyContext} option to connect";
    (0, (/*@__PURE__*/$parcel$interopDefault($1dCkN)))(storeKey === 'store', 'storeKey has been removed and does not do anything. ' + customStoreWarningMessage);
    var Context = context;
    return function wrapWithConnect(WrappedComponent) {
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
        var displayName = getDisplayName(wrappedComponentName);
        var selectorFactoryOptions = (0, $e133885d0b1e9831$export$2e2bcd8739ae039)({}, connectOptions, {
            getDisplayName: getDisplayName,
            methodName: methodName,
            renderCountProp: renderCountProp,
            shouldHandleStateChanges: shouldHandleStateChanges,
            storeKey: storeKey,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent
        });
        var pure = connectOptions.pure;
        var OuterBaseComponent = (0, $lx97N.Component);
        if (pure) OuterBaseComponent = (0, $lx97N.PureComponent);
        function makeDerivedPropsSelector() {
            var lastProps;
            var lastState;
            var lastDerivedProps;
            var lastStore;
            var lastSelectorFactoryOptions;
            var sourceSelector;
            return function selectDerivedProps(state, props, store, selectorFactoryOptions) {
                if (pure && lastProps === props && lastState === state) return lastDerivedProps;
                if (store !== lastStore || lastSelectorFactoryOptions !== selectorFactoryOptions) {
                    lastStore = store;
                    lastSelectorFactoryOptions = selectorFactoryOptions;
                    sourceSelector = selectorFactory(store.dispatch, selectorFactoryOptions);
                }
                lastProps = props;
                lastState = state;
                var nextProps = sourceSelector(state, props);
                lastDerivedProps = nextProps;
                return lastDerivedProps;
            };
        }
        function makeChildElementSelector() {
            var lastChildProps, lastForwardRef, lastChildElement, lastComponent;
            return function selectChildElement(WrappedComponent, childProps, forwardRef) {
                if (childProps !== lastChildProps || forwardRef !== lastForwardRef || lastComponent !== WrappedComponent) {
                    lastChildProps = childProps;
                    lastForwardRef = forwardRef;
                    lastComponent = WrappedComponent;
                    lastChildElement = (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement(WrappedComponent, (0, $e133885d0b1e9831$export$2e2bcd8739ae039)({}, childProps, {
                        ref: forwardRef
                    }));
                }
                return lastChildElement;
            };
        }
        var Connect = /*#__PURE__*/ function(_OuterBaseComponent) {
            (0, $7fd885f4c490992f$export$2e2bcd8739ae039)(Connect, _OuterBaseComponent);
            function Connect(props) {
                var _this;
                _this = _OuterBaseComponent.call(this, props) || this;
                (0, (/*@__PURE__*/$parcel$interopDefault($1dCkN)))(forwardRef ? !props.wrapperProps[storeKey] : !props[storeKey], 'Passing redux store in props has been removed and does not do anything. ' + customStoreWarningMessage);
                _this.selectDerivedProps = makeDerivedPropsSelector();
                _this.selectChildElement = makeChildElementSelector();
                _this.indirectRenderWrappedComponent = _this.indirectRenderWrappedComponent.bind((0, $b228f7024b99ca2f$export$2e2bcd8739ae039)(_this));
                return _this;
            }
            var _proto = Connect.prototype;
            _proto.indirectRenderWrappedComponent = function indirectRenderWrappedComponent(value) {
                // calling renderWrappedComponent on prototype from indirectRenderWrappedComponent bound to `this`
                return this.renderWrappedComponent(value);
            };
            _proto.renderWrappedComponent = function renderWrappedComponent(value) {
                (0, (/*@__PURE__*/$parcel$interopDefault($1dCkN)))(value, "Could not find \"store\" in the context of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + "or pass a custom React context provider to <Provider> and the corresponding " + ("React context consumer to " + displayName + " in connect options."));
                var storeState = value.storeState, store = value.store;
                var wrapperProps = this.props;
                var forwardedRef;
                if (forwardRef) {
                    wrapperProps = this.props.wrapperProps;
                    forwardedRef = this.props.forwardedRef;
                }
                var derivedProps = this.selectDerivedProps(storeState, wrapperProps, store, selectorFactoryOptions);
                return this.selectChildElement(WrappedComponent, derivedProps, forwardedRef);
            };
            _proto.render = function render() {
                var ContextToUse = this.props.context && this.props.context.Consumer && (0, $6df612c424d59fc3$exports.isContextConsumer)((0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement(this.props.context.Consumer, null)) ? this.props.context : Context;
                return (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement(ContextToUse.Consumer, null, this.indirectRenderWrappedComponent);
            };
            return Connect;
        }(OuterBaseComponent);
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = displayName;
        if (forwardRef) {
            var forwarded = (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).forwardRef(function forwardConnectRef(props, ref) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement(Connect, {
                    wrapperProps: props,
                    forwardedRef: ref
                });
            });
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($35f9bc7c0d546ba3$exports)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($35f9bc7c0d546ba3$exports)))(Connect, WrappedComponent);
    };
}






var $5e6f19cc76918d74$var$hasOwn = Object.prototype.hasOwnProperty;
function $5e6f19cc76918d74$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $5e6f19cc76918d74$export$2e2bcd8739ae039(objA, objB) {
    if ($5e6f19cc76918d74$var$is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!$5e6f19cc76918d74$var$hasOwn.call(objB, keysA[i]) || !$5e6f19cc76918d74$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}


function $af92bc7dcd569e4d$export$2e2bcd8739ae039(obj) {
    "@babel/helpers - typeof";
    return $af92bc7dcd569e4d$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $af92bc7dcd569e4d$export$2e2bcd8739ae039(obj);
}



function $a3d765099a72c90f$export$2e2bcd8739ae039(input, hint) {
    if ((0, $af92bc7dcd569e4d$export$2e2bcd8739ae039)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $af92bc7dcd569e4d$export$2e2bcd8739ae039)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}


function $9c01f0b6057b0d1c$export$2e2bcd8739ae039(arg) {
    var key = (0, $a3d765099a72c90f$export$2e2bcd8739ae039)(arg, "string");
    return (0, $af92bc7dcd569e4d$export$2e2bcd8739ae039)(key) === "symbol" ? key : String(key);
}


function $a08f1a0f4ba56e15$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $9c01f0b6057b0d1c$export$2e2bcd8739ae039)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $bfd9d820e5d649ff$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $bfd9d820e5d649ff$export$2e2bcd8739ae039(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $bfd9d820e5d649ff$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $a08f1a0f4ba56e15$export$2e2bcd8739ae039)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $bfd9d820e5d649ff$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $1989032bc8d1f610$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}
// Inlined version of the `symbol-observable` polyfill
var $1989032bc8d1f610$var$$$observable = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $1989032bc8d1f610$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split('').join('.');
};
var $1989032bc8d1f610$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $1989032bc8d1f610$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $1989032bc8d1f610$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $1989032bc8d1f610$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $1989032bc8d1f610$var$isPlainObject(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $1989032bc8d1f610$var$miniKindOf(val) {
    if (val === void 0) return 'undefined';
    if (val === null) return 'null';
    var type = typeof val;
    switch(type){
        case 'boolean':
        case 'string':
        case 'number':
        case 'symbol':
        case 'function':
            return type;
    }
    if (Array.isArray(val)) return 'array';
    if ($1989032bc8d1f610$var$isDate(val)) return 'date';
    if ($1989032bc8d1f610$var$isError(val)) return 'error';
    var constructorName = $1989032bc8d1f610$var$ctorName(val);
    switch(constructorName){
        case 'Symbol':
        case 'Promise':
        case 'WeakMap':
        case 'WeakSet':
        case 'Map':
        case 'Set':
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}
function $1989032bc8d1f610$var$ctorName(val) {
    return typeof val.constructor === 'function' ? val.constructor.name : null;
}
function $1989032bc8d1f610$var$isError(val) {
    return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}
function $1989032bc8d1f610$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}
function $1989032bc8d1f610$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ function $1989032bc8d1f610$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') throw new Error($1989032bc8d1f610$var$formatProdErrorMessage(0));
    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== 'undefined') {
        if (typeof enhancer !== 'function') throw new Error($1989032bc8d1f610$var$formatProdErrorMessage(1));
        return enhancer($1989032bc8d1f610$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== 'function') throw new Error($1989032bc8d1f610$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($1989032bc8d1f610$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== 'function') throw new Error($1989032bc8d1f610$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($1989032bc8d1f610$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($1989032bc8d1f610$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$1989032bc8d1f610$var$isPlainObject(action)) throw new Error($1989032bc8d1f610$var$formatProdErrorMessage(7));
        if (typeof action.type === 'undefined') throw new Error($1989032bc8d1f610$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($1989032bc8d1f610$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== 'function') throw new Error($1989032bc8d1f610$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $1989032bc8d1f610$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) throw new Error($1989032bc8d1f610$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$1989032bc8d1f610$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $1989032bc8d1f610$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$1989032bc8d1f610$var$$$observable] = observable, _ref2;
}
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $1989032bc8d1f610$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $1989032bc8d1f610$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $1989032bc8d1f610$export$4219e499db7ca678.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$1989032bc8d1f610$var$isPlainObject(inputState)) return "The " + argumentName + " has unexpected type of \"" + $1989032bc8d1f610$var$kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $1989032bc8d1f610$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
}
function $1989032bc8d1f610$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $1989032bc8d1f610$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === 'undefined') throw new Error($1989032bc8d1f610$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $1989032bc8d1f610$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === 'undefined') throw new Error($1989032bc8d1f610$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $1989032bc8d1f610$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === 'function') finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $1989032bc8d1f610$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === 'undefined') {
                var actionType = action && action.type;
                throw new Error($1989032bc8d1f610$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $1989032bc8d1f610$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $1989032bc8d1f610$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === 'function') return $1989032bc8d1f610$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== 'object' || actionCreators === null) throw new Error($1989032bc8d1f610$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = $1989032bc8d1f610$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $1989032bc8d1f610$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $1989032bc8d1f610$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($1989032bc8d1f610$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $1989032bc8d1f610$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $bfd9d820e5d649ff$export$2e2bcd8739ae039)((0, $bfd9d820e5d649ff$export$2e2bcd8739ae039)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}
/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */ function $1989032bc8d1f610$var$isCrushed() {}


/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $bece5a39de6d1f62$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}


/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $6dae30bd9745d8dc$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }


function $3669d853f8b71a0b$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $bece5a39de6d1f62$export$2e2bcd8739ae039)(value)) (0, $6dae30bd9745d8dc$export$2e2bcd8739ae039)(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
}


function $655eef994494db7c$export$710f7c60f68acd3e(getConstant) {
    return function initConstantSelector(dispatch, options) {
        var constant = getConstant(dispatch, options);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $655eef994494db7c$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $655eef994494db7c$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, _ref) {
        var displayName = _ref.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $655eef994494db7c$export$e561b938df936d57(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === 'function') {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $655eef994494db7c$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}


function $e3452ab47869ec29$export$a9f27b4b187c1166(mapDispatchToProps) {
    return typeof mapDispatchToProps === 'function' ? (0, $655eef994494db7c$export$8d46c7f53c8c602f)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function $e3452ab47869ec29$export$ba20d1a7aa0c4a90(mapDispatchToProps) {
    return !mapDispatchToProps ? (0, $655eef994494db7c$export$710f7c60f68acd3e)(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : undefined;
}
function $e3452ab47869ec29$export$94a6e55709d4d961(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, $655eef994494db7c$export$710f7c60f68acd3e)(function(dispatch) {
        return (0, $1989032bc8d1f610$export$aea084d96e84da92)(mapDispatchToProps, dispatch);
    }) : undefined;
}
var $e3452ab47869ec29$export$2e2bcd8739ae039 = [
    $e3452ab47869ec29$export$a9f27b4b187c1166,
    $e3452ab47869ec29$export$ba20d1a7aa0c4a90,
    $e3452ab47869ec29$export$94a6e55709d4d961
];



function $3d093ffdd1a423ec$export$23fc470827b14aa(mapStateToProps) {
    return typeof mapStateToProps === 'function' ? (0, $655eef994494db7c$export$8d46c7f53c8c602f)(mapStateToProps, 'mapStateToProps') : undefined;
}
function $3d093ffdd1a423ec$export$514bc8c1a53c1d66(mapStateToProps) {
    return !mapStateToProps ? (0, $655eef994494db7c$export$710f7c60f68acd3e)(function() {
        return {};
    }) : undefined;
}
var $3d093ffdd1a423ec$export$2e2bcd8739ae039 = [
    $3d093ffdd1a423ec$export$23fc470827b14aa,
    $3d093ffdd1a423ec$export$514bc8c1a53c1d66
];




function $7958d866a5bbde97$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    return (0, $e133885d0b1e9831$export$2e2bcd8739ae039)({}, ownProps, stateProps, dispatchProps);
}
function $7958d866a5bbde97$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, _ref) {
        var displayName = _ref.displayName, pure = _ref.pure, areMergedPropsEqual = _ref.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $7958d866a5bbde97$export$d61b680184bc3f00(mergeProps) {
    return typeof mergeProps === 'function' ? $7958d866a5bbde97$export$5b105939c84b5234(mergeProps) : undefined;
}
function $7958d866a5bbde97$export$a13ba70ef50dda6d(mergeProps) {
    return !mergeProps ? function() {
        return $7958d866a5bbde97$export$691c327fc30bc857;
    } : undefined;
}
var $7958d866a5bbde97$export$2e2bcd8739ae039 = [
    $7958d866a5bbde97$export$d61b680184bc3f00,
    $7958d866a5bbde97$export$a13ba70ef50dda6d
];




function $0f1a9f497f1baca2$var$verify(selector, methodName, displayName) {
    if (!selector) throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
    else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
        if (!selector.hasOwnProperty('dependsOnOwnProps')) (0, $6dae30bd9745d8dc$export$2e2bcd8739ae039)("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
}
function $0f1a9f497f1baca2$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
    $0f1a9f497f1baca2$var$verify(mapStateToProps, 'mapStateToProps', displayName);
    $0f1a9f497f1baca2$var$verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
    $0f1a9f497f1baca2$var$verify(mergeProps, 'mergeProps', displayName);
}


function $a4be6f733949e5a8$export$68c2c73bda6aa4b0(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
    return function impureFinalPropsSelector(state, ownProps) {
        return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
    };
}
function $a4be6f733949e5a8$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
    var areStatesEqual = _ref.areStatesEqual, areOwnPropsEqual = _ref.areOwnPropsEqual, areStatePropsEqual = _ref.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
} // TODO: Add more comments
function $a4be6f733949e5a8$export$2e2bcd8739ae039(dispatch, _ref2) {
    var initMapStateToProps = _ref2.initMapStateToProps, initMapDispatchToProps = _ref2.initMapDispatchToProps, initMergeProps = _ref2.initMergeProps, options = (0, $1e68ba0013b1ee9c$export$2e2bcd8739ae039)(_ref2, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    var selectorFactory = options.pure ? $a4be6f733949e5a8$export$d20c0c2ca6eb2b6f : $a4be6f733949e5a8$export$68c2c73bda6aa4b0;
    return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}


/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */ function $494dfd495f2b09e7$var$match(arg, factories, name) {
    for(var i = factories.length - 1; i >= 0; i--){
        var result = factories[i](arg);
        if (result) return result;
    }
    return function(dispatch, options) {
        throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
    };
}
function $494dfd495f2b09e7$var$strictEqual(a, b) {
    return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
function $494dfd495f2b09e7$export$9f9feb656dec1fc4(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$connectHOC = _ref.connectHOC, connectHOC = _ref$connectHOC === void 0 ? (0, $9116515fbf555f14$export$2e2bcd8739ae039) : _ref$connectHOC, _ref$mapStateToPropsF = _ref.mapStateToPropsFactories, mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? (0, $3d093ffdd1a423ec$export$2e2bcd8739ae039) : _ref$mapStateToPropsF, _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories, mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? (0, $e3452ab47869ec29$export$2e2bcd8739ae039) : _ref$mapDispatchToPro, _ref$mergePropsFactor = _ref.mergePropsFactories, mergePropsFactories = _ref$mergePropsFactor === void 0 ? (0, $7958d866a5bbde97$export$2e2bcd8739ae039) : _ref$mergePropsFactor, _ref$selectorFactory = _ref.selectorFactory, selectorFactory = _ref$selectorFactory === void 0 ? (0, $a4be6f733949e5a8$export$2e2bcd8739ae039) : _ref$selectorFactory;
    return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
        if (_ref2 === void 0) _ref2 = {};
        var _ref3 = _ref2, _ref3$pure = _ref3.pure, pure = _ref3$pure === void 0 ? true : _ref3$pure, _ref3$areStatesEqual = _ref3.areStatesEqual, areStatesEqual = _ref3$areStatesEqual === void 0 ? $494dfd495f2b09e7$var$strictEqual : _ref3$areStatesEqual, _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual, areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? (0, $5e6f19cc76918d74$export$2e2bcd8739ae039) : _ref3$areOwnPropsEqua, _ref3$areStatePropsEq = _ref3.areStatePropsEqual, areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? (0, $5e6f19cc76918d74$export$2e2bcd8739ae039) : _ref3$areStatePropsEq, _ref3$areMergedPropsE = _ref3.areMergedPropsEqual, areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? (0, $5e6f19cc76918d74$export$2e2bcd8739ae039) : _ref3$areMergedPropsE, extraOptions = (0, $1e68ba0013b1ee9c$export$2e2bcd8739ae039)(_ref3, [
            "pure",
            "areStatesEqual",
            "areOwnPropsEqual",
            "areStatePropsEqual",
            "areMergedPropsEqual"
        ]);
        var initMapStateToProps = $494dfd495f2b09e7$var$match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
        var initMapDispatchToProps = $494dfd495f2b09e7$var$match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
        var initMergeProps = $494dfd495f2b09e7$var$match(mergeProps, mergePropsFactories, 'mergeProps');
        return connectHOC(selectorFactory, (0, $e133885d0b1e9831$export$2e2bcd8739ae039)({
            // used in error messages
            methodName: 'connect',
            // used to compute Connect's displayName from the wrapped component's displayName.
            getDisplayName: function getDisplayName(name) {
                return "Connect(" + name + ")";
            },
            // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
            shouldHandleStateChanges: Boolean(mapStateToProps),
            // passed through to selectorFactory
            initMapStateToProps: initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            pure: pure,
            areStatesEqual: areStatesEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areStatePropsEqual: areStatePropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        }, extraOptions));
    };
}
var $494dfd495f2b09e7$export$2e2bcd8739ae039 = $494dfd495f2b09e7$export$9f9feb656dec1fc4();





var $9f2792b1a4d099dd$export$1e511d4a378977f5;
var $9f2792b1a4d099dd$export$d32324a03b6bde1b;
var $9f2792b1a4d099dd$export$321b1ffcca858b2b;
'use strict';

var $9f2792b1a4d099dd$require$compose = $1989032bc8d1f610$export$f672e0b6f7222cd7;
$9f2792b1a4d099dd$export$1e511d4a378977f5 = true;
$9f2792b1a4d099dd$export$d32324a03b6bde1b = typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return undefined;
    if (typeof arguments[0] === 'object') return $9f2792b1a4d099dd$require$compose;
    return $9f2792b1a4d099dd$require$compose.apply(null, arguments);
};
$9f2792b1a4d099dd$export$321b1ffcca858b2b = typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop) {
        return noop;
    };
};


/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */ function $8d812d3d1abb780d$var$createThunkMiddleware(extraArgument) {
    // Standard Redux middleware definition pattern:
    // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
    var middleware = function middleware(_ref) {
        var dispatch = _ref.dispatch, getState = _ref.getState;
        return function(next) {
            return function(action) {
                // The thunk middleware looks for any functions that were passed to `store.dispatch`.
                // If this "action" is really a function, call it and return the result.
                if (typeof action === 'function') // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
                return action(dispatch, getState, extraArgument);
                 // Otherwise, pass the action down the middleware chain as usual
                return next(action);
            };
        };
    };
    return middleware;
}
var $8d812d3d1abb780d$var$thunk = $8d812d3d1abb780d$var$createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks
$8d812d3d1abb780d$var$thunk.withExtraArgument = $8d812d3d1abb780d$var$createThunkMiddleware;
var $8d812d3d1abb780d$export$2e2bcd8739ae039 = $8d812d3d1abb780d$var$thunk;


var $82fd33bfdd541d26$exports = {};
'use strict';
Object.defineProperty($82fd33bfdd541d26$exports, "__esModule", {
    value: true
});
$82fd33bfdd541d26$exports.default = $82fd33bfdd541d26$var$immutableStateInvariantMiddleware;

var $1dCkN = parcelRequire("1dCkN");
var $82fd33bfdd541d26$var$_invariant2 = $82fd33bfdd541d26$var$_interopRequireDefault($1dCkN);

var $hCibb = parcelRequire("hCibb");
var $82fd33bfdd541d26$var$_jsonStringifySafe2 = $82fd33bfdd541d26$var$_interopRequireDefault($hCibb);
var $a7d9986fb610907a$exports = {};
'use strict';
Object.defineProperty($a7d9986fb610907a$exports, "__esModule", {
    value: true
});
var $a7d9986fb610907a$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
$a7d9986fb610907a$exports.default = $a7d9986fb610907a$var$isImmutableDefault;
function $a7d9986fb610907a$var$isImmutableDefault(value) {
    return (typeof value === 'undefined' ? 'undefined' : $a7d9986fb610907a$var$_typeof(value)) !== 'object' || value === null || typeof value === 'undefined';
}


var $82fd33bfdd541d26$var$_isImmutable2 = $82fd33bfdd541d26$var$_interopRequireDefault($a7d9986fb610907a$exports);
var $347a87bace656b15$exports = {};
'use strict';
Object.defineProperty($347a87bace656b15$exports, "__esModule", {
    value: true
});
$347a87bace656b15$exports.default = $347a87bace656b15$var$trackForMutations;
function $347a87bace656b15$var$trackForMutations(isImmutable, ignore, obj) {
    var trackedProperties = $347a87bace656b15$var$trackProperties(isImmutable, ignore, obj);
    return {
        detectMutations: function detectMutations() {
            return $347a87bace656b15$var$_detectMutations(isImmutable, ignore, trackedProperties, obj);
        }
    };
}
function $347a87bace656b15$var$trackProperties(isImmutable) {
    var ignore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var obj = arguments[2];
    var path = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    var tracked = {
        value: obj
    };
    if (!isImmutable(obj)) {
        tracked.children = {};
        for(var key in obj){
            var childPath = path.concat(key);
            if (ignore.length && ignore.indexOf(childPath.join('.')) !== -1) continue;
            tracked.children[key] = $347a87bace656b15$var$trackProperties(isImmutable, ignore, obj[key], childPath);
        }
    }
    return tracked;
}
function $347a87bace656b15$var$_detectMutations(isImmutable) {
    var ignore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var trackedProperty = arguments[2];
    var obj = arguments[3];
    var sameParentRef = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var path = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
    var prevObj = trackedProperty ? trackedProperty.value : undefined;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    // Gather all keys from prev (tracked) and after objs
    var keysToDetect = {};
    Object.keys(trackedProperty.children).forEach(function(key) {
        keysToDetect[key] = true;
    });
    Object.keys(obj).forEach(function(key) {
        keysToDetect[key] = true;
    });
    var keys = Object.keys(keysToDetect);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var childPath = path.concat(key);
        if (ignore.length && ignore.indexOf(childPath.join('.')) !== -1) continue;
        var result = $347a87bace656b15$var$_detectMutations(isImmutable, ignore, trackedProperty.children[key], obj[key], sameRef, childPath);
        if (result.wasMutated) return result;
    }
    return {
        wasMutated: false
    };
}


var $82fd33bfdd541d26$var$_trackForMutations2 = $82fd33bfdd541d26$var$_interopRequireDefault($347a87bace656b15$exports);
function $82fd33bfdd541d26$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $82fd33bfdd541d26$var$BETWEEN_DISPATCHES_MESSAGE = [
    'A state mutation was detected between dispatches, in the path `%s`.',
    'This may cause incorrect behavior.',
    '(http://redux.js.org/docs/Troubleshooting.html#never-mutate-reducer-arguments)'
].join(' ');
var $82fd33bfdd541d26$var$INSIDE_DISPATCH_MESSAGE = [
    'A state mutation was detected inside a dispatch, in the path: `%s`.',
    'Take a look at the reducer(s) handling the action %s.',
    '(http://redux.js.org/docs/Troubleshooting.html#never-mutate-reducer-arguments)'
].join(' ');
function $82fd33bfdd541d26$var$immutableStateInvariantMiddleware() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _options$isImmutable = options.isImmutable, isImmutable = _options$isImmutable === undefined ? $82fd33bfdd541d26$var$_isImmutable2.default : _options$isImmutable, ignore = options.ignore;
    var track = $82fd33bfdd541d26$var$_trackForMutations2.default.bind(null, isImmutable, ignore);
    return function(_ref) {
        var getState = _ref.getState;
        var state = getState();
        var tracker = track(state);
        var result = void 0;
        return function(next) {
            return function(action) {
                state = getState();
                result = tracker.detectMutations();
                // Track before potentially not meeting the invariant
                tracker = track(state);
                (0, $82fd33bfdd541d26$var$_invariant2.default)(!result.wasMutated, $82fd33bfdd541d26$var$BETWEEN_DISPATCHES_MESSAGE, (result.path || []).join('.'));
                var dispatchedAction = next(action);
                state = getState();
                result = tracker.detectMutations();
                // Track before potentially not meeting the invariant
                tracker = track(state);
                result.wasMutated && (0, $82fd33bfdd541d26$var$_invariant2.default)(!result.wasMutated, $82fd33bfdd541d26$var$INSIDE_DISPATCH_MESSAGE, (result.path || []).join('.'), (0, $82fd33bfdd541d26$var$_jsonStringifySafe2.default)(action));
                return dispatchedAction;
            };
        };
    };
}



var $iq75z = parcelRequire("iq75z");

var $ca5b0f8f824107ee$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $ca5b0f8f824107ee$var$defineProperty = function(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
};
var $ca5b0f8f824107ee$var$toConsumableArray = function(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $ca5b0f8f824107ee$var$isPlainObject(obj) {
    if ((typeof obj === 'undefined' ? 'undefined' : $ca5b0f8f824107ee$var$_typeof(obj)) !== 'object' || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
function $ca5b0f8f824107ee$export$77670485918dab4e(val) {
    return typeof val === 'undefined' || val === null || typeof val === 'string' || typeof val === 'boolean' || typeof val === 'number' || Array.isArray(val) || $ca5b0f8f824107ee$var$isPlainObject(val);
}
var $ca5b0f8f824107ee$var$NON_SERIALIZABLE_STATE_MESSAGE = [
    'A non-serializable value was detected in the state, in the path: `%s`. Value: %o',
    'Take a look at the reducer(s) handling this action type: %s.',
    '(See https://redux.js.org/faq/organizing-state#can-i-put-functions-promises-or-other-non-serializable-items-in-my-store-state)'
].join('\n');
var $ca5b0f8f824107ee$var$NON_SERIALIZABLE_ACTION_MESSAGE = [
    'A non-serializable value was detected in an action, in the path: `%s`. Value: %o',
    'Take a look at the logic that dispatched this action:  %o.',
    '(See https://redux.js.org/faq/actions#why-should-type-be-a-string-or-at-least-serializable-why-should-my-action-types-be-constants)'
].join('\n');
function $ca5b0f8f824107ee$var$findNonSerializableValue(obj) {
    var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var isSerializable = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $ca5b0f8f824107ee$export$77670485918dab4e;
    var foundNestedSerializable = void 0;
    if (!isSerializable(obj)) return {
        keyPath: path.join('.') || '<root>',
        value: obj
    };
    for(var property in obj)if (obj.hasOwnProperty(property)) {
        var nestedPath = path.concat(property);
        var nestedValue = obj[property];
        if (!isSerializable(nestedValue)) return {
            keyPath: nestedPath.join('.'),
            value: nestedValue
        };
        if ((typeof nestedValue === 'undefined' ? 'undefined' : $ca5b0f8f824107ee$var$_typeof(nestedValue)) === 'object') {
            foundNestedSerializable = $ca5b0f8f824107ee$var$findNonSerializableValue(nestedValue, nestedPath, isSerializable);
            if (foundNestedSerializable) return foundNestedSerializable;
        }
    }
    return false;
}
function $ca5b0f8f824107ee$export$6dea1aad6dac5ac2() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _options$isSerializab = options.isSerializable, isSerializable = _options$isSerializab === undefined ? $ca5b0f8f824107ee$export$77670485918dab4e : _options$isSerializab;
    return function(storeAPI) {
        return function(next) {
            return function(action) {
                var foundActionNonSerializableValue = $ca5b0f8f824107ee$var$findNonSerializableValue(action, [], isSerializable);
                if (foundActionNonSerializableValue) {
                    var keyPath = foundActionNonSerializableValue.keyPath, value = foundActionNonSerializableValue.value;
                    console.error($ca5b0f8f824107ee$var$NON_SERIALIZABLE_ACTION_MESSAGE, keyPath, value, action);
                }
                var result = next(action);
                var state = storeAPI.getState();
                var foundStateNonSerializableValue = $ca5b0f8f824107ee$var$findNonSerializableValue(state);
                if (foundStateNonSerializableValue) {
                    var _keyPath = foundStateNonSerializableValue.keyPath, _value = foundStateNonSerializableValue.value;
                    console.error($ca5b0f8f824107ee$var$NON_SERIALIZABLE_STATE_MESSAGE, _keyPath, _value, action.type);
                }
                return result;
            };
        };
    };
}
var $ca5b0f8f824107ee$var$IS_PRODUCTION = true;
function $ca5b0f8f824107ee$export$36c1185aeee5b0a6() {
    var isProduction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $ca5b0f8f824107ee$var$IS_PRODUCTION;
    var middlewareArray = [
        (0, $8d812d3d1abb780d$export$2e2bcd8739ae039)
    ];
    if (!isProduction) middlewareArray = [
        (0, (/*@__PURE__*/$parcel$interopDefault($82fd33bfdd541d26$exports)))(),
        (0, $8d812d3d1abb780d$export$2e2bcd8739ae039),
        $ca5b0f8f824107ee$export$6dea1aad6dac5ac2()
    ];
    return middlewareArray;
}
function $ca5b0f8f824107ee$export$7d8a5b498da695ac() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var reducer = options.reducer, _options$middleware = options.middleware, middleware = _options$middleware === undefined ? $ca5b0f8f824107ee$export$36c1185aeee5b0a6() : _options$middleware, _options$devTools = options.devTools, devTools = _options$devTools === undefined ? true : _options$devTools, preloadedState = options.preloadedState, _options$enhancers = options.enhancers, enhancers = _options$enhancers === undefined ? [] : _options$enhancers;
    var rootReducer = void 0;
    if (typeof reducer === 'function') rootReducer = reducer;
    else if ($ca5b0f8f824107ee$var$isPlainObject(reducer)) rootReducer = (0, $1989032bc8d1f610$export$66e4520cdb265d18)(reducer);
    else throw new Error('Reducer argument must be a function or an object of functions that can be passed to combineReducers');
    var middlewareEnhancer = (0, $1989032bc8d1f610$export$9ff26e0402cc7b7).apply(undefined, $ca5b0f8f824107ee$var$toConsumableArray(middleware));
    var finalCompose = (0, $1989032bc8d1f610$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = (0, $9f2792b1a4d099dd$export$d32324a03b6bde1b)({
        // Enable capture of stack traces for dispatched Redux actions
        trace: !$ca5b0f8f824107ee$var$IS_PRODUCTION
    });
    var storeEnhancers = [
        middlewareEnhancer
    ].concat($ca5b0f8f824107ee$var$toConsumableArray(enhancers));
    var composedEnhancer = finalCompose.apply(undefined, $ca5b0f8f824107ee$var$toConsumableArray(storeEnhancers));
    var store = (0, $1989032bc8d1f610$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
    return store;
}
function $ca5b0f8f824107ee$export$473eb76d322d0290(initialState, actionsMap) {
    return function() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
        var action = arguments[1];
        return (0, $iq75z.default)(state, function(draft) {
            var caseReducer = actionsMap[action.type];
            if (caseReducer) return caseReducer(draft, action);
            return draft;
        });
    };
}
function $ca5b0f8f824107ee$export$309c7a02b0b0bc62(type) {
    var action = function action(payload) {
        return {
            type: type,
            payload: payload
        };
    };
    action.toString = function() {
        return "" + type;
    };
    return action;
}
var $ca5b0f8f824107ee$export$e2b5c5db9e2009fd = function getType(action) {
    return "" + action;
};
function $ca5b0f8f824107ee$var$createSliceSelector(slice) {
    if (!slice) return function(state) {
        return state;
    };
    return function(state) {
        return state[slice];
    };
}
function $ca5b0f8f824107ee$var$createSelectorName(slice) {
    if (!slice) return 'getState';
    return $ca5b0f8f824107ee$var$camelize('get ' + slice);
}
function $ca5b0f8f824107ee$var$camelize(str) {
    return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(letter, index) {
        return index === 0 ? letter.toLowerCase() : letter.toUpperCase();
    }).replace(/\s+/g, '').replace(/[-_]/g, '');
}
var $ca5b0f8f824107ee$var$getType$1 = function getType$$1(slice, action) {
    return slice ? slice + '/' + action : action;
};
function $ca5b0f8f824107ee$export$4d8d9bd83c24ae8b(_ref) {
    var _ref$slice = _ref.slice, slice = _ref$slice === undefined ? '' : _ref$slice, _ref$reducers = _ref.reducers, reducers = _ref$reducers === undefined ? {} : _ref$reducers, initialState = _ref.initialState;
    var actionKeys = Object.keys(reducers);
    var reducerMap = actionKeys.reduce(function(map, action) {
        map[$ca5b0f8f824107ee$var$getType$1(slice, action)] = reducers[action];
        return map;
    }, {});
    var reducer = $ca5b0f8f824107ee$export$473eb76d322d0290(initialState, reducerMap);
    var actionMap = actionKeys.reduce(function(map, action) {
        var type = $ca5b0f8f824107ee$var$getType$1(slice, action);
        map[action] = $ca5b0f8f824107ee$export$309c7a02b0b0bc62(type);
        return map;
    }, {});
    var selectors = $ca5b0f8f824107ee$var$defineProperty({}, $ca5b0f8f824107ee$var$createSelectorName(slice), $ca5b0f8f824107ee$var$createSliceSelector(slice));
    return {
        actions: actionMap,
        reducer: reducer,
        slice: slice,
        selectors: selectors
    };
}



var $e85b5c20f8f311b0$exports = {};
/*!
    localForage -- Offline Storage, Improved
    Version 1.10.0
    https://localforage.github.io/localForage
    (c) 2013-2017 Mozilla, Apache License 2.0
*/ (function(f) {
    var g;
    $e85b5c20f8f311b0$exports = f();
})(function() {
    var define, module1, exports;
    return (function e(t, n, r) {
        function s(o, u) {
            if (!n[o]) {
                if (!t[o]) {
                    var a = undefined;
                    if (!u && a) return a(o, !0);
                    if (i) return i(o, !0);
                    var f = new Error("Cannot find module '" + o + "'");
                    throw f.code = "MODULE_NOT_FOUND", f;
                }
                var l = n[o] = {
                    exports: {}
                };
                t[o][0].call(l.exports, function(e) {
                    var n = t[o][1][e];
                    return s(n ? n : e);
                }, l, l.exports, e, t, n, r);
            }
            return n[o].exports;
        }
        var i = undefined;
        for(var o = 0; o < r.length; o++)s(r[o]);
        return s;
    })({
        1: [
            function(_dereq_, module1, exports) {
                (function(global1) {
                    'use strict';
                    var Mutation = global1.MutationObserver || global1.WebKitMutationObserver;
                    var scheduleDrain;
                    if (Mutation) {
                        var called = 0;
                        var observer = new Mutation(nextTick);
                        var element = global1.document.createTextNode('');
                        observer.observe(element, {
                            characterData: true
                        });
                        scheduleDrain = function() {
                            element.data = called = ++called % 2;
                        };
                    } else if (!global1.setImmediate && typeof global1.MessageChannel !== 'undefined') {
                        var channel = new global1.MessageChannel();
                        channel.port1.onmessage = nextTick;
                        scheduleDrain = function() {
                            channel.port2.postMessage(0);
                        };
                    } else if ('document' in global1 && 'onreadystatechange' in global1.document.createElement('script')) scheduleDrain = function() {
                        // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
                        // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
                        var scriptEl = global1.document.createElement('script');
                        scriptEl.onreadystatechange = function() {
                            nextTick();
                            scriptEl.onreadystatechange = null;
                            scriptEl.parentNode.removeChild(scriptEl);
                            scriptEl = null;
                        };
                        global1.document.documentElement.appendChild(scriptEl);
                    };
                    else scheduleDrain = function() {
                        setTimeout(nextTick, 0);
                    };
                    var draining;
                    var queue = [];
                    //named nextTick for less confusing stack traces
                    function nextTick() {
                        draining = true;
                        var i, oldQueue;
                        var len = queue.length;
                        while(len){
                            oldQueue = queue;
                            queue = [];
                            i = -1;
                            while(++i < len)oldQueue[i]();
                            len = queue.length;
                        }
                        draining = false;
                    }
                    module1.exports = immediate;
                    function immediate(task) {
                        if (queue.push(task) === 1 && !draining) scheduleDrain();
                    }
                }).call(this, typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
            },
            {}
        ],
        2: [
            function(_dereq_, module1, exports) {
                'use strict';
                var immediate = _dereq_(1);
                /* istanbul ignore next */ function INTERNAL() {}
                var handlers = {};
                var REJECTED = [
                    'REJECTED'
                ];
                var FULFILLED = [
                    'FULFILLED'
                ];
                var PENDING = [
                    'PENDING'
                ];
                module1.exports = Promise1;
                function Promise1(resolver) {
                    if (typeof resolver !== 'function') throw new TypeError('resolver must be a function');
                    this.state = PENDING;
                    this.queue = [];
                    this.outcome = void 0;
                    if (resolver !== INTERNAL) safelyResolveThenable(this, resolver);
                }
                Promise1.prototype["catch"] = function(onRejected) {
                    return this.then(null, onRejected);
                };
                Promise1.prototype.then = function(onFulfilled, onRejected) {
                    if (typeof onFulfilled !== 'function' && this.state === FULFILLED || typeof onRejected !== 'function' && this.state === REJECTED) return this;
                    var promise = new this.constructor(INTERNAL);
                    if (this.state !== PENDING) {
                        var resolver = this.state === FULFILLED ? onFulfilled : onRejected;
                        unwrap(promise, resolver, this.outcome);
                    } else this.queue.push(new QueueItem(promise, onFulfilled, onRejected));
                    return promise;
                };
                function QueueItem(promise, onFulfilled, onRejected) {
                    this.promise = promise;
                    if (typeof onFulfilled === 'function') {
                        this.onFulfilled = onFulfilled;
                        this.callFulfilled = this.otherCallFulfilled;
                    }
                    if (typeof onRejected === 'function') {
                        this.onRejected = onRejected;
                        this.callRejected = this.otherCallRejected;
                    }
                }
                QueueItem.prototype.callFulfilled = function(value) {
                    handlers.resolve(this.promise, value);
                };
                QueueItem.prototype.otherCallFulfilled = function(value) {
                    unwrap(this.promise, this.onFulfilled, value);
                };
                QueueItem.prototype.callRejected = function(value) {
                    handlers.reject(this.promise, value);
                };
                QueueItem.prototype.otherCallRejected = function(value) {
                    unwrap(this.promise, this.onRejected, value);
                };
                function unwrap(promise, func, value) {
                    immediate(function() {
                        var returnValue;
                        try {
                            returnValue = func(value);
                        } catch (e) {
                            return handlers.reject(promise, e);
                        }
                        if (returnValue === promise) handlers.reject(promise, new TypeError('Cannot resolve promise with itself'));
                        else handlers.resolve(promise, returnValue);
                    });
                }
                handlers.resolve = function(self1, value) {
                    var result = tryCatch(getThen, value);
                    if (result.status === 'error') return handlers.reject(self1, result.value);
                    var thenable = result.value;
                    if (thenable) safelyResolveThenable(self1, thenable);
                    else {
                        self1.state = FULFILLED;
                        self1.outcome = value;
                        var i = -1;
                        var len = self1.queue.length;
                        while(++i < len)self1.queue[i].callFulfilled(value);
                    }
                    return self1;
                };
                handlers.reject = function(self1, error) {
                    self1.state = REJECTED;
                    self1.outcome = error;
                    var i = -1;
                    var len = self1.queue.length;
                    while(++i < len)self1.queue[i].callRejected(error);
                    return self1;
                };
                function getThen(obj) {
                    // Make sure we only access the accessor once as required by the spec
                    var then = obj && obj.then;
                    if (obj && (typeof obj === 'object' || typeof obj === 'function') && typeof then === 'function') return function appyThen() {
                        then.apply(obj, arguments);
                    };
                }
                function safelyResolveThenable(self1, thenable) {
                    // Either fulfill, reject or reject with error
                    var called = false;
                    function onError(value) {
                        if (called) return;
                        called = true;
                        handlers.reject(self1, value);
                    }
                    function onSuccess(value) {
                        if (called) return;
                        called = true;
                        handlers.resolve(self1, value);
                    }
                    function tryToUnwrap() {
                        thenable(onSuccess, onError);
                    }
                    var result = tryCatch(tryToUnwrap);
                    if (result.status === 'error') onError(result.value);
                }
                function tryCatch(func, value) {
                    var out = {};
                    try {
                        out.value = func(value);
                        out.status = 'success';
                    } catch (e) {
                        out.status = 'error';
                        out.value = e;
                    }
                    return out;
                }
                Promise1.resolve = resolve;
                function resolve(value) {
                    if (value instanceof this) return value;
                    return handlers.resolve(new this(INTERNAL), value);
                }
                Promise1.reject = reject;
                function reject(reason) {
                    var promise = new this(INTERNAL);
                    return handlers.reject(promise, reason);
                }
                Promise1.all = all;
                function all(iterable) {
                    var self1 = this;
                    if (Object.prototype.toString.call(iterable) !== '[object Array]') return this.reject(new TypeError('must be an array'));
                    var len = iterable.length;
                    var called = false;
                    if (!len) return this.resolve([]);
                    var values = new Array(len);
                    var resolved = 0;
                    var i = -1;
                    var promise = new this(INTERNAL);
                    while(++i < len)allResolver(iterable[i], i);
                    return promise;
                    function allResolver(value, i) {
                        self1.resolve(value).then(resolveFromAll, function(error) {
                            if (!called) {
                                called = true;
                                handlers.reject(promise, error);
                            }
                        });
                        function resolveFromAll(outValue) {
                            values[i] = outValue;
                            if (++resolved === len && !called) {
                                called = true;
                                handlers.resolve(promise, values);
                            }
                        }
                    }
                }
                Promise1.race = race;
                function race(iterable) {
                    var self1 = this;
                    if (Object.prototype.toString.call(iterable) !== '[object Array]') return this.reject(new TypeError('must be an array'));
                    var len = iterable.length;
                    var called = false;
                    if (!len) return this.resolve([]);
                    var i = -1;
                    var promise = new this(INTERNAL);
                    while(++i < len)resolver(iterable[i]);
                    return promise;
                    function resolver(value) {
                        self1.resolve(value).then(function(response) {
                            if (!called) {
                                called = true;
                                handlers.resolve(promise, response);
                            }
                        }, function(error) {
                            if (!called) {
                                called = true;
                                handlers.reject(promise, error);
                            }
                        });
                    }
                }
            },
            {
                "1": 1
            }
        ],
        3: [
            function(_dereq_, module1, exports) {
                (function(global1) {
                    'use strict';
                    if (typeof global1.Promise !== 'function') global1.Promise = _dereq_(2);
                }).call(this, typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
            },
            {
                "2": 2
            }
        ],
        4: [
            function(_dereq_, module1, exports) {
                'use strict';
                var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                };
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function getIDB() {
                    /* global indexedDB,webkitIndexedDB,mozIndexedDB,OIndexedDB,msIndexedDB */ try {
                        if (typeof indexedDB !== 'undefined') return indexedDB;
                        if (typeof webkitIndexedDB !== 'undefined') return webkitIndexedDB;
                        if (typeof mozIndexedDB !== 'undefined') return mozIndexedDB;
                        if (typeof OIndexedDB !== 'undefined') return OIndexedDB;
                        if (typeof msIndexedDB !== 'undefined') return msIndexedDB;
                    } catch (e) {
                        return;
                    }
                }
                var idb = getIDB();
                function isIndexedDBValid() {
                    try {
                        // Initialize IndexedDB; fall back to vendor-prefixed versions
                        // if needed.
                        if (!idb || !idb.open) return false;
                        // We mimic PouchDB here;
                        //
                        // We test for openDatabase because IE Mobile identifies itself
                        // as Safari. Oh the lulz...
                        var isSafari = typeof openDatabase !== 'undefined' && /(Safari|iPhone|iPad|iPod)/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent) && !/BlackBerry/.test(navigator.platform);
                        var hasFetch = typeof fetch === 'function' && fetch.toString().indexOf('[native code') !== -1;
                        // Safari <10.1 does not meet our requirements for IDB support
                        // (see: https://github.com/pouchdb/pouchdb/issues/5572).
                        // Safari 10.1 shipped with fetch, we can use that to detect it.
                        // Note: this creates issues with `window.fetch` polyfills and
                        // overrides; see:
                        // https://github.com/localForage/localForage/issues/856
                        return (!isSafari || hasFetch) && typeof indexedDB !== 'undefined' && // some outdated implementations of IDB that appear on Samsung
                        // and HTC Android devices <4.4 are missing IDBKeyRange
                        // See: https://github.com/mozilla/localForage/issues/128
                        // See: https://github.com/mozilla/localForage/issues/272
                        typeof IDBKeyRange !== 'undefined';
                    } catch (e) {
                        return false;
                    }
                }
                // Abstracts constructing a Blob object, so it also works in older
                // browsers that don't support the native Blob constructor. (i.e.
                // old QtWebKit versions, at least).
                // Abstracts constructing a Blob object, so it also works in older
                // browsers that don't support the native Blob constructor. (i.e.
                // old QtWebKit versions, at least).
                function createBlob(parts, properties) {
                    /* global BlobBuilder,MSBlobBuilder,MozBlobBuilder,WebKitBlobBuilder */ parts = parts || [];
                    properties = properties || {};
                    try {
                        return new Blob(parts, properties);
                    } catch (e) {
                        if (e.name !== 'TypeError') throw e;
                        var Builder = typeof BlobBuilder !== 'undefined' ? BlobBuilder : typeof MSBlobBuilder !== 'undefined' ? MSBlobBuilder : typeof MozBlobBuilder !== 'undefined' ? MozBlobBuilder : WebKitBlobBuilder;
                        var builder = new Builder();
                        for(var i = 0; i < parts.length; i += 1)builder.append(parts[i]);
                        return builder.getBlob(properties.type);
                    }
                }
                // This is CommonJS because lie is an external dependency, so Rollup
                // can just ignore it.
                if (typeof Promise === 'undefined') // In the "nopromises" build this will just throw if you don't have
                // a global promise object, but it would throw anyway later.
                _dereq_(3);
                var Promise$1 = Promise;
                function executeCallback(promise, callback) {
                    if (callback) promise.then(function(result) {
                        callback(null, result);
                    }, function(error) {
                        callback(error);
                    });
                }
                function executeTwoCallbacks(promise, callback, errorCallback) {
                    if (typeof callback === 'function') promise.then(callback);
                    if (typeof errorCallback === 'function') promise["catch"](errorCallback);
                }
                function normalizeKey(key) {
                    // Cast the key to a string, as that's all we can set as a key.
                    if (typeof key !== 'string') {
                        console.warn(key + ' used as a key, but it is not a string.');
                        key = String(key);
                    }
                    return key;
                }
                function getCallback() {
                    if (arguments.length && typeof arguments[arguments.length - 1] === 'function') return arguments[arguments.length - 1];
                }
                // Some code originally from async_storage.js in
                // [Gaia](https://github.com/mozilla-b2g/gaia).
                var DETECT_BLOB_SUPPORT_STORE = 'local-forage-detect-blob-support';
                var supportsBlobs = void 0;
                var dbContexts = {};
                var toString = Object.prototype.toString;
                // Transaction Modes
                var READ_ONLY = 'readonly';
                var READ_WRITE = 'readwrite';
                // Transform a binary string to an array buffer, because otherwise
                // weird stuff happens when you try to work with the binary string directly.
                // It is known.
                // From http://stackoverflow.com/questions/14967647/ (continues on next line)
                // encode-decode-image-with-base64-breaks-image (2013-04-21)
                function _binStringToArrayBuffer(bin) {
                    var length = bin.length;
                    var buf = new ArrayBuffer(length);
                    var arr = new Uint8Array(buf);
                    for(var i = 0; i < length; i++)arr[i] = bin.charCodeAt(i);
                    return buf;
                }
                //
                // Blobs are not supported in all versions of IndexedDB, notably
                // Chrome <37 and Android <5. In those versions, storing a blob will throw.
                //
                // Various other blob bugs exist in Chrome v37-42 (inclusive).
                // Detecting them is expensive and confusing to users, and Chrome 37-42
                // is at very low usage worldwide, so we do a hacky userAgent check instead.
                //
                // content-type bug: https://code.google.com/p/chromium/issues/detail?id=408120
                // 404 bug: https://code.google.com/p/chromium/issues/detail?id=447916
                // FileReader bug: https://code.google.com/p/chromium/issues/detail?id=447836
                //
                // Code borrowed from PouchDB. See:
                // https://github.com/pouchdb/pouchdb/blob/master/packages/node_modules/pouchdb-adapter-idb/src/blobSupport.js
                //
                function _checkBlobSupportWithoutCaching(idb) {
                    return new Promise$1(function(resolve) {
                        var txn = idb.transaction(DETECT_BLOB_SUPPORT_STORE, READ_WRITE);
                        var blob = createBlob([
                            ''
                        ]);
                        txn.objectStore(DETECT_BLOB_SUPPORT_STORE).put(blob, 'key');
                        txn.onabort = function(e) {
                            // If the transaction aborts now its due to not being able to
                            // write to the database, likely due to the disk being full
                            e.preventDefault();
                            e.stopPropagation();
                            resolve(false);
                        };
                        txn.oncomplete = function() {
                            var matchedChrome = navigator.userAgent.match(/Chrome\/(\d+)/);
                            var matchedEdge = navigator.userAgent.match(/Edge\//);
                            // MS Edge pretends to be Chrome 42:
                            // https://msdn.microsoft.com/en-us/library/hh869301%28v=vs.85%29.aspx
                            resolve(matchedEdge || !matchedChrome || parseInt(matchedChrome[1], 10) >= 43);
                        };
                    })["catch"](function() {
                        return false; // error, so assume unsupported
                    });
                }
                function _checkBlobSupport(idb) {
                    if (typeof supportsBlobs === 'boolean') return Promise$1.resolve(supportsBlobs);
                    return _checkBlobSupportWithoutCaching(idb).then(function(value) {
                        supportsBlobs = value;
                        return supportsBlobs;
                    });
                }
                function _deferReadiness(dbInfo) {
                    var dbContext = dbContexts[dbInfo.name];
                    // Create a deferred object representing the current database operation.
                    var deferredOperation = {};
                    deferredOperation.promise = new Promise$1(function(resolve, reject) {
                        deferredOperation.resolve = resolve;
                        deferredOperation.reject = reject;
                    });
                    // Enqueue the deferred operation.
                    dbContext.deferredOperations.push(deferredOperation);
                    // Chain its promise to the database readiness.
                    if (!dbContext.dbReady) dbContext.dbReady = deferredOperation.promise;
                    else dbContext.dbReady = dbContext.dbReady.then(function() {
                        return deferredOperation.promise;
                    });
                }
                function _advanceReadiness(dbInfo) {
                    var dbContext = dbContexts[dbInfo.name];
                    // Dequeue a deferred operation.
                    var deferredOperation = dbContext.deferredOperations.pop();
                    // Resolve its promise (which is part of the database readiness
                    // chain of promises).
                    if (deferredOperation) {
                        deferredOperation.resolve();
                        return deferredOperation.promise;
                    }
                }
                function _rejectReadiness(dbInfo, err) {
                    var dbContext = dbContexts[dbInfo.name];
                    // Dequeue a deferred operation.
                    var deferredOperation = dbContext.deferredOperations.pop();
                    // Reject its promise (which is part of the database readiness
                    // chain of promises).
                    if (deferredOperation) {
                        deferredOperation.reject(err);
                        return deferredOperation.promise;
                    }
                }
                function _getConnection(dbInfo, upgradeNeeded) {
                    return new Promise$1(function(resolve, reject) {
                        dbContexts[dbInfo.name] = dbContexts[dbInfo.name] || createDbContext();
                        if (dbInfo.db) {
                            if (upgradeNeeded) {
                                _deferReadiness(dbInfo);
                                dbInfo.db.close();
                            } else return resolve(dbInfo.db);
                        }
                        var dbArgs = [
                            dbInfo.name
                        ];
                        if (upgradeNeeded) dbArgs.push(dbInfo.version);
                        var openreq = idb.open.apply(idb, dbArgs);
                        if (upgradeNeeded) openreq.onupgradeneeded = function(e) {
                            var db = openreq.result;
                            try {
                                db.createObjectStore(dbInfo.storeName);
                                if (e.oldVersion <= 1) // Added when support for blob shims was added
                                db.createObjectStore(DETECT_BLOB_SUPPORT_STORE);
                            } catch (ex) {
                                if (ex.name === 'ConstraintError') console.warn('The database "' + dbInfo.name + '"' + ' has been upgraded from version ' + e.oldVersion + ' to version ' + e.newVersion + ', but the storage "' + dbInfo.storeName + '" already exists.');
                                else throw ex;
                            }
                        };
                        openreq.onerror = function(e) {
                            e.preventDefault();
                            reject(openreq.error);
                        };
                        openreq.onsuccess = function() {
                            var db = openreq.result;
                            db.onversionchange = function(e) {
                                // Triggered when the database is modified (e.g. adding an objectStore) or
                                // deleted (even when initiated by other sessions in different tabs).
                                // Closing the connection here prevents those operations from being blocked.
                                // If the database is accessed again later by this instance, the connection
                                // will be reopened or the database recreated as needed.
                                e.target.close();
                            };
                            resolve(db);
                            _advanceReadiness(dbInfo);
                        };
                    });
                }
                function _getOriginalConnection(dbInfo) {
                    return _getConnection(dbInfo, false);
                }
                function _getUpgradedConnection(dbInfo) {
                    return _getConnection(dbInfo, true);
                }
                function _isUpgradeNeeded(dbInfo, defaultVersion) {
                    if (!dbInfo.db) return true;
                    var isNewStore = !dbInfo.db.objectStoreNames.contains(dbInfo.storeName);
                    var isDowngrade = dbInfo.version < dbInfo.db.version;
                    var isUpgrade = dbInfo.version > dbInfo.db.version;
                    if (isDowngrade) {
                        // If the version is not the default one
                        // then warn for impossible downgrade.
                        if (dbInfo.version !== defaultVersion) console.warn('The database "' + dbInfo.name + '"' + " can't be downgraded from version " + dbInfo.db.version + ' to version ' + dbInfo.version + '.');
                        // Align the versions to prevent errors.
                        dbInfo.version = dbInfo.db.version;
                    }
                    if (isUpgrade || isNewStore) {
                        // If the store is new then increment the version (if needed).
                        // This will trigger an "upgradeneeded" event which is required
                        // for creating a store.
                        if (isNewStore) {
                            var incVersion = dbInfo.db.version + 1;
                            if (incVersion > dbInfo.version) dbInfo.version = incVersion;
                        }
                        return true;
                    }
                    return false;
                }
                // encode a blob for indexeddb engines that don't support blobs
                function _encodeBlob(blob) {
                    return new Promise$1(function(resolve, reject) {
                        var reader = new FileReader();
                        reader.onerror = reject;
                        reader.onloadend = function(e) {
                            var base64 = btoa(e.target.result || '');
                            resolve({
                                __local_forage_encoded_blob: true,
                                data: base64,
                                type: blob.type
                            });
                        };
                        reader.readAsBinaryString(blob);
                    });
                }
                // decode an encoded blob
                function _decodeBlob(encodedBlob) {
                    var arrayBuff = _binStringToArrayBuffer(atob(encodedBlob.data));
                    return createBlob([
                        arrayBuff
                    ], {
                        type: encodedBlob.type
                    });
                }
                // is this one of our fancy encoded blobs?
                function _isEncodedBlob(value) {
                    return value && value.__local_forage_encoded_blob;
                }
                // Specialize the default `ready()` function by making it dependent
                // on the current database operations. Thus, the driver will be actually
                // ready when it's been initialized (default) *and* there are no pending
                // operations on the database (initiated by some other instances).
                function _fullyReady(callback) {
                    var self1 = this;
                    var promise = self1._initReady().then(function() {
                        var dbContext = dbContexts[self1._dbInfo.name];
                        if (dbContext && dbContext.dbReady) return dbContext.dbReady;
                    });
                    executeTwoCallbacks(promise, callback, callback);
                    return promise;
                }
                // Try to establish a new db connection to replace the
                // current one which is broken (i.e. experiencing
                // InvalidStateError while creating a transaction).
                function _tryReconnect(dbInfo) {
                    _deferReadiness(dbInfo);
                    var dbContext = dbContexts[dbInfo.name];
                    var forages = dbContext.forages;
                    for(var i = 0; i < forages.length; i++){
                        var forage = forages[i];
                        if (forage._dbInfo.db) {
                            forage._dbInfo.db.close();
                            forage._dbInfo.db = null;
                        }
                    }
                    dbInfo.db = null;
                    return _getOriginalConnection(dbInfo).then(function(db) {
                        dbInfo.db = db;
                        if (_isUpgradeNeeded(dbInfo)) // Reopen the database for upgrading.
                        return _getUpgradedConnection(dbInfo);
                        return db;
                    }).then(function(db) {
                        // store the latest db reference
                        // in case the db was upgraded
                        dbInfo.db = dbContext.db = db;
                        for(var i = 0; i < forages.length; i++)forages[i]._dbInfo.db = db;
                    })["catch"](function(err) {
                        _rejectReadiness(dbInfo, err);
                        throw err;
                    });
                }
                // FF doesn't like Promises (micro-tasks) and IDDB store operations,
                // so we have to do it with callbacks
                function createTransaction(dbInfo, mode, callback, retries) {
                    if (retries === undefined) retries = 1;
                    try {
                        var tx = dbInfo.db.transaction(dbInfo.storeName, mode);
                        callback(null, tx);
                    } catch (err) {
                        if (retries > 0 && (!dbInfo.db || err.name === 'InvalidStateError' || err.name === 'NotFoundError')) return Promise$1.resolve().then(function() {
                            if (!dbInfo.db || err.name === 'NotFoundError' && !dbInfo.db.objectStoreNames.contains(dbInfo.storeName) && dbInfo.version <= dbInfo.db.version) {
                                // increase the db version, to create the new ObjectStore
                                if (dbInfo.db) dbInfo.version = dbInfo.db.version + 1;
                                // Reopen the database for upgrading.
                                return _getUpgradedConnection(dbInfo);
                            }
                        }).then(function() {
                            return _tryReconnect(dbInfo).then(function() {
                                createTransaction(dbInfo, mode, callback, retries - 1);
                            });
                        })["catch"](callback);
                        callback(err);
                    }
                }
                function createDbContext() {
                    return {
                        // Running localForages sharing a database.
                        forages: [],
                        // Shared database.
                        db: null,
                        // Database readiness (promise).
                        dbReady: null,
                        // Deferred operations on the database.
                        deferredOperations: []
                    };
                }
                // Open the IndexedDB database (automatically creates one if one didn't
                // previously exist), using any options set in the config.
                function _initStorage(options) {
                    var self1 = this;
                    var dbInfo = {
                        db: null
                    };
                    if (options) for(var i in options)dbInfo[i] = options[i];
                    // Get the current context of the database;
                    var dbContext = dbContexts[dbInfo.name];
                    // ...or create a new context.
                    if (!dbContext) {
                        dbContext = createDbContext();
                        // Register the new context in the global container.
                        dbContexts[dbInfo.name] = dbContext;
                    }
                    // Register itself as a running localForage in the current context.
                    dbContext.forages.push(self1);
                    // Replace the default `ready()` function with the specialized one.
                    if (!self1._initReady) {
                        self1._initReady = self1.ready;
                        self1.ready = _fullyReady;
                    }
                    // Create an array of initialization states of the related localForages.
                    var initPromises = [];
                    function ignoreErrors() {
                        // Don't handle errors here,
                        // just makes sure related localForages aren't pending.
                        return Promise$1.resolve();
                    }
                    for(var j = 0; j < dbContext.forages.length; j++){
                        var forage = dbContext.forages[j];
                        if (forage !== self1) // Don't wait for itself...
                        initPromises.push(forage._initReady()["catch"](ignoreErrors));
                    }
                    // Take a snapshot of the related localForages.
                    var forages = dbContext.forages.slice(0);
                    // Initialize the connection process only when
                    // all the related localForages aren't pending.
                    return Promise$1.all(initPromises).then(function() {
                        dbInfo.db = dbContext.db;
                        // Get the connection or open a new one without upgrade.
                        return _getOriginalConnection(dbInfo);
                    }).then(function(db) {
                        dbInfo.db = db;
                        if (_isUpgradeNeeded(dbInfo, self1._defaultConfig.version)) // Reopen the database for upgrading.
                        return _getUpgradedConnection(dbInfo);
                        return db;
                    }).then(function(db) {
                        dbInfo.db = dbContext.db = db;
                        self1._dbInfo = dbInfo;
                        // Share the final connection amongst related localForages.
                        for(var k = 0; k < forages.length; k++){
                            var forage = forages[k];
                            if (forage !== self1) {
                                // Self is already up-to-date.
                                forage._dbInfo.db = dbInfo.db;
                                forage._dbInfo.version = dbInfo.version;
                            }
                        }
                    });
                }
                function getItem(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.get(key);
                                    req.onsuccess = function() {
                                        var value = req.result;
                                        if (value === undefined) value = null;
                                        if (_isEncodedBlob(value)) value = _decodeBlob(value);
                                        resolve(value);
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Iterate over all items stored in database.
                function iterate(iterator, callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.openCursor();
                                    var iterationNumber = 1;
                                    req.onsuccess = function() {
                                        var cursor = req.result;
                                        if (cursor) {
                                            var value = cursor.value;
                                            if (_isEncodedBlob(value)) value = _decodeBlob(value);
                                            var result = iterator(value, cursor.key, iterationNumber++);
                                            // when the iterator callback returns any
                                            // (non-`undefined`) value, then we stop
                                            // the iteration immediately
                                            if (result !== void 0) resolve(result);
                                            else cursor["continue"]();
                                        } else resolve();
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function setItem(key, value, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        var dbInfo;
                        self1.ready().then(function() {
                            dbInfo = self1._dbInfo;
                            if (toString.call(value) === '[object Blob]') return _checkBlobSupport(dbInfo.db).then(function(blobSupport) {
                                if (blobSupport) return value;
                                return _encodeBlob(value);
                            });
                            return value;
                        }).then(function(value) {
                            createTransaction(self1._dbInfo, READ_WRITE, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    // The reason we don't _save_ null is because IE 10 does
                                    // not support saving the `null` type in IndexedDB. How
                                    // ironic, given the bug below!
                                    // See: https://github.com/mozilla/localForage/issues/161
                                    if (value === null) value = undefined;
                                    var req = store.put(value, key);
                                    transaction.oncomplete = function() {
                                        // Cast to undefined so the value passed to
                                        // callback/promise is the same as what one would get out
                                        // of `getItem()` later. This leads to some weirdness
                                        // (setItem('foo', undefined) will return `null`), but
                                        // it's not my fault localStorage is our baseline and that
                                        // it's weird.
                                        if (value === undefined) value = null;
                                        resolve(value);
                                    };
                                    transaction.onabort = transaction.onerror = function() {
                                        var err = req.error ? req.error : req.transaction.error;
                                        reject(err);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function removeItem(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_WRITE, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    // We use a Grunt task to make this safe for IE and some
                                    // versions of Android (including those used by Cordova).
                                    // Normally IE won't like `.delete()` and will insist on
                                    // using `['delete']()`, but we have a build step that
                                    // fixes this for us now.
                                    var req = store["delete"](key);
                                    transaction.oncomplete = function() {
                                        resolve();
                                    };
                                    transaction.onerror = function() {
                                        reject(req.error);
                                    };
                                    // The request will be also be aborted if we've exceeded our storage
                                    // space.
                                    transaction.onabort = function() {
                                        var err = req.error ? req.error : req.transaction.error;
                                        reject(err);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function clear(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_WRITE, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.clear();
                                    transaction.oncomplete = function() {
                                        resolve();
                                    };
                                    transaction.onabort = transaction.onerror = function() {
                                        var err = req.error ? req.error : req.transaction.error;
                                        reject(err);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function length(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.count();
                                    req.onsuccess = function() {
                                        resolve(req.result);
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function key(n, callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        if (n < 0) {
                            resolve(null);
                            return;
                        }
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var advanced = false;
                                    var req = store.openKeyCursor();
                                    req.onsuccess = function() {
                                        var cursor = req.result;
                                        if (!cursor) {
                                            // this means there weren't enough keys
                                            resolve(null);
                                            return;
                                        }
                                        if (n === 0) // We have the first key, return it if that's what they
                                        // wanted.
                                        resolve(cursor.key);
                                        else if (!advanced) {
                                            // Otherwise, ask the cursor to skip ahead n
                                            // records.
                                            advanced = true;
                                            cursor.advance(n);
                                        } else // When we get here, we've got the nth key.
                                        resolve(cursor.key);
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function keys(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.openKeyCursor();
                                    var keys = [];
                                    req.onsuccess = function() {
                                        var cursor = req.result;
                                        if (!cursor) {
                                            resolve(keys);
                                            return;
                                        }
                                        keys.push(cursor.key);
                                        cursor["continue"]();
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function dropInstance(options, callback) {
                    callback = getCallback.apply(this, arguments);
                    var currentConfig = this.config();
                    options = typeof options !== 'function' && options || {};
                    if (!options.name) {
                        options.name = options.name || currentConfig.name;
                        options.storeName = options.storeName || currentConfig.storeName;
                    }
                    var self1 = this;
                    var promise;
                    if (!options.name) promise = Promise$1.reject('Invalid arguments');
                    else {
                        var isCurrentDb = options.name === currentConfig.name && self1._dbInfo.db;
                        var dbPromise = isCurrentDb ? Promise$1.resolve(self1._dbInfo.db) : _getOriginalConnection(options).then(function(db) {
                            var dbContext = dbContexts[options.name];
                            var forages = dbContext.forages;
                            dbContext.db = db;
                            for(var i = 0; i < forages.length; i++)forages[i]._dbInfo.db = db;
                            return db;
                        });
                        if (!options.storeName) promise = dbPromise.then(function(db) {
                            _deferReadiness(options);
                            var dbContext = dbContexts[options.name];
                            var forages = dbContext.forages;
                            db.close();
                            for(var i = 0; i < forages.length; i++){
                                var forage = forages[i];
                                forage._dbInfo.db = null;
                            }
                            var dropDBPromise = new Promise$1(function(resolve, reject) {
                                var req = idb.deleteDatabase(options.name);
                                req.onerror = function() {
                                    var db = req.result;
                                    if (db) db.close();
                                    reject(req.error);
                                };
                                req.onblocked = function() {
                                    // Closing all open connections in onversionchange handler should prevent this situation, but if
                                    // we do get here, it just means the request remains pending - eventually it will succeed or error
                                    console.warn('dropInstance blocked for database "' + options.name + '" until all open connections are closed');
                                };
                                req.onsuccess = function() {
                                    var db = req.result;
                                    if (db) db.close();
                                    resolve(db);
                                };
                            });
                            return dropDBPromise.then(function(db) {
                                dbContext.db = db;
                                for(var i = 0; i < forages.length; i++){
                                    var _forage = forages[i];
                                    _advanceReadiness(_forage._dbInfo);
                                }
                            })["catch"](function(err) {
                                (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function() {});
                                throw err;
                            });
                        });
                        else promise = dbPromise.then(function(db) {
                            if (!db.objectStoreNames.contains(options.storeName)) return;
                            var newVersion = db.version + 1;
                            _deferReadiness(options);
                            var dbContext = dbContexts[options.name];
                            var forages = dbContext.forages;
                            db.close();
                            for(var i = 0; i < forages.length; i++){
                                var forage = forages[i];
                                forage._dbInfo.db = null;
                                forage._dbInfo.version = newVersion;
                            }
                            var dropObjectPromise = new Promise$1(function(resolve, reject) {
                                var req = idb.open(options.name, newVersion);
                                req.onerror = function(err) {
                                    var db = req.result;
                                    db.close();
                                    reject(err);
                                };
                                req.onupgradeneeded = function() {
                                    var db = req.result;
                                    db.deleteObjectStore(options.storeName);
                                };
                                req.onsuccess = function() {
                                    var db = req.result;
                                    db.close();
                                    resolve(db);
                                };
                            });
                            return dropObjectPromise.then(function(db) {
                                dbContext.db = db;
                                for(var j = 0; j < forages.length; j++){
                                    var _forage2 = forages[j];
                                    _forage2._dbInfo.db = db;
                                    _advanceReadiness(_forage2._dbInfo);
                                }
                            })["catch"](function(err) {
                                (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function() {});
                                throw err;
                            });
                        });
                    }
                    executeCallback(promise, callback);
                    return promise;
                }
                var asyncStorage = {
                    _driver: 'asyncStorage',
                    _initStorage: _initStorage,
                    _support: isIndexedDBValid(),
                    iterate: iterate,
                    getItem: getItem,
                    setItem: setItem,
                    removeItem: removeItem,
                    clear: clear,
                    length: length,
                    key: key,
                    keys: keys,
                    dropInstance: dropInstance
                };
                function isWebSQLValid() {
                    return typeof openDatabase === 'function';
                }
                // Sadly, the best way to save binary data in WebSQL/localStorage is serializing
                // it to Base64, so this is how we store it to prevent very strange errors with less
                // verbose ways of binary <-> string data storage.
                var BASE_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
                var BLOB_TYPE_PREFIX = '~~local_forage_type~';
                var BLOB_TYPE_PREFIX_REGEX = /^~~local_forage_type~([^~]+)~/;
                var SERIALIZED_MARKER = '__lfsc__:';
                var SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER.length;
                // OMG the serializations!
                var TYPE_ARRAYBUFFER = 'arbf';
                var TYPE_BLOB = 'blob';
                var TYPE_INT8ARRAY = 'si08';
                var TYPE_UINT8ARRAY = 'ui08';
                var TYPE_UINT8CLAMPEDARRAY = 'uic8';
                var TYPE_INT16ARRAY = 'si16';
                var TYPE_INT32ARRAY = 'si32';
                var TYPE_UINT16ARRAY = 'ur16';
                var TYPE_UINT32ARRAY = 'ui32';
                var TYPE_FLOAT32ARRAY = 'fl32';
                var TYPE_FLOAT64ARRAY = 'fl64';
                var TYPE_SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER_LENGTH + TYPE_ARRAYBUFFER.length;
                var toString$1 = Object.prototype.toString;
                function stringToBuffer(serializedString) {
                    // Fill the string into a ArrayBuffer.
                    var bufferLength = serializedString.length * 0.75;
                    var len = serializedString.length;
                    var i;
                    var p = 0;
                    var encoded1, encoded2, encoded3, encoded4;
                    if (serializedString[serializedString.length - 1] === '=') {
                        bufferLength--;
                        if (serializedString[serializedString.length - 2] === '=') bufferLength--;
                    }
                    var buffer = new ArrayBuffer(bufferLength);
                    var bytes = new Uint8Array(buffer);
                    for(i = 0; i < len; i += 4){
                        encoded1 = BASE_CHARS.indexOf(serializedString[i]);
                        encoded2 = BASE_CHARS.indexOf(serializedString[i + 1]);
                        encoded3 = BASE_CHARS.indexOf(serializedString[i + 2]);
                        encoded4 = BASE_CHARS.indexOf(serializedString[i + 3]);
                        /*jslint bitwise: true */ bytes[p++] = encoded1 << 2 | encoded2 >> 4;
                        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
                        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
                    }
                    return buffer;
                }
                // Converts a buffer to a string to store, serialized, in the backend
                // storage library.
                function bufferToString(buffer) {
                    // base64-arraybuffer
                    var bytes = new Uint8Array(buffer);
                    var base64String = '';
                    var i;
                    for(i = 0; i < bytes.length; i += 3){
                        /*jslint bitwise: true */ base64String += BASE_CHARS[bytes[i] >> 2];
                        base64String += BASE_CHARS[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
                        base64String += BASE_CHARS[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
                        base64String += BASE_CHARS[bytes[i + 2] & 63];
                    }
                    if (bytes.length % 3 === 2) base64String = base64String.substring(0, base64String.length - 1) + '=';
                    else if (bytes.length % 3 === 1) base64String = base64String.substring(0, base64String.length - 2) + '==';
                    return base64String;
                }
                // Serialize a value, afterwards executing a callback (which usually
                // instructs the `setItem()` callback/promise to be executed). This is how
                // we store binary data with localStorage.
                function serialize(value, callback) {
                    var valueType = '';
                    if (value) valueType = toString$1.call(value);
                    // Cannot use `value instanceof ArrayBuffer` or such here, as these
                    // checks fail when running the tests using casper.js...
                    //
                    // TODO: See why those tests fail and use a better solution.
                    if (value && (valueType === '[object ArrayBuffer]' || value.buffer && toString$1.call(value.buffer) === '[object ArrayBuffer]')) {
                        // Convert binary arrays to a string and prefix the string with
                        // a special marker.
                        var buffer;
                        var marker = SERIALIZED_MARKER;
                        if (value instanceof ArrayBuffer) {
                            buffer = value;
                            marker += TYPE_ARRAYBUFFER;
                        } else {
                            buffer = value.buffer;
                            if (valueType === '[object Int8Array]') marker += TYPE_INT8ARRAY;
                            else if (valueType === '[object Uint8Array]') marker += TYPE_UINT8ARRAY;
                            else if (valueType === '[object Uint8ClampedArray]') marker += TYPE_UINT8CLAMPEDARRAY;
                            else if (valueType === '[object Int16Array]') marker += TYPE_INT16ARRAY;
                            else if (valueType === '[object Uint16Array]') marker += TYPE_UINT16ARRAY;
                            else if (valueType === '[object Int32Array]') marker += TYPE_INT32ARRAY;
                            else if (valueType === '[object Uint32Array]') marker += TYPE_UINT32ARRAY;
                            else if (valueType === '[object Float32Array]') marker += TYPE_FLOAT32ARRAY;
                            else if (valueType === '[object Float64Array]') marker += TYPE_FLOAT64ARRAY;
                            else callback(new Error('Failed to get type for BinaryArray'));
                        }
                        callback(marker + bufferToString(buffer));
                    } else if (valueType === '[object Blob]') {
                        // Conver the blob to a binaryArray and then to a string.
                        var fileReader = new FileReader();
                        fileReader.onload = function() {
                            // Backwards-compatible prefix for the blob type.
                            var str = BLOB_TYPE_PREFIX + value.type + '~' + bufferToString(this.result);
                            callback(SERIALIZED_MARKER + TYPE_BLOB + str);
                        };
                        fileReader.readAsArrayBuffer(value);
                    } else try {
                        callback(JSON.stringify(value));
                    } catch (e) {
                        console.error("Couldn't convert value into a JSON string: ", value);
                        callback(null, e);
                    }
                }
                // Deserialize data we've inserted into a value column/field. We place
                // special markers into our strings to mark them as encoded; this isn't
                // as nice as a meta field, but it's the only sane thing we can do whilst
                // keeping localStorage support intact.
                //
                // Oftentimes this will just deserialize JSON content, but if we have a
                // special marker (SERIALIZED_MARKER, defined above), we will extract
                // some kind of arraybuffer/binary data/typed array out of the string.
                function deserialize(value) {
                    // If we haven't marked this string as being specially serialized (i.e.
                    // something other than serialized JSON), we can just return it and be
                    // done with it.
                    if (value.substring(0, SERIALIZED_MARKER_LENGTH) !== SERIALIZED_MARKER) return JSON.parse(value);
                    // The following code deals with deserializing some kind of Blob or
                    // TypedArray. First we separate out the type of data we're dealing
                    // with from the data itself.
                    var serializedString = value.substring(TYPE_SERIALIZED_MARKER_LENGTH);
                    var type = value.substring(SERIALIZED_MARKER_LENGTH, TYPE_SERIALIZED_MARKER_LENGTH);
                    var blobType;
                    // Backwards-compatible blob type serialization strategy.
                    // DBs created with older versions of localForage will simply not have the blob type.
                    if (type === TYPE_BLOB && BLOB_TYPE_PREFIX_REGEX.test(serializedString)) {
                        var matcher = serializedString.match(BLOB_TYPE_PREFIX_REGEX);
                        blobType = matcher[1];
                        serializedString = serializedString.substring(matcher[0].length);
                    }
                    var buffer = stringToBuffer(serializedString);
                    // Return the right type based on the code/type set during
                    // serialization.
                    switch(type){
                        case TYPE_ARRAYBUFFER:
                            return buffer;
                        case TYPE_BLOB:
                            return createBlob([
                                buffer
                            ], {
                                type: blobType
                            });
                        case TYPE_INT8ARRAY:
                            return new Int8Array(buffer);
                        case TYPE_UINT8ARRAY:
                            return new Uint8Array(buffer);
                        case TYPE_UINT8CLAMPEDARRAY:
                            return new Uint8ClampedArray(buffer);
                        case TYPE_INT16ARRAY:
                            return new Int16Array(buffer);
                        case TYPE_UINT16ARRAY:
                            return new Uint16Array(buffer);
                        case TYPE_INT32ARRAY:
                            return new Int32Array(buffer);
                        case TYPE_UINT32ARRAY:
                            return new Uint32Array(buffer);
                        case TYPE_FLOAT32ARRAY:
                            return new Float32Array(buffer);
                        case TYPE_FLOAT64ARRAY:
                            return new Float64Array(buffer);
                        default:
                            throw new Error('Unkown type: ' + type);
                    }
                }
                var localforageSerializer = {
                    serialize: serialize,
                    deserialize: deserialize,
                    stringToBuffer: stringToBuffer,
                    bufferToString: bufferToString
                };
                /*
 * Includes code from:
 *
 * base64-arraybuffer
 * https://github.com/niklasvh/base64-arraybuffer
 *
 * Copyright (c) 2012 Niklas von Hertzen
 * Licensed under the MIT license.
 */ function createDbTable(t, dbInfo, callback, errorCallback) {
                    t.executeSql('CREATE TABLE IF NOT EXISTS ' + dbInfo.storeName + ' ' + '(id INTEGER PRIMARY KEY, key unique, value)', [], callback, errorCallback);
                }
                // Open the WebSQL database (automatically creates one if one didn't
                // previously exist), using any options set in the config.
                function _initStorage$1(options) {
                    var self1 = this;
                    var dbInfo = {
                        db: null
                    };
                    if (options) for(var i in options)dbInfo[i] = typeof options[i] !== 'string' ? options[i].toString() : options[i];
                    var dbInfoPromise = new Promise$1(function(resolve, reject) {
                        // Open the database; the openDatabase API will automatically
                        // create it for us if it doesn't exist.
                        try {
                            dbInfo.db = openDatabase(dbInfo.name, String(dbInfo.version), dbInfo.description, dbInfo.size);
                        } catch (e) {
                            return reject(e);
                        }
                        // Create our key/value table if it doesn't exist.
                        dbInfo.db.transaction(function(t) {
                            createDbTable(t, dbInfo, function() {
                                self1._dbInfo = dbInfo;
                                resolve();
                            }, function(t, error) {
                                reject(error);
                            });
                        }, reject);
                    });
                    dbInfo.serializer = localforageSerializer;
                    return dbInfoPromise;
                }
                function tryExecuteSql(t, dbInfo, sqlStatement, args, callback, errorCallback) {
                    t.executeSql(sqlStatement, args, callback, function(t, error) {
                        if (error.code === error.SYNTAX_ERR) t.executeSql("SELECT name FROM sqlite_master WHERE type='table' AND name = ?", [
                            dbInfo.storeName
                        ], function(t, results) {
                            if (!results.rows.length) // if the table is missing (was deleted)
                            // re-create it table and retry
                            createDbTable(t, dbInfo, function() {
                                t.executeSql(sqlStatement, args, callback, errorCallback);
                            }, errorCallback);
                            else errorCallback(t, error);
                        }, errorCallback);
                        else errorCallback(t, error);
                    }, errorCallback);
                }
                function getItem$1(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, 'SELECT * FROM ' + dbInfo.storeName + ' WHERE key = ? LIMIT 1', [
                                    key
                                ], function(t, results) {
                                    var result = results.rows.length ? results.rows.item(0).value : null;
                                    // Check to see if this is serialized content we need to
                                    // unpack.
                                    if (result) result = dbInfo.serializer.deserialize(result);
                                    resolve(result);
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function iterate$1(iterator, callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, 'SELECT * FROM ' + dbInfo.storeName, [], function(t, results) {
                                    var rows = results.rows;
                                    var length = rows.length;
                                    for(var i = 0; i < length; i++){
                                        var item = rows.item(i);
                                        var result = item.value;
                                        // Check to see if this is serialized content
                                        // we need to unpack.
                                        if (result) result = dbInfo.serializer.deserialize(result);
                                        result = iterator(result, item.key, i + 1);
                                        // void(0) prevents problems with redefinition
                                        // of `undefined`.
                                        if (result !== void 0) {
                                            resolve(result);
                                            return;
                                        }
                                    }
                                    resolve();
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function _setItem(key, value, callback, retriesLeft) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            // The localStorage API doesn't return undefined values in an
                            // "expected" way, so undefined is always cast to null in all
                            // drivers. See: https://github.com/mozilla/localForage/pull/42
                            if (value === undefined) value = null;
                            // Save the original value to pass to the callback.
                            var originalValue = value;
                            var dbInfo = self1._dbInfo;
                            dbInfo.serializer.serialize(value, function(value, error) {
                                if (error) reject(error);
                                else dbInfo.db.transaction(function(t) {
                                    tryExecuteSql(t, dbInfo, 'INSERT OR REPLACE INTO ' + dbInfo.storeName + ' ' + '(key, value) VALUES (?, ?)', [
                                        key,
                                        value
                                    ], function() {
                                        resolve(originalValue);
                                    }, function(t, error) {
                                        reject(error);
                                    });
                                }, function(sqlError) {
                                    // The transaction failed; check
                                    // to see if it's a quota error.
                                    if (sqlError.code === sqlError.QUOTA_ERR) {
                                        // We reject the callback outright for now, but
                                        // it's worth trying to re-run the transaction.
                                        // Even if the user accepts the prompt to use
                                        // more storage on Safari, this error will
                                        // be called.
                                        //
                                        // Try to re-run the transaction.
                                        if (retriesLeft > 0) {
                                            resolve(_setItem.apply(self1, [
                                                key,
                                                originalValue,
                                                callback,
                                                retriesLeft - 1
                                            ]));
                                            return;
                                        }
                                        reject(sqlError);
                                    }
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function setItem$1(key, value, callback) {
                    return _setItem.apply(this, [
                        key,
                        value,
                        callback,
                        1
                    ]);
                }
                function removeItem$1(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, 'DELETE FROM ' + dbInfo.storeName + ' WHERE key = ?', [
                                    key
                                ], function() {
                                    resolve();
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Deletes every item in the table.
                // TODO: Find out if this resets the AUTO_INCREMENT number.
                function clear$1(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, 'DELETE FROM ' + dbInfo.storeName, [], function() {
                                    resolve();
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Does a simple `COUNT(key)` to get the number of items stored in
                // localForage.
                function length$1(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                // Ahhh, SQL makes this one soooooo easy.
                                tryExecuteSql(t, dbInfo, 'SELECT COUNT(key) as c FROM ' + dbInfo.storeName, [], function(t, results) {
                                    var result = results.rows.item(0).c;
                                    resolve(result);
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Return the key located at key index X; essentially gets the key from a
                // `WHERE id = ?`. This is the most efficient way I can think to implement
                // this rarely-used (in my experience) part of the API, but it can seem
                // inconsistent, because we do `INSERT OR REPLACE INTO` on `setItem()`, so
                // the ID of each key will change every time it's updated. Perhaps a stored
                // procedure for the `setItem()` SQL would solve this problem?
                // TODO: Don't change ID on `setItem()`.
                function key$1(n, callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, 'SELECT key FROM ' + dbInfo.storeName + ' WHERE id = ? LIMIT 1', [
                                    n + 1
                                ], function(t, results) {
                                    var result = results.rows.length ? results.rows.item(0).key : null;
                                    resolve(result);
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function keys$1(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, 'SELECT key FROM ' + dbInfo.storeName, [], function(t, results) {
                                    var keys = [];
                                    for(var i = 0; i < results.rows.length; i++)keys.push(results.rows.item(i).key);
                                    resolve(keys);
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // https://www.w3.org/TR/webdatabase/#databases
                // > There is no way to enumerate or delete the databases available for an origin from this API.
                function getAllStoreNames(db) {
                    return new Promise$1(function(resolve, reject) {
                        db.transaction(function(t) {
                            t.executeSql("SELECT name FROM sqlite_master WHERE type='table' AND name <> '__WebKitDatabaseInfoTable__'", [], function(t, results) {
                                var storeNames = [];
                                for(var i = 0; i < results.rows.length; i++)storeNames.push(results.rows.item(i).name);
                                resolve({
                                    db: db,
                                    storeNames: storeNames
                                });
                            }, function(t, error) {
                                reject(error);
                            });
                        }, function(sqlError) {
                            reject(sqlError);
                        });
                    });
                }
                function dropInstance$1(options, callback) {
                    callback = getCallback.apply(this, arguments);
                    var currentConfig = this.config();
                    options = typeof options !== 'function' && options || {};
                    if (!options.name) {
                        options.name = options.name || currentConfig.name;
                        options.storeName = options.storeName || currentConfig.storeName;
                    }
                    var self1 = this;
                    var promise;
                    if (!options.name) promise = Promise$1.reject('Invalid arguments');
                    else promise = new Promise$1(function(resolve) {
                        var db;
                        if (options.name === currentConfig.name) // use the db reference of the current instance
                        db = self1._dbInfo.db;
                        else db = openDatabase(options.name, '', '', 0);
                        if (!options.storeName) // drop all database tables
                        resolve(getAllStoreNames(db));
                        else resolve({
                            db: db,
                            storeNames: [
                                options.storeName
                            ]
                        });
                    }).then(function(operationInfo) {
                        return new Promise$1(function(resolve, reject) {
                            operationInfo.db.transaction(function(t) {
                                function dropTable(storeName) {
                                    return new Promise$1(function(resolve, reject) {
                                        t.executeSql('DROP TABLE IF EXISTS ' + storeName, [], function() {
                                            resolve();
                                        }, function(t, error) {
                                            reject(error);
                                        });
                                    });
                                }
                                var operations = [];
                                for(var i = 0, len = operationInfo.storeNames.length; i < len; i++)operations.push(dropTable(operationInfo.storeNames[i]));
                                Promise$1.all(operations).then(function() {
                                    resolve();
                                })["catch"](function(e) {
                                    reject(e);
                                });
                            }, function(sqlError) {
                                reject(sqlError);
                            });
                        });
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                var webSQLStorage = {
                    _driver: 'webSQLStorage',
                    _initStorage: _initStorage$1,
                    _support: isWebSQLValid(),
                    iterate: iterate$1,
                    getItem: getItem$1,
                    setItem: setItem$1,
                    removeItem: removeItem$1,
                    clear: clear$1,
                    length: length$1,
                    key: key$1,
                    keys: keys$1,
                    dropInstance: dropInstance$1
                };
                function isLocalStorageValid() {
                    try {
                        return typeof localStorage !== 'undefined' && 'setItem' in localStorage && // in IE8 typeof localStorage.setItem === 'object'
                        !!localStorage.setItem;
                    } catch (e) {
                        return false;
                    }
                }
                function _getKeyPrefix(options, defaultConfig) {
                    var keyPrefix = options.name + '/';
                    if (options.storeName !== defaultConfig.storeName) keyPrefix += options.storeName + '/';
                    return keyPrefix;
                }
                // Check if localStorage throws when saving an item
                function checkIfLocalStorageThrows() {
                    var localStorageTestKey = '_localforage_support_test';
                    try {
                        localStorage.setItem(localStorageTestKey, true);
                        localStorage.removeItem(localStorageTestKey);
                        return false;
                    } catch (e) {
                        return true;
                    }
                }
                // Check if localStorage is usable and allows to save an item
                // This method checks if localStorage is usable in Safari Private Browsing
                // mode, or in any other case where the available quota for localStorage
                // is 0 and there wasn't any saved items yet.
                function _isLocalStorageUsable() {
                    return !checkIfLocalStorageThrows() || localStorage.length > 0;
                }
                // Config the localStorage backend, using options set in the config.
                function _initStorage$2(options) {
                    var self1 = this;
                    var dbInfo = {};
                    if (options) for(var i in options)dbInfo[i] = options[i];
                    dbInfo.keyPrefix = _getKeyPrefix(options, self1._defaultConfig);
                    if (!_isLocalStorageUsable()) return Promise$1.reject();
                    self1._dbInfo = dbInfo;
                    dbInfo.serializer = localforageSerializer;
                    return Promise$1.resolve();
                }
                // Remove all keys from the datastore, effectively destroying all data in
                // the app's key/value store!
                function clear$2(callback) {
                    var self1 = this;
                    var promise = self1.ready().then(function() {
                        var keyPrefix = self1._dbInfo.keyPrefix;
                        for(var i = localStorage.length - 1; i >= 0; i--){
                            var key = localStorage.key(i);
                            if (key.indexOf(keyPrefix) === 0) localStorage.removeItem(key);
                        }
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Retrieve an item from the store. Unlike the original async_storage
                // library in Gaia, we don't modify return values at all. If a key's value
                // is `undefined`, we pass that value to the callback function.
                function getItem$2(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        var result = localStorage.getItem(dbInfo.keyPrefix + key);
                        // If a result was found, parse it from the serialized
                        // string into a JS object. If result isn't truthy, the key
                        // is likely undefined and we'll pass it straight to the
                        // callback.
                        if (result) result = dbInfo.serializer.deserialize(result);
                        return result;
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Iterate over all items in the store.
                function iterate$2(iterator, callback) {
                    var self1 = this;
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        var keyPrefix = dbInfo.keyPrefix;
                        var keyPrefixLength = keyPrefix.length;
                        var length = localStorage.length;
                        // We use a dedicated iterator instead of the `i` variable below
                        // so other keys we fetch in localStorage aren't counted in
                        // the `iterationNumber` argument passed to the `iterate()`
                        // callback.
                        //
                        // See: github.com/mozilla/localForage/pull/435#discussion_r38061530
                        var iterationNumber = 1;
                        for(var i = 0; i < length; i++){
                            var key = localStorage.key(i);
                            if (key.indexOf(keyPrefix) !== 0) continue;
                            var value = localStorage.getItem(key);
                            // If a result was found, parse it from the serialized
                            // string into a JS object. If result isn't truthy, the
                            // key is likely undefined and we'll pass it straight
                            // to the iterator.
                            if (value) value = dbInfo.serializer.deserialize(value);
                            value = iterator(value, key.substring(keyPrefixLength), iterationNumber++);
                            if (value !== void 0) return value;
                        }
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Same as localStorage's key() method, except takes a callback.
                function key$2(n, callback) {
                    var self1 = this;
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        var result;
                        try {
                            result = localStorage.key(n);
                        } catch (error) {
                            result = null;
                        }
                        // Remove the prefix from the key, if a key is found.
                        if (result) result = result.substring(dbInfo.keyPrefix.length);
                        return result;
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function keys$2(callback) {
                    var self1 = this;
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        var length = localStorage.length;
                        var keys = [];
                        for(var i = 0; i < length; i++){
                            var itemKey = localStorage.key(i);
                            if (itemKey.indexOf(dbInfo.keyPrefix) === 0) keys.push(itemKey.substring(dbInfo.keyPrefix.length));
                        }
                        return keys;
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Supply the number of keys in the datastore to the callback function.
                function length$2(callback) {
                    var self1 = this;
                    var promise = self1.keys().then(function(keys) {
                        return keys.length;
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Remove an item from the store, nice and simple.
                function removeItem$2(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        localStorage.removeItem(dbInfo.keyPrefix + key);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Set a key's value and run an optional callback once the value is set.
                // Unlike Gaia's implementation, the callback function is passed the value,
                // in case you want to operate on that value only after you're sure it
                // saved, or something like that.
                function setItem$2(key, value, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = self1.ready().then(function() {
                        // Convert undefined values to null.
                        // https://github.com/mozilla/localForage/pull/42
                        if (value === undefined) value = null;
                        // Save the original value to pass to the callback.
                        var originalValue = value;
                        return new Promise$1(function(resolve, reject) {
                            var dbInfo = self1._dbInfo;
                            dbInfo.serializer.serialize(value, function(value, error) {
                                if (error) reject(error);
                                else try {
                                    localStorage.setItem(dbInfo.keyPrefix + key, value);
                                    resolve(originalValue);
                                } catch (e) {
                                    // localStorage capacity exceeded.
                                    // TODO: Make this a specific error/event.
                                    if (e.name === 'QuotaExceededError' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED') reject(e);
                                    reject(e);
                                }
                            });
                        });
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function dropInstance$2(options, callback) {
                    callback = getCallback.apply(this, arguments);
                    options = typeof options !== 'function' && options || {};
                    if (!options.name) {
                        var currentConfig = this.config();
                        options.name = options.name || currentConfig.name;
                        options.storeName = options.storeName || currentConfig.storeName;
                    }
                    var self1 = this;
                    var promise;
                    if (!options.name) promise = Promise$1.reject('Invalid arguments');
                    else promise = new Promise$1(function(resolve) {
                        if (!options.storeName) resolve(options.name + '/');
                        else resolve(_getKeyPrefix(options, self1._defaultConfig));
                    }).then(function(keyPrefix) {
                        for(var i = localStorage.length - 1; i >= 0; i--){
                            var key = localStorage.key(i);
                            if (key.indexOf(keyPrefix) === 0) localStorage.removeItem(key);
                        }
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                var localStorageWrapper = {
                    _driver: 'localStorageWrapper',
                    _initStorage: _initStorage$2,
                    _support: isLocalStorageValid(),
                    iterate: iterate$2,
                    getItem: getItem$2,
                    setItem: setItem$2,
                    removeItem: removeItem$2,
                    clear: clear$2,
                    length: length$2,
                    key: key$2,
                    keys: keys$2,
                    dropInstance: dropInstance$2
                };
                var sameValue = function sameValue(x, y) {
                    return x === y || typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y);
                };
                var includes = function includes(array, searchElement) {
                    var len = array.length;
                    var i = 0;
                    while(i < len){
                        if (sameValue(array[i], searchElement)) return true;
                        i++;
                    }
                    return false;
                };
                var isArray = Array.isArray || function(arg) {
                    return Object.prototype.toString.call(arg) === '[object Array]';
                };
                // Drivers are stored here when `defineDriver()` is called.
                // They are shared across all instances of localForage.
                var DefinedDrivers = {};
                var DriverSupport = {};
                var DefaultDrivers = {
                    INDEXEDDB: asyncStorage,
                    WEBSQL: webSQLStorage,
                    LOCALSTORAGE: localStorageWrapper
                };
                var DefaultDriverOrder = [
                    DefaultDrivers.INDEXEDDB._driver,
                    DefaultDrivers.WEBSQL._driver,
                    DefaultDrivers.LOCALSTORAGE._driver
                ];
                var OptionalDriverMethods = [
                    'dropInstance'
                ];
                var LibraryMethods = [
                    'clear',
                    'getItem',
                    'iterate',
                    'key',
                    'keys',
                    'length',
                    'removeItem',
                    'setItem'
                ].concat(OptionalDriverMethods);
                var DefaultConfig = {
                    description: '',
                    driver: DefaultDriverOrder.slice(),
                    name: 'localforage',
                    // Default DB size is _JUST UNDER_ 5MB, as it's the highest size
                    // we can use without a prompt.
                    size: 4980736,
                    storeName: 'keyvaluepairs',
                    version: 1.0
                };
                function callWhenReady(localForageInstance, libraryMethod) {
                    localForageInstance[libraryMethod] = function() {
                        var _args = arguments;
                        return localForageInstance.ready().then(function() {
                            return localForageInstance[libraryMethod].apply(localForageInstance, _args);
                        });
                    };
                }
                function extend() {
                    for(var i = 1; i < arguments.length; i++){
                        var arg = arguments[i];
                        if (arg) {
                            for(var _key in arg)if (arg.hasOwnProperty(_key)) {
                                if (isArray(arg[_key])) arguments[0][_key] = arg[_key].slice();
                                else arguments[0][_key] = arg[_key];
                            }
                        }
                    }
                    return arguments[0];
                }
                var LocalForage = function() {
                    function LocalForage(options) {
                        _classCallCheck(this, LocalForage);
                        for(var driverTypeKey in DefaultDrivers)if (DefaultDrivers.hasOwnProperty(driverTypeKey)) {
                            var driver = DefaultDrivers[driverTypeKey];
                            var driverName = driver._driver;
                            this[driverTypeKey] = driverName;
                            if (!DefinedDrivers[driverName]) // we don't need to wait for the promise,
                            // since the default drivers can be defined
                            // in a blocking manner
                            this.defineDriver(driver);
                        }
                        this._defaultConfig = extend({}, DefaultConfig);
                        this._config = extend({}, this._defaultConfig, options);
                        this._driverSet = null;
                        this._initDriver = null;
                        this._ready = false;
                        this._dbInfo = null;
                        this._wrapLibraryMethodsWithReady();
                        this.setDriver(this._config.driver)["catch"](function() {});
                    }
                    // Set any config values for localForage; can be called anytime before
                    // the first API call (e.g. `getItem`, `setItem`).
                    // We loop through options so we don't overwrite existing config
                    // values.
                    LocalForage.prototype.config = function config(options) {
                        // If the options argument is an object, we use it to set values.
                        // Otherwise, we return either a specified config value or all
                        // config values.
                        if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
                            // If localforage is ready and fully initialized, we can't set
                            // any new configuration values. Instead, we return an error.
                            if (this._ready) return new Error("Can't call config() after localforage has been used.");
                            for(var i in options){
                                if (i === 'storeName') options[i] = options[i].replace(/\W/g, '_');
                                if (i === 'version' && typeof options[i] !== 'number') return new Error('Database version must be a number.');
                                this._config[i] = options[i];
                            }
                            // after all config options are set and
                            // the driver option is used, try setting it
                            if ('driver' in options && options.driver) return this.setDriver(this._config.driver);
                            return true;
                        } else if (typeof options === 'string') return this._config[options];
                        else return this._config;
                    };
                    // Used to define a custom driver, shared across all instances of
                    // localForage.
                    LocalForage.prototype.defineDriver = function defineDriver(driverObject, callback, errorCallback) {
                        var promise = new Promise$1(function(resolve, reject) {
                            try {
                                var driverName = driverObject._driver;
                                var complianceError = new Error("Custom driver not compliant; see https://mozilla.github.io/localForage/#definedriver");
                                // A driver name should be defined and not overlap with the
                                // library-defined, default drivers.
                                if (!driverObject._driver) {
                                    reject(complianceError);
                                    return;
                                }
                                var driverMethods = LibraryMethods.concat('_initStorage');
                                for(var i = 0, len = driverMethods.length; i < len; i++){
                                    var driverMethodName = driverMethods[i];
                                    // when the property is there,
                                    // it should be a method even when optional
                                    var isRequired = !includes(OptionalDriverMethods, driverMethodName);
                                    if ((isRequired || driverObject[driverMethodName]) && typeof driverObject[driverMethodName] !== 'function') {
                                        reject(complianceError);
                                        return;
                                    }
                                }
                                var configureMissingMethods = function configureMissingMethods() {
                                    var methodNotImplementedFactory = function methodNotImplementedFactory(methodName) {
                                        return function() {
                                            var error = new Error('Method ' + methodName + ' is not implemented by the current driver');
                                            var promise = Promise$1.reject(error);
                                            executeCallback(promise, arguments[arguments.length - 1]);
                                            return promise;
                                        };
                                    };
                                    for(var _i = 0, _len = OptionalDriverMethods.length; _i < _len; _i++){
                                        var optionalDriverMethod = OptionalDriverMethods[_i];
                                        if (!driverObject[optionalDriverMethod]) driverObject[optionalDriverMethod] = methodNotImplementedFactory(optionalDriverMethod);
                                    }
                                };
                                configureMissingMethods();
                                var setDriverSupport = function setDriverSupport(support) {
                                    if (DefinedDrivers[driverName]) console.info('Redefining LocalForage driver: ' + driverName);
                                    DefinedDrivers[driverName] = driverObject;
                                    DriverSupport[driverName] = support;
                                    // don't use a then, so that we can define
                                    // drivers that have simple _support methods
                                    // in a blocking manner
                                    resolve();
                                };
                                if ('_support' in driverObject) {
                                    if (driverObject._support && typeof driverObject._support === 'function') driverObject._support().then(setDriverSupport, reject);
                                    else setDriverSupport(!!driverObject._support);
                                } else setDriverSupport(true);
                            } catch (e) {
                                reject(e);
                            }
                        });
                        executeTwoCallbacks(promise, callback, errorCallback);
                        return promise;
                    };
                    LocalForage.prototype.driver = function driver() {
                        return this._driver || null;
                    };
                    LocalForage.prototype.getDriver = function getDriver(driverName, callback, errorCallback) {
                        var getDriverPromise = DefinedDrivers[driverName] ? Promise$1.resolve(DefinedDrivers[driverName]) : Promise$1.reject(new Error('Driver not found.'));
                        executeTwoCallbacks(getDriverPromise, callback, errorCallback);
                        return getDriverPromise;
                    };
                    LocalForage.prototype.getSerializer = function getSerializer(callback) {
                        var serializerPromise = Promise$1.resolve(localforageSerializer);
                        executeTwoCallbacks(serializerPromise, callback);
                        return serializerPromise;
                    };
                    LocalForage.prototype.ready = function ready(callback) {
                        var self1 = this;
                        var promise = self1._driverSet.then(function() {
                            if (self1._ready === null) self1._ready = self1._initDriver();
                            return self1._ready;
                        });
                        executeTwoCallbacks(promise, callback, callback);
                        return promise;
                    };
                    LocalForage.prototype.setDriver = function setDriver(drivers, callback, errorCallback) {
                        var self1 = this;
                        if (!isArray(drivers)) drivers = [
                            drivers
                        ];
                        var supportedDrivers = this._getSupportedDrivers(drivers);
                        function setDriverToConfig() {
                            self1._config.driver = self1.driver();
                        }
                        function extendSelfWithDriver(driver) {
                            self1._extend(driver);
                            setDriverToConfig();
                            self1._ready = self1._initStorage(self1._config);
                            return self1._ready;
                        }
                        function initDriver(supportedDrivers) {
                            return function() {
                                var currentDriverIndex = 0;
                                function driverPromiseLoop() {
                                    while(currentDriverIndex < supportedDrivers.length){
                                        var driverName = supportedDrivers[currentDriverIndex];
                                        currentDriverIndex++;
                                        self1._dbInfo = null;
                                        self1._ready = null;
                                        return self1.getDriver(driverName).then(extendSelfWithDriver)["catch"](driverPromiseLoop);
                                    }
                                    setDriverToConfig();
                                    var error = new Error('No available storage method found.');
                                    self1._driverSet = Promise$1.reject(error);
                                    return self1._driverSet;
                                }
                                return driverPromiseLoop();
                            };
                        }
                        // There might be a driver initialization in progress
                        // so wait for it to finish in order to avoid a possible
                        // race condition to set _dbInfo
                        var oldDriverSetDone = this._driverSet !== null ? this._driverSet["catch"](function() {
                            return Promise$1.resolve();
                        }) : Promise$1.resolve();
                        this._driverSet = oldDriverSetDone.then(function() {
                            var driverName = supportedDrivers[0];
                            self1._dbInfo = null;
                            self1._ready = null;
                            return self1.getDriver(driverName).then(function(driver) {
                                self1._driver = driver._driver;
                                setDriverToConfig();
                                self1._wrapLibraryMethodsWithReady();
                                self1._initDriver = initDriver(supportedDrivers);
                            });
                        })["catch"](function() {
                            setDriverToConfig();
                            var error = new Error('No available storage method found.');
                            self1._driverSet = Promise$1.reject(error);
                            return self1._driverSet;
                        });
                        executeTwoCallbacks(this._driverSet, callback, errorCallback);
                        return this._driverSet;
                    };
                    LocalForage.prototype.supports = function supports(driverName) {
                        return !!DriverSupport[driverName];
                    };
                    LocalForage.prototype._extend = function _extend(libraryMethodsAndProperties) {
                        extend(this, libraryMethodsAndProperties);
                    };
                    LocalForage.prototype._getSupportedDrivers = function _getSupportedDrivers(drivers) {
                        var supportedDrivers = [];
                        for(var i = 0, len = drivers.length; i < len; i++){
                            var driverName = drivers[i];
                            if (this.supports(driverName)) supportedDrivers.push(driverName);
                        }
                        return supportedDrivers;
                    };
                    LocalForage.prototype._wrapLibraryMethodsWithReady = function _wrapLibraryMethodsWithReady() {
                        // Add a stub for each driver API method that delays the call to the
                        // corresponding driver method until localForage is ready. These stubs
                        // will be replaced by the driver methods as soon as the driver is
                        // loaded, so there is no performance impact.
                        for(var i = 0, len = LibraryMethods.length; i < len; i++)callWhenReady(this, LibraryMethods[i]);
                    };
                    LocalForage.prototype.createInstance = function createInstance(options) {
                        return new LocalForage(options);
                    };
                    return LocalForage;
                }();
                // The actual localForage object that we expose as a module or via a
                // global. It's extended by pulling in one of our other libraries.
                var localforage_js = new LocalForage();
                module1.exports = localforage_js;
            },
            {
                "3": 3
            }
        ]
    }, {}, [
        4
    ])(4);
});



const $64132459bb1ee385$export$49d5fc8cba920a0 = {
    editorFontSize: 15
};
var $64132459bb1ee385$export$2e2bcd8739ae039 = (0, $ca5b0f8f824107ee$export$473eb76d322d0290)($64132459bb1ee385$export$49d5fc8cba920a0, {
    INCREASE_EDITOR_FONT_SIZE: (state)=>{
        state.editorFontSize++;
    },
    DECREASE_EDITOR_FONT_SIZE: (state)=>{
        state.editorFontSize--;
    },
    UPDATE_PREFS: (state, { payload: payload })=>{
        return {
            ...state,
            ...payload
        };
    }
});



const $aabb17927466d815$export$49d5fc8cba920a0 = {
    searching: false,
    caseSensitive: false,
    regexp: false,
    words: true
};
var $aabb17927466d815$export$2e2bcd8739ae039 = (0, $ca5b0f8f824107ee$export$473eb76d322d0290)($aabb17927466d815$export$49d5fc8cba920a0, {
    UPDATE_SEARCH: (state, { payload: payload })=>{
        Object.keys(payload).forEach((key)=>{
            // @ts-ignore
            state[key] = payload[key];
        });
    },
    TOGGLE_SEARCH_CASE_SENSITIVE: (state)=>{
        state.caseSensitive = !state.caseSensitive;
    },
    TOGGLE_SEARCH_REGEXP: (state)=>{
        state.regexp = !state.regexp;
    },
    TOGGLE_SEARCH_WORDS: (state)=>{
        state.words = !state.words;
    },
    CANCEL_SEARCH: ()=>{
        return $aabb17927466d815$export$49d5fc8cba920a0;
    },
    WORK_ON_TASK: ()=>{
        return $aabb17927466d815$export$49d5fc8cba920a0;
    }
});


function $a3303bde8e8c990a$export$31821b42c6bf8465(reducer, undoKey, resetters = [], limit = 50) {
    // @ts-ignore
    return (state = $a3303bde8e8c990a$export$b59797c411227151(), action)=>{
        if (action.type === `RESET_UNDO_${undoKey}` || resetters.includes(action.type)) return {
            past: [],
            present: state.present,
            future: []
        };
        if (action.type === `UNDO_${undoKey}`) {
            if (state.past.length === 0) return state;
            return {
                present: state.past[state.past.length - 1],
                past: state.past.slice(0, state.past.length - 1),
                future: [
                    ...state.future,
                    state.present
                ]
            };
        }
        if (action.type === `REDO_${undoKey}`) {
            if (state.future.length === 0) return state;
            return {
                present: state.future[state.future.length - 1],
                past: [
                    ...state.past,
                    state.present
                ],
                future: state.future.slice(0, state.future.length - 1)
            };
        }
        const newPresent = reducer(state.present, action);
        if (newPresent !== state.present) return {
            past: [
                ...state.past,
                state.present
            ].slice(0 - limit),
            present: newPresent,
            future: state.future
        };
        return state;
    };
}
function $a3303bde8e8c990a$export$b59797c411227151() {
    return {
        past: [],
        present: {},
        future: []
    };
}



var $2bf5ecce8d10b8a0$export$2e2bcd8739ae039 = (0, $ca5b0f8f824107ee$export$473eb76d322d0290)({}, {
    LOGOUT: ()=>({
            token: null
        }),
    RECEIVE_ACCESS_TOKEN: (state, { payload: payload })=>{
        state.token = payload;
    },
    RECEIVE_GITHUB_USER: (state, { payload: payload })=>{
        return {
            ...state,
            name: payload.name,
            avatar: payload.avatar,
            user: payload.user
        };
    }
});



function $a5e988a9d09b5bf9$var$fastForward(task, commit) {
    task.parentCommit = commit;
    Object.values(task.files).forEach((file)=>{
        file.content = file.editedContent || file.content;
        file.editedContent = null;
    });
}
function $a5e988a9d09b5bf9$var$replaceInResult(result, replace, files, adjust = new Map()) {
    const { path: path, start: start, end: end } = result;
    const file = files[path];
    const content = file.editedContent || file.content;
    const lines = content.split(`\n`);
    const index = start.line - 1;
    const line = lines[index];
    const prevLength = line.length;
    const key = `${path}:${index}`;
    if (!adjust.has(key)) adjust.set(key, 0);
    const offset = adjust.get(key) || 0;
    lines[index] = [
        line.substring(0 - offset, start.column - offset),
        replace,
        line.substring(end.column - offset)
    ].join(``);
    const diff = prevLength - lines[index].length;
    adjust.set(key, offset + diff);
    file.editedContent = lines.join(`\n`);
}
var $a5e988a9d09b5bf9$export$2e2bcd8739ae039 = (0, $ca5b0f8f824107ee$export$473eb76d322d0290)({}, {
    REPLACE_IN_RESULT: (state, { payload: { taskId: taskId, result: result, replace: replace } })=>{
        const task = state[taskId];
        if (task) {
            task.editingFile = result.path;
            $a5e988a9d09b5bf9$var$replaceInResult(result, replace, task.files);
        }
    },
    REPLACE_IN_RESULTS: (state, { payload: { taskId: taskId, results: results, replace: replace } })=>{
        const task = state[taskId];
        if (task) {
            const adjust = new Map();
            results.forEach((r)=>$a5e988a9d09b5bf9$var$replaceInResult(r, replace, task.files, adjust));
        }
    },
    REOPEN_TASK: (state, { payload: { id: oldId, newId: newId } })=>{
        const task = state[oldId];
        if (!task) return;
        delete state[oldId];
        task.id = newId;
        delete task.pullRequest;
        state[newId] = task;
    },
    CREATE_TASK: (state, action)=>{
        const { payload: { taskId: taskId } } = action;
        const time = new Date().toJSON();
        state[taskId] = {
            id: taskId,
            name: ``,
            repoId: -1,
            created: time,
            updated: time,
            isNew: true,
            sidebarOpen: true,
            sidebarWidth: 400,
            collapsed: {},
            documentTitles: {},
            files: {}
        };
    },
    EDIT_SEARCH_RESULT: (state, { payload: { taskId: taskId, result: result } })=>{
        const task = state[taskId];
        if (task) task.editingFile = result.path;
    },
    TASK_SUBMITTED: (state, { payload: { id: id, prNumber: prNumber, parentCommit: parentCommit } })=>{
        const task = state[id];
        if (task) {
            task.pullRequest = {
                number: prNumber
            };
            $a5e988a9d09b5bf9$var$fastForward(task, parentCommit);
        }
    },
    TASK_RE_SUBMITTED: (state, { payload: { id: id, parentCommit: parentCommit } })=>{
        const task = state[id];
        if (task) $a5e988a9d09b5bf9$var$fastForward(task, parentCommit);
    },
    TOGGLE_SIDEBAR_OPEN: (state, { payload: { id: id } })=>{
        const task = state[id];
        if (task) task.sidebarOpen = !task.sidebarOpen;
    },
    UPDATE_SIDEBAR_WIDTH: (state, { payload: { id: id, width: width } })=>{
        const task = state[id];
        if (task) task.sidebarWidth = width;
    },
    UPDATE_EDITING_FILE: (state, { payload: { id: id, adoc: adoc } })=>{
        const task = state[id];
        if (!task) return;
        const { files: files, editingFile: editingFile } = task;
        if (!editingFile) return;
        const file = files[editingFile];
        if (adoc === file.content) file.editedContent = null;
        else file.editedContent = adoc;
    },
    UPDATE_FILE: (state, { payload: { id: id, path: path, adoc: adoc } })=>{
        const task = state[id];
        if (!task) return;
        const { files: files } = task;
        const file = files[path];
        if (!file) return;
        if (adoc === file.content) file.editedContent = null;
        else file.editedContent = adoc;
    },
    UPDATE_TASK: (state, { payload: payload })=>{
        const task = state[payload.id];
        if (task) {
            Object.keys(payload.data).forEach((key)=>{
                // @ts-ignore
                task[key] = payload.data[key];
            });
            task.updated = new Date().toJSON();
        }
    },
    TOUCH_TASK: (state, { payload: taskId })=>{
        const task = state[taskId];
        if (task) task.updated = new Date().toJSON();
    },
    COLLAPSE_TASK: (state, { payload: { taskId: taskId, key: key, isCollapsed: isCollapsed } })=>{
        const task = state[taskId];
        if (task) task.collapsed[key] = !isCollapsed;
    },
    UPDATE_PULL_REQUEST_STATUS: (state, { payload: { id: id, status: status } })=>{
        const task = state[id];
        if (task && task.pullRequest) task.pullRequest.status = status;
    },
    DELETE_TASK: (state, { payload: payload })=>{
        delete state[payload];
    }
});



var $8ab031ca4dff58ad$export$2e2bcd8739ae039 = (0, $ca5b0f8f824107ee$export$473eb76d322d0290)(null, {
    CREATE_TASK: (state, action)=>{
        return action.payload.taskId;
    },
    DELETE_TASK: (state, { payload: payload })=>{
        if (state === payload) return null;
        return state;
    },
    CHANGE_SCREEN: (state, action)=>{
        if (action.payload === `TASKS`) return null;
        return state;
    },
    WORK_ON_TASK: (state, { payload: payload })=>{
        return payload;
    }
});



const $3e05c0969d23c6c5$export$bd1d8583f199118f = `TASKS`;
const $3e05c0969d23c6c5$export$7d63f45909460d98 = `EDIT_TASK`;
const $3e05c0969d23c6c5$export$77d6f70978850641 = `WORK`;


var $ccd933eec041f4ad$export$2e2bcd8739ae039 = (0, $ca5b0f8f824107ee$export$473eb76d322d0290)($3e05c0969d23c6c5$export$bd1d8583f199118f, {
    CHANGE_SCREEN: (state, action)=>action.payload,
    WORK_ON_TASK: ()=>$3e05c0969d23c6c5$export$77d6f70978850641
});



var $5f07c15acc340a1d$export$2e2bcd8739ae039 = (0, $ca5b0f8f824107ee$export$473eb76d322d0290)([], {
    RECEIVE_FRIEND_REPOS: (state, action)=>{
        return action.payload.filter((repo)=>repo.name !== `dev` && repo.description !== undefined).map((repo)=>({
                id: repo.id,
                slug: repo.name,
                friendName: repo.name === `compilations` || repo.name === `compilaciones` ? repo.name.replace(/^c/, `C`) : repo.description?.replace(/^.. (.+) source documents$/, `$1`).replace(/ \((d\.|\d)[^)]*\d\)/, ``) ?? ``
            }));
    }
});





function $465c161bc4722f1a$var$pair(start, end) {
    const type = `${start}/${end}`;
    return {
        [start]: (state)=>{
            if (!state.includes(type)) state.push(type);
        },
        [end]: (state)=>{
            return state.filter((t)=>t !== type);
        }
    };
}
var $465c161bc4722f1a$export$2e2bcd8739ae039 = (0, $ca5b0f8f824107ee$export$473eb76d322d0290)([], {
    ...$465c161bc4722f1a$var$pair(`REQUEST_FRIEND_REPOS`, `RECEIVE_FRIEND_REPOS`),
    ...$465c161bc4722f1a$var$pair(`REQUEST_GITHUB_USER`, `RECEIVE_GITHUB_USER`),
    ...$465c161bc4722f1a$var$pair(`SUBMITTING_TASK`, `TASK_SUBMITTED`),
    ...$465c161bc4722f1a$var$pair(`RE_SUBMITTING_TASK`, `TASK_RE_SUBMITTED`),
    ...$465c161bc4722f1a$var$pair(`START_CHECKOUT`, `END_CHECKOUT`),
    NETWORK_ERROR: ()=>[]
});



var $70726dc1fa4c701d$export$2e2bcd8739ae039 = {
    github: $2bf5ecce8d10b8a0$export$2e2bcd8739ae039,
    tasks: (0, $a3303bde8e8c990a$export$31821b42c6bf8465)((0, $a5e988a9d09b5bf9$export$2e2bcd8739ae039), `TASKS`, [
        `WORK_ON_TASK`,
        `END_CHECKOUT`
    ]),
    currentTask: $8ab031ca4dff58ad$export$2e2bcd8739ae039,
    screen: $ccd933eec041f4ad$export$2e2bcd8739ae039,
    repos: $5f07c15acc340a1d$export$2e2bcd8739ae039,
    prefs: $64132459bb1ee385$export$2e2bcd8739ae039,
    search: $aabb17927466d815$export$2e2bcd8739ae039,
    network: $465c161bc4722f1a$export$2e2bcd8739ae039,
    version: ()=>2
};


function $851c71cb4dae4714$export$2e2bcd8739ae039(state) {
    const { tasks: tasks, version: version } = state;
    if (typeof version == `number` && version > 1) return state;
    for(const id in tasks){
        const task = tasks[id];
        if (typeof task.prNumber === `number`) {
            task.pullRequest = {
                number: task.prNumber
            };
            delete task.prNumber;
        }
    }
    return state;
}


function $0bb05c025cdb9cd0$export$2e2bcd8739ae039(state) {
    const migrations = [
        (0, $851c71cb4dae4714$export$2e2bcd8739ae039)
    ];
    let newState = state;
    migrations.forEach((migration)=>{
        newState = migration(newState);
    });
    return newState;
}


const $12dd306947ac2422$var$defaultState = {
    version: 2,
    screen: `TASKS`,
    currentTask: undefined,
    tasks: (0, $a3303bde8e8c990a$export$b59797c411227151)(),
    repos: [],
    search: (0, $aabb17927466d815$export$49d5fc8cba920a0),
    github: {
        token: null
    },
    prefs: (0, $64132459bb1ee385$export$49d5fc8cba920a0),
    network: []
};
async function $12dd306947ac2422$var$loadState() {
    try {
        let state = await (0, (/*@__PURE__*/$parcel$interopDefault($e85b5c20f8f311b0$exports))).getItem(`jones`);
        state = state || $12dd306947ac2422$var$getLegacyState() || {};
        state = (0, $0bb05c025cdb9cd0$export$2e2bcd8739ae039)(state);
        return {
            ...state,
            tasks: {
                past: [],
                present: state.tasks || {},
                future: []
            }
        };
    } catch  {
        return null;
    }
}
const $12dd306947ac2422$var$saveState = (state)=>{
    try {
        (0, (/*@__PURE__*/$parcel$interopDefault($e85b5c20f8f311b0$exports))).setItem(`jones`, state);
    } catch  {
    // ¯\_(ツ)_/¯
    }
};
const $12dd306947ac2422$var$sliceReducer = (0, $1989032bc8d1f610$export$66e4520cdb265d18)((0, $70726dc1fa4c701d$export$2e2bcd8739ae039));
const $12dd306947ac2422$var$reducer = (state = $12dd306947ac2422$var$defaultState, action)=>{
    if (action.type === `HARD_RESET`) {
        (0, (/*@__PURE__*/$parcel$interopDefault($e85b5c20f8f311b0$exports))).removeItem(`jones`);
        return {
            ...$12dd306947ac2422$var$defaultState,
            github: state.github
        };
    }
    return $12dd306947ac2422$var$sliceReducer(state, action);
};
async function $12dd306947ac2422$export$2e2bcd8739ae039() {
    const savedState = await $12dd306947ac2422$var$loadState();
    const store = (0, $ca5b0f8f824107ee$export$7d8a5b498da695ac)({
        reducer: $12dd306947ac2422$var$reducer,
        preloadedState: {
            ...$12dd306947ac2422$var$defaultState,
            ...savedState,
            network: []
        }
    });
    store.subscribe(()=>{
        const state = store.getState();
        $12dd306947ac2422$var$saveState({
            ...state,
            tasks: state.tasks.present
        });
    });
    return store;
}
function $12dd306947ac2422$var$getLegacyState() {
    const serialized = localStorage.getItem(`jones`);
    if (serialized == null) return null;
    const state = JSON.parse(serialized);
    // we already did the conversion once, so act like the legacy data
    // isn't there -- because I don't want to delete legacy data (for now)
    // so I can recover work in case I made a horrible mistake
    if (!state || state.convertedToIndexedDB === true) return null;
    localStorage.setItem(`jones`, JSON.stringify({
        ...state,
        convertedToIndexedDB: true
    }));
    return state;
}




var $lx97N = parcelRequire("lx97N");

var $1d811823c5bf6b48$exports = {};


!function(e, t) {
    $1d811823c5bf6b48$exports = t((parcelRequire("lx97N")), (parcelRequire("4RND8")));
}(window, function(e, t) {
    return function(e) {
        var t = {};
        function n(r) {
            if (t[r]) return t[r].exports;
            var o = t[r] = {
                i: r,
                l: !1,
                exports: {}
            };
            return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
        }
        return n.m = e, n.c = t, n.d = function(e, t, r) {
            n.o(e, t) || Object.defineProperty(e, t, {
                enumerable: !0,
                get: r
            });
        }, n.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, n.t = function(e, t) {
            if (1 & t && (e = n(e)), 8 & t) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var r = Object.create(null);
            if (n.r(r), Object.defineProperty(r, "default", {
                enumerable: !0,
                value: e
            }), 2 & t && "string" != typeof e) for(var o in e)n.d(r, o, (function(t) {
                return e[t];
            }).bind(null, o));
            return r;
        }, n.n = function(e) {
            var t = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return n.d(t, "a", t), t;
        }, n.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, n.p = "", n(n.s = 0);
    }([
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var r = n(1);
            Object.defineProperty(t, "default", {
                enumerable: !0,
                get: function() {
                    return function(e) {
                        return e && e.__esModule ? e : {
                            default: e
                        };
                    }(r).default;
                }
            }), e.exports = t.default;
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var r = Object.assign || function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var n = arguments[t];
                    for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
            }, o = function() {
                function e(e, t) {
                    for(var n = 0; n < t.length; n++){
                        var r = t[n];
                        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                    }
                }
                return function(t, n, r) {
                    return n && e(t.prototype, n), r && e(t, r), t;
                };
            }(), i = l(n(2)), u = l(n(3)), a = n(4);
            function l(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            var s = [], c = function(e) {
                function t(e) {
                    !function(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, t);
                    var n = function(e, t) {
                        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return !t || "object" != typeof t && "function" != typeof t ? e : t;
                    }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
                    return n.handleKeyboardEvent = n.handleKeyboardEvent.bind(n), n.registerExclusiveHandler = n.registerExclusiveHandler.bind(n), n.deregisterExclusiveHandler = n.deregisterExclusiveHandler.bind(n), n;
                }
                return function(e, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                    e.prototype = Object.create(t && t.prototype, {
                        constructor: {
                            value: e,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
                }(t, i.default.Component), o(t, [
                    {
                        key: "componentDidMount",
                        value: function() {
                            document.addEventListener("keydown", this.handleKeyboardEvent, !1), document.addEventListener("keyup", this.handleKeyboardEvent, !1), document.addEventListener("keypress", this.handleKeyboardEvent, !1);
                            var e = this.props, t = e.isExclusive, n = e.isDisabled;
                            t && !n && this.registerExclusiveHandler();
                        }
                    },
                    {
                        key: "componentWillUnmount",
                        value: function() {
                            document.removeEventListener("keydown", this.handleKeyboardEvent, !1), document.removeEventListener("keyup", this.handleKeyboardEvent, !1), document.removeEventListener("keypress", this.handleKeyboardEvent, !1), this.deregisterExclusiveHandler();
                        }
                    },
                    {
                        key: "componentDidUpdate",
                        value: function(e) {
                            var t = e.isExclusive, n = e.isDisabled;
                            (this.props.isExclusive !== t || this.props.isDisabled !== n) && (this.props.isExclusive && !this.props.isDisabled ? this.registerExclusiveHandler() : this.deregisterExclusiveHandler());
                        }
                    },
                    {
                        key: "registerExclusiveHandler",
                        value: function() {
                            this.deregisterExclusiveHandler(), s.unshift(this);
                        }
                    },
                    {
                        key: "deregisterExclusiveHandler",
                        value: function() {
                            var e = this;
                            s.includes(this) && (s = s.filter(function(t) {
                                return t !== e;
                            }));
                        }
                    },
                    {
                        key: "handleKeyboardEvent",
                        value: function(e) {
                            var t = this.props, n = t.isDisabled, r = t.handleKeys, o = t.onKeyEvent, i = t.handleEventType, u = t.children, l = t.handleFocusableElements;
                            if (n) return !1;
                            if (!(i === e.type)) return !1;
                            if (s.length > 0 && s[0] !== this) return !1;
                            var c = e.target === document.body || l, d = this.childrenContainer && this.childrenContainer.contains(e.target);
                            if (!(u ? d : c)) return !1;
                            var f = (0, a.findMatchedKey)(e, r);
                            return !!f && (o(f, e), !0);
                        }
                    },
                    {
                        key: "render",
                        value: function() {
                            var e = this, n = this.props.children, o = Object.assign({}, this.props), u = !0, a = !1, l = void 0;
                            try {
                                for(var s, c = Object.keys(t.propTypes)[Symbol.iterator](); !(u = (s = c.next()).done); u = !0)delete o[s.value];
                            } catch (e) {
                                a = !0, l = e;
                            } finally{
                                try {
                                    !u && c.return && c.return();
                                } finally{
                                    if (a) throw l;
                                }
                            }
                            return n ? i.default.createElement("span", r({
                                ref: function(t) {
                                    e.childrenContainer = t;
                                }
                            }, o), n) : null;
                        }
                    }
                ]), t;
            }();
            t.default = c, c.propTypes = {
                handleKeys: u.default.array,
                handleEventType: u.default.oneOf([
                    "keydown",
                    "keyup",
                    "keypress"
                ]),
                handleFocusableElements: u.default.bool,
                onKeyEvent: u.default.func,
                isDisabled: u.default.bool,
                isExclusive: u.default.bool,
                children: u.default.any
            }, c.defaultProps = {
                handleKeys: [],
                handleFocusableElements: !1,
                handleEventType: "keydown",
                onKeyEvent: function() {
                    return null;
                }
            }, e.exports = t.default;
        },
        function(t, n) {
            t.exports = e;
        },
        function(e, n) {
            e.exports = t;
        },
        function(e, t, n) {
            "use strict";
            function r(e, t, n) {
                return t in e ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : e[t] = n, e;
            }
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.matchKeyEvent = p, t.findMatchedKey = function(e, t) {
                var n = t.map(function(e) {
                    var t = e.toLowerCase(), n = f[t];
                    return n || [
                        e
                    ];
                }).reduce(function(e, t) {
                    return e.concat(t);
                }, []).find(function(t) {
                    return p(e, t);
                });
                !n && t.includes("all") && (n = "other");
                return n;
            };
            var o = {
                backspace: [
                    8
                ],
                del: [
                    46
                ],
                delete: [
                    46
                ],
                ins: [
                    45
                ],
                insert: [
                    45
                ],
                tab: [
                    9
                ],
                enter: [
                    13
                ],
                return: [
                    13
                ],
                esc: [
                    27
                ],
                space: [
                    32
                ],
                pageup: [
                    33
                ],
                pagedown: [
                    34
                ],
                end: [
                    35
                ],
                home: [
                    36
                ],
                left: [
                    37
                ],
                up: [
                    38
                ],
                right: [
                    39
                ],
                down: [
                    40
                ],
                shift: [
                    16
                ],
                ctrl: [
                    17
                ],
                alt: [
                    18
                ],
                cap: [
                    20
                ],
                num: [
                    144
                ],
                clear: [
                    12
                ],
                meta: [
                    91
                ],
                ";": [
                    186,
                    59
                ],
                "=": [
                    187,
                    61
                ],
                ",": [
                    188,
                    44
                ],
                "-": [
                    189,
                    45,
                    173,
                    109
                ],
                minus: [
                    189,
                    45,
                    173,
                    109
                ],
                ".": [
                    190,
                    110
                ],
                "/": [
                    191,
                    111
                ],
                "`": [
                    192
                ],
                "[": [
                    219
                ],
                "\\": [
                    220
                ],
                "]": [
                    221
                ],
                "*": [
                    106
                ],
                "+": [
                    107
                ],
                plus: [
                    107
                ],
                "'": [
                    222
                ],
                quote: [
                    222
                ]
            }, i = Object.keys(o).reduce(function(e, t) {
                return Object.assign(e, r({}, t.toUpperCase(), o[t]));
            }, {}), u = "0123456789".split("").reduce(function(e, t, n) {
                return Object.assign(e, r({}, t, [
                    n + 48,
                    n + 96
                ]));
            }, {}), a = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("").reduce(function(e, t, n) {
                return Object.assign(e, r({}, t.toLowerCase(), [
                    n + 65
                ]), r({}, t, [
                    n + 65
                ]));
            }, {}), l = "1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19".split(",").reduce(function(e, t, n) {
                return Object.assign(e, r({}, "f" + t, [
                    n + 112
                ]));
            }, {}), s = {
                control: "ctrl",
                ctrl: "ctrl",
                shift: "shift",
                meta: "meta",
                cmd: "meta",
                command: "meta",
                option: "alt",
                alt: "alt"
            }, c = t.AllKeys = Object.assign({}, o, i, u, a, l), d = Object.assign({}, u, a), f = {
                all: Object.keys(c),
                alphanumeric: Object.keys(d),
                numeric: Object.keys(u),
                alphabetic: Object.keys(a),
                function: Object.keys(l)
            };
            function p(e, t) {
                var n = e.which || e.keyCode, r = e.type, o = Object.keys(s).filter(function(t) {
                    return e[t + "Key"];
                }).sort(), i = t.toLowerCase().trim(), u = "+" === i ? [
                    "+"
                ] : i.split(/\s?\+\s?/), a = u.pop(), l = c[a], d = u;
                if ("keypress" === r) return t == String.fromCharCode(n).toLowerCase();
                if (0 === d.length && 0 === o.length) return l.indexOf(n) >= 0;
                if (d.length > 0 && o.length > 0) {
                    var f = d.map(function(e) {
                        return s[e];
                    }).sort(), p = f.length === o.length && f.every(function(e, t) {
                        return o[t] === e;
                    });
                    return l.indexOf(n) >= 0 && p;
                }
                return 0 == d.length && 1 === o.length && a === o[0];
            }
        }
    ]);
});




var $lx97N = parcelRequire("lx97N");
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $d403d32521212f06$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $d403d32521212f06$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    return tag;
}
var $d403d32521212f06$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    function StyleSheet(options) {
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
            var _tag = $d403d32521212f06$var$createStyleElement(this);
            var before;
            if (this.tags.length === 0) before = this.before;
            else before = this.tags[this.tags.length - 1].nextSibling;
            this.container.insertBefore(_tag, before);
            this.tags.push(_tag);
        }
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $d403d32521212f06$var$sheetForTag(tag);
            try {
                // this is a really hot path
                // we check the second character first because having "i"
                // as the second character will happen less often than
                // having "@" as the first character
                var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, // otherwise there will be an error
                // technically this means that the @import rules will
                // _usually_(not always since there could be multiple style tags)
                // be the first ones in prod and generally later in dev
                // this shouldn't really matter in the real world though
                // @import is generally only used for font faces from google fonts and etc.
                // so while this could be technically correct then it would be slower and larger
                // for a tiny bit of correctness that won't matter in the real world
                isImportRule ? 0 : sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();


function $aae144f7e0a63bc6$var$stylis_min(W) {
    function M(d, c, e, h, a) {
        for(var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;){
            g = e.charCodeAt(l);
            l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
            if (0 === b + n + v + m) {
                if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
                    switch(g){
                        case 32:
                        case 9:
                        case 59:
                        case 13:
                        case 10:
                            break;
                        default:
                            f += e.charAt(l);
                    }
                    g = 59;
                }
                switch(g){
                    case 123:
                        f = f.trim();
                        q = f.charCodeAt(0);
                        k = 1;
                        for(t = ++l; l < B;){
                            switch(g = e.charCodeAt(l)){
                                case 123:
                                    k++;
                                    break;
                                case 125:
                                    k--;
                                    break;
                                case 47:
                                    switch(g = e.charCodeAt(l + 1)){
                                        case 42:
                                        case 47:
                                            a: {
                                                for(u = l + 1; u < J; ++u)switch(e.charCodeAt(u)){
                                                    case 47:
                                                        if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                        break;
                                                    case 10:
                                                        if (47 === g) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                }
                                                l = u;
                                            }
                                    }
                                    break;
                                case 91:
                                    g++;
                                case 40:
                                    g++;
                                case 34:
                                case 39:
                                    for(; l++ < J && e.charCodeAt(l) !== g;);
                            }
                            if (0 === k) break;
                            l++;
                        }
                        k = e.substring(t, l);
                        0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));
                        switch(q){
                            case 64:
                                0 < r && (f = f.replace(N, ''));
                                g = f.charCodeAt(1);
                                switch(g){
                                    case 100:
                                    case 109:
                                    case 115:
                                    case 45:
                                        r = c;
                                        break;
                                    default:
                                        r = O;
                                }
                                k = M(c, r, k, g, a + 1);
                                t = k.length;
                                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                                if (0 < t) switch(g){
                                    case 115:
                                        f = f.replace(da, ea);
                                    case 100:
                                    case 109:
                                    case 45:
                                        k = f + '{' + k + '}';
                                        break;
                                    case 107:
                                        f = f.replace(fa, '$1 $2');
                                        k = f + '{' + k + '}';
                                        k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                                        break;
                                    default:
                                        k = f + k, 112 === h && (k = (p += k, ''));
                                }
                                else k = '';
                                break;
                            default:
                                k = M(c, X(c, f, I), k, h, a + 1);
                        }
                        F += k;
                        k = I = r = u = q = 0;
                        f = '';
                        g = e.charCodeAt(++l);
                        break;
                    case 125:
                    case 59:
                        f = (0 < r ? f.replace(N, '') : f).trim();
                        if (1 < (t = f.length)) switch(0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q){
                            case 0:
                                break;
                            case 64:
                                if (105 === g || 99 === g) {
                                    G += f + e.charAt(l);
                                    break;
                                }
                            default:
                                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
                        }
                        I = r = u = q = 0;
                        f = '';
                        g = e.charCodeAt(++l);
                }
            }
            switch(g){
                case 13:
                case 10:
                    47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
                    0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
                    z = 1;
                    D++;
                    break;
                case 59:
                case 125:
                    if (0 === b + n + v + m) {
                        z++;
                        break;
                    }
                default:
                    z++;
                    y = e.charAt(l);
                    switch(g){
                        case 9:
                        case 32:
                            if (0 === n + m + b) switch(x){
                                case 44:
                                case 58:
                                case 9:
                                case 32:
                                    y = '';
                                    break;
                                default:
                                    32 !== g && (y = ' ');
                            }
                            break;
                        case 0:
                            y = '\\0';
                            break;
                        case 12:
                            y = '\\f';
                            break;
                        case 11:
                            y = '\\v';
                            break;
                        case 38:
                            0 === n + b + m && (r = I = 1, y = '\f' + y);
                            break;
                        case 108:
                            if (0 === n + b + m + E && 0 < u) switch(l - u){
                                case 2:
                                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                                case 8:
                                    111 === K && (E = K);
                            }
                            break;
                        case 58:
                            0 === n + b + m && (u = l);
                            break;
                        case 44:
                            0 === b + v + n + m && (r = 1, y += '\r');
                            break;
                        case 34:
                        case 39:
                            0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                            break;
                        case 91:
                            0 === n + b + v && m++;
                            break;
                        case 93:
                            0 === n + b + v && m--;
                            break;
                        case 41:
                            0 === n + b + m && v--;
                            break;
                        case 40:
                            if (0 === n + b + m) {
                                if (0 === q) switch(2 * x + 3 * K){
                                    case 533:
                                        break;
                                    default:
                                        q = 1;
                                }
                                v++;
                            }
                            break;
                        case 64:
                            0 === b + v + n + m + u + k && (k = 1);
                            break;
                        case 42:
                        case 47:
                            if (!(0 < n + m + v)) switch(b){
                                case 0:
                                    switch(2 * g + 3 * e.charCodeAt(l + 1)){
                                        case 235:
                                            b = 47;
                                            break;
                                        case 220:
                                            t = l, b = 42;
                                    }
                                    break;
                                case 42:
                                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
                            }
                    }
                    0 === b && (f += y);
            }
            K = x;
            x = g;
            l++;
        }
        t = p.length;
        if (0 < t) {
            r = c;
            if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
            p = r.join(',') + '{' + p + '}';
            if (0 !== w * E) {
                2 !== w || L(p, 2) || (E = 0);
                switch(E){
                    case 111:
                        p = p.replace(ha, ':-moz-$1') + p;
                        break;
                    case 112:
                        p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
                }
                E = 0;
            }
        }
        return G + p + F;
    }
    function X(d, c, e) {
        var h = c.trim().split(ia);
        c = h;
        var a = h.length, m = d.length;
        switch(m){
            case 0:
            case 1:
                var b = 0;
                for(d = 0 === m ? '' : d[0] + ' '; b < a; ++b)c[b] = Z(d, c[b], e).trim();
                break;
            default:
                var v = b = 0;
                for(c = []; b < a; ++b)for(var n = 0; n < m; ++n)c[v++] = Z(d[n] + ' ', h[b], e).trim();
        }
        return c;
    }
    function Z(d, c, e) {
        var h = c.charCodeAt(0);
        33 > h && (h = (c = c.trim()).charCodeAt(0));
        switch(h){
            case 38:
                return c.replace(F, '$1' + d.trim());
            case 58:
                return d.trim() + c.replace(F, '$1' + d.trim());
            default:
                if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
        }
        return d + c;
    }
    function P(d, c, e, h) {
        var a = d + ';', m = 2 * c + 3 * e + 4 * h;
        if (944 === m) {
            d = a.indexOf(':', 9) + 1;
            var b = a.substring(d, a.length - 1).trim();
            b = a.substring(0, d).trim() + b + ';';
            return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
        }
        if (0 === w || 2 === w && !L(a, 1)) return a;
        switch(m){
            case 1015:
                return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;
            case 951:
                return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;
            case 963:
                return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;
            case 1009:
                if (100 !== a.charCodeAt(4)) break;
            case 969:
            case 942:
                return '-webkit-' + a + a;
            case 978:
                return '-webkit-' + a + '-moz-' + a + a;
            case 1019:
            case 983:
                return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;
            case 883:
                if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
                if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
                break;
            case 932:
                if (45 === a.charCodeAt(4)) switch(a.charCodeAt(5)){
                    case 103:
                        return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;
                    case 115:
                        return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;
                    case 98:
                        return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
                }
                return '-webkit-' + a + '-ms-' + a + a;
            case 964:
                return '-webkit-' + a + '-ms-flex-' + a + a;
            case 1023:
                if (99 !== a.charCodeAt(8)) break;
                b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
                return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;
            case 1005:
                return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;
            case 1e3:
                b = a.substring(13).trim();
                c = b.indexOf('-') + 1;
                switch(b.charCodeAt(0) + b.charCodeAt(c)){
                    case 226:
                        b = a.replace(G, 'tb');
                        break;
                    case 232:
                        b = a.replace(G, 'tb-rl');
                        break;
                    case 220:
                        b = a.replace(G, 'lr');
                        break;
                    default:
                        return a;
                }
                return '-webkit-' + a + '-ms-' + b + a;
            case 1017:
                if (-1 === a.indexOf('sticky', 9)) break;
            case 975:
                c = (a = d).length - 10;
                b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();
                switch(m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)){
                    case 203:
                        if (111 > b.charCodeAt(8)) break;
                    case 115:
                        a = a.replace(b, '-webkit-' + b) + ';' + a;
                        break;
                    case 207:
                    case 102:
                        a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
                }
                return a + ';';
            case 938:
                if (45 === a.charCodeAt(5)) switch(a.charCodeAt(6)){
                    case 105:
                        return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;
                    case 115:
                        return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;
                    default:
                        return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
                }
                break;
            case 973:
            case 989:
                if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
            case 931:
            case 953:
                if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
                break;
            case 962:
                if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
        }
        return a;
    }
    function L(d, c) {
        var e = d.indexOf(1 === c ? ':' : '{'), h = d.substring(0, 3 !== c ? e : 10);
        e = d.substring(e + 1, d.length - 1);
        return R(2 !== c ? h : h.replace(na, '$1'), e, c);
    }
    function ea(d, c) {
        var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
        return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
    }
    function H(d, c, e, h, a, m, b, v, n, q) {
        for(var g = 0, x = c, w; g < A; ++g)switch(w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)){
            case void 0:
            case !1:
            case !0:
            case null:
                break;
            default:
                x = w;
        }
        if (x !== c) return x;
    }
    function T(d) {
        switch(d){
            case void 0:
            case null:
                A = S.length = 0;
                break;
            default:
                if ('function' === typeof d) S[A++] = d;
                else if ('object' === typeof d) for(var c = 0, e = d.length; c < e; ++c)T(d[c]);
                else Y = !!d | 0;
        }
        return T;
    }
    function U(d) {
        d = d.prefix;
        void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
        return U;
    }
    function B(d, c) {
        var e = d;
        33 > e.charCodeAt(0) && (e = e.trim());
        V = e;
        e = [
            V
        ];
        if (0 < A) {
            var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
            void 0 !== h && 'string' === typeof h && (c = h);
        }
        var a = M(O, e, c, 0, 0);
        0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
        V = '';
        E = 0;
        z = D = 1;
        return a;
    }
    var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z = 1, D = 1, E = 0, w = 1, O = [], S = [], A = 0, R = null, Y = 0, V = '';
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
}
var $aae144f7e0a63bc6$export$2e2bcd8739ae039 = $aae144f7e0a63bc6$var$stylis_min;


var $a29bf53af743b8eb$var$weakMemoize = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};
var $a29bf53af743b8eb$export$2e2bcd8739ae039 = $a29bf53af743b8eb$var$weakMemoize;


// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
// inlined to avoid umd wrapper and peerDep warnings/installing stylis
// since we use stylis after closure compiler
var $90b82e94834dce34$var$delimiter = '/*|*/';
var $90b82e94834dce34$var$needle = $90b82e94834dce34$var$delimiter + '}';
function $90b82e94834dce34$var$toSheet(block) {
    if (block) $90b82e94834dce34$var$Sheet.current.insert(block + '}');
}
var $90b82e94834dce34$var$Sheet = {
    current: null
};
var $90b82e94834dce34$var$ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
    switch(context){
        // property
        case 1:
            switch(content.charCodeAt(0)){
                case 64:
                    // @import
                    $90b82e94834dce34$var$Sheet.current.insert(content + ';');
                    return '';
                // charcode for l
                case 108:
                    // charcode for b
                    // this ignores label
                    if (content.charCodeAt(2) === 98) return '';
            }
            break;
        // selector
        case 2:
            if (ns === 0) return content + $90b82e94834dce34$var$delimiter;
            break;
        // at-rule
        case 3:
            switch(ns){
                // @font-face, @page
                case 102:
                case 112:
                    $90b82e94834dce34$var$Sheet.current.insert(selectors[0] + content);
                    return '';
                default:
                    return content + (at === 0 ? $90b82e94834dce34$var$delimiter : '');
            }
        case -2:
            content.split($90b82e94834dce34$var$needle).forEach($90b82e94834dce34$var$toSheet);
    }
};
var $90b82e94834dce34$var$createCache = function createCache(options) {
    if (options === undefined) options = {};
    var key = options.key || 'css';
    var stylisOptions;
    if (options.prefix !== undefined) stylisOptions = {
        prefix: options.prefix
    };
    var stylis = new (0, $aae144f7e0a63bc6$export$2e2bcd8739ae039)(stylisOptions);
    var inserted = {}; // $FlowFixMe
    var container;
    container = options.container || document.head;
    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
    Array.prototype.forEach.call(nodes, function(node) {
        var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe
        attrib.split(' ').forEach(function(id) {
            inserted[id] = true;
        });
        if (node.parentNode !== container) container.appendChild(node);
    });
    var _insert;
    stylis.use(options.stylisPlugins)($90b82e94834dce34$var$ruleSheet);
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        var name = serialized.name;
        $90b82e94834dce34$var$Sheet.current = sheet;
        var map;
        stylis(selector, serialized.styles);
        if (shouldCache) cache.inserted[name] = true;
    };
    var commentStart, commentEnd;
    var cache = {
        key: key,
        sheet: new (0, $d403d32521212f06$export$9d753cd7ae895cce)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    return cache;
};
var $90b82e94834dce34$export$2e2bcd8739ae039 = $90b82e94834dce34$var$createCache;


var $70e6317fa428a7ee$exports = {};
var $2b27f9848afd2ca3$exports = {};
function $2b27f9848afd2ca3$var$_setPrototypeOf(o, p) {
    $2b27f9848afd2ca3$exports = $2b27f9848afd2ca3$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    }, $2b27f9848afd2ca3$exports.__esModule = true, $2b27f9848afd2ca3$exports["default"] = $2b27f9848afd2ca3$exports;
    return $2b27f9848afd2ca3$var$_setPrototypeOf(o, p);
}
$2b27f9848afd2ca3$exports = $2b27f9848afd2ca3$var$_setPrototypeOf, $2b27f9848afd2ca3$exports.__esModule = true, $2b27f9848afd2ca3$exports["default"] = $2b27f9848afd2ca3$exports;


function $70e6317fa428a7ee$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $2b27f9848afd2ca3$exports(subClass, superClass);
}
$70e6317fa428a7ee$exports = $70e6317fa428a7ee$var$_inheritsLoose, $70e6317fa428a7ee$exports.__esModule = true, $70e6317fa428a7ee$exports["default"] = $70e6317fa428a7ee$exports;



var $lx97N = parcelRequire("lx97N");

var $44d6f7c1deb750c8$var$isBrowser = true;
function $44d6f7c1deb750c8$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className]);
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $44d6f7c1deb750c8$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $44d6f7c1deb750c8$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            var maybeStyles = cache.insert("." + className, current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};


/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $265e8c0f7074eb72$var$murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}
var $265e8c0f7074eb72$export$2e2bcd8739ae039 = $265e8c0f7074eb72$var$murmur2;


var $885f4eee88e48c11$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $885f4eee88e48c11$export$2e2bcd8739ae039 = $885f4eee88e48c11$var$unitlessKeys;


function $8f6d9d09a7fd235f$var$memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $8f6d9d09a7fd235f$export$2e2bcd8739ae039 = $8f6d9d09a7fd235f$var$memoize;


var $8b10f24ae7e53fe6$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $8b10f24ae7e53fe6$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $8b10f24ae7e53fe6$var$hyphenateRegex = /[A-Z]|^ms/g;
var $8b10f24ae7e53fe6$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $8b10f24ae7e53fe6$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $8b10f24ae7e53fe6$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $8b10f24ae7e53fe6$var$processStyleName = (0, $8f6d9d09a7fd235f$export$2e2bcd8739ae039)(function(styleName) {
    return $8b10f24ae7e53fe6$var$isCustomProperty(styleName) ? styleName : styleName.replace($8b10f24ae7e53fe6$var$hyphenateRegex, '-$&').toLowerCase();
});
var $8b10f24ae7e53fe6$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($8b10f24ae7e53fe6$var$animationRegex, function(match, p1, p2) {
                $8b10f24ae7e53fe6$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $8b10f24ae7e53fe6$var$cursor
                };
                return p1;
            });
    }
    if ((0, $885f4eee88e48c11$export$2e2bcd8739ae039)[key] !== 1 && !$8b10f24ae7e53fe6$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $8b10f24ae7e53fe6$var$contentValuePattern, $8b10f24ae7e53fe6$var$contentValues, $8b10f24ae7e53fe6$var$oldProcessStyleValue, $8b10f24ae7e53fe6$var$msPattern, $8b10f24ae7e53fe6$var$hyphenPattern, $8b10f24ae7e53fe6$var$hyphenatedCache;
var $8b10f24ae7e53fe6$var$shouldWarnAboutInterpolatingClassNameFromCss = true;
function $8b10f24ae7e53fe6$var$handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
    if (interpolation == null) return '';
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            if (interpolation.anim === 1) {
                $8b10f24ae7e53fe6$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $8b10f24ae7e53fe6$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $8b10f24ae7e53fe6$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $8b10f24ae7e53fe6$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $8b10f24ae7e53fe6$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $8b10f24ae7e53fe6$var$cursor;
                var result = interpolation(mergedProps);
                $8b10f24ae7e53fe6$var$cursor = previousCursor;
                return $8b10f24ae7e53fe6$var$handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
            }
            break;
        case 'string':
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
}
function $8b10f24ae7e53fe6$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $8b10f24ae7e53fe6$var$handleInterpolation(mergedProps, registered, obj[i], false);
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== 'object') {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($8b10f24ae7e53fe6$var$isProcessableValue(value)) string += $8b10f24ae7e53fe6$var$processStyleName(_key) + ":" + $8b10f24ae7e53fe6$var$processStyleValue(_key, value) + ";";
        } else {
            _key;
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($8b10f24ae7e53fe6$var$isProcessableValue(value[_i])) string += $8b10f24ae7e53fe6$var$processStyleName(_key) + ":" + $8b10f24ae7e53fe6$var$processStyleValue(_key, value[_i]) + ";";
            } else {
                var interpolated = $8b10f24ae7e53fe6$var$handleInterpolation(mergedProps, registered, value, false);
                switch(_key){
                    case 'animation':
                    case 'animationName':
                        string += $8b10f24ae7e53fe6$var$processStyleName(_key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += _key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $8b10f24ae7e53fe6$var$labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var $8b10f24ae7e53fe6$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $8b10f24ae7e53fe6$var$cursor;
var $8b10f24ae7e53fe6$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $8b10f24ae7e53fe6$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $8b10f24ae7e53fe6$var$handleInterpolation(mergedProps, registered, strings, false);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $8b10f24ae7e53fe6$var$handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $8b10f24ae7e53fe6$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $8b10f24ae7e53fe6$var$labelPattern.exec(styles)) !== null)identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $265e8c0f7074eb72$export$2e2bcd8739ae039)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $8b10f24ae7e53fe6$var$cursor
    };
};


var $f246323fe9a4dbd3$export$dda1d9f60106f0e9 = Object.prototype.hasOwnProperty;
var $f246323fe9a4dbd3$var$EmotionCacheContext = /*#__PURE__*/ (0, $lx97N.createContext)(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? (0, $90b82e94834dce34$export$2e2bcd8739ae039)() : null);
var $f246323fe9a4dbd3$export$971d5caa766a69d7 = /*#__PURE__*/ (0, $lx97N.createContext)({});
var $f246323fe9a4dbd3$export$e7094788287c5e9b = $f246323fe9a4dbd3$var$EmotionCacheContext.Provider;
var $f246323fe9a4dbd3$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    var render = function render(props, ref) {
        return /*#__PURE__*/ (0, $lx97N.createElement)($f246323fe9a4dbd3$var$EmotionCacheContext.Consumer, null, function(cache) {
            return func(props, cache, ref);
        });
    }; // $FlowFixMe
    return /*#__PURE__*/ (0, $lx97N.forwardRef)(render);
};
// thus we only need to replace what is a valid character for JS, but not for CSS
var $f246323fe9a4dbd3$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, '-');
};
var $f246323fe9a4dbd3$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $f246323fe9a4dbd3$var$labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var $f246323fe9a4dbd3$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($f246323fe9a4dbd3$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$f246323fe9a4dbd3$var$typePropName] = type; // TODO: check if this still works with all of those different JSX functions
    var error, match;
    return newProps;
};
var $f246323fe9a4dbd3$var$Noop = function Noop() {
    return null;
};
var $f246323fe9a4dbd3$var$render = function render(cache, props, theme, ref) {
    var cssProp = theme === null ? props.css : props.css(theme); // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var type = props[$f246323fe9a4dbd3$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $44d6f7c1deb750c8$export$95d99596f328fd52)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $8b10f24ae7e53fe6$export$6321afa313b251b5)(registeredStyles);
    var labelFromStack;
    var rules = (0, $44d6f7c1deb750c8$export$6f077d94b33a01aa)(cache, serialized, typeof type === 'string');
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($f246323fe9a4dbd3$export$dda1d9f60106f0e9.call(props, key) && key !== 'css' && key !== $f246323fe9a4dbd3$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    var ele = /*#__PURE__*/ (0, $lx97N.createElement)(type, newProps);
    var possiblyStyleElement = /*#__PURE__*/ (0, $lx97N.createElement)($f246323fe9a4dbd3$var$Noop, null);
    return /*#__PURE__*/ (0, $lx97N.createElement)((0, $lx97N.Fragment), null, possiblyStyleElement, ele);
}; // eslint-disable-next-line no-undef
var $f246323fe9a4dbd3$export$a9c23c6ac3fc3eca = /* #__PURE__ */ $f246323fe9a4dbd3$export$efccba1c4a2ef57b(function(props, cache, ref) {
    if (typeof props.css === 'function') return /*#__PURE__*/ (0, $lx97N.createElement)($f246323fe9a4dbd3$export$971d5caa766a69d7.Consumer, null, function(theme) {
        return $f246323fe9a4dbd3$var$render(cache, props, theme, ref);
    });
    return $f246323fe9a4dbd3$var$render(cache, props, null, ref);
});






function $6105bfda1ce101d1$var$css() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $8b10f24ae7e53fe6$export$6321afa313b251b5)(args);
}
var $6105bfda1ce101d1$export$2e2bcd8739ae039 = $6105bfda1ce101d1$var$css;


var $a903afd89d23e5a0$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $f246323fe9a4dbd3$export$dda1d9f60106f0e9).call(props, 'css')) // $FlowFixMe
    return (0, $lx97N.createElement).apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $f246323fe9a4dbd3$export$a9c23c6ac3fc3eca);
    createElementArgArray[1] = (0, $f246323fe9a4dbd3$export$db3b6bfb95261072)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return (0, $lx97N.createElement).apply(null, createElementArgArray);
};
var $a903afd89d23e5a0$var$warnedAboutCssPropForGlobal = false;
var $a903afd89d23e5a0$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $f246323fe9a4dbd3$export$efccba1c4a2ef57b)(function(props, cache) {
    var styles = props.styles;
    if (typeof styles === 'function') return /*#__PURE__*/ (0, $lx97N.createElement)((0, $f246323fe9a4dbd3$export$971d5caa766a69d7).Consumer, null, function(theme) {
        var serialized = (0, $8b10f24ae7e53fe6$export$6321afa313b251b5)([
            styles(theme)
        ]);
        return /*#__PURE__*/ (0, $lx97N.createElement)($a903afd89d23e5a0$var$InnerGlobal, {
            serialized: serialized,
            cache: cache
        });
    });
    var serialized = (0, $8b10f24ae7e53fe6$export$6321afa313b251b5)([
        styles
    ]);
    return /*#__PURE__*/ (0, $lx97N.createElement)($a903afd89d23e5a0$var$InnerGlobal, {
        serialized: serialized,
        cache: cache
    });
});
// maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $a903afd89d23e5a0$var$InnerGlobal = /*#__PURE__*/ function(_React$Component) {
    (0, $7fd885f4c490992f$export$2e2bcd8739ae039)(InnerGlobal, _React$Component);
    function InnerGlobal(props, context, updater) {
        return _React$Component.call(this, props, context, updater) || this;
    }
    var _proto = InnerGlobal.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.sheet = new (0, $d403d32521212f06$export$9d753cd7ae895cce)({
            key: this.props.cache.key + "-global",
            nonce: this.props.cache.sheet.nonce,
            container: this.props.cache.sheet.container
        }); // $FlowFixMe
        var node = document.querySelector("style[data-emotion-" + this.props.cache.key + "=\"" + this.props.serialized.name + "\"]");
        if (node !== null) this.sheet.tags.push(node);
        if (this.props.cache.sheet.tags.length) this.sheet.before = this.props.cache.sheet.tags[0];
        this.insertStyles();
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (prevProps.serialized.name !== this.props.serialized.name) this.insertStyles();
    };
    _proto.insertStyles = function insertStyles$1() {
        if (this.props.serialized.next !== undefined) // insert keyframes
        (0, $44d6f7c1deb750c8$export$6f077d94b33a01aa)(this.props.cache, this.props.serialized.next, true);
        if (this.sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = this.sheet.tags[this.sheet.tags.length - 1].nextElementSibling;
            this.sheet.before = element;
            this.sheet.flush();
        }
        this.props.cache.insert("", this.props.serialized, this.sheet, false);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.sheet.flush();
    };
    _proto.render = function render() {
        return null;
    };
    return InnerGlobal;
}((0, $lx97N.Component));
var $a903afd89d23e5a0$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = (0, $6105bfda1ce101d1$export$2e2bcd8739ae039).apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $a903afd89d23e5a0$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $a903afd89d23e5a0$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $44d6f7c1deb750c8$export$95d99596f328fd52)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $a903afd89d23e5a0$var$Noop = function Noop() {
    return null;
};
var $a903afd89d23e5a0$export$9b9c0f9d9f3552b8 = (0, $f246323fe9a4dbd3$export$efccba1c4a2ef57b)(function(props, context) {
    return /*#__PURE__*/ (0, $lx97N.createElement)((0, $f246323fe9a4dbd3$export$971d5caa766a69d7).Consumer, null, function(theme) {
        var hasRendered = false;
        var css = function css() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            var serialized = (0, $8b10f24ae7e53fe6$export$6321afa313b251b5)(args, context.registered);
            (0, $44d6f7c1deb750c8$export$6f077d94b33a01aa)(context, serialized, false);
            return context.key + "-" + serialized.name;
        };
        var cx = function cx() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return $a903afd89d23e5a0$var$merge(context.registered, css, $a903afd89d23e5a0$var$classnames(args));
        };
        var content = {
            css: css,
            cx: cx,
            theme: theme
        };
        var ele = props.children(content);
        hasRendered = true;
        var possiblyStyleElement = /*#__PURE__*/ (0, $lx97N.createElement)($a903afd89d23e5a0$var$Noop, null);
        return /*#__PURE__*/ (0, $lx97N.createElement)((0, $lx97N.Fragment), null, possiblyStyleElement, ele);
    });
});




function $13d8f246ee75675a$export$7b81ddcf5552a7bb(state) {
    if (!state.currentTask) return null;
    return state.tasks.present[state.currentTask];
}
function $13d8f246ee75675a$export$e82b432c98c7ae91(state) {
    const task = $13d8f246ee75675a$export$7b81ddcf5552a7bb(state);
    if (!task) throw new Error(`There is no current task`);
    return task;
}
function $13d8f246ee75675a$export$9a7ed5c29b3d23ba(state) {
    const task = $13d8f246ee75675a$export$7b81ddcf5552a7bb(state);
    if (!task) return ``;
    const repo = state.repos.find((r)=>r.id === task.repoId);
    if (!repo) return ``;
    return repo.friendName;
}
function $13d8f246ee75675a$export$3bf98e6bba46a544(state) {
    const { searching: searching, documentSlug: documentSlug, editionType: editionType, filename: filename } = state.search;
    const task = $13d8f246ee75675a$export$7b81ddcf5552a7bb(state);
    if (!task || !searching) return [];
    return Object.values(task.files).filter((file)=>{
        const [docSlug, edType, basename] = file.path.split(`/`);
        if (documentSlug && docSlug !== documentSlug) return false;
        if (editionType && edType !== editionType) return false;
        if (filename && basename !== filename) return false;
        return true;
    });
}
function $13d8f246ee75675a$export$619b806001333a9(task) {
    let documents = [];
    documents = Object.values(task.files).reduce((docs, file)=>{
        const [docSlug, edType, filename] = file.path.split(`/`);
        let document = docs.find((d)=>d.slug === docSlug);
        if (!document) {
            document = {
                slug: docSlug,
                title: task.documentTitles[docSlug],
                editions: []
            };
            docs.push(document);
        }
        let edition = document.editions.find((e)=>e.type === edType);
        if (!edition) {
            edition = {
                path: file.path,
                type: edType,
                files: []
            };
            document.editions.push(edition);
        }
        edition.files.push({
            filename: filename,
            path: file.path,
            edited: !!file.editedContent && file.editedContent !== file.content
        });
        return docs;
    }, documents);
    documents.forEach((doc)=>{
        doc.editions = doc.editions.sort(({ type: type })=>{
            switch(type){
                case `updated`:
                    return -1;
                case `modernized`:
                    return 0;
                default:
                    return 1;
            }
        });
    });
    return documents;
}


var $80b1b2d4767dcec9$exports = {};

$parcel$export($80b1b2d4767dcec9$exports, "alert", () => $80b1b2d4767dcec9$export$5ea928c9faf85bd3, (v) => $80b1b2d4767dcec9$export$5ea928c9faf85bd3 = v);
$parcel$export($80b1b2d4767dcec9$exports, "prompt", () => $80b1b2d4767dcec9$export$195ba6d62321b933, (v) => $80b1b2d4767dcec9$export$195ba6d62321b933 = v);
$parcel$export($80b1b2d4767dcec9$exports, "confirm", () => $80b1b2d4767dcec9$export$715f9d76bb8c1fea, (v) => $80b1b2d4767dcec9$export$715f9d76bb8c1fea = v);
$parcel$export($80b1b2d4767dcec9$exports, "progress", () => $80b1b2d4767dcec9$export$504d7abb21fa8c9, (v) => $80b1b2d4767dcec9$export$504d7abb21fa8c9 = v);
var $80b1b2d4767dcec9$export$5ea928c9faf85bd3;
var $80b1b2d4767dcec9$export$195ba6d62321b933;
var $80b1b2d4767dcec9$export$715f9d76bb8c1fea;
var $80b1b2d4767dcec9$export$504d7abb21fa8c9;
'use strict';
function $80b1b2d4767dcec9$var$_slicedToArray(arr, i) {
    return $80b1b2d4767dcec9$var$_arrayWithHoles(arr) || $80b1b2d4767dcec9$var$_iterableToArrayLimit(arr, i) || $80b1b2d4767dcec9$var$_nonIterableRest();
}
function $80b1b2d4767dcec9$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function $80b1b2d4767dcec9$var$_iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $80b1b2d4767dcec9$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}

var $ac877ad5f08e7c88$exports = {};
'use strict';
const $ac877ad5f08e7c88$var$f = (fn)=>[
        /*eslint no-unused-vars: 0*/ function(a) {
            return fn(...arguments);
        },
        function(a, b) {
            return fn(...arguments);
        },
        function(a, b, c) {
            return fn(...arguments);
        },
        function(a, b, c, d) {
            return fn(...arguments);
        },
        function(a, b, c, d, e) {
            return fn(...arguments);
        }
    ];
const $ac877ad5f08e7c88$var$currify = (fn, ...args)=>{
    $ac877ad5f08e7c88$var$check(fn);
    if (args.length >= fn.length) return fn(...args);
    const again = (...args2)=>{
        return $ac877ad5f08e7c88$var$currify(fn, ...[
            ...args,
            ...args2
        ]);
    };
    const count = fn.length - args.length - 1;
    const func = $ac877ad5f08e7c88$var$f(again)[count];
    return func || again;
};
$ac877ad5f08e7c88$exports = $ac877ad5f08e7c88$var$currify;
function $ac877ad5f08e7c88$var$check(fn) {
    if (typeof fn !== 'function') throw Error('fn should be function!');
}


var $4a6ca9c2eb38007a$exports = {};
'use strict';
$4a6ca9c2eb38007a$exports = (value)=>{
    const data = {
        value: value
    };
    return function(value) {
        if (!arguments.length) return data.value;
        data.value = value;
        return value;
    };
};


var $6f5797ba20f000d8$exports = {};
'use strict';
var $70e7f91283e3c183$exports = {};
'use strict';
const $70e7f91283e3c183$var$f = (fn)=>[
        /*eslint no-unused-vars: 0*/ function(a) {
            return fn(...arguments);
        },
        function(a, b) {
            return fn(...arguments);
        },
        function(a, b, c) {
            return fn(...arguments);
        },
        function(a, b, c, d) {
            return fn(...arguments);
        },
        function(a, b, c, d, e) {
            return fn(...arguments);
        }
    ];
const $70e7f91283e3c183$var$currify = (fn, ...args)=>{
    $70e7f91283e3c183$var$check(fn);
    if (args.length >= fn.length) return fn(...args);
    const again = (...args2)=>{
        return $70e7f91283e3c183$var$currify(fn, ...[
            ...args,
            ...args2
        ]);
    };
    const count = fn.length - args.length - 1;
    const func = $70e7f91283e3c183$var$f(again)[count];
    return func || again;
};
$70e7f91283e3c183$exports = $70e7f91283e3c183$var$currify;
function $70e7f91283e3c183$var$check(fn) {
    if (typeof fn !== 'function') throw Error('fn should be function!');
}


const $6f5797ba20f000d8$var$query = (a)=>document.querySelector(`[data-name="${a}"]`);
const $6f5797ba20f000d8$var$setAttribute = $70e7f91283e3c183$exports((el, obj, name)=>el.setAttribute(name, obj[name]));
const $6f5797ba20f000d8$var$set = $70e7f91283e3c183$exports((el, obj, name)=>el[name] = obj[name]);
const $6f5797ba20f000d8$var$not = $70e7f91283e3c183$exports((f, a)=>!f(a));
const $6f5797ba20f000d8$var$isCamelCase = (a)=>a != a.toLowerCase();
$6f5797ba20f000d8$exports = (name, options = {})=>{
    const { dataName: dataName, notAppend: notAppend, parent: parent = document.body, uniq: uniq = true, ...restOptions } = options;
    const elFound = $6f5797ba20f000d8$var$isElementPresent(dataName);
    if (uniq && elFound) return elFound;
    const el = document.createElement(name);
    if (dataName) el.dataset.name = dataName;
    Object.keys(restOptions).filter($6f5797ba20f000d8$var$isCamelCase).map($6f5797ba20f000d8$var$set(el, options));
    Object.keys(restOptions).filter($6f5797ba20f000d8$var$not($6f5797ba20f000d8$var$isCamelCase)).map($6f5797ba20f000d8$var$setAttribute(el, options));
    if (!notAppend) parent.appendChild(el);
    return el;
};
$6f5797ba20f000d8$exports.isElementPresent = $6f5797ba20f000d8$var$isElementPresent;
function $6f5797ba20f000d8$var$isElementPresent(dataName) {
    if (!dataName) return;
    return $6f5797ba20f000d8$var$query(dataName);
}


var $80b1b2d4767dcec9$var$keyDown = $ac877ad5f08e7c88$exports($80b1b2d4767dcec9$var$keyDown_);
var $80b1b2d4767dcec9$var$BUTTON_OK = {
    ok: 'OK'
};
var $80b1b2d4767dcec9$var$BUTTON_OK_CANCEL = {
    ok: 'OK',
    cancel: 'Cancel'
};
var $80b1b2d4767dcec9$var$zIndex = $4a6ca9c2eb38007a$exports(100);
$80b1b2d4767dcec9$export$5ea928c9faf85bd3 = function(title, msg, options) {
    var buttons = $80b1b2d4767dcec9$var$getButtons(options) || $80b1b2d4767dcec9$var$BUTTON_OK;
    return $80b1b2d4767dcec9$var$showDialog(title, msg, '', buttons, options);
};
$80b1b2d4767dcec9$export$195ba6d62321b933 = function(title, msg) {
    var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var options = arguments.length > 3 ? arguments[3] : undefined;
    var type = $80b1b2d4767dcec9$var$getType(options);
    var val = String(value).replace(/"/g, '&quot;');
    var valueStr = "<input type=\"".concat(type, "\" value=\"").concat(val, "\" data-name=\"js-input\">");
    var buttons = $80b1b2d4767dcec9$var$getButtons(options) || $80b1b2d4767dcec9$var$BUTTON_OK_CANCEL;
    return $80b1b2d4767dcec9$var$showDialog(title, msg, valueStr, buttons, options);
};
$80b1b2d4767dcec9$export$715f9d76bb8c1fea = function(title, msg, options) {
    var buttons = $80b1b2d4767dcec9$var$getButtons(options) || $80b1b2d4767dcec9$var$BUTTON_OK_CANCEL;
    return $80b1b2d4767dcec9$var$showDialog(title, msg, '', buttons, options);
};
$80b1b2d4767dcec9$export$504d7abb21fa8c9 = function(title, message, options) {
    var valueStr = "\n        <progress value=\"0\" data-name=\"js-progress\" class=\"progress\" max=\"100\"></progress>\n        <span data-name=\"js-counter\">0%</span>\n    ";
    var buttons = {
        cancel: 'Abort'
    };
    var promise = $80b1b2d4767dcec9$var$showDialog(title, message, valueStr, buttons, options);
    var ok = promise.ok, dialog = promise.dialog;
    var resolve = ok();
    $80b1b2d4767dcec9$var$find(dialog, [
        'cancel'
    ]).map(function(el) {
        el.focus();
    });
    Object.assign(promise, {
        setProgress: function setProgress(count) {
            var _find = $80b1b2d4767dcec9$var$find(dialog, [
                'progress'
            ]), _find2 = $80b1b2d4767dcec9$var$_slicedToArray(_find, 1), elProgress = _find2[0];
            var _find3 = $80b1b2d4767dcec9$var$find(dialog, [
                'counter'
            ]), _find4 = $80b1b2d4767dcec9$var$_slicedToArray(_find3, 1), elCounter = _find4[0];
            elProgress.value = count;
            elCounter.textContent = "".concat(count, "%");
            if (count === 100) {
                $80b1b2d4767dcec9$var$_remove(dialog);
                resolve();
            }
        },
        remove: function remove() {
            $80b1b2d4767dcec9$var$_remove(dialog);
        }
    });
    return promise;
};
function $80b1b2d4767dcec9$var$getButtons() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var buttons = options.buttons;
    if (!buttons) return null;
    return buttons;
}
function $80b1b2d4767dcec9$var$getType() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var type = options.type;
    if (type === 'password') return 'password';
    return 'text';
}
function $80b1b2d4767dcec9$var$getTemplate(title, msg, value, buttons) {
    var encodedMsg = msg.replace(/\n/g, '<br>');
    return "<div class=\"page\">\n        <div data-name=\"js-close\" class=\"close-button\"></div>\n        <header>".concat(title, "</header>\n        <div class=\"content-area\">").concat(encodedMsg).concat(value, "</div>\n        <div class=\"action-area\">\n            <div class=\"button-strip\">\n                ").concat($80b1b2d4767dcec9$var$parseButtons(buttons), "\n            </div>\n        </div>\n    </div>");
}
function $80b1b2d4767dcec9$var$parseButtons(buttons) {
    var names = Object.keys(buttons);
    var parse = $ac877ad5f08e7c88$exports(function(buttons, name, i) {
        return "<button\n            tabindex=".concat(i, "\n            data-name=\"js-").concat(name.toLowerCase(), "\">\n            ").concat(buttons[name], "\n        </button>");
    });
    return names.map(parse(buttons)).join('');
}
function $80b1b2d4767dcec9$var$showDialog(title, msg, value, buttons, options) {
    var ok = $4a6ca9c2eb38007a$exports();
    var cancel = $4a6ca9c2eb38007a$exports();
    var closeButtons = [
        'cancel',
        'close',
        'ok'
    ];
    var promise = new Promise(function(resolve, reject) {
        var noCancel = options && options.cancel === false;
        var empty = function empty() {};
        var rejectError = function rejectError() {
            return reject(Error());
        };
        ok(resolve);
        cancel(noCancel ? empty : rejectError);
    });
    var innerHTML = $80b1b2d4767dcec9$var$getTemplate(title, msg, value, buttons);
    var dialog = $6f5797ba20f000d8$exports('div', {
        innerHTML: innerHTML,
        className: 'smalltalk',
        style: "z-index: ".concat($80b1b2d4767dcec9$var$zIndex($80b1b2d4767dcec9$var$zIndex() + 1))
    });
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;
    try {
        for(var _iterator = $80b1b2d4767dcec9$var$find(dialog, [
            'ok',
            'input'
        ])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var el = _step.value;
            el.focus();
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) _iterator["return"]();
        } finally{
            if (_didIteratorError) throw _iteratorError;
        }
    }
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;
    try {
        for(var _iterator2 = $80b1b2d4767dcec9$var$find(dialog, [
            'input'
        ])[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
            var _el = _step2.value;
            _el.setSelectionRange(0, value.length);
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) _iterator2["return"]();
        } finally{
            if (_didIteratorError2) throw _iteratorError2;
        }
    }
    $80b1b2d4767dcec9$var$addListenerAll('click', dialog, closeButtons, function(event) {
        $80b1b2d4767dcec9$var$closeDialog(event.target, dialog, ok(), cancel());
    });
    for(var _i2 = 0, _arr2 = [
        'click',
        'contextmenu'
    ]; _i2 < _arr2.length; _i2++){
        var event = _arr2[_i2];
        dialog.addEventListener(event, function(e) {
            e.stopPropagation();
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;
            try {
                for(var _iterator3 = $80b1b2d4767dcec9$var$find(dialog, [
                    'ok',
                    'input'
                ])[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                    var _el2 = _step3.value;
                    _el2.focus();
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3["return"] != null) _iterator3["return"]();
                } finally{
                    if (_didIteratorError3) throw _iteratorError3;
                }
            }
        });
    }
    dialog.addEventListener('keydown', $80b1b2d4767dcec9$var$keyDown(dialog, ok(), cancel()));
    return Object.assign(promise, {
        dialog: dialog,
        ok: ok
    });
}
function $80b1b2d4767dcec9$var$keyDown_(dialog, ok, cancel, event) {
    var KEY = {
        ENTER: 13,
        ESC: 27,
        TAB: 9,
        LEFT: 37,
        UP: 38,
        RIGHT: 39,
        DOWN: 40
    };
    var keyCode = event.keyCode;
    var el = event.target;
    var namesAll = [
        'ok',
        'cancel',
        'input'
    ];
    var names = $80b1b2d4767dcec9$var$find(dialog, namesAll).map($80b1b2d4767dcec9$var$getDataName);
    switch(keyCode){
        case KEY.ENTER:
            $80b1b2d4767dcec9$var$closeDialog(el, dialog, ok, cancel);
            event.preventDefault();
            break;
        case KEY.ESC:
            $80b1b2d4767dcec9$var$_remove(dialog);
            cancel();
            break;
        case KEY.TAB:
            if (event.shiftKey) $80b1b2d4767dcec9$var$tab(dialog, names);
            $80b1b2d4767dcec9$var$tab(dialog, names);
            event.preventDefault();
            break;
        default:
            [
                'left',
                'right',
                'up',
                'down'
            ].filter(function(name) {
                return keyCode === KEY[name.toUpperCase()];
            }).forEach(function() {
                $80b1b2d4767dcec9$var$changeButtonFocus(dialog, names);
            });
            break;
    }
    event.stopPropagation();
}
function $80b1b2d4767dcec9$var$getDataName(el) {
    return el.getAttribute('data-name').replace('js-', '');
}
function $80b1b2d4767dcec9$var$changeButtonFocus(dialog, names) {
    var active = document.activeElement;
    var activeName = $80b1b2d4767dcec9$var$getDataName(active);
    var isButton = /ok|cancel/.test(activeName);
    var count = names.length - 1;
    var getName = function getName(activeName) {
        if (activeName === 'cancel') return 'ok';
        return 'cancel';
    };
    if (activeName === 'input' || !count || !isButton) return;
    var name = getName(activeName);
    var _iteratorNormalCompletion4 = true;
    var _didIteratorError4 = false;
    var _iteratorError4 = undefined;
    try {
        for(var _iterator4 = $80b1b2d4767dcec9$var$find(dialog, [
            name
        ])[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true){
            var el = _step4.value;
            el.focus();
        }
    } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion4 && _iterator4["return"] != null) _iterator4["return"]();
        } finally{
            if (_didIteratorError4) throw _iteratorError4;
        }
    }
}
var $80b1b2d4767dcec9$var$getIndex = function getIndex(count, index) {
    if (index === count) return 0;
    return index + 1;
};
function $80b1b2d4767dcec9$var$tab(dialog, names) {
    var active = document.activeElement;
    var activeName = $80b1b2d4767dcec9$var$getDataName(active);
    var count = names.length - 1;
    var activeIndex = names.indexOf(activeName);
    var index = $80b1b2d4767dcec9$var$getIndex(count, activeIndex);
    var name = names[index];
    var _iteratorNormalCompletion5 = true;
    var _didIteratorError5 = false;
    var _iteratorError5 = undefined;
    try {
        for(var _iterator5 = $80b1b2d4767dcec9$var$find(dialog, [
            name
        ])[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true){
            var el = _step5.value;
            el.focus();
        }
    } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion5 && _iterator5["return"] != null) _iterator5["return"]();
        } finally{
            if (_didIteratorError5) throw _iteratorError5;
        }
    }
}
function $80b1b2d4767dcec9$var$closeDialog(el, dialog, ok, cancel) {
    var name = el.getAttribute('data-name').replace('js-', '');
    if (/close|cancel/.test(name)) {
        cancel();
        $80b1b2d4767dcec9$var$_remove(dialog);
        return;
    }
    var value = $80b1b2d4767dcec9$var$find(dialog, [
        'input'
    ]).reduce(function(value, el) {
        return el.value;
    }, null);
    ok(value);
    $80b1b2d4767dcec9$var$_remove(dialog);
}
function $80b1b2d4767dcec9$var$find(element, names) {
    var elements = names.map(function(name) {
        return element.querySelector("[data-name=\"js-".concat(name, "\"]"));
    }).filter(Boolean);
    return elements;
}
function $80b1b2d4767dcec9$var$addListenerAll(event, parent, elements, fn) {
    var _iteratorNormalCompletion6 = true;
    var _didIteratorError6 = false;
    var _iteratorError6 = undefined;
    try {
        for(var _iterator6 = $80b1b2d4767dcec9$var$find(parent, elements)[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true){
            var el = _step6.value;
            el.addEventListener(event, fn);
        }
    } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion6 && _iterator6["return"] != null) _iterator6["return"]();
        } finally{
            if (_didIteratorError6) throw _iteratorError6;
        }
    }
}
function $80b1b2d4767dcec9$var$_remove(dialog) {
    var parentElement = dialog.parentElement;
    if (parentElement) parentElement.removeChild(dialog);
}


var $58324057efc05658$exports = {};

$parcel$export($58324057efc05658$exports, "smartQuotes", () => $a18bae2279a18731$export$2e2bcd8739ae039);
$parcel$export($58324057efc05658$exports, "listYear", () => $f3b0901be3a09481$export$2e2bcd8739ae039);
$parcel$export($58324057efc05658$exports, "lineLength", () => $47053d0bbcd60188$export$2e2bcd8739ae039);
$parcel$export($58324057efc05658$exports, "trailingWhitespace", () => $57599e966153a2ee$export$2e2bcd8739ae039);
$parcel$export($58324057efc05658$exports, "leadingWhitespace", () => $f6bde9dc3bf69faf$export$2e2bcd8739ae039);
$parcel$export($58324057efc05658$exports, "unintentionalListItem", () => $f99917ee75a41b59$export$2e2bcd8739ae039);
$parcel$export($58324057efc05658$exports, "multipleBlankLines", () => $5133f3ddd94b5cd2$export$2e2bcd8739ae039);
$parcel$export($58324057efc05658$exports, "eofNewline", () => $c614ad91c38b4306$export$2e2bcd8739ae039);
$parcel$export($58324057efc05658$exports, "confusingBracket", () => $26a2d039a35a4871$export$2e2bcd8739ae039);
$parcel$export($58324057efc05658$exports, "floatingClass", () => $5957fdba184b6272$export$2e2bcd8739ae039);
$parcel$export($58324057efc05658$exports, "invalidHeading", () => $35b3a5fec3ec1f04$export$2e2bcd8739ae039);
$parcel$export($58324057efc05658$exports, "invalidCharacters", () => $4d2ffe8045c3da64$export$2e2bcd8739ae039);
$parcel$export($58324057efc05658$exports, "chapterSynopsisList", () => $d43c8be8f7800c7f$export$2e2bcd8739ae039);
$parcel$export($58324057efc05658$exports, "doubledPunctuation", () => $65d08bdeb08b40ea$export$2e2bcd8739ae039);
$parcel$export($58324057efc05658$exports, "consecutiveSpaces", () => $4b35679ce1077cb7$export$2e2bcd8739ae039);
$parcel$export($58324057efc05658$exports, "scanErrors", () => $7cdec9492a62c478$export$2e2bcd8739ae039);
$parcel$export($58324057efc05658$exports, "gitConflictMarkers", () => $b5344e395a604534$export$2e2bcd8739ae039);
$parcel$export($58324057efc05658$exports, "hangingQuotes", () => $b68e7ff586333865$export$2e2bcd8739ae039);
$parcel$export($58324057efc05658$exports, "trailingHyphen", () => $152524cb294970e8$export$2e2bcd8739ae039);
$parcel$export($58324057efc05658$exports, "unhyphenedWords", () => $bcfdeb0d515a5258$export$2e2bcd8739ae039);
$parcel$export($58324057efc05658$exports, "obsoleteSpellings", () => $76570f5e9ca56bcb$export$2e2bcd8739ae039);
$parcel$export($58324057efc05658$exports, "capitalize", () => $d582a41d12e1b6f4$export$2e2bcd8739ae039);
$parcel$export($58324057efc05658$exports, "unspacedClass", () => $8f12e3d409c5a0e7$export$2e2bcd8739ae039);
$parcel$export($58324057efc05658$exports, "joinWords", () => $a004eda09af84220$export$2e2bcd8739ae039);
$parcel$export($58324057efc05658$exports, "emptyRole", () => $ecd5f0c311092922$export$2e2bcd8739ae039);
$parcel$export($58324057efc05658$exports, "noUndefined", () => $a098fb060e30bc80$export$2e2bcd8739ae039);
$parcel$export($58324057efc05658$exports, "danglingPossessive", () => $4b94e3132d0562e1$export$2e2bcd8739ae039);
$parcel$export($58324057efc05658$exports, "midWordUppercase", () => $a3377bb039ce7127$export$2e2bcd8739ae039);
$parcel$export($58324057efc05658$exports, "unspacedPeriod", () => $5cf80ecccc474372$export$2e2bcd8739ae039);
$parcel$export($58324057efc05658$exports, "midWordNonLetter", () => $c5bd8cf14e91c9c0$export$2e2bcd8739ae039);
$parcel$export($58324057efc05658$exports, "unexpectedPeriod", () => $f03762e5abf291ce$export$2e2bcd8739ae039);
$parcel$export($58324057efc05658$exports, "modernizeWords", () => $b1e38fd7251c7350$export$2e2bcd8739ae039);
$parcel$export($58324057efc05658$exports, "consistentNameSpelling", () => $ec0591c1bad7c2a7$export$2e2bcd8739ae039);
$parcel$export($58324057efc05658$exports, "italicsTouchingFootnote", () => $60473d299dc0fe2d$export$2e2bcd8739ae039);
$parcel$export($58324057efc05658$exports, "unexpectedUnderscore", () => $a26a59f502c888fc$export$2e2bcd8739ae039);
$parcel$export($58324057efc05658$exports, "emdashTouchingItalics", () => $2c382442436d4807$export$2e2bcd8739ae039);
$parcel$export($58324057efc05658$exports, "libreOfficeArtifacts", () => $110b9f1101c858dc$export$2e2bcd8739ae039);
$parcel$export($58324057efc05658$exports, "footnoteSplitSpacing", () => $4cae0e279ef025d5$export$2e2bcd8739ae039);
$parcel$export($58324057efc05658$exports, "unexpectedIdentifier", () => $10ace03c47299cff$export$2e2bcd8739ae039);
$parcel$export($58324057efc05658$exports, "unspacedMarkup", () => $5cb83f8e7a6c8a6f$export$2e2bcd8739ae039);
$parcel$export($58324057efc05658$exports, "spacedPunctuation", () => $a15e5f89bdbd9718$export$2e2bcd8739ae039);
$parcel$export($58324057efc05658$exports, "postscriptHeader", () => $7c9a1b0666e63b1c$export$2e2bcd8739ae039);
$parcel$export($58324057efc05658$exports, "unwrappedPostscript", () => $a30f92c824fc8106$export$2e2bcd8739ae039);
$parcel$export($58324057efc05658$exports, "bookTitleSpacing", () => $ae00595da75427cd$export$2e2bcd8739ae039);
$parcel$export($58324057efc05658$exports, "bookTitleStart", () => $34ae04d011468e32$export$2e2bcd8739ae039);
$parcel$export($58324057efc05658$exports, "bookTitleUnclosed", () => $b0c97373f9a9b816$export$2e2bcd8739ae039);
$parcel$export($58324057efc05658$exports, "personMismatch", () => $03b5ce36bb3970cc$export$2e2bcd8739ae039);
$parcel$export($58324057efc05658$exports, "etcPeriod", () => $506f7b8b3047cda4$export$2e2bcd8739ae039);
$parcel$export($58324057efc05658$exports, "titleLength", () => $38759ac37448c45c$export$2e2bcd8739ae039);
$parcel$export($58324057efc05658$exports, "unexpectedAsterisk", () => $29007b72f36308f4$export$2e2bcd8739ae039);
$parcel$export($58324057efc05658$exports, "initialsComma", () => $6f03f58a3633b769$export$2e2bcd8739ae039);
$parcel$export($58324057efc05658$exports, "amPm", () => $1ed6579f500288ee$export$2e2bcd8739ae039);
function $2f86063047d29fb1$export$c7e07b33f2a129cf(adoc) {
    return adoc.split(`\n`).map($2f86063047d29fb1$export$ecf03f26d74da604).join(`\n`);
}
function $2f86063047d29fb1$export$ecf03f26d74da604(line) {
    if (line === `'''`) return line;
    if (line.match(/^\[.+\]$/)) return line;
    let match = null;
    const chars = line.split(``);
    const mod = [
        ...chars
    ];
    const expr = /"|'/g;
    while(match = expr.exec(line)){
        const type = match[0] ?? ``;
        const { index: index } = match;
        const before = line.substring(0, index);
        const after = line.substring(index + 1);
        const charBefore = before[index - 1];
        const charAfter = after[0];
        if (charBefore === $2f86063047d29fb1$var$BACKTICK || charAfter === $2f86063047d29fb1$var$BACKTICK) continue;
        // beginning of line? point right
        if (index === 0) {
            mod[0] = $2f86063047d29fb1$var$right(type);
            continue;
        }
        // in the middle of a word like `don't`? point left
        if (charBefore && charBefore.match(/[a-z0-9]/i) && charAfter && charAfter.match(/[a-z,;:.]/i)) {
            // continue; // comment out to segregate possessive fixes
            mod[index] = $2f86063047d29fb1$var$left(type);
            continue;
        }
        // if there is a space before it, always point it right
        if (charBefore === ` `) {
            mod[index] = $2f86063047d29fb1$var$right(type);
            continue;
        }
        // if there is a space after it, always point left
        if (charAfter === ` `) {
            mod[index] = $2f86063047d29fb1$var$left(type);
            continue;
        }
        // at the end of the line? point left
        if (index === line.length - 1) {
            mod[index] = $2f86063047d29fb1$var$left(type);
            continue;
        }
        if ([
            `?`,
            `.`,
            `,`
        ].includes(charBefore ?? ``)) {
            mod[index] = $2f86063047d29fb1$var$left(type);
            continue;
        }
        if (charBefore && charBefore.match(/[a-z0-9,;:.]/)) {
            mod[index] = $2f86063047d29fb1$var$left(type);
            continue;
        }
        // fallthrough
        mod[index] = $2f86063047d29fb1$var$right(type);
    }
    const newLine = mod.join(``);
    return newLine.replace(/([^`]|^)"`'([^` ])/g, `$1"\`'\`$2`).replace(/([^` [])'`"/g, `$1\`'\`"`).replace(/([^` [])"`'/g, `$1\`"\`'`).replace(/(^|\b| |`|-)'`(\d\d)(\b|$| )/g, `$1\`'$2$3`).replace(/([a-z])`"([a-z])/i, `$1\`'$2`).replace(/([a-z])--`'([a-z])/gi, `$1--'\`$2`).replace(/\+\+\+____+\+\+\+'`s\b/g, `+++_______+++\`'s`).replace(/(^|\b| |`|-)'`(')?(T|t)is(\b|$| )/g, (_, a, b, c, d)=>{
        return `${a}${b ? `'\`` : ``}\`'${c}is${d}`;
    });
}
function $2f86063047d29fb1$var$right(type) {
    return `${type}${$2f86063047d29fb1$var$BACKTICK}`;
}
function $2f86063047d29fb1$var$left(type) {
    return `${$2f86063047d29fb1$var$BACKTICK}${type}`;
}
const $2f86063047d29fb1$var$BACKTICK = `\``;


var $7d124c42914d71da$exports = {};

$parcel$export($7d124c42914d71da$exports, "find", () => $3eda73babff90abe$export$71aa6c912b956294);
$parcel$export($7d124c42914d71da$exports, "format", () => $578c773fac8be994$export$d9468344d3651243);
var $af8c6bde7c6033b2$exports = {};
$af8c6bde7c6033b2$exports = JSON.parse("[{\"name\":\"Genesis\",\"short\":\"Gen\",\"abbreviations\":[\"Gen\",\"Ge\",\"Gene\",\"Genes\",\"Gn\"],\"chapters\":50,\"chapter\":{\"1\":31,\"2\":25,\"3\":24,\"4\":26,\"5\":32,\"6\":22,\"7\":24,\"8\":22,\"9\":29,\"10\":32,\"11\":32,\"12\":20,\"13\":18,\"14\":24,\"15\":21,\"16\":16,\"17\":27,\"18\":33,\"19\":38,\"20\":18,\"21\":34,\"22\":24,\"23\":20,\"24\":67,\"25\":34,\"26\":35,\"27\":46,\"28\":22,\"29\":35,\"30\":43,\"31\":55,\"32\":32,\"33\":20,\"34\":31,\"35\":29,\"36\":43,\"37\":36,\"38\":30,\"39\":23,\"40\":23,\"41\":57,\"42\":38,\"43\":34,\"44\":34,\"45\":28,\"46\":34,\"47\":31,\"48\":22,\"49\":33,\"50\":26}},{\"name\":\"Exodus\",\"short\":\"Ex\",\"abbreviations\":[\"Exo\",\"Exod\",\"Ex\"],\"chapters\":40,\"chapter\":{\"1\":22,\"2\":25,\"3\":22,\"4\":31,\"5\":23,\"6\":30,\"7\":25,\"8\":32,\"9\":35,\"10\":29,\"11\":10,\"12\":51,\"13\":22,\"14\":31,\"15\":27,\"16\":36,\"17\":16,\"18\":27,\"19\":25,\"20\":26,\"21\":36,\"22\":31,\"23\":33,\"24\":18,\"25\":40,\"26\":37,\"27\":21,\"28\":43,\"29\":46,\"30\":38,\"31\":18,\"32\":35,\"33\":23,\"34\":35,\"35\":35,\"36\":38,\"37\":29,\"38\":31,\"39\":43,\"40\":38}},{\"name\":\"Leviticus\",\"short\":\"Lev\",\"abbreviations\":[\"Lev\",\"Levit\"],\"chapters\":27,\"chapter\":{\"1\":17,\"2\":16,\"3\":17,\"4\":35,\"5\":19,\"6\":30,\"7\":38,\"8\":36,\"9\":24,\"10\":20,\"11\":47,\"12\":8,\"13\":59,\"14\":57,\"15\":33,\"16\":34,\"17\":16,\"18\":30,\"19\":37,\"20\":27,\"21\":27,\"22\":33,\"23\":44,\"24\":23,\"25\":55,\"26\":46,\"27\":34}},{\"name\":\"Numbers\",\"short\":\"Num\",\"abbreviations\":[\"Num\",\"Numb\",\"Nu\",\"Nm\"],\"chapters\":36,\"chapter\":{\"1\":54,\"2\":34,\"3\":51,\"4\":49,\"5\":31,\"6\":27,\"7\":89,\"8\":26,\"9\":23,\"10\":36,\"11\":35,\"12\":16,\"13\":33,\"14\":45,\"15\":41,\"16\":50,\"17\":13,\"18\":32,\"19\":22,\"20\":29,\"21\":35,\"22\":41,\"23\":30,\"24\":25,\"25\":18,\"26\":65,\"27\":23,\"28\":31,\"29\":40,\"30\":16,\"31\":54,\"32\":42,\"33\":56,\"34\":29,\"35\":34,\"36\":13}},{\"name\":\"Deuteronomy\",\"short\":\"Duet\",\"abbreviations\":[\"Deut\",\"Deuter\",\"Deu\",\"Dt\"],\"chapters\":34,\"chapter\":{\"1\":46,\"2\":37,\"3\":29,\"4\":49,\"5\":33,\"6\":25,\"7\":26,\"8\":20,\"9\":29,\"10\":22,\"11\":32,\"12\":32,\"13\":18,\"14\":29,\"15\":23,\"16\":22,\"17\":20,\"18\":22,\"19\":21,\"20\":20,\"21\":23,\"22\":30,\"23\":25,\"24\":22,\"25\":19,\"26\":19,\"27\":26,\"28\":68,\"29\":29,\"30\":20,\"31\":30,\"32\":52,\"33\":29,\"34\":12}},{\"name\":\"Joshua\",\"short\":\"Josh\",\"abbreviations\":[\"Josh\",\"Jos\"],\"chapters\":34,\"chapter\":{\"1\":18,\"2\":24,\"3\":17,\"4\":24,\"5\":15,\"6\":27,\"7\":26,\"8\":35,\"9\":27,\"10\":43,\"11\":23,\"12\":24,\"13\":33,\"14\":15,\"15\":63,\"16\":10,\"17\":18,\"18\":28,\"19\":51,\"20\":9,\"21\":45,\"22\":34,\"23\":16,\"24\":33}},{\"name\":\"Judges\",\"short\":\"Judg\",\"abbreviations\":[\"Judg\",\"Ju\",\"Jdg\",\"Jdj\",\"Jd\"],\"chapters\":21,\"chapter\":{\"1\":36,\"2\":23,\"3\":31,\"4\":24,\"5\":31,\"6\":40,\"7\":25,\"8\":35,\"9\":57,\"10\":18,\"11\":40,\"12\":15,\"13\":25,\"14\":20,\"15\":20,\"16\":31,\"17\":13,\"18\":31,\"19\":30,\"20\":48,\"21\":25}},{\"name\":\"Ruth\",\"short\":\"Ruth\",\"abbreviations\":[\"Ru\"],\"chapters\":4,\"chapter\":{\"1\":22,\"2\":23,\"3\":18,\"4\":22}},{\"name\":\"1 Samuel\",\"short\":\"1 Sam\",\"abbreviations\":[\"1Sam\",\"1 Sam\",\"iSam\",\"i Sam\",\"1Sa\",\"1 Sa\"],\"chapters\":31,\"chapter\":{\"1\":28,\"2\":36,\"3\":21,\"4\":22,\"5\":12,\"6\":21,\"7\":17,\"8\":22,\"9\":27,\"10\":27,\"11\":15,\"12\":25,\"13\":23,\"14\":52,\"15\":35,\"16\":23,\"17\":58,\"18\":30,\"19\":24,\"20\":42,\"21\":15,\"22\":23,\"23\":29,\"24\":22,\"25\":44,\"26\":25,\"27\":12,\"28\":25,\"29\":11,\"30\":31,\"31\":13}},{\"name\":\"2 Samuel\",\"short\":\"2 Sam\",\"abbreviations\":[\"2Sam\",\"2 Sam\",\"iiSam\",\"ii Sam\",\"2Sa\",\"2 Sa\"],\"chapters\":24,\"chapter\":{\"1\":27,\"2\":32,\"3\":39,\"4\":12,\"5\":25,\"6\":23,\"7\":29,\"8\":18,\"9\":13,\"10\":19,\"11\":27,\"12\":31,\"13\":39,\"14\":33,\"15\":37,\"16\":23,\"17\":29,\"18\":33,\"19\":43,\"20\":26,\"21\":22,\"22\":51,\"23\":39,\"24\":25}},{\"name\":\"1 Kings\",\"short\":\"1 Kings\",\"abbreviations\":[\"1King\",\"1 King\",\"1Kin\",\"1 Kin\",\"1Ki\",\"1 Ki\",\"1Kgs\",\"1 Kgs\",\"iKgs\",\"i Kgs\"],\"chapters\":22,\"chapter\":{\"1\":53,\"2\":46,\"3\":28,\"4\":34,\"5\":18,\"6\":38,\"7\":51,\"8\":66,\"9\":28,\"10\":29,\"11\":43,\"12\":33,\"13\":34,\"14\":31,\"15\":34,\"16\":34,\"17\":24,\"18\":46,\"19\":21,\"20\":43,\"21\":29,\"22\":53}},{\"name\":\"2 Kings\",\"short\":\"2 Kings\",\"abbreviations\":[\"2King\",\"2 King\",\"2Kin\",\"2 Kin\",\"2Ki\",\"2 Ki\",\"2Kgs\",\"2 Kgs\",\"iiKgs\",\"ii Kgs\"],\"chapters\":25,\"chapter\":{\"1\":18,\"2\":25,\"3\":27,\"4\":44,\"5\":27,\"6\":33,\"7\":20,\"8\":29,\"9\":37,\"10\":36,\"11\":21,\"12\":21,\"13\":25,\"14\":29,\"15\":38,\"16\":20,\"17\":41,\"18\":37,\"19\":37,\"20\":21,\"21\":26,\"22\":20,\"23\":37,\"24\":20,\"25\":30}},{\"name\":\"1 Chronicles\",\"short\":\"1 Chron\",\"abbreviations\":[\"1Chron\",\"1 Chron\",\"1Chro\",\"1 Chro\",\"1Chr\",\"1 Chr\",\"iChr\",\"i Chr\",\"1Ch\",\"1 Ch\"],\"chapters\":29,\"chapter\":{\"1\":54,\"2\":55,\"3\":24,\"4\":43,\"5\":26,\"6\":81,\"7\":40,\"8\":40,\"9\":44,\"10\":14,\"11\":47,\"12\":40,\"13\":14,\"14\":17,\"15\":29,\"16\":43,\"17\":27,\"18\":17,\"19\":19,\"20\":8,\"21\":30,\"22\":19,\"23\":32,\"24\":31,\"25\":31,\"26\":32,\"27\":34,\"28\":21,\"29\":30}},{\"name\":\"2 Chronicles\",\"short\":\"2 Chron\",\"abbreviations\":[\"2Chron\",\"2 Chron\",\"2Chro\",\"2 Chro\",\"2Chr\",\"2 Chr\",\"iiChr\",\"ii Chr\",\"2Ch\",\"2 Ch\"],\"chapters\":36,\"chapter\":{\"1\":17,\"2\":18,\"3\":17,\"4\":22,\"5\":14,\"6\":42,\"7\":22,\"8\":18,\"9\":31,\"10\":19,\"11\":23,\"12\":16,\"13\":22,\"14\":15,\"15\":19,\"16\":14,\"17\":19,\"18\":34,\"19\":11,\"20\":37,\"21\":20,\"22\":12,\"23\":21,\"24\":27,\"25\":28,\"26\":23,\"27\":9,\"28\":27,\"29\":36,\"30\":27,\"31\":21,\"32\":33,\"33\":25,\"34\":33,\"35\":27,\"36\":23}},{\"name\":\"Ezra\",\"short\":\"Ezra\",\"abbreviations\":[\"Ezr\",\"Ez\"],\"chapters\":10,\"chapter\":{\"1\":11,\"2\":70,\"3\":13,\"4\":24,\"5\":17,\"6\":22,\"7\":28,\"8\":36,\"9\":15,\"10\":44}},{\"name\":\"Nehemiah\",\"short\":\"Neh\",\"abbreviations\":[\"Nehem\",\"Neh\",\"Ne\"],\"chapters\":13,\"chapter\":{\"1\":11,\"2\":20,\"3\":32,\"4\":23,\"5\":19,\"6\":19,\"7\":73,\"8\":18,\"9\":38,\"10\":39,\"11\":36,\"12\":47,\"13\":31}},{\"name\":\"Esther\",\"short\":\"Est\",\"abbreviations\":[\"Esth\",\"Est\",\"Es\"],\"chapters\":10,\"chapter\":{\"1\":22,\"2\":23,\"3\":15,\"4\":17,\"5\":14,\"6\":14,\"7\":10,\"8\":17,\"9\":32,\"10\":3}},{\"name\":\"Job\",\"short\":\"Job\",\"abbreviations\":[],\"chapters\":42,\"chapter\":{\"1\":22,\"2\":13,\"3\":26,\"4\":21,\"5\":27,\"6\":30,\"7\":21,\"8\":22,\"9\":35,\"10\":22,\"11\":20,\"12\":25,\"13\":28,\"14\":22,\"15\":35,\"16\":22,\"17\":16,\"18\":21,\"19\":29,\"20\":29,\"21\":34,\"22\":30,\"23\":17,\"24\":25,\"25\":6,\"26\":14,\"27\":23,\"28\":28,\"29\":25,\"30\":31,\"31\":40,\"32\":22,\"33\":33,\"34\":37,\"35\":16,\"36\":33,\"37\":24,\"38\":41,\"39\":30,\"40\":24,\"41\":34,\"42\":17}},{\"name\":\"Psalms\",\"short\":\"Ps\",\"abbreviations\":[\"Psalm\",\"Psal\",\"Psa\",\"Ps\"],\"chapters\":150,\"chapter\":{\"1\":6,\"2\":12,\"3\":8,\"4\":8,\"5\":12,\"6\":10,\"7\":17,\"8\":9,\"9\":20,\"10\":18,\"11\":7,\"12\":8,\"13\":6,\"14\":7,\"15\":5,\"16\":11,\"17\":15,\"18\":50,\"19\":14,\"20\":9,\"21\":13,\"22\":31,\"23\":6,\"24\":10,\"25\":22,\"26\":12,\"27\":14,\"28\":9,\"29\":11,\"30\":12,\"31\":24,\"32\":11,\"33\":22,\"34\":22,\"35\":28,\"36\":12,\"37\":40,\"38\":22,\"39\":13,\"40\":17,\"41\":13,\"42\":11,\"43\":5,\"44\":26,\"45\":17,\"46\":11,\"47\":9,\"48\":14,\"49\":20,\"50\":23,\"51\":19,\"52\":9,\"53\":6,\"54\":7,\"55\":23,\"56\":13,\"57\":11,\"58\":11,\"59\":17,\"60\":12,\"61\":8,\"62\":12,\"63\":11,\"64\":10,\"65\":13,\"66\":20,\"67\":7,\"68\":35,\"69\":36,\"70\":5,\"71\":24,\"72\":20,\"73\":28,\"74\":23,\"75\":10,\"76\":12,\"77\":20,\"78\":72,\"79\":13,\"80\":19,\"81\":16,\"82\":8,\"83\":18,\"84\":12,\"85\":13,\"86\":17,\"87\":7,\"88\":18,\"89\":52,\"90\":17,\"91\":16,\"92\":15,\"93\":5,\"94\":23,\"95\":11,\"96\":13,\"97\":12,\"98\":9,\"99\":9,\"100\":5,\"101\":8,\"102\":28,\"103\":22,\"104\":35,\"105\":45,\"106\":48,\"107\":43,\"108\":13,\"109\":31,\"110\":7,\"111\":10,\"112\":10,\"113\":9,\"114\":8,\"115\":18,\"116\":19,\"117\":2,\"118\":29,\"119\":176,\"120\":7,\"121\":8,\"122\":9,\"123\":4,\"124\":8,\"125\":5,\"126\":6,\"127\":5,\"128\":6,\"129\":8,\"130\":8,\"131\":3,\"132\":18,\"133\":3,\"134\":3,\"135\":21,\"136\":26,\"137\":9,\"138\":8,\"139\":24,\"140\":13,\"141\":10,\"142\":7,\"143\":12,\"144\":15,\"145\":21,\"146\":10,\"147\":20,\"148\":14,\"149\":9,\"150\":6}},{\"name\":\"Proverbs\",\"short\":\"Prov\",\"abbreviations\":[\"Prov\",\"Pro\",\"Pr\"],\"chapters\":31,\"chapter\":{\"1\":33,\"2\":22,\"3\":35,\"4\":27,\"5\":23,\"6\":35,\"7\":27,\"8\":36,\"9\":18,\"10\":32,\"11\":31,\"12\":28,\"13\":25,\"14\":35,\"15\":33,\"16\":33,\"17\":28,\"18\":24,\"19\":29,\"20\":30,\"21\":31,\"22\":29,\"23\":35,\"24\":34,\"25\":28,\"26\":28,\"27\":27,\"28\":28,\"29\":27,\"30\":33,\"31\":31}},{\"name\":\"Ecclesiastes\",\"short\":\"Ecc\",\"abbreviations\":[\"Eccles\",\"Eccl\",\"Ecc\",\"Ec\"],\"chapters\":12,\"chapter\":{\"1\":18,\"2\":26,\"3\":22,\"4\":16,\"5\":20,\"6\":12,\"7\":29,\"8\":17,\"9\":18,\"10\":20,\"11\":10,\"12\":14}},{\"name\":\"Song of Solomon\",\"short\":\"Song\",\"abbreviations\":[\"Song of Songs\",\"Song of Sol\",\"SS\",\"SSong\",\"Cant\",\"Canticle\",\"Canticles\",\"Sol. Song\",\"Song\",\"So\"],\"chapters\":8,\"chapter\":{\"1\":17,\"2\":17,\"3\":11,\"4\":16,\"5\":16,\"6\":13,\"7\":13,\"8\":14}},{\"name\":\"Isaiah\",\"short\":\"Isa\",\"abbreviations\":[\"Isai\",\"Isa\",\"Is\"],\"chapters\":66,\"chapter\":{\"1\":31,\"2\":22,\"3\":26,\"4\":6,\"5\":30,\"6\":13,\"7\":25,\"8\":22,\"9\":21,\"10\":34,\"11\":16,\"12\":6,\"13\":22,\"14\":32,\"15\":9,\"16\":14,\"17\":14,\"18\":7,\"19\":25,\"20\":6,\"21\":17,\"22\":25,\"23\":18,\"24\":23,\"25\":12,\"26\":21,\"27\":13,\"28\":29,\"29\":24,\"30\":33,\"31\":9,\"32\":20,\"33\":24,\"34\":17,\"35\":10,\"36\":22,\"37\":38,\"38\":22,\"39\":8,\"40\":31,\"41\":29,\"42\":25,\"43\":28,\"44\":28,\"45\":25,\"46\":13,\"47\":15,\"48\":22,\"49\":26,\"50\":11,\"51\":23,\"52\":15,\"53\":12,\"54\":17,\"55\":13,\"56\":12,\"57\":21,\"58\":14,\"59\":21,\"60\":22,\"61\":11,\"62\":12,\"63\":19,\"64\":12,\"65\":25,\"66\":24}},{\"name\":\"Jeremiah\",\"short\":\"Jer\",\"abbreviations\":[\"Jerem\",\"Jere\",\"Jer\",\"Je\"],\"chapters\":52,\"chapter\":{\"1\":19,\"2\":37,\"3\":25,\"4\":31,\"5\":31,\"6\":30,\"7\":34,\"8\":22,\"9\":26,\"10\":25,\"11\":23,\"12\":17,\"13\":27,\"14\":22,\"15\":21,\"16\":21,\"17\":27,\"18\":23,\"19\":15,\"20\":18,\"21\":14,\"22\":30,\"23\":40,\"24\":10,\"25\":38,\"26\":24,\"27\":22,\"28\":17,\"29\":32,\"30\":24,\"31\":40,\"32\":44,\"33\":26,\"34\":22,\"35\":19,\"36\":32,\"37\":21,\"38\":28,\"39\":18,\"40\":16,\"41\":18,\"42\":22,\"43\":13,\"44\":30,\"45\":5,\"46\":28,\"47\":7,\"48\":47,\"49\":39,\"50\":46,\"51\":64,\"52\":34}},{\"name\":\"Lamentations\",\"short\":\"Lam\",\"abbreviations\":[\"Lament\",\"Lamen\",\"Lam\",\"La\"],\"chapters\":5,\"chapter\":{\"1\":22,\"2\":22,\"3\":66,\"4\":22,\"5\":22}},{\"name\":\"Ezekiel\",\"short\":\"Ezek\",\"abbreviations\":[\"Ezek\",\"Eze\",\"Ez\",\"Ezechiel\"],\"chapters\":48,\"chapter\":{\"1\":28,\"2\":10,\"3\":27,\"4\":17,\"5\":17,\"6\":14,\"7\":27,\"8\":18,\"9\":11,\"10\":22,\"11\":25,\"12\":28,\"13\":23,\"14\":23,\"15\":8,\"16\":63,\"17\":24,\"18\":32,\"19\":14,\"20\":49,\"21\":32,\"22\":31,\"23\":49,\"24\":27,\"25\":17,\"26\":21,\"27\":36,\"28\":26,\"29\":21,\"30\":26,\"31\":18,\"32\":32,\"33\":33,\"34\":31,\"35\":15,\"36\":38,\"37\":28,\"38\":23,\"39\":29,\"40\":49,\"41\":26,\"42\":20,\"43\":27,\"44\":31,\"45\":25,\"46\":24,\"47\":23,\"48\":35}},{\"name\":\"Daniel\",\"short\":\"Dan\",\"abbreviations\":[\"Dan\",\"Da\"],\"chapters\":12,\"chapter\":{\"1\":21,\"2\":49,\"3\":30,\"4\":37,\"5\":31,\"6\":28,\"7\":28,\"8\":27,\"9\":27,\"10\":21,\"11\":45,\"12\":13}},{\"name\":\"Hosea\",\"short\":\"Hos\",\"abbreviations\":[\"Hos\",\"Ho\",\"Osee\"],\"chapters\":14,\"chapter\":{\"1\":11,\"2\":23,\"3\":5,\"4\":19,\"5\":15,\"6\":11,\"7\":16,\"8\":14,\"9\":17,\"10\":15,\"11\":12,\"12\":14,\"13\":16,\"14\":9}},{\"name\":\"Joel\",\"short\":\"Joel\",\"abbreviations\":[\"Joe\"],\"chapters\":3,\"chapter\":{\"1\":20,\"2\":32,\"3\":21}},{\"name\":\"Amos\",\"short\":\"Amos\",\"abbreviations\":[\"Am\"],\"chapters\":9,\"chapter\":{\"1\":15,\"2\":16,\"3\":15,\"4\":13,\"5\":27,\"6\":14,\"7\":17,\"8\":14,\"9\":15}},{\"name\":\"Obadiah\",\"short\":\"Obad\",\"abbreviations\":[\"Obad\",\"Oba\",\"Ob\"],\"chapters\":1,\"chapter\":{\"1\":21}},{\"name\":\"Jonah\",\"short\":\"Jonah\",\"abbreviations\":[\"Jona\",\"Jon\"],\"chapters\":4,\"chapter\":{\"1\":17,\"2\":10,\"3\":10,\"4\":11}},{\"name\":\"Micah\",\"short\":\"Mic\",\"abbreviations\":[\"Mich\",\"Mic\",\"Mi\"],\"chapters\":7,\"chapter\":{\"1\":16,\"2\":13,\"3\":12,\"4\":13,\"5\":15,\"6\":16,\"7\":20}},{\"name\":\"Nahum\",\"short\":\"Nah\",\"abbreviations\":[\"Nah\",\"Na\"],\"chapters\":3,\"chapter\":{\"1\":15,\"2\":13,\"3\":19}},{\"name\":\"Habakkuk\",\"short\":\"Hab\",\"abbreviations\":[\"Habak\",\"Hab\",\"Ha\"],\"chapters\":3,\"chapter\":{\"1\":17,\"2\":20,\"3\":19}},{\"name\":\"Zephaniah\",\"short\":\"Zeph\",\"abbreviations\":[\"Zeph\",\"Zep\"],\"chapters\":3,\"chapter\":{\"1\":18,\"2\":15,\"3\":20}},{\"name\":\"Haggai\",\"short\":\"Hag\",\"abbreviations\":[\"Hagg\",\"Hag\",\"Ha\"],\"chapters\":2,\"chapter\":{\"1\":15,\"2\":23}},{\"name\":\"Zechariah\",\"short\":\"Zech\",\"abbreviations\":[\"Zech\",\"Zec\"],\"chapters\":14,\"chapter\":{\"1\":21,\"2\":13,\"3\":10,\"4\":14,\"5\":11,\"6\":15,\"7\":14,\"8\":23,\"9\":17,\"10\":12,\"11\":17,\"12\":14,\"13\":9,\"14\":21}},{\"name\":\"Malachi\",\"short\":\"Mal\",\"abbreviations\":[\"Malach\",\"Malac\",\"Mal\",\"Mai\"],\"chapters\":4,\"chapter\":{\"1\":14,\"2\":17,\"3\":18,\"4\":6}},{\"name\":\"Matthew\",\"short\":\"Matt\",\"abbreviations\":[\"Matth\",\"Matt\",\"Mat\",\"Mt\"],\"chapters\":28,\"chapter\":{\"1\":25,\"2\":23,\"3\":17,\"4\":25,\"5\":48,\"6\":34,\"7\":29,\"8\":34,\"9\":38,\"10\":42,\"11\":30,\"12\":50,\"13\":58,\"14\":36,\"15\":39,\"16\":28,\"17\":27,\"18\":35,\"19\":30,\"20\":34,\"21\":46,\"22\":46,\"23\":39,\"24\":51,\"25\":46,\"26\":75,\"27\":66,\"28\":20}},{\"name\":\"Mark\",\"short\":\"Mark\",\"abbreviations\":[\"Mk\",\"Mr\"],\"chapters\":16,\"chapter\":{\"1\":45,\"2\":28,\"3\":35,\"4\":41,\"5\":43,\"6\":56,\"7\":37,\"8\":38,\"9\":50,\"10\":52,\"11\":33,\"12\":44,\"13\":37,\"14\":72,\"15\":47,\"16\":20}},{\"name\":\"Luke\",\"short\":\"Luke\",\"abbreviations\":[\"Luk\",\"Lu\",\"Lk\"],\"chapters\":24,\"chapter\":{\"1\":80,\"2\":52,\"3\":38,\"4\":44,\"5\":39,\"6\":49,\"7\":50,\"8\":56,\"9\":62,\"10\":42,\"11\":54,\"12\":59,\"13\":35,\"14\":35,\"15\":32,\"16\":31,\"17\":37,\"18\":43,\"19\":48,\"20\":47,\"21\":38,\"22\":71,\"23\":56,\"24\":53}},{\"name\":\"John\",\"short\":\"John\",\"abbreviations\":[\"Joh\",\"Jn\"],\"chapters\":21,\"chapter\":{\"1\":51,\"2\":25,\"3\":36,\"4\":54,\"5\":47,\"6\":71,\"7\":53,\"8\":59,\"9\":41,\"10\":42,\"11\":57,\"12\":50,\"13\":38,\"14\":31,\"15\":27,\"16\":33,\"17\":26,\"18\":40,\"19\":42,\"20\":31,\"21\":25}},{\"name\":\"Acts\",\"abbreviations\":[\"Act\",\"Ac\"],\"chapters\":28,\"chapter\":{\"1\":26,\"2\":47,\"3\":26,\"4\":37,\"5\":42,\"6\":15,\"7\":60,\"8\":40,\"9\":43,\"10\":48,\"11\":30,\"12\":25,\"13\":52,\"14\":28,\"15\":41,\"16\":40,\"17\":34,\"18\":28,\"19\":41,\"20\":38,\"21\":40,\"22\":30,\"23\":35,\"24\":27,\"25\":27,\"26\":32,\"27\":44,\"28\":31}},{\"name\":\"Romans\",\"short\":\"Rom\",\"abbreviations\":[\"Rom\",\"Ro\"],\"chapters\":16,\"chapter\":{\"1\":32,\"2\":29,\"3\":31,\"4\":25,\"5\":21,\"6\":23,\"7\":25,\"8\":39,\"9\":33,\"10\":21,\"11\":36,\"12\":21,\"13\":14,\"14\":23,\"15\":33,\"16\":27}},{\"name\":\"1 Corinthians\",\"short\":\"1 Cor\",\"abbreviations\":[\"1Corinth\",\"1 Corinth\",\"1Corin\",\"1 Corin\",\"1Cor\",\"1 Cor\",\"iCor\",\"i Cor\",\"1Co\",\"1 Co\"],\"chapters\":16,\"chapter\":{\"1\":31,\"2\":16,\"3\":23,\"4\":21,\"5\":13,\"6\":20,\"7\":40,\"8\":13,\"9\":27,\"10\":33,\"11\":34,\"12\":31,\"13\":13,\"14\":40,\"15\":58,\"16\":24}},{\"name\":\"2 Corinthians\",\"short\":\"2 Cor\",\"abbreviations\":[\"2Corinth\",\"2 Corinth\",\"2Corin\",\"2 Corin\",\"2Cor\",\"2 Cor\",\"iiCor\",\"ii Cor\",\"2Co\",\"2 Co\"],\"chapters\":13,\"chapter\":{\"1\":24,\"2\":17,\"3\":18,\"4\":18,\"5\":21,\"6\":18,\"7\":16,\"8\":24,\"9\":15,\"10\":18,\"11\":33,\"12\":21,\"13\":13}},{\"name\":\"Galatians\",\"short\":\"Gal\",\"abbreviations\":[\"Galat\",\"Ga\",\"Gal\"],\"chapters\":6,\"chapter\":{\"1\":24,\"2\":21,\"3\":29,\"4\":31,\"5\":26,\"6\":18}},{\"name\":\"Ephesians\",\"short\":\"Eph\",\"abbreviations\":[\"Ephes\",\"Eph\"],\"chapters\":6,\"chapter\":{\"1\":23,\"2\":22,\"3\":21,\"4\":32,\"5\":33,\"6\":24}},{\"name\":\"Philippians\",\"short\":\"Phil\",\"abbreviations\":[\"Philipp\",\"Philip\",\"Phili\",\"Phil\",\"Phi\",\"Php\",\"Ph\"],\"chapters\":4,\"chapter\":{\"1\":30,\"2\":30,\"3\":21,\"4\":23}},{\"name\":\"Colossians\",\"short\":\"Col\",\"abbreviations\":[\"Coloss\",\"Colos\",\"Colo\",\"Col\",\"Co\"],\"chapters\":4,\"chapter\":{\"1\":29,\"2\":23,\"3\":25,\"4\":18}},{\"name\":\"1 Thessalonians\",\"short\":\"1 Thess\",\"abbreviations\":[\"1Thess\",\"1 Thess\",\"iThess\",\"i Thess\",\"1Thes\",\"1 Thes\",\"1The\",\"1 The\",\"1Th\",\"1 Th\"],\"chapters\":5,\"chapter\":{\"1\":10,\"2\":20,\"3\":13,\"4\":18,\"5\":28}},{\"name\":\"2 Thessalonians\",\"short\":\"2 Thess\",\"abbreviations\":[\"2Thess\",\"2 Thess\",\"iiThess\",\"ii Thess\",\"2Thes\",\"2 Thes\",\"2The\",\"2 The\",\"2Th\",\"2 Th\"],\"chapters\":3,\"chapter\":{\"1\":12,\"2\":17,\"3\":18}},{\"name\":\"1 Timothy\",\"short\":\"1 Tim\",\"abbreviations\":[\"1Tim\",\"1 Tim\",\"iTim\",\"i Tim\",\"1Ti\",\"1 Ti\"],\"chapters\":6,\"chapter\":{\"1\":20,\"2\":15,\"3\":16,\"4\":16,\"5\":25,\"6\":21}},{\"name\":\"2 Timothy\",\"short\":\"2 Tim\",\"abbreviations\":[\"2Tim\",\"2 Tim\",\"iiTim\",\"ii Tim\",\"2Ti\",\"2 Ti\"],\"chapters\":4,\"chapter\":{\"1\":18,\"2\":26,\"3\":17,\"4\":22}},{\"name\":\"Titus\",\"short\":\"Tit\",\"abbreviations\":[\"Titu\",\"Tit\"],\"chapters\":3,\"chapter\":{\"1\":16,\"2\":15,\"3\":15}},{\"name\":\"Philemon\",\"short\":\"Philem\",\"abbreviations\":[\"Philem\",\"Phile\",\"Phlm\",\"Phm\"],\"chapters\":1,\"chapter\":{\"1\":25}},{\"name\":\"Hebrews\",\"short\":\"Heb\",\"abbreviations\":[\"Hebr\",\"Heb\"],\"chapters\":13,\"chapter\":{\"1\":14,\"2\":18,\"3\":19,\"4\":16,\"5\":14,\"6\":20,\"7\":28,\"8\":13,\"9\":28,\"10\":39,\"11\":40,\"12\":29,\"13\":25}},{\"name\":\"James\",\"short\":\"James\",\"abbreviations\":[\"Jas\",\"Jam\",\"Ja\"],\"chapters\":5,\"chapter\":{\"1\":27,\"2\":26,\"3\":18,\"4\":17,\"5\":20}},{\"name\":\"1 Peter\",\"short\":\"1 Pet\",\"abbreviations\":[\"1Pet\",\"1 Pet\",\"iPet\",\"i Pet\",\"1Pe\",\"1 Pe\",\"iPe\",\"i Pe\"],\"chapters\":5,\"chapter\":{\"1\":25,\"2\":25,\"3\":22,\"4\":19,\"5\":14}},{\"name\":\"2 Peter\",\"short\":\"2 Pet\",\"abbreviations\":[\"iiPe\",\"ii Pe\",\"iiPet\",\"ii Pet\",\"2Pe\",\"2 Pe\",\"2Pet\",\"2 Pet\"],\"chapters\":3,\"chapter\":{\"1\":21,\"2\":22,\"3\":18}},{\"name\":\"1 John\",\"short\":\"1 John\",\"abbreviations\":[\"iJohn\",\"i John\",\"1Joh\",\"1 Joh\",\"1Jo\",\"1 Jo\",\"1Jn\",\"1 Jn\"],\"chapters\":5,\"chapter\":{\"1\":10,\"2\":29,\"3\":24,\"4\":21,\"5\":21}},{\"name\":\"2 John\",\"short\":\"2 John\",\"abbreviations\":[\"iiJohn\",\"ii John\",\"2Joh\",\"2 Joh\",\"2Jo\",\"2 Jo\",\"2Jn\",\"2 Jn\"],\"chapters\":1,\"chapter\":{\"1\":13}},{\"name\":\"3 John\",\"short\":\"3 John\",\"abbreviations\":[\"iiiJohn\",\"iii John\",\"3Joh\",\"3 Joh\",\"3Jo\",\"3 Jo\",\"3Jn\",\"3 Jn\"],\"chapters\":1,\"chapter\":{\"1\":15}},{\"name\":\"Jude\",\"short\":\"Jude\",\"abbreviations\":[\"Ju\"],\"chapters\":1,\"chapter\":{\"1\":25}},{\"name\":\"Revelation\",\"short\":\"Rev\",\"abbreviations\":[\"Revel\",\"Rev\",\"Re\",\"Apocalypse\",\"Apocal\",\"Apoc\",\"Revelations\"],\"chapters\":22,\"chapter\":{\"1\":20,\"2\":29,\"3\":22,\"4\":11,\"5\":14,\"6\":17,\"7\":17,\"8\":13,\"9\":21,\"10\":11,\"11\":19,\"12\":18,\"13\":18,\"14\":20,\"15\":8,\"16\":21,\"17\":18,\"18\":24,\"19\":21,\"20\":15,\"21\":27,\"22\":21}}]");


const $c771bfd80eec184d$var$ROMAN_NUMERAL_MAP = {
    I: 1,
    V: 5,
    X: 10,
    L: 50,
    C: 100,
    D: 500,
    M: 1000
};
function $c771bfd80eec184d$export$431b8b483d919fa(input) {
    const roman = input.toUpperCase();
    const letters = roman.split(``);
    let arabic = 0;
    letters.forEach((letter, i)=>{
        const letterValue = $c771bfd80eec184d$var$ROMAN_NUMERAL_MAP[letter] || 0;
        const prevValue = $c771bfd80eec184d$var$ROMAN_NUMERAL_MAP[letters[i - 1] ?? ``] || null;
        if (prevValue !== null && prevValue < letterValue) arabic -= 2 * prevValue;
        arabic += letterValue;
    });
    return arabic;
}
function $c771bfd80eec184d$export$a0a81dc3380ce7d3(input) {
    const parsed = parseInt(String(input), 10);
    if (!Number.isNaN(parsed)) return parsed;
    return $c771bfd80eec184d$export$431b8b483d919fa(String(input));
}



// @TODO duplication...
const $960fbe2e1a216c0e$var$ARAB = `[\\d]{1,3}`;
const $960fbe2e1a216c0e$var$ADD = `(?:, ?(${$960fbe2e1a216c0e$var$ARAB}))?`;
const $960fbe2e1a216c0e$var$CSV = `${$960fbe2e1a216c0e$var$ADD}${$960fbe2e1a216c0e$var$ADD}${$960fbe2e1a216c0e$var$ADD}${$960fbe2e1a216c0e$var$ADD}${$960fbe2e1a216c0e$var$ADD}${$960fbe2e1a216c0e$var$ADD}`;
function $960fbe2e1a216c0e$var$exec(str, pattern) {
    const exp = new RegExp(pattern);
    return exp.exec(str);
}
function $960fbe2e1a216c0e$var$singleOrRange(pattern, start, context, ref, chapter) {
    const match = $960fbe2e1a216c0e$var$exec(context, pattern);
    if (!match) return ref;
    const [versesSubString, verseStart = ``, verseEnd] = match;
    ref.verses.push({
        chapter: chapter,
        verse: (0, $c771bfd80eec184d$export$a0a81dc3380ce7d3)(verseStart)
    });
    let next = (0, $c771bfd80eec184d$export$a0a81dc3380ce7d3)(verseStart) + 1;
    while(verseEnd && next <= (0, $c771bfd80eec184d$export$a0a81dc3380ce7d3)(verseEnd)){
        ref.verses.push({
            chapter: chapter,
            verse: (0, $c771bfd80eec184d$export$a0a81dc3380ce7d3)(next)
        });
        next++;
    }
    ref.position.end = start + versesSubString.length;
    return ref;
}
function $960fbe2e1a216c0e$var$comma(pattern, start, context, ref, chapter) {
    const match = $960fbe2e1a216c0e$var$exec(context, pattern);
    if (!match) return ref;
    const verseNumbers = match.slice(1, 10).filter((v)=>!!v).map((v)=>parseInt(v, 10)).sort();
    ref.position.end = start + match[0].length;
    let last = 0;
    verseNumbers.forEach((current)=>{
        if (last && current - last > 1) ref.contiguous = false;
        ref.verses.push({
            chapter: chapter,
            verse: current
        });
        last = current;
    });
    return ref;
}
function $960fbe2e1a216c0e$export$ee9cc73451b1db5c(start, context, ref, chapter) {
    const pattern = `^\\. (${$960fbe2e1a216c0e$var$ARAB})(?:-+(${$960fbe2e1a216c0e$var$ARAB}))?`;
    return $960fbe2e1a216c0e$var$singleOrRange(pattern, start, context, ref, chapter);
}
function $960fbe2e1a216c0e$export$c88d278f3c03461a(start, context, ref, chapter) {
    const pattern = `^\\. (${$960fbe2e1a216c0e$var$ARAB}),(?: )?(${$960fbe2e1a216c0e$var$ARAB})${$960fbe2e1a216c0e$var$CSV}`;
    return $960fbe2e1a216c0e$var$comma(pattern, start, context, ref, chapter);
}
function $960fbe2e1a216c0e$export$a1515d223cf4491c(start, context, ref, chapter) {
    const pattern = `^:(${$960fbe2e1a216c0e$var$ARAB}),(?: )?(${$960fbe2e1a216c0e$var$ARAB})${$960fbe2e1a216c0e$var$CSV}`;
    return $960fbe2e1a216c0e$var$comma(pattern, start, context, ref, chapter);
}
function $960fbe2e1a216c0e$export$2267795c05f721bb(start, context, ref, chapter) {
    const pattern = `^:(${$960fbe2e1a216c0e$var$ARAB})(?:-+(${$960fbe2e1a216c0e$var$ARAB}))?`;
    return $960fbe2e1a216c0e$var$singleOrRange(pattern, start, context, ref, chapter);
}


function $fc8fb0962b2a922e$var$incorrectJohannine({ book: book, position: { start: start } }, input) {
    if (book !== `John`) return false;
    let bool = false;
    const prefs = [
        `1`,
        `2`,
        `3`,
        `i`,
        `ii`,
        `iii`,
        `I`,
        `II`,
        `III`,
        `First`,
        `Second`,
        `Third`,
        `1st`,
        `2nd`,
        `3rd`
    ];
    prefs.forEach((pref)=>{
        if (bool) return;
        if (input.substr(start - pref.length - 1, pref.length + 1) === `${pref} `) {
            bool = true;
            return;
        }
        if (input.substr(start - pref.length, pref.length) === pref) bool = true;
    });
    return bool;
}
function $fc8fb0962b2a922e$var$incorrect(wrongBook, wrongMatch, prev) {
    return ({ book: book, match: match, position: { start: start } }, input)=>{
        if (book !== wrongBook) return false;
        if (!match.match(wrongMatch)) return false;
        if (input.substring(start - prev.length, start).toLowerCase() === prev) return true;
        return false;
    };
}
function $fc8fb0962b2a922e$export$bebb0f2c60e24e4b(ref, input) {
    return [
        $fc8fb0962b2a922e$var$incorrectJohannine,
        $fc8fb0962b2a922e$var$incorrect(`Song of Solomon`, /^ss\./, ` the`),
        $fc8fb0962b2a922e$var$incorrect(`Song of Solomon`, /^so /, `al`),
        $fc8fb0962b2a922e$var$incorrect(`Esther`, /^es,? /, `jam`),
        $fc8fb0962b2a922e$var$incorrect(`Esther`, /^es /, `ecclesiast`),
        $fc8fb0962b2a922e$var$incorrect(`Esther`, /^es\. /, `eccl`),
        $fc8fb0962b2a922e$var$incorrect(`Esther`, /^es /, `chronicl`),
        $fc8fb0962b2a922e$var$incorrect(`Esther`, /^es\. /, `1 th`),
        $fc8fb0962b2a922e$var$incorrect(`Esther`, /^es\. /, `2 th`),
        $fc8fb0962b2a922e$var$incorrect(`Esther`, /^es\. /, `eph`),
        $fc8fb0962b2a922e$var$incorrect(`Esther`, /^es /, `judg`),
        $fc8fb0962b2a922e$var$incorrect(`Genesis`, /^ges /, `jud`),
        $fc8fb0962b2a922e$var$incorrect(`Amos`, /^am\. /, `j`),
        $fc8fb0962b2a922e$var$incorrect(`Romans`, /^rom /, `f`)
    ].reduce((result, fn)=>result || fn(ref, input), false);
}


const $3eda73babff90abe$var$books = (0, (/*@__PURE__*/$parcel$interopDefault($af8c6bde7c6033b2$exports)));
const $3eda73babff90abe$var$ROM = `(?:CM|CD|D?C{0,3})(?:XC|XL|L?X{0,3})(?:IX|IV|V?I{0,3})`;
const $3eda73babff90abe$var$ARAB = `[\\d]{1,3}`;
function $3eda73babff90abe$var$absorbRight(ref, input) {
    const { position: { end: end } } = ref;
    const afterRef = input.substr(end);
    const match = afterRef.match(/^(?:[.|:|;|,])? *\)/);
    if (!match) return ref;
    const absorbed = match[0].substr(0, match[0].length - 1);
    return {
        ...ref,
        match: ref.match.concat(absorbed),
        position: {
            ...ref.position,
            end: ref.position.end + absorbed.length
        }
    };
}
function $3eda73babff90abe$var$isValidChapter(book, chapter) {
    if (chapter < 1) return false;
    const bookData = (0, (/*@__PURE__*/$parcel$interopDefault($af8c6bde7c6033b2$exports))).find((b)=>b.name === book);
    if (!bookData || chapter > bookData.chapters) return false;
    return true;
}
function $3eda73babff90abe$var$extractRef(book, chapter, match) {
    if (!$3eda73babff90abe$var$isValidChapter(book, chapter)) return null;
    const start = match.index + match[0].length;
    const context = match.input.substring(start, start + 25);
    // order matters!
    const strategies = [
        (0, $960fbe2e1a216c0e$export$c88d278f3c03461a),
        (0, $960fbe2e1a216c0e$export$a1515d223cf4491c),
        (0, $960fbe2e1a216c0e$export$ee9cc73451b1db5c),
        (0, $960fbe2e1a216c0e$export$2267795c05f721bb)
    ];
    let ref = {
        book: book,
        contiguous: true,
        match: ``,
        verses: [],
        position: {
            start: match.index,
            end: -1
        }
    };
    strategies.forEach((strategy)=>{
        if (ref.position.end !== -1) return;
        ref = strategy(start, context, ref, chapter);
    });
    if (ref.position.end === -1) {
        // try to grab chapter-only refs, but be more selective
        ref.match = match[0];
        // weed out stuff like `is, 1`
        const firstChar = ref.match[0] ?? ``;
        if (!firstChar.match(/^\d$/) && firstChar.toLowerCase() === firstChar) return null;
        // So, I - is not a ref to Song of Solomon 1
        if (ref.match.match(/^So\b/)) return null;
        // Am I... should not be converted to Amos 1
        if (ref.match.match(/^Am I\b/)) return null;
        ref.verses.push({
            chapter: chapter
        });
        ref.position.end = ref.position.start + ref.match.length;
        return ref;
    }
    const { position: position } = ref;
    ref.match = match.input.substr(position.start, position.end - position.start);
    ref = $3eda73babff90abe$var$absorbRight(ref, match.input);
    if ((0, $fc8fb0962b2a922e$export$bebb0f2c60e24e4b)(ref, match.input)) return null;
    return ref;
}
function $3eda73babff90abe$export$71aa6c912b956294(str) {
    const refs = [];
    $3eda73babff90abe$var$books.forEach((book)=>{
        let pattern = book.abbreviations.concat([
            book.name
        ]).map((abbrev)=>abbrev.replace(`.`, `\\.`)).join(`|`);
        pattern = `\\b(?:${pattern})(?:\\.|,)? (${$3eda73babff90abe$var$ARAB}|${$3eda73babff90abe$var$ROM})\\b`;
        const exp = new RegExp(pattern, `gi`);
        let match = null;
        while(match = exp.exec(str)){
            const chapter = (0, $c771bfd80eec184d$export$a0a81dc3380ce7d3)(match[1] ?? `0`);
            if (chapter === 0) continue;
            const ref = $3eda73babff90abe$var$extractRef(book.name, chapter, match);
            if (ref) refs.push(ref);
        }
    });
    return refs;
}



const $578c773fac8be994$var$books = (0, (/*@__PURE__*/$parcel$interopDefault($af8c6bde7c6033b2$exports)));
function $578c773fac8be994$export$d9468344d3651243({ book: book, verses: verses, contiguous: contiguous, match: match }, opts = {}) {
    const options = {
        shortBookNames: true,
        preserveFull: true,
        ...opts
    };
    let str = book;
    const found = $578c773fac8be994$var$books.find((b)=>b.name === book);
    if (!found) throw new Error(`Invalid book name ${book}`);
    const { short: short } = found;
    if (options.shortBookNames && short !== book) str = `${short}.`;
    if (options.preserveFull && match.indexOf(book) === 0) str = book;
    if (verses.length === 1 && !verses[0]?.verse) return `${str} ${verses[0]?.chapter}`;
    str += ` ${verses[0]?.chapter}:${verses[0]?.verse}`;
    if (verses.length === 1) return str;
    if (contiguous) return `${str}-${(verses.pop() || {
        verse: ``
    }).verse}`;
    return `${str},${verses.slice(1).map((v)=>v.verse).join(`,`)}`;
}




var $4dce8a670312980a$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $4dce8a670312980a$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used to stand-in for `undefined` hash values. */ var $4dce8a670312980a$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** `Object#toString` result references. */ var $4dce8a670312980a$var$funcTag = '[object Function]', $4dce8a670312980a$var$genTag = '[object GeneratorFunction]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $4dce8a670312980a$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $4dce8a670312980a$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Detect free variable `global` from Node.js. */ var $4dce8a670312980a$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $4dce8a670312980a$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $4dce8a670312980a$var$root = $4dce8a670312980a$var$freeGlobal || $4dce8a670312980a$var$freeSelf || Function('return this')();
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $4dce8a670312980a$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function $4dce8a670312980a$var$isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != 'function') try {
        result = !!(value + '');
    } catch (e) {}
    return result;
}
/** Used for built-in method references. */ var $4dce8a670312980a$var$arrayProto = Array.prototype, $4dce8a670312980a$var$funcProto = Function.prototype, $4dce8a670312980a$var$objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var $4dce8a670312980a$var$coreJsData = $4dce8a670312980a$var$root['__core-js_shared__'];
/** Used to detect methods masquerading as native. */ var $4dce8a670312980a$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($4dce8a670312980a$var$coreJsData && $4dce8a670312980a$var$coreJsData.keys && $4dce8a670312980a$var$coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/** Used to resolve the decompiled source of functions. */ var $4dce8a670312980a$var$funcToString = $4dce8a670312980a$var$funcProto.toString;
/** Used to check objects for own properties. */ var $4dce8a670312980a$var$hasOwnProperty = $4dce8a670312980a$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $4dce8a670312980a$var$objectToString = $4dce8a670312980a$var$objectProto.toString;
/** Used to detect if a method is native. */ var $4dce8a670312980a$var$reIsNative = RegExp('^' + $4dce8a670312980a$var$funcToString.call($4dce8a670312980a$var$hasOwnProperty).replace($4dce8a670312980a$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var $4dce8a670312980a$var$splice = $4dce8a670312980a$var$arrayProto.splice;
/* Built-in method references that are verified to be native. */ var $4dce8a670312980a$var$Map = $4dce8a670312980a$var$getNative($4dce8a670312980a$var$root, 'Map'), $4dce8a670312980a$var$nativeCreate = $4dce8a670312980a$var$getNative(Object, 'create');
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $4dce8a670312980a$var$Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $4dce8a670312980a$var$hashClear() {
    this.__data__ = $4dce8a670312980a$var$nativeCreate ? $4dce8a670312980a$var$nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $4dce8a670312980a$var$hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $4dce8a670312980a$var$hashGet(key) {
    var data = this.__data__;
    if ($4dce8a670312980a$var$nativeCreate) {
        var result = data[key];
        return result === $4dce8a670312980a$var$HASH_UNDEFINED ? undefined : result;
    }
    return $4dce8a670312980a$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $4dce8a670312980a$var$hashHas(key) {
    var data = this.__data__;
    return $4dce8a670312980a$var$nativeCreate ? data[key] !== undefined : $4dce8a670312980a$var$hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $4dce8a670312980a$var$hashSet(key, value) {
    var data = this.__data__;
    data[key] = $4dce8a670312980a$var$nativeCreate && value === undefined ? $4dce8a670312980a$var$HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
$4dce8a670312980a$var$Hash.prototype.clear = $4dce8a670312980a$var$hashClear;
$4dce8a670312980a$var$Hash.prototype['delete'] = $4dce8a670312980a$var$hashDelete;
$4dce8a670312980a$var$Hash.prototype.get = $4dce8a670312980a$var$hashGet;
$4dce8a670312980a$var$Hash.prototype.has = $4dce8a670312980a$var$hashHas;
$4dce8a670312980a$var$Hash.prototype.set = $4dce8a670312980a$var$hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $4dce8a670312980a$var$ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $4dce8a670312980a$var$listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $4dce8a670312980a$var$listCacheDelete(key) {
    var data = this.__data__, index = $4dce8a670312980a$var$assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $4dce8a670312980a$var$splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $4dce8a670312980a$var$listCacheGet(key) {
    var data = this.__data__, index = $4dce8a670312980a$var$assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $4dce8a670312980a$var$listCacheHas(key) {
    return $4dce8a670312980a$var$assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $4dce8a670312980a$var$listCacheSet(key, value) {
    var data = this.__data__, index = $4dce8a670312980a$var$assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
$4dce8a670312980a$var$ListCache.prototype.clear = $4dce8a670312980a$var$listCacheClear;
$4dce8a670312980a$var$ListCache.prototype['delete'] = $4dce8a670312980a$var$listCacheDelete;
$4dce8a670312980a$var$ListCache.prototype.get = $4dce8a670312980a$var$listCacheGet;
$4dce8a670312980a$var$ListCache.prototype.has = $4dce8a670312980a$var$listCacheHas;
$4dce8a670312980a$var$ListCache.prototype.set = $4dce8a670312980a$var$listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $4dce8a670312980a$var$MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $4dce8a670312980a$var$mapCacheClear() {
    this.__data__ = {
        'hash': new $4dce8a670312980a$var$Hash,
        'map': new ($4dce8a670312980a$var$Map || $4dce8a670312980a$var$ListCache),
        'string': new $4dce8a670312980a$var$Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $4dce8a670312980a$var$mapCacheDelete(key) {
    return $4dce8a670312980a$var$getMapData(this, key)['delete'](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $4dce8a670312980a$var$mapCacheGet(key) {
    return $4dce8a670312980a$var$getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $4dce8a670312980a$var$mapCacheHas(key) {
    return $4dce8a670312980a$var$getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $4dce8a670312980a$var$mapCacheSet(key, value) {
    $4dce8a670312980a$var$getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
$4dce8a670312980a$var$MapCache.prototype.clear = $4dce8a670312980a$var$mapCacheClear;
$4dce8a670312980a$var$MapCache.prototype['delete'] = $4dce8a670312980a$var$mapCacheDelete;
$4dce8a670312980a$var$MapCache.prototype.get = $4dce8a670312980a$var$mapCacheGet;
$4dce8a670312980a$var$MapCache.prototype.has = $4dce8a670312980a$var$mapCacheHas;
$4dce8a670312980a$var$MapCache.prototype.set = $4dce8a670312980a$var$mapCacheSet;
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $4dce8a670312980a$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($4dce8a670312980a$var$eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $4dce8a670312980a$var$baseIsNative(value) {
    if (!$4dce8a670312980a$var$isObject(value) || $4dce8a670312980a$var$isMasked(value)) return false;
    var pattern = $4dce8a670312980a$var$isFunction(value) || $4dce8a670312980a$var$isHostObject(value) ? $4dce8a670312980a$var$reIsNative : $4dce8a670312980a$var$reIsHostCtor;
    return pattern.test($4dce8a670312980a$var$toSource(value));
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $4dce8a670312980a$var$getMapData(map, key) {
    var data = map.__data__;
    return $4dce8a670312980a$var$isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $4dce8a670312980a$var$getNative(object, key) {
    var value = $4dce8a670312980a$var$getValue(object, key);
    return $4dce8a670312980a$var$baseIsNative(value) ? value : undefined;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $4dce8a670312980a$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $4dce8a670312980a$var$isMasked(func) {
    return !!$4dce8a670312980a$var$maskSrcKey && $4dce8a670312980a$var$maskSrcKey in func;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function $4dce8a670312980a$var$toSource(func) {
    if (func != null) {
        try {
            return $4dce8a670312980a$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $4dce8a670312980a$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver && typeof resolver != 'function') throw new TypeError($4dce8a670312980a$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result);
        return result;
    };
    memoized.cache = new ($4dce8a670312980a$var$memoize.Cache || $4dce8a670312980a$var$MapCache);
    return memoized;
}
// Assign cache to `_.memoize`.
$4dce8a670312980a$var$memoize.Cache = $4dce8a670312980a$var$MapCache;
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $4dce8a670312980a$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $4dce8a670312980a$var$isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = $4dce8a670312980a$var$isObject(value) ? $4dce8a670312980a$var$objectToString.call(value) : '';
    return tag == $4dce8a670312980a$var$funcTag || tag == $4dce8a670312980a$var$genTag;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $4dce8a670312980a$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
$4dce8a670312980a$exports = $4dce8a670312980a$var$memoize;


function $6b72b637a7d86f3b$export$17aaa75f75e7b92e(maxLen, minLen) {
    return (input)=>{
        const sentences = $6b72b637a7d86f3b$var$splitIntoSentences(input);
        const validLines = sentences.map((sentence)=>{
            if (sentence.length <= maxLen || $6b72b637a7d86f3b$var$lineIsHeading(sentence)) return sentence;
            return $6b72b637a7d86f3b$var$splitSentence(sentence, maxLen, minLen);
        }).reduce($6b72b637a7d86f3b$var$cleanup, []).join(`\n`);
        return $6b72b637a7d86f3b$var$fixFootnoteSplitters(validLines);
    };
}
const $6b72b637a7d86f3b$export$88c07fe39db9eaa1 = $6b72b637a7d86f3b$export$17aaa75f75e7b92e(90, 45);
function $6b72b637a7d86f3b$var$splitIntoSentences(input) {
    const splitSentencesRegExp = $6b72b637a7d86f3b$var$regex.assemble([
        // last word before sentence-ending `.` or `,`
        /(?<lastWord>[A-Za-z)]{3}| [a-z)]{2}| 1[678][0-9]{2})/,
        // sentence-ending `.` or `,`
        /(?<punctuation>\.|\?)/,
        // optional close quote/apostrophe
        /(?<trailingQuote>`"|')?/,
        // followed by a required space
        ` `,
        // capture whatever the next character is for ruling out certain things
        /(?<nextCharacter>.)/
    ], `gm`);
    return input.replace(/footnote:\[/gm, `^\nfootnote:[`).replace(/\] /gm, `]\n`).replace(splitSentencesRegExp, $6b72b637a7d86f3b$var$regex.groupsFirst((groups, match)=>{
        const { lastWord: lastWord, punctuation: punctuation, trailingQuote: trailingQuote = ``, nextCharacter: nextCharacter = `` } = groups;
        if (lastWord === `viz`) return match;
        if (lastWord === `ver` && punctuation === `.` && nextCharacter.match(/\d/)) return match;
        if (lastWord === `etc` && nextCharacter.match(/[a-z]/)) return match;
        return `${lastWord}${punctuation}${trailingQuote}${$6b72b637a7d86f3b$var$NEWLINE}${nextCharacter}`;
    })).replace(/([A-Za-z]{2})!(`")? ([A-Z])/gm, `$1!$2${$6b72b637a7d86f3b$var$NEWLINE}$3`).split($6b72b637a7d86f3b$var$NEWLINE).join(`\n`).split(`\n`);
}
function $6b72b637a7d86f3b$var$splitSentence(sentence, maxLen, minLen) {
    // first, split into phrases on all comma, semicolon, and colon
    let lines = $6b72b637a7d86f3b$var$splitByPunctuation(sentence);
    // next re-join short phrases to keep lines close ideal length
    lines = lines.reduce($6b72b637a7d86f3b$var$rejoinShortPhrases(maxLen), [
        ``
    ]);
    // if we still have lines that are too long, split between words (without punctuation)
    lines = lines.reduce($6b72b637a7d86f3b$var$splitBetweenWords(maxLen, minLen), []);
    // clean up and return as a single string including newlines
    return lines.reduce($6b72b637a7d86f3b$var$cleanup, []).join(`\n`);
}
function $6b72b637a7d86f3b$var$splitByPunctuation(sentence) {
    return sentence.replace(/([,|;|:]) /gm, `$1\n`).split(`\n`);
}
const $6b72b637a7d86f3b$var$rejoinShortPhrases = (maxLen)=>{
    return (acc, part)=>{
        const lastIndex = acc.length - 1;
        const lastLine = acc[lastIndex];
        if (lastLine === ``) acc[lastIndex] = part;
        else if (`${lastLine} ${part}`.length < maxLen) acc[lastIndex] = `${lastLine} ${part}`;
        else acc.push(part);
        return acc;
    };
};
function $6b72b637a7d86f3b$var$splitBetweenWords(maxLen, minLen) {
    return (acc, part)=>{
        if (part.length < maxLen) return acc.concat([
            part
        ]);
        let best = [
            ``
        ];
        let bestScore = 100000;
        let current;
        let currentScore;
        let splitLen = maxLen - 7;
        const words = part.split(` `);
        while(splitLen >= minLen){
            current = $6b72b637a7d86f3b$var$getWordSplitCandidate(words, splitLen);
            currentScore = $6b72b637a7d86f3b$var$scoreSplitBetweenWords(current, minLen, maxLen);
            if (currentScore < bestScore) {
                best = current;
                bestScore = currentScore;
            }
            splitLen -= 7;
        }
        return acc.concat(best);
    };
}
function $6b72b637a7d86f3b$var$getWordSplitCandidate(words, splitLen) {
    const chunks = [
        []
    ];
    let lineIndex = 0;
    words.forEach((word)=>{
        if ((chunks[lineIndex] ?? []).join(` `).length < splitLen) {
            (chunks[lineIndex] ?? []).push(word);
            return;
        }
        lineIndex++;
        chunks[lineIndex] = [
            word
        ];
    });
    return chunks.map((chunk)=>chunk.join(` `));
}
function $6b72b637a7d86f3b$var$scoreSplitBetweenWords(arr, minLen, maxLen) {
    let score = 0;
    let prev;
    arr.forEach((part)=>{
        score += maxLen - part.length;
        if (part.length < minLen) score += 20;
        // prevent splitting on opening/closing parens
        if (part.match(/ \($/) || part.match(/^\)/)) score += 200;
        // prevent splitting before/after smart quote open
        if (part.match(/(--| )("|')`$/) || part.match(/^`("|')/)) score += 200;
        if (prev) {
            score += Math.abs(part.length - prev.length);
            // prevent splitting between double-dash
            if (part.match(/^-/) && prev.match(/-$/)) score += 200;
            // prevent splitting inside smart quote open
            if (prev.match(/("|')$/) && part.match(/^`/)) score += 200;
            // prevent splitting inside smart quote close
            if (prev.match(/`$/) && part.match(/^("|')/)) score += 200;
        }
        prev = part;
    });
    return score;
}
function $6b72b637a7d86f3b$var$cleanup(lines, line, index) {
    // this fixes lines like ^Oh,$
    if (lines[index - 1] && lines[index - 1]?.match(/^[A-Z][a-z]{1,3},$/)) {
        lines[index - 1] = `${lines[index - 1]} ${line}`;
        return lines;
    }
    // this fixes lines that are just ^etc.$
    if (line === `etc.` && index > 0) {
        lines[index - 1] = `${lines[index - 1]} etc.`;
        return lines;
    }
    if ($6b72b637a7d86f3b$var$getLeadingRef(line) && index) {
        const pos = $6b72b637a7d86f3b$var$getLeadingRef(line) || 0;
        const ref = line.substring(0, pos);
        const rest = line.substring(pos).trim();
        lines[index - 1] = `${lines[index - 1]} ${ref}`;
        lines.push(rest);
        return lines;
    }
    lines.push(line);
    return lines;
}
const $6b72b637a7d86f3b$var$getLeadingRef = (0, (/*@__PURE__*/$parcel$interopDefault($4dce8a670312980a$exports)))((line)=>{
    if (line.match(/verse [0-9]+\./)) return line.indexOf(`.`) + 1;
    // catch refs in their "mutated" state
    if (line.match(/^((1|2) )?[A-Z][a-z]+({•})? [0-9]{1,2}{\^}[0-9,-]+\./)) return line.indexOf(`.`) + 1;
    const refs = (0, $3eda73babff90abe$export$71aa6c912b956294)(line);
    if (refs.length === 0 || refs[0]?.position.start !== 0) return null;
    if (line[refs[0].position.end] === `.`) return line.indexOf(`.`) + 1;
    return null;
});
function $6b72b637a7d86f3b$var$fixFootnoteSplitters(input) {
    return input.replace(/{(\n)?footnote(\n)?-(\n)?paragraph(\n)?-(\n)?split(\n)?}/gm, `\n{footnote-paragraph-split}\n`).replace(/\n+{footnote-paragraph-split}\n+/gm, `\n{footnote-paragraph-split}\n`);
}
function $6b72b637a7d86f3b$export$d55a3cec29278517(str) {
    return str.replace(/{•}/gm, `.`).replace(/{\^}/gm, `:`);
}
function $6b72b637a7d86f3b$export$a536ac0ca8aa9049(str) {
    return str.replace(/\./gm, `{\u{2022}}`).replace(/:/gm, `{^}`);
}
function $6b72b637a7d86f3b$var$lineIsHeading(line) {
    return line[0] === `=`;
}
const $6b72b637a7d86f3b$var$regex = {
    assemble (arr, flags) {
        return new RegExp(arr.map((p)=>typeof p === `string` ? p : p.source).join(``), flags);
    },
    groupsFirst (fn) {
        return (substr, ...rest)=>{
            const last = rest[rest.length - 1];
            const groups = typeof last === `string` ? {} : last;
            return fn(groups, substr, ...rest);
        };
    }
};
const $6b72b637a7d86f3b$var$NEWLINE = `__NEWLINE__`;


var $18df0c6f364c9037$exports = {};


(function() {
    $18df0c6f364c9037$exports = {
        toArabic: (parcelRequire("4OsZl")),
        toRoman: (parcelRequire("84eBh"))
    };
})();


function $44411577e029e7fb$export$621c68a289ff1a44() {
    return {
        lang: `en`,
        friendSlug: `george-fox`,
        friendInitials: [
            `G`,
            `F`
        ],
        documentSlug: `journal`,
        path: `en/george-fox/journal/original`,
        editionId: `9414033c-4b70-4b4b-8e48-fec037822173`,
        isCompilation: false,
        outOfBand: false,
        editionType: `original`,
        asciidocFiles: [
            {
                adoc: ``,
                filename: `01-journal.adoc`
            }
        ],
        paperbackSplits: [],
        blurb: ``,
        config: {},
        customCode: {
            css: {},
            html: {}
        },
        meta: {
            title: `Journal of George Fox`,
            isbn: `978-1-64476-029-1`,
            author: {
                name: `George Fox`,
                nameSort: `Fox, George`
            }
        },
        revision: {
            timestamp: 1611345625,
            sha: `327ceb2`,
            url: ``
        }
    };
}
const $44411577e029e7fb$export$9c5ad1ea775c3169 = [
    `paperback-interior`,
    `paperback-cover`,
    `web-pdf`,
    `epub`,
    `speech`,
    `app-ebook`
];


const $9663980678ef0204$export$b4b5a31092c79bca = [
    `en`,
    `es`
];
const $9663980678ef0204$export$252b16230363d905 = [
    `original`,
    `modernized`,
    `updated`
];
const $9663980678ef0204$export$ce5d0c4f2e182edf = [
    `s`,
    `m`,
    `xl`
];
const $9663980678ef0204$export$947b69d04ed3ae21 = [
    `s`,
    `m`,
    `xl`,
    `xl--condensed`
];
const $9663980678ef0204$export$fffba0c447ba38f9 = [
    `s`,
    `m`,
    `xl`,
    `xlCondensed`
];
const $9663980678ef0204$export$5b5355fbcb922f90 = [
    `hq`,
    `lq`
];
function $9663980678ef0204$export$209e4db5a3222f41(variant) {
    switch(variant){
        case `xl--condensed`:
            return `xlCondensed`;
        default:
            return variant;
    }
}
function $9663980678ef0204$export$27a8eb68eee51ca4(variant) {
    switch(variant){
        case `xlCondensed`:
            return `xl--condensed`;
        default:
            return variant;
    }
}
function $9663980678ef0204$export$63a9af58793cc5f4(x) {
    if (typeof x !== `string`) return false;
    return [
        ...$9663980678ef0204$export$ce5d0c4f2e182edf
    ].includes(x);
}
function $9663980678ef0204$export$652af89a55d720b7(x) {
    if (typeof x !== `string`) return false;
    return [
        ...$9663980678ef0204$export$252b16230363d905
    ].includes(x);
}
const $9663980678ef0204$export$dec6b13405c072f0 = {
    LEFT_DOUBLE_QUOTE: `&#8220;`,
    RIGHT_DOUBLE_QUOTE: `&#8221;`,
    LEFT_SINGLE_QUOTE: `&#8216;`,
    RIGHT_SINGLE_QUOTE: `&#8217;`,
    MDASH: `&#8212;`,
    AMPERSAND: `&#38;`,
    ELLIPSES: `&#8230;`,
    NON_BREAKING_SPACE: `&#160;`
};


function $07039be0dd75627a$export$cacb59c3d67ee272(title) {
    return $07039be0dd75627a$export$c3efb37301250e03(title.replace(/\bvolumen? \b/i, `Vol.${(0, $9663980678ef0204$export$dec6b13405c072f0).NON_BREAKING_SPACE}`));
}
function $07039be0dd75627a$export$c3efb37301250e03(title) {
    return title.replace(/\b(\d+)\b(.)?/g, (_, digits, next)=>{
        const number = Number(digits);
        // don't convert `#&160;` to roman -- entity for space
        return number === 160 && next === `;` || number > 1000 ? `${digits}${next ?? ``}` : `${(0, $18df0c6f364c9037$exports.toRoman)(number)}${next ?? ``}`;
    }).replace(/--/g, (0, $9663980678ef0204$export$dec6b13405c072f0).MDASH);
}
function $07039be0dd75627a$export$ab0473dc0ac47591(title) {
    return $07039be0dd75627a$export$cacb59c3d67ee272(title).replace(new RegExp((0, $9663980678ef0204$export$dec6b13405c072f0).MDASH, `g`), `\u{2013}`).replace(new RegExp((0, $9663980678ef0204$export$dec6b13405c072f0).NON_BREAKING_SPACE, `g`), ` `);
}



function $349b024fc1512096$export$f23cc10bdc92bdbb(adoc) {
    return $349b024fc1512096$export$f7536721714a2be0(adoc).replace(/--/g, (0, $9663980678ef0204$export$dec6b13405c072f0).MDASH).replace(/ & /g, ` ${(0, $9663980678ef0204$export$dec6b13405c072f0).AMPERSAND} `).trim();
}
function $349b024fc1512096$export$f7536721714a2be0(asciidoc) {
    const adoc = $349b024fc1512096$export$e65f72ee73ce552e;
    return asciidoc.replace(new RegExp(`${adoc.RIGHT_DOUBLE_QUOTE}${adoc.RIGHT_SINGLE_QUOTE}`, `gim`), `${(0, $9663980678ef0204$export$dec6b13405c072f0).RIGHT_DOUBLE_QUOTE}${(0, $9663980678ef0204$export$dec6b13405c072f0).RIGHT_SINGLE_QUOTE}`).replace(new RegExp(`${adoc.RIGHT_SINGLE_QUOTE}${adoc.RIGHT_DOUBLE_QUOTE}`, `gim`), `${(0, $9663980678ef0204$export$dec6b13405c072f0).RIGHT_SINGLE_QUOTE}${(0, $9663980678ef0204$export$dec6b13405c072f0).RIGHT_DOUBLE_QUOTE}`).replace(new RegExp(adoc.LEFT_DOUBLE_QUOTE, `gim`), (0, $9663980678ef0204$export$dec6b13405c072f0).LEFT_DOUBLE_QUOTE).replace(new RegExp(adoc.RIGHT_DOUBLE_QUOTE, `gim`), (0, $9663980678ef0204$export$dec6b13405c072f0).RIGHT_DOUBLE_QUOTE).replace(new RegExp(adoc.LEFT_SINGLE_QUOTE, `gim`), (0, $9663980678ef0204$export$dec6b13405c072f0).LEFT_SINGLE_QUOTE).replace(new RegExp(adoc.RIGHT_SINGLE_QUOTE, `gim`), (0, $9663980678ef0204$export$dec6b13405c072f0).RIGHT_SINGLE_QUOTE);
}
function $349b024fc1512096$export$1b779bb0b1da38a8(adoc) {
    return adoc.replace(/&hellip;/g, (0, $9663980678ef0204$export$dec6b13405c072f0).ELLIPSES);
}
const $349b024fc1512096$export$e65f72ee73ce552e = {
    LEFT_DOUBLE_QUOTE: `"\``,
    RIGHT_DOUBLE_QUOTE: `\`"`,
    LEFT_SINGLE_QUOTE: `'\``,
    RIGHT_SINGLE_QUOTE: `\`'`
};




const $a18bae2279a18731$var$rule = (line, lines, lineNumber)=>{
    const fixed = (0, $2f86063047d29fb1$export$ecf03f26d74da604)(line);
    if (fixed === line) return [];
    let column = null;
    line.split(``).forEach((char, col)=>{
        if (column === null && char !== fixed[col]) column = col;
    });
    return [
        {
            line: lineNumber,
            type: `error`,
            column: column || 0,
            rule: $a18bae2279a18731$var$rule.slug,
            message: `Incorrect usage of smart quotes/apostrophes`,
            recommendation: fixed,
            fixable: true
        }
    ];
};
$a18bae2279a18731$var$rule.slug = `smart-quotes`;
var $a18bae2279a18731$export$2e2bcd8739ae039 = $a18bae2279a18731$var$rule;


const $f3b0901be3a09481$var$rule = (line, lines, lineNumber)=>{
    const match = line.match(/^\* \d+\. /);
    if (!match) return [];
    return [
        {
            line: lineNumber,
            column: line.indexOf(`.`) + 1,
            rule: $f3b0901be3a09481$var$rule.slug,
            type: `error`,
            message: `The period after a year that comes first on a _list-item line_ (begins with \`*\`) must be escaped.`,
            recommendation: line.replace(`.`, `+++.+++`)
        }
    ];
};
$f3b0901be3a09481$var$rule.slug = `list-year`;
var $f3b0901be3a09481$export$2e2bcd8739ae039 = $f3b0901be3a09481$var$rule;




function $59a9bdb9d6df59dd$export$9b46b31ea036dccf(line) {
    return line[0] === `[` && line[line.length - 1] === `]`;
}
function $59a9bdb9d6df59dd$export$297e3f7c8b458254(line) {
    if (line === `|==`) return true;
    if (line.match(/^(\d+\+)?\|/)) return true;
    return false;
}
function $59a9bdb9d6df59dd$export$4227daa3b24f9dc1(line, lines, number) {
    if (line.match(/^` {4}/)) return true;
    if (!line.match(/^(\s){5}/)) return false;
    if (!lines[number - 2]) return false;
    let index = number - 2;
    let prevLine = lines[index];
    while(prevLine){
        // this special line starts footnote poetry
        if (prevLine.match(/^`(\s){4}/)) return true;
        // means we've moved up INTO a footnote, so were not in one before
        if (prevLine.match(/\]$/)) return false;
        // we're exiting a footnote, and didn't fine the special starter line
        if (prevLine.match(/footnote:\[/)) return false;
        index -= 1;
        prevLine = lines[index];
    }
    return false;
}


const $47053d0bbcd60188$var$split = (0, $6b72b637a7d86f3b$export$17aaa75f75e7b92e)(90, 45);
const $47053d0bbcd60188$var$rule = (line, lines, lineNumber)=>{
    if ($47053d0bbcd60188$var$lengthOk(line)) return [];
    const recommendation = $47053d0bbcd60188$var$getRecommendation(line);
    return [
        {
            line: lineNumber,
            column: false,
            rule: $47053d0bbcd60188$var$rule.slug,
            type: `error`,
            message: `Non-heading and non-list lines should not exceed 100 characters`,
            ...recommendation ? {
                recommendation: recommendation
            } : {}
        }
    ];
};
function $47053d0bbcd60188$var$lengthOk(line) {
    if (line.length < 100) return true;
    if ([
        `//`,
        `==`,
        `* `
    ].includes(line.substring(0, 2))) return true;
    if (line.match(/^\[.+\]$/)) return true;
    if (line.includes(`[.book-title]#`)) return true;
    if ((0, $59a9bdb9d6df59dd$export$297e3f7c8b458254)(line)) return true;
    return false;
}
function $47053d0bbcd60188$var$getRecommendation(line) {
    // hilkiah will be undefined in the browser, for bundle-size management
    const refs = $7d124c42914d71da$exports && typeof $7d124c42914d71da$exports.find === `function` ? $7d124c42914d71da$exports.find(line) : [];
    // pull out scripture refs for splitting
    const withoutRefs = refs.reduce((ln, ref, index)=>{
        return ln.replace(ref.match, `\u{2022}${index}`);
    }, line);
    const block = $47053d0bbcd60188$var$split(withoutRefs);
    // now restore the scripture refs
    const reco = refs.reduce((adoc, ref, index)=>{
        return adoc.replace(`\u{2022}${index}`, ref.match);
    }, block);
    if (reco.trim() === line.trim() || reco.split(`\n`).length > 2) return false;
    return reco;
}
$47053d0bbcd60188$var$rule.slug = `line-length`;
var $47053d0bbcd60188$export$2e2bcd8739ae039 = $47053d0bbcd60188$var$rule;


const $57599e966153a2ee$var$rule = (line, lines, lineNumber)=>{
    if (!line.length || line[line.length - 1] !== ` `) return [];
    const match = line.match(/ +$/);
    if (!match || match.index === undefined) return [];
    return [
        {
            line: lineNumber,
            column: match.index + 1,
            rule: $57599e966153a2ee$var$rule.slug,
            type: `error`,
            message: `Lines should not have trailing whitespace`,
            recommendation: line.replace(/ +$/, ``),
            fixable: true
        }
    ];
};
$57599e966153a2ee$var$rule.slug = `trailing-whitespace`;
var $57599e966153a2ee$export$2e2bcd8739ae039 = $57599e966153a2ee$var$rule;



const $f6bde9dc3bf69faf$var$rule = (line, lines, lineNumber)=>{
    if (!line.length || line[0] !== ` `) return [];
    if ((0, $59a9bdb9d6df59dd$export$4227daa3b24f9dc1)(line, lines, lineNumber)) return [];
    return [
        {
            line: lineNumber,
            column: 0,
            rule: $f6bde9dc3bf69faf$var$rule.slug,
            type: `error`,
            message: `Lines should not have leading whitespace`,
            recommendation: line.replace(/^ +/, ``),
            fixable: true
        }
    ];
};
$f6bde9dc3bf69faf$var$rule.slug = `leading-whitespace`;
var $f6bde9dc3bf69faf$export$2e2bcd8739ae039 = $f6bde9dc3bf69faf$var$rule;


const $f99917ee75a41b59$var$rule = (line, lines, lineNumber)=>{
    if (line === ``) return [];
    const match = line.match(/^(\d+||[a-z]{1})\. /i);
    if (!match || match.index === undefined) return [];
    return [
        {
            line: lineNumber,
            column: match.index + 2,
            rule: $f99917ee75a41b59$var$rule.slug,
            type: `error`,
            message: `Periods near the beginning of the line sometimes need to be escaped to prevent errors converting to HTML.`,
            recommendation: line.replace(/\./, `+++.+++`)
        }
    ];
};
$f99917ee75a41b59$var$rule.slug = `unintentional-list-item`;
var $f99917ee75a41b59$export$2e2bcd8739ae039 = $f99917ee75a41b59$var$rule;


const $5133f3ddd94b5cd2$var$rule = (line, lines, lineNumber)=>{
    if (line !== ``) return [];
    const prevLine = lines[lineNumber - 2];
    if (typeof prevLine === `undefined` || prevLine !== ``) return [];
    // we only flag the LAST line of a multi-line violation
    const nextLine = lines[lineNumber];
    if (nextLine === ``) return [];
    const remove = [];
    let offset = 2;
    let current = lines[lineNumber - offset];
    while(current === ``){
        offset++;
        remove.push(lineNumber - offset + 2);
        current = lines[lineNumber - offset];
    }
    return [
        {
            line: lineNumber - 1,
            column: false,
            type: `error`,
            rule: $5133f3ddd94b5cd2$var$rule.slug,
            message: `Multiple blank lines are not allowed`,
            fixable: true,
            recommendation: `--> remove line/s: (${remove.sort().join(`,`)})`
        }
    ];
};
$5133f3ddd94b5cd2$var$rule.slug = `multiple-blank-lines`;
var $5133f3ddd94b5cd2$export$2e2bcd8739ae039 = $5133f3ddd94b5cd2$var$rule;


const $c614ad91c38b4306$var$rule = (line, lines, lineNumber)=>{
    if (line === `` || lineNumber !== lines.length) return [];
    return [
        {
            line: lineNumber,
            column: false,
            type: `error`,
            rule: $c614ad91c38b4306$var$rule.slug,
            message: `Files must end with a single blank line`,
            fixable: true,
            recommendation: `--> add a new line to the end of the file`
        }
    ];
};
$c614ad91c38b4306$var$rule.slug = `eof-newline`;
var $c614ad91c38b4306$export$2e2bcd8739ae039 = $c614ad91c38b4306$var$rule;


const $26a2d039a35a4871$var$rule = (line, lines, lineNumber)=>{
    if (line[0] !== `[` || line[line.length - 1] !== `]`) return [];
    if (!line.startsWith(`[.book-title]`)) return [];
    return [
        {
            line: lineNumber,
            column: false,
            type: `error`,
            rule: $26a2d039a35a4871$var$rule.slug,
            message: `Line-ending bracket needs to be escaped because the line starts with a [.book-title]`,
            recommendation: line.replace(/\]$/, `+++]+++`)
        }
    ];
};
$26a2d039a35a4871$var$rule.slug = `confusing-bracket`;
var $26a2d039a35a4871$export$2e2bcd8739ae039 = $26a2d039a35a4871$var$rule;


const $5957fdba184b6272$var$rule = (line, lines, lineNumber)=>{
    if (line === `` || lines[lineNumber] !== ``) return [];
    if (line[0] !== `[` || line[line.length - 1] !== `]`) return [];
    if (line.indexOf(`]`) !== line.length - 1) return [];
    return [
        {
            line: lineNumber,
            column: false,
            type: `error`,
            rule: $5957fdba184b6272$var$rule.slug,
            message: `Class/id designations (like \`[.something]\`) may not be followed by an empty line`
        }
    ];
};
$5957fdba184b6272$var$rule.slug = `floating-class`;
var $5957fdba184b6272$export$2e2bcd8739ae039 = $5957fdba184b6272$var$rule;


const $35b3a5fec3ec1f04$var$rule = (line, lines, lineNumber)=>{
    if (line[0] !== `=`) return [];
    if (line.match(/^={2,4} [^\s\n]/)) return [];
    if (line === `====`) return []; // example block delimiter (used by .numbered-group)
    if (line === `=======`) return []; // will be flagged by `git-conflict-markers`
    const fixable = !!line.match(/^={2,4}  +/);
    return [
        {
            line: lineNumber,
            column: 1,
            type: `error`,
            rule: $35b3a5fec3ec1f04$var$rule.slug,
            message: `Headings may only have 2-4 equal signs, and must be followed by a space and at least one character`,
            fixable: fixable,
            ...fixable ? {
                recommendation: line.replace(/  +/, ` `)
            } : {}
        }
    ];
};
$35b3a5fec3ec1f04$var$rule.slug = `invalid-heading`;
var $35b3a5fec3ec1f04$export$2e2bcd8739ae039 = $35b3a5fec3ec1f04$var$rule;


function $724bbdff34a1cb90$export$2e2bcd8739ae039(char) {
    // I don't know how to code in a soft-hyphen,
    // so there's one embedded in this string
    if (char === `be\xadstowed`[2]) return `SOFT HYPHEN`;
    switch(char){
        case `\u{2013}`:
            return `EN DASH`;
        case `\u{2022}`:
            return `BULLET`;
        case `\u{41E}`:
            return `CYRILLIC CAPITAL LETTER O`;
        case `\u{201C}`:
            return `LEFT DOUBLE QUOTATION MARK`;
        case `\u{201D}`:
            return `RIGHT DOUBLE QUOTATION MARK`;
        case `\u{2018}`:
            return `LEFT SINGLE QUOTATION MARK`;
        case `\u{2019}`:
            return `RIGHT SINGLE QUOTATION MARK`;
        case `\xa0`:
            return `NO-BREAK SPACE`;
        default:
            return `UNKNOWN`;
    }
}



const $b5344e395a604534$var$rule = (line, lines, lineNumber)=>{
    if (line === ``) return [];
    if (line[0] !== `=` && line[0] !== `>` && line[0] !== `<`) return [];
    if (!line.match(/^(=======|<<<<<<<|>>>>>>>)/)) return [];
    return [
        {
            line: lineNumber,
            column: false,
            type: `error`,
            rule: $b5344e395a604534$var$rule.slug,
            message: `Git conflict markers must be removed.`
        }
    ];
};
$b5344e395a604534$var$rule.slug = `git-conflict-markers`;
var $b5344e395a604534$export$2e2bcd8739ae039 = $b5344e395a604534$var$rule;


const $4d2ffe8045c3da64$var$rule = (line, lines, lineNumber, options)=>{
    if (line === `` || (0, $59a9bdb9d6df59dd$export$297e3f7c8b458254)(line)) return [];
    if ((0, $b5344e395a604534$export$2e2bcd8739ae039)(line, lines, lineNumber, options).length) return [];
    let escapeStart;
    let escapeEnd;
    const hasEscape = line.includes(`+++`);
    if (hasEscape) {
        escapeStart = line.indexOf(`+++`) + 3;
        escapeEnd = escapeStart + line.substring(escapeStart).indexOf(`+++`);
    }
    const allowed = $4d2ffe8045c3da64$var$maps[options.lang];
    const results = [];
    line.split(``).forEach((char, index)=>{
        if (hasEscape && escapeStart <= index && escapeEnd > index) return;
        if (allowed[char]) return;
        if ($4d2ffe8045c3da64$var$delimitsXref(char, index, line)) return;
        const name = (0, $724bbdff34a1cb90$export$2e2bcd8739ae039)(char);
        results.push($4d2ffe8045c3da64$var$getLint(char, line, lineNumber, index + 1, name));
    });
    return results;
};
function $4d2ffe8045c3da64$var$delimitsXref(char, index, line) {
    if (![
        `>`,
        `<`
    ].includes(char)) return false;
    if (line[index - 1] !== char && line[index + 1] === char && line[index + 2] !== char) // is FIRST part of doubled sequence, like `<<` or `>>`
    return true;
    if (line[index - 2] !== char && line[index - 1] === char && line[index + 1] !== char) // is SECOND part of doubled sequence, like `<<` or `>>`
    return true;
    return false;
}
function $4d2ffe8045c3da64$var$getLint(char, line, lineNumber, column, name) {
    const hex = (char.codePointAt(0) || 0).toString(16);
    const unicode = `\\u${`0000`.substring(0, 4 - hex.length)}${hex}`;
    const fixableReco = $4d2ffe8045c3da64$var$fixable(name, line, column);
    return {
        line: lineNumber,
        column: column,
        type: `error`,
        rule: $4d2ffe8045c3da64$var$rule.slug,
        message: `Dissallowed character: \`${char}\`, code: \`${unicode}\` (${name})`,
        ...fixableReco !== false ? {
            fixable: true,
            recommendation: fixableReco
        } : {}
    };
}
function $4d2ffe8045c3da64$var$fixable(name, line, column) {
    switch(name){
        case `EN DASH`:
            return line.replace(/–/g, `-`);
        case `NO-BREAK SPACE`:
            return $4d2ffe8045c3da64$var$nbsp(line, column);
        case `CYRILLIC CAPITAL LETTER O`:
            return line.replace(/О/g, `O`);
        case `BULLET`:
        case `SOFT HYPHEN`:
            return `${line.substring(0, column - 1)}${line.substring(column)}`;
        case `RIGHT SINGLE QUOTATION MARK`:
            return line.replace(/’/g, `\`'`);
        case `LEFT SINGLE QUOTATION MARK`:
            return line.replace(/‘/g, `'\``);
        case `RIGHT DOUBLE QUOTATION MARK`:
            return line.replace(/”/g, `\`"`);
        case `LEFT DOUBLE QUOTATION MARK`:
            return line.replace(/“/g, `"\``);
        default:
            return false;
    }
}
function $4d2ffe8045c3da64$var$nbsp(line, column) {
    if (column === 1) return line.replace(/^ +/, ``);
    if (line.substring(column - 11, column - 1) === `footnote:[`) return line.replace(/footnote:\[./, `footnote:[`);
    if (line[column] === ` ` || line[column - 2] === ` `) return `${line.substring(0, column - 1)}${line.substring(column)}`;
    return `${line.substring(0, column - 1)} ${line.substring(column)}`;
}
// performance sort of matters here, because we're checking every character
// of sometimes every book -- using object property lookup was about 25%
// faster than using Set.has(x), in my testing, and WAY faster than [].includes(x)
const $4d2ffe8045c3da64$var$allowedEn = [
    `abcdefghijklmnopqrstuvwxyz`,
    `ABCDEFGHIJKLMNOPQRSTUVWXYZ`,
    `0123456789`,
    `.,;:!?`,
    `"'\``,
    `\xa3$`,
    `[]#^&*()-_=+/{}\xb0`,
    `\n `
];
const $4d2ffe8045c3da64$var$allowedEs = $4d2ffe8045c3da64$var$allowedEn.concat([
    `\xed\xe9\xf3\xe1\xfa\xf1\xfc`,
    `\xcd\xc9\xd3\xc1\xda\xd1\xdc`,
    `\xa1\xbf`
]);
const $4d2ffe8045c3da64$var$maps = {
    es: $4d2ffe8045c3da64$var$toObject($4d2ffe8045c3da64$var$allowedEs),
    en: $4d2ffe8045c3da64$var$toObject($4d2ffe8045c3da64$var$allowedEn)
};
$4d2ffe8045c3da64$var$rule.slug = `invalid-characters`;
var $4d2ffe8045c3da64$export$2e2bcd8739ae039 = $4d2ffe8045c3da64$var$rule;
function $4d2ffe8045c3da64$var$toObject(arr) {
    const lookup = {};
    return arr.join(``).split(``).reduce((obj, char)=>{
        obj[char] = true;
        return obj;
    }, lookup);
}


const $d43c8be8f7800c7f$var$rule = (line, lines, lineNumber)=>{
    if (line[0] !== `[` || line[1] !== `.` || line[line.length - 1] !== `]`) return [];
    if (!line.includes(`.chapter-synopsis`)) return [];
    let index = lineNumber;
    let nextLine = lines[index];
    const results = [];
    while(nextLine){
        if (!nextLine.match(/^\* [^ ]/) && !nextLine.match(/^\/\//)) results.push({
            line: index + 1,
            column: 1,
            type: `error`,
            rule: $d43c8be8f7800c7f$var$rule.slug,
            message: `Chapter synopsis list items must begin with exactly \`* \``,
            recommendation: nextLine.replace(/^\*+/, ``).replace(/^ +/, ``).replace(/^/, `* `),
            fixable: false
        });
        index++;
        nextLine = lines[index];
    }
    return results;
};
$d43c8be8f7800c7f$var$rule.slug = `chapter-synopsis-list-item`;
var $d43c8be8f7800c7f$export$2e2bcd8739ae039 = $d43c8be8f7800c7f$var$rule;



const $65d08bdeb08b40ea$var$rule = (line, lines, lineNumber)=>{
    if (line === ``) return [];
    const doubles = [
        `\`'\`'`,
        `'\`'\``,
        `\`"\`"`,
        `"\`"\``,
        `,,`,
        `;;`,
        `??`,
        `.,`,
        `,.`,
        `:.`,
        `.:`,
        `.;`,
        `;.`,
        `!.`,
        `.!`
    ];
    const lints = [];
    doubles.forEach((double)=>{
        if (!line.includes(double)) return;
        for(let i = 0; i < line.length; i++)if (line.substring(i, i + double.length) === double && !$65d08bdeb08b40ea$var$specialCase(double, line, i)) lints.push($65d08bdeb08b40ea$var$getLint(line, lineNumber, double, i));
    });
    return lints;
};
function $65d08bdeb08b40ea$var$specialCase(double, line, column) {
    if (![
        `.,`,
        `.:`,
        `.;`,
        `.!`
    ].includes(double)) return false;
    if (line[column - 1] && line[column - 1]?.match(/\d/)) return true;
    const two = line.substring(column - 2, column).toLowerCase();
    const allowedTwo = [
        `jr`,
        `sr`,
        `mo`,
        `ii`,
        `co`,
        `pa`,
        `pp`
    ];
    if (two.length === 2 && allowedTwo.includes(two)) return true;
    // prettier-ignore
    const allowedThree = [
        `etc`,
        `viz`,
        `ult`,
        `jun`,
        `vol`,
        `4to`,
        `i.e`,
        `esq`,
        `1st`,
        `2nd`,
        `3rd`,
        `4th`,
        `5th`,
        `6th`,
        `7th`,
        `8th`,
        `9th`,
        `p.m`,
        `a.m`,
        `sen`,
        `pet`,
        `jan`,
        `feb`,
        `mar`,
        `apr`,
        `jul`,
        `aug`,
        `sep`,
        `oct`,
        `nov`,
        `dec`,
        `m.d`
    ];
    const three = line.substring(column - 3, column).toLowerCase();
    if (three.length === 3 && allowedThree.includes(three)) return true;
    // prettier-ignore
    const allowedFour = [
        `vols`,
        `ibid`,
        `i. e`,
        `inst`,
        `mass`,
        `p. m`,
        `a. m`,
        `matt`,
        `chap`,
        `faht`
    ];
    const four = line.substring(column - 4, column).toLowerCase();
    if (four.length === 4 && allowedFour.includes(four)) return true;
    // special case `G. F., and F. H. went to meeting`
    if (column >= 1 && line[column] === `.` && line[column - 1]?.match(/[A-Z]/) && (column === 1 || line[column - 2] === ` `)) return true;
    if (three === `\`'s` && four[0] && line[column - 4]?.match(/[A-Z]/)) return true;
    // catch roman numerals
    const lastWord = line.substring(0, column).split(` `).pop();
    try {
        const num = (0, $18df0c6f364c9037$exports.toArabic)(lastWord || ``);
        if (typeof num === `number`) return true;
    } catch  {
    // ¯\_(ツ)_/¯
    }
    // shillings refs
    if (two.match(/^\ds$/)) return true;
    // definition lists
    if (double === `.:` && line[column + 1] === `:`) return true;
    return false;
}
function $65d08bdeb08b40ea$var$getLint(line, lineNumber, double, colIndex) {
    const before = line.substring(0, colIndex);
    const after = line.substring(colIndex + double.length);
    const single = double.substring(0, double.length / 2);
    const recommendation = `${before}${single}${after}`;
    const lint = {
        line: lineNumber,
        column: colIndex + 1 + double.length / 2,
        type: `error`,
        rule: $65d08bdeb08b40ea$var$rule.slug,
        message: `Invalid doubled punctuation mark`,
        recommendation: recommendation,
        fixable: double.length === 2
    };
    if (double.length === 2 && double[0] !== double[1]) {
        delete lint.recommendation;
        delete lint.fixable;
    }
    return lint;
}
$65d08bdeb08b40ea$var$rule.slug = `doubled-punctuation`;
var $65d08bdeb08b40ea$export$2e2bcd8739ae039 = $65d08bdeb08b40ea$var$rule;



const $4b35679ce1077cb7$var$rule = (line, lines, lineNumber)=>{
    if (line === `` || line.indexOf(`  `) === -1) return [];
    if ((0, $59a9bdb9d6df59dd$export$297e3f7c8b458254)(line) || (0, $59a9bdb9d6df59dd$export$4227daa3b24f9dc1)(line, lines, lineNumber)) return [];
    const expr = / {2,}/g;
    let match = null;
    const results = [];
    while(match = expr.exec(line)){
        const isLeading = match.index === 0;
        const isTrailing = match.index + match[0].length === line.length;
        if (isLeading || isTrailing) continue;
        // will be caught by `invalid-heading` rule
        if (results.length === 0 && line.substring(0, match.index + 1).match(/^===?=? $/)) continue;
        results.push($4b35679ce1077cb7$var$getLint(match.index + 2, line, lineNumber));
    }
    return results;
};
function $4b35679ce1077cb7$var$getLint(column, line, lineNumber) {
    return {
        line: lineNumber,
        column: column,
        type: `error`,
        rule: $4b35679ce1077cb7$var$rule.slug,
        message: `Consecutive spaces are not allowed`,
        recommendation: line.replace(/ {2,}/g, ` `),
        fixable: true
    };
}
$4b35679ce1077cb7$var$rule.slug = `consecutive-spaces`;
var $4b35679ce1077cb7$export$2e2bcd8739ae039 = $4b35679ce1077cb7$var$rule;


class $1086226af35af6e4$export$2e2bcd8739ae039 {
    defaults = {
        isMaybe: false,
        fixable: true,
        langs: [
            `en`
        ],
        editions: [
            `original`,
            `modernized`,
            `updated`
        ],
        message: `"<found>" <shouldBecome> "<fixed>" <inContext>`,
        recommend: true,
        includeNextLineFirstWord: false,
        discardIfIdenticalRecommendation: false
    };
    data;
    search;
    isMaybe;
    langs;
    editions;
    allowIfNear;
    includeNextLineFirstWord;
    discardIfIdenticalRecommendation;
    /**
   * Quick and dirty test to see if we should run the full
   * regex against a line (or chunk) of asciidoc
   */ test;
    constructor(data){
        this.data = {
            ...this.defaults,
            ...data
        };
        this.search = this.data.search;
        this.isMaybe = this.data.isMaybe;
        this.test = this.data.test;
        this.langs = this.data.langs;
        this.editions = this.data.editions;
        this.allowIfNear = this.data.allowIfNear;
        this.includeNextLineFirstWord = this.data.includeNextLineFirstWord;
        this.discardIfIdenticalRecommendation = this.data.discardIfIdenticalRecommendation;
    }
    isFixable(match, line, lineNumber) {
        const { fixable: fixable } = this.data;
        return typeof fixable === `function` ? fixable(match, line, lineNumber) : fixable;
    }
    message(found) {
        const fixed = this.execReplace(found);
        const shouldBecome = this.isMaybe ? `is often (but not always!) better` : `should be replaced with`;
        let inContext = `in all editions`;
        if (this.data.editions.length < 3) inContext = `in ${this.data.editions.join(` and `)} editions`;
        return this.data.message.replace(`<found>`, found).replace(`<shouldBecome>`, shouldBecome).replace(`<fixed>`, fixed).replace(`<inContext>`, inContext).trim();
    }
    recommendation(match, line) {
        if (!this.data.recommend) return;
        const index = match.index || 0;
        const parts = [
            line.substring(0, index),
            this.execReplace(line.substring(index, index + match[0].length)),
            line.substring(index + match[0].length)
        ];
        return parts.join(``);
    }
    execReplace(str) {
        const { replace: replace } = this.data;
        // @ts-ignore https://github.com/microsoft/TypeScript/issues/29789
        return str.replace(this.search, replace === undefined ? `???` : replace);
    }
}


class $1a547e879b999407$export$2e2bcd8739ae039 {
    lints;
    testPattern;
    rule;
    constructor(lintData, options = {}){
        this.lints = lintData.map((data)=>new (0, $1086226af35af6e4$export$2e2bcd8739ae039)({
                ...options,
                ...data
            }));
        this.testPattern = new RegExp(this.lints.map((l)=>l.test).join(`|`), `i`);
    }
    getLineLintResults(line, lineNumber, lines, options) {
        let results = [];
        if (line === `` || !line.match(this.testPattern)) return results;
        this.lints.forEach((lint)=>{
            if ($1a547e879b999407$var$shouldLint(lint, options)) {
                const matches = this.getLineMatches(lint, line, lines, lineNumber);
                results = results.concat(matches.map((match)=>this.getLintResult(match, line, lineNumber, lint)).filter((result)=>lint.discardIfIdenticalRecommendation ? !result.recommendation || line !== result.recommendation : true));
            }
        });
        return results;
    }
    getLineMatches(lint, line, lines, lineNumber) {
        const matches = [];
        if (lint.allowIfNear && line.match(lint.allowIfNear)) return matches;
        if (lint.includeNextLineFirstWord && lines[lineNumber]) {
            line += ` ${lines[lineNumber]?.split(` `).filter(Boolean).shift() || ``}`;
            line = line.trim();
        }
        if (lint.search.global) {
            let match = null;
            while(match = lint.search.exec(line))matches.push(match);
        } else {
            const match = lint.search.exec(line);
            if (match) matches.push(match);
        }
        return matches;
    }
    getLintResult(match, line, lineNumber, lint) {
        if (!this.rule) throw new Error(`Must set RegexLintRunner.rule property`);
        const recommendation = lint.recommendation(match, line);
        return {
            line: lineNumber,
            column: $1a547e879b999407$var$getColumn(match, recommendation),
            fixable: lint.isFixable(match, line, lineNumber),
            type: `error`,
            rule: this.rule,
            message: lint.message(match[0]),
            ...recommendation ? {
                recommendation: recommendation
            } : {}
        };
    }
}
function $1a547e879b999407$var$getColumn({ index: index = 0, input: before = `` }, corrected) {
    if (corrected === undefined) return index + 1;
    for(let i = 0; i < before.length; i++){
        if (corrected[i] !== before[i]) return i + 1;
    }
    return before.length + 1;
}
function $1a547e879b999407$var$shouldLint(lint, { lang: lang, editionType: edition, maybe: maybe }) {
    if (!lint.langs.includes(lang)) return false;
    if (edition && !lint.editions.includes(edition)) return false;
    if (lint.isMaybe && !maybe) return false;
    return true;
}


const $7cdec9492a62c478$var$runner = new (0, $1a547e879b999407$export$2e2bcd8739ae039)([
    {
        test: `tor`,
        search: /\btor\b/g,
        replace: `for`
    },
    {
        test: `i`,
        search: /( |^)i( |$)/g,
        replace: `$1I$2`,
        allowIfNear: /\]/
    },
    {
        test: `f`,
        search: /( |^)(F|f)( |$)/g,
        replace: `$1I `
    },
    {
        test: `"|'|\``,
        search: /(^| )('|"|`){2}( |$)/g,
        replace: ` `,
        message: `detached quotation mark scan error should be corrected`
    },
    {
        test: `ing`,
        search: /([^A-Za-z]+)\bing\b/,
        replace: (full, prev)=>{
            return full.replace(prev, ``);
        }
    },
    {
        test: `yon`,
        search: /\b(Y|y)on\b/g,
        replace: `$1ou`
    },
    {
        test: `mmd`,
        search: /\bmmd\b/g,
        replace: `mind`
    },
    {
        test: `lime|limes`,
        search: /\blime(s)?\b/g,
        replace: `time$1`,
        allowIfNear: /(ashes|lemon|orange|kiln|fruit|manure|white|stone|juice|chloride)/i
    },
    {
        test: `wc`,
        search: /\b(W|w)c\b/g,
        replace: `$1e`
    },
    {
        test: `whoso`,
        search: /\b(W|w)hoso\b/g,
        replace: `$1hose`,
        message: `"whoso" is sometimes a scan error of "whose" except when it is a synonym for "whoever"`,
        editions: [
            `original`
        ],
        isMaybe: true
    },
    {
        test: `bo`,
        search: /\b(B|b)o\b/g,
        replace: `$1e`
    },
    {
        test: `T`,
        search: /( |^)(T|t) /g,
        replace: `$1I `
    },
    {
        test: `ray`,
        search: /\bray\b/g,
        replace: `my`,
        allowIfNear: /\b(ray of|gloom|sun|shone)\b/i
    },
    {
        test: `arid`,
        search: /\b(A|a)rid\b/g,
        replace: `$1nd`,
        allowIfNear: /\b(dry|desert|parch)/i
    },
    {
        test: `arc`,
        search: /\b(A|a)rc\b/g,
        replace: `$1re`,
        allowIfNear: /\b(joan|jeanne)\b/i
    },
    {
        test: `fife`,
        search: /\bfife\b/g,
        replace: `life`,
        allowIfNear: /\bfiddle\b|\bplay|\bdrum\b/i
    },
    {
        test: `Fie`,
        search: /\bFie\b/g,
        replace: `He`
    },
    {
        test: `sec`,
        search: /\b(S|s)ec(?!\.)\b/g,
        replace: `$1ee`
    },
    {
        test: `aud`,
        search: /\b(A|a)ud\b/g,
        replace: `$1nd`
    },
    {
        test: `mc`,
        search: /\bmc\b/g,
        replace: `me`
    }
].map((d)=>({
        ...d,
        test: `\\b${d.test}\\b`
    })), {
    fixable: false,
    message: `"<found>" is often a scanning error and should be corrected to "<fixed>"`
});
const $7cdec9492a62c478$var$rule = (line, lines, lineNumber, lintOptions)=>{
    if (lintOptions.lang !== `en`) return [];
    return $7cdec9492a62c478$var$runner.getLineLintResults(line, lineNumber, lines, lintOptions);
};
$7cdec9492a62c478$var$rule.slug = `scan-errors`;
$7cdec9492a62c478$var$runner.rule = $7cdec9492a62c478$var$rule.slug;
var $7cdec9492a62c478$export$2e2bcd8739ae039 = $7cdec9492a62c478$var$rule;



const $b68e7ff586333865$var$rule = (line, lines, lineNumber)=>{
    if (line === `` || line.length < 4) return [];
    if (line[line.length - 3] !== ` `) return [];
    if (!line.match(/ ("`|`"|'`|`')$/)) return [];
    return [
        {
            line: lineNumber,
            column: line.length - 1,
            type: `error`,
            rule: $b68e7ff586333865$var$rule.slug,
            message: `Invalid hanging quotation. Perhaps move it to the next line?`
        }
    ];
};
$b68e7ff586333865$var$rule.slug = `hanging-quotes`;
var $b68e7ff586333865$export$2e2bcd8739ae039 = $b68e7ff586333865$var$rule;


const $152524cb294970e8$var$rule = (line, lines, lineNumber)=>{
    if (line === `` || line[line.length - 1] !== `-` || line[line.length - 2] === `-`) return [];
    // footnote poetry stanza marker
    if (line.indexOf(`     - - - -`) === 0) return [];
    const recommendation = $152524cb294970e8$var$getRecommendation(line, lines[lineNumber] ?? null);
    return [
        {
            line: lineNumber,
            column: line.length,
            type: `error`,
            rule: $152524cb294970e8$var$rule.slug,
            message: `Lines may not end with a hyphen`,
            ...recommendation === false ? {} : {
                recommendation: recommendation,
                fixable: true
            }
        }
    ];
};
function $152524cb294970e8$var$getRecommendation(line, next) {
    if (!next) return false;
    if (!line.includes(` `) || !next.includes(` `)) return false;
    if (next.indexOf(`//`) === 0 || next[0] === `-`) return false;
    if (line.length <= next.length) {
        const nextWords = next.split(` `);
        const nextFirst = nextWords.shift();
        return `${line}${nextFirst}\n${nextWords.join(` `)}`;
    }
    const lineWords = line.split(` `);
    const lineLast = lineWords.pop();
    return `${lineWords.join(` `)}\n${lineLast}${next}`;
}
$152524cb294970e8$var$rule.slug = `trailing-hyphen`;
var $152524cb294970e8$export$2e2bcd8739ae039 = $152524cb294970e8$var$rule;



const $bcfdeb0d515a5258$var$runner = new (0, $1a547e879b999407$export$2e2bcd8739ae039)([
    {
        test: `strong`,
        search: /\b(S|s)trong(-| )hold(s?)\b/g,
        replace: `$1tronghold$3`,
        // not always incorrect, e.g. "London had a strong hold on his affections"
        isMaybe: true,
        fixable: false
    },
    {
        test: `coast`,
        search: /\b(S|s)ea(-| )coast(s?)\b/g,
        replace: `$1eacoast$3`
    },
    {
        test: `side`,
        search: /\b(S|s)ea(-| )side(s?)\b/g,
        replace: `$1easide$3`
    },
    {
        test: `rail-road`,
        search: /\b(R|r)ail-road(s?)\b/g,
        replace: `$1ailroad$2`
    },
    {
        test: `steam-boat`,
        search: /\b(S|s)team-boat(s?)\b/g,
        replace: `$1teamboat$2`
    },
    {
        test: `light-house`,
        search: /\b(L|l)ight-house(s?)\b/g,
        replace: `$1ighthouse$2`
    },
    {
        test: `school-house`,
        search: /\b(S|s)chool-house(s?)\b/g,
        replace: `$1choolhouse$2`
    },
    {
        test: `head-ache`,
        search: /\b(H|h)ead-ache(s?)\b/g,
        replace: `$1eadache$2`
    },
    {
        test: `child-like`,
        search: /\b(C|c)hild-like\b/g,
        replace: `$1hildlike`
    },
    {
        test: `horse`,
        search: /\b(H|h)orse(-| )back\b/g,
        replace: `$1orseback`
    },
    {
        test: `body`,
        search: /\b(A|a)ny(-| )body\b/g,
        replace: `$1nybody`,
        message: `Any body should usually be replaced with anybody, but not always`,
        // not always incorrect, especially when dealing with a "body" of friends
        isMaybe: true,
        fixable: false
    },
    {
        test: `Staten-Island`,
        search: /\bStaten-Island/gi,
        replace: `Staten Island`
    },
    {
        test: `Rhode-Island`,
        search: /\bRhode-Island/gi,
        replace: `Rhode Island`
    },
    {
        test: `New-York`,
        search: /\bNew-York/g,
        replace: `New York`
    },
    {
        test: `New-Jersey`,
        search: /\bNew-Jersey/g,
        replace: `New Jersey`
    },
    {
        test: `Long-Island`,
        search: /\bLong-Island/g,
        replace: `Long Island`
    },
    {
        test: `birth-day`,
        search: /\b(B|b)irth-(days?)\b/g,
        replace: `$1irth$2`
    },
    {
        test: `short`,
        search: /\b(S|s)hort(-| )comings?\b/g,
        replace: `$1hortcomings`
    },
    {
        test: `heart-felt`,
        search: /\b(H|h)eart-felt\b/g,
        replace: `$1eartfelt`
    },
    {
        test: `care-tak`,
        search: /\b(C|c)are-tak/g,
        replace: `$1aretak`,
        message: `"care-taker" should be replaced with "caretaker" in all editions`
    },
    {
        test: `meeting-house`,
        search: /\b(M|m)eeting-house/g,
        replace: `$1eetinghouse`
    },
    {
        test: `down-stairs`,
        search: /\b(D|d)own-stairs/g,
        replace: `$1ownstairs`
    },
    {
        test: `mis-spen`,
        search: /\b(M|m)is-spen/g,
        replace: `$1isspen`,
        message: `"mis-spent" should be replaced with "misspent" in all editions`
    },
    {
        test: `court-house`,
        search: /\b(C|c)ourt-house/g,
        replace: `$1ourthouse`
    },
    {
        test: `arch-angel`,
        search: /\b(A|a)rch-angel/g,
        replace: `$1rchangel`
    },
    {
        test: `yoke-`,
        search: /\b(Y|y)oke-(mate|fellow)(s)?/g,
        replace: `$1oke$2$3`
    },
    {
        test: `back-yard`,
        search: /\b(B|b)ack-yard/g,
        replace: `$1ackyard`
    },
    {
        test: `grave-yard`,
        search: /\b(G|g)rave-yard/g,
        replace: `$1raveyard`
    },
    {
        test: `ware-house`,
        search: /\b(W|w)are-house/g,
        replace: `$1arehouse`
    },
    {
        test: `fire`,
        search: /\b(F|f)ire-side/g,
        replace: `$1ireside`
    },
    {
        test: `grand-`,
        search: /\b(G|g)rand-(child(ren)?|fathers?|mothers?)/g,
        replace: `$1rand$2`
    },
    {
        test: `fellow-`,
        search: /\b(F|f)ellow-(creature|servant|traveller)(s)?\b/g,
        replace: `$1ellow $2$3`
    },
    {
        test: `heavy-laden`,
        search: /\b(H|h)eavy-laden\b/g,
        replace: `$1eavy laden`
    },
    {
        test: `-hearted`,
        search: /\b((F|f)aint|(B|b)roken|(L|l)ight)-hearted\b/g,
        replace: `$1hearted`
    },
    {
        test: `judgment-seat`,
        search: /\b(J|j)udgment-seat\b/g,
        replace: `$1udgment seat`
    },
    {
        test: `Zion-ward`,
        search: /\bZion-ward(s)?\b/g,
        replace: `Zionward$1`
    },
    {
        test: `holy-days`,
        search: /\b(H|h)oly-days\b/g,
        replace: `$1oly days`
    },
    {
        test: `worship-house`,
        search: /\b(W|w)orship-house(s)?\b/g,
        replace: `$1orship house$2`
    },
    {
        test: `inn-keeper`,
        search: /\b(I|i)nn-keeper(s)?\b/g,
        replace: `$1nnkeeper$2`
    },
    {
        test: `dining-room`,
        search: /\b(D|d)ining-room(s)?\b/g,
        replace: `$1ining room$2`
    },
    {
        test: `re-establish`,
        search: /\b(R|r)e-establish(ed|ment|ing)?\b/g,
        replace: `$1eestablish$2`
    },
    {
        test: `-minded`,
        search: /\b((S|s)piritually|(R|r)eligiously)-minded\b/g,
        replace: `$1 minded`
    },
    {
        test: `hope-well`,
        search: /\bHope-well\b/g,
        replace: `Hopewell`
    },
    {
        test: `loving-kindness`,
        search: /\b(L|l)oving-kindness\b/g,
        replace: `$1ovingkindness`
    },
    {
        test: `to-day`,
        search: /\b(T|t)o-day\b/g,
        replace: `$1oday`
    },
    {
        test: `to-morrow`,
        search: /\b(T|t)o-morrow\b/g,
        replace: `$1omorrow`
    },
    {
        test: `sun-set`,
        search: /\b(S|s)un-set(s)?\b/g,
        replace: `$1unset$2`
    },
    {
        test: `road-side`,
        search: /\b(R|r)oad-side(s)?\b/g,
        replace: `$1oadside$2`
    },
    {
        test: `day-time`,
        search: /\b(D|d)ay-time(s)?\b/g,
        replace: `$1aytime$2`
    },
    {
        test: `death-bed`,
        search: /\b(D|d)eath-bed(s)?\b/g,
        replace: `$1eathbed$2`
    },
    {
        test: `anti-christ`,
        search: /\b(A|a)nti-(C|c)hrist\b/g,
        replace: `$1ntichrist`
    },
    {
        test: `re-enter`,
        search: /\b(R|r)e-enter(s|ed)?\b/g,
        replace: `$1eenter$2`
    },
    {
        test: `re-embark`,
        search: /\b(R|r)e-embark(s|ed|ing|ation)?\b/g,
        replace: `$1eembark$2`
    },
    {
        test: `re-examin`,
        search: /\b(R|r)e-examin(ing|ed|e|ation)\b/g,
        replace: `$1eexamin$2`
    },
    {
        test: `pre-eminen`,
        search: /(P|p)re-eminen(ce|t|tly)/g,
        replace: `$1reeminen$2`
    },
    {
        test: `slave-holder`,
        search: /\b(S|s)lave-holder(s)?\b/g,
        replace: `$1laveholder$2`
    },
    {
        test: `co-operat`,
        search: /\b(C|c)o-operat(e|ing|ed|ion|es)\b/g,
        replace: `$1ooperat$2`
    },
    {
        test: `bed-side`,
        search: /\b(B|b)ed-side(s)?\b/g,
        replace: `$1edside$2`
    }
]);
const $bcfdeb0d515a5258$var$rule = (line, lines, lineNumber, lintOptions)=>{
    if (lintOptions.lang !== `en`) return [];
    return $bcfdeb0d515a5258$var$runner.getLineLintResults(line, lineNumber, lines, lintOptions);
};
$bcfdeb0d515a5258$var$rule.slug = `unhyphened-words`;
$bcfdeb0d515a5258$var$runner.rule = $bcfdeb0d515a5258$var$rule.slug;
var $bcfdeb0d515a5258$export$2e2bcd8739ae039 = $bcfdeb0d515a5258$var$rule;



const $76570f5e9ca56bcb$var$runner = new (0, $1a547e879b999407$export$2e2bcd8739ae039)([
    {
        test: `stedfast`,
        search: /\b(S|s)tedfast(ly)?\b/g,
        replace: `$1teadfast$2`
    },
    {
        test: `scull`,
        search: /\bscull(s?)\b/g,
        replace: `skull$1`
    },
    {
        test: `befal`,
        search: /\bbefal\b/g,
        replace: `befall`
    },
    {
        test: `waggon`,
        search: /\b(W|w)aggon(s?)\b/g,
        replace: `$1agon$2`
    },
    {
        test: `comb`,
        search: /\b((High|West)-)?Wic?combe?\b/gi,
        replace: (_, __, prefix)=>`${prefix === undefined ? `` : `${prefix} `}Wycombe`,
        fixable: true
    },
    {
        test: `chesa`,
        search: /\bchesapeak\b/gi,
        replace: `Chesapeake`,
        fixable: true
    },
    {
        test: `ndors`,
        search: /\b(I|i)ndors(e|ed|es|ing)\b/gi,
        replace: (_, start, end)=>`${start === `I` ? `E` : `e`}ndors${end}`,
        fixable: true
    },
    {
        test: `stablish`,
        search: /((A|a) )?\b(S|s)tablish(ed|ing|es)\b/g,
        replace: (_, a, __, s, end)=>`${a !== undefined ? a.replace(` `, `n `) : ``}${s === `S` ? `E` : `e`}stablish${end}`,
        fixable: true
    },
    {
        test: `much`,
        search: /\bin-(so|as)-much\b/g,
        replace: `in$1much`,
        fixable: true
    },
    {
        test: `doings`,
        search: /\bLord`'s doings\b/g,
        replace: `Lord\`'s doing`,
        fixable: false,
        message: `Obsolete grammar from references to archaic KJV of Ps. 118:23 should be carefully updated`
    },
    {
        test: `biass`,
        search: /\b(un)?(b)iass(es|ed|ing)\b/gi,
        replace: (_, un, b, end)=>`${un !== undefined ? un : ``}${b}ias${end}`
    },
    {
        test: `j`,
        search: /\b(jun|jr)\./g,
        replace: `Jr.`
    },
    {
        test: `havock`,
        search: /\b(H|h)avock\b/g,
        replace: `$1avoc`
    },
    {
        test: `mould`,
        search: /\b(M|m)ould\b/g,
        replace: `$1old`
    },
    {
        test: `incumb`,
        search: /\b(I|i)ncumb(er|ered|ering|ers|rance)\b/g,
        replace: (_, i, end)=>`${i === `I` ? `E` : `e`}ncumb${end}`
    },
    {
        test: `potatoe`,
        search: /\b(P|p)otatoe\b/g,
        replace: `$1otato`
    },
    {
        test: `leathern`,
        search: /\b(L|l)eathern\b/g,
        replace: `$1eather`
    },
    {
        test: `inclos`,
        search: /\b(Un|un)?(I|i)nclos(e|ed|es|ing|ure)/g,
        replace: (_, un, i, end)=>{
            const str = `${i === `I` ? `E` : `e`}nclos${end}`;
            if (un !== undefined) return `${un}${str}`;
            return str;
        }
    },
    {
        test: `intr`,
        search: /\b(I|i)ntr(eat|ust)/g,
        replace: (_, i, end)=>`${i === `I` ? `E` : `e`}ntr${end}`
    },
    {
        test: `stile`,
        search: /\b(S|s)tile\b/g,
        replace: `$1tyle`
    },
    {
        test: `despatch`,
        search: /\b(D|d)espatch/g,
        replace: `$1ispatch`
    },
    {
        test: `cotempor`,
        search: /\b(C|c)otempora/g,
        replace: `$1ontempora`,
        message: `"cotemporary" should be replaced with "contemporary" in all editions`
    },
    {
        test: `catched`,
        search: /\b(C|c)atched\b/g,
        replace: `$1aught`
    },
    {
        test: `staid`,
        search: /\b(S|s)taid\b/g,
        replace: `$1tayed`
    },
    {
        replace: `Melchizedek`,
        search: /\bMelchi(sedec|zedeck|sedek)\b/g,
        test: `Melchi`
    },
    {
        test: `connexion`,
        search: /\b(C|c)onnexion(s)?\b/g,
        replace: `$1onnection$2`
    },
    {
        test: `behove`,
        search: /\b(B|b)ehove(s|d)?\b/g,
        replace: `$1ehoove$2`
    },
    {
        test: `vail`,
        search: /\bvail(s|ed)?\b/g,
        replace: `veil$1`
    },
    {
        test: `gaol`,
        search: /\b(G|g)aol(er)?\b/g,
        replace: (_, g, end)=>`${g === `G` ? `J` : `j`}ail${end || ``}`
    },
    {
        test: `burthen`,
        search: /\b(B|b)urthen(s|some|ed)?\b/g,
        replace: `$1urden$2`
    },
    {
        test: `stopt`,
        search: /\b(S|s)topt\b/g,
        replace: `$1topped`
    },
    {
        test: `slipt`,
        search: /\b(S|s)lipt\b/g,
        replace: `$1lipped`
    },
    {
        test: `Corah`,
        search: /\bCorah\b/g,
        replace: `Korah`
    },
    {
        test: `Barbadoes`,
        search: /\bBarbadoes\b/g,
        replace: `Barbados`
    },
    {
        test: `ilful`,
        search: /\b(un)?(sk|w)ilful(ly|ness)\b/gi,
        replace: `$1$2illful$3`
    },
    {
        test: `subtil`,
        search: /\b(S|s)ubtil(ty|e?ly|e)?\b/g,
        replace: (_, s, end)=>{
            if (!end) return `${s}ubtle`;
            if (end === `ty`) return `${s}ubtlety`;
            if (end === `e`) return `${s}ubtle`;
            return `${s}ubtly`;
        }
    },
    {
        test: `fulfil`,
        search: /\b(F|f)ulfil\b/g,
        replace: `$1ulfill`
    },
    {
        test: `hardheartedness`,
        search: /\b(H|h)ardheartedness\b/g,
        replace: `$1ard-heartedness`
    },
    {
        test: `sion`,
        search: /\bSion(-?wards?)?\b/g,
        replace: (_, end)=>`Zion${end ? end.replace(/^-/, ``) : ``}`
    },
    {
        test: `\\bwo\\b`,
        search: /\b(W|w)o\b/g,
        replace: `$1oe`
    },
    {
        test: `bishoprick`,
        search: /\b(B|b)ishoprick\b/g,
        replace: `$1ishopric`
    }
]);
const $76570f5e9ca56bcb$var$rule = (line, lines, lineNumber, lintOptions)=>{
    if (lintOptions.lang !== `en`) return [];
    return $76570f5e9ca56bcb$var$runner.getLineLintResults(line, lineNumber, lines, lintOptions);
};
$76570f5e9ca56bcb$var$rule.slug = `obsolete-spellings`;
$76570f5e9ca56bcb$var$runner.rule = $76570f5e9ca56bcb$var$rule.slug;
var $76570f5e9ca56bcb$export$2e2bcd8739ae039 = $76570f5e9ca56bcb$var$rule;


const $d582a41d12e1b6f4$var$rule = (line, lines, lineNumber, { lang: lang })=>{
    if (line === `` || line.length < 5 || lang === `es`) return [];
    // prettier-ignore
    const words = [
        [
            `satan`,
            `Satan`
        ]
    ];
    const results = [];
    words.forEach(([lower, corrected])=>{
        const find = new RegExp(`\\b${lower}\\b`, `g`);
        const match = line.match(find);
        if (match && lower && corrected) results.push({
            line: lineNumber,
            column: line.indexOf(lower) + 1,
            type: `error`,
            rule: $d582a41d12e1b6f4$var$rule.slug,
            fixable: true,
            message: `"${corrected}" should be capitalized everywhere in all editions`,
            recommendation: line.replace(find, corrected)
        });
    });
    return results;
};
$d582a41d12e1b6f4$var$rule.slug = `capitalize`;
var $d582a41d12e1b6f4$export$2e2bcd8739ae039 = $d582a41d12e1b6f4$var$rule;


const $8f12e3d409c5a0e7$var$rule = (line, lines, lineNumber)=>{
    if (line === `` || line[0] !== `[` || line[line.length - 1] !== `]` || lineNumber === 1) return [];
    if (line.indexOf(`]`) !== line.length - 1) return [];
    if (lines[lineNumber - 2] === ``) return [];
    return [
        {
            line: lineNumber,
            column: false,
            type: `error`,
            rule: $8f12e3d409c5a0e7$var$rule.slug,
            message: `Class/id designations (like \`[.something]\`) must be preceded by an empty line`,
            fixable: true,
            recommendation: `--> add an empty line before line ${lineNumber}`
        }
    ];
};
$8f12e3d409c5a0e7$var$rule.slug = `unspaced-class`;
var $8f12e3d409c5a0e7$export$2e2bcd8739ae039 = $8f12e3d409c5a0e7$var$rule;


var $41bb9f34f2a81001$exports = {};
'use strict';
const $41bb9f34f2a81001$var$matchOperatorsRegex = /[|\\{}()[\]^$+*?.-]/g;
$41bb9f34f2a81001$exports = (string)=>{
    if (typeof string !== 'string') throw new TypeError('Expected a string');
    return string.replace($41bb9f34f2a81001$var$matchOperatorsRegex, '\\$&');
};


// @see https://books.google.com/ngrams for data backing up choices
const $a004eda09af84220$var$sets = [
    [
        `short`,
        `comings`,
        ``
    ],
    [
        `meeting`,
        `house`,
        ``
    ],
    [
        `down`,
        `stairs`,
        ``
    ],
    [
        `court`,
        `house`,
        ``
    ],
    [
        `after`,
        `wards`,
        ``
    ],
    [
        `yoke`,
        `mate`,
        ``
    ],
    [
        `yoke`,
        `mates`,
        ``
    ],
    [
        `yoke`,
        `fellow`,
        ``
    ],
    [
        `yoke`,
        `fellows`,
        ``
    ],
    [
        `head`,
        `quarters`,
        ``
    ],
    [
        `fire`,
        `side`,
        ``
    ],
    [
        `grave`,
        `yard`,
        ``
    ],
    [
        `every`,
        `where`,
        ``
    ],
    [
        `every`,
        `thing`,
        ``
    ],
    [
        `tender`,
        `spirited`,
        `-`
    ],
    [
        `choice`,
        `spirited`,
        `-`
    ],
    [
        `hard`,
        `hearted`,
        `-`
    ],
    [
        `hard`,
        `heartedness`,
        `-`
    ],
    [
        `honest`,
        `hearted`,
        `-`
    ],
    [
        `simple`,
        `hearted`,
        `-`
    ],
    [
        `faint`,
        `hearted`,
        ``
    ],
    [
        `upright`,
        `hearted`,
        `-`
    ],
    [
        `sincere`,
        `hearted`,
        `-`
    ],
    [
        `tender`,
        `hearted`,
        `-`
    ],
    [
        `tender`,
        `heartedness`,
        `-`
    ],
    [
        `stout`,
        `hearted`,
        `-`
    ],
    [
        `broken`,
        `hearted`,
        ``
    ],
    [
        `humble`,
        `hearted`,
        `-`
    ],
    [
        `true`,
        `hearted`,
        `-`
    ],
    [
        `heavy`,
        `hearted`,
        `-`
    ],
    [
        `dead`,
        `hearted`,
        `-`
    ],
    [
        `open`,
        `hearted`,
        `-`
    ],
    [
        `single`,
        `hearted`,
        `-`
    ],
    [
        `light`,
        `hearted`,
        ``
    ],
    [
        `fellow`,
        `laborers`,
        `-`
    ],
    [
        `fellow`,
        `labourers`,
        `-`
    ],
    [
        `fellow`,
        `laborer`,
        `-`
    ],
    [
        `fellow`,
        `labourer`,
        `-`
    ],
    [
        `fore`,
        `part`,
        ``
    ],
    [
        `for`,
        `ever`,
        ``
    ],
    [
        `for`,
        `evermore`,
        ``
    ],
    [
        `like`,
        `minded`,
        `-`
    ],
    [
        `feeble`,
        `minded`,
        `-`
    ],
    [
        `high`,
        `minded`,
        `-`
    ],
    [
        `honest`,
        `minded`,
        `-`
    ],
    [
        `humble`,
        `minded`,
        `-`
    ],
    [
        `tender`,
        `minded`,
        `-`
    ],
    [
        `well`,
        `minded`,
        `-`
    ],
    [
        `right`,
        `minded`,
        `-`
    ],
    [
        `carnal`,
        `minded`,
        `-`
    ],
    [
        `heavenly`,
        `minded`,
        `-`
    ],
    [
        `earthly`,
        `minded`,
        `-`
    ],
    [
        `lowly`,
        `minded`,
        `-`
    ],
    [
        `simple`,
        `minded`,
        `-`
    ],
    [
        `better`,
        `minded`,
        `-`
    ],
    [
        `religious`,
        `minded`,
        `-`
    ],
    [
        `upright`,
        `minded`,
        `-`
    ],
    [
        `liberal`,
        `minded`,
        `-`
    ],
    [
        `sober`,
        `minded`,
        `-`
    ],
    [
        `evil`,
        `minded`,
        `-`
    ],
    [
        `worldly`,
        `minded`,
        `-`
    ],
    [
        `noble`,
        `minded`,
        `-`
    ],
    [
        `single`,
        `minded`,
        `-`
    ],
    [
        `open`,
        `minded`,
        `-`
    ],
    [
        `loving`,
        `kindness`,
        ``
    ],
    [
        `well`,
        `behaved`,
        `-`
    ]
];
const $a004eda09af84220$var$firstParts = new RegExp(`\\b${$a004eda09af84220$var$sets.map(([first])=>(0, (/*@__PURE__*/$parcel$interopDefault($41bb9f34f2a81001$exports)))(first)).join(`|`)}\\b`, `i`);
const $a004eda09af84220$var$rule = (line, lines, lineNumber, { lang: lang })=>{
    if (lang === `es` || line === ``) return [];
    if (!line.match($a004eda09af84220$var$firstParts)) return [];
    const results = [];
    $a004eda09af84220$var$sets.forEach(([first, second, joiner])=>{
        if (!line.match(new RegExp(`\\b${first}\\b`, `i`))) return;
        const sameLine = new RegExp(`\\b(${first})( )(${second})\\b`, `i`);
        const match = line.match(sameLine);
        if (match && match.index !== undefined) {
            results.push($a004eda09af84220$var$getLint(lineNumber, match.index + 1 + first.length, first, second, joiner, line.replace(sameLine, (_, first, __, second)=>`${first}${joiner}${second.toLowerCase()}`)));
            return;
        }
        const nextLine = lines[lineNumber];
        if (!nextLine || nextLine.indexOf(second) !== 0) return;
        const nextLineStart = new RegExp(`^(${second})\\b`);
        if (!nextLine.match(nextLineStart)) return;
        const thisLineEnd = new RegExp(`\\b(${first})$`, `i`);
        const lineEndMatch = line.match(thisLineEnd);
        if (!lineEndMatch || typeof lineEndMatch.index === `undefined`) return;
        let reco;
        if (line.length < nextLine.length) reco = `${line}${joiner}${second}\n${nextLine.replace(nextLineStart, ``).trim()}`;
        else reco = `${line.replace(thisLineEnd, ``).trim()}\n${lineEndMatch[1]}${joiner}${nextLine}`;
        results.push($a004eda09af84220$var$getLint(lineNumber, lineEndMatch.index + 1, first, second, joiner, reco));
    });
    return results;
};
$a004eda09af84220$var$rule.slug = `join-words`;
var $a004eda09af84220$export$2e2bcd8739ae039 = $a004eda09af84220$var$rule;
function $a004eda09af84220$var$getLint(line, column, first, second, joiner, recommendation) {
    return {
        line: line,
        column: column,
        type: `error`,
        rule: $a004eda09af84220$var$rule.slug,
        message: `"${first} ${second}" should be combined to become "${first}${joiner}${second}"`,
        fixable: true,
        recommendation: recommendation
    };
}


const $ecd5f0c311092922$var$rule = (line, lines, lineNumber)=>{
    if (line === `` || line[0] !== `[` || line[line.length - 1] !== `]`) return [];
    const match = line.match(/^\[[^ []+(\.)\]$/);
    if (!match) return [];
    return [
        {
            line: lineNumber,
            column: line.length - 1,
            type: `error`,
            rule: $ecd5f0c311092922$var$rule.slug,
            message: `empty classname (periods must be followed by something or omitted)`,
            fixable: false,
            recommendation: line.replace(/\.\]$/, `]`)
        }
    ];
};
$ecd5f0c311092922$var$rule.slug = `empty-role`;
var $ecd5f0c311092922$export$2e2bcd8739ae039 = $ecd5f0c311092922$var$rule;


const $a098fb060e30bc80$var$rule = (line, lines, lineNumber)=>{
    if (line === `` || !line.includes(`undefined`)) return [];
    const column = line.indexOf(`undefined`) + 1;
    return [
        {
            line: lineNumber,
            column: column,
            type: `error`,
            rule: $a098fb060e30bc80$var$rule.slug,
            message: `\`undefined\` is usually a scripting error artifact and should be removed`,
            fixable: false
        }
    ];
};
$a098fb060e30bc80$var$rule.slug = `no-undefined`;
var $a098fb060e30bc80$export$2e2bcd8739ae039 = $a098fb060e30bc80$var$rule;


const $4b94e3132d0562e1$var$rule = (line, lines, lineNumber)=>{
    if (line === ``) return [];
    const nextLine = lines[lineNumber];
    if (!nextLine || nextLine[0] !== `s` || !line.match(/`'$/)) return [];
    if (!nextLine.match(/^s\b/)) return [];
    return [
        {
            line: lineNumber,
            column: line.length + 1,
            type: `error`,
            rule: $4b94e3132d0562e1$var$rule.slug,
            message: `Possessive broken over two lines (probably by conversion process)`,
            recommendation: `${line}s\n${nextLine.replace(/^s/, ``).trim()}`,
            fixable: true
        }
    ];
};
$4b94e3132d0562e1$var$rule.slug = `dangling-possessive`;
var $4b94e3132d0562e1$export$2e2bcd8739ae039 = $4b94e3132d0562e1$var$rule;



const $a3377bb039ce7127$var$rule = (line, lines, lineNumber)=>{
    if (line === `` || (0, $59a9bdb9d6df59dd$export$9b46b31ea036dccf)(line)) return [];
    const expr = /[a-z][A-Z]([a-z]|\b)/g;
    let match = null;
    const results = [];
    while(match = expr.exec(line)){
        if ($a3377bb039ce7127$var$isMc(match, line) || $a3377bb039ce7127$var$isLitV(match, line)) continue;
        results.push({
            line: lineNumber,
            column: match.index + 2,
            type: `error`,
            rule: $a3377bb039ce7127$var$rule.slug,
            message: `Unexpected mid-word uppercase letter (probably a scan error)`
        });
    }
    return results;
};
$a3377bb039ce7127$var$rule.slug = `mid-word-uppercase`;
var $a3377bb039ce7127$export$2e2bcd8739ae039 = $a3377bb039ce7127$var$rule;
function $a3377bb039ce7127$var$isMc(match, line) {
    if (match[0][0] !== `c`) return false;
    return !!line.substr(match.index - 2, 2).match(/Ma?$/);
}
function $a3377bb039ce7127$var$isLitV(match, line) {
    if (match[0] !== `tV`) return false;
    return !!line.substr(match.index - 3, 3).match(/\bLi$/);
}


const $5cf80ecccc474372$var$rule = (line, lines, lineNumber)=>{
    if (line === ``) return [];
    const expr = /\.[A-Z][^.]/g;
    let match = null;
    const results = [];
    while(match = expr.exec(line))results.push({
        line: lineNumber,
        column: match.index + 1,
        type: `error`,
        rule: $5cf80ecccc474372$var$rule.slug,
        message: `unexpected unspaced period`
    });
    return results;
};
$5cf80ecccc474372$var$rule.slug = `unspaced-period`;
var $5cf80ecccc474372$export$2e2bcd8739ae039 = $5cf80ecccc474372$var$rule;



const $c5bd8cf14e91c9c0$var$rule = (line, lines, lineNumber)=>{
    if (line === `` || line === `{footnote-paragraph-split}` || (0, $59a9bdb9d6df59dd$export$9b46b31ea036dccf)(line)) return [];
    const expr = /[a-z][0-9&£$%*(={}°\\/[\]](?!hellip;)([a-zA-Z ]|\b)/g;
    let match = null;
    const results = [];
    while(match = expr.exec(line)){
        if (match[0].endsWith(`] `) || match[0].endsWith(`* `)) continue;
        results.push({
            line: lineNumber,
            column: match.index + 2,
            type: `error`,
            rule: $c5bd8cf14e91c9c0$var$rule.slug,
            message: `Unexpected mid-word non-letter (probably a scan error)`
        });
    }
    return results;
};
$c5bd8cf14e91c9c0$var$rule.slug = `mid-word-non-letter`;
var $c5bd8cf14e91c9c0$export$2e2bcd8739ae039 = $c5bd8cf14e91c9c0$var$rule;



const $f03762e5abf291ce$var$rule = (line, lines, lineNumber)=>{
    if (line === ``) return [];
    const expr = /[a-z]\.(?<!\betc\.)(?<!\bviz\.)(?<!\b(V|v)ol\.)(?<!\bch\.)(?<!\b8vo\.)(?<!\bfol\.)(?<!\bsect\.)(?<!\bedit\.)(?<!\b\d+(d|s)\.)(?<!\bchap\.)(?<!\bp\.) [a-z]/g;
    let match = null;
    const results = [];
    while(match = expr.exec(line)){
        if ($f03762e5abf291ce$var$isIe(match, line) || $f03762e5abf291ce$var$isPmOrAm(match, line) || $f03762e5abf291ce$var$isRomanNumeral(match, line)) continue;
        results.push({
            line: lineNumber,
            column: match.index + 2,
            type: `error`,
            rule: $f03762e5abf291ce$var$rule.slug,
            message: `Unexpected period`
        });
    }
    return results;
};
$f03762e5abf291ce$var$rule.slug = `unexpected-period`;
$f03762e5abf291ce$var$rule.maybe = true;
var $f03762e5abf291ce$export$2e2bcd8739ae039 = $f03762e5abf291ce$var$rule;
function $f03762e5abf291ce$var$isRomanNumeral(match, line) {
    const lastWord = line.substring(0, match.index).split(` `).pop();
    try {
        const num = (0, $18df0c6f364c9037$exports.toArabic)(lastWord || ``);
        if (typeof num === `number`) return true;
    } catch  {
    // ¯\_(ツ)_/¯
    }
    return false;
}
function $f03762e5abf291ce$var$isIe(match, line) {
    const firstLetter = match[0][0];
    if (firstLetter === `i`) return !!match[0].match(/i\. ?e/);
    if (firstLetter !== `e`) return false;
    return !!$f03762e5abf291ce$var$previousCharacters(line, match, 9).match(/i\+?\+?\+?\.\+?\+?\+? ?/);
}
function $f03762e5abf291ce$var$isPmOrAm(match, line) {
    const firstLetter = match[0]?.[0]?.toLowerCase() || ``;
    if ([
        `a`,
        `p`
    ].includes(firstLetter)) return !!match[0].match(/(p|a)\. ?m/i);
    if (firstLetter !== `m`) return false;
    return !!$f03762e5abf291ce$var$previousCharacters(line, match, 3).match(/(a|p)\. ?/i);
}
function $f03762e5abf291ce$var$previousCharacters(line, match, number) {
    return line.substr(Math.max(match.index - number, 0), Math.min(match.index, number));
}



const $b1e38fd7251c7350$var$runner = new (0, $1a547e879b999407$export$2e2bcd8739ae039)([
    {
        test: `proffer`,
        search: /\b(P|p)roffer/g,
        replace: (_, p)=>`${p === `P` ? `O` : `o`}ffer`,
        message: `"proffer" should be replaced in modernized editions (offer, tender, propose)`,
        fixable: false
    },
    {
        test: `builded`,
        search: /\b(B|b)uilded\b/g,
        replace: `$1uilt`
    },
    {
        test: `min`,
        search: /\b(M|m)ine (a|e|i|o|u)/g,
        fixable: (match, line)=>{
            const check = line.substr(match.index || 0).toLowerCase();
            return !!check.match(/^mine (eyes?|ears?|afflictions?|enem(y|ies)|own|anointed|acquaintances?|anger|elect|iniquit(y|ies)|inheritance|adversar(y|ies)|offen(s|c)es?|altars?|accusers?|infirmit(y|ies)|exercises?|unfitness)\b/);
        },
        replace: `$1y $2`,
        allowIfNear: /((friend|step) of mine (a|e|i|o|u)|\bmine (and?|in|is|it|of|a|at|as|or|unites|on|are|ascend|also|often|inherit|unto|appeared|into|under|once|especially)\b)/i,
        message: `"mine" used as the modern "my" (e.g. "mine eyes have seen") should be updated to "my"`
    },
    {
        test: `you`,
        // NOTE: when adding here, test whether the lowercase version should be added to "MAYBE" lint below
        search: /\b(Believe|Be|(G|g)o|Seek|Get|Come|Bring|Know|Praise|(p|P)ossess|(W|w)ait|Turn|(E|e)nter|Why stand|(W|w)atch|Wash) (Y|y)ou\b/g,
        replace: `$1`,
        fixable: false,
        message: `"<verb> you" is often an automated modernization error and should be replaced with "<verb>"`,
        includeNextLineFirstWord: true,
        allowIfNear: /((go|come) you (cursed|blessed|workers)|do you know what|possess you,|wait you shall|go you cannot come|enter you(,|;|:|\.|\?))/i,
        isMaybe: false
    },
    {
        test: `you`,
        search: /\b(be|seek|get|come|know|praise) (Y|y)ou\b/g,
        replace: `$1`,
        fixable: false,
        message: `this "<verb> you" is sometimes an automated modernization error and should be replaced with "<verb>"`,
        includeNextLineFirstWord: true,
        allowIfNear: /(come you (cursed|blessed|workers)|do you know what)/i,
        isMaybe: true
    },
    {
        test: `what do you`,
        search: /\b(w)hat do you\b/gi,
        replace: `$1hat are you doing`,
        fixable: false,
        isMaybe: true,
        message: `"What do you" is sometimes an automated modernization error that should be replaced with "What are you doing" or "What have you done"`,
        includeNextLineFirstWord: true,
        allowIfNear: /what do you (say|mean|call|deny|tell|gain|know|preach|do|witness|think|need|succeed|watch|go|owe|make|lie|talk|feel|have|pray|complain|thou|want|rejoice)\b/i
    },
    {
        test: `enter you not`,
        search: /\benter you not\b/gi,
        replace: `do not enter`,
        fixable: false,
        message: `"enter you not" is often an automated modernization error and should be replaced with "do not enter"`,
        includeNextLineFirstWord: true
    },
    {
        test: `do you it`,
        search: /\b(D|d)o (Y|y)ou it\b/g,
        replace: `$1o it`,
        fixable: false,
        message: `"Do you it" is often an automated modernization error and should be replaced with "Do it"`,
        includeNextLineFirstWord: true
    },
    {
        test: `turn you`,
        search: /\bturn you\b/gi,
        replace: `turn`,
        fixable: false,
        message: `"Turn you" is often an automated modernization error and should be replaced with "turn"`,
        isMaybe: true,
        includeNextLineFirstWord: true
    },
    {
        test: `quit you`,
        search: /\bquit you\b/gi,
        replace: `acquit yourselves`,
        fixable: false,
        message: `"Quit you" is often an automated modernization error and should be replaced with "acquit yourselves"`,
        includeNextLineFirstWord: true
    },
    {
        test: `trust you in`,
        search: /\b(t)rust you in the\b/gi,
        replace: `$1rust in the`,
        fixable: false,
        message: `"Trust you in the" is often an automated modernization error and should be replaced with "Trust in the"`,
        includeNextLineFirstWord: true
    },
    {
        test: `holden`,
        search: /\b(H|h)olden\b/g,
        replace: `$1eld`,
        allowIfNear: /Cave/,
        fixable: false
    },
    {
        test: `you`,
        search: /\b(Y|y)ou wilt\b/g,
        replace: `$1ou will`,
        fixable: (_, line)=>!!line.match(/\byou wilt\b/i),
        message: `"you wilt" is an automated modernization error and should be replaced with "you will"`,
        includeNextLineFirstWord: true
    },
    {
        test: `issue`,
        search: /\b(I|i)ssue\b/g,
        fixable: false,
        isMaybe: true,
        message: `"issue" should sometimes be replaced in modernized editions (result, outcome, consequence, offspring)`
    },
    {
        test: `yesternight`,
        search: /\b(Y|y)esternight\b/g,
        replace: (_, y)=>`${y === `Y` ? `L` : `l`}ast night`,
        fixable: true
    },
    {
        test: `imprest`,
        search: /\b(I|i)mprest\b/g,
        message: `imprest should be replaced in modernized editions (imprinted, stamped, fixed in the mind, convinced)`,
        replace: `$1mprinted`,
        fixable: false
    },
    {
        test: `esp`,
        search: /\b(E|e)sp(y|ied)\b/g,
        message: `espy should be replaced in modernized editions (catch sight of, notice, spot, discover)`,
        fixable: false
    },
    {
        test: `amongst`,
        search: /\b(A|a)mongst\b/g,
        replace: `$1mong`,
        fixable: true
    },
    {
        test: `spake`,
        search: /\b(S|s)pake\b/g,
        replace: `$1poke`,
        fixable: true
    },
    {
        test: `methinks`,
        search: /\b(M|m)ethinks\b/g,
        replace: `I think`,
        fixable: true
    },
    {
        test: `methought`,
        search: /\b(M|m)ethought\b/g,
        replace: `I thought`,
        fixable: true
    },
    {
        test: `besom`,
        search: /\b(B|b)esom\b/g,
        replace: `$1room`,
        fixable: true
    },
    {
        test: `whoso`,
        search: /\b(W|w)hoso\b/g,
        replace: `$1hoever`,
        fixable: false
    },
    {
        test: `zionward`,
        search: /\bZionward(s?)\b/g,
        replace: `towards Zion`,
        isMaybe: true,
        fixable: false
    },
    {
        test: `jollity`,
        search: /\b(J|j)ollity\b/g,
        replace: (_, firstLetter)=>`${firstLetter === `J` ? `M` : `m`}erriment`,
        fixable: false,
        message: `"<found>" should be replaced in modernized editions (merriment, revelry, mirth, gaiety, merrymaking, cheerfulness, etc.)`
    },
    {
        test: `intercourse`,
        search: /\b(I|i)ntercourse\b/g,
        recommend: false,
        fixable: false,
        message: `"<found>" should be replaced in modernized editions (communication, interaction, conversation, commerce, dealings, exchange, fellowship, communion, contact, correspondence, etc.)`
    },
    {
        test: `ejaculat`,
        search: /\b(E|e)jaculat(ed?|ions?|ing)\b/g,
        recommend: false,
        fixable: false,
        message: `"<found>" should be replaced in modernized editions (exclamation, cry, utterance, etc.)`
    }
], {
    langs: [
        `en`
    ],
    editions: [
        `modernized`
    ]
});
const $b1e38fd7251c7350$var$rule = (line, lines, lineNumber, lintOptions)=>{
    if (lintOptions.lang !== `en` || lintOptions.editionType !== `modernized`) return [];
    return $b1e38fd7251c7350$var$runner.getLineLintResults(line, lineNumber, lines, lintOptions);
};
$b1e38fd7251c7350$var$rule.slug = `modernize-words`;
$b1e38fd7251c7350$var$runner.rule = $b1e38fd7251c7350$var$rule.slug;
var $b1e38fd7251c7350$export$2e2bcd8739ae039 = $b1e38fd7251c7350$var$rule;



const $ec0591c1bad7c2a7$var$runner = new (0, $1a547e879b999407$export$2e2bcd8739ae039)([
    {
        test: `rappahannoc`,
        search: /\bRappahannoc\b/g,
        replace: `Rappahannock`,
        fixable: true,
        message: `The river Rappahannock must always be spelled "Rappahannock"`
    },
    {
        test: `sedberg`,
        search: /\bSedberg\b/g,
        replace: `Sedbergh`,
        fixable: true,
        message: `The city of Sedbergh must always be spelled "Sedbergh"`
    },
    {
        test: `mount`,
        search: /\bmount(-| )?mell?ick?\b/gi,
        replace: `Mountmellick`,
        fixable: (_, line)=>!!line.match(/\bmount(-| )?mell?ick?\b/i),
        message: `Mountmellick must always be spelled "Mountmellick"`,
        allowIfNear: /Mountmellick/,
        includeNextLineFirstWord: true
    },
    {
        test: `mary`,
        search: /\bMary Ridgeway\b/g,
        replace: `Mary Ridgway`,
        fixable: (_, line)=>line.includes(`Mary Ridgeway`),
        message: `Mary Ridgway must always be spelled without an E`,
        includeNextLineFirstWord: true
    },
    {
        test: `catharine`,
        search: /\bCatharine Payton\b/g,
        replace: `Catherine Payton`,
        fixable: (_, line)=>line.includes(`Catharine Payton`),
        message: `Catherine Payton must always be spelled with an E: Cath**E**rine`,
        includeNextLineFirstWord: true
    },
    {
        test: `naylor`,
        search: /\bNaylor\b/g,
        replace: `Nayler`,
        fixable: true,
        message: `James Nayler's last name must always be spelled "Nayler"`
    },
    {
        test: `pennington`,
        search: /\bPennington\b/g,
        replace: `Penington`,
        fixable: true,
        message: `Isaac Penington's last name must always be spelled "Penington"`,
        allowIfNear: /\bSr\.|\bAlderman\b|\bFather\b|\bDaniel\b|\b(p|P)adre\b/
    }
], {
    langs: [
        `en`,
        `es`
    ]
});
const $ec0591c1bad7c2a7$var$rule = (line, lines, lineNumber, lintOptions)=>{
    return $ec0591c1bad7c2a7$var$runner.getLineLintResults(line, lineNumber, lines, lintOptions);
};
$ec0591c1bad7c2a7$var$rule.slug = `consistent-name-spelling`;
$ec0591c1bad7c2a7$var$runner.rule = $ec0591c1bad7c2a7$var$rule.slug;
var $ec0591c1bad7c2a7$export$2e2bcd8739ae039 = $ec0591c1bad7c2a7$var$rule;


const $60473d299dc0fe2d$var$rule = (line, lines, lineNumber)=>{
    if (line === `` || !line.includes(`_`)) return [];
    const match = line.match(/[^_]_(\^|footnote:\[)/);
    if (!match) return [];
    return [
        {
            line: lineNumber,
            column: (match.index || 0) + 2,
            type: `error`,
            fixable: false,
            rule: $60473d299dc0fe2d$var$rule.slug,
            recommendation: line.replace(/_/g, `__`),
            message: `Italics touching footnote markers must use double underscores`
        }
    ];
};
$60473d299dc0fe2d$var$rule.slug = `italics-touching-footnote`;
var $60473d299dc0fe2d$export$2e2bcd8739ae039 = $60473d299dc0fe2d$var$rule;



const $a26a59f502c888fc$var$rule = (line, lines, lineNumber)=>{
    if (line === `` || !line.includes(`_`) || (0, $59a9bdb9d6df59dd$export$9b46b31ea036dccf)(line)) return [];
    const match = line.match(/[^_ \n+#([`]_[a-zA-Z]/);
    if (!match) return [];
    const column = (match.index || 0) + 2;
    const restOfLine = line.substring(column);
    // don't flag italicizing within a word like `sun_light_`
    if (restOfLine.match(/[a-z0-9:]+_/)) return [];
    // don't flag xrefs
    if (restOfLine.match(/^src,/) && line.includes(`__xref_src`)) return [];
    return [
        {
            line: lineNumber,
            column: column,
            type: `error`,
            rule: $a26a59f502c888fc$var$rule.slug,
            message: `Unexpected underscore`
        }
    ];
};
$a26a59f502c888fc$var$rule.slug = `unexpected-underscore`;
var $a26a59f502c888fc$export$2e2bcd8739ae039 = $a26a59f502c888fc$var$rule;


const $2c382442436d4807$var$rule = (line, lines, lineNumber)=>{
    if (line === `` || !line.includes(`--`)) return [];
    const nextLine = lines[lineNumber] || ``;
    const combined = `${line}${nextLine ? `\n${nextLine}` : ``}`;
    const match = combined.match(/--(\n)?_[^_]/);
    if (!match) return [];
    const isMultiLine = typeof match[1] !== `undefined`;
    return [
        {
            line: lineNumber + (isMultiLine ? 1 : 0),
            column: isMultiLine ? 1 : (match.index || 0) + 3,
            type: `error`,
            rule: $2c382442436d4807$var$rule.slug,
            recommendation: (isMultiLine ? nextLine : line).replace(/_/g, `__`),
            message: `Must use double-underscore italics when preceded by double-dash (emdash)`
        }
    ];
};
$2c382442436d4807$var$rule.slug = `emdash-touching-italics`;
var $2c382442436d4807$export$2e2bcd8739ae039 = $2c382442436d4807$var$rule;


const $110b9f1101c858dc$var$rule = (line, lines, lineNumber)=>{
    if (line === `` || !line.includes(`++++++`)) return [];
    const regex = /\+{3}\[\+{6}\[\+{3}(\w|\.)+\]\]/;
    const match = line.match(regex);
    if (!match) return [];
    return [
        {
            line: lineNumber,
            column: match.index ? match.index + 1 : 0,
            type: `error`,
            rule: $110b9f1101c858dc$var$rule.slug,
            message: `Libre Office ref artifacts must be removed`,
            fixable: true,
            recommendation: line.replace(regex, ``)
        }
    ];
};
$110b9f1101c858dc$var$rule.slug = `libre-office-artifacts`;
var $110b9f1101c858dc$export$2e2bcd8739ae039 = $110b9f1101c858dc$var$rule;


const $4cae0e279ef025d5$var$rule = (line, lines, lineNumber)=>{
    if (line === ``) return [];
    if (line.includes(`{footnote-paragraph-split}`) && lines[lineNumber] === ``) return [
        {
            line: lineNumber + 1,
            column: 1,
            type: `error`,
            rule: $4cae0e279ef025d5$var$rule.slug,
            message: `footnote paragraph splits must not be followed by empty lines`,
            fixable: true,
            recommendation: `<-- remove line ${lineNumber + 1}`
        }
    ];
    return [];
};
$4cae0e279ef025d5$var$rule.slug = `footnote-split-spacing`;
var $4cae0e279ef025d5$export$2e2bcd8739ae039 = $4cae0e279ef025d5$var$rule;



const $10ace03c47299cff$var$rule = (line, lines, lineNumber)=>{
    if (line === `` || !(0, $59a9bdb9d6df59dd$export$9b46b31ea036dccf)(line)) return [];
    const identifiers = line.replace(/^\[(.+)\]$/, `$1`).replace(/cols="([0-9,])+"/, ``).replace(/,.*/, ``).replace(/^#[\w\d-_]+/, ``).trim();
    if (!identifiers) return [];
    if ($10ace03c47299cff$var$KEYWORDS.includes(identifiers)) return [];
    if (identifiers.startsWith(`short="`)) return [];
    if (identifiers.startsWith(`quote.`)) {
        const rest = identifiers.replace(/^quote\./, ``);
        if (![
            `scripture`,
            `epigraph`,
            `section-epigraph`
        ].includes(rest)) return [
            $10ace03c47299cff$var$violation(lineNumber, identifiers, [
                `quote.scripture`,
                `quote.epigraph`,
                `quote.section-epigraph`
            ])
        ];
        return [];
    }
    if ($10ace03c47299cff$var$CLASSES.includes(identifiers)) return [
        $10ace03c47299cff$var$violation(lineNumber, identifiers, [
            `.${identifiers}`
        ])
    ];
    if ($10ace03c47299cff$var$CLASSES.includes(identifiers.replace(/^\./, ``))) return [];
    if (identifiers.split(`.`).length > 2) {
        const expr = /\.([^.#]+)/g;
        let match = null;
        while((match = expr.exec(identifiers)) && match[1]){
            if (!$10ace03c47299cff$var$CLASSES.includes(match[1])) return [
                $10ace03c47299cff$var$violation(lineNumber, match[1], [])
            ];
        }
        return [];
    }
    return [
        $10ace03c47299cff$var$violation(lineNumber, identifiers, [])
    ];
};
$10ace03c47299cff$var$rule.slug = `unexpected-identifier`;
var $10ace03c47299cff$export$2e2bcd8739ae039 = $10ace03c47299cff$var$rule;
const $10ace03c47299cff$var$KEYWORDS = [
    `verse`,
    `quote`,
    `discrete`
];
const $10ace03c47299cff$var$CLASSES = [
    `no-indent`,
    `emphasized`,
    `centered`,
    `alt`,
    `blurb`,
    `asterism`,
    `small-break`,
    `old-style`,
    `letter-heading`,
    `offset`,
    `salutation`,
    `division`,
    `discourse-part`,
    `signed-section-signature`,
    `signed-section-context-open`,
    `signed-section-closing`,
    `signed-section-context-close`,
    `numbered`,
    `bold`,
    `weight-normal`,
    `small-caps`,
    `intermediate-title`,
    `style-blurb`,
    `numbered-group`,
    `chapter-synopsis`,
    `embedded-content-document`,
    `embedded-content-document.letter`,
    `embedded-content-document.epistle`,
    `embedded-content-document.address`,
    `embedded-content-document.testimony`,
    `embedded-content-document.paper`,
    `embedded-content-document.prayer`,
    `embedded-content-document.legal`,
    `embedded-content-document.treatise`,
    `embedded-content-document.minute`,
    `chapter-subtitle--blurb`,
    `postscript`,
    `syllogism`,
    `table-valign-middle`,
    `table-vertical-lines`,
    `table-align-center`,
    `table-header-tail-x-small`,
    `table-last-col-secondary`,
    `table-tail-align-right`,
    `table-tail-align-center`,
    `section-author`,
    `section-author-context`,
    `section-date`,
    `heading-continuation-blurb`,
    `section-summary-preface`,
    `inline`,
    `the-end`
];
function $10ace03c47299cff$var$violation(lineNumber, identifier, possibly) {
    let message = `"${identifier}" is not a known identifier`;
    if (possibly.length) message += `, did you mean "${possibly.join(`", "`)}"?`;
    return {
        line: lineNumber,
        column: 2,
        type: `error`,
        rule: $10ace03c47299cff$var$rule.slug,
        message: message
    };
}


const $5cb83f8e7a6c8a6f$var$rule = (line, lines, lineNumber)=>{
    if (line === `'''` && lines[lineNumber] !== ``) return [
        {
            line: lineNumber,
            column: false,
            type: `error`,
            rule: $5cb83f8e7a6c8a6f$var$rule.slug,
            message: `This type of markup must be followed by an empty line`,
            fixable: true,
            recommendation: `--> add an empty line after line ${lineNumber}`
        }
    ];
    return [];
};
$5cb83f8e7a6c8a6f$var$rule.slug = `unspaced-markup`;
var $5cb83f8e7a6c8a6f$export$2e2bcd8739ae039 = $5cb83f8e7a6c8a6f$var$rule;




const $a15e5f89bdbd9718$var$runner = new (0, $1a547e879b999407$export$2e2bcd8739ae039)([
    {
        test: `[!?,:;.]`,
        search: / (!|\?|,|;|:|\.)/g,
        replace: `$1`
    }
], {
    fixable: true,
    message: `unexpected space before punctuation should be removed`
});
const $a15e5f89bdbd9718$var$rule = (line, lines, lineNumber, lintOptions)=>{
    if ((0, $59a9bdb9d6df59dd$export$9b46b31ea036dccf)(line)) return [];
    return $a15e5f89bdbd9718$var$runner.getLineLintResults(line, lineNumber, lines, lintOptions);
};
$a15e5f89bdbd9718$var$rule.slug = `spaced-punctuation`;
$a15e5f89bdbd9718$var$runner.rule = $a15e5f89bdbd9718$var$rule.slug;
var $a15e5f89bdbd9718$export$2e2bcd8739ae039 = $a15e5f89bdbd9718$var$rule;


const $7c9a1b0666e63b1c$var$rule = (line, lines, lineNumber)=>{
    if (line === ``) return [];
    if (!line.match(/^Postscript.?$/i)) return [];
    return [
        {
            line: lineNumber,
            column: false,
            type: `error`,
            rule: $7c9a1b0666e63b1c$var$rule.slug,
            message: `Postscript "headers" are not allowed`,
            recommendation: `Add \`Postscript.--\` to start of postscript body`,
            fixable: false
        }
    ];
};
$7c9a1b0666e63b1c$var$rule.slug = `postscript-header`;
var $7c9a1b0666e63b1c$export$2e2bcd8739ae039 = $7c9a1b0666e63b1c$var$rule;



const $a30f92c824fc8106$var$rule = (line, lines, lineNumber)=>{
    if (line === `` || !(0, $59a9bdb9d6df59dd$export$9b46b31ea036dccf)(line)) return [];
    if (line.includes(`.postscript`) && lines[lineNumber] !== `====`) return [
        {
            line: lineNumber,
            column: false,
            type: `error`,
            rule: $a30f92c824fc8106$var$rule.slug,
            message: `Postscripts must be wrapped in blocks with \`====\` delimiters`
        }
    ];
    return [];
};
$a30f92c824fc8106$var$rule.slug = `unwrapped-postscript`;
var $a30f92c824fc8106$export$2e2bcd8739ae039 = $a30f92c824fc8106$var$rule;


const $ae00595da75427cd$var$rule = (line, lines, lineNumber)=>{
    if (line === `` || !line.includes(`[.book-title]`)) return [];
    const lints = [];
    const regex = /\[\.book-title\]( +#|# +|#$)/g;
    let match = null;
    while(match = regex.exec(line))lints.push({
        line: lineNumber,
        column: (match.index || 0) + 15,
        type: `error`,
        rule: $ae00595da75427cd$var$rule.slug,
        message: `Improper spacing around [.book-title]`,
        fixable: match[1] !== `#`,
        recommendation: match[1] !== `#` ? line.replace(match[0], `[.book-title]#`) : undefined
    });
    return lints;
};
$ae00595da75427cd$var$rule.slug = `book-title-spacing`;
var $ae00595da75427cd$export$2e2bcd8739ae039 = $ae00595da75427cd$var$rule;


const $34ae04d011468e32$var$rule = (line, lines, lineNumber)=>{
    if (line === `` || !line.includes(`[.book-title]`)) return [];
    const lints = [];
    const regex = /[^^ ([-]\[\.book-title]/g;
    let match = null;
    while(match = regex.exec(line))lints.push({
        line: lineNumber,
        column: (match.index || 0) + 1,
        type: `error`,
        rule: $34ae04d011468e32$var$rule.slug,
        message: `Only -, (, and [ chars are allowed to touch the beginning of a [.book-title]`
    });
    return lints;
};
$34ae04d011468e32$var$rule.slug = `book-title-start`;
var $34ae04d011468e32$export$2e2bcd8739ae039 = $34ae04d011468e32$var$rule;


const $b0c97373f9a9b816$var$rule = (line, lines, lineNumber)=>{
    if (line === `` || !line.includes(`[.book-title]`)) return [];
    const lints = [];
    const regex = /\[\.book-title\]#/g;
    let match = null;
    while(match = regex.exec(line)){
        const restOfLine = line.substring(match.index + 14);
        if (restOfLine.match(/^[^[]+#/)) continue;
        const restOfParagraph = lines.slice(lineNumber - 1).join(`\u{2022}`).substring(match.index + 14).replace(/••.+/, ``).replace(/•/g, ` `);
        let endMatch = null;
        const endRegex = /(?:\[.book-title\]|#)/g;
        let foundStart = false;
        let foundEnd = false;
        while(endMatch = endRegex.exec(restOfParagraph))if (!foundStart && endMatch[0] === `#`) foundEnd = true;
        else foundStart = true;
        if (!foundEnd) lints.push({
            line: lineNumber,
            column: match.index + 14,
            type: `error`,
            rule: $b0c97373f9a9b816$var$rule.slug,
            message: `This book title was never closed properly with a "#"`
        });
    }
    return lints;
};
$b0c97373f9a9b816$var$rule.slug = `book-title-unclosed`;
var $b0c97373f9a9b816$export$2e2bcd8739ae039 = $b0c97373f9a9b816$var$rule;


const $03b5ce36bb3970cc$var$rule = (line, lines, lineNumber, lintOptions)=>{
    if (line === `` || lintOptions.maybe !== true || lintOptions.editionType !== `modernized` || lintOptions.lang !== `en` || !line.match(/\byou\b/i)) return [];
    let compositeLine = line;
    if (lines[lineNumber] && lines[lineNumber] !== ``) compositeLine += ` ${lines[lineNumber]?.split(` `).shift() || ``}`;
    const lints = [];
    const regex = /\byou\b ([a-z]+s)\b/g;
    let match = null;
    while((match = regex.exec(compositeLine)) && match[1])if (!$03b5ce36bb3970cc$var$WHITELIST[match[1].toLowerCase()]) {
        let column = (match.index || 0) + 4 + match[1].length;
        if (column > line.length) column = (match.index || 0) + 1;
        lints.push({
            line: lineNumber,
            column: column,
            type: `error`,
            rule: $03b5ce36bb3970cc$var$rule.slug,
            message: `verb/person mismatch from modernization should be fixed`,
            recommendation: line.replace(match[0], match[0].replace(/s$/, ``))
        });
    }
    return lints;
};
$03b5ce36bb3970cc$var$rule.slug = `person-mismatch`;
var $03b5ce36bb3970cc$export$2e2bcd8739ae039 = $03b5ce36bb3970cc$var$rule;
const $03b5ce36bb3970cc$var$WHITELIST = {
    express: 1,
    as: 1,
    has: 1,
    miss: 1,
    overseers: 1,
    travailers: 1,
    helpers: 1,
    descendents: 1,
    induces: 1,
    across: 1,
    springs: 1,
    arises: 1,
    press: 1,
    profess: 1,
    confess: 1,
    scandalous: 1,
    rebellious: 1,
    gracious: 1,
    covetous: 1,
    wages: 1,
    yours: 1,
    thanks: 1,
    afterwards: 1,
    fees: 1,
    suspicious: 1,
    kiss: 1,
    numerous: 1,
    his: 1,
    is: 1,
    its: 1,
    does: 1,
    yourselves: 1,
    this: 1,
    pass: 1,
    thus: 1,
    vineyards: 1,
    proofs: 1,
    heavens: 1,
    harmless: 1,
    blameless: 1,
    faultless: 1,
    comfortless: 1,
    sensations: 1,
    doubtless: 1,
    workers: 1,
    always: 1,
    riches: 1,
    previous: 1,
    righteous: 1,
    careless: 1,
    cedars: 1,
    mountains: 1,
    access: 1,
    happiness: 1,
    monks: 1,
    was: 1,
    towards: 1,
    onwards: 1,
    spirits: 1,
    us: 1,
    things: 1,
    vessels: 1,
    treacherous: 1,
    magistrates: 1,
    bishops: 1,
    beginners: 1,
    deceivers: 1,
    physicians: 1,
    scribes: 1,
    kings: 1,
    witnesses: 1,
    companions: 1,
    builders: 1,
    pleaders: 1,
    sharers: 1,
    ministers: 1,
    adulterers: 1,
    fighters: 1,
    handmaids: 1,
    chiefs: 1,
    fools: 1,
    partakers: 1,
    prisoners: 1,
    oppressors: 1,
    oppress: 1,
    judges: 1,
    burghers: 1,
    hypocrites: 1,
    lambs: 1,
    rulers: 1,
    princes: 1,
    teachers: 1,
    convictions: 1,
    priests: 1,
    saints: 1,
    hirelings: 1,
    witness: 1,
    followers: 1,
    lawyers: 1,
    professors: 1,
    zealous: 1,
    sons: 1,
    offences: 1,
    stoners: 1,
    inhabitants: 1,
    bless: 1,
    pilgrims: 1,
    parents: 1,
    pastors: 1,
    daughters: 1,
    valiants: 1,
    nobles: 1,
    perhaps: 1,
    fanatics: 1,
    jurors: 1,
    hints: 1,
    mourners: 1,
    affects: 1,
    transgress: 1,
    travellers: 1,
    strangers: 1,
    guiltless: 1,
    oaks: 1,
    deceits: 1,
    families: 1,
    kindness: 1,
    prodigals: 1,
    unless: 1,
    glorious: 1,
    friends: 1,
    elders: 1,
    posessors: 1,
    stones: 1,
    darkness: 1,
    stars: 1,
    fishes: 1,
    gates: 1,
    eyes: 1,
    fathers: 1,
    mothers: 1,
    widows: 1,
    hearts: 1,
    priors: 1,
    cardinals: 1,
    sometimes: 1,
    drunkenness: 1,
    servants: 1,
    tenders: 1,
    comforts: 1,
    less: 1,
    envious: 1,
    victorious: 1,
    conscious: 1,
    anxious: 1,
    railers: 1,
    years: 1,
    news: 1,
    unawares: 1,
    loss: 1,
    assurances: 1
};



const $506f7b8b3047cda4$var$runner = new (0, $1a547e879b999407$export$2e2bcd8739ae039)([
    {
        test: `etc`,
        search: /\betc,(:|;)?/g,
        replace: (_, end)=>end === undefined ? `etc.,` : `etc.${end}`,
        fixable: true,
        message: `The abbreviation "etc." must always have an ending period`
    },
    {
        test: `etc`,
        search: /\betc([^.,]|$)/g,
        replace: `etc.$1`,
        fixable: true,
        message: `The abbreviation "etc." must always have an ending period`
    }
]);
const $506f7b8b3047cda4$var$rule = (line, lines, lineNumber, lintOptions)=>{
    if (lintOptions.lang !== `en`) return [];
    return $506f7b8b3047cda4$var$runner.getLineLintResults(line, lineNumber, lines, lintOptions);
};
$506f7b8b3047cda4$var$rule.slug = `etc-period`;
$506f7b8b3047cda4$var$runner.rule = $506f7b8b3047cda4$var$rule.slug;
var $506f7b8b3047cda4$export$2e2bcd8739ae039 = $506f7b8b3047cda4$var$rule;


const $38759ac37448c45c$var$rule = (line, lines, lineNumber, lintOptions)=>{
    if (lintOptions.lang === `es` || line === `` || line[0] !== `=`) return [];
    if (line.length < 3 || line.substring(0, 3) !== `== `) return [];
    const prevLine = lines[lineNumber - 2];
    if (prevLine && prevLine.includes(`short="`)) return [];
    const tocTitle = line.replace(/^== /, ``).replace(/ \/.*/, ``).replace(/^(Chapter|Section|Capítulo|Sección) (\d+|[IVXL]+)\.?/, ``);
    if (tocTitle.length <= 50) return [];
    return [
        {
            line: lineNumber,
            column: 4,
            type: `error`,
            rule: $38759ac37448c45c$var$rule.slug,
            message: `long chapter titles need a hand-crafted short title for table of contents and running headers`
        }
    ];
};
$38759ac37448c45c$var$rule.slug = `title-length`;
var $38759ac37448c45c$export$2e2bcd8739ae039 = $38759ac37448c45c$var$rule;


const $29007b72f36308f4$var$rule = (line, lines, lineNumber)=>{
    if (line === `` || !line.includes(`*`)) return [];
    if (line.startsWith(`|`) || line.match(/^\* .+/) || line.includes(`+++*`) || line.match(/( |^)\*\*\w.*(\w|,|\.)\*\*( |-|$)/)) return [];
    return [
        {
            line: lineNumber,
            column: line.indexOf(`*`) + 1,
            type: `error`,
            rule: $29007b72f36308f4$var$rule.slug,
            message: `unexpected asterisk`,
            fixable: false,
            recommendation: line.replace(/\*/g, ``)
        }
    ];
};
$29007b72f36308f4$var$rule.slug = `unexpected-asterisk`;
var $29007b72f36308f4$export$2e2bcd8739ae039 = $29007b72f36308f4$var$rule;



const $6f03f58a3633b769$var$runner = new (0, $1a547e879b999407$export$2e2bcd8739ae039)([
    {
        test: `,`,
        search: /\b([A-Z]), ?([A-Z])\./g,
        replace: `$1. $2.`,
        fixable: true,
        allowIfNear: /I, A\. ?B\./,
        message: `unexpected comma in initials must be removed`
    },
    {
        test: `,`,
        search: /\b([A-Z])\. ?([A-Z]),/g,
        replace: `$1. $2.,`,
        fixable: true,
        allowIfNear: /I, A\. ?B\./,
        message: `unexpected comma in initials must be removed`
    }
]);
const $6f03f58a3633b769$var$rule = (line, lines, lineNumber, lintOptions)=>{
    if (lintOptions.lang !== `en`) return [];
    return $6f03f58a3633b769$var$runner.getLineLintResults(line, lineNumber, lines, lintOptions);
};
$6f03f58a3633b769$var$rule.slug = `initials-comma`;
$6f03f58a3633b769$var$runner.rule = $6f03f58a3633b769$var$rule.slug;
var $6f03f58a3633b769$export$2e2bcd8739ae039 = $6f03f58a3633b769$var$rule;



const $1ed6579f500288ee$var$runner = new (0, $1a547e879b999407$export$2e2bcd8739ae039)([
    {
        test: `(a|p). ?m.`,
        search: /\b(one|two|three|four|five|six|seven|eight|nine|ten|eleven|twelve|clock|\d),? (a|p)\. ?m\.\.?/i,
        replace: (_, prefix, aOrP)=>`${prefix} ${aOrP.toLowerCase()}.m.`,
        fixable: true,
        message: `AM/PM must be formatted consistently as "a.m." and "p.m", without leading comma`,
        discardIfIdenticalRecommendation: true
    }
]);
const $1ed6579f500288ee$var$rule = (line, lines, lineNumber, lintOptions)=>{
    if (lintOptions.lang !== `en`) return [];
    return $1ed6579f500288ee$var$runner.getLineLintResults(line, lineNumber, lines, lintOptions);
};
$1ed6579f500288ee$var$rule.slug = `am-pm`;
$1ed6579f500288ee$var$runner.rule = $1ed6579f500288ee$var$rule.slug;
var $1ed6579f500288ee$export$2e2bcd8739ae039 = $1ed6579f500288ee$var$rule;




var $dd6f2bfa486e7b4d$exports = {};

$parcel$export($dd6f2bfa486e7b4d$exports, "unterminatedOpenBlock", () => $f756723b7776ad9c$export$2e2bcd8739ae039);
$parcel$export($dd6f2bfa486e7b4d$exports, "chapterHeading", () => $16f0428ca3a7318c$export$2e2bcd8739ae039);
$parcel$export($dd6f2bfa486e7b4d$exports, "numberedGroup", () => $0567e509cd2d1620$export$2e2bcd8739ae039);
$parcel$export($dd6f2bfa486e7b4d$exports, "wrappingBlock", () => $bba88d347aa2a57a$export$2e2bcd8739ae039);
$parcel$export($dd6f2bfa486e7b4d$exports, "headingSequence", () => $638006a7f74f4b70$export$2e2bcd8739ae039);
const $f756723b7776ad9c$var$rule = (block)=>{
    const lines = block.split(`\n`);
    const delimiters = lines.reduce((delims, line, index)=>{
        if (line !== `--`) return delims;
        const isStart = lines[index - 1]?.indexOf(`[.`) === 0;
        delims.push({
            line: index + 1,
            type: isStart ? `start` : `end`,
            flagged: false
        });
        return delims;
    }, []);
    let opened = false;
    const lints = delimiters.reduce((acc, current, index)=>{
        const prev = delimiters[index - 1];
        if (current.type === `start`) {
            if (opened && prev) {
                current.flagged = true;
                acc.push($f756723b7776ad9c$var$unterminated(prev.line));
            } else if (lines[current.line] && lines[current.line] !== ``) acc.push($f756723b7776ad9c$var$missingSurroundingSpace(current.line + 1));
        }
        if (current.type === `end`) {
            if (!opened && (!prev || !prev.flagged)) {
                current.flagged = true;
                acc.push($f756723b7776ad9c$var$unlabeled(current.line));
            } else if (lines[current.line - 2] !== ``) acc.push($f756723b7776ad9c$var$missingSurroundingSpace(current.line));
            else if (lines[current.line] && lines[current.line] !== ``) acc.push($f756723b7776ad9c$var$missingSurroundingSpace(current.line + 1));
        }
        opened = current.type === `start`;
        return acc;
    }, []);
    if (opened && delimiters.length > 0) // @ts-ignore https://github.com/Microsoft/TypeScript/issues/30406
    lints.push($f756723b7776ad9c$var$unterminated(delimiters.pop().line));
    return lints;
};
function $f756723b7776ad9c$var$unterminated(line) {
    return {
        line: line,
        column: false,
        type: `error`,
        rule: $f756723b7776ad9c$var$rule.slug,
        message: `This block was never terminated with a \`--\` line.`
    };
}
function $f756723b7776ad9c$var$unlabeled(line) {
    return {
        line: line,
        column: false,
        type: `error`,
        rule: $f756723b7776ad9c$var$rule.slug,
        message: `Open blocks must be started with a class designation, like \`[.embedded-content-document.letter]\``
    };
}
function $f756723b7776ad9c$var$missingSurroundingSpace(line) {
    return {
        line: line,
        column: false,
        type: `error`,
        fixable: true,
        rule: $f756723b7776ad9c$var$rule.slug,
        message: `Open block delimiters should be surrounded by empty lines`,
        recommendation: `--> add an empty line before line ${line}`
    };
}
$f756723b7776ad9c$var$rule.slug = `open-block`;
var $f756723b7776ad9c$export$2e2bcd8739ae039 = $f756723b7776ad9c$var$rule;


const $16f0428ca3a7318c$var$rule = (block)=>{
    const lines = block.split(`\n`);
    const chapterHeadings = lines.reduce((acc, line, index)=>{
        if (line && line.substring(0, 3) === `== ` && line.match(/^== +[^\s\n]/)) acc.push(index + 1);
        return acc;
    }, []);
    if (chapterHeadings.length === 1) return [];
    if (chapterHeadings.length === 0) return [
        {
            line: 1,
            column: false,
            type: `error`,
            rule: $16f0428ca3a7318c$var$rule.slug,
            message: `Every file must have exactly one chapter level heading \`== \``,
            fixable: false
        }
    ];
    return chapterHeadings.slice(1).map((line)=>({
            line: line,
            column: false,
            type: `error`,
            rule: $16f0428ca3a7318c$var$rule.slug,
            message: `Duplicate chapter heading \`== \` -- see line ${chapterHeadings[0]}`,
            fixable: false
        }));
};
$16f0428ca3a7318c$var$rule.slug = `chapter-heading`;
var $16f0428ca3a7318c$export$2e2bcd8739ae039 = $16f0428ca3a7318c$var$rule;


const $0567e509cd2d1620$var$rule = (block)=>{
    const lints = [];
    let withinNumberedGroup = false;
    let lastFlagged = 0;
    const lines = block.split(`\n`);
    lines.forEach((line, index)=>{
        const isGroupStart = line === `====` && lines[index - 1] === `[.numbered-group]`;
        if (isGroupStart && withinNumberedGroup) lastFlagged = 0;
        else if (isGroupStart) {
            lastFlagged = 0;
            withinNumberedGroup = true;
        } else if (line === `====` && withinNumberedGroup) withinNumberedGroup = false;
        else if (line === `[.numbered]` && !withinNumberedGroup && (!lastFlagged || lastFlagged && index - lastFlagged > 150)) {
            lastFlagged = index;
            lints.push($0567e509cd2d1620$var$outOfGroup(index + 1));
        }
    });
    return lints;
};
$0567e509cd2d1620$var$rule.slug = `numbered-group`;
var $0567e509cd2d1620$export$2e2bcd8739ae039 = $0567e509cd2d1620$var$rule;
function $0567e509cd2d1620$var$outOfGroup(lineNumber) {
    return {
        type: `error`,
        line: lineNumber,
        column: false,
        rule: $0567e509cd2d1620$var$rule.slug,
        message: `Numbered chunks must be within a [.numbered-group] block`
    };
}


const $bba88d347aa2a57a$var$rule = (block)=>{
    const lines = block.split(`\n`);
    const delimiters = lines.reduce((delims, line, index)=>{
        if (line !== `====`) return delims;
        const isStart = lines[index - 1]?.indexOf(`[.`) === 0;
        delims.push({
            line: index + 1,
            type: isStart ? `start` : `end`,
            flagged: false
        });
        return delims;
    }, []);
    let opened = false;
    const lints = delimiters.reduce((acc, current, index)=>{
        const prev = delimiters[index - 1];
        if (current.type === `start`) {
            if (opened && prev) {
                current.flagged = true;
                acc.push($bba88d347aa2a57a$var$unterminated(prev.line));
            } else if (lines[current.line] && lines[current.line] !== ``) acc.push($bba88d347aa2a57a$var$missingSurroundingSpace(current.line + 1));
        }
        if (current.type === `end`) {
            if (!opened && (!prev || !prev.flagged)) {
                current.flagged = true;
                acc.push($bba88d347aa2a57a$var$unlabeled(current.line));
            }
            if (lines[current.line - 2] !== ``) acc.push($bba88d347aa2a57a$var$missingSurroundingSpace(current.line));
            if (lines[current.line] && lines[current.line] !== ``) acc.push($bba88d347aa2a57a$var$missingSurroundingSpace(current.line + 1));
        }
        opened = current.type === `start`;
        return acc;
    }, []);
    if (opened && delimiters.length > 0) // @ts-ignore https://github.com/Microsoft/TypeScript/issues/30406
    lints.push($bba88d347aa2a57a$var$unterminated(delimiters.pop().line));
    return lints;
};
function $bba88d347aa2a57a$var$unterminated(line) {
    return {
        line: line,
        column: false,
        type: `error`,
        rule: $bba88d347aa2a57a$var$rule.slug,
        message: `This block was never terminated with a \`====\` line.`
    };
}
function $bba88d347aa2a57a$var$unlabeled(line) {
    return {
        line: line,
        column: false,
        type: `error`,
        rule: $bba88d347aa2a57a$var$rule.slug,
        message: `Wrapping blocks must be started with a class designation, like \`[.numbered-group]\``
    };
}
function $bba88d347aa2a57a$var$missingSurroundingSpace(line) {
    return {
        line: line,
        column: false,
        type: `error`,
        fixable: true,
        rule: $bba88d347aa2a57a$var$rule.slug,
        message: `Wrapping block delimiters must be surrounded by empty lines`,
        recommendation: `--> add an empty line before line ${line}`
    };
}
$bba88d347aa2a57a$var$rule.slug = `wrapping-block`;
var $bba88d347aa2a57a$export$2e2bcd8739ae039 = $bba88d347aa2a57a$var$rule;


const $638006a7f74f4b70$var$rule = (block)=>{
    const lines = block.split(`\n`);
    const lints = [];
    let level = 1;
    lines.forEach((line, idx)=>{
        if (line === `` || line[0] !== `=`) return;
        const match = line.match(/^(={2,4}) /);
        if (!match || !match[1]) return;
        const newLevel = match[1].length;
        if (Math.abs(newLevel - level) > 1) lints.push({
            line: idx + 1,
            column: false,
            type: `error`,
            rule: $638006a7f74f4b70$var$rule.slug,
            message: `No skipping heading levels (i.e., from == to ====)`
        });
        else level = newLevel;
    });
    return lints;
};
$638006a7f74f4b70$var$rule.slug = `heading-sequence`;
var $638006a7f74f4b70$export$2e2bcd8739ae039 = $638006a7f74f4b70$var$rule;




function $98cb5ebf8f0b866b$export$2e2bcd8739ae039(adoc, options = {
    lang: `en`
}) {
    const lineRules = Object.values($58324057efc05658$exports);
    const lines = adoc.split(`\n`);
    let inPassthroughBlock = false;
    const lineResults = lines.reduce((acc, line, index)=>{
        if ($98cb5ebf8f0b866b$var$isPassthroughBlockDelim(line)) {
            inPassthroughBlock = !inPassthroughBlock;
            return acc;
        }
        if (inPassthroughBlock) return acc;
        if ($98cb5ebf8f0b866b$var$isLintComment(line)) return acc;
        if ($98cb5ebf8f0b866b$var$isComment(line)) {
            acc.push($98cb5ebf8f0b866b$var$commentWarning(index + 1));
            return acc;
        }
        lineRules.forEach((rule)=>{
            if ($98cb5ebf8f0b866b$var$runRule(rule, options, lines[index - 1])) {
                const ruleResults = rule(line, lines, index + 1, options);
                ruleResults.forEach((result)=>acc.push(result));
            }
        });
        return acc;
    }, []);
    const blockRules = Object.values($dd6f2bfa486e7b4d$exports);
    const blockResults = blockRules.reduce((acc, rule)=>{
        if (!$98cb5ebf8f0b866b$var$runRule(rule, options)) return acc;
        return acc.concat(...rule(adoc, options));
    }, []);
    return [
        ...lineResults,
        ...blockResults
    ];
}
function $98cb5ebf8f0b866b$var$runRule(rule, options, prevLine) {
    const { include: include, exclude: exclude } = options;
    if (rule.maybe && !options.maybe && !(include || []).includes(rule.slug)) return false;
    if ($98cb5ebf8f0b866b$var$disabledByComment(rule.slug, prevLine)) return false;
    if (include === undefined && exclude === undefined) return true;
    if (include && !include.includes(rule.slug)) return false;
    if (exclude && exclude.includes(rule.slug)) return false;
    return true;
}
function $98cb5ebf8f0b866b$var$disabledByComment(ruleSlug, prevLine) {
    return !!(prevLine && prevLine[0] === `/` && prevLine.match(new RegExp(`^// lint-disable .*${ruleSlug}`)));
}
function $98cb5ebf8f0b866b$var$isLintComment(line) {
    return $98cb5ebf8f0b866b$var$isComment(line) && !!line.match(/lint-(disable|ignore)/);
}
function $98cb5ebf8f0b866b$var$isComment(line) {
    return line[0] === `/` && line[1] === `/`;
}
function $98cb5ebf8f0b866b$var$isPassthroughBlockDelim(line) {
    return line === `++++`;
}
function $98cb5ebf8f0b866b$var$commentWarning(lineNumber) {
    return {
        line: lineNumber,
        column: false,
        type: `warning`,
        rule: `temporary-comments`,
        message: `Comments should generally be removed, with the exceptions of: 1) comments to disable lint rules (e.g. \`// lint-disable invalid-characters\`), and 2) special cases where there would be a long-term value to keeping the comment (these lines can be marked with \`--lint-ignore\` to disable this lint warning)`
    };
}



function $78b427dc99f42b79$export$2e2bcd8739ae039(adoc, lints) {
    let numUnfixedFixables = 0;
    const modifiedLines = new Set();
    const lines = adoc.split(`\n`);
    lints.forEach((lint)=>{
        const lineIndex = lint.line - 1;
        const line = lines[lineIndex];
        if (!lint.fixable || typeof lint.recommendation !== `string`) return;
        const { recommendation: recommendation, rule: rule } = lint;
        if (modifiedLines.has(lint.line)) {
            numUnfixedFixables++;
            return;
        }
        if (rule === `unspaced-markup`) {
            lines[lineIndex] = `${line}\n`;
            modifiedLines.add(lint.line);
            return;
        }
        if (rule === `open-block` || rule === `wrapping-block`) {
            lines[lineIndex] = `\n${line}`;
            modifiedLines.add(lint.line);
            return;
        }
        if (rule === `unspaced-class`) {
            lines[lineIndex] = `\n${line || ``}`;
            modifiedLines.add(lint.line);
            return;
        }
        if (rule === `multiple-blank-lines`) {
            const remove = recommendation.replace(/[^\d,]/g, ``).split(`,`).map(Number);
            remove.forEach((lineNumber)=>{
                if (!modifiedLines.has(lineNumber)) {
                    lines[lineNumber - 1] = null;
                    modifiedLines.add(lineNumber);
                }
            });
            return;
        }
        if (rule === `footnote-split-spacing`) {
            if (!modifiedLines.has(lint.line)) {
                lines[lineIndex] = null;
                modifiedLines.add(lint.line);
            }
            return;
        }
        if (rule === `numbered-group`) {
            if (!modifiedLines.has(lint.line)) {
                const before = recommendation.includes(`before`);
                const after = recommendation.includes(`after`);
                lines[lineIndex] = `${before ? `\n` : ``}${line}${after ? `\n` : ``}`;
                modifiedLines.add(lint.line);
            }
            return;
        }
        if (rule === `trailing-hyphen` || rule === `dangling-possessive` || rule === `join-words` && recommendation.includes(`\n`)) {
            if (modifiedLines.has(lint.line + 1)) numUnfixedFixables++;
            else {
                const [first = ``, second = ``] = recommendation.split(`\n`);
                lines[lint.line - 1] = first;
                lines[lint.line] = second;
                modifiedLines.add(lint.line);
                modifiedLines.add(lint.line + 1);
            }
            return;
        }
        if (rule === `eof-newline`) {
            lines.push(``);
            return;
        }
        lines[lint.line - 1] = recommendation;
        modifiedLines.add(lint.line);
    });
    return [
        lines.filter((l)=>l !== null).join(`\n`),
        numUnfixedFixables
    ];
}


function $3325b51ce745235a$export$2e2bcd8739ae039(adoc, options = {
    lang: `en`
}) {
    const lints = (0, $98cb5ebf8f0b866b$export$2e2bcd8739ae039)(adoc, options);
    const fixable = lints.filter((l)=>l.fixable === true);
    const unfixable = lints.filter((l)=>l.fixable !== true);
    if (fixable.length === 0) return {
        fixed: adoc,
        numFixed: 0,
        unfixable: unfixable
    };
    let fixed = adoc;
    let remainingUnfixed = fixable.length;
    let remainingLints = lints;
    while(remainingUnfixed > 0){
        [fixed, remainingUnfixed] = (0, $78b427dc99f42b79$export$2e2bcd8739ae039)(fixed, remainingLints);
        if (remainingUnfixed > 0) remainingLints = (0, $98cb5ebf8f0b866b$export$2e2bcd8739ae039)(fixed, options);
    }
    return {
        fixed: fixed,
        unfixable: unfixable,
        numFixed: fixable.length
    };
}




var $e08db83179311785$exports = {};
const $c21b6acfa6bea90a$var$VERSION = "1.0.4";
/**
 * @param octokit Octokit instance
 * @param options Options passed to Octokit constructor
 */ function $c21b6acfa6bea90a$export$1c1276d455e5a49b(octokit) {
    octokit.hook.wrap("request", (request, options)=>{
        octokit.log.debug("request", options);
        const start = Date.now();
        const requestOptions = octokit.request.endpoint.parse(options);
        const path = requestOptions.url.replace(options.baseUrl, "");
        return request(options).then((response)=>{
            octokit.log.info(`${requestOptions.method} ${path} - ${response.status} in ${Date.now() - start}ms`);
            return response;
        }).catch((error)=>{
            octokit.log.info(`${requestOptions.method} ${path} - ${error.status} in ${Date.now() - start}ms`);
            throw error;
        });
    });
}
$c21b6acfa6bea90a$export$1c1276d455e5a49b.VERSION = $c21b6acfa6bea90a$var$VERSION;


var $e08db83179311785$require$requestLog = $c21b6acfa6bea90a$export$1c1276d455e5a49b;

var $lG4DW = parcelRequire("lG4DW");
var $55be46b53005923d$var$endpointsByScope = {
    actions: {
        cancelWorkflowRun: {
            method: "POST",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                run_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/repos/:owner/:repo/actions/runs/:run_id/cancel"
        },
        createOrUpdateSecretForRepo: {
            method: "PUT",
            params: {
                encrypted_value: {
                    type: "string"
                },
                key_id: {
                    type: "string"
                },
                name: {
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/actions/secrets/:name"
        },
        createRegistrationToken: {
            method: "POST",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/actions/runners/registration-token"
        },
        createRemoveToken: {
            method: "POST",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/actions/runners/remove-token"
        },
        deleteArtifact: {
            method: "DELETE",
            params: {
                artifact_id: {
                    required: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/actions/artifacts/:artifact_id"
        },
        deleteSecretFromRepo: {
            method: "DELETE",
            params: {
                name: {
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/actions/secrets/:name"
        },
        downloadArtifact: {
            method: "GET",
            params: {
                archive_format: {
                    required: true,
                    type: "string"
                },
                artifact_id: {
                    required: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/actions/artifacts/:artifact_id/:archive_format"
        },
        getArtifact: {
            method: "GET",
            params: {
                artifact_id: {
                    required: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/actions/artifacts/:artifact_id"
        },
        getPublicKey: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/actions/secrets/public-key"
        },
        getSecret: {
            method: "GET",
            params: {
                name: {
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/actions/secrets/:name"
        },
        getSelfHostedRunner: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                runner_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/repos/:owner/:repo/actions/runners/:runner_id"
        },
        getWorkflow: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                workflow_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/repos/:owner/:repo/actions/workflows/:workflow_id"
        },
        getWorkflowJob: {
            method: "GET",
            params: {
                job_id: {
                    required: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/actions/jobs/:job_id"
        },
        getWorkflowRun: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                run_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/repos/:owner/:repo/actions/runs/:run_id"
        },
        listDownloadsForSelfHostedRunnerApplication: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/actions/runners/downloads"
        },
        listJobsForWorkflowRun: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                run_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/repos/:owner/:repo/actions/runs/:run_id/jobs"
        },
        listRepoWorkflowRuns: {
            method: "GET",
            params: {
                actor: {
                    type: "string"
                },
                branch: {
                    type: "string"
                },
                event: {
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                status: {
                    enum: [
                        "completed",
                        "status",
                        "conclusion"
                    ],
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/actions/runs"
        },
        listRepoWorkflows: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/actions/workflows"
        },
        listSecretsForRepo: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/actions/secrets"
        },
        listSelfHostedRunnersForRepo: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/actions/runners"
        },
        listWorkflowJobLogs: {
            method: "GET",
            params: {
                job_id: {
                    required: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/actions/jobs/:job_id/logs"
        },
        listWorkflowRunArtifacts: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                run_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/repos/:owner/:repo/actions/runs/:run_id/artifacts"
        },
        listWorkflowRunLogs: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                run_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/repos/:owner/:repo/actions/runs/:run_id/logs"
        },
        listWorkflowRuns: {
            method: "GET",
            params: {
                actor: {
                    type: "string"
                },
                branch: {
                    type: "string"
                },
                event: {
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                status: {
                    enum: [
                        "completed",
                        "status",
                        "conclusion"
                    ],
                    type: "string"
                },
                workflow_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/repos/:owner/:repo/actions/workflows/:workflow_id/runs"
        },
        reRunWorkflow: {
            method: "POST",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                run_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/repos/:owner/:repo/actions/runs/:run_id/rerun"
        },
        removeSelfHostedRunner: {
            method: "DELETE",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                runner_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/repos/:owner/:repo/actions/runners/:runner_id"
        }
    },
    activity: {
        checkStarringRepo: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/user/starred/:owner/:repo"
        },
        deleteRepoSubscription: {
            method: "DELETE",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/subscription"
        },
        deleteThreadSubscription: {
            method: "DELETE",
            params: {
                thread_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/notifications/threads/:thread_id/subscription"
        },
        getRepoSubscription: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/subscription"
        },
        getThread: {
            method: "GET",
            params: {
                thread_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/notifications/threads/:thread_id"
        },
        getThreadSubscription: {
            method: "GET",
            params: {
                thread_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/notifications/threads/:thread_id/subscription"
        },
        listEventsForOrg: {
            method: "GET",
            params: {
                org: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                username: {
                    required: true,
                    type: "string"
                }
            },
            url: "/users/:username/events/orgs/:org"
        },
        listEventsForUser: {
            method: "GET",
            params: {
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                username: {
                    required: true,
                    type: "string"
                }
            },
            url: "/users/:username/events"
        },
        listFeeds: {
            method: "GET",
            params: {},
            url: "/feeds"
        },
        listNotifications: {
            method: "GET",
            params: {
                all: {
                    type: "boolean"
                },
                before: {
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                participating: {
                    type: "boolean"
                },
                per_page: {
                    type: "integer"
                },
                since: {
                    type: "string"
                }
            },
            url: "/notifications"
        },
        listNotificationsForRepo: {
            method: "GET",
            params: {
                all: {
                    type: "boolean"
                },
                before: {
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                participating: {
                    type: "boolean"
                },
                per_page: {
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                since: {
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/notifications"
        },
        listPublicEvents: {
            method: "GET",
            params: {
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                }
            },
            url: "/events"
        },
        listPublicEventsForOrg: {
            method: "GET",
            params: {
                org: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                }
            },
            url: "/orgs/:org/events"
        },
        listPublicEventsForRepoNetwork: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/networks/:owner/:repo/events"
        },
        listPublicEventsForUser: {
            method: "GET",
            params: {
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                username: {
                    required: true,
                    type: "string"
                }
            },
            url: "/users/:username/events/public"
        },
        listReceivedEventsForUser: {
            method: "GET",
            params: {
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                username: {
                    required: true,
                    type: "string"
                }
            },
            url: "/users/:username/received_events"
        },
        listReceivedPublicEventsForUser: {
            method: "GET",
            params: {
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                username: {
                    required: true,
                    type: "string"
                }
            },
            url: "/users/:username/received_events/public"
        },
        listRepoEvents: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/events"
        },
        listReposStarredByAuthenticatedUser: {
            method: "GET",
            params: {
                direction: {
                    enum: [
                        "asc",
                        "desc"
                    ],
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                sort: {
                    enum: [
                        "created",
                        "updated"
                    ],
                    type: "string"
                }
            },
            url: "/user/starred"
        },
        listReposStarredByUser: {
            method: "GET",
            params: {
                direction: {
                    enum: [
                        "asc",
                        "desc"
                    ],
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                sort: {
                    enum: [
                        "created",
                        "updated"
                    ],
                    type: "string"
                },
                username: {
                    required: true,
                    type: "string"
                }
            },
            url: "/users/:username/starred"
        },
        listReposWatchedByUser: {
            method: "GET",
            params: {
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                username: {
                    required: true,
                    type: "string"
                }
            },
            url: "/users/:username/subscriptions"
        },
        listStargazersForRepo: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/stargazers"
        },
        listWatchedReposForAuthenticatedUser: {
            method: "GET",
            params: {
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                }
            },
            url: "/user/subscriptions"
        },
        listWatchersForRepo: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/subscribers"
        },
        markAsRead: {
            method: "PUT",
            params: {
                last_read_at: {
                    type: "string"
                }
            },
            url: "/notifications"
        },
        markNotificationsAsReadForRepo: {
            method: "PUT",
            params: {
                last_read_at: {
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/notifications"
        },
        markThreadAsRead: {
            method: "PATCH",
            params: {
                thread_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/notifications/threads/:thread_id"
        },
        setRepoSubscription: {
            method: "PUT",
            params: {
                ignored: {
                    type: "boolean"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                subscribed: {
                    type: "boolean"
                }
            },
            url: "/repos/:owner/:repo/subscription"
        },
        setThreadSubscription: {
            method: "PUT",
            params: {
                ignored: {
                    type: "boolean"
                },
                thread_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/notifications/threads/:thread_id/subscription"
        },
        starRepo: {
            method: "PUT",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/user/starred/:owner/:repo"
        },
        unstarRepo: {
            method: "DELETE",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/user/starred/:owner/:repo"
        }
    },
    apps: {
        addRepoToInstallation: {
            headers: {
                accept: "application/vnd.github.machine-man-preview+json"
            },
            method: "PUT",
            params: {
                installation_id: {
                    required: true,
                    type: "integer"
                },
                repository_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/user/installations/:installation_id/repositories/:repository_id"
        },
        checkAccountIsAssociatedWithAny: {
            method: "GET",
            params: {
                account_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/marketplace_listing/accounts/:account_id"
        },
        checkAccountIsAssociatedWithAnyStubbed: {
            method: "GET",
            params: {
                account_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/marketplace_listing/stubbed/accounts/:account_id"
        },
        checkAuthorization: {
            deprecated: "octokit.apps.checkAuthorization() is deprecated, see https://developer.github.com/v3/apps/oauth_applications/#check-an-authorization",
            method: "GET",
            params: {
                access_token: {
                    required: true,
                    type: "string"
                },
                client_id: {
                    required: true,
                    type: "string"
                }
            },
            url: "/applications/:client_id/tokens/:access_token"
        },
        checkToken: {
            headers: {
                accept: "application/vnd.github.doctor-strange-preview+json"
            },
            method: "POST",
            params: {
                access_token: {
                    type: "string"
                },
                client_id: {
                    required: true,
                    type: "string"
                }
            },
            url: "/applications/:client_id/token"
        },
        createContentAttachment: {
            headers: {
                accept: "application/vnd.github.corsair-preview+json"
            },
            method: "POST",
            params: {
                body: {
                    required: true,
                    type: "string"
                },
                content_reference_id: {
                    required: true,
                    type: "integer"
                },
                title: {
                    required: true,
                    type: "string"
                }
            },
            url: "/content_references/:content_reference_id/attachments"
        },
        createFromManifest: {
            headers: {
                accept: "application/vnd.github.fury-preview+json"
            },
            method: "POST",
            params: {
                code: {
                    required: true,
                    type: "string"
                }
            },
            url: "/app-manifests/:code/conversions"
        },
        createInstallationToken: {
            headers: {
                accept: "application/vnd.github.machine-man-preview+json"
            },
            method: "POST",
            params: {
                installation_id: {
                    required: true,
                    type: "integer"
                },
                permissions: {
                    type: "object"
                },
                repository_ids: {
                    type: "integer[]"
                }
            },
            url: "/app/installations/:installation_id/access_tokens"
        },
        deleteAuthorization: {
            headers: {
                accept: "application/vnd.github.doctor-strange-preview+json"
            },
            method: "DELETE",
            params: {
                access_token: {
                    type: "string"
                },
                client_id: {
                    required: true,
                    type: "string"
                }
            },
            url: "/applications/:client_id/grant"
        },
        deleteInstallation: {
            headers: {
                accept: "application/vnd.github.gambit-preview+json,application/vnd.github.machine-man-preview+json"
            },
            method: "DELETE",
            params: {
                installation_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/app/installations/:installation_id"
        },
        deleteToken: {
            headers: {
                accept: "application/vnd.github.doctor-strange-preview+json"
            },
            method: "DELETE",
            params: {
                access_token: {
                    type: "string"
                },
                client_id: {
                    required: true,
                    type: "string"
                }
            },
            url: "/applications/:client_id/token"
        },
        findOrgInstallation: {
            deprecated: "octokit.apps.findOrgInstallation() has been renamed to octokit.apps.getOrgInstallation() (2019-04-10)",
            headers: {
                accept: "application/vnd.github.machine-man-preview+json"
            },
            method: "GET",
            params: {
                org: {
                    required: true,
                    type: "string"
                }
            },
            url: "/orgs/:org/installation"
        },
        findRepoInstallation: {
            deprecated: "octokit.apps.findRepoInstallation() has been renamed to octokit.apps.getRepoInstallation() (2019-04-10)",
            headers: {
                accept: "application/vnd.github.machine-man-preview+json"
            },
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/installation"
        },
        findUserInstallation: {
            deprecated: "octokit.apps.findUserInstallation() has been renamed to octokit.apps.getUserInstallation() (2019-04-10)",
            headers: {
                accept: "application/vnd.github.machine-man-preview+json"
            },
            method: "GET",
            params: {
                username: {
                    required: true,
                    type: "string"
                }
            },
            url: "/users/:username/installation"
        },
        getAuthenticated: {
            headers: {
                accept: "application/vnd.github.machine-man-preview+json"
            },
            method: "GET",
            params: {},
            url: "/app"
        },
        getBySlug: {
            headers: {
                accept: "application/vnd.github.machine-man-preview+json"
            },
            method: "GET",
            params: {
                app_slug: {
                    required: true,
                    type: "string"
                }
            },
            url: "/apps/:app_slug"
        },
        getInstallation: {
            headers: {
                accept: "application/vnd.github.machine-man-preview+json"
            },
            method: "GET",
            params: {
                installation_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/app/installations/:installation_id"
        },
        getOrgInstallation: {
            headers: {
                accept: "application/vnd.github.machine-man-preview+json"
            },
            method: "GET",
            params: {
                org: {
                    required: true,
                    type: "string"
                }
            },
            url: "/orgs/:org/installation"
        },
        getRepoInstallation: {
            headers: {
                accept: "application/vnd.github.machine-man-preview+json"
            },
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/installation"
        },
        getUserInstallation: {
            headers: {
                accept: "application/vnd.github.machine-man-preview+json"
            },
            method: "GET",
            params: {
                username: {
                    required: true,
                    type: "string"
                }
            },
            url: "/users/:username/installation"
        },
        listAccountsUserOrOrgOnPlan: {
            method: "GET",
            params: {
                direction: {
                    enum: [
                        "asc",
                        "desc"
                    ],
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                plan_id: {
                    required: true,
                    type: "integer"
                },
                sort: {
                    enum: [
                        "created",
                        "updated"
                    ],
                    type: "string"
                }
            },
            url: "/marketplace_listing/plans/:plan_id/accounts"
        },
        listAccountsUserOrOrgOnPlanStubbed: {
            method: "GET",
            params: {
                direction: {
                    enum: [
                        "asc",
                        "desc"
                    ],
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                plan_id: {
                    required: true,
                    type: "integer"
                },
                sort: {
                    enum: [
                        "created",
                        "updated"
                    ],
                    type: "string"
                }
            },
            url: "/marketplace_listing/stubbed/plans/:plan_id/accounts"
        },
        listInstallationReposForAuthenticatedUser: {
            headers: {
                accept: "application/vnd.github.machine-man-preview+json"
            },
            method: "GET",
            params: {
                installation_id: {
                    required: true,
                    type: "integer"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                }
            },
            url: "/user/installations/:installation_id/repositories"
        },
        listInstallations: {
            headers: {
                accept: "application/vnd.github.machine-man-preview+json"
            },
            method: "GET",
            params: {
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                }
            },
            url: "/app/installations"
        },
        listInstallationsForAuthenticatedUser: {
            headers: {
                accept: "application/vnd.github.machine-man-preview+json"
            },
            method: "GET",
            params: {
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                }
            },
            url: "/user/installations"
        },
        listMarketplacePurchasesForAuthenticatedUser: {
            method: "GET",
            params: {
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                }
            },
            url: "/user/marketplace_purchases"
        },
        listMarketplacePurchasesForAuthenticatedUserStubbed: {
            method: "GET",
            params: {
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                }
            },
            url: "/user/marketplace_purchases/stubbed"
        },
        listPlans: {
            method: "GET",
            params: {
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                }
            },
            url: "/marketplace_listing/plans"
        },
        listPlansStubbed: {
            method: "GET",
            params: {
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                }
            },
            url: "/marketplace_listing/stubbed/plans"
        },
        listRepos: {
            headers: {
                accept: "application/vnd.github.machine-man-preview+json"
            },
            method: "GET",
            params: {
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                }
            },
            url: "/installation/repositories"
        },
        removeRepoFromInstallation: {
            headers: {
                accept: "application/vnd.github.machine-man-preview+json"
            },
            method: "DELETE",
            params: {
                installation_id: {
                    required: true,
                    type: "integer"
                },
                repository_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/user/installations/:installation_id/repositories/:repository_id"
        },
        resetAuthorization: {
            deprecated: "octokit.apps.resetAuthorization() is deprecated, see https://developer.github.com/v3/apps/oauth_applications/#reset-an-authorization",
            method: "POST",
            params: {
                access_token: {
                    required: true,
                    type: "string"
                },
                client_id: {
                    required: true,
                    type: "string"
                }
            },
            url: "/applications/:client_id/tokens/:access_token"
        },
        resetToken: {
            headers: {
                accept: "application/vnd.github.doctor-strange-preview+json"
            },
            method: "PATCH",
            params: {
                access_token: {
                    type: "string"
                },
                client_id: {
                    required: true,
                    type: "string"
                }
            },
            url: "/applications/:client_id/token"
        },
        revokeAuthorizationForApplication: {
            deprecated: "octokit.apps.revokeAuthorizationForApplication() is deprecated, see https://developer.github.com/v3/apps/oauth_applications/#revoke-an-authorization-for-an-application",
            method: "DELETE",
            params: {
                access_token: {
                    required: true,
                    type: "string"
                },
                client_id: {
                    required: true,
                    type: "string"
                }
            },
            url: "/applications/:client_id/tokens/:access_token"
        },
        revokeGrantForApplication: {
            deprecated: "octokit.apps.revokeGrantForApplication() is deprecated, see https://developer.github.com/v3/apps/oauth_applications/#revoke-a-grant-for-an-application",
            method: "DELETE",
            params: {
                access_token: {
                    required: true,
                    type: "string"
                },
                client_id: {
                    required: true,
                    type: "string"
                }
            },
            url: "/applications/:client_id/grants/:access_token"
        },
        revokeInstallationToken: {
            headers: {
                accept: "application/vnd.github.gambit-preview+json"
            },
            method: "DELETE",
            params: {},
            url: "/installation/token"
        }
    },
    checks: {
        create: {
            headers: {
                accept: "application/vnd.github.antiope-preview+json"
            },
            method: "POST",
            params: {
                actions: {
                    type: "object[]"
                },
                "actions[].description": {
                    required: true,
                    type: "string"
                },
                "actions[].identifier": {
                    required: true,
                    type: "string"
                },
                "actions[].label": {
                    required: true,
                    type: "string"
                },
                completed_at: {
                    type: "string"
                },
                conclusion: {
                    enum: [
                        "success",
                        "failure",
                        "neutral",
                        "cancelled",
                        "timed_out",
                        "action_required"
                    ],
                    type: "string"
                },
                details_url: {
                    type: "string"
                },
                external_id: {
                    type: "string"
                },
                head_sha: {
                    required: true,
                    type: "string"
                },
                name: {
                    required: true,
                    type: "string"
                },
                output: {
                    type: "object"
                },
                "output.annotations": {
                    type: "object[]"
                },
                "output.annotations[].annotation_level": {
                    enum: [
                        "notice",
                        "warning",
                        "failure"
                    ],
                    required: true,
                    type: "string"
                },
                "output.annotations[].end_column": {
                    type: "integer"
                },
                "output.annotations[].end_line": {
                    required: true,
                    type: "integer"
                },
                "output.annotations[].message": {
                    required: true,
                    type: "string"
                },
                "output.annotations[].path": {
                    required: true,
                    type: "string"
                },
                "output.annotations[].raw_details": {
                    type: "string"
                },
                "output.annotations[].start_column": {
                    type: "integer"
                },
                "output.annotations[].start_line": {
                    required: true,
                    type: "integer"
                },
                "output.annotations[].title": {
                    type: "string"
                },
                "output.images": {
                    type: "object[]"
                },
                "output.images[].alt": {
                    required: true,
                    type: "string"
                },
                "output.images[].caption": {
                    type: "string"
                },
                "output.images[].image_url": {
                    required: true,
                    type: "string"
                },
                "output.summary": {
                    required: true,
                    type: "string"
                },
                "output.text": {
                    type: "string"
                },
                "output.title": {
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                started_at: {
                    type: "string"
                },
                status: {
                    enum: [
                        "queued",
                        "in_progress",
                        "completed"
                    ],
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/check-runs"
        },
        createSuite: {
            headers: {
                accept: "application/vnd.github.antiope-preview+json"
            },
            method: "POST",
            params: {
                head_sha: {
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/check-suites"
        },
        get: {
            headers: {
                accept: "application/vnd.github.antiope-preview+json"
            },
            method: "GET",
            params: {
                check_run_id: {
                    required: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/check-runs/:check_run_id"
        },
        getSuite: {
            headers: {
                accept: "application/vnd.github.antiope-preview+json"
            },
            method: "GET",
            params: {
                check_suite_id: {
                    required: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/check-suites/:check_suite_id"
        },
        listAnnotations: {
            headers: {
                accept: "application/vnd.github.antiope-preview+json"
            },
            method: "GET",
            params: {
                check_run_id: {
                    required: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/check-runs/:check_run_id/annotations"
        },
        listForRef: {
            headers: {
                accept: "application/vnd.github.antiope-preview+json"
            },
            method: "GET",
            params: {
                check_name: {
                    type: "string"
                },
                filter: {
                    enum: [
                        "latest",
                        "all"
                    ],
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                ref: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                status: {
                    enum: [
                        "queued",
                        "in_progress",
                        "completed"
                    ],
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/commits/:ref/check-runs"
        },
        listForSuite: {
            headers: {
                accept: "application/vnd.github.antiope-preview+json"
            },
            method: "GET",
            params: {
                check_name: {
                    type: "string"
                },
                check_suite_id: {
                    required: true,
                    type: "integer"
                },
                filter: {
                    enum: [
                        "latest",
                        "all"
                    ],
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                status: {
                    enum: [
                        "queued",
                        "in_progress",
                        "completed"
                    ],
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/check-suites/:check_suite_id/check-runs"
        },
        listSuitesForRef: {
            headers: {
                accept: "application/vnd.github.antiope-preview+json"
            },
            method: "GET",
            params: {
                app_id: {
                    type: "integer"
                },
                check_name: {
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                ref: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/commits/:ref/check-suites"
        },
        rerequestSuite: {
            headers: {
                accept: "application/vnd.github.antiope-preview+json"
            },
            method: "POST",
            params: {
                check_suite_id: {
                    required: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/check-suites/:check_suite_id/rerequest"
        },
        setSuitesPreferences: {
            headers: {
                accept: "application/vnd.github.antiope-preview+json"
            },
            method: "PATCH",
            params: {
                auto_trigger_checks: {
                    type: "object[]"
                },
                "auto_trigger_checks[].app_id": {
                    required: true,
                    type: "integer"
                },
                "auto_trigger_checks[].setting": {
                    required: true,
                    type: "boolean"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/check-suites/preferences"
        },
        update: {
            headers: {
                accept: "application/vnd.github.antiope-preview+json"
            },
            method: "PATCH",
            params: {
                actions: {
                    type: "object[]"
                },
                "actions[].description": {
                    required: true,
                    type: "string"
                },
                "actions[].identifier": {
                    required: true,
                    type: "string"
                },
                "actions[].label": {
                    required: true,
                    type: "string"
                },
                check_run_id: {
                    required: true,
                    type: "integer"
                },
                completed_at: {
                    type: "string"
                },
                conclusion: {
                    enum: [
                        "success",
                        "failure",
                        "neutral",
                        "cancelled",
                        "timed_out",
                        "action_required"
                    ],
                    type: "string"
                },
                details_url: {
                    type: "string"
                },
                external_id: {
                    type: "string"
                },
                name: {
                    type: "string"
                },
                output: {
                    type: "object"
                },
                "output.annotations": {
                    type: "object[]"
                },
                "output.annotations[].annotation_level": {
                    enum: [
                        "notice",
                        "warning",
                        "failure"
                    ],
                    required: true,
                    type: "string"
                },
                "output.annotations[].end_column": {
                    type: "integer"
                },
                "output.annotations[].end_line": {
                    required: true,
                    type: "integer"
                },
                "output.annotations[].message": {
                    required: true,
                    type: "string"
                },
                "output.annotations[].path": {
                    required: true,
                    type: "string"
                },
                "output.annotations[].raw_details": {
                    type: "string"
                },
                "output.annotations[].start_column": {
                    type: "integer"
                },
                "output.annotations[].start_line": {
                    required: true,
                    type: "integer"
                },
                "output.annotations[].title": {
                    type: "string"
                },
                "output.images": {
                    type: "object[]"
                },
                "output.images[].alt": {
                    required: true,
                    type: "string"
                },
                "output.images[].caption": {
                    type: "string"
                },
                "output.images[].image_url": {
                    required: true,
                    type: "string"
                },
                "output.summary": {
                    required: true,
                    type: "string"
                },
                "output.text": {
                    type: "string"
                },
                "output.title": {
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                started_at: {
                    type: "string"
                },
                status: {
                    enum: [
                        "queued",
                        "in_progress",
                        "completed"
                    ],
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/check-runs/:check_run_id"
        }
    },
    codesOfConduct: {
        getConductCode: {
            headers: {
                accept: "application/vnd.github.scarlet-witch-preview+json"
            },
            method: "GET",
            params: {
                key: {
                    required: true,
                    type: "string"
                }
            },
            url: "/codes_of_conduct/:key"
        },
        getForRepo: {
            headers: {
                accept: "application/vnd.github.scarlet-witch-preview+json"
            },
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/community/code_of_conduct"
        },
        listConductCodes: {
            headers: {
                accept: "application/vnd.github.scarlet-witch-preview+json"
            },
            method: "GET",
            params: {},
            url: "/codes_of_conduct"
        }
    },
    emojis: {
        get: {
            method: "GET",
            params: {},
            url: "/emojis"
        }
    },
    gists: {
        checkIsStarred: {
            method: "GET",
            params: {
                gist_id: {
                    required: true,
                    type: "string"
                }
            },
            url: "/gists/:gist_id/star"
        },
        create: {
            method: "POST",
            params: {
                description: {
                    type: "string"
                },
                files: {
                    required: true,
                    type: "object"
                },
                "files.content": {
                    type: "string"
                },
                public: {
                    type: "boolean"
                }
            },
            url: "/gists"
        },
        createComment: {
            method: "POST",
            params: {
                body: {
                    required: true,
                    type: "string"
                },
                gist_id: {
                    required: true,
                    type: "string"
                }
            },
            url: "/gists/:gist_id/comments"
        },
        delete: {
            method: "DELETE",
            params: {
                gist_id: {
                    required: true,
                    type: "string"
                }
            },
            url: "/gists/:gist_id"
        },
        deleteComment: {
            method: "DELETE",
            params: {
                comment_id: {
                    required: true,
                    type: "integer"
                },
                gist_id: {
                    required: true,
                    type: "string"
                }
            },
            url: "/gists/:gist_id/comments/:comment_id"
        },
        fork: {
            method: "POST",
            params: {
                gist_id: {
                    required: true,
                    type: "string"
                }
            },
            url: "/gists/:gist_id/forks"
        },
        get: {
            method: "GET",
            params: {
                gist_id: {
                    required: true,
                    type: "string"
                }
            },
            url: "/gists/:gist_id"
        },
        getComment: {
            method: "GET",
            params: {
                comment_id: {
                    required: true,
                    type: "integer"
                },
                gist_id: {
                    required: true,
                    type: "string"
                }
            },
            url: "/gists/:gist_id/comments/:comment_id"
        },
        getRevision: {
            method: "GET",
            params: {
                gist_id: {
                    required: true,
                    type: "string"
                },
                sha: {
                    required: true,
                    type: "string"
                }
            },
            url: "/gists/:gist_id/:sha"
        },
        list: {
            method: "GET",
            params: {
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                since: {
                    type: "string"
                }
            },
            url: "/gists"
        },
        listComments: {
            method: "GET",
            params: {
                gist_id: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                }
            },
            url: "/gists/:gist_id/comments"
        },
        listCommits: {
            method: "GET",
            params: {
                gist_id: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                }
            },
            url: "/gists/:gist_id/commits"
        },
        listForks: {
            method: "GET",
            params: {
                gist_id: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                }
            },
            url: "/gists/:gist_id/forks"
        },
        listPublic: {
            method: "GET",
            params: {
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                since: {
                    type: "string"
                }
            },
            url: "/gists/public"
        },
        listPublicForUser: {
            method: "GET",
            params: {
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                since: {
                    type: "string"
                },
                username: {
                    required: true,
                    type: "string"
                }
            },
            url: "/users/:username/gists"
        },
        listStarred: {
            method: "GET",
            params: {
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                since: {
                    type: "string"
                }
            },
            url: "/gists/starred"
        },
        star: {
            method: "PUT",
            params: {
                gist_id: {
                    required: true,
                    type: "string"
                }
            },
            url: "/gists/:gist_id/star"
        },
        unstar: {
            method: "DELETE",
            params: {
                gist_id: {
                    required: true,
                    type: "string"
                }
            },
            url: "/gists/:gist_id/star"
        },
        update: {
            method: "PATCH",
            params: {
                description: {
                    type: "string"
                },
                files: {
                    type: "object"
                },
                "files.content": {
                    type: "string"
                },
                "files.filename": {
                    type: "string"
                },
                gist_id: {
                    required: true,
                    type: "string"
                }
            },
            url: "/gists/:gist_id"
        },
        updateComment: {
            method: "PATCH",
            params: {
                body: {
                    required: true,
                    type: "string"
                },
                comment_id: {
                    required: true,
                    type: "integer"
                },
                gist_id: {
                    required: true,
                    type: "string"
                }
            },
            url: "/gists/:gist_id/comments/:comment_id"
        }
    },
    git: {
        createBlob: {
            method: "POST",
            params: {
                content: {
                    required: true,
                    type: "string"
                },
                encoding: {
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/git/blobs"
        },
        createCommit: {
            method: "POST",
            params: {
                author: {
                    type: "object"
                },
                "author.date": {
                    type: "string"
                },
                "author.email": {
                    type: "string"
                },
                "author.name": {
                    type: "string"
                },
                committer: {
                    type: "object"
                },
                "committer.date": {
                    type: "string"
                },
                "committer.email": {
                    type: "string"
                },
                "committer.name": {
                    type: "string"
                },
                message: {
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                parents: {
                    required: true,
                    type: "string[]"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                signature: {
                    type: "string"
                },
                tree: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/git/commits"
        },
        createRef: {
            method: "POST",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                ref: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                sha: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/git/refs"
        },
        createTag: {
            method: "POST",
            params: {
                message: {
                    required: true,
                    type: "string"
                },
                object: {
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                tag: {
                    required: true,
                    type: "string"
                },
                tagger: {
                    type: "object"
                },
                "tagger.date": {
                    type: "string"
                },
                "tagger.email": {
                    type: "string"
                },
                "tagger.name": {
                    type: "string"
                },
                type: {
                    enum: [
                        "commit",
                        "tree",
                        "blob"
                    ],
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/git/tags"
        },
        createTree: {
            method: "POST",
            params: {
                base_tree: {
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                tree: {
                    required: true,
                    type: "object[]"
                },
                "tree[].content": {
                    type: "string"
                },
                "tree[].mode": {
                    enum: [
                        "100644",
                        "100755",
                        "040000",
                        "160000",
                        "120000"
                    ],
                    type: "string"
                },
                "tree[].path": {
                    type: "string"
                },
                "tree[].sha": {
                    allowNull: true,
                    type: "string"
                },
                "tree[].type": {
                    enum: [
                        "blob",
                        "tree",
                        "commit"
                    ],
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/git/trees"
        },
        deleteRef: {
            method: "DELETE",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                ref: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/git/refs/:ref"
        },
        getBlob: {
            method: "GET",
            params: {
                file_sha: {
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/git/blobs/:file_sha"
        },
        getCommit: {
            method: "GET",
            params: {
                commit_sha: {
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/git/commits/:commit_sha"
        },
        getRef: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                ref: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/git/ref/:ref"
        },
        getTag: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                tag_sha: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/git/tags/:tag_sha"
        },
        getTree: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                recursive: {
                    enum: [
                        "1"
                    ],
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                tree_sha: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/git/trees/:tree_sha"
        },
        listMatchingRefs: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                ref: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/git/matching-refs/:ref"
        },
        listRefs: {
            method: "GET",
            params: {
                namespace: {
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/git/refs/:namespace"
        },
        updateRef: {
            method: "PATCH",
            params: {
                force: {
                    type: "boolean"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                ref: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                sha: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/git/refs/:ref"
        }
    },
    gitignore: {
        getTemplate: {
            method: "GET",
            params: {
                name: {
                    required: true,
                    type: "string"
                }
            },
            url: "/gitignore/templates/:name"
        },
        listTemplates: {
            method: "GET",
            params: {},
            url: "/gitignore/templates"
        }
    },
    interactions: {
        addOrUpdateRestrictionsForOrg: {
            headers: {
                accept: "application/vnd.github.sombra-preview+json"
            },
            method: "PUT",
            params: {
                limit: {
                    enum: [
                        "existing_users",
                        "contributors_only",
                        "collaborators_only"
                    ],
                    required: true,
                    type: "string"
                },
                org: {
                    required: true,
                    type: "string"
                }
            },
            url: "/orgs/:org/interaction-limits"
        },
        addOrUpdateRestrictionsForRepo: {
            headers: {
                accept: "application/vnd.github.sombra-preview+json"
            },
            method: "PUT",
            params: {
                limit: {
                    enum: [
                        "existing_users",
                        "contributors_only",
                        "collaborators_only"
                    ],
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/interaction-limits"
        },
        getRestrictionsForOrg: {
            headers: {
                accept: "application/vnd.github.sombra-preview+json"
            },
            method: "GET",
            params: {
                org: {
                    required: true,
                    type: "string"
                }
            },
            url: "/orgs/:org/interaction-limits"
        },
        getRestrictionsForRepo: {
            headers: {
                accept: "application/vnd.github.sombra-preview+json"
            },
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/interaction-limits"
        },
        removeRestrictionsForOrg: {
            headers: {
                accept: "application/vnd.github.sombra-preview+json"
            },
            method: "DELETE",
            params: {
                org: {
                    required: true,
                    type: "string"
                }
            },
            url: "/orgs/:org/interaction-limits"
        },
        removeRestrictionsForRepo: {
            headers: {
                accept: "application/vnd.github.sombra-preview+json"
            },
            method: "DELETE",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/interaction-limits"
        }
    },
    issues: {
        addAssignees: {
            method: "POST",
            params: {
                assignees: {
                    type: "string[]"
                },
                issue_number: {
                    required: true,
                    type: "integer"
                },
                number: {
                    alias: "issue_number",
                    deprecated: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/issues/:issue_number/assignees"
        },
        addLabels: {
            method: "POST",
            params: {
                issue_number: {
                    required: true,
                    type: "integer"
                },
                labels: {
                    required: true,
                    type: "string[]"
                },
                number: {
                    alias: "issue_number",
                    deprecated: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/issues/:issue_number/labels"
        },
        checkAssignee: {
            method: "GET",
            params: {
                assignee: {
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/assignees/:assignee"
        },
        create: {
            method: "POST",
            params: {
                assignee: {
                    type: "string"
                },
                assignees: {
                    type: "string[]"
                },
                body: {
                    type: "string"
                },
                labels: {
                    type: "string[]"
                },
                milestone: {
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                title: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/issues"
        },
        createComment: {
            method: "POST",
            params: {
                body: {
                    required: true,
                    type: "string"
                },
                issue_number: {
                    required: true,
                    type: "integer"
                },
                number: {
                    alias: "issue_number",
                    deprecated: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/issues/:issue_number/comments"
        },
        createLabel: {
            method: "POST",
            params: {
                color: {
                    required: true,
                    type: "string"
                },
                description: {
                    type: "string"
                },
                name: {
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/labels"
        },
        createMilestone: {
            method: "POST",
            params: {
                description: {
                    type: "string"
                },
                due_on: {
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                state: {
                    enum: [
                        "open",
                        "closed"
                    ],
                    type: "string"
                },
                title: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/milestones"
        },
        deleteComment: {
            method: "DELETE",
            params: {
                comment_id: {
                    required: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/issues/comments/:comment_id"
        },
        deleteLabel: {
            method: "DELETE",
            params: {
                name: {
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/labels/:name"
        },
        deleteMilestone: {
            method: "DELETE",
            params: {
                milestone_number: {
                    required: true,
                    type: "integer"
                },
                number: {
                    alias: "milestone_number",
                    deprecated: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/milestones/:milestone_number"
        },
        get: {
            method: "GET",
            params: {
                issue_number: {
                    required: true,
                    type: "integer"
                },
                number: {
                    alias: "issue_number",
                    deprecated: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/issues/:issue_number"
        },
        getComment: {
            method: "GET",
            params: {
                comment_id: {
                    required: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/issues/comments/:comment_id"
        },
        getEvent: {
            method: "GET",
            params: {
                event_id: {
                    required: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/issues/events/:event_id"
        },
        getLabel: {
            method: "GET",
            params: {
                name: {
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/labels/:name"
        },
        getMilestone: {
            method: "GET",
            params: {
                milestone_number: {
                    required: true,
                    type: "integer"
                },
                number: {
                    alias: "milestone_number",
                    deprecated: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/milestones/:milestone_number"
        },
        list: {
            method: "GET",
            params: {
                direction: {
                    enum: [
                        "asc",
                        "desc"
                    ],
                    type: "string"
                },
                filter: {
                    enum: [
                        "assigned",
                        "created",
                        "mentioned",
                        "subscribed",
                        "all"
                    ],
                    type: "string"
                },
                labels: {
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                since: {
                    type: "string"
                },
                sort: {
                    enum: [
                        "created",
                        "updated",
                        "comments"
                    ],
                    type: "string"
                },
                state: {
                    enum: [
                        "open",
                        "closed",
                        "all"
                    ],
                    type: "string"
                }
            },
            url: "/issues"
        },
        listAssignees: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/assignees"
        },
        listComments: {
            method: "GET",
            params: {
                issue_number: {
                    required: true,
                    type: "integer"
                },
                number: {
                    alias: "issue_number",
                    deprecated: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                since: {
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/issues/:issue_number/comments"
        },
        listCommentsForRepo: {
            method: "GET",
            params: {
                direction: {
                    enum: [
                        "asc",
                        "desc"
                    ],
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                since: {
                    type: "string"
                },
                sort: {
                    enum: [
                        "created",
                        "updated"
                    ],
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/issues/comments"
        },
        listEvents: {
            method: "GET",
            params: {
                issue_number: {
                    required: true,
                    type: "integer"
                },
                number: {
                    alias: "issue_number",
                    deprecated: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/issues/:issue_number/events"
        },
        listEventsForRepo: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/issues/events"
        },
        listEventsForTimeline: {
            headers: {
                accept: "application/vnd.github.mockingbird-preview+json"
            },
            method: "GET",
            params: {
                issue_number: {
                    required: true,
                    type: "integer"
                },
                number: {
                    alias: "issue_number",
                    deprecated: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/issues/:issue_number/timeline"
        },
        listForAuthenticatedUser: {
            method: "GET",
            params: {
                direction: {
                    enum: [
                        "asc",
                        "desc"
                    ],
                    type: "string"
                },
                filter: {
                    enum: [
                        "assigned",
                        "created",
                        "mentioned",
                        "subscribed",
                        "all"
                    ],
                    type: "string"
                },
                labels: {
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                since: {
                    type: "string"
                },
                sort: {
                    enum: [
                        "created",
                        "updated",
                        "comments"
                    ],
                    type: "string"
                },
                state: {
                    enum: [
                        "open",
                        "closed",
                        "all"
                    ],
                    type: "string"
                }
            },
            url: "/user/issues"
        },
        listForOrg: {
            method: "GET",
            params: {
                direction: {
                    enum: [
                        "asc",
                        "desc"
                    ],
                    type: "string"
                },
                filter: {
                    enum: [
                        "assigned",
                        "created",
                        "mentioned",
                        "subscribed",
                        "all"
                    ],
                    type: "string"
                },
                labels: {
                    type: "string"
                },
                org: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                since: {
                    type: "string"
                },
                sort: {
                    enum: [
                        "created",
                        "updated",
                        "comments"
                    ],
                    type: "string"
                },
                state: {
                    enum: [
                        "open",
                        "closed",
                        "all"
                    ],
                    type: "string"
                }
            },
            url: "/orgs/:org/issues"
        },
        listForRepo: {
            method: "GET",
            params: {
                assignee: {
                    type: "string"
                },
                creator: {
                    type: "string"
                },
                direction: {
                    enum: [
                        "asc",
                        "desc"
                    ],
                    type: "string"
                },
                labels: {
                    type: "string"
                },
                mentioned: {
                    type: "string"
                },
                milestone: {
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                since: {
                    type: "string"
                },
                sort: {
                    enum: [
                        "created",
                        "updated",
                        "comments"
                    ],
                    type: "string"
                },
                state: {
                    enum: [
                        "open",
                        "closed",
                        "all"
                    ],
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/issues"
        },
        listLabelsForMilestone: {
            method: "GET",
            params: {
                milestone_number: {
                    required: true,
                    type: "integer"
                },
                number: {
                    alias: "milestone_number",
                    deprecated: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/milestones/:milestone_number/labels"
        },
        listLabelsForRepo: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/labels"
        },
        listLabelsOnIssue: {
            method: "GET",
            params: {
                issue_number: {
                    required: true,
                    type: "integer"
                },
                number: {
                    alias: "issue_number",
                    deprecated: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/issues/:issue_number/labels"
        },
        listMilestonesForRepo: {
            method: "GET",
            params: {
                direction: {
                    enum: [
                        "asc",
                        "desc"
                    ],
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                sort: {
                    enum: [
                        "due_on",
                        "completeness"
                    ],
                    type: "string"
                },
                state: {
                    enum: [
                        "open",
                        "closed",
                        "all"
                    ],
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/milestones"
        },
        lock: {
            method: "PUT",
            params: {
                issue_number: {
                    required: true,
                    type: "integer"
                },
                lock_reason: {
                    enum: [
                        "off-topic",
                        "too heated",
                        "resolved",
                        "spam"
                    ],
                    type: "string"
                },
                number: {
                    alias: "issue_number",
                    deprecated: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/issues/:issue_number/lock"
        },
        removeAssignees: {
            method: "DELETE",
            params: {
                assignees: {
                    type: "string[]"
                },
                issue_number: {
                    required: true,
                    type: "integer"
                },
                number: {
                    alias: "issue_number",
                    deprecated: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/issues/:issue_number/assignees"
        },
        removeLabel: {
            method: "DELETE",
            params: {
                issue_number: {
                    required: true,
                    type: "integer"
                },
                name: {
                    required: true,
                    type: "string"
                },
                number: {
                    alias: "issue_number",
                    deprecated: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/issues/:issue_number/labels/:name"
        },
        removeLabels: {
            method: "DELETE",
            params: {
                issue_number: {
                    required: true,
                    type: "integer"
                },
                number: {
                    alias: "issue_number",
                    deprecated: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/issues/:issue_number/labels"
        },
        replaceLabels: {
            method: "PUT",
            params: {
                issue_number: {
                    required: true,
                    type: "integer"
                },
                labels: {
                    type: "string[]"
                },
                number: {
                    alias: "issue_number",
                    deprecated: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/issues/:issue_number/labels"
        },
        unlock: {
            method: "DELETE",
            params: {
                issue_number: {
                    required: true,
                    type: "integer"
                },
                number: {
                    alias: "issue_number",
                    deprecated: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/issues/:issue_number/lock"
        },
        update: {
            method: "PATCH",
            params: {
                assignee: {
                    type: "string"
                },
                assignees: {
                    type: "string[]"
                },
                body: {
                    type: "string"
                },
                issue_number: {
                    required: true,
                    type: "integer"
                },
                labels: {
                    type: "string[]"
                },
                milestone: {
                    allowNull: true,
                    type: "integer"
                },
                number: {
                    alias: "issue_number",
                    deprecated: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                state: {
                    enum: [
                        "open",
                        "closed"
                    ],
                    type: "string"
                },
                title: {
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/issues/:issue_number"
        },
        updateComment: {
            method: "PATCH",
            params: {
                body: {
                    required: true,
                    type: "string"
                },
                comment_id: {
                    required: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/issues/comments/:comment_id"
        },
        updateLabel: {
            method: "PATCH",
            params: {
                color: {
                    type: "string"
                },
                current_name: {
                    required: true,
                    type: "string"
                },
                description: {
                    type: "string"
                },
                name: {
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/labels/:current_name"
        },
        updateMilestone: {
            method: "PATCH",
            params: {
                description: {
                    type: "string"
                },
                due_on: {
                    type: "string"
                },
                milestone_number: {
                    required: true,
                    type: "integer"
                },
                number: {
                    alias: "milestone_number",
                    deprecated: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                state: {
                    enum: [
                        "open",
                        "closed"
                    ],
                    type: "string"
                },
                title: {
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/milestones/:milestone_number"
        }
    },
    licenses: {
        get: {
            method: "GET",
            params: {
                license: {
                    required: true,
                    type: "string"
                }
            },
            url: "/licenses/:license"
        },
        getForRepo: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/license"
        },
        list: {
            deprecated: "octokit.licenses.list() has been renamed to octokit.licenses.listCommonlyUsed() (2019-03-05)",
            method: "GET",
            params: {},
            url: "/licenses"
        },
        listCommonlyUsed: {
            method: "GET",
            params: {},
            url: "/licenses"
        }
    },
    markdown: {
        render: {
            method: "POST",
            params: {
                context: {
                    type: "string"
                },
                mode: {
                    enum: [
                        "markdown",
                        "gfm"
                    ],
                    type: "string"
                },
                text: {
                    required: true,
                    type: "string"
                }
            },
            url: "/markdown"
        },
        renderRaw: {
            headers: {
                "content-type": "text/plain; charset=utf-8"
            },
            method: "POST",
            params: {
                data: {
                    mapTo: "data",
                    required: true,
                    type: "string"
                }
            },
            url: "/markdown/raw"
        }
    },
    meta: {
        get: {
            method: "GET",
            params: {},
            url: "/meta"
        }
    },
    migrations: {
        cancelImport: {
            method: "DELETE",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/import"
        },
        deleteArchiveForAuthenticatedUser: {
            headers: {
                accept: "application/vnd.github.wyandotte-preview+json"
            },
            method: "DELETE",
            params: {
                migration_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/user/migrations/:migration_id/archive"
        },
        deleteArchiveForOrg: {
            headers: {
                accept: "application/vnd.github.wyandotte-preview+json"
            },
            method: "DELETE",
            params: {
                migration_id: {
                    required: true,
                    type: "integer"
                },
                org: {
                    required: true,
                    type: "string"
                }
            },
            url: "/orgs/:org/migrations/:migration_id/archive"
        },
        downloadArchiveForOrg: {
            headers: {
                accept: "application/vnd.github.wyandotte-preview+json"
            },
            method: "GET",
            params: {
                migration_id: {
                    required: true,
                    type: "integer"
                },
                org: {
                    required: true,
                    type: "string"
                }
            },
            url: "/orgs/:org/migrations/:migration_id/archive"
        },
        getArchiveForAuthenticatedUser: {
            headers: {
                accept: "application/vnd.github.wyandotte-preview+json"
            },
            method: "GET",
            params: {
                migration_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/user/migrations/:migration_id/archive"
        },
        getArchiveForOrg: {
            deprecated: "octokit.migrations.getArchiveForOrg() has been renamed to octokit.migrations.downloadArchiveForOrg() (2020-01-27)",
            headers: {
                accept: "application/vnd.github.wyandotte-preview+json"
            },
            method: "GET",
            params: {
                migration_id: {
                    required: true,
                    type: "integer"
                },
                org: {
                    required: true,
                    type: "string"
                }
            },
            url: "/orgs/:org/migrations/:migration_id/archive"
        },
        getCommitAuthors: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                since: {
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/import/authors"
        },
        getImportProgress: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/import"
        },
        getLargeFiles: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/import/large_files"
        },
        getStatusForAuthenticatedUser: {
            headers: {
                accept: "application/vnd.github.wyandotte-preview+json"
            },
            method: "GET",
            params: {
                migration_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/user/migrations/:migration_id"
        },
        getStatusForOrg: {
            headers: {
                accept: "application/vnd.github.wyandotte-preview+json"
            },
            method: "GET",
            params: {
                migration_id: {
                    required: true,
                    type: "integer"
                },
                org: {
                    required: true,
                    type: "string"
                }
            },
            url: "/orgs/:org/migrations/:migration_id"
        },
        listForAuthenticatedUser: {
            headers: {
                accept: "application/vnd.github.wyandotte-preview+json"
            },
            method: "GET",
            params: {
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                }
            },
            url: "/user/migrations"
        },
        listForOrg: {
            headers: {
                accept: "application/vnd.github.wyandotte-preview+json"
            },
            method: "GET",
            params: {
                org: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                }
            },
            url: "/orgs/:org/migrations"
        },
        listReposForOrg: {
            headers: {
                accept: "application/vnd.github.wyandotte-preview+json"
            },
            method: "GET",
            params: {
                migration_id: {
                    required: true,
                    type: "integer"
                },
                org: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                }
            },
            url: "/orgs/:org/migrations/:migration_id/repositories"
        },
        listReposForUser: {
            headers: {
                accept: "application/vnd.github.wyandotte-preview+json"
            },
            method: "GET",
            params: {
                migration_id: {
                    required: true,
                    type: "integer"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                }
            },
            url: "/user/:migration_id/repositories"
        },
        mapCommitAuthor: {
            method: "PATCH",
            params: {
                author_id: {
                    required: true,
                    type: "integer"
                },
                email: {
                    type: "string"
                },
                name: {
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/import/authors/:author_id"
        },
        setLfsPreference: {
            method: "PATCH",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                use_lfs: {
                    enum: [
                        "opt_in",
                        "opt_out"
                    ],
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/import/lfs"
        },
        startForAuthenticatedUser: {
            method: "POST",
            params: {
                exclude_attachments: {
                    type: "boolean"
                },
                lock_repositories: {
                    type: "boolean"
                },
                repositories: {
                    required: true,
                    type: "string[]"
                }
            },
            url: "/user/migrations"
        },
        startForOrg: {
            method: "POST",
            params: {
                exclude_attachments: {
                    type: "boolean"
                },
                lock_repositories: {
                    type: "boolean"
                },
                org: {
                    required: true,
                    type: "string"
                },
                repositories: {
                    required: true,
                    type: "string[]"
                }
            },
            url: "/orgs/:org/migrations"
        },
        startImport: {
            method: "PUT",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                tfvc_project: {
                    type: "string"
                },
                vcs: {
                    enum: [
                        "subversion",
                        "git",
                        "mercurial",
                        "tfvc"
                    ],
                    type: "string"
                },
                vcs_password: {
                    type: "string"
                },
                vcs_url: {
                    required: true,
                    type: "string"
                },
                vcs_username: {
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/import"
        },
        unlockRepoForAuthenticatedUser: {
            headers: {
                accept: "application/vnd.github.wyandotte-preview+json"
            },
            method: "DELETE",
            params: {
                migration_id: {
                    required: true,
                    type: "integer"
                },
                repo_name: {
                    required: true,
                    type: "string"
                }
            },
            url: "/user/migrations/:migration_id/repos/:repo_name/lock"
        },
        unlockRepoForOrg: {
            headers: {
                accept: "application/vnd.github.wyandotte-preview+json"
            },
            method: "DELETE",
            params: {
                migration_id: {
                    required: true,
                    type: "integer"
                },
                org: {
                    required: true,
                    type: "string"
                },
                repo_name: {
                    required: true,
                    type: "string"
                }
            },
            url: "/orgs/:org/migrations/:migration_id/repos/:repo_name/lock"
        },
        updateImport: {
            method: "PATCH",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                vcs_password: {
                    type: "string"
                },
                vcs_username: {
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/import"
        }
    },
    oauthAuthorizations: {
        checkAuthorization: {
            deprecated: "octokit.oauthAuthorizations.checkAuthorization() has been renamed to octokit.apps.checkAuthorization() (2019-11-05)",
            method: "GET",
            params: {
                access_token: {
                    required: true,
                    type: "string"
                },
                client_id: {
                    required: true,
                    type: "string"
                }
            },
            url: "/applications/:client_id/tokens/:access_token"
        },
        createAuthorization: {
            deprecated: "octokit.oauthAuthorizations.createAuthorization() is deprecated, see https://developer.github.com/v3/oauth_authorizations/#create-a-new-authorization",
            method: "POST",
            params: {
                client_id: {
                    type: "string"
                },
                client_secret: {
                    type: "string"
                },
                fingerprint: {
                    type: "string"
                },
                note: {
                    required: true,
                    type: "string"
                },
                note_url: {
                    type: "string"
                },
                scopes: {
                    type: "string[]"
                }
            },
            url: "/authorizations"
        },
        deleteAuthorization: {
            deprecated: "octokit.oauthAuthorizations.deleteAuthorization() is deprecated, see https://developer.github.com/v3/oauth_authorizations/#delete-an-authorization",
            method: "DELETE",
            params: {
                authorization_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/authorizations/:authorization_id"
        },
        deleteGrant: {
            deprecated: "octokit.oauthAuthorizations.deleteGrant() is deprecated, see https://developer.github.com/v3/oauth_authorizations/#delete-a-grant",
            method: "DELETE",
            params: {
                grant_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/applications/grants/:grant_id"
        },
        getAuthorization: {
            deprecated: "octokit.oauthAuthorizations.getAuthorization() is deprecated, see https://developer.github.com/v3/oauth_authorizations/#get-a-single-authorization",
            method: "GET",
            params: {
                authorization_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/authorizations/:authorization_id"
        },
        getGrant: {
            deprecated: "octokit.oauthAuthorizations.getGrant() is deprecated, see https://developer.github.com/v3/oauth_authorizations/#get-a-single-grant",
            method: "GET",
            params: {
                grant_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/applications/grants/:grant_id"
        },
        getOrCreateAuthorizationForApp: {
            deprecated: "octokit.oauthAuthorizations.getOrCreateAuthorizationForApp() is deprecated, see https://developer.github.com/v3/oauth_authorizations/#get-or-create-an-authorization-for-a-specific-app",
            method: "PUT",
            params: {
                client_id: {
                    required: true,
                    type: "string"
                },
                client_secret: {
                    required: true,
                    type: "string"
                },
                fingerprint: {
                    type: "string"
                },
                note: {
                    type: "string"
                },
                note_url: {
                    type: "string"
                },
                scopes: {
                    type: "string[]"
                }
            },
            url: "/authorizations/clients/:client_id"
        },
        getOrCreateAuthorizationForAppAndFingerprint: {
            deprecated: "octokit.oauthAuthorizations.getOrCreateAuthorizationForAppAndFingerprint() is deprecated, see https://developer.github.com/v3/oauth_authorizations/#get-or-create-an-authorization-for-a-specific-app-and-fingerprint",
            method: "PUT",
            params: {
                client_id: {
                    required: true,
                    type: "string"
                },
                client_secret: {
                    required: true,
                    type: "string"
                },
                fingerprint: {
                    required: true,
                    type: "string"
                },
                note: {
                    type: "string"
                },
                note_url: {
                    type: "string"
                },
                scopes: {
                    type: "string[]"
                }
            },
            url: "/authorizations/clients/:client_id/:fingerprint"
        },
        getOrCreateAuthorizationForAppFingerprint: {
            deprecated: "octokit.oauthAuthorizations.getOrCreateAuthorizationForAppFingerprint() has been renamed to octokit.oauthAuthorizations.getOrCreateAuthorizationForAppAndFingerprint() (2018-12-27)",
            method: "PUT",
            params: {
                client_id: {
                    required: true,
                    type: "string"
                },
                client_secret: {
                    required: true,
                    type: "string"
                },
                fingerprint: {
                    required: true,
                    type: "string"
                },
                note: {
                    type: "string"
                },
                note_url: {
                    type: "string"
                },
                scopes: {
                    type: "string[]"
                }
            },
            url: "/authorizations/clients/:client_id/:fingerprint"
        },
        listAuthorizations: {
            deprecated: "octokit.oauthAuthorizations.listAuthorizations() is deprecated, see https://developer.github.com/v3/oauth_authorizations/#list-your-authorizations",
            method: "GET",
            params: {
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                }
            },
            url: "/authorizations"
        },
        listGrants: {
            deprecated: "octokit.oauthAuthorizations.listGrants() is deprecated, see https://developer.github.com/v3/oauth_authorizations/#list-your-grants",
            method: "GET",
            params: {
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                }
            },
            url: "/applications/grants"
        },
        resetAuthorization: {
            deprecated: "octokit.oauthAuthorizations.resetAuthorization() has been renamed to octokit.apps.resetAuthorization() (2019-11-05)",
            method: "POST",
            params: {
                access_token: {
                    required: true,
                    type: "string"
                },
                client_id: {
                    required: true,
                    type: "string"
                }
            },
            url: "/applications/:client_id/tokens/:access_token"
        },
        revokeAuthorizationForApplication: {
            deprecated: "octokit.oauthAuthorizations.revokeAuthorizationForApplication() has been renamed to octokit.apps.revokeAuthorizationForApplication() (2019-11-05)",
            method: "DELETE",
            params: {
                access_token: {
                    required: true,
                    type: "string"
                },
                client_id: {
                    required: true,
                    type: "string"
                }
            },
            url: "/applications/:client_id/tokens/:access_token"
        },
        revokeGrantForApplication: {
            deprecated: "octokit.oauthAuthorizations.revokeGrantForApplication() has been renamed to octokit.apps.revokeGrantForApplication() (2019-11-05)",
            method: "DELETE",
            params: {
                access_token: {
                    required: true,
                    type: "string"
                },
                client_id: {
                    required: true,
                    type: "string"
                }
            },
            url: "/applications/:client_id/grants/:access_token"
        },
        updateAuthorization: {
            deprecated: "octokit.oauthAuthorizations.updateAuthorization() is deprecated, see https://developer.github.com/v3/oauth_authorizations/#update-an-existing-authorization",
            method: "PATCH",
            params: {
                add_scopes: {
                    type: "string[]"
                },
                authorization_id: {
                    required: true,
                    type: "integer"
                },
                fingerprint: {
                    type: "string"
                },
                note: {
                    type: "string"
                },
                note_url: {
                    type: "string"
                },
                remove_scopes: {
                    type: "string[]"
                },
                scopes: {
                    type: "string[]"
                }
            },
            url: "/authorizations/:authorization_id"
        }
    },
    orgs: {
        addOrUpdateMembership: {
            method: "PUT",
            params: {
                org: {
                    required: true,
                    type: "string"
                },
                role: {
                    enum: [
                        "admin",
                        "member"
                    ],
                    type: "string"
                },
                username: {
                    required: true,
                    type: "string"
                }
            },
            url: "/orgs/:org/memberships/:username"
        },
        blockUser: {
            method: "PUT",
            params: {
                org: {
                    required: true,
                    type: "string"
                },
                username: {
                    required: true,
                    type: "string"
                }
            },
            url: "/orgs/:org/blocks/:username"
        },
        checkBlockedUser: {
            method: "GET",
            params: {
                org: {
                    required: true,
                    type: "string"
                },
                username: {
                    required: true,
                    type: "string"
                }
            },
            url: "/orgs/:org/blocks/:username"
        },
        checkMembership: {
            method: "GET",
            params: {
                org: {
                    required: true,
                    type: "string"
                },
                username: {
                    required: true,
                    type: "string"
                }
            },
            url: "/orgs/:org/members/:username"
        },
        checkPublicMembership: {
            method: "GET",
            params: {
                org: {
                    required: true,
                    type: "string"
                },
                username: {
                    required: true,
                    type: "string"
                }
            },
            url: "/orgs/:org/public_members/:username"
        },
        concealMembership: {
            method: "DELETE",
            params: {
                org: {
                    required: true,
                    type: "string"
                },
                username: {
                    required: true,
                    type: "string"
                }
            },
            url: "/orgs/:org/public_members/:username"
        },
        convertMemberToOutsideCollaborator: {
            method: "PUT",
            params: {
                org: {
                    required: true,
                    type: "string"
                },
                username: {
                    required: true,
                    type: "string"
                }
            },
            url: "/orgs/:org/outside_collaborators/:username"
        },
        createHook: {
            method: "POST",
            params: {
                active: {
                    type: "boolean"
                },
                config: {
                    required: true,
                    type: "object"
                },
                "config.content_type": {
                    type: "string"
                },
                "config.insecure_ssl": {
                    type: "string"
                },
                "config.secret": {
                    type: "string"
                },
                "config.url": {
                    required: true,
                    type: "string"
                },
                events: {
                    type: "string[]"
                },
                name: {
                    required: true,
                    type: "string"
                },
                org: {
                    required: true,
                    type: "string"
                }
            },
            url: "/orgs/:org/hooks"
        },
        createInvitation: {
            method: "POST",
            params: {
                email: {
                    type: "string"
                },
                invitee_id: {
                    type: "integer"
                },
                org: {
                    required: true,
                    type: "string"
                },
                role: {
                    enum: [
                        "admin",
                        "direct_member",
                        "billing_manager"
                    ],
                    type: "string"
                },
                team_ids: {
                    type: "integer[]"
                }
            },
            url: "/orgs/:org/invitations"
        },
        deleteHook: {
            method: "DELETE",
            params: {
                hook_id: {
                    required: true,
                    type: "integer"
                },
                org: {
                    required: true,
                    type: "string"
                }
            },
            url: "/orgs/:org/hooks/:hook_id"
        },
        get: {
            method: "GET",
            params: {
                org: {
                    required: true,
                    type: "string"
                }
            },
            url: "/orgs/:org"
        },
        getHook: {
            method: "GET",
            params: {
                hook_id: {
                    required: true,
                    type: "integer"
                },
                org: {
                    required: true,
                    type: "string"
                }
            },
            url: "/orgs/:org/hooks/:hook_id"
        },
        getMembership: {
            method: "GET",
            params: {
                org: {
                    required: true,
                    type: "string"
                },
                username: {
                    required: true,
                    type: "string"
                }
            },
            url: "/orgs/:org/memberships/:username"
        },
        getMembershipForAuthenticatedUser: {
            method: "GET",
            params: {
                org: {
                    required: true,
                    type: "string"
                }
            },
            url: "/user/memberships/orgs/:org"
        },
        list: {
            method: "GET",
            params: {
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                since: {
                    type: "integer"
                }
            },
            url: "/organizations"
        },
        listBlockedUsers: {
            method: "GET",
            params: {
                org: {
                    required: true,
                    type: "string"
                }
            },
            url: "/orgs/:org/blocks"
        },
        listForAuthenticatedUser: {
            method: "GET",
            params: {
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                }
            },
            url: "/user/orgs"
        },
        listForUser: {
            method: "GET",
            params: {
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                username: {
                    required: true,
                    type: "string"
                }
            },
            url: "/users/:username/orgs"
        },
        listHooks: {
            method: "GET",
            params: {
                org: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                }
            },
            url: "/orgs/:org/hooks"
        },
        listInstallations: {
            headers: {
                accept: "application/vnd.github.machine-man-preview+json"
            },
            method: "GET",
            params: {
                org: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                }
            },
            url: "/orgs/:org/installations"
        },
        listInvitationTeams: {
            method: "GET",
            params: {
                invitation_id: {
                    required: true,
                    type: "integer"
                },
                org: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                }
            },
            url: "/orgs/:org/invitations/:invitation_id/teams"
        },
        listMembers: {
            method: "GET",
            params: {
                filter: {
                    enum: [
                        "2fa_disabled",
                        "all"
                    ],
                    type: "string"
                },
                org: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                role: {
                    enum: [
                        "all",
                        "admin",
                        "member"
                    ],
                    type: "string"
                }
            },
            url: "/orgs/:org/members"
        },
        listMemberships: {
            method: "GET",
            params: {
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                state: {
                    enum: [
                        "active",
                        "pending"
                    ],
                    type: "string"
                }
            },
            url: "/user/memberships/orgs"
        },
        listOutsideCollaborators: {
            method: "GET",
            params: {
                filter: {
                    enum: [
                        "2fa_disabled",
                        "all"
                    ],
                    type: "string"
                },
                org: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                }
            },
            url: "/orgs/:org/outside_collaborators"
        },
        listPendingInvitations: {
            method: "GET",
            params: {
                org: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                }
            },
            url: "/orgs/:org/invitations"
        },
        listPublicMembers: {
            method: "GET",
            params: {
                org: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                }
            },
            url: "/orgs/:org/public_members"
        },
        pingHook: {
            method: "POST",
            params: {
                hook_id: {
                    required: true,
                    type: "integer"
                },
                org: {
                    required: true,
                    type: "string"
                }
            },
            url: "/orgs/:org/hooks/:hook_id/pings"
        },
        publicizeMembership: {
            method: "PUT",
            params: {
                org: {
                    required: true,
                    type: "string"
                },
                username: {
                    required: true,
                    type: "string"
                }
            },
            url: "/orgs/:org/public_members/:username"
        },
        removeMember: {
            method: "DELETE",
            params: {
                org: {
                    required: true,
                    type: "string"
                },
                username: {
                    required: true,
                    type: "string"
                }
            },
            url: "/orgs/:org/members/:username"
        },
        removeMembership: {
            method: "DELETE",
            params: {
                org: {
                    required: true,
                    type: "string"
                },
                username: {
                    required: true,
                    type: "string"
                }
            },
            url: "/orgs/:org/memberships/:username"
        },
        removeOutsideCollaborator: {
            method: "DELETE",
            params: {
                org: {
                    required: true,
                    type: "string"
                },
                username: {
                    required: true,
                    type: "string"
                }
            },
            url: "/orgs/:org/outside_collaborators/:username"
        },
        unblockUser: {
            method: "DELETE",
            params: {
                org: {
                    required: true,
                    type: "string"
                },
                username: {
                    required: true,
                    type: "string"
                }
            },
            url: "/orgs/:org/blocks/:username"
        },
        update: {
            method: "PATCH",
            params: {
                billing_email: {
                    type: "string"
                },
                company: {
                    type: "string"
                },
                default_repository_permission: {
                    enum: [
                        "read",
                        "write",
                        "admin",
                        "none"
                    ],
                    type: "string"
                },
                description: {
                    type: "string"
                },
                email: {
                    type: "string"
                },
                has_organization_projects: {
                    type: "boolean"
                },
                has_repository_projects: {
                    type: "boolean"
                },
                location: {
                    type: "string"
                },
                members_allowed_repository_creation_type: {
                    enum: [
                        "all",
                        "private",
                        "none"
                    ],
                    type: "string"
                },
                members_can_create_internal_repositories: {
                    type: "boolean"
                },
                members_can_create_private_repositories: {
                    type: "boolean"
                },
                members_can_create_public_repositories: {
                    type: "boolean"
                },
                members_can_create_repositories: {
                    type: "boolean"
                },
                name: {
                    type: "string"
                },
                org: {
                    required: true,
                    type: "string"
                }
            },
            url: "/orgs/:org"
        },
        updateHook: {
            method: "PATCH",
            params: {
                active: {
                    type: "boolean"
                },
                config: {
                    type: "object"
                },
                "config.content_type": {
                    type: "string"
                },
                "config.insecure_ssl": {
                    type: "string"
                },
                "config.secret": {
                    type: "string"
                },
                "config.url": {
                    required: true,
                    type: "string"
                },
                events: {
                    type: "string[]"
                },
                hook_id: {
                    required: true,
                    type: "integer"
                },
                org: {
                    required: true,
                    type: "string"
                }
            },
            url: "/orgs/:org/hooks/:hook_id"
        },
        updateMembership: {
            method: "PATCH",
            params: {
                org: {
                    required: true,
                    type: "string"
                },
                state: {
                    enum: [
                        "active"
                    ],
                    required: true,
                    type: "string"
                }
            },
            url: "/user/memberships/orgs/:org"
        }
    },
    projects: {
        addCollaborator: {
            headers: {
                accept: "application/vnd.github.inertia-preview+json"
            },
            method: "PUT",
            params: {
                permission: {
                    enum: [
                        "read",
                        "write",
                        "admin"
                    ],
                    type: "string"
                },
                project_id: {
                    required: true,
                    type: "integer"
                },
                username: {
                    required: true,
                    type: "string"
                }
            },
            url: "/projects/:project_id/collaborators/:username"
        },
        createCard: {
            headers: {
                accept: "application/vnd.github.inertia-preview+json"
            },
            method: "POST",
            params: {
                column_id: {
                    required: true,
                    type: "integer"
                },
                content_id: {
                    type: "integer"
                },
                content_type: {
                    type: "string"
                },
                note: {
                    type: "string"
                }
            },
            url: "/projects/columns/:column_id/cards"
        },
        createColumn: {
            headers: {
                accept: "application/vnd.github.inertia-preview+json"
            },
            method: "POST",
            params: {
                name: {
                    required: true,
                    type: "string"
                },
                project_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/projects/:project_id/columns"
        },
        createForAuthenticatedUser: {
            headers: {
                accept: "application/vnd.github.inertia-preview+json"
            },
            method: "POST",
            params: {
                body: {
                    type: "string"
                },
                name: {
                    required: true,
                    type: "string"
                }
            },
            url: "/user/projects"
        },
        createForOrg: {
            headers: {
                accept: "application/vnd.github.inertia-preview+json"
            },
            method: "POST",
            params: {
                body: {
                    type: "string"
                },
                name: {
                    required: true,
                    type: "string"
                },
                org: {
                    required: true,
                    type: "string"
                }
            },
            url: "/orgs/:org/projects"
        },
        createForRepo: {
            headers: {
                accept: "application/vnd.github.inertia-preview+json"
            },
            method: "POST",
            params: {
                body: {
                    type: "string"
                },
                name: {
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/projects"
        },
        delete: {
            headers: {
                accept: "application/vnd.github.inertia-preview+json"
            },
            method: "DELETE",
            params: {
                project_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/projects/:project_id"
        },
        deleteCard: {
            headers: {
                accept: "application/vnd.github.inertia-preview+json"
            },
            method: "DELETE",
            params: {
                card_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/projects/columns/cards/:card_id"
        },
        deleteColumn: {
            headers: {
                accept: "application/vnd.github.inertia-preview+json"
            },
            method: "DELETE",
            params: {
                column_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/projects/columns/:column_id"
        },
        get: {
            headers: {
                accept: "application/vnd.github.inertia-preview+json"
            },
            method: "GET",
            params: {
                project_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/projects/:project_id"
        },
        getCard: {
            headers: {
                accept: "application/vnd.github.inertia-preview+json"
            },
            method: "GET",
            params: {
                card_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/projects/columns/cards/:card_id"
        },
        getColumn: {
            headers: {
                accept: "application/vnd.github.inertia-preview+json"
            },
            method: "GET",
            params: {
                column_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/projects/columns/:column_id"
        },
        listCards: {
            headers: {
                accept: "application/vnd.github.inertia-preview+json"
            },
            method: "GET",
            params: {
                archived_state: {
                    enum: [
                        "all",
                        "archived",
                        "not_archived"
                    ],
                    type: "string"
                },
                column_id: {
                    required: true,
                    type: "integer"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                }
            },
            url: "/projects/columns/:column_id/cards"
        },
        listCollaborators: {
            headers: {
                accept: "application/vnd.github.inertia-preview+json"
            },
            method: "GET",
            params: {
                affiliation: {
                    enum: [
                        "outside",
                        "direct",
                        "all"
                    ],
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                project_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/projects/:project_id/collaborators"
        },
        listColumns: {
            headers: {
                accept: "application/vnd.github.inertia-preview+json"
            },
            method: "GET",
            params: {
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                project_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/projects/:project_id/columns"
        },
        listForOrg: {
            headers: {
                accept: "application/vnd.github.inertia-preview+json"
            },
            method: "GET",
            params: {
                org: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                state: {
                    enum: [
                        "open",
                        "closed",
                        "all"
                    ],
                    type: "string"
                }
            },
            url: "/orgs/:org/projects"
        },
        listForRepo: {
            headers: {
                accept: "application/vnd.github.inertia-preview+json"
            },
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                state: {
                    enum: [
                        "open",
                        "closed",
                        "all"
                    ],
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/projects"
        },
        listForUser: {
            headers: {
                accept: "application/vnd.github.inertia-preview+json"
            },
            method: "GET",
            params: {
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                state: {
                    enum: [
                        "open",
                        "closed",
                        "all"
                    ],
                    type: "string"
                },
                username: {
                    required: true,
                    type: "string"
                }
            },
            url: "/users/:username/projects"
        },
        moveCard: {
            headers: {
                accept: "application/vnd.github.inertia-preview+json"
            },
            method: "POST",
            params: {
                card_id: {
                    required: true,
                    type: "integer"
                },
                column_id: {
                    type: "integer"
                },
                position: {
                    required: true,
                    type: "string",
                    validation: "^(top|bottom|after:\\d+)$"
                }
            },
            url: "/projects/columns/cards/:card_id/moves"
        },
        moveColumn: {
            headers: {
                accept: "application/vnd.github.inertia-preview+json"
            },
            method: "POST",
            params: {
                column_id: {
                    required: true,
                    type: "integer"
                },
                position: {
                    required: true,
                    type: "string",
                    validation: "^(first|last|after:\\d+)$"
                }
            },
            url: "/projects/columns/:column_id/moves"
        },
        removeCollaborator: {
            headers: {
                accept: "application/vnd.github.inertia-preview+json"
            },
            method: "DELETE",
            params: {
                project_id: {
                    required: true,
                    type: "integer"
                },
                username: {
                    required: true,
                    type: "string"
                }
            },
            url: "/projects/:project_id/collaborators/:username"
        },
        reviewUserPermissionLevel: {
            headers: {
                accept: "application/vnd.github.inertia-preview+json"
            },
            method: "GET",
            params: {
                project_id: {
                    required: true,
                    type: "integer"
                },
                username: {
                    required: true,
                    type: "string"
                }
            },
            url: "/projects/:project_id/collaborators/:username/permission"
        },
        update: {
            headers: {
                accept: "application/vnd.github.inertia-preview+json"
            },
            method: "PATCH",
            params: {
                body: {
                    type: "string"
                },
                name: {
                    type: "string"
                },
                organization_permission: {
                    type: "string"
                },
                private: {
                    type: "boolean"
                },
                project_id: {
                    required: true,
                    type: "integer"
                },
                state: {
                    enum: [
                        "open",
                        "closed"
                    ],
                    type: "string"
                }
            },
            url: "/projects/:project_id"
        },
        updateCard: {
            headers: {
                accept: "application/vnd.github.inertia-preview+json"
            },
            method: "PATCH",
            params: {
                archived: {
                    type: "boolean"
                },
                card_id: {
                    required: true,
                    type: "integer"
                },
                note: {
                    type: "string"
                }
            },
            url: "/projects/columns/cards/:card_id"
        },
        updateColumn: {
            headers: {
                accept: "application/vnd.github.inertia-preview+json"
            },
            method: "PATCH",
            params: {
                column_id: {
                    required: true,
                    type: "integer"
                },
                name: {
                    required: true,
                    type: "string"
                }
            },
            url: "/projects/columns/:column_id"
        }
    },
    pulls: {
        checkIfMerged: {
            method: "GET",
            params: {
                number: {
                    alias: "pull_number",
                    deprecated: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                pull_number: {
                    required: true,
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/pulls/:pull_number/merge"
        },
        create: {
            method: "POST",
            params: {
                base: {
                    required: true,
                    type: "string"
                },
                body: {
                    type: "string"
                },
                draft: {
                    type: "boolean"
                },
                head: {
                    required: true,
                    type: "string"
                },
                maintainer_can_modify: {
                    type: "boolean"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                title: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/pulls"
        },
        createComment: {
            method: "POST",
            params: {
                body: {
                    required: true,
                    type: "string"
                },
                commit_id: {
                    required: true,
                    type: "string"
                },
                in_reply_to: {
                    deprecated: true,
                    description: "The comment ID to reply to. **Note**: This must be the ID of a top-level comment, not a reply to that comment. Replies to replies are not supported.",
                    type: "integer"
                },
                line: {
                    type: "integer"
                },
                number: {
                    alias: "pull_number",
                    deprecated: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                path: {
                    required: true,
                    type: "string"
                },
                position: {
                    type: "integer"
                },
                pull_number: {
                    required: true,
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                side: {
                    enum: [
                        "LEFT",
                        "RIGHT"
                    ],
                    type: "string"
                },
                start_line: {
                    type: "integer"
                },
                start_side: {
                    enum: [
                        "LEFT",
                        "RIGHT",
                        "side"
                    ],
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/pulls/:pull_number/comments"
        },
        createCommentReply: {
            deprecated: "octokit.pulls.createCommentReply() has been renamed to octokit.pulls.createComment() (2019-09-09)",
            method: "POST",
            params: {
                body: {
                    required: true,
                    type: "string"
                },
                commit_id: {
                    required: true,
                    type: "string"
                },
                in_reply_to: {
                    deprecated: true,
                    description: "The comment ID to reply to. **Note**: This must be the ID of a top-level comment, not a reply to that comment. Replies to replies are not supported.",
                    type: "integer"
                },
                line: {
                    type: "integer"
                },
                number: {
                    alias: "pull_number",
                    deprecated: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                path: {
                    required: true,
                    type: "string"
                },
                position: {
                    type: "integer"
                },
                pull_number: {
                    required: true,
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                side: {
                    enum: [
                        "LEFT",
                        "RIGHT"
                    ],
                    type: "string"
                },
                start_line: {
                    type: "integer"
                },
                start_side: {
                    enum: [
                        "LEFT",
                        "RIGHT",
                        "side"
                    ],
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/pulls/:pull_number/comments"
        },
        createFromIssue: {
            deprecated: "octokit.pulls.createFromIssue() is deprecated, see https://developer.github.com/v3/pulls/#create-a-pull-request",
            method: "POST",
            params: {
                base: {
                    required: true,
                    type: "string"
                },
                draft: {
                    type: "boolean"
                },
                head: {
                    required: true,
                    type: "string"
                },
                issue: {
                    required: true,
                    type: "integer"
                },
                maintainer_can_modify: {
                    type: "boolean"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/pulls"
        },
        createReview: {
            method: "POST",
            params: {
                body: {
                    type: "string"
                },
                comments: {
                    type: "object[]"
                },
                "comments[].body": {
                    required: true,
                    type: "string"
                },
                "comments[].path": {
                    required: true,
                    type: "string"
                },
                "comments[].position": {
                    required: true,
                    type: "integer"
                },
                commit_id: {
                    type: "string"
                },
                event: {
                    enum: [
                        "APPROVE",
                        "REQUEST_CHANGES",
                        "COMMENT"
                    ],
                    type: "string"
                },
                number: {
                    alias: "pull_number",
                    deprecated: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                pull_number: {
                    required: true,
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/pulls/:pull_number/reviews"
        },
        createReviewCommentReply: {
            method: "POST",
            params: {
                body: {
                    required: true,
                    type: "string"
                },
                comment_id: {
                    required: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                pull_number: {
                    required: true,
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/pulls/:pull_number/comments/:comment_id/replies"
        },
        createReviewRequest: {
            method: "POST",
            params: {
                number: {
                    alias: "pull_number",
                    deprecated: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                pull_number: {
                    required: true,
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                reviewers: {
                    type: "string[]"
                },
                team_reviewers: {
                    type: "string[]"
                }
            },
            url: "/repos/:owner/:repo/pulls/:pull_number/requested_reviewers"
        },
        deleteComment: {
            method: "DELETE",
            params: {
                comment_id: {
                    required: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/pulls/comments/:comment_id"
        },
        deletePendingReview: {
            method: "DELETE",
            params: {
                number: {
                    alias: "pull_number",
                    deprecated: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                pull_number: {
                    required: true,
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                review_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/repos/:owner/:repo/pulls/:pull_number/reviews/:review_id"
        },
        deleteReviewRequest: {
            method: "DELETE",
            params: {
                number: {
                    alias: "pull_number",
                    deprecated: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                pull_number: {
                    required: true,
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                reviewers: {
                    type: "string[]"
                },
                team_reviewers: {
                    type: "string[]"
                }
            },
            url: "/repos/:owner/:repo/pulls/:pull_number/requested_reviewers"
        },
        dismissReview: {
            method: "PUT",
            params: {
                message: {
                    required: true,
                    type: "string"
                },
                number: {
                    alias: "pull_number",
                    deprecated: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                pull_number: {
                    required: true,
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                review_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/repos/:owner/:repo/pulls/:pull_number/reviews/:review_id/dismissals"
        },
        get: {
            method: "GET",
            params: {
                number: {
                    alias: "pull_number",
                    deprecated: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                pull_number: {
                    required: true,
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/pulls/:pull_number"
        },
        getComment: {
            method: "GET",
            params: {
                comment_id: {
                    required: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/pulls/comments/:comment_id"
        },
        getCommentsForReview: {
            method: "GET",
            params: {
                number: {
                    alias: "pull_number",
                    deprecated: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                pull_number: {
                    required: true,
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                review_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/repos/:owner/:repo/pulls/:pull_number/reviews/:review_id/comments"
        },
        getReview: {
            method: "GET",
            params: {
                number: {
                    alias: "pull_number",
                    deprecated: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                pull_number: {
                    required: true,
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                review_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/repos/:owner/:repo/pulls/:pull_number/reviews/:review_id"
        },
        list: {
            method: "GET",
            params: {
                base: {
                    type: "string"
                },
                direction: {
                    enum: [
                        "asc",
                        "desc"
                    ],
                    type: "string"
                },
                head: {
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                sort: {
                    enum: [
                        "created",
                        "updated",
                        "popularity",
                        "long-running"
                    ],
                    type: "string"
                },
                state: {
                    enum: [
                        "open",
                        "closed",
                        "all"
                    ],
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/pulls"
        },
        listComments: {
            method: "GET",
            params: {
                direction: {
                    enum: [
                        "asc",
                        "desc"
                    ],
                    type: "string"
                },
                number: {
                    alias: "pull_number",
                    deprecated: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                pull_number: {
                    required: true,
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                since: {
                    type: "string"
                },
                sort: {
                    enum: [
                        "created",
                        "updated"
                    ],
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/pulls/:pull_number/comments"
        },
        listCommentsForRepo: {
            method: "GET",
            params: {
                direction: {
                    enum: [
                        "asc",
                        "desc"
                    ],
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                since: {
                    type: "string"
                },
                sort: {
                    enum: [
                        "created",
                        "updated"
                    ],
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/pulls/comments"
        },
        listCommits: {
            method: "GET",
            params: {
                number: {
                    alias: "pull_number",
                    deprecated: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                pull_number: {
                    required: true,
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/pulls/:pull_number/commits"
        },
        listFiles: {
            method: "GET",
            params: {
                number: {
                    alias: "pull_number",
                    deprecated: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                pull_number: {
                    required: true,
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/pulls/:pull_number/files"
        },
        listReviewRequests: {
            method: "GET",
            params: {
                number: {
                    alias: "pull_number",
                    deprecated: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                pull_number: {
                    required: true,
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/pulls/:pull_number/requested_reviewers"
        },
        listReviews: {
            method: "GET",
            params: {
                number: {
                    alias: "pull_number",
                    deprecated: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                pull_number: {
                    required: true,
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/pulls/:pull_number/reviews"
        },
        merge: {
            method: "PUT",
            params: {
                commit_message: {
                    type: "string"
                },
                commit_title: {
                    type: "string"
                },
                merge_method: {
                    enum: [
                        "merge",
                        "squash",
                        "rebase"
                    ],
                    type: "string"
                },
                number: {
                    alias: "pull_number",
                    deprecated: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                pull_number: {
                    required: true,
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                sha: {
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/pulls/:pull_number/merge"
        },
        submitReview: {
            method: "POST",
            params: {
                body: {
                    type: "string"
                },
                event: {
                    enum: [
                        "APPROVE",
                        "REQUEST_CHANGES",
                        "COMMENT"
                    ],
                    required: true,
                    type: "string"
                },
                number: {
                    alias: "pull_number",
                    deprecated: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                pull_number: {
                    required: true,
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                review_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/repos/:owner/:repo/pulls/:pull_number/reviews/:review_id/events"
        },
        update: {
            method: "PATCH",
            params: {
                base: {
                    type: "string"
                },
                body: {
                    type: "string"
                },
                maintainer_can_modify: {
                    type: "boolean"
                },
                number: {
                    alias: "pull_number",
                    deprecated: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                pull_number: {
                    required: true,
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                state: {
                    enum: [
                        "open",
                        "closed"
                    ],
                    type: "string"
                },
                title: {
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/pulls/:pull_number"
        },
        updateBranch: {
            headers: {
                accept: "application/vnd.github.lydian-preview+json"
            },
            method: "PUT",
            params: {
                expected_head_sha: {
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                pull_number: {
                    required: true,
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/pulls/:pull_number/update-branch"
        },
        updateComment: {
            method: "PATCH",
            params: {
                body: {
                    required: true,
                    type: "string"
                },
                comment_id: {
                    required: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/pulls/comments/:comment_id"
        },
        updateReview: {
            method: "PUT",
            params: {
                body: {
                    required: true,
                    type: "string"
                },
                number: {
                    alias: "pull_number",
                    deprecated: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                pull_number: {
                    required: true,
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                review_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/repos/:owner/:repo/pulls/:pull_number/reviews/:review_id"
        }
    },
    rateLimit: {
        get: {
            method: "GET",
            params: {},
            url: "/rate_limit"
        }
    },
    reactions: {
        createForCommitComment: {
            headers: {
                accept: "application/vnd.github.squirrel-girl-preview+json"
            },
            method: "POST",
            params: {
                comment_id: {
                    required: true,
                    type: "integer"
                },
                content: {
                    enum: [
                        "+1",
                        "-1",
                        "laugh",
                        "confused",
                        "heart",
                        "hooray",
                        "rocket",
                        "eyes"
                    ],
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/comments/:comment_id/reactions"
        },
        createForIssue: {
            headers: {
                accept: "application/vnd.github.squirrel-girl-preview+json"
            },
            method: "POST",
            params: {
                content: {
                    enum: [
                        "+1",
                        "-1",
                        "laugh",
                        "confused",
                        "heart",
                        "hooray",
                        "rocket",
                        "eyes"
                    ],
                    required: true,
                    type: "string"
                },
                issue_number: {
                    required: true,
                    type: "integer"
                },
                number: {
                    alias: "issue_number",
                    deprecated: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/issues/:issue_number/reactions"
        },
        createForIssueComment: {
            headers: {
                accept: "application/vnd.github.squirrel-girl-preview+json"
            },
            method: "POST",
            params: {
                comment_id: {
                    required: true,
                    type: "integer"
                },
                content: {
                    enum: [
                        "+1",
                        "-1",
                        "laugh",
                        "confused",
                        "heart",
                        "hooray",
                        "rocket",
                        "eyes"
                    ],
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/issues/comments/:comment_id/reactions"
        },
        createForPullRequestReviewComment: {
            headers: {
                accept: "application/vnd.github.squirrel-girl-preview+json"
            },
            method: "POST",
            params: {
                comment_id: {
                    required: true,
                    type: "integer"
                },
                content: {
                    enum: [
                        "+1",
                        "-1",
                        "laugh",
                        "confused",
                        "heart",
                        "hooray",
                        "rocket",
                        "eyes"
                    ],
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/pulls/comments/:comment_id/reactions"
        },
        createForTeamDiscussion: {
            deprecated: "octokit.reactions.createForTeamDiscussion() has been renamed to octokit.reactions.createForTeamDiscussionLegacy() (2020-01-16)",
            headers: {
                accept: "application/vnd.github.squirrel-girl-preview+json"
            },
            method: "POST",
            params: {
                content: {
                    enum: [
                        "+1",
                        "-1",
                        "laugh",
                        "confused",
                        "heart",
                        "hooray",
                        "rocket",
                        "eyes"
                    ],
                    required: true,
                    type: "string"
                },
                discussion_number: {
                    required: true,
                    type: "integer"
                },
                team_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/teams/:team_id/discussions/:discussion_number/reactions"
        },
        createForTeamDiscussionComment: {
            deprecated: "octokit.reactions.createForTeamDiscussionComment() has been renamed to octokit.reactions.createForTeamDiscussionCommentLegacy() (2020-01-16)",
            headers: {
                accept: "application/vnd.github.squirrel-girl-preview+json"
            },
            method: "POST",
            params: {
                comment_number: {
                    required: true,
                    type: "integer"
                },
                content: {
                    enum: [
                        "+1",
                        "-1",
                        "laugh",
                        "confused",
                        "heart",
                        "hooray",
                        "rocket",
                        "eyes"
                    ],
                    required: true,
                    type: "string"
                },
                discussion_number: {
                    required: true,
                    type: "integer"
                },
                team_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/teams/:team_id/discussions/:discussion_number/comments/:comment_number/reactions"
        },
        createForTeamDiscussionCommentInOrg: {
            headers: {
                accept: "application/vnd.github.squirrel-girl-preview+json"
            },
            method: "POST",
            params: {
                comment_number: {
                    required: true,
                    type: "integer"
                },
                content: {
                    enum: [
                        "+1",
                        "-1",
                        "laugh",
                        "confused",
                        "heart",
                        "hooray",
                        "rocket",
                        "eyes"
                    ],
                    required: true,
                    type: "string"
                },
                discussion_number: {
                    required: true,
                    type: "integer"
                },
                org: {
                    required: true,
                    type: "string"
                },
                team_slug: {
                    required: true,
                    type: "string"
                }
            },
            url: "/orgs/:org/teams/:team_slug/discussions/:discussion_number/comments/:comment_number/reactions"
        },
        createForTeamDiscussionCommentLegacy: {
            deprecated: "octokit.reactions.createForTeamDiscussionCommentLegacy() is deprecated, see https://developer.github.com/v3/reactions/#create-reaction-for-a-team-discussion-comment-legacy",
            headers: {
                accept: "application/vnd.github.squirrel-girl-preview+json"
            },
            method: "POST",
            params: {
                comment_number: {
                    required: true,
                    type: "integer"
                },
                content: {
                    enum: [
                        "+1",
                        "-1",
                        "laugh",
                        "confused",
                        "heart",
                        "hooray",
                        "rocket",
                        "eyes"
                    ],
                    required: true,
                    type: "string"
                },
                discussion_number: {
                    required: true,
                    type: "integer"
                },
                team_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/teams/:team_id/discussions/:discussion_number/comments/:comment_number/reactions"
        },
        createForTeamDiscussionInOrg: {
            headers: {
                accept: "application/vnd.github.squirrel-girl-preview+json"
            },
            method: "POST",
            params: {
                content: {
                    enum: [
                        "+1",
                        "-1",
                        "laugh",
                        "confused",
                        "heart",
                        "hooray",
                        "rocket",
                        "eyes"
                    ],
                    required: true,
                    type: "string"
                },
                discussion_number: {
                    required: true,
                    type: "integer"
                },
                org: {
                    required: true,
                    type: "string"
                },
                team_slug: {
                    required: true,
                    type: "string"
                }
            },
            url: "/orgs/:org/teams/:team_slug/discussions/:discussion_number/reactions"
        },
        createForTeamDiscussionLegacy: {
            deprecated: "octokit.reactions.createForTeamDiscussionLegacy() is deprecated, see https://developer.github.com/v3/reactions/#create-reaction-for-a-team-discussion-legacy",
            headers: {
                accept: "application/vnd.github.squirrel-girl-preview+json"
            },
            method: "POST",
            params: {
                content: {
                    enum: [
                        "+1",
                        "-1",
                        "laugh",
                        "confused",
                        "heart",
                        "hooray",
                        "rocket",
                        "eyes"
                    ],
                    required: true,
                    type: "string"
                },
                discussion_number: {
                    required: true,
                    type: "integer"
                },
                team_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/teams/:team_id/discussions/:discussion_number/reactions"
        },
        delete: {
            headers: {
                accept: "application/vnd.github.squirrel-girl-preview+json"
            },
            method: "DELETE",
            params: {
                reaction_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/reactions/:reaction_id"
        },
        listForCommitComment: {
            headers: {
                accept: "application/vnd.github.squirrel-girl-preview+json"
            },
            method: "GET",
            params: {
                comment_id: {
                    required: true,
                    type: "integer"
                },
                content: {
                    enum: [
                        "+1",
                        "-1",
                        "laugh",
                        "confused",
                        "heart",
                        "hooray",
                        "rocket",
                        "eyes"
                    ],
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/comments/:comment_id/reactions"
        },
        listForIssue: {
            headers: {
                accept: "application/vnd.github.squirrel-girl-preview+json"
            },
            method: "GET",
            params: {
                content: {
                    enum: [
                        "+1",
                        "-1",
                        "laugh",
                        "confused",
                        "heart",
                        "hooray",
                        "rocket",
                        "eyes"
                    ],
                    type: "string"
                },
                issue_number: {
                    required: true,
                    type: "integer"
                },
                number: {
                    alias: "issue_number",
                    deprecated: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/issues/:issue_number/reactions"
        },
        listForIssueComment: {
            headers: {
                accept: "application/vnd.github.squirrel-girl-preview+json"
            },
            method: "GET",
            params: {
                comment_id: {
                    required: true,
                    type: "integer"
                },
                content: {
                    enum: [
                        "+1",
                        "-1",
                        "laugh",
                        "confused",
                        "heart",
                        "hooray",
                        "rocket",
                        "eyes"
                    ],
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/issues/comments/:comment_id/reactions"
        },
        listForPullRequestReviewComment: {
            headers: {
                accept: "application/vnd.github.squirrel-girl-preview+json"
            },
            method: "GET",
            params: {
                comment_id: {
                    required: true,
                    type: "integer"
                },
                content: {
                    enum: [
                        "+1",
                        "-1",
                        "laugh",
                        "confused",
                        "heart",
                        "hooray",
                        "rocket",
                        "eyes"
                    ],
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/pulls/comments/:comment_id/reactions"
        },
        listForTeamDiscussion: {
            deprecated: "octokit.reactions.listForTeamDiscussion() has been renamed to octokit.reactions.listForTeamDiscussionLegacy() (2020-01-16)",
            headers: {
                accept: "application/vnd.github.squirrel-girl-preview+json"
            },
            method: "GET",
            params: {
                content: {
                    enum: [
                        "+1",
                        "-1",
                        "laugh",
                        "confused",
                        "heart",
                        "hooray",
                        "rocket",
                        "eyes"
                    ],
                    type: "string"
                },
                discussion_number: {
                    required: true,
                    type: "integer"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                team_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/teams/:team_id/discussions/:discussion_number/reactions"
        },
        listForTeamDiscussionComment: {
            deprecated: "octokit.reactions.listForTeamDiscussionComment() has been renamed to octokit.reactions.listForTeamDiscussionCommentLegacy() (2020-01-16)",
            headers: {
                accept: "application/vnd.github.squirrel-girl-preview+json"
            },
            method: "GET",
            params: {
                comment_number: {
                    required: true,
                    type: "integer"
                },
                content: {
                    enum: [
                        "+1",
                        "-1",
                        "laugh",
                        "confused",
                        "heart",
                        "hooray",
                        "rocket",
                        "eyes"
                    ],
                    type: "string"
                },
                discussion_number: {
                    required: true,
                    type: "integer"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                team_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/teams/:team_id/discussions/:discussion_number/comments/:comment_number/reactions"
        },
        listForTeamDiscussionCommentInOrg: {
            headers: {
                accept: "application/vnd.github.squirrel-girl-preview+json"
            },
            method: "GET",
            params: {
                comment_number: {
                    required: true,
                    type: "integer"
                },
                content: {
                    enum: [
                        "+1",
                        "-1",
                        "laugh",
                        "confused",
                        "heart",
                        "hooray",
                        "rocket",
                        "eyes"
                    ],
                    type: "string"
                },
                discussion_number: {
                    required: true,
                    type: "integer"
                },
                org: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                team_slug: {
                    required: true,
                    type: "string"
                }
            },
            url: "/orgs/:org/teams/:team_slug/discussions/:discussion_number/comments/:comment_number/reactions"
        },
        listForTeamDiscussionCommentLegacy: {
            deprecated: "octokit.reactions.listForTeamDiscussionCommentLegacy() is deprecated, see https://developer.github.com/v3/reactions/#list-reactions-for-a-team-discussion-comment-legacy",
            headers: {
                accept: "application/vnd.github.squirrel-girl-preview+json"
            },
            method: "GET",
            params: {
                comment_number: {
                    required: true,
                    type: "integer"
                },
                content: {
                    enum: [
                        "+1",
                        "-1",
                        "laugh",
                        "confused",
                        "heart",
                        "hooray",
                        "rocket",
                        "eyes"
                    ],
                    type: "string"
                },
                discussion_number: {
                    required: true,
                    type: "integer"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                team_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/teams/:team_id/discussions/:discussion_number/comments/:comment_number/reactions"
        },
        listForTeamDiscussionInOrg: {
            headers: {
                accept: "application/vnd.github.squirrel-girl-preview+json"
            },
            method: "GET",
            params: {
                content: {
                    enum: [
                        "+1",
                        "-1",
                        "laugh",
                        "confused",
                        "heart",
                        "hooray",
                        "rocket",
                        "eyes"
                    ],
                    type: "string"
                },
                discussion_number: {
                    required: true,
                    type: "integer"
                },
                org: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                team_slug: {
                    required: true,
                    type: "string"
                }
            },
            url: "/orgs/:org/teams/:team_slug/discussions/:discussion_number/reactions"
        },
        listForTeamDiscussionLegacy: {
            deprecated: "octokit.reactions.listForTeamDiscussionLegacy() is deprecated, see https://developer.github.com/v3/reactions/#list-reactions-for-a-team-discussion-legacy",
            headers: {
                accept: "application/vnd.github.squirrel-girl-preview+json"
            },
            method: "GET",
            params: {
                content: {
                    enum: [
                        "+1",
                        "-1",
                        "laugh",
                        "confused",
                        "heart",
                        "hooray",
                        "rocket",
                        "eyes"
                    ],
                    type: "string"
                },
                discussion_number: {
                    required: true,
                    type: "integer"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                team_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/teams/:team_id/discussions/:discussion_number/reactions"
        }
    },
    repos: {
        acceptInvitation: {
            method: "PATCH",
            params: {
                invitation_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/user/repository_invitations/:invitation_id"
        },
        addCollaborator: {
            method: "PUT",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                permission: {
                    enum: [
                        "pull",
                        "push",
                        "admin"
                    ],
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                username: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/collaborators/:username"
        },
        addDeployKey: {
            method: "POST",
            params: {
                key: {
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                read_only: {
                    type: "boolean"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                title: {
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/keys"
        },
        addProtectedBranchAdminEnforcement: {
            method: "POST",
            params: {
                branch: {
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/branches/:branch/protection/enforce_admins"
        },
        addProtectedBranchAppRestrictions: {
            method: "POST",
            params: {
                apps: {
                    mapTo: "data",
                    required: true,
                    type: "string[]"
                },
                branch: {
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/branches/:branch/protection/restrictions/apps"
        },
        addProtectedBranchRequiredSignatures: {
            headers: {
                accept: "application/vnd.github.zzzax-preview+json"
            },
            method: "POST",
            params: {
                branch: {
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/branches/:branch/protection/required_signatures"
        },
        addProtectedBranchRequiredStatusChecksContexts: {
            method: "POST",
            params: {
                branch: {
                    required: true,
                    type: "string"
                },
                contexts: {
                    mapTo: "data",
                    required: true,
                    type: "string[]"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/branches/:branch/protection/required_status_checks/contexts"
        },
        addProtectedBranchTeamRestrictions: {
            method: "POST",
            params: {
                branch: {
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                teams: {
                    mapTo: "data",
                    required: true,
                    type: "string[]"
                }
            },
            url: "/repos/:owner/:repo/branches/:branch/protection/restrictions/teams"
        },
        addProtectedBranchUserRestrictions: {
            method: "POST",
            params: {
                branch: {
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                users: {
                    mapTo: "data",
                    required: true,
                    type: "string[]"
                }
            },
            url: "/repos/:owner/:repo/branches/:branch/protection/restrictions/users"
        },
        checkCollaborator: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                username: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/collaborators/:username"
        },
        checkVulnerabilityAlerts: {
            headers: {
                accept: "application/vnd.github.dorian-preview+json"
            },
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/vulnerability-alerts"
        },
        compareCommits: {
            method: "GET",
            params: {
                base: {
                    required: true,
                    type: "string"
                },
                head: {
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/compare/:base...:head"
        },
        createCommitComment: {
            method: "POST",
            params: {
                body: {
                    required: true,
                    type: "string"
                },
                commit_sha: {
                    required: true,
                    type: "string"
                },
                line: {
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                path: {
                    type: "string"
                },
                position: {
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                sha: {
                    alias: "commit_sha",
                    deprecated: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/commits/:commit_sha/comments"
        },
        createDeployment: {
            method: "POST",
            params: {
                auto_merge: {
                    type: "boolean"
                },
                description: {
                    type: "string"
                },
                environment: {
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                payload: {
                    type: "string"
                },
                production_environment: {
                    type: "boolean"
                },
                ref: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                required_contexts: {
                    type: "string[]"
                },
                task: {
                    type: "string"
                },
                transient_environment: {
                    type: "boolean"
                }
            },
            url: "/repos/:owner/:repo/deployments"
        },
        createDeploymentStatus: {
            method: "POST",
            params: {
                auto_inactive: {
                    type: "boolean"
                },
                deployment_id: {
                    required: true,
                    type: "integer"
                },
                description: {
                    type: "string"
                },
                environment: {
                    enum: [
                        "production",
                        "staging",
                        "qa"
                    ],
                    type: "string"
                },
                environment_url: {
                    type: "string"
                },
                log_url: {
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                state: {
                    enum: [
                        "error",
                        "failure",
                        "inactive",
                        "in_progress",
                        "queued",
                        "pending",
                        "success"
                    ],
                    required: true,
                    type: "string"
                },
                target_url: {
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/deployments/:deployment_id/statuses"
        },
        createDispatchEvent: {
            method: "POST",
            params: {
                client_payload: {
                    type: "object"
                },
                event_type: {
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/dispatches"
        },
        createFile: {
            deprecated: "octokit.repos.createFile() has been renamed to octokit.repos.createOrUpdateFile() (2019-06-07)",
            method: "PUT",
            params: {
                author: {
                    type: "object"
                },
                "author.email": {
                    required: true,
                    type: "string"
                },
                "author.name": {
                    required: true,
                    type: "string"
                },
                branch: {
                    type: "string"
                },
                committer: {
                    type: "object"
                },
                "committer.email": {
                    required: true,
                    type: "string"
                },
                "committer.name": {
                    required: true,
                    type: "string"
                },
                content: {
                    required: true,
                    type: "string"
                },
                message: {
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                path: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                sha: {
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/contents/:path"
        },
        createForAuthenticatedUser: {
            method: "POST",
            params: {
                allow_merge_commit: {
                    type: "boolean"
                },
                allow_rebase_merge: {
                    type: "boolean"
                },
                allow_squash_merge: {
                    type: "boolean"
                },
                auto_init: {
                    type: "boolean"
                },
                delete_branch_on_merge: {
                    type: "boolean"
                },
                description: {
                    type: "string"
                },
                gitignore_template: {
                    type: "string"
                },
                has_issues: {
                    type: "boolean"
                },
                has_projects: {
                    type: "boolean"
                },
                has_wiki: {
                    type: "boolean"
                },
                homepage: {
                    type: "string"
                },
                is_template: {
                    type: "boolean"
                },
                license_template: {
                    type: "string"
                },
                name: {
                    required: true,
                    type: "string"
                },
                private: {
                    type: "boolean"
                },
                team_id: {
                    type: "integer"
                },
                visibility: {
                    enum: [
                        "public",
                        "private",
                        "visibility",
                        "internal"
                    ],
                    type: "string"
                }
            },
            url: "/user/repos"
        },
        createFork: {
            method: "POST",
            params: {
                organization: {
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/forks"
        },
        createHook: {
            method: "POST",
            params: {
                active: {
                    type: "boolean"
                },
                config: {
                    required: true,
                    type: "object"
                },
                "config.content_type": {
                    type: "string"
                },
                "config.insecure_ssl": {
                    type: "string"
                },
                "config.secret": {
                    type: "string"
                },
                "config.url": {
                    required: true,
                    type: "string"
                },
                events: {
                    type: "string[]"
                },
                name: {
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/hooks"
        },
        createInOrg: {
            method: "POST",
            params: {
                allow_merge_commit: {
                    type: "boolean"
                },
                allow_rebase_merge: {
                    type: "boolean"
                },
                allow_squash_merge: {
                    type: "boolean"
                },
                auto_init: {
                    type: "boolean"
                },
                delete_branch_on_merge: {
                    type: "boolean"
                },
                description: {
                    type: "string"
                },
                gitignore_template: {
                    type: "string"
                },
                has_issues: {
                    type: "boolean"
                },
                has_projects: {
                    type: "boolean"
                },
                has_wiki: {
                    type: "boolean"
                },
                homepage: {
                    type: "string"
                },
                is_template: {
                    type: "boolean"
                },
                license_template: {
                    type: "string"
                },
                name: {
                    required: true,
                    type: "string"
                },
                org: {
                    required: true,
                    type: "string"
                },
                private: {
                    type: "boolean"
                },
                team_id: {
                    type: "integer"
                },
                visibility: {
                    enum: [
                        "public",
                        "private",
                        "visibility",
                        "internal"
                    ],
                    type: "string"
                }
            },
            url: "/orgs/:org/repos"
        },
        createOrUpdateFile: {
            method: "PUT",
            params: {
                author: {
                    type: "object"
                },
                "author.email": {
                    required: true,
                    type: "string"
                },
                "author.name": {
                    required: true,
                    type: "string"
                },
                branch: {
                    type: "string"
                },
                committer: {
                    type: "object"
                },
                "committer.email": {
                    required: true,
                    type: "string"
                },
                "committer.name": {
                    required: true,
                    type: "string"
                },
                content: {
                    required: true,
                    type: "string"
                },
                message: {
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                path: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                sha: {
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/contents/:path"
        },
        createRelease: {
            method: "POST",
            params: {
                body: {
                    type: "string"
                },
                draft: {
                    type: "boolean"
                },
                name: {
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                prerelease: {
                    type: "boolean"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                tag_name: {
                    required: true,
                    type: "string"
                },
                target_commitish: {
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/releases"
        },
        createStatus: {
            method: "POST",
            params: {
                context: {
                    type: "string"
                },
                description: {
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                sha: {
                    required: true,
                    type: "string"
                },
                state: {
                    enum: [
                        "error",
                        "failure",
                        "pending",
                        "success"
                    ],
                    required: true,
                    type: "string"
                },
                target_url: {
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/statuses/:sha"
        },
        createUsingTemplate: {
            headers: {
                accept: "application/vnd.github.baptiste-preview+json"
            },
            method: "POST",
            params: {
                description: {
                    type: "string"
                },
                name: {
                    required: true,
                    type: "string"
                },
                owner: {
                    type: "string"
                },
                private: {
                    type: "boolean"
                },
                template_owner: {
                    required: true,
                    type: "string"
                },
                template_repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:template_owner/:template_repo/generate"
        },
        declineInvitation: {
            method: "DELETE",
            params: {
                invitation_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/user/repository_invitations/:invitation_id"
        },
        delete: {
            method: "DELETE",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo"
        },
        deleteCommitComment: {
            method: "DELETE",
            params: {
                comment_id: {
                    required: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/comments/:comment_id"
        },
        deleteDownload: {
            method: "DELETE",
            params: {
                download_id: {
                    required: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/downloads/:download_id"
        },
        deleteFile: {
            method: "DELETE",
            params: {
                author: {
                    type: "object"
                },
                "author.email": {
                    type: "string"
                },
                "author.name": {
                    type: "string"
                },
                branch: {
                    type: "string"
                },
                committer: {
                    type: "object"
                },
                "committer.email": {
                    type: "string"
                },
                "committer.name": {
                    type: "string"
                },
                message: {
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                path: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                sha: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/contents/:path"
        },
        deleteHook: {
            method: "DELETE",
            params: {
                hook_id: {
                    required: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/hooks/:hook_id"
        },
        deleteInvitation: {
            method: "DELETE",
            params: {
                invitation_id: {
                    required: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/invitations/:invitation_id"
        },
        deleteRelease: {
            method: "DELETE",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                release_id: {
                    required: true,
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/releases/:release_id"
        },
        deleteReleaseAsset: {
            method: "DELETE",
            params: {
                asset_id: {
                    required: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/releases/assets/:asset_id"
        },
        disableAutomatedSecurityFixes: {
            headers: {
                accept: "application/vnd.github.london-preview+json"
            },
            method: "DELETE",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/automated-security-fixes"
        },
        disablePagesSite: {
            headers: {
                accept: "application/vnd.github.switcheroo-preview+json"
            },
            method: "DELETE",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/pages"
        },
        disableVulnerabilityAlerts: {
            headers: {
                accept: "application/vnd.github.dorian-preview+json"
            },
            method: "DELETE",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/vulnerability-alerts"
        },
        enableAutomatedSecurityFixes: {
            headers: {
                accept: "application/vnd.github.london-preview+json"
            },
            method: "PUT",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/automated-security-fixes"
        },
        enablePagesSite: {
            headers: {
                accept: "application/vnd.github.switcheroo-preview+json"
            },
            method: "POST",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                source: {
                    type: "object"
                },
                "source.branch": {
                    enum: [
                        "master",
                        "gh-pages"
                    ],
                    type: "string"
                },
                "source.path": {
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/pages"
        },
        enableVulnerabilityAlerts: {
            headers: {
                accept: "application/vnd.github.dorian-preview+json"
            },
            method: "PUT",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/vulnerability-alerts"
        },
        get: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo"
        },
        getAppsWithAccessToProtectedBranch: {
            method: "GET",
            params: {
                branch: {
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/branches/:branch/protection/restrictions/apps"
        },
        getArchiveLink: {
            method: "GET",
            params: {
                archive_format: {
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                ref: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/:archive_format/:ref"
        },
        getBranch: {
            method: "GET",
            params: {
                branch: {
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/branches/:branch"
        },
        getBranchProtection: {
            method: "GET",
            params: {
                branch: {
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/branches/:branch/protection"
        },
        getClones: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                per: {
                    enum: [
                        "day",
                        "week"
                    ],
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/traffic/clones"
        },
        getCodeFrequencyStats: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/stats/code_frequency"
        },
        getCollaboratorPermissionLevel: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                username: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/collaborators/:username/permission"
        },
        getCombinedStatusForRef: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                ref: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/commits/:ref/status"
        },
        getCommit: {
            method: "GET",
            params: {
                commit_sha: {
                    alias: "ref",
                    deprecated: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                ref: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                sha: {
                    alias: "ref",
                    deprecated: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/commits/:ref"
        },
        getCommitActivityStats: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/stats/commit_activity"
        },
        getCommitComment: {
            method: "GET",
            params: {
                comment_id: {
                    required: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/comments/:comment_id"
        },
        getCommitRefSha: {
            deprecated: "octokit.repos.getCommitRefSha() is deprecated, see https://developer.github.com/v3/repos/commits/#get-a-single-commit",
            headers: {
                accept: "application/vnd.github.v3.sha"
            },
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                ref: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/commits/:ref"
        },
        getContents: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                path: {
                    required: true,
                    type: "string"
                },
                ref: {
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/contents/:path"
        },
        getContributorsStats: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/stats/contributors"
        },
        getDeployKey: {
            method: "GET",
            params: {
                key_id: {
                    required: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/keys/:key_id"
        },
        getDeployment: {
            method: "GET",
            params: {
                deployment_id: {
                    required: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/deployments/:deployment_id"
        },
        getDeploymentStatus: {
            method: "GET",
            params: {
                deployment_id: {
                    required: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                status_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/repos/:owner/:repo/deployments/:deployment_id/statuses/:status_id"
        },
        getDownload: {
            method: "GET",
            params: {
                download_id: {
                    required: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/downloads/:download_id"
        },
        getHook: {
            method: "GET",
            params: {
                hook_id: {
                    required: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/hooks/:hook_id"
        },
        getLatestPagesBuild: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/pages/builds/latest"
        },
        getLatestRelease: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/releases/latest"
        },
        getPages: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/pages"
        },
        getPagesBuild: {
            method: "GET",
            params: {
                build_id: {
                    required: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/pages/builds/:build_id"
        },
        getParticipationStats: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/stats/participation"
        },
        getProtectedBranchAdminEnforcement: {
            method: "GET",
            params: {
                branch: {
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/branches/:branch/protection/enforce_admins"
        },
        getProtectedBranchPullRequestReviewEnforcement: {
            method: "GET",
            params: {
                branch: {
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/branches/:branch/protection/required_pull_request_reviews"
        },
        getProtectedBranchRequiredSignatures: {
            headers: {
                accept: "application/vnd.github.zzzax-preview+json"
            },
            method: "GET",
            params: {
                branch: {
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/branches/:branch/protection/required_signatures"
        },
        getProtectedBranchRequiredStatusChecks: {
            method: "GET",
            params: {
                branch: {
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/branches/:branch/protection/required_status_checks"
        },
        getProtectedBranchRestrictions: {
            method: "GET",
            params: {
                branch: {
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/branches/:branch/protection/restrictions"
        },
        getPunchCardStats: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/stats/punch_card"
        },
        getReadme: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                ref: {
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/readme"
        },
        getRelease: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                release_id: {
                    required: true,
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/releases/:release_id"
        },
        getReleaseAsset: {
            method: "GET",
            params: {
                asset_id: {
                    required: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/releases/assets/:asset_id"
        },
        getReleaseByTag: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                tag: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/releases/tags/:tag"
        },
        getTeamsWithAccessToProtectedBranch: {
            method: "GET",
            params: {
                branch: {
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/branches/:branch/protection/restrictions/teams"
        },
        getTopPaths: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/traffic/popular/paths"
        },
        getTopReferrers: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/traffic/popular/referrers"
        },
        getUsersWithAccessToProtectedBranch: {
            method: "GET",
            params: {
                branch: {
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/branches/:branch/protection/restrictions/users"
        },
        getViews: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                per: {
                    enum: [
                        "day",
                        "week"
                    ],
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/traffic/views"
        },
        list: {
            method: "GET",
            params: {
                affiliation: {
                    type: "string"
                },
                direction: {
                    enum: [
                        "asc",
                        "desc"
                    ],
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                sort: {
                    enum: [
                        "created",
                        "updated",
                        "pushed",
                        "full_name"
                    ],
                    type: "string"
                },
                type: {
                    enum: [
                        "all",
                        "owner",
                        "public",
                        "private",
                        "member"
                    ],
                    type: "string"
                },
                visibility: {
                    enum: [
                        "all",
                        "public",
                        "private"
                    ],
                    type: "string"
                }
            },
            url: "/user/repos"
        },
        listAppsWithAccessToProtectedBranch: {
            deprecated: "octokit.repos.listAppsWithAccessToProtectedBranch() has been renamed to octokit.repos.getAppsWithAccessToProtectedBranch() (2019-09-13)",
            method: "GET",
            params: {
                branch: {
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/branches/:branch/protection/restrictions/apps"
        },
        listAssetsForRelease: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                release_id: {
                    required: true,
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/releases/:release_id/assets"
        },
        listBranches: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                protected: {
                    type: "boolean"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/branches"
        },
        listBranchesForHeadCommit: {
            headers: {
                accept: "application/vnd.github.groot-preview+json"
            },
            method: "GET",
            params: {
                commit_sha: {
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/commits/:commit_sha/branches-where-head"
        },
        listCollaborators: {
            method: "GET",
            params: {
                affiliation: {
                    enum: [
                        "outside",
                        "direct",
                        "all"
                    ],
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/collaborators"
        },
        listCommentsForCommit: {
            method: "GET",
            params: {
                commit_sha: {
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                ref: {
                    alias: "commit_sha",
                    deprecated: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/commits/:commit_sha/comments"
        },
        listCommitComments: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/comments"
        },
        listCommits: {
            method: "GET",
            params: {
                author: {
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                path: {
                    type: "string"
                },
                per_page: {
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                sha: {
                    type: "string"
                },
                since: {
                    type: "string"
                },
                until: {
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/commits"
        },
        listContributors: {
            method: "GET",
            params: {
                anon: {
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/contributors"
        },
        listDeployKeys: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/keys"
        },
        listDeploymentStatuses: {
            method: "GET",
            params: {
                deployment_id: {
                    required: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/deployments/:deployment_id/statuses"
        },
        listDeployments: {
            method: "GET",
            params: {
                environment: {
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                ref: {
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                sha: {
                    type: "string"
                },
                task: {
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/deployments"
        },
        listDownloads: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/downloads"
        },
        listForOrg: {
            method: "GET",
            params: {
                direction: {
                    enum: [
                        "asc",
                        "desc"
                    ],
                    type: "string"
                },
                org: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                sort: {
                    enum: [
                        "created",
                        "updated",
                        "pushed",
                        "full_name"
                    ],
                    type: "string"
                },
                type: {
                    enum: [
                        "all",
                        "public",
                        "private",
                        "forks",
                        "sources",
                        "member",
                        "internal"
                    ],
                    type: "string"
                }
            },
            url: "/orgs/:org/repos"
        },
        listForUser: {
            method: "GET",
            params: {
                direction: {
                    enum: [
                        "asc",
                        "desc"
                    ],
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                sort: {
                    enum: [
                        "created",
                        "updated",
                        "pushed",
                        "full_name"
                    ],
                    type: "string"
                },
                type: {
                    enum: [
                        "all",
                        "owner",
                        "member"
                    ],
                    type: "string"
                },
                username: {
                    required: true,
                    type: "string"
                }
            },
            url: "/users/:username/repos"
        },
        listForks: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                sort: {
                    enum: [
                        "newest",
                        "oldest",
                        "stargazers"
                    ],
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/forks"
        },
        listHooks: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/hooks"
        },
        listInvitations: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/invitations"
        },
        listInvitationsForAuthenticatedUser: {
            method: "GET",
            params: {
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                }
            },
            url: "/user/repository_invitations"
        },
        listLanguages: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/languages"
        },
        listPagesBuilds: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/pages/builds"
        },
        listProtectedBranchRequiredStatusChecksContexts: {
            method: "GET",
            params: {
                branch: {
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/branches/:branch/protection/required_status_checks/contexts"
        },
        listProtectedBranchTeamRestrictions: {
            deprecated: "octokit.repos.listProtectedBranchTeamRestrictions() has been renamed to octokit.repos.getTeamsWithAccessToProtectedBranch() (2019-09-09)",
            method: "GET",
            params: {
                branch: {
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/branches/:branch/protection/restrictions/teams"
        },
        listProtectedBranchUserRestrictions: {
            deprecated: "octokit.repos.listProtectedBranchUserRestrictions() has been renamed to octokit.repos.getUsersWithAccessToProtectedBranch() (2019-09-09)",
            method: "GET",
            params: {
                branch: {
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/branches/:branch/protection/restrictions/users"
        },
        listPublic: {
            method: "GET",
            params: {
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                since: {
                    type: "integer"
                }
            },
            url: "/repositories"
        },
        listPullRequestsAssociatedWithCommit: {
            headers: {
                accept: "application/vnd.github.groot-preview+json"
            },
            method: "GET",
            params: {
                commit_sha: {
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/commits/:commit_sha/pulls"
        },
        listReleases: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/releases"
        },
        listStatusesForRef: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                ref: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/commits/:ref/statuses"
        },
        listTags: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/tags"
        },
        listTeams: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/teams"
        },
        listTeamsWithAccessToProtectedBranch: {
            deprecated: "octokit.repos.listTeamsWithAccessToProtectedBranch() has been renamed to octokit.repos.getTeamsWithAccessToProtectedBranch() (2019-09-13)",
            method: "GET",
            params: {
                branch: {
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/branches/:branch/protection/restrictions/teams"
        },
        listTopics: {
            headers: {
                accept: "application/vnd.github.mercy-preview+json"
            },
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/topics"
        },
        listUsersWithAccessToProtectedBranch: {
            deprecated: "octokit.repos.listUsersWithAccessToProtectedBranch() has been renamed to octokit.repos.getUsersWithAccessToProtectedBranch() (2019-09-13)",
            method: "GET",
            params: {
                branch: {
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/branches/:branch/protection/restrictions/users"
        },
        merge: {
            method: "POST",
            params: {
                base: {
                    required: true,
                    type: "string"
                },
                commit_message: {
                    type: "string"
                },
                head: {
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/merges"
        },
        pingHook: {
            method: "POST",
            params: {
                hook_id: {
                    required: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/hooks/:hook_id/pings"
        },
        removeBranchProtection: {
            method: "DELETE",
            params: {
                branch: {
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/branches/:branch/protection"
        },
        removeCollaborator: {
            method: "DELETE",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                username: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/collaborators/:username"
        },
        removeDeployKey: {
            method: "DELETE",
            params: {
                key_id: {
                    required: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/keys/:key_id"
        },
        removeProtectedBranchAdminEnforcement: {
            method: "DELETE",
            params: {
                branch: {
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/branches/:branch/protection/enforce_admins"
        },
        removeProtectedBranchAppRestrictions: {
            method: "DELETE",
            params: {
                apps: {
                    mapTo: "data",
                    required: true,
                    type: "string[]"
                },
                branch: {
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/branches/:branch/protection/restrictions/apps"
        },
        removeProtectedBranchPullRequestReviewEnforcement: {
            method: "DELETE",
            params: {
                branch: {
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/branches/:branch/protection/required_pull_request_reviews"
        },
        removeProtectedBranchRequiredSignatures: {
            headers: {
                accept: "application/vnd.github.zzzax-preview+json"
            },
            method: "DELETE",
            params: {
                branch: {
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/branches/:branch/protection/required_signatures"
        },
        removeProtectedBranchRequiredStatusChecks: {
            method: "DELETE",
            params: {
                branch: {
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/branches/:branch/protection/required_status_checks"
        },
        removeProtectedBranchRequiredStatusChecksContexts: {
            method: "DELETE",
            params: {
                branch: {
                    required: true,
                    type: "string"
                },
                contexts: {
                    mapTo: "data",
                    required: true,
                    type: "string[]"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/branches/:branch/protection/required_status_checks/contexts"
        },
        removeProtectedBranchRestrictions: {
            method: "DELETE",
            params: {
                branch: {
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/branches/:branch/protection/restrictions"
        },
        removeProtectedBranchTeamRestrictions: {
            method: "DELETE",
            params: {
                branch: {
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                teams: {
                    mapTo: "data",
                    required: true,
                    type: "string[]"
                }
            },
            url: "/repos/:owner/:repo/branches/:branch/protection/restrictions/teams"
        },
        removeProtectedBranchUserRestrictions: {
            method: "DELETE",
            params: {
                branch: {
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                users: {
                    mapTo: "data",
                    required: true,
                    type: "string[]"
                }
            },
            url: "/repos/:owner/:repo/branches/:branch/protection/restrictions/users"
        },
        replaceProtectedBranchAppRestrictions: {
            method: "PUT",
            params: {
                apps: {
                    mapTo: "data",
                    required: true,
                    type: "string[]"
                },
                branch: {
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/branches/:branch/protection/restrictions/apps"
        },
        replaceProtectedBranchRequiredStatusChecksContexts: {
            method: "PUT",
            params: {
                branch: {
                    required: true,
                    type: "string"
                },
                contexts: {
                    mapTo: "data",
                    required: true,
                    type: "string[]"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/branches/:branch/protection/required_status_checks/contexts"
        },
        replaceProtectedBranchTeamRestrictions: {
            method: "PUT",
            params: {
                branch: {
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                teams: {
                    mapTo: "data",
                    required: true,
                    type: "string[]"
                }
            },
            url: "/repos/:owner/:repo/branches/:branch/protection/restrictions/teams"
        },
        replaceProtectedBranchUserRestrictions: {
            method: "PUT",
            params: {
                branch: {
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                users: {
                    mapTo: "data",
                    required: true,
                    type: "string[]"
                }
            },
            url: "/repos/:owner/:repo/branches/:branch/protection/restrictions/users"
        },
        replaceTopics: {
            headers: {
                accept: "application/vnd.github.mercy-preview+json"
            },
            method: "PUT",
            params: {
                names: {
                    required: true,
                    type: "string[]"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/topics"
        },
        requestPageBuild: {
            method: "POST",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/pages/builds"
        },
        retrieveCommunityProfileMetrics: {
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/community/profile"
        },
        testPushHook: {
            method: "POST",
            params: {
                hook_id: {
                    required: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/hooks/:hook_id/tests"
        },
        transfer: {
            method: "POST",
            params: {
                new_owner: {
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                team_ids: {
                    type: "integer[]"
                }
            },
            url: "/repos/:owner/:repo/transfer"
        },
        update: {
            method: "PATCH",
            params: {
                allow_merge_commit: {
                    type: "boolean"
                },
                allow_rebase_merge: {
                    type: "boolean"
                },
                allow_squash_merge: {
                    type: "boolean"
                },
                archived: {
                    type: "boolean"
                },
                default_branch: {
                    type: "string"
                },
                delete_branch_on_merge: {
                    type: "boolean"
                },
                description: {
                    type: "string"
                },
                has_issues: {
                    type: "boolean"
                },
                has_projects: {
                    type: "boolean"
                },
                has_wiki: {
                    type: "boolean"
                },
                homepage: {
                    type: "string"
                },
                is_template: {
                    type: "boolean"
                },
                name: {
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                private: {
                    type: "boolean"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                visibility: {
                    enum: [
                        "public",
                        "private",
                        "visibility",
                        "internal"
                    ],
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo"
        },
        updateBranchProtection: {
            method: "PUT",
            params: {
                allow_deletions: {
                    type: "boolean"
                },
                allow_force_pushes: {
                    allowNull: true,
                    type: "boolean"
                },
                branch: {
                    required: true,
                    type: "string"
                },
                enforce_admins: {
                    allowNull: true,
                    required: true,
                    type: "boolean"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                required_linear_history: {
                    type: "boolean"
                },
                required_pull_request_reviews: {
                    allowNull: true,
                    required: true,
                    type: "object"
                },
                "required_pull_request_reviews.dismiss_stale_reviews": {
                    type: "boolean"
                },
                "required_pull_request_reviews.dismissal_restrictions": {
                    type: "object"
                },
                "required_pull_request_reviews.dismissal_restrictions.teams": {
                    type: "string[]"
                },
                "required_pull_request_reviews.dismissal_restrictions.users": {
                    type: "string[]"
                },
                "required_pull_request_reviews.require_code_owner_reviews": {
                    type: "boolean"
                },
                "required_pull_request_reviews.required_approving_review_count": {
                    type: "integer"
                },
                required_status_checks: {
                    allowNull: true,
                    required: true,
                    type: "object"
                },
                "required_status_checks.contexts": {
                    required: true,
                    type: "string[]"
                },
                "required_status_checks.strict": {
                    required: true,
                    type: "boolean"
                },
                restrictions: {
                    allowNull: true,
                    required: true,
                    type: "object"
                },
                "restrictions.apps": {
                    type: "string[]"
                },
                "restrictions.teams": {
                    required: true,
                    type: "string[]"
                },
                "restrictions.users": {
                    required: true,
                    type: "string[]"
                }
            },
            url: "/repos/:owner/:repo/branches/:branch/protection"
        },
        updateCommitComment: {
            method: "PATCH",
            params: {
                body: {
                    required: true,
                    type: "string"
                },
                comment_id: {
                    required: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/comments/:comment_id"
        },
        updateFile: {
            deprecated: "octokit.repos.updateFile() has been renamed to octokit.repos.createOrUpdateFile() (2019-06-07)",
            method: "PUT",
            params: {
                author: {
                    type: "object"
                },
                "author.email": {
                    required: true,
                    type: "string"
                },
                "author.name": {
                    required: true,
                    type: "string"
                },
                branch: {
                    type: "string"
                },
                committer: {
                    type: "object"
                },
                "committer.email": {
                    required: true,
                    type: "string"
                },
                "committer.name": {
                    required: true,
                    type: "string"
                },
                content: {
                    required: true,
                    type: "string"
                },
                message: {
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                path: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                sha: {
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/contents/:path"
        },
        updateHook: {
            method: "PATCH",
            params: {
                active: {
                    type: "boolean"
                },
                add_events: {
                    type: "string[]"
                },
                config: {
                    type: "object"
                },
                "config.content_type": {
                    type: "string"
                },
                "config.insecure_ssl": {
                    type: "string"
                },
                "config.secret": {
                    type: "string"
                },
                "config.url": {
                    required: true,
                    type: "string"
                },
                events: {
                    type: "string[]"
                },
                hook_id: {
                    required: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                remove_events: {
                    type: "string[]"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/hooks/:hook_id"
        },
        updateInformationAboutPagesSite: {
            method: "PUT",
            params: {
                cname: {
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                source: {
                    enum: [
                        '"gh-pages"',
                        '"master"',
                        '"master /docs"'
                    ],
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/pages"
        },
        updateInvitation: {
            method: "PATCH",
            params: {
                invitation_id: {
                    required: true,
                    type: "integer"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                permissions: {
                    enum: [
                        "read",
                        "write",
                        "admin"
                    ],
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/invitations/:invitation_id"
        },
        updateProtectedBranchPullRequestReviewEnforcement: {
            method: "PATCH",
            params: {
                branch: {
                    required: true,
                    type: "string"
                },
                dismiss_stale_reviews: {
                    type: "boolean"
                },
                dismissal_restrictions: {
                    type: "object"
                },
                "dismissal_restrictions.teams": {
                    type: "string[]"
                },
                "dismissal_restrictions.users": {
                    type: "string[]"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                require_code_owner_reviews: {
                    type: "boolean"
                },
                required_approving_review_count: {
                    type: "integer"
                }
            },
            url: "/repos/:owner/:repo/branches/:branch/protection/required_pull_request_reviews"
        },
        updateProtectedBranchRequiredStatusChecks: {
            method: "PATCH",
            params: {
                branch: {
                    required: true,
                    type: "string"
                },
                contexts: {
                    type: "string[]"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                strict: {
                    type: "boolean"
                }
            },
            url: "/repos/:owner/:repo/branches/:branch/protection/required_status_checks"
        },
        updateRelease: {
            method: "PATCH",
            params: {
                body: {
                    type: "string"
                },
                draft: {
                    type: "boolean"
                },
                name: {
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                prerelease: {
                    type: "boolean"
                },
                release_id: {
                    required: true,
                    type: "integer"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                tag_name: {
                    type: "string"
                },
                target_commitish: {
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/releases/:release_id"
        },
        updateReleaseAsset: {
            method: "PATCH",
            params: {
                asset_id: {
                    required: true,
                    type: "integer"
                },
                label: {
                    type: "string"
                },
                name: {
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                }
            },
            url: "/repos/:owner/:repo/releases/assets/:asset_id"
        },
        uploadReleaseAsset: {
            method: "POST",
            params: {
                data: {
                    mapTo: "data",
                    required: true,
                    type: "string | object"
                },
                file: {
                    alias: "data",
                    deprecated: true,
                    type: "string | object"
                },
                headers: {
                    required: true,
                    type: "object"
                },
                "headers.content-length": {
                    required: true,
                    type: "integer"
                },
                "headers.content-type": {
                    required: true,
                    type: "string"
                },
                label: {
                    type: "string"
                },
                name: {
                    required: true,
                    type: "string"
                },
                url: {
                    required: true,
                    type: "string"
                }
            },
            url: ":url"
        }
    },
    search: {
        code: {
            method: "GET",
            params: {
                order: {
                    enum: [
                        "desc",
                        "asc"
                    ],
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                q: {
                    required: true,
                    type: "string"
                },
                sort: {
                    enum: [
                        "indexed"
                    ],
                    type: "string"
                }
            },
            url: "/search/code"
        },
        commits: {
            headers: {
                accept: "application/vnd.github.cloak-preview+json"
            },
            method: "GET",
            params: {
                order: {
                    enum: [
                        "desc",
                        "asc"
                    ],
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                q: {
                    required: true,
                    type: "string"
                },
                sort: {
                    enum: [
                        "author-date",
                        "committer-date"
                    ],
                    type: "string"
                }
            },
            url: "/search/commits"
        },
        issues: {
            deprecated: "octokit.search.issues() has been renamed to octokit.search.issuesAndPullRequests() (2018-12-27)",
            method: "GET",
            params: {
                order: {
                    enum: [
                        "desc",
                        "asc"
                    ],
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                q: {
                    required: true,
                    type: "string"
                },
                sort: {
                    enum: [
                        "comments",
                        "reactions",
                        "reactions-+1",
                        "reactions--1",
                        "reactions-smile",
                        "reactions-thinking_face",
                        "reactions-heart",
                        "reactions-tada",
                        "interactions",
                        "created",
                        "updated"
                    ],
                    type: "string"
                }
            },
            url: "/search/issues"
        },
        issuesAndPullRequests: {
            method: "GET",
            params: {
                order: {
                    enum: [
                        "desc",
                        "asc"
                    ],
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                q: {
                    required: true,
                    type: "string"
                },
                sort: {
                    enum: [
                        "comments",
                        "reactions",
                        "reactions-+1",
                        "reactions--1",
                        "reactions-smile",
                        "reactions-thinking_face",
                        "reactions-heart",
                        "reactions-tada",
                        "interactions",
                        "created",
                        "updated"
                    ],
                    type: "string"
                }
            },
            url: "/search/issues"
        },
        labels: {
            method: "GET",
            params: {
                order: {
                    enum: [
                        "desc",
                        "asc"
                    ],
                    type: "string"
                },
                q: {
                    required: true,
                    type: "string"
                },
                repository_id: {
                    required: true,
                    type: "integer"
                },
                sort: {
                    enum: [
                        "created",
                        "updated"
                    ],
                    type: "string"
                }
            },
            url: "/search/labels"
        },
        repos: {
            method: "GET",
            params: {
                order: {
                    enum: [
                        "desc",
                        "asc"
                    ],
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                q: {
                    required: true,
                    type: "string"
                },
                sort: {
                    enum: [
                        "stars",
                        "forks",
                        "help-wanted-issues",
                        "updated"
                    ],
                    type: "string"
                }
            },
            url: "/search/repositories"
        },
        topics: {
            method: "GET",
            params: {
                q: {
                    required: true,
                    type: "string"
                }
            },
            url: "/search/topics"
        },
        users: {
            method: "GET",
            params: {
                order: {
                    enum: [
                        "desc",
                        "asc"
                    ],
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                q: {
                    required: true,
                    type: "string"
                },
                sort: {
                    enum: [
                        "followers",
                        "repositories",
                        "joined"
                    ],
                    type: "string"
                }
            },
            url: "/search/users"
        }
    },
    teams: {
        addMember: {
            deprecated: "octokit.teams.addMember() has been renamed to octokit.teams.addMemberLegacy() (2020-01-16)",
            method: "PUT",
            params: {
                team_id: {
                    required: true,
                    type: "integer"
                },
                username: {
                    required: true,
                    type: "string"
                }
            },
            url: "/teams/:team_id/members/:username"
        },
        addMemberLegacy: {
            deprecated: "octokit.teams.addMemberLegacy() is deprecated, see https://developer.github.com/v3/teams/members/#add-team-member-legacy",
            method: "PUT",
            params: {
                team_id: {
                    required: true,
                    type: "integer"
                },
                username: {
                    required: true,
                    type: "string"
                }
            },
            url: "/teams/:team_id/members/:username"
        },
        addOrUpdateMembership: {
            deprecated: "octokit.teams.addOrUpdateMembership() has been renamed to octokit.teams.addOrUpdateMembershipLegacy() (2020-01-16)",
            method: "PUT",
            params: {
                role: {
                    enum: [
                        "member",
                        "maintainer"
                    ],
                    type: "string"
                },
                team_id: {
                    required: true,
                    type: "integer"
                },
                username: {
                    required: true,
                    type: "string"
                }
            },
            url: "/teams/:team_id/memberships/:username"
        },
        addOrUpdateMembershipInOrg: {
            method: "PUT",
            params: {
                org: {
                    required: true,
                    type: "string"
                },
                role: {
                    enum: [
                        "member",
                        "maintainer"
                    ],
                    type: "string"
                },
                team_slug: {
                    required: true,
                    type: "string"
                },
                username: {
                    required: true,
                    type: "string"
                }
            },
            url: "/orgs/:org/teams/:team_slug/memberships/:username"
        },
        addOrUpdateMembershipLegacy: {
            deprecated: "octokit.teams.addOrUpdateMembershipLegacy() is deprecated, see https://developer.github.com/v3/teams/members/#add-or-update-team-membership-legacy",
            method: "PUT",
            params: {
                role: {
                    enum: [
                        "member",
                        "maintainer"
                    ],
                    type: "string"
                },
                team_id: {
                    required: true,
                    type: "integer"
                },
                username: {
                    required: true,
                    type: "string"
                }
            },
            url: "/teams/:team_id/memberships/:username"
        },
        addOrUpdateProject: {
            deprecated: "octokit.teams.addOrUpdateProject() has been renamed to octokit.teams.addOrUpdateProjectLegacy() (2020-01-16)",
            headers: {
                accept: "application/vnd.github.inertia-preview+json"
            },
            method: "PUT",
            params: {
                permission: {
                    enum: [
                        "read",
                        "write",
                        "admin"
                    ],
                    type: "string"
                },
                project_id: {
                    required: true,
                    type: "integer"
                },
                team_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/teams/:team_id/projects/:project_id"
        },
        addOrUpdateProjectInOrg: {
            headers: {
                accept: "application/vnd.github.inertia-preview+json"
            },
            method: "PUT",
            params: {
                org: {
                    required: true,
                    type: "string"
                },
                permission: {
                    enum: [
                        "read",
                        "write",
                        "admin"
                    ],
                    type: "string"
                },
                project_id: {
                    required: true,
                    type: "integer"
                },
                team_slug: {
                    required: true,
                    type: "string"
                }
            },
            url: "/orgs/:org/teams/:team_slug/projects/:project_id"
        },
        addOrUpdateProjectLegacy: {
            deprecated: "octokit.teams.addOrUpdateProjectLegacy() is deprecated, see https://developer.github.com/v3/teams/#add-or-update-team-project-legacy",
            headers: {
                accept: "application/vnd.github.inertia-preview+json"
            },
            method: "PUT",
            params: {
                permission: {
                    enum: [
                        "read",
                        "write",
                        "admin"
                    ],
                    type: "string"
                },
                project_id: {
                    required: true,
                    type: "integer"
                },
                team_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/teams/:team_id/projects/:project_id"
        },
        addOrUpdateRepo: {
            deprecated: "octokit.teams.addOrUpdateRepo() has been renamed to octokit.teams.addOrUpdateRepoLegacy() (2020-01-16)",
            method: "PUT",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                permission: {
                    enum: [
                        "pull",
                        "push",
                        "admin"
                    ],
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                team_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/teams/:team_id/repos/:owner/:repo"
        },
        addOrUpdateRepoInOrg: {
            method: "PUT",
            params: {
                org: {
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                permission: {
                    enum: [
                        "pull",
                        "push",
                        "admin"
                    ],
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                team_slug: {
                    required: true,
                    type: "string"
                }
            },
            url: "/orgs/:org/teams/:team_slug/repos/:owner/:repo"
        },
        addOrUpdateRepoLegacy: {
            deprecated: "octokit.teams.addOrUpdateRepoLegacy() is deprecated, see https://developer.github.com/v3/teams/#add-or-update-team-repository-legacy",
            method: "PUT",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                permission: {
                    enum: [
                        "pull",
                        "push",
                        "admin"
                    ],
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                team_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/teams/:team_id/repos/:owner/:repo"
        },
        checkManagesRepo: {
            deprecated: "octokit.teams.checkManagesRepo() has been renamed to octokit.teams.checkManagesRepoLegacy() (2020-01-16)",
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                team_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/teams/:team_id/repos/:owner/:repo"
        },
        checkManagesRepoInOrg: {
            method: "GET",
            params: {
                org: {
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                team_slug: {
                    required: true,
                    type: "string"
                }
            },
            url: "/orgs/:org/teams/:team_slug/repos/:owner/:repo"
        },
        checkManagesRepoLegacy: {
            deprecated: "octokit.teams.checkManagesRepoLegacy() is deprecated, see https://developer.github.com/v3/teams/#check-if-a-team-manages-a-repository-legacy",
            method: "GET",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                team_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/teams/:team_id/repos/:owner/:repo"
        },
        create: {
            method: "POST",
            params: {
                description: {
                    type: "string"
                },
                maintainers: {
                    type: "string[]"
                },
                name: {
                    required: true,
                    type: "string"
                },
                org: {
                    required: true,
                    type: "string"
                },
                parent_team_id: {
                    type: "integer"
                },
                permission: {
                    enum: [
                        "pull",
                        "push",
                        "admin"
                    ],
                    type: "string"
                },
                privacy: {
                    enum: [
                        "secret",
                        "closed"
                    ],
                    type: "string"
                },
                repo_names: {
                    type: "string[]"
                }
            },
            url: "/orgs/:org/teams"
        },
        createDiscussion: {
            deprecated: "octokit.teams.createDiscussion() has been renamed to octokit.teams.createDiscussionLegacy() (2020-01-16)",
            method: "POST",
            params: {
                body: {
                    required: true,
                    type: "string"
                },
                private: {
                    type: "boolean"
                },
                team_id: {
                    required: true,
                    type: "integer"
                },
                title: {
                    required: true,
                    type: "string"
                }
            },
            url: "/teams/:team_id/discussions"
        },
        createDiscussionComment: {
            deprecated: "octokit.teams.createDiscussionComment() has been renamed to octokit.teams.createDiscussionCommentLegacy() (2020-01-16)",
            method: "POST",
            params: {
                body: {
                    required: true,
                    type: "string"
                },
                discussion_number: {
                    required: true,
                    type: "integer"
                },
                team_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/teams/:team_id/discussions/:discussion_number/comments"
        },
        createDiscussionCommentInOrg: {
            method: "POST",
            params: {
                body: {
                    required: true,
                    type: "string"
                },
                discussion_number: {
                    required: true,
                    type: "integer"
                },
                org: {
                    required: true,
                    type: "string"
                },
                team_slug: {
                    required: true,
                    type: "string"
                }
            },
            url: "/orgs/:org/teams/:team_slug/discussions/:discussion_number/comments"
        },
        createDiscussionCommentLegacy: {
            deprecated: "octokit.teams.createDiscussionCommentLegacy() is deprecated, see https://developer.github.com/v3/teams/discussion_comments/#create-a-comment-legacy",
            method: "POST",
            params: {
                body: {
                    required: true,
                    type: "string"
                },
                discussion_number: {
                    required: true,
                    type: "integer"
                },
                team_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/teams/:team_id/discussions/:discussion_number/comments"
        },
        createDiscussionInOrg: {
            method: "POST",
            params: {
                body: {
                    required: true,
                    type: "string"
                },
                org: {
                    required: true,
                    type: "string"
                },
                private: {
                    type: "boolean"
                },
                team_slug: {
                    required: true,
                    type: "string"
                },
                title: {
                    required: true,
                    type: "string"
                }
            },
            url: "/orgs/:org/teams/:team_slug/discussions"
        },
        createDiscussionLegacy: {
            deprecated: "octokit.teams.createDiscussionLegacy() is deprecated, see https://developer.github.com/v3/teams/discussions/#create-a-discussion-legacy",
            method: "POST",
            params: {
                body: {
                    required: true,
                    type: "string"
                },
                private: {
                    type: "boolean"
                },
                team_id: {
                    required: true,
                    type: "integer"
                },
                title: {
                    required: true,
                    type: "string"
                }
            },
            url: "/teams/:team_id/discussions"
        },
        delete: {
            deprecated: "octokit.teams.delete() has been renamed to octokit.teams.deleteLegacy() (2020-01-16)",
            method: "DELETE",
            params: {
                team_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/teams/:team_id"
        },
        deleteDiscussion: {
            deprecated: "octokit.teams.deleteDiscussion() has been renamed to octokit.teams.deleteDiscussionLegacy() (2020-01-16)",
            method: "DELETE",
            params: {
                discussion_number: {
                    required: true,
                    type: "integer"
                },
                team_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/teams/:team_id/discussions/:discussion_number"
        },
        deleteDiscussionComment: {
            deprecated: "octokit.teams.deleteDiscussionComment() has been renamed to octokit.teams.deleteDiscussionCommentLegacy() (2020-01-16)",
            method: "DELETE",
            params: {
                comment_number: {
                    required: true,
                    type: "integer"
                },
                discussion_number: {
                    required: true,
                    type: "integer"
                },
                team_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/teams/:team_id/discussions/:discussion_number/comments/:comment_number"
        },
        deleteDiscussionCommentInOrg: {
            method: "DELETE",
            params: {
                comment_number: {
                    required: true,
                    type: "integer"
                },
                discussion_number: {
                    required: true,
                    type: "integer"
                },
                org: {
                    required: true,
                    type: "string"
                },
                team_slug: {
                    required: true,
                    type: "string"
                }
            },
            url: "/orgs/:org/teams/:team_slug/discussions/:discussion_number/comments/:comment_number"
        },
        deleteDiscussionCommentLegacy: {
            deprecated: "octokit.teams.deleteDiscussionCommentLegacy() is deprecated, see https://developer.github.com/v3/teams/discussion_comments/#delete-a-comment-legacy",
            method: "DELETE",
            params: {
                comment_number: {
                    required: true,
                    type: "integer"
                },
                discussion_number: {
                    required: true,
                    type: "integer"
                },
                team_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/teams/:team_id/discussions/:discussion_number/comments/:comment_number"
        },
        deleteDiscussionInOrg: {
            method: "DELETE",
            params: {
                discussion_number: {
                    required: true,
                    type: "integer"
                },
                org: {
                    required: true,
                    type: "string"
                },
                team_slug: {
                    required: true,
                    type: "string"
                }
            },
            url: "/orgs/:org/teams/:team_slug/discussions/:discussion_number"
        },
        deleteDiscussionLegacy: {
            deprecated: "octokit.teams.deleteDiscussionLegacy() is deprecated, see https://developer.github.com/v3/teams/discussions/#delete-a-discussion-legacy",
            method: "DELETE",
            params: {
                discussion_number: {
                    required: true,
                    type: "integer"
                },
                team_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/teams/:team_id/discussions/:discussion_number"
        },
        deleteInOrg: {
            method: "DELETE",
            params: {
                org: {
                    required: true,
                    type: "string"
                },
                team_slug: {
                    required: true,
                    type: "string"
                }
            },
            url: "/orgs/:org/teams/:team_slug"
        },
        deleteLegacy: {
            deprecated: "octokit.teams.deleteLegacy() is deprecated, see https://developer.github.com/v3/teams/#delete-team-legacy",
            method: "DELETE",
            params: {
                team_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/teams/:team_id"
        },
        get: {
            deprecated: "octokit.teams.get() has been renamed to octokit.teams.getLegacy() (2020-01-16)",
            method: "GET",
            params: {
                team_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/teams/:team_id"
        },
        getByName: {
            method: "GET",
            params: {
                org: {
                    required: true,
                    type: "string"
                },
                team_slug: {
                    required: true,
                    type: "string"
                }
            },
            url: "/orgs/:org/teams/:team_slug"
        },
        getDiscussion: {
            deprecated: "octokit.teams.getDiscussion() has been renamed to octokit.teams.getDiscussionLegacy() (2020-01-16)",
            method: "GET",
            params: {
                discussion_number: {
                    required: true,
                    type: "integer"
                },
                team_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/teams/:team_id/discussions/:discussion_number"
        },
        getDiscussionComment: {
            deprecated: "octokit.teams.getDiscussionComment() has been renamed to octokit.teams.getDiscussionCommentLegacy() (2020-01-16)",
            method: "GET",
            params: {
                comment_number: {
                    required: true,
                    type: "integer"
                },
                discussion_number: {
                    required: true,
                    type: "integer"
                },
                team_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/teams/:team_id/discussions/:discussion_number/comments/:comment_number"
        },
        getDiscussionCommentInOrg: {
            method: "GET",
            params: {
                comment_number: {
                    required: true,
                    type: "integer"
                },
                discussion_number: {
                    required: true,
                    type: "integer"
                },
                org: {
                    required: true,
                    type: "string"
                },
                team_slug: {
                    required: true,
                    type: "string"
                }
            },
            url: "/orgs/:org/teams/:team_slug/discussions/:discussion_number/comments/:comment_number"
        },
        getDiscussionCommentLegacy: {
            deprecated: "octokit.teams.getDiscussionCommentLegacy() is deprecated, see https://developer.github.com/v3/teams/discussion_comments/#get-a-single-comment-legacy",
            method: "GET",
            params: {
                comment_number: {
                    required: true,
                    type: "integer"
                },
                discussion_number: {
                    required: true,
                    type: "integer"
                },
                team_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/teams/:team_id/discussions/:discussion_number/comments/:comment_number"
        },
        getDiscussionInOrg: {
            method: "GET",
            params: {
                discussion_number: {
                    required: true,
                    type: "integer"
                },
                org: {
                    required: true,
                    type: "string"
                },
                team_slug: {
                    required: true,
                    type: "string"
                }
            },
            url: "/orgs/:org/teams/:team_slug/discussions/:discussion_number"
        },
        getDiscussionLegacy: {
            deprecated: "octokit.teams.getDiscussionLegacy() is deprecated, see https://developer.github.com/v3/teams/discussions/#get-a-single-discussion-legacy",
            method: "GET",
            params: {
                discussion_number: {
                    required: true,
                    type: "integer"
                },
                team_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/teams/:team_id/discussions/:discussion_number"
        },
        getLegacy: {
            deprecated: "octokit.teams.getLegacy() is deprecated, see https://developer.github.com/v3/teams/#get-team-legacy",
            method: "GET",
            params: {
                team_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/teams/:team_id"
        },
        getMember: {
            deprecated: "octokit.teams.getMember() has been renamed to octokit.teams.getMemberLegacy() (2020-01-16)",
            method: "GET",
            params: {
                team_id: {
                    required: true,
                    type: "integer"
                },
                username: {
                    required: true,
                    type: "string"
                }
            },
            url: "/teams/:team_id/members/:username"
        },
        getMemberLegacy: {
            deprecated: "octokit.teams.getMemberLegacy() is deprecated, see https://developer.github.com/v3/teams/members/#get-team-member-legacy",
            method: "GET",
            params: {
                team_id: {
                    required: true,
                    type: "integer"
                },
                username: {
                    required: true,
                    type: "string"
                }
            },
            url: "/teams/:team_id/members/:username"
        },
        getMembership: {
            deprecated: "octokit.teams.getMembership() has been renamed to octokit.teams.getMembershipLegacy() (2020-01-16)",
            method: "GET",
            params: {
                team_id: {
                    required: true,
                    type: "integer"
                },
                username: {
                    required: true,
                    type: "string"
                }
            },
            url: "/teams/:team_id/memberships/:username"
        },
        getMembershipInOrg: {
            method: "GET",
            params: {
                org: {
                    required: true,
                    type: "string"
                },
                team_slug: {
                    required: true,
                    type: "string"
                },
                username: {
                    required: true,
                    type: "string"
                }
            },
            url: "/orgs/:org/teams/:team_slug/memberships/:username"
        },
        getMembershipLegacy: {
            deprecated: "octokit.teams.getMembershipLegacy() is deprecated, see https://developer.github.com/v3/teams/members/#get-team-membership-legacy",
            method: "GET",
            params: {
                team_id: {
                    required: true,
                    type: "integer"
                },
                username: {
                    required: true,
                    type: "string"
                }
            },
            url: "/teams/:team_id/memberships/:username"
        },
        list: {
            method: "GET",
            params: {
                org: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                }
            },
            url: "/orgs/:org/teams"
        },
        listChild: {
            deprecated: "octokit.teams.listChild() has been renamed to octokit.teams.listChildLegacy() (2020-01-16)",
            method: "GET",
            params: {
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                team_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/teams/:team_id/teams"
        },
        listChildInOrg: {
            method: "GET",
            params: {
                org: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                team_slug: {
                    required: true,
                    type: "string"
                }
            },
            url: "/orgs/:org/teams/:team_slug/teams"
        },
        listChildLegacy: {
            deprecated: "octokit.teams.listChildLegacy() is deprecated, see https://developer.github.com/v3/teams/#list-child-teams-legacy",
            method: "GET",
            params: {
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                team_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/teams/:team_id/teams"
        },
        listDiscussionComments: {
            deprecated: "octokit.teams.listDiscussionComments() has been renamed to octokit.teams.listDiscussionCommentsLegacy() (2020-01-16)",
            method: "GET",
            params: {
                direction: {
                    enum: [
                        "asc",
                        "desc"
                    ],
                    type: "string"
                },
                discussion_number: {
                    required: true,
                    type: "integer"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                team_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/teams/:team_id/discussions/:discussion_number/comments"
        },
        listDiscussionCommentsInOrg: {
            method: "GET",
            params: {
                direction: {
                    enum: [
                        "asc",
                        "desc"
                    ],
                    type: "string"
                },
                discussion_number: {
                    required: true,
                    type: "integer"
                },
                org: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                team_slug: {
                    required: true,
                    type: "string"
                }
            },
            url: "/orgs/:org/teams/:team_slug/discussions/:discussion_number/comments"
        },
        listDiscussionCommentsLegacy: {
            deprecated: "octokit.teams.listDiscussionCommentsLegacy() is deprecated, see https://developer.github.com/v3/teams/discussion_comments/#list-comments-legacy",
            method: "GET",
            params: {
                direction: {
                    enum: [
                        "asc",
                        "desc"
                    ],
                    type: "string"
                },
                discussion_number: {
                    required: true,
                    type: "integer"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                team_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/teams/:team_id/discussions/:discussion_number/comments"
        },
        listDiscussions: {
            deprecated: "octokit.teams.listDiscussions() has been renamed to octokit.teams.listDiscussionsLegacy() (2020-01-16)",
            method: "GET",
            params: {
                direction: {
                    enum: [
                        "asc",
                        "desc"
                    ],
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                team_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/teams/:team_id/discussions"
        },
        listDiscussionsInOrg: {
            method: "GET",
            params: {
                direction: {
                    enum: [
                        "asc",
                        "desc"
                    ],
                    type: "string"
                },
                org: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                team_slug: {
                    required: true,
                    type: "string"
                }
            },
            url: "/orgs/:org/teams/:team_slug/discussions"
        },
        listDiscussionsLegacy: {
            deprecated: "octokit.teams.listDiscussionsLegacy() is deprecated, see https://developer.github.com/v3/teams/discussions/#list-discussions-legacy",
            method: "GET",
            params: {
                direction: {
                    enum: [
                        "asc",
                        "desc"
                    ],
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                team_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/teams/:team_id/discussions"
        },
        listForAuthenticatedUser: {
            method: "GET",
            params: {
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                }
            },
            url: "/user/teams"
        },
        listMembers: {
            deprecated: "octokit.teams.listMembers() has been renamed to octokit.teams.listMembersLegacy() (2020-01-16)",
            method: "GET",
            params: {
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                role: {
                    enum: [
                        "member",
                        "maintainer",
                        "all"
                    ],
                    type: "string"
                },
                team_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/teams/:team_id/members"
        },
        listMembersInOrg: {
            method: "GET",
            params: {
                org: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                role: {
                    enum: [
                        "member",
                        "maintainer",
                        "all"
                    ],
                    type: "string"
                },
                team_slug: {
                    required: true,
                    type: "string"
                }
            },
            url: "/orgs/:org/teams/:team_slug/members"
        },
        listMembersLegacy: {
            deprecated: "octokit.teams.listMembersLegacy() is deprecated, see https://developer.github.com/v3/teams/members/#list-team-members-legacy",
            method: "GET",
            params: {
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                role: {
                    enum: [
                        "member",
                        "maintainer",
                        "all"
                    ],
                    type: "string"
                },
                team_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/teams/:team_id/members"
        },
        listPendingInvitations: {
            deprecated: "octokit.teams.listPendingInvitations() has been renamed to octokit.teams.listPendingInvitationsLegacy() (2020-01-16)",
            method: "GET",
            params: {
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                team_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/teams/:team_id/invitations"
        },
        listPendingInvitationsInOrg: {
            method: "GET",
            params: {
                org: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                team_slug: {
                    required: true,
                    type: "string"
                }
            },
            url: "/orgs/:org/teams/:team_slug/invitations"
        },
        listPendingInvitationsLegacy: {
            deprecated: "octokit.teams.listPendingInvitationsLegacy() is deprecated, see https://developer.github.com/v3/teams/members/#list-pending-team-invitations-legacy",
            method: "GET",
            params: {
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                team_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/teams/:team_id/invitations"
        },
        listProjects: {
            deprecated: "octokit.teams.listProjects() has been renamed to octokit.teams.listProjectsLegacy() (2020-01-16)",
            headers: {
                accept: "application/vnd.github.inertia-preview+json"
            },
            method: "GET",
            params: {
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                team_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/teams/:team_id/projects"
        },
        listProjectsInOrg: {
            headers: {
                accept: "application/vnd.github.inertia-preview+json"
            },
            method: "GET",
            params: {
                org: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                team_slug: {
                    required: true,
                    type: "string"
                }
            },
            url: "/orgs/:org/teams/:team_slug/projects"
        },
        listProjectsLegacy: {
            deprecated: "octokit.teams.listProjectsLegacy() is deprecated, see https://developer.github.com/v3/teams/#list-team-projects-legacy",
            headers: {
                accept: "application/vnd.github.inertia-preview+json"
            },
            method: "GET",
            params: {
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                team_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/teams/:team_id/projects"
        },
        listRepos: {
            deprecated: "octokit.teams.listRepos() has been renamed to octokit.teams.listReposLegacy() (2020-01-16)",
            method: "GET",
            params: {
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                team_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/teams/:team_id/repos"
        },
        listReposInOrg: {
            method: "GET",
            params: {
                org: {
                    required: true,
                    type: "string"
                },
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                team_slug: {
                    required: true,
                    type: "string"
                }
            },
            url: "/orgs/:org/teams/:team_slug/repos"
        },
        listReposLegacy: {
            deprecated: "octokit.teams.listReposLegacy() is deprecated, see https://developer.github.com/v3/teams/#list-team-repos-legacy",
            method: "GET",
            params: {
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                team_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/teams/:team_id/repos"
        },
        removeMember: {
            deprecated: "octokit.teams.removeMember() has been renamed to octokit.teams.removeMemberLegacy() (2020-01-16)",
            method: "DELETE",
            params: {
                team_id: {
                    required: true,
                    type: "integer"
                },
                username: {
                    required: true,
                    type: "string"
                }
            },
            url: "/teams/:team_id/members/:username"
        },
        removeMemberLegacy: {
            deprecated: "octokit.teams.removeMemberLegacy() is deprecated, see https://developer.github.com/v3/teams/members/#remove-team-member-legacy",
            method: "DELETE",
            params: {
                team_id: {
                    required: true,
                    type: "integer"
                },
                username: {
                    required: true,
                    type: "string"
                }
            },
            url: "/teams/:team_id/members/:username"
        },
        removeMembership: {
            deprecated: "octokit.teams.removeMembership() has been renamed to octokit.teams.removeMembershipLegacy() (2020-01-16)",
            method: "DELETE",
            params: {
                team_id: {
                    required: true,
                    type: "integer"
                },
                username: {
                    required: true,
                    type: "string"
                }
            },
            url: "/teams/:team_id/memberships/:username"
        },
        removeMembershipInOrg: {
            method: "DELETE",
            params: {
                org: {
                    required: true,
                    type: "string"
                },
                team_slug: {
                    required: true,
                    type: "string"
                },
                username: {
                    required: true,
                    type: "string"
                }
            },
            url: "/orgs/:org/teams/:team_slug/memberships/:username"
        },
        removeMembershipLegacy: {
            deprecated: "octokit.teams.removeMembershipLegacy() is deprecated, see https://developer.github.com/v3/teams/members/#remove-team-membership-legacy",
            method: "DELETE",
            params: {
                team_id: {
                    required: true,
                    type: "integer"
                },
                username: {
                    required: true,
                    type: "string"
                }
            },
            url: "/teams/:team_id/memberships/:username"
        },
        removeProject: {
            deprecated: "octokit.teams.removeProject() has been renamed to octokit.teams.removeProjectLegacy() (2020-01-16)",
            method: "DELETE",
            params: {
                project_id: {
                    required: true,
                    type: "integer"
                },
                team_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/teams/:team_id/projects/:project_id"
        },
        removeProjectInOrg: {
            method: "DELETE",
            params: {
                org: {
                    required: true,
                    type: "string"
                },
                project_id: {
                    required: true,
                    type: "integer"
                },
                team_slug: {
                    required: true,
                    type: "string"
                }
            },
            url: "/orgs/:org/teams/:team_slug/projects/:project_id"
        },
        removeProjectLegacy: {
            deprecated: "octokit.teams.removeProjectLegacy() is deprecated, see https://developer.github.com/v3/teams/#remove-team-project-legacy",
            method: "DELETE",
            params: {
                project_id: {
                    required: true,
                    type: "integer"
                },
                team_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/teams/:team_id/projects/:project_id"
        },
        removeRepo: {
            deprecated: "octokit.teams.removeRepo() has been renamed to octokit.teams.removeRepoLegacy() (2020-01-16)",
            method: "DELETE",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                team_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/teams/:team_id/repos/:owner/:repo"
        },
        removeRepoInOrg: {
            method: "DELETE",
            params: {
                org: {
                    required: true,
                    type: "string"
                },
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                team_slug: {
                    required: true,
                    type: "string"
                }
            },
            url: "/orgs/:org/teams/:team_slug/repos/:owner/:repo"
        },
        removeRepoLegacy: {
            deprecated: "octokit.teams.removeRepoLegacy() is deprecated, see https://developer.github.com/v3/teams/#remove-team-repository-legacy",
            method: "DELETE",
            params: {
                owner: {
                    required: true,
                    type: "string"
                },
                repo: {
                    required: true,
                    type: "string"
                },
                team_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/teams/:team_id/repos/:owner/:repo"
        },
        reviewProject: {
            deprecated: "octokit.teams.reviewProject() has been renamed to octokit.teams.reviewProjectLegacy() (2020-01-16)",
            headers: {
                accept: "application/vnd.github.inertia-preview+json"
            },
            method: "GET",
            params: {
                project_id: {
                    required: true,
                    type: "integer"
                },
                team_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/teams/:team_id/projects/:project_id"
        },
        reviewProjectInOrg: {
            headers: {
                accept: "application/vnd.github.inertia-preview+json"
            },
            method: "GET",
            params: {
                org: {
                    required: true,
                    type: "string"
                },
                project_id: {
                    required: true,
                    type: "integer"
                },
                team_slug: {
                    required: true,
                    type: "string"
                }
            },
            url: "/orgs/:org/teams/:team_slug/projects/:project_id"
        },
        reviewProjectLegacy: {
            deprecated: "octokit.teams.reviewProjectLegacy() is deprecated, see https://developer.github.com/v3/teams/#review-a-team-project-legacy",
            headers: {
                accept: "application/vnd.github.inertia-preview+json"
            },
            method: "GET",
            params: {
                project_id: {
                    required: true,
                    type: "integer"
                },
                team_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/teams/:team_id/projects/:project_id"
        },
        update: {
            deprecated: "octokit.teams.update() has been renamed to octokit.teams.updateLegacy() (2020-01-16)",
            method: "PATCH",
            params: {
                description: {
                    type: "string"
                },
                name: {
                    required: true,
                    type: "string"
                },
                parent_team_id: {
                    type: "integer"
                },
                permission: {
                    enum: [
                        "pull",
                        "push",
                        "admin"
                    ],
                    type: "string"
                },
                privacy: {
                    enum: [
                        "secret",
                        "closed"
                    ],
                    type: "string"
                },
                team_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/teams/:team_id"
        },
        updateDiscussion: {
            deprecated: "octokit.teams.updateDiscussion() has been renamed to octokit.teams.updateDiscussionLegacy() (2020-01-16)",
            method: "PATCH",
            params: {
                body: {
                    type: "string"
                },
                discussion_number: {
                    required: true,
                    type: "integer"
                },
                team_id: {
                    required: true,
                    type: "integer"
                },
                title: {
                    type: "string"
                }
            },
            url: "/teams/:team_id/discussions/:discussion_number"
        },
        updateDiscussionComment: {
            deprecated: "octokit.teams.updateDiscussionComment() has been renamed to octokit.teams.updateDiscussionCommentLegacy() (2020-01-16)",
            method: "PATCH",
            params: {
                body: {
                    required: true,
                    type: "string"
                },
                comment_number: {
                    required: true,
                    type: "integer"
                },
                discussion_number: {
                    required: true,
                    type: "integer"
                },
                team_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/teams/:team_id/discussions/:discussion_number/comments/:comment_number"
        },
        updateDiscussionCommentInOrg: {
            method: "PATCH",
            params: {
                body: {
                    required: true,
                    type: "string"
                },
                comment_number: {
                    required: true,
                    type: "integer"
                },
                discussion_number: {
                    required: true,
                    type: "integer"
                },
                org: {
                    required: true,
                    type: "string"
                },
                team_slug: {
                    required: true,
                    type: "string"
                }
            },
            url: "/orgs/:org/teams/:team_slug/discussions/:discussion_number/comments/:comment_number"
        },
        updateDiscussionCommentLegacy: {
            deprecated: "octokit.teams.updateDiscussionCommentLegacy() is deprecated, see https://developer.github.com/v3/teams/discussion_comments/#edit-a-comment-legacy",
            method: "PATCH",
            params: {
                body: {
                    required: true,
                    type: "string"
                },
                comment_number: {
                    required: true,
                    type: "integer"
                },
                discussion_number: {
                    required: true,
                    type: "integer"
                },
                team_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/teams/:team_id/discussions/:discussion_number/comments/:comment_number"
        },
        updateDiscussionInOrg: {
            method: "PATCH",
            params: {
                body: {
                    type: "string"
                },
                discussion_number: {
                    required: true,
                    type: "integer"
                },
                org: {
                    required: true,
                    type: "string"
                },
                team_slug: {
                    required: true,
                    type: "string"
                },
                title: {
                    type: "string"
                }
            },
            url: "/orgs/:org/teams/:team_slug/discussions/:discussion_number"
        },
        updateDiscussionLegacy: {
            deprecated: "octokit.teams.updateDiscussionLegacy() is deprecated, see https://developer.github.com/v3/teams/discussions/#edit-a-discussion-legacy",
            method: "PATCH",
            params: {
                body: {
                    type: "string"
                },
                discussion_number: {
                    required: true,
                    type: "integer"
                },
                team_id: {
                    required: true,
                    type: "integer"
                },
                title: {
                    type: "string"
                }
            },
            url: "/teams/:team_id/discussions/:discussion_number"
        },
        updateInOrg: {
            method: "PATCH",
            params: {
                description: {
                    type: "string"
                },
                name: {
                    required: true,
                    type: "string"
                },
                org: {
                    required: true,
                    type: "string"
                },
                parent_team_id: {
                    type: "integer"
                },
                permission: {
                    enum: [
                        "pull",
                        "push",
                        "admin"
                    ],
                    type: "string"
                },
                privacy: {
                    enum: [
                        "secret",
                        "closed"
                    ],
                    type: "string"
                },
                team_slug: {
                    required: true,
                    type: "string"
                }
            },
            url: "/orgs/:org/teams/:team_slug"
        },
        updateLegacy: {
            deprecated: "octokit.teams.updateLegacy() is deprecated, see https://developer.github.com/v3/teams/#edit-team-legacy",
            method: "PATCH",
            params: {
                description: {
                    type: "string"
                },
                name: {
                    required: true,
                    type: "string"
                },
                parent_team_id: {
                    type: "integer"
                },
                permission: {
                    enum: [
                        "pull",
                        "push",
                        "admin"
                    ],
                    type: "string"
                },
                privacy: {
                    enum: [
                        "secret",
                        "closed"
                    ],
                    type: "string"
                },
                team_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/teams/:team_id"
        }
    },
    users: {
        addEmails: {
            method: "POST",
            params: {
                emails: {
                    required: true,
                    type: "string[]"
                }
            },
            url: "/user/emails"
        },
        block: {
            method: "PUT",
            params: {
                username: {
                    required: true,
                    type: "string"
                }
            },
            url: "/user/blocks/:username"
        },
        checkBlocked: {
            method: "GET",
            params: {
                username: {
                    required: true,
                    type: "string"
                }
            },
            url: "/user/blocks/:username"
        },
        checkFollowing: {
            method: "GET",
            params: {
                username: {
                    required: true,
                    type: "string"
                }
            },
            url: "/user/following/:username"
        },
        checkFollowingForUser: {
            method: "GET",
            params: {
                target_user: {
                    required: true,
                    type: "string"
                },
                username: {
                    required: true,
                    type: "string"
                }
            },
            url: "/users/:username/following/:target_user"
        },
        createGpgKey: {
            method: "POST",
            params: {
                armored_public_key: {
                    type: "string"
                }
            },
            url: "/user/gpg_keys"
        },
        createPublicKey: {
            method: "POST",
            params: {
                key: {
                    type: "string"
                },
                title: {
                    type: "string"
                }
            },
            url: "/user/keys"
        },
        deleteEmails: {
            method: "DELETE",
            params: {
                emails: {
                    required: true,
                    type: "string[]"
                }
            },
            url: "/user/emails"
        },
        deleteGpgKey: {
            method: "DELETE",
            params: {
                gpg_key_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/user/gpg_keys/:gpg_key_id"
        },
        deletePublicKey: {
            method: "DELETE",
            params: {
                key_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/user/keys/:key_id"
        },
        follow: {
            method: "PUT",
            params: {
                username: {
                    required: true,
                    type: "string"
                }
            },
            url: "/user/following/:username"
        },
        getAuthenticated: {
            method: "GET",
            params: {},
            url: "/user"
        },
        getByUsername: {
            method: "GET",
            params: {
                username: {
                    required: true,
                    type: "string"
                }
            },
            url: "/users/:username"
        },
        getContextForUser: {
            method: "GET",
            params: {
                subject_id: {
                    type: "string"
                },
                subject_type: {
                    enum: [
                        "organization",
                        "repository",
                        "issue",
                        "pull_request"
                    ],
                    type: "string"
                },
                username: {
                    required: true,
                    type: "string"
                }
            },
            url: "/users/:username/hovercard"
        },
        getGpgKey: {
            method: "GET",
            params: {
                gpg_key_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/user/gpg_keys/:gpg_key_id"
        },
        getPublicKey: {
            method: "GET",
            params: {
                key_id: {
                    required: true,
                    type: "integer"
                }
            },
            url: "/user/keys/:key_id"
        },
        list: {
            method: "GET",
            params: {
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                since: {
                    type: "string"
                }
            },
            url: "/users"
        },
        listBlocked: {
            method: "GET",
            params: {},
            url: "/user/blocks"
        },
        listEmails: {
            method: "GET",
            params: {
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                }
            },
            url: "/user/emails"
        },
        listFollowersForAuthenticatedUser: {
            method: "GET",
            params: {
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                }
            },
            url: "/user/followers"
        },
        listFollowersForUser: {
            method: "GET",
            params: {
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                username: {
                    required: true,
                    type: "string"
                }
            },
            url: "/users/:username/followers"
        },
        listFollowingForAuthenticatedUser: {
            method: "GET",
            params: {
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                }
            },
            url: "/user/following"
        },
        listFollowingForUser: {
            method: "GET",
            params: {
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                username: {
                    required: true,
                    type: "string"
                }
            },
            url: "/users/:username/following"
        },
        listGpgKeys: {
            method: "GET",
            params: {
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                }
            },
            url: "/user/gpg_keys"
        },
        listGpgKeysForUser: {
            method: "GET",
            params: {
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                username: {
                    required: true,
                    type: "string"
                }
            },
            url: "/users/:username/gpg_keys"
        },
        listPublicEmails: {
            method: "GET",
            params: {
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                }
            },
            url: "/user/public_emails"
        },
        listPublicKeys: {
            method: "GET",
            params: {
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                }
            },
            url: "/user/keys"
        },
        listPublicKeysForUser: {
            method: "GET",
            params: {
                page: {
                    type: "integer"
                },
                per_page: {
                    type: "integer"
                },
                username: {
                    required: true,
                    type: "string"
                }
            },
            url: "/users/:username/keys"
        },
        togglePrimaryEmailVisibility: {
            method: "PATCH",
            params: {
                email: {
                    required: true,
                    type: "string"
                },
                visibility: {
                    required: true,
                    type: "string"
                }
            },
            url: "/user/email/visibility"
        },
        unblock: {
            method: "DELETE",
            params: {
                username: {
                    required: true,
                    type: "string"
                }
            },
            url: "/user/blocks/:username"
        },
        unfollow: {
            method: "DELETE",
            params: {
                username: {
                    required: true,
                    type: "string"
                }
            },
            url: "/user/following/:username"
        },
        updateAuthenticated: {
            method: "PATCH",
            params: {
                bio: {
                    type: "string"
                },
                blog: {
                    type: "string"
                },
                company: {
                    type: "string"
                },
                email: {
                    type: "string"
                },
                hireable: {
                    type: "boolean"
                },
                location: {
                    type: "string"
                },
                name: {
                    type: "string"
                }
            },
            url: "/user"
        }
    }
};
const $55be46b53005923d$var$VERSION = "2.4.0";
function $55be46b53005923d$var$registerEndpoints(octokit, routes) {
    Object.keys(routes).forEach((namespaceName)=>{
        if (!octokit[namespaceName]) octokit[namespaceName] = {};
        Object.keys(routes[namespaceName]).forEach((apiName)=>{
            const apiOptions = routes[namespaceName][apiName];
            const endpointDefaults = [
                "method",
                "url",
                "headers"
            ].reduce((map, key)=>{
                if (typeof apiOptions[key] !== "undefined") map[key] = apiOptions[key];
                return map;
            }, {});
            endpointDefaults.request = {
                validate: apiOptions.params
            };
            let request = octokit.request.defaults(endpointDefaults);
            // patch request & endpoint methods to support deprecated parameters.
            // Not the most elegant solution, but we don’t want to move deprecation
            // logic into octokit/endpoint.js as it’s out of scope
            const hasDeprecatedParam = Object.keys(apiOptions.params || {}).find((key)=>apiOptions.params[key].deprecated);
            if (hasDeprecatedParam) {
                const patch = $55be46b53005923d$var$patchForDeprecation.bind(null, octokit, apiOptions);
                request = patch(octokit.request.defaults(endpointDefaults), `.${namespaceName}.${apiName}()`);
                request.endpoint = patch(request.endpoint, `.${namespaceName}.${apiName}.endpoint()`);
                request.endpoint.merge = patch(request.endpoint.merge, `.${namespaceName}.${apiName}.endpoint.merge()`);
            }
            if (apiOptions.deprecated) {
                octokit[namespaceName][apiName] = Object.assign(function deprecatedEndpointMethod() {
                    octokit.log.warn(new (0, $lG4DW.Deprecation)(`[@octokit/rest] ${apiOptions.deprecated}`));
                    octokit[namespaceName][apiName] = request;
                    return request.apply(null, arguments);
                }, request);
                return;
            }
            octokit[namespaceName][apiName] = request;
        });
    });
}
function $55be46b53005923d$var$patchForDeprecation(octokit, apiOptions, method, methodName) {
    const patchedMethod = (options)=>{
        options = Object.assign({}, options);
        Object.keys(options).forEach((key)=>{
            if (apiOptions.params[key] && apiOptions.params[key].deprecated) {
                const aliasKey = apiOptions.params[key].alias;
                octokit.log.warn(new (0, $lG4DW.Deprecation)(`[@octokit/rest] "${key}" parameter is deprecated for "${methodName}". Use "${aliasKey}" instead`));
                if (!(aliasKey in options)) options[aliasKey] = options[key];
                delete options[key];
            }
        });
        return method(options);
    };
    Object.keys(method).forEach((key)=>{
        patchedMethod[key] = method[key];
    });
    return patchedMethod;
}
/**
 * This plugin is a 1:1 copy of internal @octokit/rest plugins. The primary
 * goal is to rebuild @octokit/rest on top of @octokit/core. Once that is
 * done, we will remove the registerEndpoints methods and return the methods
 * directly as with the other plugins. At that point we will also remove the
 * legacy workarounds and deprecations.
 *
 * See the plan at
 * https://github.com/octokit/plugin-rest-endpoint-methods.js/pull/1
 */ function $55be46b53005923d$export$a1fe24cc78039d62(octokit) {
    // @ts-ignore
    octokit.registerEndpoints = $55be46b53005923d$var$registerEndpoints.bind(null, octokit);
    $55be46b53005923d$var$registerEndpoints(octokit, $55be46b53005923d$var$endpointsByScope);
    // Aliasing scopes for backward compatibility
    // See https://github.com/octokit/rest.js/pull/1134
    [
        [
            "gitdata",
            "git"
        ],
        [
            "authorization",
            "oauthAuthorizations"
        ],
        [
            "pullRequests",
            "pulls"
        ]
    ].forEach(([deprecatedScope, scope])=>{
        Object.defineProperty(octokit, deprecatedScope, {
            get () {
                octokit.log.warn(// @ts-ignore
                new (0, $lG4DW.Deprecation)(`[@octokit/plugin-rest-endpoint-methods] "octokit.${deprecatedScope}.*" methods are deprecated, use "octokit.${scope}.*" instead`));
                // @ts-ignore
                return octokit[scope];
            }
        });
    });
    return {};
}
$55be46b53005923d$export$a1fe24cc78039d62.VERSION = $55be46b53005923d$var$VERSION;


var $e08db83179311785$require$restEndpointMethods = $55be46b53005923d$export$a1fe24cc78039d62;
var $3cc045d983cca955$exports = {};
var $16a8e11c3a7490cc$exports = {};
$16a8e11c3a7490cc$exports = $16a8e11c3a7490cc$var$factory;
var $a793e54ae19e793b$exports = {};
$a793e54ae19e793b$exports = $a793e54ae19e793b$var$Octokit;
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */ function $cdeacdf23b3f7c65$var$isObject(o) {
    return Object.prototype.toString.call(o) === '[object Object]';
}
function $cdeacdf23b3f7c65$export$53b83ca8eaab0383(o) {
    var ctor, prot;
    if ($cdeacdf23b3f7c65$var$isObject(o) === false) return false;
    // If has modified constructor
    ctor = o.constructor;
    if (ctor === undefined) return true;
    // If has modified prototype
    prot = ctor.prototype;
    if ($cdeacdf23b3f7c65$var$isObject(prot) === false) return false;
    // If constructor does not have an Object-specific method
    if (prot.hasOwnProperty('isPrototypeOf') === false) return false;
    // Most likely a plain Object
    return true;
}


function $c75a59017d47d2d8$export$7935961ef7719cb0() {
    if (typeof navigator === "object" && "userAgent" in navigator) return navigator.userAgent;
    return "<environment undetectable>";
}


function $7f55e49166b9f1c8$var$lowercaseKeys(object) {
    if (!object) return {};
    return Object.keys(object).reduce((newObj, key)=>{
        newObj[key.toLowerCase()] = object[key];
        return newObj;
    }, {});
}
function $7f55e49166b9f1c8$var$mergeDeep(defaults, options) {
    const result = Object.assign({}, defaults);
    Object.keys(options).forEach((key)=>{
        if ((0, $cdeacdf23b3f7c65$export$53b83ca8eaab0383)(options[key])) {
            if (!(key in defaults)) Object.assign(result, {
                [key]: options[key]
            });
            else result[key] = $7f55e49166b9f1c8$var$mergeDeep(defaults[key], options[key]);
        } else Object.assign(result, {
            [key]: options[key]
        });
    });
    return result;
}
function $7f55e49166b9f1c8$var$removeUndefinedProperties(obj) {
    for(const key in obj)if (obj[key] === undefined) delete obj[key];
    return obj;
}
function $7f55e49166b9f1c8$var$merge(defaults, route, options) {
    if (typeof route === "string") {
        let [method, url] = route.split(" ");
        options = Object.assign(url ? {
            method: method,
            url: url
        } : {
            url: method
        }, options);
    } else options = Object.assign({}, route);
    // lowercase header names before merging with defaults to avoid duplicates
    options.headers = $7f55e49166b9f1c8$var$lowercaseKeys(options.headers);
    // remove properties with undefined values before merging
    $7f55e49166b9f1c8$var$removeUndefinedProperties(options);
    $7f55e49166b9f1c8$var$removeUndefinedProperties(options.headers);
    const mergedOptions = $7f55e49166b9f1c8$var$mergeDeep(defaults || {}, options);
    // mediaType.previews arrays are merged, instead of overwritten
    if (defaults && defaults.mediaType.previews.length) mergedOptions.mediaType.previews = defaults.mediaType.previews.filter((preview)=>!mergedOptions.mediaType.previews.includes(preview)).concat(mergedOptions.mediaType.previews);
    mergedOptions.mediaType.previews = mergedOptions.mediaType.previews.map((preview)=>preview.replace(/-preview/, ""));
    return mergedOptions;
}
function $7f55e49166b9f1c8$var$addQueryParameters(url, parameters) {
    const separator = /\?/.test(url) ? "&" : "?";
    const names = Object.keys(parameters);
    if (names.length === 0) return url;
    return url + separator + names.map((name)=>{
        if (name === "q") return "q=" + parameters.q.split("+").map(encodeURIComponent).join("+");
        return `${name}=${encodeURIComponent(parameters[name])}`;
    }).join("&");
}
const $7f55e49166b9f1c8$var$urlVariableRegex = /\{[^}]+\}/g;
function $7f55e49166b9f1c8$var$removeNonChars(variableName) {
    return variableName.replace(/^\W+|\W+$/g, "").split(/,/);
}
function $7f55e49166b9f1c8$var$extractUrlVariableNames(url) {
    const matches = url.match($7f55e49166b9f1c8$var$urlVariableRegex);
    if (!matches) return [];
    return matches.map($7f55e49166b9f1c8$var$removeNonChars).reduce((a, b)=>a.concat(b), []);
}
function $7f55e49166b9f1c8$var$omit(object, keysToOmit) {
    return Object.keys(object).filter((option)=>!keysToOmit.includes(option)).reduce((obj, key)=>{
        obj[key] = object[key];
        return obj;
    }, {});
}
// Based on https://github.com/bramstein/url-template, licensed under BSD
// TODO: create separate package.
//
// Copyright (c) 2012-2014, Bram Stein
// All rights reserved.
// Redistribution and use in source and binary forms, with or without
// modification, are permitted provided that the following conditions
// are met:
//  1. Redistributions of source code must retain the above copyright
//     notice, this list of conditions and the following disclaimer.
//  2. Redistributions in binary form must reproduce the above copyright
//     notice, this list of conditions and the following disclaimer in the
//     documentation and/or other materials provided with the distribution.
//  3. The name of the author may not be used to endorse or promote products
//     derived from this software without specific prior written permission.
// THIS SOFTWARE IS PROVIDED BY THE AUTHOR "AS IS" AND ANY EXPRESS OR IMPLIED
// WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
// MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO
// EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
// INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING,
// BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
// DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
// OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
// NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
// EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
/* istanbul ignore file */ function $7f55e49166b9f1c8$var$encodeReserved(str) {
    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function(part) {
        if (!/%[0-9A-Fa-f]/.test(part)) part = encodeURI(part).replace(/%5B/g, "[").replace(/%5D/g, "]");
        return part;
    }).join("");
}
function $7f55e49166b9f1c8$var$encodeUnreserved(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
function $7f55e49166b9f1c8$var$encodeValue(operator, value, key) {
    value = operator === "+" || operator === "#" ? $7f55e49166b9f1c8$var$encodeReserved(value) : $7f55e49166b9f1c8$var$encodeUnreserved(value);
    if (key) return $7f55e49166b9f1c8$var$encodeUnreserved(key) + "=" + value;
    else return value;
}
function $7f55e49166b9f1c8$var$isDefined(value) {
    return value !== undefined && value !== null;
}
function $7f55e49166b9f1c8$var$isKeyOperator(operator) {
    return operator === ";" || operator === "&" || operator === "?";
}
function $7f55e49166b9f1c8$var$getValues(context, operator, key, modifier) {
    var value = context[key], result = [];
    if ($7f55e49166b9f1c8$var$isDefined(value) && value !== "") {
        if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") {
            value = value.toString();
            if (modifier && modifier !== "*") value = value.substring(0, parseInt(modifier, 10));
            result.push($7f55e49166b9f1c8$var$encodeValue(operator, value, $7f55e49166b9f1c8$var$isKeyOperator(operator) ? key : ""));
        } else if (modifier === "*") {
            if (Array.isArray(value)) value.filter($7f55e49166b9f1c8$var$isDefined).forEach(function(value) {
                result.push($7f55e49166b9f1c8$var$encodeValue(operator, value, $7f55e49166b9f1c8$var$isKeyOperator(operator) ? key : ""));
            });
            else Object.keys(value).forEach(function(k) {
                if ($7f55e49166b9f1c8$var$isDefined(value[k])) result.push($7f55e49166b9f1c8$var$encodeValue(operator, value[k], k));
            });
        } else {
            const tmp = [];
            if (Array.isArray(value)) value.filter($7f55e49166b9f1c8$var$isDefined).forEach(function(value) {
                tmp.push($7f55e49166b9f1c8$var$encodeValue(operator, value));
            });
            else Object.keys(value).forEach(function(k) {
                if ($7f55e49166b9f1c8$var$isDefined(value[k])) {
                    tmp.push($7f55e49166b9f1c8$var$encodeUnreserved(k));
                    tmp.push($7f55e49166b9f1c8$var$encodeValue(operator, value[k].toString()));
                }
            });
            if ($7f55e49166b9f1c8$var$isKeyOperator(operator)) result.push($7f55e49166b9f1c8$var$encodeUnreserved(key) + "=" + tmp.join(","));
            else if (tmp.length !== 0) result.push(tmp.join(","));
        }
    } else {
        if (operator === ";") {
            if ($7f55e49166b9f1c8$var$isDefined(value)) result.push($7f55e49166b9f1c8$var$encodeUnreserved(key));
        } else if (value === "" && (operator === "&" || operator === "?")) result.push($7f55e49166b9f1c8$var$encodeUnreserved(key) + "=");
        else if (value === "") result.push("");
    }
    return result;
}
function $7f55e49166b9f1c8$var$parseUrl(template) {
    return {
        expand: $7f55e49166b9f1c8$var$expand.bind(null, template)
    };
}
function $7f55e49166b9f1c8$var$expand(template, context) {
    var operators = [
        "+",
        "#",
        ".",
        "/",
        ";",
        "?",
        "&"
    ];
    return template.replace(/\{([^\{\}]+)\}|([^\{\}]+)/g, function(_, expression, literal) {
        if (expression) {
            let operator = "";
            const values = [];
            if (operators.indexOf(expression.charAt(0)) !== -1) {
                operator = expression.charAt(0);
                expression = expression.substr(1);
            }
            expression.split(/,/g).forEach(function(variable) {
                var tmp = /([^:\*]*)(?::(\d+)|(\*))?/.exec(variable);
                values.push($7f55e49166b9f1c8$var$getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
            });
            if (operator && operator !== "+") {
                var separator = ",";
                if (operator === "?") separator = "&";
                else if (operator !== "#") separator = operator;
                return (values.length !== 0 ? operator : "") + values.join(separator);
            } else return values.join(",");
        } else return $7f55e49166b9f1c8$var$encodeReserved(literal);
    });
}
function $7f55e49166b9f1c8$var$parse(options) {
    // https://fetch.spec.whatwg.org/#methods
    let method = options.method.toUpperCase();
    // replace :varname with {varname} to make it RFC 6570 compatible
    let url = (options.url || "/").replace(/:([a-z]\w+)/g, "{$1}");
    let headers = Object.assign({}, options.headers);
    let body;
    let parameters = $7f55e49166b9f1c8$var$omit(options, [
        "method",
        "baseUrl",
        "url",
        "headers",
        "request",
        "mediaType"
    ]);
    // extract variable names from URL to calculate remaining variables later
    const urlVariableNames = $7f55e49166b9f1c8$var$extractUrlVariableNames(url);
    url = $7f55e49166b9f1c8$var$parseUrl(url).expand(parameters);
    if (!/^http/.test(url)) url = options.baseUrl + url;
    const omittedParameters = Object.keys(options).filter((option)=>urlVariableNames.includes(option)).concat("baseUrl");
    const remainingParameters = $7f55e49166b9f1c8$var$omit(parameters, omittedParameters);
    const isBinaryRequest = /application\/octet-stream/i.test(headers.accept);
    if (!isBinaryRequest) {
        if (options.mediaType.format) // e.g. application/vnd.github.v3+json => application/vnd.github.v3.raw
        headers.accept = headers.accept.split(/,/).map((preview)=>preview.replace(/application\/vnd(\.\w+)(\.v3)?(\.\w+)?(\+json)?$/, `application/vnd$1$2.${options.mediaType.format}`)).join(",");
        if (options.mediaType.previews.length) {
            const previewsFromAcceptHeader = headers.accept.match(/[\w-]+(?=-preview)/g) || [];
            headers.accept = previewsFromAcceptHeader.concat(options.mediaType.previews).map((preview)=>{
                const format = options.mediaType.format ? `.${options.mediaType.format}` : "+json";
                return `application/vnd.github.${preview}-preview${format}`;
            }).join(",");
        }
    }
    // for GET/HEAD requests, set URL query parameters from remaining parameters
    // for PATCH/POST/PUT/DELETE requests, set request body from remaining parameters
    if ([
        "GET",
        "HEAD"
    ].includes(method)) url = $7f55e49166b9f1c8$var$addQueryParameters(url, remainingParameters);
    else {
        if ("data" in remainingParameters) body = remainingParameters.data;
        else if (Object.keys(remainingParameters).length) body = remainingParameters;
        else headers["content-length"] = 0;
    }
    // default content-type for JSON if body is set
    if (!headers["content-type"] && typeof body !== "undefined") headers["content-type"] = "application/json; charset=utf-8";
    // GitHub expects 'content-length: 0' header for PUT/PATCH requests without body.
    // fetch does not allow to set `content-length` header, but we can set body to an empty string
    if ([
        "PATCH",
        "PUT"
    ].includes(method) && typeof body === "undefined") body = "";
    // Only return body/request keys if present
    return Object.assign({
        method: method,
        url: url,
        headers: headers
    }, typeof body !== "undefined" ? {
        body: body
    } : null, options.request ? {
        request: options.request
    } : null);
}
function $7f55e49166b9f1c8$var$endpointWithDefaults(defaults, route, options) {
    return $7f55e49166b9f1c8$var$parse($7f55e49166b9f1c8$var$merge(defaults, route, options));
}
function $7f55e49166b9f1c8$var$withDefaults(oldDefaults, newDefaults) {
    const DEFAULTS = $7f55e49166b9f1c8$var$merge(oldDefaults, newDefaults);
    const endpoint = $7f55e49166b9f1c8$var$endpointWithDefaults.bind(null, DEFAULTS);
    return Object.assign(endpoint, {
        DEFAULTS: DEFAULTS,
        defaults: $7f55e49166b9f1c8$var$withDefaults.bind(null, DEFAULTS),
        merge: $7f55e49166b9f1c8$var$merge.bind(null, DEFAULTS),
        parse: $7f55e49166b9f1c8$var$parse
    });
}
const $7f55e49166b9f1c8$var$VERSION = "6.0.12";
const $7f55e49166b9f1c8$var$userAgent = `octokit-endpoint.js/${$7f55e49166b9f1c8$var$VERSION} ${(0, $c75a59017d47d2d8$export$7935961ef7719cb0)()}`;
// DEFAULTS has all properties set that EndpointOptions has, except url.
// So we use RequestParameters and add method as additional required property.
const $7f55e49166b9f1c8$var$DEFAULTS = {
    method: "GET",
    baseUrl: "https://api.github.com",
    headers: {
        accept: "application/vnd.github.v3+json",
        "user-agent": $7f55e49166b9f1c8$var$userAgent
    },
    mediaType: {
        format: "",
        previews: []
    }
};
const $7f55e49166b9f1c8$export$125e2b775860041f = $7f55e49166b9f1c8$var$withDefaults(null, $7f55e49166b9f1c8$var$DEFAULTS);





var $5Uvwt = parcelRequire("5Uvwt");

var $lG4DW = parcelRequire("lG4DW");

var $i1Owb = parcelRequire("i1Owb");
const $76f5a0d4862f0d81$var$logOnceCode = (0, (/*@__PURE__*/$parcel$interopDefault($i1Owb)))((deprecation)=>console.warn(deprecation));
const $76f5a0d4862f0d81$var$logOnceHeaders = (0, (/*@__PURE__*/$parcel$interopDefault($i1Owb)))((deprecation)=>console.warn(deprecation));
/**
 * Error with extra properties to help with debugging
 */ class $76f5a0d4862f0d81$export$43ee7d0e4f429743 extends Error {
    constructor(message, statusCode, options){
        super(message);
        // Maintains proper stack trace (only available on V8)
        /* istanbul ignore next */ if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
        this.name = "HttpError";
        this.status = statusCode;
        let headers;
        if ("headers" in options && typeof options.headers !== "undefined") headers = options.headers;
        if ("response" in options) {
            this.response = options.response;
            headers = options.response.headers;
        }
        // redact request credentials without mutating original request options
        const requestCopy = Object.assign({}, options.request);
        if (options.request.headers.authorization) requestCopy.headers = Object.assign({}, options.request.headers, {
            authorization: options.request.headers.authorization.replace(/ .*$/, " [REDACTED]")
        });
        requestCopy.url = requestCopy.url// client_id & client_secret can be passed as URL query parameters to increase rate limit
        // see https://developer.github.com/v3/#increasing-the-unauthenticated-rate-limit-for-oauth-applications
        .replace(/\bclient_secret=\w+/g, "client_secret=[REDACTED]")// OAuth tokens can be passed as URL query parameters, although it is not recommended
        // see https://developer.github.com/v3/#oauth2-token-sent-in-a-header
        .replace(/\baccess_token=\w+/g, "access_token=[REDACTED]");
        this.request = requestCopy;
        // deprecations
        Object.defineProperty(this, "code", {
            get () {
                $76f5a0d4862f0d81$var$logOnceCode(new (0, $lG4DW.Deprecation)("[@octokit/request-error] `error.code` is deprecated, use `error.status`."));
                return statusCode;
            }
        });
        Object.defineProperty(this, "headers", {
            get () {
                $76f5a0d4862f0d81$var$logOnceHeaders(new (0, $lG4DW.Deprecation)("[@octokit/request-error] `error.headers` is deprecated, use `error.response.headers`."));
                return headers || {};
            }
        });
    }
}


const $1afa27718af1bd71$var$VERSION = "5.6.3";
function $1afa27718af1bd71$var$getBufferResponse(response) {
    return response.arrayBuffer();
}
function $1afa27718af1bd71$var$fetchWrapper(requestOptions) {
    const log = requestOptions.request && requestOptions.request.log ? requestOptions.request.log : console;
    if ((0, $cdeacdf23b3f7c65$export$53b83ca8eaab0383)(requestOptions.body) || Array.isArray(requestOptions.body)) requestOptions.body = JSON.stringify(requestOptions.body);
    let headers = {};
    let status;
    let url;
    const fetch = requestOptions.request && requestOptions.request.fetch || (0, (/*@__PURE__*/$parcel$interopDefault($5Uvwt)));
    return fetch(requestOptions.url, Object.assign({
        method: requestOptions.method,
        body: requestOptions.body,
        headers: requestOptions.headers,
        redirect: requestOptions.redirect
    }, // `requestOptions.request.agent` type is incompatible
    // see https://github.com/octokit/types.ts/pull/264
    requestOptions.request)).then(async (response)=>{
        url = response.url;
        status = response.status;
        for (const keyAndValue of response.headers)headers[keyAndValue[0]] = keyAndValue[1];
        if ("deprecation" in headers) {
            const matches = headers.link && headers.link.match(/<([^>]+)>; rel="deprecation"/);
            const deprecationLink = matches && matches.pop();
            log.warn(`[@octokit/request] "${requestOptions.method} ${requestOptions.url}" is deprecated. It is scheduled to be removed on ${headers.sunset}${deprecationLink ? `. See ${deprecationLink}` : ""}`);
        }
        if (status === 204 || status === 205) return;
        // GitHub API returns 200 for HEAD requests
        if (requestOptions.method === "HEAD") {
            if (status < 400) return;
            throw new (0, $76f5a0d4862f0d81$export$43ee7d0e4f429743)(response.statusText, status, {
                response: {
                    url: url,
                    status: status,
                    headers: headers,
                    data: undefined
                },
                request: requestOptions
            });
        }
        if (status === 304) throw new (0, $76f5a0d4862f0d81$export$43ee7d0e4f429743)("Not modified", status, {
            response: {
                url: url,
                status: status,
                headers: headers,
                data: await $1afa27718af1bd71$var$getResponseData(response)
            },
            request: requestOptions
        });
        if (status >= 400) {
            const data = await $1afa27718af1bd71$var$getResponseData(response);
            const error = new (0, $76f5a0d4862f0d81$export$43ee7d0e4f429743)($1afa27718af1bd71$var$toErrorMessage(data), status, {
                response: {
                    url: url,
                    status: status,
                    headers: headers,
                    data: data
                },
                request: requestOptions
            });
            throw error;
        }
        return $1afa27718af1bd71$var$getResponseData(response);
    }).then((data)=>{
        return {
            status: status,
            url: url,
            headers: headers,
            data: data
        };
    }).catch((error)=>{
        if (error instanceof (0, $76f5a0d4862f0d81$export$43ee7d0e4f429743)) throw error;
        throw new (0, $76f5a0d4862f0d81$export$43ee7d0e4f429743)(error.message, 500, {
            request: requestOptions
        });
    });
}
async function $1afa27718af1bd71$var$getResponseData(response) {
    const contentType = response.headers.get("content-type");
    if (/application\/json/.test(contentType)) return response.json();
    if (!contentType || /^text\/|charset=utf-8$/.test(contentType)) return response.text();
    return $1afa27718af1bd71$var$getBufferResponse(response);
}
function $1afa27718af1bd71$var$toErrorMessage(data) {
    if (typeof data === "string") return data;
    // istanbul ignore else - just in case
    if ("message" in data) {
        if (Array.isArray(data.errors)) return `${data.message}: ${data.errors.map(JSON.stringify).join(", ")}`;
        return data.message;
    }
    // istanbul ignore next - just in case
    return `Unknown error: ${JSON.stringify(data)}`;
}
function $1afa27718af1bd71$var$withDefaults(oldEndpoint, newDefaults) {
    const endpoint = oldEndpoint.defaults(newDefaults);
    const newApi = function(route, parameters) {
        const endpointOptions = endpoint.merge(route, parameters);
        if (!endpointOptions.request || !endpointOptions.request.hook) return $1afa27718af1bd71$var$fetchWrapper(endpoint.parse(endpointOptions));
        const request = (route, parameters)=>{
            return $1afa27718af1bd71$var$fetchWrapper(endpoint.parse(endpoint.merge(route, parameters)));
        };
        Object.assign(request, {
            endpoint: endpoint,
            defaults: $1afa27718af1bd71$var$withDefaults.bind(null, endpoint)
        });
        return endpointOptions.request.hook(request, endpointOptions);
    };
    return Object.assign(newApi, {
        endpoint: endpoint,
        defaults: $1afa27718af1bd71$var$withDefaults.bind(null, endpoint)
    });
}
const $1afa27718af1bd71$export$b5fe3f66a567bec0 = $1afa27718af1bd71$var$withDefaults((0, $7f55e49166b9f1c8$export$125e2b775860041f), {
    headers: {
        "user-agent": `octokit-request.js/${$1afa27718af1bd71$var$VERSION} ${(0, $c75a59017d47d2d8$export$7935961ef7719cb0)()}`
    }
});


var $a793e54ae19e793b$require$request = $1afa27718af1bd71$export$b5fe3f66a567bec0;
var $64d6cf6c97643708$exports = {};
var $4e52112a2fe6496e$exports = {};
$4e52112a2fe6496e$exports = $4e52112a2fe6496e$var$register;
function $4e52112a2fe6496e$var$register(state, name, method, options) {
    if (typeof method !== "function") throw new Error("method for before hook must be a function");
    if (!options) options = {};
    if (Array.isArray(name)) return name.reverse().reduce(function(callback, name) {
        return $4e52112a2fe6496e$var$register.bind(null, state, name, callback, options);
    }, method)();
    return Promise.resolve().then(function() {
        if (!state.registry[name]) return method(options);
        return state.registry[name].reduce(function(method, registered) {
            return registered.hook.bind(null, method, options);
        }, method)();
    });
}


var $9eef2cad465692a0$exports = {};
$9eef2cad465692a0$exports = $9eef2cad465692a0$var$addHook;
function $9eef2cad465692a0$var$addHook(state, kind, name, hook) {
    var orig = hook;
    if (!state.registry[name]) state.registry[name] = [];
    if (kind === "before") hook = function(method, options) {
        return Promise.resolve().then(orig.bind(null, options)).then(method.bind(null, options));
    };
    if (kind === "after") hook = function(method, options) {
        var result;
        return Promise.resolve().then(method.bind(null, options)).then(function(result_) {
            result = result_;
            return orig(result, options);
        }).then(function() {
            return result;
        });
    };
    if (kind === "error") hook = function(method, options) {
        return Promise.resolve().then(method.bind(null, options)).catch(function(error) {
            return orig(error, options);
        });
    };
    state.registry[name].push({
        hook: hook,
        orig: orig
    });
}


var $a75d89bca955257e$exports = {};
$a75d89bca955257e$exports = $a75d89bca955257e$var$removeHook;
function $a75d89bca955257e$var$removeHook(state, name, method) {
    if (!state.registry[name]) return;
    var index = state.registry[name].map(function(registered) {
        return registered.orig;
    }).indexOf(method);
    if (index === -1) return;
    state.registry[name].splice(index, 1);
}


// bind with array of arguments: https://stackoverflow.com/a/21792913
var $64d6cf6c97643708$var$bind = Function.bind;
var $64d6cf6c97643708$var$bindable = $64d6cf6c97643708$var$bind.bind($64d6cf6c97643708$var$bind);
function $64d6cf6c97643708$var$bindApi(hook, state, name) {
    var removeHookRef = $64d6cf6c97643708$var$bindable($a75d89bca955257e$exports, null).apply(null, name ? [
        state,
        name
    ] : [
        state
    ]);
    hook.api = {
        remove: removeHookRef
    };
    hook.remove = removeHookRef;
    [
        "before",
        "error",
        "after",
        "wrap"
    ].forEach(function(kind) {
        var args = name ? [
            state,
            kind,
            name
        ] : [
            state,
            kind
        ];
        hook[kind] = hook.api[kind] = $64d6cf6c97643708$var$bindable($9eef2cad465692a0$exports, null).apply(null, args);
    });
}
function $64d6cf6c97643708$var$HookSingular() {
    var singularHookName = "h";
    var singularHookState = {
        registry: {}
    };
    var singularHook = $4e52112a2fe6496e$exports.bind(null, singularHookState, singularHookName);
    $64d6cf6c97643708$var$bindApi(singularHook, singularHookState, singularHookName);
    return singularHook;
}
function $64d6cf6c97643708$var$HookCollection() {
    var state = {
        registry: {}
    };
    var hook = $4e52112a2fe6496e$exports.bind(null, state);
    $64d6cf6c97643708$var$bindApi(hook, state);
    return hook;
}
var $64d6cf6c97643708$var$collectionHookDeprecationMessageDisplayed = false;
function $64d6cf6c97643708$var$Hook() {
    if (!$64d6cf6c97643708$var$collectionHookDeprecationMessageDisplayed) {
        console.warn('[before-after-hook]: "Hook()" repurposing warning, use "Hook.Collection()". Read more: https://git.io/upgrade-before-after-hook-to-1.4');
        $64d6cf6c97643708$var$collectionHookDeprecationMessageDisplayed = true;
    }
    return $64d6cf6c97643708$var$HookCollection();
}
$64d6cf6c97643708$var$Hook.Singular = $64d6cf6c97643708$var$HookSingular.bind();
$64d6cf6c97643708$var$Hook.Collection = $64d6cf6c97643708$var$HookCollection.bind();
$64d6cf6c97643708$exports = $64d6cf6c97643708$var$Hook;
// expose constructors as a named property for TypeScript
$64d6cf6c97643708$exports.Hook = $64d6cf6c97643708$var$Hook;
$64d6cf6c97643708$exports.Singular = $64d6cf6c97643708$var$Hook.Singular;
$64d6cf6c97643708$exports.Collection = $64d6cf6c97643708$var$Hook.Collection;


var $757df046ca8e90c9$exports = {};
$757df046ca8e90c9$exports = $757df046ca8e90c9$var$parseOptions;

var $lG4DW = parcelRequire("lG4DW");
var $757df046ca8e90c9$require$Deprecation = $lG4DW.Deprecation;
function $93369f6a25768e9c$export$7935961ef7719cb0() {
    try {
        return navigator.userAgent;
    } catch (e) {
        return "<environment unknown>";
    }
}


var $757df046ca8e90c9$require$getUserAgent = $93369f6a25768e9c$export$7935961ef7719cb0;

var $i1Owb = parcelRequire("i1Owb");
var $001b8c7a04b4bc0f$exports = {};
$001b8c7a04b4bc0f$exports = JSON.parse("{\"name\":\"@octokit/rest\",\"version\":\"16.43.2\",\"publishConfig\":{\"access\":\"public\"},\"description\":\"GitHub REST API client for Node.js\",\"keywords\":[\"octokit\",\"github\",\"rest\",\"api-client\"],\"author\":\"Gregor Martynus (https://github.com/gr2m)\",\"contributors\":[{\"name\":\"Mike de Boer\",\"email\":\"info@mikedeboer.nl\"},{\"name\":\"Fabian Jakobs\",\"email\":\"fabian@c9.io\"},{\"name\":\"Joe Gallo\",\"email\":\"joe@brassafrax.com\"},{\"name\":\"Gregor Martynus\",\"url\":\"https://github.com/gr2m\"}],\"repository\":\"https://github.com/octokit/rest.js\",\"dependencies\":{\"@octokit/auth-token\":\"^2.4.0\",\"@octokit/plugin-paginate-rest\":\"^1.1.1\",\"@octokit/plugin-request-log\":\"^1.0.0\",\"@octokit/plugin-rest-endpoint-methods\":\"2.4.0\",\"@octokit/request\":\"^5.2.0\",\"@octokit/request-error\":\"^1.0.2\",\"atob-lite\":\"^2.0.0\",\"before-after-hook\":\"^2.0.0\",\"btoa-lite\":\"^1.0.0\",\"deprecation\":\"^2.0.0\",\"lodash.get\":\"^4.4.2\",\"lodash.set\":\"^4.3.2\",\"lodash.uniq\":\"^4.5.0\",\"octokit-pagination-methods\":\"^1.1.0\",\"once\":\"^1.4.0\",\"universal-user-agent\":\"^4.0.0\"},\"devDependencies\":{\"@gimenete/type-writer\":\"^0.1.3\",\"@octokit/auth\":\"^1.1.1\",\"@octokit/fixtures-server\":\"^5.0.6\",\"@octokit/graphql\":\"^4.2.0\",\"@types/node\":\"^13.1.0\",\"bundlesize\":\"^0.18.0\",\"chai\":\"^4.1.2\",\"compression-webpack-plugin\":\"^3.1.0\",\"cypress\":\"^4.0.0\",\"glob\":\"^7.1.2\",\"http-proxy-agent\":\"^4.0.0\",\"lodash.camelcase\":\"^4.3.0\",\"lodash.merge\":\"^4.6.1\",\"lodash.upperfirst\":\"^4.3.1\",\"lolex\":\"^6.0.0\",\"mkdirp\":\"^1.0.0\",\"mocha\":\"^7.0.1\",\"mustache\":\"^4.0.0\",\"nock\":\"^11.3.3\",\"npm-run-all\":\"^4.1.2\",\"nyc\":\"^15.0.0\",\"prettier\":\"^1.14.2\",\"proxy\":\"^1.0.0\",\"semantic-release\":\"^17.0.0\",\"sinon\":\"^8.0.0\",\"sinon-chai\":\"^3.0.0\",\"sort-keys\":\"^4.0.0\",\"string-to-arraybuffer\":\"^1.0.0\",\"string-to-jsdoc-comment\":\"^1.0.0\",\"typescript\":\"^3.3.1\",\"webpack\":\"^4.0.0\",\"webpack-bundle-analyzer\":\"^3.0.0\",\"webpack-cli\":\"^3.0.0\"},\"types\":\"index.d.ts\",\"scripts\":{\"coverage\":\"nyc report --reporter=html && open coverage/index.html\",\"lint\":\"prettier --check '{lib,plugins,scripts,test}/**/*.{js,json,ts}' 'docs/*.{js,json}' 'docs/src/**/*' index.js README.md package.json\",\"lint:fix\":\"prettier --write '{lib,plugins,scripts,test}/**/*.{js,json,ts}' 'docs/*.{js,json}' 'docs/src/**/*' index.js README.md package.json\",\"pretest\":\"npm run -s lint\",\"test\":\"nyc mocha test/mocha-node-setup.js \\\"test/*/**/*-test.js\\\"\",\"test:browser\":\"cypress run --browser chrome\",\"build\":\"npm-run-all build:*\",\"build:ts\":\"npm run -s update-endpoints:typescript\",\"prebuild:browser\":\"mkdirp dist/\",\"build:browser\":\"npm-run-all build:browser:*\",\"build:browser:development\":\"webpack --mode development --entry . --output-library=Octokit --output=./dist/octokit-rest.js --profile --json > dist/bundle-stats.json\",\"build:browser:production\":\"webpack --mode production --entry . --plugin=compression-webpack-plugin --output-library=Octokit --output-path=./dist --output-filename=octokit-rest.min.js --devtool source-map\",\"generate-bundle-report\":\"webpack-bundle-analyzer dist/bundle-stats.json --mode=static --no-open --report dist/bundle-report.html\",\"update-endpoints\":\"npm-run-all update-endpoints:*\",\"update-endpoints:fetch-json\":\"node scripts/update-endpoints/fetch-json\",\"update-endpoints:typescript\":\"node scripts/update-endpoints/typescript\",\"prevalidate:ts\":\"npm run -s build:ts\",\"validate:ts\":\"tsc --target es6 --noImplicitAny index.d.ts\",\"postvalidate:ts\":\"tsc --noEmit --target es6 test/typescript-validate.ts\",\"start-fixtures-server\":\"octokit-fixtures-server\"},\"license\":\"MIT\",\"files\":[\"index.js\",\"index.d.ts\",\"lib\",\"plugins\"],\"nyc\":{\"ignore\":[\"test\"]},\"release\":{\"publish\":[\"@semantic-release/npm\",{\"path\":\"@semantic-release/github\",\"assets\":[\"dist/*\",\"!dist/*.map.gz\"]}]},\"bundlesize\":[{\"path\":\"./dist/octokit-rest.min.js.gz\",\"maxSize\":\"33 kB\"}]}");


const $757df046ca8e90c9$var$deprecateOptionsTimeout = $i1Owb((log, deprecation)=>log.warn(deprecation));
const $757df046ca8e90c9$var$deprecateOptionsAgent = $i1Owb((log, deprecation)=>log.warn(deprecation));
const $757df046ca8e90c9$var$deprecateOptionsHeaders = $i1Owb((log, deprecation)=>log.warn(deprecation));
function $757df046ca8e90c9$var$parseOptions(options, log, hook) {
    if (options.headers) options.headers = Object.keys(options.headers).reduce((newObj, key)=>{
        newObj[key.toLowerCase()] = options.headers[key];
        return newObj;
    }, {});
    const clientDefaults = {
        headers: options.headers || {},
        request: options.request || {},
        mediaType: {
            previews: [],
            format: ""
        }
    };
    if (options.baseUrl) clientDefaults.baseUrl = options.baseUrl;
    if (options.userAgent) clientDefaults.headers["user-agent"] = options.userAgent;
    if (options.previews) clientDefaults.mediaType.previews = options.previews;
    if (options.timeZone) clientDefaults.headers["time-zone"] = options.timeZone;
    if (options.timeout) {
        $757df046ca8e90c9$var$deprecateOptionsTimeout(log, new $757df046ca8e90c9$require$Deprecation("[@octokit/rest] new Octokit({timeout}) is deprecated. Use {request: {timeout}} instead. See https://github.com/octokit/request.js#request"));
        clientDefaults.request.timeout = options.timeout;
    }
    if (options.agent) {
        $757df046ca8e90c9$var$deprecateOptionsAgent(log, new $757df046ca8e90c9$require$Deprecation("[@octokit/rest] new Octokit({agent}) is deprecated. Use {request: {agent}} instead. See https://github.com/octokit/request.js#request"));
        clientDefaults.request.agent = options.agent;
    }
    if (options.headers) $757df046ca8e90c9$var$deprecateOptionsHeaders(log, new $757df046ca8e90c9$require$Deprecation("[@octokit/rest] new Octokit({headers}) is deprecated. Use {userAgent, previews} instead. See https://github.com/octokit/request.js#request"));
    const userAgentOption = clientDefaults.headers["user-agent"];
    const defaultUserAgent = `octokit.js/${$001b8c7a04b4bc0f$exports.version} ${$757df046ca8e90c9$require$getUserAgent()}`;
    clientDefaults.headers["user-agent"] = [
        userAgentOption,
        defaultUserAgent
    ].filter(Boolean).join(" ");
    clientDefaults.request.hook = hook.bind(null, "request");
    return clientDefaults;
}


function $a793e54ae19e793b$var$Octokit(plugins, options) {
    options = options || {};
    const hook = new $64d6cf6c97643708$exports.Collection();
    const log = Object.assign({
        debug: ()=>{},
        info: ()=>{},
        warn: console.warn,
        error: console.error
    }, options && options.log);
    const api = {
        hook: hook,
        log: log,
        request: $a793e54ae19e793b$require$request.defaults($757df046ca8e90c9$exports(options, log, hook))
    };
    plugins.forEach((pluginFunction)=>pluginFunction(api, options));
    return api;
}


var $2cc33a9bcf2c766f$exports = {};
$2cc33a9bcf2c766f$exports = $2cc33a9bcf2c766f$var$registerPlugin;

function $2cc33a9bcf2c766f$var$registerPlugin(plugins, pluginFunction) {
    return $16a8e11c3a7490cc$exports(plugins.includes(pluginFunction) ? plugins : plugins.concat(pluginFunction));
}


function $16a8e11c3a7490cc$var$factory(plugins) {
    const Api = $a793e54ae19e793b$exports.bind(null, plugins || []);
    Api.plugin = $2cc33a9bcf2c766f$exports.bind(null, plugins || []);
    return Api;
}


$3cc045d983cca955$exports = $16a8e11c3a7490cc$exports();







const $e08db83179311785$var$CORE_PLUGINS = [
    (parcelRequire("2iHVY")),
    (parcelRequire("9h37l")),
    $e08db83179311785$require$requestLog,
    (parcelRequire("5RX7O")),
    $e08db83179311785$require$restEndpointMethods,
    (parcelRequire("3asPy")),
    (parcelRequire("5C24u")) // deprecated: remove in v17
];
const $e08db83179311785$var$OctokitRest = $3cc045d983cca955$exports.plugin($e08db83179311785$var$CORE_PLUGINS);
function $e08db83179311785$var$DeprecatedOctokit(options) {
    const warn = options && options.log && options.log.warn ? options.log.warn : console.warn;
    warn('[@octokit/rest] `const Octokit = require("@octokit/rest")` is deprecated. Use `const { Octokit } = require("@octokit/rest")` instead');
    return new $e08db83179311785$var$OctokitRest(options);
}
const $e08db83179311785$var$Octokit = Object.assign($e08db83179311785$var$DeprecatedOctokit, {
    Octokit: $e08db83179311785$var$OctokitRest
});
Object.keys($e08db83179311785$var$OctokitRest).forEach((key)=>{
    /* istanbul ignore else */ if ($e08db83179311785$var$OctokitRest.hasOwnProperty(key)) $e08db83179311785$var$Octokit[key] = $e08db83179311785$var$OctokitRest[key];
});
$e08db83179311785$exports = $e08db83179311785$var$Octokit;


var $19d968b7a885c915$exports = {};
/*
 *  base64.js
 *
 *  Licensed under the BSD 3-Clause License.
 *    http://opensource.org/licenses/BSD-3-Clause
 *
 *  References:
 *    http://en.wikipedia.org/wiki/Base64
 */ (function(global1, factory) {
    $19d968b7a885c915$exports = factory(global1);
})(typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : $19d968b7a885c915$exports, function(global1) {
    'use strict';
    // existing version for noConflict()
    global1 = global1 || {};
    var _Base64 = global1.Base64;
    var version = "2.6.4";
    // constants
    var b64chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    var b64tab = function(bin) {
        var t = {};
        for(var i = 0, l = bin.length; i < l; i++)t[bin.charAt(i)] = i;
        return t;
    }(b64chars);
    var fromCharCode = String.fromCharCode;
    // encoder stuff
    var cb_utob = function(c) {
        if (c.length < 2) {
            var cc = c.charCodeAt(0);
            return cc < 0x80 ? c : cc < 0x800 ? fromCharCode(0xc0 | cc >>> 6) + fromCharCode(0x80 | cc & 0x3f) : fromCharCode(0xe0 | cc >>> 12 & 0x0f) + fromCharCode(0x80 | cc >>> 6 & 0x3f) + fromCharCode(0x80 | cc & 0x3f);
        } else {
            var cc = 0x10000 + (c.charCodeAt(0) - 0xD800) * 0x400 + (c.charCodeAt(1) - 0xDC00);
            return fromCharCode(0xf0 | cc >>> 18 & 0x07) + fromCharCode(0x80 | cc >>> 12 & 0x3f) + fromCharCode(0x80 | cc >>> 6 & 0x3f) + fromCharCode(0x80 | cc & 0x3f);
        }
    };
    var re_utob = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g;
    var utob = function(u) {
        return u.replace(re_utob, cb_utob);
    };
    var cb_encode = function(ccc) {
        var padlen = [
            0,
            2,
            1
        ][ccc.length % 3], ord = ccc.charCodeAt(0) << 16 | (ccc.length > 1 ? ccc.charCodeAt(1) : 0) << 8 | (ccc.length > 2 ? ccc.charCodeAt(2) : 0), chars = [
            b64chars.charAt(ord >>> 18),
            b64chars.charAt(ord >>> 12 & 63),
            padlen >= 2 ? '=' : b64chars.charAt(ord >>> 6 & 63),
            padlen >= 1 ? '=' : b64chars.charAt(ord & 63)
        ];
        return chars.join('');
    };
    var btoa = global1.btoa && typeof global1.btoa == 'function' ? function(b) {
        return global1.btoa(b);
    } : function(b) {
        if (b.match(/[^\x00-\xFF]/)) throw new RangeError('The string contains invalid characters.');
        return b.replace(/[\s\S]{1,3}/g, cb_encode);
    };
    var _encode = function(u) {
        return btoa(utob(String(u)));
    };
    var mkUriSafe = function(b64) {
        return b64.replace(/[+\/]/g, function(m0) {
            return m0 == '+' ? '-' : '_';
        }).replace(/=/g, '');
    };
    var encode = function(u, urisafe) {
        return urisafe ? mkUriSafe(_encode(u)) : _encode(u);
    };
    var encodeURI = function(u) {
        return encode(u, true);
    };
    var fromUint8Array;
    if (global1.Uint8Array) fromUint8Array = function(a, urisafe) {
        // return btoa(fromCharCode.apply(null, a));
        var b64 = '';
        for(var i = 0, l = a.length; i < l; i += 3){
            var a0 = a[i], a1 = a[i + 1], a2 = a[i + 2];
            var ord = a0 << 16 | a1 << 8 | a2;
            b64 += b64chars.charAt(ord >>> 18) + b64chars.charAt(ord >>> 12 & 63) + (typeof a1 != 'undefined' ? b64chars.charAt(ord >>> 6 & 63) : '=') + (typeof a2 != 'undefined' ? b64chars.charAt(ord & 63) : '=');
        }
        return urisafe ? mkUriSafe(b64) : b64;
    };
    // decoder stuff
    var re_btou = /[\xC0-\xDF][\x80-\xBF]|[\xE0-\xEF][\x80-\xBF]{2}|[\xF0-\xF7][\x80-\xBF]{3}/g;
    var cb_btou = function(cccc) {
        switch(cccc.length){
            case 4:
                var cp = (0x07 & cccc.charCodeAt(0)) << 18 | (0x3f & cccc.charCodeAt(1)) << 12 | (0x3f & cccc.charCodeAt(2)) << 6 | 0x3f & cccc.charCodeAt(3), offset = cp - 0x10000;
                return fromCharCode((offset >>> 10) + 0xD800) + fromCharCode((offset & 0x3FF) + 0xDC00);
            case 3:
                return fromCharCode((0x0f & cccc.charCodeAt(0)) << 12 | (0x3f & cccc.charCodeAt(1)) << 6 | 0x3f & cccc.charCodeAt(2));
            default:
                return fromCharCode((0x1f & cccc.charCodeAt(0)) << 6 | 0x3f & cccc.charCodeAt(1));
        }
    };
    var btou = function(b) {
        return b.replace(re_btou, cb_btou);
    };
    var cb_decode = function(cccc) {
        var len = cccc.length, padlen = len % 4, n = (len > 0 ? b64tab[cccc.charAt(0)] << 18 : 0) | (len > 1 ? b64tab[cccc.charAt(1)] << 12 : 0) | (len > 2 ? b64tab[cccc.charAt(2)] << 6 : 0) | (len > 3 ? b64tab[cccc.charAt(3)] : 0), chars = [
            fromCharCode(n >>> 16),
            fromCharCode(n >>> 8 & 0xff),
            fromCharCode(n & 0xff)
        ];
        chars.length -= [
            0,
            0,
            2,
            1
        ][padlen];
        return chars.join('');
    };
    var _atob = global1.atob && typeof global1.atob == 'function' ? function(a) {
        return global1.atob(a);
    } : function(a) {
        return a.replace(/\S{1,4}/g, cb_decode);
    };
    var atob = function(a) {
        return _atob(String(a).replace(/[^A-Za-z0-9\+\/]/g, ''));
    };
    var _decode = function(a) {
        return btou(_atob(a));
    };
    var _fromURI = function(a) {
        return String(a).replace(/[-_]/g, function(m0) {
            return m0 == '-' ? '+' : '/';
        }).replace(/[^A-Za-z0-9\+\/]/g, '');
    };
    var decode = function(a) {
        return _decode(_fromURI(a));
    };
    var toUint8Array;
    if (global1.Uint8Array) toUint8Array = function(a) {
        return Uint8Array.from(atob(_fromURI(a)), function(c) {
            return c.charCodeAt(0);
        });
    };
    var noConflict = function() {
        var Base641 = global1.Base64;
        global1.Base64 = _Base64;
        return Base641;
    };
    // export Base64
    global1.Base64 = {
        VERSION: version,
        atob: atob,
        btoa: btoa,
        fromBase64: decode,
        toBase64: encode,
        utob: utob,
        encode: encode,
        encodeURI: encodeURI,
        btou: btou,
        decode: decode,
        noConflict: noConflict,
        fromUint8Array: fromUint8Array,
        toUint8Array: toUint8Array
    };
    // if ES5 is available, make Base64.extendString() available
    if (typeof Object.defineProperty === 'function') {
        var noEnum = function(v) {
            return {
                value: v,
                enumerable: false,
                writable: true,
                configurable: true
            };
        };
        global1.Base64.extendString = function() {
            Object.defineProperty(String.prototype, 'fromBase64', noEnum(function() {
                return decode(this);
            }));
            Object.defineProperty(String.prototype, 'toBase64', noEnum(function(urisafe) {
                return encode(this, urisafe);
            }));
            Object.defineProperty(String.prototype, 'toBase64URI', noEnum(function() {
                return encode(this, true);
            }));
        };
    }
    //
    // export Base64 to the namespace
    //
    if (global1['Meteor']) Base64 = global1.Base64;
    // module.exports and AMD are mutually exclusive.
    // module.exports has precedence.
    if ($19d968b7a885c915$exports) $19d968b7a885c915$exports.Base64 = global1.Base64;
    else if (typeof define === 'function' && define.amd) // AMD. Register as an anonymous module.
    define([], function() {
        return global1.Base64;
    });
    // that's it!
    return {
        Base64: global1.Base64
    };
});


const $8b46f778ffe0a0e8$var$isDev = "production" === `development`;
const $8b46f778ffe0a0e8$var$GITHUB_ORG = "biblioteca-de-los-amigos";
const $8b46f778ffe0a0e8$export$c7bc89c720838974 = $8b46f778ffe0a0e8$var$GITHUB_ORG;
const $8b46f778ffe0a0e8$export$ce37e184d908d785 = $8b46f778ffe0a0e8$export$c7bc89c720838974 === `biblioteca-de-los-amigos` ? `es` : `en`;
let $8b46f778ffe0a0e8$var$gh = new (0, $e08db83179311785$exports.Octokit)();
function $8b46f778ffe0a0e8$export$61bb00ddedae72e4(token) {
    $8b46f778ffe0a0e8$var$gh = new (0, $e08db83179311785$exports.Octokit)({
        auth: `token ${token}`
    });
}
function $8b46f778ffe0a0e8$export$3bcbbe78488f4be6(owner, repo, branch) {
    owner = $8b46f778ffe0a0e8$export$c7bc89c720838974; // while not supporting forks
    $8b46f778ffe0a0e8$var$gh.git.deleteRef({
        owner: owner,
        repo: repo,
        ref: `heads/${branch}`
    });
}
async function $8b46f778ffe0a0e8$export$ea534231211ffae9(repo, number) {
    const res = await $8b46f778ffe0a0e8$var$gh.pulls.get({
        owner: $8b46f778ffe0a0e8$export$c7bc89c720838974,
        repo: repo,
        pull_number: number
    });
    if (res.data.merged_at !== null) return `merged`;
    if (res.data.closed_at !== null) return `closed`;
    return `open`;
}
async function $8b46f778ffe0a0e8$export$5e07128021d77d99() {
    const repos = await $8b46f778ffe0a0e8$var$gh.paginate(`/orgs/${$8b46f778ffe0a0e8$export$c7bc89c720838974}/repos`);
    return repos.filter((repo)=>repo.name !== $8b46f778ffe0a0e8$export$c7bc89c720838974);
}
async function $8b46f778ffe0a0e8$export$449394f7f4591191(repoId) {
    const { data: { name: slug } } = await $8b46f778ffe0a0e8$export$f46232c2a9c34923(`/repositories/:id`, {
        id: repoId
    });
    return slug;
}
async function $8b46f778ffe0a0e8$export$b748c30ef3da3c71(repo, branch = `master`) {
    const response = await $8b46f778ffe0a0e8$export$f46232c2a9c34923(`/repos/:owner/:repo/git/refs/:ref`, {
        repo: repo,
        ref: `heads/${branch}`
    });
    const { data: { object: { sha: sha } } } = response;
    return sha;
}
async function $8b46f778ffe0a0e8$export$b4a8889dc0c0918c(repo, sha) {
    const tree = await $8b46f778ffe0a0e8$export$b76263aac816aadb(repo, sha);
    const filePromises = tree.filter($8b46f778ffe0a0e8$var$isAsciidoc).map(async (blob)=>{
        const { data: { content: content } } = await $8b46f778ffe0a0e8$export$f46232c2a9c34923(`/repos/:owner/:repo/git/blobs/:sha`, {
            repo: repo,
            sha: blob.sha
        });
        return {
            path: blob.path,
            sha: blob.sha,
            content: (0, $19d968b7a885c915$exports.Base64).decode(content)
        };
    });
    return await Promise.all(filePromises);
}
async function $8b46f778ffe0a0e8$export$b76263aac816aadb(repo, sha) {
    const { data: { tree: tree } } = await $8b46f778ffe0a0e8$export$f46232c2a9c34923(`/repos/:owner/:repo/git/trees/:sha?recursive=1`, {
        repo: repo,
        sha: sha
    });
    return tree;
}
async function $8b46f778ffe0a0e8$var$createFork(repo, user) {
    await $8b46f778ffe0a0e8$export$f46232c2a9c34923(`POST /repos/:owner/:repo/forks`, {
        repo: repo
    });
    return new Promise((resolve)=>{
        const interval = setInterval(async ()=>{
            const forkExists = await $8b46f778ffe0a0e8$var$hasFork(repo, user);
            if (forkExists) {
                clearInterval(interval);
                resolve();
            }
        }, 250);
    });
}
async function $8b46f778ffe0a0e8$var$hasFork(repo, user) {
    try {
        await $8b46f778ffe0a0e8$export$f46232c2a9c34923(`/repos/:owner/:repo`, {
            owner: user,
            repo: repo
        });
        return true;
    } catch  {
        return false;
    }
}
async function $8b46f778ffe0a0e8$var$syncFork(repo, user) {
    const upstream = await $8b46f778ffe0a0e8$export$f46232c2a9c34923(`/repos/:owner/:repo/git/refs/:ref`, {
        repo: repo,
        ref: `heads/master`
    });
    await $8b46f778ffe0a0e8$export$f46232c2a9c34923(`PATCH /repos/:owner/:repo/git/refs/:ref`, {
        sha: upstream.data.object.sha,
        owner: user,
        repo: repo,
        ref: `heads/master`
    });
}
async function $8b46f778ffe0a0e8$export$f0d9b8ea9420a26c(repo, user) {
    const forkExists = await $8b46f778ffe0a0e8$var$hasFork(repo, user);
    if (!forkExists) await $8b46f778ffe0a0e8$var$createFork(repo, user);
    await $8b46f778ffe0a0e8$var$syncFork(repo, user);
}
async function $8b46f778ffe0a0e8$export$84583c097d55cb87(task/*, user: string */ ) {
    const { parentCommit: parentCommit = ``, repoId: repoId, id: id, files: files } = task;
    const branchName = `task-${id}`;
    const repo = await $8b46f778ffe0a0e8$export$449394f7f4591191(repoId);
    const baseTreeSha = await $8b46f778ffe0a0e8$export$14262974201b2eed(repo, parentCommit);
    const newTreeSha = await $8b46f778ffe0a0e8$var$createTree(repo, baseTreeSha, files);
    const msg = `updates to task: ${task.name}`;
    const newCommitSha = await $8b46f778ffe0a0e8$var$createCommit(repo, newTreeSha, parentCommit, msg);
    await $8b46f778ffe0a0e8$var$updateHead(repo, branchName, newCommitSha);
    return newCommitSha;
}
async function $8b46f778ffe0a0e8$export$4998f7fb23724e09(task, user) {
    const { parentCommit: parentCommit = ``, repoId: repoId, id: id, files: files } = task;
    const branchName = `task-${id}`;
    const repo = await $8b46f778ffe0a0e8$export$449394f7f4591191(repoId);
    // create branch WITHIN org for now, because lint action doesn't have
    // permission to create a check: https://github.community/t/115708
    // await ensureSyncedFork(repo, user);
    await $8b46f778ffe0a0e8$export$2a9bf4c22289dd1a(repo, branchName, parentCommit);
    const baseTreeSha = await $8b46f778ffe0a0e8$export$14262974201b2eed(repo, parentCommit);
    const newTreeSha = await $8b46f778ffe0a0e8$var$createTree(repo, baseTreeSha, files);
    const newCommitSha = await $8b46f778ffe0a0e8$var$createCommit(repo, newTreeSha, parentCommit, task.name);
    await $8b46f778ffe0a0e8$var$updateHead(repo, branchName, newCommitSha);
    const prNumber = await $8b46f778ffe0a0e8$var$openPullRequest(repo, branchName, task.name, user);
    return {
        commit: newCommitSha,
        number: prNumber
    };
}
async function $8b46f778ffe0a0e8$var$openPullRequest(repo, branch, title, user) {
    const body = $8b46f778ffe0a0e8$var$getPrBody(user);
    const { data: { number: number } } = await $8b46f778ffe0a0e8$export$f46232c2a9c34923(`POST /repos/:owner/:repo/pulls`, {
        repo: repo,
        title: title,
        owner: $8b46f778ffe0a0e8$export$c7bc89c720838974,
        head: branch,
        base: `master`,
        body: body,
        maintainer_can_modify: true
    });
    return number;
}
function $8b46f778ffe0a0e8$var$getPrBody(user) {
    if ($8b46f778ffe0a0e8$var$isDev || user === `jaredh159` || user === `Henderjay`) return ``;
    if ($8b46f778ffe0a0e8$export$c7bc89c720838974 === `biblioteca-de-los-amigos`) return `@Henderjay`;
    return $8b46f778ffe0a0e8$export$c7bc89c720838974 === `friends-library` ? `@jaredh159 @Henderjay` : ``;
}
async function $8b46f778ffe0a0e8$var$updateHead(repo, branch, sha, owner = $8b46f778ffe0a0e8$export$c7bc89c720838974) {
    await $8b46f778ffe0a0e8$export$f46232c2a9c34923(`PATCH /repos/:owner/:repo/git/refs/:ref`, {
        repo: repo,
        owner: owner,
        ref: `heads/${branch}`,
        sha: sha
    });
}
async function $8b46f778ffe0a0e8$var$createCommit(repo, treeSha, parent, message, owner = $8b46f778ffe0a0e8$export$c7bc89c720838974) {
    const { data: { sha: sha } } = await $8b46f778ffe0a0e8$export$f46232c2a9c34923(`POST /repos/:owner/:repo/git/commits`, {
        owner: owner,
        repo: repo,
        message: message,
        tree: treeSha,
        parents: [
            parent
        ]
    });
    return sha;
}
async function $8b46f778ffe0a0e8$var$createTree(repo, baseTreeSha, files, owner = $8b46f778ffe0a0e8$export$c7bc89c720838974) {
    const { data: { sha: sha } } = await $8b46f778ffe0a0e8$export$f46232c2a9c34923(`POST /repos/:owner/:repo/git/trees`, {
        repo: repo,
        owner: owner,
        base_tree: baseTreeSha,
        tree: Object.values(files).filter($8b46f778ffe0a0e8$var$validContent).map((f)=>({
                path: f.path,
                mode: `100644`,
                type: `blob`,
                content: f.editedContent
            }))
    });
    return sha;
}
function $8b46f778ffe0a0e8$var$validContent(file) {
    if (!file.editedContent) return false;
    if (file.editedContent === `null`) return false;
    return true;
}
async function $8b46f778ffe0a0e8$export$2a9bf4c22289dd1a(repo, newBranchName, parentCommit, owner = $8b46f778ffe0a0e8$export$c7bc89c720838974) {
    const res = await $8b46f778ffe0a0e8$var$gh.git.createRef({
        owner: owner,
        repo: repo,
        sha: parentCommit,
        ref: `refs/heads/${newBranchName}`
    });
    if (res.status === 201) return res.data.object.sha;
    throw new Error(`Failed to create branch \xaf\\_(\u{30C4})_/\xaf`);
}
async function $8b46f778ffe0a0e8$export$14262974201b2eed(repo, sha, owner = $8b46f778ffe0a0e8$export$c7bc89c720838974) {
    const res = await $8b46f778ffe0a0e8$export$f46232c2a9c34923(`/repos/:owner/:repo/git/commits/:sha`, {
        owner: owner,
        repo: repo,
        sha: sha
    });
    return res.data.tree.sha;
}
async function $8b46f778ffe0a0e8$export$f46232c2a9c34923(route, opts = {}) {
    if (route.match(/:owner/) && !opts.owner) opts = {
        ...opts,
        owner: $8b46f778ffe0a0e8$export$c7bc89c720838974
    };
    return $8b46f778ffe0a0e8$var$gh.request(route, opts);
}
function $8b46f778ffe0a0e8$var$isAsciidoc(node) {
    return node.type === `blob` && !!node.path.match(/\.adoc$/);
}



function $b9d1978dee2f18f9$export$8edc5db9321836f0(path) {
    let editionType = `original`;
    if (path.includes(`/modernized/`)) editionType = `modernized`;
    else if (path.includes(`/updated/`)) editionType = `updated`;
    return {
        lang: (0, $8b46f778ffe0a0e8$export$ce37e184d908d785),
        editionType: editionType
    };
}
function $b9d1978dee2f18f9$export$44a4ce1f1535e549(path) {
    const options = $b9d1978dee2f18f9$export$8edc5db9321836f0(path);
    options.exclude = [
        `am-pm`,
        `capitalize`,
        `consecutive-spaces`,
        `consistent-name-spelling`,
        `eof-newline`,
        `git-conflict-markers`,
        `initials-comma`,
        `join-words`,
        `leading-whitespace`,
        `libre-office-artifacts`,
        `mid-word-non-letter`,
        `mid-word-uppercase`,
        `modernize-words`,
        `multiple-blank-lines`,
        `no-undefined`,
        `obsolete-spellings`,
        `person-mismatch`,
        `scan-errors`,
        `trailing-whitespace`,
        `unexpected-period`,
        `unhyphened-words`
    ];
    return options;
}


function $831556aba23b4e91$export$f08d315250e1aa23(id) {
    return async (dispatch, getState)=>{
        dispatch({
            type: `DELETE_TASK`,
            payload: id
        });
        const { tasks: tasks, repos: repos, github: github } = getState();
        const task = tasks.present[id];
        if (github.token === null || !task) return;
        const repo = repos.find((r)=>r.id === task.repoId);
        if (!repo) return;
        try {
            $8b46f778ffe0a0e8$export$3bcbbe78488f4be6(github.user, repo.slug, `task-${id}`);
        } catch  {
        // ¯\_(ツ)_/¯
        }
    };
}
function $831556aba23b4e91$export$103149011e4c2e95(task) {
    return async (dispatch, getState)=>{
        if (!task.pullRequest) return;
        const state = getState();
        const repo = state.repos.find((r)=>r.id === task.repoId);
        if (!repo) return;
        try {
            const status = await $8b46f778ffe0a0e8$export$ea534231211ffae9(repo.slug, task.pullRequest.number);
            dispatch({
                type: `UPDATE_PULL_REQUEST_STATUS`,
                payload: {
                    id: task.id,
                    status: status
                }
            });
        } catch  {
        // ¯\_(ツ)_/¯
        }
    };
}
function $831556aba23b4e91$export$1af9e694f7afdc53(task) {
    return async (dispatch, getState)=>{
        const { github: github } = getState();
        if (github.token === null) throw new Error(`Github user not authenticated`);
        const fixedTask = $831556aba23b4e91$var$lintFix(task, dispatch, getState);
        dispatch({
            type: `SUBMITTING_TASK`
        });
        const pr = await $831556aba23b4e91$var$tryGithub(async ()=>{
            return await $8b46f778ffe0a0e8$export$4998f7fb23724e09(fixedTask, github.user);
        }, `SUBMIT_TASK`, dispatch);
        if (pr) dispatch({
            type: `TASK_SUBMITTED`,
            payload: {
                id: task.id,
                prNumber: pr.number,
                parentCommit: pr.commit
            }
        });
    };
}
function $831556aba23b4e91$var$lintFix(task, dispatch, getState) {
    Object.keys(task.files).forEach((path)=>{
        const file = task.files[path];
        if (typeof file.editedContent !== `string` || file.editedContent === file.content) return;
        const { fixed: fixed } = (0, $3325b51ce745235a$export$2e2bcd8739ae039)(file.editedContent, (0, $b9d1978dee2f18f9$export$8edc5db9321836f0)(file.path));
        if (!fixed || typeof fixed !== `string` || fixed.length < 8 || fixed === file.editedContent) return;
        dispatch({
            type: `UPDATE_FILE`,
            payload: {
                id: task.id,
                path: path,
                adoc: fixed
            }
        });
    });
    return getState().tasks.present[task.id];
}
function $831556aba23b4e91$export$c35a154f6cfe8aea(task) {
    return async (dispatch, getState)=>{
        const { github: github } = getState();
        if (github.token === null) throw new Error(`Github user not authenticated`);
        const fixedTask = $831556aba23b4e91$var$lintFix(task, dispatch, getState);
        dispatch({
            type: `RE_SUBMITTING_TASK`
        });
        const sha = await $831556aba23b4e91$var$tryGithub(async ()=>{
            return await $8b46f778ffe0a0e8$export$84583c097d55cb87(fixedTask /*, github.user */ );
        }, `SUBMIT_TASK`, dispatch);
        if (sha) dispatch({
            type: `TASK_RE_SUBMITTED`,
            payload: {
                id: task.id,
                parentCommit: sha
            }
        });
    };
}
function $831556aba23b4e91$export$f0bf07efc4a101de(task) {
    return async (dispatch)=>{
        dispatch({
            type: `START_CHECKOUT`
        });
        const data = await $831556aba23b4e91$var$tryGithub(async ()=>{
            const repoSlug = await $8b46f778ffe0a0e8$export$449394f7f4591191(task.repoId);
            const parentCommit = await $8b46f778ffe0a0e8$export$b748c30ef3da3c71(repoSlug, `master`);
            const fileArray = await $8b46f778ffe0a0e8$export$b4a8889dc0c0918c(repoSlug, parentCommit);
            const files = fileArray.reduce((acc, file)=>{
                acc[file.path] = file;
                return acc;
            }, {});
            const docResponse = await window.fetch(`/.netlify/functions/get-documents`);
            const allDocumentTitles = await docResponse.json();
            const documentTitles = Object.entries(allDocumentTitles).reduce((acc, [key, title])=>{
                if (key.startsWith(`${(0, $8b46f778ffe0a0e8$export$ce37e184d908d785)}/${repoSlug}`)) acc[key.replace(`${(0, $8b46f778ffe0a0e8$export$ce37e184d908d785)}/${repoSlug}/`, ``)] = title;
                return acc;
            }, {});
            return {
                documentTitles: documentTitles,
                files: files,
                parentCommit: parentCommit
            };
        }, `CHECKOUT`, dispatch);
        if (data) {
            dispatch({
                type: `UPDATE_TASK`,
                payload: {
                    id: task.id,
                    data: data
                }
            });
            dispatch({
                type: `END_CHECKOUT`
            });
        } else dispatch({
            type: `CHANGE_SCREEN`,
            payload: `TASKS`
        });
    };
}
function $831556aba23b4e91$export$a0a66e16c6df8da0() {
    return async (dispatch)=>{
        dispatch({
            type: `REQUEST_FRIEND_REPOS`
        });
        try {
            const friendRepos = await $8b46f778ffe0a0e8$export$5e07128021d77d99();
            dispatch({
                type: `RECEIVE_FRIEND_REPOS`,
                payload: friendRepos
            });
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
            dispatch({
                type: `NETWORK_ERROR`
            });
            return;
        }
    };
}
function $831556aba23b4e91$export$8333dcfd1ac4d0a6() {
    return async (dispatch)=>{
        dispatch({
            type: `REQUEST_GITHUB_USER`
        });
        const { data: user } = await $8b46f778ffe0a0e8$export$f46232c2a9c34923(`/user`);
        dispatch({
            type: `RECEIVE_GITHUB_USER`,
            payload: {
                name: user.name,
                avatar: user.avatar_url,
                user: user.login
            }
        });
    };
}
async function $831556aba23b4e91$var$tryGithub(fn, errorType, dispatch) {
    let result;
    try {
        result = await fn();
    } catch  {
        dispatch({
            type: `NETWORK_ERROR`
        });
        $831556aba23b4e91$var$alertGithubError(errorType);
        return false;
    }
    return result;
}
function $831556aba23b4e91$var$alertGithubError(type) {
    (0, (/*@__PURE__*/$parcel$interopDefault($80b1b2d4767dcec9$exports))).alert(`\u{1F62C} <b style="color: red;">Network Error</b>`, $831556aba23b4e91$var$ghErrorMsgs[type]);
}
const $831556aba23b4e91$var$ghErrorMsgs = {
    SUBMIT_TASK: `There was an error submitting your task to GitHub. Probably just a temporary glitch on their end. None of your work was lost, try submitting again in a few seconds. \u{1F91E}`,
    CHECKOUT: `There was an error retrieving source files to edit. Probably just a temporary glitch with GitHub. Try again in a few seconds. \u{1F91E}`
};


var $001567453c5b14c2$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $001567453c5b14c2$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $001567453c5b14c2$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
/* Built-in method references for those with the same name as other `lodash` methods. */ var $001567453c5b14c2$var$nativeMax = Math.max;
/**
 * The base implementation of `_.delay` and `_.defer` which accepts `args`
 * to provide to `func`.
 *
 * @private
 * @param {Function} func The function to delay.
 * @param {number} wait The number of milliseconds to delay invocation.
 * @param {Array} args The arguments to provide to `func`.
 * @returns {number} Returns the timer id.
 */ function $001567453c5b14c2$var$baseDelay(func, wait, args) {
    if (typeof func != 'function') throw new TypeError($001567453c5b14c2$var$FUNC_ERROR_TEXT);
    return setTimeout(function() {
        func.apply(undefined, args);
    }, wait);
}
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $001567453c5b14c2$var$baseRest(func, start) {
    start = $001567453c5b14c2$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $001567453c5b14c2$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = array;
        return $001567453c5b14c2$var$apply(func, this, otherArgs);
    };
}
/**
 * Defers invoking the `func` until the current call stack has cleared. Any
 * additional arguments are provided to `func` when it's invoked.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to defer.
 * @param {...*} [args] The arguments to invoke `func` with.
 * @returns {number} Returns the timer id.
 * @example
 *
 * _.defer(function(text) {
 *   console.log(text);
 * }, 'deferred');
 * // => Logs 'deferred' after one or more milliseconds.
 */ var $001567453c5b14c2$var$defer = $001567453c5b14c2$var$baseRest(function(func, args) {
    return $001567453c5b14c2$var$baseDelay(func, 1, args);
});
$001567453c5b14c2$exports = $001567453c5b14c2$var$defer;




function $b2949b4251eec564$var$getEditor() {
    const el = document.getElementById(`brace-editor`);
    if (!el) return;
    try {
        // @ts-ignore
        const editor = window.ace.edit(`brace-editor`);
        if (editor) return editor;
    } catch  {
    // ¯\_(ツ)_/¯
    }
    return null;
}
function $b2949b4251eec564$export$cbbc0215700ad81e() {
    const editor = $b2949b4251eec564$var$getEditor();
    if (!editor) return;
    try {
        const session = editor.getSession();
        Object.values(session.getMarkers()).forEach((m)=>{
            const marker = m;
            if (marker.clazz === `search-result`) session.removeMarker(marker.id);
        });
    } catch  {
    // ¯\_(ツ)_/¯
    }
}
function $b2949b4251eec564$export$36bdef3e751cade0(result, replace = null) {
    // defer to allow ace to re-init
    (0, (/*@__PURE__*/$parcel$interopDefault($001567453c5b14c2$exports)))(()=>{
        try {
            const editor = $b2949b4251eec564$var$getEditor();
            if (!editor) return;
            const session = editor.getSession();
            // @ts-ignore
            const Range = window.ace.acequire(`ace/range`).Range;
            editor.gotoLine(result.start.line);
            const endCol = replace ? result.start.column + replace.length : result.end.column;
            const range = new Range(result.start.line - 1, result.start.column, result.end.line - 1, endCol);
            editor.scrollToLine(result.start.line - 1, true, true);
            $b2949b4251eec564$export$cbbc0215700ad81e();
            // highlight selected search result
            const marker = session.addMarker(range, `search-result`, `text`);
            editor.on(`focus`, ()=>session.removeMarker(marker));
        } catch  {
        // ¯\_(ツ)_/¯
        }
    });
}


function $221bf0d0018b5ded$export$7a995bfc8661504b() {
    return (dispatch, getState)=>{
        const task = (0, $13d8f246ee75675a$export$7b81ddcf5552a7bb)(getState());
        if (!task || !task.editingFile) return;
        const [documentSlug, editionType, filename] = task.editingFile.split(`/`);
        dispatch({
            type: `UPDATE_SEARCH`,
            payload: {
                searching: true,
                documentSlug: documentSlug,
                editionType: editionType,
                filename: filename
            }
        });
    };
}
function $221bf0d0018b5ded$export$b8b3234b4edfc4c2({ results: results, replace: replace }) {
    return (dispatch, getState)=>{
        const task = (0, $13d8f246ee75675a$export$7b81ddcf5552a7bb)(getState());
        if (!task) return;
        dispatch({
            type: `REPLACE_IN_RESULTS`,
            payload: {
                results: results,
                replace: replace,
                taskId: task.id
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($001567453c5b14c2$exports)))(()=>(0, $b2949b4251eec564$export$cbbc0215700ad81e)());
    };
}
function $221bf0d0018b5ded$export$35f8b54d6eee17d7({ result: result, replace: replace }) {
    return (dispatch, getState)=>{
        const task = (0, $13d8f246ee75675a$export$7b81ddcf5552a7bb)(getState());
        if (!task) return;
        dispatch({
            type: `REPLACE_IN_RESULT`,
            payload: {
                result: result,
                replace: replace,
                taskId: task.id
            }
        });
        (0, $b2949b4251eec564$export$36bdef3e751cade0)(result, replace);
    };
}
function $221bf0d0018b5ded$export$f3cb5d28a95ee19(result) {
    return (dispatch, getState)=>{
        const task = (0, $13d8f246ee75675a$export$7b81ddcf5552a7bb)(getState());
        if (!task) return;
        dispatch({
            type: `EDIT_SEARCH_RESULT`,
            payload: {
                taskId: task.id,
                result: result
            }
        });
        (0, $b2949b4251eec564$export$36bdef3e751cade0)(result);
    };
}


const $75c2ce1d62cf75f2$export$a0973bcfe11b05c9 = (0, $ca5b0f8f824107ee$export$309c7a02b0b0bc62)(`LOGOUT`);
const $75c2ce1d62cf75f2$export$d7f6453813abca85 = (0, $ca5b0f8f824107ee$export$309c7a02b0b0bc62)(`RECEIVE_ACCESS_TOKEN`);
const $75c2ce1d62cf75f2$export$4ff35e5b1175d6f6 = (0, $ca5b0f8f824107ee$export$309c7a02b0b0bc62)(`HARD_RESET`);
const $75c2ce1d62cf75f2$export$40b495d76fa99f84 = (0, $ca5b0f8f824107ee$export$309c7a02b0b0bc62)(`CHANGE_SCREEN`);
const $75c2ce1d62cf75f2$export$f7292ab7796be73c = (0, $ca5b0f8f824107ee$export$309c7a02b0b0bc62)(`CREATE_TASK`);
const $75c2ce1d62cf75f2$export$e8e0154b7bb02be4 = (0, $ca5b0f8f824107ee$export$309c7a02b0b0bc62)(`UPDATE_TASK`);
const $75c2ce1d62cf75f2$export$a23735b9c4842f23 = (0, $ca5b0f8f824107ee$export$309c7a02b0b0bc62)(`WORK_ON_TASK`);
const $75c2ce1d62cf75f2$export$fccfdb27a6737cfe = (0, $ca5b0f8f824107ee$export$309c7a02b0b0bc62)(`COLLAPSE_TASK`);
const $75c2ce1d62cf75f2$export$aa23c58c72aeeb8a = (0, $ca5b0f8f824107ee$export$309c7a02b0b0bc62)(`SET_EDITING_FILE`);
const $75c2ce1d62cf75f2$export$b14c90fc27f0b629 = (0, $ca5b0f8f824107ee$export$309c7a02b0b0bc62)(`UPDATE_SEARCH`);
const $75c2ce1d62cf75f2$export$4b93d1fac58b899a = (0, $ca5b0f8f824107ee$export$309c7a02b0b0bc62)(`INCREASE_EDITOR_FONT_SIZE`);
const $75c2ce1d62cf75f2$export$f666e322c19d5625 = (0, $ca5b0f8f824107ee$export$309c7a02b0b0bc62)(`DECREASE_EDITOR_FONT_SIZE`);
const $75c2ce1d62cf75f2$export$58f3f9b95b84be3c = (0, $ca5b0f8f824107ee$export$309c7a02b0b0bc62)(`CANCEL_SEARCH`);
const $75c2ce1d62cf75f2$export$44881ed2056bcdb7 = (0, $ca5b0f8f824107ee$export$309c7a02b0b0bc62)(`UNDO_TASKS`);
const $75c2ce1d62cf75f2$export$8df76a88841e9487 = (0, $ca5b0f8f824107ee$export$309c7a02b0b0bc62)(`REDO_TASKS`);
const $75c2ce1d62cf75f2$export$9bbea660512b1799 = (0, $ca5b0f8f824107ee$export$309c7a02b0b0bc62)(`TOGGLE_SEARCH_CASE_SENSITIVE`);
const $75c2ce1d62cf75f2$export$f6603ee5314e9bbe = (0, $ca5b0f8f824107ee$export$309c7a02b0b0bc62)(`TOGGLE_SEARCH_REGEXP`);
const $75c2ce1d62cf75f2$export$e234babc6a0394bc = (0, $ca5b0f8f824107ee$export$309c7a02b0b0bc62)(`TOGGLE_SEARCH_WORDS`);
const $75c2ce1d62cf75f2$export$2b0f1fd6a0f7f3d2 = (0, $ca5b0f8f824107ee$export$309c7a02b0b0bc62)(`REOPEN_TASK`);
function $75c2ce1d62cf75f2$export$1d54456469cf71ed() {
    return (dispatch, getState)=>{
        const task = (0, $13d8f246ee75675a$export$7b81ddcf5552a7bb)(getState());
        if (!task) return;
        dispatch({
            type: `TOGGLE_SIDEBAR_OPEN`,
            payload: {
                id: task.id
            }
        });
    };
}
function $75c2ce1d62cf75f2$export$9e3f1bcb8acbee0d(width) {
    return (dispatch, getState)=>{
        const task = (0, $13d8f246ee75675a$export$7b81ddcf5552a7bb)(getState());
        if (!task) return;
        dispatch({
            type: `UPDATE_SIDEBAR_WIDTH`,
            payload: {
                id: task.id,
                width: width
            }
        });
    };
}
function $75c2ce1d62cf75f2$export$e1434007a6fed2b8(adoc) {
    return (dispatch, getState)=>{
        const task = (0, $13d8f246ee75675a$export$7b81ddcf5552a7bb)(getState());
        if (!task) return;
        dispatch({
            type: `UPDATE_EDITING_FILE`,
            payload: {
                id: task.id,
                adoc: adoc
            }
        });
    };
}



parcelRequire("lx97N");
function $c5ac91862c8363d3$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $c5ac91862c8363d3$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c5ac91862c8363d3$export$2e2bcd8739ae039(o);
}



function $a4386b5da3bc956a$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $c5ac91862c8363d3$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $c5ac91862c8363d3$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $cbce4e107de5a9e3$export$2e2bcd8739ae039(t) {
    var i = (0, $a4386b5da3bc956a$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $c5ac91862c8363d3$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $def8730fb4b8d50a$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $cbce4e107de5a9e3$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}



var $lx97N = parcelRequire("lx97N");

var $48c93a948b8615d1$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $48c93a948b8615d1$var$index = (0, $8f6d9d09a7fd235f$export$2e2bcd8739ae039)(function(prop) {
    return $48c93a948b8615d1$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
var $48c93a948b8615d1$export$2e2bcd8739ae039 = $48c93a948b8615d1$var$index;





var $d1075490e7470b1c$var$testOmitPropsOnStringTag = (0, $48c93a948b8615d1$export$2e2bcd8739ae039);
var $d1075490e7470b1c$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme' && key !== 'innerRef';
};
var $d1075490e7470b1c$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $d1075490e7470b1c$var$testOmitPropsOnStringTag : $d1075490e7470b1c$var$testOmitPropsOnComponent;
};
function $d1075490e7470b1c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d1075490e7470b1c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $d1075490e7470b1c$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $def8730fb4b8d50a$export$2e2bcd8739ae039)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $d1075490e7470b1c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $d1075490e7470b1c$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $d1075490e7470b1c$var$Noop = function Noop() {
    return null;
};
var $d1075490e7470b1c$var$createStyled = function createStyled(tag, options) {
    var identifierName;
    var shouldForwardProp;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
        shouldForwardProp = tag.__emotion_forwardProp && options.shouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && // $FlowFixMe
            options.shouldForwardProp(propName);
        } : options.shouldForwardProp;
    }
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    var defaultShouldForwardProp = shouldForwardProp || $d1075490e7470b1c$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
        var Styled = (0, $f246323fe9a4dbd3$export$efccba1c4a2ef57b)(function(props, context, ref) {
            return /*#__PURE__*/ (0, $lx97N.createElement)((0, $f246323fe9a4dbd3$export$971d5caa766a69d7).Consumer, null, function(theme) {
                var finalTag = shouldUseAs && props.as || baseTag;
                var className = '';
                var classInterpolations = [];
                var mergedProps = props;
                if (props.theme == null) {
                    mergedProps = {};
                    for(var key in props)mergedProps[key] = props[key];
                    mergedProps.theme = theme;
                }
                if (typeof props.className === 'string') className = (0, $44d6f7c1deb750c8$export$95d99596f328fd52)(context.registered, classInterpolations, props.className);
                else if (props.className != null) className = props.className + " ";
                var serialized = (0, $8b10f24ae7e53fe6$export$6321afa313b251b5)(styles.concat(classInterpolations), context.registered, mergedProps);
                var rules = (0, $44d6f7c1deb750c8$export$6f077d94b33a01aa)(context, serialized, typeof finalTag === 'string');
                className += context.key + "-" + serialized.name;
                if (targetClassName !== undefined) className += " " + targetClassName;
                var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $d1075490e7470b1c$var$getDefaultShouldForwardProp(finalTag) : defaultShouldForwardProp;
                var newProps = {};
                for(var _key in props){
                    if (shouldUseAs && _key === 'as') continue;
                    if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
                }
                newProps.className = className;
                newProps.ref = ref || props.innerRef;
                var ele = /*#__PURE__*/ (0, $lx97N.createElement)(finalTag, newProps);
                var possiblyStyleElement = /*#__PURE__*/ (0, $lx97N.createElement)($d1075490e7470b1c$var$Noop, null);
                return /*#__PURE__*/ (0, $lx97N.createElement)((0, $lx97N.Fragment), null, possiblyStyleElement, ele);
            });
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, nextOptions !== undefined ? $d1075490e7470b1c$var$_objectSpread({}, options || {}, {}, nextOptions) : options).apply(void 0, styles);
        };
        return Styled;
    };
};
var $d1075490e7470b1c$export$2e2bcd8739ae039 = $d1075490e7470b1c$var$createStyled;


var $c47ddde344dbf90f$var$tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
var $c47ddde344dbf90f$var$newStyled = (0, $d1075490e7470b1c$export$2e2bcd8739ae039).bind();
$c47ddde344dbf90f$var$tags.forEach(function(tagName) {
    $c47ddde344dbf90f$var$newStyled[tagName] = $c47ddde344dbf90f$var$newStyled(tagName);
});
var $c47ddde344dbf90f$export$2e2bcd8739ae039 = $c47ddde344dbf90f$var$newStyled;



parcelRequire("lx97N");

const $65f15d32471eec71$var$Component = (props)=>/*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)($65f15d32471eec71$var$StyledSpan, {
        ...props,
        ...props.href && !props.disabled ? {
            as: `a`
        } : {},
        ...props.disabled ? {
            onClick: undefined
        } : {},
        children: props.children
    });
var $65f15d32471eec71$export$2e2bcd8739ae039 = $65f15d32471eec71$var$Component;
const $65f15d32471eec71$var$StyledSpan = (0, $c47ddde344dbf90f$export$2e2bcd8739ae039).span`
  opacity: ${({ disabled: disabled })=>disabled ? 0.15 : 1};
  cursor: ${({ disabled: disabled })=>disabled ? `not-allowed` : `pointer`};
  background: ${({ secondary: secondary })=>secondary ? `#666` : `#61afef`};
  display: inline-block;
  width: 190px;
  height: ${(p)=>p.height || 50}px;
  text-align: center;
  line-height: ${(p)=>p.height || 50}px;

  &:link,
  &:visited {
    text-decoration: none;
    color: inherit;
  }

  &:hover {
    ${(p)=>p.disabled ? `` : p.secondary ? `background: #777` : `background: #4d99d8`}
  }
`;


const $7bba885684e8baef$var$Div = (0, $c47ddde344dbf90f$export$2e2bcd8739ae039).div`
  display: flex;
  width: 100%;
  height: 100vh;
  justify-content: center;
  align-items: center;

  img {
    width: 100px;
    height: 100px;
    display: block;
    margin: -15px auto 20px auto;
  }

  .login-btn {
    width: 100%;
    color: white !important;
    display: block;
    margin: 30px auto 15px auto;
  }

  a {
    color: var(--accent);
  }

  > div {
    width: 400px;
    background: white;
    padding: 2em;
    color: #555;
  }

  p {
    line-height: 140%;
  }
`;
const $7bba885684e8baef$var$Component = ()=>{
    const url = [
        `https://github.com/login/oauth/authorize`,
        `?client_id=${"d3d2082e14077ecb7986"}`,
        `&scope=repo,read:user`,
        `&state=894c5e7f-c83f-4bd3-b299-47b754d9b506`
    ].join(``);
    return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)($7bba885684e8baef$var$Div, {
        children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("img", {
                            src: "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
                            alt: "github logo"
                        }),
                        "To use the ",
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("i", {
                            children: "Friends Library Editor,"
                        }),
                        " you'll need to login with a (free)",
                        ` `,
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("a", {
                            href: "https://github.com",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: "GitHub"
                        }),
                        ` `,
                        "account."
                    ]
                }),
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $65f15d32471eec71$export$2e2bcd8739ae039), {
                    className: "login-btn",
                    href: url,
                    children: "Login"
                })
            ]
        })
    });
};
var $7bba885684e8baef$export$2e2bcd8739ae039 = $7bba885684e8baef$var$Component;




var $lx97N = parcelRequire("lx97N");







parcelRequire("lx97N");

parcelRequire("lx97N");





const $d0c4111d72ceb047$var$Wrap = (0, $c47ddde344dbf90f$export$2e2bcd8739ae039).nav`
  display: flex;

  .to-tasks {
    width: 150px;
  }

  > .task {
    padding-left: 1em;
    flex-grow: 1;

    > .fa-code-branch {
      color: var(--accent);
      padding-right: 0.4em;
    }
  }

  > .task-friend {
    opacity: 0.75;
  }
`;
const $d0c4111d72ceb047$var$PreviewLink = (0, $c47ddde344dbf90f$export$2e2bcd8739ae039).a`
  opacity: 0.85;
  background: rgba(97, 175, 239, 0.55);
  color: white;
  width: 56px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(97, 175, 239, 0.75);
    opacity: 1;
  }

  i {
    margin-left: -5px;
    transform: scale(1.2);
    color: white !important;
  }
`;
const $d0c4111d72ceb047$var$WorkNav = ({ task: task, goToTasks: goToTasks, friendName: friendName })=>/*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)($d0c4111d72ceb047$var$Wrap, {
        children: [
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $65f15d32471eec71$export$2e2bcd8739ae039), {
                secondary: true,
                className: "to-tasks",
                onClick: goToTasks,
                children: "\u2190 Tasks"
            }),
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("div", {
                className: "task",
                children: [
                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("i", {
                        className: "fas fa-code-branch"
                    }),
                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("span", {
                        className: "task-friend",
                        children: [
                            friendName,
                            ":\xa0"
                        ]
                    }),
                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("span", {
                        className: "task-name",
                        children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("i", {
                            children: task.name
                        })
                    })
                ]
            }),
            task.editingFile && /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)($d0c4111d72ceb047$var$PreviewLink, {
                href: `/?preview=true&task=${task.id}&file=${task.editingFile}`,
                target: "_blank",
                children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("i", {
                    className: "fas fa-book-open"
                })
            })
        ]
    });
const $d0c4111d72ceb047$var$mapState = (state)=>{
    const task = (0, $13d8f246ee75675a$export$e82b432c98c7ae91)(state);
    return {
        task: task,
        friendName: (0, $13d8f246ee75675a$export$9a7ed5c29b3d23ba)(state)
    };
};
const $d0c4111d72ceb047$var$mapDispatch = {
    goToTasks: ()=>$75c2ce1d62cf75f2$export$40b495d76fa99f84(`TASKS`)
};
var $d0c4111d72ceb047$export$2e2bcd8739ae039 = (0, $494dfd495f2b09e7$export$2e2bcd8739ae039)($d0c4111d72ceb047$var$mapState, $d0c4111d72ceb047$var$mapDispatch)($d0c4111d72ceb047$var$WorkNav);


const $182c368e3b285583$var$Component = ({ screen: screen })=>/*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $b8c53ef43392f031$exports.Fragment), {
        children: screen !== `WORK` ? /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)((0, $b8c53ef43392f031$exports.Fragment), {
            children: [
                "Friends Library Publishing ",
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("i", {
                    children: "Online Editor"
                })
            ]
        }) : /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $d0c4111d72ceb047$export$2e2bcd8739ae039), {})
    });
var $182c368e3b285583$export$2e2bcd8739ae039 = $182c368e3b285583$var$Component;


const $81704584cb2f8aea$var$TopNav = (0, $c47ddde344dbf90f$export$2e2bcd8739ae039).div`
  height: 50px;
  color: #ddd;
  background: black;
  display: flex;
  line-height: 50px;

  & .icon,
  & .avatar {
    width: 40px;
    height: 40px;
    border-radius: 4px;
    margin: 5px;
  }

  .icon {
    transition: opacity 200ms ease;
    opacity: ${(p)=>p.throbbing ? 0.5 : 1};
  }

  .spinner {
    opacity: ${(p)=>p.throbbing ? 0.75 : 0};
    width: 20px;
    height: 20px;
    position: absolute;
    top: 15px;
    left: 15px;
  }

  & .center {
    flex-grow: 1;

    & i {
      padding-left: 0.25em;
      color: var(--accent);
    }
  }

  & .github {
    background-color: #111;
    color: #bbb;
    display: flex;
    & .name {
      padding: 0 0.5em 0 0.8em;
      display: block;
    }
  }
`;
class $81704584cb2f8aea$var$Component extends $lx97N.Component {
    componentDidMount() {
        const { token: token, requestGitHubUser: requestGitHubUser } = this.props;
        $8b46f778ffe0a0e8$export$61bb00ddedae72e4(token);
        // always re-request the github user so we pull in new avatars, etc
        requestGitHubUser();
    }
    render() {
        const { avatar: avatar, name: name, screen: screen, user: user, throbbing: throbbing, logout: logout } = this.props;
        return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)($81704584cb2f8aea$var$TopNav, {
            throbbing: throbbing,
            children: [
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("img", {
                    className: "icon",
                    src: (0, {}),
                    alt: ""
                }),
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("img", {
                    className: "spinner",
                    src: (0, {}),
                    alt: ""
                }),
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                    className: "center",
                    children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $182c368e3b285583$export$2e2bcd8739ae039), {
                        screen: screen
                    })
                }),
                user && /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("div", {
                    className: "github",
                    onDoubleClick: logout,
                    children: [
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("span", {
                            className: "name",
                            children: name ? name : user
                        }),
                        avatar && /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("img", {
                            className: "avatar",
                            src: avatar,
                            alt: ""
                        })
                    ]
                })
            ]
        });
    }
}
const $81704584cb2f8aea$var$mapState = (state)=>{
    if (state.github.token === null) throw new Error(`No github token found`);
    return {
        ...state.github,
        screen: state.screen,
        throbbing: state.network.length > 0
    };
};
const $81704584cb2f8aea$var$mapDispatch = {
    requestGitHubUser: $831556aba23b4e91$export$8333dcfd1ac4d0a6,
    logout: $75c2ce1d62cf75f2$export$a0973bcfe11b05c9
};
var $81704584cb2f8aea$export$2e2bcd8739ae039 = (0, $494dfd495f2b09e7$export$2e2bcd8739ae039)($81704584cb2f8aea$var$mapState, $81704584cb2f8aea$var$mapDispatch)($81704584cb2f8aea$var$Component);



parcelRequire("lx97N");

var $351905e2e6034104$exports = {};
var $da779faf86fd2042$exports = {};
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $da779faf86fd2042$var$getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
if ($da779faf86fd2042$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $da779faf86fd2042$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    $da779faf86fd2042$exports = function whatwgRNG() {
        $da779faf86fd2042$var$getRandomValues($da779faf86fd2042$var$rnds8);
        return $da779faf86fd2042$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $da779faf86fd2042$var$rnds = new Array(16);
    $da779faf86fd2042$exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $da779faf86fd2042$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $da779faf86fd2042$var$rnds;
    };
}


var $675124580882843e$exports = {};
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $675124580882843e$var$byteToHex = [];
for(var $675124580882843e$var$i = 0; $675124580882843e$var$i < 256; ++$675124580882843e$var$i)$675124580882843e$var$byteToHex[$675124580882843e$var$i] = ($675124580882843e$var$i + 0x100).toString(16).substr(1);
function $675124580882843e$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $675124580882843e$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join('');
}
$675124580882843e$exports = $675124580882843e$var$bytesToUuid;


function $351905e2e6034104$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == 'string') {
        buf = options === 'binary' ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $da779faf86fd2042$exports)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $675124580882843e$exports(rnds);
}
$351905e2e6034104$exports = $351905e2e6034104$var$v4;






const $88d580fab232dbb4$var$Heading = (0, $c47ddde344dbf90f$export$2e2bcd8739ae039).h3`
  color: #61afef;
  margin-bottom: 12px;
  margin-top: 35px;
`;
var $88d580fab232dbb4$export$2e2bcd8739ae039 = $88d580fab232dbb4$var$Heading;



parcelRequire("lx97N");




var $lx97N = parcelRequire("lx97N");



var $h5Z1H = parcelRequire("h5Z1H");





const $be01f831dd871f7f$var$Wrap = (0, $c47ddde344dbf90f$export$2e2bcd8739ae039).li`
  background: #999;
  color: #222;
  border-radius: 3px;
  box-shadow: 3px 6px 9px black;
  display: inline-block;
  list-style: none;
  margin-bottom: 35px;
  padding: 14px 21px;

  & h1 {
    font-size: 20px;
    background: ${(p)=>p.locked ? `#5d0303` : `#121212`};
    border-top-right-radius: 3px;
    border-top-left-radius: 3px;
    color: #ddd;
    margin: -14px -21px 12px -21px;
    padding: 16px;
  }

  & p.friend {
    font-weight: 700;
    font-size: 17px;
    color: #333;
  }

  & i {
    padding-right: 0.4em;
  }

  & .actions {
    margin-bottom: 10px;

    & .delete,
    & .work {
      margin-left: 50px;
    }

    .reopen {
      color: red;
    }

    & .delete {
      color: ${(p)=>p.locked ? `white` : `red`};
      background: ${(p)=>p.locked ? `var(--accent)` : `#eaeaea`};
    }

    & > * {
      border-radius: 3px;
      display: inline-block;
      width: 190px;
      margin-top: 10px;
      background: #eaeaea;
    }

    & > .work {
      background: var(--accent);
      color: white;
    }

    & > .invisible {
      opacity: 0;
      cursor: default;
    }
  }

  & .time {
    list-style: none;
    color: white;
    opacity: 0.5;
    margin-bottom: 20px;
    padding-left: 20px;
    line-height: 150%;
  }
`;
class $be01f831dd871f7f$var$Task extends $lx97N.Component {
    state = {
        submitting: false
    };
    async componentDidMount() {
        const { task: task, syncStatus: syncStatus } = this.props;
        task.pullRequest && syncStatus(task);
    }
    confirmDelete = ()=>{
        if ("production" === `development`) {
            this.deleteTask();
            return;
        }
        (0, (/*@__PURE__*/$parcel$interopDefault($80b1b2d4767dcec9$exports))).prompt(`Delete Task?`, `You will lose any work and there is no undo.\nPlease type "Hubberthorne" to confirm:\n\n`).then((value)=>{
            if (value === `Hubberthorne`) this.deleteTask();
        }).catch(()=>{});
    };
    deleteTask = ()=>{
        const { task: task, deleteTask: deleteTask } = this.props;
        deleteTask(task.id);
    };
    submit = async ()=>{
        const { task: task, submit: submit } = this.props;
        this.setState({
            submitting: true
        });
        await submit(task);
        this.setState({
            submitting: false
        });
    };
    resubmit = async ()=>{
        const { task: task, resubmit: resubmit } = this.props;
        this.setState({
            submitting: true
        });
        await resubmit(task);
        this.setState({
            submitting: false
        });
    };
    reopen = ()=>{
        const { task: task, reopenTask: reopenTask } = this.props;
        (0, (/*@__PURE__*/$parcel$interopDefault($80b1b2d4767dcec9$exports))).confirm(`Reopen?`, `Reopening should only be done when you need to re-submit a task that has accidentally been worked on after the PR has been merged.`, {
            buttons: {
                ok: `Recover`,
                cancel: `Cancel`
            }
        }).then(()=>reopenTask({
                id: task.id,
                newId: (0, (/*@__PURE__*/$parcel$interopDefault($351905e2e6034104$exports)))()
            })).catch(()=>{});
    };
    submitText() {
        const { task: { pullRequest: pullRequest } } = this.props;
        const { submitting: submitting } = this.state;
        if (submitting) return `Submitting...`;
        return pullRequest ? `Re-submit` : `Submit`;
    }
    render() {
        const { submitting: submitting } = this.state;
        const { task: task, repo: repo, workOnTask: workOnTask, taskHasWork: taskHasWork } = this.props;
        let status = `open`;
        if (task.pullRequest && task.pullRequest.status) status = task.pullRequest.status;
        const isLocked = status !== `open`;
        return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)($be01f831dd871f7f$var$Wrap, {
            locked: isLocked,
            children: [
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("h1", {
                    children: [
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("i", {
                            className: `fas fa-${isLocked ? `lock` : `code-branch`}`
                        }),
                        ` `,
                        isLocked ? `${status.toUpperCase()}: ` : ``,
                        task.name
                    ]
                }),
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("p", {
                    className: "friend",
                    children: [
                        "Friend: ",
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("em", {
                            children: repo.friendName
                        })
                    ]
                }),
                !isLocked && /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("ul", {
                    className: "time",
                    children: [
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("i", {
                                    className: "far fa-calendar"
                                }),
                                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("i", {
                                    children: "Created:"
                                }),
                                (0, (/*@__PURE__*/$parcel$interopDefault($h5Z1H)))(task.created).format(`M/D/YY [at] h:mm:ssa`)
                            ]
                        }),
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("i", {
                                    className: "far fa-calendar"
                                }),
                                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("i", {
                                    children: "Last updated:"
                                }),
                                (0, (/*@__PURE__*/$parcel$interopDefault($h5Z1H)))(task.updated).from((0, (/*@__PURE__*/$parcel$interopDefault($h5Z1H)))())
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("div", {
                    className: "actions",
                    children: [
                        task.pullRequest ? /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)((0, $65f15d32471eec71$export$2e2bcd8739ae039), {
                            secondary: true,
                            target: "_blank",
                            href: `https://github.com/${(0, $8b46f778ffe0a0e8$export$c7bc89c720838974)}/${repo.slug}/pull/${task.pullRequest.number}`,
                            className: "pr",
                            children: [
                                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("i", {
                                    className: "fas fa-code-branch"
                                }),
                                "View pull request"
                            ]
                        }) : /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $65f15d32471eec71$export$2e2bcd8739ae039), {
                            className: "invisible",
                            children: "\xaf\\_(\u30C4)_/\xaf"
                        }),
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)((0, $65f15d32471eec71$export$2e2bcd8739ae039), {
                            secondary: !isLocked,
                            className: "delete",
                            onClick: isLocked ? this.deleteTask : this.confirmDelete,
                            children: [
                                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("i", {
                                    className: "far fa-trash-alt"
                                }),
                                "Delete"
                            ]
                        }),
                        !isLocked && /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)((0, $65f15d32471eec71$export$2e2bcd8739ae039), {
                            secondary: true,
                            disabled: !taskHasWork || submitting,
                            className: "submit",
                            onClick: task.pullRequest ? this.resubmit : this.submit,
                            children: [
                                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("i", {
                                    className: "fas fa-cloud-upload-alt"
                                }),
                                this.submitText()
                            ]
                        }),
                        isLocked && /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)((0, $65f15d32471eec71$export$2e2bcd8739ae039), {
                            secondary: true,
                            className: "reopen",
                            onClick: this.reopen,
                            children: [
                                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("i", {
                                    className: "fas fa-redo-alt"
                                }),
                                "Reopen"
                            ]
                        }),
                        !isLocked && /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)((0, $65f15d32471eec71$export$2e2bcd8739ae039), {
                            className: "work",
                            onClick: ()=>workOnTask(task.id),
                            children: [
                                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("i", {
                                    className: "fas fa-pencil-alt"
                                }),
                                "Work"
                            ]
                        })
                    ]
                })
            ]
        });
    }
}
const $be01f831dd871f7f$var$mapState = (state, { task: task })=>{
    const repo = state.repos.find((r)=>r.id === task.repoId);
    if (!repo) throw new Error(`Could not find repo with id ${task.repoId}`);
    return {
        task: task,
        repo: repo,
        taskHasWork: !!Object.values(task.files).find((f)=>!!f.editedContent)
    };
};
const $be01f831dd871f7f$var$mapDispatch = {
    submit: $831556aba23b4e91$export$1af9e694f7afdc53,
    resubmit: $831556aba23b4e91$export$c35a154f6cfe8aea,
    workOnTask: $75c2ce1d62cf75f2$export$a23735b9c4842f23,
    updateTask: $75c2ce1d62cf75f2$export$e8e0154b7bb02be4,
    deleteTask: $831556aba23b4e91$export$f08d315250e1aa23,
    reopenTask: $75c2ce1d62cf75f2$export$2b0f1fd6a0f7f3d2,
    syncStatus: $831556aba23b4e91$export$103149011e4c2e95
};
var $be01f831dd871f7f$export$2e2bcd8739ae039 = (0, $494dfd495f2b09e7$export$2e2bcd8739ae039)($be01f831dd871f7f$var$mapState, $be01f831dd871f7f$var$mapDispatch)($be01f831dd871f7f$var$Task);


const $2c93566adbe4ea42$var$List = (0, $c47ddde344dbf90f$export$2e2bcd8739ae039).ul`
  margin: 30px -15px;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  > li {
    flex-basis: 480px;
    margin: 15px;
  }
`;
const $2c93566adbe4ea42$var$TaskList = ({ tasks: tasks })=>/*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)($2c93566adbe4ea42$var$List, {
        children: tasks.map((task)=>/*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $be01f831dd871f7f$export$2e2bcd8739ae039), {
                task: task
            }, task.id))
    });
const $2c93566adbe4ea42$var$mapState = (state)=>({
        tasks: Object.values(state.tasks.present)
    });
var $2c93566adbe4ea42$export$2e2bcd8739ae039 = (0, $494dfd495f2b09e7$export$2e2bcd8739ae039)($2c93566adbe4ea42$var$mapState)($2c93566adbe4ea42$var$TaskList);


const $ff07e8289fff4ce0$var$Welcome = ({ tasks: tasks, changeScreen: changeScreen, createTask: createTask })=>/*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("div", {
        className: "padded-wrap",
        children: [
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("h1", {
                children: "Tasks"
            }),
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)((0, $88d580fab232dbb4$export$2e2bcd8739ae039), {
                children: [
                    "You have ",
                    tasks.length,
                    " task",
                    tasks.length === 1 ? `` : `s`,
                    ":"
                ]
            }),
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $2c93566adbe4ea42$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $65f15d32471eec71$export$2e2bcd8739ae039), {
                onClick: ()=>{
                    createTask({
                        taskId: (0, (/*@__PURE__*/$parcel$interopDefault($351905e2e6034104$exports)))()
                    });
                    changeScreen($3e05c0969d23c6c5$export$7d63f45909460d98);
                },
                children: "Create a task"
            })
        ]
    });
const $ff07e8289fff4ce0$var$mapState = (state)=>({
        tasks: Object.values(state.tasks.present)
    });
const $ff07e8289fff4ce0$var$mapDispatch = {
    changeScreen: $75c2ce1d62cf75f2$export$40b495d76fa99f84,
    createTask: $75c2ce1d62cf75f2$export$f7292ab7796be73c
};
var $ff07e8289fff4ce0$export$2e2bcd8739ae039 = (0, $494dfd495f2b09e7$export$2e2bcd8739ae039)($ff07e8289fff4ce0$var$mapState, $ff07e8289fff4ce0$var$mapDispatch)($ff07e8289fff4ce0$var$Welcome);




var $lx97N = parcelRequire("lx97N");








parcelRequire("lx97N");


parcelRequire("lx97N");

const $d5f1ba22637aca3e$var$Wrap = (0, $c47ddde344dbf90f$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;
const $d5f1ba22637aca3e$var$Component = ({ children: children })=>/*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)($d5f1ba22637aca3e$var$Wrap, {
        children: children
    });
var $d5f1ba22637aca3e$export$2e2bcd8739ae039 = $d5f1ba22637aca3e$var$Component;


const $14318da104c038f4$var$H1 = (0, $c47ddde344dbf90f$export$2e2bcd8739ae039).h1`
  opacity: 0.35;
`;
const $14318da104c038f4$var$Loading = ()=>/*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $d5f1ba22637aca3e$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)($14318da104c038f4$var$H1, {
            children: "Loading..."
        })
    });
var $14318da104c038f4$export$2e2bcd8739ae039 = $14318da104c038f4$var$Loading;


const $1318f36bc6ccd8c0$var$FriendList = (0, $c47ddde344dbf90f$export$2e2bcd8739ae039).ul`
  margin: 0;
  padding: 0;
  column-width: 140px;
  column-gap: 7px;

  & li {
    list-style-type: none;
    break-inside: avoid-column;
    background: gray;
    margin-bottom: 7px;
    padding: 5px 7px;
    cursor: pointer;
    font-size: 12px;

    &:hover {
      background: #444;
    }

    &.selected {
      background: var(--accent);
      color: black;
      cursor: default;
    }
  }
`;
const $1318f36bc6ccd8c0$var$Btns = (0, $c47ddde344dbf90f$export$2e2bcd8739ae039).div`
  height: 100px;
  display: flex;
  width: 100%;
  align-items: center;

  > * {
    margin-right: 30px;
  }
`;
const $1318f36bc6ccd8c0$var$H1 = (0, $c47ddde344dbf90f$export$2e2bcd8739ae039).h1`
  > i {
    color: var(--accent);
    padding-right: 0.35em;
    font-size: 0.85em;
  }
`;
const $1318f36bc6ccd8c0$var$Input = (0, $c47ddde344dbf90f$export$2e2bcd8739ae039).input`
  background: gray;
  border: none;
  color: #ddd;
  padding: 5px 10px;
  font-size: 25px;
  width: 500px;
`;
let $1318f36bc6ccd8c0$var$friendsFetchedThisSession = false;
class $1318f36bc6ccd8c0$var$EditTask extends (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).Component {
    input = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createRef();
    constructor(props){
        super(props);
        this.state = {
            name: props.task.name,
            repoId: props.task.repoId
        };
    }
    componentDidMount() {
        const { fetchFriendRepos: fetchFriendRepos, friends: friends } = this.props;
        // re-fetch friend repos once per session to add new friends
        if (!$1318f36bc6ccd8c0$var$friendsFetchedThisSession || friends.length === 0) {
            fetchFriendRepos();
            $1318f36bc6ccd8c0$var$friendsFetchedThisSession = true;
        }
        this.input.current && this.input.current.focus();
    }
    clickSave = ()=>{
        const { name: name, repoId: repoId } = this.state;
        const { updateTask: updateTask, goToTasks: goToTasks, task: task } = this.props;
        if (!repoId || !name.trim()) return;
        updateTask({
            id: task.id,
            data: {
                name: name,
                repoId: repoId,
                isNew: false
            }
        });
        goToTasks();
    };
    clickCancel = ()=>{
        const { deleteTask: deleteTask, goToTasks: goToTasks, task: task } = this.props;
        if (task.isNew) deleteTask(task.id);
        goToTasks();
    };
    render() {
        const { name: name, repoId: repoId } = this.state;
        const { task: task, friends: friends } = this.props;
        return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("div", {
            className: "padded-wrap",
            children: [
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)($1318f36bc6ccd8c0$var$H1, {
                    children: [
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("i", {
                            className: "fas fa-code-branch"
                        }),
                        task.isNew ? `Create` : `Edit`,
                        " Task"
                    ]
                }),
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $88d580fab232dbb4$export$2e2bcd8739ae039), {
                    children: "Task name:"
                }),
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)($1318f36bc6ccd8c0$var$Input, {
                    ref: this.input,
                    type: "text",
                    value: name,
                    onChange: (e)=>this.setState({
                            name: e.target.value
                        })
                }),
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $88d580fab232dbb4$export$2e2bcd8739ae039), {
                    children: "Choose a Friend:"
                }),
                friends.length === 0 ? /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $14318da104c038f4$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)($1318f36bc6ccd8c0$var$FriendList, {
                    children: friends.sort((a, b)=>a.name.trim() < b.name.trim() ? -1 : 1).map((friend)=>/*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("li", {
                            className: repoId === friend.repoId ? `selected` : ``,
                            onClick: ()=>this.setState({
                                    repoId: friend.repoId
                                }),
                            children: friend.name.trim()
                        }, friend.repoId))
                }),
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)($1318f36bc6ccd8c0$var$Btns, {
                    children: [
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $65f15d32471eec71$export$2e2bcd8739ae039), {
                            height: 50,
                            secondary: true,
                            onClick: this.clickCancel,
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $65f15d32471eec71$export$2e2bcd8739ae039), {
                            height: 50,
                            disabled: repoId === -1 || !name.trim(),
                            onClick: this.clickSave,
                            children: "Save"
                        })
                    ]
                })
            ]
        });
    }
}
const $1318f36bc6ccd8c0$var$mapState = (state)=>({
        friends: state.repos.map((r)=>({
                repoId: r.id,
                name: r.friendName,
                slug: r.slug
            })),
        task: (0, $13d8f246ee75675a$export$e82b432c98c7ae91)(state)
    });
const $1318f36bc6ccd8c0$var$mapDispatch = {
    fetchFriendRepos: $831556aba23b4e91$export$a0a66e16c6df8da0,
    updateTask: $75c2ce1d62cf75f2$export$e8e0154b7bb02be4,
    goToTasks: ()=>$75c2ce1d62cf75f2$export$40b495d76fa99f84($3e05c0969d23c6c5$export$bd1d8583f199118f),
    deleteTask: $831556aba23b4e91$export$f08d315250e1aa23
};
var $1318f36bc6ccd8c0$export$2e2bcd8739ae039 = (0, $494dfd495f2b09e7$export$2e2bcd8739ae039)($1318f36bc6ccd8c0$var$mapState, $1318f36bc6ccd8c0$var$mapDispatch)($1318f36bc6ccd8c0$var$EditTask);




var $lx97N = parcelRequire("lx97N");


var $j0yhs = parcelRequire("j0yhs");






var $lx97N = parcelRequire("lx97N");

var $2e028685ecba3f47$exports = {};
"use strict";
Object.defineProperty($2e028685ecba3f47$exports, "__esModule", {
    value: true
});
Object.defineProperty($2e028685ecba3f47$exports, "split", {
    enumerable: true,
    get: function get() {
        return $2e028685ecba3f47$var$_split["default"];
    }
});
Object.defineProperty($2e028685ecba3f47$exports, "diff", {
    enumerable: true,
    get: function get() {
        return $2e028685ecba3f47$var$_diff["default"];
    }
});
$2e028685ecba3f47$exports["default"] = void 0;

var $2e028685ecba3f47$var$_ace = $2e028685ecba3f47$var$_interopRequireDefault((parcelRequire("jan5f")));

var $2e028685ecba3f47$var$_split = $2e028685ecba3f47$var$_interopRequireDefault((parcelRequire("les1L")));

var $2e028685ecba3f47$var$_diff = $2e028685ecba3f47$var$_interopRequireDefault((parcelRequire("6GVRA")));
function $2e028685ecba3f47$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $2e028685ecba3f47$var$_default = $2e028685ecba3f47$var$_ace["default"];
$2e028685ecba3f47$exports["default"] = $2e028685ecba3f47$var$_default;


var $29a4ffa32b5e7e98$exports = {};
'use strict';
function $29a4ffa32b5e7e98$var$_interopDefault(ex) {
    return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var $lx97N = parcelRequire("lx97N");
var $29a4ffa32b5e7e98$var$React__default = $29a4ffa32b5e7e98$var$_interopDefault($lx97N);

var $29a4ffa32b5e7e98$var$ReactDOM = $29a4ffa32b5e7e98$var$_interopDefault((parcelRequire("1amKe")));

var $29a4ffa32b5e7e98$var$invariant = $29a4ffa32b5e7e98$var$_interopDefault((parcelRequire("1dCkN")));
var $80d5e8df4a495438$exports = {};
(function(global, factory) {
    factory($80d5e8df4a495438$exports);
})($80d5e8df4a495438$exports, function(exports1) {
    'use strict';
    /* eslint-disable no-undefined,no-param-reassign,no-shadow */ /**
	 * Throttle execution of a function. Especially useful for rate limiting
	 * execution of handlers on events like resize and scroll.
	 *
	 * @param  {number}    delay -          A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
	 * @param  {boolean}   [noTrailing] -   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds while the
	 *                                    throttled-function is being called. If noTrailing is false or unspecified, callback will be executed one final time
	 *                                    after the last throttled-function call. (After the throttled-function has not been called for `delay` milliseconds,
	 *                                    the internal counter is reset).
	 * @param  {Function}  callback -       A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
	 *                                    to `callback` when the throttled-function is executed.
	 * @param  {boolean}   [debounceMode] - If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is false (at end),
	 *                                    schedule `callback` to execute after `delay` ms.
	 *
	 * @returns {Function}  A new, throttled, function.
	 */ function throttle(delay, noTrailing, callback, debounceMode) {
        /*
	   * After wrapper has stopped being called, this timeout ensures that
	   * `callback` is executed at the proper times in `throttle` and `end`
	   * debounce modes.
	   */ var timeoutID;
        var cancelled = false; // Keep track of the last time `callback` was executed.
        var lastExec = 0; // Function to clear existing timeout
        function clearExistingTimeout() {
            if (timeoutID) clearTimeout(timeoutID);
        } // Function to cancel next exec
        function cancel() {
            clearExistingTimeout();
            cancelled = true;
        } // `noTrailing` defaults to falsy.
        if (typeof noTrailing !== 'boolean') {
            debounceMode = callback;
            callback = noTrailing;
            noTrailing = undefined;
        }
        /*
	   * The `wrapper` function encapsulates all of the throttling / debouncing
	   * functionality and when executed will limit the rate at which `callback`
	   * is executed.
	   */ function wrapper() {
            for(var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++)arguments_[_key] = arguments[_key];
            var self = this;
            var elapsed = Date.now() - lastExec;
            if (cancelled) return;
             // Execute `callback` and update the `lastExec` timestamp.
            function exec() {
                lastExec = Date.now();
                callback.apply(self, arguments_);
            }
            /*
	     * If `debounceMode` is true (at begin) this is used to clear the flag
	     * to allow future `callback` executions.
	     */ function clear() {
                timeoutID = undefined;
            }
            if (debounceMode && !timeoutID) /*
	       * Since `wrapper` is being called for the first time and
	       * `debounceMode` is true (at begin), execute `callback`.
	       */ exec();
            clearExistingTimeout();
            if (debounceMode === undefined && elapsed > delay) /*
	       * In throttle mode, if `delay` time has been exceeded, execute
	       * `callback`.
	       */ exec();
            else if (noTrailing !== true) /*
	       * In trailing throttle mode, since `delay` time has not been
	       * exceeded, schedule `callback` to execute `delay` ms after most
	       * recent execution.
	       *
	       * If `debounceMode` is true (at begin), schedule `clear` to execute
	       * after `delay` ms.
	       *
	       * If `debounceMode` is false (at end), schedule `callback` to
	       * execute after `delay` ms.
	       */ timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
        }
        wrapper.cancel = cancel; // Return the wrapper function.
        return wrapper;
    }
    /* eslint-disable no-undefined */ /**
	 * Debounce execution of a function. Debouncing, unlike throttling,
	 * guarantees that a function is only executed a single time, either at the
	 * very beginning of a series of calls, or at the very end.
	 *
	 * @param  {number}   delay -         A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
	 * @param  {boolean}  [atBegin] -     Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
	 *                                  after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
	 *                                  (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
	 * @param  {Function} callback -      A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
	 *                                  to `callback` when the debounced-function is executed.
	 *
	 * @returns {Function} A new, debounced function.
	 */ function debounce(delay, atBegin, callback) {
        return callback === undefined ? throttle(delay, atBegin, false) : throttle(delay, callback, atBegin !== false);
    }
    exports1.debounce = debounce;
    exports1.throttle = throttle;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});



var $29a4ffa32b5e7e98$var$createResizeDetector = $29a4ffa32b5e7e98$var$_interopDefault((parcelRequire("9Cv3p")));

var $29a4ffa32b5e7e98$var$isShallowEqual = $29a4ffa32b5e7e98$var$_interopDefault((parcelRequire("fudzi")));
function $29a4ffa32b5e7e98$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $29a4ffa32b5e7e98$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $29a4ffa32b5e7e98$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $29a4ffa32b5e7e98$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $29a4ffa32b5e7e98$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $29a4ffa32b5e7e98$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $29a4ffa32b5e7e98$var$_extends() {
    $29a4ffa32b5e7e98$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $29a4ffa32b5e7e98$var$_extends.apply(this, arguments);
}
function $29a4ffa32b5e7e98$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $29a4ffa32b5e7e98$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $29a4ffa32b5e7e98$var$ownKeys(Object(source), true).forEach(function(key) {
            $29a4ffa32b5e7e98$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $29a4ffa32b5e7e98$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $29a4ffa32b5e7e98$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $29a4ffa32b5e7e98$var$_setPrototypeOf(subClass, superClass);
}
function $29a4ffa32b5e7e98$var$_getPrototypeOf(o) {
    $29a4ffa32b5e7e98$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $29a4ffa32b5e7e98$var$_getPrototypeOf(o);
}
function $29a4ffa32b5e7e98$var$_setPrototypeOf(o, p) {
    $29a4ffa32b5e7e98$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $29a4ffa32b5e7e98$var$_setPrototypeOf(o, p);
}
function $29a4ffa32b5e7e98$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $29a4ffa32b5e7e98$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $29a4ffa32b5e7e98$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $29a4ffa32b5e7e98$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $29a4ffa32b5e7e98$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    return $29a4ffa32b5e7e98$var$_assertThisInitialized(self);
}
var $29a4ffa32b5e7e98$var$instances = {}; // Lazily require to not cause bug
// https://github.com/ctrlplusb/react-sizeme/issues/6
function $29a4ffa32b5e7e98$var$resizeDetector() {
    var strategy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'scroll';
    if (!$29a4ffa32b5e7e98$var$instances[strategy]) $29a4ffa32b5e7e98$var$instances[strategy] = $29a4ffa32b5e7e98$var$createResizeDetector({
        strategy: strategy
    });
    return $29a4ffa32b5e7e98$var$instances[strategy];
}
var $29a4ffa32b5e7e98$var$errMsg = 'react-sizeme: an error occurred whilst stopping to listen to node size changes';
var $29a4ffa32b5e7e98$var$defaultConfig = {
    monitorWidth: true,
    monitorHeight: false,
    monitorPosition: false,
    refreshRate: 16,
    refreshMode: 'throttle',
    noPlaceholder: false,
    resizeDetectorStrategy: 'scroll'
};
function $29a4ffa32b5e7e98$var$getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}
/**
 * This is a utility wrapper component that will allow our higher order
 * component to get a ref handle on our wrapped components html.
 * @see https://gist.github.com/jimfb/32b587ee6177665fb4cf
 */ var $29a4ffa32b5e7e98$var$ReferenceWrapper = /*#__PURE__*/ function(_Component) {
    $29a4ffa32b5e7e98$var$_inherits(ReferenceWrapper, _Component);
    function ReferenceWrapper() {
        $29a4ffa32b5e7e98$var$_classCallCheck(this, ReferenceWrapper);
        return $29a4ffa32b5e7e98$var$_possibleConstructorReturn(this, $29a4ffa32b5e7e98$var$_getPrototypeOf(ReferenceWrapper).apply(this, arguments));
    }
    $29a4ffa32b5e7e98$var$_createClass(ReferenceWrapper, [
        {
            key: "render",
            value: function render() {
                return $lx97N.Children.only(this.props.children);
            }
        }
    ]);
    return ReferenceWrapper;
}($lx97N.Component);
$29a4ffa32b5e7e98$var$_defineProperty($29a4ffa32b5e7e98$var$ReferenceWrapper, "displayName", 'SizeMeReferenceWrapper');
function $29a4ffa32b5e7e98$var$Placeholder(_ref) {
    var className = _ref.className, style = _ref.style;
    // Lets create the props for the temp element.
    var phProps = {}; // We will use any provided className/style or else make the temp
    // container take the full available space.
    if (!className && !style) phProps.style = {
        width: '100%',
        height: '100%'
    };
    else {
        if (className) phProps.className = className;
        if (style) phProps.style = style;
    }
    return $29a4ffa32b5e7e98$var$React__default.createElement("div", phProps);
}
$29a4ffa32b5e7e98$var$Placeholder.displayName = 'SizeMePlaceholder';
/**
 * As we need to maintain a ref on the root node that is rendered within our
 * SizeMe component we need to wrap our entire render in a sub component.
 * Without this, we lose the DOM ref after the placeholder is removed from
 * the render and the actual component is rendered.
 * It took me forever to figure this out, so tread extra careful on this one!
 */ var $29a4ffa32b5e7e98$var$renderWrapper = function renderWrapper(WrappedComponent) {
    function SizeMeRenderer(props) {
        var explicitRef = props.explicitRef, className = props.className, style = props.style, size = props.size, disablePlaceholder = props.disablePlaceholder, onSize = props.onSize, restProps = $29a4ffa32b5e7e98$var$_objectWithoutProperties(props, [
            "explicitRef",
            "className",
            "style",
            "size",
            "disablePlaceholder",
            "onSize"
        ]);
        var noSizeData = size == null || size.width == null && size.height == null && size.position == null;
        var renderPlaceholder = noSizeData && !disablePlaceholder;
        var renderProps = {
            className: className,
            style: style
        };
        if (size != null) renderProps.size = size;
        var toRender = renderPlaceholder ? $29a4ffa32b5e7e98$var$React__default.createElement($29a4ffa32b5e7e98$var$Placeholder, {
            className: className,
            style: style
        }) : $29a4ffa32b5e7e98$var$React__default.createElement(WrappedComponent, $29a4ffa32b5e7e98$var$_extends({}, renderProps, restProps));
        return $29a4ffa32b5e7e98$var$React__default.createElement($29a4ffa32b5e7e98$var$ReferenceWrapper, {
            ref: explicitRef
        }, toRender);
    }
    SizeMeRenderer.displayName = "SizeMeRenderer(".concat($29a4ffa32b5e7e98$var$getDisplayName(WrappedComponent), ")");
    return SizeMeRenderer;
};
/**
 * :: config -> Component -> WrappedComponent
 *
 * Higher order component that allows the wrapped component to become aware
 * of it's size, by receiving it as an object within it's props.
 *
 * @param  monitorWidth
 *   Default true, whether changes in the element's width should be monitored,
 *   causing a size property to be broadcast.
 * @param  monitorHeight
 *   Default false, whether changes in the element's height should be monitored,
 *   causing a size property to be broadcast.
 *
 * @return The wrapped component.
 */ function $29a4ffa32b5e7e98$var$withSize() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $29a4ffa32b5e7e98$var$defaultConfig;
    var _config$monitorWidth = config.monitorWidth, monitorWidth = _config$monitorWidth === void 0 ? $29a4ffa32b5e7e98$var$defaultConfig.monitorWidth : _config$monitorWidth, _config$monitorHeight = config.monitorHeight, monitorHeight = _config$monitorHeight === void 0 ? $29a4ffa32b5e7e98$var$defaultConfig.monitorHeight : _config$monitorHeight, _config$monitorPositi = config.monitorPosition, monitorPosition = _config$monitorPositi === void 0 ? $29a4ffa32b5e7e98$var$defaultConfig.monitorPosition : _config$monitorPositi, _config$refreshRate = config.refreshRate, refreshRate = _config$refreshRate === void 0 ? $29a4ffa32b5e7e98$var$defaultConfig.refreshRate : _config$refreshRate, _config$refreshMode = config.refreshMode, refreshMode = _config$refreshMode === void 0 ? $29a4ffa32b5e7e98$var$defaultConfig.refreshMode : _config$refreshMode, _config$noPlaceholder = config.noPlaceholder, noPlaceholder = _config$noPlaceholder === void 0 ? $29a4ffa32b5e7e98$var$defaultConfig.noPlaceholder : _config$noPlaceholder, _config$resizeDetecto = config.resizeDetectorStrategy, resizeDetectorStrategy = _config$resizeDetecto === void 0 ? $29a4ffa32b5e7e98$var$defaultConfig.resizeDetectorStrategy : _config$resizeDetecto;
    $29a4ffa32b5e7e98$var$invariant(monitorWidth || monitorHeight || monitorPosition, 'You have to monitor at least one of the width, height, or position when using "sizeMe"');
    $29a4ffa32b5e7e98$var$invariant(refreshRate >= 16, "It is highly recommended that you don't put your refreshRate lower than 16 as this may cause layout thrashing.");
    $29a4ffa32b5e7e98$var$invariant(refreshMode === 'throttle' || refreshMode === 'debounce', 'The refreshMode should have a value of "throttle" or "debounce"');
    var refreshDelayStrategy = refreshMode === 'throttle' ? $80d5e8df4a495438$exports.throttle : $80d5e8df4a495438$exports.debounce;
    return function WrapComponent(WrappedComponent) {
        var SizeMeRenderWrapper = $29a4ffa32b5e7e98$var$renderWrapper(WrappedComponent);
        var SizeAwareComponent = /*#__PURE__*/ function(_React$Component) {
            $29a4ffa32b5e7e98$var$_inherits(SizeAwareComponent, _React$Component);
            function SizeAwareComponent() {
                var _getPrototypeOf2;
                var _this;
                $29a4ffa32b5e7e98$var$_classCallCheck(this, SizeAwareComponent);
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                _this = $29a4ffa32b5e7e98$var$_possibleConstructorReturn(this, (_getPrototypeOf2 = $29a4ffa32b5e7e98$var$_getPrototypeOf(SizeAwareComponent)).call.apply(_getPrototypeOf2, [
                    this
                ].concat(args)));
                $29a4ffa32b5e7e98$var$_defineProperty($29a4ffa32b5e7e98$var$_assertThisInitialized(_this), "domEl", null);
                $29a4ffa32b5e7e98$var$_defineProperty($29a4ffa32b5e7e98$var$_assertThisInitialized(_this), "state", {
                    width: undefined,
                    height: undefined,
                    position: undefined
                });
                $29a4ffa32b5e7e98$var$_defineProperty($29a4ffa32b5e7e98$var$_assertThisInitialized(_this), "uninstall", function() {
                    if (_this.domEl) {
                        try {
                            _this.detector.uninstall(_this.domEl);
                        } catch (err) {
                            // eslint-disable-next-line no-console
                            console.warn($29a4ffa32b5e7e98$var$errMsg);
                        }
                        _this.domEl = null;
                    }
                });
                $29a4ffa32b5e7e98$var$_defineProperty($29a4ffa32b5e7e98$var$_assertThisInitialized(_this), "determineStrategy", function(props) {
                    if (props.onSize) {
                        if (!_this.callbackState) _this.callbackState = $29a4ffa32b5e7e98$var$_objectSpread2({}, _this.state);
                        _this.strategy = 'callback';
                    } else _this.strategy = 'render';
                });
                $29a4ffa32b5e7e98$var$_defineProperty($29a4ffa32b5e7e98$var$_assertThisInitialized(_this), "strategisedSetState", function(state) {
                    if (_this.strategy === 'callback') {
                        _this.callbackState = state;
                        _this.props.onSize(state);
                    }
                    _this.setState(state);
                });
                $29a4ffa32b5e7e98$var$_defineProperty($29a4ffa32b5e7e98$var$_assertThisInitialized(_this), "strategisedGetState", function() {
                    return _this.strategy === 'callback' ? _this.callbackState : _this.state;
                });
                $29a4ffa32b5e7e98$var$_defineProperty($29a4ffa32b5e7e98$var$_assertThisInitialized(_this), "refCallback", function(element) {
                    _this.element = element;
                });
                $29a4ffa32b5e7e98$var$_defineProperty($29a4ffa32b5e7e98$var$_assertThisInitialized(_this), "hasSizeChanged", function(current, next) {
                    var c = current;
                    var n = next;
                    var cp = c.position || {};
                    var np = n.position || {};
                    return monitorWidth && c.width !== n.width || monitorHeight && c.height !== n.height || monitorPosition && (cp.top !== np.top || cp.left !== np.left || cp.bottom !== np.bottom || cp.right !== np.right);
                });
                $29a4ffa32b5e7e98$var$_defineProperty($29a4ffa32b5e7e98$var$_assertThisInitialized(_this), "checkIfSizeChanged", refreshDelayStrategy(refreshRate, function(el) {
                    var _el$getBoundingClient = el.getBoundingClientRect(), width = _el$getBoundingClient.width, height = _el$getBoundingClient.height, right = _el$getBoundingClient.right, left = _el$getBoundingClient.left, top = _el$getBoundingClient.top, bottom = _el$getBoundingClient.bottom;
                    var next = {
                        width: monitorWidth ? width : null,
                        height: monitorHeight ? height : null,
                        position: monitorPosition ? {
                            right: right,
                            left: left,
                            top: top,
                            bottom: bottom
                        } : null
                    };
                    if (_this.hasSizeChanged(_this.strategisedGetState(), next)) _this.strategisedSetState(next);
                }));
                return _this;
            }
            $29a4ffa32b5e7e98$var$_createClass(SizeAwareComponent, [
                {
                    key: "componentDidMount",
                    value: function componentDidMount() {
                        this.detector = $29a4ffa32b5e7e98$var$resizeDetector(resizeDetectorStrategy);
                        this.determineStrategy(this.props);
                        this.handleDOMNode();
                    }
                },
                {
                    key: "componentDidUpdate",
                    value: function componentDidUpdate() {
                        this.determineStrategy(this.props);
                        this.handleDOMNode();
                    }
                },
                {
                    key: "componentWillUnmount",
                    value: function componentWillUnmount() {
                        // Change our size checker to a noop just in case we have some
                        // late running events.
                        this.hasSizeChanged = function() {
                            return undefined;
                        };
                        this.checkIfSizeChanged = function() {
                            return undefined;
                        };
                        this.uninstall();
                    }
                },
                {
                    key: "handleDOMNode",
                    value: function handleDOMNode() {
                        var found = this.element && $29a4ffa32b5e7e98$var$ReactDOM.findDOMNode(this.element);
                        if (!found) {
                            // If we previously had a dom node then we need to ensure that
                            // we remove any existing listeners to avoid memory leaks.
                            this.uninstall();
                            return;
                        }
                        if (!this.domEl) {
                            this.domEl = found;
                            this.detector.listenTo(this.domEl, this.checkIfSizeChanged);
                        } else if (this.domEl.isSameNode && !this.domEl.isSameNode(found) || this.domEl !== found) {
                            this.uninstall();
                            this.domEl = found;
                            this.detector.listenTo(this.domEl, this.checkIfSizeChanged);
                        }
                    }
                },
                {
                    key: "render",
                    value: function render() {
                        var disablePlaceholder = $29a4ffa32b5e7e98$var$withSize.enableSSRBehaviour || $29a4ffa32b5e7e98$var$withSize.noPlaceholders || noPlaceholder || this.strategy === 'callback';
                        var size = $29a4ffa32b5e7e98$var$_objectSpread2({}, this.state);
                        return $29a4ffa32b5e7e98$var$React__default.createElement(SizeMeRenderWrapper, $29a4ffa32b5e7e98$var$_extends({
                            explicitRef: this.refCallback,
                            size: this.strategy === 'callback' ? null : size,
                            disablePlaceholder: disablePlaceholder
                        }, this.props));
                    }
                }
            ]);
            return SizeAwareComponent;
        }($29a4ffa32b5e7e98$var$React__default.Component);
        $29a4ffa32b5e7e98$var$_defineProperty(SizeAwareComponent, "displayName", "SizeMe(".concat($29a4ffa32b5e7e98$var$getDisplayName(WrappedComponent), ")"));
        SizeAwareComponent.WrappedComponent = WrappedComponent;
        return SizeAwareComponent;
    };
}
/**
 * Allow SizeMe to run within SSR environments.  This is a "global" behaviour
 * flag that should be set within the initialisation phase of your application.
 *
 * Warning: don't set this flag unless you need to as using it may cause
 * extra render cycles to happen within your components depending on the logic
 * contained within them around the usage of the `size` data.
 *
 * DEPRECATED: Please use the global noPlaceholders
 */ $29a4ffa32b5e7e98$var$withSize.enableSSRBehaviour = false;
/**
 * Global configuration allowing to disable placeholder rendering for all
 * sizeMe components.
 */ $29a4ffa32b5e7e98$var$withSize.noPlaceholders = false;
var $29a4ffa32b5e7e98$var$SizeMe = /*#__PURE__*/ function(_Component) {
    $29a4ffa32b5e7e98$var$_inherits(SizeMe, _Component);
    function SizeMe(props) {
        var _this;
        $29a4ffa32b5e7e98$var$_classCallCheck(this, SizeMe);
        _this = $29a4ffa32b5e7e98$var$_possibleConstructorReturn(this, $29a4ffa32b5e7e98$var$_getPrototypeOf(SizeMe).call(this, props));
        $29a4ffa32b5e7e98$var$_defineProperty($29a4ffa32b5e7e98$var$_assertThisInitialized(_this), "createComponent", function(config) {
            _this.SizeAware = $29a4ffa32b5e7e98$var$withSize(config)(function(_ref) {
                var children = _ref.children;
                return children;
            });
        });
        $29a4ffa32b5e7e98$var$_defineProperty($29a4ffa32b5e7e98$var$_assertThisInitialized(_this), "onSize", function(size) {
            return _this.setState({
                size: size
            });
        });
        var _children = props.children, render = props.render, sizeMeConfig = $29a4ffa32b5e7e98$var$_objectWithoutProperties(props, [
            "children",
            "render"
        ]);
        _this.createComponent(sizeMeConfig);
        _this.state = {
            size: {
                width: undefined,
                height: undefined
            }
        };
        return _this;
    }
    $29a4ffa32b5e7e98$var$_createClass(SizeMe, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props = this.props, prevChildren = _this$props.children, prevRender = _this$props.render, currentSizeMeConfig = $29a4ffa32b5e7e98$var$_objectWithoutProperties(_this$props, [
                    "children",
                    "render"
                ]);
                var nextChildren = prevProps.children, nextRender = prevProps.render, prevSizeMeConfig = $29a4ffa32b5e7e98$var$_objectWithoutProperties(prevProps, [
                    "children",
                    "render"
                ]);
                if (!$29a4ffa32b5e7e98$var$isShallowEqual(currentSizeMeConfig, prevSizeMeConfig)) this.createComponent(currentSizeMeConfig);
            }
        },
        {
            key: "render",
            value: function render() {
                var SizeAware = this.SizeAware;
                var render = this.props.children || this.props.render;
                return $29a4ffa32b5e7e98$var$React__default.createElement(SizeAware, {
                    onSize: this.onSize
                }, render({
                    size: this.state.size
                }));
            }
        }
    ]);
    return SizeMe;
}($lx97N.Component);
$29a4ffa32b5e7e98$var$_defineProperty($29a4ffa32b5e7e98$var$SizeMe, "defaultProps", {
    children: undefined,
    render: undefined
});
$29a4ffa32b5e7e98$var$withSize.SizeMe = $29a4ffa32b5e7e98$var$SizeMe;
$29a4ffa32b5e7e98$var$withSize.withSize = $29a4ffa32b5e7e98$var$withSize;
$29a4ffa32b5e7e98$exports = $29a4ffa32b5e7e98$var$withSize;


var $fc6da8441dcd6fda$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $fc6da8441dcd6fda$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */ var $fc6da8441dcd6fda$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $fc6da8441dcd6fda$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $fc6da8441dcd6fda$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $fc6da8441dcd6fda$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $fc6da8441dcd6fda$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $fc6da8441dcd6fda$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $fc6da8441dcd6fda$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $fc6da8441dcd6fda$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $fc6da8441dcd6fda$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $fc6da8441dcd6fda$var$root = $fc6da8441dcd6fda$var$freeGlobal || $fc6da8441dcd6fda$var$freeSelf || Function('return this')();
/** Used for built-in method references. */ var $fc6da8441dcd6fda$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $fc6da8441dcd6fda$var$objectToString = $fc6da8441dcd6fda$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $fc6da8441dcd6fda$var$nativeMax = Math.max, $fc6da8441dcd6fda$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $fc6da8441dcd6fda$var$now = function() {
    return $fc6da8441dcd6fda$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $fc6da8441dcd6fda$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($fc6da8441dcd6fda$var$FUNC_ERROR_TEXT);
    wait = $fc6da8441dcd6fda$var$toNumber(wait) || 0;
    if ($fc6da8441dcd6fda$var$isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $fc6da8441dcd6fda$var$nativeMax($fc6da8441dcd6fda$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $fc6da8441dcd6fda$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $fc6da8441dcd6fda$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($fc6da8441dcd6fda$var$now());
    }
    function debounced() {
        var time = $fc6da8441dcd6fda$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $fc6da8441dcd6fda$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $fc6da8441dcd6fda$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $fc6da8441dcd6fda$var$isSymbol(value) {
    return typeof value == 'symbol' || $fc6da8441dcd6fda$var$isObjectLike(value) && $fc6da8441dcd6fda$var$objectToString.call(value) == $fc6da8441dcd6fda$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $fc6da8441dcd6fda$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($fc6da8441dcd6fda$var$isSymbol(value)) return $fc6da8441dcd6fda$var$NAN;
    if ($fc6da8441dcd6fda$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $fc6da8441dcd6fda$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($fc6da8441dcd6fda$var$reTrim, '');
    var isBinary = $fc6da8441dcd6fda$var$reIsBinary.test(value);
    return isBinary || $fc6da8441dcd6fda$var$reIsOctal.test(value) ? $fc6da8441dcd6fda$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $fc6da8441dcd6fda$var$reIsBadHex.test(value) ? $fc6da8441dcd6fda$var$NAN : +value;
}
$fc6da8441dcd6fda$exports = $fc6da8441dcd6fda$var$debounce;



const $f556b19a33951931$export$c916c075a7028158 = {
    TEXT: `TEXT`,
    ASTERISK: `ASTERISK`,
    DOUBLE_ASTERISK: `DOUBLE_ASTERISK`,
    TRIPLE_ASTERISK: `TRIPLE_ASTERISK`,
    THEMATIC_BREAK: `THEMATIC_BREAK`,
    STRAIGHT_DOUBLE_QUOTE: `STRAIGHT_DOUBLE_QUOTE`,
    STRAIGHT_SINGLE_QUOTE: `STRAIGHT_SINGLE_QUOTE`,
    DOUBLE_COLON: `DOUBLE_COLON`,
    FORWARD_SLASH: `FORWARD_SLASH`,
    PIPE: `PIPE`,
    PLUS: `PLUS`,
    HASH: `HASH`,
    TRIPLE_PLUS: `TRIPLE_PLUS`,
    QUADRUPLE_PLUS: `QUADRUPLE_PLUS`,
    WHITESPACE: `WHITESPACE`,
    DOUBLE_DASH: `DOUBLE_DASH`,
    UNDERSCORE: `UNDERSCORE`,
    LEFT_SINGLE_CURLY: `LEFT_SINGLE_CURLY`,
    RIGHT_SINGLE_CURLY: `RIGHT_SINGLE_CURLY`,
    LEFT_DOUBLE_CURLY: `LEFT_DOUBLE_CURLY`,
    RIGHT_DOUBLE_CURLY: `RIGHT_DOUBLE_CURLY`,
    LEFT_BRACKET: `LEFT_BRACKET`,
    RIGHT_BRACKET: `RIGHT_BRACKET`,
    XREF_OPEN: `XREF_OPEN`,
    XREF_CLOSE: `XREF_CLOSE`,
    LEFT_PARENS: `LEFT_PARENS`,
    RIGHT_PARENS: `RIGHT_PARENS`,
    FOOTNOTE_PREFIX: `FOOTNOTE_PREFIX`,
    FOOTNOTE_STANZA: `FOOTNOTE_STANZA`,
    FOOTNOTE_PARAGRAPH_SPLIT: `FOOTNOTE_PARAGRAPH_SPLIT`,
    DEGREE_SYMBOL: `DEGREE_SYMBOL`,
    POUND_SYMBOL: `POUND_SYMBOL`,
    DOLLAR_SYMBOL: `DOLLAR_SYMBOL`,
    ENTITY: `ENTITY`,
    EQUALS: `EQUALS`,
    COMMA: `COMMA`,
    CARET: `CARET`,
    BACKTICK: `BACKTICK`,
    RAW_PASSTHROUGH: `RAW_PASSTHROUGH`,
    DOT: `DOT`,
    SEMICOLON: `SEMICOLON`,
    COLON: `COLON`,
    EXCLAMATION_MARK: `EXCLAMATION_MARK`,
    QUESTION_MARK: `QUESTION_MARK`,
    ILLEGAL: `ILLEGAL`,
    EOL: `EOL`,
    DOUBLE_EOL: `DOUBLE_EOL`,
    EOF: `EOF`,
    EOD: `EOD`,
    EOX: `EOX`
};
const $f556b19a33951931$export$845480b930b0e280 = {
    DOCUMENT: `DOCUMENT`,
    CHAPTER: `CHAPTER`,
    HEADING: `HEADING`,
    HEADING_SEQUENCE_IDENTIFIER: `HEADING_SEQUENCE_IDENTIFIER`,
    HEADING_TITLE: `HEADING_TITLE`,
    HEADING_SEGMENT: `HEADING_SEGMENT`,
    SECTION: `SECTION`,
    PARAGRAPH: `PARAGRAPH`,
    EMPHASIS: `EMPHASIS`,
    STRONG: `STRONG`,
    TEXT: `TEXT`,
    BLOCK: `BLOCK`,
    THEMATIC_BREAK: `THEMATIC_BREAK`,
    VERSE_STANZA: `VERSE_STANZA`,
    VERSE_LINE: `VERSE_LINE`,
    SYMBOL: `SYMBOL`,
    INLINE_PASSTHROUGH: `INLINE_PASSTHROUGH`,
    BLOCK_PASSTHROUGH: `BLOCK_PASSTHROUGH`,
    UNORDERED_LIST: `UNORDERED_LIST`,
    LIST_ITEM: `LIST_ITEM`,
    INLINE: `INLINE`,
    FOOTNOTE: `FOOTNOTE`,
    REDACTED: `REDACTED`,
    DESCRIPTION_LIST: `DESCRIPTION_LIST`,
    DESCRIPTION_LIST_ITEM: `DESCRIPTION_LIST_ITEM`,
    DESCRIPTION_LIST_ITEM_TERM: `DESCRIPTION_LIST_ITEM_TERM`,
    DESCRIPTION_LIST_ITEM_CONTENT: `DESCRIPTION_LIST_ITEM_CONTENT`,
    DISCOURSE_PART_IDENTIFIER: `DISCOURSE_PART_IDENTIFIER`,
    POSTSCRIPT_IDENTIFIER: `POSTSCRIPT_IDENTIFIER`,
    ENTITY: `ENTITY`,
    MONEY: `MONEY`,
    COLLECTION: `COLLECTION`,
    XREF: `XREF`
};
const $f556b19a33951931$export$fa20de1d199f87ac = {
    EMDASH: `EMDASH`,
    ELLIPSES: `ELLIPSES`,
    AMPERSAND: `AMPERSAND`
};




class $8ac22502c9309918$export$2e2bcd8739ae039 {
    children = [];
    value = ``;
    meta = {};
    _context;
    _startToken;
    _endToken;
    get parent() {
        throw new Error(`AbstractAstNode.parent not implemented for type: ${this.type}`);
    }
    get chapter() {
        let current = this;
        while(current.type !== (0, $f556b19a33951931$export$845480b930b0e280).CHAPTER)current = current.parent;
        return current;
    }
    document() {
        let current = this;
        while(!current.isDocument())current = current.parent;
        return current;
    }
    get type() {
        throw new Error(`AbstractAstNode.type not implemented`);
    }
    descendsFrom(type) {
        let current = this;
        while(!current.isDocument()){
            current = current.parent;
            if (current.type === type) return true;
        }
        return false;
    }
    isDocument() {
        return false;
    }
    parentIsDocument() {
        return !this.isDocument() && this.parent.isDocument();
    }
    isParagraph() {
        return this.type === (0, $f556b19a33951931$export$845480b930b0e280).PARAGRAPH;
    }
    isOpenBlock() {
        return this.meta.subType === `open`;
    }
    isNumberedBlock() {
        return this.isExampleBlock() && this.hasClass(`numbered-group`);
    }
    isExampleBlock() {
        return this.meta.subType === `example`;
    }
    isPoetryBlock() {
        return this.type === (0, $f556b19a33951931$export$845480b930b0e280).BLOCK && this.meta.subType === `verse`;
    }
    isQuoteBlock() {
        return this.type === (0, $f556b19a33951931$export$845480b930b0e280).BLOCK && this.context?.type === `quote`;
    }
    isAttributedQuoteBlock() {
        if (!this.isQuoteBlock()) return false;
        const context = this.context;
        return !!(context?.quoteSource?.length || context?.quoteSource?.length);
    }
    hasClass(className) {
        return this.context?.classList.includes(className) ?? false;
    }
    siblingIndex() {
        return this.parent.children.indexOf(this);
    }
    nextSibling() {
        return this.parent.children[this.siblingIndex() + 1] ?? null;
    }
    isFirstChild() {
        return this.siblingIndex() === 0;
    }
    isLastChild() {
        return this.siblingIndex() === this.parent.children.length - 1;
    }
    isOnlyChild() {
        return this.parent.children.length === 1;
    }
    hasSiblings() {
        return !this.isOnlyChild();
    }
    isInFootnote() {
        return this.descendsFrom((0, $f556b19a33951931$export$845480b930b0e280).FOOTNOTE);
    }
    expectFirstChild(type) {
        const firstChild = this.children[0];
        if (!firstChild) throw new Error(`Unexpected missing first child`);
        if (type && firstChild.type !== type) throw new Error(`Unexpected wrong type for first child. Expected ${type}, got: ${firstChild.type}`);
        return firstChild;
    }
    setMetaData(key, value) {
        if (!this.meta.data) this.meta.data = {};
        this.meta.data[key] = value;
    }
    getMetaData(key) {
        return this.meta.data?.[key];
    }
    expectBooleanMetaData(key) {
        const data = this.getMetaData(key);
        if (data !== true && data !== false) throw new Error(`Unexpected non-boolean metadata for key=${key}, val=${data}`);
        return data;
    }
    expectNumberMetaData(key) {
        const data = this.getMetaData(key);
        if (typeof data !== `number`) throw new Error(`Unexpected non-number metadata for key=${key}, val=${data}`);
        return data;
    }
    expectStringMetaData(key) {
        const data = this.getMetaData(key);
        if (typeof data !== `string`) throw new Error(`Unexpected non-string metadata for key=${key}, val=${data}`);
        return data;
    }
    set startToken(token) {
        this._startToken = token;
    }
    get startToken() {
        if (!this._startToken) throw new Error(`Unexpected missing AstNode.startToken`);
        return this._startToken;
    }
    set endToken(token) {
        this._endToken = token;
    }
    get endToken() {
        if (!this._endToken) throw new Error(`Unexpected missing AstNode.endToken`);
        return this._endToken;
    }
    get context() {
        return this._context;
    }
    set context(context) {
        this._context = context;
        if (!this._context) return;
        if (this._context.classList.filter($8ac22502c9309918$var$indicatesSignedSection).length > 0) this.chapter.setMetaData(`hasSignedSection`, true);
    }
    toJSON(withTokens) {
        return {
            type: this.type,
            ...this.context ? {
                context: this.context.toJSON()
            } : {},
            ...this.value ? {
                value: this.value
            } : {},
            ...this.children.length ? {
                children: this.children.map((c)=>c.toJSON(withTokens))
            } : {},
            ...Object.keys(this.meta).length ? {
                meta: this.meta
            } : {},
            ...withTokens ? {
                startToken: this.startToken,
                endToken: this.endToken
            } : {}
        };
    }
    print(withTokens) {
        // eslint-disable-next-line no-console
        console.log(JSON.stringify(this.toJSON(withTokens), null, 2));
    }
}
function $8ac22502c9309918$var$indicatesSignedSection(kls) {
    if (kls === `salutation` || kls === `letter-heading`) return true;
    return kls.startsWith(`signed-section`);
}



class $86b9a01d2c8c01db$export$2e2bcd8739ae039 extends (0, $8ac22502c9309918$export$2e2bcd8739ae039) {
    _type;
    _parent;
    children;
    value;
    meta;
    constructor(_type, _parent, config = {}){
        super(), this._type = _type, this._parent = _parent, this.children = [], this.value = ``, this.meta = {};
        if (config.context) {
            this.context = config.context;
            this.startToken = config.context.startToken;
        }
        if (config.value) this.value = config.value;
        // `!this._startToken` allows config.context.startToken to trump config.startToken
        // giving a more ergonomic API for creating nodes with optional contexts
        if (config.startToken && !this._startToken) this.startToken = config.startToken;
        if (config.endToken) this._endToken = config.endToken;
        if (config.subType) this.meta.subType = config.subType;
        if (config.level) this.meta.level = config.level;
    }
    get type() {
        return this._type;
    }
    set type(type) {
        this._type = type;
    }
    get parent() {
        return this._parent;
    }
    set parent(parent) {
        this._parent = parent;
    }
}


class $53a0ebb1c5fd63b9$export$2e2bcd8739ae039 extends (0, $8ac22502c9309918$export$2e2bcd8739ae039) {
    epigraphs;
    footnotes;
    idChapterLocations = {};
    embeddableSections = {};
    constructor(){
        super();
        this.epigraphs = new (0, $86b9a01d2c8c01db$export$2e2bcd8739ae039)((0, $f556b19a33951931$export$845480b930b0e280).COLLECTION, this);
        this.footnotes = new (0, $86b9a01d2c8c01db$export$2e2bcd8739ae039)((0, $f556b19a33951931$export$845480b930b0e280).COLLECTION, this);
    }
    get type() {
        return (0, $f556b19a33951931$export$845480b930b0e280).DOCUMENT;
    }
    get chapter() {
        throw new Error(`Error: attempt to resolve chapter from document node`);
    }
    isDocument() {
        return true;
    }
    parentIsDocument() {
        return false;
    }
    document() {
        return this;
    }
    get chapters() {
        return this.children;
    }
    toJSON(withTokens) {
        return {
            footnotes: this.footnotes.children.map((footnote)=>footnote.toJSON(withTokens)),
            epigraphs: this.epigraphs.children.map((epigraph)=>epigraph.toJSON(withTokens)),
            ...Object.keys(this.embeddableSections).length ? {
                embeddableSections: Object.keys(this.embeddableSections).reduce((map, key)=>({
                        ...map,
                        [key]: `[[AstNode]]`
                    }), {})
            } : {},
            ...Object.keys(this.idChapterLocations).length ? {
                idChapterLocations: this.idChapterLocations
            } : {},
            ...super.toJSON(withTokens)
        };
    }
}







class $74d733bd15d62224$export$2e2bcd8739ae039 {
    p;
    terminators;
    className;
    idStarters;
    constructor(p){
        this.p = p;
        this.terminators = [
            (0, $f556b19a33951931$export$c916c075a7028158).DOT,
            (0, $f556b19a33951931$export$c916c075a7028158).COLON
        ];
        this.className = `discourse-part`;
        this.idStarters = [
            `question`,
            `pregunta`,
            `answer`,
            `respuesta`,
            `objection`,
            `objeci\xf3n`,
            `inquiry`
        ];
    }
    parse(parent) {
        if (!this.identifierPossible(parent)) return null;
        const firstWord = this.p.current.literal;
        if (!this.idStarters.includes(firstWord.toLowerCase())) return null;
        const node = new (0, $86b9a01d2c8c01db$export$2e2bcd8739ae039)((0, $f556b19a33951931$export$845480b930b0e280).DISCOURSE_PART_IDENTIFIER, parent);
        node.startToken = this.p.consume((0, $f556b19a33951931$export$c916c075a7028158).TEXT);
        node.value = node.startToken.literal;
        if (this.consumeTerminator(node)) return node;
        if (this.p.currentIs((0, $f556b19a33951931$export$c916c075a7028158).WHITESPACE) && this.p.peekIs((0, $f556b19a33951931$export$c916c075a7028158).TEXT) && this.p.peek.literal.match(/^\d+$/)) {
            node.value += this.p.consume().literal;
            node.value += this.p.current.literal;
            node.endToken = this.p.consume();
        }
        this.consumeTerminator(node);
        return node;
    }
    consumeTerminator(node) {
        if (this.p.currentOneOf(...this.terminators)) {
            node.value += this.p.current.literal;
            node.endToken = this.p.consume();
            return true;
        }
        return false;
    }
    identifierPossible(parent) {
        if (this.p.current.column.start !== 1 || this.p.current.type !== (0, $f556b19a33951931$export$845480b930b0e280).TEXT) return false;
        if (!parent.hasClass(this.className) && !parent.parent.hasClass(this.className)) return false;
        return true;
    }
}





class $985c245ed012fe95$export$2e2bcd8739ae039 extends (0, $74d733bd15d62224$export$2e2bcd8739ae039) {
    // protected terminators = [t.DOT, t.C];
    className = `postscript`;
    idStarters = [
        `PS`,
        `Postscript`,
        `PostScript`,
        `PD`,
        `NB`,
        `Posdata`,
        `PosData`
    ];
    parse(parent) {
        if (!this.identifierPossible(parent)) return null;
        const fullWordNode = this.parseFullWord(parent);
        if (fullWordNode) return fullWordNode;
        const abbrevNode = this.parseAbbrev(parent);
        if (abbrevNode) return abbrevNode;
        return null;
    }
    parseAbbrev(parent) {
        const peekText = this.p.peekJoinedLiterals(8);
        const match = peekText.match(/(P|N)(?:\+\+\+)?\.(?:\+\+\+)? ?(S|D|B)(?:\.)?/);
        if (!match) return null;
        // reject stuff like P. B. or N. S.
        if (![
            `PS`,
            `PD`,
            `NB`
        ].includes(`${match[1]}${match[2]}`)) return null;
        const node = new (0, $86b9a01d2c8c01db$export$2e2bcd8739ae039)((0, $f556b19a33951931$export$845480b930b0e280).POSTSCRIPT_IDENTIFIER, parent);
        node.startToken = this.p.current;
        let numConsumedChars = 0;
        while(numConsumedChars < (match[0] ?? ``).length){
            const token = this.p.consume();
            node.endToken = token;
            numConsumedChars += token.literal.length;
            if (!this.p.tokenIs(token, (0, $f556b19a33951931$export$c916c075a7028158).TRIPLE_PLUS)) node.value += token.literal;
        }
        if (numConsumedChars !== (match[0] ?? ``).length) this.p.throwError(`unexpected result creating postscript identifier`);
        return node;
    }
    parseFullWord(parent) {
        const firstWord = this.p.current.literal;
        if (!this.idStarters.includes(firstWord)) return null;
        const node = new (0, $86b9a01d2c8c01db$export$2e2bcd8739ae039)((0, $f556b19a33951931$export$845480b930b0e280).POSTSCRIPT_IDENTIFIER, parent);
        node.startToken = this.p.consume((0, $f556b19a33951931$export$c916c075a7028158).TEXT);
        node.value = node.startToken.literal;
        if (node.value.length > 2) {
            node.value = node.startToken.literal.toLowerCase();
            node.value = [
                (node.value[0] ?? ``).toUpperCase(),
                ...node.value.slice(1)
            ].join(``);
        }
        node.endToken = node.startToken;
        this.consumeTerminator(node);
        return node;
    }
    identifierPossible(parent) {
        if (!super.identifierPossible(parent)) return false;
        return !!this.p.current.literal.match(/^(P|N)/);
    }
}


const $e7e7aebf457370c7$var$textParselet = (parser, parent)=>{
    if (parser.currentIs((0, $f556b19a33951931$export$c916c075a7028158).DOT) && parser.current.column.start === 1) parser.throwError(`line starting with dot not implemented`);
    const discourseParser = new (0, $74d733bd15d62224$export$2e2bcd8739ae039)(parser);
    const discoursePartId = discourseParser.parse(parent);
    if (discoursePartId) return discoursePartId;
    const psParser = new (0, $985c245ed012fe95$export$2e2bcd8739ae039)(parser);
    const psId = psParser.parse(parent);
    if (psId) return psId;
    const node = new (0, $86b9a01d2c8c01db$export$2e2bcd8739ae039)((0, $f556b19a33951931$export$845480b930b0e280).TEXT, parent, {
        value: parser.current.literal
    });
    if (parser.currentOneOf((0, $f556b19a33951931$export$c916c075a7028158).WHITESPACE, (0, $f556b19a33951931$export$c916c075a7028158).EOL)) node.value = ` `;
    node.startToken = parser.consume();
    node.endToken = node.startToken;
    // handle special case where we're starting a line with something like `+++[+++`
    if (parser.peekTokens((0, $f556b19a33951931$export$c916c075a7028158).RAW_PASSTHROUGH, (0, $f556b19a33951931$export$c916c075a7028158).TRIPLE_PLUS)) {
        node.value = parser.consume().literal;
        parser.consume();
    }
    while(parser.currentOneOf((0, $f556b19a33951931$export$c916c075a7028158).TEXT, (0, $f556b19a33951931$export$c916c075a7028158).WHITESPACE, (0, $f556b19a33951931$export$c916c075a7028158).EOL, (0, $f556b19a33951931$export$c916c075a7028158).COMMA, (0, $f556b19a33951931$export$c916c075a7028158).DOT, (0, $f556b19a33951931$export$c916c075a7028158).EXCLAMATION_MARK, (0, $f556b19a33951931$export$c916c075a7028158).LEFT_PARENS, (0, $f556b19a33951931$export$c916c075a7028158).RIGHT_PARENS, (0, $f556b19a33951931$export$c916c075a7028158).RIGHT_BRACKET, (0, $f556b19a33951931$export$c916c075a7028158).TRIPLE_PLUS) && !parser.stopTokensFound()){
        const passthruResult = $e7e7aebf457370c7$var$handlePassthru(node, parser);
        if (passthruResult === `continue`) continue;
        else if (passthruResult === `return`) return $e7e7aebf457370c7$var$endNode(node, parser);
        const token = parser.consume();
        switch(token.type){
            case (0, $f556b19a33951931$export$c916c075a7028158).WHITESPACE:
                node.value += ` `;
                break;
            case (0, $f556b19a33951931$export$c916c075a7028158).EOL:
                if ($e7e7aebf457370c7$var$shouldConvertEolToSpace(parser, token)) node.value += ` `;
                break;
            default:
                node.value += token.literal;
                break;
        }
    }
    return $e7e7aebf457370c7$var$endNode(node, parser);
};
var $e7e7aebf457370c7$export$2e2bcd8739ae039 = $e7e7aebf457370c7$var$textParselet;
function $e7e7aebf457370c7$var$handlePassthru(node, parser) {
    if (!parser.currentIs((0, $f556b19a33951931$export$c916c075a7028158).TRIPLE_PLUS)) return `proceed`;
    // we only consume (certain) INLINE passthroughs
    if (!parser.peekTokens((0, $f556b19a33951931$export$c916c075a7028158).TRIPLE_PLUS, (0, $f556b19a33951931$export$c916c075a7028158).RAW_PASSTHROUGH, (0, $f556b19a33951931$export$c916c075a7028158).TRIPLE_PLUS)) return `return`;
    if (!parser.peek.literal.match(/^(\.|\[|\]|-|;|\*)$/)) return `return`;
    parser.consume((0, $f556b19a33951931$export$c916c075a7028158).TRIPLE_PLUS);
    node.endToken = parser.consume((0, $f556b19a33951931$export$c916c075a7028158).RAW_PASSTHROUGH);
    node.value += node.endToken.literal;
    parser.consume((0, $f556b19a33951931$export$c916c075a7028158).TRIPLE_PLUS);
    return `continue`;
}
function $e7e7aebf457370c7$var$endNode(node, parser) {
    node.endToken = parser.lastSignificantToken();
    return node;
}
function $e7e7aebf457370c7$var$shouldConvertEolToSpace(parser, token) {
    // final paragraph in blockquote should not have a trailing space
    if (parser.tokenIs(token, [
        (0, $f556b19a33951931$export$c916c075a7028158).UNDERSCORE,
        `____`
    ])) return false;
    if (parser.currentIs((0, $f556b19a33951931$export$c916c075a7028158).FOOTNOTE_PARAGRAPH_SPLIT)) return false;
    return true;
}




const $61db92ea5ad89434$var$underscore = (parser, parent)=>{
    if (parser.current.literal === `_` || parser.current.literal === `__`) return $61db92ea5ad89434$var$emphasis(parser, parent);
    if (parser.current.column.start !== 1 || !parser.peekIs((0, $f556b19a33951931$export$c916c075a7028158).EOX)) {
        const redacted = parser.consume();
        return new (0, $86b9a01d2c8c01db$export$2e2bcd8739ae039)((0, $f556b19a33951931$export$845480b930b0e280).REDACTED, parent, {
            startToken: redacted,
            endToken: redacted,
            value: redacted.literal
        });
    }
    throw parser.throwError(`unexpected underscore token`);
};
var $61db92ea5ad89434$export$2e2bcd8739ae039 = $61db92ea5ad89434$var$underscore;
const $61db92ea5ad89434$var$emphasis = (parser, parent)=>{
    const open = parser.current;
    const node = new (0, $86b9a01d2c8c01db$export$2e2bcd8739ae039)((0, $f556b19a33951931$export$845480b930b0e280).EMPHASIS, parent, {
        startToken: open
    });
    parser.consume();
    node.children = parser.parseUntil(node, [
        (0, $f556b19a33951931$export$c916c075a7028158).UNDERSCORE,
        open.literal
    ]);
    node.endToken = parser.current;
    parser.consumeClose([
        (0, $f556b19a33951931$export$c916c075a7028158).UNDERSCORE,
        open.literal
    ], (0, $f556b19a33951931$export$845480b930b0e280).EMPHASIS, open);
    if (open.column.start === 1 && (parent.hasClass(`discourse-part`) || parent.parent.hasClass(`discourse-part`)) && node.children.length === 1 && node.children[0]?.type === (0, $f556b19a33951931$export$845480b930b0e280).TEXT) {
        const dpId = node.children[0];
        dpId.type = (0, $f556b19a33951931$export$845480b930b0e280).DISCOURSE_PART_IDENTIFIER;
        dpId.parent = parent;
        return dpId;
    }
    return node;
};




const $7ce37a34024bb879$var$strong = (parser, parent)=>{
    const open = parser.current;
    const node = new (0, $86b9a01d2c8c01db$export$2e2bcd8739ae039)((0, $f556b19a33951931$export$845480b930b0e280).STRONG, parent);
    node.startToken = parser.consume((0, $f556b19a33951931$export$c916c075a7028158).DOUBLE_ASTERISK);
    node.children = parser.parseUntil(node, (0, $f556b19a33951931$export$c916c075a7028158).DOUBLE_ASTERISK);
    node.endToken = parser.consumeClose((0, $f556b19a33951931$export$c916c075a7028158).DOUBLE_ASTERISK, (0, $f556b19a33951931$export$845480b930b0e280).STRONG, open);
    return node;
};
var $7ce37a34024bb879$export$2e2bcd8739ae039 = $7ce37a34024bb879$var$strong;




const $415a765061218442$var$symbol = (parser, parent)=>{
    const current = parser.current;
    if ($415a765061218442$var$isMoney(parser)) return $415a765061218442$var$parseMoney(parser, parent);
    const node = new (0, $86b9a01d2c8c01db$export$2e2bcd8739ae039)((0, $f556b19a33951931$export$845480b930b0e280).SYMBOL, parent, {
        subType: current.type,
        value: current.literal,
        startToken: current,
        endToken: current
    });
    const symbolType = current.type;
    parser.consume();
    // lines ending with `--` should join directly to next line
    if (symbolType === (0, $f556b19a33951931$export$c916c075a7028158).DOUBLE_DASH && parser.currentIs((0, $f556b19a33951931$export$c916c075a7028158).EOL) && parent.type !== (0, $f556b19a33951931$export$845480b930b0e280).VERSE_LINE // except for verses ending in `--`
    ) parser.consume();
    return node;
};
var $415a765061218442$export$2e2bcd8739ae039 = $415a765061218442$var$symbol;
function $415a765061218442$var$parseMoney(parser, parent) {
    const money = new (0, $86b9a01d2c8c01db$export$2e2bcd8739ae039)((0, $f556b19a33951931$export$845480b930b0e280).MONEY, parent, {
        value: parser.current.literal + parser.peek.literal,
        startToken: parser.current,
        endToken: parser.peek
    });
    let numberStr = parser.peek.literal;
    parser.consume(); // currency symbol
    parser.consume(); // start of amount
    if (parser.currentOneOf((0, $f556b19a33951931$export$c916c075a7028158).COMMA, (0, $f556b19a33951931$export$c916c075a7028158).DOT) && $415a765061218442$var$isNumber(parser.peek)) {
        money.value += parser.consume().literal;
        const moreDigits = parser.consume();
        money.endToken = moreDigits;
        numberStr += moreDigits.literal;
        money.value += moreDigits.literal;
    }
    money.meta.data = {
        currencyType: money.startToken.type,
        amount: Number(numberStr)
    };
    return money;
}
function $415a765061218442$var$isMoney(parser) {
    if (!parser.currentOneOf((0, $f556b19a33951931$export$c916c075a7028158).POUND_SYMBOL, (0, $f556b19a33951931$export$c916c075a7028158).DOLLAR_SYMBOL)) return false;
    return $415a765061218442$var$isNumber(parser.peek);
}
function $415a765061218442$var$isNumber(token) {
    return token.type === (0, $f556b19a33951931$export$c916c075a7028158).TEXT && !!token.literal.match(/^\d+/);
}




class $9681347b5b14fb6c$export$2e2bcd8739ae039 {
    classList = [];
    type;
    id;
    quoteAttribution;
    quoteSource;
    shortTitle;
    _startToken;
    _endToken;
    set startToken(token) {
        this._startToken = token;
    }
    get startToken() {
        if (!this._startToken) throw new Error(`Unexpected missing Context.startToken`);
        return this._startToken;
    }
    set endToken(token) {
        this._endToken = token;
    }
    get endToken() {
        if (!this._endToken) throw new Error(`Unexpected missing Context.endToken`);
        return this._endToken;
    }
    toJSON(withTokens) {
        return {
            classList: this.classList,
            ...this.type ? {
                type: this.type
            } : {},
            ...this.id ? {
                id: this.id
            } : {},
            ...this.quoteAttribution ? {
                quoteAttribution: this.quoteAttribution
            } : {},
            ...this.quoteSource ? {
                quoteSource: this.quoteSource
            } : {},
            ...this.shortTitle ? {
                shortTitle: this.shortTitle
            } : {},
            ...withTokens ? {
                startToken: this.startToken,
                endToken: this.endToken
            } : {}
        };
    }
    print(withTokens) {
        // eslint-disable-next-line no-console
        console.log(JSON.stringify(this.toJSON(withTokens), null, 2));
    }
}



const $3c98ce3051974dd4$var$leftBracket = (parser, parent)=>{
    if ($3c98ce3051974dd4$var$isInlineStart(parser)) {
        const leftBracket = parser.consume((0, $f556b19a33951931$export$c916c075a7028158).LEFT_BRACKET);
        parser.consume((0, $f556b19a33951931$export$c916c075a7028158).DOT);
        const context = new (0, $9681347b5b14fb6c$export$2e2bcd8739ae039)();
        context.startToken = leftBracket;
        context.classList.push(parser.consume((0, $f556b19a33951931$export$c916c075a7028158).TEXT).literal);
        context.endToken = parser.consume((0, $f556b19a33951931$export$c916c075a7028158).RIGHT_BRACKET);
        parser.consume((0, $f556b19a33951931$export$c916c075a7028158).HASH);
        const inline = new (0, $86b9a01d2c8c01db$export$2e2bcd8739ae039)((0, $f556b19a33951931$export$845480b930b0e280).INLINE, parent, {
            context: context
        });
        inline.children = parser.parseUntil(inline, (0, $f556b19a33951931$export$c916c075a7028158).HASH);
        inline.endToken = parser.consumeClose((0, $f556b19a33951931$export$c916c075a7028158).HASH, (0, $f556b19a33951931$export$845480b930b0e280).INLINE, leftBracket);
        return inline;
    }
    // if it's not a book title or a context line, we can safely treat like plain text
    if (!$3c98ce3051974dd4$var$isContextLine(parser)) {
        const leftBracket = parser.consume((0, $f556b19a33951931$export$c916c075a7028158).LEFT_BRACKET);
        const textNode = (0, $e7e7aebf457370c7$export$2e2bcd8739ae039)(parser, parent);
        textNode.startToken = leftBracket;
        textNode.value = `[${textNode.value}`;
        return textNode;
    }
    throw parser.throwError(`unexpected left bracket`);
};
var $3c98ce3051974dd4$export$2e2bcd8739ae039 = $3c98ce3051974dd4$var$leftBracket;
function $3c98ce3051974dd4$var$isInlineStart(parser) {
    return parser.peekTokens((0, $f556b19a33951931$export$c916c075a7028158).LEFT_BRACKET, (0, $f556b19a33951931$export$c916c075a7028158).DOT, (0, $f556b19a33951931$export$c916c075a7028158).TEXT, (0, $f556b19a33951931$export$c916c075a7028158).RIGHT_BRACKET, (0, $f556b19a33951931$export$c916c075a7028158).HASH) && [
        `book-title`,
        `underline`
    ].includes(parser.lookAhead(2).literal);
}
function $3c98ce3051974dd4$var$isContextLine(parser) {
    if (parser.current.column.start !== 1) return false;
    let i = 1;
    const guard = parser.makeWhileGuard(`leftBracketParselet/isContextLine()`);
    while(guard() && !parser.tokenIs(parser.lookAhead(i), (0, $f556b19a33951931$export$c916c075a7028158).EOX))i++;
    // it's a context line if the line also ENDs with `]`
    return parser.tokenIs(parser.lookAhead(i - 1), (0, $f556b19a33951931$export$c916c075a7028158).RIGHT_PARENS);
}




const $894c21048d391d64$var$inlinePassThrough = (parser, parent)=>{
    let node = new (0, $86b9a01d2c8c01db$export$2e2bcd8739ae039)((0, $f556b19a33951931$export$845480b930b0e280).INLINE_PASSTHROUGH, parent, {
        startToken: parser.current
    });
    parser.consume((0, $f556b19a33951931$export$c916c075a7028158).TRIPLE_PLUS);
    const token = parser.consume((0, $f556b19a33951931$export$c916c075a7028158).RAW_PASSTHROUGH);
    node.value = token.literal;
    if (token.literal.match(/^___+$/)) node = new (0, $86b9a01d2c8c01db$export$2e2bcd8739ae039)((0, $f556b19a33951931$export$845480b930b0e280).REDACTED, parent, {
        startToken: node.startToken,
        value: node.value
    });
    if (!parser.currentIs((0, $f556b19a33951931$export$c916c075a7028158).TRIPLE_PLUS)) parser.throwError(`unclosed inline passthrough`);
    node.endToken = parser.consume((0, $f556b19a33951931$export$c916c075a7028158).TRIPLE_PLUS);
    return node;
};
var $894c21048d391d64$export$2e2bcd8739ae039 = $894c21048d391d64$var$inlinePassThrough;





class $6789c820aa5ac17a$export$2e2bcd8739ae039 {
    p;
    constructor(p){
        this.p = p;
    }
    parse(parent) {
        const block = new (0, $86b9a01d2c8c01db$export$2e2bcd8739ae039)((0, $f556b19a33951931$export$845480b930b0e280).BLOCK, parent, {
            startToken: this.p.current,
            subType: `verse`
        });
        const stanzas = [];
        const guard = this.p.makeWhileGuard(`FootnotePoetry.parse()`);
        while(guard() && !this.p.peekTokensAnyOf($6789c820aa5ac17a$var$END_FN_POETRY, [
            (0, $f556b19a33951931$export$c916c075a7028158).EOL,
            (0, $f556b19a33951931$export$c916c075a7028158).EOF
        ])){
            if (this.p.peekTokens((0, $f556b19a33951931$export$c916c075a7028158).BACKTICK, [
                (0, $f556b19a33951931$export$c916c075a7028158).WHITESPACE,
                `    `
            ])) {
                this.p.consume();
                this.p.consume();
            }
            const stanza = new (0, $86b9a01d2c8c01db$export$2e2bcd8739ae039)((0, $f556b19a33951931$export$845480b930b0e280).VERSE_STANZA, block, {
                startToken: this.p.current
            });
            stanza.children = this.parseLines(stanza);
            block.children.push(stanza);
            stanzas.push(stanza);
            stanza.endToken = this.p.lastSignificantToken();
            if (this.p.currentIs((0, $f556b19a33951931$export$c916c075a7028158).FOOTNOTE_STANZA)) this.p.consumeMany((0, $f556b19a33951931$export$c916c075a7028158).FOOTNOTE_STANZA, (0, $f556b19a33951931$export$c916c075a7028158).EOL);
        }
        block.children = stanzas;
        block.endToken = this.p.lastSignificantToken();
        this.p.consumeMany(...$6789c820aa5ac17a$var$END_FN_POETRY);
        this.p.consume((0, $f556b19a33951931$export$c916c075a7028158).EOL);
        return block;
    }
    parseLines(stanza) {
        const lines = [];
        const guard = this.p.makeWhileGuard(`FootnotePoetry.parseLines()`);
        while(guard() && !this.p.peekTokensAnyOf([
            (0, $f556b19a33951931$export$c916c075a7028158).FOOTNOTE_STANZA
        ], $6789c820aa5ac17a$var$END_FN_POETRY)){
            this.p.consumeIf([
                (0, $f556b19a33951931$export$c916c075a7028158).WHITESPACE,
                `     `
            ]);
            const line = new (0, $86b9a01d2c8c01db$export$2e2bcd8739ae039)((0, $f556b19a33951931$export$845480b930b0e280).VERSE_LINE, stanza, {
                startToken: this.p.current
            });
            line.children = this.parseLine(line);
            lines.push(line);
            line.endToken = this.p.lastSignificantToken();
            this.p.consumeIf([
                (0, $f556b19a33951931$export$c916c075a7028158).WHITESPACE,
                `     `
            ]);
        }
        return lines;
    }
    parseLine(line) {
        const children = this.p.parseUntilAnyOf(line, [
            (0, $f556b19a33951931$export$c916c075a7028158).EOL
        ], $6789c820aa5ac17a$var$END_FN_POETRY, [
            (0, $f556b19a33951931$export$c916c075a7028158).FOOTNOTE_STANZA
        ]);
        if (this.p.currentIs((0, $f556b19a33951931$export$c916c075a7028158).EOL)) this.p.consume((0, $f556b19a33951931$export$c916c075a7028158).EOL);
        return children;
    }
}
const $6789c820aa5ac17a$var$END_FN_POETRY = [
    [
        (0, $f556b19a33951931$export$c916c075a7028158).WHITESPACE,
        ` `
    ],
    (0, $f556b19a33951931$export$c916c075a7028158).BACKTICK
];



const $c79e92f5cf61321d$var$footnoteParselet = (parser, parent)=>{
    const footnote = new (0, $86b9a01d2c8c01db$export$2e2bcd8739ae039)((0, $f556b19a33951931$export$845480b930b0e280).FOOTNOTE, parent, {
        startToken: parser.current
    });
    if (parser.currentIs((0, $f556b19a33951931$export$c916c075a7028158).CARET)) parser.consumeMany((0, $f556b19a33951931$export$c916c075a7028158).CARET, (0, $f556b19a33951931$export$c916c075a7028158).EOL);
    parser.consumeMany((0, $f556b19a33951931$export$c916c075a7028158).FOOTNOTE_PREFIX, (0, $f556b19a33951931$export$c916c075a7028158).LEFT_BRACKET);
    if (parser.currentIs((0, $f556b19a33951931$export$c916c075a7028158).RIGHT_BRACKET)) parser.throwError(`unexpected empty footnote`);
    const bufp = parser.getBufferedParser((p)=>{
        if (p.currentIs((0, $f556b19a33951931$export$c916c075a7028158).DOUBLE_EOL)) return true;
        if (!p.currentIs((0, $f556b19a33951931$export$c916c075a7028158).RIGHT_BRACKET)) return false;
        // escaped bracket +++]+++ is not a footnote end
        if (p.peekIs((0, $f556b19a33951931$export$c916c075a7028158).TRIPLE_PLUS)) return false;
        // [.book-title]#Apology# within footnote is not end
        if ([
            `book-title`,
            `underline`
        ].includes(p.lookBehind(-1)?.literal || ``)) return false;
        return true;
    }, 1);
    const poetryStart = [
        (0, $f556b19a33951931$export$c916c075a7028158).EOL,
        (0, $f556b19a33951931$export$c916c075a7028158).BACKTICK,
        [
            (0, $f556b19a33951931$export$c916c075a7028158).WHITESPACE,
            `    `
        ]
    ];
    const stops = [
        [
            (0, $f556b19a33951931$export$c916c075a7028158).FOOTNOTE_PARAGRAPH_SPLIT
        ],
        [
            (0, $f556b19a33951931$export$c916c075a7028158).EOL,
            (0, $f556b19a33951931$export$c916c075a7028158).EOF
        ],
        [
            (0, $f556b19a33951931$export$c916c075a7028158).EOF,
            (0, $f556b19a33951931$export$c916c075a7028158).EOD
        ],
        poetryStart
    ];
    const guard = bufp.makeWhileGuard(`footnoteParselet()`);
    while(guard() && !bufp.peekTokensAnyOf(...stops)){
        const para = new (0, $86b9a01d2c8c01db$export$2e2bcd8739ae039)((0, $f556b19a33951931$export$845480b930b0e280).PARAGRAPH, footnote, {
            startToken: bufp.current
        });
        para.children = bufp.parseUntilAnyOf(para, ...stops);
        para.endToken = bufp.lastSignificantToken();
        footnote.children.push(para);
        bufp.consumeIf((0, $f556b19a33951931$export$c916c075a7028158).FOOTNOTE_PARAGRAPH_SPLIT);
        if (bufp.peekTokens((0, $f556b19a33951931$export$c916c075a7028158).EOL, (0, $f556b19a33951931$export$c916c075a7028158).FOOTNOTE_PARAGRAPH_SPLIT)) bufp.throwError(`illegal double footnote paragraph split`);
        if (bufp.peekTokens(...poetryStart)) {
            bufp.consume((0, $f556b19a33951931$export$c916c075a7028158).EOL);
            const fnPoetryParser = new (0, $6789c820aa5ac17a$export$2e2bcd8739ae039)(bufp);
            footnote.children.push(fnPoetryParser.parse(footnote));
            bufp.consumeIf((0, $f556b19a33951931$export$c916c075a7028158).FOOTNOTE_PARAGRAPH_SPLIT);
            if (bufp.peekTokens((0, $f556b19a33951931$export$c916c075a7028158).EOL, (0, $f556b19a33951931$export$c916c075a7028158).FOOTNOTE_PARAGRAPH_SPLIT)) bufp.throwError(`illegal double footnote paragraph split`);
        }
        bufp.consumeIf((0, $f556b19a33951931$export$c916c075a7028158).EOL);
    }
    footnote.endToken = parser.expectLookBehind(-1); // right bracket `]`
    if (!parser.tokenIs(footnote.endToken, (0, $f556b19a33951931$export$c916c075a7028158).RIGHT_BRACKET)) parser.throwError(`unexpected footnote ending token`);
    footnote.document().footnotes.children.push(footnote);
    return footnote;
};
var $c79e92f5cf61321d$export$2e2bcd8739ae039 = $c79e92f5cf61321d$var$footnoteParselet;




const $1daea20c486306e9$var$entity = (parser, parent)=>{
    const current = parser.current;
    const node = new (0, $86b9a01d2c8c01db$export$2e2bcd8739ae039)((0, $f556b19a33951931$export$845480b930b0e280).ENTITY, parent, {
        subType: $1daea20c486306e9$var$entityType(current.literal, parser),
        value: current.literal,
        startToken: current,
        endToken: current
    });
    $1daea20c486306e9$var$setEntityMeta(node);
    parser.consume();
    return node;
};
var $1daea20c486306e9$export$2e2bcd8739ae039 = $1daea20c486306e9$var$entity;
function $1daea20c486306e9$var$entityType(tokenLiteral, parser) {
    switch(tokenLiteral){
        case `&#8212;`:
        case `&mdash;`:
            return (0, $f556b19a33951931$export$fa20de1d199f87ac).EMDASH;
        case `&hellip;`:
            return (0, $f556b19a33951931$export$fa20de1d199f87ac).ELLIPSES;
        case `&`:
        /* fallthrough */ case `&amp;`:
            return (0, $f556b19a33951931$export$fa20de1d199f87ac).AMPERSAND;
        default:
            throw parser.throwError(`unknown entity type: ${tokenLiteral}`);
    }
}
function $1daea20c486306e9$var$setEntityMeta(node) {
    switch(node.meta.subType){
        case (0, $f556b19a33951931$export$fa20de1d199f87ac).EMDASH:
            node.setMetaData(`htmlEntity`, `&mdash;`);
            node.setMetaData(`decimalEntity`, `&#8212;`);
            break;
        case (0, $f556b19a33951931$export$fa20de1d199f87ac).ELLIPSES:
            node.setMetaData(`htmlEntity`, `&hellip;`);
            node.setMetaData(`decimalEntity`, `&#8230;`);
            break;
        case (0, $f556b19a33951931$export$fa20de1d199f87ac).AMPERSAND:
            node.setMetaData(`htmlEntity`, `&amp;`);
            node.setMetaData(`decimalEntity`, `&#38;`);
            break;
    }
}




const $a9426888a2401bb7$var$entity = (parser, parent)=>{
    const current = parser.current;
    const node = new (0, $86b9a01d2c8c01db$export$2e2bcd8739ae039)((0, $f556b19a33951931$export$845480b930b0e280).XREF, parent, {
        value: current.literal,
        startToken: current,
        endToken: current
    });
    parser.consume((0, $f556b19a33951931$export$c916c075a7028158).XREF_OPEN);
    const targetId = parser.consume((0, $f556b19a33951931$export$c916c075a7028158).TEXT).literal;
    const selfId = `${targetId}__xref_src`;
    node.setMetaData(`target`, targetId);
    if (parser.peekTokens(...$a9426888a2401bb7$var$BACKREF_TOKENS)) {
        node.setMetaData(`target`, selfId);
        parser.consumeMany(...$a9426888a2401bb7$var$BACKREF_TOKENS);
    }
    parser.consume((0, $f556b19a33951931$export$c916c075a7028158).COMMA);
    if (parser.peekTokens(...$a9426888a2401bb7$var$LINKABLE_BACK)) {
        node.setMetaData(`isLinkableBack`, true);
        parser.consumeMany(...$a9426888a2401bb7$var$LINKABLE_BACK);
    } else {
        node.document().idChapterLocations[selfId] = parser.parsingChapterNum;
        node.children = parser.parseUntil(node, (0, $f556b19a33951931$export$c916c075a7028158).XREF_CLOSE);
    }
    parser.consume((0, $f556b19a33951931$export$c916c075a7028158).XREF_CLOSE);
    return node;
};
var $a9426888a2401bb7$export$2e2bcd8739ae039 = $a9426888a2401bb7$var$entity;
const $a9426888a2401bb7$var$BACKREF_TOKENS = [
    [
        (0, $f556b19a33951931$export$c916c075a7028158).UNDERSCORE,
        `__`
    ],
    [
        (0, $f556b19a33951931$export$c916c075a7028158).TEXT,
        `xref`
    ],
    [
        (0, $f556b19a33951931$export$c916c075a7028158).UNDERSCORE,
        `_`
    ],
    [
        (0, $f556b19a33951931$export$c916c075a7028158).TEXT,
        `src`
    ]
];
const $a9426888a2401bb7$var$LINKABLE_BACK = [
    // the asciidoc source string `?LINKABLE-BACK` is a sentinal magic string
    // meaning "a link back to the xref source (in targets that support linking)"
    (0, $f556b19a33951931$export$c916c075a7028158).QUESTION_MARK,
    [
        (0, $f556b19a33951931$export$c916c075a7028158).TEXT,
        `LINKABLE-BACK`
    ]
];


function $e5222345832214f6$export$2e2bcd8739ae039(token, parser) {
    switch(token.type){
        case (0, $f556b19a33951931$export$c916c075a7028158).COMMA:
        case (0, $f556b19a33951931$export$c916c075a7028158).TEXT:
        case (0, $f556b19a33951931$export$c916c075a7028158).EOL:
        case (0, $f556b19a33951931$export$c916c075a7028158).DOT:
        case (0, $f556b19a33951931$export$c916c075a7028158).QUESTION_MARK:
        case (0, $f556b19a33951931$export$c916c075a7028158).EXCLAMATION_MARK:
        case (0, $f556b19a33951931$export$c916c075a7028158).COLON:
        case (0, $f556b19a33951931$export$c916c075a7028158).SEMICOLON:
        case (0, $f556b19a33951931$export$c916c075a7028158).WHITESPACE:
        case (0, $f556b19a33951931$export$c916c075a7028158).LEFT_PARENS:
        case (0, $f556b19a33951931$export$c916c075a7028158).RIGHT_BRACKET:
        case (0, $f556b19a33951931$export$c916c075a7028158).RIGHT_PARENS:
            return 0, $e7e7aebf457370c7$export$2e2bcd8739ae039;
        case (0, $f556b19a33951931$export$c916c075a7028158).DOUBLE_ASTERISK:
            return 0, $7ce37a34024bb879$export$2e2bcd8739ae039;
        case (0, $f556b19a33951931$export$c916c075a7028158).CARET:
        case (0, $f556b19a33951931$export$c916c075a7028158).FOOTNOTE_PREFIX:
            return 0, $c79e92f5cf61321d$export$2e2bcd8739ae039;
        case (0, $f556b19a33951931$export$c916c075a7028158).DOUBLE_DASH:
        case (0, $f556b19a33951931$export$c916c075a7028158).LEFT_SINGLE_CURLY:
        case (0, $f556b19a33951931$export$c916c075a7028158).RIGHT_SINGLE_CURLY:
        case (0, $f556b19a33951931$export$c916c075a7028158).LEFT_DOUBLE_CURLY:
        case (0, $f556b19a33951931$export$c916c075a7028158).RIGHT_DOUBLE_CURLY:
        case (0, $f556b19a33951931$export$c916c075a7028158).DEGREE_SYMBOL:
        case (0, $f556b19a33951931$export$c916c075a7028158).POUND_SYMBOL:
        case (0, $f556b19a33951931$export$c916c075a7028158).DOLLAR_SYMBOL:
            return 0, $415a765061218442$export$2e2bcd8739ae039;
        case (0, $f556b19a33951931$export$c916c075a7028158).LEFT_BRACKET:
            return 0, $3c98ce3051974dd4$export$2e2bcd8739ae039;
        case (0, $f556b19a33951931$export$c916c075a7028158).TRIPLE_PLUS:
            if (token.column.start === 1 && parser.peek.literal === `[`) return 0, $e7e7aebf457370c7$export$2e2bcd8739ae039;
            return 0, $894c21048d391d64$export$2e2bcd8739ae039;
        case (0, $f556b19a33951931$export$c916c075a7028158).UNDERSCORE:
            return 0, $61db92ea5ad89434$export$2e2bcd8739ae039;
        case (0, $f556b19a33951931$export$c916c075a7028158).ENTITY:
            return 0, $1daea20c486306e9$export$2e2bcd8739ae039;
        case (0, $f556b19a33951931$export$c916c075a7028158).XREF_OPEN:
            return 0, $a9426888a2401bb7$export$2e2bcd8739ae039;
    }
    return null;
}










class $a585df9a4b9d8f1e$export$2e2bcd8739ae039 {
    p;
    constructor(p){
        this.p = p;
    }
    parse(parent) {
        const stanzas = [];
        const guard = this.p.makeWhileGuard(`PoetryParser.parse()`);
        while(guard() && !this.p.peekTokensAnyOf([
            [
                (0, $f556b19a33951931$export$c916c075a7028158).UNDERSCORE,
                `____`
            ]
        ], [
            (0, $f556b19a33951931$export$c916c075a7028158).EOF,
            (0, $f556b19a33951931$export$c916c075a7028158).EOD
        ])){
            const stanza = new (0, $86b9a01d2c8c01db$export$2e2bcd8739ae039)((0, $f556b19a33951931$export$845480b930b0e280).VERSE_STANZA, parent, {
                startToken: this.p.current
            });
            stanza.children = this.parseLines(stanza);
            parent.children.push(stanza);
            stanzas.push(stanza);
            stanza.endToken = this.p.lastSignificantToken();
            if (this.p.currentIs((0, $f556b19a33951931$export$c916c075a7028158).DOUBLE_EOL)) this.p.consume((0, $f556b19a33951931$export$c916c075a7028158).DOUBLE_EOL);
        }
        return stanzas;
    }
    parseLines(stanza) {
        const lines = [];
        const guard = this.p.makeWhileGuard(`PoetryParser.parseLines()`);
        while(guard() && !this.p.peekTokensAnyOf([
            (0, $f556b19a33951931$export$c916c075a7028158).DOUBLE_EOL
        ], [
            [
                (0, $f556b19a33951931$export$c916c075a7028158).UNDERSCORE,
                `____`
            ]
        ], [
            (0, $f556b19a33951931$export$c916c075a7028158).EOF
        ])){
            const line = new (0, $86b9a01d2c8c01db$export$2e2bcd8739ae039)((0, $f556b19a33951931$export$845480b930b0e280).VERSE_LINE, stanza, {
                startToken: this.p.current
            });
            this.parseLine(line);
            lines.push(line);
            line.endToken = this.p.lastSignificantToken();
        }
        return lines;
    }
    parseLine(line) {
        line.children = this.p.parseUntil(line, (0, $f556b19a33951931$export$c916c075a7028158).EOX);
        if (this.p.currentIs((0, $f556b19a33951931$export$c916c075a7028158).EOL)) this.p.consume((0, $f556b19a33951931$export$c916c075a7028158).EOL);
    }
}




class $9bf356c66bc80999$export$2e2bcd8739ae039 {
    p;
    constructor(p){
        this.p = p;
    }
    peekStart() {
        if (this.p.current.column.start !== 1) return false;
        const guard = this.p.makeWhileGuard(`DescriptionListParser.peekStart()`);
        let distance = 1;
        let current = this.p.lookAhead(distance);
        while(guard() && !this.p.tokenIs(current, (0, $f556b19a33951931$export$c916c075a7028158).EOX)){
            if (current.type === (0, $f556b19a33951931$export$c916c075a7028158).DOUBLE_COLON) return true;
            current = this.p.lookAhead(++distance);
        }
        return false;
    }
    parse(parent) {
        const list = new (0, $86b9a01d2c8c01db$export$2e2bcd8739ae039)((0, $f556b19a33951931$export$845480b930b0e280).DESCRIPTION_LIST, parent, {
            startToken: this.p.current
        });
        const guard = this.p.makeWhileGuard(`DescriptionListParser.parse()`);
        while(guard() && this.peekStart()){
            const item = new (0, $86b9a01d2c8c01db$export$2e2bcd8739ae039)((0, $f556b19a33951931$export$845480b930b0e280).DESCRIPTION_LIST_ITEM, list, {
                startToken: this.p.current
            });
            const term = new (0, $86b9a01d2c8c01db$export$2e2bcd8739ae039)((0, $f556b19a33951931$export$845480b930b0e280).DESCRIPTION_LIST_ITEM_TERM, item, {
                startToken: this.p.current
            });
            term.children = this.p.parseUntil(term, (0, $f556b19a33951931$export$c916c075a7028158).DOUBLE_COLON);
            term.endToken = this.p.lastSignificantToken();
            this.p.consume((0, $f556b19a33951931$export$c916c075a7028158).DOUBLE_COLON);
            if (this.p.currentIs((0, $f556b19a33951931$export$c916c075a7028158).EOL)) this.p.consume((0, $f556b19a33951931$export$c916c075a7028158).EOL);
            else this.p.consume((0, $f556b19a33951931$export$c916c075a7028158).WHITESPACE);
            const content = new (0, $86b9a01d2c8c01db$export$2e2bcd8739ae039)((0, $f556b19a33951931$export$845480b930b0e280).DESCRIPTION_LIST_ITEM_CONTENT, item, {
                startToken: this.p.current
            });
            content.children = this.p.parseUntilAnyOf(content, [
                (0, $f556b19a33951931$export$c916c075a7028158).DOUBLE_EOL
            ], [
                (0, $f556b19a33951931$export$c916c075a7028158).EOL,
                (0, $f556b19a33951931$export$c916c075a7028158).EOF
            ]);
            content.endToken = this.p.lastSignificantToken();
            item.children = [
                term,
                content
            ];
            list.children.push(item);
            item.endToken = this.p.lastSignificantToken();
            this.p.consume((0, $f556b19a33951931$export$c916c075a7028158).EOX);
        }
        list.endToken = this.p.lastSignificantToken();
        return list;
    }
}


class $f9757a24f1739d46$export$2e2bcd8739ae039 {
    p;
    constructor(p){
        this.p = p;
    }
    parse(parent) {
        const context = this.p.parseContext();
        const thematicBreak = this.parseThematicBreak(parent, context);
        if (thematicBreak) return thematicBreak;
        if (this.peekStartUnorderedList()) return this.parseUnorderedList(parent, context);
        if (this.peekStartPassthroughBlock()) return this.parsePassthroughBlock(parent);
        const descriptionList = this.parseDescriptionList(parent);
        if (descriptionList) return descriptionList;
        const block = this.makeBlock(parent, context);
        this.prepareCompoundBlock(block);
        if (block.meta?.subType === `paragraph`) {
            this.parseChild(block);
            this.consumeTrailingWhitespace();
            block.endToken = this.p.lastSignificantToken();
            return block;
        }
        const guard = this.p.makeWhileGuard(`BlockParser.parse()`);
        while(guard() && !this.p.peekTokensAnyOf([
            (0, $f556b19a33951931$export$c916c075a7028158).EOL,
            (0, $f556b19a33951931$export$c916c075a7028158).EOF
        ], [
            (0, $f556b19a33951931$export$c916c075a7028158).EOF,
            (0, $f556b19a33951931$export$c916c075a7028158).EOD
        ], [
            (0, $f556b19a33951931$export$c916c075a7028158).EOD
        ])){
            if (block.meta?.subType === `verse`) {
                const poetryParser = new (0, $a585df9a4b9d8f1e$export$2e2bcd8739ae039)(this.p);
                block.children = poetryParser.parse(block);
            } else if (this.peekStartInnerBlock()) {
                const restoreAfterSubBufferedParse = this.p;
                block.children.push(this.parse(block));
                this.p = restoreAfterSubBufferedParse;
            } else if (this.peekStartUnorderedList()) block.children.push(this.parseUnorderedList(block, this.p.parseContext()));
            else if (this.p.peekHeading()) block.children.push(this.p.parseHeading(block));
            else {
                this.parseChild(block);
                if (this.p.peekTokens((0, $f556b19a33951931$export$c916c075a7028158).DOUBLE_EOL)) this.p.consume((0, $f556b19a33951931$export$c916c075a7028158).DOUBLE_EOL);
            }
        }
        block.endToken = this.p.lastSignificantToken();
        return block;
    }
    parseDescriptionList(parent) {
        const descriptionListParser = new (0, $9bf356c66bc80999$export$2e2bcd8739ae039)(this.p);
        if (descriptionListParser.peekStart()) return descriptionListParser.parse(parent);
        return undefined;
    }
    parsePassthroughBlock(parent) {
        const block = new (0, $86b9a01d2c8c01db$export$2e2bcd8739ae039)((0, $f556b19a33951931$export$845480b930b0e280).BLOCK_PASSTHROUGH, parent, {
            startToken: this.p.current
        });
        this.p.consumeMany((0, $f556b19a33951931$export$c916c075a7028158).QUADRUPLE_PLUS, (0, $f556b19a33951931$export$c916c075a7028158).EOL);
        const guard = this.p.makeWhileGuard(`BlockParser.parsePassThroughBlock()`);
        while(guard() && this.p.currentIs((0, $f556b19a33951931$export$c916c075a7028158).RAW_PASSTHROUGH))block.value += this.p.consume().literal;
        block.endToken = this.p.current; // `++++`
        this.p.consumeMany((0, $f556b19a33951931$export$c916c075a7028158).QUADRUPLE_PLUS, (0, $f556b19a33951931$export$c916c075a7028158).EOX);
        return block;
    }
    peekStartUnorderedList() {
        if (this.p.current.column.start !== 1) return false;
        const [after1, after2] = this.p.firstTokensAfterOptionalContext();
        return after1.type === (0, $f556b19a33951931$export$c916c075a7028158).ASTERISK && after2.type === (0, $f556b19a33951931$export$c916c075a7028158).WHITESPACE;
    }
    parseUnorderedList(parent, context) {
        const list = new (0, $86b9a01d2c8c01db$export$2e2bcd8739ae039)((0, $f556b19a33951931$export$845480b930b0e280).UNORDERED_LIST, parent, {
            context: context,
            startToken: this.p.current
        });
        const guard = this.p.makeWhileGuard(`BlockParser.parseUnorderedList()`);
        while(guard() && !this.p.peekTokensAnyOf([
            (0, $f556b19a33951931$export$c916c075a7028158).DOUBLE_EOL
        ], [
            (0, $f556b19a33951931$export$c916c075a7028158).EOX,
            (0, $f556b19a33951931$export$c916c075a7028158).EOX
        ])){
            const item = new (0, $86b9a01d2c8c01db$export$2e2bcd8739ae039)((0, $f556b19a33951931$export$845480b930b0e280).LIST_ITEM, list);
            item.startToken = this.p.current;
            this.p.consumeMany((0, $f556b19a33951931$export$c916c075a7028158).ASTERISK, (0, $f556b19a33951931$export$c916c075a7028158).WHITESPACE);
            item.children = this.p.parseUntil(item, (0, $f556b19a33951931$export$c916c075a7028158).EOX);
            item.endToken = this.p.lastSignificantToken();
            list.children.push(item);
            if (this.p.currentIs((0, $f556b19a33951931$export$c916c075a7028158).EOL)) this.p.consume();
        }
        list.endToken = this.p.lastSignificantToken();
        this.p.consume((0, $f556b19a33951931$export$c916c075a7028158).EOX);
        return list;
    }
    parseThematicBreak(parent, context) {
        if (this.p.peekTokensAnyOf([
            (0, $f556b19a33951931$export$c916c075a7028158).THEMATIC_BREAK,
            (0, $f556b19a33951931$export$c916c075a7028158).EOL,
            (0, $f556b19a33951931$export$c916c075a7028158).EOX
        ], [
            (0, $f556b19a33951931$export$c916c075a7028158).THEMATIC_BREAK,
            (0, $f556b19a33951931$export$c916c075a7028158).DOUBLE_EOL
        ])) {
            if (!context) this.p.throwError(`thematic break missing context`);
            this.p.consume((0, $f556b19a33951931$export$c916c075a7028158).THEMATIC_BREAK);
            if (this.p.currentIs((0, $f556b19a33951931$export$c916c075a7028158).DOUBLE_EOL)) this.p.consume((0, $f556b19a33951931$export$c916c075a7028158).DOUBLE_EOL);
            else this.p.consumeMany((0, $f556b19a33951931$export$c916c075a7028158).EOL, (0, $f556b19a33951931$export$c916c075a7028158).EOX);
            return new (0, $86b9a01d2c8c01db$export$2e2bcd8739ae039)((0, $f556b19a33951931$export$845480b930b0e280).THEMATIC_BREAK, parent, {
                context: context,
                endToken: this.p.lastSignificantToken()
            });
        }
        return undefined;
    }
    parseChild(block) {
        const context = this.p.parseContext();
        const thematicBreak = this.parseThematicBreak(block, context);
        if (thematicBreak) {
            block.children.push(thematicBreak);
            return;
        }
        if (this.peekStartPassthroughBlock()) {
            block.children.push(this.parsePassthroughBlock(block));
            return;
        }
        const para = new (0, $86b9a01d2c8c01db$export$2e2bcd8739ae039)((0, $f556b19a33951931$export$845480b930b0e280).PARAGRAPH, block, {
            context: context,
            startToken: this.p.current
        });
        block.children.push(para);
        para.children = this.p.parseUntilAnyOf(para, [
            (0, $f556b19a33951931$export$c916c075a7028158).DOUBLE_EOL
        ], [
            (0, $f556b19a33951931$export$c916c075a7028158).EOL,
            (0, $f556b19a33951931$export$c916c075a7028158).EOF
        ], [
            (0, $f556b19a33951931$export$c916c075a7028158).EOF
        ]);
        para.endToken = this.p.lastSignificantToken();
    }
    consumeTrailingWhitespace() {
        if (this.p.currentIs((0, $f556b19a33951931$export$c916c075a7028158).DOUBLE_EOL)) this.p.consume((0, $f556b19a33951931$export$c916c075a7028158).DOUBLE_EOL);
        else if (this.p.peekTokens((0, $f556b19a33951931$export$c916c075a7028158).EOL, (0, $f556b19a33951931$export$c916c075a7028158).EOF)) this.p.consumeMany((0, $f556b19a33951931$export$c916c075a7028158).EOL, (0, $f556b19a33951931$export$c916c075a7028158).EOF);
    }
    prepareCompoundBlock(block) {
        if (block.meta?.subType === `quote`) {
            this.p.consumeMany($f9757a24f1739d46$var$QUAD_UNDERSCORE, (0, $f556b19a33951931$export$c916c075a7028158).EOX);
            this.p = this.p.getBufferedParser((p)=>p.peekTokens((0, $f556b19a33951931$export$c916c075a7028158).EOX, $f9757a24f1739d46$var$QUAD_UNDERSCORE, (0, $f556b19a33951931$export$c916c075a7028158).EOX), 3);
        } else if (block.meta?.subType === `verse`) {
            this.p.consumeMany($f9757a24f1739d46$var$QUAD_UNDERSCORE, (0, $f556b19a33951931$export$c916c075a7028158).EOL);
            this.p = this.p.getBufferedParser((p)=>p.peekTokens($f9757a24f1739d46$var$QUAD_UNDERSCORE, (0, $f556b19a33951931$export$c916c075a7028158).EOX), 2);
        } else if (this.p.peekTokens((0, $f556b19a33951931$export$c916c075a7028158).DOUBLE_DASH, (0, $f556b19a33951931$export$c916c075a7028158).DOUBLE_EOL)) {
            block.meta.subType = `open`;
            this.p.consumeMany((0, $f556b19a33951931$export$c916c075a7028158).DOUBLE_DASH, (0, $f556b19a33951931$export$c916c075a7028158).DOUBLE_EOL);
            this.p = this.p.getBufferedParser((p)=>p.peekTokens((0, $f556b19a33951931$export$c916c075a7028158).DOUBLE_EOL, (0, $f556b19a33951931$export$c916c075a7028158).DOUBLE_DASH, (0, $f556b19a33951931$export$c916c075a7028158).EOX), 3);
        } else if (this.p.peekTokensAnyOf([
            $f9757a24f1739d46$var$EXAMPLE,
            (0, $f556b19a33951931$export$c916c075a7028158).DOUBLE_EOL
        ])) {
            block.meta.subType = `example`;
            this.p.consumeMany($f9757a24f1739d46$var$EXAMPLE, (0, $f556b19a33951931$export$c916c075a7028158).DOUBLE_EOL);
            this.p = this.p.getBufferedParser((p)=>p.peekTokens((0, $f556b19a33951931$export$c916c075a7028158).DOUBLE_EOL, $f9757a24f1739d46$var$EXAMPLE, (0, $f556b19a33951931$export$c916c075a7028158).EOX), 3);
        }
    }
    peekStartInnerBlock() {
        const [token1, token2] = this.p.firstTokensAfterOptionalContext();
        if (this.p.tokenIs(token1, $f9757a24f1739d46$var$EXAMPLE) && this.p.tokenIs(token2, (0, $f556b19a33951931$export$c916c075a7028158).EOX)) return true;
        else if (this.p.tokenIs(token1, $f9757a24f1739d46$var$QUAD_UNDERSCORE) && this.p.tokenIs(token2, (0, $f556b19a33951931$export$c916c075a7028158).EOX)) return true;
        return false;
    }
    peekStartPassthroughBlock() {
        return this.p.peekTokens((0, $f556b19a33951931$export$c916c075a7028158).QUADRUPLE_PLUS, (0, $f556b19a33951931$export$c916c075a7028158).EOL);
    }
    makeBlock(parent, context) {
        const block = new (0, $86b9a01d2c8c01db$export$2e2bcd8739ae039)((0, $f556b19a33951931$export$845480b930b0e280).BLOCK, parent, {
            context: context,
            subType: `paragraph`,
            startToken: this.p.current
        });
        if (context?.type === `quote` || context?.type === `epigraph`) block.meta.subType = `quote`;
        else if (context?.type === `verse`) block.meta.subType = `verse`;
        return block;
    }
}
const $f9757a24f1739d46$var$EXAMPLE = [
    (0, $f556b19a33951931$export$c916c075a7028158).EQUALS,
    `====`
];
const $f9757a24f1739d46$var$QUAD_UNDERSCORE = [
    (0, $f556b19a33951931$export$c916c075a7028158).UNDERSCORE,
    `____`
];


class $4ef1e9612de3ba4d$export$2e2bcd8739ae039 {
    p;
    level;
    constructor(p, level){
        this.p = p;
        this.level = level;
    }
    parse(parent) {
        const context = this.p.parseContext();
        const section = new (0, $86b9a01d2c8c01db$export$2e2bcd8739ae039)((0, $f556b19a33951931$export$845480b930b0e280).SECTION, parent, {
            level: this.level,
            context: context,
            startToken: this.p.current
        });
        if (context?.id !== undefined) section.document().embeddableSections[context.id] = section;
        const level = this.p.current.literal.length;
        if (level !== this.level) this.p.throwError(`expected heading level ${this.level}, got ${level}`);
        const heading = this.p.parseHeading(section);
        section.children = [
            heading,
            ...this.parseBody(section)
        ];
        section.endToken = this.p.lastSignificantToken();
        return section;
    }
    parseBody(section) {
        const nodes = [];
        const guard = this.p.makeWhileGuard(`SectionParser.parseBody()`);
        while(guard() && !this.p.currentOneOf((0, $f556b19a33951931$export$c916c075a7028158).EOF, (0, $f556b19a33951931$export$c916c075a7028158).EOD)){
            this.p.assertLineStart();
            const [after1, after2] = this.p.firstTokensAfterOptionalContext();
            if (after1.type === (0, $f556b19a33951931$export$c916c075a7028158).EQUALS && after2.type === (0, $f556b19a33951931$export$c916c075a7028158).WHITESPACE) {
                const sectionLevel = after1.literal.length;
                // unless we're restarting with a new chapter, a difference greater than 1 is error
                if (sectionLevel !== 2 && Math.abs(this.level - sectionLevel) > 1) this.p.throwError(`unexpected heading level`);
                if (sectionLevel <= this.level) // got to another heading of the same level (or one less)
                // close this one up so the next can start
                return nodes;
                const sectionParser = new $4ef1e9612de3ba4d$export$2e2bcd8739ae039(this.p, this.level + 1);
                const subSection = sectionParser.parse(section);
                nodes.push(subSection);
            } else {
                const blockParser = new (0, $f9757a24f1739d46$export$2e2bcd8739ae039)(this.p);
                const block = blockParser.parse(section);
                nodes.push(block);
            }
        }
        return nodes;
    }
}


class $cdf0e540d17ae265$export$2e2bcd8739ae039 {
    p;
    constructor(p){
        this.p = p;
    }
    parse(parent) {
        const context = this.p.parseContext();
        const chapter = new (0, $86b9a01d2c8c01db$export$2e2bcd8739ae039)((0, $f556b19a33951931$export$845480b930b0e280).CHAPTER, parent, {
            context: context,
            startToken: this.p.current
        });
        if (!this.p.peekTokens([
            (0, $f556b19a33951931$export$c916c075a7028158).EQUALS,
            `==`
        ], (0, $f556b19a33951931$export$c916c075a7028158).WHITESPACE)) this.p.throwError(`unexpected missing chapter heading`);
        const heading = this.p.parseHeading(chapter);
        chapter.children = [
            heading,
            ...new (0, $4ef1e9612de3ba4d$export$2e2bcd8739ae039)(this.p, 2).parseBody(chapter)
        ];
        chapter.endToken = this.p.lastSignificantToken();
        if (this.p.peekTokens((0, $f556b19a33951931$export$c916c075a7028158).EOL, (0, $f556b19a33951931$export$c916c075a7028158).EOF)) // no more blocks in chapter, consume trailing newline
        this.p.consume((0, $f556b19a33951931$export$c916c075a7028158).EOL);
        return chapter;
    }
}





class $6b40de79f0e267c3$export$2e2bcd8739ae039 {
    p;
    context;
    constructor(p){
        this.p = p;
        this.context = new (0, $9681347b5b14fb6c$export$2e2bcd8739ae039)();
    }
    parse() {
        if (!this.p.currentIs((0, $f556b19a33951931$export$c916c075a7028158).LEFT_BRACKET) || this.p.current.column.start !== 1) return undefined;
        // reject lines starting with inline-context, like `[.book-title]#Apology# foo`
        if (this.isInlineContext()) return undefined;
        this.context.startToken = this.p.consume((0, $f556b19a33951931$export$c916c075a7028158).LEFT_BRACKET);
        this.parseShortTitle($6b40de79f0e267c3$var$DONT_REQUIRE);
        this.parseType();
        this.parseId();
        const guard = this.p.makeWhileGuard(`ContextParser.parse(<classes>)`, 10);
        while(guard() && this.p.currentIs((0, $f556b19a33951931$export$c916c075a7028158).DOT)){
            this.p.consume((0, $f556b19a33951931$export$c916c075a7028158).DOT);
            this.context.classList.push(this.parseIdentifier());
        }
        if (this.p.currentIs((0, $f556b19a33951931$export$c916c075a7028158).COMMA)) {
            this.p.consume((0, $f556b19a33951931$export$c916c075a7028158).COMMA);
            this.p.consume((0, $f556b19a33951931$export$c916c075a7028158).WHITESPACE);
            this.context.type === `quote` || this.context.type === `epigraph` ? this.parseQuoteMeta() : this.parseShortTitle($6b40de79f0e267c3$var$REQUIRE);
        }
        this.p.consume((0, $f556b19a33951931$export$c916c075a7028158).RIGHT_BRACKET);
        this.context.endToken = this.p.consume((0, $f556b19a33951931$export$c916c075a7028158).EOL);
        return this.context;
    }
    parseQuoteMeta() {
        if (this.p.currentOneOf((0, $f556b19a33951931$export$c916c075a7028158).TEXT, (0, $f556b19a33951931$export$c916c075a7028158).STRAIGHT_DOUBLE_QUOTE)) this.context.quoteAttribution = this.getAttributeTokens();
        this.p.consume((0, $f556b19a33951931$export$c916c075a7028158).COMMA);
        // if we see `]` here it means it's an empty attribution, e.g. `[quote, ,]
        if (this.p.currentIs((0, $f556b19a33951931$export$c916c075a7028158).RIGHT_BRACKET)) return;
        this.p.consume((0, $f556b19a33951931$export$c916c075a7028158).WHITESPACE);
        this.context.quoteSource = this.getAttributeTokens();
    }
    parseShortTitle(require = true) {
        if (!this.p.peekTokens([
            (0, $f556b19a33951931$export$c916c075a7028158).TEXT,
            `short`
        ], [
            (0, $f556b19a33951931$export$c916c075a7028158).EQUALS,
            `=`
        ], (0, $f556b19a33951931$export$c916c075a7028158).STRAIGHT_DOUBLE_QUOTE)) {
            if (require) this.p.throwError(`expected short title (e.g. short="<title>")`);
            return;
        }
        this.p.consume((0, $f556b19a33951931$export$c916c075a7028158).TEXT);
        this.p.consume((0, $f556b19a33951931$export$c916c075a7028158).EQUALS);
        this.context.shortTitle = this.getAttributeTokens();
    }
    getAttributeTokens() {
        const tokens = [];
        let stopTokenType = (0, $f556b19a33951931$export$c916c075a7028158).RIGHT_BRACKET;
        if (this.p.currentIs((0, $f556b19a33951931$export$c916c075a7028158).STRAIGHT_DOUBLE_QUOTE)) {
            stopTokenType = (0, $f556b19a33951931$export$c916c075a7028158).STRAIGHT_DOUBLE_QUOTE;
            this.p.consume((0, $f556b19a33951931$export$c916c075a7028158).STRAIGHT_DOUBLE_QUOTE);
        }
        const stop = [
            stopTokenType
        ];
        if (stopTokenType !== (0, $f556b19a33951931$export$c916c075a7028158).STRAIGHT_DOUBLE_QUOTE) stop.push((0, $f556b19a33951931$export$c916c075a7028158).COMMA);
        const guard = this.p.makeWhileGuard(`ContextParser.getAttributeTokens()`, 100);
        while(guard() && !this.p.currentOneOf(...stop)){
            // currently not supporting escaped double-quote: e.g. `[quote, , "Hello \"world\""]
            tokens.push(this.p.current);
            this.p.consume();
        }
        if (stopTokenType === (0, $f556b19a33951931$export$c916c075a7028158).STRAIGHT_DOUBLE_QUOTE) this.p.consume((0, $f556b19a33951931$export$c916c075a7028158).STRAIGHT_DOUBLE_QUOTE);
        return tokens;
    }
    parseId() {
        if (!this.p.currentIs((0, $f556b19a33951931$export$c916c075a7028158).HASH)) return;
        this.p.consume((0, $f556b19a33951931$export$c916c075a7028158).HASH);
        this.context.id = this.parseIdentifier();
        this.p.document.idChapterLocations[this.context.id] = this.p.parsingChapterNum;
    }
    parseType() {
        if (!this.p.currentIs((0, $f556b19a33951931$export$c916c075a7028158).TEXT)) return;
        const literal = this.p.current.literal;
        this.p.consume((0, $f556b19a33951931$export$c916c075a7028158).TEXT);
        switch(literal){
            case `quote`:
                if (this.p.peekTokens((0, $f556b19a33951931$export$c916c075a7028158).DOT, [
                    (0, $f556b19a33951931$export$c916c075a7028158).TEXT,
                    `epigraph`
                ])) {
                    this.p.consume((0, $f556b19a33951931$export$c916c075a7028158).DOT);
                    this.p.consume((0, $f556b19a33951931$export$c916c075a7028158).TEXT);
                    this.context.type = `epigraph`;
                } else this.context.type = `quote`;
                return;
            case `discrete`:
                this.context.type = `discrete`;
                return;
            case `verse`:
                this.context.type = `verse`;
                return;
            default:
                this.p.throwError(`unexpected context type: ${literal}`);
        }
    }
    parseIdentifier() {
        let identifier = ``;
        const guard = this.p.makeWhileGuard(`ContextParser.parseIdentifier()`, 10);
        while(guard() && !this.p.currentOneOf((0, $f556b19a33951931$export$c916c075a7028158).DOT, (0, $f556b19a33951931$export$c916c075a7028158).WHITESPACE, (0, $f556b19a33951931$export$c916c075a7028158).RIGHT_BRACKET, (0, $f556b19a33951931$export$c916c075a7028158).COMMA)){
            identifier += this.p.current.literal;
            this.p.consume();
        }
        return identifier;
    }
    isInlineContext() {
        let distance = 1;
        let current = this.p.lookAhead(distance);
        const guard = this.p.makeWhileGuard(`ContextParser.isInlineContext()`);
        while(guard() && !this.p.tokenIs(current, (0, $f556b19a33951931$export$c916c075a7028158).RIGHT_BRACKET) && !this.p.tokenIs(current, (0, $f556b19a33951931$export$c916c075a7028158).EOX))current = this.p.lookAhead(++distance);
        return this.p.lookAhead(distance + 1).type === (0, $f556b19a33951931$export$c916c075a7028158).HASH;
    }
}
const $6b40de79f0e267c3$var$REQUIRE = true;
const $6b40de79f0e267c3$var$DONT_REQUIRE = false;



class $7fc52cf72ff87bc4$export$2e2bcd8739ae039 {
    _tokens;
    EOD;
    constructor(tokens){
        this._tokens = tokens;
        const last = this._tokens[this._tokens.length - 1];
        if (last?.type === (0, $f556b19a33951931$export$c916c075a7028158).EOF) this.pushEndToken(last, (0, $f556b19a33951931$export$c916c075a7028158).EOD);
        else if (last?.type !== (0, $f556b19a33951931$export$c916c075a7028158).EOD) {
            this.pushEndToken(last, (0, $f556b19a33951931$export$c916c075a7028158).EOF);
            this.pushEndToken(last, (0, $f556b19a33951931$export$c916c075a7028158).EOD);
        }
        const EOD = this._tokens[this._tokens.length - 1];
        if (!EOD) throw new Error(`Unexpected missing EOD token`);
        this.EOD = EOD;
    }
    tokens() {
        return this._tokens;
    }
    nextToken() {
        return this._tokens.shift() ?? this.EOD;
    }
    pushEndToken(last, type) {
        this._tokens.push({
            type: type,
            literal: ``,
            line: last?.line ?? 1,
            filename: last?.filename,
            column: last?.column ?? {
                start: 1,
                end: 1
            }
        });
    }
}





class $9a333cc5c0929b82$export$2e2bcd8739ae039 {
    p;
    constructor(p){
        this.p = p;
    }
    parse(parent) {
        const headingContext = this.p.parseContext();
        const heading = new (0, $86b9a01d2c8c01db$export$2e2bcd8739ae039)((0, $f556b19a33951931$export$845480b930b0e280).HEADING, parent, {
            level: this.p.current.literal.length,
            context: headingContext,
            startToken: this.p.current
        });
        this.p.consumeMany((0, $f556b19a33951931$export$c916c075a7028158).EQUALS, (0, $f556b19a33951931$export$c916c075a7028158).WHITESPACE);
        // only parse sequence identifiers for chapter-level (2) headings
        if (heading.meta.level === 2 && this.hasSequenceIdentifier()) this.parseSequenceIdentifier(heading);
        if (this.p.currentIs((0, $f556b19a33951931$export$c916c075a7028158).EOX)) {
            this.p.consume((0, $f556b19a33951931$export$c916c075a7028158).EOX);
            return heading;
        }
        const title = new (0, $86b9a01d2c8c01db$export$2e2bcd8739ae039)((0, $f556b19a33951931$export$845480b930b0e280).HEADING_TITLE, heading);
        title.startToken = this.p.current;
        heading.children.push(title);
        if (this.isSegmented()) this.parseSegmented(title);
        else title.children = this.p.parseUntil(heading, (0, $f556b19a33951931$export$c916c075a7028158).EOX);
        title.endToken = this.p.lastSignificantToken();
        heading.endToken = this.p.lastSignificantToken();
        this.p.consume((0, $f556b19a33951931$export$c916c075a7028158).EOX);
        return heading;
    }
    parseSequenceIdentifier(heading) {
        const node = new (0, $86b9a01d2c8c01db$export$2e2bcd8739ae039)((0, $f556b19a33951931$export$845480b930b0e280).HEADING_SEQUENCE_IDENTIFIER, heading);
        heading.children.push(node);
        node.startToken = this.p.consume((0, $f556b19a33951931$export$c916c075a7028158).TEXT);
        node.setMetaData(`kind`, node.startToken.literal);
        this.p.consume((0, $f556b19a33951931$export$c916c075a7028158).WHITESPACE);
        const numberToken = this.p.consume((0, $f556b19a33951931$export$c916c075a7028158).TEXT);
        node.endToken = numberToken;
        node.value = `${node.startToken.literal} ${numberToken.literal}`;
        if (this.p.currentOneOf((0, $f556b19a33951931$export$c916c075a7028158).DOT, (0, $f556b19a33951931$export$c916c075a7028158).COLON)) {
            node.endToken = this.p.current;
            node.value += this.p.consume().literal;
        }
        if (numberToken.literal.match(/^\d/)) node.setMetaData(`number`, Number(numberToken.literal));
        else node.setMetaData(`number`, (0, $18df0c6f364c9037$exports.toArabic)(numberToken.literal));
        node.setMetaData(`roman`, (0, $18df0c6f364c9037$exports.toRoman)(node.getMetaData(`number`)));
        if (this.p.currentIs([
            (0, $f556b19a33951931$export$c916c075a7028158).WHITESPACE,
            ` `
        ])) this.p.consume();
        heading.endToken = this.p.lastSignificantToken();
    }
    hasSequenceIdentifier() {
        if (!this.p.peekTokens((0, $f556b19a33951931$export$c916c075a7028158).TEXT, [
            (0, $f556b19a33951931$export$c916c075a7028158).WHITESPACE,
            ` `
        ], (0, $f556b19a33951931$export$c916c075a7028158).TEXT)) return false;
        if (!this.p.current.literal.match(/^(chapter|section|capítulo|sección|sermon)$/i)) return false;
        if (!this.p.lookAhead(2).literal.match(/^(([1-9]+[0-9]*)|([ivxlcdm]+))$/i)) return false;
        return true;
    }
    isSegmented() {
        const guard = this.p.makeWhileGuard(`HeadingParser.isOldStyle()`);
        let index = 0;
        let current = this.p.lookAhead(index++);
        while(guard() && !this.p.tokenIs(current, (0, $f556b19a33951931$export$c916c075a7028158).EOX)){
            if (current.type === (0, $f556b19a33951931$export$c916c075a7028158).FORWARD_SLASH) return true;
            current = this.p.lookAhead(index++);
        }
        return false;
    }
    parseSegmented(title) {
        const delim = [
            [
                (0, $f556b19a33951931$export$c916c075a7028158).WHITESPACE,
                ` `
            ],
            (0, $f556b19a33951931$export$c916c075a7028158).FORWARD_SLASH,
            [
                (0, $f556b19a33951931$export$c916c075a7028158).WHITESPACE,
                ` `
            ]
        ];
        const guard = this.p.makeWhileGuard(`HeadingParser.parseOldStyle()`);
        let level = 1;
        while(guard() && !this.p.peekTokensAnyOf(delim, [
            (0, $f556b19a33951931$export$c916c075a7028158).EOX
        ])){
            const segment = new (0, $86b9a01d2c8c01db$export$2e2bcd8739ae039)((0, $f556b19a33951931$export$845480b930b0e280).HEADING_SEGMENT, title, {
                level: level++,
                startToken: this.p.current
            });
            segment.children = this.p.parseUntilAnyOf(segment, delim, [
                (0, $f556b19a33951931$export$c916c075a7028158).EOX
            ]);
            segment.endToken = this.p.lastSignificantToken();
            title.children.push(segment);
            if (this.p.peekTokens(...delim)) this.p.consumeMany((0, $f556b19a33951931$export$c916c075a7028158).WHITESPACE, (0, $f556b19a33951931$export$c916c075a7028158).FORWARD_SLASH, (0, $f556b19a33951931$export$c916c075a7028158).WHITESPACE);
        }
    }
}



class $dae131b9c8b5ab8a$export$2e2bcd8739ae039 {
    inputs = [];
    inputIdx = -1;
    line = null;
    lines = [];
    lastToken;
    bufferedToken;
    passThruState;
    constructor(...inputs){
        this.inputs = inputs;
    }
    tokens() {
        let current = this.nextToken();
        const tokens = [
            current
        ];
        while(current.type !== (0, $f556b19a33951931$export$c916c075a7028158).EOD){
            current = this.nextToken();
            tokens.push(current);
        }
        return tokens;
    }
    nextToken() {
        if (this.lastToken?.type === (0, $f556b19a33951931$export$c916c075a7028158).EOD) return this.lastToken;
        let tok;
        if (this.bufferedToken) {
            tok = this.bufferedToken;
            this.bufferedToken = undefined;
            return tok;
        }
        const line = this.currentLine();
        if (!line) return this.makeToken((0, $f556b19a33951931$export$c916c075a7028158).EOD, null);
        if (this.passThruState === `inline`) return this.getInlinePassThru(line);
        else if (this.passThruState === `block`) return this.getBlockPassThru(line);
        const char = line.content[line.charIdx];
        if (char === undefined) {
            this.line = null;
            return this.nextToken();
        }
        switch(char){
            case `,`:
                return this.makeToken((0, $f556b19a33951931$export$c916c075a7028158).COMMA, line);
            case `?`:
                return this.makeToken((0, $f556b19a33951931$export$c916c075a7028158).QUESTION_MARK, line);
            case `;`:
                return this.makeToken((0, $f556b19a33951931$export$c916c075a7028158).SEMICOLON, line);
            case `!`:
                return this.makeToken((0, $f556b19a33951931$export$c916c075a7028158).EXCLAMATION_MARK, line);
            case `.`:
                return this.makeToken((0, $f556b19a33951931$export$c916c075a7028158).DOT, line);
            case `[`:
                return this.makeToken((0, $f556b19a33951931$export$c916c075a7028158).LEFT_BRACKET, line);
            case `]`:
                return this.makeToken((0, $f556b19a33951931$export$c916c075a7028158).RIGHT_BRACKET, line);
            case `(`:
                return this.makeToken((0, $f556b19a33951931$export$c916c075a7028158).LEFT_PARENS, line);
            case `)`:
                return this.makeToken((0, $f556b19a33951931$export$c916c075a7028158).RIGHT_PARENS, line);
            case `^`:
                return this.makeToken((0, $f556b19a33951931$export$c916c075a7028158).CARET, line);
            case `_`:
                return this.makeGreedyToken((0, $f556b19a33951931$export$c916c075a7028158).UNDERSCORE, line);
            case `|`:
                return this.makeToken((0, $f556b19a33951931$export$c916c075a7028158).PIPE, line);
            case ` `:
                return this.makeGreedyToken((0, $f556b19a33951931$export$c916c075a7028158).WHITESPACE, line);
            case `=`:
                return this.makeGreedyToken((0, $f556b19a33951931$export$c916c075a7028158).EQUALS, line);
            case `$`:
                return this.makeToken((0, $f556b19a33951931$export$c916c075a7028158).DOLLAR_SYMBOL, line);
            case `\xa3`:
                return this.makeToken((0, $f556b19a33951931$export$c916c075a7028158).POUND_SYMBOL, line);
            case `#`:
                return this.makeToken((0, $f556b19a33951931$export$c916c075a7028158).HASH, line);
            case `\xb0`:
                return this.makeToken((0, $f556b19a33951931$export$c916c075a7028158).DEGREE_SYMBOL, line);
            case `\n`:
                {
                    tok = this.makeToken((0, $f556b19a33951931$export$c916c075a7028158).EOL, line);
                    const nextLine = this.nextLine();
                    if (nextLine && nextLine.content === `\n`) {
                        tok.type = (0, $f556b19a33951931$export$c916c075a7028158).DOUBLE_EOL;
                        this.setLiteral(tok, `\n\n`, line);
                        this.nextLine();
                    }
                    return tok;
                }
            case `&`:
                {
                    const entityMatch = line.content.substring(line.charIdx).match(/^&#?[a-z0-9]+;/);
                    if (entityMatch !== null) {
                        tok = this.makeToken((0, $f556b19a33951931$export$c916c075a7028158).ENTITY, line);
                        this.setLiteral(tok, entityMatch[0] || ``, line);
                        return tok;
                    } else return this.makeToken((0, $f556b19a33951931$export$c916c075a7028158).ENTITY, line);
                }
            case `/`:
                if (line.charIdx === 0 && this.peekChar() === `/`) {
                    line.charIdx += line.content.length;
                    return this.nextToken();
                }
                return this.makeToken((0, $f556b19a33951931$export$c916c075a7028158).FORWARD_SLASH, line);
            case `>`:
                if (this.peekChar() === `>`) {
                    tok = this.makeGreedyToken((0, $f556b19a33951931$export$c916c075a7028158).XREF_CLOSE, line);
                    if (tok.literal.length !== 2) tok.type = (0, $f556b19a33951931$export$c916c075a7028158).ILLEGAL;
                    return tok;
                } else return this.makeToken((0, $f556b19a33951931$export$c916c075a7028158).ILLEGAL, line);
            case `<`:
                if (this.peekChar() === `<`) {
                    tok = this.makeGreedyToken((0, $f556b19a33951931$export$c916c075a7028158).XREF_OPEN, line);
                    if (tok.literal.length !== 2) tok.type = (0, $f556b19a33951931$export$c916c075a7028158).ILLEGAL;
                    return tok;
                } else return this.makeToken((0, $f556b19a33951931$export$c916c075a7028158).ILLEGAL, line);
            case `+`:
                if (this.peekChar() === `+`) {
                    tok = this.makeGreedyToken((0, $f556b19a33951931$export$c916c075a7028158).TRIPLE_PLUS, line);
                    if (tok.literal.length === 3) {
                        this.passThruState = `inline`;
                        return tok;
                    } else if (tok.literal.length === 4) {
                        tok.type = (0, $f556b19a33951931$export$c916c075a7028158).QUADRUPLE_PLUS;
                        this.passThruState = `block`;
                        return tok;
                    } else tok.type = (0, $f556b19a33951931$export$c916c075a7028158).ILLEGAL;
                    return tok;
                } else return this.makeToken((0, $f556b19a33951931$export$c916c075a7028158).PLUS, line);
            case `:`:
                tok = this.makeGreedyToken((0, $f556b19a33951931$export$c916c075a7028158).DOUBLE_COLON, line);
                if (tok.literal.length === 1) tok.type = (0, $f556b19a33951931$export$c916c075a7028158).COLON;
                else if (tok.literal.length !== 2) tok.type = (0, $f556b19a33951931$export$c916c075a7028158).ILLEGAL;
                return tok;
            case `{`:
                if (line.charIdx === 0 && line.content === `${$dae131b9c8b5ab8a$var$FOOTNOTE_PARA_SPLIT}\n`) {
                    tok = this.makeToken((0, $f556b19a33951931$export$c916c075a7028158).FOOTNOTE_PARAGRAPH_SPLIT, line);
                    return this.setLiteral(tok, $dae131b9c8b5ab8a$var$FOOTNOTE_PARA_SPLIT, line);
                }
                return this.makeToken((0, $f556b19a33951931$export$c916c075a7028158).ILLEGAL, line);
            case `*`:
                tok = this.makeGreedyToken((0, $f556b19a33951931$export$c916c075a7028158).ASTERISK, line);
                if (tok.literal.length === 3) tok.type = (0, $f556b19a33951931$export$c916c075a7028158).TRIPLE_ASTERISK;
                else if (tok.literal.length === 2) tok.type = (0, $f556b19a33951931$export$c916c075a7028158).DOUBLE_ASTERISK;
                else if (tok.literal.length !== 1) tok.type = (0, $f556b19a33951931$export$c916c075a7028158).ILLEGAL;
                return tok;
            case `-`:
                if (line.content.substring(line.charIdx) === `${$dae131b9c8b5ab8a$var$FOOTNOTE_STANZA}\n`) {
                    tok = this.makeToken((0, $f556b19a33951931$export$c916c075a7028158).FOOTNOTE_STANZA, line);
                    return this.setLiteral(tok, $dae131b9c8b5ab8a$var$FOOTNOTE_STANZA, line);
                }
                return this.makeGreedyToken((0, $f556b19a33951931$export$c916c075a7028158).DOUBLE_DASH, line, 2);
            case `\``:
                if (this.peekChar() === `"`) {
                    tok = this.makeToken((0, $f556b19a33951931$export$c916c075a7028158).RIGHT_DOUBLE_CURLY, line, false);
                    return this.requireAppendChar(tok, line);
                } else if (this.peekChar() === `'`) {
                    tok = this.makeToken((0, $f556b19a33951931$export$c916c075a7028158).RIGHT_SINGLE_CURLY, line, false);
                    return this.requireAppendChar(tok, line);
                } else return this.makeToken((0, $f556b19a33951931$export$c916c075a7028158).BACKTICK, line);
            case `'`:
                if (this.peekChar() === `\``) {
                    tok = this.makeToken((0, $f556b19a33951931$export$c916c075a7028158).LEFT_SINGLE_CURLY, line, false);
                    return this.requireAppendChar(tok, line);
                } else if (this.peekChar() === `'`) return this.makeGreedyToken((0, $f556b19a33951931$export$c916c075a7028158).THEMATIC_BREAK, line, 3);
                else return this.makeToken((0, $f556b19a33951931$export$c916c075a7028158).STRAIGHT_SINGLE_QUOTE, line);
            case `"`:
                if (this.peekChar() === `\``) {
                    tok = this.makeToken((0, $f556b19a33951931$export$c916c075a7028158).LEFT_DOUBLE_CURLY, line, false);
                    return this.requireAppendChar(tok, line);
                } else return this.makeToken((0, $f556b19a33951931$export$c916c075a7028158).STRAIGHT_DOUBLE_QUOTE, line);
            default:
                {
                    tok = this.makeToken((0, $f556b19a33951931$export$c916c075a7028158).TEXT, line, false);
                    while(!$dae131b9c8b5ab8a$var$isTextBoundaryChar(this.peekChar())){
                        const nextChar = this.requireNextChar();
                        tok.literal += nextChar;
                        tok.column.end += 1;
                    }
                    line.charIdx++;
                    const embedMatch = tok.literal.match(/(--|::)/);
                    if (embedMatch) {
                        const reverseChars = tok.literal.length - (embedMatch.index ?? 0);
                        tok.column.end -= reverseChars;
                        line.charIdx -= reverseChars;
                        tok.literal = tok.literal.substring(0, tok.literal.length - reverseChars);
                    }
                    if (tok.literal === `footnote` && this.currentChar() === `:`) {
                        tok.type = (0, $f556b19a33951931$export$c916c075a7028158).FOOTNOTE_PREFIX;
                        tok.literal += `:`;
                        line.charIdx++;
                    } else if (// first test just for perf
                    tok.literal[tok.literal.length - 1] === `e` && this.currentChar() === `:` && tok.literal.match(/footnote$/)) {
                        tok.literal = tok.literal.replace(/footnote$/, ``);
                        tok.column.end -= `footnote`.length;
                        line.charIdx -= `footnote`.length;
                    }
                    return tok;
                }
        }
    }
    requireAppendChar(tok, line) {
        tok.literal += this.requireNextChar();
        tok.column.end++;
        line.charIdx++;
        return tok;
    }
    requireNextChar() {
        const line = this.line;
        if (line === null) throw new Error(`Expected a next char`);
        line.charIdx += 1;
        const nextChar = line.content[line.charIdx];
        if (nextChar === undefined) throw new Error(`Expected a next char`);
        return nextChar;
    }
    makeToken(type, line, advanceChar = true) {
        let column = {
            start: 1,
            end: 1
        };
        if (line) column = {
            start: line.charIdx + 1,
            end: line.charIdx + 1
        };
        else if (this.lastToken) column = {
            start: this.lastToken.column.end,
            end: this.lastToken.column.end
        };
        const token = {
            type: type,
            literal: line?.content[line.charIdx] ?? ``,
            filename: line?.filename ?? this.lastToken?.filename,
            line: line?.number ?? this.lastToken?.line ?? 1,
            column: column
        };
        this.lastToken = token;
        if (advanceChar && line) line.charIdx++;
        return token;
    }
    makeGreedyToken(type, line, requiredLength) {
        const tok = this.makeToken(type, line, false);
        while(tok.literal[0] && this.peekChar() === tok.literal[0]){
            tok.literal += this.requireNextChar();
            tok.column.end++;
        }
        line.charIdx++;
        if (typeof requiredLength === `number` && tok.literal.length !== requiredLength) tok.type = (0, $f556b19a33951931$export$c916c075a7028158).ILLEGAL;
        return tok;
    }
    setLiteral(token, literal, line) {
        token.literal = literal;
        token.column.end += literal.length - 1;
        line.charIdx += literal.length - 1;
        return token;
    }
    currentChar() {
        const line = this.line;
        if (line === null) return null;
        return line.content[line.charIdx] ?? null;
    }
    peekChar() {
        const line = this.line;
        if (line === null) return null;
        return line.content[line.charIdx + 1] ?? null;
    }
    currentLine() {
        if (this.line === null) return this.nextLine();
        return this.line;
    }
    nextLine() {
        if (this.lines.length) {
            const line = this.lines.shift();
            this.line = line;
            return line;
        }
        // we reached the end of a file
        if (this.inputIdx > -1) this.bufferedToken = this.makeToken((0, $f556b19a33951931$export$c916c075a7028158).EOF, null);
        this.inputIdx++;
        const nextInput = this.inputs[this.inputIdx];
        if (this.inputIdx >= this.inputs.length || !nextInput) return null;
        this.lines = nextInput.adoc.split(/\n/g).map((line, lineIdx)=>({
                charIdx: 0,
                content: `${line}\n`,
                number: lineIdx + 1,
                filename: nextInput.filename
            }));
        if (nextInput.adoc.endsWith(`\n`)) // throw away false empty line created by splitting on `\n`
        this.lines.pop();
        return this.nextLine();
    }
    getBlockPassThru(line) {
        // first EOL after `++++`
        if (line.charIdx === 4 && line.content[line.charIdx] === `\n`) {
            const tk = this.makeToken((0, $f556b19a33951931$export$c916c075a7028158).EOL, line);
            this.nextLine();
            return tk;
        }
        if (line.content === `++++\n`) {
            this.passThruState = undefined;
            return this.makeGreedyToken((0, $f556b19a33951931$export$c916c075a7028158).QUADRUPLE_PLUS, line);
        }
        // make a raw passthrough line, keep returning lines until we exit passthrough
        const token = this.makeToken((0, $f556b19a33951931$export$c916c075a7028158).RAW_PASSTHROUGH, line);
        this.setLiteral(token, line.content, line);
        this.nextLine();
        return token;
    }
    getInlinePassThru(line) {
        const restOfLine = line.content.substring(line.charIdx);
        const token = this.makeToken((0, $f556b19a33951931$export$c916c075a7028158).RAW_PASSTHROUGH, line);
        this.setLiteral(token, restOfLine.replace(/\+\+\+.*\n/, ``), line);
        this.passThruState = undefined;
        this.bufferedToken = this.makeGreedyToken((0, $f556b19a33951931$export$c916c075a7028158).TRIPLE_PLUS, line);
        return token;
    }
}
function $dae131b9c8b5ab8a$var$isTextBoundaryChar(char) {
    if (char === null) return true;
    return $dae131b9c8b5ab8a$var$BOUNDARY_MAP[char] ?? false;
}
const $dae131b9c8b5ab8a$var$FOOTNOTE_PARA_SPLIT = `{footnote-paragraph-split}`;
const $dae131b9c8b5ab8a$var$FOOTNOTE_STANZA = `- - - - - -`;
const $dae131b9c8b5ab8a$var$BOUNDARY_MAP = {
    ' ': true,
    '\n': true,
    '.': true,
    ',': true,
    ']': true,
    '[': true,
    '^': true,
    '`': true,
    "'": true,
    _: true,
    '"': true,
    '+': true,
    $: true,
    "\xb0": true,
    '&': true,
    '#': true,
    '(': true,
    ')': true,
    '*': true,
    '=': true,
    '!': true,
    '?': true,
    ':': true,
    ';': true,
    '>': true,
    '<': true
};


var $371a3837fd81d701$exports = {};
// shim for using process in browser
var $371a3837fd81d701$var$process = $371a3837fd81d701$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $371a3837fd81d701$var$cachedSetTimeout;
var $371a3837fd81d701$var$cachedClearTimeout;
function $371a3837fd81d701$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $371a3837fd81d701$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $371a3837fd81d701$var$cachedSetTimeout = setTimeout;
        else $371a3837fd81d701$var$cachedSetTimeout = $371a3837fd81d701$var$defaultSetTimout;
    } catch (e) {
        $371a3837fd81d701$var$cachedSetTimeout = $371a3837fd81d701$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $371a3837fd81d701$var$cachedClearTimeout = clearTimeout;
        else $371a3837fd81d701$var$cachedClearTimeout = $371a3837fd81d701$var$defaultClearTimeout;
    } catch (e) {
        $371a3837fd81d701$var$cachedClearTimeout = $371a3837fd81d701$var$defaultClearTimeout;
    }
})();
function $371a3837fd81d701$var$runTimeout(fun) {
    if ($371a3837fd81d701$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($371a3837fd81d701$var$cachedSetTimeout === $371a3837fd81d701$var$defaultSetTimout || !$371a3837fd81d701$var$cachedSetTimeout) && setTimeout) {
        $371a3837fd81d701$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $371a3837fd81d701$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $371a3837fd81d701$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $371a3837fd81d701$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $371a3837fd81d701$var$runClearTimeout(marker) {
    if ($371a3837fd81d701$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($371a3837fd81d701$var$cachedClearTimeout === $371a3837fd81d701$var$defaultClearTimeout || !$371a3837fd81d701$var$cachedClearTimeout) && clearTimeout) {
        $371a3837fd81d701$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $371a3837fd81d701$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $371a3837fd81d701$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $371a3837fd81d701$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $371a3837fd81d701$var$queue = [];
var $371a3837fd81d701$var$draining = false;
var $371a3837fd81d701$var$currentQueue;
var $371a3837fd81d701$var$queueIndex = -1;
function $371a3837fd81d701$var$cleanUpNextTick() {
    if (!$371a3837fd81d701$var$draining || !$371a3837fd81d701$var$currentQueue) return;
    $371a3837fd81d701$var$draining = false;
    if ($371a3837fd81d701$var$currentQueue.length) $371a3837fd81d701$var$queue = $371a3837fd81d701$var$currentQueue.concat($371a3837fd81d701$var$queue);
    else $371a3837fd81d701$var$queueIndex = -1;
    if ($371a3837fd81d701$var$queue.length) $371a3837fd81d701$var$drainQueue();
}
function $371a3837fd81d701$var$drainQueue() {
    if ($371a3837fd81d701$var$draining) return;
    var timeout = $371a3837fd81d701$var$runTimeout($371a3837fd81d701$var$cleanUpNextTick);
    $371a3837fd81d701$var$draining = true;
    var len = $371a3837fd81d701$var$queue.length;
    while(len){
        $371a3837fd81d701$var$currentQueue = $371a3837fd81d701$var$queue;
        $371a3837fd81d701$var$queue = [];
        while(++$371a3837fd81d701$var$queueIndex < len)if ($371a3837fd81d701$var$currentQueue) $371a3837fd81d701$var$currentQueue[$371a3837fd81d701$var$queueIndex].run();
        $371a3837fd81d701$var$queueIndex = -1;
        len = $371a3837fd81d701$var$queue.length;
    }
    $371a3837fd81d701$var$currentQueue = null;
    $371a3837fd81d701$var$draining = false;
    $371a3837fd81d701$var$runClearTimeout(timeout);
}
$371a3837fd81d701$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $371a3837fd81d701$var$queue.push(new $371a3837fd81d701$var$Item(fun, args));
    if ($371a3837fd81d701$var$queue.length === 1 && !$371a3837fd81d701$var$draining) $371a3837fd81d701$var$runTimeout($371a3837fd81d701$var$drainQueue);
};
// v8 likes predictible objects
function $371a3837fd81d701$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$371a3837fd81d701$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$371a3837fd81d701$var$process.title = 'browser';
$371a3837fd81d701$var$process.browser = true;
$371a3837fd81d701$var$process.env = {};
$371a3837fd81d701$var$process.argv = [];
$371a3837fd81d701$var$process.version = ''; // empty string to avoid regexp issues
$371a3837fd81d701$var$process.versions = {};
function $371a3837fd81d701$var$noop() {}
$371a3837fd81d701$var$process.on = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.addListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.once = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.off = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.removeListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.removeAllListeners = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.emit = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.prependListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.prependOnceListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.listeners = function(name) {
    return [];
};
$371a3837fd81d701$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$371a3837fd81d701$var$process.cwd = function() {
    return '/';
};
$371a3837fd81d701$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$371a3837fd81d701$var$process.umask = function() {
    return 0;
};


class $7e6e5536f6256095$export$2e2bcd8739ae039 extends Error {
    line;
    location;
    token;
    constructor(message, line, location, token){
        super(message), this.line = line, this.location = location, this.token = token;
        this.name = `ParserError`;
    }
    get codeFrame() {
        const lineNum = String(this.token.line);
        const col = this.token.column;
        return [
            `Parse error: ${this.message}\nat ${this.location}`,
            `\n\n${$7e6e5536f6256095$var$c(`magenta`)}${lineNum.padStart(5, ` `)}${$7e6e5536f6256095$var$c(`reset`)}`,
            `${$7e6e5536f6256095$var$c(`gray`)}: ${this.line.trimEnd()}${$7e6e5536f6256095$var$c(`reset`)}\n`,
            `${` `.padStart(col.start + 6, ` `)}`,
            `${$7e6e5536f6256095$var$c(`red`)}${`^`.padStart(col.end - col.start + 1, `^`)}-- ERR!${$7e6e5536f6256095$var$c(`reset`)}\n`
        ].join(``);
    }
    get filename() {
        return this.token.filename ?? `[no-file]`;
    }
    get lineNumber() {
        return this.token.line;
    }
    /**
   * @deprecated Use columnStart and columnEnd instead
   */ get column() {
        return this.token.column.start;
    }
    get columnStart() {
        return this.token.column.start;
    }
    get columnEnd() {
        return this.token.column.end;
    }
}
function $7e6e5536f6256095$var$isBrowser() {
    try {
        return typeof window?.document !== `undefined`;
    } catch  {
        return false;
    }
}
function $7e6e5536f6256095$var$isCI() {
    try {
        return typeof $371a3837fd81d701$exports?.env?.CI !== `undefined`;
    } catch  {
        return false;
    }
}
function $7e6e5536f6256095$var$c(type) {
    if ($7e6e5536f6256095$var$isBrowser() || $7e6e5536f6256095$var$isCI()) return ``;
    switch(type){
        case `reset`:
            return `\x1b[0m`;
        case `magenta`:
            return `\x1b[35m`;
        case `gray`:
            return `\x1b[2m`;
        case `red`:
            return `\x1b[31m`;
    }
}



class $a8d03726b9ff868b$export$2e2bcd8739ae039 {
    lexer;
    static MAX_SHIFTED_TOKENS = 50;
    tokens;
    parsingChapterNum;
    document;
    stopStack;
    shifted;
    static parseDocument(...inputs) {
        const lexer = new (0, $dae131b9c8b5ab8a$export$2e2bcd8739ae039)(...inputs);
        const parser = new $a8d03726b9ff868b$export$2e2bcd8739ae039(lexer);
        return parser.parse();
    }
    constructor(lexer){
        this.lexer = lexer;
        this.tokens = [];
        this.parsingChapterNum = 1;
        this.document = new (0, $53a0ebb1c5fd63b9$export$2e2bcd8739ae039)();
        this.stopStack = [];
        this.shifted = [];
    }
    parse() {
        const document = new (0, $53a0ebb1c5fd63b9$export$2e2bcd8739ae039)();
        this.document = document;
        document.startToken = this.current;
        this.parseDocumentEpigraphs(document);
        this.parsingChapterNum = 1;
        const guard = this.makeWhileGuard(`Parser.parse()`);
        while(guard() && !this.currentIs((0, $f556b19a33951931$export$c916c075a7028158).EOD)){
            const chapterParser = new (0, $cdf0e540d17ae265$export$2e2bcd8739ae039)(this);
            document.children.push(chapterParser.parse(document));
            this.consumeIf((0, $f556b19a33951931$export$c916c075a7028158).EOF);
            this.parsingChapterNum++;
        }
        document.endToken = this.current;
        return document;
    }
    parseContext() {
        const contextParser = new (0, $6b40de79f0e267c3$export$2e2bcd8739ae039)(this);
        return contextParser.parse();
    }
    parseHeading(parent) {
        const headingParser = new (0, $9a333cc5c0929b82$export$2e2bcd8739ae039)(this);
        return headingParser.parse(parent);
    }
    parseUntil(parent, ...stopTokens) {
        return this.parseUntilAnyOf(parent, ...[
            stopTokens
        ]);
    }
    parseUntilAnyOf(parent, ...stopTokensGroups) {
        this.stopStack = stopTokensGroups.concat(this.stopStack);
        const nodes = [];
        const guard = this.makeWhileGuard(`Parser.parseUntilAnyOf()`);
        while(guard() && !this.stopTokensFound()){
            const parselet = (0, $e5222345832214f6$export$2e2bcd8739ae039)(this.current, this);
            if (parselet === null) this.throwError(`no parselet found for token type=${this.current.type}`);
            nodes.push(parselet(this, parent));
        }
        for(let i = 0; i < stopTokensGroups.length; i++)this.stopStack.shift();
        return nodes;
    }
    stopTokensFound() {
        for (const stopTokens of this.stopStack){
            if (this.peekTokens(...stopTokens)) return true;
        }
        return false;
    }
    currentOneOf(...types) {
        for (const type of types){
            if (this.current.type === type) return true;
        }
        return false;
    }
    get current() {
        return this.lookAhead(0);
    }
    get peek() {
        return this.lookAhead(1);
    }
    parseDocumentEpigraphs(document) {
        if (this.peekTokens((0, $f556b19a33951931$export$c916c075a7028158).LEFT_BRACKET, [
            (0, $f556b19a33951931$export$c916c075a7028158).TEXT,
            `quote`
        ], (0, $f556b19a33951931$export$c916c075a7028158).DOT, [
            (0, $f556b19a33951931$export$c916c075a7028158).TEXT,
            `epigraph`
        ])) {
            const blockParser = new (0, $f9757a24f1739d46$export$2e2bcd8739ae039)(this);
            const epigraph = blockParser.parse(document);
            document.epigraphs.children.push(epigraph);
            this.parseDocumentEpigraphs(document);
        }
    }
    currentIs(tokenSpec) {
        return this.tokenIs(this.current, tokenSpec);
    }
    peekIs(tokenSpec) {
        return this.tokenIs(this.peek, tokenSpec);
    }
    assertLineStart() {
        if (this.current.column.start !== 1) this.throwError(`line start assertion failed`);
    }
    firstTokensAfterOptionalContext() {
        if (!this.currentIs((0, $f556b19a33951931$export$c916c075a7028158).LEFT_BRACKET)) return [
            this.current,
            this.peek,
            this.lookAhead(2)
        ];
        let lookAheadIndex = 1;
        const guard = this.makeWhileGuard(`Parser.firstTokenAfterOptionalContext()`);
        while(guard()){
            const token = this.lookAhead(lookAheadIndex++);
            if (token.column.start === 1 || token.type === (0, $f556b19a33951931$export$c916c075a7028158).EOF || token.type === (0, $f556b19a33951931$export$c916c075a7028158).EOD) return [
                token,
                this.lookAhead(lookAheadIndex),
                this.lookAhead(lookAheadIndex + 1)
            ];
        }
        this.throwError(`error finding first token after optional context`);
    }
    getBufferedParser(shouldStop, numConsumeAfter) {
        const tokens = [];
        const guard = this.makeWhileGuard(`Parser.getBufferedParser()`);
        while(guard() && !shouldStop(this)){
            const token = this.consume();
            tokens.push(token);
            if (token.type === (0, $f556b19a33951931$export$c916c075a7028158).EOD && !shouldStop(this)) this.throwError(`failed to find ending tokens for buffered parser`);
        }
        for(let i = 0; i < numConsumeAfter; i++)this.consume();
        // ensure we end with EOL, like real files do, so consumers can be ignorant
        // that they are dealing with a buffered lexer instead of a real one
        const last = tokens.pop();
        if (last) {
            tokens.push(last);
            if (!this.tokenIs(last, (0, $f556b19a33951931$export$c916c075a7028158).EOX)) tokens.push({
                ...last,
                type: (0, $f556b19a33951931$export$c916c075a7028158).EOL,
                literal: `\n`
            });
        }
        const parser = new $a8d03726b9ff868b$export$2e2bcd8739ae039(new (0, $7fc52cf72ff87bc4$export$2e2bcd8739ae039)(tokens));
        parser.document = this.document;
        parser.parsingChapterNum = this.parsingChapterNum;
        return parser;
    }
    /**
   * Do the next n-tokens match the passed specs?
   */ peekTokens(...specs) {
        for(let i = 0; i < specs.length; i++){
            const spec = specs[i];
            if (spec === undefined) this.throwError(`Unexpected missing token in peekTokens()`);
            if (!this.tokenIs(this.lookAhead(i), spec)) return false;
        }
        return true;
    }
    /**
   * Do the next tokens match ANY of the possible arrays of specs?
   */ peekTokensAnyOf(...groups) {
        return groups.some((tokens)=>this.peekTokens(...tokens));
    }
    peekJoinedLiterals(numTokens) {
        let joined = ``;
        for(let i = 0; i < numTokens; i++)joined += this.lookAhead(i).literal;
        return joined;
    }
    peekHeading() {
        const [token1, token2] = this.firstTokensAfterOptionalContext();
        if (this.tokenIs(token1, (0, $f556b19a33951931$export$c916c075a7028158).EQUALS) && this.tokenIs(token2, (0, $f556b19a33951931$export$c916c075a7028158).WHITESPACE)) return token1.column.start === 1;
        return false;
    }
    tokenIs(token, spec) {
        const tokenTypeMatch = Array.isArray(spec) ? spec[0] : spec;
        let tokenTypes = [];
        if (tokenTypeMatch === `EOX`) tokenTypes = [
            (0, $f556b19a33951931$export$c916c075a7028158).EOL,
            (0, $f556b19a33951931$export$c916c075a7028158).DOUBLE_EOL,
            (0, $f556b19a33951931$export$c916c075a7028158).EOF,
            (0, $f556b19a33951931$export$c916c075a7028158).EOD
        ];
        else tokenTypes = [
            tokenTypeMatch
        ];
        if (!tokenTypes.includes(token.type)) return false;
        const tokenLiteral = Array.isArray(spec) ? spec[1] : null;
        if (tokenLiteral !== null && token.literal !== tokenLiteral) return false;
        return true;
    }
    consume(spec) {
        const token = this.lookAhead(0);
        if (spec && !this.tokenIs(token, spec)) this.throwError(`unexpected token ${this.logToken(token, ``)}, expected ${spec}`);
        this.shiftToken();
        return token;
    }
    shiftToken() {
        const shifted = this.tokens.shift();
        if (!shifted) return;
        if (this.shifted.length === $a8d03726b9ff868b$export$2e2bcd8739ae039.MAX_SHIFTED_TOKENS) this.shifted = this.shifted.slice(0, -1);
        this.shifted.unshift(shifted);
    }
    consumeMany(...specs) {
        return specs.map((spec)=>this.consume(spec));
    }
    consumeIf(spec) {
        if (this.currentIs(spec)) return this.consume();
        return undefined;
    }
    lookAhead(distance) {
        if (distance < 0) return this.expectLookBehind(distance);
        while(distance >= this.tokens.length)this.tokens.push(this.lexer.nextToken());
        const token = this.tokens[distance];
        if (!token) this.throwError(`unexpected missing token in Parser.lookAhead()`);
        return token;
    }
    lookBehind(distance) {
        if (distance === 0) // 0 always refers to current token
        return this.lookAhead(0);
        return this.shifted[Math.abs(distance) - 1];
    }
    expectLookBehind(distance) {
        if (distance >= 0) return this.lookAhead(distance);
        const token = this.lookBehind(distance);
        if (!token) this.throwError(`unexpected missing token in Parser.expectLookBehind()`);
        return token;
    }
    lastSignificantToken() {
        let index = -1;
        let token = this.current;
        const guard = this.makeWhileGuard(`Parser.lastSignificantToken()`);
        while(guard() && (this.tokenIs(token, (0, $f556b19a33951931$export$c916c075a7028158).EOX) || this.tokenIs(token, (0, $f556b19a33951931$export$c916c075a7028158).FOOTNOTE_PARAGRAPH_SPLIT)))token = this.expectLookBehind(index--);
        return token;
    }
    consumeClose(tokenSpec, nodeType, open) {
        try {
            return this.consume(tokenSpec);
        } catch  {
            this.throwError(`Parse error: unclosed ${nodeType} node, opened at ${$a8d03726b9ff868b$var$location(open)}`);
        }
    }
    makeWhileGuard(identifier, max) {
        let maxIterations = this.isVitestTest() ? 20000 : 50000;
        if (typeof max === `number`) maxIterations = max;
        let numIterations = 0;
        return ()=>{
            numIterations++;
            if (numIterations >= maxIterations) {
                // eslint-disable-next-line no-console
                console.trace();
                this.throwError(`Infinite loop detected in ${identifier}`);
            }
            return true;
        };
    }
    isVitestTest() {
        return typeof $371a3837fd81d701$exports?.env?.VITEST !== `undefined`;
    }
    throwError(msg) {
        let line = ``;
        const errorLine = this.current.line;
        let index = 0;
        let current = this.current;
        while(current && !this.tokenIs(current, (0, $f556b19a33951931$export$c916c075a7028158).EOX)){
            line += current.literal;
            current = this.lookAhead(++index);
        }
        index = 0;
        current = this.shifted[index++];
        while(current && current.line === errorLine){
            line = current.literal + line;
            current = this.shifted[index++];
        }
        throw new (0, $7e6e5536f6256095$export$2e2bcd8739ae039)(msg, line, $a8d03726b9ff868b$var$location(this.current), this.current);
    }
    log(msg = ``, distance = 3) {
        const logged = [];
        for(let i = 0; i < distance; i++)logged.push(this.logToken(this.lookAhead(i), `${i}`, msg));
        // eslint-disable-next-line no-console
        console.log(logged.join(`\n`));
    }
    logToken(token, label, msg) {
        let logStr = `${msg ? `(${msg}) ` : ``}${label ? `${label}: ` : ``}`;
        logStr += `{ type: ${token.type}, literal: ${this.printableLiteral(token.literal)} }`;
        return logStr;
    }
    printableLiteral(literal) {
        if (literal === `\n`) return `"\\n"`;
        else if (literal === `\n\n`) return `"\\n\\n"`;
        return `"${literal}"`;
    }
}
function $a8d03726b9ff868b$var$location(token) {
    let filename = token.filename ?? `[no-file]`;
    if ($371a3837fd81d701$exports?.cwd) filename = filename.replace(`${$371a3837fd81d701$exports.cwd()}/`, ``);
    return `${filename}:${token.line}:${token.column.start}`;
}




function $cd9944187d9cfa79$export$2e2bcd8739ae039(node, visitor, output, context, index = 0) {
    const data = {
        node: node,
        output: output,
        context: context,
        index: index
    };
    let methods;
    for (const type of $cd9944187d9cfa79$var$getTypes(node))methods = methods ?? visitor[type];
    if (methods?.dispatch) methods = methods.dispatch(data);
    methods?.enter ? methods.enter(data) : visitor.node?.enter?.(data);
    for(let i = 0; i < node.children.length; i++)$cd9944187d9cfa79$export$2e2bcd8739ae039(node.children[i], visitor, output, context, i);
    methods?.exit ? methods.exit(data) : visitor.node?.exit?.(data);
}
function $cd9944187d9cfa79$var$getTypes(node) {
    if (node.isDocument() || node.parentIsDocument()) return [
        $cd9944187d9cfa79$var$camelCase(node.type)
    ];
    const types = [];
    let current = node.parent;
    while(!current.parentIsDocument()){
        types.push($cd9944187d9cfa79$var$camelCase(`${node.type}_IN_${current.type}`));
        current = current.parent;
    }
    types.push($cd9944187d9cfa79$var$camelCase(node.type));
    return types;
}
function $cd9944187d9cfa79$var$camelCase(input) {
    return input.toLowerCase().replace(/_([a-z])/g, (_, letter)=>letter.toUpperCase());
}



var $681aff5b66429191$exports = {};
'use strict';
var $bb9f8b9756add972$exports = {};
'use strict';
$bb9f8b9756add972$exports = (string)=>{
    const match = string.match(/^[ \t]*(?=\S)/gm);
    if (!match) return 0;
    return match.reduce((r, a)=>Math.min(r, a.length), Infinity);
};


$681aff5b66429191$exports = (string)=>{
    const indent = $bb9f8b9756add972$exports(string);
    if (indent === 0) return string;
    const regex = new RegExp(`^[ \\t]{${indent}}`, 'gm');
    return string.replace(regex, '');
};







function $c52898537277664b$export$4a1118a9a33eb240(...adoc) {
    const parser = $c52898537277664b$export$d003a19ab753048(...$c52898537277664b$export$feadd5fc9f60071b(...adoc));
    return parser.parse();
}
function $c52898537277664b$export$feadd5fc9f60071b(...adocs) {
    return adocs.map((adoc)=>(0, (/*@__PURE__*/$parcel$interopDefault($681aff5b66429191$exports)))(adoc).trim() + `\n`);
}
function $c52898537277664b$export$d003a19ab753048(...adocs) {
    const lexer = new (0, $dae131b9c8b5ab8a$export$2e2bcd8739ae039)(...adocs.map((adoc)=>({
            adoc: adoc
        })));
    return new (0, $a8d03726b9ff868b$export$2e2bcd8739ae039)(lexer);
}
function $c52898537277664b$export$6329391af1e135c1() {
    return new (0, $86b9a01d2c8c01db$export$2e2bcd8739ae039)((0, $f556b19a33951931$export$845480b930b0e280).PARAGRAPH, $c52898537277664b$export$31125d4d32802c1d());
}
function $c52898537277664b$export$31125d4d32802c1d() {
    return new (0, $86b9a01d2c8c01db$export$2e2bcd8739ae039)((0, $f556b19a33951931$export$845480b930b0e280).CHAPTER, $c52898537277664b$export$11eb3b5ef9574821());
}
function $c52898537277664b$export$11eb3b5ef9574821() {
    return new (0, $53a0ebb1c5fd63b9$export$2e2bcd8739ae039)();
}
function $c52898537277664b$export$ea0af84ed2e77902() {
    return new (0, $86b9a01d2c8c01db$export$2e2bcd8739ae039)((0, $f556b19a33951931$export$845480b930b0e280).BLOCK, $c52898537277664b$export$31125d4d32802c1d());
}
function $c52898537277664b$export$cca58e4599c0e000(node) {
    try {
        node.startToken && node.endToken;
    } catch  {
        node.print();
        throw new Error(`Node missing tokens in assertAllNodesHaveTokens()`);
    }
    node.children.forEach((child)=>$c52898537277664b$export$cca58e4599c0e000(child));
}
function $c52898537277664b$export$b0c069098c809a90(token) {
    return {
        type: token.type,
        literal: token.literal
    };
}
const $c52898537277664b$export$971d5caa766a69d7 = {
    text: (value)=>{
        return {
            type: (0, $f556b19a33951931$export$845480b930b0e280).TEXT,
            value: value
        };
    },
    paragraph: (value, classList)=>{
        return {
            type: (0, $f556b19a33951931$export$845480b930b0e280).PARAGRAPH,
            children: [
                $c52898537277664b$export$971d5caa766a69d7.text(value)
            ],
            ...classList ? $c52898537277664b$export$971d5caa766a69d7.context(classList) : {}
        };
    },
    context: (classList = [])=>{
        return {
            context: {
                classList: classList
            }
        };
    },
    chapterHeading: (text)=>{
        return {
            type: (0, $f556b19a33951931$export$845480b930b0e280).HEADING,
            children: [
                {
                    type: (0, $f556b19a33951931$export$845480b930b0e280).HEADING_TITLE,
                    children: [
                        {
                            type: (0, $f556b19a33951931$export$845480b930b0e280).TEXT,
                            value: text
                        }
                    ]
                }
            ],
            meta: {
                level: 2
            }
        };
    }
};










const $3d8fed0c3db304a7$var$minusSearch = `calc(55vh - 50px)`;
const $3d8fed0c3db304a7$var$minusSearchLarge = `calc(30vh - 50px)`;
var $3d8fed0c3db304a7$export$2e2bcd8739ae039 = (0, $c47ddde344dbf90f$export$2e2bcd8739ae039).div`
  position: relative;
  z-index: 1;
  background: #555;
  width: 100%;
  height: ${(p)=>p.searching ? $3d8fed0c3db304a7$var$minusSearch : `100%`};

  @media (min-height: 1024px) {
    height: ${(p)=>p.searching ? $3d8fed0c3db304a7$var$minusSearchLarge : `100%`};
  }

  .ace_print-margin {
    background: rgba(255, 255, 255, 0.08) !important;
  }

  .ace_gutter-cell.ace_warning {
    color: #4c390c;
    background-color: #846a3b;
  }

  .ace_gutter {
    background: #282c34;
    color: #555 !important;
  }

  .ace_editor {
    background: #282c34;
    color: rgb(171, 178, 191);
    font-family: Menlo, Consolas, 'DejaVu Sans Mono', monospace;
    width: 100% !important;
    height: ${(p)=>p.searching ? $3d8fed0c3db304a7$var$minusSearch : `100%`} !important;

    .ace_active-line {
      background: #454545 !important;
    }

    .ace_selection {
      background: blue !important;
    }

    .search-result {
      position: absolute;
      z-index: 20;
      background: green !important;
      opacity: 0.75;
    }
  }

  /* all the ace_* classes below are semantically
     meaningless, I just plugged in random textmate_scope
     keywords when creating my custom asciidoc grammar */

  /* headers */
  .ace_punctuation {
    color: white;
    font-weight: 700;
  }

  /* inline quotes */
  .ace_meta.ace_selector {
    color: #d19a66;
    font-style: italic;
  }

  /* verse/quote brackets */
  .ace_meta.ace_require {
    color: #c678dd;
    font-style: italic;
  }

  /* innerds of verse/quote */
  .ace_invalid.ace_illegal {
    color: #61afef !important;
    font-style: italic;
    background: transparent;
  }

  .ace_quote {
    color: #c678dd;
    font-style: italic;
  }

  /* class bracket open/close [] */
  .ace_punctuation.ace_definition.ace_comment {
    color: white;
    font-weight: 700;
  }

  /* class bracket . and # */
  .ace_meta.ace_tag.string.ace_quoted {
    color: white;
    font-weight: 200;
    opacity: 0.8;
  }

  /* class bracket text */
  .ace_keyword.ace_control {
    color: rgba(171, 178, 191, 0.5);
  }

  /* list asterisk */
  .ace_meta.ace_function-call {
    color: #cc6b73;
  }

  /* footnote (footnote) */
  .ace_markup.ace_raw.ace_inline {
    color: #61afef;
  }

  /* footnote (:[) and comments */
  .ace_meta.ace_diff,
  .ace_comment.ace_block.ace_documentation {
    color: rgba(171, 178, 191, 0.5) !important;
  }

  /* footnote text */
  .ace_meta.ace_diff.ace_index {
    color: #98c379 !important;
  }

  /* quote header innerds */
  .ace_invalid {
    font-style: italic;
    color: rgba(171, 178, 191, 0.5) !important;
    background: transparent !important;
  }

  .ace_markup.ace_italic {
    font-style: italic;
    color: #c678dd;
  }

  /* definition list term */
  .ace_markup.ace_heading {
    color: white !important;
    font-size: 700 !important;
  }

  /* definition list colon */
  .ace_markup.ace_raw {
    color: #d19a66;
  }

  /* escape +++ */
  .ace_meta.ace_separator {
    color: #d19a66;
  }

  /* escaped +++[+++ */
  .ace_keyword.ace_other.ace_unit {
    color: #98c379 !important;
  }

  /* open block delimiter */
  .ace_markup.ace_bold {
    color: #61afef !important;
  }

  /* footnote caret ^ */
  .ace_markup.ace_inserted.punctuation {
    color: yellow;
  }

  /* hr ''' */
  .ace_meta.ace_diff.ace_header.ace_from-file {
    color: #61afef !important;
  }
`;


function $b64bb8ffc24fb7cb$export$7e16c19d4b655374(selection, firstLine, lastLine, range) {
    const { start: { column: startCol }, end: { column: endCol } } = range;
    const before = firstLine[startCol - 1] || ``;
    const after = lastLine[endCol] || ``;
    const symbol = $b64bb8ffc24fb7cb$var$dunder(before) || $b64bb8ffc24fb7cb$var$dunder(after) ? `__` : `_`;
    return `${symbol}${selection}${symbol}`;
}
function $b64bb8ffc24fb7cb$var$dunder(char) {
    return !!char.match(/[A-Z`^]/i);
}


function $ffcaa208e85016e8$export$1a527062cd0f7273(editor, editorProps) {
    const { githubUser: githubUser, increaseFontSize: increaseFontSize, decreaseFontSize: decreaseFontSize, toggleSidebarOpen: toggleSidebarOpen, undo: undo, redo: redo, find: find } = editorProps;
    const isJared = githubUser === `jaredh159`;
    if (!isJared) editor.commands.addCommand({
        name: `italicize`,
        bindKey: {
            mac: `Command-I`,
            win: `Ctrl-I`
        },
        exec: ()=>{
            const selected = editor.getSelectedText();
            const range = editor.getSelectionRange();
            const firstLine = editor.session.getLine(range.start.row);
            const lastLine = editor.session.getLine(range.end.row);
            const replacement = (0, $b64bb8ffc24fb7cb$export$7e16c19d4b655374)(selected, firstLine, lastLine, range);
            editor.session.replace(range, replacement);
        }
    });
    editor.commands.addCommand({
        name: `increaseFontSize`,
        bindKey: {
            mac: `Command-Up`,
            win: `Ctrl-Up`
        },
        exec: ()=>increaseFontSize()
    });
    editor.commands.addCommand({
        name: `decreaseFontSize`,
        bindKey: {
            mac: `Command-Down`,
            win: `Ctrl-Down`
        },
        exec: ()=>decreaseFontSize()
    });
    editor.commands.addCommand({
        name: `toggleSidebarOpen`,
        bindKey: {
            mac: `Command-Ctrl-7`,
            win: `Alt-Ctrl-7`
        },
        exec: ()=>toggleSidebarOpen()
    });
    editor.commands.addCommand({
        name: `find`,
        bindKey: {
            mac: `Command-F`,
            win: `Ctrl-F`
        },
        exec: ()=>find()
    });
    editor.commands.addCommand({
        name: `undo`,
        bindKey: {
            mac: `Command-Z`,
            win: `Ctrl-Z`
        },
        exec: ()=>undo()
    });
    editor.commands.addCommand({
        name: `redo`,
        bindKey: {
            mac: `Command-Shift-Z`,
            win: `Alt-Shift-Z`
        },
        exec: ()=>redo()
    });
    editor.commands.addCommand({
        name: `redo`,
        bindKey: {
            mac: `Command-S`,
            win: `Ctrl-S`
        },
        exec: ()=>{}
    });
    editor.commands.addCommand({
        name: `moveRight`,
        bindKey: {
            mac: `Command-l`,
            win: `Ctrl-l`
        },
        exec: ()=>{
            editor.navigateRight(1);
            return true;
        }
    });
    editor.commands.addCommand({
        name: `moveLeft`,
        bindKey: {
            mac: `Command-J`,
            win: `Ctrl-J`
        },
        exec: ()=>editor.navigateLeft(1)
    });
    editor.commands.addCommand({
        name: `moveWordRight`,
        bindKey: {
            mac: `Command-Alt-l`
        },
        exec: ()=>editor.navigateWordRight()
    });
    editor.commands.addCommand({
        name: `moveWordLeft`,
        bindKey: {
            mac: `Command-Alt-J`
        },
        exec: ()=>editor.navigateWordLeft()
    });
    editor.commands.addCommand({
        name: `endOfLine`,
        bindKey: {
            mac: `Command-Ctrl-l`
        },
        exec: ()=>editor.navigateLineEnd()
    });
    editor.commands.addCommand({
        name: `startOfLine`,
        bindKey: {
            mac: `Command-Ctrl-J`
        },
        exec: ()=>editor.navigateLineStart()
    });
    if (isJared) // non-jared gets "italicize"
    editor.commands.addCommand({
        name: `moveUp`,
        bindKey: {
            mac: `Command-I`,
            win: `Ctrl-I`
        },
        exec: ()=>editor.navigateUp(1)
    });
    editor.commands.addCommand({
        name: `moveDown`,
        bindKey: {
            mac: `Command-K`,
            win: `Ctrl-K`
        },
        exec: ()=>editor.navigateDown(1)
    });
    editor.commands.addCommand({
        name: `moveUp10`,
        bindKey: {
            mac: `Command-Ctrl-I`
        },
        exec: ()=>editor.navigateUp(10)
    });
    editor.commands.addCommand({
        name: `moveDown10`,
        bindKey: {
            mac: `Command-Ctrl-K`
        },
        exec: ()=>editor.navigateDown(10)
    });
}


/*
 * To try in Ace editor, copy and paste into the mode creator
 * here : http://ace.c9.io/tool/mode_creator.html
 */ // @ts-ignore
const $659ddf42cb0ad888$var$ace = window.ace;
$659ddf42cb0ad888$var$ace.define(`ace/mode/adoc_highlight_rules`, [
    `require`,
    `exports`,
    `ace/lib/oop`,
    `ace/mode/text`,
    `ace/mode/custom_highlight_rules`
], (acequire, exports)=>{
    const oop = acequire(`ace/lib/oop`);
    const { TextHighlightRules: TextHighlightRules } = acequire(`ace/mode/text_highlight_rules`);
    const AdocHighlightRules = function() {
        // @ts-ignore
        this.$rules = {
            start: [
                {
                    token: `punctuation`,
                    regex: `(^=+ .+$)`
                },
                {
                    token: `meta.function-call`,
                    regex: `(^\\* )`
                },
                {
                    token: `markup.bold`,
                    regex: `(^--$)`
                },
                {
                    token: `comment.block.documentation`,
                    regex: `(^//.+$)`
                },
                {
                    token: `meta.selector`,
                    regex: `(("|')\`.+?\`("|'))`
                },
                {
                    token: `markup.inserted punctuation`,
                    regex: `(\\^$)`
                },
                {
                    token: `markup.heading`,
                    regex: `(^.+(?=::$))`,
                    push: `main__1`
                },
                {
                    token: `markup.quote`,
                    regex: `(^____$)`,
                    push: `main__2`
                },
                {
                    token: `markup.italic`,
                    regex: `(__*.+?__*)`
                },
                {
                    token: `meta.diff.header.from-file`,
                    regex: `(^'''$)`
                },
                {
                    token: `markup.raw.inline`,
                    regex: `(footnote(?=:\\[))`,
                    push: `main__3`
                },
                {
                    token: `meta.require`,
                    regex: `(^\\[(?=(quote|verse)))`,
                    push: `main__5`
                },
                {
                    token: `meta.separator`,
                    regex: `(\\+\\+\\+)`,
                    push: `main__6`
                },
                {
                    token: `punctuation.definition.comment`,
                    regex: `(^\\[)`,
                    push: `main__7`
                },
                {
                    defaultToken: `text`
                }
            ],
            main__1: [
                {
                    token: `meta.diff.header.from-file`,
                    regex: `(^(?=.{0,1})(?:|))`,
                    next: `pop`
                },
                {
                    defaultToken: `markup.raw`
                }
            ],
            main__2: [
                {
                    token: `markup.quote`,
                    regex: `(^____$)`,
                    next: `pop`
                },
                {
                    defaultToken: `markup.quote`
                }
            ],
            main__3: [
                {
                    token: `meta.diff`,
                    regex: `(([^\\+]\\]|\\]$))`,
                    next: `pop`
                },
                {
                    token: `meta.separator`,
                    regex: `(\\+\\+\\+)`,
                    push: `main__4`
                },
                {
                    token: `meta.diff`,
                    regex: `(:\\[)`
                },
                {
                    token: `comment`,
                    regex: `(^{footnote-paragraph-split}$)`
                },
                {
                    token: `meta.diff.index`,
                    regex: `(([^\\]\\+]+)|(\\+(?!\\+\\+)))`
                },
                {
                    defaultToken: `text`
                }
            ],
            main__4: [
                {
                    token: `meta.separator`,
                    regex: `((\\+\\+\\+|$))`,
                    next: `pop`
                },
                {
                    defaultToken: `keyword.other.unit`
                }
            ],
            main__5: [
                {
                    token: `meta.require`,
                    regex: `(\\]$)`,
                    next: `pop`
                },
                {
                    token: `invalid.illegal`,
                    regex: `((quote|verse))`
                },
                {
                    token: `meta.property-name`,
                    regex: `(\\.|,)`
                },
                {
                    token: `invalid`,
                    regex: `([^\\],\\.]+)`
                },
                {
                    defaultToken: `text`
                }
            ],
            main__6: [
                {
                    token: `meta.separator`,
                    regex: `((\\+\\+\\+|$))`,
                    next: `pop`
                },
                {
                    defaultToken: `keyword.other.unit`
                }
            ],
            main__7: [
                {
                    token: `punctuation.definition.comment`,
                    regex: `(\\]$)`,
                    next: `pop`
                },
                {
                    token: `meta.tag string.quoted`,
                    regex: `(\\.|#)`
                },
                {
                    token: `keyword.control`,
                    regex: `(.)`
                },
                {
                    defaultToken: `text`
                }
            ]
        };
        // @ts-ignore
        this.normalizeRules();
    };
    /* ------------------------ END ------------------------------ */ oop.inherits(AdocHighlightRules, TextHighlightRules);
    exports.AdocHighlightRules = AdocHighlightRules;
});
$659ddf42cb0ad888$var$ace.define(`ace/mode/adoc`, [
    `require`,
    `exports`,
    `ace/lib/oop`,
    `ace/mode/text`,
    `ace/mode/adoc_highlight_rules`
], (acequire, exports)=>{
    const oop = acequire(`ace/lib/oop`);
    const TextMode = acequire(`ace/mode/text`).Mode;
    const AdocHighlightRules = acequire(`ace/mode/adoc_highlight_rules`).AdocHighlightRules;
    const Mode = function() {
        // @ts-ignore
        this.HighlightRules = AdocHighlightRules;
    };
    oop.inherits(Mode, TextMode); // ACE's way of doing inheritance
    (function() {
        // @ts-ignore
        this.$id = `ace/mode/adoc`;
    }).call(Mode.prototype);
    exports.Mode = Mode;
});


ace.define("ace/snippets", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/lib/event_emitter",
    "ace/lib/lang",
    "ace/range",
    "ace/anchor",
    "ace/keyboard/hash_handler",
    "ace/tokenizer",
    "ace/lib/dom",
    "ace/editor"
], function(acequire, exports, module) {
    "use strict";
    var oop = acequire("./lib/oop");
    var EventEmitter = acequire("./lib/event_emitter").EventEmitter;
    var lang = acequire("./lib/lang");
    var Range = acequire("./range").Range;
    var Anchor = acequire("./anchor").Anchor;
    var HashHandler = acequire("./keyboard/hash_handler").HashHandler;
    var Tokenizer = acequire("./tokenizer").Tokenizer;
    var comparePoints = Range.comparePoints;
    var SnippetManager = function() {
        this.snippetMap = {};
        this.snippetNameMap = {};
    };
    (function() {
        oop.implement(this, EventEmitter);
        this.getTokenizer = function() {
            function TabstopToken(str, _, stack) {
                str = str.substr(1);
                if (/^\d+$/.test(str) && !stack.inFormatString) return [
                    {
                        tabstopId: parseInt(str, 10)
                    }
                ];
                return [
                    {
                        text: str
                    }
                ];
            }
            function escape(ch) {
                return "(?:[^\\\\" + ch + "]|\\\\.)";
            }
            SnippetManager.$tokenizer = new Tokenizer({
                start: [
                    {
                        regex: /:/,
                        onMatch: function(val, state, stack) {
                            if (stack.length && stack[0].expectIf) {
                                stack[0].expectIf = false;
                                stack[0].elseBranch = stack[0];
                                return [
                                    stack[0]
                                ];
                            }
                            return ":";
                        }
                    },
                    {
                        regex: /\\./,
                        onMatch: function(val, state, stack) {
                            var ch = val[1];
                            if (ch == "}" && stack.length) val = ch;
                            else if ("`$\\".indexOf(ch) != -1) val = ch;
                            else if (stack.inFormatString) {
                                if (ch == "n") val = "\n";
                                else if (ch == "t") val = "\n";
                                else if ("ulULE".indexOf(ch) != -1) val = {
                                    changeCase: ch,
                                    local: ch > "a"
                                };
                            }
                            return [
                                val
                            ];
                        }
                    },
                    {
                        regex: /}/,
                        onMatch: function(val, state, stack) {
                            return [
                                stack.length ? stack.shift() : val
                            ];
                        }
                    },
                    {
                        regex: /\$(?:\d+|\w+)/,
                        onMatch: TabstopToken
                    },
                    {
                        regex: /\$\{[\dA-Z_a-z]+/,
                        onMatch: function(str, state, stack) {
                            var t = TabstopToken(str.substr(1), state, stack);
                            stack.unshift(t[0]);
                            return t;
                        },
                        next: "snippetVar"
                    },
                    {
                        regex: /\n/,
                        token: "newline",
                        merge: false
                    }
                ],
                snippetVar: [
                    {
                        regex: "\\|" + escape("\\|") + "*\\|",
                        onMatch: function(val, state, stack) {
                            stack[0].choices = val.slice(1, -1).split(",");
                        },
                        next: "start"
                    },
                    {
                        regex: "/(" + escape("/") + "+)/(?:(" + escape("/") + "*)/)(\\w*):?",
                        onMatch: function(val, state, stack) {
                            var ts = stack[0];
                            ts.fmtString = val;
                            val = this.splitRegex.exec(val);
                            ts.guard = val[1];
                            ts.fmt = val[2];
                            ts.flag = val[3];
                            return "";
                        },
                        next: "start"
                    },
                    {
                        regex: "`" + escape("`") + "*`",
                        onMatch: function(val, state, stack) {
                            stack[0].code = val.splice(1, -1);
                            return "";
                        },
                        next: "start"
                    },
                    {
                        regex: "\\?",
                        onMatch: function(val, state, stack) {
                            if (stack[0]) stack[0].expectIf = true;
                        },
                        next: "start"
                    },
                    {
                        regex: "([^:}\\\\]|\\\\.)*:?",
                        token: "",
                        next: "start"
                    }
                ],
                formatString: [
                    {
                        regex: "/(" + escape("/") + "+)/",
                        token: "regex"
                    },
                    {
                        regex: "",
                        onMatch: function(val, state, stack) {
                            stack.inFormatString = true;
                        },
                        next: "start"
                    }
                ]
            });
            SnippetManager.prototype.getTokenizer = function() {
                return SnippetManager.$tokenizer;
            };
            return SnippetManager.$tokenizer;
        };
        this.tokenizeTmSnippet = function(str, startState) {
            return this.getTokenizer().getLineTokens(str, startState).tokens.map(function(x) {
                return x.value || x;
            });
        };
        this.$getDefaultValue = function(editor, name) {
            if (/^[A-Z]\d+$/.test(name)) {
                var i = name.substr(1);
                return (this.variables[name[0] + "__"] || {})[i];
            }
            if (/^\d+$/.test(name)) return (this.variables.__ || {})[name];
            name = name.replace(/^TM_/, "");
            if (!editor) return;
            var s = editor.session;
            switch(name){
                case "CURRENT_WORD":
                    var r = s.getWordRange();
                case "SELECTION":
                case "SELECTED_TEXT":
                    return s.getTextRange(r);
                case "CURRENT_LINE":
                    return s.getLine(editor.getCursorPosition().row);
                case "PREV_LINE":
                    return s.getLine(editor.getCursorPosition().row - 1);
                case "LINE_INDEX":
                    return editor.getCursorPosition().column;
                case "LINE_NUMBER":
                    return editor.getCursorPosition().row + 1;
                case "SOFT_TABS":
                    return s.getUseSoftTabs() ? "YES" : "NO";
                case "TAB_SIZE":
                    return s.getTabSize();
                case "FILENAME":
                case "FILEPATH":
                    return "";
                case "FULLNAME":
                    return "Ace";
            }
        };
        this.variables = {};
        this.getVariableValue = function(editor, varName) {
            if (this.variables.hasOwnProperty(varName)) return this.variables[varName](editor, varName) || "";
            return this.$getDefaultValue(editor, varName) || "";
        };
        this.tmStrFormat = function(str, ch, editor) {
            var flag = ch.flag || "";
            var re = ch.guard;
            re = new RegExp(re, flag.replace(/[^gi]/, ""));
            var fmtTokens = this.tokenizeTmSnippet(ch.fmt, "formatString");
            var _self = this;
            var formatted = str.replace(re, function() {
                _self.variables.__ = arguments;
                var fmtParts = _self.resolveVariables(fmtTokens, editor);
                var gChangeCase = "E";
                for(var i = 0; i < fmtParts.length; i++){
                    var ch = fmtParts[i];
                    if (typeof ch == "object") {
                        fmtParts[i] = "";
                        if (ch.changeCase && ch.local) {
                            var next = fmtParts[i + 1];
                            if (next && typeof next == "string") {
                                if (ch.changeCase == "u") fmtParts[i] = next[0].toUpperCase();
                                else fmtParts[i] = next[0].toLowerCase();
                                fmtParts[i + 1] = next.substr(1);
                            }
                        } else if (ch.changeCase) gChangeCase = ch.changeCase;
                    } else if (gChangeCase == "U") fmtParts[i] = ch.toUpperCase();
                    else if (gChangeCase == "L") fmtParts[i] = ch.toLowerCase();
                }
                return fmtParts.join("");
            });
            this.variables.__ = null;
            return formatted;
        };
        this.resolveVariables = function(snippet, editor) {
            var result = [];
            for(var i = 0; i < snippet.length; i++){
                var ch = snippet[i];
                if (typeof ch == "string") result.push(ch);
                else if (typeof ch != "object") continue;
                else if (ch.skip) gotoNext(ch);
                else if (ch.processed < i) continue;
                else if (ch.text) {
                    var value = this.getVariableValue(editor, ch.text);
                    if (value && ch.fmtString) value = this.tmStrFormat(value, ch);
                    ch.processed = i;
                    if (ch.expectIf == null) {
                        if (value) {
                            result.push(value);
                            gotoNext(ch);
                        }
                    } else if (value) ch.skip = ch.elseBranch;
                    else gotoNext(ch);
                } else if (ch.tabstopId != null) result.push(ch);
                else if (ch.changeCase != null) result.push(ch);
            }
            function gotoNext(ch) {
                var i1 = snippet.indexOf(ch, i + 1);
                if (i1 != -1) i = i1;
            }
            return result;
        };
        this.insertSnippetForSelection = function(editor, snippetText) {
            var cursor = editor.getCursorPosition();
            var line = editor.session.getLine(cursor.row);
            var tabString = editor.session.getTabString();
            var indentString = line.match(/^\s*/)[0];
            if (cursor.column < indentString.length) indentString = indentString.slice(0, cursor.column);
            snippetText = snippetText.replace(/\r/g, "");
            var tokens = this.tokenizeTmSnippet(snippetText);
            tokens = this.resolveVariables(tokens, editor);
            tokens = tokens.map(function(x) {
                if (x == "\n") return x + indentString;
                if (typeof x == "string") return x.replace(/\t/g, tabString);
                return x;
            });
            var tabstops = [];
            tokens.forEach(function(p, i) {
                if (typeof p != "object") return;
                var id = p.tabstopId;
                var ts = tabstops[id];
                if (!ts) {
                    ts = tabstops[id] = [];
                    ts.index = id;
                    ts.value = "";
                }
                if (ts.indexOf(p) !== -1) return;
                ts.push(p);
                var i1 = tokens.indexOf(p, i + 1);
                if (i1 === -1) return;
                var value = tokens.slice(i + 1, i1);
                var isNested = value.some(function(t) {
                    return typeof t === "object";
                });
                if (isNested && !ts.value) ts.value = value;
                else if (value.length && (!ts.value || typeof ts.value !== "string")) ts.value = value.join("");
            });
            tabstops.forEach(function(ts) {
                ts.length = 0;
            });
            var expanding = {};
            function copyValue(val) {
                var copy = [];
                for(var i = 0; i < val.length; i++){
                    var p = val[i];
                    if (typeof p == "object") {
                        if (expanding[p.tabstopId]) continue;
                        var j = val.lastIndexOf(p, i - 1);
                        p = copy[j] || {
                            tabstopId: p.tabstopId
                        };
                    }
                    copy[i] = p;
                }
                return copy;
            }
            for(var i = 0; i < tokens.length; i++){
                var p = tokens[i];
                if (typeof p != "object") continue;
                var id = p.tabstopId;
                var i1 = tokens.indexOf(p, i + 1);
                if (expanding[id]) {
                    if (expanding[id] === p) expanding[id] = null;
                    continue;
                }
                var ts = tabstops[id];
                var arg = typeof ts.value == "string" ? [
                    ts.value
                ] : copyValue(ts.value);
                arg.unshift(i + 1, Math.max(0, i1 - i));
                arg.push(p);
                expanding[id] = p;
                tokens.splice.apply(tokens, arg);
                if (ts.indexOf(p) === -1) ts.push(p);
            }
            var row = 0, column = 0;
            var text = "";
            tokens.forEach(function(t) {
                if (typeof t === "string") {
                    var lines = t.split("\n");
                    if (lines.length > 1) {
                        column = lines[lines.length - 1].length;
                        row += lines.length - 1;
                    } else column += t.length;
                    text += t;
                } else if (!t.start) t.start = {
                    row: row,
                    column: column
                };
                else t.end = {
                    row: row,
                    column: column
                };
            });
            var range = editor.getSelectionRange();
            var end = editor.session.replace(range, text);
            var tabstopManager = new TabstopManager(editor);
            var selectionId = editor.inVirtualSelectionMode && editor.selection.index;
            tabstopManager.addTabstops(tabstops, range.start, end, selectionId);
        };
        this.insertSnippet = function(editor, snippetText) {
            var self = this;
            if (editor.inVirtualSelectionMode) return self.insertSnippetForSelection(editor, snippetText);
            editor.forEachSelection(function() {
                self.insertSnippetForSelection(editor, snippetText);
            }, null, {
                keepOrder: true
            });
            if (editor.tabstopManager) editor.tabstopManager.tabNext();
        };
        this.$getScope = function(editor) {
            var scope = editor.session.$mode.$id || "";
            scope = scope.split("/").pop();
            if (scope === "html" || scope === "php") {
                if (scope === "php" && !editor.session.$mode.inlinePhp) scope = "html";
                var c = editor.getCursorPosition();
                var state = editor.session.getState(c.row);
                if (typeof state === "object") state = state[0];
                if (state.substring) {
                    if (state.substring(0, 3) == "js-") scope = "javascript";
                    else if (state.substring(0, 4) == "css-") scope = "css";
                    else if (state.substring(0, 4) == "php-") scope = "php";
                }
            }
            return scope;
        };
        this.getActiveScopes = function(editor) {
            var scope = this.$getScope(editor);
            var scopes = [
                scope
            ];
            var snippetMap = this.snippetMap;
            if (snippetMap[scope] && snippetMap[scope].includeScopes) scopes.push.apply(scopes, snippetMap[scope].includeScopes);
            scopes.push("_");
            return scopes;
        };
        this.expandWithTab = function(editor, options) {
            var self = this;
            var result = editor.forEachSelection(function() {
                return self.expandSnippetForSelection(editor, options);
            }, null, {
                keepOrder: true
            });
            if (result && editor.tabstopManager) editor.tabstopManager.tabNext();
            return result;
        };
        this.expandSnippetForSelection = function(editor, options) {
            var cursor = editor.getCursorPosition();
            var line = editor.session.getLine(cursor.row);
            var before = line.substring(0, cursor.column);
            var after = line.substr(cursor.column);
            var snippetMap = this.snippetMap;
            var snippet;
            this.getActiveScopes(editor).some(function(scope) {
                var snippets = snippetMap[scope];
                if (snippets) snippet = this.findMatchingSnippet(snippets, before, after);
                return !!snippet;
            }, this);
            if (!snippet) return false;
            if (options && options.dryRun) return true;
            editor.session.doc.removeInLine(cursor.row, cursor.column - snippet.replaceBefore.length, cursor.column + snippet.replaceAfter.length);
            this.variables.M__ = snippet.matchBefore;
            this.variables.T__ = snippet.matchAfter;
            this.insertSnippetForSelection(editor, snippet.content);
            this.variables.M__ = this.variables.T__ = null;
            return true;
        };
        this.findMatchingSnippet = function(snippetList, before, after) {
            for(var i = snippetList.length; i--;){
                var s = snippetList[i];
                if (s.startRe && !s.startRe.test(before)) continue;
                if (s.endRe && !s.endRe.test(after)) continue;
                if (!s.startRe && !s.endRe) continue;
                s.matchBefore = s.startRe ? s.startRe.exec(before) : [
                    ""
                ];
                s.matchAfter = s.endRe ? s.endRe.exec(after) : [
                    ""
                ];
                s.replaceBefore = s.triggerRe ? s.triggerRe.exec(before)[0] : "";
                s.replaceAfter = s.endTriggerRe ? s.endTriggerRe.exec(after)[0] : "";
                return s;
            }
        };
        this.snippetMap = {};
        this.snippetNameMap = {};
        this.register = function(snippets, scope) {
            var snippetMap = this.snippetMap;
            var snippetNameMap = this.snippetNameMap;
            var self = this;
            if (!snippets) snippets = [];
            function wrapRegexp(src) {
                if (src && !/^\^?\(.*\)\$?$|^\\b$/.test(src)) src = "(?:" + src + ")";
                return src || "";
            }
            function guardedRegexp(re, guard, opening) {
                re = wrapRegexp(re);
                guard = wrapRegexp(guard);
                if (opening) {
                    re = guard + re;
                    if (re && re[re.length - 1] != "$") re = re + "$";
                } else {
                    re = re + guard;
                    if (re && re[0] != "^") re = "^" + re;
                }
                return new RegExp(re);
            }
            function addSnippet(s) {
                if (!s.scope) s.scope = scope || "_";
                scope = s.scope;
                if (!snippetMap[scope]) {
                    snippetMap[scope] = [];
                    snippetNameMap[scope] = {};
                }
                var map = snippetNameMap[scope];
                if (s.name) {
                    var old = map[s.name];
                    if (old) self.unregister(old);
                    map[s.name] = s;
                }
                snippetMap[scope].push(s);
                if (s.tabTrigger && !s.trigger) {
                    if (!s.guard && /^\w/.test(s.tabTrigger)) s.guard = "\\b";
                    s.trigger = lang.escapeRegExp(s.tabTrigger);
                }
                if (!s.trigger && !s.guard && !s.endTrigger && !s.endGuard) return;
                s.startRe = guardedRegexp(s.trigger, s.guard, true);
                s.triggerRe = new RegExp(s.trigger, "", true);
                s.endRe = guardedRegexp(s.endTrigger, s.endGuard, true);
                s.endTriggerRe = new RegExp(s.endTrigger, "", true);
            }
            if (snippets && snippets.content) addSnippet(snippets);
            else if (Array.isArray(snippets)) snippets.forEach(addSnippet);
            this._signal("registerSnippets", {
                scope: scope
            });
        };
        this.unregister = function(snippets, scope) {
            var snippetMap = this.snippetMap;
            var snippetNameMap = this.snippetNameMap;
            function removeSnippet(s) {
                var nameMap = snippetNameMap[s.scope || scope];
                if (nameMap && nameMap[s.name]) {
                    delete nameMap[s.name];
                    var map = snippetMap[s.scope || scope];
                    var i = map && map.indexOf(s);
                    if (i >= 0) map.splice(i, 1);
                }
            }
            if (snippets.content) removeSnippet(snippets);
            else if (Array.isArray(snippets)) snippets.forEach(removeSnippet);
        };
        this.parseSnippetFile = function(str) {
            str = str.replace(/\r/g, "");
            var list = [], snippet = {};
            var re = /^#.*|^({[\s\S]*})\s*$|^(\S+) (.*)$|^((?:\n*\t.*)+)/gm;
            var m;
            while(m = re.exec(str)){
                if (m[1]) try {
                    snippet = JSON.parse(m[1]);
                    list.push(snippet);
                } catch (e) {}
                if (m[4]) {
                    snippet.content = m[4].replace(/^\t/gm, "");
                    list.push(snippet);
                    snippet = {};
                } else {
                    var key = m[2], val = m[3];
                    if (key == "regex") {
                        var guardRe = /\/((?:[^\/\\]|\\.)*)|$/g;
                        snippet.guard = guardRe.exec(val)[1];
                        snippet.trigger = guardRe.exec(val)[1];
                        snippet.endTrigger = guardRe.exec(val)[1];
                        snippet.endGuard = guardRe.exec(val)[1];
                    } else if (key == "snippet") {
                        snippet.tabTrigger = val.match(/^\S*/)[0];
                        if (!snippet.name) snippet.name = val;
                    } else snippet[key] = val;
                }
            }
            return list;
        };
        this.getSnippetByName = function(name, editor) {
            var snippetMap = this.snippetNameMap;
            var snippet;
            this.getActiveScopes(editor).some(function(scope) {
                var snippets = snippetMap[scope];
                if (snippets) snippet = snippets[name];
                return !!snippet;
            }, this);
            return snippet;
        };
    }).call(SnippetManager.prototype);
    var TabstopManager = function(editor) {
        if (editor.tabstopManager) return editor.tabstopManager;
        editor.tabstopManager = this;
        this.$onChange = this.onChange.bind(this);
        this.$onChangeSelection = lang.delayedCall(this.onChangeSelection.bind(this)).schedule;
        this.$onChangeSession = this.onChangeSession.bind(this);
        this.$onAfterExec = this.onAfterExec.bind(this);
        this.attach(editor);
    };
    (function() {
        this.attach = function(editor) {
            this.index = 0;
            this.ranges = [];
            this.tabstops = [];
            this.$openTabstops = null;
            this.selectedTabstop = null;
            this.editor = editor;
            this.editor.on("change", this.$onChange);
            this.editor.on("changeSelection", this.$onChangeSelection);
            this.editor.on("changeSession", this.$onChangeSession);
            this.editor.commands.on("afterExec", this.$onAfterExec);
            this.editor.keyBinding.addKeyboardHandler(this.keyboardHandler);
        };
        this.detach = function() {
            this.tabstops.forEach(this.removeTabstopMarkers, this);
            this.ranges = null;
            this.tabstops = null;
            this.selectedTabstop = null;
            this.editor.removeListener("change", this.$onChange);
            this.editor.removeListener("changeSelection", this.$onChangeSelection);
            this.editor.removeListener("changeSession", this.$onChangeSession);
            this.editor.commands.removeListener("afterExec", this.$onAfterExec);
            this.editor.keyBinding.removeKeyboardHandler(this.keyboardHandler);
            this.editor.tabstopManager = null;
            this.editor = null;
        };
        this.onChange = function(delta) {
            var changeRange = delta;
            var isRemove = delta.action[0] == "r";
            var start = delta.start;
            var end = delta.end;
            var startRow = start.row;
            var endRow = end.row;
            var lineDif = endRow - startRow;
            var colDiff = end.column - start.column;
            if (isRemove) {
                lineDif = -lineDif;
                colDiff = -colDiff;
            }
            if (!this.$inChange && isRemove) {
                var ts = this.selectedTabstop;
                var changedOutside = ts && !ts.some(function(r) {
                    return comparePoints(r.start, start) <= 0 && comparePoints(r.end, end) >= 0;
                });
                if (changedOutside) return this.detach();
            }
            var ranges = this.ranges;
            for(var i = 0; i < ranges.length; i++){
                var r = ranges[i];
                if (r.end.row < start.row) continue;
                if (isRemove && comparePoints(start, r.start) < 0 && comparePoints(end, r.end) > 0) {
                    this.removeRange(r);
                    i--;
                    continue;
                }
                if (r.start.row == startRow && r.start.column > start.column) r.start.column += colDiff;
                if (r.end.row == startRow && r.end.column >= start.column) r.end.column += colDiff;
                if (r.start.row >= startRow) r.start.row += lineDif;
                if (r.end.row >= startRow) r.end.row += lineDif;
                if (comparePoints(r.start, r.end) > 0) this.removeRange(r);
            }
            if (!ranges.length) this.detach();
        };
        this.updateLinkedFields = function() {
            var ts = this.selectedTabstop;
            if (!ts || !ts.hasLinkedRanges) return;
            this.$inChange = true;
            var session = this.editor.session;
            var text = session.getTextRange(ts.firstNonLinked);
            for(var i = ts.length; i--;){
                var range = ts[i];
                if (!range.linked) continue;
                var fmt = exports.snippetManager.tmStrFormat(text, range.original);
                session.replace(range, fmt);
            }
            this.$inChange = false;
        };
        this.onAfterExec = function(e) {
            if (e.command && !e.command.readOnly) this.updateLinkedFields();
        };
        this.onChangeSelection = function() {
            if (!this.editor) return;
            var lead = this.editor.selection.lead;
            var anchor = this.editor.selection.anchor;
            var isEmpty = this.editor.selection.isEmpty();
            for(var i = this.ranges.length; i--;){
                if (this.ranges[i].linked) continue;
                var containsLead = this.ranges[i].contains(lead.row, lead.column);
                var containsAnchor = isEmpty || this.ranges[i].contains(anchor.row, anchor.column);
                if (containsLead && containsAnchor) return;
            }
            this.detach();
        };
        this.onChangeSession = function() {
            this.detach();
        };
        this.tabNext = function(dir) {
            var max = this.tabstops.length;
            var index = this.index + (dir || 1);
            index = Math.min(Math.max(index, 1), max);
            if (index == max) index = 0;
            this.selectTabstop(index);
            if (index === 0) this.detach();
        };
        this.selectTabstop = function(index) {
            this.$openTabstops = null;
            var ts = this.tabstops[this.index];
            if (ts) this.addTabstopMarkers(ts);
            this.index = index;
            ts = this.tabstops[this.index];
            if (!ts || !ts.length) return;
            this.selectedTabstop = ts;
            if (!this.editor.inVirtualSelectionMode) {
                var sel = this.editor.multiSelect;
                sel.toSingleRange(ts.firstNonLinked.clone());
                for(var i = ts.length; i--;){
                    if (ts.hasLinkedRanges && ts[i].linked) continue;
                    sel.addRange(ts[i].clone(), true);
                }
                if (sel.ranges[0]) sel.addRange(sel.ranges[0].clone());
            } else this.editor.selection.setRange(ts.firstNonLinked);
            this.editor.keyBinding.addKeyboardHandler(this.keyboardHandler);
        };
        this.addTabstops = function(tabstops, start, end) {
            if (!this.$openTabstops) this.$openTabstops = [];
            if (!tabstops[0]) {
                var p = Range.fromPoints(end, end);
                moveRelative(p.start, start);
                moveRelative(p.end, start);
                tabstops[0] = [
                    p
                ];
                tabstops[0].index = 0;
            }
            var i = this.index;
            var arg = [
                i + 1,
                0
            ];
            var ranges = this.ranges;
            tabstops.forEach(function(ts, index) {
                var dest = this.$openTabstops[index] || ts;
                for(var i = ts.length; i--;){
                    var p = ts[i];
                    var range = Range.fromPoints(p.start, p.end || p.start);
                    movePoint(range.start, start);
                    movePoint(range.end, start);
                    range.original = p;
                    range.tabstop = dest;
                    ranges.push(range);
                    if (dest != ts) dest.unshift(range);
                    else dest[i] = range;
                    if (p.fmtString) {
                        range.linked = true;
                        dest.hasLinkedRanges = true;
                    } else if (!dest.firstNonLinked) dest.firstNonLinked = range;
                }
                if (!dest.firstNonLinked) dest.hasLinkedRanges = false;
                if (dest === ts) {
                    arg.push(dest);
                    this.$openTabstops[index] = dest;
                }
                this.addTabstopMarkers(dest);
            }, this);
            if (arg.length > 2) {
                if (this.tabstops.length) arg.push(arg.splice(2, 1)[0]);
                this.tabstops.splice.apply(this.tabstops, arg);
            }
        };
        this.addTabstopMarkers = function(ts) {
            var session = this.editor.session;
            ts.forEach(function(range) {
                if (!range.markerId) range.markerId = session.addMarker(range, "ace_snippet-marker", "text");
            });
        };
        this.removeTabstopMarkers = function(ts) {
            var session = this.editor.session;
            ts.forEach(function(range) {
                session.removeMarker(range.markerId);
                range.markerId = null;
            });
        };
        this.removeRange = function(range) {
            var i = range.tabstop.indexOf(range);
            range.tabstop.splice(i, 1);
            i = this.ranges.indexOf(range);
            this.ranges.splice(i, 1);
            this.editor.session.removeMarker(range.markerId);
            if (!range.tabstop.length) {
                i = this.tabstops.indexOf(range.tabstop);
                if (i != -1) this.tabstops.splice(i, 1);
                if (!this.tabstops.length) this.detach();
            }
        };
        this.keyboardHandler = new HashHandler();
        this.keyboardHandler.bindKeys({
            "Tab": function(ed) {
                if (exports.snippetManager && exports.snippetManager.expandWithTab(ed)) return;
                ed.tabstopManager.tabNext(1);
            },
            "Shift-Tab": function(ed) {
                ed.tabstopManager.tabNext(-1);
            },
            "Esc": function(ed) {
                ed.tabstopManager.detach();
            },
            "Return": function(ed) {
                return false;
            }
        });
    }).call(TabstopManager.prototype);
    var changeTracker = {};
    changeTracker.onChange = Anchor.prototype.onChange;
    changeTracker.setPosition = function(row, column) {
        this.pos.row = row;
        this.pos.column = column;
    };
    changeTracker.update = function(pos, delta, $insertRight) {
        this.$insertRight = $insertRight;
        this.pos = pos;
        this.onChange(delta);
    };
    var movePoint = function(point, diff) {
        if (point.row == 0) point.column += diff.column;
        point.row += diff.row;
    };
    var moveRelative = function(point, start) {
        if (point.row == start.row) point.column -= start.column;
        point.row -= start.row;
    };
    acequire("./lib/dom").importCssString("\
.ace_snippet-marker {\
    -moz-box-sizing: border-box;\
    box-sizing: border-box;\
    background: rgba(194, 193, 208, 0.09);\
    border: 1px dotted rgba(211, 208, 235, 0.62);\
    position: absolute;\
}");
    exports.snippetManager = new SnippetManager();
    var Editor = acequire("./editor").Editor;
    (function() {
        this.insertSnippet = function(content, options) {
            return exports.snippetManager.insertSnippet(this, content, options);
        };
        this.expandSnippet = function(options) {
            return exports.snippetManager.expandWithTab(this, options);
        };
    }).call(Editor.prototype);
});
ace.define("ace/autocomplete/popup", [
    "require",
    "exports",
    "module",
    "ace/virtual_renderer",
    "ace/editor",
    "ace/range",
    "ace/lib/event",
    "ace/lib/lang",
    "ace/lib/dom"
], function(acequire, exports, module) {
    "use strict";
    var Renderer = acequire("../virtual_renderer").VirtualRenderer;
    var Editor = acequire("../editor").Editor;
    var Range = acequire("../range").Range;
    var event = acequire("../lib/event");
    var lang = acequire("../lib/lang");
    var dom = acequire("../lib/dom");
    var $singleLineEditor = function(el) {
        var renderer = new Renderer(el);
        renderer.$maxLines = 4;
        var editor = new Editor(renderer);
        editor.setHighlightActiveLine(false);
        editor.setShowPrintMargin(false);
        editor.renderer.setShowGutter(false);
        editor.renderer.setHighlightGutterLine(false);
        editor.$mouseHandler.$focusWaitTimout = 0;
        editor.$highlightTagPending = true;
        return editor;
    };
    var AcePopup = function(parentNode) {
        var el = dom.createElement("div");
        var popup = new $singleLineEditor(el);
        if (parentNode) parentNode.appendChild(el);
        el.style.display = "none";
        popup.renderer.content.style.cursor = "default";
        popup.renderer.setStyle("ace_autocomplete");
        popup.setOption("displayIndentGuides", false);
        popup.setOption("dragDelay", 150);
        var noop = function() {};
        popup.focus = noop;
        popup.$isFocused = true;
        popup.renderer.$cursorLayer.restartTimer = noop;
        popup.renderer.$cursorLayer.element.style.opacity = 0;
        popup.renderer.$maxLines = 8;
        popup.renderer.$keepTextAreaAtCursor = false;
        popup.setHighlightActiveLine(false);
        popup.session.highlight("");
        popup.session.$searchHighlight.clazz = "ace_highlight-marker";
        popup.on("mousedown", function(e) {
            var pos = e.getDocumentPosition();
            popup.selection.moveToPosition(pos);
            selectionMarker.start.row = selectionMarker.end.row = pos.row;
            e.stop();
        });
        var lastMouseEvent;
        var hoverMarker = new Range(-1, 0, -1, Infinity);
        var selectionMarker = new Range(-1, 0, -1, Infinity);
        selectionMarker.id = popup.session.addMarker(selectionMarker, "ace_active-line", "fullLine");
        popup.setSelectOnHover = function(val) {
            if (!val) hoverMarker.id = popup.session.addMarker(hoverMarker, "ace_line-hover", "fullLine");
            else if (hoverMarker.id) {
                popup.session.removeMarker(hoverMarker.id);
                hoverMarker.id = null;
            }
        };
        popup.setSelectOnHover(false);
        popup.on("mousemove", function(e) {
            if (!lastMouseEvent) {
                lastMouseEvent = e;
                return;
            }
            if (lastMouseEvent.x == e.x && lastMouseEvent.y == e.y) return;
            lastMouseEvent = e;
            lastMouseEvent.scrollTop = popup.renderer.scrollTop;
            var row = lastMouseEvent.getDocumentPosition().row;
            if (hoverMarker.start.row != row) {
                if (!hoverMarker.id) popup.setRow(row);
                setHoverMarker(row);
            }
        });
        popup.renderer.on("beforeRender", function() {
            if (lastMouseEvent && hoverMarker.start.row != -1) {
                lastMouseEvent.$pos = null;
                var row = lastMouseEvent.getDocumentPosition().row;
                if (!hoverMarker.id) popup.setRow(row);
                setHoverMarker(row, true);
            }
        });
        popup.renderer.on("afterRender", function() {
            var row = popup.getRow();
            var t = popup.renderer.$textLayer;
            var selected = t.element.childNodes[row - t.config.firstRow];
            if (selected == t.selectedNode) return;
            if (t.selectedNode) dom.removeCssClass(t.selectedNode, "ace_selected");
            t.selectedNode = selected;
            if (selected) dom.addCssClass(selected, "ace_selected");
        });
        var hideHoverMarker = function() {
            setHoverMarker(-1);
        };
        var setHoverMarker = function(row, suppressRedraw) {
            if (row !== hoverMarker.start.row) {
                hoverMarker.start.row = hoverMarker.end.row = row;
                if (!suppressRedraw) popup.session._emit("changeBackMarker");
                popup._emit("changeHoverMarker");
            }
        };
        popup.getHoveredRow = function() {
            return hoverMarker.start.row;
        };
        event.addListener(popup.container, "mouseout", hideHoverMarker);
        popup.on("hide", hideHoverMarker);
        popup.on("changeSelection", hideHoverMarker);
        popup.session.doc.getLength = function() {
            return popup.data.length;
        };
        popup.session.doc.getLine = function(i) {
            var data = popup.data[i];
            if (typeof data == "string") return data;
            return data && data.value || "";
        };
        var bgTokenizer = popup.session.bgTokenizer;
        bgTokenizer.$tokenizeRow = function(row) {
            var data = popup.data[row];
            var tokens = [];
            if (!data) return tokens;
            if (typeof data == "string") data = {
                value: data
            };
            if (!data.caption) data.caption = data.value || data.name;
            var last = -1;
            var flag, c;
            for(var i = 0; i < data.caption.length; i++){
                c = data.caption[i];
                flag = data.matchMask & 1 << i ? 1 : 0;
                if (last !== flag) {
                    tokens.push({
                        type: data.className || "" + (flag ? "completion-highlight" : ""),
                        value: c
                    });
                    last = flag;
                } else tokens[tokens.length - 1].value += c;
            }
            if (data.meta) {
                var maxW = popup.renderer.$size.scrollerWidth / popup.renderer.layerConfig.characterWidth;
                var metaData = data.meta;
                if (metaData.length + data.caption.length > maxW - 2) metaData = metaData.substr(0, maxW - data.caption.length - 3) + "\u2026";
                tokens.push({
                    type: "rightAlignedText",
                    value: metaData
                });
            }
            return tokens;
        };
        bgTokenizer.$updateOnChange = noop;
        bgTokenizer.start = noop;
        popup.session.$computeWidth = function() {
            return this.screenWidth = 0;
        };
        popup.$blockScrolling = Infinity;
        popup.isOpen = false;
        popup.isTopdown = false;
        popup.autoSelect = true;
        popup.data = [];
        popup.setData = function(list) {
            popup.setValue(lang.stringRepeat("\n", list.length), -1);
            popup.data = list || [];
            popup.setRow(0);
        };
        popup.getData = function(row) {
            return popup.data[row];
        };
        popup.getRow = function() {
            return selectionMarker.start.row;
        };
        popup.setRow = function(line) {
            line = Math.max(this.autoSelect ? 0 : -1, Math.min(this.data.length, line));
            if (selectionMarker.start.row != line) {
                popup.selection.clearSelection();
                selectionMarker.start.row = selectionMarker.end.row = line || 0;
                popup.session._emit("changeBackMarker");
                popup.moveCursorTo(line || 0, 0);
                if (popup.isOpen) popup._signal("select");
            }
        };
        popup.on("changeSelection", function() {
            if (popup.isOpen) popup.setRow(popup.selection.lead.row);
            popup.renderer.scrollCursorIntoView();
        });
        popup.hide = function() {
            this.container.style.display = "none";
            this._signal("hide");
            popup.isOpen = false;
        };
        popup.show = function(pos, lineHeight, topdownOnly) {
            var el = this.container;
            var screenHeight = window.innerHeight;
            var screenWidth = window.innerWidth;
            var renderer = this.renderer;
            var maxH = renderer.$maxLines * lineHeight * 1.4;
            var top = pos.top + this.$borderSize;
            var allowTopdown = top > screenHeight / 2 && !topdownOnly;
            if (allowTopdown && top + lineHeight + maxH > screenHeight) {
                renderer.$maxPixelHeight = top - 2 * this.$borderSize;
                el.style.top = "";
                el.style.bottom = screenHeight - top + "px";
                popup.isTopdown = false;
            } else {
                top += lineHeight;
                renderer.$maxPixelHeight = screenHeight - top - 0.2 * lineHeight;
                el.style.top = top + "px";
                el.style.bottom = "";
                popup.isTopdown = true;
            }
            el.style.display = "";
            this.renderer.$textLayer.checkForSizeChanges();
            var left = pos.left;
            if (left + el.offsetWidth > screenWidth) left = screenWidth - el.offsetWidth;
            el.style.left = left + "px";
            this._signal("show");
            lastMouseEvent = null;
            popup.isOpen = true;
        };
        popup.getTextLeftOffset = function() {
            return this.$borderSize + this.renderer.$padding + this.$imageSize;
        };
        popup.$imageSize = 0;
        popup.$borderSize = 1;
        return popup;
    };
    dom.importCssString("\
.ace_editor.ace_autocomplete .ace_marker-layer .ace_active-line {\
    background-color: #CAD6FA;\
    z-index: 1;\
}\
.ace_editor.ace_autocomplete .ace_line-hover {\
    border: 1px solid #abbffe;\
    margin-top: -1px;\
    background: rgba(233,233,253,0.4);\
}\
.ace_editor.ace_autocomplete .ace_line-hover {\
    position: absolute;\
    z-index: 2;\
}\
.ace_editor.ace_autocomplete .ace_scroller {\
   background: none;\
   border: none;\
   box-shadow: none;\
}\
.ace_rightAlignedText {\
    color: gray;\
    display: inline-block;\
    position: absolute;\
    right: 4px;\
    text-align: right;\
    z-index: -1;\
}\
.ace_editor.ace_autocomplete .ace_completion-highlight{\
    color: #000;\
    text-shadow: 0 0 0.01em;\
}\
.ace_editor.ace_autocomplete {\
    width: 280px;\
    z-index: 200000;\
    background: #fbfbfb;\
    color: #444;\
    border: 1px lightgray solid;\
    position: fixed;\
    box-shadow: 2px 3px 5px rgba(0,0,0,.2);\
    line-height: 1.4;\
}");
    exports.AcePopup = AcePopup;
});
ace.define("ace/autocomplete/util", [
    "require",
    "exports",
    "module"
], function(acequire, exports, module) {
    "use strict";
    exports.parForEach = function(array, fn, callback) {
        var completed = 0;
        var arLength = array.length;
        if (arLength === 0) callback();
        for(var i = 0; i < arLength; i++)fn(array[i], function(result, err) {
            completed++;
            if (completed === arLength) callback(result, err);
        });
    };
    var ID_REGEX = /[a-zA-Z_0-9\$\-\u00A2-\uFFFF]/;
    exports.retrievePrecedingIdentifier = function(text, pos, regex) {
        regex = regex || ID_REGEX;
        var buf = [];
        for(var i = pos - 1; i >= 0; i--){
            if (regex.test(text[i])) buf.push(text[i]);
            else break;
        }
        return buf.reverse().join("");
    };
    exports.retrieveFollowingIdentifier = function(text, pos, regex) {
        regex = regex || ID_REGEX;
        var buf = [];
        for(var i = pos; i < text.length; i++){
            if (regex.test(text[i])) buf.push(text[i]);
            else break;
        }
        return buf;
    };
    exports.getCompletionPrefix = function(editor) {
        var pos = editor.getCursorPosition();
        var line = editor.session.getLine(pos.row);
        var prefix;
        editor.completers.forEach((function(completer) {
            if (completer.identifierRegexps) completer.identifierRegexps.forEach((function(identifierRegex) {
                if (!prefix && identifierRegex) prefix = this.retrievePrecedingIdentifier(line, pos.column, identifierRegex);
            }).bind(this));
        }).bind(this));
        return prefix || this.retrievePrecedingIdentifier(line, pos.column);
    };
});
ace.define("ace/autocomplete", [
    "require",
    "exports",
    "module",
    "ace/keyboard/hash_handler",
    "ace/autocomplete/popup",
    "ace/autocomplete/util",
    "ace/lib/event",
    "ace/lib/lang",
    "ace/lib/dom",
    "ace/snippets"
], function(acequire, exports, module) {
    "use strict";
    var HashHandler = acequire("./keyboard/hash_handler").HashHandler;
    var AcePopup = acequire("./autocomplete/popup").AcePopup;
    var util = acequire("./autocomplete/util");
    var event = acequire("./lib/event");
    var lang = acequire("./lib/lang");
    var dom = acequire("./lib/dom");
    var snippetManager = acequire("./snippets").snippetManager;
    var Autocomplete = function() {
        this.autoInsert = false;
        this.autoSelect = true;
        this.exactMatch = false;
        this.gatherCompletionsId = 0;
        this.keyboardHandler = new HashHandler();
        this.keyboardHandler.bindKeys(this.commands);
        this.blurListener = this.blurListener.bind(this);
        this.changeListener = this.changeListener.bind(this);
        this.mousedownListener = this.mousedownListener.bind(this);
        this.mousewheelListener = this.mousewheelListener.bind(this);
        this.changeTimer = lang.delayedCall((function() {
            this.updateCompletions(true);
        }).bind(this));
        this.tooltipTimer = lang.delayedCall(this.updateDocTooltip.bind(this), 50);
    };
    (function() {
        this.$init = function() {
            this.popup = new AcePopup(document.body || document.documentElement);
            this.popup.on("click", (function(e) {
                this.insertMatch();
                e.stop();
            }).bind(this));
            this.popup.focus = this.editor.focus.bind(this.editor);
            this.popup.on("show", this.tooltipTimer.bind(null, null));
            this.popup.on("select", this.tooltipTimer.bind(null, null));
            this.popup.on("changeHoverMarker", this.tooltipTimer.bind(null, null));
            return this.popup;
        };
        this.getPopup = function() {
            return this.popup || this.$init();
        };
        this.openPopup = function(editor, prefix, keepPopupPosition) {
            if (!this.popup) this.$init();
            this.popup.autoSelect = this.autoSelect;
            this.popup.setData(this.completions.filtered);
            editor.keyBinding.addKeyboardHandler(this.keyboardHandler);
            var renderer = editor.renderer;
            this.popup.setRow(this.autoSelect ? 0 : -1);
            if (!keepPopupPosition) {
                this.popup.setTheme(editor.getTheme());
                this.popup.setFontSize(editor.getFontSize());
                var lineHeight = renderer.layerConfig.lineHeight;
                var pos = renderer.$cursorLayer.getPixelPosition(this.base, true);
                pos.left -= this.popup.getTextLeftOffset();
                var rect = editor.container.getBoundingClientRect();
                pos.top += rect.top - renderer.layerConfig.offset;
                pos.left += rect.left - editor.renderer.scrollLeft;
                pos.left += renderer.gutterWidth;
                this.popup.show(pos, lineHeight);
            } else if (keepPopupPosition && !prefix) this.detach();
        };
        this.detach = function() {
            this.editor.keyBinding.removeKeyboardHandler(this.keyboardHandler);
            this.editor.off("changeSelection", this.changeListener);
            this.editor.off("blur", this.blurListener);
            this.editor.off("mousedown", this.mousedownListener);
            this.editor.off("mousewheel", this.mousewheelListener);
            this.changeTimer.cancel();
            this.hideDocTooltip();
            this.gatherCompletionsId += 1;
            if (this.popup && this.popup.isOpen) this.popup.hide();
            if (this.base) this.base.detach();
            this.activated = false;
            this.completions = this.base = null;
        };
        this.changeListener = function(e) {
            var cursor = this.editor.selection.lead;
            if (cursor.row != this.base.row || cursor.column < this.base.column) this.detach();
            if (this.activated) this.changeTimer.schedule();
            else this.detach();
        };
        this.blurListener = function(e) {
            var el = document.activeElement;
            var text = this.editor.textInput.getElement();
            var fromTooltip = e.relatedTarget && this.tooltipNode && this.tooltipNode.contains(e.relatedTarget);
            var container = this.popup && this.popup.container;
            if (el != text && el.parentNode != container && !fromTooltip && el != this.tooltipNode && e.relatedTarget != text) this.detach();
        };
        this.mousedownListener = function(e) {
            this.detach();
        };
        this.mousewheelListener = function(e) {
            this.detach();
        };
        this.goTo = function(where) {
            var row = this.popup.getRow();
            var max = this.popup.session.getLength() - 1;
            switch(where){
                case "up":
                    row = row <= 0 ? max : row - 1;
                    break;
                case "down":
                    row = row >= max ? -1 : row + 1;
                    break;
                case "start":
                    row = 0;
                    break;
                case "end":
                    row = max;
                    break;
            }
            this.popup.setRow(row);
        };
        this.insertMatch = function(data, options) {
            if (!data) data = this.popup.getData(this.popup.getRow());
            if (!data) return false;
            if (data.completer && data.completer.insertMatch) data.completer.insertMatch(this.editor, data);
            else {
                if (this.completions.filterText) {
                    var ranges = this.editor.selection.getAllRanges();
                    for(var i = 0, range; range = ranges[i]; i++){
                        range.start.column -= this.completions.filterText.length;
                        this.editor.session.remove(range);
                    }
                }
                if (data.snippet) snippetManager.insertSnippet(this.editor, data.snippet);
                else this.editor.execCommand("insertstring", data.value || data);
            }
            this.detach();
        };
        this.commands = {
            "Up": function(editor) {
                editor.completer.goTo("up");
            },
            "Down": function(editor) {
                editor.completer.goTo("down");
            },
            "Ctrl-Up|Ctrl-Home": function(editor) {
                editor.completer.goTo("start");
            },
            "Ctrl-Down|Ctrl-End": function(editor) {
                editor.completer.goTo("end");
            },
            "Esc": function(editor) {
                editor.completer.detach();
            },
            "Return": function(editor) {
                return editor.completer.insertMatch();
            },
            "Shift-Return": function(editor) {
                editor.completer.insertMatch(null, {
                    deleteSuffix: true
                });
            },
            "Tab": function(editor) {
                var result = editor.completer.insertMatch();
                if (!result && !editor.tabstopManager) editor.completer.goTo("down");
                else return result;
            },
            "PageUp": function(editor) {
                editor.completer.popup.gotoPageUp();
            },
            "PageDown": function(editor) {
                editor.completer.popup.gotoPageDown();
            }
        };
        this.gatherCompletions = function(editor, callback) {
            var session = editor.getSession();
            var pos = editor.getCursorPosition();
            var prefix = util.getCompletionPrefix(editor);
            this.base = session.doc.createAnchor(pos.row, pos.column - prefix.length);
            this.base.$insertRight = true;
            var matches = [];
            var total = editor.completers.length;
            editor.completers.forEach(function(completer, i) {
                completer.getCompletions(editor, session, pos, prefix, function(err, results) {
                    if (!err && results) matches = matches.concat(results);
                    callback(null, {
                        prefix: util.getCompletionPrefix(editor),
                        matches: matches,
                        finished: --total === 0
                    });
                });
            });
            return true;
        };
        this.showPopup = function(editor) {
            if (this.editor) this.detach();
            this.activated = true;
            this.editor = editor;
            if (editor.completer != this) {
                if (editor.completer) editor.completer.detach();
                editor.completer = this;
            }
            editor.on("changeSelection", this.changeListener);
            editor.on("blur", this.blurListener);
            editor.on("mousedown", this.mousedownListener);
            editor.on("mousewheel", this.mousewheelListener);
            this.updateCompletions();
        };
        this.updateCompletions = function(keepPopupPosition) {
            if (keepPopupPosition && this.base && this.completions) {
                var pos = this.editor.getCursorPosition();
                var prefix = this.editor.session.getTextRange({
                    start: this.base,
                    end: pos
                });
                if (prefix == this.completions.filterText) return;
                this.completions.setFilter(prefix);
                if (!this.completions.filtered.length) return this.detach();
                if (this.completions.filtered.length == 1 && this.completions.filtered[0].value == prefix && !this.completions.filtered[0].snippet) return this.detach();
                this.openPopup(this.editor, prefix, keepPopupPosition);
                return;
            }
            var _id = this.gatherCompletionsId;
            this.gatherCompletions(this.editor, (function(err, results) {
                var detachIfFinished = (function() {
                    if (!results.finished) return;
                    return this.detach();
                }).bind(this);
                var prefix = results.prefix;
                var matches = results && results.matches;
                if (!matches || !matches.length) return detachIfFinished();
                if (prefix.indexOf(results.prefix) !== 0 || _id != this.gatherCompletionsId) return;
                this.completions = new FilteredList(matches);
                if (this.exactMatch) this.completions.exactMatch = true;
                this.completions.setFilter(prefix);
                var filtered = this.completions.filtered;
                if (!filtered.length) return detachIfFinished();
                if (filtered.length == 1 && filtered[0].value == prefix && !filtered[0].snippet) return detachIfFinished();
                if (this.autoInsert && filtered.length == 1 && results.finished) return this.insertMatch(filtered[0]);
                this.openPopup(this.editor, prefix, keepPopupPosition);
            }).bind(this));
        };
        this.cancelContextMenu = function() {
            this.editor.$mouseHandler.cancelContextMenu();
        };
        this.updateDocTooltip = function() {
            var popup = this.popup;
            var all = popup.data;
            var selected = all && (all[popup.getHoveredRow()] || all[popup.getRow()]);
            var doc = null;
            if (!selected || !this.editor || !this.popup.isOpen) return this.hideDocTooltip();
            this.editor.completers.some(function(completer) {
                if (completer.getDocTooltip) doc = completer.getDocTooltip(selected);
                return doc;
            });
            if (!doc) doc = selected;
            if (typeof doc == "string") doc = {
                docText: doc
            };
            if (!doc || !(doc.docHTML || doc.docText)) return this.hideDocTooltip();
            this.showDocTooltip(doc);
        };
        this.showDocTooltip = function(item) {
            if (!this.tooltipNode) {
                this.tooltipNode = dom.createElement("div");
                this.tooltipNode.className = "ace_tooltip ace_doc-tooltip";
                this.tooltipNode.style.margin = 0;
                this.tooltipNode.style.pointerEvents = "auto";
                this.tooltipNode.tabIndex = -1;
                this.tooltipNode.onblur = this.blurListener.bind(this);
                this.tooltipNode.onclick = this.onTooltipClick.bind(this);
            }
            var tooltipNode = this.tooltipNode;
            if (item.docHTML) tooltipNode.innerHTML = item.docHTML;
            else if (item.docText) tooltipNode.textContent = item.docText;
            if (!tooltipNode.parentNode) document.body.appendChild(tooltipNode);
            var popup = this.popup;
            var rect = popup.container.getBoundingClientRect();
            tooltipNode.style.top = popup.container.style.top;
            tooltipNode.style.bottom = popup.container.style.bottom;
            if (window.innerWidth - rect.right < 320) {
                tooltipNode.style.right = window.innerWidth - rect.left + "px";
                tooltipNode.style.left = "";
            } else {
                tooltipNode.style.left = rect.right + 1 + "px";
                tooltipNode.style.right = "";
            }
            tooltipNode.style.display = "block";
        };
        this.hideDocTooltip = function() {
            this.tooltipTimer.cancel();
            if (!this.tooltipNode) return;
            var el = this.tooltipNode;
            if (!this.editor.isFocused() && document.activeElement == el) this.editor.focus();
            this.tooltipNode = null;
            if (el.parentNode) el.parentNode.removeChild(el);
        };
        this.onTooltipClick = function(e) {
            var a = e.target;
            while(a && a != this.tooltipNode){
                if (a.nodeName == "A" && a.href) {
                    a.rel = "noreferrer";
                    a.target = "_blank";
                    break;
                }
                a = a.parentNode;
            }
        };
    }).call(Autocomplete.prototype);
    Autocomplete.startCommand = {
        name: "startAutocomplete",
        exec: function(editor) {
            if (!editor.completer) editor.completer = new Autocomplete();
            editor.completer.autoInsert = false;
            editor.completer.autoSelect = true;
            editor.completer.showPopup(editor);
            editor.completer.cancelContextMenu();
        },
        bindKey: "Ctrl-Space|Ctrl-Shift-Space|Alt-Space"
    };
    var FilteredList = function(array, filterText) {
        this.all = array;
        this.filtered = array;
        this.filterText = filterText || "";
        this.exactMatch = false;
    };
    (function() {
        this.setFilter = function(str) {
            if (str.length > this.filterText && str.lastIndexOf(this.filterText, 0) === 0) var matches = this.filtered;
            else var matches = this.all;
            this.filterText = str;
            matches = this.filterCompletions(matches, this.filterText);
            matches = matches.sort(function(a, b) {
                return b.exactMatch - a.exactMatch || b.score - a.score;
            });
            var prev = null;
            matches = matches.filter(function(item) {
                var caption = item.snippet || item.caption || item.value;
                if (caption === prev) return false;
                prev = caption;
                return true;
            });
            this.filtered = matches;
        };
        this.filterCompletions = function(items, needle) {
            var results = [];
            var upper = needle.toUpperCase();
            var lower = needle.toLowerCase();
            loop: for(var i = 0, item; item = items[i]; i++){
                var caption = item.value || item.caption || item.snippet;
                if (!caption) continue;
                var lastIndex = -1;
                var matchMask = 0;
                var penalty = 0;
                var index, distance;
                if (this.exactMatch) {
                    if (needle !== caption.substr(0, needle.length)) continue loop;
                } else for(var j = 0; j < needle.length; j++){
                    var i1 = caption.indexOf(lower[j], lastIndex + 1);
                    var i2 = caption.indexOf(upper[j], lastIndex + 1);
                    index = i1 >= 0 ? i2 < 0 || i1 < i2 ? i1 : i2 : i2;
                    if (index < 0) continue loop;
                    distance = index - lastIndex - 1;
                    if (distance > 0) {
                        if (lastIndex === -1) penalty += 10;
                        penalty += distance;
                    }
                    matchMask = matchMask | 1 << index;
                    lastIndex = index;
                }
                item.matchMask = matchMask;
                item.exactMatch = penalty ? 0 : 1;
                item.score = (item.score || 0) - penalty;
                results.push(item);
            }
            return results;
        };
    }).call(FilteredList.prototype);
    exports.Autocomplete = Autocomplete;
    exports.FilteredList = FilteredList;
});
ace.define("ace/autocomplete/text_completer", [
    "require",
    "exports",
    "module",
    "ace/range"
], function(acequire, exports, module) {
    var Range = acequire("../range").Range;
    var splitRegex = /[^a-zA-Z_0-9\$\-\u00C0-\u1FFF\u2C00-\uD7FF\w]+/;
    function getWordIndex(doc, pos) {
        var textBefore = doc.getTextRange(Range.fromPoints({
            row: 0,
            column: 0
        }, pos));
        return textBefore.split(splitRegex).length - 1;
    }
    function wordDistance(doc, pos) {
        var prefixPos = getWordIndex(doc, pos);
        var words = doc.getValue().split(splitRegex);
        var wordScores = Object.create(null);
        var currentWord = words[prefixPos];
        words.forEach(function(word, idx) {
            if (!word || word === currentWord) return;
            var distance = Math.abs(prefixPos - idx);
            var score = words.length - distance;
            if (wordScores[word]) wordScores[word] = Math.max(score, wordScores[word]);
            else wordScores[word] = score;
        });
        return wordScores;
    }
    exports.getCompletions = function(editor, session, pos, prefix, callback) {
        var wordScore = wordDistance(session, pos, prefix);
        var wordList = Object.keys(wordScore);
        callback(null, wordList.map(function(word) {
            return {
                caption: word,
                value: word,
                score: wordScore[word],
                meta: "local"
            };
        }));
    };
});
ace.define("ace/ext/language_tools", [
    "require",
    "exports",
    "module",
    "ace/snippets",
    "ace/autocomplete",
    "ace/config",
    "ace/lib/lang",
    "ace/autocomplete/util",
    "ace/autocomplete/text_completer",
    "ace/editor",
    "ace/config"
], function(acequire, exports, module) {
    "use strict";
    var snippetManager = acequire("../snippets").snippetManager;
    var Autocomplete = acequire("../autocomplete").Autocomplete;
    var config = acequire("../config");
    var lang = acequire("../lib/lang");
    var util = acequire("../autocomplete/util");
    var textCompleter = acequire("../autocomplete/text_completer");
    var keyWordCompleter = {
        getCompletions: function(editor, session, pos, prefix, callback) {
            if (session.$mode.completer) return session.$mode.completer.getCompletions(editor, session, pos, prefix, callback);
            var state = editor.session.getState(pos.row);
            var completions = session.$mode.getCompletions(state, session, pos, prefix);
            callback(null, completions);
        }
    };
    var snippetCompleter = {
        getCompletions: function(editor, session, pos, prefix, callback) {
            var snippetMap = snippetManager.snippetMap;
            var completions = [];
            snippetManager.getActiveScopes(editor).forEach(function(scope) {
                var snippets = snippetMap[scope] || [];
                for(var i = snippets.length; i--;){
                    var s = snippets[i];
                    var caption = s.name || s.tabTrigger;
                    if (!caption) continue;
                    completions.push({
                        caption: caption,
                        snippet: s.content,
                        meta: s.tabTrigger && !s.name ? s.tabTrigger + "\u21E5 " : "snippet",
                        type: "snippet"
                    });
                }
            }, this);
            callback(null, completions);
        },
        getDocTooltip: function(item) {
            if (item.type == "snippet" && !item.docHTML) item.docHTML = [
                "<b>",
                lang.escapeHTML(item.caption),
                "</b>",
                "<hr></hr>",
                lang.escapeHTML(item.snippet)
            ].join("");
        }
    };
    var completers = [
        snippetCompleter,
        textCompleter,
        keyWordCompleter
    ];
    exports.setCompleters = function(val) {
        completers.length = 0;
        if (val) completers.push.apply(completers, val);
    };
    exports.addCompleter = function(completer) {
        completers.push(completer);
    };
    exports.textCompleter = textCompleter;
    exports.keyWordCompleter = keyWordCompleter;
    exports.snippetCompleter = snippetCompleter;
    var expandSnippet = {
        name: "expandSnippet",
        exec: function(editor) {
            return snippetManager.expandWithTab(editor);
        },
        bindKey: "Tab"
    };
    var onChangeMode = function(e, editor) {
        loadSnippetsForMode(editor.session.$mode);
    };
    var loadSnippetsForMode = function(mode) {
        var id = mode.$id;
        if (!snippetManager.files) snippetManager.files = {};
        loadSnippetFile(id);
        if (mode.modes) mode.modes.forEach(loadSnippetsForMode);
    };
    var loadSnippetFile = function(id) {
        if (!id || snippetManager.files[id]) return;
        var snippetFilePath = id.replace("mode", "snippets");
        snippetManager.files[id] = {};
        config.loadModule(snippetFilePath, function(m) {
            if (m) {
                snippetManager.files[id] = m;
                if (!m.snippets && m.snippetText) m.snippets = snippetManager.parseSnippetFile(m.snippetText);
                snippetManager.register(m.snippets || [], m.scope);
                if (m.includeScopes) {
                    snippetManager.snippetMap[m.scope].includeScopes = m.includeScopes;
                    m.includeScopes.forEach(function(x) {
                        loadSnippetFile("ace/mode/" + x);
                    });
                }
            }
        });
    };
    var doLiveAutocomplete = function(e) {
        var editor = e.editor;
        var hasCompleter = editor.completer && editor.completer.activated;
        if (e.command.name === "backspace") {
            if (hasCompleter && !util.getCompletionPrefix(editor)) editor.completer.detach();
        } else if (e.command.name === "insertstring") {
            var prefix = util.getCompletionPrefix(editor);
            if (prefix && !hasCompleter) {
                if (!editor.completer) editor.completer = new Autocomplete();
                editor.completer.autoInsert = false;
                editor.completer.showPopup(editor);
            }
        }
    };
    var Editor = acequire("../editor").Editor;
    acequire("../config").defineOptions(Editor.prototype, "editor", {
        enableBasicAutocompletion: {
            set: function(val) {
                if (val) {
                    if (!this.completers) this.completers = Array.isArray(val) ? val : completers;
                    this.commands.addCommand(Autocomplete.startCommand);
                } else this.commands.removeCommand(Autocomplete.startCommand);
            },
            value: false
        },
        enableLiveAutocompletion: {
            set: function(val) {
                if (val) {
                    if (!this.completers) this.completers = Array.isArray(val) ? val : completers;
                    this.commands.on('afterExec', doLiveAutocomplete);
                } else this.commands.removeListener('afterExec', doLiveAutocomplete);
            },
            value: false
        },
        enableSnippets: {
            set: function(val) {
                if (val) {
                    this.commands.addCommand(expandSnippet);
                    this.on("changeMode", onChangeMode);
                    onChangeMode(null, this);
                } else {
                    this.commands.removeCommand(expandSnippet);
                    this.off("changeMode", onChangeMode);
                }
            },
            value: false
        }
    });
});
(function() {
    ace.acequire([
        "ace/ext/language_tools"
    ], function() {});
})();


// @ts-ignore
const { snippetManager: $9f3f2307a48ab1bc$var$snippetManager } = window.ace.acequire(`ace/snippets`);
$9f3f2307a48ab1bc$var$snippetManager.register([
    {
        content: `[.signed-section-closing]`,
        name: `[.signed-section-closing]`,
        tabTrigger: `sscl`
    },
    {
        name: `[.signed-section-signature]`,
        tabTrigger: `sss`,
        content: `[.signed-section-signature]`
    },
    {
        name: `[.signed-section-context-open]`,
        tabTrigger: `ssco`,
        content: `[.signed-section-context-open]`
    },
    {
        name: `[.signed-section-context-close]`,
        tabTrigger: `sscc`,
        content: `[.signed-section-context-close]`
    },
    {
        name: `[.salutation]`,
        tabTrigger: `sal`,
        content: `[.salutation]`
    },
    {
        name: `[.chapter-synopsis]`,
        tabTrigger: `cs`,
        content: `[.chapter-synopsis]`
    },
    {
        content: `[.embedded-content-document.\${1:letter}]\n--\n$2`,
        name: `[.embedded-content-document.letter]`,
        tabTrigger: `ed`
    },
    {
        name: `[.embedded-content-document.epistle]`,
        tabTrigger: `ede`,
        content: `[.embedded-content-document.epistle]\n--\n`
    },
    {
        name: `[quote.scripture]`,
        tabTrigger: `qs`,
        content: `[quote.scripture, , $1]\n____\n$2`
    },
    {
        name: `[quote]`,
        tabTrigger: `q`,
        content: `[quote]\n____\n`
    },
    {
        name: `[.asterism]`,
        tabTrigger: `ast`,
        content: `[.asterism]\n'''`
    },
    {
        name: `[.letter-heading]`,
        tabTrigger: `lh`,
        content: `[.letter-heading]`
    },
    {
        name: `smart apostrophe open (start)`,
        tabTrigger: `sas`,
        content: `'\``
    },
    {
        name: `smart apostrophe close (end)`,
        tabTrigger: `sae`,
        content: `\`'`
    },
    {
        name: `smart quote open (start)`,
        tabTrigger: `sqs`,
        content: `"\``
    },
    {
        name: `smart quote close (end)`,
        tabTrigger: `sqe`,
        content: `\`"`
    },
    {
        name: `[.offset]`,
        tabTrigger: `off`,
        content: `[.offset]`
    },
    {
        name: `[.numbered]`,
        tabTrigger: `num`,
        content: `[.numbered]`
    },
    {
        name: `[.discourse-part]`,
        tabTrigger: `dp`,
        content: `[.discourse-part]`
    },
    {
        name: `[.small-break]`,
        tabTrigger: `sb`,
        content: `[.small-break]\n'''\n`
    },
    {
        name: `[.alt]`,
        tabTrigger: `alt`,
        content: `[.alt]\n=== `
    },
    {
        name: `[.old-style]`,
        tabTrigger: `os`,
        content: `[.old-style]`
    },
    {
        name: `[.chapter-subtitle--blurb]`,
        tabTrigger: `csb`,
        content: `[.chapter-subtitle--blurb]`
    },
    {
        name: `[.book-title]#`,
        tabTrigger: `bt`,
        content: `[.book-title]#`
    }
], `adoc`);


ace.define("ace/theme/tomorrow_night", [
    "require",
    "exports",
    "module",
    "ace/lib/dom"
], function(acequire, exports, module) {
    exports.isDark = true;
    exports.cssClass = "ace-tomorrow-night";
    exports.cssText = ".ace-tomorrow-night .ace_gutter {\
background: #25282c;\
color: #C5C8C6\
}\
.ace-tomorrow-night .ace_print-margin {\
width: 1px;\
background: #25282c\
}\
.ace-tomorrow-night {\
background-color: #1D1F21;\
color: #C5C8C6\
}\
.ace-tomorrow-night .ace_cursor {\
color: #AEAFAD\
}\
.ace-tomorrow-night .ace_marker-layer .ace_selection {\
background: #373B41\
}\
.ace-tomorrow-night.ace_multiselect .ace_selection.ace_start {\
box-shadow: 0 0 3px 0px #1D1F21;\
}\
.ace-tomorrow-night .ace_marker-layer .ace_step {\
background: rgb(102, 82, 0)\
}\
.ace-tomorrow-night .ace_marker-layer .ace_bracket {\
margin: -1px 0 0 -1px;\
border: 1px solid #4B4E55\
}\
.ace-tomorrow-night .ace_marker-layer .ace_active-line {\
background: #282A2E\
}\
.ace-tomorrow-night .ace_gutter-active-line {\
background-color: #282A2E\
}\
.ace-tomorrow-night .ace_marker-layer .ace_selected-word {\
border: 1px solid #373B41\
}\
.ace-tomorrow-night .ace_invisible {\
color: #4B4E55\
}\
.ace-tomorrow-night .ace_keyword,\
.ace-tomorrow-night .ace_meta,\
.ace-tomorrow-night .ace_storage,\
.ace-tomorrow-night .ace_storage.ace_type,\
.ace-tomorrow-night .ace_support.ace_type {\
color: #B294BB\
}\
.ace-tomorrow-night .ace_keyword.ace_operator {\
color: #8ABEB7\
}\
.ace-tomorrow-night .ace_constant.ace_character,\
.ace-tomorrow-night .ace_constant.ace_language,\
.ace-tomorrow-night .ace_constant.ace_numeric,\
.ace-tomorrow-night .ace_keyword.ace_other.ace_unit,\
.ace-tomorrow-night .ace_support.ace_constant,\
.ace-tomorrow-night .ace_variable.ace_parameter {\
color: #DE935F\
}\
.ace-tomorrow-night .ace_constant.ace_other {\
color: #CED1CF\
}\
.ace-tomorrow-night .ace_invalid {\
color: #CED2CF;\
background-color: #DF5F5F\
}\
.ace-tomorrow-night .ace_invalid.ace_deprecated {\
color: #CED2CF;\
background-color: #B798BF\
}\
.ace-tomorrow-night .ace_fold {\
background-color: #81A2BE;\
border-color: #C5C8C6\
}\
.ace-tomorrow-night .ace_entity.ace_name.ace_function,\
.ace-tomorrow-night .ace_support.ace_function,\
.ace-tomorrow-night .ace_variable {\
color: #81A2BE\
}\
.ace-tomorrow-night .ace_support.ace_class,\
.ace-tomorrow-night .ace_support.ace_type {\
color: #F0C674\
}\
.ace-tomorrow-night .ace_heading,\
.ace-tomorrow-night .ace_markup.ace_heading,\
.ace-tomorrow-night .ace_string {\
color: #B5BD68\
}\
.ace-tomorrow-night .ace_entity.ace_name.ace_tag,\
.ace-tomorrow-night .ace_entity.ace_other.ace_attribute-name,\
.ace-tomorrow-night .ace_meta.ace_tag,\
.ace-tomorrow-night .ace_string.ace_regexp,\
.ace-tomorrow-night .ace_variable {\
color: #CC6666\
}\
.ace-tomorrow-night .ace_comment {\
color: #969896\
}\
.ace-tomorrow-night .ace_indent-guide {\
background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAAEklEQVQImWNgYGBgYHB3d/8PAAOIAdULw8qMAAAAAElFTkSuQmCC) right repeat-y\
}";
    var dom = acequire("../lib/dom");
    dom.importCssString(exports.cssText, exports.cssClass);
});


const $5609852d618f9ba6$var$noopEditor = new Proxy({}, {
    get (target, prop, receiver) {
        const fn = ()=>receiver;
        Object.setPrototypeOf(fn, receiver);
        return fn;
    }
});
const $5609852d618f9ba6$var$ChooseAFile = ()=>/*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $d5f1ba22637aca3e$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("p", {
            style: {
                opacity: 0.5
            },
            children: [
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("span", {
                    role: "img",
                    "aria-label": "left",
                    children: [
                        "\uD83D\uDC48",
                        ` `
                    ]
                }),
                ` `,
                "choose a file"
            ]
        })
    });
class $5609852d618f9ba6$var$Editor extends $lx97N.Component {
    aceRef = /*#__PURE__*/ $lx97N.createRef();
    componentDidMount() {
        const editor = this.editor();
        (0, $ffcaa208e85016e8$export$1a527062cd0f7273)(editor, this.props);
        editor.focus();
        editor.gotoLine(0);
        editor.setPrintMarginColumn(90);
        this.checkErrors(editor.getValue());
    }
    componentDidUpdate(prev) {
        const { size: size, searching: searching } = this.props;
        if (size.width !== prev.size.width || searching !== prev.searching) this.editor().resize();
        // ace seems to sometimes lose commands ¯\_(ツ)_/¯
        if (!this.editor().commands.commands.increaseFontSize) (0, $ffcaa208e85016e8$export$1a527062cd0f7273)(this.editor(), this.props);
    }
    checkErrors(adoc) {
        if (typeof adoc !== `string`) return;
        const lints = (0, $98cb5ebf8f0b866b$export$2e2bcd8739ae039)(adoc, this.props.lintOptions).filter((l)=>l.fixable !== true || [
                `join-words`,
                `obsolete-spellings`
            ].includes(l.rule)).filter((l)=>l.rule !== `temporary-comments`);
        try {
            (0, $a8d03726b9ff868b$export$2e2bcd8739ae039).parseDocument({
                adoc: adoc
            });
        } catch (err) {
            if (err instanceof (0, $7e6e5536f6256095$export$2e2bcd8739ae039)) // don't show parser error if we already have a lint on the line
            {
                if (lints.every((lint)=>lint.line !== err.lineNumber)) lints.push({
                    type: `error`,
                    line: err.lineNumber,
                    rule: `parser-error`,
                    message: `PARSER ERROR: ${err.message}`,
                    info: err.codeFrame.split(`\n`).filter((l, i)=>i > 2).join(`\n`),
                    column: err.columnStart
                });
            }
        }
        this.annotateLintErrors(lints);
    }
    annotateLintErrors(lints) {
        this.editor().getSession().setAnnotations(lints.map((lint)=>{
            let text = lint.message;
            if (lint.recommendation) text += `\n\n>> Recommended fix:\n\n${lint.recommendation}`;
            if (lint.info) text += `\n\n>> More info:\n\n${lint.info}`;
            return {
                row: lint.line - 1,
                column: lint.column,
                text: text,
                type: `warning`
            };
        }));
    }
    editor() {
        if (this.aceRef.current && this.aceRef.current.editor) return this.aceRef.current.editor;
        return $5609852d618f9ba6$var$noopEditor;
    }
    renderAce() {
        const { updateFile: updateFile, adoc: adoc, fontSize: fontSize } = this.props;
        return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2e028685ecba3f47$exports))), {
            style: {
                fontSize: fontSize
            },
            ref: this.aceRef,
            mode: "adoc",
            theme: "tomorrow_night",
            onChange: (0, (/*@__PURE__*/$parcel$interopDefault($fc6da8441dcd6fda$exports)))((adoc)=>{
                updateFile(adoc);
                this.checkErrors(adoc);
            }, 500),
            value: adoc || ``,
            editorProps: {
                $blockScrolling: true
            },
            setOptions: {
                enableSnippets: true,
                // @ts-ignore
                indentedSoftWrap: false,
                wrap: true
            }
        });
    }
    render() {
        const { adoc: adoc, searching: searching } = this.props;
        return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $3d8fed0c3db304a7$export$2e2bcd8739ae039), {
            searching: searching,
            className: "Editor",
            children: adoc === undefined ? /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)($5609852d618f9ba6$var$ChooseAFile, {}) : this.renderAce()
        });
    }
}
const $5609852d618f9ba6$var$mapState = (state)=>{
    const task = (0, $13d8f246ee75675a$export$e82b432c98c7ae91)(state);
    const file = task.files[task.editingFile || ``];
    return {
        lintOptions: (0, $b9d1978dee2f18f9$export$44a4ce1f1535e549)(file ? file.path : ``),
        githubUser: state.github.token !== null ? state.github.user : ``,
        fontSize: state.prefs.editorFontSize,
        searching: state.search.searching,
        adoc: file ? file.editedContent || file.content : undefined
    };
};
const $5609852d618f9ba6$var$mapDispatch = {
    updateFile: $75c2ce1d62cf75f2$export$e1434007a6fed2b8,
    toggleSidebarOpen: $75c2ce1d62cf75f2$export$1d54456469cf71ed,
    undo: $75c2ce1d62cf75f2$export$44881ed2056bcdb7,
    redo: $75c2ce1d62cf75f2$export$8df76a88841e9487,
    find: $221bf0d0018b5ded$export$7a995bfc8661504b,
    increaseFontSize: $75c2ce1d62cf75f2$export$4b93d1fac58b899a,
    decreaseFontSize: $75c2ce1d62cf75f2$export$f666e322c19d5625
};
const $5609852d618f9ba6$var$SizedEditor = (0, $29a4ffa32b5e7e98$exports.withSize)({
    monitorHeight: true
})($5609852d618f9ba6$var$Editor);
var $5609852d618f9ba6$export$2e2bcd8739ae039 = (0, $494dfd495f2b09e7$export$2e2bcd8739ae039)($5609852d618f9ba6$var$mapState, $5609852d618f9ba6$var$mapDispatch)($5609852d618f9ba6$var$SizedEditor);




var $lx97N = parcelRequire("lx97N");



var $lx97N = parcelRequire("lx97N");
var $46cfc33e0a2e9a73$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $46cfc33e0a2e9a73$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $46cfc33e0a2e9a73$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $46cfc33e0a2e9a73$var$inherits = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var $46cfc33e0a2e9a73$var$possibleConstructorReturn = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
var $46cfc33e0a2e9a73$var$styles = {
    base: {
        position: 'absolute',
        userSelect: 'none',
        MsUserSelect: 'none'
    },
    top: {
        width: '100%',
        height: '10px',
        top: '-5px',
        left: '0px',
        cursor: 'row-resize'
    },
    right: {
        width: '10px',
        height: '100%',
        top: '0px',
        right: '-5px',
        cursor: 'col-resize'
    },
    bottom: {
        width: '100%',
        height: '10px',
        bottom: '-5px',
        left: '0px',
        cursor: 'row-resize'
    },
    left: {
        width: '10px',
        height: '100%',
        top: '0px',
        left: '-5px',
        cursor: 'col-resize'
    },
    topRight: {
        width: '20px',
        height: '20px',
        position: 'absolute',
        right: '-10px',
        top: '-10px',
        cursor: 'ne-resize'
    },
    bottomRight: {
        width: '20px',
        height: '20px',
        position: 'absolute',
        right: '-10px',
        bottom: '-10px',
        cursor: 'se-resize'
    },
    bottomLeft: {
        width: '20px',
        height: '20px',
        position: 'absolute',
        left: '-10px',
        bottom: '-10px',
        cursor: 'sw-resize'
    },
    topLeft: {
        width: '20px',
        height: '20px',
        position: 'absolute',
        left: '-10px',
        top: '-10px',
        cursor: 'nw-resize'
    }
};
var $46cfc33e0a2e9a73$var$Resizer = function(props) {
    return (0, $lx97N.createElement)('div', {
        className: props.className,
        style: $46cfc33e0a2e9a73$var$_extends({}, $46cfc33e0a2e9a73$var$styles.base, $46cfc33e0a2e9a73$var$styles[props.direction], props.replaceStyles || {}),
        onMouseDown: function onMouseDown(e) {
            props.onResizeStart(e, props.direction);
        },
        onTouchStart: function onTouchStart(e) {
            props.onResizeStart(e, props.direction);
        }
    }, props.children);
};
var $46cfc33e0a2e9a73$var$userSelectNone = {
    userSelect: 'none',
    MozUserSelect: 'none',
    WebkitUserSelect: 'none',
    MsUserSelect: 'none'
};
var $46cfc33e0a2e9a73$var$userSelectAuto = {
    userSelect: 'auto',
    MozUserSelect: 'auto',
    WebkitUserSelect: 'auto',
    MsUserSelect: 'auto'
};
var $46cfc33e0a2e9a73$var$clamp = function clamp(n, min, max) {
    return Math.max(Math.min(n, max), min);
};
var $46cfc33e0a2e9a73$var$snap = function snap(n, size) {
    return Math.round(n / size) * size;
};
var $46cfc33e0a2e9a73$var$findClosestSnap = function findClosestSnap(n, snapArray) {
    return snapArray.reduce(function(prev, curr) {
        return Math.abs(curr - n) < Math.abs(prev - n) ? curr : prev;
    });
};
var $46cfc33e0a2e9a73$var$endsWith = function endsWith(str, searchStr) {
    return str.substr(str.length - searchStr.length, searchStr.length) === searchStr;
};
var $46cfc33e0a2e9a73$var$getStringSize = function getStringSize(n) {
    if (n.toString() === 'auto') return n.toString();
    if ($46cfc33e0a2e9a73$var$endsWith(n.toString(), 'px')) return n.toString();
    if ($46cfc33e0a2e9a73$var$endsWith(n.toString(), '%')) return n.toString();
    if ($46cfc33e0a2e9a73$var$endsWith(n.toString(), 'vh')) return n.toString();
    if ($46cfc33e0a2e9a73$var$endsWith(n.toString(), 'vw')) return n.toString();
    if ($46cfc33e0a2e9a73$var$endsWith(n.toString(), 'vmax')) return n.toString();
    if ($46cfc33e0a2e9a73$var$endsWith(n.toString(), 'vmin')) return n.toString();
    return n + 'px';
};
var $46cfc33e0a2e9a73$var$definedProps = [
    'style',
    'className',
    'grid',
    'snap',
    'bounds',
    'size',
    'defaultSize',
    'minWidth',
    'minHeight',
    'maxWidth',
    'maxHeight',
    'lockAspectRatio',
    'lockAspectRatioExtraWidth',
    'lockAspectRatioExtraHeight',
    'enable',
    'handleStyles',
    'handleClasses',
    'handleWrapperStyle',
    'handleWrapperClass',
    'children',
    'onResizeStart',
    'onResize',
    'onResizeStop',
    'handleComponent',
    'scale',
    'resizeRatio'
];
var $46cfc33e0a2e9a73$var$baseClassName = '__resizable_base__';
var $46cfc33e0a2e9a73$var$Resizable = function(_React$Component) {
    $46cfc33e0a2e9a73$var$inherits(Resizable, _React$Component);
    function Resizable(props) {
        $46cfc33e0a2e9a73$var$classCallCheck(this, Resizable);
        var _this = $46cfc33e0a2e9a73$var$possibleConstructorReturn(this, (Resizable.__proto__ || Object.getPrototypeOf(Resizable)).call(this, props));
        _this.state = {
            isResizing: false,
            resizeCursor: 'auto',
            width: typeof (_this.propsSize && _this.propsSize.width) === 'undefined' ? 'auto' : _this.propsSize && _this.propsSize.width,
            height: typeof (_this.propsSize && _this.propsSize.height) === 'undefined' ? 'auto' : _this.propsSize && _this.propsSize.height,
            direction: 'right',
            original: {
                x: 0,
                y: 0,
                width: 0,
                height: 0
            }
        };
        _this.updateExtendsProps(props);
        _this.onResizeStart = _this.onResizeStart.bind(_this);
        _this.onMouseMove = _this.onMouseMove.bind(_this);
        _this.onMouseUp = _this.onMouseUp.bind(_this);
        if (typeof window !== 'undefined') {
            window.addEventListener('mouseup', _this.onMouseUp);
            window.addEventListener('mousemove', _this.onMouseMove);
            window.addEventListener('mouseleave', _this.onMouseUp);
            window.addEventListener('touchmove', _this.onMouseMove);
            window.addEventListener('touchend', _this.onMouseUp);
        }
        return _this;
    }
    $46cfc33e0a2e9a73$var$createClass(Resizable, [
        {
            key: 'updateExtendsProps',
            value: function updateExtendsProps(props) {
                this.extendsProps = Object.keys(props).reduce(function(acc, key) {
                    if ($46cfc33e0a2e9a73$var$definedProps.indexOf(key) !== -1) return acc;
                    acc[key] = props[key];
                    return acc;
                }, {});
            }
        },
        {
            key: 'getParentSize',
            value: function getParentSize() {
                var base = this.base;
                if (!base) return {
                    width: window.innerWidth,
                    height: window.innerHeight
                };
                // INFO: To calculate parent width with flex layout
                var wrapChanged = false;
                var wrap = this.parentNode.style.flexWrap;
                var minWidth = base.style.minWidth;
                if (wrap !== 'wrap') {
                    wrapChanged = true;
                    this.parentNode.style.flexWrap = 'wrap';
                // HACK: Use relative to get parent padding size
                }
                base.style.position = 'relative';
                base.style.minWidth = '100%';
                var size = {
                    width: base.offsetWidth,
                    height: base.offsetHeight
                };
                base.style.position = 'absolute';
                if (wrapChanged) this.parentNode.style.flexWrap = wrap;
                base.style.minWidth = minWidth;
                return size;
            }
        },
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                var size = this.size;
                this.setState({
                    width: this.state.width || size.width,
                    height: this.state.height || size.height
                });
                var parent = this.parentNode;
                if (!(parent instanceof HTMLElement)) return;
                if (this.base) return;
                var element = document.createElement('div');
                element.style.width = '100%';
                element.style.height = '100%';
                element.style.position = 'absolute';
                element.style.transform = 'scale(0, 0)';
                element.style.left = '0';
                element.style.flex = '0';
                if (element.classList) element.classList.add($46cfc33e0a2e9a73$var$baseClassName);
                else element.className += $46cfc33e0a2e9a73$var$baseClassName;
                parent.appendChild(element);
            }
        },
        {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(next) {
                this.updateExtendsProps(next);
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                if (typeof window !== 'undefined') {
                    window.removeEventListener('mouseup', this.onMouseUp);
                    window.removeEventListener('mousemove', this.onMouseMove);
                    window.removeEventListener('mouseleave', this.onMouseUp);
                    window.removeEventListener('touchmove', this.onMouseMove);
                    window.removeEventListener('touchend', this.onMouseUp);
                    var parent = this.parentNode;
                    var base = this.base;
                    if (!base || !parent) return;
                    if (!(parent instanceof HTMLElement) || !(base instanceof Node)) return;
                    parent.removeChild(base);
                }
            }
        },
        {
            key: 'calculateNewSize',
            value: function calculateNewSize(newSize, kind) {
                var propsSize = this.propsSize && this.propsSize[kind];
                return this.state[kind] === 'auto' && this.state.original[kind] === newSize && (typeof propsSize === 'undefined' || propsSize === 'auto') ? 'auto' : newSize;
            }
        },
        {
            key: 'onResizeStart',
            value: function onResizeStart(event, direction) {
                var clientX = 0;
                var clientY = 0;
                if (event.nativeEvent instanceof MouseEvent) {
                    clientX = event.nativeEvent.clientX;
                    clientY = event.nativeEvent.clientY;
                    // When user click with right button the resize is stuck in resizing mode
                    // until users clicks again, dont continue if right click is used.
                    // HACK: MouseEvent does not have `which` from flow-bin v0.68.
                    if (event.nativeEvent.which === 3) return;
                } else if (event.nativeEvent instanceof TouchEvent) {
                    clientX = event.nativeEvent.touches[0].clientX;
                    clientY = event.nativeEvent.touches[0].clientY;
                }
                if (this.props.onResizeStart) this.props.onResizeStart(event, direction, this.resizable);
                // Fix #168
                if (this.props.size) {
                    if (typeof this.props.size.height !== 'undefined' && this.props.size.height !== this.state.height) this.setState({
                        height: this.props.size.height
                    });
                    if (typeof this.props.size.width !== 'undefined' && this.props.size.width !== this.state.width) this.setState({
                        width: this.props.size.width
                    });
                }
                this.setState({
                    original: {
                        x: clientX,
                        y: clientY,
                        width: this.size.width,
                        height: this.size.height
                    },
                    isResizing: true,
                    resizeCursor: window.getComputedStyle(event.target).cursor,
                    direction: direction
                });
            }
        },
        {
            key: 'onMouseMove',
            value: function onMouseMove(event) {
                if (!this.state.isResizing) return;
                var clientX = event instanceof MouseEvent ? event.clientX : event.touches[0].clientX;
                var clientY = event instanceof MouseEvent ? event.clientY : event.touches[0].clientY;
                var _state = this.state, direction = _state.direction, original = _state.original, width = _state.width, height = _state.height;
                var _props = this.props, lockAspectRatio = _props.lockAspectRatio, lockAspectRatioExtraHeight = _props.lockAspectRatioExtraHeight, lockAspectRatioExtraWidth = _props.lockAspectRatioExtraWidth;
                var scale = this.props.scale || 1;
                var _props2 = this.props, maxWidth = _props2.maxWidth, maxHeight = _props2.maxHeight, minWidth = _props2.minWidth, minHeight = _props2.minHeight;
                var resizeRatio = this.props.resizeRatio || 1;
                // TODO: refactor
                var parentSize = this.getParentSize();
                if (maxWidth && typeof maxWidth === 'string' && $46cfc33e0a2e9a73$var$endsWith(maxWidth, '%')) {
                    var _ratio = Number(maxWidth.replace('%', '')) / 100;
                    maxWidth = parentSize.width * _ratio;
                }
                if (maxHeight && typeof maxHeight === 'string' && $46cfc33e0a2e9a73$var$endsWith(maxHeight, '%')) {
                    var _ratio2 = Number(maxHeight.replace('%', '')) / 100;
                    maxHeight = parentSize.height * _ratio2;
                }
                if (minWidth && typeof minWidth === 'string' && $46cfc33e0a2e9a73$var$endsWith(minWidth, '%')) {
                    var _ratio3 = Number(minWidth.replace('%', '')) / 100;
                    minWidth = parentSize.width * _ratio3;
                }
                if (minHeight && typeof minHeight === 'string' && $46cfc33e0a2e9a73$var$endsWith(minHeight, '%')) {
                    var _ratio4 = Number(minHeight.replace('%', '')) / 100;
                    minHeight = parentSize.height * _ratio4;
                }
                maxWidth = typeof maxWidth === 'undefined' ? undefined : Number(maxWidth);
                maxHeight = typeof maxHeight === 'undefined' ? undefined : Number(maxHeight);
                minWidth = typeof minWidth === 'undefined' ? undefined : Number(minWidth);
                minHeight = typeof minHeight === 'undefined' ? undefined : Number(minHeight);
                var ratio = typeof lockAspectRatio === 'number' ? lockAspectRatio : original.width / original.height;
                var newWidth = original.width;
                var newHeight = original.height;
                if (/right/i.test(direction)) {
                    newWidth = original.width + (clientX - original.x) * resizeRatio / scale;
                    if (lockAspectRatio) newHeight = (newWidth - lockAspectRatioExtraWidth) / ratio + lockAspectRatioExtraHeight;
                }
                if (/left/i.test(direction)) {
                    newWidth = original.width - (clientX - original.x) * resizeRatio / scale;
                    if (lockAspectRatio) newHeight = (newWidth - lockAspectRatioExtraWidth) / ratio + lockAspectRatioExtraHeight;
                }
                if (/bottom/i.test(direction)) {
                    newHeight = original.height + (clientY - original.y) * resizeRatio / scale;
                    if (lockAspectRatio) newWidth = (newHeight - lockAspectRatioExtraHeight) * ratio + lockAspectRatioExtraWidth;
                }
                if (/top/i.test(direction)) {
                    newHeight = original.height - (clientY - original.y) * resizeRatio / scale;
                    if (lockAspectRatio) newWidth = (newHeight - lockAspectRatioExtraHeight) * ratio + lockAspectRatioExtraWidth;
                }
                if (this.props.bounds === 'parent') {
                    var parent = this.parentNode;
                    if (parent instanceof HTMLElement) {
                        var parentRect = parent.getBoundingClientRect();
                        var parentLeft = parentRect.left;
                        var parentTop = parentRect.top;
                        var _resizable$getBoundin = this.resizable.getBoundingClientRect(), _left = _resizable$getBoundin.left, _top = _resizable$getBoundin.top;
                        var boundWidth = parent.offsetWidth + (parentLeft - _left);
                        var boundHeight = parent.offsetHeight + (parentTop - _top);
                        maxWidth = maxWidth && maxWidth < boundWidth ? maxWidth : boundWidth;
                        maxHeight = maxHeight && maxHeight < boundHeight ? maxHeight : boundHeight;
                    }
                } else if (this.props.bounds === 'window') {
                    if (typeof window !== 'undefined') {
                        var _resizable$getBoundin2 = this.resizable.getBoundingClientRect(), _left2 = _resizable$getBoundin2.left, _top2 = _resizable$getBoundin2.top;
                        var _boundWidth = window.innerWidth - _left2;
                        var _boundHeight = window.innerHeight - _top2;
                        maxWidth = maxWidth && maxWidth < _boundWidth ? maxWidth : _boundWidth;
                        maxHeight = maxHeight && maxHeight < _boundHeight ? maxHeight : _boundHeight;
                    }
                } else if (this.props.bounds instanceof HTMLElement) {
                    var targetRect = this.props.bounds.getBoundingClientRect();
                    var targetLeft = targetRect.left;
                    var targetTop = targetRect.top;
                    var _resizable$getBoundin3 = this.resizable.getBoundingClientRect(), _left3 = _resizable$getBoundin3.left, _top3 = _resizable$getBoundin3.top;
                    if (!(this.props.bounds instanceof HTMLElement)) return;
                    var _boundWidth2 = this.props.bounds.offsetWidth + (targetLeft - _left3);
                    var _boundHeight2 = this.props.bounds.offsetHeight + (targetTop - _top3);
                    maxWidth = maxWidth && maxWidth < _boundWidth2 ? maxWidth : _boundWidth2;
                    maxHeight = maxHeight && maxHeight < _boundHeight2 ? maxHeight : _boundHeight2;
                }
                var computedMinWidth = typeof minWidth === 'undefined' ? 10 : minWidth;
                var computedMaxWidth = typeof maxWidth === 'undefined' || maxWidth < 0 ? newWidth : maxWidth;
                var computedMinHeight = typeof minHeight === 'undefined' ? 10 : minHeight;
                var computedMaxHeight = typeof maxHeight === 'undefined' || maxHeight < 0 ? newHeight : maxHeight;
                if (lockAspectRatio) {
                    var extraMinWidth = (computedMinHeight - lockAspectRatioExtraHeight) * ratio + lockAspectRatioExtraWidth;
                    var extraMaxWidth = (computedMaxHeight - lockAspectRatioExtraHeight) * ratio + lockAspectRatioExtraWidth;
                    var extraMinHeight = (computedMinWidth - lockAspectRatioExtraWidth) / ratio + lockAspectRatioExtraHeight;
                    var extraMaxHeight = (computedMaxWidth - lockAspectRatioExtraWidth) / ratio + lockAspectRatioExtraHeight;
                    var lockedMinWidth = Math.max(computedMinWidth, extraMinWidth);
                    var lockedMaxWidth = Math.min(computedMaxWidth, extraMaxWidth);
                    var lockedMinHeight = Math.max(computedMinHeight, extraMinHeight);
                    var lockedMaxHeight = Math.min(computedMaxHeight, extraMaxHeight);
                    newWidth = $46cfc33e0a2e9a73$var$clamp(newWidth, lockedMinWidth, lockedMaxWidth);
                    newHeight = $46cfc33e0a2e9a73$var$clamp(newHeight, lockedMinHeight, lockedMaxHeight);
                } else {
                    newWidth = $46cfc33e0a2e9a73$var$clamp(newWidth, computedMinWidth, computedMaxWidth);
                    newHeight = $46cfc33e0a2e9a73$var$clamp(newHeight, computedMinHeight, computedMaxHeight);
                }
                if (this.props.grid) newWidth = $46cfc33e0a2e9a73$var$snap(newWidth, this.props.grid[0]);
                if (this.props.grid) newHeight = $46cfc33e0a2e9a73$var$snap(newHeight, this.props.grid[1]);
                if (this.props.snap && this.props.snap.x) newWidth = $46cfc33e0a2e9a73$var$findClosestSnap(newWidth, this.props.snap.x);
                if (this.props.snap && this.props.snap.y) newHeight = $46cfc33e0a2e9a73$var$findClosestSnap(newHeight, this.props.snap.y);
                var delta = {
                    width: newWidth - original.width,
                    height: newHeight - original.height
                };
                if (width && typeof width === 'string' && $46cfc33e0a2e9a73$var$endsWith(width, '%')) {
                    var percent = newWidth / parentSize.width * 100;
                    newWidth = percent + '%';
                }
                if (height && typeof height === 'string' && $46cfc33e0a2e9a73$var$endsWith(height, '%')) {
                    var _percent = newHeight / parentSize.height * 100;
                    newHeight = _percent + '%';
                }
                this.setState({
                    width: this.calculateNewSize(newWidth, 'width'),
                    height: this.calculateNewSize(newHeight, 'height')
                });
                if (this.props.onResize) this.props.onResize(event, direction, this.resizable, delta);
            }
        },
        {
            key: 'onMouseUp',
            value: function onMouseUp(event) {
                var _state2 = this.state, isResizing = _state2.isResizing, direction = _state2.direction, original = _state2.original;
                if (!isResizing) return;
                var delta = {
                    width: this.size.width - original.width,
                    height: this.size.height - original.height
                };
                if (this.props.onResizeStop) this.props.onResizeStop(event, direction, this.resizable, delta);
                if (this.props.size) this.setState(this.props.size);
                this.setState({
                    isResizing: false,
                    resizeCursor: 'auto'
                });
            }
        },
        {
            key: 'updateSize',
            value: function updateSize(size) {
                this.setState({
                    width: size.width,
                    height: size.height
                });
            }
        },
        {
            key: 'renderResizer',
            value: function renderResizer() {
                var _this2 = this;
                var _props3 = this.props, enable = _props3.enable, handleStyles = _props3.handleStyles, handleClasses = _props3.handleClasses, handleWrapperStyle = _props3.handleWrapperStyle, handleWrapperClass = _props3.handleWrapperClass, handleComponent = _props3.handleComponent;
                if (!enable) return null;
                var resizers = Object.keys(enable).map(function(dir) {
                    if (enable[dir] !== false) return (0, $lx97N.createElement)($46cfc33e0a2e9a73$var$Resizer, {
                        key: dir,
                        direction: dir,
                        onResizeStart: _this2.onResizeStart,
                        replaceStyles: handleStyles && handleStyles[dir],
                        className: handleClasses && handleClasses[dir]
                    }, handleComponent && handleComponent[dir] ? (0, $lx97N.createElement)(handleComponent[dir]) : null);
                    return null;
                });
                // #93 Wrap the resize box in span (will not break 100% width/height)
                return (0, $lx97N.createElement)('span', {
                    className: handleWrapperClass,
                    style: handleWrapperStyle
                }, resizers);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this3 = this;
                var userSelect = this.state.isResizing ? $46cfc33e0a2e9a73$var$userSelectNone : $46cfc33e0a2e9a73$var$userSelectAuto;
                return (0, $lx97N.createElement)('div', $46cfc33e0a2e9a73$var$_extends({
                    ref: function ref(c) {
                        if (c) _this3.resizable = c;
                    },
                    style: $46cfc33e0a2e9a73$var$_extends({
                        position: 'relative'
                    }, userSelect, this.props.style, this.sizeStyle, {
                        maxWidth: this.props.maxWidth,
                        maxHeight: this.props.maxHeight,
                        minWidth: this.props.minWidth,
                        minHeight: this.props.minHeight,
                        boxSizing: 'border-box'
                    }),
                    className: this.props.className
                }, this.extendsProps), this.state.isResizing && (0, $lx97N.createElement)('div', {
                    style: {
                        height: '100%',
                        width: '100%',
                        backgroundColor: 'rgba(0,0,0,0)',
                        cursor: '' + (this.state.resizeCursor || 'auto'),
                        opacity: '0',
                        position: 'fixed',
                        zIndex: '9999',
                        top: '0',
                        left: '0',
                        bottom: '0',
                        right: '0'
                    }
                }), this.props.children, this.renderResizer());
            }
        },
        {
            key: 'parentNode',
            get: function get$$1() {
                return this.resizable.parentNode;
            }
        },
        {
            key: 'propsSize',
            get: function get$$1() {
                return this.props.size || this.props.defaultSize;
            }
        },
        {
            key: 'base',
            get: function get$$1() {
                var parent = this.parentNode;
                if (!parent) return undefined;
                var children = [].slice.call(parent.children);
                for(var i = 0; i < children.length; i += 1){
                    var n = children[i];
                    if (n instanceof HTMLElement) {
                        if (n.classList.contains($46cfc33e0a2e9a73$var$baseClassName)) return n;
                    }
                }
                return undefined;
            }
        },
        {
            key: 'size',
            get: function get$$1() {
                var width = 0;
                var height = 0;
                if (typeof window !== 'undefined') {
                    var orgWidth = this.resizable.offsetWidth;
                    var orgHeight = this.resizable.offsetHeight;
                    // HACK: Set position `relative` to get parent size.
                    //       This is because when re-resizable set `absolute`, I can not get base width correctly.
                    var orgPosition = this.resizable.style.position;
                    if (orgPosition !== 'relative') this.resizable.style.position = 'relative';
                    // INFO: Use original width or height if set auto.
                    width = this.resizable.style.width !== 'auto' ? this.resizable.offsetWidth : orgWidth;
                    height = this.resizable.style.height !== 'auto' ? this.resizable.offsetHeight : orgHeight;
                    // Restore original position
                    this.resizable.style.position = orgPosition;
                }
                return {
                    width: width,
                    height: height
                };
            }
        },
        {
            key: 'sizeStyle',
            get: function get$$1() {
                var _this4 = this;
                var size = this.props.size;
                var getSize = function getSize(key) {
                    if (typeof _this4.state[key] === 'undefined' || _this4.state[key] === 'auto') return 'auto';
                    if (_this4.propsSize && _this4.propsSize[key] && $46cfc33e0a2e9a73$var$endsWith(_this4.propsSize[key].toString(), '%')) {
                        if ($46cfc33e0a2e9a73$var$endsWith(_this4.state[key].toString(), '%')) return _this4.state[key].toString();
                        var parentSize = _this4.getParentSize();
                        var value = Number(_this4.state[key].toString().replace('px', ''));
                        var percent = value / parentSize[key] * 100;
                        return percent + '%';
                    }
                    return $46cfc33e0a2e9a73$var$getStringSize(_this4.state[key]);
                };
                var width = size && typeof size.width !== 'undefined' && !this.state.isResizing ? $46cfc33e0a2e9a73$var$getStringSize(size.width) : getSize('width');
                var height = size && typeof size.height !== 'undefined' && !this.state.isResizing ? $46cfc33e0a2e9a73$var$getStringSize(size.height) : getSize('height');
                return {
                    width: width,
                    height: height
                };
            }
        }
    ]);
    return Resizable;
}((0, $lx97N.Component));
$46cfc33e0a2e9a73$var$Resizable.defaultProps = {
    onResizeStart: function onResizeStart() {},
    onResize: function onResize() {},
    onResizeStop: function onResizeStop() {},
    enable: {
        top: true,
        right: true,
        bottom: true,
        left: true,
        topRight: true,
        bottomRight: true,
        bottomLeft: true,
        topLeft: true
    },
    style: {},
    grid: [
        1,
        1
    ],
    lockAspectRatio: false,
    lockAspectRatioExtraWidth: 0,
    lockAspectRatioExtraHeight: 0,
    scale: 1,
    resizeRatio: 1
};
var $46cfc33e0a2e9a73$export$2e2bcd8739ae039 = $46cfc33e0a2e9a73$var$Resizable;






var $lx97N = parcelRequire("lx97N");

var $6e4550947d7f8679$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    var nativeCodeString = '[native code]';
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === 'string' || argType === 'number') classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === 'object') {
                if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
                    classes.push(arg.toString());
                    continue;
                }
                for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
            }
        }
        return classes.join(' ');
    }
    if ($6e4550947d7f8679$exports) {
        classNames.default = classNames;
        $6e4550947d7f8679$exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();





const $40048202dd4366be$var$WrapUl = (0, $c47ddde344dbf90f$export$2e2bcd8739ae039).ul`
  margin: 0;
  padding: 1.5em;

  & .search {
    display: none;
    position: absolute;
    top: 4px;
    right: -28px;
  }

  & .parent:hover .search {
    display: block;
  }

  & > li {
    margin-bottom: 9px;
  }

  & li {
    white-space: nowrap;
    list-style: none;
  }

  & > li > ul {
    padding-left: 20px;
  }

  & li.collapsed > ul {
    display: none;
  }

  & .toggler::before {
    cursor: pointer;
    width: 11px;
    display: inline-block;
    font-style: normal;
    font-variant: normal;
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
    font-family: 'Font Awesome 5 Free';
    font-weight: 900;
    content: '\f0d7';
    color: var(--accent);
    margin-right: 0;
  }

  & .collapsed .toggler::before {
    content: '\f0da';
  }
`;
const $40048202dd4366be$var$EditionLi = (0, $c47ddde344dbf90f$export$2e2bcd8739ae039).li`
  margin-top: 0.5em;
  white-space: nowrap;

  & > span {
    text-transform: capitalize;
  }

  & > ul {
    margin: 0.35em 0 0.75em;
    padding-left: 2em;
  }
`;
const $40048202dd4366be$var$Filename = (0, $c47ddde344dbf90f$export$2e2bcd8739ae039).li`
  margin: 6px;

  &::before {
    content: '• ';
    opacity: 0;
    color: orange;
  }

  &.edited::before {
    opacity: 1;
  }

  & code {
    font-size: 13px;
    cursor: pointer;
    padding: 2px 8px;
    background: #232323;
    &:hover {
      background: #000;
    }
  }

  &.editing {
    & code {
      color: #000;
      cursor: default;
      background: var(--accent);
    }
  }
`;
const $40048202dd4366be$var$IconSearch = (0, $c47ddde344dbf90f$export$2e2bcd8739ae039).i`
  padding-left: 10px;

  &::before {
    width: 11px;
    display: inline-block;
    font-style: normal;
    font-variant: normal;
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
    font-family: 'Font Awesome 5 Free';
    font-weight: 900;
    content: ${(props)=>props.isEdition ? `"\f02e"` : `"\f02d"`};
    margin-right: 0.75em;
    color: #999;
  }

  &:hover::before {
    content: '\f002';
    color: white;
  }
`;
class $40048202dd4366be$var$FriendFiles extends (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).Component {
    search(path) {
        const { updateSearch: updateSearch } = this.props;
        const [documentSlug, editionType] = path.split(`/`);
        updateSearch({
            searching: true,
            documentSlug: documentSlug || null,
            editionType: editionType || null,
            filename: null
        });
    }
    isCollapsed(key) {
        const { collapsed: collapsed, editingFile: editingFile } = this.props;
        // ensure editing file is always visible, because we can
        // jump to a collapsed section from the search feature
        if (editingFile && editingFile.indexOf(key) === 0) return false;
        return collapsed[key] || false;
    }
    renderDoc = (doc)=>{
        const { collapseTask: collapseTask, taskId: taskId } = this.props;
        const key = doc.slug;
        const isCollapsed = this.isCollapsed(key);
        return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("li", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($6e4550947d7f8679$exports)))(`parent`, {
                collapsed: isCollapsed
            }),
            children: [
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("span", {
                    className: "toggler",
                    onClick: ()=>collapseTask({
                            taskId: taskId,
                            key: key,
                            isCollapsed: isCollapsed
                        })
                }),
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)($40048202dd4366be$var$IconSearch, {
                    onClick: ()=>this.search(key)
                }),
                doc.title,
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("ul", {
                    children: doc.editions.map((ed)=>this.renderEdition(ed, doc))
                })
            ]
        }, doc.slug);
    };
    renderEdition = (ed, doc)=>{
        const { collapseTask: collapseTask, taskId: taskId } = this.props;
        const key = [
            doc.slug,
            ed.type
        ].join(`/`);
        const isCollapsed = this.isCollapsed(key);
        return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)($40048202dd4366be$var$EditionLi, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($6e4550947d7f8679$exports)))(`parent`, {
                collapsed: isCollapsed
            }),
            children: [
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("span", {
                    className: "toggler",
                    onClick: ()=>collapseTask({
                            taskId: taskId,
                            key: key,
                            isCollapsed: isCollapsed
                        })
                }),
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)($40048202dd4366be$var$IconSearch, {
                    onClick: ()=>this.search(key),
                    isEdition: true
                }),
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("span", {
                    className: "edition-type",
                    children: ed.type
                }),
                " edition:",
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("ul", {
                    children: ed.files.map((file)=>this.renderFile(file))
                })
            ]
        }, `${doc.slug}/${ed.type}`);
    };
    renderFile = (file)=>{
        const { editingFile: editingFile, updateTask: updateTask, taskId: taskId } = this.props;
        const editing = file.path === editingFile;
        return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)($40048202dd4366be$var$Filename, {
            onClick: (e)=>{
                e.stopPropagation();
                updateTask({
                    id: taskId,
                    data: {
                        editingFile: file.path
                    }
                });
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($6e4550947d7f8679$exports)))({
                editing: editing,
                edited: file.edited
            }),
            children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("code", {
                children: file.filename
            })
        }, file.filename);
    };
    render() {
        const { documents: documents } = this.props;
        return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)($40048202dd4366be$var$WrapUl, {
            children: documents.map(this.renderDoc)
        });
    }
}
const $40048202dd4366be$var$mapState = (state)=>{
    const task = (0, $13d8f246ee75675a$export$e82b432c98c7ae91)(state);
    return {
        taskId: task.id,
        documents: (0, $13d8f246ee75675a$export$619b806001333a9)(task),
        editingFile: task.editingFile || ``,
        collapsed: task.collapsed || {}
    };
};
const $40048202dd4366be$var$mapDispatch = {
    updateTask: $75c2ce1d62cf75f2$export$e8e0154b7bb02be4,
    collapseTask: $75c2ce1d62cf75f2$export$fccfdb27a6737cfe,
    updateSearch: $75c2ce1d62cf75f2$export$b14c90fc27f0b629
};
var $40048202dd4366be$export$2e2bcd8739ae039 = (0, $494dfd495f2b09e7$export$2e2bcd8739ae039)($40048202dd4366be$var$mapState, $40048202dd4366be$var$mapDispatch)($40048202dd4366be$var$FriendFiles);


const $1b3b930c97a996cc$var$Div = (0, $c47ddde344dbf90f$export$2e2bcd8739ae039)((0, $46cfc33e0a2e9a73$export$2e2bcd8739ae039))`
  background: #333;
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;
  z-index: 2;
  transform: translateZ(0);

  .resize-handle {
    position: static;
    > div {
      right: 0 !important;
    }
  }
`;
const $1b3b930c97a996cc$var$ToggleEl = (0, $c47ddde344dbf90f$export$2e2bcd8739ae039).div`
  cursor: pointer;
  width: 25px;
  height: 50px;
  border-bottom-${(p)=>p.open ? `right` : `left`}-radius: 50px;
  border-top-${(p)=>p.open ? `right` : `left`}-radius: 50px;
  background: ${(p)=>p.open ? `#111` : `#25282c`};
  z-index: 5;
  position: fixed;
  ${(p)=>p.open ? `left` : `right`}: 0px;
  top: calc(50% - 25px);

  & i {
    line-height: 50px;
    color: grey;
    width: 100%;
    text-align: center;
    font-size: 20px;
  }

  * >  & {
    display: opacity 0;
    visibility: hidden;
  }

  *:hover > & {
    visibility: visible;
    opacity: 1;
  }
`;
const $1b3b930c97a996cc$var$Closed = (0, $c47ddde344dbf90f$export$2e2bcd8739ae039).div`
  width: 15px;
  background: transparent;
  position: absolute;
  height: calc(100vh - 50px);
  z-index: 2;
`;
const $1b3b930c97a996cc$var$Toggle = ({ onClick: onClick, isOpen: isOpen })=>/*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)($1b3b930c97a996cc$var$ToggleEl, {
        className: "toggle",
        onClick: onClick,
        open: isOpen,
        children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("i", {
            className: `fas fa-angle-${isOpen ? `right` : `left`}`
        })
    });
class $1b3b930c97a996cc$var$Sidebar extends $lx97N.Component {
    render() {
        const { open: open, width: width, toggleOpen: toggleOpen, updateWidth: updateWidth } = this.props;
        if (!open) return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)($1b3b930c97a996cc$var$Closed, {
            children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)($1b3b930c97a996cc$var$Toggle, {
                onClick: toggleOpen,
                isOpen: true
            })
        });
        return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)($1b3b930c97a996cc$var$Div, {
            minWidth: 200,
            defaultSize: {
                width: width
            },
            handleWrapperClass: "resize-handle",
            onResizeStop: (e, dir, ref, delta)=>{
                updateWidth(width + delta.width);
            },
            enable: {
                top: false,
                right: true,
                bottom: false,
                left: false,
                topRight: false,
                bottomRight: false,
                bottomLeft: false,
                topLeft: false
            },
            children: [
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)($1b3b930c97a996cc$var$Toggle, {
                    onClick: toggleOpen,
                    isOpen: false
                }),
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $40048202dd4366be$export$2e2bcd8739ae039), {})
            ]
        });
    }
}
const $1b3b930c97a996cc$var$mapState = (state)=>{
    const task = (0, $13d8f246ee75675a$export$e82b432c98c7ae91)(state);
    return {
        open: task.sidebarOpen,
        width: task.sidebarWidth
    };
};
const $1b3b930c97a996cc$var$mapDispatch = {
    toggleOpen: $75c2ce1d62cf75f2$export$1d54456469cf71ed,
    updateWidth: $75c2ce1d62cf75f2$export$9e3f1bcb8acbee0d
};
var $1b3b930c97a996cc$export$2e2bcd8739ae039 = (0, $494dfd495f2b09e7$export$2e2bcd8739ae039)($1b3b930c97a996cc$var$mapState, $1b3b930c97a996cc$var$mapDispatch)($1b3b930c97a996cc$var$Sidebar);




var $lx97N = parcelRequire("lx97N");





var $07b66721c6074d55$exports = {};
'use strict';
var $07b66721c6074d55$var$matchOperatorsRe = /[|\\{}()[\]^$+*?.]/g;
$07b66721c6074d55$exports = function(str) {
    if (typeof str !== 'string') throw new TypeError('Expected a string');
    return str.replace($07b66721c6074d55$var$matchOperatorsRe, '\\$&');
};


function $4fa4c0a0a4bd80f8$export$451dfe10be14dac0(searchTerm, files, words = true, caseSensitive = false, regexp = false) {
    const results = files.reduce((acc, file)=>{
        const lines = (file.editedContent || file.content || ``).split(/\n/);
        let pattern = regexp ? searchTerm : (0, (/*@__PURE__*/$parcel$interopDefault($07b66721c6074d55$exports)))(searchTerm);
        if (words) pattern = `\\b${pattern}\\b`;
        let exp;
        try {
            exp = new RegExp(pattern, `g${caseSensitive ? `` : `i`}`);
        } catch  {
            return [];
        }
        lines.forEach((line, index)=>{
            let match = null;
            while(match = exp.exec(line)){
                const [documentSlug, editionType, filename] = file.path.split(`/`);
                const result = {
                    path: file.path,
                    documentSlug: documentSlug,
                    editionType: editionType,
                    filename: filename,
                    start: {
                        line: index + 1,
                        column: match.index
                    },
                    end: {
                        line: index + 1,
                        column: match.index + searchTerm.length
                    }
                };
                acc.push({
                    ...result,
                    context: $4fa4c0a0a4bd80f8$var$getContext(result, lines)
                });
            }
        });
        return acc;
    }, []);
    return results.sort(({ editionType: editionType })=>{
        switch(editionType){
            case `updated`:
                return -1;
            case `modernized`:
                return 0;
            default:
                return 1;
        }
    });
}
function $4fa4c0a0a4bd80f8$var$getContext(result, lines) {
    const context = [];
    const { start: start, end: end } = result;
    const beforeLineIndex = start.line - 2;
    if (beforeLineIndex > -1 && lines[beforeLineIndex].trim()) context.push({
        lineNumber: beforeLineIndex + 1,
        content: lines[beforeLineIndex]
    });
    const resultLines = end.line - start.line + 1;
    for(let i = 1; i <= resultLines; i++)context.push({
        lineNumber: start.line + (i - 1),
        content: lines[start.line + (i - 2)]
    });
    const afterLineIndex = end.line;
    if (lines[afterLineIndex] && lines[afterLineIndex].trim()) context.push({
        lineNumber: afterLineIndex + 1,
        content: lines[afterLineIndex]
    });
    return context;
}



parcelRequire("lx97N");




parcelRequire("lx97N");


const $b58503a9ad35e31c$var$SearchResultActions = (0, $c47ddde344dbf90f$export$2e2bcd8739ae039).div`
  z-index: 1;
  display: flex;
  justify-content: flex-end;
  position: absolute;
  top: 0;
  right: 0;
  padding-right: 19px;
  opacity: 0;
  transition: opacity 250ms ease;

  > * {
    font-size: 12px;
    width: auto !important;
    padding: 0 12px;
    border-radius: 6px;
    margin-top: 15px;
    margin-left: 8px;
  }

  .replace {
    color: #000;
  }
`;
const $b58503a9ad35e31c$var$Component = ({ dismiss: dismiss, goto: goto, replace: replace })=>/*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)($b58503a9ad35e31c$var$SearchResultActions, {
        className: "result-actions",
        children: [
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $65f15d32471eec71$export$2e2bcd8739ae039), {
                height: 26,
                secondary: true,
                onClick: dismiss,
                children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("i", {
                    className: "fas fa-times-circle"
                })
            }),
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $65f15d32471eec71$export$2e2bcd8739ae039), {
                height: 26,
                secondary: true,
                onClick: goto,
                children: "Edit"
            }),
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $65f15d32471eec71$export$2e2bcd8739ae039), {
                className: "replace",
                height: 26,
                onClick: ()=>{
                    dismiss();
                    replace();
                },
                children: "Replace"
            })
        ]
    });
var $b58503a9ad35e31c$export$2e2bcd8739ae039 = $b58503a9ad35e31c$var$Component;



parcelRequire("lx97N");

const $bcb9ada7826d8a2d$var$SearchResultPreview = (0, $c47ddde344dbf90f$export$2e2bcd8739ae039).div`
  color: white;
  background: #222;
  font-family: monospace;
  margin-left: 15px;
`;
const $bcb9ada7826d8a2d$var$LineNumber = (0, $c47ddde344dbf90f$export$2e2bcd8739ae039).span`
  opacity: 0.4;
  margin: 0 0.5em 0 0.3em;
  text-align: right;
  width: 2.5em;
`;
const $bcb9ada7826d8a2d$var$Line = (0, $c47ddde344dbf90f$export$2e2bcd8739ae039).div`
  line-height: 1.3em;
  display: flex;
  flex-wrap: nowrap;
  color: #bbb;

  .content {
    flex-grow: 1;
    overflow: hidden;
    position: relative;
  }

  .content-inner {
    position: absolute;
    top: 0;
    left: 0;
    white-space: pre-line;
  }

  .find,
  .replace {
    font-weight: 700;
    color: white;
  }

  .find {
    background: rgba(255, 0, 0, 0.5);
    cursor: ne-resize;
  }

  .replace {
    background: rgba(0, 128, 0, 0.65);
  }
`;
const $bcb9ada7826d8a2d$var$Component = ({ result: result, edit: edit, replace: replace })=>/*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)($bcb9ada7826d8a2d$var$SearchResultPreview, {
        onClick: (e)=>{
            if (e.target instanceof Element && e.target.nodeName === `B`) edit(result);
        },
        children: result.context.map((line, index)=>/*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)($bcb9ada7826d8a2d$var$Line, {
                children: [
                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)($bcb9ada7826d8a2d$var$LineNumber, {
                        children: line.lineNumber
                    }),
                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                        className: "content",
                        children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("span", {
                            className: "content-inner",
                            dangerouslySetInnerHTML: {
                                __html: $bcb9ada7826d8a2d$var$lineContent(line, index, result, replace)
                            }
                        })
                    })
                ]
            }, line.lineNumber))
    });
var $bcb9ada7826d8a2d$export$2e2bcd8739ae039 = $bcb9ada7826d8a2d$var$Component;
function $bcb9ada7826d8a2d$var$lineContent(line, index, result, replace) {
    const { start: start, end: end } = result;
    let content = ``;
    const isStartLine = line.lineNumber === start.line;
    if (isStartLine) {
        const before = line.content.substring(0, start.column);
        content = `${before}<b class="find">`;
        if (end.line === start.line) {
            const highlighted = line.content.substring(start.column, end.column);
            content += `${highlighted}</b><b class="replace">${replace}</b>`;
            content += line.content.substring(end.column);
        }
        return content;
    }
    return line.content;
}


const $9c45f7ae7bb7c714$var$SearchResult = (0, $c47ddde344dbf90f$export$2e2bcd8739ae039).div`
  position: relative;
  padding-right: 1.2em;
  padding-bottom: 1.5em;
  color: #aaa;

  &:hover .result-actions {
    opacity: 0.85;
  }

  code {
    font-size: 0.85em;
    padding: 0 0.35em;
    background: #111;
  }

  .sep {
    padding: 0;
    opacity: 0.5;
  }

  .edition-type {
    color: #b0b66c;
    margin-left: 0.25em;
  }

  .filename {
    color: var(--accent);
  }

  & + & {
    border-top: dashed 1px #333;
  }
`;
const $9c45f7ae7bb7c714$var$ResultHeading = (0, $c47ddde344dbf90f$export$2e2bcd8739ae039).p`
  margin: 0;
  padding: 1em 0;
`;
const $9c45f7ae7bb7c714$var$Component = ({ result: result, replace: replace, number: number, edit: edit, dismiss: dismiss, replaceInResult: replaceInResult })=>{
    if (result.dismissed) return null;
    return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)($9c45f7ae7bb7c714$var$SearchResult, {
        children: [
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $b58503a9ad35e31c$export$2e2bcd8739ae039), {
                dismiss: dismiss,
                replace: ()=>replaceInResult({
                        result: result,
                        replace: replace
                    }),
                goto: ()=>edit(result)
            }),
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)($9c45f7ae7bb7c714$var$ResultHeading, {
                children: [
                    "Match ",
                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("code", {
                        children: number
                    }),
                    " in file:",
                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("code", {
                        className: "edition-type",
                        children: result.editionType
                    }),
                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("code", {
                        className: "sep",
                        children: "/"
                    }),
                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("code", {
                        className: "filename",
                        children: result.filename
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $bcb9ada7826d8a2d$export$2e2bcd8739ae039), {
                result: result,
                edit: edit,
                replace: replace
            })
        ]
    });
};
const $9c45f7ae7bb7c714$var$mapDispatch = {
    replaceInResult: $221bf0d0018b5ded$export$35f8b54d6eee17d7,
    edit: $221bf0d0018b5ded$export$f3cb5d28a95ee19
};
var $9c45f7ae7bb7c714$export$2e2bcd8739ae039 = (0, $494dfd495f2b09e7$export$2e2bcd8739ae039)(null, $9c45f7ae7bb7c714$var$mapDispatch)($9c45f7ae7bb7c714$var$Component);




var $lx97N = parcelRequire("lx97N");





const $51fa989934bb5c19$var$Modifiers = (0, $c47ddde344dbf90f$export$2e2bcd8739ae039).div`
  color: #555;
  font-size: 13px;

  label {
    margin-right: 0.9em;
    position: relative;
    display: inline-block;
    line-height: 29px;
    vertical-align: middle;
    padding-left: 20px;
  }

  input {
    appearance: none;
    background: #222;
    margin-right: 0.35em;
    width: 12px;
    height: 12px;
    position: absolute !important;
    bottom: 5px;
    left: 1px;
    border-radius: 2px;
    display: inline-block;
    position: relative;
  }

  input:focus {
    outline: 0;
  }

  input:checked {
    opacity: 0.6;
    background: var(--accent);
  }
`;
const $51fa989934bb5c19$var$SearchBar = (0, $c47ddde344dbf90f$export$2e2bcd8739ae039).div`
  padding-right: 1.5em;
  display: flex;
  flex-direction: row;
  margin: 5px 0;

  & input {
    flex-grow: 1;
    background: #333;
    color: #dedede;
    padding: 2px 10px;
    font-size: 16px;
    font-family: monospace;
    border: none;
  }

  .Button {
    margin-left: 5px;
    margin-right: -19px;
    color: #bbb;
    width: 140px;
    text-align: left;
    padding-left: 1em;
  }

  .fas {
    opacity: 0.45;
    padding-right: 0.25em;
  }
`;
class $51fa989934bb5c19$var$Component extends $lx97N.Component {
    searchInput = /*#__PURE__*/ $lx97N.createRef();
    state = {
        replaceTerm: ``
    };
    componentDidMount() {
        if (this.searchInput.current) this.searchInput.current.focus();
    }
    changeReplaceTerm = (0, (/*@__PURE__*/$parcel$interopDefault($fc6da8441dcd6fda$exports)))(()=>{
        const { replaceTerm: replaceTerm } = this.state;
        const { changeReplaceTerm: changeReplaceTerm } = this.props;
        changeReplaceTerm(replaceTerm);
    }, 500);
    handleReplaceTermChange = (e)=>{
        this.setState({
            replaceTerm: e.target.value
        }, this.changeReplaceTerm);
    };
    replaceAll = ()=>{
        this.setState({
            replaceTerm: ``
        });
        this.props.replaceAll();
    };
    handleSpecialKeys = (event)=>{
        const { undo: undo, redo: redo, cancelSearch: cancelSearch } = this.props;
        if (event.key === `z` && (event.ctrlKey || event.metaKey)) {
            event.preventDefault();
            event.shiftKey ? redo() : undo();
        }
        if (event.key === `Escape`) cancelSearch();
        if (event.key === `f` && (event.ctrlKey || event.metaKey)) {
            event.preventDefault();
            cancelSearch();
        }
    };
    render() {
        const { replaceTerm: replaceTerm } = this.state;
        const { searchTerm: searchTerm, changeSearchTerm: changeSearchTerm, search: search, toggleCaseSensitive: toggleCaseSensitive, toggleWords: toggleWords, toggleRegexp: toggleRegexp, regexp: regexp, words: words, caseSensitive: caseSensitive } = this.props;
        return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)($51fa989934bb5c19$var$Modifiers, {
                    children: [
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("label", {
                            children: [
                                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("input", {
                                    type: "checkbox",
                                    checked: words,
                                    onChange: ()=>toggleWords()
                                }),
                                "whole words"
                            ]
                        }),
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("label", {
                            children: [
                                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("input", {
                                    type: "checkbox",
                                    checked: caseSensitive,
                                    onChange: ()=>toggleCaseSensitive()
                                }),
                                "case sensitive"
                            ]
                        }),
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("label", {
                            children: [
                                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("input", {
                                    type: "checkbox",
                                    checked: regexp,
                                    onChange: ()=>toggleRegexp()
                                }),
                                "regexp"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)($51fa989934bb5c19$var$SearchBar, {
                    children: [
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("input", {
                            ref: this.searchInput,
                            value: searchTerm,
                            placeholder: "Find",
                            onChange: (e)=>changeSearchTerm(e.target.value),
                            onKeyDown: (event)=>{
                                this.handleSpecialKeys(event);
                                if (event.key === `Enter`) search();
                            }
                        }),
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)((0, $65f15d32471eec71$export$2e2bcd8739ae039), {
                            className: "Button",
                            secondary: true,
                            onClick: search,
                            height: 35,
                            children: [
                                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("i", {
                                    className: "fas fa-search"
                                }),
                                "\xa0Find"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)($51fa989934bb5c19$var$SearchBar, {
                    children: [
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("input", {
                            value: replaceTerm,
                            placeholder: "Replace",
                            onChange: this.handleReplaceTermChange,
                            onKeyDown: this.handleSpecialKeys
                        }),
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)((0, $65f15d32471eec71$export$2e2bcd8739ae039), {
                            className: "Button",
                            secondary: true,
                            onClick: this.replaceAll,
                            height: 35,
                            children: [
                                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("i", {
                                    className: "fas fa-sync"
                                }),
                                "\xa0Replace All"
                            ]
                        })
                    ]
                })
            ]
        });
    }
}
const $51fa989934bb5c19$var$mapState = (state)=>({
        words: state.search.words,
        regexp: state.search.regexp,
        caseSensitive: state.search.caseSensitive
    });
const $51fa989934bb5c19$var$mapDispatch = {
    toggleWords: $75c2ce1d62cf75f2$export$e234babc6a0394bc,
    toggleCaseSensitive: $75c2ce1d62cf75f2$export$9bbea660512b1799,
    toggleRegexp: $75c2ce1d62cf75f2$export$f6603ee5314e9bbe,
    cancelSearch: $75c2ce1d62cf75f2$export$58f3f9b95b84be3c,
    undo: $75c2ce1d62cf75f2$export$44881ed2056bcdb7,
    redo: $75c2ce1d62cf75f2$export$8df76a88841e9487
};
var $51fa989934bb5c19$export$2e2bcd8739ae039 = (0, $494dfd495f2b09e7$export$2e2bcd8739ae039)($51fa989934bb5c19$var$mapState, $51fa989934bb5c19$var$mapDispatch)($51fa989934bb5c19$var$Component);



parcelRequire("lx97N");
const $600cb0dafe12817f$var$SearchSummary = ({ results: results })=>{
    if (results.length === 0) return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("p", {
        children: "Found no results. \xaf\\_(\u30C4)_/\xaf"
    });
    const dismissed = results.filter((result)=>result.dismissed);
    const found = dismissed.length ? `Showing` : `Found`;
    const number = dismissed.length ? `${results.length - dismissed.length}/${results.length}` : results.length;
    if (results.length === 1) return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("p", {
        children: [
            found,
            " ",
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("code", {
                children: number
            }),
            " result:"
        ]
    });
    else return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("p", {
        children: [
            found,
            " ",
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("code", {
                children: number
            }),
            " results:"
        ]
    });
};
var $600cb0dafe12817f$export$2e2bcd8739ae039 = $600cb0dafe12817f$var$SearchSummary;




var $lx97N = parcelRequire("lx97N");



const $a0dcb8c2447c2da5$var$SearchScope = (0, $c47ddde344dbf90f$export$2e2bcd8739ae039).div`
  color: #666;
  font-size: 14px;
  margin: 10px 0 25px 0;
  opacity: 0.9;

  i {
    border-bottom: 1px dotted #333;
  }

  i.edition {
    text-transform: capitalize;
  }

  code {
    color: var(--accent);
    opacity: 0.6;
    font-size: 13.5px;
  }
`;
class $a0dcb8c2447c2da5$var$Component extends $lx97N.Component {
    renderSingleFile() {
        const { filename: filename } = this.props;
        return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)((0, $b8c53ef43392f031$exports.Fragment), {
            children: [
                "* Searching only in the ",
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("i", {
                    children: "current active"
                }),
                " file: ",
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("code", {
                    children: filename
                })
            ]
        });
    }
    renderEdition() {
        const { editionType: editionType, documentTitle: documentTitle, numFiles: numFiles } = this.props;
        return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)((0, $b8c53ef43392f031$exports.Fragment), {
            children: [
                "* Searching ",
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("code", {
                    children: numFiles
                }),
                " files in the",
                ` `,
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("i", {
                    className: "edition",
                    children: editionType
                }),
                " edition of ",
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("i", {
                    children: documentTitle
                }),
                "."
            ]
        });
    }
    renderDocument() {
        const { documentTitle: documentTitle, numFiles: numFiles } = this.props;
        return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)((0, $b8c53ef43392f031$exports.Fragment), {
            children: [
                "* Searching all ",
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("code", {
                    children: numFiles
                }),
                " files in: ",
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("i", {
                    children: documentTitle
                }),
                "."
            ]
        });
    }
    renderFriend() {
        const { friendName: friendName } = this.props;
        return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)((0, $b8c53ef43392f031$exports.Fragment), {
            children: [
                "* Searching ",
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("i", {
                    children: "all books"
                }),
                " by: ",
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("i", {
                    children: friendName
                }),
                "."
            ]
        });
    }
    render() {
        const { filename: filename, editionType: editionType, documentTitle: documentTitle } = this.props;
        let inner;
        if (filename) inner = this.renderSingleFile();
        else if (editionType) inner = this.renderEdition();
        else if (documentTitle) inner = this.renderDocument();
        else inner = this.renderFriend();
        return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)($a0dcb8c2447c2da5$var$SearchScope, {
            children: inner
        });
    }
}
const $a0dcb8c2447c2da5$var$mapState = (state)=>{
    const task = (0, $13d8f246ee75675a$export$e82b432c98c7ae91)(state);
    const { filename: filename, documentSlug: documentSlug, editionType: editionType } = state.search;
    return {
        filename: filename,
        numFiles: (0, $13d8f246ee75675a$export$3bf98e6bba46a544)(state).length,
        documentTitle: documentSlug ? task.documentTitles[documentSlug] : undefined,
        editionType: editionType === undefined ? undefined : editionType,
        friendName: (0, $13d8f246ee75675a$export$9a7ed5c29b3d23ba)(state)
    };
};
var $a0dcb8c2447c2da5$export$2e2bcd8739ae039 = (0, $494dfd495f2b09e7$export$2e2bcd8739ae039)($a0dcb8c2447c2da5$var$mapState)($a0dcb8c2447c2da5$var$Component);


const $2c062442f75b9916$var$SearchWrap = (0, $c47ddde344dbf90f$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  background: #000;
  padding: 0.75em 0 0 1.5em;
  height: 45vh;
  flex: 0 0 auto;
  color: white;
  position: relative;
  box-sizing: border-box;
  z-index: 1;

  @media (min-height: 1024px) {
    height: 70vh;
  }

  & .close {
    position: absolute;
    top: 5px;
    right: 5px;
  }
`;
const $2c062442f75b9916$var$Results = (0, $c47ddde344dbf90f$export$2e2bcd8739ae039).div`
  overflow: hidden;
  height: 100%;
  overflow: auto;
`;
let $2c062442f75b9916$var$keepSearchTerm = ``;
function $2c062442f75b9916$var$initialState() {
    return {
        searchComplete: false,
        searchTerm: $2c062442f75b9916$var$keepSearchTerm,
        replaceTerm: ``,
        results: []
    };
}
class $2c062442f75b9916$var$Search extends $lx97N.Component {
    state = $2c062442f75b9916$var$initialState();
    componentDidUpdate(prev) {
        const { files: files, regexp: regexp, words: words, caseSensitive: caseSensitive } = this.props;
        if (files.length !== prev.files.length) {
            this.setState($2c062442f75b9916$var$initialState());
            return;
        }
        if (regexp !== prev.regexp || words !== prev.words || caseSensitive !== prev.caseSensitive) this.setState({
            results: [],
            searchComplete: false
        }, this.search);
    }
    changeSearchTerm = (searchTerm)=>{
        $2c062442f75b9916$var$keepSearchTerm = searchTerm;
        this.setState({
            searchTerm: searchTerm,
            searchComplete: false,
            results: []
        });
    };
    changeReplaceTerm = (replaceTerm)=>{
        this.setState({
            replaceTerm: replaceTerm
        });
    };
    search = ()=>{
        const { searchTerm: searchTerm } = this.state;
        const { files: files, regexp: regexp, caseSensitive: caseSensitive, words: words } = this.props;
        const termLength = searchTerm.trim().length;
        if (termLength < 3) return;
        if (regexp && termLength < 5) return;
        const results = (0, $4fa4c0a0a4bd80f8$export$451dfe10be14dac0)(searchTerm, files, words, caseSensitive, regexp);
        this.setState({
            results: results,
            searchComplete: true
        });
    };
    cancelSearch = ()=>{
        const { cancelSearch: cancelSearch } = this.props;
        cancelSearch();
        this.setState({
            searchTerm: ``,
            results: []
        });
    };
    dismissResult(index) {
        const { results: results } = this.state;
        results[index].dismissed = true;
        this.setState({
            results: results
        });
    }
    replaceAll = ()=>{
        const { replaceAll: replaceAll } = this.props;
        const { results: results, replaceTerm: replaceTerm } = this.state;
        replaceAll({
            results: results,
            replace: replaceTerm
        });
        this.setState({
            results: [],
            replaceTerm: ``,
            searchComplete: false
        });
    };
    render() {
        const { searchTerm: searchTerm, replaceTerm: replaceTerm, results: results, searchComplete: searchComplete } = this.state;
        const { searching: searching } = this.props;
        if (!searching) return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $b8c53ef43392f031$exports.Fragment), {});
        return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)($2c062442f75b9916$var$SearchWrap, {
            children: [
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("i", {
                            className: "close fas fa-times-circle",
                            onClick: this.cancelSearch
                        }),
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $51fa989934bb5c19$export$2e2bcd8739ae039), {
                            searchTerm: searchTerm,
                            changeSearchTerm: this.changeSearchTerm,
                            changeReplaceTerm: this.changeReplaceTerm,
                            search: this.search,
                            replaceAll: this.replaceAll
                        }),
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $a0dcb8c2447c2da5$export$2e2bcd8739ae039), {}),
                        searchComplete && /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $600cb0dafe12817f$export$2e2bcd8739ae039), {
                            results: results
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)($2c062442f75b9916$var$Results, {
                    children: results.map((r, i)=>/*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $9c45f7ae7bb7c714$export$2e2bcd8739ae039), {
                            replace: replaceTerm,
                            result: r,
                            number: i + 1,
                            dismiss: ()=>this.dismissResult(i)
                        }, `${r.filename}-${i}`))
                }),
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1d811823c5bf6b48$exports))), {
                    handleKeys: [
                        `esc`
                    ],
                    onKeyEvent: this.cancelSearch
                })
            ]
        });
    }
}
const $2c062442f75b9916$var$mapState = (state)=>{
    const { search: { searching: searching, regexp: regexp, caseSensitive: caseSensitive, words: words } } = state;
    return {
        files: (0, $13d8f246ee75675a$export$3bf98e6bba46a544)(state),
        searching: searching,
        regexp: regexp,
        caseSensitive: caseSensitive,
        words: words
    };
};
const $2c062442f75b9916$var$mapDispatch = {
    replaceAll: $221bf0d0018b5ded$export$b8b3234b4edfc4c2,
    cancelSearch: $75c2ce1d62cf75f2$export$58f3f9b95b84be3c
};
var $2c062442f75b9916$export$2e2bcd8739ae039 = (0, $494dfd495f2b09e7$export$2e2bcd8739ae039)($2c062442f75b9916$var$mapState, $2c062442f75b9916$var$mapDispatch)($2c062442f75b9916$var$Search);



const $d1b17548d5df9f3d$var$Main = (0, $c47ddde344dbf90f$export$2e2bcd8739ae039).div`
  display: flex;
  height: 100%;
`;
const $d1b17548d5df9f3d$var$Wrap = (0, $c47ddde344dbf90f$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
const $d1b17548d5df9f3d$var$EditorPane = (0, $c47ddde344dbf90f$export$2e2bcd8739ae039).div`
  flex: auto;
  display: flex;
  height: calc(100vh - 50px);
  flex-flow: column nowrap;
  justify-content: flex-end;
`;
class $d1b17548d5df9f3d$var$Work extends $lx97N.Component {
    statusInterval = -1;
    componentDidMount() {
        const { task: task, checkout: checkout, syncTask: syncTask } = this.props;
        if (!task.parentCommit) checkout(task);
        if (task.pullRequest) this.statusInterval = setInterval(()=>syncTask(task), 120000);
    }
    componentWillUnmount() {
        clearInterval(this.statusInterval);
    }
    render() {
        const { task: task } = this.props;
        const { increaseFontSize: increaseFontSize, decreaseFontSize: decreaseFontSize, toggleSidebarOpen: toggleSidebarOpen, undo: undo, redo: redo, find: find } = this.props;
        const status = (0, (/*@__PURE__*/$parcel$interopDefault($j0yhs)))(task, `pullRequest.status`, `open`);
        if (status !== `open`) return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)($d1b17548d5df9f3d$var$ClosedWarning, {
            status: status
        });
        if (!task.parentCommit) return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $14318da104c038f4$export$2e2bcd8739ae039), {});
        return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)($d1b17548d5df9f3d$var$Wrap, {
            children: [
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)($d1b17548d5df9f3d$var$Main, {
                    children: [
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $1b3b930c97a996cc$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)($d1b17548d5df9f3d$var$EditorPane, {
                            children: [
                                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $5609852d618f9ba6$export$2e2bcd8739ae039), {}),
                                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $2c062442f75b9916$export$2e2bcd8739ae039), {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1d811823c5bf6b48$exports))), {
                    handleKeys: [
                        `meta+Up`,
                        `ctrl+Up`
                    ],
                    onKeyEvent: increaseFontSize
                }),
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1d811823c5bf6b48$exports))), {
                    handleKeys: [
                        `meta+Down`,
                        `ctrl+Down`
                    ],
                    onKeyEvent: decreaseFontSize
                }),
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1d811823c5bf6b48$exports))), {
                    handleKeys: [
                        `meta+ctrl+7`,
                        `alt+ctrl+7`
                    ],
                    onKeyEvent: toggleSidebarOpen
                }),
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1d811823c5bf6b48$exports))), {
                    handleKeys: [
                        `meta+Z`,
                        `ctrl+Z`
                    ],
                    onKeyEvent: undo
                }),
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1d811823c5bf6b48$exports))), {
                    handleKeys: [
                        `meta+shift+Z`,
                        `ctrl+shift+Z`
                    ],
                    onKeyEvent: redo
                }),
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1d811823c5bf6b48$exports))), {
                    handleKeys: [
                        `meta+F`,
                        `ctrl+F`
                    ],
                    onKeyEvent: (_, event)=>{
                        find();
                        event.preventDefault();
                    }
                })
            ]
        });
    }
}
const $d1b17548d5df9f3d$var$mapState = (state)=>({
        task: (0, $13d8f246ee75675a$export$e82b432c98c7ae91)(state)
    });
const $d1b17548d5df9f3d$var$mapDispatch = {
    checkout: $831556aba23b4e91$export$f0bf07efc4a101de,
    undo: $75c2ce1d62cf75f2$export$44881ed2056bcdb7,
    redo: $75c2ce1d62cf75f2$export$8df76a88841e9487,
    find: $221bf0d0018b5ded$export$7a995bfc8661504b,
    toggleSidebarOpen: $75c2ce1d62cf75f2$export$1d54456469cf71ed,
    increaseFontSize: $75c2ce1d62cf75f2$export$4b93d1fac58b899a,
    decreaseFontSize: $75c2ce1d62cf75f2$export$f666e322c19d5625,
    syncTask: $831556aba23b4e91$export$103149011e4c2e95
};
var $d1b17548d5df9f3d$export$2e2bcd8739ae039 = (0, $494dfd495f2b09e7$export$2e2bcd8739ae039)($d1b17548d5df9f3d$var$mapState, $d1b17548d5df9f3d$var$mapDispatch)($d1b17548d5df9f3d$var$Work);
const $d1b17548d5df9f3d$var$ClosedWarning = ({ status: status })=>/*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("div", {
        style: {
            color: `red`,
            padding: `1em 3em`
        },
        children: [
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("h1", {
                children: [
                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("span", {
                        role: "img",
                        "aria-label": "Embarrassed face.",
                        children: "\uD83D\uDE2C"
                    }),
                    ` `,
                    "Pull Request was ",
                    status,
                    "!"
                ]
            }),
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("p", {
                style: {
                    lineHeight: `160%`,
                    color: `white`
                },
                children: [
                    "Whoops, looks like there was some sort of a coordination problem. Don't worry, none of your work is lost, you can reopen the task if necessary. But for now you'll need to go back to the \"Tasks\" screen, and you'll probably want to contact Jared or Jason, or leave a slack in the ",
                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("code", {
                        children: "#asciidoc"
                    }),
                    " channel."
                ]
            })
        ]
    });




var $lx97N = parcelRequire("lx97N");






const $746e4812f3965251$var$strings = {
    Or: `O`,
    Search: `Buscar`,
    Authors: `Autores`,
    Books: `Libros`,
    Compilations: `Compilaciones`,
    About: `Acerca de`,
    Help: `Ayuda`,
    Recommended: `Recomendado`,
    Recommendations: `Recomendaciones`,
    Cart: `Carrito`,
    Download: `Descargar`,
    Audiobooks: `Audiolibros`,
    Audiobook: `Audiolibro`,
    Listen: `Escuchar`,
    Paperback: `Libro Impreso`,
    by: `por`,
    Play: `Reproducir`,
    Pause: `Pausar`,
    Quakers: `Cu\xe1queros`,
    'Back 15 seconds': `Retroceder 15 segundos`,
    'Forward 15 seconds': `Avanzar 15 segundos`,
    'Play part %s': `Reproducir parte %s`,
    'Religious Society of Friends': `La Sociedad de Amigos (Cu\xe1queros)`,
    'Audio Book': `Audiolibro`,
    'All Audio Books': `Todos los Audiolibros`,
    'Audio Books': `Audiolibros`,
    'Recently Added Books': `Libros A\xf1adidos Recientemente`,
    'Not Found': `P\xe1gina No Encontrada`,
    'Recently Added Authors': `Autores A\xf1adidos Recientemente`,
    'Learn More': `M\xe1s Informaci\xf3n`,
    'View Compilations': `Ver Compilaciones`,
    'Getting Started': `C\xf3mo Empezar`,
    'Explore Books': `Explorar los Libros`,
    'All Friends': `Todos los Amigos`,
    'About the Quakers': `Acerca de los Cu\xe1queros`,
    'About this Site': `Acerca de este sitio`,
    'Quakers Today?': `\xbfCu\xe1queros hoy en d\xeda?`,
    'Early Quaker Beliefs': `Creencias de los Cu\xe1queros`,
    'Audio Help': `Ayuda para Audio`,
    'E-Book Help': `Ayuda para Libro Electr\xf3nico`,
    'Contact Us': `Cont\xe1ctanos`,
    'The Friends Library': `La Biblioteca de los Amigos`,
    'Friends Library Publishing': `La Biblioteca de los Amigos`,
    'Friends Library': `Biblioteca de los Amigos`,
    'Friends Library App': `Aplicaci\xf3n de Bibliotecas de Los Amigos`,
    'View %s More': `Ver %s m\xe1s`,
    'View More': `Ver m\xe1s`,
    'Your search returned no results': `Tu b\xfasqueda no obtuvo resultados`,
    // all friends filters
    Sort: `Ordenar por`,
    'First Name': `Nombre`,
    'Last Name': `Apellido`,
    'Birth Date': `Fecha de Nacimiento`,
    'Death Date': `Fecha de Muerte`,
    // tags, tag-like
    'Spiritual Life': `Vida Espiritual`,
    'spiritual life': `vida espiritual`,
    'spiritual-life': `vida-espiritual`,
    doctrinal: `doctrinal`,
    Doctrine: `Doctrinal`,
    history: `historia`,
    History: `Historia`,
    Biographical: `Biogr\xe1fico`,
    biographical: `biogr\xe1fico`,
    Tags: `Etiquetas`,
    journal: `diario`,
    letters: `cartas`,
    exhortation: `exhortaci\xf3n`,
    treatise: `tratado`,
    allegory: `alegor\xeda`,
    devotional: `devocional`,
    // searching, filters
    Filters: `Filtros`,
    'All Books': `Todos los Libros`,
    'Select a filter or search to get started!': `\xa1Selecciona un filtro o realiza una b\xfasqueda para empezar!`,
    // Home Page
    'Our Books': `Nuestros Libros`,
    Paperbacks: `Libros Impresos`,
    'E-Books': `Libros Electr\xf3nicos`,
    'Featured Books': `Libros Destacados`,
    'Find out more': `M\xe1s Informaci\xf3n`,
    // search
    Pages: `P\xe1ginas`,
    Friends: `Amigos`,
    Page: `P\xe1gina`,
    Residences: `Residencias`,
    'No results for query': `No hemos encontrado resultados para`,
    // Friend Page
    'All Compilations (%s)': `Todas las Compilaciones (%s)`,
    'Books by %s': `Libros de %s`,
    'View Book': `Ver Libro`,
    'Where did %s live?': `\xbfD\xf3nde vivi\xf3 %s?`,
    'Related Books': `Libros Relacionados`,
    // Document page
    'Download Audiobook': `Descargar Audiolibro`,
    'Download as': `Descargar como`,
    'Download mp3 Files as Zip': `Descargar archivos Mp3 como Zip`,
    'Download mp3 File': `Descargar archivo Mp3`,
    'Higher quality, larger file size': `Mayor Calidad, mayor tama\xf1o del archivo`,
    'Lower quality, faster download': `Menor calidad, pero se descarga m\xe1s r\xe1pido`,
    'Need Help?': `\xbfNecesitas Ayuda?`,
    'Listen online': `Escuchar en l\xednea`,
    'Other Compilations': `Otras Compilaciones`,
    'Other Books by this Author': `Otros libros de este Autor`,
    '1 chapter': `1 capitulo`,
    '%s chapters': `%s cap\xedtulos`,
    '1 page': `1 pagina`,
    '%s pages': `%s p\xe1ginas`,
    // urls
    '/getting-started': `/comenzar`,
    '/explore': `/explorar`,
    '/audiobooks': `/audiolibros`,
    '/compilations': `/compilaciones`,
    '/friends': `/amigos`,
    '/quakers': `/cuaqueros`,
    '/quakers-today': `/cuaqeros-hoy-en-dia`,
    '/what-early-quakers-believed': `/creencias-de-los-primeros-cuaqueros`,
    '/about': `/acerca-de-este-sitio`,
    '/audio-help': `/audio-ayuda`,
    '/ebook-help': `/ebook-ayuda`,
    '/contact': `/contactanos`,
    '/spanish-translations': `/nuestras-traducciones`,
    '/app': `/app`,
    '/app-privacy': `/app-privacidad`,
    '/plain-text-format': `/descargar-texto-sin-formato`,
    // contact
    Submit: `Enviar`,
    Submitting: `Enviando`,
    Contact: `Contacto`,
    Name: `Nombre`,
    Email: `Correo Electr\xf3nico`,
    Message: `Mensaje`,
    // download / add to cart wizard
    'Choose Book Type': `Escoger el tipo de Libro`,
    'Choose Download Format': `Escoge el Formato de Descarga`,
    'E-Book': `Libro Electr\xf3nico`,
    'Best for reading on a computer, phone, or tablet.': `La mejor opci\xf3n para leer en computadora, tel\xe9fono o tablet.`,
    'Best for printing out your own copy.': `La mejor opci\xf3n para imprimir tu propia copia`,
    'Choose eBook Type': `Selecciona el Tipo de Libro Electr\xf3nico`,
    "Best for text-to-speech apps like \u201CVoice Dream.\u201D": `La mejor opci\xf3n para aplicaciones que convierten el texto a voz como \u{201C}Voice Dream.\u{201D}`,
    // old, remove next major
    'Best for most apps and platforms, including iOS.': `El mejor formato para la mayor\xeda de aplicaciones y plataformas, incluyendo iOS.`,
    // replaced by below
    'Best for most apps and platforms, including Android, iOS, and newer Kindle devices.': `El mejor para la mayor\xeda de aplicaciones y plataformas, incluyendo Android, iOS y los dispositivos m\xe1s nuevos de Kindle.`,
    // old, remove next major
    'Best on Amazon devices, Kindle app, and Android.': `El mejor formato para los dispositivos Amazon, aplicaciones de Kindle y Android.`,
    // replaced by below
    'Best for older Android and Kindle devices.': `El mejor para dispositivos Android y Kindle antiguos.`,
    // Cart / Checkout
    'Your Order': `Tu Pedido`,
    'Continue Browsing': `Continuar Explorando`,
    'Handling Fee': `Gastos de Gesti\xf3n`,
    Order: `Pedido`,
    Delivery: `Env\xedo`,
    Payment: `Pago`,
    Confirmation: `Confirmaci\xf3n`,
    Item: `Art\xedculo`,
    Price: `Precio`,
    Quantity: `Cantidad`,
    Remove: `Quitar`,
    Total: `Total`,
    City: `Ciudad`,
    'Qty.': `Cant.`,
    'Full name': `Nombre Completo`,
    'Apartment, suite, unit, etc.': `Apartamento, suite, casa, etc.`,
    'State / Province / Region': `Estado / Provincia / Regi\xf3n`,
    'Street address, P.O. Box, C/O': `Direcci\xf3n`,
    'ZIP / Postal Code': `C\xf3digo Postal`,
    'Select Country': `Seleccionar el Pa\xeds`,
    'Back to Order': `Regresar al Pedido`,
    'Name is required': `Se requiere tu nombre`,
    'Street address is required': `Se requiere tu direcci\xf3n`,
    'City is required': `Se requiere tu ciudad`,
    'State / Province / Region is required': `Se requiere tu Estado / Provincia / Regi\xf3n`,
    'Email is required': `Se requiere tu correo electr\xf3nico `,
    'Valid email is required': `Se requiere tu correo electr\xf3nico `,
    'ZIP / Postal Code is required': `Se requiere tu c\xf3digo postal `,
    '%s is required': `Se requiere tu %s`,
    'Select a Country': `Selecciona tu pa\xeds`,
    Subtotal: `Subtotal`,
    Shipping: `Env\xedo`,
    Taxes: `Impuestos`,
    Handling: `Gesti\xf3n`,
    'Credit Card Fee Offset': `Tarifa de Tarjeta de Cr\xe9dito`,
    'Grand Total': `Total General`,
    'Enter credit card details': `Introduce la informaci\xf3n de tu tarjeta de Cr\xe9dito`,
    'Back to Delivery': `Regresar a Env\xedo`,
    Purchase: `Comprar`,
    'Try Again': `Intentar Nuevamente`,
    Close: `Cerrar`,
    'Confirmed!': `\xa1Confirmado!`,
    'Must be less than 30 characters': `No puede tener m\xe1s de 30 caracteres`,
    // app
    Home: `Inicio`,
    Settings: `Configuraciones`,
    'High quality audio': `Audio de Alta Calidad`,
    'Downloaded audio': `Descargar Audio`,
    Delete: `Borrar`,
    Downloading: `Descargando`,
    'Download all': `Descargar todos`,
    'Delete all': `Borrar todos`,
    queued: `en espera`,
    'No internet': `No hay internet`,
    'Unable to download at this time': `No se puede descargar en este momento`,
    'No internet connection': `No hay conexi\xf3n de internet`,
    'Get it on Google Play': `Disponible en Google Play`,
    'Download on the App Store': `Cons\xedguelo en el App Store`,
    Read: `Leer`,
    Loading: `Cargando`,
    Preferences: `Preferencias`,
    'Continue reading': `Seguir leyendo`,
    'Continue listening': `Seguir escuchando`,
    'No Results': `No hay resultados`,
    'First %s Results': `Los Primeros %s Resultados`,
    '1 Result': `1 Resultado`,
    '%s Results': `%s Resultados`,
    // book publishing metadata
    'Original title': `T\xedtulo original`,
    'Public domain in the USA': `Dominio p\xfablico en los Estados Unidos de Am\xe9rica`,
    'Originally published in %s': `Publicado originalmente en %s`,
    'friendslibrary.com': `bibliotecadelosamigos.org`,
    'info@friendslibrary.com': `info@bibliotecadelosamigos.org`,
    'Text revision %s': `Revisi\xf3n de texto %s`,
    'Created and freely distributed by': `Creado y distribuido gratuitamente por`,
    'Find more free books from early Quakers at': `Encuentre m\xe1s libros gratis de los primeros Cu\xe1queros en`,
    'Published by %s': `Publicado por %s`,
    'Contact the publishers at': `Puede contactarnos en`,
    // speech target
    footnote: `Nota a pie de p\xe1gina`,
    'returning to text': `Volviendo al texto`,
    Back: `Volver`,
    // order invoice
    'Commercial Invoice': `Factura Comercial`,
    'Order Number': `N\xfamero de Pedido`,
    'Order Date': `Fecha del Pedido`,
    Seller: `Vendedor`,
    'Ship To': `Enviar a`,
    'Tax ID': `Identificaci\xf3n Fiscal`,
    'ISBN-13': `ISBN-13`,
    Qty: `Cant.`,
    'Unit Price': `Precio Unitario`,
    Currency: `Moneda`,
    'Payment Status': `Estado del Pago`,
    Paid: `Pagado`,
    Unpaid: `Pendiente`,
    "Complimentary copy \u2014 no charge to recipient": `Ejemplar de cortes\xeda \u{2014} sin cargo para el destinatario`,
    'Value shown for customs purposes only.': `Valor declarado \xfanicamente con fines aduaneros.`,
    'Payment Reference': `Referencia de Pago`,
    'Order Status': `Estado del Pedido`,
    'HS Code': `C\xf3digo Arancelario`,
    'Printed books': `Libros impresos`,
    'Country of Origin': `Pa\xeds de Origen`,
    'United States of America': `Estados Unidos de Am\xe9rica`,
    'Print Invoice': `Imprimir Factura`,
    'Goods are printed books for personal, non-commercial use. Not for resale.': `Estos art\xedculos son libros impresos para uso personal y no comercial. No est\xe1n destinados a la reventa.`,
    'Friends Library Publishing is a U.S. registered 501(c)(3) non-profit organization. Books are sold at production cost and contain no commercial markup.': `Friends Library Publishing es una organizaci\xf3n sin fines de lucro registrada en EE.UU. como 501(c)(3). Los libros se venden al costo de producci\xf3n y no contienen ning\xfan margen comercial.`,
    'This is a system-generated document. Please contact us with any questions at %s.': `Este es un documento generado autom\xe1ticamente. Si tiene preguntas, por favor cont\xe1ctenos en %s.`,
    '501(c)(3) non-profit organization': `Organizaci\xf3n sin fines de lucro 501(c)(3)`,
    'Order Confirmed': `Pedido Confirmado`,
    'Order Shipped': `Pedido Enviado`,
    'Awaiting Fulfillment': `Pendiente de Env\xedo`,
    'View / print your receipt:': `Ver / imprimir tu recibo:`,
    // geography
    Dublin: `Dubl\xedn`,
    Wales: `Gales`,
    Ireland: `Irlanda`,
    'Hemel Hempstead': `Hemel Hempstead`,
    England: `Inglaterra`,
    Scotland: `Escocia`,
    London: `Londres`,
    Philadelphia: `Filadelfia`,
    Pennsylvania: `Pensilvania`,
    Amsterdam: `\xc1msterdam`,
    Netherlands: `Holanda`
};
var $746e4812f3965251$export$2e2bcd8739ae039 = $746e4812f3965251$var$strings;



let $32912afad45a7f51$var$locale = null;
function $32912afad45a7f51$export$625550452a3fa3ec(strings, ...vars) {
    const string = $32912afad45a7f51$export$d73ee8ef04f5226a(strings.join(`%s`));
    return string.replace(`%s`, String(vars[0]));
}
function $32912afad45a7f51$export$7a2e08723259643a(strings, ...vars) {
    const string = $32912afad45a7f51$export$d5d080819904603c(strings.join(`%s`));
    return string.replace(`%s`, String(vars[0]));
}
function $32912afad45a7f51$export$d73ee8ef04f5226a(str) {
    const translation = $32912afad45a7f51$var$getTranslation(str);
    if (translation === null) throw new Error(`missing translation for string: ${str}`);
    return translation;
}
function $32912afad45a7f51$export$d5d080819904603c(str) {
    return $32912afad45a7f51$var$getTranslation(str) ?? str;
}
function $32912afad45a7f51$export$c8aadf3621e41efb(set) {
    $32912afad45a7f51$var$locale = set;
}
function $32912afad45a7f51$var$getTranslation(str) {
    if (!$32912afad45a7f51$var$locale) $32912afad45a7f51$var$locale = $32912afad45a7f51$var$localeFromEnv();
    if ($32912afad45a7f51$var$locale === `es`) {
        const translated = (0, $746e4812f3965251$export$2e2bcd8739ae039)[str];
        if (typeof translated === `string`) return translated;
        else return null;
    }
    return str;
}
function $32912afad45a7f51$var$localeFromEnv() {
    try {
        "undefined" !== `undefined` && $371a3837fd81d701$exports.env;
        if (typeof window !== `undefined`) return document.documentElement.lang === `es` ? `es` : `en`;
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error(`Error determining locale from env`, err);
    }
    return `en`;
}





let $06fa4c238c9d323f$var$_chapterLines = [];
/**
 * Convenience singleton for better ergonomics
 * when building up chapter markup across multiple
 * files and functions
 */ class $06fa4c238c9d323f$var$ChapterMarkup {
    DEFER_STR = `<!-- DEFER OUTPUT -->`;
    paused = false;
    pause() {
        this.paused = true;
    }
    unpause() {
        this.paused = false;
    }
    defer() {
        this.push(this.DEFER_STR);
        this.push(``);
    }
    fulfillDeferred(str) {
        let index = $06fa4c238c9d323f$var$_chapterLines.length - 1;
        let line = $06fa4c238c9d323f$var$_chapterLines[index];
        while(index > 0 && line !== this.DEFER_STR)line = $06fa4c238c9d323f$var$_chapterLines[--index];
        if (line !== this.DEFER_STR) throw new Error(`Unable to fulfill deferred output`);
        $06fa4c238c9d323f$var$_chapterLines[index] = str;
    }
    push(str) {
        !this.paused && $06fa4c238c9d323f$var$_chapterLines.push(str);
    }
    append(str) {
        if (this.paused) return;
        $06fa4c238c9d323f$var$_chapterLines[$06fa4c238c9d323f$var$_chapterLines.length - 1] = `${$06fa4c238c9d323f$var$_chapterLines[$06fa4c238c9d323f$var$_chapterLines.length - 1]}${str}`;
    }
    reset() {
        $06fa4c238c9d323f$var$_chapterLines = [];
    }
    get() {
        return $06fa4c238c9d323f$var$_chapterLines;
    }
}
const $06fa4c238c9d323f$export$ee93807ff92bd69e = new $06fa4c238c9d323f$var$ChapterMarkup();
const $06fa4c238c9d323f$var$c = $06fa4c238c9d323f$export$ee93807ff92bd69e;
function $06fa4c238c9d323f$export$e9ef8cbf00acc805(node) {
    switch(node.meta.subType){
        case (0, $f556b19a33951931$export$c916c075a7028158).LEFT_DOUBLE_CURLY:
            return `\u{201C}`;
        case (0, $f556b19a33951931$export$c916c075a7028158).RIGHT_DOUBLE_CURLY:
            return `\u{201D}`;
        case (0, $f556b19a33951931$export$c916c075a7028158).LEFT_SINGLE_CURLY:
            return `\u{2018}`;
        case (0, $f556b19a33951931$export$c916c075a7028158).RIGHT_SINGLE_CURLY:
            return `\u{2019}`;
        case (0, $f556b19a33951931$export$c916c075a7028158).DOUBLE_DASH:
            return `\u{2014}`;
        case (0, $f556b19a33951931$export$c916c075a7028158).POUND_SYMBOL:
        case (0, $f556b19a33951931$export$c916c075a7028158).DOLLAR_SYMBOL:
        case (0, $f556b19a33951931$export$c916c075a7028158).DEGREE_SYMBOL:
            return node.value;
        default:
            node.print(true);
            throw new Error(`unhandled symbol: ${node.value}`);
    }
}
function $06fa4c238c9d323f$export$178915fa4ada5fa0(tokens) {
    return tokens.map((token)=>{
        switch(token.type){
            case (0, $f556b19a33951931$export$c916c075a7028158).LEFT_DOUBLE_CURLY:
                return `\u{201C}`;
            case (0, $f556b19a33951931$export$c916c075a7028158).RIGHT_DOUBLE_CURLY:
                return `\u{201D}`;
            case (0, $f556b19a33951931$export$c916c075a7028158).LEFT_SINGLE_CURLY:
                return `\u{2018}`;
            case (0, $f556b19a33951931$export$c916c075a7028158).RIGHT_SINGLE_CURLY:
                return `\u{2019}`;
            case (0, $f556b19a33951931$export$c916c075a7028158).DOUBLE_DASH:
                return `\u{2014}`;
            default:
                return token.literal;
        }
    }).join(``);
}
function $06fa4c238c9d323f$export$4997ffc0176396a6(tag, classList) {
    return {
        enter ({ node: node }) {
            const el = typeof tag === `function` ? tag(node) : tag;
            const classes = typeof classList === `function` ? classList(node) : classList;
            el && $06fa4c238c9d323f$var$c.append(`<${el}${$06fa4c238c9d323f$export$574ae795d22dbddd(node, classes) || $06fa4c238c9d323f$export$574ae795d22dbddd(node.parent)}>`);
        },
        exit ({ node: node }) {
            const el = typeof tag === `function` ? tag(node) : tag;
            el && $06fa4c238c9d323f$var$c.append(`</${el}>`);
        }
    };
}
function $06fa4c238c9d323f$export$574ae795d22dbddd(node, classes) {
    classes = [
        ...classes ?? [],
        ...$06fa4c238c9d323f$export$b49e03d1eb3cd13a(node)
    ];
    return classes.length ? ` class="${classes.join(` `)}"` : ``;
}
function $06fa4c238c9d323f$export$b49e03d1eb3cd13a(node) {
    if (node.getMetaData($06fa4c238c9d323f$var$CONSUMED_CLASSES) !== true) {
        node.setMetaData($06fa4c238c9d323f$var$CONSUMED_CLASSES, true);
        return [
            ...node.context?.classList ?? []
        ];
    }
    return [];
}
function $06fa4c238c9d323f$export$6cdbefbf2189cee6(str) {
    if (str.endsWith(`etc.`)) return str;
    return str.replace(/[.,;:]$/, ``);
}
const $06fa4c238c9d323f$export$eab97d15b1788b8d = {
    consumeClasses: $06fa4c238c9d323f$export$b49e03d1eb3cd13a,
    classAttr: $06fa4c238c9d323f$export$574ae795d22dbddd,
    wrap: $06fa4c238c9d323f$export$4997ffc0176396a6,
    joinTokens: $06fa4c238c9d323f$export$178915fa4ada5fa0,
    symbolOutput: $06fa4c238c9d323f$export$e9ef8cbf00acc805,
    trimTrailingPunctuation: $06fa4c238c9d323f$export$6cdbefbf2189cee6
};
const $06fa4c238c9d323f$var$CONSUMED_CLASSES = `__CONSUMED_CLASSES`;



const $5f08f562963a364d$var$visitor = {
    document: {
        enter ({ output: output, context: context, node: node }) {
            (0, $32912afad45a7f51$export$c8aadf3621e41efb)(context.dpc.lang);
            output.push(context.dpc.meta.title.toUpperCase());
            output.push(``);
            if (!context.dpc.isCompilation) {
                output.push(`${(0, $32912afad45a7f51$export$625550452a3fa3ec)`by`} ${context.dpc.meta.author.name.toUpperCase()}\n`);
                output.push(``);
            }
            node.document().epigraphs.children.forEach((epigraph)=>{
                const epigraphLines = [];
                (0, $cd9944187d9cfa79$export$2e2bcd8739ae039)(epigraph, $5f08f562963a364d$var$visitor, epigraphLines, context);
                output.push(epigraphLines.join(``));
            });
        },
        exit ({ output: output, context: { dpc: dpc } }) {
            output.push(`\n`);
            output.push(`\n\n* * *\n`);
            output.push(`${(0, $32912afad45a7f51$export$625550452a3fa3ec)`Published by ${(0, $32912afad45a7f51$export$625550452a3fa3ec)`Friends Library Publishing`.toUpperCase()}`}.`);
            output.push(``);
            output.push(`${(0, $32912afad45a7f51$export$625550452a3fa3ec)`Find more free books from early Quakers at`} www.${(0, $32912afad45a7f51$export$625550452a3fa3ec)`friendslibrary.com`}.\n`);
            output.push(`${(0, $32912afad45a7f51$export$625550452a3fa3ec)`Public domain in the USA`}.\n`);
            output.push(`${(0, $32912afad45a7f51$export$625550452a3fa3ec)`Contact the publishers at`} ${(0, $32912afad45a7f51$export$625550452a3fa3ec)`info@friendslibrary.com`}.\n`);
            output.push(`ISBN: ${dpc.meta.isbn}\n`);
            output.push(`${(0, $32912afad45a7f51$export$625550452a3fa3ec)`Text revision ${dpc.revision.sha}`} - `);
            $5f08f562963a364d$var$append(output, new Date(dpc.revision.timestamp * 1000).toLocaleDateString(dpc.lang));
        }
    },
    footnote: {
        enter ({ node: node, output: output, context: context }) {
            if (node.children.length === 1) {
                context.inlineFootnote = true;
                $5f08f562963a364d$var$append(output, ` [${(0, $32912afad45a7f51$export$625550452a3fa3ec)`footnote`}: `);
                const paragraph = node.children.shift();
                node.children = (paragraph ?? {
                    children: []
                }).children;
            } else {
                output.push(``);
                output.push(`[${(0, $32912afad45a7f51$export$625550452a3fa3ec)`footnote`}:]`);
                output.push(``);
            }
        },
        exit ({ context: context, output: output }) {
            if (context.inlineFootnote) {
                context.inlineFootnote = false;
                $5f08f562963a364d$var$append(output, ` --${(0, $32912afad45a7f51$export$625550452a3fa3ec)`returning to text`}.]`);
            } else {
                output.push(``);
                output.push(`[--${(0, $32912afad45a7f51$export$625550452a3fa3ec)`returning to text`}.]`);
                output.push(``);
                output.push(``);
            }
        }
    },
    listItem: {
        enter ({ output: output }) {
            $5f08f562963a364d$var$append(output, `- `);
        },
        exit: $5f08f562963a364d$var$pushLine
    },
    money: {
        enter ({ node: node, output: output }) {
            let moneyStr = node.value.replace(/^./, ``);
            const currencyType = node.meta?.data?.currencyType;
            moneyStr += ` ${currencyType === `POUND_SYMBOL` ? `pound` : `dollar`}`;
            const amount = Number(node.meta?.data?.amount);
            if (amount > 1) moneyStr += `s`;
            $5f08f562963a364d$var$append(output, moneyStr);
        }
    },
    verseStanza: {
        enter: $5f08f562963a364d$var$pushLine
    },
    verseLine: {
        exit: $5f08f562963a364d$var$pushLine
    },
    symbol: {
        enter ({ node: node, output: output }) {
            $5f08f562963a364d$var$append(output, (0, $06fa4c238c9d323f$export$e9ef8cbf00acc805)(node));
        }
    },
    entity: {
        enter ({ node: node, output: output }) {
            switch(node.meta.subType){
                case `ELLIPSES`:
                    return $5f08f562963a364d$var$append(output, `...`);
                case `EMDASH`:
                    return $5f08f562963a364d$var$append(output, `\u{2014}`);
                case `AMPERSAND`:
                    return $5f08f562963a364d$var$append(output, `&`);
                default:
                    node.print(true);
                    throw new Error(`unhandled entity: ${node.value}`);
            }
        }
    },
    paragraph: {
        enter ({ output: output, node: node, context: context }) {
            const parent = node.parent;
            output.push(``);
            const SIGNATURE = `signed-section-signature`;
            if ($5f08f562963a364d$var$hasClass(parent, SIGNATURE) || $5f08f562963a364d$var$hasClass(node, SIGNATURE)) $5f08f562963a364d$var$append(output, `Signed, `);
            // wrap quotes around epigraphs
            if (parent.meta.subType === `quote` && parent.context?.type === `epigraph`) {
                const first = node.children[0];
                if (first?.type === `SYMBOL` && first.meta.subType === `LEFT_DOUBLE_CURLY`) return;
                $5f08f562963a364d$var$append(output, `\u{201C}`);
                context.quotifyEpigraph = true;
            }
        },
        exit ({ output: output, context: context }) {
            if (context.quotifyEpigraph) {
                $5f08f562963a364d$var$append(output, `\u{201D}`);
                context.quotifyEpigraph = false;
            }
            output.push(``);
        }
    },
    heading: {
        enter: $5f08f562963a364d$var$pushLine,
        exit: $5f08f562963a364d$var$pushLine
    },
    headingSequenceIdentifier: {
        enter ({ node: node, output: output }) {
            $5f08f562963a364d$var$append(output, node.value.toUpperCase());
        }
    },
    redacted: {
        enter ({ output: output }) {
            $5f08f562963a364d$var$append(output, `[name removed]`);
        }
    },
    text: {
        enter (data) {
            const { node: node, output: output } = data;
            if (($5f08f562963a364d$var$getParentOfType(node, `HEADING`)?.meta.level ?? 5) < 4) return $5f08f562963a364d$var$append(output, node.value.toUpperCase());
            if ($5f08f562963a364d$var$isChildOfType(node, `DESCRIPTION_LIST_ITEM_TERM`)) return $5f08f562963a364d$var$append(output, node.value.toUpperCase());
            $5f08f562963a364d$var$appendNodeValue(data);
        }
    },
    descriptionListItemTerm: {
        exit ({ output: output }) {
            $5f08f562963a364d$var$append(output, `: `);
        }
    },
    descriptionList: {
        enter: $5f08f562963a364d$var$pushLine
    },
    descriptionListItem: {
        exit ({ output: output }) {
            output.push(``);
            output.push(``);
        }
    },
    unorderedList: {
        enter ({ node: node, output: output }) {
            if ($5f08f562963a364d$var$hasClass(node, `chapter-synopsis`)) node.children = [];
            else output.push(``);
        }
    },
    block: {
        exit ({ node: node, output: output }) {
            const { meta: meta, context: context } = node;
            if (meta?.subType === `quote` && (context?.quoteSource || context?.quoteAttribution)) {
                $5f08f562963a364d$var$append(output, ` \u{2014}`);
                if (context.quoteAttribution) {
                    $5f08f562963a364d$var$append(output, context.quoteAttribution.map((t)=>t.literal).join(``));
                    if (context.quoteSource) $5f08f562963a364d$var$append(output, `, `);
                }
                if (context.quoteSource) $5f08f562963a364d$var$append(output, context.quoteSource.map((t)=>t.literal).join(``));
                output.push(`\n`);
            }
        }
    },
    xref: {
        enter () {},
        exit ({ node: node, output: output, context: { dpc: dpc } }) {
            const target = node.getMetaData(`target`);
            if (typeof target !== `string`) return;
            const document = node.document();
            const section = document.embeddableSections[target];
            if (section === undefined) return;
            output.push(``);
            output.push(`[${(0, $32912afad45a7f51$export$625550452a3fa3ec)`footnote`}:]`);
            output.push(``);
            // render the embedded note here...
            (0, $1ab4cbc8fcb467c7$export$a25007406b5d996e)(section, dpc).forEach((line)=>output.push(line));
            output.push(``);
            output.push(`[--${(0, $32912afad45a7f51$export$625550452a3fa3ec)`returning to text`}.]`);
            output.push(``);
            output.push(``);
            // and then mutate it, clearing children so it doesn't render twice
            section.children = [];
        }
    },
    node: {
        enter: $5f08f562963a364d$var$appendNodeValue
    }
};
var $5f08f562963a364d$export$2e2bcd8739ae039 = $5f08f562963a364d$var$visitor;
function $5f08f562963a364d$var$pushLine({ output: output }) {
    output.push(``);
}
function $5f08f562963a364d$var$appendNodeValue({ node: node, output: output }) {
    $5f08f562963a364d$var$append(output, node.value);
}
function $5f08f562963a364d$var$append(output, str) {
    let line = output.pop() ?? ``;
    line += str;
    output.push(line);
}
function $5f08f562963a364d$var$getParentOfType(node, nodeType) {
    let current = node.parent;
    while(current.type !== `DOCUMENT`){
        if (current.type === nodeType) return current;
        current = current.parent;
    }
    return null;
}
function $5f08f562963a364d$export$d3a562da4d94432c(node, className) {
    let current = node.parent;
    while(current.type !== `DOCUMENT`){
        if ($5f08f562963a364d$var$hasClass(current, className)) return true;
        current = current.parent;
    }
    return false;
}
function $5f08f562963a364d$var$isChildOfType(node, nodeType) {
    return $5f08f562963a364d$var$getParentOfType(node, nodeType) !== null;
}
function $5f08f562963a364d$var$hasClass(node, className) {
    return node.context?.classList.includes(className) ?? false;
}


function $1ab4cbc8fcb467c7$export$5ae66ca102e22691(dpc) {
    const document = (0, $a8d03726b9ff868b$export$2e2bcd8739ae039).parseDocument(...dpc.asciidocFiles);
    const lines = $1ab4cbc8fcb467c7$export$a25007406b5d996e(document, dpc);
    return lines.reduce((doc, line, idx)=>{
        // prevent more than 2 line breaks in a row
        const join = line === `` && lines[idx - 1] === `` ? `` : `\n`;
        return `${doc}${join}${line.trimStart()}`;
    }, ``).trim();
}
function $1ab4cbc8fcb467c7$export$14a04967aee91de1(dpc) {
    return `<!DOCTYPE html>
<html>
<head>
<meta charset="UTF-8" />
<title>${dpc.meta.title}</title>
</head>
<body>
${$1ab4cbc8fcb467c7$export$5ae66ca102e22691(dpc).trim().replace(/\n/g, `\n<br />`)}
</body>
</html>`;
}
function $1ab4cbc8fcb467c7$export$a25007406b5d996e(node, dpc) {
    const lines = [];
    (0, $cd9944187d9cfa79$export$2e2bcd8739ae039)(node, (0, $5f08f562963a364d$export$2e2bcd8739ae039), lines, {
        dpc: dpc
    });
    return lines;
}





class $8407fb9105d52787$export$2e2bcd8739ae039 {
    enter({ node: node }) {
        const classList = node.context?.classList ?? [];
        (0, $06fa4c238c9d323f$export$ee93807ff92bd69e).push(`<figure${(0, $06fa4c238c9d323f$export$574ae795d22dbddd)(node, [
            `attributed-quote`
        ])}>`);
        (0, $06fa4c238c9d323f$export$ee93807ff92bd69e).push(`<blockquote${(0, $06fa4c238c9d323f$export$574ae795d22dbddd)(node, classList)}>`);
    }
    exit({ node: node }) {
        const cite = (0, $06fa4c238c9d323f$export$eab97d15b1788b8d).joinTokens(node.context?.quoteSource ?? []);
        const attribution = $8407fb9105d52787$var$getAttribution(node);
        (0, $06fa4c238c9d323f$export$ee93807ff92bd69e).push(`</blockquote>`);
        (0, $06fa4c238c9d323f$export$ee93807ff92bd69e).push(`<figcaption>${attribution}<cite>${cite}</cite></figcaption>`);
        (0, $06fa4c238c9d323f$export$ee93807ff92bd69e).push(`</figure>`);
    }
}
function $8407fb9105d52787$var$getAttribution(node) {
    if (node.context?.quoteAttribution?.length) {
        const src = (0, $06fa4c238c9d323f$export$eab97d15b1788b8d).joinTokens(node.context.quoteAttribution);
        return `<span class="quote-attribution">${src}</span>`;
    }
    return ``;
}





function $eb25fcc43542a0a4$export$2e2bcd8739ae039(chapter) {
    if (chapter.type !== (0, $f556b19a33951931$export$845480b930b0e280).CHAPTER) throw new Error(`Unexpected non-chapter arg passed to evalShortChapterHeading()`);
    // always evaluate to set up the rich metadata on the chapter...
    const heading = chapter.expectFirstChild((0, $f556b19a33951931$export$845480b930b0e280).HEADING);
    const output = {
        string: ``,
        buffer: ``
    };
    (0, $cd9944187d9cfa79$export$2e2bcd8739ae039)(heading, $eb25fcc43542a0a4$var$visitor, output, {});
    const shortHeading = (0, $06fa4c238c9d323f$export$6cdbefbf2189cee6)(output.string);
    // ...but prefer an explicitly set short title
    if (chapter.context?.shortTitle) return (0, $06fa4c238c9d323f$export$178915fa4ada5fa0)(chapter.context.shortTitle);
    return shortHeading;
}
const $eb25fcc43542a0a4$var$visitor = {
    headingSequenceIdentifier: {
        enter ({ node: node, output: output }) {
            output.string = `${node.getMetaData(`kind`)} ${node.getMetaData(`roman`)}`;
            if (node.nextSibling()) output.string += ` ${(0, $9663980678ef0204$export$dec6b13405c072f0).MDASH} `;
        }
    },
    headingTitle: {
        enter ({ output: output }) {
            // buffer up everything evaluated inside `HEADING_TITLE` node
            // so we can set the metaData
            output.buffer = output.string;
            output.string = ``;
        },
        exit ({ node: node, output: output }) {
            node.chapter.setMetaData(`nonSequenceTitle`, output.string);
            // restore output from buffer
            output.string = output.buffer + output.string;
        }
    },
    symbolInHeadingSegment: {
        enter ({ node: node, output: output }) {
            if (node.parent.meta.level === 1) output.string += (0, $06fa4c238c9d323f$export$e9ef8cbf00acc805)(node);
        }
    },
    textInHeadingSegment: {
        enter ({ node: node, output: output }) {
            if (node.parent.meta.level === 1) output.string += node.value;
        }
    },
    entityInHeadingSegment: {
        enter ({ node: node, output: output }) {
            if (node.parent.meta.level === 1) output.string += node.value;
        }
    },
    entityInHeading: {
        enter ({ node: node, output: output }) {
            output.string += node.value;
        }
    },
    text: {
        enter ({ node: node, output: output }) {
            if (!node.isInFootnote()) output.string += node.value;
        }
    },
    symbol: {
        enter ({ node: node, output: output }) {
            output.string += (0, $06fa4c238c9d323f$export$e9ef8cbf00acc805)(node);
        }
    },
    inlinePassthrough: {
        enter ({ node: node, output: output }) {
            if (node.value.match(/^<br ?\/?>$/)) output.string += ` `;
        }
    }
};



const $5033327e5df740fe$var$HeadingVisitor = {
    heading: {
        dispatch ({ node: node }) {
            if (!$5033327e5df740fe$var$isChapter(node)) return {
                enter ({ node: node }) {
                    const el = `h${$5033327e5df740fe$var$level(node)}`;
                    const id = node.parent.context?.id ? ` id="${node.parent.context.id}" ` : ``;
                    (0, $06fa4c238c9d323f$export$ee93807ff92bd69e).append(`<${el}${id}${(0, $06fa4c238c9d323f$export$eab97d15b1788b8d).classAttr(node) || (0, $06fa4c238c9d323f$export$eab97d15b1788b8d).classAttr(node.parent)}>`);
                },
                exit ({ node: node }) {
                    (0, $06fa4c238c9d323f$export$ee93807ff92bd69e).append(`</h${$5033327e5df740fe$var$level(node)}>`);
                }
            };
            return this;
        },
        enter () {
            (0, $06fa4c238c9d323f$export$ee93807ff92bd69e).defer();
        },
        exit ({ node: node }) {
            const chapter = node.chapter;
            const short = (0, $eb25fcc43542a0a4$export$2e2bcd8739ae039)(chapter);
            chapter.setMetaData(`shortChapterHeading`, short);
            (0, $06fa4c238c9d323f$export$ee93807ff92bd69e).fulfillDeferred(`<header class="chapter-heading" data-short="${short}">`);
            (0, $06fa4c238c9d323f$export$ee93807ff92bd69e).push(`</header>`);
        }
    },
    headingSequenceIdentifier: {
        enter ({ node: node }) {
            const el = $5033327e5df740fe$var$isChapter(node.parent) ? `h2` : `span`;
            const kind = node.getMetaData(`kind`);
            const roman = node.getMetaData(`roman`);
            const sequenceNumber = node.expectNumberMetaData(`number`);
            node.chapter.setMetaData(`sequenceNumber`, sequenceNumber);
            if (node.isOnlyChild()) {
                (0, $06fa4c238c9d323f$export$ee93807ff92bd69e).push(`<${el}>${kind} ${roman}</${el}>`);
                return;
            }
            const kls = `chapter-heading__sequence`;
            (0, $06fa4c238c9d323f$export$ee93807ff92bd69e).push(`<${el} class="${kls}">`);
            (0, $06fa4c238c9d323f$export$ee93807ff92bd69e).push(`${kind} <span class="${kls}__number">${roman}</span>`);
            (0, $06fa4c238c9d323f$export$ee93807ff92bd69e).push(`</${el}>`);
        }
    },
    headingTitle: {
        enter ({ node: node }) {
            if (!$5033327e5df740fe$var$isChapter(node.parent)) return;
            if (node.isFirstChild()) (0, $06fa4c238c9d323f$export$ee93807ff92bd69e).push(`<h2>`);
            else (0, $06fa4c238c9d323f$export$ee93807ff92bd69e).push(`<div class="chapter-heading__title">`);
        },
        exit ({ node: node }) {
            if (!$5033327e5df740fe$var$isChapter(node.parent)) return;
            if (node.isFirstChild()) (0, $06fa4c238c9d323f$export$ee93807ff92bd69e).push(`</h2>`);
            else (0, $06fa4c238c9d323f$export$ee93807ff92bd69e).push(`</div>`);
        }
    }
};
var $5033327e5df740fe$export$2e2bcd8739ae039 = $5033327e5df740fe$var$HeadingVisitor;
function $5033327e5df740fe$var$level(node) {
    const headingLevel = node.meta?.level;
    if (typeof headingLevel === `undefined`) {
        node.print();
        throw new Error(`Unexpected missing level for heading node`);
    }
    return headingLevel;
}
function $5033327e5df740fe$var$isChapter(node) {
    return $5033327e5df740fe$var$level(node) === 2;
}




class $80f02115b0921b3d$export$2e2bcd8739ae039 {
    subGroupIsOpen = false;
    enter({ node: node }) {
        const el = $80f02115b0921b3d$var$isChapterSubtitleBlurb(node) ? `h3` : `p`;
        if ($80f02115b0921b3d$var$opensNumberedSubgroup(node)) {
            (0, $06fa4c238c9d323f$export$ee93807ff92bd69e).push(`<div${(0, $06fa4c238c9d323f$export$eab97d15b1788b8d).classAttr(node)}>`);
            // this seems like a smell... i think it's telling me
            // that the parser should be creating a wrapping node
            // so that the evaluator doesn't have to be this smart or stateful...
            this.subGroupIsOpen = true;
        }
        (0, $06fa4c238c9d323f$export$ee93807ff92bd69e).push(`<${el}${$80f02115b0921b3d$var$classAttr(el, node)}>`);
    }
    exit({ node: node }) {
        const el = $80f02115b0921b3d$var$isChapterSubtitleBlurb(node) ? `h3` : `p`;
        (0, $06fa4c238c9d323f$export$ee93807ff92bd69e).push(`</${el}>`);
        if (this.closesNumberedSubgroup(node)) {
            (0, $06fa4c238c9d323f$export$ee93807ff92bd69e).push(`</div>`);
            this.subGroupIsOpen = false;
        }
    }
    closesNumberedSubgroup(node) {
        if (!this.subGroupIsOpen) return false;
        return !!(node.parent.hasClass(`numbered-group`) && (node.isLastChild() || node.nextSibling()?.hasClass(`numbered`) || node.nextSibling()?.type !== (0, $f556b19a33951931$export$845480b930b0e280).PARAGRAPH));
    }
}
function $80f02115b0921b3d$var$opensNumberedSubgroup(node) {
    return node.hasClass(`numbered`);
}
function $80f02115b0921b3d$var$isChapterSubtitleBlurb(node) {
    return node.hasClass(`chapter-subtitle--blurb`) || node.parent.hasClass(`chapter-subtitle--blurb`);
}
function $80f02115b0921b3d$var$classAttr(el, node) {
    let htmlAttr = (0, $06fa4c238c9d323f$export$eab97d15b1788b8d).classAttr(node) || (0, $06fa4c238c9d323f$export$eab97d15b1788b8d).classAttr(node.parent);
    if (el === `h3`) return htmlAttr;
    if (htmlAttr === ``) htmlAttr = ` class="paragraph"`;
    else if (htmlAttr.includes(`emphasized`)) htmlAttr = htmlAttr.replace(`class="`, `class="paragraph `);
    return htmlAttr;
}



const $76cf7427665b84d4$var$FootnoteVisitor = {
    blockInFootnote: {
        dispatch ({ node: node, context: context }) {
            if (!node.isPoetryBlock()) throw new Error(`Unexpected block type within footnote.`);
            return $76cf7427665b84d4$var$isEbook(context) ? {} : (0, $06fa4c238c9d323f$export$4997ffc0176396a6)(`span`, [
                `poetry`
            ]);
        }
    },
    paragraphInFootnote: {
        dispatch ({ context: context }) {
            if ($76cf7427665b84d4$var$isEbook(context)) return {};
            return (0, $06fa4c238c9d323f$export$4997ffc0176396a6)((n)=>n.hasSiblings() ? `span` : null, [
                `footnote-paragraph`
            ]);
        }
    },
    footnote: {
        dispatch ({ context: context, node: node }) {
            if (!$76cf7427665b84d4$var$isEbook(context)) return (0, $06fa4c238c9d323f$export$4997ffc0176396a6)(`span`, [
                `footnote`
            ]);
            const [num, marker] = $76cf7427665b84d4$export$d9e849fdd85b511d(node, false);
            return {
                enter () {
                    (0, $06fa4c238c9d323f$export$ee93807ff92bd69e).push($76cf7427665b84d4$export$31dac9670e5720eb(num, marker, `notes`));
                    (0, $06fa4c238c9d323f$export$ee93807ff92bd69e).pause();
                },
                exit () {
                    (0, $06fa4c238c9d323f$export$ee93807ff92bd69e).unpause();
                }
            };
        }
    }
};
var $76cf7427665b84d4$export$2e2bcd8739ae039 = $76cf7427665b84d4$var$FootnoteVisitor;
function $76cf7427665b84d4$export$d9e849fdd85b511d(footnote, helperNoteAlreadyPrepended = false) {
    const document = footnote.document();
    const footnotes = document.footnotes.children;
    let numFootnotes = footnotes.length;
    let index = footnotes.indexOf(footnote);
    if (!helperNoteAlreadyPrepended) {
        index += 1;
        numFootnotes += 1;
    }
    const number = index + 1;
    const marker = $76cf7427665b84d4$export$9c42aa7141cb1427(numFootnotes, index);
    const file = footnote.getMetaData(`isFootnoteHelper`) ? `footnote-helper` : `chapter-${document.chapters.indexOf(footnote.chapter) + 1}`;
    return [
        number,
        marker,
        file
    ];
}
function $76cf7427665b84d4$export$9c42aa7141cb1427(numTotalFootnotes, footnoteIndex) {
    const number = footnoteIndex + 1;
    let marker = String(number);
    if (numTotalFootnotes < 5 && footnoteIndex <= 3) marker = [
        `\xa7`,
        `*`,
        `\u{2020}`,
        `\u{2021}`
    ][footnoteIndex] ?? ``;
    return marker;
}
function $76cf7427665b84d4$var$isEbook(context) {
    return context.target === `ebook`;
}
function $76cf7427665b84d4$export$31dac9670e5720eb(num, marker, file) {
    return [
        `<sup class="footnote" id="fn-call__${num}">`,
        `<a href="${file}.xhtml#fn__${num}" title="View footnote.">${marker}</a>`,
        `</sup>`
    ].join(`\n`);
}



const $8e6a28ae6624ebb3$var$PrimitivesVisitor = {
    entity: {
        enter ({ node: node }) {
            // always use decimal versions, works for BOTH ebook and browsers
            (0, $06fa4c238c9d323f$export$ee93807ff92bd69e).append(node.expectStringMetaData(`decimalEntity`));
        }
    },
    text: {
        enter ({ node: node }) {
            (0, $06fa4c238c9d323f$export$ee93807ff92bd69e).append(node.value);
        }
    },
    redacted: {
        enter ({ node: node }) {
            (0, $06fa4c238c9d323f$export$ee93807ff92bd69e).append(node.value);
        }
    },
    blockPassthrough: {
        enter ({ node: node }) {
            (0, $06fa4c238c9d323f$export$ee93807ff92bd69e).append(node.value);
        }
    },
    inlinePassthrough: {
        enter ({ node: node }) {
            (0, $06fa4c238c9d323f$export$ee93807ff92bd69e).append(node.value);
        }
    },
    symbol: {
        enter ({ node: node }) {
            (0, $06fa4c238c9d323f$export$ee93807ff92bd69e).append((0, $06fa4c238c9d323f$export$eab97d15b1788b8d).symbolOutput(node));
        }
    },
    money: {
        enter ({ node: node }) {
            (0, $06fa4c238c9d323f$export$ee93807ff92bd69e).append(node.value);
        }
    },
    xref: {
        enter ({ node: node, context: { target: target, lang: lang } }) {
            const xrefTarget = node.expectStringMetaData(`target`);
            const isLinkableBack = !!node.getMetaData(`isLinkableBack`);
            const id = isLinkableBack ? `` : ` id="${xrefTarget}__xref_src"`;
            const cls = isLinkableBack ? `__xref __xref-linkable-back` : `__xref`;
            let href = `#${xrefTarget}`;
            if (target === `ebook`) {
                const targetChapter = node.document().idChapterLocations[xrefTarget];
                if (targetChapter === undefined) throw new Error(`Missing xref chapter location for #${xrefTarget}`);
                href = `chapter-${targetChapter}.xhtml${href}`;
            }
            // APPEND not PUSH is important for tight wrapping like [See <<note-A,Appendix BB.>>]
            (0, $06fa4c238c9d323f$export$ee93807ff92bd69e).append(`<a${id} class="${cls}" href="${href}">`);
            if (isLinkableBack) {
                let text = $8e6a28ae6624ebb3$var$RETURN_SYMBOL_DECIMAL_ENTITY;
                if (target === `pdf` && lang === `en`) text = `&larr; Back`;
                else if (target === `pdf`) text = `&larr; Backito`;
                (0, $06fa4c238c9d323f$export$ee93807ff92bd69e).append(text);
            }
        },
        exit () {
            (0, $06fa4c238c9d323f$export$ee93807ff92bd69e).append(`</a>`);
        }
    },
    inline: (0, $06fa4c238c9d323f$export$4997ffc0176396a6)(`span`),
    unorderedList: (0, $06fa4c238c9d323f$export$4997ffc0176396a6)(`ul`),
    listItem: (0, $06fa4c238c9d323f$export$4997ffc0176396a6)(`li`),
    strong: (0, $06fa4c238c9d323f$export$4997ffc0176396a6)(`b`),
    emphasis: (0, $06fa4c238c9d323f$export$4997ffc0176396a6)(`em`),
    descriptionList: (0, $06fa4c238c9d323f$export$4997ffc0176396a6)(`dl`),
    descriptionListItemTerm: (0, $06fa4c238c9d323f$export$4997ffc0176396a6)(`dt`),
    descriptionListItemContent: (0, $06fa4c238c9d323f$export$4997ffc0176396a6)(`dd`),
    verseLine: (0, $06fa4c238c9d323f$export$4997ffc0176396a6)(`span`, [
        `verse-line`
    ]),
    verseStanza: (0, $06fa4c238c9d323f$export$4997ffc0176396a6)((n)=>n.isInFootnote() ? `span` : `div`, (n)=>!n.isInFootnote() && n.children.length > $8e6a28ae6624ebb3$var$LONG_VERSE_STANZA_THRESHOLD ? [
            `verse-stanza`,
            `verse-stanza--long`
        ] : [
            `verse-stanza`
        ])
};
var $8e6a28ae6624ebb3$export$2e2bcd8739ae039 = $8e6a28ae6624ebb3$var$PrimitivesVisitor;
const $8e6a28ae6624ebb3$var$RETURN_SYMBOL_DECIMAL_ENTITY = `&#9166;`;
// longer stanzas may break across pages; shorter ones stay together as one unit
const $8e6a28ae6624ebb3$var$LONG_VERSE_STANZA_THRESHOLD = 10;


const $901e6f21036e2df7$var$documentVisitor = {
    chapter: {
        enter ({ node: node, output: output, index: index }) {
            (0, $06fa4c238c9d323f$export$ee93807ff92bd69e).reset();
            output.push((0, $06fa4c238c9d323f$export$ee93807ff92bd69e).get());
            const { context: context } = node;
            const hasSignedSection = node.getMetaData(`hasSignedSection`) === true;
            const classes = [
                `chapter`,
                `chapter-${index + 1}`,
                `chapter--${hasSignedSection ? `has` : `no`}-signed-section`,
                ...(0, $06fa4c238c9d323f$export$eab97d15b1788b8d).consumeClasses(node)
            ];
            const id = context?.id ? context.id : `chapter-${index + 1}`;
            node.setMetaData(`id`, id);
            (0, $06fa4c238c9d323f$export$ee93807ff92bd69e).push(`<div id="${id}" class="${classes.join(` `)}">`);
        },
        exit () {
            (0, $06fa4c238c9d323f$export$ee93807ff92bd69e).push(`</div>`);
        }
    },
    block: {
        dispatch ({ node: node }) {
            if (node.isAttributedQuoteBlock()) return new (0, $8407fb9105d52787$export$2e2bcd8739ae039)();
            else if (node.isPoetryBlock()) return (0, $06fa4c238c9d323f$export$4997ffc0176396a6)(`section`, [
                `poetry`
            ]);
            else if (node.isQuoteBlock()) return (0, $06fa4c238c9d323f$export$4997ffc0176396a6)(`blockquote`);
            else if (node.isExampleBlock() || node.isOpenBlock()) return (0, $06fa4c238c9d323f$export$4997ffc0176396a6)(`div`);
            else return {};
        }
    },
    thematicBreak: {
        enter ({ node: node }) {
            if (node.hasClass(`asterism`)) (0, $06fa4c238c9d323f$export$ee93807ff92bd69e).push(`<div class="asterism">*&#160;&#160;*&#160;&#160;*</div>`);
            else if (node.hasClass(`small-break`)) (0, $06fa4c238c9d323f$export$ee93807ff92bd69e).push(`<div class="small-break"></div>`);
        }
    },
    postscriptIdentifier: {
        enter ({ node: node }) {
            (0, $06fa4c238c9d323f$export$ee93807ff92bd69e).append(`<em>${node.value}</em>`);
        }
    },
    discoursePartIdentifier: {
        enter ({ node: node }) {
            (0, $06fa4c238c9d323f$export$ee93807ff92bd69e).append(`<em>${node.value}</em>`);
        }
    },
    headingSegment: {
        enter ({ node: node }) {
            (0, $06fa4c238c9d323f$export$ee93807ff92bd69e).append(`<span class="heading-segment heading-segment--${node.meta.level}">`);
        },
        exit () {
            (0, $06fa4c238c9d323f$export$ee93807ff92bd69e).append(`</span>`);
        }
    },
    paragraph: new (0, $80f02115b0921b3d$export$2e2bcd8739ae039)(),
    ...(0, $8e6a28ae6624ebb3$export$2e2bcd8739ae039),
    ...(0, $5033327e5df740fe$export$2e2bcd8739ae039),
    ...(0, $76cf7427665b84d4$export$2e2bcd8739ae039)
};
var $901e6f21036e2df7$export$2e2bcd8739ae039 = $901e6f21036e2df7$var$documentVisitor;





function $65618736d6f68d95$export$2e2bcd8739ae039(document, lang) {
    if (document.epigraphs.children.length === 0) return ``;
    const output = [];
    (0, $cd9944187d9cfa79$export$2e2bcd8739ae039)(document.epigraphs, $65618736d6f68d95$var$visitor, output, {
        target: `pdf`,
        lang: lang
    });
    return (output[0] || []).join(`\n`);
}
const $65618736d6f68d95$var$visitor = {
    collection: {
        enter ({ output: output }) {
            (0, $06fa4c238c9d323f$export$ee93807ff92bd69e).reset();
            output.push((0, $06fa4c238c9d323f$export$ee93807ff92bd69e).get());
            (0, $06fa4c238c9d323f$export$ee93807ff92bd69e).push(`<div class="epigraphs own-page">`);
        },
        exit () {
            (0, $06fa4c238c9d323f$export$ee93807ff92bd69e).push(`</div>`);
        }
    },
    block: {
        enter ({ index: index }) {
            (0, $06fa4c238c9d323f$export$ee93807ff92bd69e).push(`<div class="epigraph${index > 0 ? ` epigraph--not-first` : ``}">`);
            (0, $06fa4c238c9d323f$export$ee93807ff92bd69e).push(`<span class="epigraph__text">`);
        },
        exit ({ node: node }) {
            (0, $06fa4c238c9d323f$export$ee93807ff92bd69e).push(`</span>`);
            (0, $06fa4c238c9d323f$export$ee93807ff92bd69e).push(`<span class="epigraph__source">${(0, $06fa4c238c9d323f$export$178915fa4ada5fa0)(node.context?.quoteSource ?? [])}</span>`);
            (0, $06fa4c238c9d323f$export$ee93807ff92bd69e).push(`</div>`);
        }
    },
    ...(0, $8e6a28ae6624ebb3$export$2e2bcd8739ae039)
};


class $459db2bf4c2e1243$export$2e2bcd8739ae039 {
    index;
    content;
    shortHeading;
    isIntermediateTitle;
    sequenceNumber;
    nonSequenceTitle;
    customId;
    constructor(index, content, shortHeading, isIntermediateTitle, sequenceNumber, nonSequenceTitle, customId){
        this.index = index;
        this.content = content;
        this.shortHeading = shortHeading;
        this.isIntermediateTitle = isIntermediateTitle;
        this.sequenceNumber = sequenceNumber;
        this.nonSequenceTitle = nonSequenceTitle;
        this.customId = customId;
    }
    get id() {
        return this.customId ?? this.slug;
    }
    get slug() {
        return `chapter-${this.index + 1}`;
    }
    get isSequenced() {
        return typeof this.sequenceNumber === `number`;
    }
    get hasNonSequenceTitle() {
        return typeof this.nonSequenceTitle === `string`;
    }
}


class $9013d1c4f9e18026$export$2e2bcd8739ae039 {
    output;
    document;
    lang;
    _chapters;
    constructor(output, document, lang){
        this.output = output;
        this.document = document;
        this.lang = lang;
        this._chapters = null;
    }
    get numFootnotes() {
        return this.document.footnotes.children.length;
    }
    get hasFootnotes() {
        return this.numFootnotes > 0;
    }
    get numChapters() {
        return this.chapters.length;
    }
    get hasEpigraphs() {
        return this.document.epigraphs.children.length > 0;
    }
    get epigraphHtml() {
        return (0, $65618736d6f68d95$export$2e2bcd8739ae039)(this.document, this.lang);
    }
    get chapters() {
        if (this._chapters) return this._chapters;
        this._chapters = this.document.chapters.map((chapter, idx)=>{
            const chapterOutput = this.output[idx];
            if (chapterOutput === undefined) throw new Error(`Unexpected missing chapter output for index=${idx}`);
            let sequenceNumber;
            try {
                sequenceNumber = chapter.expectNumberMetaData(`sequenceNumber`);
            } catch  {
            // ¯\_(ツ)_/¯
            }
            let nonSequenceTitle;
            try {
                nonSequenceTitle = chapter.expectStringMetaData(`nonSequenceTitle`);
            } catch  {
            // ¯\_(ツ)_/¯
            }
            return new (0, $459db2bf4c2e1243$export$2e2bcd8739ae039)(idx, chapterOutput.join(`\n`), chapter.expectStringMetaData(`shortChapterHeading`), chapter.hasClass(`intermediate-title`), sequenceNumber, nonSequenceTitle, chapter.expectStringMetaData(`id`));
        });
        return this._chapters;
    }
}


class $aa30c6eabff3a1c2$export$2e2bcd8739ae039 extends (0, $9013d1c4f9e18026$export$2e2bcd8739ae039) {
    mergedChapterHtml(startIndex = 0, endIndex = Infinity) {
        return this.chapters.slice(startIndex, endIndex).map(({ content: html })=>html).join(`\n\n`);
    }
}






const $9fcf74fd41363ee7$var$EbookFootnoteContentVisitor = {
    collection: {
        enter ({ output: output }) {
            (0, $06fa4c238c9d323f$export$ee93807ff92bd69e).reset();
            output.push((0, $06fa4c238c9d323f$export$ee93807ff92bd69e).get());
            (0, $06fa4c238c9d323f$export$ee93807ff92bd69e).push(`<div id="footnotes">`);
        },
        exit () {
            (0, $06fa4c238c9d323f$export$ee93807ff92bd69e).push(`</div>`);
        }
    },
    footnote: {
        enter ({ node: node }) {
            const [num, marker, file] = (0, $76cf7427665b84d4$export$d9e849fdd85b511d)(node, true);
            (0, $06fa4c238c9d323f$export$ee93807ff92bd69e).push(`<div class="footnote" id="fn__${num}">`);
            (0, $06fa4c238c9d323f$export$ee93807ff92bd69e).push(`<a href="${file}.xhtml#fn-call__${num}">${marker}</a>`);
        },
        exit ({ node: node }) {
            const [num, , file] = (0, $76cf7427665b84d4$export$d9e849fdd85b511d)(node, true);
            (0, $06fa4c238c9d323f$export$ee93807ff92bd69e).push(`<a href="${file}.xhtml#fn-call__${num}">\u23CE</a>`);
            (0, $06fa4c238c9d323f$export$ee93807ff92bd69e).push(`</div>`);
        }
    },
    blockInFootnote: (0, $06fa4c238c9d323f$export$eab97d15b1788b8d).wrap(`span`, [
        `poetry`
    ]),
    paragraphInFootnote: (0, $06fa4c238c9d323f$export$eab97d15b1788b8d).wrap((n)=>n.hasSiblings() ? `span` : null, [
        `footnote-paragraph`
    ]),
    textInFootnote: {
        enter ({ node: node }) {
            (0, $06fa4c238c9d323f$export$ee93807ff92bd69e).append(node.value);
        }
    },
    ...(0, $8e6a28ae6624ebb3$export$2e2bcd8739ae039)
};
var $9fcf74fd41363ee7$export$2e2bcd8739ae039 = $9fcf74fd41363ee7$var$EbookFootnoteContentVisitor;



function $031701f74f7b2dd3$export$2e2bcd8739ae039(document, lang) {
    const footnotes = document.footnotes;
    footnotes.children.unshift($031701f74f7b2dd3$var$helperNote(footnotes, lang));
    const output = [];
    (0, $cd9944187d9cfa79$export$2e2bcd8739ae039)(footnotes, (0, $9fcf74fd41363ee7$export$2e2bcd8739ae039), output, {
        target: `ebook`,
        lang: lang
    });
    return output[0]?.join(`\n`) ?? ``;
}
function $031701f74f7b2dd3$var$helperNote(footnotes, lang) {
    const helper = new (0, $86b9a01d2c8c01db$export$2e2bcd8739ae039)((0, $f556b19a33951931$export$845480b930b0e280).FOOTNOTE, footnotes);
    const paragraph = new (0, $86b9a01d2c8c01db$export$2e2bcd8739ae039)((0, $f556b19a33951931$export$845480b930b0e280).PARAGRAPH, helper);
    const text = new (0, $86b9a01d2c8c01db$export$2e2bcd8739ae039)((0, $f556b19a33951931$export$845480b930b0e280).TEXT, paragraph);
    helper.children = [
        paragraph
    ];
    paragraph.children = [
        text
    ];
    text.value = $031701f74f7b2dd3$var$helperNoteText(footnotes.children.length < 4, lang);
    helper.setMetaData(`isFootnoteHelper`, true);
    return helper;
}
function $031701f74f7b2dd3$var$helperNoteText(symbols, lang) {
    if (lang === `en`) {
        const marker = symbols ? `symbol` : `number`;
        return `You made it to the notes area! To get back to where you just were, click the back arrow (\u23CE) at the end of the note, or the ${marker} at the beginning of the note, or use your e-reader\u{2019}s \u{201C}back to page...\u{201D} feature.`;
    }
    // TODO need spanish for "symbol" or "number"
    return `\xa1Llegaste a la secci\xf3n de notas! Para volver al lugar donde estabas leyendo, haz clic en la peque\xf1a flecha (\u23CE) al final de la nota, o en el n\xfamero al principio de la nota, o donde tu aplicaci\xf3n dice  \u{201C}volver a la p\xe1gina.\u{201D}`;
}
function $031701f74f7b2dd3$export$2447a9ccd0e76613(numTotalFootnotes, lang) {
    const marker = (0, $76cf7427665b84d4$export$9c42aa7141cb1427)(numTotalFootnotes, 0);
    const isSymbol = marker !== `1`;
    const clickTarget = isSymbol ? `symbol` : `note number`;
    const callMarkup = (0, $76cf7427665b84d4$export$31dac9670e5720eb)(1, marker, `notes`);
    const title = lang === `en` ? `Help with Footnotes` : `Ayuda con las Notas a Pie de P\xe1gina`;
    let helpNote = `This e-book contains footnotes. When you see a reference number, click it to access the footnote. Once you're done reading the note, it's easy to get back to exactly where you were just reading\u{2014}just click the back arrow <span>(\u23CE)</span> after the note, or the ${clickTarget} at the beginning of the note. Here's a sample footnote for you to practice.${callMarkup}`;
    if (lang === `es`) helpNote = `Este libro electr\xf3nico contiene notas a pie de p\xe1gina. Cuando veas un n\xfamero de referencia, haz clic ah\xed para acceder a la nota al pie. Una vez que hayas terminado de leer la nota, es f\xe1cil regresar al lugar exacto en el que estabas leyendo, simplemente haz clic en la peque\xf1a flecha <span>(\u23CE)</span> despu\xe9s de la nota, o el n\xfamero al principio de la nota. Aqu\xed hay una nota para que practiques${callMarkup}`;
    return `
    <div class="footnote-helper">
      <h3>${title}</h3>
      <p>${helpNote}</p>
    </div>
  `.trim();
}



class $015e4be4433a7dbd$export$2e2bcd8739ae039 extends (0, $9013d1c4f9e18026$export$2e2bcd8739ae039) {
    get notesContentHtml() {
        return (0, $031701f74f7b2dd3$export$2e2bcd8739ae039)(this.document, this.lang);
    }
    get footnoteHelperSourceHtml() {
        return (0, $031701f74f7b2dd3$export$2447a9ccd0e76613)(this.numFootnotes, this.lang);
    }
}


function $d1745ebe46899516$export$81a573fb38372de3(dpc) {
    return $d1745ebe46899516$var$toSrcHtml(dpc, `ebook`);
}
function $d1745ebe46899516$export$3bac9ee3a75f0916(dpc) {
    return $d1745ebe46899516$var$toSrcHtml(dpc, `pdf`);
}
function $d1745ebe46899516$var$toSrcHtml(dpc, target) {
    const document = (0, $a8d03726b9ff868b$export$2e2bcd8739ae039).parseDocument(...dpc.asciidocFiles);
    const output = [];
    (0, $cd9944187d9cfa79$export$2e2bcd8739ae039)(document, (0, $901e6f21036e2df7$export$2e2bcd8739ae039), output, {
        target: target,
        lang: dpc.lang
    });
    const Result = target === `pdf` ? (0, $aa30c6eabff3a1c2$export$2e2bcd8739ae039) : (0, $015e4be4433a7dbd$export$2e2bcd8739ae039);
    return new Result(output, document, dpc.lang);
}







const $942c18ddce4f2598$export$fef61f332f2c0afc = {
    toPdfSrcHtml: $d1745ebe46899516$export$3bac9ee3a75f0916,
    toEbookSrcHtml: $d1745ebe46899516$export$81a573fb38372de3,
    toSpeechText: $1ab4cbc8fcb467c7$export$5ae66ca102e22691,
    toSpeechHtml: $1ab4cbc8fcb467c7$export$14a04967aee91de1
};




function $2af337d11c4a099c$export$2e2bcd8739ae039(state, taskId, path) {
    const task = state.tasks.present[taskId];
    if (!task) throw new Error(`Task ${taskId} not found`);
    const file = task.files[path];
    if (!file) throw new Error(`No file with path ${path}`);
    const adoc = file.editedContent == null ? file.content : file.editedContent;
    const dpc = (0, $44411577e029e7fb$export$621c68a289ff1a44)();
    dpc.asciidocFiles = [
        {
            adoc: adoc,
            filename: path
        }
    ];
    const result = (0, $942c18ddce4f2598$export$fef61f332f2c0afc).toPdfSrcHtml(dpc);
    return result.mergedChapterHtml();
}




const $7d0df7f5e92ae98d$var$Rendered = (0, $c47ddde344dbf90f$export$2e2bcd8739ae039).div`
  background: #eaeaea;
  color: black;
  min-height: 100vh;

  .page {
    background: white;
    max-width: 650px;
    padding: 0 75px 75px 75px;
    margin: auto;
    min-height: 100vh;
  }
`;
const $7d0df7f5e92ae98d$var$globalStyles = (0, $6105bfda1ce101d1$export$2e2bcd8739ae039)`
  * {
    user-select: auto !important;
  }

  html {
    font-size: 12.5pt !important;
    background: #eaeaea;
    counter-reset: footnotes;
  }

  .chapter {
    margin-top: 0 !important;
    padding-top: 1.125in !important;
  }

  .footnote {
    counter-increment: footnotes;
    font-size: 0 !important;
    width: 0;
  }

  span.footnote::before {
    content: counter(footnotes);
    font-size: 0.85rem;
    display: inline-block;
    transform: translateY(-7px);
  }

  span.footnote > * {
    display: none !important;
  }

  pre.error {
    font-size: 14px;
    color: #ff7e7e;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    margin: 0;
    padding: 2em;
  }
`;
class $7d0df7f5e92ae98d$var$Component extends (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).Component {
    state = {
        html: ``
    };
    componentDidMount() {
        window.addEventListener(`scroll`, this.watchScroll);
        // prepping HTML for a big file can take 1-5 SECONDS
        // so DEFER so that we can show the throbber while waiting
        const { getHtml: getHtml } = this.props;
        setTimeout(()=>{
            this.setState({
                html: getHtml()
            });
            this.restoreScroll();
        }, 100);
    }
    componentWillUnmount() {
        window.removeEventListener(`scroll`, this.watchScroll);
    }
    restoreScroll() {
        const savedScroll = sessionStorage.getItem(this.scrollKey());
        if (savedScroll) window.scrollTo(0, Number(savedScroll));
    }
    scrollKey() {
        const { taskId: taskId, file: file } = this.props;
        return `scroll:${taskId}--${file}`;
    }
    watchScroll = (0, (/*@__PURE__*/$parcel$interopDefault($fc6da8441dcd6fda$exports)))(()=>{
        sessionStorage.setItem(this.scrollKey(), String(window.scrollY));
    }, 200);
    render() {
        const { html: html } = this.state;
        return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)($7d0df7f5e92ae98d$var$Rendered, {
            className: "body",
            children: [
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $a903afd89d23e5a0$export$98f03c5d19621d70), {
                    styles: $7d0df7f5e92ae98d$var$globalStyles
                }),
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                    className: "page",
                    children: html ? /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                        className: "inner",
                        dangerouslySetInnerHTML: {
                            __html: html
                        }
                    }) : /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $d5f1ba22637aca3e$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("h1", {
                            style: {
                                height: `100vh`,
                                opacity: 0.8,
                                lineHeight: `100vh`
                            },
                            children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("img", {
                                alt: "",
                                src: (0, {}),
                                style: {
                                    height: 45
                                }
                            })
                        })
                    })
                })
            ]
        });
    }
}
const $7d0df7f5e92ae98d$var$mapState = (state, { taskId: taskId, file: file })=>{
    const getHtml = ()=>{
        try {
            return (0, $2af337d11c4a099c$export$2e2bcd8739ae039)(state, taskId, file);
        } catch (err) {
            if (err instanceof (0, $7e6e5536f6256095$export$2e2bcd8739ae039)) return `<pre class="error parse-error">${err.codeFrame}</pre>`;
            return `<pre class="error">${String(err)}</pre>`;
        }
    };
    return {
        taskId: taskId,
        file: file,
        getHtml: getHtml
    };
};
var $7d0df7f5e92ae98d$export$2e2bcd8739ae039 = (0, $494dfd495f2b09e7$export$2e2bcd8739ae039)($7d0df7f5e92ae98d$var$mapState)($7d0df7f5e92ae98d$var$Component);


const $113483d5b6f78089$var$isDev = "production" === `development`;
const $113483d5b6f78089$var$scrollCss = (0, $6105bfda1ce101d1$export$2e2bcd8739ae039)`
  ::-webkit-scrollbar {
    width: 15px;
    height: 15px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 6px;
    border: 3px solid black;
    background-clip: content-box;
    background-color: #2e353d;
    border-color: #555;
  }

  ::-webkit-scrollbar-track {
    background-color: #555;
  }
`;
class $113483d5b6f78089$var$App extends $lx97N.Component {
    componentDidMount() {
        const { receiveAccessToken: receiveAccessToken } = this.props;
        const query = new URLSearchParams(window.location.search);
        if (query.has(`access_token`)) {
            receiveAccessToken(query.get(`access_token`));
            // remove query param from url
            window.history.pushState({}, ``, `/`);
        }
    }
    renderScreen() {
        const { screen: screen } = this.props;
        switch(screen){
            case $3e05c0969d23c6c5$export$bd1d8583f199118f:
                return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $ff07e8289fff4ce0$export$2e2bcd8739ae039), {});
            case $3e05c0969d23c6c5$export$7d63f45909460d98:
                return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $1318f36bc6ccd8c0$export$2e2bcd8739ae039), {});
            case $3e05c0969d23c6c5$export$77d6f70978850641:
                return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $d1b17548d5df9f3d$export$2e2bcd8739ae039), {});
            default:
                return null;
        }
    }
    render() {
        const { loggedIn: loggedIn, hardReset: hardReset } = this.props;
        if (!loggedIn) return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $7bba885684e8baef$export$2e2bcd8739ae039), {});
        const query = new URLSearchParams(window.location.search);
        if (query.get(`preview`) && query.get(`task`) && query.get(`file`)) {
            const taskId = query.get(`task`);
            const file = query.get(`file`);
            return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $7d0df7f5e92ae98d$export$2e2bcd8739ae039), {
                taskId: taskId,
                file: file
            });
        }
        return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)((0, $b8c53ef43392f031$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $a903afd89d23e5a0$export$98f03c5d19621d70), {
                    styles: $113483d5b6f78089$var$scrollCss
                }),
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $81704584cb2f8aea$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
                    style: {
                        height: `calc(100vh - 50px)`
                    },
                    children: this.renderScreen()
                }),
                $113483d5b6f78089$var$isDev && /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1d811823c5bf6b48$exports))), {
                    handleKeys: [
                        `meta+ctrl+1`
                    ],
                    onKeyEvent: hardReset
                })
            ]
        });
    }
}
const $113483d5b6f78089$var$mapState = (state)=>({
        loggedIn: Boolean(state.github.token),
        screen: state.screen
    });
const $113483d5b6f78089$var$mapDispatch = {
    receiveAccessToken: $75c2ce1d62cf75f2$export$d7f6453813abca85,
    hardReset: $75c2ce1d62cf75f2$export$4ff35e5b1175d6f6
};
var $113483d5b6f78089$export$2e2bcd8739ae039 = (0, $494dfd495f2b09e7$export$2e2bcd8739ae039)($113483d5b6f78089$var$mapState, $113483d5b6f78089$var$mapDispatch)($113483d5b6f78089$var$App);



(0, $12dd306947ac2422$export$2e2bcd8739ae039)().then((store)=>{
    const root = (0, (/*@__PURE__*/$parcel$interopDefault($e08bedd2d92855da$exports))).createRoot($216540463726947f$var$container());
    root.render(/*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $302e609c0f21ba7e$export$2e2bcd8739ae039), {
        store: store,
        children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $113483d5b6f78089$export$2e2bcd8739ae039), {})
    }));
});
function $216540463726947f$var$container() {
    const app = document.getElementById(`root`);
    if (!app) throw new Error(`No element with id 'root' found in document`);
    return app;
}


//# sourceMappingURL=jones.9496898f.js.map
